webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__(1531)
var isDate = __webpack_require__(464)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
    } else {
      var fullTime = timestamp + time
      var fullTimeDate = new Date(fullTime)

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime)
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate)
      if (offsetDiff > 0) {
        offset += offsetDiff
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, module) {var __WEBPACK_AMD_DEFINE_RESULT__;/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;(function() {

  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
      FUNC_ERROR_TEXT = 'Expected a function',
      INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
      CLONE_FLAT_FLAG = 2,
      CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
      COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
      WRAP_BIND_KEY_FLAG = 2,
      WRAP_CURRY_BOUND_FLAG = 4,
      WRAP_CURRY_FLAG = 8,
      WRAP_CURRY_RIGHT_FLAG = 16,
      WRAP_PARTIAL_FLAG = 32,
      WRAP_PARTIAL_RIGHT_FLAG = 64,
      WRAP_ARY_FLAG = 128,
      WRAP_REARG_FLAG = 256,
      WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
      DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
      HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
      LAZY_MAP_FLAG = 2,
      LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
      MAX_SAFE_INTEGER = 9007199254740991,
      MAX_INTEGER = 1.7976931348623157e+308,
      NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [
    ['ary', WRAP_ARY_FLAG],
    ['bind', WRAP_BIND_FLAG],
    ['bindKey', WRAP_BIND_KEY_FLAG],
    ['curry', WRAP_CURRY_FLAG],
    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
    ['flip', WRAP_FLIP_FLAG],
    ['partial', WRAP_PARTIAL_FLAG],
    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
    ['rearg', WRAP_REARG_FLAG]
  ];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
      arrayTag = '[object Array]',
      asyncTag = '[object AsyncFunction]',
      boolTag = '[object Boolean]',
      dateTag = '[object Date]',
      domExcTag = '[object DOMException]',
      errorTag = '[object Error]',
      funcTag = '[object Function]',
      genTag = '[object GeneratorFunction]',
      mapTag = '[object Map]',
      numberTag = '[object Number]',
      nullTag = '[object Null]',
      objectTag = '[object Object]',
      promiseTag = '[object Promise]',
      proxyTag = '[object Proxy]',
      regexpTag = '[object RegExp]',
      setTag = '[object Set]',
      stringTag = '[object String]',
      symbolTag = '[object Symbol]',
      undefinedTag = '[object Undefined]',
      weakMapTag = '[object WeakMap]',
      weakSetTag = '[object WeakSet]';

  var arrayBufferTag = '[object ArrayBuffer]',
      dataViewTag = '[object DataView]',
      float32Tag = '[object Float32Array]',
      float64Tag = '[object Float64Array]',
      int8Tag = '[object Int8Array]',
      int16Tag = '[object Int16Array]',
      int32Tag = '[object Int32Array]',
      uint8Tag = '[object Uint8Array]',
      uint8ClampedTag = '[object Uint8ClampedArray]',
      uint16Tag = '[object Uint16Array]',
      uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
      reUnescapedHtml = /[&<>"']/g,
      reHasEscapedHtml = RegExp(reEscapedHtml.source),
      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
      reEvaluate = /<%([\s\S]+?)%>/g,
      reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
      reIsPlainProp = /^\w*$/,
      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
      reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
      reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = '\\ud800-\\udfff',
      rsComboMarksRange = '\\u0300-\\u036f',
      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
      rsComboSymbolsRange = '\\u20d0-\\u20ff',
      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
      rsDingbatRange = '\\u2700-\\u27bf',
      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
      rsPunctuationRange = '\\u2000-\\u206f',
      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
      rsVarRange = '\\ufe0e\\ufe0f',
      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
      rsAstral = '[' + rsAstralRange + ']',
      rsBreak = '[' + rsBreakRange + ']',
      rsCombo = '[' + rsComboRange + ']',
      rsDigits = '\\d+',
      rsDingbat = '[' + rsDingbatRange + ']',
      rsLower = '[' + rsLowerRange + ']',
      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
      rsFitz = '\\ud83c[\\udffb-\\udfff]',
      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
      rsNonAstral = '[^' + rsAstralRange + ']',
      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
      rsUpper = '[' + rsUpperRange + ']',
      rsZWJ = '\\u200d';

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
      reOptMod = rsModifier + '?',
      rsOptVar = '[' + rsVarRange + ']?',
      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
      rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
      rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
      rsSeq = rsOptVar + reOptMod + rsOptJoin,
      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([
    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
    rsUpper + '+' + rsOptContrUpper,
    rsOrdUpper,
    rsOrdLower,
    rsDigits,
    rsEmoji
  ].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = [
    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
  ];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
  typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
  typedArrayTags[setTag] = typedArrayTags[stringTag] =
  typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] =
  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
  cloneableTags[boolTag] = cloneableTags[dateTag] =
  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
  cloneableTags[int32Tag] = cloneableTags[mapTag] =
  cloneableTags[numberTag] = cloneableTags[objectTag] =
  cloneableTags[regexpTag] = cloneableTags[setTag] =
  cloneableTags[stringTag] = cloneableTags[symbolTag] =
  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] =
  cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
    '\xc7': 'C',  '\xe7': 'c',
    '\xd0': 'D',  '\xf0': 'd',
    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
    '\xd1': 'N',  '\xf1': 'n',
    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
    '\xc6': 'Ae', '\xe6': 'ae',
    '\xde': 'Th', '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
    '\u0134': 'J',  '\u0135': 'j',
    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
    '\u0174': 'W',  '\u0175': 'w',
    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
    '\u0132': 'IJ', '\u0133': 'ij',
    '\u0152': 'Oe', '\u0153': 'oe',
    '\u0149': "'n", '\u017f': 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
      freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = (function() {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;

      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }());

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
      nodeIsDate = nodeUtil && nodeUtil.isDate,
      nodeIsMap = nodeUtil && nodeUtil.isMap,
      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
      nodeIsSet = nodeUtil && nodeUtil.isSet,
      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0: return func.call(thisArg);
      case 1: return func.call(thisArg, args[0]);
      case 2: return func.call(thisArg, args[0], args[1]);
      case 3: return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;

    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
        length = array == null ? 0 : array.length,
        result = Array(length);

    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
        length = values.length,
        offset = array.length;

    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
        length = array == null ? 0 : array.length;

    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
        length = array == null ? 0 : array.length;

    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
        index = fromIndex + (fromRight ? 1 : -1);

    while ((fromRight ? index-- : ++index < length)) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value
      ? strictIndexOf(array, value, fromIndex)
      : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? (baseSum(array, iteratee) / length) : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function(object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function(key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
      accumulator = initAccum
        ? (initAccum = false, value)
        : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;

    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
        index = -1,
        length = array.length;

    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : (result + current);
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
        result = Array(n);

    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function(key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string
      ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
      : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function(value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function(key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
        length = strSymbols.length;

    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;

    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
        result = 0;

    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
        result = [];

    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
        result = Array(map.size);

    map.forEach(function(value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function(arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];

    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
        result = Array(set.size);

    set.forEach(function(value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
        length = array.length;

    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string)
      ? unicodeSize(string)
      : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string)
      ? unicodeToArray(string)
      : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;

    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = (function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
        Date = context.Date,
        Error = context.Error,
        Function = context.Function,
        Math = context.Math,
        Object = context.Object,
        RegExp = context.RegExp,
        String = context.String,
        TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
        funcProto = Function.prototype,
        objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = (function() {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? ('Symbol(src)_1.' + uid) : '';
    }());

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' +
      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
    );

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
        Symbol = context.Symbol,
        Uint8Array = context.Uint8Array,
        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
        getPrototype = overArg(Object.getPrototypeOf, Object),
        objectCreate = Object.create,
        propertyIsEnumerable = objectProto.propertyIsEnumerable,
        splice = arrayProto.splice,
        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
        symIterator = Symbol ? Symbol.iterator : undefined,
        symToStringTag = Symbol ? Symbol.toStringTag : undefined;

    var defineProperty = (function() {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }());

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
        ctxNow = Date && Date.now !== root.Date.now && Date.now,
        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
        nativeFloor = Math.floor,
        nativeGetSymbols = Object.getOwnPropertySymbols,
        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
        nativeIsFinite = context.isFinite,
        nativeJoin = arrayProto.join,
        nativeKeys = overArg(Object.keys, Object),
        nativeMax = Math.max,
        nativeMin = Math.min,
        nativeNow = Date.now,
        nativeParseInt = context.parseInt,
        nativeRandom = Math.random,
        nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
        Map = getNative(context, 'Map'),
        Promise = getNative(context, 'Promise'),
        Set = getNative(context, 'Set'),
        WeakMap = getNative(context, 'WeakMap'),
        nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap;

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
        mapCtorString = toSource(Map),
        promiseCtorString = toSource(Promise),
        setCtorString = toSource(Set),
        weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = Symbol ? Symbol.prototype : undefined,
        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
        symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = (function() {
      function object() {}
      return function(proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object;
        object.prototype = undefined;
        return result;
      };
    }());

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {

      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,

      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,

      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,

      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',

      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {

        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;

    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
          dir = this.__dir__,
          isArr = isArray(array),
          isRight = dir < 0,
          arrLength = isArr ? array.length : 0,
          view = getView(0, arrLength, this.__views__),
          start = view.start,
          end = view.end,
          length = end - start,
          index = isRight ? end : (start - 1),
          iteratees = this.__iteratees__,
          iterLength = iteratees.length,
          resIndex = 0,
          takeCount = nativeMin(length, this.__takeCount__);

      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];

      outer:
      while (length-- && resIndex < takeCount) {
        index += dir;

        var iterIndex = -1,
            value = array[index];

        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
              iteratee = data.iteratee,
              type = data.type,
              computed = iteratee(value);

          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
          index = assocIndexOf(data, key);

      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
          length = entries == null ? 0 : entries.length;

      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash,
        'map': new (Map || ListCache),
        'string': new Hash
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
          size = data.size;

      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
          length = values == null ? 0 : values.length;

      this.__data__ = new MapCache;
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache;
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
          result = data['delete'](key);

      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
          isArg = !isArr && isArguments(value),
          isBuff = !isArr && !isArg && isBuffer(value),
          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
          skipIndexes = isArr || isArg || isBuff || isType,
          result = skipIndexes ? baseTimes(value.length, String) : [],
          length = result.length;

      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) &&
            !(skipIndexes && (
               // Safari 9 has enumerable `arguments.length` in strict mode.
               key == 'length' ||
               // Node.js 0.10 has enumerable non-index properties on buffers.
               (isBuff && (key == 'offset' || key == 'parent')) ||
               // PhantomJS 2 has enumerable non-index properties on typed arrays.
               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
               // Skip index properties.
               isIndex(key, length)
            ))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if ((value !== undefined && !eq(object[key], value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
          (value === undefined && !(key in object))) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function(value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
          length = paths.length,
          result = Array(length),
          skip = object == null;

      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
          isDeep = bitmask & CLONE_DEEP_FLAG,
          isFlat = bitmask & CLONE_FLAT_FLAG,
          isFull = bitmask & CLONE_SYMBOLS_FLAG;

      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
            isFunc = tag == funcTag || tag == genTag;

        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
          result = (isFlat || isFunc) ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat
              ? copySymbolsIn(value, baseAssignIn(result, value))
              : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack);
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);

      if (isSet(value)) {
        value.forEach(function(subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function(subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }

      var keysFunc = isFull
        ? (isFlat ? getAllKeysIn : getAllKeys)
        : (isFlat ? keysIn : keys);

      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function(subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function(object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
            predicate = source[key],
            value = object[key];

        if ((value === undefined && !(key in object)) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function() { func.apply(undefined, args); }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          isCommon = true,
          length = array.length,
          result = [],
          valuesLength = values.length;

      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      }
      else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee == null ? value : iteratee(value);

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        }
        else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function(value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
          length = array.length;

      while (++index < length) {
        var value = array[index],
            current = iteratee(value);

        if (current != null && (computed === undefined
              ? (current === current && !isSymbol(current))
              : comparator(current, computed)
            )) {
          var computed = current,
              result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;

      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = (end === undefined || end > length) ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function(value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
          length = array.length;

      predicate || (predicate = isFlattenable);
      result || (result = []);

      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function(key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);

      var index = 0,
          length = path.length;

      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return (index && index == length) ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return (symToStringTag && symToStringTag in Object(value))
        ? getRawTag(value)
        : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
          length = arrays[0].length,
          othLength = arrays.length,
          othIndex = othLength,
          caches = Array(othLength),
          maxLength = Infinity,
          result = [];

      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
          ? new SetCache(othIndex && array)
          : undefined;
      }
      array = arrays[0];

      var index = -1,
          seen = caches[0];

      outer:
      while (++index < length && result.length < maxLength) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (!(seen
              ? cacheHas(seen, computed)
              : includes(result, computed, comparator)
            )) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache
                  ? cacheHas(cache, computed)
                  : includes(arrays[othIndex], computed, comparator))
                ) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
          othIsArr = isArray(other),
          objTag = objIsArr ? arrayTag : getTag(object),
          othTag = othIsArr ? arrayTag : getTag(other);

      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;

      var objIsObj = objTag == objectTag,
          othIsObj = othTag == objectTag,
          isSameTag = objTag == othTag;

      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack);
        return (objIsArr || isTypedArray(object))
          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
              othUnwrapped = othIsWrapped ? other.value() : other;

          stack || (stack = new Stack);
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack);
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
          length = index,
          noCustomizer = !customizer;

      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if ((noCustomizer && data[2])
              ? data[1] !== object[data[0]]
              : !(data[0] in object)
            ) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
            objValue = object[key],
            srcValue = data[1];

        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack;
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined
                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
                : result
              )) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) &&
        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (typeof value == 'object') {
        return isArray(value)
          ? baseMatchesProperty(value[0], value[1])
          : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
          result = [];

      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function(object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function(object) {
        var objValue = get(object, path);
        return (objValue === undefined && objValue === srcValue)
          ? hasIn(object, path)
          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function(srcValue, key) {
        stack || (stack = new Stack);
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        }
        else {
          var newValue = customizer
            ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
            : undefined;

          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
          srcValue = safeGet(source, key),
          stacked = stack.get(srcValue);

      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer
        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
        : undefined;

      var isCommon = newValue === undefined;

      if (isCommon) {
        var isArr = isArray(srcValue),
            isBuff = !isArr && isBuffer(srcValue),
            isTyped = !isArr && !isBuff && isTypedArray(srcValue);

        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          }
          else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          }
          else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          }
          else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          }
          else {
            newValue = [];
          }
        }
        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          }
          else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        }
        else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function(iteratee) {
          if (isArray(iteratee)) {
            return function(value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            }
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }

      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));

      var result = baseMap(collection, function(value, key, collection) {
        var criteria = arrayMap(iteratees, function(iteratee) {
          return iteratee(value);
        });
        return { 'criteria': criteria, 'index': ++index, 'value': value };
      });

      return baseSortBy(result, function(object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function(value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
          length = paths.length,
          result = {};

      while (++index < length) {
        var path = paths[index],
            value = baseGet(object, path);

        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function(object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
          index = -1,
          length = values.length,
          seen = array;

      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
            value = values[index],
            computed = iteratee ? iteratee(value) : value;

        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
          lastIndex = length - 1;

      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
          result = Array(length);

      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);

      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          lastIndex = length - 1,
          nested = object;

      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
            newValue = value;

        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }

        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue)
              ? objValue
              : (isIndex(path[index + 1]) ? [] : {});
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function(func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function(func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
          length = array.length;

      if (start < 0) {
        start = -start > length ? 0 : (length + start);
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : ((end - start) >>> 0);
      start >>>= 0;

      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;

      baseEach(collection, function(value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
          high = array == null ? low : array.length;

      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = (low + high) >>> 1,
              computed = array[mid];

          if (computed !== null && !isSymbol(computed) &&
              (retHighest ? (computed <= value) : (computed < value))) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
          high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }

      value = iteratee(value);
      var valIsNaN = value !== value,
          valIsNull = value === null,
          valIsSymbol = isSymbol(value),
          valIsUndefined = value === undefined;

      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
            computed = iteratee(array[mid]),
            othIsDefined = computed !== undefined,
            othIsNull = computed === null,
            othIsReflexive = computed === computed,
            othIsSymbol = isSymbol(computed);

        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? (computed <= value) : (computed < value);
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
          length = array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
          includes = arrayIncludes,
          length = array.length,
          isCommon = true,
          result = [],
          seen = result;

      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      }
      else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache;
      }
      else {
        seen = iteratee ? [] : result;
      }
      outer:
      while (++index < length) {
        var value = array[index],
            computed = iteratee ? iteratee(value) : value;

        value = (comparator || value !== 0) ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        }
        else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
          index = fromRight ? length : -1;

      while ((fromRight ? index-- : ++index < length) &&
        predicate(array[index], index, array)) {}

      return isDrop
        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function(result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
          result = Array(length);

      while (++index < length) {
        var array = arrays[index],
            othIndex = -1;

        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
          length = props.length,
          valsLength = values.length,
          result = {};

      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return (!start && end >= length) ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function(id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
            valIsNull = value === null,
            valIsReflexive = value === value,
            valIsSymbol = isSymbol(value);

        var othIsDefined = other !== undefined,
            othIsNull = other === null,
            othIsReflexive = other === other,
            othIsSymbol = isSymbol(other);

        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
            (valIsNull && othIsDefined && othIsReflexive) ||
            (!valIsDefined && othIsReflexive) ||
            !valIsReflexive) {
          return 1;
        }
        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
            (othIsNull && valIsDefined && valIsReflexive) ||
            (!othIsDefined && valIsReflexive) ||
            !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
          objCriteria = object.criteria,
          othCriteria = other.criteria,
          length = objCriteria.length,
          ordersLength = orders.length;

      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersLength = holders.length,
          leftIndex = -1,
          leftLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(leftLength + rangeLength),
          isUncurried = !isCurried;

      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
          argsLength = args.length,
          holdersIndex = -1,
          holdersLength = holders.length,
          rightIndex = -1,
          rightLength = partials.length,
          rangeLength = nativeMax(argsLength - holdersLength, 0),
          result = Array(rangeLength + rightLength),
          isUncurried = !isCurried;

      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
          length = source.length;

      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});

      var index = -1,
          length = props.length;

      while (++index < length) {
        var key = props[index];

        var newValue = customizer
          ? customizer(object[key], source[key], key, object, source)
          : undefined;

        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function(collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
            accumulator = initializer ? initializer() : {};

        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function(object, sources) {
        var index = -1,
            length = sources.length,
            customizer = length > 1 ? sources[length - 1] : undefined,
            guard = length > 2 ? sources[2] : undefined;

        customizer = (assigner.length > 3 && typeof customizer == 'function')
          ? (length--, customizer)
          : undefined;

        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function(collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
            index = fromRight ? length : -1,
            iterable = Object(collection);

        while ((fromRight ? index-- : ++index < length)) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function(object, iteratee, keysFunc) {
        var index = -1,
            iterable = Object(object),
            props = keysFunc(object),
            length = props.length;

        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function(string) {
        string = toString(string);

        var strSymbols = hasUnicode(string)
          ? stringToArray(string)
          : undefined;

        var chr = strSymbols
          ? strSymbols[0]
          : string.charAt(0);

        var trailing = strSymbols
          ? castSlice(strSymbols, 1).join('')
          : string.slice(1);

        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function(string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function() {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0: return new Ctor;
          case 1: return new Ctor(args[0]);
          case 2: return new Ctor(args[0], args[1]);
          case 3: return new Ctor(args[0], args[1], args[2]);
          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
            result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length,
            placeholder = getHolder(wrapper);

        while (index--) {
          args[index] = arguments[index];
        }
        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
          ? []
          : replaceHolders(args, placeholder);

        length -= holders.length;
        if (length < arity) {
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, undefined,
            args, holders, undefined, undefined, arity - length);
        }
        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function(funcs) {
        var length = funcs.length,
            index = length,
            prereq = LodashWrapper.prototype.thru;

        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];

          var funcName = getFuncName(func),
              data = funcName == 'wrapper' ? getData(func) : undefined;

          if (data && isLaziable(data[0]) &&
                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
                !data[4].length && data[9] == 1
              ) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = (func.length == 1 && isLaziable(func))
              ? wrapper[funcName]()
              : wrapper.thru(func);
          }
        }
        return function() {
          var args = arguments,
              value = args[0];

          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
              result = length ? funcs[index].apply(this, args) : value;

          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
          isBind = bitmask & WRAP_BIND_FLAG,
          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
          isFlip = bitmask & WRAP_FLIP_FLAG,
          Ctor = isBindKey ? undefined : createCtor(func);

      function wrapper() {
        var length = arguments.length,
            args = Array(length),
            index = length;

        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
              holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(
            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
            args, newHolders, argPos, ary, arity - length
          );
        }
        var thisBinding = isBind ? thisArg : this,
            fn = isBindKey ? thisBinding[func] : func;

        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function(object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function(value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function(iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function(args) {
          var thisArg = this;
          return arrayFunc(iteratees, function(iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);

      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars)
        ? castSlice(stringToArray(result), 0, length).join('')
        : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
          Ctor = createCtor(func);

      function wrapper() {
        var argsIndex = -1,
            argsLength = arguments.length,
            leftIndex = -1,
            leftLength = partials.length,
            args = Array(leftLength + argsLength),
            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;

        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function(start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function(value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
          newHolders = isCurry ? holders : undefined,
          newHoldersRight = isCurry ? undefined : holders,
          newPartials = isCurry ? partials : undefined,
          newPartialsRight = isCurry ? undefined : partials;

      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);

      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [
        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
        newHoldersRight, argPos, ary, arity
      ];

      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function(number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
              value = func(pair[0] + 'e' + (+pair[1] + precision));

          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function(object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;

      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
            holdersRight = holders;

        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);

      var newData = [
        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
        argPos, ary, arity
      ];

      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined
        ? (isBindKey ? 0 : func.length)
        : nativeMax(newData[9] - length, 0);

      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined ||
          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          arrLength = array.length,
          othLength = other.length;

      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
          result = true,
          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
            othValue = other[index];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, arrValue, index, other, array, stack)
            : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function(othValue, othIndex) {
                if (!cacheHas(seen, othIndex) &&
                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
            result = false;
            break;
          }
        } else if (!(
              arrValue === othValue ||
                equalFunc(arrValue, othValue, bitmask, customizer, stack)
            )) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if ((object.byteLength != other.byteLength) ||
              (object.byteOffset != other.byteOffset)) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;

        case arrayBufferTag:
          if ((object.byteLength != other.byteLength) ||
              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;

        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);

        case errorTag:
          return object.name == other.name && object.message == other.message;

        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == (other + '');

        case mapTag:
          var convert = mapToArray;

        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);

          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;

        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
          objProps = getAllKeys(object),
          objLength = objProps.length,
          othProps = getAllKeys(other),
          othLength = othProps.length;

      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);

      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
            othValue = other[key];

        if (customizer) {
          var compared = isPartial
            ? customizer(othValue, objValue, key, other, object, stack)
            : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined
              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
              : compared
            )) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
            othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor &&
            ('constructor' in object && 'constructor' in other) &&
            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function(func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = (func.name + ''),
          array = realNames[result],
          length = hasOwnProperty.call(realNames, result) ? array.length : 0;

      while (length--) {
        var data = array[length],
            otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key)
        ? data[typeof key == 'string' ? 'string' : 'hash']
        : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
          length = result.length;

      while (length--) {
        var key = result[length],
            value = object[key];

        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
          tag = value[symToStringTag];

      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}

      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function(symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
        (Map && getTag(new Map) != mapTag) ||
        (Promise && getTag(Promise.resolve()) != promiseTag) ||
        (Set && getTag(new Set) != setTag) ||
        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
      getTag = function(value) {
        var result = baseGetTag(value),
            Ctor = result == objectTag ? value.constructor : undefined,
            ctorString = Ctor ? toSource(Ctor) : '';

        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString: return dataViewTag;
            case mapCtorString: return mapTag;
            case promiseCtorString: return promiseTag;
            case setCtorString: return setTag;
            case weakMapCtorString: return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
          length = transforms.length;

      while (++index < length) {
        var data = transforms[index],
            size = data.size;

        switch (data.type) {
          case 'drop':      start += size; break;
          case 'dropRight': end -= size; break;
          case 'take':      end = nativeMin(end, start + size); break;
          case 'takeRight': start = nativeMax(start, end - size); break;
        }
      }
      return { 'start': start, 'end': end };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);

      var index = -1,
          length = path.length,
          result = false;

      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) &&
        (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
          result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return (typeof object.constructor == 'function' && !isPrototype(object))
        ? baseCreate(getPrototype(object))
        : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);

        case boolTag:
        case dateTag:
          return new Ctor(+object);

        case dataViewTag:
          return cloneDataView(object, isDeep);

        case float32Tag: case float64Tag:
        case int8Tag: case int16Tag: case int32Tag:
        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
          return cloneTypedArray(object, isDeep);

        case mapTag:
          return new Ctor;

        case numberTag:
        case stringTag:
          return new Ctor(object);

        case regexpTag:
          return cloneRegExp(object);

        case setTag:
          return new Ctor;

        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) ||
        !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = typeof value;
      length = length == null ? MAX_SAFE_INTEGER : length;

      return !!length &&
        (type == 'number' ||
          (type != 'symbol' && reIsUint.test(value))) &&
            (value > -1 && value % 1 == 0 && value < length);
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = typeof index;
      if (type == 'number'
            ? (isArrayLike(object) && isIndex(index, object.length))
            : (type == 'string' && index in object)
          ) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = typeof value;
      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
          value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
        (object != null && value in Object(object));
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = typeof value;
      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
        ? (value !== '__proto__')
        : (value === null);
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
          other = lodash[funcName];

      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && (maskSrcKey in func);
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function(object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue &&
          (srcValue !== undefined || (key in Object(object)));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function(key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });

      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
          srcBitmask = source[1],
          newBitmask = bitmask | srcBitmask,
          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);

      var isCombo =
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;

      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
      return function() {
        var args = arguments,
            index = -1,
            length = nativeMax(args.length - start, 0),
            array = Array(length);

        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
          length = nativeMin(indexes.length, arrLength),
          oldArray = copyArray(array);

      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }

      if (key == '__proto__') {
        return;
      }

      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function(func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = (reference + '');
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
          lastCalled = 0;

      return function() {
        var stamp = nativeNow(),
            remaining = HOT_SPAN - (stamp - lastCalled);

        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
          length = array.length,
          lastIndex = length - 1;

      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
            value = array[rand];

        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function(string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = (value + '');
      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return (func + '');
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function(pair) {
        var value = '_.' + pair[0];
        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__  = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
          resIndex = 0,
          result = Array(nativeCeil(length / size));

      while (index < length) {
        result[resIndex++] = baseSlice(array, index, (index += size));
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
          length = array == null ? 0 : array.length,
          resIndex = 0,
          result = [];

      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
          array = arguments[0],
          index = length;

      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function(array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function(array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array)
        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
        : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true, true)
        : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), true)
        : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0
          ? nativeMax(length + index, 0)
          : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
          length = pairs == null ? 0 : pairs.length,
          result = {};

      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return (array && array.length) ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function(arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped)
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function(arrays) {
      var iteratee = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, getIteratee(iteratee, 2))
        : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function(arrays) {
      var comparator = last(arrays),
          mapped = arrayMap(arrays, castArrayLikeObject);

      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return (mapped.length && mapped[0] === arrays[0])
        ? baseIntersection(mapped, undefined, comparator)
        : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value
        ? strictLastIndexOf(array, value, index)
        : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values)
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, getIteratee(iteratee, 2))
        : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return (array && array.length && values && values.length)
        ? basePullAll(array, values, undefined, comparator)
        : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function(array, indexes) {
      var length = array == null ? 0 : array.length,
          result = baseAt(array, indexes);

      basePullAt(array, arrayMap(indexes, function(index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));

      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
          indexes = [],
          length = array.length;

      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      }
      else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return (array && array.length)
        ? baseSortedUniq(array)
        : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return (array && array.length)
        ? baseSortedUniq(array, getIteratee(iteratee, 2))
        : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = (guard || n === undefined) ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3), false, true)
        : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return (array && array.length)
        ? baseWhile(array, getIteratee(predicate, 3))
        : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function(arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return (array && array.length) ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function(group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function(index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function(group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function(array, values) {
      return isArrayLikeObject(array)
        ? baseDifference(array, values)
        : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function(arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function(arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function(arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function(arrays) {
      var length = arrays.length,
          iteratee = length > 1 ? arrays[length - 1] : undefined;

      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function(paths) {
      var length = paths.length,
          start = length ? paths[0] : 0,
          value = this.__wrapped__,
          interceptor = function(object) { return baseAt(object, paths); };

      if (length > 1 || this.__actions__.length ||
          !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function(array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
          value = done ? undefined : this.__values__[this.__index__++];

      return { 'done': done, 'value': value };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
          parent = this;

      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function(result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection)
        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function(collection, path, args) {
      var index = -1,
          isFunc = typeof path == 'function',
          result = isArrayLike(collection) ? Array(collection.length) : [];

      baseEach(collection, function(value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function(result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function(result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function() { return [[], []]; });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
          initAccum = arguments.length < 3;

      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function(collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function() {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = (func && n == null) ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function() {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function(func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function(object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
          lastThis,
          maxWait,
          result,
          timerId,
          lastCallTime,
          lastInvokeTime = 0,
          leading = false,
          maxing = false,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }

      function invokeFunc(time) {
        var args = lastArgs,
            thisArg = lastThis;

        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }

      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }

      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime,
            timeWaiting = wait - timeSinceLastCall;

        return maxing
          ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
          : timeWaiting;
      }

      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
            timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
      }

      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }

      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }

      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }

      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }

      function debounced() {
        var time = now(),
            isInvoking = shouldInvoke(time);

        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;

        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function(func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function(func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var memoized = function() {
        var args = arguments,
            key = resolver ? resolver.apply(this, args) : args[0],
            cache = memoized.cache;

        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      memoized.cache = new (memoize.Cache || MapCache);
      return memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function() {
        var args = arguments;
        switch (args.length) {
          case 0: return !predicate.call(this);
          case 1: return !predicate.call(this, args[0]);
          case 2: return !predicate.call(this, args[0], args[1]);
          case 3: return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function(func, transforms) {
      transforms = (transforms.length == 1 && isArray(transforms[0]))
        ? arrayMap(transforms[0], baseUnary(getIteratee()))
        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));

      var funcsLength = transforms.length;
      return baseRest(function(args) {
        var index = -1,
            length = nativeMin(args.length, funcsLength);

        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function(func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function(func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function(args) {
        var array = args[start],
            otherArgs = castSlice(args, 0, start);

        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
          trailing = true;

      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || (value !== value && other !== other);
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function(value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
        !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false ||
        (isObjectLike(value) && baseGetTag(value) == boolTag);
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) &&
          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag ||
        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' &&
        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = typeof value;
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && typeof value == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' ||
        (isObjectLike(value) && baseGetTag(value) == numberTag);
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
        funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' ||
        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return typeof value == 'symbol' ||
        (isObjectLike(value) && baseGetTag(value) == symbolTag);
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function(value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);

      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = (value < 0 ? -1 : 1);
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
          remainder = result % 1;

      return result === result ? (remainder ? result - remainder : result) : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? (other + '') : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return (isBinary || reIsOctal.test(value))
        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
        : (reIsBadHex.test(value) ? NAN : +value);
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value
        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
        : (value === 0 ? value : 0);
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function(object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function(object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function(object, sources) {
      object = Object(object);

      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;

      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }

      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;

        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];

          if (value === undefined ||
              (eq(value, objectProto[key]) && !hasOwnProperty.call(object, key))) {
            object[key] = source[key];
          }
        }
      }

      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function(args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null
        ? object
        : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null
        ? object
        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function(result, value, key) {
      if (value != null &&
          typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }

      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);

      baseForOwn(object, function(value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function(object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function(object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function(path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function(object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function(prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function(value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);

      var index = -1,
          length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
          isArrLike = isArr || isBuffer(object) || isTypedArray(object);

      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor : [];
        }
        else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        }
        else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        }
        else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      }
      else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function(result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);

      var length = string.length;
      position = position === undefined
        ? length
        : baseClamp(toInteger(position), 0, length);

      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return (string && reHasUnescapedHtml.test(string))
        ? string.replace(reUnescapedHtml, escapeHtmlChar)
        : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return (string && reHasRegExpChar.test(string))
        ? string.replace(reRegExpChar, '\\$&')
        : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function(result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return (
        createPadding(nativeFloor(mid), chars) +
        string +
        createPadding(nativeCeil(mid), chars)
      );
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (string + createPadding(length - strLength, chars))
        : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);

      var strLength = length ? stringSize(string) : 0;
      return (length && strLength < length)
        ? (createPadding(length - strLength, chars) + string)
        : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
          string = toString(args[0]);

      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function(result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (
            typeof separator == 'string' ||
            (separator != null && !isRegExp(separator))
          )) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null
        ? 0
        : baseClamp(toInteger(position), 0, string.length);

      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;

      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);

      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
          importsKeys = keys(imports),
          importsValues = baseValues(imports, importsKeys);

      var isEscaping,
          isEvaluating,
          index = 0,
          interpolate = options.interpolate || reNoMatch,
          source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp(
        (options.escape || reNoMatch).source + '|' +
        interpolate.source + '|' +
        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
        (options.evaluate || reNoMatch).source + '|$'
      , 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' +
        (hasOwnProperty.call(options, 'sourceURL')
          ? (options.sourceURL + '').replace(/\s/g, ' ')
          : ('lodash.templateSources[' + (++templateCounter) + ']')
        ) + '\n';

      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });

      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
        .replace(reEmptyStringMiddle, '$1')
        .replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' +
        (variable
          ? ''
          : 'obj || (obj = {});\n'
        ) +
        "var __t, __p = ''" +
        (isEscaping
           ? ', __e = _.escape'
           : ''
        ) +
        (isEvaluating
          ? ', __j = Array.prototype.join;\n' +
            "function print() { __p += __j.call(arguments, '') }\n"
          : ';\n'
        ) +
        source +
        'return __p\n}';

      var result = attempt(function() {
        return Function(importsKeys, sourceURL + 'return ' + source)
          .apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          chrSymbols = stringToArray(chars),
          start = charsStartIndex(strSymbols, chrSymbols),
          end = charsEndIndex(strSymbols, chrSymbols) + 1;

      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;

      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
          start = charsStartIndex(strSymbols, stringToArray(chars));

      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
          omission = DEFAULT_TRUNC_OMISSION;

      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);

      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols
        ? castSlice(strSymbols, 0, end).join('')
        : string.slice(0, end);

      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += (result.length - end);
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
              substring = result;

          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while ((match = separator.exec(substring))) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return (string && reHasEscapedHtml.test(string))
        ? string.replace(reEscapedHtml, unescapeHtmlChar)
        : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function(result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;

      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function(func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function(object, methodNames) {
      arrayEach(methodNames, function(key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
          toIteratee = getIteratee();

      pairs = !length ? [] : arrayMap(pairs, function(pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });

      return baseRest(function(args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function() {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return (value == null || value !== value) ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function(path, args) {
      return function(object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function(object, args) {
      return function(path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
          methodNames = baseFunctions(source, props);

      if (options == null &&
          !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
          isFunc = isFunction(object);

      arrayEach(methodNames, function(methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function() {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                  actions = result.__actions__ = copyArray(this.__actions__);

              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });

      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function(args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function(path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
          length = nativeMin(n, MAX_ARRAY_LENGTH);

      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;

      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function(augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function(dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseGt)
        : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
        : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return (array && array.length)
        ? baseExtremum(array, identity, baseLt)
        : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return (array && array.length)
        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
        : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function(multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function(minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return (array && array.length)
        ? baseSum(array, identity)
        : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return (array && array.length)
        ? baseSum(array, getIteratee(iteratee, 2))
        : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;

    mixin(lodash, (function() {
      var source = {};
      baseForOwn(lodash, function(func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }()), { 'chain': false });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function(methodName, index) {
      LazyWrapper.prototype[methodName] = function(n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);

        var result = (this.__filtered__ && !index)
          ? new LazyWrapper(this)
          : this.clone();

        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };

      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
      var type = index + 1,
          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;

      LazyWrapper.prototype[methodName] = function(iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function(methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');

      LazyWrapper.prototype[methodName] = function() {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function(methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');

      LazyWrapper.prototype[methodName] = function() {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });

    LazyWrapper.prototype.compact = function() {
      return this.filter(identity);
    };

    LazyWrapper.prototype.find = function(predicate) {
      return this.filter(predicate).head();
    };

    LazyWrapper.prototype.findLast = function(predicate) {
      return this.reverse().find(predicate);
    };

    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function(value) {
        return baseInvoke(value, path, args);
      });
    });

    LazyWrapper.prototype.reject = function(predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };

    LazyWrapper.prototype.slice = function(start, end) {
      start = toInteger(start);

      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };

    LazyWrapper.prototype.takeRightWhile = function(predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };

    LazyWrapper.prototype.toArray = function() {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
          isTaker = /^(?:head|last)$/.test(methodName),
          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
          retUnwrapped = isTaker || /^find/.test(methodName);

      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function() {
        var value = this.__wrapped__,
            args = isTaker ? [1] : arguments,
            isLazy = value instanceof LazyWrapper,
            iteratee = args[0],
            useLazy = isLazy || isArray(value);

        var interceptor = function(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return (isTaker && chainAll) ? result[0] : result;
        };

        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
            isHybrid = !!this.__actions__.length,
            isUnwrapped = retUnwrapped && !chainAll,
            onlyLazy = isLazy && !isHybrid;

        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
      var func = arrayProto[methodName],
          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
          retUnwrapped = /^(?:pop|shift)$/.test(methodName);

      lodash.prototype[methodName] = function() {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function(value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({ 'name': methodName, 'func': lodashFunc });
      }
    });

    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;

    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  });

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (true) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  }
  else {
    // Export to the global object.
    root._ = _;
  }
}.call(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21), __webpack_require__(289)(module)))

/***/ }),
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getYearFromUtc = exports.formatEntryDateTime = exports.formatEntryTime = exports.formatEntryDate = exports.sortByRecentMonth = exports.sortByDate = undefined;
exports.isToday = isToday;
exports.isTomorrow = isTomorrow;
exports.formatDate = formatDate;

var _momentTimezone = __webpack_require__(904);

var _momentTimezone2 = _interopRequireDefault(_momentTimezone);

var _lodash = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var tzLondon = 'Europe/London';

function isToday(dateStr) {
    var today = (0, _momentTimezone2.default)().tz(tzLondon);
    var date = _momentTimezone2.default.tz(dateStr, tzLondon);
    return date.isSame(today, 'day');
}

function isTomorrow(dateStr) {
    var tomorrow = (0, _momentTimezone2.default)().tz(tzLondon).add(1, 'days');
    var date = _momentTimezone2.default.tz(dateStr, tzLondon);
    return date.isSame(tomorrow, 'day');
}

var sortByDate = exports.sortByDate = function sortByDate(key) {
    var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (a, b) {
        var date1 = new Date((0, _lodash.get)(a, key));
        var date2 = new Date((0, _lodash.get)(b, key));
        var reverseCoef = reverse ? -1 : 1;
        if (date1 > date2) {
            return -1 * reverseCoef;
        }
        if (date1 < date2) {
            return 1 * reverseCoef;
        }

        return 0;
    };
};

var sortByRecentMonth = exports.sortByRecentMonth = function sortByRecentMonth(key) {
    var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return function (a, b) {
        var date1 = (0, _momentTimezone2.default)(a[key], 'MMMM YYYY');
        var date2 = (0, _momentTimezone2.default)(b[key], 'MMMM YYYY');
        var reverseCoef = reverse ? -1 : 1;

        if (date1 > date2) {
            return -1 * reverseCoef;
        }
        if (date1 < date2) {
            return 1 * reverseCoef;
        }

        return 0;
    };
};

function formatDate(dateStr, format) {
    return dateStr ? _momentTimezone2.default.tz(dateStr, tzLondon).format(format) : '';
}

var formatEntryDate = exports.formatEntryDate = function formatEntryDate(dateStr, format) {
    if (!dateStr) {
        return null;
    }

    if (isToday(dateStr)) {
        return 'Today';
    }

    if (isTomorrow(dateStr)) {
        return 'Tomorrow';
    }

    return formatDate(dateStr, format || 'dddd, DD MMMM YYYY');
};

var formatEntryTime = exports.formatEntryTime = function formatEntryTime(dateStr) {
    return formatDate(dateStr, 'h:mm');
};

var formatEntryDateTime = exports.formatEntryDateTime = function formatEntryDateTime(dateStr) {
    return formatEntryDate(dateStr) + ' - ' + formatEntryTime(dateStr);
};

var getYearFromUtc = exports.getYearFromUtc = function getYearFromUtc() {
    var utcStr = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    return new Date(utcStr).getUTCFullYear();
};

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RpSimpleTable = exports.addIds = exports.EMPTINESS_SIGN = exports.compareFns = exports.addSortFns = exports.sortData = exports.Row = exports.Body = exports.Header = exports.ShowMore = exports.NoData = exports.Loading = undefined;

var _RpTable = __webpack_require__(2614);

var _RpTable2 = _interopRequireDefault(_RpTable);

var _RpSimpleTable = __webpack_require__(2613);

var _RpSimpleTable2 = _interopRequireDefault(_RpSimpleTable);

var _Loading = __webpack_require__(1000);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoData = __webpack_require__(1001);

var _NoData2 = _interopRequireDefault(_NoData);

var _ShowMore = __webpack_require__(1002);

var _ShowMore2 = _interopRequireDefault(_ShowMore);

var _Header = __webpack_require__(586);

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__(585);

var _Body2 = _interopRequireDefault(_Body);

var _Row = __webpack_require__(587);

var _Row2 = _interopRequireDefault(_Row);

var _sortData = __webpack_require__(1007);

var _sortData2 = _interopRequireDefault(_sortData);

var _compareFns = __webpack_require__(1006);

var _compareFns2 = _interopRequireDefault(_compareFns);

var _addSortFns = __webpack_require__(1005);

var _addSortFns2 = _interopRequireDefault(_addSortFns);

var _handleEmpty = __webpack_require__(1004);

var _addIds = __webpack_require__(1003);

var _addIds2 = _interopRequireDefault(_addIds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Loading = _Loading2.default;
exports.NoData = _NoData2.default;
exports.ShowMore = _ShowMore2.default;
exports.Header = _Header2.default;
exports.Body = _Body2.default;
exports.Row = _Row2.default;
exports.sortData = _sortData2.default;
exports.addSortFns = _addSortFns2.default;
exports.compareFns = _compareFns2.default;
exports.EMPTINESS_SIGN = _handleEmpty.EMPTINESS_SIGN;
exports.addIds = _addIds2.default;
exports.RpSimpleTable = _RpSimpleTable2.default;
exports.default = _RpTable2.default;

/***/ }),
/* 24 */,
/* 25 */,
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TrainerLink = exports.OwnerLink = exports.JockeyLink = exports.HorseLink = exports.CourseLink = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _rpReactTable = __webpack_require__(23);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _url = __webpack_require__(232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon chevronIcon',
    size: 'XSmall'
});

var Link = function Link(_ref) {
    var profileType = _ref.profileType,
        name = _ref.name,
        title = _ref.title,
        shortName = _ref.shortName,
        uid = _ref.uid,
        className = _ref.className,
        children = _ref.children,
        _ref$whenEmpty = _ref.whenEmpty,
        whenEmpty = _ref$whenEmpty === undefined ? _rpReactTable.EMPTINESS_SIGN : _ref$whenEmpty;
    return uid && name ? _jsx('a', {
        className: (0, _classnames2.default)('ui-link ui-link_table js-popupLink', className),
        href: (0, _url.buildProfileUrl)(uid, name, profileType),
        title: title
    }, void 0, children || shortName || name, _ref2) : _jsx('span', {}, void 0, whenEmpty);
};

var profileTypes = ['trainer', 'owner', 'jockey', 'horse', 'course'];

/* eslint react/prop-types: 0 */
var ProfileLink = profileTypes.reduce(function (res, type) {
    return Object.assign(res, _defineProperty({}, type, function (props) {
        return _jsx(Link, {
            profileType: type,
            uid: props[type + 'Uid'],
            name: props[type + 'StyleName'],
            shortName: props[type + 'ShortName'],
            className: props.className,
            whenEmpty: props.whenEmpty,
            title: props.title
        }, void 0, props.children);
    }));
}, {});

var CourseLink = exports.CourseLink = ProfileLink.course;
var HorseLink = exports.HorseLink = ProfileLink.horse;
var JockeyLink = exports.JockeyLink = ProfileLink.jockey;
var OwnerLink = exports.OwnerLink = ProfileLink.owner;
var TrainerLink = exports.TrainerLink = ProfileLink.trainer;

exports.default = ProfileLink;

/***/ }),
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatStake = exports.formatPrize = exports.formatMoney = exports.formatSalePrice = exports.formatPrice = undefined;

var _numeral = __webpack_require__(2289);

var _numeral2 = _interopRequireDefault(_numeral);

var _lodash = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var currencySymbols = {
    GBP: '£',
    EUR: '€',
    USD: '$'
};

var formatPrice = exports.formatPrice = function formatPrice(value) {
    return (0, _numeral2.default)(value).format('0,0');
};

var formatSalePrice = exports.formatSalePrice = function formatSalePrice(price, curCode) {
    if (!+price) {
        return '—';
    }

    var currency = (0, _lodash.toUpper)(curCode);
    var currencySymbol = currencySymbols[currency];
    var formattedPrice = formatPrice(price);

    return currencySymbol ? '' + currencySymbol + formattedPrice : formattedPrice + ' ' + currency;
};

var formatMoney = exports.formatMoney = function formatMoney(number) {
    return formatSalePrice(number, 'GBP');
};

var formatPrize = exports.formatPrize = function formatPrize(prize) {
    if (prize < 100) {
        return '';
    }

    var res = prize < 500 ? Math.round(prize / 100) / 10 : Math.round(prize / 1000);
    return res + 'K';
};

var formatStake = exports.formatStake = function formatStake(stake) {
    if (!(0, _lodash.isNumber)(stake)) {
        return stake;
    }
    if (stake === 0) {
        return '0.00';
    }

    return (0, _numeral2.default)(stake).format('+0.00');
};

/***/ }),
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Abbr = function Abbr(_ref) {
    var title = _ref.title,
        children = _ref.children,
        _ref$breakpoint = _ref.breakpoint,
        breakpoint = _ref$breakpoint === undefined ? 'fromNarrow' : _ref$breakpoint;
    return _jsx('abbr', {
        className: 'pp-abbr pp-abbr__' + breakpoint,
        title: title
    }, void 0, _jsx('span', {
        className: 'pp-abbr__inner'
    }, void 0, children || title.charAt(0)));
};

exports.default = Abbr;

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1293), __esModule: true };

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(1274);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(54);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(635);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(635);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var createFlow = __webpack_require__(2184);

/**
 * This method is like `_.flow` except that it creates a function that
 * invokes the given functions from right to left.
 *
 * @static
 * @since 3.0.0
 * @memberOf _
 * @category Util
 * @param {...(Function|Function[])} [funcs] The functions to invoke.
 * @returns {Function} Returns the new composite function.
 * @see _.flow
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var addSquare = _.flowRight([square, _.add]);
 * addSquare(1, 2);
 * // => 9
 */
var flowRight = createFlow(true);

module.exports = flowRight;


/***/ }),
/* 72 */,
/* 73 */,
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var MAP = exports.MAP = "__SECRET_MAP_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

// export const SKELETON = `__SECRET_SKELETON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED`;

var MARKER = exports.MARKER = "__SECRET_MARKER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var RECTANGLE = exports.RECTANGLE = "__SECRET_RECTANGLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var POLYLINE = exports.POLYLINE = "__SECRET_POLYLINE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var POLYGON = exports.POLYGON = "__SECRET_POLYGON_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var CIRCLE = exports.CIRCLE = "__SECRET_CIRCLE_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var KML_LAYER = exports.KML_LAYER = "__SECRET_KML_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var DIRECTIONS_RENDERER = exports.DIRECTIONS_RENDERER = "__SECRET_DIRECTIONS_RENDERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var HEATMAP_LAYER = exports.HEATMAP_LAYER = "__SECRET_HEATMAP_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var FUSION_TABLES_LAYER = exports.FUSION_TABLES_LAYER = "__SECRET_FUSION_TABLES_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var ANCHOR = exports.ANCHOR = "__SECRET_ANCHOR_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var INFO_WINDOW = exports.INFO_WINDOW = "__SECRET_INFO_WINDOW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var OVERLAY_VIEW = exports.OVERLAY_VIEW = "__SECRET_OVERLAY_VIEW_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var DRAWING_MANAGER = exports.DRAWING_MANAGER = "__SECRET_DRAWING_MANAGER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var SEARCH_BOX = exports.SEARCH_BOX = "__SECRET_SEARCH_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var MARKER_CLUSTERER = exports.MARKER_CLUSTERER = "__SECRET_MARKER_CLUSTERER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var INFO_BOX = exports.INFO_BOX = "__SECRET_INFO_BOX_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var TRAFFIC_LAYER = exports.TRAFFIC_LAYER = "__SECRET_TRAFFIC_LAYER_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

var STREET_VIEW_PANORAMA = exports.STREET_VIEW_PANORAMA = "__SECRET_STREET_VIEW_PANORAMA_DO_NOT_USE_OR_YOU_WILL_BE_FIRED";

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.selection = exports.timePeriods = exports.raceTypes = undefined;

var _raceTypes = __webpack_require__(1263);

var _raceTypes2 = _interopRequireDefault(_raceTypes);

var _timePeriods = __webpack_require__(408);

var timePeriods = _interopRequireWildcard(_timePeriods);

var _selection = __webpack_require__(160);

var selection = _interopRequireWildcard(_selection);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.raceTypes = _raceTypes2.default;
exports.timePeriods = timePeriods;
exports.selection = selection;

/***/ }),
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @providesModule shallowCompare
 */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/**
 * Does a shallow comparison for props and state.
 * See ReactComponentWithPureRenderMixin
 * See also https://facebook.github.io/react/docs/shallow-compare.html
 */
function shallowCompare(instance, nextProps, nextState) {
  return (
    !shallowEqual(instance.props, nextProps) ||
    !shallowEqual(instance.state, nextState)
  );
}

module.exports = shallowCompare;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _curry2 = __webpack_require__(893);

var _curry3 = _interopRequireDefault(_curry2);

var _noop2 = __webpack_require__(901);

var _noop3 = _interopRequireDefault(_noop2);

var _forEach2 = __webpack_require__(896);

var _forEach3 = _interopRequireDefault(_forEach2);

var _bind2 = __webpack_require__(2241);

var _bind3 = _interopRequireDefault(_bind2);

var _has2 = __webpack_require__(2253);

var _has3 = _interopRequireDefault(_has2);

var _reduce2 = __webpack_require__(2272);

var _reduce3 = _interopRequireDefault(_reduce2);

var _identity2 = __webpack_require__(219);

var _identity3 = _interopRequireDefault(_identity2);

var _mapKeys2 = __webpack_require__(2265);

var _mapKeys3 = _interopRequireDefault(_mapKeys2);

exports.addDefaultPrefixToPropTypes = addDefaultPrefixToPropTypes;
exports.collectUncontrolledAndControlledProps = collectUncontrolledAndControlledProps;
exports.default = enhanceElement;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
function addDefaultPrefixToPropTypes(propTypes /*: Object*/) {
  return (0, _mapKeys3.default)(propTypes, function (value, key) {
    return "default" + key.substr(0, 1).toUpperCase() + key.substr(1);
  });
}

function removeDefaultPrefix(defaultKey) {
  // default = 7
  var key = defaultKey.substr(7);
  return "" + key.substr(0, 1).toLowerCase() + key.substr(1);
}

function collectProps(propTypes /*: Object*/, props /*: Object*/) {
  var keyTransform = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _identity3.default;

  return (0, _reduce3.default)(propTypes, function (acc, value, key) {
    if ((0, _has3.default)(props, key)) {
      var nextKey = keyTransform(key);
      // eslint-disable-next-line no-param-reassign
      acc[nextKey] = props[key];
    }
    return acc;
  }, {});
}

function collectUncontrolledAndControlledProps(defaultUncontrolledPropTypes /*: Object*/, controlledPropTypes /*: Object*/, props /*: Object*/) {
  return (0, _extends3.default)({}, collectProps(defaultUncontrolledPropTypes, props, removeDefaultPrefix), collectProps(controlledPropTypes, props));
}

function registerGoogleEventsFromReactProps(instance /*: Object*/, props /*: Object*/, eventMap /*: Object*/) {
  var registered = (0, _reduce3.default)(eventMap, function (acc, googleEventName, onEventName) {
    if ((0, _has3.default)(props, onEventName)) {
      acc.push(google.maps.event.addListener(instance, googleEventName, props[onEventName]));
    }
    return acc;
  }, []);

  return (0, _bind3.default)(_forEach3.default, null, registered, function (event) {
    return google.maps.event.removeListener(event);
  });
}

function registerEventsFromComponent(component, getInstanceFromComponent, eventMap) {
  var instance = getInstanceFromComponent(component);
  // eslint-disable-next-line no-param-reassign
  component._unregisterEvents = registerGoogleEventsFromReactProps(instance, component.props, eventMap);
}

function unregisterEventsFromComponent(component, getInstanceFromComponent) {
  // eslint-disable-next-line no-param-reassign
  component._unregisterEvents();
  // eslint-disable-next-line no-param-reassign
  component._unregisterEvents = _noop3.default;
}

var enhanceWithPropTypes = (0, _curry3.default)(function (getInstanceFromComponent, controlledPropUpdaterMap, componentSpec) {
  var _componentSpec$compon = componentSpec.componentDidUpdate,
      _componentDidUpdate = _componentSpec$compon === undefined ? _noop3.default : _componentSpec$compon;

  return (0, _extends3.default)({}, componentSpec, {
    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
      var _this = this;

      (0, _forEach3.default)(controlledPropUpdaterMap, function (fn, key) {
        var nextValue = _this.props[key];
        if (nextValue !== prevProps[key]) {
          fn(getInstanceFromComponent(_this), nextValue, _this);
        }
      });
      _componentDidUpdate.call(this, prevProps, prevState);
    }
  });
});

var enhanceWithEventMap = (0, _curry3.default)(function (getInstanceFromComponent, eventMap, componentSpec) {
  var _componentSpec$compon2 = componentSpec.componentDidMount,
      _componentDidMount = _componentSpec$compon2 === undefined ? _noop3.default : _componentSpec$compon2,
      _componentSpec$compon3 = componentSpec.componentDidUpdate,
      _componentDidUpdate2 = _componentSpec$compon3 === undefined ? _noop3.default : _componentSpec$compon3,
      _componentSpec$compon4 = componentSpec.componentWillUnmount,
      _componentWillUnmount = _componentSpec$compon4 === undefined ? _noop3.default : _componentSpec$compon4;

  return (0, _extends3.default)({}, componentSpec, {

    _unregisterEvents: _noop3.default,

    componentDidMount: function componentDidMount() {
      _componentDidMount.call(this);
      registerEventsFromComponent(this, getInstanceFromComponent, eventMap);
    },
    componentDidUpdate: function componentDidUpdate(prevProps, prevState) {
      unregisterEventsFromComponent(this, getInstanceFromComponent);
      _componentDidUpdate2.call(this, prevProps, prevState);
      registerEventsFromComponent(this, getInstanceFromComponent, eventMap);
    },
    componentWillUnmount: function componentWillUnmount() {
      unregisterEventsFromComponent(this, getInstanceFromComponent);
      _componentWillUnmount.call(this);
    }
  });
});

var enhanceWithPublicMethod = (0, _curry3.default)(function (getInstanceFromComponent, publicMethodMap, componentSpec) {
  return (0, _reduce3.default)(publicMethodMap, function (acc, fn, publicMethodName) {
    // eslint-disable-next-line no-param-reassign
    acc[publicMethodName] = function publicMethod() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return fn(getInstanceFromComponent(this), args, /* Use with caution */this);
    };
    return acc;
  }, (0, _extends3.default)({}, componentSpec));
});

function enhanceElement(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap) {
  return (0, _flowRight3.default)(enhanceWithPublicMethod(getInstanceFromComponent, publicMethodMap), enhanceWithEventMap(getInstanceFromComponent, eventMap), enhanceWithPropTypes(getInstanceFromComponent, controlledPropUpdaterMap));
}

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(596);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  typeof document.createElement -> undefined
 */
function isStandardBrowserEnv() {
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined' &&
    typeof document.createElement === 'function'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object' && !isArray(obj)) {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _url = __webpack_require__(232);

var _date = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon ui-icon__btn chevronIcon',
    size: 'XSmall'
});

var ResultLink = function ResultLink(_ref) {
    var courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        raceDatetime = _ref.raceDatetime,
        raceDate = _ref.raceDate,
        raceInstanceUid = _ref.raceInstanceUid,
        raceInstanceTitle = _ref.raceInstanceTitle,
        children = _ref.children,
        className = _ref.className,
        urlHash = _ref.urlHash;

    var date = raceDatetime || raceDate;
    if (!courseUid || !courseName || !date || !raceInstanceUid) {
        return _jsx('span', {
            className: className
        }, void 0, '\u2014');
    }

    var urlDate = (0, _date.formatDate)(date, 'Y-MM-DD');
    var name = (0, _url.nameToUrl)(courseName);
    var hash = urlHash ? '#' + urlHash : '';
    var url = '/results/' + courseUid + '/' + name + '/' + urlDate + '/' + raceInstanceUid + hash;

    return _jsx('a', {
        className: (0, _classnames2.default)('ui-link ui-link_table js-popupLink', className),
        href: url,
        title: raceInstanceTitle
    }, void 0, children || raceInstanceTitle, _ref2);
};

ResultLink.defaultProps = {
    urlHash: ''
};

exports.default = ResultLink;

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.zeroToDash = exports.numericAndDashSort = exports.placesSort = undefined;

var _rpReactTable = __webpack_require__(23);

var _helper = __webpack_require__(230);

var placesSort = exports.placesSort = function placesSort(key) {
    return function (a, b) {
        if (a[key] === 0) {
            return 1;
        }
        if (b[key] === 0) {
            return -1;
        }
        return a[key] - b[key];
    };
};

var numericAndDashSort = exports.numericAndDashSort = function numericAndDashSort(key) {
    return function (a, b) {
        // Hanlde non-runners
        if (!(0, _helper.isRunner)(a)) return 1;
        if (!(0, _helper.isRunner)(b)) return -1;

        // Handle cases with special rows ( N days break )
        if (a.isSpecial) return 1;
        if (b.isSpecial) return -1;

        // Show 0 values first
        if (a[key] === 0 && (b[key] === null || b[key] === _rpReactTable.EMPTINESS_SIGN)) return -1;
        if (b[key] === 0 && (a[key] === null || a[key] === _rpReactTable.EMPTINESS_SIGN)) return 1;

        // Show '-' after 0 values
        if (a[key] === _rpReactTable.EMPTINESS_SIGN && b[key] !== _rpReactTable.EMPTINESS_SIGN) return 1;
        if (b[key] === _rpReactTable.EMPTINESS_SIGN && a[key] !== _rpReactTable.EMPTINESS_SIGN) return -1;

        return b[key] - a[key];
    };
};

var zeroToDash = exports.zeroToDash = function zeroToDash(key) {
    return function (rowData) {
        return rowData[key] || _rpReactTable.EMPTINESS_SIGN;
    };
};

/***/ }),
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.formatWinDist = exports.yardsToFurlongs = undefined;
exports.distanceMap = distanceMap;
exports.mapYardGroups = mapYardGroups;

var _lodash = __webpack_require__(9);

var yardsInFurlong = 220;
var furlongsInMile = 8;
var forthPartOfYard = yardsInFurlong / 4;
var roundToLowerValue = forthPartOfYard;
var roundToGreaterValue = forthPartOfYard * 3;
var halfSymbol = '½';
var yardsLabel = 'yds';
var furlongsLabel = 'f';
var milesLabel = 'm';

var getShortForm = function getShortForm(yardsValue, furlongsValue, milesValue) {
    var result = [];
    var resultYards = null;
    var resultFurlongs = furlongsValue;
    var resultMiles = milesValue;

    if (yardsValue > roundToLowerValue && yardsValue < roundToGreaterValue) {
        resultYards = halfSymbol;
    }
    // If yards value is rounded to greater, lets add 1 unit to furlongs value
    if (yardsValue >= roundToGreaterValue) {
        resultFurlongs += 1;
    }

    // If yards value is rounded to greater, lets add 1 unit to furlongs value
    if (resultFurlongs >= furlongsInMile) {
        resultFurlongs = 0;
        resultMiles += 1;
    }

    // Don't show 0 number
    if (!resultFurlongs) {
        resultFurlongs = '';
    }

    if (resultMiles) {
        result.push(resultMiles + milesLabel);
    }
    if (resultFurlongs || resultYards) {
        result.push(resultFurlongs + resultYards + furlongsLabel);
    }

    return result;
};

var getLongForm = function getLongForm(yardsValue, furlongsValue, milesValue) {
    var result = [];
    if (milesValue) {
        result.push(milesValue + milesLabel);
    }
    if (furlongsValue) {
        result.push(furlongsValue + furlongsLabel);
    }
    if (yardsValue) {
        result.push(yardsValue + yardsLabel);
    }

    return result;
};

var yardsToFurlongs = exports.yardsToFurlongs = function yardsToFurlongs(yards, isShowInLongForm) {
    if (!isFinite(yards)) {
        return '';
    }

    var yardsValue = yards % yardsInFurlong;

    // Calculate furlongs value (with no dependant on yards rounding)
    var furlongsValue = Math.floor(yards / yardsInFurlong % furlongsInMile);

    // Calculate miles value
    var milesValue = Math.floor(yards / yardsInFurlong / furlongsInMile);

    var result = isShowInLongForm ? getLongForm(yardsValue, furlongsValue, milesValue) : getShortForm(yardsValue, furlongsValue, milesValue);

    return result.join('');
};

var furlongMap = {
    flat: [{ from: 0, to: 1211, value: '5f' }, { from: 1211, to: 1431, value: '6f' }, { from: 1431, to: 1651, value: '7f' }, { from: 1651, to: 2091, value: '1m-1m1f' }, { from: 2091, to: 2531, value: '1m2f-1m3f' }, { from: 2531, to: 2971, value: '1m4f-1m5f' }, { from: 2971, to: 3411, value: '1m6f-1m7f' }, { from: 3411, to: Infinity, value: '2m-plus' }],
    jumps: [{ from: 0, to: 3851, value: '2m-2m1f' }, { from: 3851, to: 4291, value: '2m1½f-2m3f' }, { from: 4291, to: 4951, value: '2m3½f-2m6f' }, { from: 4951, to: 5831, value: '2m7f-3m2½f' }, { from: 5831, to: Infinity, value: '3m3f-plus' }]
};

function distanceMap(yard, raceType) {
    var matchedRange = furlongMap[raceType].find(function (range) {
        return (0, _lodash.isNaN)(yard) ? null : (0, _lodash.inRange)(yard, range.from, range.to);
    });

    return matchedRange && matchedRange.value;
}

function mapYardGroups(yardsRange, raceType) {
    return (0, _lodash.uniq)(yardsRange.split('-').map(function (yardStr) {
        return parseInt(yardStr, 10);
    }).map(function (yard) {
        return distanceMap(yard, raceType);
    }).filter(function (distance) {
        return distance;
    })).join('-');
}

var formatWinDist = exports.formatWinDist = function formatWinDist(raceOutcomeCode, winningDistance, distanceToWinner) {
    if (!winningDistance && !distanceToWinner) {
        return null;
    }

    return +raceOutcomeCode === 1 ? 'by ' + winningDistance + ', ' : 'btn ' + distanceToWinner + ', ';
};

/***/ }),
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(1020);

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.restrictedPagesByCustomMetering = exports.tabsMapping = exports.tabsMap = exports.sireSubTabs = exports.horseSubStubs = undefined;

var _lodash = __webpack_require__(9);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var human = ['form', 'entries', 'horses', 'stats'];

var jockey = [human[0], 'booked-rides', human[2], human[3]];

var course = ['stats', 'course-map', 'course-records', 'favourites', 'signposts', 'course-info', 'results'];

var horseSubStubs = exports.horseSubStubs = {
    form: ['my-ratings'],
    entries: [],
    stats: [],
    quotes: [],
    pedigree: [],
    sales: [],
    notes: []
};

var horse = Object.keys(horseSubStubs);

var dam = (0, _lodash.uniq)(['progeny', 'progeny-entries', 'progeny-sales', 'pedigree'].concat(_toConsumableArray(horse)));

var sireSubTabs = exports.sireSubTabs = {
    stallionDetails: ['weatherbys-overview', 'best-progeny', 'recent-stakes-performers', 'sire-reference', 'stallion-book-pdf'],
    studRecord: ['progeny', 'progeny-statistics', 'progeny-dams-sire', 'progeny-results', 'progeny-entries', 'nicks'],
    salesRecord: ['fee-history', 'sales-statistics', 'sales-results', 'sales-entries']
};

var sire = (0, _lodash.uniq)([].concat(_toConsumableArray(Object.keys(sireSubTabs)), [
// no sub-tabs:
'pedigree'], _toConsumableArray(horse)));

var TabNames = {
    owner: human,
    trainer: human,
    jockey: jockey,
    course: course,
    horse: horse,
    sire: sire,
    dam: dam
};

var tabsMap = exports.tabsMap = {
    'weatherbys-overview': 'overview',
    stallionDetails: 'stallionBook',
    'stallion-book-pdf': 'stallion-book-PDF',
    'recent-stakes-performers': 'Recent Top Performers'
};

var tabsMapping = exports.tabsMapping = function tabsMapping(tabName) {
    return tabsMap[tabName] ? (0, _lodash.startCase)(tabsMap[tabName]) : (0, _lodash.startCase)(tabName);
};

var restrictedPagesByCustomMetering = exports.restrictedPagesByCustomMetering = {
    course_profile: [],
    horse_profile: ['form', 'entries'],
    jockey_profile: ['form', 'booked_rides', 'horses', 'stats'],
    trainer_profile: ['form', 'entries', 'horses', 'stats'],
    owner_profile: ['form', 'entries', 'horses', 'stats']
};

exports.default = TabNames;

/***/ }),
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selection = undefined;

var _Filter = __webpack_require__(1039);

var _Filter2 = _interopRequireDefault(_Filter);

var _selection = __webpack_require__(597);

var _selection2 = _interopRequireDefault(_selection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.selection = _selection2.default;
exports.default = _Filter2.default;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Definition = function Definition(_ref) {
    var term = _ref.term,
        _ref$isTermLabel = _ref.isTermLabel,
        isTermLabel = _ref$isTermLabel === undefined ? true : _ref$isTermLabel,
        _ref$forceShow = _ref.forceShow,
        forceShow = _ref$forceShow === undefined ? false : _ref$forceShow,
        _ref$perfectCenter = _ref.perfectCenter,
        perfectCenter = _ref$perfectCenter === undefined ? false : _ref$perfectCenter,
        description = _ref.description,
        children = _ref.children,
        className = _ref.className;
    return description || children || forceShow ? _jsx('div', {
        className: (0, _classnames2.default)('pp-definition', className) + (perfectCenter ? ' pp-definition__perfect-center' : '')
    }, void 0, term && _jsx('dt', {
        className: 'pp-definition__term'
    }, void 0, isTermLabel ? term + ':' : term), _jsx('dd', {
        className: 'pp-definition__description'
    }, void 0, children || description)) : null;
};

exports.default = Definition;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FilteringComponent = __webpack_require__(1243);

var _FilteringComponent2 = _interopRequireDefault(_FilteringComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FilteringComponent2.default;

/***/ }),
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hasValue = exports.getValues = exports.getValue = exports.getValueWithSuffix = exports.getCaptions = exports.getCaption = exports.getOptions = exports.getOption = exports.setSelected = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(9);

var _timePeriods = __webpack_require__(408);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var setFirstAsSelected = function setFirstAsSelected(arr) {
    return arr.map(function (item, index) {
        return index ? item : _extends({}, item, { selected: true });
    });
};

var setSelected = exports.setSelected = function setSelected(arr, value) {
    var mappedArray = arr.map(function (item) {
        return item.value === value ? _extends({}, item, { selected: true }) : item;
    });

    return mappedArray.find(function (option) {
        return option.selected;
    }) ? mappedArray : setFirstAsSelected(mappedArray);
};

var getOption = exports.getOption = function getOption(categories, categoryName) {
    return categories[categoryName].options.find(function (item) {
        return item.selected;
    });
};

var getOptions = exports.getOptions = function getOptions(categories) {
    return (0, _lodash.keys)(categories).reduce(function (result, key) {
        return _extends({}, result, _defineProperty({}, key, getOption(categories, key)));
    }, {});
};

var getCaption = exports.getCaption = function getCaption() {
    return getOption.apply(undefined, arguments).label;
};

var getCaptions = exports.getCaptions = function getCaptions(categories) {
    var selectedOptions = getOptions(categories);
    return (0, _lodash.keys)(categories).reduce(function (result, key) {
        return _extends({}, result, _defineProperty({}, key, selectedOptions[key].label));
    }, {});
};

var getValueWithSuffix = exports.getValueWithSuffix = function getValueWithSuffix() {
    return getOption.apply(undefined, arguments).value;
};

var getValue = exports.getValue = function getValue() {
    return (0, _timePeriods.removeExtra)(getOption.apply(undefined, arguments).value);
};

var getValues = exports.getValues = function getValues(categories) {
    var selectedOptions = getOptions(categories);
    return (0, _lodash.keys)(categories).reduce(function (result, key) {
        return _extends({}, result, _defineProperty({}, key, (0, _timePeriods.removeExtra)(selectedOptions[key].value)));
    }, {});
};

var hasValue = exports.hasValue = function hasValue(categories, value) {
    return categories.options.some(function (option) {
        return value === option.value;
    });
};

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getHorseType = exports.getHorseType = function getHorseType(_ref) {
    var damStatus = _ref.damStatus,
        sireStatus = _ref.sireStatus;

    if (damStatus) {
        return 'dam';
    }
    if (sireStatus) {
        return 'sire';
    }
    return 'horse';
};

var hasProgeny = exports.hasProgeny = function hasProgeny(profile) {
    return getHorseType(profile) !== 'horse';
};

var isWeatherbysMobile = exports.isWeatherbysMobile = function isWeatherbysMobile(_ref2) {
    var weatherbysUid = _ref2.weatherbysUid,
        isMobile = _ref2.isMobile;
    return weatherbysUid && !isMobile;
};

var shouldShowReplayButton = exports.shouldShowReplayButton = function shouldShowReplayButton(videoDetail) {
    if (!videoDetail || !videoDetail.videoProvider) {
        return false;
    }

    var videoProvider = videoDetail.videoProvider,
        finishRaceUid = videoDetail.finishRaceUid,
        ptvAssetId = videoDetail.ptvAssetId;


    if (videoProvider === 'RUK') {
        return Boolean(ptvAssetId);
    }

    return Boolean(finishRaceUid);
};

/***/ }),
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var startOfISOWeek = __webpack_require__(178)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(326)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var fixMobileSafariWhiteScreenBug = function fixMobileSafariWhiteScreenBug() {
    if (!document || !document.getElementsByTagName) return;

    var body = document.getElementsByTagName('body');
    if (body && body[0]) {
        body[0].style.display = 'none';
        /* eslint-disable no-unused-expressions */
        body[0].offsetHeight; // no need to store this anywhere, the reference is enough
        /* eslint-enable no-unused-expressions */
        body[0].style.display = '';
    }
};

exports.default = fixMobileSafariWhiteScreenBug;

/***/ }),
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var getRaceInfoKey = function getRaceInfoKey(_ref) {
    var bookmaker = _ref.bookmaker,
        raceTime = _ref.raceTime,
        raceDate = _ref.raceDate,
        courseName = _ref.courseName;

    if (!(raceTime && raceDate && courseName && bookmaker)) {
        // eslint-disable-next-line no-console
        console.error('no required info data in: getRaceInfoKey');
    }
    return (raceDate + '/' + raceTime + '/' + courseName + '/' + bookmaker).toUpperCase();
};

var PricesStateStore = function () {
    function PricesStateStore() {
        _classCallCheck(this, PricesStateStore);

        this.showDecimalPrices = false;
        this.raceInfo = {};
        this.currentBookmakerName = null;
    }

    _createClass(PricesStateStore, [{
        key: 'setPriceViewType',
        value: function setPriceViewType(_ref2) {
            var showDecimal = _ref2.showDecimal;

            this.showDecimalPrices = showDecimal;
        }
    }, {
        key: 'isDecimalPrice',
        value: function isDecimalPrice() {
            return this.showDecimalPrices;
        }
    }, {
        key: 'setCurrentBookmaker',
        value: function setCurrentBookmaker(bookmakerName) {
            this.currentBookmakerName = bookmakerName;
        }
    }, {
        key: 'getCurrentBookmaker',
        value: function getCurrentBookmaker() {
            return this.currentBookmakerName;
        }
    }, {
        key: 'updateRaceInfo',
        value: function updateRaceInfo(_ref3) {
            var bookmaker = _ref3.bookmaker,
                raceTime = _ref3.raceTime,
                raceDate = _ref3.raceDate,
                courseName = _ref3.courseName,
                suspendState = _ref3.suspendState,
                winOdds = _ref3.winOdds,
                placeWinner = _ref3.placeWinner,
                isBog = _ref3.isBog;

            var statusKey = getRaceInfoKey({ bookmaker: bookmaker, raceTime: raceTime, raceDate: raceDate, courseName: courseName });

            this.raceInfo[statusKey] = { suspendState: suspendState, winOdds: winOdds, placeWinner: placeWinner, isBog: isBog };
        }
    }, {
        key: 'getRaceInfo',
        value: function getRaceInfo(_ref4) {
            var bookmaker = _ref4.bookmaker,
                raceTime = _ref4.raceTime,
                raceDate = _ref4.raceDate,
                courseName = _ref4.courseName;

            return this.raceInfo[getRaceInfoKey({ bookmaker: bookmaker, raceTime: raceTime, raceDate: raceDate, courseName: courseName })];
        }
    }]);

    return PricesStateStore;
}();
// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)
/* eslint-disable import/prefer-default-export */


var pricesStateStore = exports.pricesStateStore = new PricesStateStore();

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.diffusionServiceUtils = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _PricesStateStore = __webpack_require__(228);

var _DIFFUSION = __webpack_require__(384);

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _DiffusionFeedHelper = __webpack_require__(2600);

var _DiffusionFeedHelper2 = _interopRequireDefault(_DiffusionFeedHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getTopicRaceType() {
    return 'HORSES';
}

function getTopicInfoType() {
    return '#INFO';
}

function getTopicMarketType(type) {
    return type || 'WIN';
}

function getElementDataAttribute(attribute, element) {
    return (0, _jquery2.default)(element).closest('[' + attribute + ']').attr(attribute);
}

function getTopicRaceDate(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.RACE_DATE, element);
}

function getTopicCourseName(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.COURSE_NAME, element);
}

function getTopicRaceTime(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.RACE_TIME, element);
}

function getTopicHorseName(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME, element);
}

function getTopicBookmaker(element) {
    return getElementDataAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER, element);
}

function getElementDiffusionData(element) {
    return {
        horseName: getTopicHorseName(element),
        courseName: getTopicCourseName(element),
        raceTime: getTopicRaceTime(element),
        raceDate: getTopicRaceDate(element)
    };
}

function createInfoTopic(_ref) {
    var raceDate = _ref.raceDate,
        courseName = _ref.courseName,
        raceTime = _ref.raceTime,
        bookmaker = _ref.bookmaker;

    if (!raceDate || !courseName || !raceTime || !bookmaker) {
        // eslint-disable-next-line no-console
        console.error('info topic not created', raceDate, courseName, raceTime, bookmaker);
        return null;
    }

    var topicArray = [getTopicRaceType(), raceDate, courseName, raceTime, getTopicMarketType(), getTopicInfoType(), _DiffusionFeedHelper2.default.getFeedByBookmaker(bookmaker)];

    return topicArray.join('/');
}

function createPriceTopic(_ref2) {
    var raceDate = _ref2.raceDate,
        courseName = _ref2.courseName,
        raceTime = _ref2.raceTime,
        horseName = _ref2.horseName,
        bookmaker = _ref2.bookmaker;

    if (!raceDate || !courseName || !raceTime || !horseName || !bookmaker) {
        // eslint-disable-next-line no-console
        console.error('price topic not created', raceDate, courseName, raceTime, horseName, bookmaker);
        return null;
    }

    var topicArray = [getTopicRaceType(), raceDate, courseName, raceTime, getTopicMarketType(), horseName, _DiffusionFeedHelper2.default.getFeedByBookmaker(bookmaker)];

    return topicArray.join('/');
}

function parseDiffusionTopic(topic) {
    var topicArray = topic.split('/');
    return {
        raceType: topicArray[0],
        raceDate: topicArray[1],
        courseName: topicArray[2],
        raceTime: topicArray[3],
        marketType: topicArray[4],
        infoType: topicArray[5],
        bookmaker: topicArray[6]
    };
}

function parseInfoTopicData(WebClientMessage) {
    var _WebClientMessage$get = WebClientMessage.getFields(0),
        _WebClientMessage$get2 = _slicedToArray(_WebClientMessage$get, 4),
        eachwayTerms = _WebClientMessage$get2[0],
        isBog = _WebClientMessage$get2[1],
        suspendState = _WebClientMessage$get2[2],
        orderBy = _WebClientMessage$get2[3];

    var isWinOnly = eachwayTerms === '1/1|1-1';

    var _eachwayTerms$split = eachwayTerms.split('|'),
        _eachwayTerms$split2 = _slicedToArray(_eachwayTerms$split, 2),
        winOdds = _eachwayTerms$split2[0],
        placeWinner = _eachwayTerms$split2[1];

    var topic = WebClientMessage.getTopic();

    var _parseDiffusionTopic = parseDiffusionTopic(topic),
        bookmaker = _parseDiffusionTopic.bookmaker,
        courseName = _parseDiffusionTopic.courseName,
        raceDate = _parseDiffusionTopic.raceDate,
        raceTime = _parseDiffusionTopic.raceTime;

    return {
        raceDate: raceDate,
        courseName: courseName,
        raceTime: raceTime,
        bookmaker: _DiffusionFeedHelper2.default.getBookmakerByFeed(bookmaker),
        winOdds: winOdds,
        placeWinner: placeWinner,
        isWinOnly: isWinOnly,
        isBog: isBog,
        suspendState: suspendState,
        orderBy: orderBy
    };
}

function parsePriceTopicData(WebClientMessage) {
    var dataFields = WebClientMessage.getFields(0);
    var topic = WebClientMessage.getTopic();

    var _parseDiffusionTopic2 = parseDiffusionTopic(topic),
        horseName = _parseDiffusionTopic2.infoType,
        bookmaker = _parseDiffusionTopic2.bookmaker,
        courseName = _parseDiffusionTopic2.courseName,
        raceDate = _parseDiffusionTopic2.raceDate,
        raceTime = _parseDiffusionTopic2.raceTime;

    var historyPrices = {
        fractional: dataFields.slice(9, 14),
        decimal: dataFields.slice(14, 19)
    };

    return {
        horseName: horseName,
        raceDate: raceDate,
        courseName: courseName,
        raceTime: raceTime,
        bookmaker: _DiffusionFeedHelper2.default.getBookmakerByFeed(bookmaker),
        historyPrices: historyPrices,
        outcomersId: dataFields[1],
        marketId: dataFields[3],
        eventId: dataFields[4],
        meetingId: dataFields[5],
        status: dataFields[6],
        fractionalPrice: dataFields[7],
        decimalPrice: dataFields[8],
        historyPrice: dataFields[14]
    };
}

function getDisplayedPriceValue(renderConfig) {
    var result = void 0;
    var raceInfo = _PricesStateStore.pricesStateStore.getRaceInfo(renderConfig);
    var raceSuspendState = raceInfo && raceInfo.suspendState;
    var isHorseSuspended = [renderConfig.status, raceSuspendState].includes('H');

    if (isHorseSuspended) {
        return '-';
    }
    if (!renderConfig.decimalPrice && !renderConfig.fractionalPrice) {
        return '';
    }
    if (!renderConfig.decimalPrice) {
        return 'SP';
    }
    if (_PricesStateStore.pricesStateStore.isDecimalPrice()) {
        result = Math.floor(parseFloat(renderConfig.decimalPrice) * 100) / 100;
    } else {
        result = renderConfig.fractionalPrice;
    }
    if (renderConfig.bookmaker === 'TOTE') {
        result = parseFloat(result).toFixed(2);
    }
    return result;
}

function getPriceContainer(horseData) {
    return (0, _jquery2.default)('[' + _DIFFUSION2.default.DATA.INPUT.HORSE_NAME + ']').toArray().filter(function (element) {
        var _getElementDiffusionD = getElementDiffusionData(element),
            courseName = _getElementDiffusionD.courseName,
            raceTime = _getElementDiffusionD.raceTime,
            raceDate = _getElementDiffusionD.raceDate,
            horseName = _getElementDiffusionD.horseName;

        return horseName.toUpperCase() === horseData.horseName.toUpperCase() && raceDate === horseData.raceDate && raceTime === horseData.raceTime && courseName === horseData.courseName;
    });
}

// TODO: export by default or export all methods separately (JIRA: PC-4559)
/* eslint-disable import/prefer-default-export */
var diffusionServiceUtils = exports.diffusionServiceUtils = {
    getTopicRaceType: getTopicRaceType,
    getTopicInfoType: getTopicInfoType,
    getTopicMarketType: getTopicMarketType,
    getTopicRaceDate: getTopicRaceDate,
    getTopicCourseName: getTopicCourseName,
    getTopicRaceTime: getTopicRaceTime,
    getTopicHorseName: getTopicHorseName,
    getTopicBookmaker: getTopicBookmaker,
    getElementDataAttribute: getElementDataAttribute,
    getElementDiffusionData: getElementDiffusionData,
    createInfoTopic: createInfoTopic,
    createPriceTopic: createPriceTopic,
    parseDiffusionTopic: parseDiffusionTopic,
    parseInfoTopicData: parseInfoTopicData,
    parsePriceTopicData: parsePriceTopicData,
    getDisplayedPriceValue: getDisplayedPriceValue,
    getPriceContainer: getPriceContainer
};

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var nonRunnerKeys = ['NR', 'WD'];

var isRunnerCode = exports.isRunnerCode = function isRunnerCode(raceOutcomeCode) {
    return !nonRunnerKeys.includes(raceOutcomeCode);
};

var isRunner = exports.isRunner = function isRunner(_ref) {
    var raceOutcomeCode = _ref.raceOutcomeCode;
    return isRunnerCode(raceOutcomeCode);
};

var duplicateArrayVals = exports.duplicateArrayVals = function duplicateArrayVals(sourceArr) {
    return sourceArr.reduce(function (acc, el) {
        return [].concat(_toConsumableArray(acc), [el, el]);
    }, []);
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.sortByRaceName = exports.formatRaceName = undefined;

var _lodash = __webpack_require__(9);

var formatRaceName = exports.formatRaceName = function formatRaceName(name) {
    if ((0, _lodash.toLower)(name) === 'total') {
        return 'TOTAL';
    }

    return (0, _lodash.capitalize)(name).replace('aw', 'AW').replace('Nhf', 'NHF');
};

var raceNameIndexes = {
    Hurdle: 1,
    Chase: 2,
    NHF: 3
};

var sortByRaceName = exports.sortByRaceName = function sortByRaceName(key) {
    return function (a, b) {
        var name1 = a[key];
        var name2 = b[key];
        if (name1 === name2) {
            return 0;
        }

        var index1 = raceNameIndexes[name1];
        var index2 = raceNameIndexes[name2];
        if (index1 && index2) {
            return index1 - index2;
        }

        return name1 > name2 ? 1 : -1;
    };
};

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.buildProfileUrl = exports.nameToBannerUrl = exports.nameToUrl = undefined;

var _lodash = __webpack_require__(9);

var nameToUrl = exports.nameToUrl = function nameToUrl(name) {
    return (0, _lodash.toLower)(name).replace(/[^\w\d\s-]/g, '').replace(/\s+/g, '-');
};

var nameToBannerUrl = exports.nameToBannerUrl = function nameToBannerUrl(name) {
    return (0, _lodash.toLower)(name).replace(/\.|\s|'/g, '');
};

var buildProfileUrl = exports.buildProfileUrl = function buildProfileUrl(id, name, type) {
    return '/profile/' + type + '/' + id + '/' + nameToUrl(name);
};

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added
 * @returns {Date} the new date with the milliseconds added
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * var result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds (dirtyDate, dirtyAmount) {
  var timestamp = parse(dirtyDate).getTime()
  var amount = Number(dirtyAmount)
  return new Date(timestamp + amount)
}

module.exports = addMilliseconds


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(176)
var startOfISOWeek = __webpack_require__(178)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getHorseName = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = analyticsPage;

var _rpAnalytics = __webpack_require__(59);

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var section1 = {
    horse: 'Horses',
    jockey: 'Jockeys',
    owner: 'Owners',
    trainer: 'Trainers',
    course: 'Courses'
};

var state = {
    raceHorseName: '',
    jokeyName: '',
    ownerName: '',
    trainerName: '',
    courseName: ''
};

var getHorseName = exports.getHorseName = function getHorseName() {
    return state.raceHorseName;
};

function analyticsPage() {
    var _extends2;

    var preloadedState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var hasAccess = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var pathnameSplit = global.location.pathname.split('/');
    var type = pathnameSplit[2];
    // eslint-disable-next-line

    if (preloadedState) {
        state.raceHorseName = type === 'horse' && preloadedState.profile && preloadedState.profile.horseName;

        state.jokeyName = type === 'jockey' && preloadedState.profile && preloadedState.profile.styleName;

        state.ownerName = type === 'owner' && preloadedState.profile && preloadedState.profile.styleName;

        state.trainerName = type === 'trainer' && preloadedState.profile && preloadedState.profile.styleName;

        state.courseName = type === 'course' && preloadedState.profile && preloadedState.profile.courseStyleName;
    }

    /*
        These constants for sections are for the bloodstock horse profile logic JP-9373
        where we have to add site_sub_section_3 in the analytics for the bloodstock horse profile on Stub Record and Sales Record tabs.
     */
    var newSection2 = (0, _jquery2.default)('span.ui-tabs__tab_selected').attr('data-tab-name');
    var newSection3 = (0, _jquery2.default)('.pp-subTabs__tab_selected').text();

    var commonTraits = segmentio.getCommonTraits();

    var oldSection2 = commonTraits && commonTraits[segmentio.TRAIT_SITE_SUB_SECTION_2];
    var oldSection3 = commonTraits && commonTraits[segmentio.TRAIT_SITE_SUB_SECTION_3];

    var shouldIncludeSectionThree = newSection2 === 'Stud Record' || newSection2 === 'Sales Record';
    var hasSectionThree = newSection3 !== '' && newSection3 !== oldSection3;

    var hasSectionTwo = newSection2 && newSection2 !== oldSection2;

    if (!hasSectionTwo && !hasSectionThree) {
        return;
    }

    var subsection = localStorage.getItem('subsection');

    segmentio.clearCommonTraits();
    var commonTraitsProps = _extends((_extends2 = {}, _defineProperty(_extends2, segmentio.TRAIT_SITE_SECTION, 'Profiles'), _defineProperty(_extends2, segmentio.TRAIT_SITE_SUB_SECTION_1, section1[type]), _defineProperty(_extends2, segmentio.TRAIT_SITE_SUB_SECTION_2, newSection2), _extends2), subsection && _defineProperty({}, segmentio.TRAIT_SUBSECTION, subsection));

    if (shouldIncludeSectionThree) {
        segmentio.setCommonTraits(_extends({}, commonTraitsProps, _defineProperty({}, segmentio.TRAIT_SITE_SUB_SECTION_3, newSection3)));
    } else {
        segmentio.setCommonTraits(_extends({}, commonTraitsProps));
    }

    var pageTraits = {};

    if (state.raceHorseName) {
        pageTraits['race_horse_name'] = state.raceHorseName; // eslint-disable-line
    }

    if (state.jokeyName) {
        pageTraits['jockey_name'] = state.jokeyName; // eslint-disable-line
    }

    if (state.ownerName) {
        pageTraits['owner_name'] = state.ownerName; // eslint-disable-line
    }

    if (state.trainerName) {
        pageTraits['trainer_name'] = state.trainerName; // eslint-disable-line
    }

    if (state.courseName) {
        pageTraits['course_name'] = state.courseName; // eslint-disable-line
    }

    if (hasAccess !== null) {
        pageTraits.paywall_barrier = hasAccess; // eslint-disable-line
    }
    pageTraits.title = window.pageTitle;

    var eventName = window.location.pathname;

    segmentio.page(eventName, pageTraits, segmentio.page.DEFAULT_OPTIONS);
}
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Definition = __webpack_require__(143);

var _Definition2 = _interopRequireDefault(_Definition);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseDefinition = function HorseDefinition(_ref) {
    var horseName = _ref.horseName,
        horseUid = _ref.horseUid,
        countryOriginCode = _ref.countryOriginCode,
        avgFlatWinDist = _ref.avgFlatWinDist,
        term = _ref.term;
    return horseUid ? _jsx(_Definition2.default, {
        term: term
    }, void 0, _jsx(_ProfileLink.HorseLink, {
        horseStyleName: horseName,
        horseUid: horseUid,
        className: 'hp-horseDefinition__link'
    }), '\xA0', _jsx('span', {
        className: 'hp-horseDefinition__country'
    }, void 0, '(', countryOriginCode, ')'), !!avgFlatWinDist && ' (' + avgFlatWinDist + 'f)') : null;
};

exports.default = HorseDefinition;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Switcher = function Switcher(_ref) {
    var items = _ref.items,
        selected = _ref.selected,
        setSelected = _ref.setSelected;
    return items.length <= 1 ? null : _jsx('div', {
        className: 'ui-switcher'
    }, void 0, items.map(function (item, index) {
        return _jsx('button', {
            className: (0, _classnames2.default)('ui-btn', 'ui-switcher__btn', index === selected && 'ui-btn_primary', index !== selected && 'ui-btn_secondary'),
            onClick: function onClick() {
                return setSelected(index);
            }
        }, item, item);
    }));
};

exports.default = Switcher;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _money = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StakeCell = function StakeCell(_ref) {
    var stake = _ref.stake;
    return stake <= 0 ? (0, _money.formatStake)(stake) : _jsx('strong', {}, void 0, (0, _money.formatStake)(stake));
};

exports.default = StakeCell;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _date = __webpack_require__(18);

var _url = __webpack_require__(232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon ui-icon__btn chevronIcon',
    size: 'XSmall'
});

var RaceCardLink = function RaceCardLink(_ref) {
    var courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        raceDatetime = _ref.raceDatetime,
        raceUid = _ref.raceInstanceUid,
        children = _ref.children;

    if (!courseName || !courseUid || !raceDatetime || !raceUid) {
        return null;
    }

    var date = (0, _date.formatDate)(raceDatetime, 'Y-MM-DD');
    var url = '/racecards/' + courseUid + '/' + (0, _url.nameToUrl)(courseName) + '/' + date + '/' + raceUid;
    return _jsx('a', {
        className: 'ui-link ui-link_table js-popupLink js-navigate-url',
        href: url
    }, void 0, children, _ref2);
};

exports.default = RaceCardLink;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _axios = __webpack_require__(127);

var _axios2 = _interopRequireDefault(_axios);

var _FetchError = __webpack_require__(1237);

var _FetchError2 = _interopRequireDefault(_FetchError);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(200);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref4 = _jsx(_rpReactTable.Loading, {});

var TabFetchProvider = function (_PureComponent) {
    _inherits(TabFetchProvider, _PureComponent);

    function TabFetchProvider(props) {
        _classCallCheck(this, TabFetchProvider);

        var _this = _possibleConstructorReturn(this, (TabFetchProvider.__proto__ || Object.getPrototypeOf(TabFetchProvider)).call(this, props));

        _this.resizeUpdate = function (event) {
            var isMobile = event.detail;
            _this.setState(_extends({}, _this.state, {
                isMobile: isMobile
            }));
        };

        _this.cancelRequest = function () {
            return null;
        };

        _this.refresh = function () {
            clearTimeout(_this.state.errorTimeout);
            _this.setState({
                errorTimeout: null
            });
            _this.fetchData(_this.props.params);
        };

        _this.state = {
            shouldFetch: true,
            errorTimeout: null,
            isMobile: localStorage.getItem('isMobile') === 'true'
        };
        return _this;
    }

    _createClass(TabFetchProvider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('screen-resized', this.resizeUpdate);

            this.fetchData(this.props.params);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var params = _ref.params;
            var _props$params = this.props.params,
                id = _props$params.id,
                tab = _props$params.tab;

            if (id === params.id && tab === params.tab) {
                return;
            }

            this.cancelRequest();
            this.setState({ shouldFetch: true, data: {} });

            this.fetchData(params);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('screen-resized', this.resizeUpdate);
        }
    }, {
        key: 'fetchData',
        value: function fetchData(_ref2) {
            var _this2 = this;

            var id = _ref2.id,
                name = _ref2.name,
                tab = _ref2.tab,
                type = _ref2.type;

            var indexTab = this.props.route.fetchPath || '';
            var tabOrIndex = tab || indexTab;

            _axios2.default.get('tab/' + type + '/' + id + '/' + name + '/' + tabOrIndex, {
                cancelToken: new _axios.CancelToken(function (cancel) {
                    _this2.cancelRequest = cancel;
                })
            }).then(function (_ref3) {
                var data = _ref3.data;

                _this2.setState({ shouldFetch: false, data: data }, function () {
                    (0, _fixMobileSafariWhiteScreenBug2.default)();
                });
            }).catch(function (error) {
                if ((0, _axios.isCancel)(error)) {
                    return;
                }

                console.warn(error);
                _this2.setState({
                    errorTimeout: setTimeout(_this2.refresh, 20000)
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                shouldFetch = _state.shouldFetch,
                fetchedData = _state.data,
                errorTimeout = _state.errorTimeout,
                isMobile = _state.isMobile;
            var _props = this.props,
                Tab = _props.route.Tab,
                params = _props.params,
                data = _props.data,
                hasAccess = _props.hasAccess;


            return shouldFetch ? _jsx('section', {}, void 0, _ref4, errorTimeout && _jsx(_FetchError2.default, {
                refresh: this.refresh
            })) : _jsx(Tab, {
                data: Object.assign({}, data, fetchedData),
                params: params,
                isMobile: isMobile,
                hasAccess: hasAccess
            });
        }
    }]);

    return TabFetchProvider;
}(_react.PureComponent);

exports.default = TabFetchProvider;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var formatWeight = function formatWeight(weightInLbs) {
    return weightInLbs ? Math.floor(weightInLbs / 14) + "-" + weightInLbs % 14 : null;
};

exports.default = formatWeight;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.areAllFieldsEmpty = exports.fromObjToArray = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(9);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * Convert object to array
 * @param dataObj object
 * @param keyField string
 * @returns {array}
 */
var fromObjToArray = exports.fromObjToArray = function fromObjToArray(dataObj) {
    var keyField = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'key';
    return (0, _lodash.keys)(dataObj).map(function (key) {
        return _extends(_defineProperty({}, keyField, key), dataObj[key]);
    });
};

/**
 * Check if all obj/array values are empty
 * @param obj array
 * @returns {boolean}
 */
var areAllFieldsEmpty = exports.areAllFieldsEmpty = function areAllFieldsEmpty(obj) {
    return (0, _lodash.values)(obj).every(function (val) {
        return (0, _lodash.isPlainObject)(val) ? areAllFieldsEmpty(val) : !val;
    });
};

/***/ }),
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var getDaysInMonth = __webpack_require__(462)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(177)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Millisecond Helpers
 * @summary Get the number of milliseconds between the given dates.
 *
 * @description
 * Get the number of milliseconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of milliseconds
 *
 * @example
 * // How many milliseconds are between
 * // 2 July 2014 12:30:20.600 and 2 July 2014 12:30:21.700?
 * var result = differenceInMilliseconds(
 *   new Date(2014, 6, 2, 12, 30, 21, 700),
 *   new Date(2014, 6, 2, 12, 30, 20, 600)
 * )
 * //=> 1100
 */
function differenceInMilliseconds (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getTime() - dateRight.getTime()
}

module.exports = differenceInMilliseconds


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Grid__ = __webpack_require__(958);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__Grid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellRangeRenderer__ = __webpack_require__(959);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__defaultCellRangeRenderer__["a"]; });







/***/ }),
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    DATA: {
        INPUT: {
            HORSE_NAME: 'data-diffusion-horsename',
            COURSE_NAME: 'data-diffusion-coursename',
            RACE_TIME: 'data-diffusion-racetime',
            RACE_DATE: 'data-diffusion-racedate',
            BOOKMAKER: 'data-diffusion-bookmaker'
        },
        OUTPUT: {
            OUTCOMERS_ID: 'data-diffusion-outcomers-id',
            FRACTIONAL: 'data-diffusion-fractional',
            DECIMAL: 'data-diffusion-decimal',
            HISTORY: 'data-diffusion-history',
            STATUS: 'data-diffusion-status',
            EVENT_ID: 'data-diffusion-event-id',
            MARKET_ID: 'data-diffusion-market-id',
            MEETING_ID: 'data-diffusion-meeting-id',
            NEXT_PRICE: 'data-diffusion-next-price'
        }
    }
};

/***/ }),
/* 385 */,
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

module.exports = __webpack_require__(2624);


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var randomFromSeed = __webpack_require__(2627);

var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
var alphabet;
var previousSeed;

var shuffled;

function reset() {
    shuffled = false;
}

function setCharacters(_alphabet_) {
    if (!_alphabet_) {
        if (alphabet !== ORIGINAL) {
            alphabet = ORIGINAL;
            reset();
        }
        return;
    }

    if (_alphabet_ === alphabet) {
        return;
    }

    if (_alphabet_.length !== ORIGINAL.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
    }

    var unique = _alphabet_.split('').filter(function(item, ind, arr){
       return ind !== arr.lastIndexOf(item);
    });

    if (unique.length) {
        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
    }

    alphabet = _alphabet_;
    reset();
}

function characters(_alphabet_) {
    setCharacters(_alphabet_);
    return alphabet;
}

function setSeed(seed) {
    randomFromSeed.seed(seed);
    if (previousSeed !== seed) {
        reset();
        previousSeed = seed;
    }
}

function shuffle() {
    if (!alphabet) {
        setCharacters(ORIGINAL);
    }

    var sourceArray = alphabet.split('');
    var targetArray = [];
    var r = randomFromSeed.nextValue();
    var characterIndex;

    while (sourceArray.length > 0) {
        r = randomFromSeed.nextValue();
        characterIndex = Math.floor(r * sourceArray.length);
        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
    }
    return targetArray.join('');
}

function getShuffled() {
    if (shuffled) {
        return shuffled;
    }
    shuffled = shuffle();
    return shuffled;
}

/**
 * lookup shuffled letter
 * @param index
 * @returns {string}
 */
function lookup(index) {
    var alphabetShuffled = getShuffled();
    return alphabetShuffled[index];
}

function get () {
  return alphabet || ORIGINAL;
}

module.exports = {
    get: get,
    characters: characters,
    seed: setSeed,
    lookup: lookup,
    shuffled: getShuffled
};


/***/ }),
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(87);
var normalizeHeaderName = __webpack_require__(1034);

var PROTECTION_PREFIX = /^\)\]\}',?\n/;
var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(592);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(592);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      data = data.replace(PROTECTION_PREFIX, '');
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMehtodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(84)))

/***/ }),
/* 392 */,
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__(73);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(9);

var _Definition = __webpack_require__(143);

var _Definition2 = _interopRequireDefault(_Definition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formatBirthDate = function formatBirthDate(utc) {
    return (0, _moment2.default)(utc).format('DDMMMYY');
};

var _ref = _jsx('span', {
    className: 'hp-details__info'
});

var Age = function Age(props) {
    var age = props.age,
        horseDateOfBirth = props.horseDateOfBirth,
        horseColourCode = props.horseColourCode,
        horseSexCode = props.horseSexCode,
        avgFlatWinDist = props.avgFlatWinDist,
        isWeatherbysMobile = props.isWeatherbysMobile;

    var data = (0, _lodash.compact)([horseDateOfBirth && formatBirthDate(horseDateOfBirth), (0, _lodash.toLower)(horseColourCode), (0, _lodash.toLower)(horseSexCode)]).join(' ');

    if (isWeatherbysMobile) {
        var term = age.replace(/-/g, '') + ' (' + data + ')';

        return _jsx(_Definition2.default, {
            term: term,
            isTermLabel: false
        }, void 0, avgFlatWinDist && _jsx('span', {
            className: 'hp-details__info'
        }, void 0, '\xA0(', avgFlatWinDist, 'f)'), !avgFlatWinDist && age && _ref);
    }

    return _jsx(_Definition2.default, {
        term: age.replace(/-/g, '')
    }, void 0, data && _jsx('span', {
        className: 'hp-details__info'
    }, void 0, '(', data, ')'), avgFlatWinDist && _jsx('span', {
        className: 'hp-details__info'
    }, void 0, '\xA0(', avgFlatWinDist, 'f)'));
};

exports.default = Age;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Definition = __webpack_require__(143);

var _Definition2 = _interopRequireDefault(_Definition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Breeder = function Breeder(_ref) {
    var breederName = _ref.breederName,
        className = _ref.className,
        isWeatherbysMobile = _ref.isWeatherbysMobile;

    if (isWeatherbysMobile) {
        return breederName ? _jsx(_Definition2.default, {
            term: isWeatherbysMobile ? breederName : 'Breeder',
            className: className,
            forceShow: true,
            isTermLabel: false,
            description: ''
        }) : null;
    }

    return breederName ? _jsx(_Definition2.default, {
        term: 'Breeder',
        className: className,
        description: breederName
    }) : null;
};

exports.default = Breeder;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorseDefinition = __webpack_require__(294);

var _HorseDefinition2 = _interopRequireDefault(_HorseDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Dam = function Dam(_ref) {
    var damHorseName = _ref.damHorseName,
        damUid = _ref.damUid,
        damCountryOriginCode = _ref.damCountryOriginCode,
        isWeatherbysMobile = _ref.isWeatherbysMobile;
    return _jsx(_HorseDefinition2.default, {
        countryOriginCode: damCountryOriginCode,
        horseName: damHorseName,
        horseUid: damUid,
        term: isWeatherbysMobile ? '' : 'Dam'
    });
};

exports.default = Dam;

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorseDefinition = __webpack_require__(294);

var _HorseDefinition2 = _interopRequireDefault(_HorseDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DamSire = function DamSire(_ref) {
    var damSireHorseName = _ref.damSireHorseName,
        damSireUid = _ref.damSireUid,
        damSireCountryOriginCode = _ref.damSireCountryOriginCode,
        damSireAvgFlatWinDist = _ref.damSireAvgFlatWinDist,
        isWeatherbysMobile = _ref.isWeatherbysMobile;
    return _jsx(_HorseDefinition2.default, {
        avgFlatWinDist: damSireAvgFlatWinDist,
        countryOriginCode: damSireCountryOriginCode,
        horseName: damSireHorseName,
        horseUid: damSireUid,
        term: isWeatherbysMobile ? '' : 'Dam\'s Sire'
    });
};

exports.default = DamSire;

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shortid = __webpack_require__(386);

var _shortid2 = _interopRequireDefault(_shortid);

var _lodash = __webpack_require__(9);

var _Definition = __webpack_require__(143);

var _Definition2 = _interopRequireDefault(_Definition);

var _ProfileLink = __webpack_require__(26);

var _date = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var previousOwner = function previousOwner(owner) {
    return _jsx('li', {}, _shortid2.default.generate(), owner.ownerStyleName, ' until ', (0, _date.formatDate)(owner.ownerChangeDate, 'D MMM YYYY'));
};

var Owner = function Owner(_ref) {
    var ownerName = _ref.ownerName,
        ownerUid = _ref.ownerUid,
        hasPedigree = _ref.hasPedigree,
        previousOwners = _ref.previousOwners,
        isWeatherbysMobile = _ref.isWeatherbysMobile;

    if (isWeatherbysMobile) {
        return ownerUid ? _jsx(_Definition2.default, {
            term: ''
        }, void 0, _jsx(_ProfileLink.OwnerLink, {
            ownerStyleName: ownerName,
            ownerUid: ownerUid
        })) : null;
    }

    return ownerUid ? _jsx(_Definition2.default, {
        term: (hasPedigree ? 'Racing ' : '') + 'Owner'
    }, void 0, _jsx(_ProfileLink.OwnerLink, {
        ownerStyleName: ownerName,
        ownerUid: ownerUid
    }), !(0, _lodash.isEmpty)(previousOwners) && _jsx('ul', {
        className: 'hp-details__owners-list'
    }, void 0, previousOwners.map(previousOwner))) : null;
};

exports.default = Owner;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorseDefinition = __webpack_require__(294);

var _HorseDefinition2 = _interopRequireDefault(_HorseDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sire = function Sire(_ref) {
    var sireHorseName = _ref.sireHorseName,
        sireUid = _ref.sireUid,
        sireCountryOriginCode = _ref.sireCountryOriginCode,
        sireAvgFlatWinDist = _ref.sireAvgFlatWinDist,
        isWeatherbysMobile = _ref.isWeatherbysMobile;
    return _jsx(_HorseDefinition2.default, {
        avgFlatWinDist: sireAvgFlatWinDist,
        countryOriginCode: sireCountryOriginCode,
        horseName: sireHorseName,
        horseUid: sireUid,
        term: isWeatherbysMobile ? '' : 'Sire'
    });
};

exports.default = Sire;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Definition = __webpack_require__(143);

var _Definition2 = _interopRequireDefault(_Definition);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Trainer = function Trainer(_ref) {
    var hasPedigree = _ref.hasPedigree,
        trainerName = _ref.trainerName,
        trainerUid = _ref.trainerUid,
        isWeatherbysMobile = _ref.isWeatherbysMobile,
        _ref$trainerLast14Day = _ref.trainerLast14Days,
        wins = _ref$trainerLast14Day.wins,
        runs = _ref$trainerLast14Day.runs,
        percent = _ref$trainerLast14Day.percent;
    return trainerUid ? _jsx(_Definition2.default, {
        term: isWeatherbysMobile ? '' : 'Trainer'
    }, void 0, _jsx(_ProfileLink.TrainerLink, {
        trainerStyleName: trainerName,
        trainerUid: trainerUid
    }), !hasPedigree && !!runs && _jsx('span', {
        className: 'hp-details__info'
    }, void 0, '\xA0(Last 14 days: ', wins, '-', runs, ', ', percent, '%)')) : null;
};

exports.default = Trainer;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.myRatingsType = exports.raceRecordsType = exports.figuresType = exports.formType = undefined;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var formType = exports.formType = _propTypes2.default.shape({
    raceDatetime: _propTypes2.default.string,
    courseName: _propTypes2.default.string,
    distanceYard: _propTypes2.default.number,
    goingTypeServicesDesc: _propTypes2.default.string,
    goingTypeCode: _propTypes2.default.string,
    weightCarriedLbs: _propTypes2.default.number,
    otherHorse: _propTypes2.default.shape({
        styleName: _propTypes2.default.string,
        weightCarriedLbs: _propTypes2.default.number
    }),
    oddsDesc: _propTypes2.default.string,
    jockeyShortName: _propTypes2.default.string,
    officialRatingRanOff: _propTypes2.default.number,
    rpTopspeed: _propTypes2.default.number,
    rpPostmark: _propTypes2.default.number,
    rukReplayAvailable: _propTypes2.default.bool
});

var figuresType = exports.figuresType = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    raceTypeCode: _propTypes2.default.string,
    formFigure: _propTypes2.default.string
}));

var raceRecordsType = exports.raceRecordsType = _propTypes2.default.shape({
    jumpsFiguresCalculated: figuresType,
    flatFiguresCalculated: figuresType,
    lifetimeRecords: _propTypes2.default.objectOf(_propTypes2.default.shape({
        starts: _propTypes2.default.number.isRequired,
        wins: _propTypes2.default.number.isRequired,
        '2nds': _propTypes2.default.number.isRequired,
        '3rds': _propTypes2.default.number.isRequired,
        winnigs: _propTypes2.default.number,
        earnings: _propTypes2.default.number,
        'or+': _propTypes2.default.number,
        bestTs: _propTypes2.default.number,
        bestRpr: _propTypes2.default.number
    }))
});

var myRatingsType = exports.myRatingsType = _propTypes2.default.objectOf(_propTypes2.default.number);

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(112);

var _reactRouter = __webpack_require__(199);

var _history = __webpack_require__(1017);

__webpack_require__(1016);

var _humanRoutes = __webpack_require__(1013);

var _humanRoutes2 = _interopRequireDefault(_humanRoutes);

var _courseRoutes = __webpack_require__(1011);

var _courseRoutes2 = _interopRequireDefault(_courseRoutes);

var _horseRoutes = __webpack_require__(1012);

var _horseRoutes2 = _interopRequireDefault(_horseRoutes);

var _rpLibs = __webpack_require__(1014);

var _rpLibs2 = _interopRequireDefault(_rpLibs);

var _analyticsPage = __webpack_require__(290);

var _analyticsPage2 = _interopRequireDefault(_analyticsPage);

var _isBloodstockHorseProfile = __webpack_require__(588);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

_rpLibs2.default.beforeRender();

var routes = [].concat(_toConsumableArray(_humanRoutes2.default), [_courseRoutes2.default, _horseRoutes2.default]);

var browserHistory = (0, _reactRouter.useRouterHistory)(_history.createHistory)({
    basename: '/profile/'
});

var onRouteUpdate = function onRouteUpdate() {
    var _browserHistory$getCu = browserHistory.getCurrentLocation(),
        pathname = _browserHistory$getCu.pathname,
        search = _browserHistory$getCu.search,
        hash = _browserHistory$getCu.hash;

    var newRoute = '' + pathname + search + hash;
    var routeParts = newRoute.split('/').filter(function (routePart) {
        return routePart !== '';
    });

    var isBloodstockProfile = (0, _isBloodstockHorseProfile.isBloodstockHorseProfile)();

    if (routeParts.length >= 3 && isBloodstockProfile) {
        (0, _analyticsPage2.default)();
    }
};

(0, _reactDom.render)(_jsx(_reactRouter.Router, {
    routes: routes,
    history: browserHistory,
    onUpdate: function onUpdate() {
        onRouteUpdate();
    }
}), document.querySelector('main'));

_rpLibs2.default.afterRender();

exports.default = browserHistory;

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpGuiGuide = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// on desktop iOS arrow is always down (you cannot see it when Select is opened)
var isDesktopIos = !_rpGuiGuide.mobileDetect.isPhone() && !_rpGuiGuide.mobileDetect.tablet() && window.navigator.userAgent.indexOf('Mac') > -1;

var Select = function (_PureComponent) {
    _inherits(Select, _PureComponent);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.onSelect = function (e) {
            _this.props.onSelect(e.target.value);
        };

        _this.toggleArrow = function () {
            _this.setState(function (_ref) {
                var arrowUp = _ref.arrowUp;
                return { arrowUp: !arrowUp };
            });
        };

        _this.downArrow = function () {
            _this.setState({ arrowUp: false });
        };

        _this.state = { arrowUp: false };
        return _this;
    }

    _createClass(Select, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                children = _props.children,
                value = _props.value,
                options = _props.options,
                wrapperClass = _props.wrapperClass;

            var title = children || options[value];

            var arrowClass = (0, _classnames2.default)('pp-select__arrow', !isDesktopIos && this.state.arrowUp && 'pp-select__arrow_up');

            var selectBoxState = (0, _classnames2.default)(this.state.arrowUp && 'ui-btn_primary pp-select__selected');

            // "slt" and "sld" classes are used for automation tests
            return options.length > 1 ? _jsx('div', {
                className: 'pp-select ui-btn ' + wrapperClass + ' ' + selectBoxState
            }, void 0, title, _jsx(_rpReactSvgIcon2.default, {
                iconName: 'down',
                size: 'Medium',
                className: arrowClass
            }), _jsx('select', {
                className: 'slt pp-select__input',
                value: value,
                onChange: this.onSelect,
                onBlur: this.downArrow,
                onClick: this.toggleArrow
            }, void 0, options.map(function (optionText, index) {
                return _jsx('option', {
                    value: index,
                    className: value === index ? 'sld' : null
                }, optionText, optionText);
            }))) : _jsx('div', {
                className: 'pp-select'
            }, void 0, title);
        }
    }]);

    return Select;
}(_react.PureComponent);

exports.default = Select;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CopyrightWeatherby = function CopyrightWeatherby() {
    var date = new Date();

    return _jsx("div", {
        className: "copyright-weatherbys"
    }, void 0, "Copyright \xA9 ", date.getFullYear(), " Weatherbys. All rights reserved.");
};

exports.default = CopyrightWeatherby;

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = __webpack_require__(2387);

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _getHumanMetaData = __webpack_require__(1252);

var _getHumanMetaData2 = _interopRequireDefault(_getHumanMetaData);

var _getHorseMetaData = __webpack_require__(1251);

var _getHorseMetaData2 = _interopRequireDefault(_getHorseMetaData);

var _getCourseMetaData = __webpack_require__(1250);

var _getCourseMetaData2 = _interopRequireDefault(_getCourseMetaData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMetaData = function getMetaData(type, page, name, profile) {
    switch (type) {
        case 'course':
            return (0, _getCourseMetaData2.default)(page, name);
        case 'horse':
            return (0, _getHorseMetaData2.default)(page, profile);
        default:
            return (0, _getHumanMetaData2.default)(type, page, name);
    }
};

var MetaData = function MetaData(_ref) {
    var type = _ref.type,
        page = _ref.page,
        name = _ref.name,
        profile = _ref.profile;

    var _getMetaData = getMetaData(type, page, name, profile),
        title = _getMetaData.title,
        description = _getMetaData.description;

    return _jsx(_reactHelmet2.default, {
        title: title,
        meta: [{
            name: 'description',
            content: description.replace(/\s\s+/g, ' ')
        }]
    });
};

exports.default = MetaData;

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpAuth = __webpack_require__(287);

var _lodash = __webpack_require__(9);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _NavLink = __webpack_require__(1255);

var _NavLink2 = _interopRequireDefault(_NavLink);

var _HelpLink = __webpack_require__(1253);

var _HelpLink2 = _interopRequireDefault(_HelpLink);

var _MoreBtn = __webpack_require__(1254);

var _MoreBtn2 = _interopRequireDefault(_MoreBtn);

var _SubNav = __webpack_require__(1257);

var _SubNav2 = _interopRequireDefault(_SubNav);

var _tabNames = __webpack_require__(128);

var _tabNames2 = _interopRequireDefault(_tabNames);

var _isShown = __webpack_require__(1261);

var _isShown2 = _interopRequireDefault(_isShown);

var _calculateTabUrl = __webpack_require__(629);

var _calculateTabUrl2 = _interopRequireDefault(_calculateTabUrl);

var _checkSubTabSelected = __webpack_require__(1260);

var _checkSubTabSelected2 = _interopRequireDefault(_checkSubTabSelected);

var _calculateActiveClass = __webpack_require__(1259);

var _calculateActiveClass2 = _interopRequireDefault(_calculateActiveClass);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _ref2 = _jsx('div', {
    className: 'stallion-logo'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    iconName: 'stallionBookLogo'
}));

var Nav = function Nav(_ref) {
    var _ref$params = _ref.params,
        type = _ref$params.type,
        id = _ref$params.id,
        name = _ref$params.name,
        currentTab = _ref$params.tab,
        _ref$params$hash = _ref$params.hash,
        hash = _ref$params$hash === undefined ? '' : _ref$params$hash,
        _ref$params$mr = _ref$params.mr,
        mr = _ref$params$mr === undefined ? {} : _ref$params$mr,
        helpUrl = _ref.helpUrl,
        tabsToExclude = _ref.tabsToExclude,
        horseType = _ref.horseType,
        isMobile = _ref.isMobile,
        onSubnavMenuExpand = _ref.onSubnavMenuExpand,
        isSubnavMenuExpanded = _ref.isSubnavMenuExpanded,
        userRole = _ref.userRole,
        pageName = _ref.pageName;

    var url = type + '/' + id + '/' + name;
    // removing tabs that shouldn't be rendered
    var tabs = _lodash.without.apply(undefined, [_tabNames2.default[horseType || type]].concat(_toConsumableArray(tabsToExclude)));
    (0, _rpAuth.createBarriers)();

    // calculating on what sreen size we need a "More" button
    var MoreBtnIsShown = tabs.length > _isShown2.default.XN + 1;
    var MoreBtnIsShownOnNarrow = tabs.length > _isShown2.default.N + 1;

    // sire tabs has sub-tabs so we need to handle this case
    var isSire = horseType === 'sire';
    var hasWeatherbys = isSire && !tabsToExclude.includes('stallionDetails');

    var isSubTabSelected = isSire && (0, _checkSubTabSelected2.default)(currentTab);
    var activeClassName = (0, _calculateActiveClass2.default)(isSire, hasWeatherbys, isSubTabSelected, currentTab);

    var currentSubTab = currentTab || (hasWeatherbys ? 'weatherbys-overview' : 'progeny');

    return _jsx('nav', {
        className: (0, _classnames2.default)('ui-tabs__wrapper', isSubTabSelected && 'pp-tabs__subNavWrapper')
    }, void 0, _jsx('div', {
        className: 'ui-tabs pp-tabs dark'
    }, void 0, tabs.map(function (tabName, index) {
        return _jsx(_NavLink2.default, {
            url: url,
            hash: hash,
            tabName: tabName,
            userRole: userRole,
            pageName: pageName,
            tabUrl: (0, _calculateTabUrl2.default)(currentTab, tabName, index, isSire, mr.isShown),
            activeClassName: activeClassName,
            cssClasses: [MoreBtnIsShown && index >= _isShown2.default.XN && 'hidden-xs-down', MoreBtnIsShownOnNarrow && index >= _isShown2.default.N && 'hidden-sm-down']
        }, tabName);
    }), MoreBtnIsShown && _jsx(_MoreBtn2.default, {
        url: url,
        hash: hash,
        tabNames: tabs.slice(_isShown2.default.XN),
        currentTab: currentTab,
        is5Tabs: tabs.length === 5
    }), _jsx(_HelpLink2.default, {
        url: helpUrl
    })), _tabNames.sireSubTabs.stallionDetails.includes(currentSubTab) && hasWeatherbys && _ref2, isSubTabSelected && _jsx(_SubNav2.default, {
        currentTab: currentTab,
        hasWeatherbys: hasWeatherbys,
        url: url,
        isMobile: isMobile,
        isExpanded: isSubnavMenuExpanded,
        onSubnavMenuExpand: onSubnavMenuExpand
    }));
};

Nav.defaultProps = {
    tabsToExclude: []
};

exports.default = Nav;

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpAuth = __webpack_require__(287);

var _timePeriods = __webpack_require__(408);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(200);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

var _analyticsPage = __webpack_require__(290);

var _analyticsPage2 = _interopRequireDefault(_analyticsPage);

var _getPageName = __webpack_require__(1266);

var _tabNames = __webpack_require__(128);

var _sessionStorage = __webpack_require__(1267);

var _isBloodstockHorseProfile = __webpack_require__(588);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ULTIMATE = _rpAuth.subscriptionTypes.ULTIMATE;

var Form = 'Form';
var COURSE_PROFILE = 'course_profile';

var PageProvider = function (_PureComponent) {
    _inherits(PageProvider, _PureComponent);

    function PageProvider(props) {
        _classCallCheck(this, PageProvider);

        var _this = _possibleConstructorReturn(this, (PageProvider.__proto__ || Object.getPrototypeOf(PageProvider)).call(this, props));

        _this.onFocus = function () {
            // on retaining focus, set the isFreeTrial to freeTrialAllowedOnThisTab,
            // which has the info if there should be a free trial for the specific page and tab
            sessionStorage.setItem('isFreeTrial', sessionStorage.getItem('freeTrialAllowedOnThisTab'));
        };

        _this.onBlur = function () {
            sessionStorage.removeItem('isFreeTrial');
        };

        var data = _extends({}, window.PRELOADED_STATE, {
            skybetDiffusionName: window.skybetDiffusionName,
            isSkybetMigrationEnabled: window.isSkybetMigrationEnabled,
            isDiffusionIdleTimerEnabled: window.isDiffusionIdleTimerEnabled
        });

        _this.state = {
            data: data,
            hasAccess: true,
            userRole: null,
            isFreeTrial: false,
            pageName: null
        };

        (0, _timePeriods.setActiveSeasons)(data.seasons);
        return _this;
    }

    _createClass(PageProvider, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            (0, _sessionStorage.setSessionStorageItem)('abTastyUserProps', JSON.stringify({
                isLogged: this.state.data.isLogged,
                userRole: this.state.data.originalSubscriptionLevel
            }));
            // eslint-disable-next-line no-unused-vars

            var _props$location$pathn = this.props.location.pathname.split('/'),
                _props$location$pathn2 = _slicedToArray(_props$location$pathn, 5),
                type = _props$location$pathn2[0],
                id = _props$location$pathn2[1],
                name = _props$location$pathn2[2],
                tab = _props$location$pathn2[3],
                subTab = _props$location$pathn2[4];

            var _state$data = this.state.data,
                userRole = _state$data.userRole,
                isFreeTrial = _state$data.isFreeTrial;


            var pageName = (0, _getPageName.getPageName)(type);

            if (userRole !== ULTIMATE && pageName !== COURSE_PROFILE) {
                var currentTab = tab || Form;
                var tabName = currentTab.toLowerCase().replace('-', '_');
                var shouldUseCustomMetering = _tabNames.restrictedPagesByCustomMetering[pageName].includes(tabName);

                // if page doesn't exist in metering, give access to it directly
                // P.S. That page might be behind MPP metering too
                // hasAccess is only for the custom metering rules
                var hasAccess = Boolean(_rpAuth.customMeteringRules[userRole][pageName][tabName]);

                if (!hasAccess && tabName !== Form.toLowerCase() && shouldUseCustomMetering) {
                    window.location.href = '/racecards/?authme';
                }

                this.setState({ hasAccess: hasAccess, userRole: userRole, pageName: pageName, isFreeTrial: isFreeTrial });
            }

            // user has Ultimate subscription
            if (userRole === ULTIMATE) {
                this.setState({ hasAccess: true, userRole: ULTIMATE, pageName: pageName });
            }
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            (0, _fixMobileSafariWhiteScreenBug2.default)();
            // add event listeners for focus, blur tab and unloading to remove the isFreeTrial
            // the event listeners will automatically detach when we go to another page because of SSR
            window.addEventListener('focus', this.onFocus);
            window.addEventListener('blur', this.onBlur);
            window.addEventListener('beforeunload', function () {
                window.removeEventListener('focus', _this2.onFocus);
                window.removeEventListener('blur', _this2.onBlur);
                sessionStorage.removeItem('isFreeTrial');
                sessionStorage.removeItem('freeTrialAllowedOnThisTab');
                sessionStorage.removeItem('freeTrialHeader');
            });

            var pathname = this.props.location.pathname;

            var pathParts = pathname.split('/').filter(Boolean);
            var isHorseProfile = pathParts.includes('horse');

            // HERE on first page load we trigger the normal horse profile analytics on in FormTable component didMount
            if (!isHorseProfile) {
                (0, _analyticsPage2.default)(this.state.data);
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
            (0, _fixMobileSafariWhiteScreenBug2.default)();
            var prevPathParts = prevProps.location.pathname.split('/').filter(Boolean).join('-');
            var currentPathParts = this.props.location.pathname.split('/').filter(Boolean).join('-');
            var isBloodstockHorseProfilePage = (0, _isBloodstockHorseProfile.isBloodstockHorseProfile)();

            // HERE analytics will be triggered on every tab change EXCEPT the bloodstock horse profile page, its logic is in the index.js file routerUpdate function
            if (prevPathParts !== currentPathParts && !isBloodstockHorseProfilePage) {
                (0, _analyticsPage2.default)(this.state.data);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                Page = _props.route.Page,
                location = _props.location,
                children = _props.children;

            var _location$pathname$sp = location.pathname.split('/'),
                _location$pathname$sp2 = _slicedToArray(_location$pathname$sp, 5),
                type = _location$pathname$sp2[0],
                id = _location$pathname$sp2[1],
                name = _location$pathname$sp2[2],
                tab = _location$pathname$sp2[3],
                subTab = _location$pathname$sp2[4];

            var hash = location.hash;
            var _state = this.state,
                data = _state.data,
                hasAccess = _state.hasAccess,
                pageName = _state.pageName,
                userRole = _state.userRole,
                preloadedFreeTrial = _state.isFreeTrial;


            var isFreeTrialAllowed = preloadedFreeTrial;

            // If the page is horse_profile but not Entries tab, there shouldn't be a free trial - JP-9931
            // this includes the stallion book
            if (pageName === 'horse_profile' && tab !== 'Entries') {
                isFreeTrialAllowed = false;
            }

            localStorage.setItem('userRole', userRole);
            sessionStorage.setItem('freeTrialHeader', preloadedFreeTrial);
            sessionStorage.setItem('freeTrialAllowedOnThisTab', isFreeTrialAllowed);
            sessionStorage.setItem('isFreeTrial', isFreeTrialAllowed);

            return _jsx(Page, {
                data: data,
                params: { type: type, id: id, name: name, tab: tab, hash: hash, subTab: subTab },
                hasAccess: hasAccess,
                userRole: userRole,
                pageName: pageName
            }, void 0, children);
        }
    }]);

    return PageProvider;
}(_react.PureComponent);

exports.default = PageProvider;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// reason of creating: goo.gl/YMZBM6

var TabProvider = function TabProvider(_ref) {
    var Tab = _ref.route.Tab,
        params = _ref.params,
        data = _ref.data;
    return Tab && _jsx(Tab, {
        data: data,
        params: params
    });
};

exports.default = TabProvider;

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.removeEndYear = exports.removeExtra = exports.getAvailable = exports.getLast5 = exports.getCurrent = exports.getAll = exports.setActiveSeasons = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.getRaceTypeStartYear = getRaceTypeStartYear;
exports.getCurrentSeasonEndYear = getCurrentSeasonEndYear;
exports.getPeriods = getPeriods;

var _lodash = __webpack_require__(9);

var _date = __webpack_require__(18);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var activeSeasons = [];

var setActiveSeasons = exports.setActiveSeasons = function setActiveSeasons(seasons) {
    activeSeasons.splice(0);
    activeSeasons.push.apply(activeSeasons, _toConsumableArray(seasons));
};

var getCurrentSeasonYear = function getCurrentSeasonYear(racingType) {
    var currentYear = new Date().getUTCFullYear();
    return racingType === 'jumps' ? currentYear - 1 : currentYear;
};

function getRaceTypeStartYear(racingType, country, seasons) {
    var startYearUTC = (0, _lodash.get)(seasons, [racingType, country], undefined);
    return startYearUTC ? (0, _date.getYearFromUtc)(startYearUTC) : getCurrentSeasonYear(racingType);
}

function getCurrentSeasonEndYear(racingType, country) {
    var currentYear = new Date().getUTCFullYear();
    var currentSeasonCode = 'F';
    if (racingType === 'jumps') {
        currentSeasonCode = country === 'IRE' ? 'I' : 'J';
    }
    var activeSeason = activeSeasons.find(function (_ref) {
        var seasonTypeCode = _ref.seasonTypeCode;
        return seasonTypeCode === currentSeasonCode;
    });

    return activeSeason ? (0, _date.getYearFromUtc)(activeSeason.seasonEndDate) : currentYear;
}

function getPeriods(startYear, endYear, raceType) {
    var periods = [];

    var labelTemplate = function labelTemplate(year) {
        return '' + year;
    };
    var valueTemplate = function valueTemplate(year) {
        return year + '/' + year;
    };

    if (raceType === 'jumps') {
        labelTemplate = function labelTemplate(year) {
            return year - 1 + '-' + year.toString().slice(2);
        };
        valueTemplate = function valueTemplate(year) {
            return year - 1 + '/' + year;
        };
    }

    for (var year = startYear; year > endYear; year -= 1) {
        periods.push({
            label: labelTemplate(year),
            value: valueTemplate(year)
        });
    }

    return periods;
}

var getAll = exports.getAll = function getAll(lastYear, currentYear) {
    return {
        label: 'All',
        value: lastYear + '/' + currentYear + '/all'
    };
};

var getCurrent = exports.getCurrent = function getCurrent(currentYear, type) {
    return {
        label: 'Current ' + (type === 'jumps' ? 'season' : 'year'),
        value: (type === 'jumps' ? currentYear - 1 : currentYear) + '/' + currentYear + '/current'
    };
};

var getLast5 = exports.getLast5 = function getLast5(currentSeasonEndYear, type) {
    var isJumps = type === 'jumps';
    var periodStartYear = currentSeasonEndYear - (isJumps ? 5 : 4);
    return {
        label: 'Last 5 ' + (isJumps ? 'season' : 'year') + 's',
        value: periodStartYear + '/' + currentSeasonEndYear + '/last5'
    };
};

var getAvailable = exports.getAvailable = function getAvailable() {
    var seasonsAvailable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var type = arguments[1];
    var useSingleYearFormat = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return seasonsAvailable[type] ? seasonsAvailable[type].map(function (_ref2) {
        var seasonStartDate = _ref2.seasonStartDate,
            seasonEndDate = _ref2.seasonEndDate;

        var startYear = (0, _date.formatDate)(seasonStartDate, 'Y');
        return {
            value: useSingleYearFormat ? startYear : (0, _date.getYearFromUtc)(seasonStartDate) + '/' + (0, _date.getYearFromUtc)(seasonEndDate),
            label: type === 'FLAT' ? startYear : startYear + '-' + (0, _date.formatDate)(seasonEndDate, 'YY')
        };
    }) : [];
};

// removing helper suffixes from option value
var removeExtra = exports.removeExtra = function removeExtra(val) {
    return val.replace('/last5', '').replace('/current', '').replace('/all', '');
};

// remove end year from option value
// '2015-2016' => '2015'
var removeEndYear = exports.removeEndYear = function removeEndYear(option) {
    return _extends({}, option, {
        value: option.value.split('/')[0]
    });
};

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpNavigation = __webpack_require__(389);

var _index = __webpack_require__(401);

var _index2 = _interopRequireDefault(_index);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var showBarrier = function showBarrier(event, url) {
    var tabNameText = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var shouldUseCustomMetering = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var userRole = arguments[4];
    var pageName = arguments[5];

    event.preventDefault();
    var isFreeTrial = sessionStorage.getItem('isFreeTrial') === 'true';

    if (pageName === 'horse_profile' && tabNameText !== 'Entries') {
        // If the page is horse_profile but not Entries tab, there shouldn't be a free trial - JP-9931
        // this includes the stallion book
        isFreeTrial = false;
        sessionStorage.setItem('isFreeTrial', 'false');
    } else {
        // If the page is not on horse_profile (trainer_profile) or is Entries tab on horse_profile, show free trial as it is in the header - JP-9931
        isFreeTrial = sessionStorage.getItem('freeTrialHeader');
        sessionStorage.setItem('isFreeTrial', sessionStorage.getItem('freeTrialHeader'));
    }

    var urlToRedirect = window.location.origin + '/profile/' + url.split('#')[0];
    var lightBoxText = isFreeTrial ? 'Sign up for free to access this feature' : 'Subscribe to Racing Post+ and get access to this content and much more';
    localStorage.setItem('subsection', tabNameText);

    if (shouldUseCustomMetering) {
        var hasAccess = (0, _rpNavigation.checkForAccess)('Subscriptions', true, true, {
            text: lightBoxText,
            r: urlToRedirect,
            service: 'both'
        }, true, userRole, pageName, tabNameText.toLowerCase().replace(/\s/g, '_') // this is section argument
        );
        if (hasAccess) {
            _index2.default.push(url);
        }
    } else {
        (0, _rpNavigation.checkForAccess)('Subscriptions', true, true, {
            text: lightBoxText,
            r: urlToRedirect,
            service: 'both'
        }).then(function (hasAccess) {
            if (hasAccess) {
                _index2.default.push(url);
            }
        });
    }
};

exports.default = showBarrier;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.setCategories = exports.getCategories = undefined;

var _selection = __webpack_require__(160);

var _updateCategories = __webpack_require__(1244);

var _updateCategories2 = _interopRequireDefault(_updateCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getCategories = exports.getCategories = function getCategories(tab, type, reducer, categories) {
    var key = 'filter_' + tab + '_' + type;
    var storedActions = JSON.parse(localStorage.getItem(key));

    if (!Array.isArray(storedActions)) {
        return null;
    }

    return storedActions.reduce(function (acc, action) {
        return (0, _updateCategories2.default)(acc, reducer, action);
    }, categories);
};

var setCategories = exports.setCategories = function setCategories(tab, type, categories) {
    var key = 'filter_' + tab + '_' + type;
    var actions = Object.keys(categories).map(function (categoryName) {
        return {
            type: categoryName,
            value: (0, _selection.getOption)(categories, categoryName).value
        };
    });
    localStorage.setItem(key, JSON.stringify(actions));
};

/***/ }),
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(236);
var createDesc = __webpack_require__(237);
var toIObject = __webpack_require__(146);
var toPrimitive = __webpack_require__(427);
var has = __webpack_require__(163);
var IE8_DOM_DEFINE = __webpack_require__(638);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(145) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(67);
var core = __webpack_require__(38);
var LIBRARY = __webpack_require__(235);
var wksExt = __webpack_require__(429);
var defineProperty = __webpack_require__(130).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(68);


/***/ }),
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(246)

/**
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added
 * @returns {Date} the new date with the weeks added
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * var result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var days = amount * 7
  return addDays(dirtyDate, days)
}

module.exports = addWeeks


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Compare the two dates reverse chronologically and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return -1 if the first date is after the second,
 * 1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989 reverse chronologically:
 * var result = compareDesc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> 1
 *
 * @example
 * // Sort the array of dates in reverse chronological order:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareDesc)
 * //=> [
 * //   Sun Jul 02 1995 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Wed Feb 11 1987 00:00:00
 * // ]
 */
function compareDesc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft > timeRight) {
    return -1
  } else if (timeLeft < timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareDesc


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var differenceInCalendarMonths = __webpack_require__(707)
var compareAsc = __webpack_require__(248)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(325)

/**
 * @category Second Helpers
 * @summary Get the number of seconds between the given dates.
 *
 * @description
 * Get the number of seconds between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of seconds
 *
 * @example
 * // How many seconds are between
 * // 2 July 2014 12:30:07.999 and 2 July 2014 12:30:20.000?
 * var result = differenceInSeconds(
 *   new Date(2014, 6, 2, 12, 30, 20, 0),
 *   new Date(2014, 6, 2, 12, 30, 7, 999)
 * )
 * //=> 12
 */
function differenceInSeconds (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / 1000
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInSeconds


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a day
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * var result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfDay


/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var startOfISOWeek = __webpack_require__(178)
var startOfISOYear = __webpack_require__(249)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 464 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(326)

/**
 * @category Week Helpers
 * @summary Are the given dates in the same week?
 *
 * @description
 * Are the given dates in the same week?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the dates are in the same week
 *
 * @example
 * // Are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4)
 * )
 * //=> true
 *
 * @example
 * // If week starts with Monday,
 * // are 31 August 2014 and 4 September 2014 in the same week?
 * var result = isSameWeek(
 *   new Date(2014, 7, 31),
 *   new Date(2014, 8, 4),
 *   {weekStartsOn: 1}
 * )
 * //=> false
 */
function isSameWeek (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var dateLeftStartOfWeek = startOfWeek(dirtyDateLeft, dirtyOptions)
  var dateRightStartOfWeek = startOfWeek(dirtyDateRight, dirtyOptions)

  return dateLeftStartOfWeek.getTime() === dateRightStartOfWeek.getTime()
}

module.exports = isSameWeek


/***/ }),
/* 466 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(1606)
var buildFormatLocale = __webpack_require__(1607)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Default CellMeasurer `cellSizeCache` implementation.
 * Permanently caches all cell sizes (identified by column and row index) unless explicitly cleared.
 * Can be configured to handle uniform cell widths and/or heights as a way of optimizing certain use cases.
 */
var DefaultCellSizeCache = function () {
  function DefaultCellSizeCache() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _ref$uniformRowHeight = _ref.uniformRowHeight;
    var uniformRowHeight = _ref$uniformRowHeight === undefined ? false : _ref$uniformRowHeight;
    var _ref$uniformColumnWid = _ref.uniformColumnWidth;
    var uniformColumnWidth = _ref$uniformColumnWid === undefined ? false : _ref$uniformColumnWid;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, DefaultCellSizeCache);

    this._uniformRowHeight = uniformRowHeight;
    this._uniformColumnWidth = uniformColumnWidth;

    this._cachedColumnWidth = undefined;
    this._cachedRowHeight = undefined;

    this._cachedColumnWidths = {};
    this._cachedRowHeights = {};
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(DefaultCellSizeCache, [{
    key: "clearAllColumnWidths",
    value: function clearAllColumnWidths() {
      this._cachedColumnWidth = undefined;
      this._cachedColumnWidths = {};
    }
  }, {
    key: "clearAllRowHeights",
    value: function clearAllRowHeights() {
      this._cachedRowHeight = undefined;
      this._cachedRowHeights = {};
    }
  }, {
    key: "clearColumnWidth",
    value: function clearColumnWidth(index) {
      this._cachedColumnWidth = undefined;

      delete this._cachedColumnWidths[index];
    }
  }, {
    key: "clearRowHeight",
    value: function clearRowHeight(index) {
      this._cachedRowHeight = undefined;

      delete this._cachedRowHeights[index];
    }
  }, {
    key: "getColumnWidth",
    value: function getColumnWidth(index) {
      return this._uniformColumnWidth ? this._cachedColumnWidth : this._cachedColumnWidths[index];
    }
  }, {
    key: "getRowHeight",
    value: function getRowHeight(index) {
      return this._uniformRowHeight ? this._cachedRowHeight : this._cachedRowHeights[index];
    }
  }, {
    key: "setColumnWidth",
    value: function setColumnWidth(index, width) {
      this._cachedColumnWidth = width;
      this._cachedColumnWidths[index] = width;
    }
  }, {
    key: "setRowHeight",
    value: function setRowHeight(index, height) {
      this._cachedRowHeight = height;
      this._cachedRowHeights[index] = height;
    }
  }]);

  return DefaultCellSizeCache;
}();

/* harmony default export */ __webpack_exports__["a"] = (DefaultCellSizeCache);

/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var SortDirection = {
  /**
   * Sort items in ascending order.
   * This means arranging from the lowest value to the highest (e.g. a-z, 0-9).
   */
  ASC: 'ASC',

  /**
   * Sort items in descending order.
   * This means arranging from the highest value to the lowest (e.g. z-a, 9-0).
   */
  DESC: 'DESC'
};

/* harmony default export */ __webpack_exports__["a"] = (SortDirection);

/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createCallbackMemoizer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);

/**
 * Helper utility that updates the specified callback whenever any of the specified indices have changed.
 */
function createCallbackMemoizer() {
  var requireAllKeys = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

  var cachedIndices = {};

  return function (_ref) {
    var callback = _ref.callback;
    var indices = _ref.indices;

    var keys = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices);
    var allInitialized = !requireAllKeys || keys.every(function (key) {
      var value = indices[key];
      return Array.isArray(value) ? value.length > 0 : value >= 0;
    });
    var indexChanged = keys.length !== __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(cachedIndices).length || keys.some(function (key) {
      var cachedValue = cachedIndices[key];
      var value = indices[key];

      return Array.isArray(value) ? cachedValue.join(',') !== value.join(',') : cachedValue !== value;
    });

    cachedIndices = indices;

    if (allInitialized && indexChanged) {
      callback(indices);
    }
  };
}

/***/ }),
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _menuStateManager = __webpack_require__(2542);

var _menuStateManager2 = _interopRequireDefault(_menuStateManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Common Menu Item
 * @param {jQuery} $object
 * @param {string} activeClass
 * @property {string} title
 * @property {boolean} isActive
 * @property {boolean} toBeRemoved
 * @constructor
 */
/**
 * @module navigation/commonMenuItem
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function CommonMenuItem($object, activeClass) {
    this.$obj = $object;
    this.activeClass = activeClass;

    this.title = this.getTitle();
    this.isActive = this.$obj.children().hasClass(this.activeClass);
    this.toBeRemoved = false;

    this.stateManager = new _menuStateManager2.default(this);
}

/**
 * Get item title
 * @returns {String}
 */


/**
 * @type {MenuStateManager}
 */
CommonMenuItem.prototype.getTitle = function () {
    return this.$obj.text().trim();
};

/**
 * Get item href
 * @returns {String}
 */
CommonMenuItem.prototype.getHref = function () {
    return this.$obj.children().attr('href');
};

/**
 * Get js classes
 * @returns {Array}
 */
CommonMenuItem.prototype.getJsClasses = function () {
    var aClassList = this.$obj.children().attr('class').split(/\s+/);

    var jsClasses = [];
    aClassList.map(function (item) {
        if (/^js-.*/.test(item)) {
            jsClasses.push(item);
        }
    });

    return jsClasses;
};

/**
 * Get menu item state
 * @public
 * @returns {Object}
 */
CommonMenuItem.prototype.getItemState = function () {
    return this.stateManager.getItemState();
};

/**
 * Set menu item state
 * @public
 * @param {Object} options
 * @returns {CommonMenuItem}
 */
CommonMenuItem.prototype.setItemState = function (options) {
    this.stateManager.setItemState(options);
    return this;
};

/**
 * Clear menu item state
 * @public
 * @returns {CommonMenuItem}
 */
CommonMenuItem.prototype.clearItemState = function () {
    this.stateManager.clearItemState();
    return this;
};

/**
 * Apply changes to DOM
 * @public
 * @protected
 */
CommonMenuItem.prototype.render = function () {
    if (!this.activeClass) {
        throw new Error('Class for active item is undefined!');
    }

    var $innerObj = this.$obj.children();
    if (this.isActive) {
        $innerObj.addClass(this.activeClass);
    } else {
        $innerObj.removeClass(this.activeClass);
    }

    return this;
};

/**
 * @protected
 * @param {string} selector
 * @returns {*}
 */
CommonMenuItem.prototype.hasSelector = function (selector) {
    return this.$obj.children().is(selector);
};

exports.default = CommonMenuItem;

/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Active menu item for N and XN breakpoints
 * @param {String} selector
 * @constructor
 */
function CommonMenuItemActiveNarrow(selector) {
  this.$obj = (0, _jquery2.default)(selector);
}

/**
 * Set item's href
 * @param {String} href
 */
/**
 * @module navigation/commonMenuItemActiveNarrow
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

CommonMenuItemActiveNarrow.prototype.setHref = function (href) {
  this.$obj.attr('href', href);
};

/**
 * @returns {String}
 */
CommonMenuItemActiveNarrow.prototype.getHref = function () {
  return this.$obj.attr('href');
};

/**
 * Set item's title
 * @param {String} title
 */
CommonMenuItemActiveNarrow.prototype.setTitle = function (title) {
  this.$obj.text(title);
};

/**
 * @returns {String}
 */
CommonMenuItemActiveNarrow.prototype.getTitle = function () {
  return this.$obj.text();
};

/**
 * Add classes
 * @param {Array} classes
 */
CommonMenuItemActiveNarrow.prototype.addClasses = function (classes) {
  var jsClasses = classes.join(' ');
  if (!this.$obj.hasClass(jsClasses)) {
    this.$obj.addClass(jsClasses);
  }
};

exports.default = CommonMenuItemActiveNarrow;

/***/ }),
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var skybetDiffusionName = exports.skybetDiffusionName = window.skybetDiffusionName ? window.skybetDiffusionName.toUpperCase() : "SKYBET_FLUTTER";

/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Row = __webpack_require__(587);

var _Row2 = _interopRequireDefault(_Row);

var _Loading = __webpack_require__(1000);

var _Loading2 = _interopRequireDefault(_Loading);

var _NoData = __webpack_require__(1001);

var _NoData2 = _interopRequireDefault(_NoData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Body = function Body(_ref) {
  var loading = _ref.loading,
      noDataText = _ref.noDataText,
      data = _ref.data,
      columns = _ref.columns,
      setRowClass = _ref.setRowClass,
      specialRow = _ref.specialRow;
  return _react2.default.createElement(
    'tbody',
    { className: 'ui-table__body' },
    loading || !data.length ? _react2.default.createElement(
      'tr',
      { className: 'ui-table__row' },
      _react2.default.createElement(
        'td',
        {
          className: 'ui-table__cell',
          colSpan: columns.length
        },
        loading ? _react2.default.createElement(_Loading2.default, null) : _react2.default.createElement(_NoData2.default, { text: noDataText })
      )
    ) : data.map(function (rowData, index) {
      return _react2.default.createElement(_Row2.default, {
        rowData: rowData,
        columns: columns,
        key: rowData.__id || index,
        setRowClass: setRowClass,
        specialRow: specialRow
      });
    })
  );
};

Body.propTypes = {
  loading: _propTypes2.default.bool,
  noDataText: _propTypes2.default.string,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({}).isRequired).isRequired,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  setRowClass: _propTypes2.default.func,
  specialRow: _propTypes2.default.func
};

exports.default = Body;

/***/ }),
/* 586 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var createHeaderText = function createHeaderText() {
  var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return name.split(/(?=[A-Z])/).join(' ').toLowerCase();
};

/* eslint jsx-a11y/no-static-element-interactions: 0 */

var Header = function (_PureComponent) {
  _inherits(Header, _PureComponent);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          columns = _props.columns,
          sortIdx = _props.sortIdx,
          sortable = _props.sortable,
          onHeaderCellClick = _props.onHeaderCellClick,
          headerRow = _props.headerRow;


      return _react2.default.createElement(
        'thead',
        { className: 'ui-table__header' },
        headerRow && headerRow(),
        _react2.default.createElement(
          'tr',
          { className: 'ui-table__row' },
          columns.map(function (_ref, i) {
            var header = _ref.header,
                className = _ref.className,
                key = _ref.key;
            return _react2.default.createElement(
              'th',
              {
                className: (0, _classnames2.default)('ui-table__cell', 'ui-table__cell_header', className, sortable && sortIdx === i && 'ui-table__cell_sorted'),
                key: key,
                onClick: sortable && sortIdx !== i && function () {
                  return onHeaderCellClick(i, key);
                } || function () {
                  return null;
                }
              },
              _react2.default.createElement(
                'span',
                { className: 'ui-table__cellContent' },
                (0, _lodash.isFunction)(header) ? header() : header || createHeaderText(key)
              )
            );
          })
        )
      );
    }
  }]);

  return Header;
}(_react.PureComponent);

Header.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
  })).isRequired,
  sortable: _propTypes2.default.bool,
  sortIdx: _propTypes2.default.number,
  onHeaderCellClick: _propTypes2.default.func,
  headerRow: _propTypes2.default.func
};

exports.default = Header;

/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _handleEmpty = __webpack_require__(1004);

var _handleEmpty2 = _interopRequireDefault(_handleEmpty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Row = function (_PureComponent) {
  _inherits(Row, _PureComponent);

  function Row() {
    _classCallCheck(this, Row);

    return _possibleConstructorReturn(this, (Row.__proto__ || Object.getPrototypeOf(Row)).apply(this, arguments));
  }

  _createClass(Row, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          rowData = _props.rowData,
          columns = _props.columns,
          setRowClass = _props.setRowClass,
          specialRow = _props.specialRow;


      return specialRow(rowData) || _react2.default.createElement(
        'tr',
        {
          className: (0, _classnames2.default)('ui-table__row', setRowClass && setRowClass(rowData))
        },
        columns.map(function (_ref) {
          var className = _ref.className,
              key = _ref.key,
              cell = _ref.cell;
          return _react2.default.createElement(
            'td',
            {
              className: (0, _classnames2.default)('ui-table__cell', className),
              key: key
            },
            cell ? cell(rowData) : (0, _handleEmpty2.default)(rowData[key])
          );
        })
      );
    }
  }]);

  return Row;
}(_react.PureComponent);

Row.defaultProps = {
  specialRow: function specialRow() {
    return false;
  }
};

Row.propTypes = {
  rowData: _propTypes2.default.shape({}).isRequired,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string,
    cell: _propTypes2.default.func,
    className: _propTypes2.default.string
  })).isRequired,
  setRowClass: _propTypes2.default.func,
  specialRow: _propTypes2.default.func
};

exports.default = Row;

/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var isBloodstockHorseProfile = exports.isBloodstockHorseProfile = function isBloodstockHorseProfile() {
    /*
        we check here if we are on bloodstock profile page OR on normal horse profile page
        one of the differences are exactly the logo rendered on both pages
        on both page 2 logos are rendered (one is not visible), but only on bloodstock page one of the logos has href which includes 'bloodstock'
    */
    var logosElements = document.querySelectorAll('[data-test-selector="link-navigationRpLogo"]');
    return Array.from(logosElements).filter(function (logo) {
        return logo.tagName === 'A' && logo.href.includes('bloodstock');
    }).length > 0;
};

/***/ }),
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);
var settle = __webpack_require__(1026);
var buildURL = __webpack_require__(1029);
var parseHeaders = __webpack_require__(1035);
var isURLSameOrigin = __webpack_require__(1033);
var createError = __webpack_require__(595);
var btoa = (typeof window !== 'undefined' && window.btoa && window.btoa.bind(window)) || __webpack_require__(1028);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();
    var loadEvent = 'onreadystatechange';
    var xDomain = false;

    // For IE 8/9 CORS support
    // Only supports POST and GET calls and doesn't returns the response headers.
    // DON'T do this for testing b/c XMLHttpRequest is mocked, not XDomainRequest.
    if ("production" !== 'test' &&
        typeof window !== 'undefined' &&
        window.XDomainRequest && !('withCredentials' in request) &&
        !isURLSameOrigin(config.url)) {
      request = new window.XDomainRequest();
      loadEvent = 'onload';
      xDomain = true;
      request.onprogress = function handleProgress() {};
      request.ontimeout = function handleTimeout() {};
    }

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request[loadEvent] = function handleLoad() {
      if (!request || (request.readyState !== 4 && !xDomain)) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        // IE sends 1223 instead of 204 (https://github.com/mzabriskie/axios/issues/201)
        status: request.status === 1223 ? 204 : request.status,
        statusText: request.status === 1223 ? 'No Content' : request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED'));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(1031);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        if (request.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(1025);

/**
 * Create an Error with the specified message, config, error code, and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, response);
};


/***/ }),
/* 596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getValues = exports.getValue = exports.getStatusLabels = exports.getStatusLabel = exports.getLabels = exports.getLabel = exports.getOptions = exports.getOption = exports.setSelected = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _entries = __webpack_require__(895);

var _entries2 = _interopRequireDefault(_entries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setSelected = exports.setSelected = function setSelected(arr, value) {
    return arr.map(function (item) {
        return item.value === value ? _extends({}, item, { selected: true }) : item;
    });
};

var getOption = exports.getOption = function getOption(category) {
    return (category.options || []).find(function (item) {
        return item.selected;
    }) || {};
};

var getOptions = exports.getOptions = function getOptions(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            category = _ref2[1];

        res[key] = getOption(category);
    });
    return res;
};

var getLabel = exports.getLabel = function getLabel(category) {
    return getOption(category).label;
};

var getLabels = exports.getLabels = function getLabels(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            category = _ref4[1];

        res[key] = getLabel(category);
    });
    return res;
};

var getStatusLabel = exports.getStatusLabel = function getStatusLabel(category) {
    var _getOption = getOption(category),
        statusLabel = _getOption.statusLabel,
        label = _getOption.label;

    return statusLabel || label;
};

var getStatusLabels = exports.getStatusLabels = function getStatusLabels(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            category = _ref6[1];

        res[key] = !category.isHidden ? getStatusLabel(category) : null;
    });
    return res;
};

var getValue = exports.getValue = function getValue(category) {
    return getOption(category).value;
};

var getValues = exports.getValues = function getValues(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            category = _ref8[1];

        res[key] = getValue(category);
    });
    return res;
};

exports.default = {
    setSelected: setSelected,
    getOption: getOption,
    getOptions: getOptions,
    getLabel: getLabel,
    getLabels: getLabels,
    getStatusLabel: getStatusLabel,
    getStatusLabels: getStatusLabels,
    getValue: getValue,
    getValues: getValues
};

/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PopoverComponent = __webpack_require__(1049);

var _PopoverComponent2 = _interopRequireDefault(_PopoverComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PopoverComponent2.default;

/***/ }),
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timePeriodFactory = undefined;

var _filter = __webpack_require__(75);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getRTOptions = function getRTOptions(typeCode) {
    var _raceTypes$course = _filter.raceTypes.course,
        jumps = _raceTypes$course.jumps,
        flat = _raceTypes$course.flat;

    switch (typeCode) {
        case 'J':
        case 'P':
            return [jumps];
        case 'B':
            return [flat, jumps];
        default:
            return [flat];
    }
};

var raceTypeFactory = function raceTypeFactory(code, currentRaceType) {
    return {
        options: _filter.selection.setSelected(getRTOptions(code), currentRaceType),
        title: 'race type'
    };
};

var timePeriodFactory = exports.timePeriodFactory = function timePeriodFactory(raceType, countryCode) {
    var currentYear = _filter.timePeriods.getCurrentSeasonEndYear(raceType, countryCode);

    var options = [_filter.timePeriods.getLast5(currentYear, raceType), _filter.timePeriods.getCurrent(currentYear, raceType)].concat(_toConsumableArray(_filter.timePeriods.getPeriods(currentYear - 1, currentYear - 5, raceType)));

    options[0].selected = true;

    return {
        title: 'time period',
        options: options,
        createdBy: { raceType: raceType, countryCode: countryCode }
    };
};

var categories = function categories(currentRaceType, countryCode, typeCode) {
    return {
        raceType: raceTypeFactory(typeCode, currentRaceType),
        timePeriod: timePeriodFactory(currentRaceType, countryCode)
    };
};

exports.default = categories;

/***/ }),
/* 607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timePeriodFactory = undefined;

var _lodash = __webpack_require__(9);

var _filter = __webpack_require__(75);

var raceCategoryOptions = {
    big: {
        label: 'Big races',
        value: 'big-race'
    },
    all: {
        label: 'All races',
        value: 'all-races'
    }
};

var raceCategoryFactory = function raceCategoryFactory(statusType) {
    var all = raceCategoryOptions.all,
        big = raceCategoryOptions.big;

    var options = statusType === 'big-race' ? [big, all] : [all];

    return {
        options: _filter.selection.setSelected(options, statusType),
        title: 'race category'
    };
};

var raceTypeFactory = function raceTypeFactory(typeCode, raceType) {
    return {
        title: 'race type',
        options: _filter.selection.setSelected(_filter.raceTypes.getForCourse(typeCode), raceType)
    };
};

var timePeriodFactory = exports.timePeriodFactory = function timePeriodFactory(raceType, principalSeason, seasonsAvailable) {
    return {
        options: _filter.selection.setSelected(_filter.timePeriods.getAvailable(seasonsAvailable, (0, _lodash.toUpper)(raceType), true), principalSeason.toString()),
        title: 'time period',
        createdBy: {
            seasonsAvailable: seasonsAvailable,
            principalSeason: principalSeason,
            raceType: raceType
        }
    };
};

var categoriesFactory = function categoriesFactory(raceStatusType, courseTypeCode, raceType) {
    var coursePrincipalSeason = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
    var seasonsAvailable = arguments[4];
    return seasonsAvailable ? {
        raceCategory: raceCategoryFactory(raceStatusType),
        raceType: raceTypeFactory(courseTypeCode, raceType),
        timePeriod: timePeriodFactory(raceType, coursePrincipalSeason, seasonsAvailable)
    } : null;
};

exports.default = categoriesFactory;

/***/ }),
/* 608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.categoriesFactory = exports.timePeriodsFactory = undefined;
exports.raceTypesFactory = raceTypesFactory;

var _lodash = __webpack_require__(9);

var _filter = __webpack_require__(75);

var _date = __webpack_require__(18);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getExtraTimeOptions = function getExtraTimeOptions(hasCurrentYear, currentYear, seasons, type) {
    var firstSeasonStart = 1988;
    var lastSeasonEnd = +(0, _date.formatDate)(seasons[0].seasonEndDate, 'YYYY');

    var allOption = _filter.timePeriods.getAll(firstSeasonStart, currentYear);
    var currentYearOption = _filter.timePeriods.getCurrent(currentYear, type);
    currentYearOption.selected = true;
    var last5Option = _filter.timePeriods.getLast5(currentYear, type);

    var hasFewSeasons = seasons.length > 1;
    var hasLast5Seasons = currentYear - lastSeasonEnd < 5;

    return (0, _lodash.compact)([hasFewSeasons && allOption, hasCurrentYear && currentYearOption, hasLast5Seasons && last5Option]);
};

var getAvailableTimeOptions = function getAvailableTimeOptions(seasonsAvailable, raceType) {
    var options = _filter.timePeriods.getAvailable(seasonsAvailable, (0, _lodash.toUpper)(raceType));
    options[0].selected = true;
    return options;
};

var timePeriodsFactory = exports.timePeriodsFactory = function timePeriodsFactory(country, raceType, seasonsAvailable) {
    var seasons = seasonsAvailable[(0, _lodash.toUpper)(raceType)];

    var currentYear = _filter.timePeriods.getCurrentSeasonEndYear(raceType, country);

    var hasCurrentYear = seasons[0].seasonDesc.includes(currentYear);

    var availableSeasonsOptions = getAvailableTimeOptions(seasonsAvailable, raceType);
    var extraOptions = getExtraTimeOptions(hasCurrentYear, currentYear, seasons, raceType);

    var options = [].concat(_toConsumableArray(extraOptions), _toConsumableArray(hasCurrentYear ? availableSeasonsOptions.slice(1) : availableSeasonsOptions));

    var timePeriod = {
        title: 'time period',
        options: options,
        createdBy: {
            raceType: raceType,
            seasonsAvailable: seasonsAvailable,
            country: country
        }
    };

    return timePeriod;
};

function raceTypesFactory(typeCode, raceType, seasonsAvailable) {
    var options = _filter.raceTypes.getForCourse(typeCode, seasonsAvailable, true);

    return {
        title: 'race type',
        options: _filter.selection.setSelected(options, raceType)
    };
}

var categoriesFactory = exports.categoriesFactory = function categoriesFactory(typeCode, country, raceType, seasonsAvailable) {
    return seasonsAvailable ? {
        raceType: raceTypesFactory(typeCode, raceType, seasonsAvailable),
        timePeriod: timePeriodsFactory(country, raceType, seasonsAvailable)
    } : null;
};

/***/ }),
/* 609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Definition = __webpack_require__(143);

var _Definition2 = _interopRequireDefault(_Definition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @param studFee array|null
 * @param weatherbysUid string|null
 * @returns {*}
 * @constructor
 */
var Standing = function Standing(_ref) {
    var studFee = _ref.studFee,
        weatherbysUid = _ref.weatherbysUid;

    if (studFee && studFee.length) {
        var _studFee$ = studFee[0],
            studName = _studFee$.studName,
            countryCode = _studFee$.countryCode,
            nominationFee = _studFee$.nominationFee;


        if (weatherbysUid) {
            return _jsx(_Definition2.default, {
                term: '',
                forceShow: true,
                perfectCenter: true
            }, void 0, _jsx('span', {
                className: 'weatherbys-standing__wrapper'
            }, void 0, 'Standing at ', studName, ' (', countryCode, ') ', nominationFee !== 0 ? 'for' : ''));
        }

        return _jsx(_Definition2.default, {
            term: 'Standing'
        }, void 0, _jsx('span', {}, void 0, studName, ' (', countryCode, ')'));
    }
    return null;
};

exports.default = Standing;

/***/ }),
/* 610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _axios = __webpack_require__(127);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(279);

var _qs2 = _interopRequireDefault(_qs);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _FormTable = __webpack_require__(1129);

var _FormTable2 = _interopRequireDefault(_FormTable);

var _RaceRecords = __webpack_require__(1140);

var _RaceRecords2 = _interopRequireDefault(_RaceRecords);

var _transformData = __webpack_require__(1143);

var _transformData2 = _interopRequireDefault(_transformData);

var _dataPropTypes = __webpack_require__(400);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref3 = _jsx('span', {}, void 0, 'Details of horses trained outside GB and Ireland or born prior to 1986 may be incomplete.');

var _ref4 = _jsx('span', {}, void 0, '\xA0OR Rating is the latest published.', _jsx('br', {}));

var _ref5 = _jsx('span', {}, void 0, 'GB PTP results are displayed when a horse is declared to run under rules.');

var Form = function (_Component) {
    _inherits(Form, _Component);

    function Form(props) {
        _classCallCheck(this, Form);

        var _this = _possibleConstructorReturn(this, (Form.__proto__ || Object.getPrototypeOf(Form)).call(this, props));

        _this.fetchMyRating = _this.fetchMyRating.bind(_this);
        _this.onFilterClick = _this.onFilterClick.bind(_this);

        _this.state = _extends({
            loading: false,
            myRatingFetched: false,
            myRatingData: null,
            selectedFilter: null
        }, (0, _transformData2.default)(props.data));
        return _this;
    }

    _createClass(Form, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var mr = this.props.params.mr;

            if (mr.isShown) {
                this.fetchMyRating();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            var mr = this.props.params.mr;

            if (mr.isShown && !this.state.loading && !this.state.myRatingFetched) {
                this.fetchMyRating();
            }
        }
    }, {
        key: 'onFilterClick',
        value: function onFilterClick(_ref) {
            var nextFilter = _ref.currentTarget.value;

            if (!this.props.hasAccess) {
                return;
            }
            this.setState(function (prevState) {
                return {
                    selectedFilter: prevState.selectedFilter === nextFilter ? null : nextFilter
                };
            });
        }
    }, {
        key: 'fetchMyRating',
        value: function fetchMyRating() {
            var _this2 = this;

            this.setState({ loading: true });
            var formData = this.state.form;
            var horseUid = this.props.params.id;

            var racesIds = formData.map(function (entry) {
                return entry.raceInstanceUid;
            });

            _axios2.default.post('horse/form/ugc/' + horseUid, _qs2.default.stringify({ params: racesIds })).then(function (_ref2) {
                var ratings = _ref2.data.ratings;
                return _this2.setState({
                    loading: false,
                    myRatingFetched: true,
                    myRatingData: ratings || []
                });
            }).catch(function () {
                return _this2.setState({ loading: false, myRatingFetched: true });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                selectedFilter = _state.selectedFilter,
                records = _state.records,
                figures = _state.figures,
                form = _state.form,
                hasSpecial = _state.hasSpecial,
                myRatingData = _state.myRatingData,
                loading = _state.loading;
            var _props = this.props,
                params = _props.params,
                hasAccess = _props.hasAccess;


            var data = {
                loading: loading,
                form: form,
                myRatings: myRatingData,
                raceRecords: records
            };

            return _jsx('section', {}, void 0, _jsx(_RaceRecords2.default, {
                data: data,
                figures: figures,
                onFilterClick: this.onFilterClick,
                selectedFilter: selectedFilter,
                params: params,
                hasAccess: hasAccess
            }), _jsx(_FormTable2.default, {
                data: data,
                hasSpecial: hasSpecial,
                selectedFilter: selectedFilter,
                params: params,
                hasAccess: hasAccess
            }), _jsx('div', {
                className: (0, _classnames2.default)('pp-bottomText', !hasAccess && 'pp-bottomText--without-access')
            }, void 0, _ref3, _ref4, _ref5));
        }
    }]);

    return Form;
}(_react.Component);

Form.displayName = 'Form';

exports.default = Form;

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var filterArrays = {
    'Flat Turf': ['F'],
    'All-weather': ['X'],
    NHF: ['B', 'W'],
    Hurdle: ['H', 'Y'],
    Chase: ['C', 'U', 'Z'],
    PTP: ['P']
};

var findTypeByCode = function findTypeByCode(code) {
    return Object.keys(filterArrays).filter(function (type) {
        return filterArrays[type].includes(code);
    })[0];
};

exports.default = filterArrays;
exports.findTypeByCode = findTypeByCode;

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NameContainer = function NameContainer(_ref) {
    var horseName = _ref.horseName,
        countryCode = _ref.countryCode,
        number = _ref.number;
    return _jsx('div', {
        className: 'hp-nameRow__leftContainer'
    }, void 0, _jsx('h1', {
        className: 'hp-nameRow__name'
    }, void 0, number && _jsx('span', {
        className: 'hp-nameRow__number'
    }, void 0, number, '.'), horseName), _jsx('span', {
        className: 'hp-nameRow__code'
    }, void 0, '(', countryCode, ')'));
};

exports.default = NameContainer;

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _RelativesTable = __webpack_require__(1161);

var _RelativesTable2 = _interopRequireDefault(_RelativesTable);

var _RelativesTableDisclaimer = __webpack_require__(1162);

var _RelativesTableDisclaimer2 = _interopRequireDefault(_RelativesTableDisclaimer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FlatJumpsTables = function FlatJumpsTables(_ref) {
    var _ref$data = _ref.data,
        FLAT = _ref$data.FLAT,
        JUMPS = _ref$data.JUMPS,
        disclaimerName = _ref.disclaimerName,
        flatTitle = _ref.flatTitle,
        jumpsTitle = _ref.jumpsTitle,
        flatNoData = _ref.flatNoData,
        jumpsNoData = _ref.jumpsNoData;

    var flatJumps = [{ type: 'Flat', data: FLAT, noDataText: flatNoData, title: flatTitle }, { type: 'jumps', data: JUMPS, noDataText: jumpsNoData, title: jumpsTitle }];
    var maxFlat = (0, _lodash.maxBy)(FLAT, 'bestRpPostmark');
    var maxJumps = (0, _lodash.maxBy)(JUMPS, 'bestRpPostmark');

    if (maxJumps && (!maxFlat || maxFlat.bestRpPostmark < maxJumps.bestRpPostmark)) {
        flatJumps.reverse();
    }

    return _jsx('div', {}, void 0, flatJumps.map(function (_ref2) {
        var type = _ref2.type,
            data = _ref2.data,
            noDataText = _ref2.noDataText,
            title = _ref2.title;
        return _jsx(_RelativesTable2.default, {
            data: data,
            noDataText: noDataText,
            title: title
        }, type);
    }), _jsx(_RelativesTableDisclaimer2.default, {
        type: disclaimerName
    }));
};

exports.default = FlatJumpsTables;

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DamProgeny = __webpack_require__(1166);

var _DamProgeny2 = _interopRequireDefault(_DamProgeny);

var _ProgenyCommon = __webpack_require__(1164);

var _ProgenyCommon2 = _interopRequireDefault(_ProgenyCommon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Progeny = function Progeny(_ref) {
    var _ref$data = _ref.data,
        progenyResults = _ref$data.progenyResults,
        availableSeasonsData = _ref$data.availableSeasonsData,
        progenyHorsesData = _ref$data.progenyHorsesData,
        _ref$data$profile = _ref$data.profile,
        damStatus = _ref$data$profile.damStatus,
        weatherbysUid = _ref$data$profile.weatherbysUid,
        _ref$params = _ref.params,
        id = _ref$params.id,
        tab = _ref$params.tab;
    return (!tab || tab === 'progeny') && damStatus ? _jsx(_DamProgeny2.default, {
        data: progenyResults
    }) : _jsx(_ProgenyCommon2.default, {
        id: id,
        weatherbysUid: weatherbysUid,
        availableSeasonsData: availableSeasonsData,
        data: progenyHorsesData.data,
        tab: tab
    });
};

exports.default = Progeny;

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint-disable no-console */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _ProfileLink = __webpack_require__(26);

var _date = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseCell = function HorseCell(_ref) {
    var horseName = _ref.horseName,
        horseUid = _ref.horseUid,
        horseSexCode = _ref.horseSexCode,
        countryOriginCode = _ref.countryOriginCode,
        damSireStyleName = _ref.damSireStyleName,
        damSireUid = _ref.damSireUid,
        damSireCountryOriginCode = _ref.damSireCountryOriginCode,
        sireUid = _ref.sireUid,
        horseDateOfBirth = _ref.horseDateOfBirth,
        sireStyleName = _ref.sireStyleName,
        sireCountryOriginCode = _ref.sireCountryOriginCode,
        isDamSire = _ref.isDamSire;

    var horseYob = horseDateOfBirth ? (0, _date.formatDate)(horseDateOfBirth, 'YYYY') : null;

    return _jsx('div', {}, void 0, _jsx(_ProfileLink.HorseLink, {
        className: horseSexCode === 'M' || horseSexCode === 'F' ? 'hp-sire-progeny__female' : '',
        horseStyleName: horseName,
        horseUid: horseUid
    }), isDamSire ? _jsx('span', {
        className: 'hp-sire-progeny__horseInfo'
    }, void 0, countryOriginCode && ' (' + countryOriginCode + ') ', horseYob, (0, _lodash.toLower)(horseSexCode)) : _jsx('span', {
        className: 'hp-sire-progeny__country'
    }, void 0, ' (', countryOriginCode, ')'), _jsx('div', {
        className: 'hidden-md-up'
    }, void 0, _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked',
        horseStyleName: isDamSire ? damSireStyleName : sireStyleName,
        horseUid: isDamSire ? damSireUid : sireUid
    }), _jsx('span', {}, void 0, ' (', isDamSire ? damSireCountryOriginCode : sireCountryOriginCode, ')')));
};

exports.default = HorseCell;

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timePeriodsFactory = undefined;

var _lodash = __webpack_require__(9);

var _selection = __webpack_require__(160);

var _index = __webpack_require__(75);

var _date = __webpack_require__(18);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getRaceTypesOptions = function getRaceTypesOptions(seasonsAvailable) {
    return (0, _lodash.keys)(seasonsAvailable).reduce(function (result, key) {
        return seasonsAvailable[key] ? [].concat(_toConsumableArray(result), [{ label: (0, _lodash.capitalize)(key), value: (0, _lodash.toLower)(key) }]) : result;
    }, []);
};

var getOnwardsOption = function getOnwardsOption(raceType, seasonsForType) {
    var _seasonsForType = seasonsForType[seasonsForType.length - 1],
        seasonStartDate = _seasonsForType.seasonStartDate,
        seasonEndDate = _seasonsForType.seasonEndDate;

    var lastSeasonEndDate = seasonsForType[0].seasonEndDate;
    var jumpsSuffix = raceType === 'jumps' ? '-' + (0, _date.formatDate)(seasonEndDate, 'YY') : '';

    return {
        value: (0, _date.getYearFromUtc)(seasonStartDate) + '/' + (0, _date.getYearFromUtc)(lastSeasonEndDate),
        label: '' + (0, _date.formatDate)(seasonStartDate, 'Y') + jumpsSuffix + ' onwards'
    };
};

var timePeriodsFactory = exports.timePeriodsFactory = function timePeriodsFactory(raceType, seasonsAvailable) {
    var options = _index.timePeriods.getAvailable(seasonsAvailable, (0, _lodash.upperCase)(raceType));
    var seasonsForType = seasonsAvailable[(0, _lodash.upperCase)(raceType)];
    if (seasonsForType.length > 1) {
        options.unshift(getOnwardsOption(raceType, seasonsForType));
    }
    options[0].selected = true;

    return {
        title: 'time period',
        options: options,
        createdBy: {
            raceType: raceType,
            seasonsAvailable: seasonsAvailable
        }
    };
};

var raceTypeFactory = function raceTypeFactory(raceType, seasonsAvailable) {
    return {
        title: 'race type',
        options: (0, _selection.setSelected)(getRaceTypesOptions(seasonsAvailable), raceType)
    };
};

var categoriesFactory = function categoriesFactory(seasonsAvailable, _ref) {
    var raceType = _ref.raceType;
    return {
        raceType: raceTypeFactory(raceType, seasonsAvailable),
        timePeriod: timePeriodsFactory(raceType, seasonsAvailable)
    };
};

exports.default = categoriesFactory;

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.monthFactory = exports.timePeriodsFactory = undefined;

var _moment = __webpack_require__(73);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(9);

var _selection = __webpack_require__(160);

var _filter = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var last3MonthOption = {
    label: 'Last 3 months',
    value: 'lastThree'
};

var getRaceTypesOptions = function getRaceTypesOptions(_ref) {
    var FLAT = _ref.FLAT,
        JUMPS = _ref.JUMPS;

    var result = [];
    var _raceTypes$horse = _filter.raceTypes.horse,
        flat = _raceTypes$horse.flat,
        jumps = _raceTypes$horse.jumps;

    if (FLAT) {
        result.push.apply(result, _toConsumableArray(flat));
    }
    if (JUMPS) {
        result.push.apply(result, _toConsumableArray(jumps));
    }
    return result;
};

var timePeriodsFactory = exports.timePeriodsFactory = function timePeriodsFactory(raceType, seasonsAvailable) {
    var flatOrJumps = raceType.split('/')[1];
    var options = _filter.timePeriods.getAvailable(seasonsAvailable, (0, _lodash.upperCase)(flatOrJumps));
    options[0].selected = true;

    var timePeriod = {
        title: 'time period',
        options: options,
        createdBy: {
            flatOrJumps: flatOrJumps,
            seasonsAvailable: seasonsAvailable
        }
    };
    return timePeriod;
};

var raceTypeFactory = function raceTypeFactory(raceType, seasonsAvailable) {
    return {
        title: 'race type',
        options: (0, _selection.setSelected)(getRaceTypesOptions(seasonsAvailable), raceType)
    };
};

var getMonthOptions = function getMonthOptions() {
    return [{
        label: 'No filter',
        value: ''
    }].concat(_toConsumableArray(_moment2.default.months().map(function (m, i) {
        return {
            label: m,
            value: '' + (i + 1)
        };
    })));
};

var monthFactory = exports.monthFactory = function monthFactory(raceType, timePeriod, seasonsAvailable) {
    var flatOrJumps = raceType.split('/')[1] || raceType;
    var typeSeasons = seasonsAvailable[(0, _lodash.upperCase)(flatOrJumps)] || [];
    var selectedSeasonEndYear = timePeriod.substr(5);
    var selectedSeason = typeSeasons.find(function (_ref2) {
        var seasonEndDate = _ref2.seasonEndDate;
        return seasonEndDate.substr(0, 4) === selectedSeasonEndYear;
    }) || {};
    var isCurrentSeason = (0, _moment2.default)(selectedSeason.seasonEndDate) > (0, _moment2.default)();

    var options = isCurrentSeason ? [last3MonthOption].concat(_toConsumableArray(getMonthOptions())) : getMonthOptions();
    options[0].selected = true;

    return {
        title: 'month',
        options: options,
        createdBy: {
            timePeriod: timePeriod,
            flatOrJumps: flatOrJumps,
            seasonsAvailable: seasonsAvailable
        }
    };
};

var categoriesFactory = function categoriesFactory(seasonsAvailable, _ref3) {
    var raceType = _ref3.raceType,
        timePeriod = _ref3.timePeriod;
    return {
        raceType: raceTypeFactory(raceType, seasonsAvailable),
        timePeriod: timePeriodsFactory(raceType, seasonsAvailable),
        month: monthFactory(raceType, timePeriod, seasonsAvailable)
    };
};

exports.default = categoriesFactory;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _RatioCell = __webpack_require__(624);

var _RatioCell2 = _interopRequireDefault(_RatioCell);

var _money = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_rpReactSvgIcon2.default, {
    className: 'hp-progeny-statistics__arrow tableShowIcon',
    iconName: 'down',
    size: 'Medium'
});

var _ref2 = _jsx(_Abbr2.default, {
    title: 'winners / runners',
    breakpoint: 'fromMedium'
}, void 0, 'wnrs\xA0/ rnrs');

var _ref4 = _jsx(_Abbr2.default, {
    title: 'wins',
    breakpoint: 'fromMedium'
}, void 0, 'wins\xA0/ runs');

var _ref6 = _jsx('wbr', {});

var columns = [{
    key: 'arrow',
    header: ' ',
    cell: function cell() {
        return _ref;
    }

}, {
    key: 'category',
    header: 'race type'
}, {
    key: 'winners',
    header: function header() {
        return _ref2;
    },
    cell: function cell(_ref3) {
        var a = _ref3.winners,
            b = _ref3.runners;
        return _jsx(_RatioCell2.default, {
            a: a,
            b: b
        });
    }
}, {
    key: 'percentWinnersRunners',
    header: '%'
}, {
    key: 'wins',
    header: function header() {
        return _ref4;
    },
    cell: function cell(_ref5) {
        var wins = _ref5.wins,
            runs = _ref5.runs;
        return _jsx('span', {}, void 0, _jsx('strong', {}, void 0, wins), _jsx('span', {
            className: 'hidden-md-up'
        }, void 0, '/', _ref6, runs));
    }
}, {
    key: 'runs'
}, {
    key: 'percentWinsRuns',
    header: '%'
}, {
    key: 'place2ndNumber',
    header: '2nd'
}, {
    key: 'place3rdNumber',
    header: '3rd'
}, {
    key: 'totalPrizeMoney',
    header: 'total earnings',
    cell: function cell(_ref7) {
        var totalPrizeMoney = _ref7.totalPrizeMoney;
        return (0, _money.formatMoney)(totalPrizeMoney);
    }
}];

exports.default = columns;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Slider = __webpack_require__(1239);

var _Slider2 = _interopRequireDefault(_Slider);

var _HorseParentsTree = __webpack_require__(1202);

var _HorseParentsTree2 = _interopRequireDefault(_HorseParentsTree);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('section', {
    className: 'hp-weatherbysOverview__container'
}, void 0, _jsx('p', {
    className: 'hp-weatherbysOverview--text-center'
}, void 0, 'No data available'));

var renderWeatherOverview = function renderWeatherOverview(weatherbys, isMobile) {
    if (!weatherbys) {
        return _ref;
    }

    var item = weatherbys.stallionregister.stallion.media.item;


    var slides = item.filter(function (img) {
        return img.mediatype.toLowerCase() === 'carousel image';
    });
    var narrative = item.find(function (img) {
        return img.mediatype.toLowerCase() === 'narrative';
    });
    var contact = item.find(function (img) {
        return img.mediatype.toLowerCase() === 'contact';
    });
    var ad = item.find(function (img) {
        return img.mediatype.toLowerCase() === 'mobile';
    });

    return _jsx('section', {
        className: 'hp-weatherbysOverview__container'
    }, void 0, _jsx('div', {
        className: 'hp-weatherbysOverview__horse-info-wrapper'
    }, void 0, _jsx(_Slider2.default, {
        slides: slides,
        hideArrows: isMobile
    }), !isMobile && narrative && _jsx('div', {
        className: 'hp-weatherbysOverview__horse-info'
    }, void 0, _jsx('img', {
        src: narrative.url,
        alt: 'narrative'
    }))), _jsx('div', {
        className: 'hp-weatherbysOverview__bannerContainer'
    }, void 0, !isMobile && contact && _jsx('img', {
        src: contact.url,
        alt: 'contaqct'
    }), isMobile && ad && _jsx('img', {
        src: ad.url,
        alt: 'ad'
    })));
};

var _ref2 = _jsx('div', {
    className: 'family-tree'
}, void 0, 'No data available');

var renderFamilyTree = function renderFamilyTree(bloodstock) {
    if (!bloodstock) {
        return _ref2;
    }

    return _jsx('div', {
        className: 'family-tree'
    }, void 0, _jsx('div', {
        className: 'family-tree__horse family-tree__horse--current'
    }, void 0, _jsx('div', {
        className: 'family-tree__horse-info family-tree__horse-info--current'
    }, void 0, _jsx('h1', {}, void 0, bloodstock.horseName)), (0, _HorseParentsTree2.default)(bloodstock.parents)));
};

var _ref3 = _jsx('div', {
    className: 'family-tree'
}, void 0, 'No data available');

var WeatherbysOverview = function WeatherbysOverview(props) {
    var data = props.data,
        isMobile = props.isMobile;

    var overviewData = data.data;

    var weatherbys = overviewData.weatherbys,
        bloodstock = overviewData.bloodstock;


    if (!weatherbys && !bloodstock) {
        return _ref3;
    }

    return _jsx('div', {}, void 0, renderWeatherOverview(weatherbys, isMobile), renderFamilyTree(bloodstock));
};

exports.default = WeatherbysOverview;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.timePeriodsFactory = undefined;

var _filter = __webpack_require__(75);

var raceTypeFactory = function raceTypeFactory(country, type) {
    return {
        title: 'race type',
        options: _filter.selection.setSelected(_filter.raceTypes.human, country + '/' + type)
    };
};

var timePeriodsFactory = exports.timePeriodsFactory = function timePeriodsFactory(country, raceType) {
    var currentYear = _filter.timePeriods.getCurrentSeasonEndYear(raceType, country);
    var options = _filter.timePeriods.getPeriods(currentYear, 1987, raceType).map(_filter.timePeriods.removeEndYear);

    return {
        title: 'time period',
        options: _filter.selection.setSelected(options, options[0].value),
        createdBy: { raceType: raceType }
    };
};

var categoriesFactory = function categoriesFactory(country, type) {
    return country && type ? {
        raceType: raceTypeFactory(country, type),
        timePeriod: timePeriodsFactory(country, type)
    } : null;
};

exports.default = categoriesFactory;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.statusFactory = exports.categoriesFactory = exports.raceTypeFactory = undefined;
exports.displayByFactory = displayByFactory;
exports.timePeriodFactory = timePeriodFactory;
exports.advancedFactory = advancedFactory;

var _lodash = __webpack_require__(9);

var _filter = __webpack_require__(75);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var trainerOption = {
    label: 'Trainer',
    value: 'trainer'
};

var jockeyOption = {
    label: 'Jockey',
    value: 'jockey'
};

var getGenericDisplayBy = function getGenericDisplayBy(humanType) {
    return (0, _lodash.compact)([{
        label: 'Course',
        value: 'course'
    }, {
        label: 'Distance',
        value: 'distance'
    }, humanType === 'jockey' ? trainerOption : jockeyOption, {
        label: 'Month',
        value: 'month'
    }, {
        label: 'Race Class (Handicap, Selling..)',
        value: 'race-type'
    }, humanType === 'owner' && trainerOption]);
};

function displayByFactory(country, type, humanType) {
    var selectedValue = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

    var options = [];
    var genericDisplayByOptions = getGenericDisplayBy(humanType);

    if (type === 'flat') {
        var year = {
            label: 'Year',
            value: 'year'
        };
        var age = {
            label: 'Age of horse',
            value: 'age-of-horse'
        };
        options = [age].concat(_toConsumableArray(genericDisplayByOptions), [year]);
    } else {
        var raceTypeOption = {
            label: 'Race Type (NHF, Hurdle, Chase)',
            value: 'race-category'
        };
        var season = {
            label: 'Season (' + (country === 'GB' ? 'April' : 'May') + ' - April)',
            value: 'season'
        };

        options = [].concat(_toConsumableArray(genericDisplayByOptions), [raceTypeOption, season]);
    }

    options.find(function (_ref) {
        var value = _ref.value;
        return value === selectedValue || value === 'year' || value === 'season';
    }).selected = true;

    return {
        options: options,
        title: 'display by',
        createdBy: {
            raceType: type,
            humanType: humanType
        }
    };
}

function timePeriodFactory(country, type, seasonsAvailable) {
    var currentYear = _filter.timePeriods.getCurrentSeasonEndYear(type, country);

    var options = [_filter.timePeriods.getAll(1988, currentYear), _filter.timePeriods.getCurrent(currentYear, type), _filter.timePeriods.getLast5(currentYear, type)].concat(_toConsumableArray(_filter.timePeriods.getPeriods(currentYear - 1, currentYear - 6, type)));

    options[0].selected = true;

    return {
        options: options,
        title: 'time period',
        createdBy: {
            raceType: type
        },
        seasonsAvailable: seasonsAvailable
    };
}

function getAdvancedOptions(type) {
    if (type === 'flat') {
        return [{
            label: '2yo',
            value: '2yo'
        }, {
            label: '3yo',
            value: '3yo'
        }, {
            label: '4yo+',
            value: '4yo+'
        }];
    }

    return [{
        label: 'Hurdles',
        value: 'hurdle'
    }, {
        label: 'Chases',
        value: 'chase'
    }, {
        label: 'National Hunt Flat',
        value: 'nhf'
    }];
}

function advancedFactory(country, type) {
    var displayBy = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var humanType = arguments[3];

    var noFilter = {
        value: 'overall',
        label: 'No filter',
        selected: true
    };
    var options = [noFilter];

    if (getGenericDisplayBy(humanType).some(function (o) {
        return o.value === displayBy;
    })) {
        options = [noFilter].concat(_toConsumableArray(getAdvancedOptions(type)));
    }

    return {
        options: options,
        title: 'advanced filter (' + (type === 'jumps' ? 'by code' : 'by age') + ')',
        createdBy: {
            raceType: type
        }
    };
}

var raceTypeFactory = exports.raceTypeFactory = function raceTypeFactory(country, type) {
    return {
        title: 'race type',
        options: _filter.selection.setSelected(_filter.raceTypes.human, country + '/' + type)
    };
};

var categoriesFactory = exports.categoriesFactory = function categoriesFactory(country, type, humanType, seasonsAvailable) {
    var raceType = raceTypeFactory(country, type);
    var displayBy = displayByFactory(country, type, humanType);
    var timePeriod = timePeriodFactory(country, type, seasonsAvailable);
    var advanced = advancedFactory(country, type);
    return { raceType: raceType, displayBy: displayBy, timePeriod: timePeriod, advanced: advanced };
};

function getAdvancedStatus(categories) {
    var selectedValue = _filter.selection.getValue(categories, 'advanced');
    if (selectedValue !== 'overall') {
        return _filter.selection.getCaption(categories, 'advanced');
    }

    return null;
}

function getTimePeriodStatus(categories) {
    var option = _filter.selection.getOption(categories, 'timePeriod');
    var years = (0, _lodash.uniq)(option.value.split('/').slice(0, 2));

    if (option.value.match(/last5/)) {
        return (0, _lodash.toLower)(option.label);
    }
    if (option.value.match(/all/)) {
        return years.join(' - ');
    }
    if (years.length > 1) {
        years[1] = years[1].slice(2);
    }
    return years.join('-');
}

var statusFactory = exports.statusFactory = function statusFactory(categories) {
    return {
        raceType: _filter.selection.getCaption(categories, 'raceType'),
        displayBy: _filter.selection.getCaption(categories, 'displayBy'),
        timePeriod: getTimePeriodStatus(categories),
        advanced: getAdvancedStatus(categories)
    };
};

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'cross',
    size: 'Medium'
});

var ErrorModal = function ErrorModal(_ref) {
    var children = _ref.children,
        text = _ref.text,
        onClose = _ref.onClose;
    return _jsx('div', {
        className: 'pp-errorModal__overlay'
    }, void 0, _jsx('div', {
        className: 'pp-errorModal__container'
    }, void 0, _jsx('div', {
        className: 'pp-errorModal__header'
    }, void 0, _jsx('button', {
        className: 'ui-btn',
        onClick: onClose
    }, void 0, _ref2)), _jsx('div', {
        className: 'pp-errorModal__content'
    }, void 0, children || text), _jsx('button', {
        className: 'pp-errorModal__button ui-btn ui-btn_major',
        onClick: onClose
    }, void 0, 'Ok')));
};

exports.default = ErrorModal;

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultSilkImg = '/pdfs/missing-silk-40x29.133.0.png';

var Image = function (_PureComponent) {
    _inherits(Image, _PureComponent);

    function Image(props) {
        _classCallCheck(this, Image);

        var _this = _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).call(this, props));

        _this.onError = function () {
            _this.setState({ src: '' + _this.props.imgHost + defaultSilkImg });
        };

        _this.state = { src: props.src };
        return _this;
    }

    _createClass(Image, [{
        key: 'render',
        value: function render() {
            return _jsx('img', {
                className: this.props.imgClass,
                src: this.state.src,
                alt: this.props.alt,
                onError: this.onError
            });
        }
    }]);

    return Image;
}(_react.PureComponent);

exports.default = Image;

/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Formats a ratio cell, e.g.: a/b
 * @param {number} a - Divident.
 * @param {number} b - Divisor.
 */
var _ref2 = _jsx('span', {}, void 0, _rpReactTable.EMPTINESS_SIGN);

var _ref3 = _jsx('wbr', {});

var RatioCell = function RatioCell(_ref) {
    var a = _ref.a,
        b = _ref.b;
    return a === 0 && b === 0 ? _ref2 : _jsx('span', {}, void 0, _jsx('strong', {}, void 0, a), '/', _ref3, b);
};

exports.default = RatioCell;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _EntriesList = __webpack_require__(626);

var _EntriesList2 = _interopRequireDefault(_EntriesList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Entries = function Entries(props) {
    var type = props.params.type,
        data = props.data;

    var isJockey = type === 'jockey';
    var isHorseShown = type !== 'horse';
    var entries = (isJockey ? data.bookedRides : data.entries) || [];
    var title = isJockey ? 'booked rides' : 'entries';
    var horseName = isHorseShown ? null : data.profile.horseName;

    return _jsx('section', {}, void 0, _jsx(_EntriesList2.default, {
        entries: entries,
        horseName: horseName,
        noDataText: 'No ' + title + ' for this ' + type,
        isHorseShown: isHorseShown,
        isPriceShown: true,
        isDamShown: false
    }));
};

var entriesTypes = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    courseStyleName: _propTypes2.default.string,
    courseUid: _propTypes2.default.number,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    raceDatetime: _propTypes2.default.string,
    raceInstanceTitle: _propTypes2.default.string,
    raceInstanceUid: _propTypes2.default.number,
    raceStatusCode: _propTypes2.default.string,
    raceUid: _propTypes2.default.number
}));

exports.default = Entries;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpReactTable = __webpack_require__(23);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _EntriesRow = __webpack_require__(1242);

var _EntriesRow2 = _interopRequireDefault(_EntriesRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var itemsPerPage = 20;

var EntriesList = function (_PureComponent) {
    _inherits(EntriesList, _PureComponent);

    function EntriesList(props) {
        _classCallCheck(this, EntriesList);

        var _this = _possibleConstructorReturn(this, (EntriesList.__proto__ || Object.getPrototypeOf(EntriesList)).call(this, props));

        _this.updatePrices = function () {
            (0, _jquery2.default)(document).trigger('dynamicPricesUpdated.PRICES');
        };

        _this.showMore = function () {
            _this.setState(function (state) {
                return { shownItems: state.shownItems + itemsPerPage };
            });
        };

        _this.state = { shownItems: itemsPerPage };
        return _this;
    }

    _createClass(EntriesList, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.updatePrices();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var entries = _ref.entries;

            if (entries !== this.props.entries) {
                this.setState({ shownItems: itemsPerPage });
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.updatePrices();
        }
    }, {
        key: 'render',
        value: function render() {
            var shownItems = this.state.shownItems;
            var _props = this.props,
                entries = _props.entries,
                isDamShown = _props.isDamShown,
                isHorseShown = _props.isHorseShown,
                noDataText = _props.noDataText,
                horseName = _props.horseName,
                isPriceShown = _props.isPriceShown;


            return _jsx('section', {
                className: 'pp-entries'
            }, void 0, _jsx('h2', {
                className: 'pp-entries__header'
            }, void 0, 'Date / ', isHorseShown && 'Horse / ', isDamShown && 'Dam / ', 'Race'), entries.length ? _jsx('ul', {
                className: (0, _classnames2.default)({ 'js-diffusionTopicSettingsRace': isPriceShown })
            }, void 0, entries.slice(0, shownItems).map(function (row) {
                return _jsx(_EntriesRow2.default, {
                    data: _extends({ horseName: horseName }, row),
                    isDamShown: isDamShown,
                    isHorseShown: isHorseShown,
                    isPriceShown: isPriceShown
                }, '' + row.horseUid + row.raceInstanceUid);
            })) : _jsx(_rpReactTable.NoData, {
                text: noDataText
            }), shownItems < entries.length && _jsx(_rpReactTable.ShowMore, {
                onClick: this.showMore
            }));
        }
    }]);

    return EntriesList;
}(_react.PureComponent);

exports.default = EntriesList;

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'videoHollow',
    className: 'ui-icon tableShowIcon',
    size: 'Medium'
});

var ReplayLink = function ReplayLink(props) {
    return _react2.default.createElement(
        _ResultLink2.default,
        _extends({}, props, {
            urlHash: 'fullReplay-profiles',
            className: 'hp-formTable__videoIcon'
        }),
        _ref
    );
};

exports.default = ReplayLink;

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _date = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon ui-icon__btn chevronIcon',
    size: 'XSmall'
});

var SalesHorseLink = function SalesHorseLink(_ref) {
    var children = _ref.children,
        venueUid = _ref.venueUid,
        saleDate = _ref.saleDate,
        lotNo = _ref.lotNo,
        lotLetter = _ref.lotLetter;

    if (!venueUid || !saleDate || !lotNo) {
        return null;
    }

    var date = (0, _date.formatDate)(saleDate, 'Y-MM-DD');
    var url = '/bloodstock/sales/catalogues/' + venueUid + '/' + date + '?lot=' + lotNo + '&letter=' + (lotLetter || ' ');

    return _jsx('a', {
        className: 'ui-link ui-link_table js-popupLink js-navigate-url',
        href: url
    }, void 0, children || (0, _date.formatDate)(saleDate, 'DDMMMYY'), _ref2);
};

exports.default = SalesHorseLink;

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabNames = __webpack_require__(128);

var calculateTabUrl = function calculateTabUrl(currentTab, tabName, index, isSire, isMyRatingShown) {
    // when current tab is missing (we are on the index tab)
    // tab with index = 0 would be active
    if (!currentTab && !index) {
        return '';
    }
    if (tabName === 'form' && isMyRatingShown) {
        return tabName + '/my-ratings';
    }
    if (!isSire) {
        return tabName;
    }

    // if we are on sire profiles there are subtabs
    // and sometimes title of tab is different from url
    var subTabs = _tabNames.sireSubTabs[tabName];
    if (subTabs) {
        return subTabs.includes(currentTab) ? currentTab : subTabs[0];
    }
    return tabName;
};

exports.default = calculateTabUrl;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var PropTypes = _interopRequireWildcard(_propTypes);

var _rpGuiGuide = __webpack_require__(126);

var _rpUtils = __webpack_require__(288);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable */
var _ref = _jsx('div', {
	className: 'PC-bestOdds__shadow js-PC-bestOdds__shadow'
});

var _ref2 = _jsx('div', {
	className: 'PC-bestOdds__arrow js-PC-bestOdds__arrow'
});

var _ref3 = _jsx('div', {
	className: 'PC-bestOdds__horseName js-bestOddsHorseName'
});

var _ref4 = _jsx('div', {
	className: 'PC-bestOdds__headers'
}, void 0, _jsx('div', {
	className: 'PC-bestOdds__headers__field\n                        PC-bestOdds__headers__field_bookmaker'
}, void 0, 'Bookmaker'), _jsx('div', {
	className: 'PC-bestOdds__headers__field\n                        PC-bestOdds__headers__field_price'
}, void 0, 'Price'), _jsx('div', {
	className: 'PC-bestOdds__headers__field\n                        PC-bestOdds__headers__field_terms'
}, void 0, 'E.W. Terms'));

var _ref5 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow PC-bestOdds__bookieRow_betslip js-diffusionBestOdds',
	'data-diffusion-horsename': '',
	'data-diffusion-bookmaker': 'BET365',
	'data-diffusion-bookieName': 'bet365'
}, void 0, _jsx('div', {
	className: 'PC-bestOdds__bookieRow__name'
}, void 0, _jsx('div', {}, void 0, 'bet365'), _jsx('a', {
	href: 'https://members.bet365.com/Members/OpenAccount/?affiliate=365_386841&prdid=1&ibpid=2200&lng=1&rUrl=www%2Eracingpost%2Ecom&oty=1&ver=2',
	target: '_blank',
	rel: 'noopener noreferrer',
	className: 'PC-bestOdds__bookieRow__name_account'
}, void 0, 'Open Account')), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__price'
}, void 0, _jsx('div', {
	className: 'ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_bet365 js-betHandler\n                                js-PC-bestOdds__priceBtn'
})), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay'
}), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__oddsIcon\n                            PC-bestOdds__bookieRow__oddsIcon_betslip\n                            js-diffusionBestOdds_bog'
}));

var _ref6 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow\n                        PC-bestOdds__bookieRow_betslip\n                        js-diffusionBestOdds',
	'data-diffusion-horsename': '',
	'data-diffusion-bookmaker': 'LADB',
	'data-diffusion-bookieName': 'ladbrokes'
}, void 0, _jsx('div', {
	className: 'PC-bestOdds__bookieRow__name'
}, void 0, _jsx('div', {}, void 0, 'Ladbrokes'), _jsx('a', {
	href: 'http://online.ladbrokes.com/promoRedirect?key=ej0xMzc3MTI2OSZsPS0xJnA9NjgwNDk4',
	target: '_blank',
	rel: 'noopener noreferrer',
	className: 'PC-bestOdds__bookieRow__name_account'
}, void 0, 'Open Account')), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__price'
}, void 0, _jsx('div', {
	className: 'ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_ladbrokes js-betHandler\n                                js-PC-bestOdds__priceBtn'
})), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay'
}), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__oddsIcon\n                            PC-bestOdds__bookieRow__oddsIcon_betslip\n                            js-diffusionBestOdds_bog'
}));

var _ref7 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow js-diffusionBestOdds',
	'data-diffusion-horsename': '',
	'data-diffusion-bookmaker': 'PPWR',
	'data-diffusion-bookieName': 'paddypower'
}, void 0, _jsx('div', {
	className: 'PC-bestOdds__bookieRow__name'
}, void 0, 'Paddy Power'), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__price'
}, void 0, _jsx('div', {
	className: 'ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_paddypower js-betHandler\n                                js-PC-bestOdds__priceBtn'
})), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay'
}), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog'
}));

var _ref8 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow js-diffusionBestOdds',
	'data-diffusion-horsename': '',
	'data-diffusion-bookmaker': 'BETFAIR',
	'data-diffusion-bookieName': 'betfair'
}, void 0, _jsx('div', {
	className: 'PC-bestOdds__bookieRow__name'
}, void 0, 'Betfair'), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__price'
}, void 0, _jsx('div', {
	className: 'ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_betfair js-betHandler\n                                js-PC-bestOdds__priceBtn'
})), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay'
}), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog'
}));

var _ref9 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow\n                        PC-bestOdds__bookieRow_betslip\n                        js-diffusionBestOdds',
	'data-diffusion-horsename': '',
	'data-diffusion-bookmaker': 'WH_OXI',
	'data-diffusion-bookieName': 'williamHill'
}, void 0, _jsx('div', {
	className: 'PC-bestOdds__bookieRow__name'
}, void 0, _jsx('div', {}, void 0, 'William Hill'), _jsx('a', {
	href: 'http://ads2.williamhill.com/redirect.aspx?pid=185759757&lpid=1487411833&bid=1487411716',
	target: '_blank',
	rel: 'noopener noreferrer',
	className: 'PC-bestOdds__bookieRow__name_account'
}, void 0, 'Open Account')), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__price'
}, void 0, _jsx('div', {
	className: 'ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_williamHill js-betHandler\n                                js-PC-bestOdds__priceBtn'
})), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay'
}), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__oddsIcon\n                            PC-bestOdds__bookieRow__oddsIcon_betslip\n                            js-diffusionBestOdds_bog'
}));

var _ref10 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow\n                        PC-bestOdds__bookieRow_betslip\n                        js-diffusionBestOdds',
	'data-diffusion-horsename': '',
	'data-diffusion-bookmaker': 'CORAL',
	'data-diffusion-bookieName': 'coral'
}, void 0, _jsx('div', {
	className: 'PC-bestOdds__bookieRow__name'
}, void 0, _jsx('div', {}, void 0, 'Coral'), _jsx('a', {
	href: 'http://affiliate.coral.co.uk/processing/clickthrgh.asp?btag=a_2757b_6528',
	target: '_blank',
	rel: 'noopener noreferrer',
	className: 'PC-bestOdds__bookieRow__name_account'
}, void 0, 'Open Account')), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__price'
}, void 0, _jsx('div', {
	className: 'ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_coral js-betHandler\n                                js-PC-bestOdds__priceBtn'
})), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay'
}), _jsx('div', {
	className: 'PC-bestOdds__bookieRow__oddsIcon\n                            PC-bestOdds__bookieRow__oddsIcon_betslip\n                            js-diffusionBestOdds_bog'
}));

var _ref11 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow__name'
}, void 0, _jsx('div', {}, void 0, 'Sky Bet'), _jsx('a', {
	href: 'https://m.skybet.com/',
	target: '_blank',
	rel: 'noopener noreferrer',
	className: 'PC-bestOdds__bookieRow__name_account'
}, void 0, 'Open Account'));

var _ref12 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow__price'
}, void 0, _jsx('div', {
	className: 'ui-btn PC-bestOdds__bookieRow__priceBtn\n                                ui-priceBtn_skybet js-betHandler\n                                js-PC-bestOdds__priceBtn'
}));

var _ref13 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay'
});

var _ref14 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow__oddsIcon\n                            PC-bestOdds__bookieRow__oddsIcon_betslip\n                            js-diffusionBestOdds_bog'
});

var _ref15 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay'
});

var _ref16 = _jsx('div', {
	className: 'PC-bestOdds__bookieRow__oddsIcon\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tPC-bestOdds__bookieRow__oddsIcon_betslip\n\t\t\t\t\t\t\t\t\t\t\t\t\t\tjs-diffusionBestOdds_bog'
});

var BestOdds = function (_React$Component) {
	_inherits(BestOdds, _React$Component);

	function BestOdds(props) {
		_classCallCheck(this, BestOdds);

		var _this = _possibleConstructorReturn(this, (BestOdds.__proto__ || Object.getPrototypeOf(BestOdds)).call(this, props));

		_this.bookmakers = [{
			key: 'tote',
			displayName: 'Tote',
			diffusionName: 'TOTE',
			diffusionBookieName: 'Tote',
			class: 'tote'
		}, {
			key: 'boylesports',
			displayName: 'Boylesports',
			diffusionName: 'BOLEYSPORTS',
			diffusionBookieName: 'boylesports',
			class: 'boylesports'
		}, {
			key: 'betfred',
			displayName: 'Betfred',
			diffusionName: 'BETFRED',
			diffusionBookieName: 'betfred',
			class: 'betfred'
		}];

		_this.getOpenAccountLinks = function (tierOneDesktop, tierTwoDesktop) {
			var toteOffer = tierOneDesktop.find(function (bookmakerOffer) {
				return bookmakerOffer.name === 'tote';
			});
			var boyleSportsOffer = tierTwoDesktop.find(function (bookmakerOffer) {
				return bookmakerOffer.name === 'BoyleSports';
			});
			var betfredOffer = tierTwoDesktop.find(function (bookmakerOffer) {
				return bookmakerOffer.name === 'Betfred';
			});

			_this.setState({
				bookmakersOpenAccountLinks: {
					boyleSports: boyleSportsOffer.signUpLink3 ? boyleSportsOffer.signUpLink3 : null,
					tote: toteOffer.signUpLink8 ? toteOffer.signUpLink8 : null,
					betfred: betfredOffer.signUpLink3 ? betfredOffer.signUpLink3 : null
				}
			});
		};

		_this.createOpenAccountLink = function (link) {
			return _jsx('a', {
				href: link,
				target: '_blank',
				rel: 'noopener noreferrer',
				className: 'PC-bestOdds__bookieRow__name_account'
			}, void 0, 'Open Account');
		};

		_this.state = {
			bookmakersOpenAccountLinks: {
				boyleSports: null,
				tote: null,
				betfred: null
			}
		};
		return _this;
	}

	_createClass(BestOdds, [{
		key: 'componentDidMount',
		value: function componentDidMount() {
			var _this2 = this;

			(0, _rpUtils.fetchBookmakersMixed)().then(function (data) {
				_this2.getOpenAccountLinks(data.bookmakerOffersDesktop, data.bookmakerOffersTierTwoDesktop);
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _this3 = this;

			var skybetDiffusionName = this.props.skybetDiffusionName;


			return _jsx('div', {
				className: 'js-PC-runnerBestOddsContainer'
			}, void 0, _jsx('div', {
				className: 'PC-bestOddsContainer js-bestOddsContainer'
			}, void 0, _ref, _jsx('div', {
				className: 'PC-bestOdds js-PC-bestOdds'
			}, void 0, _ref2, _ref3, _ref4, _jsx('div', {
				className: 'PC-bestOdds__bookiesList PC-bestOdds__bookiesList_betslip'
			}, void 0, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _jsx('div', {
				className: 'PC-bestOdds__bookieRow\n                        PC-bestOdds__bookieRow_betslip\n                        js-diffusionBestOdds',
				'data-diffusion-horsename': '',
				'data-diffusion-bookmaker': skybetDiffusionName,
				'data-diffusion-bookieName': 'skybet'
			}, void 0, _ref11, _ref12, _ref13, _ref14)), _jsx('div', {
				className: 'PC-bestOdds__bookiesList'
			}, void 0, this.bookmakers.map(function (bookmaker) {
				var link = _this3.state.bookmakersOpenAccountLinks[bookmaker.key];

				return _jsx('div', {
					className: 'PC-bestOdds__bookieRow\n\t\t\t\t\t\t\t\t\t\t\t\t\tjs-diffusionBestOdds',
					'data-diffusion-horsename': '',
					'data-diffusion-bookmaker': bookmaker.diffusionName,
					'data-diffusion-bookieName': bookmaker.diffusionBookieName
				}, void 0, _jsx('div', {
					className: 'PC-bestOdds__bookieRow__name'
				}, void 0, _jsx('div', {}, void 0, bookmaker.displayName), link && !_rpGuiGuide.mobileDetect.mobile() && _jsx('a', {
					href: link,
					target: '_blank',
					rel: 'noopener noreferrer',
					className: 'PC-bestOdds__bookieRow__name_account'
				}, void 0, 'Open Account')), _jsx('div', {
					className: 'PC-bestOdds__bookieRow__price'
				}, void 0, _jsx('div', {
					className: 'ui-btn PC-bestOdds__bookieRow__priceBtn\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tui-priceBtn_' + bookmaker.class + ' js-betHandler\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t\tjs-PC-bestOdds__priceBtn'
				})), _ref15, _ref16);
			})))));
		}
	}]);

	return BestOdds;
}(_react2.default.Component);

/* eslint-enable */
exports.default = BestOdds;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PriceButton = function PriceButton(_ref) {
    var diffusionCourseName = _ref.diffusionCourseName,
        horseName = _ref.horseName,
        saddleClothNo = _ref.saddleClothNo,
        raceDatetime = _ref.raceDatetime,
        raceInstanceUid = _ref.raceInstanceUid;
    return _jsx('div', {
        className: 'js-PC-runnerRow hp-price-button__wrapper'
    }, void 0, saddleClothNo && _jsx('div', {
        className: 'RC-runnerNumber__no',
        'data-horseName': horseName
    }, void 0, saddleClothNo), _jsx('div', {
        className: 'js-diffusionHorsesList js-bestOddsPriceContainer js-horsesList',
        'data-card-race-date-time': raceDatetime,
        'data-diffusion-horsename': horseName,
        'data-diffusion-race-id': raceInstanceUid,
        'data-diffusion-racedate': (0, _date.formatDate)(raceDatetime, 'YYYY-MM-DD'),
        'data-diffusion-coursename': diffusionCourseName,
        'data-diffusion-racetime': (0, _date.formatDate)(raceDatetime, 'HH:mm')
    }, void 0, _jsx('div', {
        className: 'ui-priceBtn_noPrice ui-btn js-diffusionPriceValue\n                    js-betHandler js-runnerPrice js-runnerPriceBestOdds'
    })), _jsx('div', {
        className: 'js-bestOddsRunnerHorseName hide'
    }, void 0, horseName));
};

exports.default = PriceButton;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var gngSequence = ['Frozen', 'Hard', 'Firm', 'Fast', 'Good To Firm', 'Standard To Fast', 'Good', 'Standard', 'Good To Yielding', 'Good To Soft', 'Standard To Slow', 'Yielding', 'Yielding To Soft', 'Muddy', 'Soft', 'Slow', 'Sloppy', 'Very Soft', 'Soft To Heavy', 'Heavy'];

var gngCodeSequence = ['FZ', 'HD', 'F', 'FT', 'GF', 'SF', 'G', 'SD', 'GY', 'GS', 'SS', 'Y', 'YS', 'MY', 'S', 'SW', 'SY', 'VS', 'SH', 'HY'];

var goingSortFn = exports.goingSortFn = function goingSortFn(a, b) {
    return gngSequence.indexOf(a.going) - gngSequence.indexOf(b.going);
};

var goingCodeSortFn = exports.goingCodeSortFn = function goingCodeSortFn(a, b) {
    return gngCodeSequence.indexOf(a.goingTypeCode) - gngCodeSequence.indexOf(b.goingTypeCode);
};

/***/ }),
/* 633 */,
/* 634 */,
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(1277);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(1276);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(647);
var hiddenKeys = __webpack_require__(418).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(247)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added
 * @returns {Date} the new date with the hours added
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * var result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR)
}

module.exports = addHours


/***/ }),
/* 701 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(176)
var setISOYear = __webpack_require__(727)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Add the specified number of ISO week-numbering years to the given date.
 *
 * @description
 * Add the specified number of ISO week-numbering years to the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be added
 * @returns {Date} the new date with the ISO week-numbering years added
 *
 * @example
 * // Add 5 ISO week-numbering years to 2 July 2010:
 * var result = addISOYears(new Date(2010, 6, 2), 5)
 * //=> Fri Jun 26 2015 00:00:00
 */
function addISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return setISOYear(dirtyDate, getISOYear(dirtyDate) + amount)
}

module.exports = addISOYears


/***/ }),
/* 702 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(247)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added
 * @returns {Date} the new date with the minutes added
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * var result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE)
}

module.exports = addMinutes


/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(323)

/**
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added
 * @returns {Date} the new date with the quarters added
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * var result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  var months = amount * 3
  return addMonths(dirtyDate, months)
}

module.exports = addQuarters


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(247)

/**
 * @category Second Helpers
 * @summary Add the specified number of seconds to the given date.
 *
 * @description
 * Add the specified number of seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be added
 * @returns {Date} the new date with the seconds added
 *
 * @example
 * // Add 30 seconds to 10 July 2014 12:45:00:
 * var result = addSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:45:30
 */
function addSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, amount * 1000)
}

module.exports = addSeconds


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(323)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),
/* 706 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(176)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of calendar ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of calendar ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO week-numbering years
 *
 * @example
 * // How many calendar ISO week-numbering years are 1 January 2010 and 1 January 2012?
 * var result = differenceInCalendarISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 2
 */
function differenceInCalendarISOYears (dirtyDateLeft, dirtyDateRight) {
  return getISOYear(dirtyDateLeft) - getISOYear(dirtyDateRight)
}

module.exports = differenceInCalendarISOYears


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  return dateLeft.getFullYear() - dateRight.getFullYear()
}

module.exports = differenceInCalendarYears


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var differenceInCalendarDays = __webpack_require__(324)
var compareAsc = __webpack_require__(248)

/**
 * @category Day Helpers
 * @summary Get the number of full days between the given dates.
 *
 * @description
 * Get the number of full days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full days
 *
 * @example
 * // How many full days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 365
 */
function differenceInDays (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarDays(dateLeft, dateRight))
  dateLeft.setDate(dateLeft.getDate() - sign * difference)

  // Math.abs(diff in full days - diff in calendar days) === 1 if last calendar day is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastDayNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastDayNotFull)
}

module.exports = differenceInDays


/***/ }),
/* 710 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(458)
var parse = __webpack_require__(5)
var differenceInSeconds = __webpack_require__(460)
var differenceInMonths = __webpack_require__(459)
var enLocale = __webpack_require__(466)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_ALMOST_TWO_DAYS = 2520
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_TWO_MONTHS = 86400

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words.
 *
 * | Distance between dates                                            | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance between dates | Result               |
 * |------------------------|----------------------|
 * | 0 secs ... 5 secs      | less than 5 seconds  |
 * | 5 secs ... 10 secs     | less than 10 seconds |
 * | 10 secs ... 20 secs    | less than 20 seconds |
 * | 20 secs ... 40 secs    | half a minute        |
 * | 40 secs ... 60 secs    | less than a minute   |
 * | 60 secs ... 90 secs    | 1 minute             |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWords(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 1)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00, including seconds?
 * var result = distanceInWords(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWords(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'about 1 year ago'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWords(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWords (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = Math.round(seconds / 60) - offset
  var months

  // 0 up to 2 mins
  if (minutes < 2) {
    if (options.includeSeconds) {
      if (seconds < 5) {
        return localize('lessThanXSeconds', 5, localizeOptions)
      } else if (seconds < 10) {
        return localize('lessThanXSeconds', 10, localizeOptions)
      } else if (seconds < 20) {
        return localize('lessThanXSeconds', 20, localizeOptions)
      } else if (seconds < 40) {
        return localize('halfAMinute', null, localizeOptions)
      } else if (seconds < 60) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', 1, localizeOptions)
      }
    } else {
      if (minutes === 0) {
        return localize('lessThanXMinutes', 1, localizeOptions)
      } else {
        return localize('xMinutes', minutes, localizeOptions)
      }
    }

  // 2 mins up to 0.75 hrs
  } else if (minutes < 45) {
    return localize('xMinutes', minutes, localizeOptions)

  // 0.75 hrs up to 1.5 hrs
  } else if (minutes < 90) {
    return localize('aboutXHours', 1, localizeOptions)

  // 1.5 hrs up to 24 hrs
  } else if (minutes < MINUTES_IN_DAY) {
    var hours = Math.round(minutes / 60)
    return localize('aboutXHours', hours, localizeOptions)

  // 1 day up to 1.75 days
  } else if (minutes < MINUTES_IN_ALMOST_TWO_DAYS) {
    return localize('xDays', 1, localizeOptions)

  // 1.75 days up to 30 days
  } else if (minutes < MINUTES_IN_MONTH) {
    var days = Math.round(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 month up to 2 months
  } else if (minutes < MINUTES_IN_TWO_MONTHS) {
    months = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('aboutXMonths', months, localizeOptions)
  }

  months = differenceInMonths(dateRight, dateLeft)

  // 2 months up to 12 months
  if (months < 12) {
    var nearestMonth = Math.round(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', nearestMonth, localizeOptions)

  // 1 year up to max Date
  } else {
    var monthsSinceStartOfYear = months % 12
    var years = Math.floor(months / 12)

    // N years up to 1 years 3 months
    if (monthsSinceStartOfYear < 3) {
      return localize('aboutXYears', years, localizeOptions)

    // N years 3 months up to N years 9 months
    } else if (monthsSinceStartOfYear < 9) {
      return localize('overXYears', years, localizeOptions)

    // N years 9 months up to N year 12 months
    } else {
      return localize('almostXYears', years + 1, localizeOptions)
    }
  }
}

module.exports = distanceInWords


/***/ }),
/* 711 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a month
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * var result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfMonth


/***/ }),
/* 712 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Week Helpers
 * @summary Return the end of a week for the given date.
 *
 * @description
 * Return the end of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the end of a week
 *
 * @example
 * // The end of a week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 23:59:59.999
 *
 * @example
 * // If the week starts on Monday, the end of the week for 2 September 2014 11:55:00:
 * var result = endOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setDate(date.getDate() + diff)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfWeek


/***/ }),
/* 713 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var startOfYear = __webpack_require__(733)
var differenceInCalendarDays = __webpack_require__(324)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 714 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Weekday Helpers
 * @summary Get the day of the ISO week of the given date.
 *
 * @description
 * Get the day of the ISO week of the given date,
 * which is 7 for Sunday, 1 for Monday etc.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of ISO week
 *
 * @example
 * // Which day of the ISO week is 26 February 2012?
 * var result = getISODay(new Date(2012, 1, 26))
 * //=> 7
 */
function getISODay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()

  if (day === 0) {
    day = 7
  }

  return day
}

module.exports = getISODay


/***/ }),
/* 715 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the quarter
 *
 * @example
 * // Which quarter is 2 July 2014?
 * var result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var quarter = Math.floor(date.getMonth() / 3) + 1
  return quarter
}

module.exports = getQuarter


/***/ }),
/* 716 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Year Helpers
 * @summary Is the given date in the leap year?
 *
 * @description
 * Is the given date in the leap year?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the leap year
 *
 * @example
 * // Is 1 September 2012 in the leap year?
 * var result = isLeapYear(new Date(2012, 8, 1))
 * //=> true
 */
function isLeapYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0
}

module.exports = isLeapYear


/***/ }),
/* 717 */
/***/ (function(module, exports, __webpack_require__) {

var startOfHour = __webpack_require__(729)

/**
 * @category Hour Helpers
 * @summary Are the given dates in the same hour?
 *
 * @description
 * Are the given dates in the same hour?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same hour
 *
 * @example
 * // Are 4 September 2014 06:00:00 and 4 September 06:30:00 in the same hour?
 * var result = isSameHour(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 6, 30)
 * )
 * //=> true
 */
function isSameHour (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfHour = startOfHour(dirtyDateLeft)
  var dateRightStartOfHour = startOfHour(dirtyDateRight)

  return dateLeftStartOfHour.getTime() === dateRightStartOfHour.getTime()
}

module.exports = isSameHour


/***/ }),
/* 718 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(465)

/**
 * @category ISO Week Helpers
 * @summary Are the given dates in the same ISO week?
 *
 * @description
 * Are the given dates in the same ISO week?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week
 *
 * @example
 * // Are 1 September 2014 and 7 September 2014 in the same ISO week?
 * var result = isSameISOWeek(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 8, 7)
 * )
 * //=> true
 */
function isSameISOWeek (dirtyDateLeft, dirtyDateRight) {
  return isSameWeek(dirtyDateLeft, dirtyDateRight, {weekStartsOn: 1})
}

module.exports = isSameISOWeek


/***/ }),
/* 719 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(249)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Are the given dates in the same ISO week-numbering year?
 *
 * @description
 * Are the given dates in the same ISO week-numbering year?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same ISO week-numbering year
 *
 * @example
 * // Are 29 December 2003 and 2 January 2005 in the same ISO week-numbering year?
 * var result = isSameISOYear(
 *   new Date(2003, 11, 29),
 *   new Date(2005, 0, 2)
 * )
 * //=> true
 */
function isSameISOYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfYear = startOfISOYear(dirtyDateLeft)
  var dateRightStartOfYear = startOfISOYear(dirtyDateRight)

  return dateLeftStartOfYear.getTime() === dateRightStartOfYear.getTime()
}

module.exports = isSameISOYear


/***/ }),
/* 720 */
/***/ (function(module, exports, __webpack_require__) {

var startOfMinute = __webpack_require__(730)

/**
 * @category Minute Helpers
 * @summary Are the given dates in the same minute?
 *
 * @description
 * Are the given dates in the same minute?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same minute
 *
 * @example
 * // Are 4 September 2014 06:30:00 and 4 September 2014 06:30:15
 * // in the same minute?
 * var result = isSameMinute(
 *   new Date(2014, 8, 4, 6, 30),
 *   new Date(2014, 8, 4, 6, 30, 15)
 * )
 * //=> true
 */
function isSameMinute (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfMinute = startOfMinute(dirtyDateLeft)
  var dateRightStartOfMinute = startOfMinute(dirtyDateRight)

  return dateLeftStartOfMinute.getTime() === dateRightStartOfMinute.getTime()
}

module.exports = isSameMinute


/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Month Helpers
 * @summary Are the given dates in the same month?
 *
 * @description
 * Are the given dates in the same month?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * var result = isSameMonth(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameMonth (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear() &&
    dateLeft.getMonth() === dateRight.getMonth()
}

module.exports = isSameMonth


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

var startOfQuarter = __webpack_require__(731)

/**
 * @category Quarter Helpers
 * @summary Are the given dates in the same year quarter?
 *
 * @description
 * Are the given dates in the same year quarter?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * var result = isSameQuarter(
 *   new Date(2014, 0, 1),
 *   new Date(2014, 2, 8)
 * )
 * //=> true
 */
function isSameQuarter (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft)
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight)

  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime()
}

module.exports = isSameQuarter


/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

var startOfSecond = __webpack_require__(732)

/**
 * @category Second Helpers
 * @summary Are the given dates in the same second?
 *
 * @description
 * Are the given dates in the same second?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same second
 *
 * @example
 * // Are 4 September 2014 06:30:15.000 and 4 September 2014 06:30.15.500
 * // in the same second?
 * var result = isSameSecond(
 *   new Date(2014, 8, 4, 6, 30, 15),
 *   new Date(2014, 8, 4, 6, 30, 15, 500)
 * )
 * //=> true
 */
function isSameSecond (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfSecond = startOfSecond(dirtyDateLeft)
  var dateRightStartOfSecond = startOfSecond(dirtyDateRight)

  return dateLeftStartOfSecond.getTime() === dateRightStartOfSecond.getTime()
}

module.exports = isSameSecond


/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * var result = isSameYear(
 *   new Date(2014, 8, 2),
 *   new Date(2014, 8, 25)
 * )
 * //=> true
 */
function isSameYear (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)
  return dateLeft.getFullYear() === dateRight.getFullYear()
}

module.exports = isSameYear


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(464)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Week Helpers
 * @summary Return the last day of a week for the given date.
 *
 * @description
 * Return the last day of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the last day of a week
 *
 * @example
 * // The last day of a week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sat Sep 06 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the last day of the week for 2 September 2014 11:55:00:
 * var result = lastDayOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? -7 : 0) + 6 - (day - weekStartsOn)

  date.setHours(0, 0, 0, 0)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = lastDayOfWeek


/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var startOfISOYear = __webpack_require__(249)
var differenceInCalendarDays = __webpack_require__(324)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Set the ISO week-numbering year to the given date.
 *
 * @description
 * Set the ISO week-numbering year to the given date,
 * saving the week number and the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoYear - the ISO week-numbering year of the new date
 * @returns {Date} the new date with the ISO week-numbering year setted
 *
 * @example
 * // Set ISO week-numbering year 2007 to 29 December 2008:
 * var result = setISOYear(new Date(2008, 11, 29), 2007)
 * //=> Mon Jan 01 2007 00:00:00
 */
function setISOYear (dirtyDate, dirtyISOYear) {
  var date = parse(dirtyDate)
  var isoYear = Number(dirtyISOYear)
  var diff = differenceInCalendarDays(date, startOfISOYear(date))
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(isoYear, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  date = startOfISOYear(fourthOfJanuary)
  date.setDate(date.getDate() + diff)
  return date
}

module.exports = setISOYear


/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var getDaysInMonth = __webpack_require__(462)

/**
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month setted
 *
 * @example
 * // Set February to 1 September 2014:
 * var result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth (dirtyDate, dirtyMonth) {
  var date = parse(dirtyDate)
  var month = Number(dirtyMonth)
  var year = date.getFullYear()
  var day = date.getDate()

  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(year, month, 15)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth))
  return date
}

module.exports = setMonth


/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Hour Helpers
 * @summary Return the start of an hour for the given date.
 *
 * @description
 * Return the start of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an hour
 *
 * @example
 * // The start of an hour for 2 September 2014 11:55:00:
 * var result = startOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:00:00
 */
function startOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(0, 0, 0)
  return date
}

module.exports = startOfHour


/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Minute Helpers
 * @summary Return the start of a minute for the given date.
 *
 * @description
 * Return the start of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a minute
 *
 * @example
 * // The start of a minute for 1 December 2014 22:15:45.400:
 * var result = startOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:00
 */
function startOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(0, 0)
  return date
}

module.exports = startOfMinute


/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a quarter
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * var result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3
  date.setMonth(month, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfQuarter


/***/ }),
/* 732 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Second Helpers
 * @summary Return the start of a second for the given date.
 *
 * @description
 * Return the start of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a second
 *
 * @example
 * // The start of a second for 1 December 2014 22:15:45.400:
 * var result = startOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.000
 */
function startOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(0)
  return date
}

module.exports = startOfSecond


/***/ }),
/* 733 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 734 */
/***/ (function(module, exports, __webpack_require__) {

var addISOYears = __webpack_require__(701)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Subtract the specified number of ISO week-numbering years from the given date.
 *
 * @description
 * Subtract the specified number of ISO week-numbering years from the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of ISO week-numbering years to be subtracted
 * @returns {Date} the new date with the ISO week-numbering years subtracted
 *
 * @example
 * // Subtract 5 ISO week-numbering years from 1 September 2014:
 * var result = subISOYears(new Date(2014, 8, 1), 5)
 * //=> Mon Aug 31 2009 00:00:00
 */
function subISOYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addISOYears(dirtyDate, -amount)
}

module.exports = subISOYears


/***/ }),
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(590);

exports.__esModule = true;
exports.default = scrollbarSize;

var _inDOM = _interopRequireDefault(__webpack_require__(2086));

var size;

function scrollbarSize(recalc) {
  if (!size && size !== 0 || recalc) {
    if (_inDOM.default) {
      var scrollDiv = document.createElement('div');
      scrollDiv.style.position = 'absolute';
      scrollDiv.style.top = '-9999px';
      scrollDiv.style.width = '50px';
      scrollDiv.style.height = '50px';
      scrollDiv.style.overflow = 'scroll';
      document.body.appendChild(scrollDiv);
      size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
      document.body.removeChild(scrollDiv);
    }
  }

  return size;
}

module.exports = exports["default"];

/***/ }),
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */,
/* 866 */,
/* 867 */,
/* 868 */,
/* 869 */,
/* 870 */,
/* 871 */,
/* 872 */,
/* 873 */,
/* 874 */,
/* 875 */,
/* 876 */,
/* 877 */,
/* 878 */,
/* 879 */,
/* 880 */,
/* 881 */,
/* 882 */,
/* 883 */,
/* 884 */,
/* 885 */,
/* 886 */,
/* 887 */,
/* 888 */,
/* 889 */,
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */,
/* 895 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(2277);


/***/ }),
/* 896 */,
/* 897 */,
/* 898 */,
/* 899 */,
/* 900 */,
/* 901 */,
/* 902 */,
/* 903 */,
/* 904 */,
/* 905 */,
/* 906 */,
/* 907 */,
/* 908 */,
/* 909 */,
/* 910 */,
/* 911 */,
/* 912 */,
/* 913 */,
/* 914 */,
/* 915 */,
/* 916 */,
/* 917 */,
/* 918 */,
/* 919 */,
/* 920 */,
/* 921 */,
/* 922 */,
/* 923 */,
/* 924 */,
/* 925 */,
/* 926 */,
/* 927 */,
/* 928 */,
/* 929 */,
/* 930 */,
/* 931 */,
/* 932 */,
/* 933 */,
/* 934 */,
/* 935 */,
/* 936 */,
/* 937 */,
/* 938 */,
/* 939 */,
/* 940 */,
/* 941 */,
/* 942 */,
/* 943 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 944 */,
/* 945 */,
/* 946 */,
/* 947 */,
/* 948 */,
/* 949 */,
/* 950 */,
/* 951 */,
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);



function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';

var isIE = isBrowser ? !!document.documentElement.currentStyle : false;
var hiddenTextarea = isBrowser && document.createElement('textarea');
var HIDDEN_TEXTAREA_STYLE = {
  'min-height': '0',
  'max-height': 'none',
  height: '0',
  visibility: 'hidden',
  overflow: 'hidden',
  position: 'absolute',
  'z-index': '-1000',
  top: '0',
  right: '0'
};
var SIZING_STYLE = ['letter-spacing', 'line-height', 'font-family', 'font-weight', 'font-size', 'font-style', 'tab-size', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-top', 'padding-right', 'padding-bottom', 'padding-left', 'border-top-width', 'border-right-width', 'border-bottom-width', 'border-left-width', 'box-sizing'];
var computedStyleCache = {};
function calculateNodeHeight(uiTextNode, uid, useCache, minRows, maxRows) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (minRows === void 0) {
    minRows = null;
  }

  if (maxRows === void 0) {
    maxRows = null;
  }

  if (hiddenTextarea.parentNode === null) {
    document.body.appendChild(hiddenTextarea);
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var nodeStyling = calculateNodeStyling(uiTextNode, uid, useCache);

  if (nodeStyling === null) {
    return null;
  }

  var paddingSize = nodeStyling.paddingSize,
      borderSize = nodeStyling.borderSize,
      boxSizing = nodeStyling.boxSizing,
      sizingStyle = nodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content

  Object.keys(sizingStyle).forEach(function (key) {
    hiddenTextarea.style[key] = sizingStyle[key];
  });
  Object.keys(HIDDEN_TEXTAREA_STYLE).forEach(function (key) {
    hiddenTextarea.style.setProperty(key, HIDDEN_TEXTAREA_STYLE[key], 'important');
  });
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || 'x';
  var minHeight = -Infinity;
  var maxHeight = Infinity;
  var height = hiddenTextarea.scrollHeight;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height = height + borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height = height - paddingSize;
  } // measure height of a textarea with a single row


  hiddenTextarea.value = 'x';
  var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

  if (minRows !== null || maxRows !== null) {
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      height = Math.min(maxHeight, height);
    }
  }

  var rowCount = Math.floor(height / singleRowHeight);
  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    rowCount: rowCount
  };
}

function calculateNodeStyling(node, uid, useCache) {
  if (useCache === void 0) {
    useCache = false;
  }

  if (useCache && computedStyleCache[uid]) {
    return computedStyleCache[uid];
  }

  var style = window.getComputedStyle(node);

  if (style === null) {
    return null;
  }

  var sizingStyle = SIZING_STYLE.reduce(function (obj, name) {
    obj[name] = style.getPropertyValue(name);
    return obj;
  }, {});
  var boxSizing = sizingStyle['box-sizing']; // IE (Edge has already correct behaviour) returns content width as computed width
  // so we need to add manually padding and border widths

  if (isIE && boxSizing === 'border-box') {
    sizingStyle.width = parseFloat(sizingStyle.width) + parseFloat(style['border-right-width']) + parseFloat(style['border-left-width']) + parseFloat(style['padding-right']) + parseFloat(style['padding-left']) + 'px';
  }

  var paddingSize = parseFloat(sizingStyle['padding-bottom']) + parseFloat(sizingStyle['padding-top']);
  var borderSize = parseFloat(sizingStyle['border-bottom-width']) + parseFloat(sizingStyle['border-top-width']);
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache) {
    computedStyleCache[uid] = nodeInfo;
  }

  return nodeInfo;
}

var purgeCache = function purgeCache(uid) {
  return delete computedStyleCache[uid];
};

function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();

/**
 * <TextareaAutosize />
 */
var noop = function noop() {}; // IE11 has a problem with eval source maps, can be reproduced with:
// eval('"use strict"; var onNextFrame = window.cancelAnimationFrame; onNextFrame(4);')
// so we bind window as context in dev modes


var _ref = isBrowser && window.requestAnimationFrame ?  true ? [window.requestAnimationFrame, window.cancelAnimationFrame] : [window.requestAnimationFrame.bind(window), window.cancelAnimationFrame.bind(window)] : [setTimeout, clearTimeout];
var onNextFrame = _ref[0];
var clearNextFrameAction = _ref[1];

var TextareaAutosize =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(TextareaAutosize, _React$Component);

  function TextareaAutosize(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this._resizeLock = false;

    _this._onRootDOMNode = function (node) {
      _this._rootDOMNode = node;

      if (_this.props.inputRef) {
        _this.props.inputRef(node);
      }
    };

    _this._onChange = function (event) {
      if (!_this._controlled) {
        _this._resizeComponent();
      }

      _this.props.onChange(event);
    };

    _this._resizeComponent = function (callback) {
      if (callback === void 0) {
        callback = noop;
      }

      if (typeof _this._rootDOMNode === 'undefined') {
        callback();
        return;
      }

      var nodeHeight = calculateNodeHeight(_this._rootDOMNode, _this._uid, _this.props.useCacheForDOMMeasurements, _this.props.minRows, _this.props.maxRows);

      if (nodeHeight === null) {
        callback();
        return;
      }

      var height = nodeHeight.height,
          minHeight = nodeHeight.minHeight,
          maxHeight = nodeHeight.maxHeight,
          rowCount = nodeHeight.rowCount;
      _this.rowCount = rowCount;

      if (_this.state.height !== height || _this.state.minHeight !== minHeight || _this.state.maxHeight !== maxHeight) {
        _this.setState({
          height: height,
          minHeight: minHeight,
          maxHeight: maxHeight
        }, callback);

        return;
      }

      callback();
    };

    _this.state = {
      height: props.style && props.style.height || 0,
      minHeight: -Infinity,
      maxHeight: Infinity
    };
    _this._uid = uid();
    _this._controlled = typeof props.value === 'string';
    return _this;
  }

  var _proto = TextareaAutosize.prototype;

  _proto.render = function render() {
    var _props = this.props,
        _minRows = _props.minRows,
        _maxRows = _props.maxRows,
        _onHeightChange = _props.onHeightChange,
        _useCacheForDOMMeasurements = _props.useCacheForDOMMeasurements,
        _inputRef = _props.inputRef,
        props = _objectWithoutProperties(_props, ["minRows", "maxRows", "onHeightChange", "useCacheForDOMMeasurements", "inputRef"]);
    props.style = _extends({}, props.style, {
      height: this.state.height
    });
    var maxHeight = Math.max(props.style.maxHeight || Infinity, this.state.maxHeight);

    if (maxHeight < this.state.height) {
      props.style.overflow = 'hidden';
    }

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("textarea", _extends({}, props, {
      onChange: this._onChange,
      ref: this._onRootDOMNode
    }));
  };

  _proto.componentDidMount = function componentDidMount() {
    var _this2 = this;

    this._resizeComponent(); // Working around Firefox bug which runs resize listeners even when other JS is running at the same moment
    // causing competing rerenders (due to setState in the listener) in React.
    // More can be found here - facebook/react#6324


    this._resizeListener = function () {
      if (_this2._resizeLock) {
        return;
      }

      _this2._resizeLock = true;

      _this2._resizeComponent(function () {
        return _this2._resizeLock = false;
      });
    };

    window.addEventListener('resize', this._resizeListener);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps() {
    var _this3 = this;

    this._clearNextFrame();

    this._onNextFrameActionId = onNextFrame(function () {
      return _this3._resizeComponent();
    });
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    if (this.state.height !== prevState.height) {
      this.props.onHeightChange(this.state.height, this);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this._clearNextFrame();

    window.removeEventListener('resize', this._resizeListener);
    purgeCache(this._uid);
  };

  _proto._clearNextFrame = function _clearNextFrame() {
    clearNextFrameAction(this._onNextFrameActionId);
  };

  return TextareaAutosize;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

TextareaAutosize.propTypes = {
  value: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  onChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  onHeightChange: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  useCacheForDOMMeasurements: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  minRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  maxRows: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,
  inputRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
};
TextareaAutosize.defaultProps = {
  onChange: noop,
  onHeightChange: noop,
  useCacheForDOMMeasurements: false
};

/* harmony default export */ __webpack_exports__["default"] = (TextareaAutosize);


/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);








/**
 * This HOC decorates a virtualized component and responds to arrow-key events by scrolling one row or column at a time.
 */

var ArrowKeyStepper = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ArrowKeyStepper, _Component);

  function ArrowKeyStepper(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ArrowKeyStepper);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ArrowKeyStepper.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ArrowKeyStepper)).call(this, props, context));

    _this.state = {
      scrollToColumn: props.scrollToColumn,
      scrollToRow: props.scrollToRow
    };

    _this._columnStartIndex = 0;
    _this._columnStopIndex = 0;
    _this._rowStartIndex = 0;
    _this._rowStopIndex = 0;

    _this._onKeyDown = _this._onKeyDown.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ArrowKeyStepper, [{
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var scrollToColumn = nextProps.scrollToColumn;
      var scrollToRow = nextProps.scrollToRow;


      if (this.props.scrollToColumn !== scrollToColumn) {
        this.setState({ scrollToColumn: scrollToColumn });
      }

      if (this.props.scrollToRow !== scrollToRow) {
        this.setState({ scrollToRow: scrollToRow });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var className = _props.className;
      var children = _props.children;
      var _state = this.state;
      var scrollToColumn = _state.scrollToColumn;
      var scrollToRow = _state.scrollToRow;


      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          className: className,
          onKeyDown: this._onKeyDown
        },
        children({
          onSectionRendered: this._onSectionRendered,
          scrollToColumn: scrollToColumn,
          scrollToRow: scrollToRow
        })
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_onKeyDown',
    value: function _onKeyDown(event) {
      var _props2 = this.props;
      var columnCount = _props2.columnCount;
      var disabled = _props2.disabled;
      var mode = _props2.mode;
      var rowCount = _props2.rowCount;


      if (disabled) {
        return;
      }

      var _state2 = this.state;
      var scrollToColumnPrevious = _state2.scrollToColumn;
      var scrollToRowPrevious = _state2.scrollToRow;
      var _state3 = this.state;
      var scrollToColumn = _state3.scrollToColumn;
      var scrollToRow = _state3.scrollToRow;

      // The above cases all prevent default event event behavior.
      // This is to keep the grid from scrolling after the snap-to update.

      switch (event.key) {
        case 'ArrowDown':
          scrollToRow = mode === 'cells' ? Math.min(scrollToRow + 1, rowCount - 1) : Math.min(this._rowStopIndex + 1, rowCount - 1);
          break;
        case 'ArrowLeft':
          scrollToColumn = mode === 'cells' ? Math.max(scrollToColumn - 1, 0) : Math.max(this._columnStartIndex - 1, 0);
          break;
        case 'ArrowRight':
          scrollToColumn = mode === 'cells' ? Math.min(scrollToColumn + 1, columnCount - 1) : Math.min(this._columnStopIndex + 1, columnCount - 1);
          break;
        case 'ArrowUp':
          scrollToRow = mode === 'cells' ? Math.max(scrollToRow - 1, 0) : Math.max(this._rowStartIndex - 1, 0);
          break;
      }

      if (scrollToColumn !== scrollToColumnPrevious || scrollToRow !== scrollToRowPrevious) {
        event.preventDefault();

        this.setState({ scrollToColumn: scrollToColumn, scrollToRow: scrollToRow });
      }
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref) {
      var columnStartIndex = _ref.columnStartIndex;
      var columnStopIndex = _ref.columnStopIndex;
      var rowStartIndex = _ref.rowStartIndex;
      var rowStopIndex = _ref.rowStopIndex;

      this._columnStartIndex = columnStartIndex;
      this._columnStopIndex = columnStopIndex;
      this._rowStartIndex = rowStartIndex;
      this._rowStopIndex = rowStopIndex;
    }
  }]);

  return ArrowKeyStepper;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

ArrowKeyStepper.defaultProps = {
  disabled: false,
  mode: 'edges',
  scrollToColumn: 0,
  scrollToRow: 0
};
/* harmony default export */ __webpack_exports__["a"] = (ArrowKeyStepper);
 false ? ArrowKeyStepper.propTypes = {
  children: PropTypes.func.isRequired,
  className: PropTypes.string,
  columnCount: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
  mode: PropTypes.oneOf(['cells', 'edges']),
  rowCount: PropTypes.number.isRequired,
  scrollToColumn: PropTypes.number.isRequired,
  scrollToRow: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__ = __webpack_require__(2432);









/**
 * Decorator component that automatically adjusts the width and height of a single child.
 * Child component should not be declared as a child but should rather be specified by a `ChildComponent` property.
 * All other properties will be passed through to the child component.
 */

var AutoSizer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(AutoSizer, _Component);

  function AutoSizer(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, AutoSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AutoSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AutoSizer)).call(this, props));

    _this.state = {
      height: 0,
      width: 0
    };

    _this._onResize = _this._onResize.bind(_this);
    _this._setRef = _this._setRef.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(AutoSizer, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // Delay access of parentNode until mount.
      // This handles edge-cases where the component has already been unmounted before its ref has been set,
      // As well as libraries like react-lite which have a slightly different lifecycle.
      this._parentNode = this._autoSizer.parentNode;

      // Defer requiring resize handler in order to support server-side rendering.
      // See issue #41
      this._detectElementResize = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__vendor_detectElementResize__["a" /* default */])();
      this._detectElementResize.addResizeListener(this._parentNode, this._onResize);

      this._onResize();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._detectElementResize) {
        this._detectElementResize.removeResizeListener(this._parentNode, this._onResize);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props;
      var children = _props.children;
      var disableHeight = _props.disableHeight;
      var disableWidth = _props.disableWidth;
      var _state = this.state;
      var height = _state.height;
      var width = _state.width;

      // Outer div should not force width/height since that may prevent containers from shrinking.
      // Inner component should overflow and use calculated width/height.
      // See issue #68 for more information.

      var outerStyle = { overflow: 'visible' };

      if (!disableHeight) {
        outerStyle.height = 0;
      }

      if (!disableWidth) {
        outerStyle.width = 0;
      }

      return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(
        'div',
        {
          ref: this._setRef,
          style: outerStyle
        },
        children({ height: height, width: width })
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_onResize',
    value: function _onResize() {
      var onResize = this.props.onResize;

      // Gaurd against AutoSizer component being removed from the DOM immediately after being added.
      // This can result in invalid style values which can result in NaN values if we don't handle them.
      // See issue #150 for more context.

      var boundingRect = this._parentNode.getBoundingClientRect();
      var height = boundingRect.height || 0;
      var width = boundingRect.width || 0;

      var style = window.getComputedStyle(this._parentNode) || {};
      var paddingLeft = parseInt(style.paddingLeft, 10) || 0;
      var paddingRight = parseInt(style.paddingRight, 10) || 0;
      var paddingTop = parseInt(style.paddingTop, 10) || 0;
      var paddingBottom = parseInt(style.paddingBottom, 10) || 0;

      this.setState({
        height: height - paddingTop - paddingBottom,
        width: width - paddingLeft - paddingRight
      });

      onResize({ height: height, width: width });
    }
  }, {
    key: '_setRef',
    value: function _setRef(autoSizer) {
      this._autoSizer = autoSizer;
    }
  }]);

  return AutoSizer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

AutoSizer.defaultProps = {
  onResize: function onResize() {}
};
/* harmony default export */ __webpack_exports__["a"] = (AutoSizer);
 false ? AutoSizer.propTypes = {
  /**
  * Function responsible for rendering children.
  * This function should implement the following signature:
  * ({ height, width }) => PropTypes.element
  */
  children: PropTypes.func.isRequired,

  /** Disable dynamic :height property */
  disableHeight: PropTypes.bool,

  /** Disable dynamic :width property */
  disableWidth: PropTypes.bool,

  /** Callback to be invoked on-resize: ({ height, width }) */
  onResize: PropTypes.func.isRequired
} : void 0;

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__defaultCellSizeCache__ = __webpack_require__(568);










/**
 * Measures a Grid cell's contents by rendering them in a way that is not visible to the user.
 * Either a fixed width or height may be provided if it is desirable to measure only in one direction.
 */

var CellMeasurer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CellMeasurer, _Component);

  function CellMeasurer(props, state) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CellMeasurer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CellMeasurer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CellMeasurer)).call(this, props, state));

    _this._cellSizeCache = props.cellSizeCache || new __WEBPACK_IMPORTED_MODULE_8__defaultCellSizeCache__["a" /* default */]();

    _this.getColumnWidth = _this.getColumnWidth.bind(_this);
    _this.getRowHeight = _this.getRowHeight.bind(_this);
    _this.resetMeasurements = _this.resetMeasurements.bind(_this);
    _this.resetMeasurementForColumn = _this.resetMeasurementForColumn.bind(_this);
    _this.resetMeasurementForRow = _this.resetMeasurementForRow.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CellMeasurer, [{
    key: 'getColumnWidth',
    value: function getColumnWidth(_ref) {
      var index = _ref.index;

      var columnWidth = this._cellSizeCache.getColumnWidth(index);
      if (columnWidth != null) {
        return columnWidth;
      }

      var rowCount = this.props.rowCount;


      var maxWidth = 0;

      for (var rowIndex = 0; rowIndex < rowCount; rowIndex++) {
        var _measureCell2 = this._measureCell({
          clientWidth: true,
          columnIndex: index,
          rowIndex: rowIndex
        });

        var width = _measureCell2.width;


        maxWidth = Math.max(maxWidth, width);
      }

      this._cellSizeCache.setColumnWidth(index, maxWidth);

      return maxWidth;
    }
  }, {
    key: 'getRowHeight',
    value: function getRowHeight(_ref2) {
      var index = _ref2.index;

      var rowHeight = this._cellSizeCache.getRowHeight(index);
      if (rowHeight != null) {
        return rowHeight;
      }

      var columnCount = this.props.columnCount;


      var maxHeight = 0;

      for (var columnIndex = 0; columnIndex < columnCount; columnIndex++) {
        var _measureCell3 = this._measureCell({
          clientHeight: true,
          columnIndex: columnIndex,
          rowIndex: index
        });

        var height = _measureCell3.height;


        maxHeight = Math.max(maxHeight, height);
      }

      this._cellSizeCache.setRowHeight(index, maxHeight);

      return maxHeight;
    }
  }, {
    key: 'resetMeasurementForColumn',
    value: function resetMeasurementForColumn(columnIndex) {
      this._cellSizeCache.clearColumnWidth(columnIndex);
    }
  }, {
    key: 'resetMeasurementForRow',
    value: function resetMeasurementForRow(rowIndex) {
      this._cellSizeCache.clearRowHeight(rowIndex);
    }
  }, {
    key: 'resetMeasurements',
    value: function resetMeasurements() {
      this._cellSizeCache.clearAllColumnWidths();
      this._cellSizeCache.clearAllRowHeights();
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._renderAndMount();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var cellSizeCache = this.props.cellSizeCache;


      if (cellSizeCache !== nextProps.cellSizeCache) {
        this._cellSizeCache = nextProps.cellSizeCache;
      }

      this._updateDivDimensions(nextProps);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this._unmountContainer();
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        getColumnWidth: this.getColumnWidth,
        getRowHeight: this.getRowHeight,
        resetMeasurements: this.resetMeasurements,
        resetMeasurementForColumn: this.resetMeasurementForColumn,
        resetMeasurementForRow: this.resetMeasurementForRow
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_getContainerNode',
    value: function _getContainerNode(props) {
      var container = props.container;


      if (container) {
        return __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.findDOMNode(typeof container === 'function' ? container() : container);
      } else {
        return document.body;
      }
    }
  }, {
    key: '_measureCell',
    value: function _measureCell(_ref3) {
      var _ref3$clientHeight = _ref3.clientHeight;
      var clientHeight = _ref3$clientHeight === undefined ? false : _ref3$clientHeight;
      var _ref3$clientWidth = _ref3.clientWidth;
      var clientWidth = _ref3$clientWidth === undefined ? true : _ref3$clientWidth;
      var columnIndex = _ref3.columnIndex;
      var rowIndex = _ref3.rowIndex;
      var cellRenderer = this.props.cellRenderer;


      var rendered = cellRenderer({
        columnIndex: columnIndex,
        index: rowIndex, // Simplify List :rowRenderer use case
        rowIndex: rowIndex
      });

      // Handle edge case where this method is called before the CellMeasurer has completed its initial render (and mounted).
      this._renderAndMount();

      // @TODO Keep an eye on this for future React updates as the interface may change:
      // https://twitter.com/soprano/status/737316379712331776
      __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.unstable_renderSubtreeIntoContainer(this, rendered, this._div);

      var measurements = {
        height: clientHeight && this._div.clientHeight,
        width: clientWidth && this._div.clientWidth
      };

      __WEBPACK_IMPORTED_MODULE_7_react_dom___default.a.unmountComponentAtNode(this._div);

      return measurements;
    }
  }, {
    key: '_renderAndMount',
    value: function _renderAndMount() {
      if (!this._div) {
        this._div = document.createElement('div');
        this._div.style.display = 'inline-block';
        this._div.style.position = 'absolute';
        this._div.style.visibility = 'hidden';
        this._div.style.zIndex = -1;

        this._updateDivDimensions(this.props);

        this._containerNode = this._getContainerNode(this.props);
        this._containerNode.appendChild(this._div);
      }
    }
  }, {
    key: '_unmountContainer',
    value: function _unmountContainer() {
      if (this._div) {
        this._containerNode.removeChild(this._div);

        this._div = null;
      }

      this._containerNode = null;
    }
  }, {
    key: '_updateDivDimensions',
    value: function _updateDivDimensions(props) {
      var height = props.height;
      var width = props.width;


      if (height && height !== this._divHeight) {
        this._divHeight = height;
        this._div.style.height = height + 'px';
      }

      if (width && width !== this._divWidth) {
        this._divWidth = width;
        this._div.style.width = width + 'px';
      }
    }
  }]);

  return CellMeasurer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (CellMeasurer);
 false ? CellMeasurer.propTypes = {
  /**
   * Renders a cell given its indices.
   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Optional, custom caching strategy for cell sizes.
   */
  cellSizeCache: PropTypes.object,

  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ getColumnWidth, getRowHeight, resetMeasurements }) => PropTypes.element
   */
  children: PropTypes.func.isRequired,

  /**
   * Number of columns in grid.
   */
  columnCount: PropTypes.number.isRequired,

  /**
   * A Node, Component instance, or function that returns either.
   * If this property is not specified the document body will be used.
   */
  container: React.PropTypes.oneOfType([React.PropTypes.func, React.PropTypes.node]),

  /**
   * Assign a fixed :height in order to measure dynamic text :width only.
   */
  height: PropTypes.number,

  /**
   * Number of rows in grid.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Assign a fixed :width in order to measure dynamic text :height only.
   */
  width: PropTypes.number
} : void 0;

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__CollectionView__ = __webpack_require__(2412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionData__ = __webpack_require__(2416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_getUpdatedOffsetForIndex__ = __webpack_require__(2431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare__);













/**
 * Renders scattered or non-linear data.
 * Unlike Grid, which renders checkerboard data, Collection can render arbitrarily positioned- even overlapping- data.
 */
var Collection = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Collection, _Component);

  function Collection(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Collection);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Collection.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Collection)).call(this, props, context));

    _this._cellMetadata = [];
    _this._lastRenderedCellIndices = [];

    // Cell cache during scroll (for perforamnce)
    _this._cellCache = [];

    _this._isScrollingChange = _this._isScrollingChange.bind(_this);
    return _this;
  }

  /** See Collection#recomputeCellSizesAndPositions */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Collection, [{
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this._cellCache = [];
      this._collectionView.recomputeCellSizesAndPositions();
    }

    /** React lifecycle methods */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var props = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(this.props, []);

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__CollectionView__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        cellLayoutManager: this,
        isScrollingChange: this._isScrollingChange,
        ref: function ref(_ref) {
          _this2._collectionView = _ref;
        }
      }, props));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }

    /** CellLayoutManager interface */

  }, {
    key: 'calculateSizeAndPositionData',
    value: function calculateSizeAndPositionData() {
      var _props = this.props;
      var cellCount = _props.cellCount;
      var cellSizeAndPositionGetter = _props.cellSizeAndPositionGetter;
      var sectionSize = _props.sectionSize;


      var data = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_calculateSizeAndPositionData__["a" /* default */])({
        cellCount: cellCount,
        cellSizeAndPositionGetter: cellSizeAndPositionGetter,
        sectionSize: sectionSize
      });

      this._cellMetadata = data.cellMetadata;
      this._sectionManager = data.sectionManager;
      this._height = data.height;
      this._width = data.width;
    }

    /**
     * Returns the most recently rendered set of cell indices.
     */

  }, {
    key: 'getLastRenderedIndices',
    value: function getLastRenderedIndices() {
      return this._lastRenderedCellIndices;
    }

    /**
     * Calculates the minimum amount of change from the current scroll position to ensure the specified cell is (fully) visible.
     */

  }, {
    key: 'getScrollPositionForCell',
    value: function getScrollPositionForCell(_ref2) {
      var align = _ref2.align;
      var cellIndex = _ref2.cellIndex;
      var height = _ref2.height;
      var scrollLeft = _ref2.scrollLeft;
      var scrollTop = _ref2.scrollTop;
      var width = _ref2.width;
      var cellCount = this.props.cellCount;


      if (cellIndex >= 0 && cellIndex < cellCount) {
        var cellMetadata = this._cellMetadata[cellIndex];

        scrollLeft = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.x,
          cellSize: cellMetadata.width,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: cellIndex
        });

        scrollTop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_getUpdatedOffsetForIndex__["a" /* default */])({
          align: align,
          cellOffset: cellMetadata.y,
          cellSize: cellMetadata.height,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: cellIndex
        });
      }

      return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      };
    }
  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return {
        height: this._height,
        width: this._width
      };
    }
  }, {
    key: 'cellRenderers',
    value: function cellRenderers(_ref3) {
      var _this3 = this;

      var height = _ref3.height;
      var isScrolling = _ref3.isScrolling;
      var width = _ref3.width;
      var x = _ref3.x;
      var y = _ref3.y;
      var _props2 = this.props;
      var cellGroupRenderer = _props2.cellGroupRenderer;
      var cellRenderer = _props2.cellRenderer;

      // Store for later calls to getLastRenderedIndices()

      this._lastRenderedCellIndices = this._sectionManager.getCellIndices({
        height: height,
        width: width,
        x: x,
        y: y
      });

      return cellGroupRenderer({
        cellCache: this._cellCache,
        cellRenderer: cellRenderer,
        cellSizeAndPositionGetter: function cellSizeAndPositionGetter(_ref4) {
          var index = _ref4.index;
          return _this3._sectionManager.getCellMetadata({ index: index });
        },
        indices: this._lastRenderedCellIndices,
        isScrolling: isScrolling
      });
    }
  }, {
    key: '_isScrollingChange',
    value: function _isScrollingChange(isScrolling) {
      if (!isScrolling) {
        this._cellCache = [];
      }
    }
  }]);

  return Collection;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Collection.defaultProps = {
  'aria-label': 'grid',
  cellGroupRenderer: defaultCellGroupRenderer
};
/* harmony default export */ __webpack_exports__["a"] = (Collection);
 false ? Collection.propTypes = {
  'aria-label': PropTypes.string,

  /**
   * Number of cells in Collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a group of cells given their indices.
   * Should implement the following interface: ({
   *   cellSizeAndPositionGetter:Function,
   *   indices: Array<number>,
   *   cellRenderer: Function
   * }): Array<PropTypes.node>
   */
  cellGroupRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ index: number, key: string, style: object }): PropTypes.element
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Callback responsible for returning size and offset/position information for a given cell (index).
   * ({ index: number }): { height: number, width: number, x: number, y: number }
   */
  cellSizeAndPositionGetter: PropTypes.func.isRequired,

  /**
   * Optionally override the size of the sections a Collection's cells are split into.
   */
  sectionSize: PropTypes.number
} : void 0;


function defaultCellGroupRenderer(_ref5) {
  var cellCache = _ref5.cellCache;
  var cellRenderer = _ref5.cellRenderer;
  var cellSizeAndPositionGetter = _ref5.cellSizeAndPositionGetter;
  var indices = _ref5.indices;
  var isScrolling = _ref5.isScrolling;

  return indices.map(function (index) {
    var cellMetadata = cellSizeAndPositionGetter({ index: index });

    var cellRendererProps = {
      index: index,
      isScrolling: isScrolling,
      key: index,
      style: {
        height: cellMetadata.height,
        left: cellMetadata.x,
        position: 'absolute',
        top: cellMetadata.y,
        width: cellMetadata.width
      }
    };

    // Avoid re-creating cells while scrolling.
    // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
    // If a scroll is in progress- cache and reuse cells.
    // This cache will be thrown away once scrolling complets.
    if (isScrolling) {
      if (!(index in cellCache)) {
        cellCache[index] = cellRenderer(cellRendererProps);
      }

      return cellCache[index];
    } else {
      return cellRenderer(cellRendererProps);
    }
  }).filter(function (renderedCell) {
    return !!renderedCell;
  });
}

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);








/**
 * High-order component that auto-calculates column-widths for `Grid` cells.
 */

var ColumnSizer = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ColumnSizer, _Component);

  function ColumnSizer(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ColumnSizer);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ColumnSizer.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ColumnSizer)).call(this, props, context));

    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ColumnSizer, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props = this.props;
      var columnMaxWidth = _props.columnMaxWidth;
      var columnMinWidth = _props.columnMinWidth;
      var columnCount = _props.columnCount;
      var width = _props.width;


      if (columnMaxWidth !== prevProps.columnMaxWidth || columnMinWidth !== prevProps.columnMinWidth || columnCount !== prevProps.columnCount || width !== prevProps.width) {
        if (this._registeredChild) {
          this._registeredChild.recomputeGridSize();
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props;
      var children = _props2.children;
      var columnMaxWidth = _props2.columnMaxWidth;
      var columnMinWidth = _props2.columnMinWidth;
      var columnCount = _props2.columnCount;
      var width = _props2.width;


      var safeColumnMinWidth = columnMinWidth || 1;

      var safeColumnMaxWidth = columnMaxWidth ? Math.min(columnMaxWidth, width) : width;

      var columnWidth = width / columnCount;
      columnWidth = Math.max(safeColumnMinWidth, columnWidth);
      columnWidth = Math.min(safeColumnMaxWidth, columnWidth);
      columnWidth = Math.floor(columnWidth);

      var adjustedWidth = Math.min(width, columnWidth * columnCount);

      return children({
        adjustedWidth: adjustedWidth,
        getColumnWidth: function getColumnWidth() {
          return columnWidth;
        },
        registerChild: this._registerChild
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(child) {
      if (child && typeof child.recomputeGridSize !== 'function') {
        throw Error('Unexpected child type registered; only Grid/MultiGrid children are supported.');
      }

      this._registeredChild = child;

      if (this._registeredChild) {
        this._registeredChild.recomputeGridSize();
      }
    }
  }]);

  return ColumnSizer;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ColumnSizer);
 false ? ColumnSizer.propTypes = {
  /**
   * Function responsible for rendering a virtualized Grid.
   * This function should implement the following signature:
   * ({ adjustedWidth, getColumnWidth, registerChild }) => PropTypes.element
   *
   * The specified :getColumnWidth function should be passed to the Grid's :columnWidth property.
   * The :registerChild should be passed to the Grid's :ref property.
   * The :adjustedWidth property is optional; it reflects the lesser of the overall width or the width of all columns.
   */
  children: PropTypes.func.isRequired,

  /** Optional maximum allowed column width */
  columnMaxWidth: PropTypes.number,

  /** Optional minimum allowed column width */
  columnMinWidth: PropTypes.number,

  /** Number of columns in Grid or Table child */
  columnCount: PropTypes.number.isRequired,

  /** Width of Grid or Table child */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_SCROLLING_RESET_TIME_INTERVAL */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__ = __webpack_require__(2420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__ = __webpack_require__(2419);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__ = __webpack_require__(2421);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_dom_helpers_util_scrollbarSize__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils_updateScrollIndexHelper__ = __webpack_require__(2422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__defaultCellRangeRenderer__ = __webpack_require__(959);

















/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var DEFAULT_SCROLLING_RESET_TIME_INTERVAL = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Renders tabular data with virtualization along the vertical and horizontal axes.
 * Row heights and column widths must be known ahead of time and specified as properties.
 */

var Grid = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Grid, _Component);

  function Grid(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Grid);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Grid.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Grid)).call(this, props, context));

    _this.state = {
      isScrolling: false,
      scrollDirectionHorizontal: __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */],
      scrollDirectionVertical: __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */],
      scrollLeft: 0,
      scrollTop: 0
    };

    // Invokes onSectionRendered callback only when start/stop row or column indices change
    _this._onGridRenderedMemoizer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils_createCallbackMemoizer__["a" /* default */])(false);

    // Bind functions to instance so they don't lose context when passed around
    _this._debounceScrollEndedCallback = _this._debounceScrollEndedCallback.bind(_this);
    _this._invokeOnGridRenderedHelper = _this._invokeOnGridRenderedHelper.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._updateScrollLeftForScrollToColumn = _this._updateScrollLeftForScrollToColumn.bind(_this);
    _this._updateScrollTopForScrollToRow = _this._updateScrollTopForScrollToRow.bind(_this);

    _this._columnWidthGetter = _this._wrapSizeGetter(props.columnWidth);
    _this._rowHeightGetter = _this._wrapSizeGetter(props.rowHeight);

    _this._columnSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.columnCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._columnWidthGetter(params);
      },
      estimatedCellSize: _this._getEstimatedColumnSize(props)
    });
    _this._rowSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_9__utils_ScalingCellSizeAndPositionManager__["a" /* default */]({
      cellCount: props.rowCount,
      cellSizeGetter: function cellSizeGetter(params) {
        return _this._rowHeightGetter(params);
      },
      estimatedCellSize: _this._getEstimatedRowSize(props)
    });

    // See defaultCellRangeRenderer() for more information on the usage of these caches
    _this._cellCache = {};
    _this._styleCache = {};
    return _this;
  }

  /**
   * Pre-measure all columns and rows in a Grid.
   * Typically cells are only measured as needed and estimated sizes are used for cells that have not yet been measured.
   * This method ensures that the next call to getTotalSize() returns an exact size (as opposed to just an estimated one).
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Grid, [{
    key: 'measureAllCells',
    value: function measureAllCells() {
      var _props = this.props;
      var columnCount = _props.columnCount;
      var rowCount = _props.rowCount;


      this._columnSizeAndPositionManager.getSizeAndPositionOfCell(columnCount - 1);
      this._rowSizeAndPositionManager.getSizeAndPositionOfCell(rowCount - 1);
    }

    /**
     * Forced recompute of row heights and column widths.
     * This function should be called if dynamic column or row sizes have changed but nothing else has.
     * Since Grid only receives :columnCount and :rowCount it has no way of detecting when the underlying data changes.
     */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref$columnIndex = _ref.columnIndex;
      var columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex;
      var _ref$rowIndex = _ref.rowIndex;
      var rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;

      this._columnSizeAndPositionManager.resetCell(columnIndex);
      this._rowSizeAndPositionManager.resetCell(rowIndex);

      // Clear cell cache in case we are scrolling;
      // Invalid row heights likely mean invalid cached content as well.
      this._cellCache = {};
      this._styleCache = {};

      this.forceUpdate();
    }

    /**
     * Ensure column and row are visible.
     */

  }, {
    key: 'scrollToCell',
    value: function scrollToCell(_ref2) {
      var columnIndex = _ref2.columnIndex;
      var rowIndex = _ref2.rowIndex;

      var props = this.props;
      this._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        scrollToColumn: columnIndex
      }));
      this._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        scrollToRow: rowIndex
      }));
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props2 = this.props;
      var scrollLeft = _props2.scrollLeft;
      var scrollToColumn = _props2.scrollToColumn;
      var scrollTop = _props2.scrollTop;
      var scrollToRow = _props2.scrollToRow;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_12_dom_helpers_util_scrollbarSize___default()();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      if (scrollToColumn >= 0 || scrollToRow >= 0) {
        this._updateScrollLeftForScrollToColumn();
        this._updateScrollTopForScrollToRow();
      }

      // Update onRowsRendered callback
      this._invokeOnGridRenderedHelper();

      // Initialize onScroll callback
      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalColumnsWidth: this._columnSizeAndPositionManager.getTotalSize(),
        totalRowsHeight: this._rowSizeAndPositionManager.getTotalSize()
      });
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) New scroll-to-cell props have been set
     */

  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _this2 = this;

      var _props3 = this.props;
      var autoHeight = _props3.autoHeight;
      var columnCount = _props3.columnCount;
      var height = _props3.height;
      var rowCount = _props3.rowCount;
      var scrollToAlignment = _props3.scrollToAlignment;
      var scrollToColumn = _props3.scrollToColumn;
      var scrollToRow = _props3.scrollToRow;
      var width = _props3.width;
      var _state = this.state;
      var scrollLeft = _state.scrollLeft;
      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
      var scrollTop = _state.scrollTop;

      // Handle edge case where column or row count has only just increased over 0.
      // In this case we may have to restore a previously-specified scroll offset.
      // For more info see bvaughn/react-virtualized/issues/218

      var columnOrRowCountJustIncreasedFromZero = columnCount > 0 && prevProps.columnCount === 0 || rowCount > 0 && prevProps.rowCount === 0;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.
      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && (scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }

        // @TRICKY :autoHeight property instructs Grid to leave :scrollTop management to an external HOC (eg WindowScroller).
        // In this case we should avoid checking scrollingContainer.scrollTop since it forces layout/flow.
        if (!autoHeight && scrollTop >= 0 && (scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop || columnOrRowCountJustIncreasedFromZero)) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToColumn or :scrollToRow values requires it
      // @TODO Do we also need this check or can the one in componentWillUpdate() suffice?
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_updateScrollIndexHelper__["a" /* default */])({
        cellSizeAndPositionManager: this._columnSizeAndPositionManager,
        previousCellsCount: prevProps.columnCount,
        previousCellSize: prevProps.columnWidth,
        previousScrollToAlignment: prevProps.scrollToAlignment,
        previousScrollToIndex: prevProps.scrollToColumn,
        previousSize: prevProps.width,
        scrollOffset: scrollLeft,
        scrollToAlignment: scrollToAlignment,
        scrollToIndex: scrollToColumn,
        size: width,
        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToColumn) {
          return _this2._updateScrollLeftForScrollToColumn(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.props, { scrollToColumn: scrollToColumn }));
        }
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils_updateScrollIndexHelper__["a" /* default */])({
        cellSizeAndPositionManager: this._rowSizeAndPositionManager,
        previousCellsCount: prevProps.rowCount,
        previousCellSize: prevProps.rowHeight,
        previousScrollToAlignment: prevProps.scrollToAlignment,
        previousScrollToIndex: prevProps.scrollToRow,
        previousSize: prevProps.height,
        scrollOffset: scrollTop,
        scrollToAlignment: scrollToAlignment,
        scrollToIndex: scrollToRow,
        size: height,
        updateScrollIndexCallback: function updateScrollIndexCallback(scrollToRow) {
          return _this2._updateScrollTopForScrollToRow(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, _this2.props, { scrollToRow: scrollToRow }));
        }
      });

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnGridRenderedHelper();

      // Changes to :scrollLeft or :scrollTop should also notify :onScroll listeners
      if (scrollLeft !== prevState.scrollLeft || scrollTop !== prevState.scrollTop) {
        var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
        var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();

        this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
      }
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
      // We handle this case in componentDidMount()
      this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_12_dom_helpers_util_scrollbarSize___default()();
      if (this._scrollbarSize === undefined) {
        this._scrollbarSizeMeasured = false;
        this._scrollbarSize = 0;
      } else {
        this._scrollbarSizeMeasured = true;
      }

      this._calculateChildrenToRender();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      var _this3 = this;

      if (nextProps.columnCount === 0 && nextState.scrollLeft !== 0 || nextProps.rowCount === 0 && nextState.scrollTop !== 0) {
        this._setScrollPosition({
          scrollLeft: 0,
          scrollTop: 0
        });
      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
        var newState = {};

        if (nextProps.scrollLeft != null) {
          newState.scrollLeft = nextProps.scrollLeft;
        }
        if (nextProps.scrollTop != null) {
          newState.scrollTop = nextProps.scrollTop;
        }

        this._setScrollPosition(newState);
      }

      if (nextProps.columnWidth !== this.props.columnWidth || nextProps.rowHeight !== this.props.rowHeight) {
        this._styleCache = {};
      }

      this._columnWidthGetter = this._wrapSizeGetter(nextProps.columnWidth);
      this._rowHeightGetter = this._wrapSizeGetter(nextProps.rowHeight);

      this._columnSizeAndPositionManager.configure({
        cellCount: nextProps.columnCount,
        estimatedCellSize: this._getEstimatedColumnSize(nextProps)
      });
      this._rowSizeAndPositionManager.configure({
        cellCount: nextProps.rowCount,
        estimatedCellSize: this._getEstimatedRowSize(nextProps)
      });

      // Update scroll offsets if the size or number of cells have changed, invalidating the previous value
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: this.props.columnCount,
        cellSize: this.props.columnWidth,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._columnSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.columnCount,
        nextCellSize: nextProps.columnWidth,
        nextScrollToIndex: nextProps.scrollToColumn,
        scrollToIndex: this.props.scrollToColumn,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollLeftForScrollToColumn(nextProps, nextState);
        }
      });
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_calculateSizeAndPositionDataAndUpdateScrollOffset__["a" /* default */])({
        cellCount: this.props.rowCount,
        cellSize: this.props.rowHeight,
        computeMetadataCallback: function computeMetadataCallback() {
          return _this3._rowSizeAndPositionManager.resetCell(0);
        },
        computeMetadataCallbackProps: nextProps,
        nextCellsCount: nextProps.rowCount,
        nextCellSize: nextProps.rowHeight,
        nextScrollToIndex: nextProps.scrollToRow,
        scrollToIndex: this.props.scrollToRow,
        updateScrollOffsetForScrollToIndex: function updateScrollOffsetForScrollToIndex() {
          return _this3._updateScrollTopForScrollToRow(nextProps, nextState);
        }
      });

      this._calculateChildrenToRender(nextProps, nextState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props4 = this.props;
      var autoContainerWidth = _props4.autoContainerWidth;
      var autoHeight = _props4.autoHeight;
      var className = _props4.className;
      var containerStyle = _props4.containerStyle;
      var height = _props4.height;
      var id = _props4.id;
      var noContentRenderer = _props4.noContentRenderer;
      var style = _props4.style;
      var tabIndex = _props4.tabIndex;
      var width = _props4.width;
      var isScrolling = this.state.isScrolling;


      var gridStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        width: width,
        WebkitOverflowScrolling: 'touch',
        willChange: 'transform'
      };

      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalRowsHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalColumnsWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      gridStyle.overflowX = totalColumnsWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      gridStyle.overflowY = totalRowsHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      var childrenToDisplay = this._childrenToDisplay;

      var showNoContentRenderer = childrenToDisplay.length === 0 && height > 0 && width > 0;

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          ref: function ref(_ref3) {
            _this4._scrollingContainer = _ref3;
          },
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ReactVirtualized__Grid', className),
          id: id,
          onScroll: this._onScroll,
          role: 'grid',
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, style),
          tabIndex: tabIndex
        },
        childrenToDisplay.length > 0 && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          {
            className: 'ReactVirtualized__Grid__innerScrollContainer',
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
              width: autoContainerWidth ? 'auto' : totalColumnsWidth,
              height: totalRowsHeight,
              maxWidth: totalColumnsWidth,
              maxHeight: totalRowsHeight,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : ''
            }, containerStyle)
          },
          childrenToDisplay
        ),
        showNoContentRenderer && noContentRenderer()
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_13_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }

    /* ---------------------------- Helper methods ---------------------------- */

  }, {
    key: '_calculateChildrenToRender',
    value: function _calculateChildrenToRender() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var cellRenderer = props.cellRenderer;
      var cellRangeRenderer = props.cellRangeRenderer;
      var columnCount = props.columnCount;
      var height = props.height;
      var overscanColumnCount = props.overscanColumnCount;
      var overscanRowCount = props.overscanRowCount;
      var rowCount = props.rowCount;
      var width = props.width;
      var isScrolling = state.isScrolling;
      var scrollDirectionHorizontal = state.scrollDirectionHorizontal;
      var scrollDirectionVertical = state.scrollDirectionVertical;
      var scrollLeft = state.scrollLeft;
      var scrollTop = state.scrollTop;


      this._childrenToDisplay = [];

      // Render only enough columns and rows to cover the visible area of the grid.
      if (height > 0 && width > 0) {
        var visibleColumnIndices = this._columnSizeAndPositionManager.getVisibleCellRange({
          containerSize: width,
          offset: scrollLeft
        });
        var visibleRowIndices = this._rowSizeAndPositionManager.getVisibleCellRange({
          containerSize: height,
          offset: scrollTop
        });

        var horizontalOffsetAdjustment = this._columnSizeAndPositionManager.getOffsetAdjustment({
          containerSize: width,
          offset: scrollLeft
        });
        var verticalOffsetAdjustment = this._rowSizeAndPositionManager.getOffsetAdjustment({
          containerSize: height,
          offset: scrollTop
        });

        // Store for _invokeOnGridRenderedHelper()
        this._renderedColumnStartIndex = visibleColumnIndices.start;
        this._renderedColumnStopIndex = visibleColumnIndices.stop;
        this._renderedRowStartIndex = visibleRowIndices.start;
        this._renderedRowStopIndex = visibleRowIndices.stop;

        var overscanColumnIndices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["b" /* default */])({
          cellCount: columnCount,
          overscanCellsCount: overscanColumnCount,
          scrollDirection: scrollDirectionHorizontal,
          startIndex: this._renderedColumnStartIndex,
          stopIndex: this._renderedColumnStopIndex
        });

        var overscanRowIndices = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["b" /* default */])({
          cellCount: rowCount,
          overscanCellsCount: overscanRowCount,
          scrollDirection: scrollDirectionVertical,
          startIndex: this._renderedRowStartIndex,
          stopIndex: this._renderedRowStopIndex
        });

        // Store for _invokeOnGridRenderedHelper()
        this._columnStartIndex = overscanColumnIndices.overscanStartIndex;
        this._columnStopIndex = overscanColumnIndices.overscanStopIndex;
        this._rowStartIndex = overscanRowIndices.overscanStartIndex;
        this._rowStopIndex = overscanRowIndices.overscanStopIndex;

        this._childrenToDisplay = cellRangeRenderer({
          cellCache: this._cellCache,
          cellRenderer: cellRenderer,
          columnSizeAndPositionManager: this._columnSizeAndPositionManager,
          columnStartIndex: this._columnStartIndex,
          columnStopIndex: this._columnStopIndex,
          horizontalOffsetAdjustment: horizontalOffsetAdjustment,
          isScrolling: isScrolling,
          rowSizeAndPositionManager: this._rowSizeAndPositionManager,
          rowStartIndex: this._rowStartIndex,
          rowStopIndex: this._rowStopIndex,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          styleCache: this._styleCache,
          verticalOffsetAdjustment: verticalOffsetAdjustment,
          visibleColumnIndices: visibleColumnIndices,
          visibleRowIndices: visibleRowIndices
        });
      }
    }

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Grid.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_debounceScrollEnded',
    value: function _debounceScrollEnded() {
      var scrollingResetTimeInterval = this.props.scrollingResetTimeInterval;


      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(this._debounceScrollEndedCallback, scrollingResetTimeInterval);
    }
  }, {
    key: '_debounceScrollEndedCallback',
    value: function _debounceScrollEndedCallback() {
      this._disablePointerEventsTimeoutId = null;

      var styleCache = this._styleCache;

      // Reset cell and style caches once scrolling stops.
      // This makes Grid simpler to use (since cells commonly change).
      // And it keeps the caches from growing too large.
      // Performance is most sensitive when a user is scrolling.
      this._cellCache = {};
      this._styleCache = {};

      // Copy over the visible cell styles so avoid unnecessary re-render.
      for (var rowIndex = this._rowStartIndex; rowIndex <= this._rowStopIndex; rowIndex++) {
        for (var columnIndex = this._columnStartIndex; columnIndex <= this._columnStopIndex; columnIndex++) {
          var key = rowIndex + '-' + columnIndex;
          this._styleCache[key] = styleCache[key];
        }
      }

      this.setState({
        isScrolling: false
      });
    }
  }, {
    key: '_getEstimatedColumnSize',
    value: function _getEstimatedColumnSize(props) {
      return typeof props.columnWidth === 'number' ? props.columnWidth : props.estimatedColumnSize;
    }
  }, {
    key: '_getEstimatedRowSize',
    value: function _getEstimatedRowSize(props) {
      return typeof props.rowHeight === 'number' ? props.rowHeight : props.estimatedRowSize;
    }
  }, {
    key: '_invokeOnGridRenderedHelper',
    value: function _invokeOnGridRenderedHelper() {
      var onSectionRendered = this.props.onSectionRendered;


      this._onGridRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          columnOverscanStartIndex: this._columnStartIndex,
          columnOverscanStopIndex: this._columnStopIndex,
          columnStartIndex: this._renderedColumnStartIndex,
          columnStopIndex: this._renderedColumnStopIndex,
          rowOverscanStartIndex: this._rowStartIndex,
          rowOverscanStopIndex: this._rowStopIndex,
          rowStartIndex: this._renderedRowStartIndex,
          rowStopIndex: this._renderedRowStopIndex
        }
      });
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref4) {
      var _this5 = this;

      var scrollLeft = _ref4.scrollLeft;
      var scrollTop = _ref4.scrollTop;
      var totalColumnsWidth = _ref4.totalColumnsWidth;
      var totalRowsHeight = _ref4.totalRowsHeight;

      this._onScrollMemoizer({
        callback: function callback(_ref5) {
          var scrollLeft = _ref5.scrollLeft;
          var scrollTop = _ref5.scrollTop;
          var _props5 = _this5.props;
          var height = _props5.height;
          var onScroll = _props5.onScroll;
          var width = _props5.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalRowsHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalColumnsWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref6) {
      var scrollLeft = _ref6.scrollLeft;
      var scrollTop = _ref6.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["c" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollDirectionVertical = scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["c" /* SCROLL_DIRECTION_BACKWARD */];
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }, {
    key: '_wrapPropertyGetter',
    value: function _wrapPropertyGetter(value) {
      return value instanceof Function ? value : function () {
        return value;
      };
    }
  }, {
    key: '_wrapSizeGetter',
    value: function _wrapSizeGetter(size) {
      return this._wrapPropertyGetter(size);
    }
  }, {
    key: '_updateScrollLeftForScrollToColumn',
    value: function _updateScrollLeftForScrollToColumn() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var columnCount = props.columnCount;
      var scrollToAlignment = props.scrollToAlignment;
      var scrollToColumn = props.scrollToColumn;
      var width = props.width;
      var scrollLeft = state.scrollLeft;


      if (scrollToColumn >= 0 && columnCount > 0) {
        var targetIndex = Math.max(0, Math.min(columnCount - 1, scrollToColumn));

        var calculatedScrollLeft = this._columnSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: width,
          currentOffset: scrollLeft,
          targetIndex: targetIndex
        });

        if (scrollLeft !== calculatedScrollLeft) {
          this._setScrollPosition({
            scrollLeft: calculatedScrollLeft
          });
        }
      }
    }
  }, {
    key: '_updateScrollTopForScrollToRow',
    value: function _updateScrollTopForScrollToRow() {
      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.state;
      var height = props.height;
      var rowCount = props.rowCount;
      var scrollToAlignment = props.scrollToAlignment;
      var scrollToRow = props.scrollToRow;
      var scrollTop = state.scrollTop;


      if (scrollToRow >= 0 && rowCount > 0) {
        var targetIndex = Math.max(0, Math.min(rowCount - 1, scrollToRow));

        var calculatedScrollTop = this._rowSizeAndPositionManager.getUpdatedOffsetForIndex({
          align: scrollToAlignment,
          containerSize: height,
          currentOffset: scrollTop,
          targetIndex: targetIndex
        });

        if (scrollTop !== calculatedScrollTop) {
          this._setScrollPosition({
            scrollTop: calculatedScrollTop
          });
        }
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._debounceScrollEnded();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _props6 = this.props;
      var autoHeight = _props6.autoHeight;
      var height = _props6.height;
      var width = _props6.width;

      var scrollbarSize = this._scrollbarSize;
      var totalRowsHeight = this._rowSizeAndPositionManager.getTotalSize();
      var totalColumnsWidth = this._columnSizeAndPositionManager.getTotalSize();
      var scrollLeft = Math.min(Math.max(0, totalColumnsWidth - width + scrollbarSize), event.target.scrollLeft);
      var scrollTop = Math.min(Math.max(0, totalRowsHeight - height + scrollbarSize), event.target.scrollTop);

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Track scrolling direction so we can more efficiently overscan rows to reduce empty space around the edges while scrolling.
        var scrollDirectionHorizontal = scrollLeft > this.state.scrollLeft ? __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["c" /* SCROLL_DIRECTION_BACKWARD */];
        var scrollDirectionVertical = scrollTop > this.state.scrollTop ? __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["a" /* SCROLL_DIRECTION_FORWARD */] : __WEBPACK_IMPORTED_MODULE_11__utils_getOverscanIndices__["c" /* SCROLL_DIRECTION_BACKWARD */];

        var newState = {
          isScrolling: true,
          scrollDirectionHorizontal: scrollDirectionHorizontal,
          scrollDirectionVertical: scrollDirectionVertical,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.OBSERVED
        };

        if (!autoHeight) {
          newState.scrollTop = scrollTop;
        }

        this.setState(newState);
      }

      this._invokeOnScrollMemoizer({ scrollLeft: scrollLeft, scrollTop: scrollTop, totalColumnsWidth: totalColumnsWidth, totalRowsHeight: totalRowsHeight });
    }
  }]);

  return Grid;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

Grid.defaultProps = {
  'aria-label': 'grid',
  cellRangeRenderer: __WEBPACK_IMPORTED_MODULE_15__defaultCellRangeRenderer__["a" /* default */],
  estimatedColumnSize: 100,
  estimatedRowSize: 30,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  overscanColumnCount: 0,
  overscanRowCount: 10,
  scrollingResetTimeInterval: DEFAULT_SCROLLING_RESET_TIME_INTERVAL,
  scrollToAlignment: 'auto',
  style: {},
  tabIndex: 0
};
/* harmony default export */ __webpack_exports__["a"] = (Grid);
 false ? Grid.propTypes = {
  'aria-label': PropTypes.string,

  /**
   * Set the width of the inner scrollable container to 'auto'.
   * This is useful for single-column Grids to ensure that the column doesn't extend below a vertical scrollbar.
   */
  autoContainerWidth: PropTypes.bool,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Responsible for rendering a cell given an row and column index.
   * Should implement the following interface: ({ columnIndex: number, rowIndex: number }): PropTypes.node
   */
  cellRenderer: PropTypes.func.isRequired,

  /**
   * Responsible for rendering a group of cells given their index ranges.
   * Should implement the following interface: ({
   *   cellCache: Map,
   *   cellRenderer: Function,
   *   columnSizeAndPositionManager: CellSizeAndPositionManager,
   *   columnStartIndex: number,
   *   columnStopIndex: number,
   *   isScrolling: boolean,
   *   rowSizeAndPositionManager: CellSizeAndPositionManager,
   *   rowStartIndex: number,
   *   rowStopIndex: number,
   *   scrollLeft: number,
   *   scrollTop: number
   * }): Array<PropTypes.node>
   */
  cellRangeRenderer: PropTypes.func.isRequired,

  /**
   * Optional custom CSS class name to attach to root Grid element.
   */
  className: PropTypes.string,

  /**
   * Number of columns in grid.
   */
  columnCount: PropTypes.number.isRequired,

  /**
   * Either a fixed column width (number) or a function that returns the width of a column given its index.
   * Should implement the following interface: (index: number): number
   */
  columnWidth: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Optional inline style applied to inner cell-container */
  containerStyle: PropTypes.object,

  /**
   * Used to estimate the total width of a Grid before all of its columns have actually been measured.
   * The estimated total width is adjusted as columns are rendered.
   */
  estimatedColumnSize: PropTypes.number.isRequired,

  /**
   * Used to estimate the total height of a Grid before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /**
   * Height of Grid; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Grid element.
   */
  id: PropTypes.string,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :columnCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Grid that was just rendered.
   * ({ columnStartIndex, columnStopIndex, rowStartIndex, rowStopIndex }): void
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Number of columns to render before/after the visible section of the grid.
   * These columns can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanColumnCount: PropTypes.number.isRequired,

  /**
   * Number of rows to render above/below the visible section of the grid.
   * These rows can help for smoother scrolling on touch devices or browsers that send scroll events infrequently.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * Should implement the following interface: ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /**
   * Number of rows in grid.
   */
  rowCount: PropTypes.number.isRequired,

  /** Wait this amount of time after the last scroll event before resetting Grid `pointer-events`. */
  scrollingResetTimeInterval: PropTypes.number,

  /** Horizontal offset. */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Column index to ensure visible (by forcefully scrolling if necessary)
   */
  scrollToColumn: PropTypes.number,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Row index to ensure visible (by forcefully scrolling if necessary)
   */
  scrollToRow: PropTypes.number,

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /**
   * Width of Grid; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRangeRenderer;

/**
 * Default implementation of cellRangeRenderer used by Grid.
 * This renderer supports cell-caching while the user is scrolling.
 */
function defaultCellRangeRenderer(_ref) {
  var cellCache = _ref.cellCache;
  var cellRenderer = _ref.cellRenderer;
  var columnSizeAndPositionManager = _ref.columnSizeAndPositionManager;
  var columnStartIndex = _ref.columnStartIndex;
  var columnStopIndex = _ref.columnStopIndex;
  var horizontalOffsetAdjustment = _ref.horizontalOffsetAdjustment;
  var isScrolling = _ref.isScrolling;
  var rowSizeAndPositionManager = _ref.rowSizeAndPositionManager;
  var rowStartIndex = _ref.rowStartIndex;
  var rowStopIndex = _ref.rowStopIndex;
  var scrollLeft = _ref.scrollLeft;
  var scrollTop = _ref.scrollTop;
  var styleCache = _ref.styleCache;
  var verticalOffsetAdjustment = _ref.verticalOffsetAdjustment;
  var visibleColumnIndices = _ref.visibleColumnIndices;
  var visibleRowIndices = _ref.visibleRowIndices;

  var renderedCells = [];
  var offsetAdjusted = verticalOffsetAdjustment || horizontalOffsetAdjustment;
  var canCacheStyle = !isScrolling || !offsetAdjusted;

  for (var rowIndex = rowStartIndex; rowIndex <= rowStopIndex; rowIndex++) {
    var rowDatum = rowSizeAndPositionManager.getSizeAndPositionOfCell(rowIndex);

    for (var columnIndex = columnStartIndex; columnIndex <= columnStopIndex; columnIndex++) {
      var columnDatum = columnSizeAndPositionManager.getSizeAndPositionOfCell(columnIndex);
      var isVisible = columnIndex >= visibleColumnIndices.start && columnIndex <= visibleColumnIndices.stop && rowIndex >= visibleRowIndices.start && rowIndex <= visibleRowIndices.stop;
      var key = rowIndex + '-' + columnIndex;
      var style = void 0;

      // Cache style objects so shallow-compare doesn't re-render unnecessarily.
      if (canCacheStyle && styleCache[key]) {
        style = styleCache[key];
      } else {
        style = {
          height: rowDatum.size,
          left: columnDatum.offset + horizontalOffsetAdjustment,
          position: 'absolute',
          top: rowDatum.offset + verticalOffsetAdjustment,
          width: columnDatum.size
        };

        styleCache[key] = style;
      }

      var cellRendererParams = {
        columnIndex: columnIndex,
        isScrolling: isScrolling,
        isVisible: isVisible,
        key: key,
        rowIndex: rowIndex,
        style: style
      };

      var renderedCell = void 0;

      // Avoid re-creating cells while scrolling.
      // This can lead to the same cell being created many times and can cause performance issues for "heavy" cells.
      // If a scroll is in progress- cache and reuse cells.
      // This cache will be thrown away once scrolling completes.
      // However if we are scaling scroll positions and sizes, we should also avoid caching.
      // This is because the offset changes slightly as scroll position changes and caching leads to stale values.
      // For more info refer to issue #395
      if (isScrolling && !horizontalOffsetAdjustment && !verticalOffsetAdjustment) {
        if (!cellCache[key]) {
          cellCache[key] = cellRenderer(cellRendererParams);
        }

        renderedCell = cellCache[key];

        // If the user is no longer scrolling, don't cache cells.
        // This makes dynamic cell content difficult for users and would also lead to a heavier memory footprint.
      } else {
        renderedCell = cellRenderer(cellRendererParams);
      }

      if (renderedCell == null || renderedCell === false) {
        continue;
      }

      renderedCells.push(renderedCell);
    }
  }

  return renderedCells;
}

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isRangeVisible */
/* unused harmony export scanForUnloadedRanges */
/* unused harmony export forceUpdateReactVirtualizedComponent */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__ = __webpack_require__(570);









/**
 * Higher-order component that manages lazy-loading for "infinite" data.
 * This component decorates a virtual component and just-in-time prefetches rows as a user scrolls.
 * It is intended as a convenience component; fork it if you'd like finer-grained control over data-loading.
 */

var InfiniteLoader = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(InfiniteLoader, _Component);

  function InfiniteLoader(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, InfiniteLoader);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (InfiniteLoader.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(InfiniteLoader)).call(this, props, context));

    _this._loadMoreRowsMemoizer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_7__utils_createCallbackMemoizer__["a" /* default */])();

    _this._onRowsRendered = _this._onRowsRendered.bind(_this);
    _this._registerChild = _this._registerChild.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(InfiniteLoader, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return children({
        onRowsRendered: this._onRowsRendered,
        registerChild: this._registerChild
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_loadUnloadedRanges',
    value: function _loadUnloadedRanges(unloadedRanges) {
      var _this2 = this;

      var loadMoreRows = this.props.loadMoreRows;


      unloadedRanges.forEach(function (unloadedRange) {
        var promise = loadMoreRows(unloadedRange);
        if (promise) {
          promise.then(function () {
            // Refresh the visible rows if any of them have just been loaded.
            // Otherwise they will remain in their unloaded visual state.
            if (isRangeVisible({
              lastRenderedStartIndex: _this2._lastRenderedStartIndex,
              lastRenderedStopIndex: _this2._lastRenderedStopIndex,
              startIndex: unloadedRange.startIndex,
              stopIndex: unloadedRange.stopIndex
            })) {
              if (_this2._registeredChild) {
                forceUpdateReactVirtualizedComponent(_this2._registeredChild);
              }
            }
          });
        }
      });
    }
  }, {
    key: '_onRowsRendered',
    value: function _onRowsRendered(_ref) {
      var _this3 = this;

      var startIndex = _ref.startIndex;
      var stopIndex = _ref.stopIndex;
      var _props = this.props;
      var isRowLoaded = _props.isRowLoaded;
      var minimumBatchSize = _props.minimumBatchSize;
      var rowCount = _props.rowCount;
      var threshold = _props.threshold;


      this._lastRenderedStartIndex = startIndex;
      this._lastRenderedStopIndex = stopIndex;

      var unloadedRanges = scanForUnloadedRanges({
        isRowLoaded: isRowLoaded,
        minimumBatchSize: minimumBatchSize,
        rowCount: rowCount,
        startIndex: Math.max(0, startIndex - threshold),
        stopIndex: Math.min(rowCount - 1, stopIndex + threshold)
      });

      // For memoize comparison
      var squashedUnloadedRanges = unloadedRanges.reduce(function (reduced, unloadedRange) {
        return reduced.concat([unloadedRange.startIndex, unloadedRange.stopIndex]);
      }, []);

      this._loadMoreRowsMemoizer({
        callback: function callback() {
          _this3._loadUnloadedRanges(unloadedRanges);
        },
        indices: { squashedUnloadedRanges: squashedUnloadedRanges }
      });
    }
  }, {
    key: '_registerChild',
    value: function _registerChild(registeredChild) {
      this._registeredChild = registeredChild;
    }
  }]);

  return InfiniteLoader;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/**
 * Determines if the specified start/stop range is visible based on the most recently rendered range.
 */


InfiniteLoader.defaultProps = {
  minimumBatchSize: 10,
  rowCount: 0,
  threshold: 15
};
/* harmony default export */ __webpack_exports__["a"] = (InfiniteLoader);
 false ? InfiniteLoader.propTypes = {
  /**
   * Function responsible for rendering a virtualized component.
   * This function should implement the following signature:
   * ({ onRowsRendered, registerChild }) => PropTypes.element
   *
   * The specified :onRowsRendered function should be passed through to the child's :onRowsRendered property.
   * The :registerChild callback should be set as the virtualized component's :ref.
   */
  children: PropTypes.func.isRequired,

  /**
   * Function responsible for tracking the loaded state of each row.
   * It should implement the following signature: ({ index: number }): boolean
   */
  isRowLoaded: PropTypes.func.isRequired,

  /**
   * Callback to be invoked when more rows must be loaded.
   * It should implement the following signature: ({ startIndex, stopIndex }): Promise
   * The returned Promise should be resolved once row data has finished loading.
   * It will be used to determine when to refresh the list with the newly-loaded data.
   * This callback may be called multiple times in reaction to a single scroll event.
   */
  loadMoreRows: PropTypes.func.isRequired,

  /**
   * Minimum number of rows to be loaded at a time.
   * This property can be used to batch requests to reduce HTTP requests.
   */
  minimumBatchSize: PropTypes.number.isRequired,

  /**
   * Number of rows in list; can be arbitrary high number if actual number is unknown.
   */
  rowCount: PropTypes.number.isRequired,

  /**
   * Threshold at which to pre-fetch data.
   * A threshold X means that data will start loading when a user scrolls within X rows.
   * This value defaults to 15.
   */
  threshold: PropTypes.number.isRequired
} : void 0;
function isRangeVisible(_ref2) {
  var lastRenderedStartIndex = _ref2.lastRenderedStartIndex;
  var lastRenderedStopIndex = _ref2.lastRenderedStopIndex;
  var startIndex = _ref2.startIndex;
  var stopIndex = _ref2.stopIndex;

  return !(startIndex > lastRenderedStopIndex || stopIndex < lastRenderedStartIndex);
}

/**
 * Returns all of the ranges within a larger range that contain unloaded rows.
 */
function scanForUnloadedRanges(_ref3) {
  var isRowLoaded = _ref3.isRowLoaded;
  var minimumBatchSize = _ref3.minimumBatchSize;
  var rowCount = _ref3.rowCount;
  var startIndex = _ref3.startIndex;
  var stopIndex = _ref3.stopIndex;

  var unloadedRanges = [];

  var rangeStartIndex = null;
  var rangeStopIndex = null;

  for (var index = startIndex; index <= stopIndex; index++) {
    var loaded = isRowLoaded({ index: index });

    if (!loaded) {
      rangeStopIndex = index;
      if (rangeStartIndex === null) {
        rangeStartIndex = index;
      }
    } else if (rangeStopIndex !== null) {
      unloadedRanges.push({
        startIndex: rangeStartIndex,
        stopIndex: rangeStopIndex
      });

      rangeStartIndex = rangeStopIndex = null;
    }
  }

  // If :rangeStopIndex is not null it means we haven't ran out of unloaded rows.
  // Scan forward to try filling our :minimumBatchSize.
  if (rangeStopIndex !== null) {
    var potentialStopIndex = Math.min(Math.max(rangeStopIndex, rangeStartIndex + minimumBatchSize - 1), rowCount - 1);

    for (var _index = rangeStopIndex + 1; _index <= potentialStopIndex; _index++) {
      if (!isRowLoaded({ index: _index })) {
        rangeStopIndex = _index;
      } else {
        break;
      }
    }

    unloadedRanges.push({
      startIndex: rangeStartIndex,
      stopIndex: rangeStopIndex
    });
  }

  // Check to see if our first range ended prematurely.
  // In this case we should scan backwards to try filling our :minimumBatchSize.
  if (unloadedRanges.length) {
    var firstUnloadedRange = unloadedRanges[0];

    while (firstUnloadedRange.stopIndex - firstUnloadedRange.startIndex + 1 < minimumBatchSize && firstUnloadedRange.startIndex > 0) {
      var _index2 = firstUnloadedRange.startIndex - 1;

      if (!isRowLoaded({ index: _index2 })) {
        firstUnloadedRange.startIndex = _index2;
      } else {
        break;
      }
    }
  }

  return unloadedRanges;
}

/**
 * Since RV components use shallowCompare we need to force a render (even though props haven't changed).
 * However InfiniteLoader may wrap a Grid or it may wrap a Table or List.
 * In the first case the built-in React forceUpdate() method is sufficient to force a re-render,
 * But in the latter cases we need to use the RV-specific forceUpdateGrid() method.
 * Else the inner Grid will not be re-rendered and visuals may be stale.
 *
 * Additionally, while a Grid is scrolling the cells can be cached,
 * So it's important to invalidate that cache by recalculating sizes
 * before forcing a rerender.
 */
function forceUpdateReactVirtualizedComponent(component) {
  var recomputeSize = typeof component.recomputeGridSize === 'function' ? component.recomputeGridSize : component.recomputeRowHeights;

  if (recomputeSize) {
    recomputeSize.call(component);
  } else {
    component.forceUpdate();
  }
}

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Grid__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare__);













/**
 * It is inefficient to create and manage a large list of DOM elements within a scrolling container
 * if only a few of those elements are visible. The primary purpose of this component is to improve
 * performance by only rendering the DOM nodes that a user is able to see based on their current
 * scroll position.
 *
 * This component renders a virtualized list of elements with either fixed or dynamic heights.
 */

var List = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(List, _Component);

  function List(props, context) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, List);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (List.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(List)).call(this, props, context));

    _this._cellRenderer = _this._cellRenderer.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(List, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      this.Grid.forceUpdate();
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      this.Grid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.recomputeGridSize({
        rowIndex: index
      });
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.scrollToCell({
        columnIndex: 0,
        rowIndex: index
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var className = _props.className;
      var noRowsRenderer = _props.noRowsRenderer;
      var scrollToIndex = _props.scrollToIndex;
      var width = _props.width;


      var classNames = __WEBPACK_IMPORTED_MODULE_10_classnames___default()('ReactVirtualized__List', className);

      return __WEBPACK_IMPORTED_MODULE_9_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, this.props, {
        autoContainerWidth: true,
        cellRenderer: this._cellRenderer,
        className: classNames,
        columnWidth: width,
        columnCount: 1,
        noContentRenderer: noRowsRenderer,
        onScroll: this._onScroll,
        onSectionRendered: this._onSectionRendered,
        ref: function ref(_ref) {
          _this2.Grid = _ref;
        },
        scrollToRow: scrollToIndex
      }));
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_11_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_cellRenderer',
    value: function _cellRenderer(_ref2) {
      var rowIndex = _ref2.rowIndex;
      var style = _ref2.style;

      var rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['rowIndex', 'style']);

      var rowRenderer = this.props.rowRenderer;

      // TRICKY The style object is sometimes cached by Grid.
      // This prevents new style objects from bypassing shallowCompare().
      // However as of React 16, style props are auto-frozen (at least in dev mode)
      // Check to make sure we can still modify the style before proceeding.
      // https://github.com/facebook/react/commit/977357765b44af8ff0cfea327866861073095c12#commitcomment-20648713

      var _Object$getOwnPropert = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_own_property_descriptor___default()(style, 'width');

      var writable = _Object$getOwnPropert.writable;

      if (writable) {
        // By default, List cells should be 100% width.
        // This prevents them from flowing under a scrollbar (if present).
        style.width = '100%';
      }

      return rowRenderer(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({
        index: rowIndex,
        style: style
      }, rest));
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref3) {
      var clientHeight = _ref3.clientHeight;
      var scrollHeight = _ref3.scrollHeight;
      var scrollTop = _ref3.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref4) {
      var rowOverscanStartIndex = _ref4.rowOverscanStartIndex;
      var rowOverscanStopIndex = _ref4.rowOverscanStopIndex;
      var rowStartIndex = _ref4.rowStartIndex;
      var rowStopIndex = _ref4.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }]);

  return List;
}(__WEBPACK_IMPORTED_MODULE_9_react__["Component"]);

List.defaultProps = {
  estimatedRowSize: 30,
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanRowCount: 10,
  scrollToAlignment: 'auto',
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (List);
 false ? List.propTypes = {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** Optional CSS class name */
  className: PropTypes.string,

  /**
   * Used to estimate the total height of a List before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Height constraint for list (determines how many actual rows are rendered) */
  height: PropTypes.number.isRequired,

  /** Optional renderer to be used in place of rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Responsible for rendering a row given an index; ({ index: number }): node */
  rowRenderer: PropTypes.func.isRequired,

  /** Number of rows in list. */
  rowCount: PropTypes.number.isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Grid__ = __webpack_require__(378);











/**
 * Renders 1, 2, or 4 Grids depending on configuration.
 * A main (body) Grid will always be rendered.
 * Optionally, 1-2 Grids for sticky header rows will also be rendered.
 * If no sticky columns, only 1 sticky header Grid will be rendered.
 * If sticky columns, 2 sticky header Grids will be rendered.
 */

var MultiGrid = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(MultiGrid, _Component);

  function MultiGrid(props, context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MultiGrid);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MultiGrid.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(MultiGrid)).call(this, props, context));

    _this.state = {
      scrollLeft: 0,
      scrollTop: 0
    };

    _this._bottomLeftGridRef = _this._bottomLeftGridRef.bind(_this);
    _this._bottomRightGridRef = _this._bottomRightGridRef.bind(_this);
    _this._cellRendererBottomLeftGrid = _this._cellRendererBottomLeftGrid.bind(_this);
    _this._cellRendererBottomRightGrid = _this._cellRendererBottomRightGrid.bind(_this);
    _this._cellRendererTopRightGrid = _this._cellRendererTopRightGrid.bind(_this);
    _this._columnWidthRightGrid = _this._columnWidthRightGrid.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._rowHeightBottomGrid = _this._rowHeightBottomGrid.bind(_this);
    _this._topLeftGridRef = _this._topLeftGridRef.bind(_this);
    _this._topRightGridRef = _this._topRightGridRef.bind(_this);
    return _this;
  }

  /** See Grid#measureAllCells */


  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MultiGrid, [{
    key: 'measureAllCells',
    value: function measureAllCells() {
      this._bottomLeftGrid && this._bottomLeftGrid.measureAllCells();
      this._bottomRightGrid && this._bottomRightGrid.measureAllCells();
      this._topLeftGrid && this._topLeftGrid.measureAllCells();
      this._topRightGrid && this._topRightGrid.measureAllCells();
    }

    /** See issue #546 */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      console.warn('MultiGrid measureAllRows() is deprecated; use measureAllCells() instead.');

      this.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeGridSize',
    value: function recomputeGridSize() {
      var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _ref$columnIndex = _ref.columnIndex;
      var columnIndex = _ref$columnIndex === undefined ? 0 : _ref$columnIndex;
      var _ref$rowIndex = _ref.rowIndex;
      var rowIndex = _ref$rowIndex === undefined ? 0 : _ref$rowIndex;
      var _props = this.props;
      var fixedColumnCount = _props.fixedColumnCount;
      var fixedRowCount = _props.fixedRowCount;


      var adjustedColumnIndex = Math.max(0, columnIndex - fixedColumnCount);
      var adjustedRowIndex = Math.max(0, rowIndex - fixedRowCount);

      this._bottomLeftGrid && this._bottomLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: adjustedRowIndex
      });
      this._bottomRightGrid && this._bottomRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: adjustedRowIndex
      });
      this._topLeftGrid && this._topLeftGrid.recomputeGridSize({
        columnIndex: columnIndex,
        rowIndex: rowIndex
      });
      this._topRightGrid && this._topRightGrid.recomputeGridSize({
        columnIndex: adjustedColumnIndex,
        rowIndex: rowIndex
      });

      this._leftGridWidth = null;
      this._topGridHeight = null;
      this._maybeCalculateCachedStyles(null, this.props);
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this._maybeCalculateCachedStyles(null, this.props);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _props2 = this.props;
      var columnWidth = _props2.columnWidth;
      var fixedColumnCount = _props2.fixedColumnCount;
      var fixedRowCount = _props2.fixedRowCount;
      var rowHeight = _props2.rowHeight;


      if (columnWidth !== nextProps.columnWidth || fixedColumnCount !== nextProps.fixedColumnCount) {
        this._leftGridWidth = null;
      }

      if (fixedRowCount !== nextProps.fixedRowCount || rowHeight !== nextProps.rowHeight) {
        this._topGridHeight = null;
      }

      this._maybeCalculateCachedStyles(this.props, nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props3 = this.props;
      var onScroll = _props3.onScroll;
      var onSectionRendered = _props3.onSectionRendered;
      var scrollLeftProp = _props3.scrollLeft;
      var scrollToColumn = _props3.scrollToColumn;
      var scrollTopProp = _props3.scrollTop;
      var scrollToRow = _props3.scrollToRow;

      var rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_props3, ['onScroll', 'onSectionRendered', 'scrollLeft', 'scrollToColumn', 'scrollTop', 'scrollToRow']);

      // scrollTop and scrollToRow props are explicitly filtered out and ignored

      var _state = this.state;
      var scrollLeft = _state.scrollLeft;
      var scrollTop = _state.scrollTop;


      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
        'div',
        { style: this._containerOuterStyle },
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { style: this._containerTopStyle },
          this._renderTopLeftGrid(rest),
          this._renderTopRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            scrollLeft: scrollLeft
          }))
        ),
        __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(
          'div',
          { style: this._containerBottomStyle },
          this._renderBottomLeftGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            scrollTop: scrollTop
          })),
          this._renderBottomRightGrid(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
            onScroll: onScroll,
            onSectionRendered: onSectionRendered,
            scrollLeft: scrollLeft,
            scrollToColumn: scrollToColumn,
            scrollToRow: scrollToRow,
            scrollTop: scrollTop
          }))
        )
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_8_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_bottomLeftGridRef',
    value: function _bottomLeftGridRef(ref) {
      this._bottomLeftGrid = ref;
    }
  }, {
    key: '_bottomRightGridRef',
    value: function _bottomRightGridRef(ref) {
      this._bottomRightGrid = ref;
    }
  }, {
    key: '_cellRendererBottomLeftGrid',
    value: function _cellRendererBottomLeftGrid(_ref2) {
      var rowIndex = _ref2.rowIndex;

      var rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref2, ['rowIndex']);

      var _props4 = this.props;
      var cellRenderer = _props4.cellRenderer;
      var fixedRowCount = _props4.fixedRowCount;


      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        rowIndex: rowIndex + fixedRowCount
      }));
    }
  }, {
    key: '_cellRendererBottomRightGrid',
    value: function _cellRendererBottomRightGrid(_ref3) {
      var columnIndex = _ref3.columnIndex;
      var rowIndex = _ref3.rowIndex;

      var rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref3, ['columnIndex', 'rowIndex']);

      var _props5 = this.props;
      var cellRenderer = _props5.cellRenderer;
      var fixedColumnCount = _props5.fixedColumnCount;
      var fixedRowCount = _props5.fixedRowCount;


      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        columnIndex: columnIndex + fixedColumnCount,
        rowIndex: rowIndex + fixedRowCount
      }));
    }
  }, {
    key: '_cellRendererTopRightGrid',
    value: function _cellRendererTopRightGrid(_ref4) {
      var columnIndex = _ref4.columnIndex;

      var rest = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_objectWithoutProperties___default()(_ref4, ['columnIndex']);

      var _props6 = this.props;
      var cellRenderer = _props6.cellRenderer;
      var fixedColumnCount = _props6.fixedColumnCount;


      return cellRenderer(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rest, {
        columnIndex: columnIndex + fixedColumnCount
      }));
    }
  }, {
    key: '_columnWidthRightGrid',
    value: function _columnWidthRightGrid(_ref5) {
      var index = _ref5.index;
      var _props7 = this.props;
      var fixedColumnCount = _props7.fixedColumnCount;
      var columnWidth = _props7.columnWidth;


      return columnWidth instanceof Function ? columnWidth({ index: index + fixedColumnCount }) : columnWidth;
    }
  }, {
    key: '_getBottomGridHeight',
    value: function _getBottomGridHeight(props) {
      var height = props.height;


      var topGridHeight = this._getTopGridHeight(props);

      return height - topGridHeight;
    }
  }, {
    key: '_getLeftGridWidth',
    value: function _getLeftGridWidth(props) {
      var fixedColumnCount = props.fixedColumnCount;
      var columnWidth = props.columnWidth;


      if (this._leftGridWidth == null) {
        if (columnWidth instanceof Function) {
          var leftGridWidth = 0;

          for (var index = 0; index < fixedColumnCount; index++) {
            leftGridWidth += columnWidth({ index: index });
          }

          this._leftGridWidth = leftGridWidth;
        } else {
          this._leftGridWidth = columnWidth * fixedColumnCount;
        }
      }

      return this._leftGridWidth;
    }
  }, {
    key: '_getRightGridWidth',
    value: function _getRightGridWidth(props) {
      var width = props.width;


      var leftGridWidth = this._getLeftGridWidth(props);

      return width - leftGridWidth;
    }
  }, {
    key: '_getTopGridHeight',
    value: function _getTopGridHeight(props) {
      var fixedRowCount = props.fixedRowCount;
      var rowHeight = props.rowHeight;


      if (this._topGridHeight == null) {
        if (rowHeight instanceof Function) {
          var topGridHeight = 0;

          for (var index = 0; index < fixedRowCount; index++) {
            topGridHeight += rowHeight({ index: index });
          }

          this._topGridHeight = topGridHeight;
        } else {
          this._topGridHeight = rowHeight * fixedRowCount;
        }
      }

      return this._topGridHeight;
    }

    /**
     * Avoid recreating inline styles each render; this bypasses Grid's shallowCompare.
     * This method recalculates styles only when specific props change.
     */

  }, {
    key: '_maybeCalculateCachedStyles',
    value: function _maybeCalculateCachedStyles(prevProps, props) {
      var columnWidth = props.columnWidth;
      var height = props.height;
      var fixedColumnCount = props.fixedColumnCount;
      var fixedRowCount = props.fixedRowCount;
      var rowHeight = props.rowHeight;
      var style = props.style;
      var styleBottomLeftGrid = props.styleBottomLeftGrid;
      var styleBottomRightGrid = props.styleBottomRightGrid;
      var styleTopLeftGrid = props.styleTopLeftGrid;
      var styleTopRightGrid = props.styleTopRightGrid;
      var width = props.width;


      var firstRender = !prevProps;
      var sizeChange = firstRender || height !== prevProps.height || width !== prevProps.width;
      var leftSizeChange = firstRender || columnWidth !== prevProps.columnWidth || fixedColumnCount !== prevProps.fixedColumnCount;
      var topSizeChange = firstRender || fixedRowCount !== prevProps.fixedRowCount || rowHeight !== prevProps.rowHeight;

      if (firstRender || sizeChange || style !== prevProps.style) {
        this._containerOuterStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          height: height,
          width: width
        }, style);
      }

      if (firstRender || sizeChange || topSizeChange) {
        this._containerTopStyle = {
          height: this._getTopGridHeight(props),
          position: 'relative',
          width: width
        };

        this._containerBottomStyle = {
          height: height - this._getTopGridHeight(props),
          overflow: 'hidden',
          position: 'relative',
          width: width
        };
      }

      if (firstRender || styleBottomLeftGrid !== prevProps.styleBottomLeftGrid) {
        this._bottomLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          outline: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute'
        }, styleBottomLeftGrid);
      }

      if (firstRender || leftSizeChange || styleBottomRightGrid !== prevProps.styleBottomRightGrid) {
        this._bottomRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(props),
          outline: 0,
          position: 'absolute'
        }, styleBottomRightGrid);
      }

      if (firstRender || styleTopLeftGrid !== prevProps.styleTopLeftGrid) {
        this._topLeftGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: 0,
          outline: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopLeftGrid);
      }

      if (firstRender || leftSizeChange || styleTopRightGrid !== prevProps.styleTopRightGrid) {
        this._topRightGridStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
          left: this._getLeftGridWidth(props),
          outline: 0,
          overflowX: 'hidden',
          overflowY: 'hidden',
          position: 'absolute',
          top: 0
        }, styleTopRightGrid);
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(scrollInfo) {
      var scrollLeft = scrollInfo.scrollLeft;
      var scrollTop = scrollInfo.scrollTop;

      this.setState({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
      });
      var onScroll = this.props.onScroll;
      if (onScroll) {
        onScroll(scrollInfo);
      }
    }
  }, {
    key: '_renderBottomLeftGrid',
    value: function _renderBottomLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount;
      var fixedRowCount = props.fixedRowCount;
      var rowCount = props.rowCount;
      var scrollTop = props.scrollTop;


      if (!fixedColumnCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomLeftGrid,
        columnCount: fixedColumnCount,
        height: this._getBottomGridHeight(props),
        ref: this._bottomLeftGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollTop: scrollTop,
        style: this._bottomLeftGridStyle,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderBottomRightGrid',
    value: function _renderBottomRightGrid(props) {
      var columnCount = props.columnCount;
      var fixedColumnCount = props.fixedColumnCount;
      var fixedRowCount = props.fixedRowCount;
      var rowCount = props.rowCount;
      var scrollToColumn = props.scrollToColumn;
      var scrollToRow = props.scrollToRow;


      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererBottomRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        height: this._getBottomGridHeight(props),
        onScroll: this._onScroll,
        ref: this._bottomRightGridRef,
        rowCount: Math.max(0, rowCount - fixedRowCount),
        rowHeight: this._rowHeightBottomGrid,
        scrollToColumn: scrollToColumn - fixedColumnCount,
        scrollToRow: scrollToRow - fixedRowCount,
        style: this._bottomRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopLeftGrid',
    value: function _renderTopLeftGrid(props) {
      var fixedColumnCount = props.fixedColumnCount;
      var fixedRowCount = props.fixedRowCount;


      if (!fixedColumnCount || !fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        columnCount: fixedColumnCount,
        height: this._getTopGridHeight(props),
        ref: this._topLeftGridRef,
        rowCount: fixedRowCount,
        style: this._topLeftGridStyle,
        width: this._getLeftGridWidth(props)
      }));
    }
  }, {
    key: '_renderTopRightGrid',
    value: function _renderTopRightGrid(props) {
      var columnCount = props.columnCount;
      var fixedColumnCount = props.fixedColumnCount;
      var fixedRowCount = props.fixedRowCount;
      var scrollLeft = props.scrollLeft;


      if (!fixedRowCount) {
        return null;
      }

      return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, props, {
        cellRenderer: this._cellRendererTopRightGrid,
        columnCount: Math.max(0, columnCount - fixedColumnCount),
        columnWidth: this._columnWidthRightGrid,
        height: this._getTopGridHeight(props),
        ref: this._topRightGridRef,
        rowCount: fixedRowCount,
        scrollLeft: scrollLeft,
        style: this._topRightGridStyle,
        width: this._getRightGridWidth(props)
      }));
    }
  }, {
    key: '_rowHeightBottomGrid',
    value: function _rowHeightBottomGrid(_ref6) {
      var index = _ref6.index;
      var _props8 = this.props;
      var fixedRowCount = _props8.fixedRowCount;
      var rowHeight = _props8.rowHeight;


      return rowHeight instanceof Function ? rowHeight({ index: index + fixedRowCount }) : rowHeight;
    }
  }, {
    key: '_topLeftGridRef',
    value: function _topLeftGridRef(ref) {
      this._topLeftGrid = ref;
    }
  }, {
    key: '_topRightGridRef',
    value: function _topRightGridRef(ref) {
      this._topRightGrid = ref;
    }
  }]);

  return MultiGrid;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

MultiGrid.defaultProps = {
  fixedColumnCount: 0,
  fixedRowCount: 0,
  style: {},
  styleBottomLeftGrid: {},
  styleBottomRightGrid: {},
  styleTopLeftGrid: {},
  styleTopRightGrid: {}
};
/* harmony default export */ __webpack_exports__["a"] = (MultiGrid);
 false ? MultiGrid.propTypes = {
  fixedColumnCount: PropTypes.number.isRequired,
  fixedRowCount: PropTypes.number.isRequired,
  style: PropTypes.object.isRequired,
  styleBottomLeftGrid: PropTypes.object.isRequired,
  styleBottomRightGrid: PropTypes.object.isRequired,
  styleTopLeftGrid: PropTypes.object.isRequired,
  styleTopRightGrid: PropTypes.object.isRequired
} : void 0;

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare__);








/**
 * HOC that simplifies the process of synchronizing scrolling between two or more virtualized components.
 */

var ScrollSync = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(ScrollSync, _Component);

  function ScrollSync(props, context) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScrollSync);

    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ScrollSync.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ScrollSync)).call(this, props, context));

    _this.state = {
      clientHeight: 0,
      clientWidth: 0,
      scrollHeight: 0,
      scrollLeft: 0,
      scrollTop: 0,
      scrollWidth: 0
    };

    _this._onScroll = _this._onScroll.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScrollSync, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state;
      var clientHeight = _state.clientHeight;
      var clientWidth = _state.clientWidth;
      var scrollHeight = _state.scrollHeight;
      var scrollLeft = _state.scrollLeft;
      var scrollTop = _state.scrollTop;
      var scrollWidth = _state.scrollWidth;


      return children({
        clientHeight: clientHeight,
        clientWidth: clientWidth,
        onScroll: this._onScroll,
        scrollHeight: scrollHeight,
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        scrollWidth: scrollWidth
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_6_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref) {
      var clientHeight = _ref.clientHeight;
      var clientWidth = _ref.clientWidth;
      var scrollHeight = _ref.scrollHeight;
      var scrollLeft = _ref.scrollLeft;
      var scrollTop = _ref.scrollTop;
      var scrollWidth = _ref.scrollWidth;

      this.setState({ clientHeight: clientHeight, clientWidth: clientWidth, scrollHeight: scrollHeight, scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth });
    }
  }]);

  return ScrollSync;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

/* harmony default export */ __webpack_exports__["a"] = (ScrollSync);
 false ? ScrollSync.propTypes = {
  /**
   * Function responsible for rendering 2 or more virtualized components.
   * This function should implement the following signature:
   * ({ onScroll, scrollLeft, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired
} : void 0;

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__defaultHeaderRenderer__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__defaultCellRenderer__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__defaultCellDataGetter__ = __webpack_require__(967);









/**
 * Describes the header and cell contents of a table column.
 */

var Column = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(Column, _Component);

  function Column() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Column);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Column.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(Column)).apply(this, arguments));
  }

  return Column;
}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]);

Column.defaultProps = {
  cellDataGetter: __WEBPACK_IMPORTED_MODULE_7__defaultCellDataGetter__["a" /* default */],
  cellRenderer: __WEBPACK_IMPORTED_MODULE_6__defaultCellRenderer__["a" /* default */],
  flexGrow: 0,
  flexShrink: 1,
  headerRenderer: __WEBPACK_IMPORTED_MODULE_5__defaultHeaderRenderer__["a" /* default */],
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Column);
 false ? Column.propTypes = {
  /** Optional aria-label value to set on the column header */
  'aria-label': PropTypes.string,

  /**
   * Callback responsible for returning a cell's data, given its :dataKey
   * ({ columnData: any, dataKey: string, rowData: any }): any
   */
  cellDataGetter: PropTypes.func,

  /**
   * Callback responsible for rendering a cell's contents.
   * ({ cellData: any, columnData: any, dataKey: string, rowData: any, rowIndex: number }): node
   */
  cellRenderer: PropTypes.func,

  /** Optional CSS class to apply to cell */
  className: PropTypes.string,

  /** Optional additional data passed to this column's :cellDataGetter */
  columnData: PropTypes.object,

  /** Uniquely identifies the row-data attribute correspnding to this cell */
  dataKey: PropTypes.any.isRequired,

  /** If sort is enabled for the table at large, disable it for this column */
  disableSort: PropTypes.bool,

  /** Flex grow style; defaults to 0 */
  flexGrow: PropTypes.number,

  /** Flex shrink style; defaults to 1 */
  flexShrink: PropTypes.number,

  /** Optional CSS class to apply to this column's header */
  headerClassName: PropTypes.string,

  /**
   * Optional callback responsible for rendering a column header contents.
   * ({ columnData: object, dataKey: string, disableSort: boolean, label: string, sortBy: string, sortDirection: string }): PropTypes.node
   */
  headerRenderer: PropTypes.func.isRequired,

  /** Header label for this column */
  label: PropTypes.string,

  /** Maximum width of column; this property will only be used if :flexGrow is > 0. */
  maxWidth: PropTypes.number,

  /** Minimum width of column. */
  minWidth: PropTypes.number,

  /** Optional inline style to apply to cell */
  style: PropTypes.object,

  /** Flex basis (width) for this column; This value can grow or shrink based on :flexGrow and :flexShrink properties. */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SortIndicator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SortDirection__ = __webpack_require__(569);




/**
 * Displayed beside a header to indicate that a Table is currently sorted by this column.
 */
function SortIndicator(_ref) {
  var sortDirection = _ref.sortDirection;

  var classNames = __WEBPACK_IMPORTED_MODULE_1_classnames___default()('ReactVirtualized__Table__sortableHeaderIcon', {
    'ReactVirtualized__Table__sortableHeaderIcon--ASC': sortDirection === __WEBPACK_IMPORTED_MODULE_2__SortDirection__["a" /* default */].ASC,
    'ReactVirtualized__Table__sortableHeaderIcon--DESC': sortDirection === __WEBPACK_IMPORTED_MODULE_2__SortDirection__["a" /* default */].DESC
  });

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'svg',
    {
      className: classNames,
      width: 18,
      height: 18,
      viewBox: '0 0 24 24'
    },
    sortDirection === __WEBPACK_IMPORTED_MODULE_2__SortDirection__["a" /* default */].ASC ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M7 14l5-5 5 5z' }) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M7 10l5 5 5-5z' }),
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path', { d: 'M0 0h24v24H0z', fill: 'none' })
  );
}

 false ? SortIndicator.propTypes = {
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC])
} : void 0;

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Column__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Grid__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SortDirection__ = __webpack_require__(569);















/**
 * Table component with fixed headers and virtualized rows for improved performance with large data sets.
 * This component expects explicit width, height, and padding parameters.
 */

var Table = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Table, _Component);

  function Table(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Table);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Table.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Table)).call(this, props));

    _this.state = {
      scrollbarWidth: 0
    };

    _this._createColumn = _this._createColumn.bind(_this);
    _this._createRow = _this._createRow.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._onSectionRendered = _this._onSectionRendered.bind(_this);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Table, [{
    key: 'forceUpdateGrid',
    value: function forceUpdateGrid() {
      this.Grid.forceUpdate();
    }

    /** See Grid#measureAllCells */

  }, {
    key: 'measureAllRows',
    value: function measureAllRows() {
      this.Grid.measureAllCells();
    }

    /** See Grid#recomputeGridSize */

  }, {
    key: 'recomputeRowHeights',
    value: function recomputeRowHeights() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.recomputeGridSize({
        rowIndex: index
      });
    }

    /** See Grid#scrollToCell */

  }, {
    key: 'scrollToRow',
    value: function scrollToRow() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.Grid.scrollToCell({
        columnIndex: 0,
        rowIndex: index
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this._setScrollbarWidth();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props;
      var children = _props.children;
      var className = _props.className;
      var disableHeader = _props.disableHeader;
      var gridClassName = _props.gridClassName;
      var gridStyle = _props.gridStyle;
      var headerHeight = _props.headerHeight;
      var height = _props.height;
      var id = _props.id;
      var noRowsRenderer = _props.noRowsRenderer;
      var rowClassName = _props.rowClassName;
      var rowStyle = _props.rowStyle;
      var scrollToIndex = _props.scrollToIndex;
      var style = _props.style;
      var width = _props.width;
      var scrollbarWidth = this.state.scrollbarWidth;


      var availableRowsHeight = disableHeader ? height : height - headerHeight;

      var rowClass = rowClassName instanceof Function ? rowClassName({ index: -1 }) : rowClassName;
      var rowStyleObject = rowStyle instanceof Function ? rowStyle({ index: -1 }) : rowStyle;

      // Precompute and cache column styles before rendering rows and columns to speed things up
      this._cachedColumnStyles = [];
      __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.toArray(children).forEach(function (column, index) {
        var flexStyles = _this2._getFlexStyleForColumn(column, column.props.style);

        _this2._cachedColumnStyles[index] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, flexStyles, {
          overflow: 'hidden'
        });
      });

      // Note that we specify :rowCount, :scrollbarWidth, :sortBy, and :sortDirection as properties on Grid even though these have nothing to do with Grid.
      // This is done because Grid is a pure component and won't update unless its properties or state has changed.
      // Any property that should trigger a re-render of Grid then is specified here to avoid a stale display.
      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        {
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table', className),
          id: id,
          style: style
        },
        !disableHeader && __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
          'div',
          {
            className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerRow', rowClass),
            style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, rowStyleObject, {
              height: headerHeight,
              overflow: 'hidden',
              paddingRight: scrollbarWidth,
              width: width
            })
          },
          this._getRenderedHeaderRow()
        ),
        __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Grid__["c" /* default */], __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, this.props, {
          autoContainerWidth: true,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__Grid', gridClassName),
          cellRenderer: this._createRow,
          columnWidth: width,
          columnCount: 1,
          height: availableRowsHeight,
          id: undefined,
          noContentRenderer: noRowsRenderer,
          onScroll: this._onScroll,
          onSectionRendered: this._onSectionRendered,
          ref: function ref(_ref) {
            _this2.Grid = _ref;
          },
          scrollbarWidth: scrollbarWidth,
          scrollToRow: scrollToIndex,
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, gridStyle, {
            overflowX: 'hidden'
          })
        }))
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_createColumn',
    value: function _createColumn(_ref2) {
      var column = _ref2.column;
      var columnIndex = _ref2.columnIndex;
      var isScrolling = _ref2.isScrolling;
      var rowData = _ref2.rowData;
      var rowIndex = _ref2.rowIndex;
      var _column$props = column.props;
      var cellDataGetter = _column$props.cellDataGetter;
      var cellRenderer = _column$props.cellRenderer;
      var className = _column$props.className;
      var columnData = _column$props.columnData;
      var dataKey = _column$props.dataKey;


      var cellData = cellDataGetter({ columnData: columnData, dataKey: dataKey, rowData: rowData });
      var renderedCell = cellRenderer({ cellData: cellData, columnData: columnData, dataKey: dataKey, isScrolling: isScrolling, rowData: rowData, rowIndex: rowIndex });

      var style = this._cachedColumnStyles[columnIndex];

      var title = typeof renderedCell === 'string' ? renderedCell : null;

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        {
          key: 'Row' + rowIndex + '-Col' + columnIndex,
          className: __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__rowColumn', className),
          style: style,
          title: title
        },
        renderedCell
      );
    }
  }, {
    key: '_createHeader',
    value: function _createHeader(_ref3) {
      var column = _ref3.column;
      var index = _ref3.index;
      var _props2 = this.props;
      var headerClassName = _props2.headerClassName;
      var headerStyle = _props2.headerStyle;
      var onHeaderClick = _props2.onHeaderClick;
      var sort = _props2.sort;
      var sortBy = _props2.sortBy;
      var sortDirection = _props2.sortDirection;
      var _column$props2 = column.props;
      var dataKey = _column$props2.dataKey;
      var disableSort = _column$props2.disableSort;
      var headerRenderer = _column$props2.headerRenderer;
      var label = _column$props2.label;
      var columnData = _column$props2.columnData;

      var sortEnabled = !disableSort && sort;

      var classNames = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__headerColumn', headerClassName, column.props.headerClassName, {
        'ReactVirtualized__Table__sortableHeaderColumn': sortEnabled
      });
      var style = this._getFlexStyleForColumn(column, headerStyle);

      var renderedHeader = headerRenderer({
        columnData: columnData,
        dataKey: dataKey,
        disableSort: disableSort,
        label: label,
        sortBy: sortBy,
        sortDirection: sortDirection
      });

      var a11yProps = {};

      if (sortEnabled || onHeaderClick) {
        (function () {
          // If this is a sortable header, clicking it should update the table data's sorting.
          var newSortDirection = sortBy !== dataKey || sortDirection === __WEBPACK_IMPORTED_MODULE_13__SortDirection__["a" /* default */].DESC ? __WEBPACK_IMPORTED_MODULE_13__SortDirection__["a" /* default */].ASC : __WEBPACK_IMPORTED_MODULE_13__SortDirection__["a" /* default */].DESC;

          var onClick = function onClick() {
            sortEnabled && sort({
              sortBy: dataKey,
              sortDirection: newSortDirection
            });
            onHeaderClick && onHeaderClick({ columnData: columnData, dataKey: dataKey });
          };

          var onKeyDown = function onKeyDown(event) {
            if (event.key === 'Enter' || event.key === ' ') {
              onClick();
            }
          };

          a11yProps['aria-label'] = column.props['aria-label'] || label || dataKey;
          a11yProps.role = 'rowheader';
          a11yProps.tabIndex = 0;
          a11yProps.onClick = onClick;
          a11yProps.onKeyDown = onKeyDown;
        })();
      }

      return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(
        'div',
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a11yProps, {
          key: 'Header-Col' + index,
          className: classNames,
          style: style
        }),
        renderedHeader
      );
    }
  }, {
    key: '_createRow',
    value: function _createRow(_ref4) {
      var _this3 = this;

      var index = _ref4.rowIndex;
      var isScrolling = _ref4.isScrolling;
      var key = _ref4.key;
      var style = _ref4.style;
      var _props3 = this.props;
      var children = _props3.children;
      var onRowClick = _props3.onRowClick;
      var onRowDoubleClick = _props3.onRowDoubleClick;
      var onRowMouseOver = _props3.onRowMouseOver;
      var onRowMouseOut = _props3.onRowMouseOut;
      var rowClassName = _props3.rowClassName;
      var rowGetter = _props3.rowGetter;
      var rowRenderer = _props3.rowRenderer;
      var rowStyle = _props3.rowStyle;
      var scrollbarWidth = this.state.scrollbarWidth;


      var rowClass = rowClassName instanceof Function ? rowClassName({ index: index }) : rowClassName;
      var rowStyleObject = rowStyle instanceof Function ? rowStyle({ index: index }) : rowStyle;
      var rowData = rowGetter({ index: index });

      var columns = __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.toArray(children).map(function (column, columnIndex) {
        return _this3._createColumn({
          column: column,
          columnIndex: columnIndex,
          isScrolling: isScrolling,
          rowData: rowData,
          rowIndex: index,
          scrollbarWidth: scrollbarWidth
        });
      });

      var className = __WEBPACK_IMPORTED_MODULE_6_classnames___default()('ReactVirtualized__Table__row', rowClass);
      var flattenedStyle = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, style, rowStyleObject, {
        height: this._getRowHeight(index),
        overflow: 'hidden',
        paddingRight: scrollbarWidth
      });

      return rowRenderer({
        className: className,
        columns: columns,
        index: index,
        isScrolling: isScrolling,
        key: key,
        onRowClick: onRowClick,
        onRowDoubleClick: onRowDoubleClick,
        onRowMouseOver: onRowMouseOver,
        onRowMouseOut: onRowMouseOut,
        rowData: rowData,
        style: flattenedStyle
      });
    }

    /**
     * Determines the flex-shrink, flex-grow, and width values for a cell (header or column).
     */

  }, {
    key: '_getFlexStyleForColumn',
    value: function _getFlexStyleForColumn(column) {
      var customStyle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var flexValue = column.props.flexGrow + ' ' + column.props.flexShrink + ' ' + column.props.width + 'px';

      var style = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, customStyle, {
        flex: flexValue,
        msFlex: flexValue,
        WebkitFlex: flexValue
      });

      if (column.props.maxWidth) {
        style.maxWidth = column.props.maxWidth;
      }

      if (column.props.minWidth) {
        style.minWidth = column.props.minWidth;
      }

      return style;
    }
  }, {
    key: '_getRenderedHeaderRow',
    value: function _getRenderedHeaderRow() {
      var _this4 = this;

      var _props4 = this.props;
      var children = _props4.children;
      var disableHeader = _props4.disableHeader;

      var items = disableHeader ? [] : __WEBPACK_IMPORTED_MODULE_8_react___default.a.Children.toArray(children);

      return items.map(function (column, index) {
        return _this4._createHeader({ column: column, index: index });
      });
    }
  }, {
    key: '_getRowHeight',
    value: function _getRowHeight(rowIndex) {
      var rowHeight = this.props.rowHeight;


      return rowHeight instanceof Function ? rowHeight({ index: rowIndex }) : rowHeight;
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(_ref5) {
      var clientHeight = _ref5.clientHeight;
      var scrollHeight = _ref5.scrollHeight;
      var scrollTop = _ref5.scrollTop;
      var onScroll = this.props.onScroll;


      onScroll({ clientHeight: clientHeight, scrollHeight: scrollHeight, scrollTop: scrollTop });
    }
  }, {
    key: '_onSectionRendered',
    value: function _onSectionRendered(_ref6) {
      var rowOverscanStartIndex = _ref6.rowOverscanStartIndex;
      var rowOverscanStopIndex = _ref6.rowOverscanStopIndex;
      var rowStartIndex = _ref6.rowStartIndex;
      var rowStopIndex = _ref6.rowStopIndex;
      var onRowsRendered = this.props.onRowsRendered;


      onRowsRendered({
        overscanStartIndex: rowOverscanStartIndex,
        overscanStopIndex: rowOverscanStopIndex,
        startIndex: rowStartIndex,
        stopIndex: rowStopIndex
      });
    }
  }, {
    key: '_setScrollbarWidth',
    value: function _setScrollbarWidth() {
      var Grid = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9_react_dom__["findDOMNode"])(this.Grid);
      var clientWidth = Grid.clientWidth || 0;
      var offsetWidth = Grid.offsetWidth || 0;
      var scrollbarWidth = offsetWidth - clientWidth;

      this.setState({ scrollbarWidth: scrollbarWidth });
    }
  }]);

  return Table;
}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]);

Table.defaultProps = {
  disableHeader: false,
  estimatedRowSize: 30,
  headerHeight: 0,
  headerStyle: {},
  noRowsRenderer: function noRowsRenderer() {
    return null;
  },
  onRowsRendered: function onRowsRendered() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  overscanRowCount: 10,
  rowRenderer: __WEBPACK_IMPORTED_MODULE_12__defaultRowRenderer__["a" /* default */],
  rowStyle: {},
  scrollToAlignment: 'auto',
  style: {}
};
/* harmony default export */ __webpack_exports__["a"] = (Table);
 false ? Table.propTypes = {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /** One or more Columns describing the data displayed in this row */
  children: function children(props, propName, componentName) {
    var children = React.Children.toArray(props.children);
    for (var i = 0; i < children.length; i++) {
      if (children[i].type !== Column) {
        return new Error('Table only accepts children of type Column');
      }
    }
  },

  /** Optional CSS class name */
  className: PropTypes.string,

  /** Disable rendering the header at all */
  disableHeader: PropTypes.bool,

  /**
   * Used to estimate the total height of a Table before all of its rows have actually been measured.
   * The estimated total height is adjusted as rows are rendered.
   */
  estimatedRowSize: PropTypes.number.isRequired,

  /** Optional custom CSS class name to attach to inner Grid element. */
  gridClassName: PropTypes.string,

  /** Optional inline style to attach to inner Grid element. */
  gridStyle: PropTypes.object,

  /** Optional CSS class to apply to all column headers */
  headerClassName: PropTypes.string,

  /** Fixed height of header row */
  headerHeight: PropTypes.number.isRequired,

  /** Fixed/available height for out DOM element */
  height: PropTypes.number.isRequired,

  /** Optional id */
  id: PropTypes.string,

  /** Optional renderer to be used in place of table body rows when rowCount is 0 */
  noRowsRenderer: PropTypes.func,

  /**
  * Optional callback when a column's header is clicked.
  * ({ columnData: any, dataKey: string }): void
  */
  onHeaderClick: PropTypes.func,

  /** Optional custom inline style to attach to table header columns. */
  headerStyle: PropTypes.object,

  /**
   * Callback invoked when a user clicks on a table row.
   * ({ index: number }): void
   */
  onRowClick: PropTypes.func,

  /**
   * Callback invoked when a user double-clicks on a table row.
   * ({ index: number }): void
   */
  onRowDoubleClick: PropTypes.func,

  /**
   * Callback invoked when the mouse leaves a table row.
   * ({ index: number }): void
   */
  onRowMouseOut: PropTypes.func,

  /**
   * Callback invoked when a user moves the mouse over a table row.
   * ({ index: number }): void
   */
  onRowMouseOver: PropTypes.func,

  /**
   * Callback invoked with information about the slice of rows that were just rendered.
   * ({ startIndex, stopIndex }): void
   */
  onRowsRendered: PropTypes.func,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, scrollHeight, scrollTop }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Number of rows to render above/below the visible bounds of the list.
   * These rows can help for smoother scrolling on touch devices.
   */
  overscanRowCount: PropTypes.number.isRequired,

  /**
   * Optional CSS class to apply to all table rows (including the header row).
   * This property can be a CSS class name (string) or a function that returns a class name.
   * If a function is provided its signature should be: ({ index: number }): string
   */
  rowClassName: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),

  /**
   * Callback responsible for returning a data row given an index.
   * ({ index: number }): any
   */
  rowGetter: PropTypes.func.isRequired,

  /**
   * Either a fixed row height (number) or a function that returns the height of a row given its index.
   * ({ index: number }): number
   */
  rowHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.func]).isRequired,

  /** Number of rows in table. */
  rowCount: PropTypes.number.isRequired,

  /**
   * Responsible for rendering a table row given an array of columns:
   * Should implement the following interface: ({
   *   className: string,
   *   columns: Array,
   *   index: number,
   *   isScrolling: boolean,
   *   onRowClick: ?Function,
   *   onRowDoubleClick: ?Function,
   *   onRowMouseOver: ?Function,
   *   onRowMouseOut: ?Function,
   *   rowData: any,
   *   style: any
   * }): PropTypes.node
   */
  rowRenderer: PropTypes.func,

  /** Optional custom inline style to attach to table rows. */
  rowStyle: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,

  /** See Grid#scrollToAlignment */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /** Row index to ensure visible (by forcefully scrolling if necessary) */
  scrollToIndex: PropTypes.number,

  /** Vertical offset. */
  scrollTop: PropTypes.number,

  /**
   * Sort function to be called if a sortable header is clicked.
   * ({ sortBy: string, sortDirection: SortDirection }): void
   */
  sort: PropTypes.func,

  /** Table data is currently sorted by this :dataKey (if it is sorted at all) */
  sortBy: PropTypes.string,

  /** Table data is currently sorted in this direction (if it is sorted at all) */
  sortDirection: PropTypes.oneOf([SortDirection.ASC, SortDirection.DESC]),

  /** Optional inline style */
  style: PropTypes.object,

  /** Tab index for focus */
  tabIndex: PropTypes.number,

  /** Width of list */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellDataGetter;


/**
 * Default accessor for returning a cell value for a given attribute.
 * This function expects to operate on either a vanilla Object or an Immutable Map.
 * You should override the column's cellDataGetter if your data is some other type of object.
 */
function defaultCellDataGetter(_ref) {
  var columnData = _ref.columnData;
  var dataKey = _ref.dataKey;
  var rowData = _ref.rowData;

  if (rowData.get instanceof Function) {
    return rowData.get(dataKey);
  } else {
    return rowData[dataKey];
  }
}

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultCellRenderer;


/**
 * Default cell renderer that displays an attribute as a simple string
 * You should override the column's cellRenderer if your data is some other type of object.
 */
function defaultCellRenderer(_ref) {
  var cellData = _ref.cellData;
  var cellDataKey = _ref.cellDataKey;
  var columnData = _ref.columnData;
  var rowData = _ref.rowData;
  var rowIndex = _ref.rowIndex;

  if (cellData == null) {
    return '';
  } else {
    return String(cellData);
  }
}

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultHeaderRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SortIndicator__ = __webpack_require__(965);




/**
 * Default table header renderer.
 */
function defaultHeaderRenderer(_ref) {
  var columnData = _ref.columnData;
  var dataKey = _ref.dataKey;
  var disableSort = _ref.disableSort;
  var label = _ref.label;
  var sortBy = _ref.sortBy;
  var sortDirection = _ref.sortDirection;

  var showSortIndicator = sortBy === dataKey;
  var children = [__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    'span',
    {
      className: 'ReactVirtualized__Table__headerTruncatedText',
      key: 'label',
      title: label
    },
    label
  )];

  if (showSortIndicator) {
    children.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__SortIndicator__["a" /* default */], {
      key: 'SortIndicator',
      sortDirection: sortDirection
    }));
  }

  return children;
}

/***/ }),
/* 970 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defaultRowRenderer;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);




/**
 * Default row renderer for Table.
 */
function defaultRowRenderer(_ref) {
  var className = _ref.className;
  var columns = _ref.columns;
  var index = _ref.index;
  var isScrolling = _ref.isScrolling;
  var key = _ref.key;
  var onRowClick = _ref.onRowClick;
  var onRowDoubleClick = _ref.onRowDoubleClick;
  var onRowMouseOver = _ref.onRowMouseOver;
  var onRowMouseOut = _ref.onRowMouseOut;
  var rowData = _ref.rowData;
  var style = _ref.style;

  var a11yProps = {};

  if (onRowClick || onRowDoubleClick || onRowMouseOver || onRowMouseOut) {
    a11yProps['aria-label'] = 'row';
    a11yProps.role = 'row';
    a11yProps.tabIndex = 0;

    if (onRowClick) {
      a11yProps.onClick = function () {
        return onRowClick({ index: index, rowData: rowData });
      };
    }
    if (onRowDoubleClick) {
      a11yProps.onDoubleClick = function () {
        return onRowDoubleClick({ index: index, rowData: rowData });
      };
    }
    if (onRowMouseOut) {
      a11yProps.onMouseOut = function () {
        return onRowMouseOut({ index: index, rowData: rowData });
      };
    }
    if (onRowMouseOver) {
      a11yProps.onMouseOver = function () {
        return onRowMouseOver({ index: index, rowData: rowData });
      };
    }
  }

  return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
    'div',
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, a11yProps, {
      className: className,
      key: key,
      style: style
    }),
    columns
  );
}

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_onScroll__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_dimensions__ = __webpack_require__(2429);











var WindowScroller = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(WindowScroller, _Component);

  function WindowScroller(props) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, WindowScroller);

    // Handle server-side rendering case
    var _this = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (WindowScroller.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(WindowScroller)).call(this, props));

    var height = typeof window !== 'undefined' ? __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getHeight */])(props.scrollElement || window) : 0;

    _this.state = {
      height: height,
      isScrolling: false,
      scrollTop: 0
    };

    _this._onResize = _this._onResize.bind(_this);
    _this.__handleWindowScrollEvent = _this.__handleWindowScrollEvent.bind(_this);
    _this.__resetIsScrolling = _this.__resetIsScrolling.bind(_this);
    return _this;
  }

  // Can’t use defaultProps for scrollElement without breaking server-side rendering


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(WindowScroller, [{
    key: 'updatePosition',
    value: function updatePosition(scrollElement) {
      var onResize = this.props.onResize;
      var height = this.state.height;


      scrollElement = scrollElement || this.props.scrollElement || window;
      this._positionFromTop = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["b" /* getPositionFromTop */])(__WEBPACK_IMPORTED_MODULE_6_react_dom___default.a.findDOMNode(this), scrollElement);

      var newHeight = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["a" /* getHeight */])(scrollElement);
      if (height !== newHeight) {
        this.setState({
          height: newHeight
        });
        onResize({
          height: newHeight
        });
      }
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var scrollElement = this.props.scrollElement || window;

      this.updatePosition(scrollElement);

      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, scrollElement);

      window.addEventListener('resize', this._onResize, false);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var scrollElement = this.props.scrollElement || window;
      var nextScrollElement = nextProps.scrollElement || window;

      if (scrollElement !== nextScrollElement) {
        this.updatePosition(nextScrollElement);

        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, scrollElement);
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["a" /* registerScrollListener */])(this, nextScrollElement);
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_onScroll__["b" /* unregisterScrollListener */])(this, this.props.scrollElement || window);

      window.removeEventListener('resize', this._onResize, false);
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;
      var _state = this.state;
      var isScrolling = _state.isScrolling;
      var scrollTop = _state.scrollTop;
      var height = _state.height;


      return children({
        height: height,
        isScrolling: isScrolling,
        scrollTop: scrollTop
      });
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_7_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }
  }, {
    key: '_onResize',
    value: function _onResize(event) {
      this.updatePosition();
    }

    // Referenced by utils/onScroll

  }, {
    key: '__handleWindowScrollEvent',
    value: function __handleWindowScrollEvent(event) {
      var onScroll = this.props.onScroll;


      var scrollElement = this.props.scrollElement || window;
      var scrollTop = Math.max(0, __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_9__utils_dimensions__["c" /* getScrollTop */])(scrollElement) - this._positionFromTop);

      this.setState({
        isScrolling: true,
        scrollTop: scrollTop
      });

      onScroll({
        scrollTop: scrollTop
      });
    }

    // Referenced by utils/onScroll

  }, {
    key: '__resetIsScrolling',
    value: function __resetIsScrolling() {
      this.setState({
        isScrolling: false
      });
    }
  }, {
    key: 'scrollElement',
    get: function get() {
      return this.props.scrollElement || window;
    }
  }]);

  return WindowScroller;
}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]);

WindowScroller.defaultProps = {
  onResize: function onResize() {},
  onScroll: function onScroll() {}
};
/* harmony default export */ __webpack_exports__["a"] = (WindowScroller);
 false ? WindowScroller.propTypes = {
  /**
   * Function responsible for rendering children.
   * This function should implement the following signature:
   * ({ height, isScrolling, scrollTop }) => PropTypes.element
   */
  children: PropTypes.func.isRequired,

  /** Callback to be invoked on-resize: ({ height }) */
  onResize: PropTypes.func.isRequired,

  /** Callback to be invoked on-scroll: ({ scrollTop }) */
  onScroll: PropTypes.func.isRequired,

  /** Element to attach scroll event listeners. Defaults to window. */
  scrollElement: PropTypes.any
} : void 0;

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export IS_SCROLLING_TIMEOUT */
/* harmony export (immutable) */ __webpack_exports__["a"] = registerScrollListener;
/* harmony export (immutable) */ __webpack_exports__["b"] = unregisterScrollListener;
var mountedInstances = [];
var originalBodyPointerEvents = null;
var disablePointerEventsTimeoutId = null;

/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

function enablePointerEventsIfDisabled() {
  if (disablePointerEventsTimeoutId) {
    disablePointerEventsTimeoutId = null;

    document.body.style.pointerEvents = originalBodyPointerEvents;

    originalBodyPointerEvents = null;
  }
}

function enablePointerEventsAfterDelayCallback() {
  enablePointerEventsIfDisabled();
  mountedInstances.forEach(function (instance) {
    return instance.__resetIsScrolling();
  });
}

function enablePointerEventsAfterDelay() {
  if (disablePointerEventsTimeoutId) {
    clearTimeout(disablePointerEventsTimeoutId);
  }

  disablePointerEventsTimeoutId = setTimeout(enablePointerEventsAfterDelayCallback, IS_SCROLLING_TIMEOUT);
}

function onScrollWindow(event) {
  if (event.currentTarget === window && originalBodyPointerEvents == null) {
    originalBodyPointerEvents = document.body.style.pointerEvents;

    document.body.style.pointerEvents = 'none';
  }
  enablePointerEventsAfterDelay();
  mountedInstances.forEach(function (instance) {
    if (instance.scrollElement === event.currentTarget) {
      instance.__handleWindowScrollEvent(event);
    }
  });
}

function registerScrollListener(component, element) {
  if (!mountedInstances.some(function (instance) {
    return instance.scrollElement === element;
  })) {
    element.addEventListener('scroll', onScrollWindow);
  }
  mountedInstances.push(component);
}

function unregisterScrollListener(component, element) {
  mountedInstances = mountedInstances.filter(function (instance) {
    return instance !== component;
  });
  if (!mountedInstances.length) {
    element.removeEventListener('scroll', onScrollWindow);
    if (disablePointerEventsTimeoutId) {
      clearTimeout(disablePointerEventsTimeoutId);
      enablePointerEventsIfDisabled();
    }
  }
}

/***/ }),
/* 973 */,
/* 974 */,
/* 975 */,
/* 976 */,
/* 977 */,
/* 978 */,
/* 979 */,
/* 980 */,
/* 981 */,
/* 982 */,
/* 983 */,
/* 984 */,
/* 985 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(0), __webpack_require__(14), __webpack_require__(15), __webpack_require__(279), __webpack_require__(66), __webpack_require__(112), __webpack_require__(2129), __webpack_require__(2612), __webpack_require__(1634), __webpack_require__(13), __webpack_require__(1570), __webpack_require__(2540), __webpack_require__(952));
	else if(typeof define === 'function' && define.amd)
		define(["react", "prop-types", "rp-react-svg-icon", "classnames", "qs", "rp-mq-breakpoints", "react-dom", "isomorphic-fetch", "rp-react-select", "datepicker", "jquery", "date-fns", "rp-navigation", "react-textarea-autosize"], factory);
	else if(typeof exports === 'object')
		exports["rpBloodstockSearch"] = factory(require("react"), require("prop-types"), require("rp-react-svg-icon"), require("classnames"), require("qs"), require("rp-mq-breakpoints"), require("react-dom"), require("isomorphic-fetch"), require("rp-react-select"), require("datepicker"), require("jquery"), require("date-fns"), require("rp-navigation"), require("react-textarea-autosize"));
	else
		root["rpBloodstockSearch"] = factory(root["react"], root["prop-types"], root["rp-react-svg-icon"], root["classnames"], root["qs"], root["rp-mq-breakpoints"], root["react-dom"], root["isomorphic-fetch"], root["rp-react-select"], root["datepicker"], root["jquery"], root["date-fns"], root["rp-navigation"], root["react-textarea-autosize"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_1__, __WEBPACK_EXTERNAL_MODULE_4__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_17__, __WEBPACK_EXTERNAL_MODULE_24__, __WEBPACK_EXTERNAL_MODULE_68__, __WEBPACK_EXTERNAL_MODULE_195__, __WEBPACK_EXTERNAL_MODULE_217__, __WEBPACK_EXTERNAL_MODULE_226__, __WEBPACK_EXTERNAL_MODULE_227__, __WEBPACK_EXTERNAL_MODULE_228__, __WEBPACK_EXTERNAL_MODULE_275__, __WEBPACK_EXTERNAL_MODULE_318__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 90);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getElement = (function (fn) {
	var memo = {};

	return function(selector) {
		if (typeof memo[selector] === "undefined") {
			memo[selector] = fn.call(this, selector);
		}

		return memo[selector]
	};
})(function (target) {
	return document.querySelector(target)
});

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(184);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton) options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
	if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else {
		throw new Error("Invalid value for parameter 'insertAt'. Must be 'top' or 'bottom'.");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_4__;

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var getTimezoneOffsetInMilliseconds = __webpack_require__(154)
var isDate = __webpack_require__(58)

var MILLISECONDS_IN_HOUR = 3600000
var MILLISECONDS_IN_MINUTE = 60000
var DEFAULT_ADDITIONAL_DIGITS = 2

var parseTokenDateTimeDelimeter = /[T ]/
var parseTokenPlainTime = /:/

// year tokens
var parseTokenYY = /^(\d{2})$/
var parseTokensYYY = [
  /^([+-]\d{2})$/, // 0 additional digits
  /^([+-]\d{3})$/, // 1 additional digit
  /^([+-]\d{4})$/ // 2 additional digits
]

var parseTokenYYYY = /^(\d{4})/
var parseTokensYYYYY = [
  /^([+-]\d{4})/, // 0 additional digits
  /^([+-]\d{5})/, // 1 additional digit
  /^([+-]\d{6})/ // 2 additional digits
]

// date tokens
var parseTokenMM = /^-(\d{2})$/
var parseTokenDDD = /^-?(\d{3})$/
var parseTokenMMDD = /^-?(\d{2})-?(\d{2})$/
var parseTokenWww = /^-?W(\d{2})$/
var parseTokenWwwD = /^-?W(\d{2})-?(\d{1})$/

// time tokens
var parseTokenHH = /^(\d{2}([.,]\d*)?)$/
var parseTokenHHMM = /^(\d{2}):?(\d{2}([.,]\d*)?)$/
var parseTokenHHMMSS = /^(\d{2}):?(\d{2}):?(\d{2}([.,]\d*)?)$/

// timezone tokens
var parseTokenTimezone = /([Z+-].*)$/
var parseTokenTimezoneZ = /^(Z)$/
var parseTokenTimezoneHH = /^([+-])(\d{2})$/
var parseTokenTimezoneHHMM = /^([+-])(\d{2}):?(\d{2})$/

/**
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If an argument is a string, the function tries to parse it.
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If all above fails, the function passes the given argument to Date constructor.
 *
 * @param {Date|String|Number} argument - the value to convert
 * @param {Object} [options] - the object with options
 * @param {0 | 1 | 2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * var result = parse('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Parse string '+02014101',
 * // if the additional number of digits in the extended year format is 1:
 * var result = parse('+02014101', {additionalDigits: 1})
 * //=> Fri Apr 11 2014 00:00:00
 */
function parse (argument, dirtyOptions) {
  if (isDate(argument)) {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime())
  } else if (typeof argument !== 'string') {
    return new Date(argument)
  }

  var options = dirtyOptions || {}
  var additionalDigits = options.additionalDigits
  if (additionalDigits == null) {
    additionalDigits = DEFAULT_ADDITIONAL_DIGITS
  } else {
    additionalDigits = Number(additionalDigits)
  }

  var dateStrings = splitDateString(argument)

  var parseYearResult = parseYear(dateStrings.date, additionalDigits)
  var year = parseYearResult.year
  var restDateString = parseYearResult.restDateString

  var date = parseDate(restDateString, year)

  if (date) {
    var timestamp = date.getTime()
    var time = 0
    var offset

    if (dateStrings.time) {
      time = parseTime(dateStrings.time)
    }

    if (dateStrings.timezone) {
      offset = parseTimezone(dateStrings.timezone) * MILLISECONDS_IN_MINUTE
    } else {
      var fullTime = timestamp + time
      var fullTimeDate = new Date(fullTime)

      offset = getTimezoneOffsetInMilliseconds(fullTimeDate)

      // Adjust time when it's coming from DST
      var fullTimeDateNextDay = new Date(fullTime)
      fullTimeDateNextDay.setDate(fullTimeDate.getDate() + 1)
      var offsetDiff =
        getTimezoneOffsetInMilliseconds(fullTimeDateNextDay) -
        getTimezoneOffsetInMilliseconds(fullTimeDate)
      if (offsetDiff > 0) {
        offset += offsetDiff
      }
    }

    return new Date(timestamp + time + offset)
  } else {
    return new Date(argument)
  }
}

function splitDateString (dateString) {
  var dateStrings = {}
  var array = dateString.split(parseTokenDateTimeDelimeter)
  var timeString

  if (parseTokenPlainTime.test(array[0])) {
    dateStrings.date = null
    timeString = array[0]
  } else {
    dateStrings.date = array[0]
    timeString = array[1]
  }

  if (timeString) {
    var token = parseTokenTimezone.exec(timeString)
    if (token) {
      dateStrings.time = timeString.replace(token[1], '')
      dateStrings.timezone = token[1]
    } else {
      dateStrings.time = timeString
    }
  }

  return dateStrings
}

function parseYear (dateString, additionalDigits) {
  var parseTokenYYY = parseTokensYYY[additionalDigits]
  var parseTokenYYYYY = parseTokensYYYYY[additionalDigits]

  var token

  // YYYY or ±YYYYY
  token = parseTokenYYYY.exec(dateString) || parseTokenYYYYY.exec(dateString)
  if (token) {
    var yearString = token[1]
    return {
      year: parseInt(yearString, 10),
      restDateString: dateString.slice(yearString.length)
    }
  }

  // YY or ±YYY
  token = parseTokenYY.exec(dateString) || parseTokenYYY.exec(dateString)
  if (token) {
    var centuryString = token[1]
    return {
      year: parseInt(centuryString, 10) * 100,
      restDateString: dateString.slice(centuryString.length)
    }
  }

  // Invalid ISO-formatted year
  return {
    year: null
  }
}

function parseDate (dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) {
    return null
  }

  var token
  var date
  var month
  var week

  // YYYY
  if (dateString.length === 0) {
    date = new Date(0)
    date.setUTCFullYear(year)
    return date
  }

  // YYYY-MM
  token = parseTokenMM.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    date.setUTCFullYear(year, month)
    return date
  }

  // YYYY-DDD or YYYYDDD
  token = parseTokenDDD.exec(dateString)
  if (token) {
    date = new Date(0)
    var dayOfYear = parseInt(token[1], 10)
    date.setUTCFullYear(year, 0, dayOfYear)
    return date
  }

  // YYYY-MM-DD or YYYYMMDD
  token = parseTokenMMDD.exec(dateString)
  if (token) {
    date = new Date(0)
    month = parseInt(token[1], 10) - 1
    var day = parseInt(token[2], 10)
    date.setUTCFullYear(year, month, day)
    return date
  }

  // YYYY-Www or YYYYWww
  token = parseTokenWww.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    return dayOfISOYear(year, week)
  }

  // YYYY-Www-D or YYYYWwwD
  token = parseTokenWwwD.exec(dateString)
  if (token) {
    week = parseInt(token[1], 10) - 1
    var dayOfWeek = parseInt(token[2], 10) - 1
    return dayOfISOYear(year, week, dayOfWeek)
  }

  // Invalid ISO-formatted date
  return null
}

function parseTime (timeString) {
  var token
  var hours
  var minutes

  // hh
  token = parseTokenHH.exec(timeString)
  if (token) {
    hours = parseFloat(token[1].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR
  }

  // hh:mm or hhmm
  token = parseTokenHHMM.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseFloat(token[2].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE
  }

  // hh:mm:ss or hhmmss
  token = parseTokenHHMMSS.exec(timeString)
  if (token) {
    hours = parseInt(token[1], 10)
    minutes = parseInt(token[2], 10)
    var seconds = parseFloat(token[3].replace(',', '.'))
    return (hours % 24) * MILLISECONDS_IN_HOUR +
      minutes * MILLISECONDS_IN_MINUTE +
      seconds * 1000
  }

  // Invalid ISO-formatted time
  return null
}

function parseTimezone (timezoneString) {
  var token
  var absoluteOffset

  // Z
  token = parseTokenTimezoneZ.exec(timezoneString)
  if (token) {
    return 0
  }

  // ±hh
  token = parseTokenTimezoneHH.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  // ±hh:mm or ±hhmm
  token = parseTokenTimezoneHHMM.exec(timezoneString)
  if (token) {
    absoluteOffset = parseInt(token[2], 10) * 60 + parseInt(token[3], 10)
    return (token[1] === '+') ? -absoluteOffset : absoluteOffset
  }

  return 0
}

function dayOfISOYear (isoYear, week, day) {
  week = week || 0
  day = day || 0
  var date = new Date(0)
  date.setUTCFullYear(isoYear, 0, 4)
  var fourthOfJanuaryDay = date.getUTCDay() || 7
  var diff = week * 7 + day + 1 - fourthOfJanuaryDay
  date.setUTCDate(date.getUTCDate() + diff)
  return date
}

module.exports = parse


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.STATUS_UNAUTHORIZED = exports.CONTENT_TYPE_TEXT = exports.CONTENT_TYPE_JSON = exports.HEADER_CONTENT_TYPE = exports.HEADER_DISABLE_REDIRECT = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.isUnauthorized = isUnauthorized;
exports.callApi = callApi;

var _isomorphicFetch = __webpack_require__(195);

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _isPlainObject2 = __webpack_require__(41);

var _isPlainObject3 = _interopRequireDefault(_isPlainObject2);

var _qs = __webpack_require__(17);

var _qs2 = _interopRequireDefault(_qs);

var _rpAuth = __webpack_require__(197);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var HEADER_DISABLE_REDIRECT = exports.HEADER_DISABLE_REDIRECT = 'X-Disable-Redirect';
var HEADER_CONTENT_TYPE = exports.HEADER_CONTENT_TYPE = 'Content-Type';

var CONTENT_TYPE_JSON = exports.CONTENT_TYPE_JSON = 'application/json';
var CONTENT_TYPE_TEXT = exports.CONTENT_TYPE_TEXT = 'text/plain';

var STATUS_UNAUTHORIZED = exports.STATUS_UNAUTHORIZED = 401;

function isUnauthorized(resp) {
    return resp && resp.status === STATUS_UNAUTHORIZED;
}

function callApi(endpoint) {
    var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var query = _ref.query,
        body = _ref.body,
        otherInit = _objectWithoutProperties(_ref, ['query', 'body']);

    var init = _extends({}, otherInit, {
        credentials: 'include',
        headers: _extends({}, otherInit.headers, _defineProperty({}, HEADER_DISABLE_REDIRECT, true))
    });
    if (body) {
        init = _extends({
            method: 'POST' }, init, {
            body: (0, _isPlainObject3.default)(body) ? JSON.stringify(body) : body,
            headers: _extends({}, init.headers, _defineProperty({}, HEADER_CONTENT_TYPE, CONTENT_TYPE_JSON))
        });
    }
    var url = (0, _isPlainObject3.default)(query) ? endpoint + '?' + _qs2.default.stringify(query, { skipNulls: true }) : endpoint;
    return (0, _isomorphicFetch2.default)(url, init).then(function (resp) {
        if (resp.status === STATUS_UNAUTHORIZED) {
            if (resp.url.indexOf('shortlist') > -1) {
                (0, _rpAuth.checkForAccess)('SignIn', true, true, {
                    text: 'Please sign in to edit your shortlist'
                });
            } else {
                (0, _rpAuth.checkForAccess)('Subscriptions', true, true);
            }
        }
        if (!resp.ok) {
            return Promise.reject(resp);
        }

        var contentType = resp.headers.get(HEADER_CONTENT_TYPE);

        if (contentType.indexOf(CONTENT_TYPE_JSON) !== -1) return resp.json();
        if (contentType.indexOf(CONTENT_TYPE_TEXT) !== -1) return resp.text();

        return Promise.resolve(null);
    });
}

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(46);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 9 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindCode = exports.bind = exports.codes = undefined;

var _rpMqBreakpoints = __webpack_require__(24);

var _Breakpoints = __webpack_require__(171);

exports.codes = _rpMqBreakpoints.breakpointCodes;
exports.bind = _Breakpoints.bind;
exports.bindCode = _Breakpoints.bindCode;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21),
    getRawTag = __webpack_require__(106),
    objectToString = __webpack_require__(107);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 12 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CellRace = exports.CellDateSale = exports.CellHorseSireUGC = exports.CellHorseUGC = exports.CellPrice = exports.CellDamDamsSire = exports.CellDamsSire = exports.CellDam = exports.CellSire = exports.CellHorse = exports.CellLot = undefined;

var _CellLot = __webpack_require__(264);

var _CellLot2 = _interopRequireDefault(_CellLot);

var _CellHorse = __webpack_require__(77);

var _CellHorse2 = _interopRequireDefault(_CellHorse);

var _CellSire = __webpack_require__(78);

var _CellSire2 = _interopRequireDefault(_CellSire);

var _CellDam = __webpack_require__(79);

var _CellDam2 = _interopRequireDefault(_CellDam);

var _CellDamsSire = __webpack_require__(80);

var _CellDamsSire2 = _interopRequireDefault(_CellDamsSire);

var _CellDamDamsSire = __webpack_require__(270);

var _CellDamDamsSire2 = _interopRequireDefault(_CellDamDamsSire);

var _CellPrice = __webpack_require__(271);

var _CellPrice2 = _interopRequireDefault(_CellPrice);

var _CellHorseUGC = __webpack_require__(81);

var _CellHorseUGC2 = _interopRequireDefault(_CellHorseUGC);

var _CellHorseSireUGC = __webpack_require__(282);

var _CellHorseSireUGC2 = _interopRequireDefault(_CellHorseSireUGC);

var _CellDateSale = __webpack_require__(283);

var _CellDateSale2 = _interopRequireDefault(_CellDateSale);

var _CellRace = __webpack_require__(284);

var _CellRace2 = _interopRequireDefault(_CellRace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.CellLot = _CellLot2.default;
exports.CellHorse = _CellHorse2.default;
exports.CellSire = _CellSire2.default;
exports.CellDam = _CellDam2.default;
exports.CellDamsSire = _CellDamsSire2.default;
exports.CellDamDamsSire = _CellDamDamsSire2.default;
exports.CellPrice = _CellPrice2.default;
exports.CellHorseUGC = _CellHorseUGC2.default;
exports.CellHorseSireUGC = _CellHorseSireUGC2.default;
exports.CellDateSale = _CellDateSale2.default;
exports.CellRace = _CellRace2.default;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(105),
    getValue = __webpack_require__(110);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isObject = __webpack_require__(16);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 16 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 17 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_17__;

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TableToggle = exports.TableCell = exports.TableRowConstructor = exports.TableRow = exports.TableBody = exports.TableHeadCell = exports.TableHead = exports.default = undefined;

var _Table = __webpack_require__(241);

var _Table2 = _interopRequireDefault(_Table);

var _TableHead = __webpack_require__(72);

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TableHeadCell = __webpack_require__(73);

var _TableHeadCell2 = _interopRequireDefault(_TableHeadCell);

var _TableBody = __webpack_require__(75);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableRow = __webpack_require__(27);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableRowConstructor = __webpack_require__(76);

var _TableRowConstructor2 = _interopRequireDefault(_TableRowConstructor);

var _TableCell = __webpack_require__(28);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableToggle = __webpack_require__(261);

var _TableToggle2 = _interopRequireDefault(_TableToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Table2.default;
exports.TableHead = _TableHead2.default;
exports.TableHeadCell = _TableHeadCell2.default;
exports.TableBody = _TableBody2.default;
exports.TableRow = _TableRow2.default;
exports.TableRowConstructor = _TableRowConstructor2.default;
exports.TableCell = _TableCell2.default;
exports.TableToggle = _TableToggle2.default;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(95),
    listCacheDelete = __webpack_require__(96),
    listCacheGet = __webpack_require__(97),
    listCacheHas = __webpack_require__(98),
    listCacheSet = __webpack_require__(99);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(33);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(119);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 24 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_24__;

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isObjectLike = __webpack_require__(12);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(63);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TableRow;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TableRow(_ref) {
    var className = _ref.className,
        otherProps = _objectWithoutProperties(_ref, ['className']);

    return _react2.default.createElement('tr', _extends({
        className: (0, _classnames2.default)('ui-table__row', className)
    }, otherProps));
}

TableRow.propTypes = {
    className: _propTypes2.default.string
};

TableRow.defaultProps = {
    className: ''
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TableCell;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TableCell(_ref) {
    var className = _ref.className,
        otherProps = _objectWithoutProperties(_ref, ['className']);

    return _react2.default.createElement('td', _extends({
        className: (0, _classnames2.default)('ui-table__cell', className)
    }, otherProps));
}

TableCell.propTypes = {
    className: _propTypes2.default.string
};

TableCell.defaultProps = {
    className: ''
};

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ProfileLink = __webpack_require__(265);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ProfileLink2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.catalogueUrl = catalogueUrl;
exports.statisticsUrl = statisticsUrl;
exports.lotUrl = lotUrl;
exports.profileUrl = profileUrl;
exports.raceUrl = raceUrl;
exports.queryUrl = queryUrl;

var _qs = __webpack_require__(17);

var _qs2 = _interopRequireDefault(_qs);

var _url = __webpack_require__(266);

var _url2 = _interopRequireDefault(_url);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Build URL for catalogue page
 *
 * @param {number} uid Sales venue UID
 * @param {string} date Sales start date YYYY-MM-DD
 * @param {object} [queryParams]
 * @returns {string} URL
 */
function catalogueUrl(uid, date) {
    var queryParams = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var catUrl = 'catalogues/' + uid + '/' + date;
    if (queryParams) {
        catUrl += '?' + _qs2.default.stringify(queryParams);
    }

    return catUrl;
}

/**
 * Build URL for statistics page
 *
 * @param {number} uid Sales venue UID
 * @param {string} date Sales start date YYYY-MM-DD
 * @returns {string} URL
 */
function statisticsUrl(uid, date) {
    return 'statistics/' + uid + '/' + date;
}

/**
 * Build URL to concrete lot
 *
 * @param {number} uid Sales venue UID
 * @param {string} date Sales start date YYYY-MM-DD
 * @param {number} lot Lot number
 * @param {string} letter Lot letter
 * @returns {string} URL
 */
function lotUrl(uid, date, lot, letter) {
    return 'catalogues/' + uid + '/' + date + '?lot=' + lot + '&letter=' + encodeURIComponent(letter);
}

/**
 * Build URL to horses/humans profiles
 *
 * @param {string} type Profile type
 * @param {number} id Profile ID
 * @param {string} name Profile style name
 * @returns {string}
 */
function profileUrl(type, id, name) {
    if (!type || !id || !name) {
        return '';
    }

    var urlName = name.toLowerCase().replace(/[^\w\s-]/g, '').replace(/[\s_]+/g, '-');

    return '/profile/' + type + '/' + id + '/' + urlName;
}

/**
 * Build URL to race card
 *
 * @param {number} courseId courseId
 * @param {string} courseName courseName
  * @param {string} raceDate raceDate
 * @param {number} raceId raceId
 * @returns {string}
 */
function raceUrl(courseId, courseName, raceDate, raceId) {
    if (!courseId || !courseName || !raceDate || !raceId) {
        return '';
    }

    var urlName = courseName.toLowerCase().replace(/[^\w\s-]/g, '').replace(/[\s_]+/g, '-');

    return '/racecards/' + courseId + '/' + urlName + '/' + raceDate + '/' + raceId;
}

/**
 * Build URL with given query params
 *
 * @param {string} baseUrl
 * @param {{}} params Query parameters
 * @returns {string}
 */
function queryUrl(baseUrl, params) {
    var parsedUrl = _url2.default.parse(baseUrl);
    var query = _qs2.default.parse(parsedUrl.query || parsedUrl.search);

    return _url2.default.format(Object.assign(parsedUrl, {
        search: _qs2.default.stringify(Object.assign(query, params))
    }));
}

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesTab = __webpack_require__(289);

var _RelativesTab2 = _interopRequireDefault(_RelativesTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesTab2.default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(44);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 33 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(111),
    mapCacheDelete = __webpack_require__(118),
    mapCacheGet = __webpack_require__(120),
    mapCacheHas = __webpack_require__(121),
    mapCacheSet = __webpack_require__(122);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(138),
    baseKeys = __webpack_require__(146),
    isArrayLike = __webpack_require__(56);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 37 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(159)
var getISOWeek = __webpack_require__(163)
var getISOYear = __webpack_require__(60)
var parse = __webpack_require__(6)
var isValid = __webpack_require__(166)
var enLocale = __webpack_require__(167)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(164)

/**
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO week
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * var result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek (dirtyDate) {
  return startOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = startOfISOWeek


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(62),
    isObject = __webpack_require__(16),
    isSymbol = __webpack_require__(25);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    getPrototype = __webpack_require__(196),
    isObjectLike = __webpack_require__(12);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getCatalogueItemSafe = exports.getDefaultCatalogueItem = exports.findCatalogueItem = exports.submitNote = exports.fetchNote = exports.toggleNote = exports.toggleShortlist = exports.bindCatalogue = undefined;

var _UGC = __webpack_require__(274);

var _ugc = __webpack_require__(82);

exports.bindCatalogue = _UGC.bindCatalogue;
exports.toggleShortlist = _UGC.toggleShortlist;
exports.toggleNote = _UGC.toggleNote;
exports.fetchNote = _UGC.fetchNote;
exports.submitNote = _UGC.submitNote;
exports.findCatalogueItem = _ugc.findCatalogueItem;
exports.getDefaultCatalogueItem = _ugc.getDefaultCatalogueItem;
exports.getCatalogueItemSafe = _ugc.getCatalogueItemSafe;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Dialog = exports.Backdrop = exports.default = undefined;

var _Lightbox = __webpack_require__(325);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _LightboxBackdrop = __webpack_require__(86);

var _LightboxBackdrop2 = _interopRequireDefault(_LightboxBackdrop);

var _LightboxDialog = __webpack_require__(87);

var _LightboxDialog2 = _interopRequireDefault(_LightboxDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Lightbox2.default;
exports.Backdrop = _LightboxBackdrop2.default;
exports.Dialog = _LightboxDialog2.default;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(94),
    isObjectLike = __webpack_require__(12);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(19),
    stackClear = __webpack_require__(100),
    stackDelete = __webpack_require__(101),
    stackGet = __webpack_require__(102),
    stackHas = __webpack_require__(103),
    stackSet = __webpack_require__(104);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(47)))

/***/ }),
/* 47 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 48 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(123),
    arraySome = __webpack_require__(126),
    cacheHas = __webpack_require__(127);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 50 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(8),
    stubFalse = __webpack_require__(142);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)(module)))

/***/ }),
/* 52 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(143),
    baseUnary = __webpack_require__(144),
    nodeUtil = __webpack_require__(145);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 54 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 55 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 56 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(15),
    isLength = __webpack_require__(54);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(149),
    Map = __webpack_require__(34),
    Promise = __webpack_require__(150),
    Set = __webpack_require__(151),
    WeakMap = __webpack_require__(152),
    baseGetTag = __webpack_require__(11),
    toSource = __webpack_require__(48);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 58 */
/***/ (function(module, exports) {

/**
 * @category Common Helpers
 * @summary Is the given argument an instance of Date?
 *
 * @description
 * Is the given argument an instance of Date?
 *
 * @param {*} argument - the argument to check
 * @returns {Boolean} the given argument is an instance of Date
 *
 * @example
 * // Is 'mayonnaise' a Date?
 * var result = isDate('mayonnaise')
 * //=> false
 */
function isDate (argument) {
  return argument instanceof Date
}

module.exports = isDate


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)
var getDaysInMonth = __webpack_require__(158)

/**
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added
 * @returns {Date} the new date with the months added
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * var result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  var desiredMonth = date.getMonth() + amount
  var dateWithDesiredMonth = new Date(0)
  dateWithDesiredMonth.setFullYear(date.getFullYear(), desiredMonth, 1)
  dateWithDesiredMonth.setHours(0, 0, 0, 0)
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth)
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(desiredMonth, Math.min(daysInMonth, date.getDate()))
  return date
}

module.exports = addMonths


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)
var startOfISOWeek = __webpack_require__(39)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * var result = getISOYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()

  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear)

  var fourthOfJanuaryOfThisYear = new Date(0)
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4)
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0)
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear)

  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year
  } else {
    return year - 1
  }
}

module.exports = getISOYear


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Pagination = __webpack_require__(172);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Pagination2.default;

/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(178);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21),
    arrayMap = __webpack_require__(64),
    isArray = __webpack_require__(9),
    isSymbol = __webpack_require__(25);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 64 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(192);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 66 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(193),
    hasUnicode = __webpack_require__(66),
    unicodeToArray = __webpack_require__(194);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 68 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_68__;

/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FiltersToggle = exports.FiltersSelect = exports.FiltersReset = exports.FiltersNav = exports.FiltersInput = undefined;

var _Input = __webpack_require__(198);

var _Input2 = _interopRequireDefault(_Input);

var _Nav = __webpack_require__(205);

var _Nav2 = _interopRequireDefault(_Nav);

var _Reset = __webpack_require__(213);

var _Reset2 = _interopRequireDefault(_Reset);

var _Select = __webpack_require__(215);

var _Select2 = _interopRequireDefault(_Select);

var _Toggle = __webpack_require__(220);

var _Toggle2 = _interopRequireDefault(_Toggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.FiltersInput = _Input2.default;
exports.FiltersNav = _Nav2.default;
exports.FiltersReset = _Reset2.default;
exports.FiltersSelect = _Select2.default;
exports.FiltersToggle = _Toggle2.default;

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Input = __webpack_require__(200);

var _Input2 = _interopRequireDefault(_Input);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Input2.default;

/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkbox = __webpack_require__(231);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Checkbox2.default;

/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableHead;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableHead(props) {
    return _react2.default.createElement('thead', props);
}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TableHeadCell;

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TableHeadSortIcon = __webpack_require__(253);

var _TableHeadSortIcon2 = _interopRequireDefault(_TableHeadSortIcon);

var _TableHead = __webpack_require__(74);

var _TableHead2 = _interopRequireDefault(_TableHead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TableHeadCell(_ref) {
    var className = _ref.className,
        children = _ref.children,
        type = _ref.type,
        sorting = _ref.sorting,
        sortable = _ref.sortable,
        otherProps = _objectWithoutProperties(_ref, ['className', 'children', 'type', 'sorting', 'sortable']);

    return _react2.default.createElement(
        'th',
        _extends({
            className: (0, _classnames3.default)('ui-table__cell', _defineProperty({}, _TableHead2.default.cell_unsortable, !sortable),
            // ui-table__cell_sorted describes styles only for table type 1
            { 'ui-table__cell_sorted': type === 1 && sorting }, className)
        }, otherProps),
        children,
        type === 5 && _react2.default.createElement(_TableHeadSortIcon2.default, {
            className: _TableHead2.default.cell__sortIcon,
            direction: sorting
        })
    );
}

TableHeadCell.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    type: _propTypes2.default.number.isRequired,
    sorting: _propTypes2.default.string,
    sortable: _propTypes2.default.bool.isRequired
};

TableHeadCell.defaultProps = {
    className: '',
    children: null,
    sorting: null
};

/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(254);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableHead.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableHead.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TableBody;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function TableBody(_ref) {
    var rootRef = _ref.rootRef,
        otherProps = _objectWithoutProperties(_ref, ['rootRef']);

    return _react2.default.createElement('tbody', _extends({
        ref: rootRef
    }, otherProps));
}

TableBody.propTypes = {
    rootRef: _propTypes2.default.func
};

TableBody.defaultProps = {
    rootRef: null
};

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = TableRowConstructor;

var _isFunction = __webpack_require__(15);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isPlainObject = __webpack_require__(41);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TableCell = __webpack_require__(28);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableRow = __webpack_require__(27);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableRowConstructor = __webpack_require__(259);

var _TableRowConstructor2 = _interopRequireDefault(_TableRowConstructor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableRowConstructor(_ref) {
    var children = _ref.children,
        type = _ref.type,
        columns = _ref.columns,
        data = _ref.data,
        identity = _ref.identity,
        expanded = _ref.expanded,
        onToggle = _ref.onToggle;

    var row = _react2.default.createElement(
        _TableRow2.default,
        null,
        columns.map(function (column) {
            if (!column.cell) {
                return _react2.default.createElement(
                    _TableCell2.default,
                    {
                        key: column.name,
                        className: column.className
                    },
                    data[column.name]
                );
            }

            if ((0, _isPlainObject2.default)(column.cell)) {
                return _react2.default.createElement(
                    _TableCell2.default,
                    _extends({
                        key: column.name,
                        className: column.className
                    }, column.cell),
                    function () {
                        if ((0, _isFunction2.default)(column.cell.children)) {
                            var Children = column.cell.children;
                            return _react2.default.createElement(Children, {
                                column: column,
                                data: data,
                                identity: identity,
                                expanded: expanded,
                                onToggle: onToggle
                            });
                        }
                        return data[column.name];
                    }()
                );
            }

            var Cell = column.cell;
            if ((0, _isFunction2.default)(Cell)) {
                return _react2.default.createElement(Cell, {
                    key: column.name,
                    className: column.className,
                    column: column,
                    data: data,
                    identity: identity,
                    expanded: expanded,
                    onToggle: onToggle
                });
            }

            throw new Error('Column ' + column.name + ' has invalid cell ' + column.cell);
        })
    );

    if (!expanded) {
        return row;
    }

    return _react2.default.createElement(
        'tr',
        { className: 'ui-table__row' },
        _react2.default.createElement(
            'td',
            { className: _TableRowConstructor2.default.expansion__cell, colSpan: columns.length },
            _react2.default.createElement(
                'table',
                {
                    className: _TableRowConstructor2.default.expansion__table + ' ui-table ui-table_type' + type
                },
                _react2.default.createElement(
                    'tbody',
                    null,
                    row
                )
            ),
            function () {
                if (_react2.default.isValidElement(children)) {
                    return children;
                }

                if ((0, _isFunction2.default)(children)) {
                    var Children = children;
                    return _react2.default.createElement(Children, {
                        data: data,
                        identity: identity,
                        onToggle: onToggle
                    });
                }

                throw new Error('Row has invalid children ' + children);
            }()
        )
    );
}

TableRowConstructor.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
    type: _propTypes2.default.number.isRequired,
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        className: _propTypes2.default.string,
        name: _propTypes2.default.string.isRequired,
        cell: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.node, _propTypes2.default.func])
    })).isRequired,
    data: _propTypes2.default.object.isRequired, // eslint-disable-line react/forbid-prop-types
    identity: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    expanded: _propTypes2.default.bool,
    onToggle: _propTypes2.default.func
};

TableRowConstructor.defaultProps = {
    children: null,
    expanded: false,
    onToggle: function onToggle() {
        return null;
    }
};

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = CellHorse;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(29);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function CellHorse(_ref) {
    var data = _ref.data,
        otherProps = _objectWithoutProperties(_ref, ['data']);

    return _react2.default.createElement(
        _ProfileLink2.default,
        _extends({
            type: _ProfileLink2.default.TYPE_HORSE,
            uid: data.horse_uid,
            name: data.horse_style_name
        }, otherProps),
        data.horse_name || data.horse_style_name
    );
}

CellHorse.propTypes = {
    data: _propTypes2.default.shape({
        horse_uid: _propTypes2.default.number,
        horse_name: _propTypes2.default.string,
        horse_style_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = CellSire;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(29);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function CellSire(_ref) {
    var data = _ref.data,
        otherProps = _objectWithoutProperties(_ref, ['data']);

    return _react2.default.createElement(
        _ProfileLink2.default,
        _extends({
            type: _ProfileLink2.default.TYPE_HORSE,
            uid: data.sire_uid,
            name: data.sire_style_name
        }, otherProps),
        data.sire_name || data.sire_style_name
    );
}

CellSire.propTypes = {
    data: _propTypes2.default.shape({
        sire_uid: _propTypes2.default.number,
        sire_name: _propTypes2.default.string,
        sire_style_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellDam;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(29);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellDam(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        _ProfileLink2.default,
        {
            type: _ProfileLink2.default.TYPE_HORSE,
            uid: data.dam_uid,
            name: data.dam_style_name
        },
        data.dam_style_name
    );
}

CellDam.propTypes = {
    data: _propTypes2.default.shape({
        dam_uid: _propTypes2.default.number,
        dam_style_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellDamsSire;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(29);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellDamsSire(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        _ProfileLink2.default,
        {
            type: 'horse',
            uid: data.sire_of_dam_uid,
            name: data.sire_of_dam_style_name || data.sire_of_dam_name
        },
        data.sire_of_dam_name || data.sire_of_dam_style_name
    );
}

CellDamsSire.propTypes = {
    data: _propTypes2.default.shape({
        sire_of_dam_uid: _propTypes2.default.number,
        sire_of_dam_name: _propTypes2.default.string,
        sire_of_dam_style_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CellHorseUGCComponent = CellHorseUGCComponent;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _UGC = __webpack_require__(42);

var _CellHorse = __webpack_require__(77);

var _CellHorse2 = _interopRequireDefault(_CellHorse);

var _CellHorseUGC = __webpack_require__(280);

var _CellHorseUGC2 = _interopRequireDefault(_CellHorseUGC);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellHorseUGCComponent(_ref) {
    var children = _ref.children,
        data = _ref.data,
        shortlist = _ref.shortlist,
        note = _ref.note,
        expanded = _ref.expanded;

    return _react2.default.createElement(
        'div',
        { className: _CellHorseUGC2.default.root },
        _react2.default.createElement(
            'div',
            { className: _CellHorseUGC2.default.horse },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_CellHorse2.default, {
                    data: data,
                    bold: true
                })
            ),
            children && _react2.default.createElement(
                'div',
                null,
                children
            )
        ),
        !expanded && _react2.default.createElement(
            'div',
            { className: _CellHorseUGC2.default.ugc },
            shortlist && _react2.default.createElement(_rpReactSvgIcon2.default, {
                className: _CellHorseUGC2.default.icon,
                iconName: 'starFilled',
                size: 'Medium'
            }),
            note && _react2.default.createElement(_rpReactSvgIcon2.default, {
                className: _CellHorseUGC2.default.icon,
                iconName: 'note-dark',
                size: 'Medium'
            })
        )
    );
}

CellHorseUGCComponent.propTypes = {
    children: _propTypes2.default.node,
    data: _propTypes2.default.shape({
        venue_uid: _propTypes2.default.number.isRequired,
        sale_date_raw: _propTypes2.default.string.isRequired,
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string.isRequired
    }).isRequired,
    shortlist: _propTypes2.default.bool,
    note: _propTypes2.default.bool,
    expanded: _propTypes2.default.bool
};

CellHorseUGCComponent.defaultProps = {
    children: null,
    shortlist: false,
    note: false,
    expanded: false
};

exports.default = (0, _UGC.bindCatalogue)(CellHorseUGCComponent, function (catalogue, ownProps) {
    var _ownProps$data = ownProps.data,
        venue_uid = _ownProps$data.venue_uid,
        sale_date_raw = _ownProps$data.sale_date_raw,
        lot_no = _ownProps$data.lot_no,
        lot_letter = _ownProps$data.lot_letter;

    var _getCatalogueItemSafe = (0, _UGC.getCatalogueItemSafe)(catalogue, venue_uid, sale_date_raw, lot_no, lot_letter),
        shortlist = _getCatalogueItemSafe.shortlist,
        note = _getCatalogueItemSafe.note;

    return { shortlist: shortlist, note: note };
});

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.findCatalogueItem = findCatalogueItem;
exports.getDefaultCatalogueItem = getDefaultCatalogueItem;
exports.getCatalogueItemSafe = getCatalogueItemSafe;

var _isMatch2 = __webpack_require__(276);

var _isMatch3 = _interopRequireDefault(_isMatch2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function findCatalogueItem(catalogue, venueId, saleDate, lotNo, lotLetter) {
    return catalogue.find(function (item) {
        return (0, _isMatch3.default)(item, { venueId: venueId, saleDate: saleDate, lotNo: lotNo, lotLetter: lotLetter });
    });
}

function getDefaultCatalogueItem(venueId, saleDate, lotNo, lotLetter) {
    return {
        venueId: venueId,
        saleDate: saleDate,
        lotNo: lotNo,
        lotLetter: lotLetter,
        shortlist: false,
        note: false
    };
}

function getCatalogueItemSafe(catalogue, venueId, saleDate, lotNo, lotLetter) {
    return findCatalogueItem(catalogue, venueId, saleDate, lotNo, lotLetter) || getDefaultCatalogueItem(venueId, saleDate, lotNo, lotLetter);
}

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesRow = __webpack_require__(287);

var _RelativesRow2 = _interopRequireDefault(_RelativesRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesRow2.default;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Relatives = __webpack_require__(288);

var _Relatives2 = _interopRequireDefault(_Relatives);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Relatives2.default;

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(314),
    baseIsNaN = __webpack_require__(315),
    strictIndexOf = __webpack_require__(316);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactDom = __webpack_require__(68);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Backdrop = function (_PureComponent) {
    _inherits(Backdrop, _PureComponent);

    function Backdrop() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Backdrop);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Backdrop.__proto__ || Object.getPrototypeOf(Backdrop)).call.apply(_ref, [this].concat(args))), _this), _this.container = document.getElementById('lightbox'), _this.handleOverlayClick = function (ev) {
            if (ev.target === _this.rootRef || ev.target === _this.containerRef) {
                _this.props.onClose();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Backdrop, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (this.props.open) {
                this.manipulate(true);
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var open = _ref2.open;

            if (this.props.open !== open) {
                this.manipulate(open);
            }
        }
    }, {
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate() {
            return false;
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this.manipulate(false);
        }
    }, {
        key: 'manipulate',
        value: function manipulate(open) {
            var _this2 = this;

            if (open) {
                /* eslint-disable jsx-a11y/no-static-element-interactions */
                _reactDom2.default.render(_react2.default.createElement(
                    'div',
                    {
                        ref: function ref(_ref4) {
                            _this2.rootRef = _ref4;
                        },
                        className: 'ui-overlay',
                        onClick: this.handleOverlayClick
                    },
                    _react2.default.createElement(
                        'div',
                        {
                            ref: function ref(_ref3) {
                                _this2.containerRef = _ref3;
                            },
                            className: 'ui-overlay__container'
                        },
                        this.props.children
                    )
                ), this.container);
                /* eslint-enable jsx-a11y/no-static-element-interactions */
            } else {
                _reactDom2.default.unmountComponentAtNode(this.container);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return Backdrop;
}(_react.PureComponent);

Backdrop.propTypes = {
    children: _propTypes2.default.node.isRequired,
    open: _propTypes2.default.bool,
    onClose: _propTypes2.default.func
};
Backdrop.defaultProps = {
    open: false,
    onClose: null
};
exports.default = Backdrop;

/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Dialog;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _LightboxDialog = __webpack_require__(326);

var _LightboxDialog2 = _interopRequireDefault(_LightboxDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Dialog(_ref) {
    var children = _ref.children,
        closeButton = _ref.closeButton,
        onClose = _ref.onClose;

    return _react2.default.createElement(
        'div',
        { className: 'ui-modal' },
        closeButton && _react2.default.createElement(
            'button',
            {
                className: _LightboxDialog2.default.closeButton,
                onClick: onClose
            },
            _react2.default.createElement(_rpReactSvgIcon2.default, {
                className: _LightboxDialog2.default.closeButtonIcon,
                iconName: 'cross',
                size: 'Medium'
            })
        ),
        _react2.default.createElement(
            'div',
            { className: 'ui-modal__canvas' },
            children
        )
    );
}

Dialog.propTypes = {
    children: _propTypes2.default.node,
    closeButton: _propTypes2.default.bool,
    onClose: _propTypes2.default.func
};

Dialog.defaultProps = {
    children: null,
    closeButton: true,
    onClose: null
};

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(349);


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getValues = exports.getValue = exports.getStatusLabels = exports.getStatusLabel = exports.getLabels = exports.getLabel = exports.getOptions = exports.getOption = exports.setSelected = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _entries = __webpack_require__(88);

var _entries2 = _interopRequireDefault(_entries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setSelected = exports.setSelected = function setSelected(arr, value) {
    return arr.map(function (item) {
        return item.value === value ? _extends({}, item, { selected: true }) : item;
    });
};

var getOption = exports.getOption = function getOption(category) {
    return (category.options || []).find(function (item) {
        return item.selected;
    }) || {};
};

var getOptions = exports.getOptions = function getOptions(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            category = _ref2[1];

        res[key] = getOption(category);
    });
    return res;
};

var getLabel = exports.getLabel = function getLabel(category) {
    return getOption(category).label;
};

var getLabels = exports.getLabels = function getLabels(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            key = _ref4[0],
            category = _ref4[1];

        res[key] = getLabel(category);
    });
    return res;
};

var getStatusLabel = exports.getStatusLabel = function getStatusLabel(category) {
    var _getOption = getOption(category),
        statusLabel = _getOption.statusLabel,
        label = _getOption.label;

    return statusLabel || label;
};

var getStatusLabels = exports.getStatusLabels = function getStatusLabels(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            key = _ref6[0],
            category = _ref6[1];

        res[key] = !category.isHidden ? getStatusLabel(category) : null;
    });
    return res;
};

var getValue = exports.getValue = function getValue(category) {
    return getOption(category).value;
};

var getValues = exports.getValues = function getValues(categories) {
    var res = {};
    (0, _entries2.default)(categories).forEach(function (_ref7) {
        var _ref8 = _slicedToArray(_ref7, 2),
            key = _ref8[0],
            category = _ref8[1];

        res[key] = getValue(category);
    });
    return res;
};

exports.default = {
    setSelected: setSelected,
    getOption: getOption,
    getOptions: getOptions,
    getLabel: getLabel,
    getLabels: getLabels,
    getStatusLabel: getStatusLabel,
    getStatusLabels: getStatusLabels,
    getValue: getValue,
    getValues: getValues
};

/***/ }),
/* 90 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.callApi = exports.bindBreakpointCode = exports.bindBreakpoints = exports.getUGCCatalogueItemSafe = exports.bindUGCCatalogue = exports.Lightbox = exports.Relatives = exports.SearchResults = exports.SearchEntries = undefined;

var _Search = __webpack_require__(91);

var _Relatives = __webpack_require__(84);

var _Relatives2 = _interopRequireDefault(_Relatives);

var _Lightbox = __webpack_require__(43);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _UGC = __webpack_require__(42);

var _Breakpoints = __webpack_require__(10);

var _api = __webpack_require__(7);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SearchEntries = _Search.SearchEntries;
exports.SearchResults = _Search.SearchResults;
exports.Relatives = _Relatives2.default;
exports.Lightbox = _Lightbox2.default;
exports.bindUGCCatalogue = _UGC.bindCatalogue;
exports.getUGCCatalogueItemSafe = _UGC.getCatalogueItemSafe;
exports.bindBreakpoints = _Breakpoints.bind;
exports.bindBreakpointCode = _Breakpoints.bindCode;
exports.callApi = _api.callApi;

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SearchEntries = exports.SearchResults = undefined;

var _Results = __webpack_require__(92);

var _Results2 = _interopRequireDefault(_Results);

var _Entries = __webpack_require__(381);

var _Entries2 = _interopRequireDefault(_Entries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SearchResults = _Results2.default;
exports.SearchEntries = _Entries2.default;

/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchResults = __webpack_require__(93);

var _SearchResults2 = _interopRequireDefault(_SearchResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SearchResults2.default;

/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isEqual2 = __webpack_require__(32);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _difference_in_months = __webpack_require__(153);

var _difference_in_months2 = _interopRequireDefault(_difference_in_months);

var _add_days = __webpack_require__(157);

var _add_days2 = _interopRequireDefault(_add_days);

var _add_months = __webpack_require__(59);

var _add_months2 = _interopRequireDefault(_add_months);

var _format = __webpack_require__(38);

var _format2 = _interopRequireDefault(_format);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Breakpoints = __webpack_require__(10);

var _Pagination = __webpack_require__(61);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _SearchResultsFilters = __webpack_require__(188);

var _SearchResultsFilters2 = _interopRequireDefault(_SearchResultsFilters);

var _SearchResultsTable = __webpack_require__(240);

var _SearchResultsTable2 = _interopRequireDefault(_SearchResultsTable);

var _Lightbox = __webpack_require__(375);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _api = __webpack_require__(7);

var _SearchResults = __webpack_require__(379);

var _SearchResults2 = _interopRequireDefault(_SearchResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var ERROR_MESSAGE_REFINE = 'No lots found matching your search. ' + 'Use the reset button to clear your search and start again';
var ERROR_MESSAGE_RANGE = 'No lots found for the selected date range';

var DATE_FORMAT = 'YYYY-MM-DD';

function isRefinementBroad(_ref) {
    var from = _ref.from,
        to = _ref.to,
        otherRefinement = _objectWithoutProperties(_ref, ['from', 'to']);

    // Date range is longer than a month
    // and filters Sale, Vendor, Horse, Sire, Dam, Dam Sire are empty
    return (0, _difference_in_months2.default)(to, (0, _add_days2.default)(from, 1)) > 0 && ['sale', 'vendor', 'buyer', 'name', 'sire', 'dam', 'damSire'].every(function (prop) {
        return !otherRefinement[prop];
    });
}

var SearchResults = function (_PureComponent) {
    _inherits(SearchResults, _PureComponent);

    function SearchResults() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchResults);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SearchResults.__proto__ || Object.getPrototypeOf(SearchResults)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            lightbox: false,
            fetching: false,
            fetchFailed: false,
            filtersUsed: false,
            totalLotsNum: SearchResults.getInitialTotalLotsNum(),
            totalPagesNum: SearchResults.getInitialTotalPagesNum(),
            filters: _this.getInitialFilters(),
            page: SearchResults.getInitialPage(),
            data: SearchResults.getInitialData(),
            header: [],
            expansion: null,
            sort: 'lot_no'
        }, _this.isFiltersUsed = function () {
            return (0, _isEqual3.default)(_this.getInitialFilters(), _this.state.filters);
        }, _this.isSortable = function (sort) {
            return _this.state.header.find(function (headerCellData) {
                return headerCellData.name === sort && headerCellData.sortLink;
            });
        }, _this.isDateRangeInitial = function () {
            var _this$state$filters = _this.state.filters,
                from = _this$state$filters.from,
                to = _this$state$filters.to;

            var _this$getInitialFilte = _this.getInitialFilters(),
                initialRangeFrom = _this$getInitialFilte.from,
                initialRangeTo = _this$getInitialFilte.to;

            return initialRangeFrom === from && initialRangeTo === to;
        }, _this.handleFiltersChange = function (filters, next) {
            _this.setState({ filters: filters }, function () {
                if (next) {
                    next();
                }
            });
        }, _this.handleFiltersReset = function () {
            _this.setState({
                filters: _this.getInitialFilters(),
                filtersUsed: false,
                data: SearchResults.getInitialData(),
                page: SearchResults.getInitialPage(),
                totalLotsNum: SearchResults.getInitialTotalLotsNum(),
                totalPagesNum: SearchResults.getInitialTotalPagesNum()
            });
        }, _this.handleFiltersSearch = function () {
            if (isRefinementBroad(_this.state.filters)) {
                _this.setState({ lightbox: true });
                return Promise.reject();
            }

            return _this.fetchData({
                filters: _this.state.filters,
                page: SearchResults.getInitialPage()
            }).then(function () {
                _this.setState({
                    filtersUsed: true
                });
            });
        }, _this.handleTableToggle = function (expansion) {
            return _this.setState({
                expansion: expansion === _this.state.expansion ? null : expansion
            });
        }, _this.handleTableSort = function (sort) {
            return _this.fetchData({ sort: sort });
        }, _this.handlePageChange = function (page) {
            return _this.fetchData({ page: page });
        }, _this.handleLightboxClose = function () {
            return _this.setState({ lightbox: false });
        }, _this.createErrorMessage = function () {
            if (!_this.isDateRangeInitial()) {
                return ERROR_MESSAGE_RANGE;
            } else if (!_this.isFiltersUsed()) {
                return ERROR_MESSAGE_REFINE;
            }
            return ERROR_MESSAGE_RANGE;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchResults, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            // fetching the data after page being loaded on profiles
            var _props = this.props,
                sireName = _props.sireName,
                from = _props.from,
                to = _props.to;

            if (sireName && from && to) {
                this.fetchData().then(function () {
                    return _this2.setState({ filtersUsed: true });
                });
            }
        }
    }, {
        key: 'getInitialFilters',
        value: function getInitialFilters() {
            var _props2 = this.props,
                from = _props2.from,
                to = _props2.to,
                sireName = _props2.sireName;

            return {
                from: from || (0, _format2.default)((0, _add_months2.default)(new Date(), -1), DATE_FORMAT),
                to: to || (0, _format2.default)(new Date(), DATE_FORMAT),
                sale: '',
                saleCompany: null,
                sex: null,
                age: null,
                name: '',
                sire: sireName,
                dam: '',
                damSire: '',
                vendor: '',
                buyer: '',
                resultsWithSold: false,
                minPrice: null,
                maxPrice: null
            };
        }
    }, {
        key: 'fetchData',
        value: function fetchData(params) {
            var _this3 = this;

            var _state$params = _extends({}, this.state, params),
                filters = _state$params.filters,
                sort = _state$params.sort,
                page = _state$params.page;

            this.setState({ sort: sort, page: page, fetching: true });
            var sireName = this.props.sireName;

            var query = {
                sort: sort,
                page: page,
                q: Object.keys(filters).reduce(function (result, key) {
                    var value = key === _SearchResultsFilters.FILTERS_PROP_SIRE && sireName ? sireName : filters[key];
                    return value ? _extends({}, result, _defineProperty({}, key, value)) : result;
                }, {})
            };
            return (0, _api.callApi)('/bloodstock/sales/search/results/data.json', { query: query }).then(function (data) {
                return _this3.setState({
                    fetching: false,
                    fetchFailed: false,
                    totalLotsNum: data.pagination.totalItems,
                    totalPagesNum: data.pagination.totalPages,
                    page: data.pagination.currentPage,
                    data: data.rows,
                    header: data.header
                });
            }).catch(function () {
                return _this3.setState({
                    fetching: false,
                    fetchFailed: true,
                    totalLotsNum: 0,
                    totalPagesNum: 0,
                    data: [],
                    header: []
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var breakpointCode = this.props.breakpointCode;
            var _state = this.state,
                lightbox = _state.lightbox,
                fetching = _state.fetching,
                filtersUsed = _state.filtersUsed,
                totalPagesNum = _state.totalPagesNum,
                totalLotsNum = _state.totalLotsNum,
                filters = _state.filters,
                page = _state.page,
                data = _state.data,
                expansion = _state.expansion,
                sort = _state.sort;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _SearchResults2.default.filters },
                    _react2.default.createElement(_SearchResultsFilters2.default, {
                        lotsNum: totalLotsNum,
                        resetDisabled: this.isFiltersUsed(),
                        value: filters,
                        breakpointCode: breakpointCode,
                        onChange: this.handleFiltersChange,
                        onReset: this.handleFiltersReset,
                        onSearch: this.handleFiltersSearch,
                        filtersUsed: filtersUsed,
                        filters: filters
                    })
                ),
                _react2.default.createElement(_Lightbox2.default, {
                    open: lightbox,
                    onClose: this.handleLightboxClose
                }),
                (fetching || filtersUsed) && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: _SearchResults2.default.table },
                        _react2.default.createElement(_SearchResultsTable2.default, {
                            breakpointCode: breakpointCode,
                            data: data,
                            canSortByColumn: this.isSortable,
                            loading: fetching,
                            expansion: expansion,
                            sorting: _defineProperty({}, sort, 'asc'),
                            onToggle: this.handleTableToggle,
                            onSort: this.handleTableSort,
                            errorMessage: this.createErrorMessage()
                        })
                    ),
                    _react2.default.createElement(_Pagination2.default, {
                        displayedPagesNum: 5,
                        totalPagesNum: totalPagesNum,
                        page: page,
                        onPageChange: this.handlePageChange
                    })
                )
            );
        }
    }], [{
        key: 'getInitialPage',
        value: function getInitialPage() {
            return 1;
        }
    }, {
        key: 'getInitialData',
        value: function getInitialData() {
            return [];
        }
    }, {
        key: 'getInitialTotalLotsNum',
        value: function getInitialTotalLotsNum() {
            return 0;
        }
    }, {
        key: 'getInitialTotalPagesNum',
        value: function getInitialTotalPagesNum() {
            return 0;
        }
    }, {
        key: 'defaultProps',
        get: function get() {
            return {
                sireName: '',
                from: null,
                to: null
            };
        }
    }]);

    return SearchResults;
}(_react.PureComponent);

SearchResults.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    sireName: _propTypes2.default.string,
    from: _propTypes2.default.string,
    to: _propTypes2.default.string
};
exports.default = (0, _Breakpoints.bindCode)(SearchResults);

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(45),
    equalArrays = __webpack_require__(49),
    equalByTag = __webpack_require__(128),
    equalObjects = __webpack_require__(131),
    getTag = __webpack_require__(57),
    isArray = __webpack_require__(9),
    isBuffer = __webpack_require__(51),
    isTypedArray = __webpack_require__(53);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(20);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(20);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(20);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(20);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(19);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 101 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 102 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 103 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(19),
    Map = __webpack_require__(34),
    MapCache = __webpack_require__(35);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(15),
    isMasked = __webpack_require__(108),
    isObject = __webpack_require__(16),
    toSource = __webpack_require__(48);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 107 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(109);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 110 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(112),
    ListCache = __webpack_require__(19),
    Map = __webpack_require__(34);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(113),
    hashDelete = __webpack_require__(114),
    hashGet = __webpack_require__(115),
    hashHas = __webpack_require__(116),
    hashSet = __webpack_require__(117);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(22);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 114 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(22);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(22);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(22);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(23);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(23);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(23);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(23);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(35),
    setCacheAdd = __webpack_require__(124),
    setCacheHas = __webpack_require__(125);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 124 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 125 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 126 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 127 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(21),
    Uint8Array = __webpack_require__(129),
    eq = __webpack_require__(33),
    equalArrays = __webpack_require__(49),
    mapToArray = __webpack_require__(50),
    setToArray = __webpack_require__(130);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(132);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(133),
    getSymbols = __webpack_require__(135),
    keys = __webpack_require__(36);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(134),
    isArray = __webpack_require__(9);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 134 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(136),
    stubArray = __webpack_require__(137);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 136 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 137 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(139),
    isArguments = __webpack_require__(140),
    isArray = __webpack_require__(9),
    isBuffer = __webpack_require__(51),
    isIndex = __webpack_require__(52),
    isTypedArray = __webpack_require__(53);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 139 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(141),
    isObjectLike = __webpack_require__(12);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isObjectLike = __webpack_require__(12);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 142 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isLength = __webpack_require__(54),
    isObjectLike = __webpack_require__(12);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 144 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(46);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)(module)))

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(147),
    nativeKeys = __webpack_require__(148);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 147 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(55);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(14),
    root = __webpack_require__(8);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 153 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)
var differenceInCalendarMonths = __webpack_require__(155)
var compareAsc = __webpack_require__(156)

/**
 * @category Month Helpers
 * @summary Get the number of full months between the given dates.
 *
 * @description
 * Get the number of full months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full months
 *
 * @example
 * // How many full months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 7
 */
function differenceInMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarMonths(dateLeft, dateRight))
  dateLeft.setMonth(dateLeft.getMonth() - sign * difference)

  // Math.abs(diff in full months - diff in calendar months) === 1 if last calendar month is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastMonthNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastMonthNotFull)
}

module.exports = differenceInMonths


/***/ }),
/* 154 */
/***/ (function(module, exports) {

var MILLISECONDS_IN_MINUTE = 60000

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime())
  var baseTimezoneOffset = date.getTimezoneOffset()
  date.setSeconds(0, 0)
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * var result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth()

  return yearDiff * 12 + monthDiff
}

module.exports = differenceInCalendarMonths


/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Common Helpers
 * @summary Compare the two dates and return -1, 0 or 1.
 *
 * @description
 * Compare the two dates and return 1 if the first date is after the second,
 * -1 if the first date is before the second or 0 if dates are equal.
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Number} the result of the comparison
 *
 * @example
 * // Compare 11 February 1987 and 10 July 1989:
 * var result = compareAsc(
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * )
 * //=> -1
 *
 * @example
 * // Sort the array of dates:
 * var result = [
 *   new Date(1995, 6, 2),
 *   new Date(1987, 1, 11),
 *   new Date(1989, 6, 10)
 * ].sort(compareAsc)
 * //=> [
 * //   Wed Feb 11 1987 00:00:00,
 * //   Mon Jul 10 1989 00:00:00,
 * //   Sun Jul 02 1995 00:00:00
 * // ]
 */
function compareAsc (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var timeLeft = dateLeft.getTime()
  var dateRight = parse(dirtyDateRight)
  var timeRight = dateRight.getTime()

  if (timeLeft < timeRight) {
    return -1
  } else if (timeLeft > timeRight) {
    return 1
  } else {
    return 0
  }
}

module.exports = compareAsc


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added
 * @returns {Date} the new date with the days added
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * var result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays (dirtyDate, dirtyAmount) {
  var date = parse(dirtyDate)
  var amount = Number(dirtyAmount)
  date.setDate(date.getDate() + amount)
  return date
}

module.exports = addDays


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a month
 *
 * @example
 * // How many days are in February 2000?
 * var result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  var monthIndex = date.getMonth()
  var lastDayOfMonth = new Date(0)
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0)
  lastDayOfMonth.setHours(0, 0, 0, 0)
  return lastDayOfMonth.getDate()
}

module.exports = getDaysInMonth


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)
var startOfYear = __webpack_require__(160)
var differenceInCalendarDays = __webpack_require__(161)

/**
 * @category Day Helpers
 * @summary Get the day of the year of the given date.
 *
 * @description
 * Get the day of the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of year
 *
 * @example
 * // Which day of the year is 2 July 2014?
 * var result = getDayOfYear(new Date(2014, 6, 2))
 * //=> 183
 */
function getDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = differenceInCalendarDays(date, startOfYear(date))
  var dayOfYear = diff + 1
  return dayOfYear
}

module.exports = getDayOfYear


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a year
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * var result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear (dirtyDate) {
  var cleanDate = parse(dirtyDate)
  var date = new Date(0)
  date.setFullYear(cleanDate.getFullYear(), 0, 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYear


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(162)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_DAY = 86400000

/**
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * var result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 */
function differenceInCalendarDays (dirtyDateLeft, dirtyDateRight) {
  var startOfDayLeft = startOfDay(dirtyDateLeft)
  var startOfDayRight = startOfDay(dirtyDateRight)

  var timestampLeft = startOfDayLeft.getTime() -
    startOfDayLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfDayRight.getTime() -
    startOfDayRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY)
}

module.exports = differenceInCalendarDays


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a day
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * var result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay (dirtyDate) {
  var date = parse(dirtyDate)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfDay


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)
var startOfISOWeek = __webpack_require__(39)
var startOfISOYear = __webpack_require__(165)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the ISO week
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * var result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek (dirtyDate) {
  var date = parse(dirtyDate)
  var diff = startOfISOWeek(date).getTime() - startOfISOYear(date).getTime()

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1
}

module.exports = getISOWeek


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * var result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), {weekStartsOn: 1})
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek (dirtyDate, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0

  var date = parse(dirtyDate)
  var day = date.getDay()
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn

  date.setDate(date.getDate() - diff)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfWeek


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(60)
var startOfISOWeek = __webpack_require__(39)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of an ISO year
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * var result = startOfISOYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  return date
}

module.exports = startOfISOYear


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

var isDate = __webpack_require__(58)

/**
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {Date} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} argument must be an instance of Date
 *
 * @example
 * // For the valid date:
 * var result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the invalid date:
 * var result = isValid(new Date(''))
 * //=> false
 */
function isValid (dirtyDate) {
  if (isDate(dirtyDate)) {
    return !isNaN(dirtyDate)
  } else {
    throw new TypeError(toString.call(dirtyDate) + ' is not an instance of Date')
  }
}

module.exports = isValid


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

var buildDistanceInWordsLocale = __webpack_require__(168)
var buildFormatLocale = __webpack_require__(169)

/**
 * @category Locales
 * @summary English locale.
 */
module.exports = {
  distanceInWords: buildDistanceInWordsLocale(),
  format: buildFormatLocale()
}


/***/ }),
/* 168 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(170)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 170 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.bind = bind;
exports.bindCode = bindCode;

var _rpMqBreakpoints = __webpack_require__(24);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProcessor = function defaultProcessor(breakpoint) {
    return { breakpoint: breakpoint };
};

function bind(Component) {
    var processor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultProcessor;

    return function (_PureComponent) {
        _inherits(Breakpoints, _PureComponent);

        function Breakpoints() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, Breakpoints);

            for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
                args[_key] = arguments[_key];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Breakpoints.__proto__ || Object.getPrototypeOf(Breakpoints)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, processor(_rpMqBreakpoints2.default.current())), _this.handleSwitch = function (ev) {
                _this.setState(processor(ev.detail.breakpoint));
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(Breakpoints, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                window.addEventListener('rpBreakpointsSwitch', this.handleSwitch);
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                window.removeEventListener('rpBreakpointsSwitch', this.handleSwitch);
            }
        }, {
            key: 'render',
            value: function render() {
                return _react2.default.createElement(Component, _extends({}, this.props, this.state));
            }
        }]);

        return Breakpoints;
    }(_react.PureComponent);
}

function bindCode(Component) {
    return bind(Component, function (breakpoint) {
        return { breakpointCode: breakpoint.code };
    });
}

/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _range = __webpack_require__(173);

var _range2 = _interopRequireDefault(_range);

var _clamp = __webpack_require__(179);

var _clamp2 = _interopRequireDefault(_clamp);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _PaginationNav = __webpack_require__(181);

var _PaginationNav2 = _interopRequireDefault(_PaginationNav);

var _PaginationPage = __webpack_require__(185);

var _PaginationPage2 = _interopRequireDefault(_PaginationPage);

var _Pagination = __webpack_require__(186);

var _Pagination2 = _interopRequireDefault(_Pagination);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Pagination = function (_PureComponent) {
    _inherits(Pagination, _PureComponent);

    function Pagination() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Pagination);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Pagination.__proto__ || Object.getPrototypeOf(Pagination)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            offset: Pagination.clampOffset(Pagination.calcPageOffset(_this.props), _this.props)
        }, _this.handlePageClick = function (page) {
            return _this.changePage(page);
        }, _this.handlePrevPageClick = function () {
            _this.changePage(_this.props.page - 1);
        }, _this.handleNextPageClick = function () {
            _this.changePage(_this.props.page + 1);
        }, _this.handleLeftOffsetClick = function () {
            _this.setOffset(_this.state.offset - _this.props.displayedPagesNum);
        }, _this.handleRightOffsetClick = function () {
            _this.setOffset(_this.state.offset + _this.props.displayedPagesNum);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Pagination, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(props) {
            this.setOffset(Pagination.calcPageOffset(props));
        }
    }, {
        key: 'setOffset',
        value: function setOffset(offset) {
            this.setState({
                offset: Pagination.clampOffset(offset, this.props)
            });
        }
    }, {
        key: 'changePage',
        value: function changePage(page) {
            return this.props.onPageChange(page);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                totalPagesNum = _props.totalPagesNum,
                displayedPagesNum = _props.displayedPagesNum,
                page = _props.page;

            if (!totalPagesNum) {
                return null;
            }
            var offset = this.state.offset;

            return _react2.default.createElement(
                'div',
                {
                    className: 'ui-btnGroup ui-btnGroup_pagination rn-pagination'
                },
                _react2.default.createElement(
                    _PaginationNav2.default,
                    {
                        disabled: offset <= 0,
                        onClick: this.handleLeftOffsetClick
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, {
                        className: _Pagination2.default.icon + ' ' + _Pagination2.default.iconLeft,
                        size: 'Medium',
                        iconName: 'expand-all'
                    })
                ),
                _react2.default.createElement(
                    _PaginationNav2.default,
                    {
                        disabled: page <= 1,
                        onClick: this.handlePrevPageClick
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { className: _Pagination2.default.icon, size: 'Medium', iconName: 'left' })
                ),
                _react2.default.createElement(
                    'span',
                    { className: 'ui-btn_paginationRange ui-btn' },
                    'Page ',
                    page,
                    ' of ',
                    totalPagesNum
                ),
                (0, _range2.default)(offset, Math.min(offset + displayedPagesNum, totalPagesNum)).map(function (i) {
                    return _react2.default.createElement(_PaginationPage2.default, {
                        key: i,
                        current: i + 1 === page,
                        value: i + 1,
                        onClick: _this2.handlePageClick
                    });
                }),
                _react2.default.createElement(
                    _PaginationNav2.default,
                    {
                        disabled: page >= totalPagesNum,
                        onClick: this.handleNextPageClick
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { className: _Pagination2.default.icon, size: 'Medium', iconName: 'right' })
                ),
                _react2.default.createElement(
                    _PaginationNav2.default,
                    {
                        disabled: offset >= totalPagesNum - displayedPagesNum,
                        onClick: this.handleRightOffsetClick
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, {
                        className: _Pagination2.default.icon + ' ' + _Pagination2.default.iconRight,
                        size: 'Medium',
                        iconName: 'expand-all'
                    })
                )
            );
        }
    }], [{
        key: 'clampOffset',
        value: function clampOffset(offset, _ref2) {
            var totalPagesNum = _ref2.totalPagesNum,
                displayedPagesNum = _ref2.displayedPagesNum;

            return (0, _clamp2.default)(offset, 0, totalPagesNum - displayedPagesNum);
        }
    }, {
        key: 'calcPageOffset',
        value: function calcPageOffset(_ref3) {
            var page = _ref3.page,
                displayedPagesNum = _ref3.displayedPagesNum;

            return Math.floor(page - displayedPagesNum / 2);
        }
    }]);

    return Pagination;
}(_react.PureComponent);

Pagination.propTypes = {
    totalPagesNum: _propTypes2.default.number.isRequired,
    displayedPagesNum: _propTypes2.default.number,
    page: _propTypes2.default.number.isRequired,
    onPageChange: _propTypes2.default.func.isRequired
};
Pagination.defaultProps = {
    displayedPagesNum: 10
};
exports.default = Pagination;

/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(174);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(175),
    isIterateeCall = __webpack_require__(176),
    toFinite = __webpack_require__(177);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 175 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(33),
    isArrayLike = __webpack_require__(56),
    isIndex = __webpack_require__(52),
    isObject = __webpack_require__(16);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(40);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 178 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(180),
    toNumber = __webpack_require__(40);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),
/* 180 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = PaginationNav;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _PaginationNav = __webpack_require__(182);

var _PaginationNav2 = _interopRequireDefault(_PaginationNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function PaginationNav(_ref) {
    var children = _ref.children,
        disabled = _ref.disabled,
        onClick = _ref.onClick;

    return _react2.default.createElement(
        'button',
        {
            className: (0, _classnames2.default)(_PaginationNav2.default.root, 'ui-btn', { 'ui-btn--disabled': disabled }),
            disabled: disabled,
            onClick: onClick
        },
        children
    );
}

PaginationNav.propTypes = {
    children: _propTypes2.default.node,
    disabled: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};

PaginationNav.defaultProps = {
    children: null,
    disabled: false,
    onClick: null
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(183);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./PaginationNav.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./PaginationNav.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".PaginationNav__root___2pSil {\n  width: 32px;\n  text-align: center; }\n", ""]);

// exports
exports.locals = {
	"root": "PaginationNav__root___2pSil"
};

/***/ }),
/* 184 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PaginationPage = function (_PureComponent) {
    _inherits(PaginationPage, _PureComponent);

    function PaginationPage() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PaginationPage);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PaginationPage.__proto__ || Object.getPrototypeOf(PaginationPage)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            var _this$props = _this.props,
                value = _this$props.value,
                onClick = _this$props.onClick;

            onClick(value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PaginationPage, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                current = _props.current,
                value = _props.value;

            return _react2.default.createElement(
                'button',
                {
                    className: (0, _classnames2.default)('ui-btn ui-btn_paginationItem', { 'ui-btn_primary': current }),
                    disabled: current,
                    onClick: this.handleClick
                },
                value
            );
        }
    }]);

    return PaginationPage;
}(_react.PureComponent);

exports.default = PaginationPage;


PaginationPage.propTypes = {
    current: _propTypes2.default.bool,
    value: _propTypes2.default.number.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

PaginationPage.defaultProps = {
    current: false
};

/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(187);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Pagination.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Pagination.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".Pagination__icon___2Jufl {\n  margin: auto !important; }\n  .Pagination__iconLeft___2s-E7 {\n    transform: rotate(90deg); }\n  .Pagination__iconRight___1S0t7 {\n    transform: rotate(-90deg); }\n", ""]);

// exports
exports.locals = {
	"icon": "Pagination__icon___2Jufl",
	"iconLeft": "Pagination__iconLeft___2s-E7",
	"iconRight": "Pagination__iconRight___1S0t7"
};

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FILTERS_PROP_ONLY_SOLD = exports.FILTERS_PROP_MAX_PRICE = exports.FILTERS_PROP_MIN_PRICE = exports.FILTERS_PROP_BUYER = exports.FILTERS_PROP_VENDOR = exports.FILTERS_PROP_DAM_SIRE = exports.FILTERS_PROP_DAM = exports.FILTERS_PROP_SIRE = exports.FILTERS_PROP_NAME = exports.FILTERS_PROP_AGE = exports.FILTERS_PROP_SEX = exports.FILTERS_PROP_SALE_COMPANY = exports.FILTERS_PROP_SALE = exports.FITLERS_PROP_TO = exports.FITLERS_PROP_FROM = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _filtersLabels, _propTypes$shape;

var _capitalize2 = __webpack_require__(189);

var _capitalize3 = _interopRequireDefault(_capitalize2);

var _format = __webpack_require__(38);

var _format2 = _interopRequireDefault(_format);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Breakpoints = __webpack_require__(10);

var _api = __webpack_require__(7);

var _Filters = __webpack_require__(69);

var _DatePicker = __webpack_require__(224);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

var _Checkbox = __webpack_require__(71);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Sale = __webpack_require__(234);

var _Sale2 = _interopRequireDefault(_Sale);

var _SearchResultsFilters = __webpack_require__(238);

var _SearchResultsFilters2 = _interopRequireDefault(_SearchResultsFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TAB_SALE = 'TAB_SALE';
var TAB_HORSE = 'TAB_HORSE';
var TAB_PEDIGREE = 'TAB_PEDIGREE';
var TAB_VENDOR_BUYER = 'TAB_VENDOR_BUYER';
var TAB_PRICE_RANGE = 'TAB_PRICE_RANGE';

var ONLY_SOLD_LABEL = 'Show only sold lots';

var DATE_MIN_THRESHOLD = '1991-01-01';

var EXTRA_NARROW = _Breakpoints.codes.EXTRA_NARROW,
    NARROW = _Breakpoints.codes.NARROW,
    WIDE = _Breakpoints.codes.WIDE,
    EXTRA_WIDE = _Breakpoints.codes.EXTRA_WIDE;


var SEX_OPTIONS = [{ label: 'Colt', value: 'C' }, { label: 'Filly', value: 'F' }, { label: 'Gelding', value: 'G' }, { label: 'Horse', value: 'H' }, { label: 'Mare', value: 'M' }, { label: 'Rig', value: 'R' }];

var AGE_OPTIONS = [{ label: 'Foal', value: '0' }, { label: 'Yearling', value: '1' }, { label: '2-y-o', value: '2' }, { label: 'Older horses', value: '3+' }];

var PRICE_OPTIONS = [{ label: '£10,000', value: 10000 }, { label: '£20,000', value: 20000 }, { label: '£30,000', value: 30000 }, { label: '£40,000', value: 40000 }, { label: '£50,000', value: 50000 }, { label: '£100,000', value: 100000 }, { label: '£200,000', value: 200000 }, { label: '£300,000', value: 300000 }, { label: '£400,000', value: 400000 }, { label: '£500,000 +', value: '' }];

var FITLERS_PROP_FROM = exports.FITLERS_PROP_FROM = 'from';
var FITLERS_PROP_TO = exports.FITLERS_PROP_TO = 'to';
var FILTERS_PROP_SALE = exports.FILTERS_PROP_SALE = 'sale';
var FILTERS_PROP_SALE_COMPANY = exports.FILTERS_PROP_SALE_COMPANY = 'saleCompany';
var FILTERS_PROP_SEX = exports.FILTERS_PROP_SEX = 'sex';
var FILTERS_PROP_AGE = exports.FILTERS_PROP_AGE = 'age';
var FILTERS_PROP_NAME = exports.FILTERS_PROP_NAME = 'name';
var FILTERS_PROP_SIRE = exports.FILTERS_PROP_SIRE = 'sire';
var FILTERS_PROP_DAM = exports.FILTERS_PROP_DAM = 'dam';
var FILTERS_PROP_DAM_SIRE = exports.FILTERS_PROP_DAM_SIRE = 'damSire';
var FILTERS_PROP_VENDOR = exports.FILTERS_PROP_VENDOR = 'vendor';
var FILTERS_PROP_BUYER = exports.FILTERS_PROP_BUYER = 'buyer';
var FILTERS_PROP_MIN_PRICE = exports.FILTERS_PROP_MIN_PRICE = 'minPrice';
var FILTERS_PROP_MAX_PRICE = exports.FILTERS_PROP_MAX_PRICE = 'maxPrice';
var FILTERS_PROP_ONLY_SOLD = exports.FILTERS_PROP_ONLY_SOLD = 'resultsWithSold';

var filtersLabels = (_filtersLabels = {}, _defineProperty(_filtersLabels, FILTERS_PROP_SALE, 'Sale'), _defineProperty(_filtersLabels, FILTERS_PROP_SALE_COMPANY, 'Sale Company'), _defineProperty(_filtersLabels, FILTERS_PROP_SEX, 'Sex'), _defineProperty(_filtersLabels, FILTERS_PROP_AGE, 'Age'), _defineProperty(_filtersLabels, FILTERS_PROP_NAME, 'Name'), _defineProperty(_filtersLabels, FILTERS_PROP_SIRE, 'Sire'), _defineProperty(_filtersLabels, FILTERS_PROP_DAM, 'Dam'), _defineProperty(_filtersLabels, FILTERS_PROP_DAM_SIRE, 'Dam\'s Sire'), _defineProperty(_filtersLabels, FILTERS_PROP_VENDOR, 'Vendor'), _defineProperty(_filtersLabels, FILTERS_PROP_BUYER, 'Buyer'), _filtersLabels);

var SearchResultsFilters = function (_PureComponent) {
    _inherits(SearchResultsFilters, _PureComponent);

    function SearchResultsFilters() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchResultsFilters);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchResultsFilters.__proto__ || Object.getPrototypeOf(SearchResultsFilters)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            tab: TAB_SALE,
            open: true,
            saleCompanyOptions: { data: [], fetched: false },
            history: [],
            appliedFilters: []
        }, _this.getNavAlign = function () {
            var breakpointCode = _this.props.breakpointCode;


            switch (breakpointCode) {
                case EXTRA_NARROW:
                    return _Filters.FiltersNav.ALIGN_HORIZONTAL;
                default:
                    return _Filters.FiltersNav.ALIGN_VERTICAL;
            }
        }, _this.getNavOptions = function () {
            var breakpointCode = _this.props.breakpointCode;


            var getVendorLabel = function getVendorLabel() {
                switch (breakpointCode) {
                    case EXTRA_NARROW:
                        return 'V / B';
                    case NARROW:
                        return 'Ven / Buy';
                    default:
                        return 'Vendor / Buyer';
                }
            };

            return [{ label: 'Sale', value: TAB_SALE }, { label: 'Horse', value: TAB_HORSE }, { label: 'Pedigree', value: TAB_PEDIGREE }, { label: getVendorLabel(), value: TAB_VENDOR_BUYER }, { label: 'Price Range', value: TAB_PRICE_RANGE }];
        }, _this.getPriceMinOptions = function () {
            var filters = _this.props.filters;

            var maxPrice = filters[FILTERS_PROP_MAX_PRICE];

            return PRICE_OPTIONS.filter(function (option) {
                return option.value !== '' && (maxPrice ? option.value < maxPrice : true);
            });
        }, _this.getPriceMaxOptions = function () {
            var filters = _this.props.filters;

            var minPrice = filters[FILTERS_PROP_MIN_PRICE];

            return PRICE_OPTIONS.filter(function (option) {
                return option.value === '' || option.value > minPrice;
            });
        }, _this.handleTabChange = function (tab) {
            return _this.setState({ tab: tab });
        }, _this.handleFiltersVisibilityChange = function () {
            _this.setState({
                open: !_this.state.open
            });
        }, _this.handleResetClick = function () {
            _this.setState({ history: [] });
            return _this.props.onReset();
        }, _this.handleSearchClick = function () {
            _this.props.onSearch().then(function () {
                _this.setState({
                    appliedFilters: [].concat(_toConsumableArray(_this.state.history))
                });
            });
        }, _this.createFilterChangeHandler = function (prop) {
            return function (value, option) {
                var filters = _this.props.filters;

                if (filters[prop] === value) {
                    return;
                }

                var shouldUpdateHistory = ![FITLERS_PROP_FROM, FITLERS_PROP_TO, FILTERS_PROP_MIN_PRICE, FILTERS_PROP_MAX_PRICE].includes(prop);
                if (shouldUpdateHistory) {
                    _this.setState({
                        history: _this.state.history.filter(function (item) {
                            return item.prop !== prop;
                        }).concat(value ? {
                            prop: prop,
                            value: function () {
                                switch (prop) {
                                    case FILTERS_PROP_ONLY_SOLD:
                                        return ONLY_SOLD_LABEL;
                                    case FILTERS_PROP_SALE_COMPANY:
                                        return option.name;
                                    case FILTERS_PROP_SEX:
                                    case FILTERS_PROP_AGE:
                                        return option.label;
                                    default:
                                        return value;
                                }
                            }()
                        } : [])
                    });
                }

                var shouldTriggerSearchAutomatically = [FITLERS_PROP_FROM, FITLERS_PROP_TO, FILTERS_PROP_MIN_PRICE, FILTERS_PROP_MAX_PRICE, FILTERS_PROP_SALE_COMPANY, FILTERS_PROP_SEX, FILTERS_PROP_AGE, FILTERS_PROP_ONLY_SOLD].includes(prop);

                _this.props.onChange(_extends({}, filters, _defineProperty({}, prop, value)), shouldTriggerSearchAutomatically && _this.handleSearchClick);
            };
        }, _this.filterChangeHandlers = [FITLERS_PROP_FROM, FITLERS_PROP_TO, FILTERS_PROP_SALE, FILTERS_PROP_SALE_COMPANY, FILTERS_PROP_SEX, FILTERS_PROP_AGE, FILTERS_PROP_NAME, FILTERS_PROP_SIRE, FILTERS_PROP_DAM, FILTERS_PROP_DAM_SIRE, FILTERS_PROP_VENDOR, FILTERS_PROP_BUYER, FILTERS_PROP_ONLY_SOLD, FILTERS_PROP_MIN_PRICE, FILTERS_PROP_MAX_PRICE].reduce(function (result, prop) {
            return _extends({}, result, _defineProperty({}, prop, _this.createFilterChangeHandler(prop)));
        }, {}), _this.handleSaleCompanyOpen = function () {
            if (_this.state.saleCompanyOptions.fetched) {
                return null;
            }
            return (0, _api.callApi)('/bloodstock/sales/search/company/data.json').then(function (options) {
                _this.setState({
                    saleCompanyOptions: { data: [].concat(_toConsumableArray(options)), fetched: true }
                });
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchResultsFilters, [{
        key: 'getFilterProps',
        value: function getFilterProps() {
            var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
                prop = _ref2.prop,
                _ref2$label = _ref2.label,
                label = _ref2$label === undefined ? (0, _capitalize3.default)(prop) : _ref2$label,
                _ref2$className = _ref2.className,
                className = _ref2$className === undefined ? _SearchResultsFilters2.default.filter : _ref2$className;

            return {
                className: className,
                label: label,
                value: this.props.filters[prop],
                onChange: this.filterChangeHandlers[prop]
            };
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                filters = _props.filters,
                filtersUsed = _props.filtersUsed,
                lotsNum = _props.lotsNum,
                resetDisabled = _props.resetDisabled,
                breakpointCode = _props.breakpointCode;
            var _state = this.state,
                saleCompanyOptions = _state.saleCompanyOptions,
                tab = _state.tab,
                appliedFilters = _state.appliedFilters,
                open = _state.open;

            var toNarrow = [NARROW, EXTRA_NARROW].includes(breakpointCode);
            var toWide = [WIDE, EXTRA_WIDE].includes(breakpointCode);
            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _SearchResultsFilters2.default.top },
                    toNarrow && _react2.default.createElement(_Filters.FiltersToggle, {
                        className: _SearchResultsFilters2.default.toggle,
                        open: open,
                        onClick: this.handleFiltersVisibilityChange
                    }),
                    _react2.default.createElement(
                        'h2',
                        { className: _SearchResultsFilters2.default.heading },
                        'Refine Search Results'
                    ),
                    _react2.default.createElement(
                        'p',
                        { className: _SearchResultsFilters2.default.description },
                        'For Sales Results searches on a date range larger than 30 days you will need to apply two filters below on the Sale Name, Horse name, pedigree, vendor or price range'
                    )
                ),
                (open || !toNarrow) && _react2.default.createElement(
                    'div',
                    { className: _SearchResultsFilters2.default.center },
                    _react2.default.createElement(
                        'div',
                        { className: _SearchResultsFilters2.default.nav },
                        _react2.default.createElement(_Filters.FiltersNav, {
                            name: 'tab',
                            align: this.getNavAlign(),
                            options: this.getNavOptions(),
                            value: tab,
                            onChange: this.handleTabChange
                        }),
                        _react2.default.createElement(
                            'div',
                            { className: _SearchResultsFilters2.default.datepicker },
                            _react2.default.createElement(_DatePicker2.default, _extends({
                                displayFormat: 'DD MMM YYYY',
                                min: DATE_MIN_THRESHOLD,
                                max: filters[FITLERS_PROP_TO]
                            }, this.getFilterProps({
                                prop: FITLERS_PROP_FROM,
                                label: 'From',
                                className: _SearchResultsFilters2.default.date
                            }))),
                            _react2.default.createElement(_DatePicker2.default, _extends({
                                displayFormat: 'DD MMM YYYY',
                                min: filters[FITLERS_PROP_FROM],
                                max: (0, _format2.default)(new Date(), 'YYYY-MM-DD')
                            }, this.getFilterProps({
                                prop: FITLERS_PROP_TO,
                                label: 'To',
                                className: _SearchResultsFilters2.default.date
                            })))
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _SearchResultsFilters2.default.lotsFilter },
                            _react2.default.createElement(_Checkbox2.default, this.getFilterProps({
                                prop: FILTERS_PROP_ONLY_SOLD,
                                label: ONLY_SOLD_LABEL
                            }))
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _SearchResultsFilters2.default.center + ' ' + _SearchResultsFilters2.default.content },
                        _react2.default.createElement(
                            'div',
                            { className: _SearchResultsFilters2.default.form },
                            function () {
                                switch (tab) {
                                    case TAB_SALE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Sale2.default, _this2.getFilterProps({
                                                prop: FILTERS_PROP_SALE
                                            })),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({}, _this2.getFilterProps({
                                                prop: FILTERS_PROP_SALE_COMPANY,
                                                label: 'Sale Company'
                                            }), {
                                                labelGetter: 'name',
                                                options: saleCompanyOptions.data,
                                                onOpen: _this2.handleSaleCompanyOpen
                                            }))
                                        );
                                    case TAB_HORSE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({}, _this2.getFilterProps({
                                                prop: FILTERS_PROP_SEX
                                            }), {
                                                options: SEX_OPTIONS
                                            })),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({}, _this2.getFilterProps({
                                                prop: FILTERS_PROP_AGE
                                            }), {
                                                options: AGE_OPTIONS
                                            })),
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_NAME
                                            }))
                                        );
                                    case TAB_PEDIGREE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_SIRE
                                            })),
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_DAM
                                            })),
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_DAM_SIRE,
                                                label: 'Dam\'s Sire'
                                            }))
                                        );
                                    case TAB_VENDOR_BUYER:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_VENDOR,
                                                label: 'Vendor Name'
                                            })),
                                            _react2.default.createElement(_Filters.FiltersInput, _this2.getFilterProps({
                                                prop: FILTERS_PROP_BUYER,
                                                label: 'Buyer Name'
                                            }))
                                        );
                                    case TAB_PRICE_RANGE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({}, _this2.getFilterProps({
                                                prop: FILTERS_PROP_MIN_PRICE,
                                                label: 'Price Range Min'
                                            }), {
                                                options: _this2.getPriceMinOptions(),
                                                optionsSorter: null
                                            })),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({}, _this2.getFilterProps({
                                                prop: FILTERS_PROP_MAX_PRICE,
                                                label: 'Price Range Max'
                                            }), {
                                                options: _this2.getPriceMaxOptions(),
                                                optionsSorter: null
                                            }))
                                        );
                                    default:
                                        return null;
                                }
                            }()
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _SearchResultsFilters2.default.lots },
                            _react2.default.createElement(
                                'div',
                                { className: _SearchResultsFilters2.default.lotsInfo },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    'Lots found'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: _SearchResultsFilters2.default.lotsNum,
                                        'data-test-selector': 'lots_found_right_block'
                                    },
                                    lotsNum
                                )
                            )
                        )
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _SearchResultsFilters2.default.buttons },
                        _react2.default.createElement(_Filters.FiltersReset, {
                            className: _SearchResultsFilters2.default.reset,
                            disabled: resetDisabled,
                            onClick: this.handleResetClick
                        }),
                        _react2.default.createElement(
                            'button',
                            {
                                className: _SearchResultsFilters2.default.search + ' ui-btn ui-btn_primary',
                                onClick: this.handleSearchClick
                            },
                            _react2.default.createElement(
                                'span',
                                null,
                                'Search'
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _SearchResultsFilters2.default.history },
                    filtersUsed && appliedFilters.length > 0 && toWide && _react2.default.createElement(
                        'span',
                        { 'data-test-selector': 'filters_applied' },
                        'Filters Applied: ',
                        appliedFilters.map(function (item) {
                            if (item.prop === FILTERS_PROP_ONLY_SOLD) {
                                return item.value;
                            }
                            return filtersLabels[item.prop] + ' -\n                                        ' + item.value.charAt(0).toUpperCase().concat(item.value.slice(1));
                        }).join(', ')
                    )
                )
            );
        }
    }], [{
        key: 'defaultProps',
        get: function get() {
            return {
                resetDisabled: false
            };
        }
    }]);

    return SearchResultsFilters;
}(_react.PureComponent);

SearchResultsFilters.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    filters: _propTypes2.default.shape((_propTypes$shape = {}, _defineProperty(_propTypes$shape, FITLERS_PROP_FROM, _propTypes2.default.string), _defineProperty(_propTypes$shape, FITLERS_PROP_TO, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_SALE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_SALE_COMPANY, _propTypes2.default.number), _defineProperty(_propTypes$shape, FILTERS_PROP_SEX, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_AGE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_NAME, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_SIRE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_DAM, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_DAM_SIRE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_VENDOR, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_BUYER, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_MIN_PRICE, _propTypes2.default.number), _defineProperty(_propTypes$shape, FILTERS_PROP_MAX_PRICE, _propTypes2.default.number), _propTypes$shape)).isRequired,
    filtersUsed: _propTypes2.default.bool.isRequired,
    lotsNum: _propTypes2.default.number.isRequired,
    resetDisabled: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired,
    onReset: _propTypes2.default.func.isRequired,
    onSearch: _propTypes2.default.func.isRequired
};
exports.default = SearchResultsFilters;

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(26),
    upperFirst = __webpack_require__(190);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(191);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(65),
    hasUnicode = __webpack_require__(66),
    stringToArray = __webpack_require__(67),
    toString = __webpack_require__(26);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 192 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 193 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 194 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_195__;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(55);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(1), __webpack_require__(0), __webpack_require__(4), __webpack_require__(5), __webpack_require__(17), __webpack_require__(68));
	else if(typeof define === 'function' && define.amd)
		define(["prop-types", "react", "rp-react-svg-icon", "classnames", "qs", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["rpAuth"] = factory(require("prop-types"), require("react"), require("rp-react-svg-icon"), require("classnames"), require("qs"), require("react-dom"));
	else
		root["rpAuth"] = factory(root["prop-types"], root["react"], root["rp-react-svg-icon"], root["classnames"], root["qs"], root["react-dom"]);
})(typeof self !== 'undefined' ? self : this, function(__WEBPACK_EXTERNAL_MODULE_0__, __WEBPACK_EXTERNAL_MODULE_5__, __WEBPACK_EXTERNAL_MODULE_22__, __WEBPACK_EXTERNAL_MODULE_48__, __WEBPACK_EXTERNAL_MODULE_94__, __WEBPACK_EXTERNAL_MODULE_125__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 142);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_0__;

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Event's name for tracking
 * @type {string}
 */
var EVENT_LOG_IN = exports.EVENT_LOG_IN = 'Login';
var EVENT_EMAIL_VERIFICATION = exports.EVENT_EMAIL_VERIFICATION = 'Email Verified';
var EVENT_REGISTRATION = exports.EVENT_REGISTRATION = 'Registration Complete';
var EVENT_SUBSCRIPTION_SALE_ATTEMPT = exports.EVENT_SUBSCRIPTION_SALE_ATTEMPT = 'Subscription Sale Attempt';
var EVENT_SUBSCRIPTION_SALE = exports.EVENT_SUBSCRIPTION_SALE = 'Subscription Sale';
var EVENT_SUBSCRIPTION_SALE_CONFIRMATION = exports.EVENT_SUBSCRIPTION_SALE_CONFIRMATION = 'Subscription Sale Confirmation';

var EVENT_BOOKMAKER_LOGIN = exports.EVENT_BOOKMAKER_LOGIN = 'Bookmaker Login';
var EVENT_BOOKMAKER_LOGIN_SUCCESS = exports.EVENT_BOOKMAKER_LOGIN_SUCCESS = 'Bookmaker Login Success';
var EVENT_BOOKMAKER_LOGIN_FAILURE = exports.EVENT_BOOKMAKER_LOGIN_FAILURE = 'Bookmaker Login Failure';
var EVENT_BOOKMAKER_LOGIN_ATTEMPT = exports.EVENT_BOOKMAKER_LOGIN_ATTEMPT = 'Bookmaker Login Attempt';
var EVENT_BOOKMAKER_REGISTER_BUTTON = exports.EVENT_BOOKMAKER_REGISTER_BUTTON = 'Bookmaker Register Button';
var EVENT_BOOKMAKER_REGISTRATION_TAP = exports.EVENT_BOOKMAKER_REGISTRATION_TAP = 'Bookmaker Registration Tap';
var EVENT_BOOKMAKER_PLACE_BET = exports.EVENT_BOOKMAKER_PLACE_BET = 'Place Bet';
var EVENT_BOOKMAKER_BET_RECEIPT = exports.EVENT_BOOKMAKER_BET_RECEIPT = 'Bet Receipt';
var EVENT_BOOKMAKER_OFFER_CLAIM_CLICK = exports.EVENT_BOOKMAKER_OFFER_CLAIM_CLICK = 'Bookmaker Offer Claim Button';
var EVENT_ALL_OFFERS_LINK_CLICK = exports.EVENT_ALL_OFFERS_LINK_CLICK = 'All Offers Click';
var EVENT_FREE_BETS_TAP = exports.EVENT_FREE_BETS_TAP = 'Free Bets Tap';

var EVENT_BETSLIP_ERROR_MESSAGE = exports.EVENT_BETSLIP_ERROR_MESSAGE = 'Betslip Error Message';

var EVENT_BET_BUTTON_CLICK = exports.EVENT_BET_BUTTON_CLICK = 'Odds Button';
var EVENT_REMOVE_SELECTION_BUTTON_CLICK = exports.EVENT_REMOVE_SELECTION_BUTTON_CLICK = 'Remove Selection';
var EVENT_QUICK_STAKE_BUTTONS_CLICK = exports.EVENT_QUICK_STAKE_BUTTONS_CLICK = 'Quick Stake Buttons';
var EVENT_CANCEL_BET_BUTTON_CLICK = exports.EVENT_CANCEL_BET_BUTTON_CLICK = 'Cancel Bet';
var EVENT_DISCARD_SLIP_CLICK = exports.EVENT_DISCARD_SLIP_CLICK = 'Discard Slip';

var EVENT_CARD_CUSTOMISATION = exports.EVENT_CARD_CUSTOMISATION = 'Card Customisation';
var EVENT_HORSE_TRACKING_SETTINGS = exports.EVENT_HORSE_TRACKING_SETTINGS = 'Horse Tracker Settings';

var EVENT_NAVIGATION_CLICK = exports.EVENT_NAVIGATION_CLICK = 'Navigation Click';
var EVENT_FOOTER_CLICK = exports.EVENT_FOOTER_CLICK = 'Footer Click';

var EVENT_BARRIER_SHOW = exports.EVENT_BARRIER_SHOW = 'Barrier';
var EVENT_BARRIER_INTERACTION = exports.EVENT_BARRIER_INTERACTION = 'Barrier Interaction';
var EVENT_BARRIER_SIGN_IN = exports.EVENT_BARRIER_SIGN_IN = 'Barrier Sign In';

var EVENT_BARRIER_ESSENTIAL_SHOW = exports.EVENT_BARRIER_ESSENTIAL_SHOW = 'Essential subscribe barrier';
var EVENT_BARRIER_ESSENTIAL_SUBSCRIBE = exports.EVENT_BARRIER_ESSENTIAL_SUBSCRIBE = 'Subscribe essential barrier';

var EVENT_BARRIER_ULTIMATE_SHOW = exports.EVENT_BARRIER_ULTIMATE_SHOW = 'Ultimate subscribe barrier';
var EVENT_BARRIER_ULTIMATE_SUBSCRIBE = exports.EVENT_BARRIER_ULTIMATE_SUBSCRIBE = 'Subscribe ultimate barrier';

var EVENT_BARRIER_ULTIMATE_ONLY_SHOW = exports.EVENT_BARRIER_ULTIMATE_ONLY_SHOW = 'Ultimate upgrade barrier';
var EVENT_BARRIER_ULTIMATE_ONLY_UPGRADE = exports.EVENT_BARRIER_ULTIMATE_ONLY_UPGRADE = 'Upgrade ultimate barrier';

var EVENT_BARRIER_SIGNIN_SHOW = exports.EVENT_BARRIER_SIGNIN_SHOW = 'Sign in';
var EVENT_BARRIER_SIGNIN_PASSWORD = exports.EVENT_BARRIER_SIGNIN_PASSWORD = 'Forgotten password';

var EVENT_BETTING_OFFER_CLICK = exports.EVENT_BETTING_OFFER_CLICK = 'Betting Offer Click';

var EVENT_CHECKOUT_STARTED = exports.EVENT_CHECKOUT_STARTED = 'Checkout Started';
var EVENT_CHECKOUT_STEP_VIEWED = exports.EVENT_CHECKOUT_STEP_VIEWED = 'Checkout Step Viewed';
var EVENT_CHECKOUT_STEP_COMPLETED = exports.EVENT_CHECKOUT_STEP_COMPLETED = 'Checkout Step Completed';

var EVENT_COUPON_ENTERED = exports.EVENT_COUPON_ENTERED = 'Coupon Entered';
var EVENT_COUPON_DENIED = exports.EVENT_COUPON_DENIED = 'Coupon Denied';
var EVENT_COUPON_REMOVED = exports.EVENT_COUPON_REMOVED = 'Coupon Removed';
var EVENT_COUPON_APPLIED = exports.EVENT_COUPON_APPLIED = 'Coupon Applied';

var EVENT_OFFER_ACCORDION = exports.EVENT_OFFER_ACCORDION = 'Offer Accordion';
var EVENT_ORDER_COMPLETED = exports.EVENT_ORDER_COMPLETED = 'Order Completed';

var EVENT_PACKAGE_UPGRADE = exports.EVENT_PACKAGE_UPGRADE = 'Package Upgrade';
var EVENT_PREFERENCE_UPDATE = exports.EVENT_PREFERENCE_UPDATE = 'Preference Update';

var EVENT_BLUKAI_ODDS_BUTTON_CLICK = exports.EVENT_BLUKAI_ODDS_BUTTON_CLICK = 'Odds_Button_Click';
var EVENT_BLUKAI_BOOKMAKER_LOGIN = exports.EVENT_BLUKAI_BOOKMAKER_LOGIN = 'Bookmaker_Login';
var EVENT_BLUKAI_OPEN_ACCOUNT = exports.EVENT_BLUKAI_OPEN_ACCOUNT = 'Open_Account';

var EVENT_RACE_MATRIX_CLICK = exports.EVENT_RACE_MATRIX_CLICK = 'Todays Race Matrix Click';

var EVENT_RACECARD_OFFER_ACCORDION_OPENED = exports.EVENT_RACECARD_OFFER_ACCORDION_OPENED = 'Racecard Offer Accordion Opened';
var EVENT_RACECARD_OFFER_ACCORDION_CLOSED = exports.EVENT_RACECARD_OFFER_ACCORDION_CLOSED = 'Racecard Offer Accordion Closed';
var EVENT_RACECARD_OFFER_BUTTON_CLICKED = exports.EVENT_RACECARD_OFFER_BUTTON_CLICKED = 'Racecard Offer Button Clicked';
var EVENT_CARD_INDEX_CLICKED = exports.EVENT_CARD_INDEX_CLICKED = 'Card Index Clicked';

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var TRAIT_ORDER_ID = exports.TRAIT_ORDER_ID = 'order_id';
var TRAIT_COUPON_ID = exports.TRAIT_COUPON_ID = 'Coupon ID';
var TRAIT_DISCOUNT = exports.TRAIT_DISCOUNT = 'Discount';
var TRAIT_PRODUCT_ID = exports.TRAIT_PRODUCT_ID = 'product_id';
var TRAIT_PRODUCT_NAME = exports.TRAIT_PRODUCT_NAME = 'product_name';
var TRAIT_PRODUCT_PRICE = exports.TRAIT_PRODUCT_PRICE = 'product_price';
var TRAIT_PRODUCT_CATEGORY = exports.TRAIT_PRODUCT_CATEGORY = 'product_category';
var TRAIT_TOTAL = exports.TRAIT_TOTAL = 'Total';
var TRAIT_NAME = exports.TRAIT_NAME = 'name';
var TRAIT_PRICE = exports.TRAIT_PRICE = 'price';
var TRAIT_AFFILIATION = exports.TRAIT_AFFILIATION = 'affiliation';
var TRAIT_CATEGORY = exports.TRAIT_CATEGORY = 'category';
var TRAIT_QUANTITY = exports.TRAIT_QUANTITY = 'quantity';
var TRAIT_CHECKOUT_ID = exports.TRAIT_CHECKOUT_ID = 'checkout_id';
var TRAIT_PRODUCTS = exports.TRAIT_PRODUCTS = 'products';
var TRAIT_STEP = exports.TRAIT_STEP = 'step';
var TRAIT_LOCATION = exports.TRAIT_LOCATION = 'location';
var TRAIT_SUBSECTION = exports.TRAIT_SUBSECTION = 'subsection';
var TRAIT_POSITION = exports.TRAIT_POSITION = 'position';
var TRAIT_BOOKMAKER = exports.TRAIT_BOOKMAKER = 'bookmaker';
var TRAIT_BOOKMAKER_USERNAME = exports.TRAIT_BOOKMAKER_USERNAME = 'bookmaker_username';
var TRAIT_BOOKMAKER_NAME = exports.TRAIT_BOOKMAKER_NAME = 'bookmaker_name';
var TRAIT_BOOKMAKER_OFFER = exports.TRAIT_BOOKMAKER_OFFER = 'bookmaker_offer';
var TRAIT_BOOKMAKER_TIER = exports.TRAIT_BOOKMAKER_TIER = 'bookmaker_tier';
var TRAIT_OFFERS_BANNER = exports.TRAIT_OFFERS_BANNER = 'offers_banner';
var TRAIT_BOOKMAKER_STATUS = exports.TRAIT_BOOKMAKER_STATUS = 'status';
var TRAIT_PRODUCT = exports.TRAIT_PRODUCT = 'Product';
var TRAIT_CURRENCY = exports.TRAIT_CURRENCY = 'currency';

var TRAIT_ODDS = exports.TRAIT_ODDS = 'odds';
var TRAIT_RACE_ID = exports.TRAIT_RACE_ID = 'race_id';
var TRAIT_RACE_DATE = exports.TRAIT_RACE_DATE = 'race_date';
var TRAIT_RACE_TIME = exports.TRAIT_RACE_TIME = 'race_time';
var TRAIT_RACE_OFFERS_AVAILABLE = exports.TRAIT_RACE_OFFERS_AVAILABLE = 'offer_available';
var TRAIT_TIME_OF_EVENT = exports.TRAIT_TIME_OF_EVENT = 'time_of_event';
var TRAIT_RACECOURSE = exports.TRAIT_RACECOURSE = 'racecourse';
var TRAIT_HORSE_NAME = exports.TRAIT_HORSE_NAME = 'horse_name';
var TRAIT_BET_DATE = exports.TRAIT_BET_DATE = 'bet_date';
var TRAIT_SELECTIONS = exports.TRAIT_SELECTIONS = 'selections';
var TRAIT_BETSLIP_ID = exports.TRAIT_BETSLIP_ID = 'bet_slip_id';
var TRAIT_RECEIPT = exports.TRAIT_RECEIPT = 'bet_receipt';
var TRAIT_RECEIPT_ID = exports.TRAIT_RECEIPT_ID = 'bet_receipt_id';
var TRAIT_RECEIPT_TYPE = exports.TRAIT_RECEIPT_TYPE = 'bet_receipt_type';
var TRAIT_BET_COUNT = exports.TRAIT_BET_COUNT = 'bet_count';
var TRAIT_BET_TYPE = exports.TRAIT_BET_TYPE = 'bet_type';
var TRAIT_STAKE = exports.TRAIT_STAKE = 'stake';
var TRAIT_WIN_EW = exports.TRAIT_WIN_EW = 'win_or_ew';
var TRAIT_API_OUTCOME = exports.TRAIT_API_OUTCOME = 'api_outcome';
var TRAIT_COUPON = exports.TRAIT_COUPON = 'Coupon';
var TRAIT_REVENUE = exports.TRAIT_REVENUE = 'revenue';
var TRAIT_PACKAGE = exports.TRAIT_PACKAGE = 'Package';
var TRAIT_STATUS = exports.TRAIT_STATUS = 'Status';

var TRAIT_REWARDS_FOR_RACING = exports.TRAIT_REWARDS_FOR_RACING = 'Rewards For Racing';
var TRAIT_DAILY_CONTACT = exports.TRAIT_DAILY_CONTACT = 'Daily Contact';
var TRAIT_FIRST_NAME = exports.TRAIT_FIRST_NAME = 'First Name';
var TRAIT_LAST_NAME = exports.TRAIT_LAST_NAME = 'Last Name';
var TRAIT_PHONE_NUMBER = exports.TRAIT_PHONE_NUMBER = 'Phone Number';

var TRAIT_EMAIL = exports.TRAIT_EMAIL = 'Email';
var TRAIT_CREATED_AT = exports.TRAIT_CREATED_AT = 'Created At';
var TRAIT_OUTCOME = exports.TRAIT_OUTCOME = 'Outcome';
var TRAIT_ERROR = exports.TRAIT_ERROR = 'error';

var TRAIT_RACINGPOST_CONTACT = exports.TRAIT_RACINGPOST_CONTACT = 'Racing Post Contact';
var TRAIT_THIRDPARTY_CONTACT = exports.TRAIT_THIRDPARTY_CONTACT = 'Third Party Contact';

var TRAIT_DEVICE_TYPE = exports.TRAIT_DEVICE_TYPE = 'device_type';
var TRAIT_USER_NAME = exports.TRAIT_USER_NAME = 'username';
var TRAIT_USER_ID = exports.TRAIT_USER_ID = 'user_id';
var TRAIT_LOGGED_IN_STATUS = exports.TRAIT_LOGGED_IN_STATUS = 'logged_in_status';
var TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS = exports.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS = 'betting_account_logged_in_status';

var TRAIT_PACKAGE_ORIGIN = exports.TRAIT_PACKAGE_ORIGIN = 'Package Origin';
var TRAIT_PACKAGE_DESTINATION = exports.TRAIT_PACKAGE_DESTINATION = 'Package Destination';

var TRAIT_LAST_CHANGED_OPTION = exports.TRAIT_LAST_CHANGED_OPTION = 'last_changed_option';

var TRAIT_RACE_CONDITIONS = exports.TRAIT_RACE_CONDITIONS = 'race_conditions';
var TRAIT_FORM = exports.TRAIT_FORM = 'form';
var TRAIT_MY_NOTES = exports.TRAIT_MY_NOTES = 'my_notes';
var TRAIT_SPOTLIGHTS = exports.TRAIT_SPOTLIGHTS = 'spotlights';
var TRAIT_COMMENTS = exports.TRAIT_COMMENTS = 'comments';
var TRAIT_OWNER = exports.TRAIT_OWNER = 'owner';
var TRAIT_QUOTES = exports.TRAIT_QUOTES = 'quotes';
var TRAIT_PEDIGREES = exports.TRAIT_PEDIGREES = 'pedigrees';
var TRAIT_RTF = exports.TRAIT_RTF = 'rtf%';
var TRAIT_DECIMAL_ODDS = exports.TRAIT_DECIMAL_ODDS = 'decimal_odds';
var TRAIT_PRICE_HISTORY = exports.TRAIT_PRICE_HISTORY = 'price_history';
var TRAIT_ORDER_BY_PRICE = exports.TRAIT_ORDER_BY_PRICE = 'order_by_price';
var TRAIT_BETTING_FORCAST = exports.TRAIT_BETTING_FORCAST = 'betting_forecast';
var TRAIT_MY_RATINGS = exports.TRAIT_MY_RATINGS = 'my_ratings';
var TRAIT_SHOW_PRICES = exports.TRAIT_SHOW_PRICES = 'show_prices';

var TRAIT_HORSE_ENTERED = exports.TRAIT_HORSE_ENTERED = 'Horse Entered';
var TRAIT_HORSE_DECLARED = exports.TRAIT_HORSE_DECLARED = 'Horse Declared';
var TRAIT_SHOW_PEDIGREE = exports.TRAIT_SHOW_PEDIGREE = 'Show Pedigree';

var TRAIT_SELECTION = exports.TRAIT_SELECTION = 'selection';

var TRAIT_SITE_SECTION = exports.TRAIT_SITE_SECTION = 'site_section';
var TRAIT_SITE_SUB_SECTION_1 = exports.TRAIT_SITE_SUB_SECTION_1 = 'site_sub_section_1';
var TRAIT_SITE_SUB_SECTION_2 = exports.TRAIT_SITE_SUB_SECTION_2 = 'site_sub_section_2';
var TRAIT_SITE_SUB_SECTION_3 = exports.TRAIT_SITE_SUB_SECTION_3 = 'site_sub_section_3';

var TRAIT_UK_TIMESTAMP = exports.TRAIT_UK_TIMESTAMP = 'uk_timestamp';

var TRAIT_HORSE_BETTING = exports.TRAIT_HORSE_BETTING = 'Communication Horse Betting';
var TRAIT_HORSE_NEWS = exports.TRAIT_HORSE_NEWS = 'Communication Horse News';
var TRAIT_COMPETITIONS = exports.TRAIT_COMPETITIONS = 'Communication Competitions';
var TRAIT_BLOODSTOCK = exports.TRAIT_BLOODSTOCK = 'Communication Bloodstock';
var TRAIT_SPORT_BETTING = exports.TRAIT_SPORT_BETTING = 'Communication Sport Betting';
var TRAIT_OVER_EIGHTEEN = exports.TRAIT_OVER_EIGHTEEN = 'Communication Eighteen';
var TRAIT_DAYLY_UPDATES = exports.TRAIT_DAYLY_UPDATES = 'Daily Contact';
var TRAIT_R4R = exports.TRAIT_R4R = 'Rewards For Racing';
var TRAIT_THIRD_PARTY = exports.TRAIT_THIRD_PARTY = 'Third Party Contact';
var TRAIT_TS_CS = exports.TRAIT_TS_CS = 'Ts+Cs';
var TRAIT_18_PLUST = exports.TRAIT_18_PLUST = '18+';

var TRAIT_SUBSCRIBER_REWARDS = exports.TRAIT_SUBSCRIBER_REWARDS = 'Subscriber rewards (Members only)';
var TRAIT_MEMBERS_BRIEFING = exports.TRAIT_MEMBERS_BRIEFING = 'Member\'s Briefing (Members only)';
var TRAIT_THE_FRONT_RUNNER = exports.TRAIT_THE_FRONT_RUNNER = 'The Front Runner (Ultimate Members only)';
var TRAIT_THE_ULTIMATE_DAILY = exports.TRAIT_THE_ULTIMATE_DAILY = 'The Ultimate Daily (Ultimate Members only)';

var TRAIT_ACCORDION_NAME = exports.TRAIT_ACCORDION_NAME = 'Accordion Name';
var TRAIT_DISC_NAME = exports.TRAIT_DISC_NAME = 'Disc Name';

var TRAIT_TYPE = exports.TRAIT_TYPE = 'type';

var TRAIT_NUMBER_OF_OFFERS = exports.TRAIT_NUMBER_OF_OFFERS = 'number_of_offers';

var TRAIT_USER_LAST_LOGIN_DATE = exports.TRAIT_USER_LAST_LOGIN_DATE = 'last_logged_in_date_web';
var TRAIT_NUMBER_BOOKMAKERS_ACCOUNTS = exports.TRAIT_NUMBER_BOOKMAKERS_ACCOUNTS = 'bookmaker_accounts_number_web';
var TRAIT_RECENT_BOOKMAKERS = exports.TRAIT_RECENT_BOOKMAKERS = {
    bet365_logged_in_web: false,
    betfair_logged_in_web: false,
    coral_logged_in_web: false,
    ladbrokes_logged_in_web: false,
    paddy_power_logged_in_web: false,
    skybet_logged_in_web: false,
    william_hill_logged_in_web: false
};

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(155);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_OPTIONS = undefined;

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(6);

var _extends6 = _interopRequireDefault(_extends5);

var _dayjs = __webpack_require__(108);

var _dayjs2 = _interopRequireDefault(_dayjs);

var _propTypes = __webpack_require__(0);

var _constants = __webpack_require__(18);

var _nonCanonical = __webpack_require__(63);

var _getBettingAccountLoggedInStatus = __webpack_require__(64);

var _getBettingAccountLoggedInStatus2 = _interopRequireDefault(_getBettingAccountLoggedInStatus);

var _getUserName = __webpack_require__(65);

var _getUserName2 = _interopRequireDefault(_getUserName);

var _getUserId = __webpack_require__(37);

var _getUserId2 = _interopRequireDefault(_getUserId);

var _commonTraits = __webpack_require__(45);

var _getUTMParams = __webpack_require__(66);

var _getUTMParams2 = _interopRequireDefault(_getUTMParams);

var _getBetslipId = __webpack_require__(196);

var _traits = __webpack_require__(2);

var _configProvider = __webpack_require__(93);

var _configProvider2 = _interopRequireDefault(_configProvider);

var _getScreenProps = __webpack_require__(197);

var _getScreenProps2 = _interopRequireDefault(_getScreenProps);

var _getLocationAndSubsection = __webpack_require__(200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var utc = __webpack_require__(217);
var timezone = __webpack_require__(112);

_dayjs2.default.extend(utc);
_dayjs2.default.extend(timezone);
var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    integrations: {
        All: true
    }
};

function track(event) {
    var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTIONS;
    var shouldHaveSiteSections = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

    var _extends4;

    var shouldHaveLocationAndSubsection = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var shouldGetBetslipId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;

    var _configProvider$getEv = _configProvider2.default.getEvent(event),
        getPropTypes = _configProvider$getEv.getPropTypes,
        buildProps = _configProvider$getEv.buildProps;

    var props = (0, _extends6.default)({}, traits);

    if (getPropTypes) {
        (0, _propTypes.checkPropTypes)(getPropTypes(), traits, 'trait', event + ' event');
    }

    if (buildProps) {
        props = buildProps(traits);
    }

    // Overwrite segment defaults to use a non canonical values
    var properties = {
        path: (0, _nonCanonical.getNonCanonicalPath)(),
        url: (0, _nonCanonical.getNonCanonicalUrl)()
    };

    var userName = (0, _getUserName2.default)();
    if (userName) {
        properties[_traits.TRAIT_USER_NAME] = userName;
    }

    var userId = (0, _getUserId2.default)();
    if (userId) {
        properties[_traits.TRAIT_USER_ID] = userId;
    }

    var traitsProps = (0, _commonTraits.getCommonTraits)();
    var screenProps = (0, _getScreenProps2.default)();

    if (traitsProps && traitsProps[_traits.TRAIT_SITE_SECTION] && shouldHaveSiteSections) {
        var subsection = localStorage.getItem(_traits.TRAIT_SUBSECTION);

        properties[_traits.TRAIT_SITE_SECTION] = traitsProps[_traits.TRAIT_SITE_SECTION];
        properties[_traits.TRAIT_SITE_SUB_SECTION_1] = traitsProps[_traits.TRAIT_SITE_SUB_SECTION_1];
        properties[_traits.TRAIT_SITE_SUB_SECTION_2] = traitsProps[_traits.TRAIT_SITE_SUB_SECTION_2];

        if (subsection) {
            properties[_traits.TRAIT_SUBSECTION] = subsection;
        }
    }

    if (shouldHaveLocationAndSubsection) {
        var _extends2;

        var _getLocationAndSubsec = (0, _getLocationAndSubsection.getLocationAndSubsection)(),
            location = _getLocationAndSubsec.location,
            _subsection = _getLocationAndSubsec.subsection;

        properties = (0, _extends6.default)({}, properties, (_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_LOCATION, location), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_SUBSECTION, _subsection), _extends2));
    }

    if (shouldGetBetslipId) {
        properties = (0, _extends6.default)({}, properties, (0, _defineProperty3.default)({}, _traits.TRAIT_BETSLIP_ID, (0, _getBetslipId.getBetslipId)()));
    }

    localStorage.removeItem('subsection');

    var ukTimestamp = (0, _dayjs2.default)().tz('Europe/London').format('YYYY-MM-DDTHH:mm:ss.SSS[Z]');
    properties = (0, _extends6.default)((_extends4 = {}, (0, _defineProperty3.default)(_extends4, _traits.TRAIT_LOGGED_IN_STATUS, userId ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends4, _traits.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS, (0, _getBettingAccountLoggedInStatus2.default)() ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends4, _traits.TRAIT_UK_TIMESTAMP, ukTimestamp), _extends4), properties, (0, _getUTMParams2.default)(), props);

    return new Promise(function (resolve) {
        if (!global.analytics || !global.analytics.initialize) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        global.analytics.track(event, properties, (0, _extends6.default)({}, screenProps, options), resolve);
    });
}

exports.default = track;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 5 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_5__;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(144);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 7 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapProps", function() { return mapProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withProps", function() { return withProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withPropsOnChange", function() { return withPropsOnChange; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withHandlers", function() { return withHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultProps", function() { return defaultProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProp", function() { return renameProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renameProps", function() { return renameProps; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flattenProp", function() { return flattenProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withState", function() { return withState; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withStateHandlers", function() { return withStateHandlers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withReducer", function() { return withReducer; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "branch", function() { return branch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderComponent", function() { return renderComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "renderNothing", function() { return renderNothing; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shouldUpdate", function() { return shouldUpdate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "pure", function() { return pure; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForKeys", function() { return onlyUpdateForKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onlyUpdateForPropTypes", function() { return onlyUpdateForPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "withContext", function() { return withContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getContext", function() { return getContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "lifecycle", function() { return lifecycle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "toClass", function() { return toClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setStatic", function() { return setStatic; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setPropTypes", function() { return setPropTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setDisplayName", function() { return setDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDisplayName", function() { return getDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapDisplayName", function() { return wrapDisplayName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isClassComponent", function() { return isClassComponent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSink", function() { return createSink; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromProp", function() { return componentFromProp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "nest", function() { return nest; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hoistStatics", function() { return hoistStatics; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStream", function() { return componentFromStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "componentFromStreamWithConfig", function() { return componentFromStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStream", function() { return mapPropsStream; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapPropsStreamWithConfig", function() { return mapPropsStreamWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandler", function() { return createEventHandler; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createEventHandlerWithConfig", function() { return createEventHandlerWithConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setObservableConfig", function() { return configureObservable; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_change_emitter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_change_emitter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_symbol_observable__ = __webpack_require__(127);
/* harmony reexport (default from non-hamory) */ __webpack_require__.d(__webpack_exports__, "shallowEqual", function() { return __WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default.a; });






var setStatic = function setStatic(key, value) {
  return function (BaseComponent) {
    /* eslint-disable no-param-reassign */
    BaseComponent[key] = value;
    /* eslint-enable no-param-reassign */
    return BaseComponent;
  };
};

var setDisplayName = function setDisplayName(displayName) {
  return setStatic('displayName', displayName);
};

var getDisplayName = function getDisplayName(Component$$1) {
  if (typeof Component$$1 === 'string') {
    return Component$$1;
  }

  if (!Component$$1) {
    return undefined;
  }

  return Component$$1.displayName || Component$$1.name || 'Component';
};

var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
  return hocName + '(' + getDisplayName(BaseComponent) + ')';
};

var mapProps = function mapProps(propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var MapProps = function MapProps(props) {
      return factory(propsMapper(props));
    };
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapProps'))(MapProps);
    }
    return MapProps;
  };
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};









var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};



var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};









var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

var withProps = function withProps(input) {
  var hoc = mapProps(function (props) {
    return _extends({}, props, typeof input === 'function' ? input(props) : input);
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var pick = function pick(obj, keys) {
  var result = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (obj.hasOwnProperty(key)) {
      result[key] = obj[key];
    }
  }
  return result;
};

var withPropsOnChange = function withPropsOnChange(shouldMapOrKeys, propsMapper) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var shouldMap = typeof shouldMapOrKeys === 'function' ? shouldMapOrKeys : function (props, nextProps) {
      return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(props, shouldMapOrKeys), pick(nextProps, shouldMapOrKeys));
    };

    var WithPropsOnChange = function (_Component) {
      inherits(WithPropsOnChange, _Component);

      function WithPropsOnChange() {
        var _temp, _this, _ret;

        classCallCheck(this, WithPropsOnChange);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.computedProps = propsMapper(_this.props), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithPropsOnChange.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        if (shouldMap(this.props, nextProps)) {
          this.computedProps = propsMapper(nextProps);
        }
      };

      WithPropsOnChange.prototype.render = function render() {
        return factory(_extends({}, this.props, this.computedProps));
      };

      return WithPropsOnChange;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withPropsOnChange'))(WithPropsOnChange);
    }
    return WithPropsOnChange;
  };
};

var mapValues = function mapValues(obj, func) {
  var result = {};
  /* eslint-disable no-restricted-syntax */
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) {
      result[key] = func(obj[key], key);
    }
  }
  /* eslint-enable no-restricted-syntax */
  return result;
};

/* eslint-disable no-console */
var withHandlers = function withHandlers(handlers) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithHandlers = function (_Component) {
      inherits(WithHandlers, _Component);

      function WithHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithHandlers.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
        this.cachedHandlers = {};
      };

      WithHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.handlers));
      };

      return WithHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.cachedHandlers = {};
      this.handlers = mapValues(typeof handlers === 'function' ? handlers(this.props) : handlers, function (createHandler, handlerName) {
        return function () {
          var cachedHandler = _this2.cachedHandlers[handlerName];
          if (cachedHandler) {
            return cachedHandler.apply(undefined, arguments);
          }

          var handler = createHandler(_this2.props);
          _this2.cachedHandlers[handlerName] = handler;

          if (false) {
            console.error(
            // eslint-disable-line no-console
            'withHandlers(): Expected a map of higher-order functions. ' + 'Refer to the docs for more info.');
          }

          return handler.apply(undefined, arguments);
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withHandlers'))(WithHandlers);
    }
    return WithHandlers;
  };
};

var defaultProps = function defaultProps(props) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var DefaultProps = function DefaultProps(ownerProps) {
      return factory(ownerProps);
    };
    DefaultProps.defaultProps = props;
    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'defaultProps'))(DefaultProps);
    }
    return DefaultProps;
  };
};

var omit = function omit(obj, keys) {
  var rest = objectWithoutProperties(obj, []);

  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (rest.hasOwnProperty(key)) {
      delete rest[key];
    }
  }
  return rest;
};

var renameProp = function renameProp(oldName, newName) {
  var hoc = mapProps(function (props) {
    var _babelHelpers$extends;

    return _extends({}, omit(props, [oldName]), (_babelHelpers$extends = {}, _babelHelpers$extends[newName] = props[oldName], _babelHelpers$extends));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProp'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var keys = Object.keys;


var mapKeys = function mapKeys(obj, func) {
  return keys(obj).reduce(function (result, key) {
    var val = obj[key];
    /* eslint-disable no-param-reassign */
    result[func(val, key)] = val;
    /* eslint-enable no-param-reassign */
    return result;
  }, {});
};

var renameProps = function renameProps(nameMap) {
  var hoc = mapProps(function (props) {
    return _extends({}, omit(props, keys(nameMap)), mapKeys(pick(props, keys(nameMap)), function (_, oldName) {
      return nameMap[oldName];
    }));
  });
  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'renameProps'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var flattenProp = function flattenProp(propName) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var FlattenProp = function FlattenProp(props) {
      return factory(_extends({}, props, props[propName]));
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'flattenProp'))(FlattenProp);
    }
    return FlattenProp;
  };
};

var withState = function withState(stateName, stateUpdaterName, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithState = function (_Component) {
      inherits(WithState, _Component);

      function WithState() {
        var _temp, _this, _ret;

        classCallCheck(this, WithState);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: typeof initialState === 'function' ? initialState(_this.props) : initialState
        }, _this.updateStateValue = function (updateFn, callback) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: typeof updateFn === 'function' ? updateFn(stateValue) : updateFn
            };
          }, callback);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithState.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[stateUpdaterName] = this.updateStateValue, _babelHelpers$extends)));
      };

      return WithState;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withState'))(WithState);
    }
    return WithState;
  };
};

var withStateHandlers = function withStateHandlers(initialState, stateUpdaters) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithStateHandlers = function (_Component) {
      inherits(WithStateHandlers, _Component);

      function WithStateHandlers() {
        var _temp, _this, _ret;

        classCallCheck(this, WithStateHandlers);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), possibleConstructorReturn(_this, _ret);
      }

      WithStateHandlers.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        var propsChanged = nextProps !== this.props;
        // the idea is to skip render if stateUpdater handler return undefined
        // this allows to create no state update handlers with access to state and props
        var stateChanged = !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(nextState, this.state);
        return propsChanged || stateChanged;
      };

      WithStateHandlers.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state, this.stateUpdaters));
      };

      return WithStateHandlers;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.state = typeof initialState === 'function' ? initialState(this.props) : initialState;
      this.stateUpdaters = mapValues(stateUpdaters, function (handler) {
        return function (mayBeEvent) {
          for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
            args[_key2 - 1] = arguments[_key2];
          }

          // Having that functional form of setState can be called async
          // we need to persist SyntheticEvent
          if (mayBeEvent && typeof mayBeEvent.persist === 'function') {
            mayBeEvent.persist();
          }

          _this2.setState(function (state, props) {
            return handler(state, props).apply(undefined, [mayBeEvent].concat(args));
          });
        };
      });
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withStateHandlers'))(WithStateHandlers);
    }
    return WithStateHandlers;
  };
};

var withReducer = function withReducer(stateName, dispatchName, reducer, initialState) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithReducer = function (_Component) {
      inherits(WithReducer, _Component);

      function WithReducer() {
        var _temp, _this, _ret;

        classCallCheck(this, WithReducer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = {
          stateValue: _this.initializeStateValue()
        }, _this.dispatch = function (action) {
          return _this.setState(function (_ref) {
            var stateValue = _ref.stateValue;
            return {
              stateValue: reducer(stateValue, action)
            };
          });
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithReducer.prototype.initializeStateValue = function initializeStateValue() {
        if (initialState !== undefined) {
          return typeof initialState === 'function' ? initialState(this.props) : initialState;
        }
        return reducer(undefined, { type: '@@recompose/INIT' });
      };

      WithReducer.prototype.render = function render() {
        var _babelHelpers$extends;

        return factory(_extends({}, this.props, (_babelHelpers$extends = {}, _babelHelpers$extends[stateName] = this.state.stateValue, _babelHelpers$extends[dispatchName] = this.dispatch, _babelHelpers$extends)));
      };

      return WithReducer;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withReducer'))(WithReducer);
    }
    return WithReducer;
  };
};

var identity = function identity(Component$$1) {
  return Component$$1;
};

var branch = function branch(test, left) {
  var right = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : identity;
  return function (BaseComponent) {
    var leftFactory = void 0;
    var rightFactory = void 0;
    var Branch = function Branch(props) {
      if (test(props)) {
        leftFactory = leftFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(left(BaseComponent));
        return leftFactory(props);
      }
      rightFactory = rightFactory || Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(right(BaseComponent));
      return rightFactory(props);
    };

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'branch'))(Branch);
    }
    return Branch;
  };
};

var renderComponent = function renderComponent(Component$$1) {
  return function (_) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(Component$$1);
    var RenderComponent = function RenderComponent(props) {
      return factory(props);
    };
    if (false) {
      RenderComponent.displayName = wrapDisplayName(Component$$1, 'renderComponent');
    }
    return RenderComponent;
  };
};

var Nothing = function (_Component) {
  inherits(Nothing, _Component);

  function Nothing() {
    classCallCheck(this, Nothing);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  Nothing.prototype.render = function render() {
    return null;
  };

  return Nothing;
}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

var renderNothing = function renderNothing(_) {
  return Nothing;
};

var shouldUpdate = function shouldUpdate(test) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var ShouldUpdate = function (_Component) {
      inherits(ShouldUpdate, _Component);

      function ShouldUpdate() {
        classCallCheck(this, ShouldUpdate);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return test(this.props, nextProps);
      };

      ShouldUpdate.prototype.render = function render() {
        return factory(this.props);
      };

      return ShouldUpdate;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
    }
    return ShouldUpdate;
  };
};

var pure = function pure(BaseComponent) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(props, nextProps);
  });

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'pure'))(hoc(BaseComponent));
  }

  return hoc(BaseComponent);
};

var onlyUpdateForKeys = function onlyUpdateForKeys(propKeys) {
  var hoc = shouldUpdate(function (props, nextProps) {
    return !__WEBPACK_IMPORTED_MODULE_1_fbjs_lib_shallowEqual___default()(pick(nextProps, propKeys), pick(props, propKeys));
  });

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForKeys'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var onlyUpdateForPropTypes = function onlyUpdateForPropTypes(BaseComponent) {
  var propTypes = BaseComponent.propTypes;

  if (false) {
    if (!propTypes) {
      /* eslint-disable */
      console.error('A component without any `propTypes` was passed to ' + '`onlyUpdateForPropTypes()`. Check the implementation of the ' + ('component with display name "' + getDisplayName(BaseComponent) + '".'));
      /* eslint-enable */
    }
  }

  var propKeys = Object.keys(propTypes || {});
  var OnlyUpdateForPropTypes = onlyUpdateForKeys(propKeys)(BaseComponent);

  if (false) {
    return setDisplayName(wrapDisplayName(BaseComponent, 'onlyUpdateForPropTypes'))(OnlyUpdateForPropTypes);
  }
  return OnlyUpdateForPropTypes;
};

var withContext = function withContext(childContextTypes, getChildContext) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    var WithContext = function (_Component) {
      inherits(WithContext, _Component);

      function WithContext() {
        var _temp, _this, _ret;

        classCallCheck(this, WithContext);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.getChildContext = function () {
          return getChildContext(_this.props);
        }, _temp), possibleConstructorReturn(_this, _ret);
      }

      WithContext.prototype.render = function render() {
        return factory(this.props);
      };

      return WithContext;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    WithContext.childContextTypes = childContextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'withContext'))(WithContext);
    }
    return WithContext;
  };
};

var getContext = function getContext(contextTypes) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
    var GetContext = function GetContext(ownerProps, context) {
      return factory(_extends({}, ownerProps, context));
    };

    GetContext.contextTypes = contextTypes;

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'getContext'))(GetContext);
    }
    return GetContext;
  };
};

/* eslint-disable no-console */
var lifecycle = function lifecycle(spec) {
  return function (BaseComponent) {
    var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);

    if (false) {
      console.error('lifecycle() does not support the render method; its behavior is to ' + 'pass all props and state to the base component.');
    }

    var Lifecycle = function (_Component) {
      inherits(Lifecycle, _Component);

      function Lifecycle() {
        classCallCheck(this, Lifecycle);
        return possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      Lifecycle.prototype.render = function render() {
        return factory(_extends({}, this.props, this.state));
      };

      return Lifecycle;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

    Object.keys(spec).forEach(function (hook) {
      return Lifecycle.prototype[hook] = spec[hook];
    });

    if (false) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'lifecycle'))(Lifecycle);
    }
    return Lifecycle;
  };
};

var isClassComponent = function isClassComponent(Component$$1) {
  return Boolean(Component$$1 && Component$$1.prototype && typeof Component$$1.prototype.render === 'function');
};

var toClass = function toClass(baseComponent) {
  if (isClassComponent(baseComponent)) {
    return baseComponent;
  }

  var ToClass = function (_Component) {
    inherits(ToClass, _Component);

    function ToClass() {
      classCallCheck(this, ToClass);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    ToClass.prototype.render = function render() {
      if (typeof baseComponent === 'string') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(baseComponent, this.props);
      }
      return baseComponent(this.props, this.context);
    };

    return ToClass;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

  ToClass.displayName = getDisplayName(baseComponent);
  ToClass.propTypes = baseComponent.propTypes;
  ToClass.contextTypes = baseComponent.contextTypes;
  ToClass.defaultProps = baseComponent.defaultProps;

  return ToClass;
};

var setPropTypes = function setPropTypes(propTypes) {
  return setStatic('propTypes', propTypes);
};

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}

var createSink = function createSink(callback) {
  return function (_Component) {
    inherits(Sink, _Component);

    function Sink() {
      classCallCheck(this, Sink);
      return possibleConstructorReturn(this, _Component.apply(this, arguments));
    }

    Sink.prototype.componentWillMount = function componentWillMount() {
      callback(this.props);
    };

    Sink.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      callback(nextProps);
    };

    Sink.prototype.render = function render() {
      return null;
    };

    return Sink;
  }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
};

var componentFromProp = function componentFromProp(propName) {
  var Component$$1 = function Component$$1(props) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_react__["createElement"])(props[propName], omit(props, [propName]));
  };
  Component$$1.displayName = 'componentFromProp(' + propName + ')';
  return Component$$1;
};

var nest = function nest() {
  for (var _len = arguments.length, Components = Array(_len), _key = 0; _key < _len; _key++) {
    Components[_key] = arguments[_key];
  }

  var factories = Components.map(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"]);
  var Nest = function Nest(_ref) {
    var props = objectWithoutProperties(_ref, []),
        children = _ref.children;
    return factories.reduceRight(function (child, factory) {
      return factory(props, child);
    }, children);
  };

  if (false) {
    var displayNames = Components.map(getDisplayName);
    Nest.displayName = 'nest(' + displayNames.join(', ') + ')';
  }

  return Nest;
};

var hoistStatics = function hoistStatics(higherOrderComponent) {
  return function (BaseComponent) {
    var NewComponent = higherOrderComponent(BaseComponent);
    __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(NewComponent, BaseComponent);
    return NewComponent;
  };
};

var _config = {
  fromESObservable: null,
  toESObservable: null
};

var configureObservable = function configureObservable(c) {
  _config = c;
};

var config = {
  fromESObservable: function fromESObservable(observable) {
    return typeof _config.fromESObservable === 'function' ? _config.fromESObservable(observable) : observable;
  },
  toESObservable: function toESObservable(stream) {
    return typeof _config.toESObservable === 'function' ? _config.toESObservable(stream) : stream;
  }
};

var componentFromStreamWithConfig = function componentFromStreamWithConfig(config$$1) {
  return function (propsToVdom) {
    return function (_Component) {
      inherits(ComponentFromStream, _Component);

      function ComponentFromStream() {
        var _config$fromESObserva;

        var _temp, _this, _ret;

        classCallCheck(this, ComponentFromStream);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.state = { vdom: null }, _this.propsEmitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])(), _this.props$ = config$$1.fromESObservable((_config$fromESObserva = {
          subscribe: function subscribe(observer) {
            var unsubscribe = _this.propsEmitter.listen(function (props) {
              if (props) {
                observer.next(props);
              } else {
                observer.complete();
              }
            });
            return { unsubscribe: unsubscribe };
          }
        }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _config$fromESObserva)), _this.vdom$ = config$$1.toESObservable(propsToVdom(_this.props$)), _temp), possibleConstructorReturn(_this, _ret);
      }

      // Stream of props


      // Stream of vdom


      ComponentFromStream.prototype.componentWillMount = function componentWillMount() {
        var _this2 = this;

        // Subscribe to child prop changes so we know when to re-render
        this.subscription = this.vdom$.subscribe({
          next: function next(vdom) {
            _this2.setState({ vdom: vdom });
          }
        });
        this.propsEmitter.emit(this.props);
      };

      ComponentFromStream.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        // Receive new props from the owner
        this.propsEmitter.emit(nextProps);
      };

      ComponentFromStream.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState) {
        return nextState.vdom !== this.state.vdom;
      };

      ComponentFromStream.prototype.componentWillUnmount = function componentWillUnmount() {
        // Call without arguments to complete stream
        this.propsEmitter.emit();

        // Clean-up subscription before un-mounting
        this.subscription.unsubscribe();
      };

      ComponentFromStream.prototype.render = function render() {
        return this.state.vdom;
      };

      return ComponentFromStream;
    }(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);
  };
};

var componentFromStream = function componentFromStream(propsToVdom) {
  return componentFromStreamWithConfig(config)(propsToVdom);
};

var identity$1 = function identity(t) {
  return t;
};

var mapPropsStreamWithConfig = function mapPropsStreamWithConfig(config$$1) {
  var componentFromStream = componentFromStreamWithConfig({
    fromESObservable: identity$1,
    toESObservable: identity$1
  });
  return function (transform) {
    return function (BaseComponent) {
      var factory = Object(__WEBPACK_IMPORTED_MODULE_0_react__["createFactory"])(BaseComponent);
      var fromESObservable = config$$1.fromESObservable,
          toESObservable = config$$1.toESObservable;

      return componentFromStream(function (props$) {
        var _ref;

        return _ref = {
          subscribe: function subscribe(observer) {
            var subscription = toESObservable(transform(fromESObservable(props$))).subscribe({
              next: function next(childProps) {
                return observer.next(factory(childProps));
              }
            });
            return {
              unsubscribe: function unsubscribe() {
                return subscription.unsubscribe();
              }
            };
          }
        }, _ref[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
          return this;
        }, _ref;
      });
    };
  };
};

var mapPropsStream = function mapPropsStream(transform) {
  var hoc = mapPropsStreamWithConfig(config)(transform);

  if (false) {
    return function (BaseComponent) {
      return setDisplayName(wrapDisplayName(BaseComponent, 'mapPropsStream'))(hoc(BaseComponent));
    };
  }
  return hoc;
};

var createEventHandlerWithConfig = function createEventHandlerWithConfig(config$$1) {
  return function () {
    var _config$fromESObserva;

    var emitter = Object(__WEBPACK_IMPORTED_MODULE_3_change_emitter__["createChangeEmitter"])();
    var stream = config$$1.fromESObservable((_config$fromESObserva = {
      subscribe: function subscribe(observer) {
        var unsubscribe = emitter.listen(function (value) {
          return observer.next(value);
        });
        return { unsubscribe: unsubscribe };
      }
    }, _config$fromESObserva[__WEBPACK_IMPORTED_MODULE_4_symbol_observable__["a" /* default */]] = function () {
      return this;
    }, _config$fromESObserva));
    return {
      handler: emitter.emit,
      stream: stream
    };
  };
};

var createEventHandler = createEventHandlerWithConfig(config);

// Higher-order component helpers




/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/inheritsLoose.js

function _inheritsLoose(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o);
}

// EXTERNAL MODULE: external "react"
var external__react_ = __webpack_require__(5);
var external__react__default = /*#__PURE__*/__webpack_require__.n(external__react_);

// EXTERNAL MODULE: external "prop-types"
var external__prop_types_ = __webpack_require__(0);
var external__prop_types__default = /*#__PURE__*/__webpack_require__.n(external__prop_types_);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/PropTypes.js

var subscriptionShape = external__prop_types__default.a.shape({
  trySubscribe: external__prop_types__default.a.func.isRequired,
  tryUnsubscribe: external__prop_types__default.a.func.isRequired,
  notifyNestedSubs: external__prop_types__default.a.func.isRequired,
  isSubscribed: external__prop_types__default.a.func.isRequired
});
var storeShape = external__prop_types__default.a.shape({
  subscribe: external__prop_types__default.a.func.isRequired,
  dispatch: external__prop_types__default.a.func.isRequired,
  getState: external__prop_types__default.a.func.isRequired
});
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}
// CONCATENATED MODULE: ./node_modules/react-redux/es/components/Provider.js





var prefixUnsafeLifecycleMethods = typeof external__react__default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  warning('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    _inheritsLoose(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return external__react_["Children"].only(this.props.children);
    };

    return Provider;
  }(external__react_["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: storeShape.isRequired,
    children: external__prop_types__default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = storeShape.isRequired, _Provider$childContex[subscriptionKey] = subscriptionShape, _Provider$childContex);
  return Provider;
}
/* harmony default export */ var components_Provider = (createProvider());
// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (-1 !== e.indexOf(n)) continue;
    t[n] = r[n];
  }
  return t;
}

// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(324);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);

// EXTERNAL MODULE: ./node_modules/invariant/browser.js
var browser = __webpack_require__(326);
var browser_default = /*#__PURE__*/__webpack_require__.n(browser);

// EXTERNAL MODULE: ./node_modules/react-is/index.js
var react_is = __webpack_require__(126);
var react_is_default = /*#__PURE__*/__webpack_require__.n(react_is);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/Subscription.js
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();


// CONCATENATED MODULE: ./node_modules/react-redux/es/components/connectAdvanced.js










var connectAdvanced_prefixUnsafeLifecycleMethods = typeof external__react__default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = _objectWithoutPropertiesLoose(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = storeShape, _contextTypes[subscriptionKey] = subscriptionShape, _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = subscriptionShape, _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    browser_default()(Object(react_is["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = _extends({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(_assertThisInitialized(_assertThisInitialized(_this)));
        browser_default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        browser_default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new Subscription(this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = _extends({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(external__react_["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(external__react_["Component"]);

    if (connectAdvanced_prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = connectAdvanced_prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return hoist_non_react_statics_cjs_default()(Connect, WrappedComponent);
  };
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/shallowEqual.js
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}
// EXTERNAL MODULE: ./node_modules/redux/es/index.js + 15 modules
var es = __webpack_require__(77);

// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/isPlainObject.js
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/utils/verifyPlainObject.js


function verifyPlainObject_verifyPlainObject(value, displayName, methodName) {
  if (!isPlainObject(value)) {
    warning(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/wrapMapToProps.js

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapDispatchToProps.js


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? wrapMapToPropsFunc(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? wrapMapToPropsConstant(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? wrapMapToPropsConstant(function (dispatch) {
    return Object(es["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ var connect_mapDispatchToProps = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mapStateToProps.js

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? wrapMapToPropsFunc(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? wrapMapToPropsConstant(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ var connect_mapStateToProps = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/mergeProps.js


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return _extends({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ var connect_mergeProps = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/verifySubselectors.js


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      warning("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors_verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/selectorFactory.js


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = _objectWithoutPropertiesLoose(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}
// CONCATENATED MODULE: ./node_modules/react-redux/es/connect/connect.js








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? connectAdvanced : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? connect_mapStateToProps : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? connect_mapDispatchToProps : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? connect_mergeProps : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? finalPropsSelectorFactory : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? shallowEqual : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? shallowEqual : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? shallowEqual : _ref3$areMergedPropsE,
        extraOptions = _objectWithoutPropertiesLoose(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, _extends({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ var connect_connect = (createConnect());
// CONCATENATED MODULE: ./node_modules/react-redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "Provider", function() { return components_Provider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createProvider", function() { return createProvider; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "connectAdvanced", function() { return connectAdvanced; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "connect", function() { return connect_connect; });





/***/ }),
/* 10 */
/***/ (function(module, exports) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/
// css base code, injected by the css-loader
module.exports = function(useSourceMap) {
	var list = [];

	// return the list of modules as css string
	list.toString = function toString() {
		return this.map(function (item) {
			var content = cssWithMappingToString(item, useSourceMap);
			if(item[2]) {
				return "@media " + item[2] + "{" + content + "}";
			} else {
				return content;
			}
		}).join("");
	};

	// import a list of modules into the list
	list.i = function(modules, mediaQuery) {
		if(typeof modules === "string")
			modules = [[null, modules, ""]];
		var alreadyImportedModules = {};
		for(var i = 0; i < this.length; i++) {
			var id = this[i][0];
			if(typeof id === "number")
				alreadyImportedModules[id] = true;
		}
		for(i = 0; i < modules.length; i++) {
			var item = modules[i];
			// skip already imported module
			// this implementation is not 100% perfect for weird media query combinations
			//  when a module is imported multiple times with different media queries.
			//  I hope this will never occur (Hey this way we have smaller bundles)
			if(typeof item[0] !== "number" || !alreadyImportedModules[item[0]]) {
				if(mediaQuery && !item[2]) {
					item[2] = mediaQuery;
				} else if(mediaQuery) {
					item[2] = "(" + item[2] + ") and (" + mediaQuery + ")";
				}
				list.push(item);
			}
		}
	};
	return list;
};

function cssWithMappingToString(item, useSourceMap) {
	var content = item[1] || '';
	var cssMapping = item[3];
	if (!cssMapping) {
		return content;
	}

	if (useSourceMap && typeof btoa === 'function') {
		var sourceMapping = toComment(cssMapping);
		var sourceURLs = cssMapping.sources.map(function (source) {
			return '/*# sourceURL=' + cssMapping.sourceRoot + source + ' */'
		});

		return [content].concat(sourceURLs).concat([sourceMapping]).join('\n');
	}

	return [content].join('\n');
}

// Adapted from convert-source-map (MIT)
function toComment(sourceMap) {
	// eslint-disable-next-line no-undef
	var base64 = btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap))));
	var data = 'sourceMappingURL=data:application/json;charset=utf-8;base64,' + base64;

	return '/*# ' + data + ' */';
}


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

/*
	MIT License http://www.opensource.org/licenses/mit-license.php
	Author Tobias Koppers @sokra
*/

var stylesInDom = {};

var	memoize = function (fn) {
	var memo;

	return function () {
		if (typeof memo === "undefined") memo = fn.apply(this, arguments);
		return memo;
	};
};

var isOldIE = memoize(function () {
	// Test for IE <= 9 as proposed by Browserhacks
	// @see http://browserhacks.com/#hack-e71d8692f65334173fee715c222cb805
	// Tests for existence of standard globals is to allow style-loader
	// to operate correctly into non-standard environments
	// @see https://github.com/webpack-contrib/style-loader/issues/177
	return window && document && document.all && !window.atob;
});

var getTarget = function (target) {
  return document.querySelector(target);
};

var getElement = (function (fn) {
	var memo = {};

	return function(target) {
                // If passing function in options, then use it for resolve "head" element.
                // Useful for Shadow Root style i.e
                // {
                //   insertInto: function () { return document.querySelector("#foo").shadowRoot }
                // }
                if (typeof target === 'function') {
                        return target();
                }
                if (typeof memo[target] === "undefined") {
			var styleTarget = getTarget.call(this, target);
			// Special case to return head of iframe instead of iframe itself
			if (window.HTMLIFrameElement && styleTarget instanceof window.HTMLIFrameElement) {
				try {
					// This will throw an exception if access to iframe is blocked
					// due to cross-origin restrictions
					styleTarget = styleTarget.contentDocument.head;
				} catch(e) {
					styleTarget = null;
				}
			}
			memo[target] = styleTarget;
		}
		return memo[target]
	};
})();

var singleton = null;
var	singletonCounter = 0;
var	stylesInsertedAtTop = [];

var	fixUrls = __webpack_require__(335);

module.exports = function(list, options) {
	if (typeof DEBUG !== "undefined" && DEBUG) {
		if (typeof document !== "object") throw new Error("The style-loader cannot be used in a non-browser environment");
	}

	options = options || {};

	options.attrs = typeof options.attrs === "object" ? options.attrs : {};

	// Force single-tag solution on IE6-9, which has a hard limit on the # of <style>
	// tags it will allow on a page
	if (!options.singleton && typeof options.singleton !== "boolean") options.singleton = isOldIE();

	// By default, add <style> tags to the <head> element
        if (!options.insertInto) options.insertInto = "head";

	// By default, add <style> tags to the bottom of the target
	if (!options.insertAt) options.insertAt = "bottom";

	var styles = listToStyles(list, options);

	addStylesToDom(styles, options);

	return function update (newList) {
		var mayRemove = [];

		for (var i = 0; i < styles.length; i++) {
			var item = styles[i];
			var domStyle = stylesInDom[item.id];

			domStyle.refs--;
			mayRemove.push(domStyle);
		}

		if(newList) {
			var newStyles = listToStyles(newList, options);
			addStylesToDom(newStyles, options);
		}

		for (var i = 0; i < mayRemove.length; i++) {
			var domStyle = mayRemove[i];

			if(domStyle.refs === 0) {
				for (var j = 0; j < domStyle.parts.length; j++) domStyle.parts[j]();

				delete stylesInDom[domStyle.id];
			}
		}
	};
};

function addStylesToDom (styles, options) {
	for (var i = 0; i < styles.length; i++) {
		var item = styles[i];
		var domStyle = stylesInDom[item.id];

		if(domStyle) {
			domStyle.refs++;

			for(var j = 0; j < domStyle.parts.length; j++) {
				domStyle.parts[j](item.parts[j]);
			}

			for(; j < item.parts.length; j++) {
				domStyle.parts.push(addStyle(item.parts[j], options));
			}
		} else {
			var parts = [];

			for(var j = 0; j < item.parts.length; j++) {
				parts.push(addStyle(item.parts[j], options));
			}

			stylesInDom[item.id] = {id: item.id, refs: 1, parts: parts};
		}
	}
}

function listToStyles (list, options) {
	var styles = [];
	var newStyles = {};

	for (var i = 0; i < list.length; i++) {
		var item = list[i];
		var id = options.base ? item[0] + options.base : item[0];
		var css = item[1];
		var media = item[2];
		var sourceMap = item[3];
		var part = {css: css, media: media, sourceMap: sourceMap};

		if(!newStyles[id]) styles.push(newStyles[id] = {id: id, parts: [part]});
		else newStyles[id].parts.push(part);
	}

	return styles;
}

function insertStyleElement (options, style) {
	var target = getElement(options.insertInto)

	if (!target) {
		throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
	}

	var lastStyleElementInsertedAtTop = stylesInsertedAtTop[stylesInsertedAtTop.length - 1];

	if (options.insertAt === "top") {
		if (!lastStyleElementInsertedAtTop) {
			target.insertBefore(style, target.firstChild);
		} else if (lastStyleElementInsertedAtTop.nextSibling) {
			target.insertBefore(style, lastStyleElementInsertedAtTop.nextSibling);
		} else {
			target.appendChild(style);
		}
		stylesInsertedAtTop.push(style);
	} else if (options.insertAt === "bottom") {
		target.appendChild(style);
	} else if (typeof options.insertAt === "object" && options.insertAt.before) {
		var nextSibling = getElement(options.insertInto + " " + options.insertAt.before);
		target.insertBefore(style, nextSibling);
	} else {
		throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
	}
}

function removeStyleElement (style) {
	if (style.parentNode === null) return false;
	style.parentNode.removeChild(style);

	var idx = stylesInsertedAtTop.indexOf(style);
	if(idx >= 0) {
		stylesInsertedAtTop.splice(idx, 1);
	}
}

function createStyleElement (options) {
	var style = document.createElement("style");

	options.attrs.type = "text/css";

	addAttrs(style, options.attrs);
	insertStyleElement(options, style);

	return style;
}

function createLinkElement (options) {
	var link = document.createElement("link");

	options.attrs.type = "text/css";
	options.attrs.rel = "stylesheet";

	addAttrs(link, options.attrs);
	insertStyleElement(options, link);

	return link;
}

function addAttrs (el, attrs) {
	Object.keys(attrs).forEach(function (key) {
		el.setAttribute(key, attrs[key]);
	});
}

function addStyle (obj, options) {
	var style, update, remove, result;

	// If a transform function was defined, run it on the css
	if (options.transform && obj.css) {
	    result = options.transform(obj.css);

	    if (result) {
	    	// If transform returns a value, use that instead of the original css.
	    	// This allows running runtime transformations on the css.
	    	obj.css = result;
	    } else {
	    	// If the transform function returns a falsy value, don't add this css.
	    	// This allows conditional loading of css
	    	return function() {
	    		// noop
	    	};
	    }
	}

	if (options.singleton) {
		var styleIndex = singletonCounter++;

		style = singleton || (singleton = createStyleElement(options));

		update = applyToSingletonTag.bind(null, style, styleIndex, false);
		remove = applyToSingletonTag.bind(null, style, styleIndex, true);

	} else if (
		obj.sourceMap &&
		typeof URL === "function" &&
		typeof URL.createObjectURL === "function" &&
		typeof URL.revokeObjectURL === "function" &&
		typeof Blob === "function" &&
		typeof btoa === "function"
	) {
		style = createLinkElement(options);
		update = updateLink.bind(null, style, options);
		remove = function () {
			removeStyleElement(style);

			if(style.href) URL.revokeObjectURL(style.href);
		};
	} else {
		style = createStyleElement(options);
		update = applyToTag.bind(null, style);
		remove = function () {
			removeStyleElement(style);
		};
	}

	update(obj);

	return function updateStyle (newObj) {
		if (newObj) {
			if (
				newObj.css === obj.css &&
				newObj.media === obj.media &&
				newObj.sourceMap === obj.sourceMap
			) {
				return;
			}

			update(obj = newObj);
		} else {
			remove();
		}
	};
}

var replaceText = (function () {
	var textStore = [];

	return function (index, replacement) {
		textStore[index] = replacement;

		return textStore.filter(Boolean).join('\n');
	};
})();

function applyToSingletonTag (style, index, remove, obj) {
	var css = remove ? "" : obj.css;

	if (style.styleSheet) {
		style.styleSheet.cssText = replaceText(index, css);
	} else {
		var cssNode = document.createTextNode(css);
		var childNodes = style.childNodes;

		if (childNodes[index]) style.removeChild(childNodes[index]);

		if (childNodes.length) {
			style.insertBefore(cssNode, childNodes[index]);
		} else {
			style.appendChild(cssNode);
		}
	}
}

function applyToTag (style, obj) {
	var css = obj.css;
	var media = obj.media;

	if(media) {
		style.setAttribute("media", media)
	}

	if(style.styleSheet) {
		style.styleSheet.cssText = css;
	} else {
		while(style.firstChild) {
			style.removeChild(style.firstChild);
		}

		style.appendChild(document.createTextNode(css));
	}
}

function updateLink (link, options, obj) {
	var css = obj.css;
	var sourceMap = obj.sourceMap;

	/*
		If convertToAbsoluteUrls isn't defined, but sourcemaps are enabled
		and there is no publicPath defined then lets turn convertToAbsoluteUrls
		on by default.  Otherwise default to the convertToAbsoluteUrls option
		directly
	*/
	var autoFixUrls = options.convertToAbsoluteUrls === undefined && sourceMap;

	if (options.convertToAbsoluteUrls || autoFixUrls) {
		css = fixUrls(css);
	}

	if (sourceMap) {
		// http://stackoverflow.com/a/26603875
		css += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(sourceMap)))) + " */";
	}

	var blob = new Blob([css], { type: "text/css" });

	var oldSrc = link.href;

	link.href = URL.createObjectURL(blob);

	if(oldSrc) URL.revokeObjectURL(oldSrc);
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hideMandatoryLogin = exports.showMandatoryLogin = exports.hideErrorDialog = exports.showErrorDialog = exports.hideForgottenPassword = exports.showForgottenPassword = exports.hideResetPassword = exports.showResetPassword = exports.setEmailVerificationData = exports.hideEmailVerification = exports.showEmailVerification = exports.hideBarriers = exports.showBarriers = exports.signOut = exports.signIn = exports.HIDE_MANDATORY_LOGIN = exports.SHOW_MANDATORY_LOGIN = exports.HIDE_ERROR_DIALOG = exports.SHOW_ERROR_DIALOG = exports.HIDE_FORGOTTEN_PASSWORD = exports.SHOW_FORGOTTEN_PASSWORD = exports.HIDE_CREATE_PASSWORD = exports.SHOW_CREATE_PASSWORD = exports.HIDE_RESET_PASSWORD = exports.SHOW_RESET_PASSWORD = exports.SET_EMAIL_VERIFICATION_MESSAGE = exports.HIDE_EMAIL_VERIFICATION = exports.SHOW_EMAIL_VERIFICATION = exports.HIDE_BARRIER = exports.SHOW_BARRIER = exports.SIGN_OUT = exports.SIGN_IN = exports.SET_SESSION = undefined;

var _rpAnalytics = __webpack_require__(23);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var SET_SESSION = exports.SET_SESSION = 'SESSION_SET';
var SIGN_IN = exports.SIGN_IN = 'SIGN_IN';
var SIGN_OUT = exports.SIGN_OUT = 'SIGN_OUT';
var SHOW_BARRIER = exports.SHOW_BARRIER = 'SHOW_BARRIER';
var HIDE_BARRIER = exports.HIDE_BARRIER = 'HIDE_BARRIER';
var SHOW_EMAIL_VERIFICATION = exports.SHOW_EMAIL_VERIFICATION = 'SHOW_EMAIL_VERIFICATION';
var HIDE_EMAIL_VERIFICATION = exports.HIDE_EMAIL_VERIFICATION = 'HIDE_EMAIL_VERIFICATION';
var SET_EMAIL_VERIFICATION_MESSAGE = exports.SET_EMAIL_VERIFICATION_MESSAGE = 'SET_EMAIL_VERIFICATION_MESSAGE';
var SHOW_RESET_PASSWORD = exports.SHOW_RESET_PASSWORD = 'SHOW_RESET_PASSWORD';
var HIDE_RESET_PASSWORD = exports.HIDE_RESET_PASSWORD = 'HIDE_RESET_PASSWORD';
var SHOW_CREATE_PASSWORD = exports.SHOW_CREATE_PASSWORD = 'SHOW_CREATE_PASSWORD';
var HIDE_CREATE_PASSWORD = exports.HIDE_CREATE_PASSWORD = 'HIDE_CREATE_PASSWORD';
var SHOW_FORGOTTEN_PASSWORD = exports.SHOW_FORGOTTEN_PASSWORD = 'SHOW_FORGOTTEN_PASSWORD';
var HIDE_FORGOTTEN_PASSWORD = exports.HIDE_FORGOTTEN_PASSWORD = 'HIDE_FORGOTTEN_PASSWORD';
var SHOW_ERROR_DIALOG = exports.SHOW_ERROR_DIALOG = 'SHOW_ERROR_DIALOG';
var HIDE_ERROR_DIALOG = exports.HIDE_ERROR_DIALOG = 'HIDE_ERROR_DIALOG';
var SHOW_MANDATORY_LOGIN = exports.SHOW_MANDATORY_LOGIN = 'SHOW_MANDATORY_LOGIN';
var HIDE_MANDATORY_LOGIN = exports.HIDE_MANDATORY_LOGIN = 'HIDE_MANDATORY_LOGIN';

var signIn = exports.signIn = function signIn() {
    return { type: SIGN_IN };
};
var signOut = exports.signOut = function signOut() {
    return { type: SIGN_OUT };
};

var showBarriers = exports.showBarriers = function showBarriers(step, backUrl, text, service, showTitle) {
    (0, _rpAnalytics.identify)().then(function () {
        (0, _rpAnalytics.trackBarrierShow)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, backUrl));
    });
    return {
        type: SHOW_BARRIER, step: step, backUrl: backUrl, text: text, service: service, showTitle: showTitle
    };
};
var hideBarriers = exports.hideBarriers = function hideBarriers() {
    return { type: HIDE_BARRIER };
};
var showEmailVerification = exports.showEmailVerification = function showEmailVerification(message, accountId, session) {
    return {
        type: SHOW_EMAIL_VERIFICATION,
        message: message,
        accountId: accountId,
        session: session
    };
};
var hideEmailVerification = exports.hideEmailVerification = function hideEmailVerification() {
    return { type: HIDE_EMAIL_VERIFICATION };
};
var setEmailVerificationData = exports.setEmailVerificationData = function setEmailVerificationData(message, accountId, session) {
    return {
        type: SET_EMAIL_VERIFICATION_MESSAGE,
        message: message,
        accountId: accountId,
        session: session
    };
};
var showResetPassword = exports.showResetPassword = function showResetPassword(email) {
    return { type: SHOW_RESET_PASSWORD, email: email };
};
var hideResetPassword = exports.hideResetPassword = function hideResetPassword() {
    return { type: HIDE_RESET_PASSWORD };
};
var showForgottenPassword = exports.showForgottenPassword = function showForgottenPassword() {
    (0, _rpAnalytics.identify)().then(function () {
        (0, _rpAnalytics.trackBarrierSignInPassword)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, global.location.href));
    });
    return { type: SHOW_FORGOTTEN_PASSWORD };
};
var hideForgottenPassword = exports.hideForgottenPassword = function hideForgottenPassword() {
    return { type: HIDE_FORGOTTEN_PASSWORD };
};
var showErrorDialog = exports.showErrorDialog = function showErrorDialog() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    var action = arguments[1];
    return {
        type: SHOW_ERROR_DIALOG,
        message: message,
        action: action
    };
};
var hideErrorDialog = exports.hideErrorDialog = function hideErrorDialog() {
    return { type: HIDE_ERROR_DIALOG };
};
var showMandatoryLogin = exports.showMandatoryLogin = function showMandatoryLogin(step, target) {
    return { type: SHOW_MANDATORY_LOGIN, step: step, target: target };
};
var hideMandatoryLogin = exports.hideMandatoryLogin = function hideMandatoryLogin() {
    return { type: HIDE_MANDATORY_LOGIN };
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(89)('wks');
var uid = __webpack_require__(90);
var Symbol = __webpack_require__(13).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.upgradeSubscription = exports.renewSubscription = exports.confirmSubscription = exports.createUserPassword = exports.requestPasswordChange = exports.resetUserPassword = exports.getUserPackage = exports.getUserServices = exports.getUserAmend = exports.getSessionStatus = exports.getSubscriptions = exports.handleLogout = exports.deleteSession = exports.getAccess = exports.getSession = exports.AuthStateIdentify = exports.AuthSignUp = exports.AuthSignIn = exports.getApplicableToMove = exports.confirmVerificationEmail = exports.sendVerificationEmail = exports.getOfferInfo = exports.getUserCardInfo = exports.getUserInfo = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = __webpack_require__(118);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(94);

var _qs2 = _interopRequireDefault(_qs);

var _jsCookie = __webpack_require__(28);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _getMPPAttributes2 = __webpack_require__(320);

var _getMPPAttributes3 = _interopRequireDefault(_getMPPAttributes2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _getMPPAttributes = (0, _getMPPAttributes3.default)(),
    esuitejsToken = _getMPPAttributes.esuitejsToken,
    esuitejsRestEndpoint = _getMPPAttributes.esuitejsRestEndpoint,
    esuitejsRestVersion = _getMPPAttributes.esuitejsRestVersion;

var sessionUrl = '/subscriptions/session';
var logoutUrl = '/api/auth/logout';
var accessUrl = '/subscriptions/access';
var BASE_URL = esuitejsRestEndpoint + '/api';
var ACCOUNTS_URL = BASE_URL + '/accounts';
var OFFER_URL = BASE_URL + '/offers';
var AUTHENTICATION_URL = ACCOUNTS_URL + '/authenticate';
var FORGOTTEN_PASSWORD_URL = ACCOUNTS_URL + '/forgotten-password';
var RESET_PASSWORD_URL = ACCOUNTS_URL + '/update-password';
var SESSIONS_URL = BASE_URL + '/sessions';
var EMAIL_VERIFICATION_URL = '/verify';
var SUBSCRIPTIONS_URL = '/subscriptions';
var AUTH_STATE_JANUS = 'auth_state';

var getSubscriptionMoveUrl = function getSubscriptionMoveUrl(accountReference, subscriptionReference) {
    return ACCOUNTS_URL + '/' + accountReference + '/subscriptions/' + subscriptionReference + '/move';
};
var getAccountReferenceUrl = function getAccountReferenceUrl(accountReference) {
    return ACCOUNTS_URL + '/' + accountReference;
};

var parametersNames = ['RP_horseBetting', 'RP_horseNews', 'RP_bloodstock', 'RP_sportBetting', 'RP_competitions', 'RP_newsletterThirdParty', 'RP_18yo', 'RP_isTermsAgreed', 'membersBriefing', 'theFrontRunner', 'theUltimateDaily', 'subscriberRewards'];

var getMPPHeaders = function getMPPHeaders(session, version) {
    return _extends({
        'Content-Type': 'application/json; charset=UTF-8',
        'X-TokenId': esuitejsToken,
        'X-Version': version || esuitejsRestVersion
    }, session ? {
        'X-SessionId': session
    } : null);
};

var getRawHeaders = function getRawHeaders() {
    return {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
    };
};

var config = {
    RP_18yo: 'eighteenYears',
    RP_isTermsAgreed: 'termsConditions',
    membersBriefing: 'membersBriefing',
    theFrontRunner: 'theFrontRunner',
    theUltimateDaily: 'theUltimateDaily',
    subscriberRewards: 'subscriberRewards'
};

var setCustomParameters = function setCustomParameters(conditions) {
    var customParameters = {};

    parametersNames.forEach(function (name) {
        customParameters[name] = config[name] ? Number(conditions[config[name]]) || 0 : Number(conditions[name.slice(3)]) || 0;
    });

    return customParameters;
};

var getChangeUserDetails = function getChangeUserDetails(key, value, isCustomParameter, isExistent) {
    return {
        op: isExistent ? 'replace' : 'add',
        path: '/' + (isCustomParameter ? 'CustomAccountParameter/' : '') + key,
        value: value
    };
};

var getCustomParametersArray = function getCustomParametersArray(conditions, customParameters) {
    return Object.keys(conditions).map(function (key) {
        var hasKey = key in customParameters;
        return getChangeUserDetails(key, conditions[key], true, hasKey);
    });
};

var getUserAmendDataArray = function getUserAmendDataArray(existingData, newData) {
    var dataArray = [];
    Object.keys(newData).forEach(function (key) {
        if (key === 'conditions') {
            dataArray.push.apply(dataArray, _toConsumableArray(getCustomParametersArray(setCustomParameters(newData[key]), existingData.customParameters)));
        } else if (key.toLowerCase() === 'lastname') {
            dataArray.push(getChangeUserDetails('surname', newData[key], false, true));
        } else if (key.toLowerCase() === 'phone') {
            dataArray.push(getChangeUserDetails('phonenumber', newData[key], false, true));
        } else {
            dataArray.push(getChangeUserDetails(key.toLowerCase(), newData[key], false, true));
        }
    });

    return dataArray;
};

var signInOptions = function signInOptions(sessionId, email, clientUserId) {
    return {
        url: sessionUrl,
        method: 'put',
        headers: getRawHeaders(),
        data: _qs2.default.stringify({
            sessionId: sessionId,
            email: email,
            clientUserId: clientUserId
        })
    };
};

var getUserInfo = exports.getUserInfo = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(accountReference, sessionToken) {
        var getAccountInfoOptions, _ref2, data;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        getAccountInfoOptions = {
                            url: ACCOUNTS_URL + '/' + accountReference,
                            method: 'get',
                            headers: getMPPHeaders(sessionToken)
                        };
                        _context.prev = 1;
                        _context.next = 4;
                        return (0, _axios2.default)(getAccountInfoOptions);

                    case 4:
                        _ref2 = _context.sent;
                        data = _ref2.data;
                        return _context.abrupt('return', data);

                    case 9:
                        _context.prev = 9;
                        _context.t0 = _context['catch'](1);
                        throw _context.t0;

                    case 12:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[1, 9]]);
    }));

    return function getUserInfo(_x, _x2) {
        return _ref.apply(this, arguments);
    };
}();

var getUserCardInfo = exports.getUserCardInfo = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(accountReference, sessionToken) {
        var getAccountPaymentInfoOptions, _ref4, data;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
                switch (_context2.prev = _context2.next) {
                    case 0:
                        getAccountPaymentInfoOptions = {
                            url: ACCOUNTS_URL + '/' + accountReference + '/payment-details',
                            method: 'get',
                            headers: getMPPHeaders(sessionToken)
                        };
                        _context2.prev = 1;
                        _context2.next = 4;
                        return (0, _axios2.default)(getAccountPaymentInfoOptions);

                    case 4:
                        _ref4 = _context2.sent;
                        data = _ref4.data;
                        return _context2.abrupt('return', data);

                    case 9:
                        _context2.prev = 9;
                        _context2.t0 = _context2['catch'](1);
                        throw _context2.t0;

                    case 12:
                    case 'end':
                        return _context2.stop();
                }
            }
        }, _callee2, undefined, [[1, 9]]);
    }));

    return function getUserCardInfo(_x3, _x4) {
        return _ref3.apply(this, arguments);
    };
}();

// TODO hardcoded mpp api version - diff in response
// Returns offer info or list off all voucher for that offer
var getOfferInfo = exports.getOfferInfo = function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(offerReference, sessionToken) {
        var hasVouchers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

        var endpoint, getOfferConfig, _ref6, data;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) {
                switch (_context3.prev = _context3.next) {
                    case 0:
                        endpoint = hasVouchers ? offerReference + '/vouchers' : offerReference;
                        getOfferConfig = {
                            url: OFFER_URL + '/' + endpoint + '/',
                            method: 'get',
                            headers: getMPPHeaders(sessionToken, '11.17.0')
                        };
                        _context3.prev = 2;
                        _context3.next = 5;
                        return (0, _axios2.default)(getOfferConfig);

                    case 5:
                        _ref6 = _context3.sent;
                        data = _ref6.data;
                        return _context3.abrupt('return', data);

                    case 10:
                        _context3.prev = 10;
                        _context3.t0 = _context3['catch'](2);
                        throw _context3.t0;

                    case 13:
                    case 'end':
                        return _context3.stop();
                }
            }
        }, _callee3, undefined, [[2, 10]]);
    }));

    return function getOfferInfo(_x5, _x6) {
        return _ref5.apply(this, arguments);
    };
}();

var sendVerificationEmail = exports.sendVerificationEmail = function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(accountReference, sessionToken) {
        var emailVerificationOptions;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
            while (1) {
                switch (_context4.prev = _context4.next) {
                    case 0:
                        emailVerificationOptions = {
                            url: '' + getAccountReferenceUrl(accountReference) + EMAIL_VERIFICATION_URL,
                            method: 'post',
                            headers: getMPPHeaders(sessionToken)
                        };
                        _context4.prev = 1;
                        _context4.next = 4;
                        return (0, _axios2.default)(emailVerificationOptions);

                    case 4:
                        return _context4.abrupt('return', _context4.sent);

                    case 7:
                        _context4.prev = 7;
                        _context4.t0 = _context4['catch'](1);
                        throw _context4.t0;

                    case 10:
                    case 'end':
                        return _context4.stop();
                }
            }
        }, _callee4, undefined, [[1, 7]]);
    }));

    return function sendVerificationEmail(_x8, _x9) {
        return _ref7.apply(this, arguments);
    };
}();

var confirmVerificationEmail = exports.confirmVerificationEmail = function () {
    var _ref8 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(verificationToken) {
        var emailConfirmationOptions;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
                switch (_context5.prev = _context5.next) {
                    case 0:
                        emailConfirmationOptions = {
                            url: '' + ACCOUNTS_URL + EMAIL_VERIFICATION_URL,
                            method: 'patch',
                            headers: getMPPHeaders(),
                            data: {
                                verificationToken: verificationToken
                            }
                        };
                        _context5.prev = 1;
                        _context5.next = 4;
                        return (0, _axios2.default)(emailConfirmationOptions);

                    case 4:
                        return _context5.abrupt('return', _context5.sent);

                    case 7:
                        _context5.prev = 7;
                        _context5.t0 = _context5['catch'](1);
                        throw _context5.t0;

                    case 10:
                    case 'end':
                        return _context5.stop();
                }
            }
        }, _callee5, undefined, [[1, 7]]);
    }));

    return function confirmVerificationEmail(_x10) {
        return _ref8.apply(this, arguments);
    };
}();

var getApplicableToMove = exports.getApplicableToMove = function () {
    var _ref9 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(accountReference, sessionToken, currentServiceId) {
        var availableSubscriptionOptions, _ref10, data;

        return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
                switch (_context6.prev = _context6.next) {
                    case 0:
                        availableSubscriptionOptions = {
                            url: getSubscriptionMoveUrl(accountReference, currentServiceId) + 's/Available',
                            method: 'get',
                            headers: getMPPHeaders(sessionToken)
                        };
                        _context6.prev = 1;
                        _context6.next = 4;
                        return (0, _axios2.default)(availableSubscriptionOptions);

                    case 4:
                        _ref10 = _context6.sent;
                        data = _ref10.data;
                        return _context6.abrupt('return', data);

                    case 9:
                        _context6.prev = 9;
                        _context6.t0 = _context6['catch'](1);
                        throw _context6.t0;

                    case 12:
                    case 'end':
                        return _context6.stop();
                }
            }
        }, _callee6, undefined, [[1, 9]]);
    }));

    return function getApplicableToMove(_x11, _x12, _x13) {
        return _ref9.apply(this, arguments);
    };
}();

// not used due to Auth0
var AuthSignIn = exports.AuthSignIn = function () {
    var _ref11 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(email, password) {
        var checkEmailVeriied = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        var MPPSignInOptions, _ref12, _ref12$data, resourceReference, sessionToken, _ref13, verified, clientUserId, error;

        return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
                switch (_context7.prev = _context7.next) {
                    case 0:
                        MPPSignInOptions = {
                            url: AUTHENTICATION_URL,
                            method: 'post',
                            headers: getMPPHeaders(null, '10.2.0'),
                            data: { email: email, password: password }
                        };
                        _context7.prev = 1;
                        _context7.next = 4;
                        return (0, _axios2.default)(MPPSignInOptions);

                    case 4:
                        _ref12 = _context7.sent;
                        _ref12$data = _ref12.data;
                        resourceReference = _ref12$data.resourceReference;
                        sessionToken = _ref12$data.sessionToken;
                        _context7.next = 10;
                        return getUserInfo(resourceReference, sessionToken);

                    case 10:
                        _ref13 = _context7.sent;
                        verified = _ref13.verified;
                        clientUserId = _ref13.clientUserId;

                        if (!(checkEmailVeriied && !verified)) {
                            _context7.next = 19;
                            break;
                        }

                        error = new Error('Account not verified');

                        error.accountNotVerified = !verified;
                        error.accountId = resourceReference;
                        error.session = sessionToken;
                        throw error;

                    case 19:
                        _context7.next = 21;
                        return (0, _axios2.default)(signInOptions(sessionToken, email, clientUserId));

                    case 21:
                        return _context7.abrupt('return', _context7.sent);

                    case 24:
                        _context7.prev = 24;
                        _context7.t0 = _context7['catch'](1);
                        throw _context7.t0;

                    case 27:
                    case 'end':
                        return _context7.stop();
                }
            }
        }, _callee7, undefined, [[1, 24]]);
    }));

    return function AuthSignIn(_x14, _x15) {
        return _ref11.apply(this, arguments);
    };
}();

// not used due to Auth0
var AuthSignUp = exports.AuthSignUp = function () {
    var _ref14 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8(_ref15) {
        var email = _ref15.email,
            password = _ref15.password,
            conditions = _ref15.conditions;

        var MPPSignUpOptions, _ref16, data;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
                switch (_context8.prev = _context8.next) {
                    case 0:
                        MPPSignUpOptions = {
                            url: ACCOUNTS_URL,
                            method: 'post',
                            headers: getMPPHeaders(),
                            data: {
                                email: email,
                                password: password,
                                customParameters: setCustomParameters(conditions)
                            }
                        };
                        _context8.prev = 1;
                        _context8.next = 4;
                        return (0, _axios2.default)(MPPSignUpOptions);

                    case 4:
                        _ref16 = _context8.sent;
                        data = _ref16.data;
                        _context8.next = 8;
                        return sendVerificationEmail(data.accountReference, data.sessionToken);

                    case 8:
                        return _context8.abrupt('return', data);

                    case 11:
                        _context8.prev = 11;
                        _context8.t0 = _context8['catch'](1);
                        throw _context8.t0;

                    case 14:
                    case 'end':
                        return _context8.stop();
                }
            }
        }, _callee8, undefined, [[1, 11]]);
    }));

    return function AuthSignUp(_x17) {
        return _ref14.apply(this, arguments);
    };
}();

var AuthStateIdentify = exports.AuthStateIdentify = function AuthStateIdentify(currentSession) {
    var getAuthStateCookie = _jsCookie2.default.get(AUTH_STATE_JANUS);

    if (!getAuthStateCookie) return;

    var authStateSessionId = window.atob(getAuthStateCookie);

    if (authStateSessionId === currentSession) {
        _jsCookie2.default.remove(AUTH_STATE_JANUS, { path: '/', domain: '.racingpost.com' });
        window.authApi.onSignInSuccess();
    }
};

var getSession = exports.getSession = function () {
    var _ref17 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _ref18, session;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) {
                switch (_context9.prev = _context9.next) {
                    case 0:
                        _context9.prev = 0;
                        _context9.next = 3;
                        return (0, _axios2.default)(sessionUrl);

                    case 3:
                        _ref18 = _context9.sent;
                        session = _ref18.data.session;

                        AuthStateIdentify(session);

                        return _context9.abrupt('return', session ? Promise.resolve(session) : Promise.reject(new Error('Session expired')));

                    case 9:
                        _context9.prev = 9;
                        _context9.t0 = _context9['catch'](0);
                        throw _context9.t0;

                    case 12:
                    case 'end':
                        return _context9.stop();
                }
            }
        }, _callee9, undefined, [[0, 9]]);
    }));

    return function getSession() {
        return _ref17.apply(this, arguments);
    };
}();

var getAccess = exports.getAccess = function () {
    var _ref19 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10(_ref20) {
        var requestUrl = _ref20.requestUrl;
        var response, data, access;
        return regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) {
                switch (_context10.prev = _context10.next) {
                    case 0:
                        console.log(requestUrl, 'requestUrl');
                        _context10.prev = 1;
                        _context10.next = 4;
                        return (0, _axios2.default)(accessUrl, {
                            params: { url: requestUrl }
                        });

                    case 4:
                        response = _context10.sent;


                        console.log(response, 'response');

                        data = response.data;

                        console.log(data, 'data');

                        access = data.access;

                        console.log(access, 'access');

                        return _context10.abrupt('return', access ? Promise.resolve(access) : Promise.resolve(false));

                    case 13:
                        _context10.prev = 13;
                        _context10.t0 = _context10['catch'](1);

                        console.log(_context10.t0, 'error');
                        throw _context10.t0;

                    case 17:
                    case 'end':
                        return _context10.stop();
                }
            }
        }, _callee10, undefined, [[1, 13]]);
    }));

    return function getAccess(_x18) {
        return _ref19.apply(this, arguments);
    };
}();

var deleteSession = exports.deleteSession = function () {
    var _ref21 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var getSessionOptions, session;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) {
                switch (_context11.prev = _context11.next) {
                    case 0:
                        getSessionOptions = function getSessionOptions(session) {
                            return {
                                url: SESSIONS_URL,
                                method: 'delete',
                                headers: getMPPHeaders(session)
                            };
                        };

                        _context11.prev = 1;
                        _context11.next = 4;
                        return getSession();

                    case 4:
                        session = _context11.sent;
                        _context11.next = 7;
                        return _axios2.default.delete(sessionUrl);

                    case 7:
                        if (!session) {
                            _context11.next = 10;
                            break;
                        }

                        _context11.next = 10;
                        return (0, _axios2.default)(getSessionOptions(session));

                    case 10:
                        return _context11.abrupt('return', session);

                    case 13:
                        _context11.prev = 13;
                        _context11.t0 = _context11['catch'](1);
                        return _context11.abrupt('return', { session: false });

                    case 16:
                    case 'end':
                        return _context11.stop();
                }
            }
        }, _callee11, undefined, [[1, 13]]);
    }));

    return function deleteSession() {
        return _ref21.apply(this, arguments);
    };
}();

var handleLogout = exports.handleLogout = function handleLogout() {
    deleteSession().then(function () {
        window.location.href = logoutUrl;
    });
};

var getSubscriptions = exports.getSubscriptions = function getSubscriptions() {
    return _axios2.default.get('/subscriptions/services');
};

var getSessionStatus = exports.getSessionStatus = function () {
    var _ref22 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
        var getSessionOptions, session, _ref23, data;

        return regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) {
                switch (_context12.prev = _context12.next) {
                    case 0:
                        getSessionOptions = function getSessionOptions(session) {
                            return {
                                url: SESSIONS_URL,
                                method: 'get',
                                headers: getMPPHeaders(session)
                            };
                        };

                        _context12.prev = 1;
                        _context12.next = 4;
                        return getSession();

                    case 4:
                        session = _context12.sent;

                        if (session) {
                            _context12.next = 7;
                            break;
                        }

                        return _context12.abrupt('return', { session: false });

                    case 7:
                        _context12.next = 9;
                        return (0, _axios2.default)(getSessionOptions(session));

                    case 9:
                        _ref23 = _context12.sent;
                        data = _ref23.data;
                        return _context12.abrupt('return', { sessionStatus: data, session: session });

                    case 14:
                        _context12.prev = 14;
                        _context12.t0 = _context12['catch'](1);
                        throw _context12.t0;

                    case 17:
                    case 'end':
                        return _context12.stop();
                }
            }
        }, _callee12, undefined, [[1, 14]]);
    }));

    return function getSessionStatus() {
        return _ref22.apply(this, arguments);
    };
}();

var getUserAmend = exports.getUserAmend = function () {
    var _ref24 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee13(newInfo, sessionInfo) {
        var MPPUserAmendOptions, sessionInfoData, accountReference, session, userInfo, _ref25, data;

        return regeneratorRuntime.wrap(function _callee13$(_context13) {
            while (1) {
                switch (_context13.prev = _context13.next) {
                    case 0:
                        MPPUserAmendOptions = function MPPUserAmendOptions(accountReference, session, userInfo) {
                            return {
                                url: '' + getAccountReferenceUrl(accountReference),
                                method: 'patch',
                                headers: getMPPHeaders(session),
                                data: getUserAmendDataArray(userInfo, newInfo)
                            };
                        };

                        _context13.prev = 1;
                        _context13.t0 = sessionInfo;

                        if (_context13.t0) {
                            _context13.next = 7;
                            break;
                        }

                        _context13.next = 6;
                        return getSessionStatus();

                    case 6:
                        _context13.t0 = _context13.sent;

                    case 7:
                        sessionInfoData = _context13.t0;
                        accountReference = sessionInfoData.sessionStatus.accountReference, session = sessionInfoData.session;
                        _context13.next = 11;
                        return getUserInfo(accountReference, session);

                    case 11:
                        userInfo = _context13.sent;
                        _context13.next = 14;
                        return (0, _axios2.default)(MPPUserAmendOptions(accountReference, session, userInfo));

                    case 14:
                        _ref25 = _context13.sent;
                        data = _ref25.data;
                        return _context13.abrupt('return', data);

                    case 19:
                        _context13.prev = 19;
                        _context13.t1 = _context13['catch'](1);
                        throw _context13.t1;

                    case 22:
                    case 'end':
                        return _context13.stop();
                }
            }
        }, _callee13, undefined, [[1, 19]]);
    }));

    return function getUserAmend(_x19, _x20) {
        return _ref24.apply(this, arguments);
    };
}();

var getUserServices = exports.getUserServices = function () {
    var _ref26 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee14(accountReference, sessionToken) {
        var userServicesOptions, _ref27, data;

        return regeneratorRuntime.wrap(function _callee14$(_context14) {
            while (1) {
                switch (_context14.prev = _context14.next) {
                    case 0:
                        userServicesOptions = {
                            url: '' + getAccountReferenceUrl(accountReference) + SUBSCRIPTIONS_URL,
                            method: 'get',
                            headers: getMPPHeaders(sessionToken, '10.6.0')
                        };
                        _context14.prev = 1;
                        _context14.next = 4;
                        return (0, _axios2.default)(userServicesOptions);

                    case 4:
                        _ref27 = _context14.sent;
                        data = _ref27.data;
                        return _context14.abrupt('return', data);

                    case 9:
                        _context14.prev = 9;
                        _context14.t0 = _context14['catch'](1);
                        throw _context14.t0;

                    case 12:
                    case 'end':
                        return _context14.stop();
                }
            }
        }, _callee14, undefined, [[1, 9]]);
    }));

    return function getUserServices(_x21, _x22) {
        return _ref26.apply(this, arguments);
    };
}();

var getUserPackage = exports.getUserPackage = function () {
    var _ref28 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee15() {
        var _ref29, accountReference, session, _ref30, subscriptions;

        return regeneratorRuntime.wrap(function _callee15$(_context15) {
            while (1) {
                switch (_context15.prev = _context15.next) {
                    case 0:
                        _context15.prev = 0;
                        _context15.next = 3;
                        return getSessionStatus();

                    case 3:
                        _ref29 = _context15.sent;
                        accountReference = _ref29.sessionStatus.accountReference;
                        session = _ref29.session;
                        _context15.next = 8;
                        return getUserServices(accountReference, session);

                    case 8:
                        _ref30 = _context15.sent;
                        subscriptions = _ref30.subscriptions;
                        return _context15.abrupt('return', subscriptions && subscriptions.length && subscriptions[0].defaultSubscriptionInfo.subscriptionTitle);

                    case 13:
                        _context15.prev = 13;
                        _context15.t0 = _context15['catch'](0);
                        throw _context15.t0;

                    case 16:
                    case 'end':
                        return _context15.stop();
                }
            }
        }, _callee15, undefined, [[0, 13]]);
    }));

    return function getUserPackage() {
        return _ref28.apply(this, arguments);
    };
}();

var resetUserPassword = exports.resetUserPassword = function () {
    var _ref31 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee16(email, password, newPassword) {
        var resetPasswordOptions, _ref32, accountReference, session, _ref33, data;

        return regeneratorRuntime.wrap(function _callee16$(_context16) {
            while (1) {
                switch (_context16.prev = _context16.next) {
                    case 0:
                        resetPasswordOptions = function resetPasswordOptions(accountReference, session) {
                            return {
                                url: '' + getAccountReferenceUrl(accountReference),
                                method: 'patch',
                                headers: getMPPHeaders(session),
                                data: [getChangeUserDetails('password', newPassword, false, true)]
                            };
                        };

                        _context16.prev = 1;
                        _context16.next = 4;
                        return AuthSignIn(email, password);

                    case 4:
                        _context16.next = 6;
                        return getSessionStatus();

                    case 6:
                        _ref32 = _context16.sent;
                        accountReference = _ref32.sessionStatus.accountReference;
                        session = _ref32.session;
                        _context16.next = 11;
                        return (0, _axios2.default)(resetPasswordOptions(accountReference, session));

                    case 11:
                        _ref33 = _context16.sent;
                        data = _ref33.data;
                        return _context16.abrupt('return', data);

                    case 16:
                        _context16.prev = 16;
                        _context16.t0 = _context16['catch'](1);
                        throw _context16.t0;

                    case 19:
                    case 'end':
                        return _context16.stop();
                }
            }
        }, _callee16, undefined, [[1, 16]]);
    }));

    return function resetUserPassword(_x23, _x24, _x25) {
        return _ref31.apply(this, arguments);
    };
}();

var requestPasswordChange = exports.requestPasswordChange = function () {
    var _ref34 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee17(emailAddress) {
        var requestPasswordOptions;
        return regeneratorRuntime.wrap(function _callee17$(_context17) {
            while (1) {
                switch (_context17.prev = _context17.next) {
                    case 0:
                        requestPasswordOptions = {
                            url: '' + FORGOTTEN_PASSWORD_URL,
                            method: 'post',
                            headers: getMPPHeaders(),
                            data: { emailAddress: emailAddress }
                        };
                        _context17.prev = 1;
                        _context17.next = 4;
                        return (0, _axios2.default)(requestPasswordOptions);

                    case 4:
                        return _context17.abrupt('return', _context17.sent);

                    case 7:
                        _context17.prev = 7;
                        _context17.t0 = _context17['catch'](1);
                        throw _context17.t0;

                    case 10:
                    case 'end':
                        return _context17.stop();
                }
            }
        }, _callee17, undefined, [[1, 7]]);
    }));

    return function requestPasswordChange(_x26) {
        return _ref34.apply(this, arguments);
    };
}();

var createUserPassword = exports.createUserPassword = function () {
    var _ref35 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee18(token, password) {
        return regeneratorRuntime.wrap(function _callee18$(_context18) {
            while (1) {
                switch (_context18.prev = _context18.next) {
                    case 0:
                        _context18.prev = 0;
                        _context18.next = 3;
                        return (0, _axios2.default)({
                            url: '' + RESET_PASSWORD_URL,
                            method: 'patch',
                            headers: getMPPHeaders(token),
                            data: { password: password, login: false }
                        });

                    case 3:
                        return _context18.abrupt('return', _context18.sent);

                    case 6:
                        _context18.prev = 6;
                        _context18.t0 = _context18['catch'](0);
                        throw _context18.t0;

                    case 9:
                    case 'end':
                        return _context18.stop();
                }
            }
        }, _callee18, undefined, [[0, 6]]);
    }));

    return function createUserPassword(_x27, _x28) {
        return _ref35.apply(this, arguments);
    };
}();

var confirmSubscription = exports.confirmSubscription = function () {
    var _ref36 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee19(payload) {
        var confirmSubscriptionOptions, _ref37, data;

        return regeneratorRuntime.wrap(function _callee19$(_context19) {
            while (1) {
                switch (_context19.prev = _context19.next) {
                    case 0:
                        confirmSubscriptionOptions = {
                            url: sessionUrl + '/payment',
                            method: 'put',
                            headers: getRawHeaders(),
                            data: _qs2.default.stringify(payload),
                            withCredentials: true
                        };
                        _context19.prev = 1;
                        _context19.next = 4;
                        return (0, _axios2.default)(confirmSubscriptionOptions);

                    case 4:
                        _ref37 = _context19.sent;
                        data = _ref37.data;
                        return _context19.abrupt('return', data);

                    case 9:
                        _context19.prev = 9;
                        _context19.t0 = _context19['catch'](1);
                        throw _context19.t0;

                    case 12:
                    case 'end':
                        return _context19.stop();
                }
            }
        }, _callee19, undefined, [[1, 9]]);
    }));

    return function confirmSubscription(_x29) {
        return _ref36.apply(this, arguments);
    };
}();

var renewSubscription = exports.renewSubscription = function () {
    var _ref38 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee20(payload) {
        var renewSubscriptionOptions, _ref39, accountReference, _ref40, data;

        return regeneratorRuntime.wrap(function _callee20$(_context20) {
            while (1) {
                switch (_context20.prev = _context20.next) {
                    case 0:
                        renewSubscriptionOptions = function renewSubscriptionOptions(accountReference) {
                            return {
                                url: '/subscriptions/add',
                                method: 'post',
                                headers: getRawHeaders(),
                                data: _qs2.default.stringify({ servicePriceId: payload.resourceReference, accountReference: accountReference }),
                                withCredentials: true
                            };
                        };

                        _context20.prev = 1;
                        _context20.next = 4;
                        return getSessionStatus();

                    case 4:
                        _ref39 = _context20.sent;
                        accountReference = _ref39.sessionStatus.accountReference;
                        _context20.next = 8;
                        return (0, _axios2.default)(renewSubscriptionOptions(accountReference));

                    case 8:
                        _ref40 = _context20.sent;
                        data = _ref40.data;
                        return _context20.abrupt('return', data);

                    case 13:
                        _context20.prev = 13;
                        _context20.t0 = _context20['catch'](1);
                        throw _context20.t0;

                    case 16:
                    case 'end':
                        return _context20.stop();
                }
            }
        }, _callee20, undefined, [[1, 13]]);
    }));

    return function renewSubscription(_x30) {
        return _ref38.apply(this, arguments);
    };
}();

var upgradeSubscription = exports.upgradeSubscription = function () {
    var _ref41 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee21(_ref42) {
        var currentServiceId = _ref42.currentServiceId,
            servicePriceId = _ref42.servicePriceId;

        var upgradeSubscriptionOptions, _ref43, accountReference, session, _ref44, data;

        return regeneratorRuntime.wrap(function _callee21$(_context21) {
            while (1) {
                switch (_context21.prev = _context21.next) {
                    case 0:
                        upgradeSubscriptionOptions = function upgradeSubscriptionOptions(accountReference, sessionToken) {
                            return {
                                url: getSubscriptionMoveUrl(accountReference, currentServiceId),
                                method: 'post',
                                headers: getMPPHeaders(sessionToken),
                                data: {
                                    servicePriceResourceReference: servicePriceId,
                                    upgradeSubscription: 'Refund',
                                    immediateSwitch: true
                                }
                            };
                        };

                        _context21.prev = 1;
                        _context21.next = 4;
                        return getSessionStatus();

                    case 4:
                        _ref43 = _context21.sent;
                        accountReference = _ref43.sessionStatus.accountReference;
                        session = _ref43.session;
                        _context21.next = 9;
                        return (0, _axios2.default)(upgradeSubscriptionOptions(accountReference, session));

                    case 9:
                        _ref44 = _context21.sent;
                        data = _ref44.data;
                        return _context21.abrupt('return', data);

                    case 14:
                        _context21.prev = 14;
                        _context21.t0 = _context21['catch'](1);
                        throw _context21.t0;

                    case 17:
                    case 'end':
                        return _context21.stop();
                }
            }
        }, _callee21, undefined, [[1, 14]]);
    }));

    return function upgradeSubscription(_x31) {
        return _ref41.apply(this, arguments);
    };
}();

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(119);
var isBuffer = __webpack_require__(303);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 17 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Constants
 * @type {string}
 */
var DEFAULT_AFFILIATION = exports.DEFAULT_AFFILIATION = 'www.racingpost.com';
var CATEGORY_UPGRADE = exports.CATEGORY_UPGRADE = 'upgrade';
var CATEGORY_SUBSCRIPTION = exports.CATEGORY_SUBSCRIPTION = 'subscription';
var MESSAGE_ERROR_NO_ANALYTICS = exports.MESSAGE_ERROR_NO_ANALYTICS = 'window.analytics is not defined.';
var MESSAGE_ERROR_NO_ANALYTICS_DEBUG = exports.MESSAGE_ERROR_NO_ANALYTICS_DEBUG = 'window.analytics.debug is not defined.';

var EVENT_KEY = exports.EVENT_KEY = 'event';
var LOCATION_KEY = exports.LOCATION_KEY = 'Location';
var BOOKMAKER_KEY = exports.BOOKMAKER_KEY = 'Bookmaker';
var EVENT_TYPE_KEY = exports.EVENT_TYPE_KEY = 'Event_Type';
var EVENT_NAME = exports.EVENT_NAME = 'Bookmaker_Event';

var API_NAME_TO_KEY = exports.API_NAME_TO_KEY = {
    bet365: 'bet365_logged_in_web',
    coral: 'coral_logged_in_web',
    williamhill: 'william_hill_logged_in_web',
    paddypower: 'paddy_power_logged_in_web',
    betfair: 'betfair_logged_in_web',
    ladbrokes: 'ladbrokes_logged_in_web',
    skybetflutter: 'skybet_logged_in_web'
};

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(372);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/sass-loader/lib/loader.js!./fields.scss", function() {
		var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--3-1!../../../../node_modules/sass-loader/lib/loader.js!./fields.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.cleanLegacy = exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsCookie = __webpack_require__(28);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _legacy = __webpack_require__(159);

var _legacy2 = _interopRequireDefault(_legacy);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var rpCookie = function (cookie) {
    var cookieType = {
        sharedSession: 'RDSS',
        sharedPermanent: 'RDSP',
        privateSession: 'RDPS',
        privatePermanent: 'RDPP'
    };
    var cookieProp = {
        domain: window.location.hostname.split('.').slice(-2).join('.'),
        lifetime: 365,
        secure: true
    };

    function init(_ref) {
        var name = _ref.name,
            shared = _ref.shared,
            domain = _ref.domain,
            expires = _ref.expires,
            secure = _ref.secure;

        return {
            set: function set(key, value) {
                var cookieValue = _defineProperty({}, key, value);

                if (cookie.getJSON(name)) {
                    cookieValue = _extends(cookie.getJSON(name), cookieValue);
                }

                if (value === null) {
                    cookieValue = cookie.getJSON(name);
                    delete cookieValue[key];
                }

                if (shared) {
                    if (expires) {
                        cookie.set(name, cookieValue, { domain: domain, expires: expires, secure: secure });
                    } else {
                        cookie.set(name, cookieValue, { domain: domain, secure: secure });
                    }
                } else {
                    if (expires) {
                        cookie.set(name, cookieValue, { expires: expires, secure: secure });
                    } else {
                        cookie.set(name, cookieValue, { secure: secure });
                    }
                }
            },
            get: function get(key) {
                var cookieJSON = cookie.getJSON(name);
                if (!cookieJSON) {
                    return undefined;
                }
                return key ? cookieJSON[key] : cookieJSON;
            },
            remove: function remove(key) {
                this.set(key, null);
            }
        };
    }

    var sharedSession = init({
        name: cookieType.sharedSession,
        shared: true,
        domain: cookieProp.domain,
        secure: cookieProp.secure
    });
    var sharedPermanent = init({
        name: cookieType.sharedPermanent,
        shared: true,
        domain: cookieProp.domain,
        expires: cookieProp.lifetime,
        secure: cookieProp.secure
    });
    var privateSession = init({
        name: cookieType.privateSession,
        shared: false,
        secure: cookieProp.secure
    });
    var privatePermanent = init({
        name: cookieType.privatePermanent,
        shared: false,
        expires: cookieProp.lifetime,
        secure: cookieProp.secure
    });

    return {
        sharedSession: sharedSession,
        sharedPermanent: sharedPermanent,
        privateSession: privateSession,
        privatePermanent: privatePermanent
    };
}(_jsCookie2.default);

exports.default = rpCookie;
exports.cleanLegacy = _legacy2.default;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var COOKIE_NAME_USER_PACKAGE = exports.COOKIE_NAME_USER_PACKAGE = 'rp_package';
var COOKIE_NAME_DB_USER_ID = exports.COOKIE_NAME_DB_USER_ID = 'rp_uid';
var COOKIE_NAME_UNIQUE_USER_ID = exports.COOKIE_NAME_UNIQUE_USER_ID = '__t';
var COOKIE_NAME_USER_LOGIN = exports.COOKIE_NAME_USER_LOGIN = 'rp_email';
var COOKIE_LAST_LOGGED_IN_WEB = exports.COOKIE_LAST_LOGGED_IN_WEB = 'rp_last_logged_in_date_web';

var COOKIE_UTM_KEY_FIRST = exports.COOKIE_UTM_KEY_FIRST = 'utmFirst';
var COOKIE_UTM_KEY_LAST = exports.COOKIE_UTM_KEY_LAST = 'utmLast';

/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_22__;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.trackSubscriptionSaleConfirmation = exports.trackFreeBetsTap = exports.trackAllOffers = exports.trackCardIndexClick = exports.trackRacecardOfferButtonClicked = exports.trackRacecardOfferAccordionClosed = exports.trackRacecardOfferAccordionOpened = exports.trackRaceMatrixClick = exports.trackVoucherCodeRemoved = exports.trackVoucherCodeEntered = exports.trackVoucherCodeDenied = exports.trackVoucherCodeApplied = exports.trackUpgradeStarted = exports.trackUpgradeCompleted = exports.trackSubscriptionUpgraded = exports.trackSubscriptionViewed = exports.trackSubscriptionStarted = exports.trackSubscriptionSaleAttempt = exports.trackSubscriptionSale = exports.trackSubscriptionDetailsViewed = exports.trackSubscriptionDetailsCompleted = exports.trackSubscriptionCompleted = exports.trackRemoveSelectionButtonClick = exports.trackRegister = exports.trackQuickStakeButtonsClick = exports.trackPreferencesUpdate = exports.trackBetslipErrorMessage = exports.trackPlaceBet = exports.trackOrderCompleted = exports.trackBookmakerRegistrationTap = exports.trackOfferAccordion = exports.trackNavigationClick = exports.trackBookmakerOfferClaimButtonClick = exports.trackBookmakerLoginSuccess = exports.trackBookmakerLoginFailure = exports.trackBookmakerLoginAttempt = exports.trackCancelBetButtonClick = exports.trackLogin = exports.trackHorseTrackerSettings = exports.trackFooterClick = exports.trackEmailVerification = exports.trackDiscardSlipButtonClick = exports.trackCardCustomisation = exports.trackBookmakerRegister = exports.trackBookmakerLogin = exports.trackBettingOfferClick = exports.trackBetReceipt = exports.trackBetButtonClick = exports.trackBarrierUltimateSubscribe = exports.trackBarrierUltimateShow = exports.trackBarrierUltimateOnlyUpgrade = exports.trackBarrierUltimateOnlyShow = exports.trackBarrierInteraction = exports.trackBarrierSignInShow = exports.trackBarrierSignInPassword = exports.trackBarrierSignIn = exports.trackBarrierShow = exports.trackBarrierEssentialSubscribe = exports.trackBarrierEssentialShow = exports.identifySubscriptionSale = exports.identifyRegister = exports.identifyLogin = exports.clearCommonTraits = exports.setCommonTraits = exports.getCommonTraits = exports.enableDebug = exports.enableLogging = exports.alias = exports.identify = exports.page = exports.track = undefined;

var _events = __webpack_require__(1);

Object.keys(_events).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _events[key];
        }
    });
});

var _traits = __webpack_require__(2);

Object.keys(_traits).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _traits[key];
        }
    });
});

var _registerEvents = __webpack_require__(143);

var _registerEvents2 = _interopRequireDefault(_registerEvents);

var _setUTMParams = __webpack_require__(160);

var _setUTMParams2 = _interopRequireDefault(_setUTMParams);

var _enableLogging = __webpack_require__(193);

var _enableLogging2 = _interopRequireDefault(_enableLogging);

var _enableDebug = __webpack_require__(194);

var _enableDebug2 = _interopRequireDefault(_enableDebug);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _page = __webpack_require__(218);

var _page2 = _interopRequireDefault(_page);

var _identify = __webpack_require__(46);

var _identify2 = _interopRequireDefault(_identify);

var _alias = __webpack_require__(220);

var _alias2 = _interopRequireDefault(_alias);

var _commonTraits = __webpack_require__(45);

var _identifyLogin = __webpack_require__(222);

var _identifyLogin2 = _interopRequireDefault(_identifyLogin);

var _identifyRegister = __webpack_require__(223);

var _identifyRegister2 = _interopRequireDefault(_identifyRegister);

var _identifySubscriptionSale = __webpack_require__(224);

var _identifySubscriptionSale2 = _interopRequireDefault(_identifySubscriptionSale);

var _trackBarrierEssentialShow = __webpack_require__(225);

var _trackBarrierEssentialShow2 = _interopRequireDefault(_trackBarrierEssentialShow);

var _trackBarrierEssentialSubscribe = __webpack_require__(226);

var _trackBarrierEssentialSubscribe2 = _interopRequireDefault(_trackBarrierEssentialSubscribe);

var _trackBarrierShow = __webpack_require__(227);

var _trackBarrierShow2 = _interopRequireDefault(_trackBarrierShow);

var _trackBarrierSignIn = __webpack_require__(228);

var _trackBarrierSignIn2 = _interopRequireDefault(_trackBarrierSignIn);

var _trackBarrierSignInPassword = __webpack_require__(229);

var _trackBarrierSignInPassword2 = _interopRequireDefault(_trackBarrierSignInPassword);

var _trackBarrierSignInShow = __webpack_require__(230);

var _trackBarrierSignInShow2 = _interopRequireDefault(_trackBarrierSignInShow);

var _trackBarrierInteraction = __webpack_require__(231);

var _trackBarrierInteraction2 = _interopRequireDefault(_trackBarrierInteraction);

var _trackBarrierUltimateOnlyShow = __webpack_require__(232);

var _trackBarrierUltimateOnlyShow2 = _interopRequireDefault(_trackBarrierUltimateOnlyShow);

var _trackBarrierUltimateOnlyUpgrade = __webpack_require__(233);

var _trackBarrierUltimateOnlyUpgrade2 = _interopRequireDefault(_trackBarrierUltimateOnlyUpgrade);

var _trackBarrierUltimateShow = __webpack_require__(234);

var _trackBarrierUltimateShow2 = _interopRequireDefault(_trackBarrierUltimateShow);

var _trackBarrierUltimateSubscribe = __webpack_require__(235);

var _trackBarrierUltimateSubscribe2 = _interopRequireDefault(_trackBarrierUltimateSubscribe);

var _trackBetButtonClick = __webpack_require__(236);

var _trackBetButtonClick2 = _interopRequireDefault(_trackBetButtonClick);

var _trackBetReceipt = __webpack_require__(237);

var _trackBetReceipt2 = _interopRequireDefault(_trackBetReceipt);

var _trackBettingOfferClick = __webpack_require__(238);

var _trackBettingOfferClick2 = _interopRequireDefault(_trackBettingOfferClick);

var _trackBookmakerLogin = __webpack_require__(239);

var _trackBookmakerLogin2 = _interopRequireDefault(_trackBookmakerLogin);

var _trackBookmakerRegister = __webpack_require__(240);

var _trackBookmakerRegister2 = _interopRequireDefault(_trackBookmakerRegister);

var _trackBookmakerLoginAttempt = __webpack_require__(241);

var _trackBookmakerLoginAttempt2 = _interopRequireDefault(_trackBookmakerLoginAttempt);

var _trackBookmakerLoginFailure = __webpack_require__(242);

var _trackBookmakerLoginFailure2 = _interopRequireDefault(_trackBookmakerLoginFailure);

var _trackBookmakerLoginSuccess = __webpack_require__(243);

var _trackBookmakerLoginSuccess2 = _interopRequireDefault(_trackBookmakerLoginSuccess);

var _trackBookmakerOfferClaimButtonClick = __webpack_require__(244);

var _trackBookmakerOfferClaimButtonClick2 = _interopRequireDefault(_trackBookmakerOfferClaimButtonClick);

var _trackLogin = __webpack_require__(245);

var _trackLogin2 = _interopRequireDefault(_trackLogin);

var _trackCancelBetButtonClick = __webpack_require__(246);

var _trackCancelBetButtonClick2 = _interopRequireDefault(_trackCancelBetButtonClick);

var _trackCardCustomisation = __webpack_require__(247);

var _trackCardCustomisation2 = _interopRequireDefault(_trackCardCustomisation);

var _trackDiscardSlipButtonClick = __webpack_require__(248);

var _trackDiscardSlipButtonClick2 = _interopRequireDefault(_trackDiscardSlipButtonClick);

var _trackHorseTrackerSettings = __webpack_require__(249);

var _trackHorseTrackerSettings2 = _interopRequireDefault(_trackHorseTrackerSettings);

var _trackEmailVerification = __webpack_require__(250);

var _trackEmailVerification2 = _interopRequireDefault(_trackEmailVerification);

var _trackNavigationClick = __webpack_require__(251);

var _trackNavigationClick2 = _interopRequireDefault(_trackNavigationClick);

var _trackFooterClick = __webpack_require__(252);

var _trackFooterClick2 = _interopRequireDefault(_trackFooterClick);

var _trackOfferAccordion = __webpack_require__(253);

var _trackOfferAccordion2 = _interopRequireDefault(_trackOfferAccordion);

var _trackBookmakerRegistrationTap = __webpack_require__(272);

var _trackBookmakerRegistrationTap2 = _interopRequireDefault(_trackBookmakerRegistrationTap);

var _trackOrderCompleted = __webpack_require__(273);

var _trackOrderCompleted2 = _interopRequireDefault(_trackOrderCompleted);

var _trackPlaceBet = __webpack_require__(274);

var _trackPlaceBet2 = _interopRequireDefault(_trackPlaceBet);

var _trackBetslipErrorMessage = __webpack_require__(275);

var _trackBetslipErrorMessage2 = _interopRequireDefault(_trackBetslipErrorMessage);

var _trackPreferencesUpdate = __webpack_require__(276);

var _trackPreferencesUpdate2 = _interopRequireDefault(_trackPreferencesUpdate);

var _trackQuickStakeButtonsClick = __webpack_require__(277);

var _trackQuickStakeButtonsClick2 = _interopRequireDefault(_trackQuickStakeButtonsClick);

var _trackRegister = __webpack_require__(278);

var _trackRegister2 = _interopRequireDefault(_trackRegister);

var _trackRemoveSelectionButtonClick = __webpack_require__(279);

var _trackRemoveSelectionButtonClick2 = _interopRequireDefault(_trackRemoveSelectionButtonClick);

var _trackSubscriptionCompleted = __webpack_require__(280);

var _trackSubscriptionCompleted2 = _interopRequireDefault(_trackSubscriptionCompleted);

var _trackSubscriptionDetailsCompleted = __webpack_require__(281);

var _trackSubscriptionDetailsCompleted2 = _interopRequireDefault(_trackSubscriptionDetailsCompleted);

var _trackSubscriptionDetailsViewed = __webpack_require__(282);

var _trackSubscriptionDetailsViewed2 = _interopRequireDefault(_trackSubscriptionDetailsViewed);

var _trackSubscriptionSale = __webpack_require__(283);

var _trackSubscriptionSale2 = _interopRequireDefault(_trackSubscriptionSale);

var _trackSubscriptionSaleAttempt = __webpack_require__(284);

var _trackSubscriptionSaleAttempt2 = _interopRequireDefault(_trackSubscriptionSaleAttempt);

var _trackSubscriptionStarted = __webpack_require__(285);

var _trackSubscriptionStarted2 = _interopRequireDefault(_trackSubscriptionStarted);

var _trackSubscriptionViewed = __webpack_require__(286);

var _trackSubscriptionViewed2 = _interopRequireDefault(_trackSubscriptionViewed);

var _trackSubscriptionUpgraded = __webpack_require__(287);

var _trackSubscriptionUpgraded2 = _interopRequireDefault(_trackSubscriptionUpgraded);

var _trackUpgradeCompleted = __webpack_require__(288);

var _trackUpgradeCompleted2 = _interopRequireDefault(_trackUpgradeCompleted);

var _trackUpgradeStarted = __webpack_require__(289);

var _trackUpgradeStarted2 = _interopRequireDefault(_trackUpgradeStarted);

var _trackVoucherCodeApplied = __webpack_require__(290);

var _trackVoucherCodeApplied2 = _interopRequireDefault(_trackVoucherCodeApplied);

var _trackVoucherCodeDenied = __webpack_require__(291);

var _trackVoucherCodeDenied2 = _interopRequireDefault(_trackVoucherCodeDenied);

var _trackVoucherCodeEntered = __webpack_require__(292);

var _trackVoucherCodeEntered2 = _interopRequireDefault(_trackVoucherCodeEntered);

var _trackVoucherCodeRemoved = __webpack_require__(293);

var _trackVoucherCodeRemoved2 = _interopRequireDefault(_trackVoucherCodeRemoved);

var _trackRaceMatrixClick = __webpack_require__(294);

var _trackRaceMatrixClick2 = _interopRequireDefault(_trackRaceMatrixClick);

var _trackRacecardOfferAccordionOpened = __webpack_require__(295);

var _trackRacecardOfferAccordionOpened2 = _interopRequireDefault(_trackRacecardOfferAccordionOpened);

var _trackRacecardOfferAccordionClosed = __webpack_require__(296);

var _trackRacecardOfferAccordionClosed2 = _interopRequireDefault(_trackRacecardOfferAccordionClosed);

var _trackRacecardOfferButtonClicked = __webpack_require__(297);

var _trackRacecardOfferButtonClicked2 = _interopRequireDefault(_trackRacecardOfferButtonClicked);

var _trackCardIndexClick = __webpack_require__(298);

var _trackCardIndexClick2 = _interopRequireDefault(_trackCardIndexClick);

var _trackAllOffers = __webpack_require__(299);

var _trackAllOffers2 = _interopRequireDefault(_trackAllOffers);

var _trackFreeBetsTap = __webpack_require__(300);

var _trackFreeBetsTap2 = _interopRequireDefault(_trackFreeBetsTap);

var _trackSubscriptionSaleConfirmation = __webpack_require__(301);

var _trackSubscriptionSaleConfirmation2 = _interopRequireDefault(_trackSubscriptionSaleConfirmation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _registerEvents2.default)(); /**
                                  * Helper for using segmentio API.
                                  * Provides public interface for calling segmentio
                                  * @author Artem Nakhodkin <artem.nakhodkin@racingpost.com>
                                  * @author Serhii Kotyk <serhii.kotyk@racingpost.com>
                                  */

(0, _setUTMParams2.default)(location.search.substr(1));

exports.track = _track2.default;
exports.page = _page2.default;
exports.identify = _identify2.default;
exports.alias = _alias2.default;
exports.enableLogging = _enableLogging2.default;
exports.enableDebug = _enableDebug2.default;
exports.getCommonTraits = _commonTraits.getCommonTraits;
exports.setCommonTraits = _commonTraits.setCommonTraits;
exports.clearCommonTraits = _commonTraits.clearCommonTraits;
exports.identifyLogin = _identifyLogin2.default;
exports.identifyRegister = _identifyRegister2.default;
exports.identifySubscriptionSale = _identifySubscriptionSale2.default;
exports.trackBarrierEssentialShow = _trackBarrierEssentialShow2.default;
exports.trackBarrierEssentialSubscribe = _trackBarrierEssentialSubscribe2.default;
exports.trackBarrierShow = _trackBarrierShow2.default;
exports.trackBarrierSignIn = _trackBarrierSignIn2.default;
exports.trackBarrierSignInPassword = _trackBarrierSignInPassword2.default;
exports.trackBarrierSignInShow = _trackBarrierSignInShow2.default;
exports.trackBarrierInteraction = _trackBarrierInteraction2.default;
exports.trackBarrierUltimateOnlyShow = _trackBarrierUltimateOnlyShow2.default;
exports.trackBarrierUltimateOnlyUpgrade = _trackBarrierUltimateOnlyUpgrade2.default;
exports.trackBarrierUltimateShow = _trackBarrierUltimateShow2.default;
exports.trackBarrierUltimateSubscribe = _trackBarrierUltimateSubscribe2.default;
exports.trackBetButtonClick = _trackBetButtonClick2.default;
exports.trackBetReceipt = _trackBetReceipt2.default;
exports.trackBettingOfferClick = _trackBettingOfferClick2.default;
exports.trackBookmakerLogin = _trackBookmakerLogin2.default;
exports.trackBookmakerRegister = _trackBookmakerRegister2.default;
exports.trackCardCustomisation = _trackCardCustomisation2.default;
exports.trackDiscardSlipButtonClick = _trackDiscardSlipButtonClick2.default;
exports.trackEmailVerification = _trackEmailVerification2.default;
exports.trackFooterClick = _trackFooterClick2.default;
exports.trackHorseTrackerSettings = _trackHorseTrackerSettings2.default;
exports.trackLogin = _trackLogin2.default;
exports.trackCancelBetButtonClick = _trackCancelBetButtonClick2.default;
exports.trackBookmakerLoginAttempt = _trackBookmakerLoginAttempt2.default;
exports.trackBookmakerLoginFailure = _trackBookmakerLoginFailure2.default;
exports.trackBookmakerLoginSuccess = _trackBookmakerLoginSuccess2.default;
exports.trackBookmakerOfferClaimButtonClick = _trackBookmakerOfferClaimButtonClick2.default;
exports.trackNavigationClick = _trackNavigationClick2.default;
exports.trackOfferAccordion = _trackOfferAccordion2.default;
exports.trackBookmakerRegistrationTap = _trackBookmakerRegistrationTap2.default;
exports.trackOrderCompleted = _trackOrderCompleted2.default;
exports.trackPlaceBet = _trackPlaceBet2.default;
exports.trackBetslipErrorMessage = _trackBetslipErrorMessage2.default;
exports.trackPreferencesUpdate = _trackPreferencesUpdate2.default;
exports.trackQuickStakeButtonsClick = _trackQuickStakeButtonsClick2.default;
exports.trackRegister = _trackRegister2.default;
exports.trackRemoveSelectionButtonClick = _trackRemoveSelectionButtonClick2.default;
exports.trackSubscriptionCompleted = _trackSubscriptionCompleted2.default;
exports.trackSubscriptionDetailsCompleted = _trackSubscriptionDetailsCompleted2.default;
exports.trackSubscriptionDetailsViewed = _trackSubscriptionDetailsViewed2.default;
exports.trackSubscriptionSale = _trackSubscriptionSale2.default;
exports.trackSubscriptionSaleAttempt = _trackSubscriptionSaleAttempt2.default;
exports.trackSubscriptionStarted = _trackSubscriptionStarted2.default;
exports.trackSubscriptionViewed = _trackSubscriptionViewed2.default;
exports.trackSubscriptionUpgraded = _trackSubscriptionUpgraded2.default;
exports.trackUpgradeCompleted = _trackUpgradeCompleted2.default;
exports.trackUpgradeStarted = _trackUpgradeStarted2.default;
exports.trackVoucherCodeApplied = _trackVoucherCodeApplied2.default;
exports.trackVoucherCodeDenied = _trackVoucherCodeDenied2.default;
exports.trackVoucherCodeEntered = _trackVoucherCodeEntered2.default;
exports.trackVoucherCodeRemoved = _trackVoucherCodeRemoved2.default;
exports.trackRaceMatrixClick = _trackRaceMatrixClick2.default;
exports.trackRacecardOfferAccordionOpened = _trackRacecardOfferAccordionOpened2.default;
exports.trackRacecardOfferAccordionClosed = _trackRacecardOfferAccordionClosed2.default;
exports.trackRacecardOfferButtonClicked = _trackRacecardOfferButtonClicked2.default;
exports.trackCardIndexClick = _trackCardIndexClick2.default;
exports.trackAllOffers = _trackAllOffers2.default;
exports.trackFreeBetsTap = _trackFreeBetsTap2.default;
exports.trackSubscriptionSaleConfirmation = _trackSubscriptionSaleConfirmation2.default;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(34);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(53)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var core = __webpack_require__(17);
var ctx = __webpack_require__(38);
var hide = __webpack_require__(27);
var has = __webpack_require__(40);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33);
var createDesc = __webpack_require__(85);
module.exports = __webpack_require__(25) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * JavaScript Cookie v2.2.1
 * https://github.com/js-cookie/js-cookie
 *
 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
 * Released under the MIT license
 */
;(function (factory) {
	var registeredInModuleLoader;
	if (true) {
		!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		registeredInModuleLoader = true;
	}
	if (true) {
		module.exports = factory();
		registeredInModuleLoader = true;
	}
	if (!registeredInModuleLoader) {
		var OldCookies = window.Cookies;
		var api = window.Cookies = factory();
		api.noConflict = function () {
			window.Cookies = OldCookies;
			return api;
		};
	}
}(function () {
	function extend () {
		var i = 0;
		var result = {};
		for (; i < arguments.length; i++) {
			var attributes = arguments[ i ];
			for (var key in attributes) {
				result[key] = attributes[key];
			}
		}
		return result;
	}

	function decode (s) {
		return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
	}

	function init (converter) {
		function api() {}

		function set (key, value, attributes) {
			if (typeof document === 'undefined') {
				return;
			}

			attributes = extend({
				path: '/'
			}, api.defaults, attributes);

			if (typeof attributes.expires === 'number') {
				attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
			}

			// We're using "expires" because "max-age" is not supported by IE
			attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';

			try {
				var result = JSON.stringify(value);
				if (/^[\{\[]/.test(result)) {
					value = result;
				}
			} catch (e) {}

			value = converter.write ?
				converter.write(value, key) :
				encodeURIComponent(String(value))
					.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);

			key = encodeURIComponent(String(key))
				.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
				.replace(/[\(\)]/g, escape);

			var stringifiedAttributes = '';
			for (var attributeName in attributes) {
				if (!attributes[attributeName]) {
					continue;
				}
				stringifiedAttributes += '; ' + attributeName;
				if (attributes[attributeName] === true) {
					continue;
				}

				// Considers RFC 6265 section 5.2:
				// ...
				// 3.  If the remaining unparsed-attributes contains a %x3B (";")
				//     character:
				// Consume the characters of the unparsed-attributes up to,
				// not including, the first %x3B (";") character.
				// ...
				stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
			}

			return (document.cookie = key + '=' + value + stringifiedAttributes);
		}

		function get (key, json) {
			if (typeof document === 'undefined') {
				return;
			}

			var jar = {};
			// To prevent the for loop in the first place assign an empty array
			// in case there are no cookies at all.
			var cookies = document.cookie ? document.cookie.split('; ') : [];
			var i = 0;

			for (; i < cookies.length; i++) {
				var parts = cookies[i].split('=');
				var cookie = parts.slice(1).join('=');

				if (!json && cookie.charAt(0) === '"') {
					cookie = cookie.slice(1, -1);
				}

				try {
					var name = decode(parts[0]);
					cookie = (converter.read || converter)(cookie, name) ||
						decode(cookie);

					if (json) {
						try {
							cookie = JSON.parse(cookie);
						} catch (e) {}
					}

					jar[name] = cookie;

					if (key === name) {
						break;
					}
				} catch (e) {}
			}

			return key ? jar[key] : jar;
		}

		api.set = set;
		api.get = function (key) {
			return get(key, false /* read as raw */);
		};
		api.getJSON = function (key) {
			return get(key, true /* read as json */);
		};
		api.remove = function (key, attributes) {
			set(key, '', extend(attributes, {
				expires: -1
			}));
		};

		api.defaults = {};

		api.withConverter = init;

		return api;
	}

	return init(function () {});
}));


/***/ }),
/* 29 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var FREE = exports.FREE = 'Free';
var ESSENTIAL = exports.ESSENTIAL = 'Essential';
var TIPPING = exports.TIPPING = 'Tipping';
var ULTIMATE = exports.ULTIMATE = 'Ultimate';
var INSIGHTS = exports.INSIGHTS = 'Insights';
var ESSENTIAL_ULTIMATE = exports.ESSENTIAL_ULTIMATE = 'Essential Ultimate';
var LOG_IN = exports.LOG_IN = 'LOG IN';
var MY_ACCOUNT = exports.MY_ACCOUNT = 'MY ACCOUNT';

/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Lightbox = __webpack_require__(340);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Lightbox2.default;

/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(373);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./modal.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./modal.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(24);
var IE8_DOM_DEFINE = __webpack_require__(147);
var toPrimitive = __webpack_require__(148);
var dP = Object.defineProperty;

exports.f = __webpack_require__(25) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 34 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./type')} */
module.exports = TypeError;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(184);

module.exports = Function.prototype.bind || implementation;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(20);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserId() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_DB_USER_ID);
}

exports.default = getUserId;

/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(39);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 39 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 40 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 41 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(20);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserPackage() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_USER_PACKAGE);
}

exports.default = getUserPackage;

/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $defineProperty = Object.defineProperty || false;
if ($defineProperty) {
	try {
		$defineProperty({}, 'a', { value: 1 });
	} catch (e) {
		// IE 8 has a broken defineProperty
		$defineProperty = false;
	}
}

module.exports = $defineProperty;


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
var $gOPD = __webpack_require__(164);

if ($gOPD) {
	try {
		$gOPD([], 'length');
	} catch (e) {
		// IE 8 has a broken gOPD
		$gOPD = null;
	}
}

module.exports = $gOPD;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getCommonTraits = exports.getCommonTraits = function getCommonTraits() {
    if (!global.analyticsCommonTraits) {
        return false;
    }

    return Object.assign({}, global.analyticsCommonTraits);
};

var setCommonTraits = exports.setCommonTraits = function setCommonTraits(newCommonTraits) {
    if (!global.analyticsCommonTraits && !newCommonTraits) return;

    global.analyticsCommonTraits = Object.assign({}, global.analyticsCommonTraits, newCommonTraits);
};

var clearCommonTraits = exports.clearCommonTraits = function clearCommonTraits() {
    if (!global.analyticsCommonTraits) {
        return;
    }
    global.analyticsCommonTraits = false;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_OPTIONS = undefined;

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(6);

var _extends6 = _interopRequireDefault(_extends5);

exports.cleanUsedTraits = cleanUsedTraits;

var _jsCookie = __webpack_require__(28);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _rpCookie = __webpack_require__(20);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _rpUtils = __webpack_require__(72);

var _constants = __webpack_require__(18);

var _nonCanonical = __webpack_require__(63);

var _getDeviceType = __webpack_require__(67);

var _getDeviceType2 = _interopRequireDefault(_getDeviceType);

var _getBettingAccountLoggedInStatus = __webpack_require__(64);

var _getBettingAccountLoggedInStatus2 = _interopRequireDefault(_getBettingAccountLoggedInStatus);

var _getUserName = __webpack_require__(65);

var _getUserName2 = _interopRequireDefault(_getUserName);

var _getUserId = __webpack_require__(37);

var _getUserId2 = _interopRequireDefault(_getUserId);

var _getUTMParams = __webpack_require__(66);

var _getUTMParams2 = _interopRequireDefault(_getUTMParams);

var _commonTraits = __webpack_require__(45);

var _traits = __webpack_require__(2);

var _constants2 = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    integrations: {
        All: true
    }
};

var usedTraits = {};

function cleanUsedTraits() {
    usedTraits = {};
}

var tryParseJson = function tryParseJson(json) {
    try {
        return JSON.parse(json);
    } catch (err) {
        return null;
    }
};

function setCardCustomistaion() {
    var customizationCookie = _jsCookie2.default.get('customizeSettings');

    if (!customizationCookie) {
        return {};
    }

    var getCustomizeSettings = tryParseJson(customizationCookie);

    if (!getCustomizeSettings) {
        return {};
    }

    var form = getCustomizeSettings.form,
        myNotes = getCustomizeSettings.myNotes,
        spotlights = getCustomizeSettings.spotlights,
        comments = getCustomizeSettings.comments,
        raceConditions = getCustomizeSettings.raceConditions,
        owner = getCustomizeSettings.owner,
        quotes = getCustomizeSettings.quotes,
        pedigrees = getCustomizeSettings.pedigrees,
        rtf = getCustomizeSettings.rtf,
        priceHistory = getCustomizeSettings.priceHistory,
        decimalOdds = getCustomizeSettings.decimalOdds,
        bettingForecast = getCustomizeSettings.bettingForecast,
        orderByPrice = getCustomizeSettings.orderByPrice,
        myRatings = getCustomizeSettings.myRatings,
        showPrices = getCustomizeSettings.showPrices;


    var settings = {
        betting_forecast: bettingForecast,
        comments: comments,
        decimal_odds: decimalOdds,
        form: form,
        my_notes: myNotes,
        my_ratings: myRatings,
        order_by_price: orderByPrice,
        owner: owner,
        pedigrees: pedigrees,
        price_history: priceHistory,
        quotes: quotes,
        race_conditions: raceConditions,
        rtf: rtf,
        show_prices: showPrices,
        spotlights: spotlights
    };

    return settings;
}

function identify() {
    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_OPTIONS;

    var _extends3;

    var shouldGetFromLocalStorage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var loggedBookmakersAccounts = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

    // eslint-disable-next-line no-console
    // package props has been deleted because we don't need it
    var newProps = (0, _extends6.default)({}, props);
    delete newProps.Package;
    var userIdLocal = newProps[_traits.TRAIT_USER_ID] ? newProps[_traits.TRAIT_USER_ID] : (0, _getUserId2.default)();
    var emailLocal = newProps[_traits.TRAIT_EMAIL] ? newProps[_traits.TRAIT_EMAIL] : (0, _getUserName2.default)();
    /**
     * [JP-9761] - getting all logged bookmakers accounts
     *  from local storage or from betslip-ui
     * If we are in the betslip-ui, we will get
     *  the logged bookmakers accounts from the prop
     * The needs from the flag shouldGetFromLocalStorage
     *  are because if user re-load browser we should
     *  get it from localStorage
     *  NOTE: keep in mind skybet comes like 'skybetflutter'
     */
    var loggedBookmakersFromStorage = [];
    if (shouldGetFromLocalStorage) {
        var jsonLoggedBookmakers = (0, _rpUtils.getLocalStorage)('userAccountsInfo') || {};
        loggedBookmakersFromStorage = Object.values(jsonLoggedBookmakers).filter(function (account) {
            return account.isLoggedIn;
        });

        loggedBookmakersFromStorage.forEach(function (bookmaker) {
            var key = _constants.API_NAME_TO_KEY[bookmaker.apiName];
            _traits.TRAIT_RECENT_BOOKMAKERS[key] = true;
        });
    } else {
        /**
         * set all bookmakers to false in order to prevent
         * the case when we are not clearing someone of the bookmakers
         */
        Object.keys(_traits.TRAIT_RECENT_BOOKMAKERS).forEach(function (key) {
            _traits.TRAIT_RECENT_BOOKMAKERS[key] = false;
        });

        loggedBookmakersAccounts.forEach(function (bookmaker) {
            var key = _constants.API_NAME_TO_KEY[bookmaker];
            _traits.TRAIT_RECENT_BOOKMAKERS[key] = true;
        });
    }

    var checkloginCookie = (0, _getUserId2.default)();

    // Overwrite segment defaults to use a non canonical values
    var properties = {
        path: (0, _nonCanonical.getNonCanonicalPath)(),
        url: (0, _nonCanonical.getNonCanonicalUrl)()
    };

    properties[_traits.TRAIT_USER_NAME] = emailLocal;
    properties[_traits.TRAIT_EMAIL] = emailLocal;
    properties[_traits.TRAIT_USER_ID] = userIdLocal;

    var commonTraits = (0, _commonTraits.getCommonTraits)();
    if (commonTraits && commonTraits[_traits.TRAIT_SITE_SECTION]) {
        properties[_traits.TRAIT_SITE_SECTION] = commonTraits[_traits.TRAIT_SITE_SECTION];
        properties[_traits.TRAIT_SITE_SUB_SECTION_1] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_1];
        properties[_traits.TRAIT_SITE_SUB_SECTION_2] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_2];
    }

    var bettingAccountLoggedIn = (0, _getBettingAccountLoggedInStatus2.default)();

    if (userIdLocal) {
        properties = (0, _extends6.default)({}, properties, (0, _defineProperty3.default)({}, _traits.TRAIT_USER_LAST_LOGIN_DATE, _rpCookie2.default.sharedSession.get(_constants2.COOKIE_LAST_LOGGED_IN_WEB) || (0, _rpUtils.convertToIsoUKTime)(Date.now())));
    }

    properties = (0, _extends6.default)((_extends3 = {}, (0, _defineProperty3.default)(_extends3, _traits.TRAIT_DEVICE_TYPE, (0, _getDeviceType2.default)()), (0, _defineProperty3.default)(_extends3, _traits.TRAIT_LOGGED_IN_STATUS, checkloginCookie ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends3, _traits.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS, bettingAccountLoggedIn ? 'Logged In' : 'Logged Out'), _extends3), setCardCustomistaion(), properties, _traits.TRAIT_RECENT_BOOKMAKERS, (0, _defineProperty3.default)({}, _traits.TRAIT_NUMBER_BOOKMAKERS_ACCOUNTS, shouldGetFromLocalStorage ? loggedBookmakersFromStorage.length : loggedBookmakersAccounts.length), (0, _getUTMParams2.default)(), newProps);

    var keys = Object.keys(properties);
    var isSameTraits = keys.every(function (prop) {
        return properties[prop] === usedTraits[prop];
    });

    if (isSameTraits) {
        // set Timeout here to fetch user-metadata after the identify call
        // removed Timeout from getUserMetaData in order to call it separately without delay
        setTimeout(function () {
            (0, _rpUtils.getUserMetaData)(userIdLocal);
        }, 1000);

        return Promise.resolve();
    }

    usedTraits = Object.assign({}, properties);

    return new Promise(function (resolve) {
        // Segment Identify event
        if (!global.analytics) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        if (userIdLocal) {
            global.analytics.identify(userIdLocal, properties, options, resolve);
        } else {
            global.analytics.identify(properties, options, resolve);
        }

        // set Timeout here to fetch user-metadata after the identify call
        // removed Timeout from getUserMetaData in order to call it separately without delay
        setTimeout(function () {
            (0, _rpUtils.getUserMetaData)(userIdLocal);
        }, 1000);
    });
}

exports.default = identify;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _startCase = __webpack_require__(344);

var _startCase2 = _interopRequireDefault(_startCase);

var _isFunction = __webpack_require__(370);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _ValidationIcon = __webpack_require__(81);

var _ValidationIcon2 = _interopRequireDefault(_ValidationIcon);

var _ForgottenPasswordBtn = __webpack_require__(131);

var _ForgottenPasswordBtn2 = _interopRequireDefault(_ForgottenPasswordBtn);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint jsx-a11y/label-has-for: 0 */


var msg = 'This email address is already used on another Racing Post account.';

var _ref2 = _jsx('div', {}, void 0, msg);

var FormField = function (_PureComponent) {
    _inherits(FormField, _PureComponent);

    function FormField() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, FormField);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = FormField.__proto__ || Object.getPrototypeOf(FormField)).call.apply(_ref, [this].concat(args))), _this), _this.state = { dirty: false, empty: true }, _this.onBlur = function (e) {
            _this.setState({ dirty: true, empty: !e.target.value.trim() });
            _this.props.validate(e.target);
        }, _this.onChange = function (e) {
            if (_this.props.onlyBlur) {
                return;
            }
            _this.setState({ dirty: true, empty: !e.target.value.trim() });
            _this.props.validate(e.target);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(FormField, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                type = _props.type,
                hasError = _props.hasError,
                error = _props.error,
                signUpError = _props.signUpError,
                handleClick = _props.handleClick,
                label = _props.label,
                children = _props.children;
            var _state = this.state,
                dirty = _state.dirty,
                empty = _state.empty;


            return _jsx('div', {
                className: _fields2.default.field
            }, void 0, _jsx('label', {
                className: _fields2.default.label
            }, void 0, label || (0, _startCase2.default)(name), _jsx('div', {
                className: _fields2.default.validationWrapper
            }, void 0, _jsx('input', {
                type: type || name,
                name: name,
                autoComplete: 'off',
                className: 'ui-input',
                onBlur: this.onBlur,
                onChange: this.onChange
            }), (dirty || hasError) && _jsx(_ValidationIcon2.default, {
                noValidate: this.props.noValidate,
                hasError: hasError
            }))), hasError && _jsx('div', {
                className: _fields2.default.error
            }, void 0, (0, _isFunction2.default)(error) ? error(dirty, empty) : error), signUpError && _jsx('div', {
                className: _fields2.default.error,
                id: 'pwd-reset'
            }, void 0, _ref2, _jsx(_ForgottenPasswordBtn2.default, {
                onClick: handleClick,
                className: _fields2.default.link
            })), children);
        }
    }]);

    return FormField;
}(_react.PureComponent);

FormField.defaultProps = {
    signUpError: false,
    handleClick: function handleClick() {
        return null;
    },
    label: '',
    children: null,
    noValidate: false,
    onlyBlur: undefined,
    type: undefined
};

exports.default = FormField;

/***/ }),
/* 48 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_48__;

/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(22);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(48);

var _classnames2 = _interopRequireDefault(_classnames);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var getActiveButtonClass = function getActiveButtonClass(loading) {
    return (0, _classnames2.default)('ui-btn', 'ui-btn_large', 'ui-btn_primary', _fields2.default.submit, _defineProperty({}, _fields2.default.submitActive, loading));
};

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'spinner',
    size: 'Large',
    className: 'ui-animation_spinnerAnimation'
});

var SubmitBtn = function SubmitBtn(_ref) {
    var label = _ref.label,
        loading = _ref.loading;
    return _jsx('div', {
        className: _fields2.default.submitField
    }, void 0, _jsx('button', {
        type: 'submit',
        className: getActiveButtonClass(loading)
    }, void 0, loading ? _ref2 : label));
};

exports.default = SubmitBtn;

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint max-len: 0 */
var email = function email(val) {
    return (/^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9]{2}(?:[a-z0-9-]*[a-z0-9])?$/i.test(val)
    );
};

var password = function password(val) {
    return new RegExp('(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$').test(val);
};

var passwordNotEmpty = function passwordNotEmpty(val) {
    return Boolean(val.trim().length);
};

var confirmPassword = function confirmPassword(val, otherVal) {
    return val && val === otherVal;
};

var newPassword = password;

var termsConditions = function termsConditions(val) {
    return val;
};

exports.default = {
    email: email, password: password, newPassword: newPassword, passwordNotEmpty: passwordNotEmpty, confirmPassword: confirmPassword, termsConditions: termsConditions
};

/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.onSignInSuccess = exports.onSignUpSuccess = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _axios = __webpack_require__(118);

var _axios2 = _interopRequireDefault(_axios);

var _rpAnalytics = __webpack_require__(23);

var _api = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var conditionNames = {
    horseBetting: 'communicationHorseBetting',
    horseNews: 'communicationHorseNews',
    bloodstock: 'communicationBloodstock',
    sportBetting: 'communicationSportBetting',
    competitions: 'communicationCompetitions',
    newsletterThirdParty: 'thirdPartyContact',
    eighteenYears: 'communicationEighteen'
};

var getConditionsArray = function getConditionsArray(conditions) {
    return Object.keys(conditionNames).reduce(function (acc, name) {
        return _extends({}, acc, _defineProperty({}, conditionNames[name], Number(conditions[name])));
    }, {});
};
function checkAllComunications(option) {
    return option === 1;
}
function checkAllComunicationsIfFalse(option) {
    return option !== 1;
}
var onSignUpSuccess = exports.onSignUpSuccess = function onSignUpSuccess(userInfo, conditions) {
    var _props;

    var emailGroups = getConditionsArray(conditions);
    var email = userInfo.email,
        userId = userInfo.userId;

    var props = (_props = {}, _defineProperty(_props, _rpAnalytics.TRAIT_EMAIL, email), _defineProperty(_props, _rpAnalytics.TRAIT_USER_ID, userId), _defineProperty(_props, _rpAnalytics.TRAIT_TS_CS, conditions.termsConditions), _defineProperty(_props, _rpAnalytics.TRAIT_18_PLUST, conditions.eighteenYears), _props);

    var allComunicationOptions = [emailGroups.communicationBloodstock, emailGroups.communicationCompetitions, emailGroups.communicationHorseBetting, emailGroups.communicationHorseNews, emailGroups.communicationSportBetting];

    (0, _rpAnalytics.identify)(props).then(function () {
        var _extends3;

        var TRAIT_RACING_POST_CONTACT = 'racingPostContact';

        var racingPostContact = allComunicationOptions.every(checkAllComunications) ? 1 : 0;
        (0, _rpAnalytics.trackRegister)(_extends((_extends3 = {}, _defineProperty(_extends3, _rpAnalytics.TRAIT_EMAIL, email), _defineProperty(_extends3, TRAIT_RACING_POST_CONTACT, racingPostContact), _extends3), emailGroups));
        (0, _rpAnalytics.trackLogin)(_defineProperty({}, _rpAnalytics.TRAIT_EMAIL, email));
    }).then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _data;

        var traits, allEmailGroups, isAnyCommunicationSelected, userEmialGroups, emailLabel, filterUserSubscribedGroups, getAccountInfoOptions, _ref6, data, SUBS_TRAIT, API_REQ_ERROR;

        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        traits = _defineProperty({}, _rpAnalytics.TRAIT_EMAIL, email);
                        allEmailGroups = allComunicationOptions.concat([emailGroups.thirdPartyContact]);
                        isAnyCommunicationSelected = allEmailGroups.every(checkAllComunicationsIfFalse) ? 1 : 0;

                        if (!isAnyCommunicationSelected) {
                            _context.next = 5;
                            break;
                        }

                        return _context.abrupt('return');

                    case 5:
                        userEmialGroups = Object.entries(emailGroups);
                        emailLabel = 'email';
                        // eslint-disable-next-line

                        filterUserSubscribedGroups = userEmialGroups.filter(function (_ref2) {
                            var _ref3 = _slicedToArray(_ref2, 2),
                                name = _ref3[0],
                                value = _ref3[1];

                            return value > 0;
                        }).map(function (_ref4) {
                            var _ref5 = _slicedToArray(_ref4, 1),
                                name = _ref5[0];

                            return name;
                        });
                        getAccountInfoOptions = {
                            url: '/subscriptions/braze',
                            baseURL: window.location.protocol + '//' + window.location.host,
                            method: 'post',
                            headers: {
                                'Content-Type': 'application/json;charset=utf-8'
                            },
                            data: (_data = {}, _defineProperty(_data, emailLabel, email), _defineProperty(_data, 'emailSubscriptions', filterUserSubscribedGroups), _data)
                        };
                        _context.prev = 9;
                        _context.next = 12;
                        return (0, _axios2.default)(getAccountInfoOptions);

                    case 12:
                        _ref6 = _context.sent;
                        data = _ref6.data;
                        SUBS_TRAIT = 'subscriptions';

                        traits[SUBS_TRAIT] = data;

                        (0, _rpAnalytics.track)('SignUp Email Subscriptions', traits);
                        _context.next = 24;
                        break;

                    case 19:
                        _context.prev = 19;
                        _context.t0 = _context['catch'](9);
                        API_REQ_ERROR = 'Api request error';

                        traits[API_REQ_ERROR] = _context.t0;

                        (0, _rpAnalytics.track)('SignUp Email Subscriptions error', traits);

                    case 24:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined, [[9, 19]]);
    })));
};

var onSignInSuccess = exports.onSignInSuccess = function onSignInSuccess() {
    return (0, _api.getUserPackage)().then(function (userPackage) {
        return (0, _rpAnalytics.identify)().then(function () {
            (0, _rpAnalytics.trackLogin)(_defineProperty({}, _rpAnalytics.TRAIT_PACKAGE, userPackage));
        });
    }).catch(function (error) {
        return error;
    });
};

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Created by Serhii_Kotyk on 09-Sep-16.
 */
var goToUrl = function goToUrl(url) {
    var loc = window.location;
    if (loc) {
        // timeout is required for safari
        // otherwise it only reloads the page
        // but should work fine as well for all browsers
        setTimeout(function () {
            if (loc.href !== url) {
                loc.assign(url);
            } else {
                // issue was spotted on profiles pages
                // assigning url with hash to window location
                // does not trigger page reload
                // https://racingpost.atlassian.net/browse/QW-390
                loc.reload();
            }
        }, 1);
    }
};

exports.default = goToUrl;

/***/ }),
/* 53 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(34);
var document = __webpack_require__(13).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(87);
var defined = __webpack_require__(56);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 56 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 57 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(89)('keys');
var uid = __webpack_require__(90);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 59 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(36);
var $TypeError = __webpack_require__(35);

var $call = __webpack_require__(61);
var $actualApply = __webpack_require__(104);

/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */
module.exports = function callBindBasic(args) {
	if (args.length < 1 || typeof args[0] !== 'function') {
		throw new $TypeError('a function is required');
	}
	return $actualApply(bind, $call, args);
};


/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionCall')} */
module.exports = Function.prototype.call;


/***/ }),
/* 62 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./functionApply')} */
module.exports = Function.prototype.apply;


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
var getNonCanonicalPath = exports.getNonCanonicalPath = function getNonCanonicalPath() {
    return global.location.pathname;
};

var getNonCanonicalUrl = exports.getNonCanonicalUrl = function getNonCanonicalUrl() {
    var url = global.location.href;
    var i = url.indexOf('#');
    return i === -1 ? url : url.slice(0, i);
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var cookieNames = {
    coral: 'c-c',
    ladbrokes: 'lb-c',
    paddyPower: 'pp-c',
    williamHill: 'wh-c',
    bet365: 'bet365-c',
    betway: 'bw-c',
    skybet: 'sb-c'
};

function isCookieActive(cookieName) {
    var cookies = document.cookie.split(';');
    return cookies.some(function (cookie) {
        return cookie.split('=')[0].trim() === cookieName;
    });
}

function getBettingAccountLoggedInStatus() {
    var bookies = Object.keys(cookieNames);
    var isBettingAccountLoggedIn = bookies.some(function (bookie) {
        return isCookieActive(cookieNames[bookie]);
    });

    return isBettingAccountLoggedIn;
}

exports.default = getBettingAccountLoggedInStatus;

/***/ }),
/* 65 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(20);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUserName() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_USER_LOGIN);
}

exports.default = getUserName;

/***/ }),
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(6);

var _extends4 = _interopRequireDefault(_extends3);

var _getUTMFirst = __webpack_require__(107);

var _getUTMFirst2 = _interopRequireDefault(_getUTMFirst);

var _getUTMLast = __webpack_require__(195);

var _getUTMLast2 = _interopRequireDefault(_getUTMLast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUTMParams() {
    var utmFirst = (0, _getUTMFirst2.default)();
    var utmLast = (0, _getUTMLast2.default)();

    return (0, _extends4.default)({}, utmFirst, utmLast ? Object.keys(utmLast).reduce(function (result, key) {
        return (0, _extends4.default)({}, result, (0, _defineProperty3.default)({}, key + ' [last touch]', utmLast[key]));
    }, {}) : null);
}

exports.default = getUTMParams;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEVICE_DESKTOP = exports.DEVICE_TABLET = exports.DEVICE_PHONE = undefined;

var _mobileDetect = __webpack_require__(198);

var _mobileDetect2 = _interopRequireDefault(_mobileDetect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEVICE_PHONE = exports.DEVICE_PHONE = 'Mobile';
var DEVICE_TABLET = exports.DEVICE_TABLET = 'Tablet';
var DEVICE_DESKTOP = exports.DEVICE_DESKTOP = 'Desktop';

function getDeviceType() {
    var mobileDetect = new _mobileDetect2.default(window.navigator.userAgent);

    if (mobileDetect.phone()) {
        return DEVICE_PHONE;
    }

    if (mobileDetect.tablet() || window.navigator.maxTouchPoints > 1) {
        return DEVICE_TABLET;
    }

    return DEVICE_DESKTOP;
}

exports.default = getDeviceType;

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(204);
var global = __webpack_require__(13);
var hide = __webpack_require__(27);
var Iterators = __webpack_require__(29);
var TO_STRING_TAG = __webpack_require__(14)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 69 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(33).f;
var has = __webpack_require__(40);
var TAG = __webpack_require__(14)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(212)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(109)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(41);
var TAG = __webpack_require__(14)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {function r(r,t,e,n,o,a,i){try{var c=r[a](i),u=c.value}catch(r){return void e(r)}c.done?t(u):Promise.resolve(u).then(n,o)}function t(t){return function(){var e=this,n=arguments;return new Promise(function(o,a){var i=t.apply(e,n);function c(t){r(i,o,a,c,u,"next",t)}function u(t){r(i,o,a,c,u,"throw",t)}c(void 0)})}}function e(){
/*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */
var r,t,o="function"==typeof Symbol?Symbol:{},a=o.iterator||"@@iterator",i=o.toStringTag||"@@toStringTag";function c(e,o,a,i){var c=o&&o.prototype instanceof s?o:s,f=Object.create(c.prototype);return n(f,"_invoke",function(e,n,o){var a,i,c,s=0,f=o||[],l=!1,p={p:0,n:0,v:r,a:w,f:w.bind(r,4),d:function(t,e){return a=t,i=0,c=r,p.n=e,u}};function w(e,n){for(i=e,c=n,t=0;!l&&s&&!o&&t<f.length;t++){var o,a=f[t],w=p.p,h=a[2];e>3?(o=h===n)&&(c=a[(i=a[4])?5:(i=3,3)],a[4]=a[5]=r):a[0]<=w&&((o=e<2&&w<a[1])?(i=0,p.v=n,p.n=a[1]):w<h&&(o=e<3||a[0]>n||n>h)&&(a[4]=e,a[5]=n,p.n=h,i=0))}if(o||e>1)return u;throw l=!0,n}return function(o,f,h){if(s>1)throw TypeError("Generator is already running");for(l&&1===f&&w(f,h),i=f,c=h;(t=i<2?r:c)||!l;){a||(i?i<3?(i>1&&(p.n=-1),w(i,c)):p.n=c:p.v=c);try{if(s=2,a){if(i||(o="next"),t=a[o]){if(!(t=t.call(a,c)))throw TypeError("iterator result is not an object");if(!t.done)return t;c=t.value,i<2&&(i=0)}else 1===i&&(t=a.return)&&t.call(a),i<2&&(c=TypeError("The iterator does not provide a '"+o+"' method"),i=1);a=r}else if((t=(l=p.n<0)?c:e.call(n,p))!==u)break}catch(t){a=r,i=1,c=t}finally{s=1}}return{value:t,done:l}}}(e,a,i),!0),f}var u={};function s(){}function f(){}function l(){}t=Object.getPrototypeOf;var p=[][a]?t(t([][a]())):(n(t={},a,function(){return this}),t),w=l.prototype=s.prototype=Object.create(p);function h(r){return Object.setPrototypeOf?Object.setPrototypeOf(r,l):(r.__proto__=l,n(r,i,"GeneratorFunction")),r.prototype=Object.create(w),r}return f.prototype=l,n(w,"constructor",l),n(l,"constructor",f),f.displayName="GeneratorFunction",n(l,i,"GeneratorFunction"),n(w),n(w,i,"Generator"),n(w,a,function(){return this}),n(w,"toString",function(){return"[object Generator]"}),(e=function(){return{w:c,m:h}})()}function n(r,t,e,o){var a=Object.defineProperty;try{a({},"",{})}catch(r){a=0}n=function(r,t,e,o){function i(t,e){n(r,t,function(r){return this._invoke(t,e,r)})}t?a?a(r,t,{value:e,enumerable:!o,configurable:!o,writable:!o}):r[t]=e:(i("next",0),i("throw",1),i("return",2))},n(r,t,e,o)}Object.defineProperty(exports,"__esModule",{value:!0});var o=function(){var r=t(e().m(function r(){var t,n,o,a=arguments;return e().w(function(r){for(;;)switch(r.p=r.n){case 0:return t=a.length>0&&void 0!==a[0]&&a[0]?"http://localhost:8080/api/stubs/bookmaker-offers-tier-two/":"".concat(window.location.origin,"/api/stubs/bookmaker-offers-tier-two/"),r.p=1,r.n=2,fetch(t);case 2:if((n=r.v).ok){r.n=3;break}throw new Error("Network response was not ok");case 3:return r.n=4,n.json();case 4:return r.a(2,r.v);case 5:r.p=5,o=r.v,console.error("Error fetching bookmaker offers tier 2/3:",o);case 6:return r.a(2)}},r,null,[[1,5]])}));return function(){return r.apply(this,arguments)}}(),a=function(){var r=t(e().m(function r(){var t,n,o,a=arguments;return e().w(function(r){for(;;)switch(r.p=r.n){case 0:return t=a.length>0&&void 0!==a[0]&&a[0]?"http://localhost:8080/api/stubs/bookmaker-offers-tier-two/":"".concat(window.location.origin,"/api/stubs/bookmaker-offers-tier-two/"),r.p=1,r.n=2,fetch(t);case 2:if((n=r.v).ok){r.n=3;break}throw new Error("Network response was not ok");case 3:return r.n=4,n.json();case 4:return r.a(2,r.v);case 5:r.p=5,o=r.v,console.error("Error fetching bookmaker offers tier 1:",o);case 6:return r.a(2)}},r,null,[[1,5]])}));return function(){return r.apply(this,arguments)}}(),i=function(){var r=t(e().m(function r(){var t,n,o,a=arguments;return e().w(function(r){for(;;)switch(r.p=r.n){case 0:return t=a.length>0&&void 0!==a[0]&&a[0]?"http://localhost:8080/api/stubs/bookmaker-offers-mixed-tier/":"".concat(window.location.origin,"/api/stubs/bookmaker-offers-mixed-tier/"),r.p=1,r.n=2,fetch(t);case 2:if((n=r.v).ok){r.n=3;break}throw new Error("Network response was not ok");case 3:return r.n=4,n.json();case 4:return r.a(2,r.v);case 5:r.p=5,o=r.v,console.error("Error fetching bookmaker mixed offers:",o);case 6:return r.a(2)}},r,null,[[1,5]])}));return function(){return r.apply(this,arguments)}}(),c=__webpack_require__(219),u=function(){var r=decodeURIComponent(document.cookie).split("; ".concat("RDSS","="));if(2!==r.length)return null;var t=r.pop().split(";").shift();return t&&(t.startsWith("{")?JSON.parse(t):JSON.parse(atob(t))).rp_uid||null},s=function(){var r=t(e().m(function r(t){var n,o;return e().w(function(r){for(;;)switch(r.n){case 0:if(global.analytics&&global.analytics.initialize){r.n=1;break}return r.a(2);case 1:if(n=t||u()){r.n=2;break}return r.a(2,null);case 2:return o=null,r.n=3,fetch("".concat(window.location.origin,"/api/user-metadata/?userId=").concat(n,"&v=").concat(Date.now())).then(function(r){if(!r.ok)throw new Error("Network response was not ok");return r.json()}).then(function(r){return o=r}).catch(function(r){console.log("There was an error fetching user meta data",r)});case 3:return r.a(2,o)}},r)}));return function(t){return r.apply(this,arguments)}}();exports.convertToIsoUKTime=function(r){return c(r).tz("Europe/London").format("YYYY-MM-DDTHH:mm:ss.SSS[Z]")},exports.fetchBookmakersMixed=i,exports.fetchBookmakersTierOne=a,exports.fetchBookmakersTierTwo=o,exports.getLocalStorage=function(r){if(!window)return null;var t=window.localStorage.getItem(r);return t?JSON.parse(t):null},exports.getUserId=u,exports.getUserMetaData=s,exports.isLocalStorageAvailable=function(){if(!window.localStorage)return!1;try{return window.localStorage.setItem("test","test"),window.localStorage.removeItem("test"),!0}catch(r){return!1}},exports.setLocalStorage=function(r,t){window.localStorage.setItem(r,JSON.stringify(t))},exports.tryParseJson=function(r){try{return JSON.parse(r)}catch(r){return null}};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(254);


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _promise = __webpack_require__(256);

var _promise2 = _interopRequireDefault(_promise);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new _promise2.default(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return _promise2.default.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
};

/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 25.4.1.5 NewPromiseCapability(C)
var aFunction = __webpack_require__(39);

function PromiseCapability(C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aFunction(resolve);
  this.reject = aFunction(reject);
}

module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(16);
var normalizeHeaderName = __webpack_require__(306);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(120);
  } else if (typeof process !== 'undefined') {
    // For node use HTTP adapter
    adapter = __webpack_require__(120);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(305)))

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/lodash-es/_freeGlobal.js
var _freeGlobal = __webpack_require__(327);

// CONCATENATED MODULE: ./node_modules/lodash-es/_root.js


/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = _freeGlobal["a" /* default */] || freeSelf || Function('return this')();

/* harmony default export */ var _root = (root);

// CONCATENATED MODULE: ./node_modules/lodash-es/_Symbol.js


/** Built-in value references. */
var Symbol = _root.Symbol;

/* harmony default export */ var _Symbol = (Symbol);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getRawTag.js


/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var _getRawTag_hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = _getRawTag_hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

/* harmony default export */ var _getRawTag = (getRawTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_objectToString.js
/** Used for built-in method references. */
var _objectToString_objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var _objectToString_nativeObjectToString = _objectToString_objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return _objectToString_nativeObjectToString.call(value);
}

/* harmony default export */ var _objectToString = (objectToString);

// CONCATENATED MODULE: ./node_modules/lodash-es/_baseGetTag.js




/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var _baseGetTag_symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (_baseGetTag_symToStringTag && _baseGetTag_symToStringTag in Object(value))
    ? _getRawTag(value)
    : _objectToString(value);
}

/* harmony default export */ var _baseGetTag = (baseGetTag);

// CONCATENATED MODULE: ./node_modules/lodash-es/_overArg.js
/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

/* harmony default export */ var _overArg = (overArg);

// CONCATENATED MODULE: ./node_modules/lodash-es/_getPrototype.js


/** Built-in value references. */
var getPrototype = _overArg(Object.getPrototypeOf, Object);

/* harmony default export */ var _getPrototype = (getPrototype);

// CONCATENATED MODULE: ./node_modules/lodash-es/isObjectLike.js
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

/* harmony default export */ var lodash_es_isObjectLike = (isObjectLike);

// CONCATENATED MODULE: ./node_modules/lodash-es/isPlainObject.js




/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    isPlainObject_objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var isPlainObject_hasOwnProperty = isPlainObject_objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!lodash_es_isObjectLike(value) || _baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = _getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = isPlainObject_hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

/* harmony default export */ var lodash_es_isPlainObject = (isPlainObject);

// EXTERNAL MODULE: ./node_modules/symbol-observable/es/index.js
var es = __webpack_require__(127);

// CONCATENATED MODULE: ./node_modules/redux/es/createStore.js



/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var ActionTypes = {
  INIT: '@@redux/INIT'

  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */
};function createStore_createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error('Expected the enhancer to be a function.');
    }

    return enhancer(createStore_createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error('Expected the reducer to be a function.');
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */
  function getState() {
    return currentState;
  }

  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */
  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */
  function dispatch(action) {
    if (!lodash_es_isPlainObject(action)) {
      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
    }

    if (typeof action.type === 'undefined') {
      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
    }

    if (isDispatching) {
      throw new Error('Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }

  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error('Expected the nextReducer to be a function.');
    }

    currentReducer = nextReducer;
    dispatch({ type: ActionTypes.INIT });
  }

  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */
  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object') {
          throw new TypeError('Expected the observer to be an object.');
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return { unsubscribe: unsubscribe };
      }
    }, _ref[es["a" /* default */]] = function () {
      return this;
    }, _ref;
  }

  // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.
  dispatch({ type: ActionTypes.INIT });

  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[es["a" /* default */]] = observable, _ref2;
}
// CONCATENATED MODULE: ./node_modules/redux/es/utils/warning.js
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning_warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */
  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */
}
// CONCATENATED MODULE: ./node_modules/redux/es/combineReducers.js




function getUndefinedStateErrorMessage(key, action) {
  var actionType = action && action.type;
  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';

  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!lodash_es_isPlainObject(inputState)) {
    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });

  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });

  if (unexpectedKeys.length > 0) {
    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, { type: ActionTypes.INIT });

    if (typeof initialState === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
    }

    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
    if (typeof reducer(undefined, { type: type }) === 'undefined') {
      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
    }
  });
}

/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */
function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};
  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning('No reducer provided for key "' + key + '"');
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }
  var finalReducerKeys = Object.keys(finalReducers);

  var unexpectedKeyCache = void 0;
  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError = void 0;
  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};
    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === 'undefined') {
        var errorMessage = getUndefinedStateErrorMessage(_key, action);
        throw new Error(errorMessage);
      }
      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    return hasChanged ? nextState : state;
  };
}
// CONCATENATED MODULE: ./node_modules/redux/es/bindActionCreators.js
function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(undefined, arguments));
  };
}

/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass a single function as the first argument,
 * and get a function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */
function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
  }

  var keys = Object.keys(actionCreators);
  var boundActionCreators = {};
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    var actionCreator = actionCreators[key];
    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }
  return boundActionCreators;
}
// CONCATENATED MODULE: ./node_modules/redux/es/compose.js
/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */

function compose() {
  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(undefined, arguments));
    };
  });
}
// CONCATENATED MODULE: ./node_modules/redux/es/applyMiddleware.js
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */
function applyMiddleware() {
  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function (reducer, preloadedState, enhancer) {
      var store = createStore(reducer, preloadedState, enhancer);
      var _dispatch = store.dispatch;
      var chain = [];

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch(action) {
          return _dispatch(action);
        }
      };
      chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(undefined, chain)(store.dispatch);

      return _extends({}, store, {
        dispatch: _dispatch
      });
    };
  };
}
// CONCATENATED MODULE: ./node_modules/redux/es/index.js
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore_createStore; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* concated harmony reexport */__webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });







/*
* This is a dummy function to check if the function name has been altered by minification.
* If the function has been minified and NODE_ENV !== 'production', warn the user.
*/
function isCrushed() {}

if (false) {
  warning('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
}



/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _rpCookie = __webpack_require__(20);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var AuthSync = function () {
    function AuthSync() {
        var _this = this;

        _classCallCheck(this, AuthSync);

        this.key = 'reload';
        this.defaultValue = 11;
        this.interval = 1000;
        this.lightboxAllowParam = 'authme';

        this.currentValue = undefined;
        /**
         * We use an array of intervalIds coz module may be use as a singleton
         * @type {Array}
         */
        this.intervalIds = [];

        window.addEventListener('beforeunload', function () {
            _this.stopListening();
        });
    }

    _createClass(AuthSync, [{
        key: 'run',
        value: function run() {
            this.startListening();
        }
    }, {
        key: 'listen',
        value: function listen() {
            var _this2 = this;

            this.intervalIds.push(setInterval(function () {
                if (_this2.getStatus()) {
                    _this2.reloadCurrentPage();
                    _this2.stopListening();
                }
            }, this.interval));
        }
    }, {
        key: 'startListening',
        value: function startListening() {
            if (!this.get()) {
                this.set();
            }
            this.currentValue = this.get();

            this.listen();
        }
    }, {
        key: 'stopListening',
        value: function stopListening() {
            this.intervalIds.forEach(function (interval) {
                clearInterval(interval);
            });
        }
    }, {
        key: 'set',
        value: function set() {
            _rpCookie2.default.sharedSession.set(this.key, this.defaultValue);
        }
    }, {
        key: 'get',
        value: function get() {
            return _rpCookie2.default.sharedSession.get(this.key);
        }
    }, {
        key: 'getStatus',
        value: function getStatus() {
            return this.currentValue !== this.get();
        }
    }, {
        key: 'reloadCurrentPage',
        value: function reloadCurrentPage() {
            var query = window.location.search;

            var param = '?' + this.lightboxAllowParam;
            if (query.indexOf(param) !== -1) {
                window.location.search = window.location.search.replace(param, '?');
            } else {
                window.location.reload();
            }
        }

        /**
         * @deprecated please use reloadAll() instead
         */

    }, {
        key: 'reload',
        value: function reload() {
            this.reloadAll();
        }
    }, {
        key: 'reloadOther',
        value: function reloadOther() {
            _rpCookie2.default.sharedSession.set(this.key, ++this.currentValue);
        }
    }, {
        key: 'reloadAll',
        value: function reloadAll() {
            _rpCookie2.default.sharedSession.set(this.key, this.currentValue + 1);
        }
    }]);

    return AuthSync;
}();

exports.default = new AuthSync();

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(350);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(351);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(48);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(22);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'cross',
    size: 'Medium'
});

var _ref3 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'tick',
    size: 'Medium'
});

var ValidationIcon = function ValidationIcon(_ref) {
    var _classNames;

    var hasError = _ref.hasError,
        noValidate = _ref.noValidate;

    var isError = hasError;
    var isSuccess = !noValidate && !hasError;
    var className = (0, _classnames2.default)((_classNames = {}, _defineProperty(_classNames, _fields2.default.iconError, isError), _defineProperty(_classNames, _fields2.default.iconSuccess, isSuccess), _classNames), _fields2.default.iconWrapper);
    return _jsx('div', {
        className: className
    }, void 0, isError && _ref2, isSuccess && _ref3);
};

ValidationIcon.defaultProps = {
    noValidate: false
};

exports.default = ValidationIcon;

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint no-mixed-operators: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('li', {}, void 0, 'Contain at least 1 number');

var _ref2 = _jsx('li', {}, void 0, 'Contain an upper and lower case character');

var _ref3 = _jsx('li', {}, void 0, 'Be at least 8 characters long');

var PasswordError = function PasswordError(props) {
    return _jsx('div', {
        className: props && _fields2.default[props.className] || _fields2.default.comment
    }, void 0, _jsx('span', {
        className: _fields2.default.commentTitle
    }, void 0, 'Passwords must:'), _jsx('ul', {
        className: _fields2.default.commentList
    }, void 0, _ref, _ref2, _ref3));
};

PasswordError.defaultProps = {
    className: ''
};

exports.default = PasswordError;

/***/ }),
/* 83 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForgottenPassword = __webpack_require__(381);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForgottenPassword2.default;

/***/ }),
/* 84 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ErrorDialog = __webpack_require__(388);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ErrorDialog2.default;

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(150);
var enumBugKeys = __webpack_require__(91);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(41);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(57);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(17);
var global = __webpack_require__(13);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(59) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 90 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 91 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(56);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var EMPTY_EVENT = exports.EMPTY_EVENT = {};
var config = {};

function createConfigProvider() {
    return {
        registerEvent: function registerEvent(event, getPropTypes, buildProps) {
            config[event] = {
                getPropTypes: getPropTypes,
                buildProps: buildProps
            };
        },
        getEvent: function getEvent(event) {
            return event in config ? config[event] : EMPTY_EVENT;
        }
    };
}

var configProvider = createConfigProvider();

exports.default = configProvider;

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_94__;

/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keys = __webpack_require__(162);
var hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';

var toStr = Object.prototype.toString;
var concat = Array.prototype.concat;
var defineDataProperty = __webpack_require__(97);

var isFunction = function (fn) {
	return typeof fn === 'function' && toStr.call(fn) === '[object Function]';
};

var supportsDescriptors = __webpack_require__(99)();

var defineProperty = function (object, name, value, predicate) {
	if (name in object) {
		if (predicate === true) {
			if (object[name] === value) {
				return;
			}
		} else if (!isFunction(predicate) || !predicate()) {
			return;
		}
	}

	if (supportsDescriptors) {
		defineDataProperty(object, name, value, true);
	} else {
		defineDataProperty(object, name, value);
	}
};

var defineProperties = function (object, map) {
	var predicates = arguments.length > 2 ? arguments[2] : {};
	var props = keys(map);
	if (hasSymbols) {
		props = concat.call(props, Object.getOwnPropertySymbols(map));
	}
	for (var i = 0; i < props.length; i += 1) {
		defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
	}
};

defineProperties.supportsDescriptors = !!supportsDescriptors;

module.exports = defineProperties;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var toStr = Object.prototype.toString;

module.exports = function isArguments(value) {
	var str = toStr.call(value);
	var isArgs = str === '[object Arguments]';
	if (!isArgs) {
		isArgs = str !== '[object Array]' &&
			value !== null &&
			typeof value === 'object' &&
			typeof value.length === 'number' &&
			value.length >= 0 &&
			toStr.call(value.callee) === '[object Function]';
	}
	return isArgs;
};


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(43);

var $SyntaxError = __webpack_require__(98);
var $TypeError = __webpack_require__(35);

var gopd = __webpack_require__(44);

/** @type {import('.')} */
module.exports = function defineDataProperty(
	obj,
	property,
	value
) {
	if (!obj || (typeof obj !== 'object' && typeof obj !== 'function')) {
		throw new $TypeError('`obj` must be an object or a function`');
	}
	if (typeof property !== 'string' && typeof property !== 'symbol') {
		throw new $TypeError('`property` must be a string or a symbol`');
	}
	if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) {
		throw new $TypeError('`nonEnumerable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) {
		throw new $TypeError('`nonWritable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) {
		throw new $TypeError('`nonConfigurable`, if provided, must be a boolean or null');
	}
	if (arguments.length > 6 && typeof arguments[6] !== 'boolean') {
		throw new $TypeError('`loose`, if provided, must be a boolean');
	}

	var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
	var nonWritable = arguments.length > 4 ? arguments[4] : null;
	var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
	var loose = arguments.length > 6 ? arguments[6] : false;

	/* @type {false | TypedPropertyDescriptor<unknown>} */
	var desc = !!gopd && gopd(obj, property);

	if ($defineProperty) {
		$defineProperty(obj, property, {
			configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
			enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
			value: value,
			writable: nonWritable === null && desc ? desc.writable : !nonWritable
		});
	} else if (loose || (!nonEnumerable && !nonWritable && !nonConfigurable)) {
		// must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
		obj[property] = value; // eslint-disable-line no-param-reassign
	} else {
		throw new $SyntaxError('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
	}
};


/***/ }),
/* 98 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./syntax')} */
module.exports = SyntaxError;


/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $defineProperty = __webpack_require__(43);

var hasPropertyDescriptors = function hasPropertyDescriptors() {
	return !!$defineProperty;
};

hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
	// node v0.6 has a bug where array lengths can be Set but not Defined
	if (!$defineProperty) {
		return null;
	}
	try {
		return $defineProperty([], 'length', { value: 1 }).length !== 1;
	} catch (e) {
		// In Firefox 4-22, defining length on an array throws an exception.
		return true;
	}
};

module.exports = hasPropertyDescriptors;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var undefined;

var $Object = __webpack_require__(101);

var $Error = __webpack_require__(167);
var $EvalError = __webpack_require__(168);
var $RangeError = __webpack_require__(169);
var $ReferenceError = __webpack_require__(170);
var $SyntaxError = __webpack_require__(98);
var $TypeError = __webpack_require__(35);
var $URIError = __webpack_require__(171);

var abs = __webpack_require__(172);
var floor = __webpack_require__(173);
var max = __webpack_require__(174);
var min = __webpack_require__(175);
var pow = __webpack_require__(176);
var round = __webpack_require__(177);
var sign = __webpack_require__(178);

var $Function = Function;

// eslint-disable-next-line consistent-return
var getEvalledConstructor = function (expressionSyntax) {
	try {
		return $Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
	} catch (e) {}
};

var $gOPD = __webpack_require__(44);
var $defineProperty = __webpack_require__(43);

var throwTypeError = function () {
	throw new $TypeError();
};
var ThrowTypeError = $gOPD
	? (function () {
		try {
			// eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
			arguments.callee; // IE 8 does not throw here
			return throwTypeError;
		} catch (calleeThrows) {
			try {
				// IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
				return $gOPD(arguments, 'callee').get;
			} catch (gOPDthrows) {
				return throwTypeError;
			}
		}
	}())
	: throwTypeError;

var hasSymbols = __webpack_require__(180)();

var getProto = __webpack_require__(182);
var $ObjectGPO = __webpack_require__(103);
var $ReflectGPO = __webpack_require__(102);

var $apply = __webpack_require__(62);
var $call = __webpack_require__(61);

var needsEval = {};

var TypedArray = typeof Uint8Array === 'undefined' || !getProto ? undefined : getProto(Uint8Array);

var INTRINSICS = {
	__proto__: null,
	'%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
	'%Array%': Array,
	'%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
	'%ArrayIteratorPrototype%': hasSymbols && getProto ? getProto([][Symbol.iterator]()) : undefined,
	'%AsyncFromSyncIteratorPrototype%': undefined,
	'%AsyncFunction%': needsEval,
	'%AsyncGenerator%': needsEval,
	'%AsyncGeneratorFunction%': needsEval,
	'%AsyncIteratorPrototype%': needsEval,
	'%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
	'%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
	'%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
	'%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
	'%Boolean%': Boolean,
	'%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
	'%Date%': Date,
	'%decodeURI%': decodeURI,
	'%decodeURIComponent%': decodeURIComponent,
	'%encodeURI%': encodeURI,
	'%encodeURIComponent%': encodeURIComponent,
	'%Error%': $Error,
	'%eval%': eval, // eslint-disable-line no-eval
	'%EvalError%': $EvalError,
	'%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
	'%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
	'%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
	'%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
	'%Function%': $Function,
	'%GeneratorFunction%': needsEval,
	'%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
	'%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
	'%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
	'%isFinite%': isFinite,
	'%isNaN%': isNaN,
	'%IteratorPrototype%': hasSymbols && getProto ? getProto(getProto([][Symbol.iterator]())) : undefined,
	'%JSON%': typeof JSON === 'object' ? JSON : undefined,
	'%Map%': typeof Map === 'undefined' ? undefined : Map,
	'%MapIteratorPrototype%': typeof Map === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Map()[Symbol.iterator]()),
	'%Math%': Math,
	'%Number%': Number,
	'%Object%': $Object,
	'%Object.getOwnPropertyDescriptor%': $gOPD,
	'%parseFloat%': parseFloat,
	'%parseInt%': parseInt,
	'%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
	'%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
	'%RangeError%': $RangeError,
	'%ReferenceError%': $ReferenceError,
	'%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
	'%RegExp%': RegExp,
	'%Set%': typeof Set === 'undefined' ? undefined : Set,
	'%SetIteratorPrototype%': typeof Set === 'undefined' || !hasSymbols || !getProto ? undefined : getProto(new Set()[Symbol.iterator]()),
	'%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
	'%String%': String,
	'%StringIteratorPrototype%': hasSymbols && getProto ? getProto(''[Symbol.iterator]()) : undefined,
	'%Symbol%': hasSymbols ? Symbol : undefined,
	'%SyntaxError%': $SyntaxError,
	'%ThrowTypeError%': ThrowTypeError,
	'%TypedArray%': TypedArray,
	'%TypeError%': $TypeError,
	'%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
	'%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
	'%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
	'%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
	'%URIError%': $URIError,
	'%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
	'%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
	'%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,

	'%Function.prototype.call%': $call,
	'%Function.prototype.apply%': $apply,
	'%Object.defineProperty%': $defineProperty,
	'%Object.getPrototypeOf%': $ObjectGPO,
	'%Math.abs%': abs,
	'%Math.floor%': floor,
	'%Math.max%': max,
	'%Math.min%': min,
	'%Math.pow%': pow,
	'%Math.round%': round,
	'%Math.sign%': sign,
	'%Reflect.getPrototypeOf%': $ReflectGPO
};

if (getProto) {
	try {
		null.error; // eslint-disable-line no-unused-expressions
	} catch (e) {
		// https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
		var errorProto = getProto(getProto(e));
		INTRINSICS['%Error.prototype%'] = errorProto;
	}
}

var doEval = function doEval(name) {
	var value;
	if (name === '%AsyncFunction%') {
		value = getEvalledConstructor('async function () {}');
	} else if (name === '%GeneratorFunction%') {
		value = getEvalledConstructor('function* () {}');
	} else if (name === '%AsyncGeneratorFunction%') {
		value = getEvalledConstructor('async function* () {}');
	} else if (name === '%AsyncGenerator%') {
		var fn = doEval('%AsyncGeneratorFunction%');
		if (fn) {
			value = fn.prototype;
		}
	} else if (name === '%AsyncIteratorPrototype%') {
		var gen = doEval('%AsyncGenerator%');
		if (gen && getProto) {
			value = getProto(gen.prototype);
		}
	}

	INTRINSICS[name] = value;

	return value;
};

var LEGACY_ALIASES = {
	__proto__: null,
	'%ArrayBufferPrototype%': ['ArrayBuffer', 'prototype'],
	'%ArrayPrototype%': ['Array', 'prototype'],
	'%ArrayProto_entries%': ['Array', 'prototype', 'entries'],
	'%ArrayProto_forEach%': ['Array', 'prototype', 'forEach'],
	'%ArrayProto_keys%': ['Array', 'prototype', 'keys'],
	'%ArrayProto_values%': ['Array', 'prototype', 'values'],
	'%AsyncFunctionPrototype%': ['AsyncFunction', 'prototype'],
	'%AsyncGenerator%': ['AsyncGeneratorFunction', 'prototype'],
	'%AsyncGeneratorPrototype%': ['AsyncGeneratorFunction', 'prototype', 'prototype'],
	'%BooleanPrototype%': ['Boolean', 'prototype'],
	'%DataViewPrototype%': ['DataView', 'prototype'],
	'%DatePrototype%': ['Date', 'prototype'],
	'%ErrorPrototype%': ['Error', 'prototype'],
	'%EvalErrorPrototype%': ['EvalError', 'prototype'],
	'%Float32ArrayPrototype%': ['Float32Array', 'prototype'],
	'%Float64ArrayPrototype%': ['Float64Array', 'prototype'],
	'%FunctionPrototype%': ['Function', 'prototype'],
	'%Generator%': ['GeneratorFunction', 'prototype'],
	'%GeneratorPrototype%': ['GeneratorFunction', 'prototype', 'prototype'],
	'%Int8ArrayPrototype%': ['Int8Array', 'prototype'],
	'%Int16ArrayPrototype%': ['Int16Array', 'prototype'],
	'%Int32ArrayPrototype%': ['Int32Array', 'prototype'],
	'%JSONParse%': ['JSON', 'parse'],
	'%JSONStringify%': ['JSON', 'stringify'],
	'%MapPrototype%': ['Map', 'prototype'],
	'%NumberPrototype%': ['Number', 'prototype'],
	'%ObjectPrototype%': ['Object', 'prototype'],
	'%ObjProto_toString%': ['Object', 'prototype', 'toString'],
	'%ObjProto_valueOf%': ['Object', 'prototype', 'valueOf'],
	'%PromisePrototype%': ['Promise', 'prototype'],
	'%PromiseProto_then%': ['Promise', 'prototype', 'then'],
	'%Promise_all%': ['Promise', 'all'],
	'%Promise_reject%': ['Promise', 'reject'],
	'%Promise_resolve%': ['Promise', 'resolve'],
	'%RangeErrorPrototype%': ['RangeError', 'prototype'],
	'%ReferenceErrorPrototype%': ['ReferenceError', 'prototype'],
	'%RegExpPrototype%': ['RegExp', 'prototype'],
	'%SetPrototype%': ['Set', 'prototype'],
	'%SharedArrayBufferPrototype%': ['SharedArrayBuffer', 'prototype'],
	'%StringPrototype%': ['String', 'prototype'],
	'%SymbolPrototype%': ['Symbol', 'prototype'],
	'%SyntaxErrorPrototype%': ['SyntaxError', 'prototype'],
	'%TypedArrayPrototype%': ['TypedArray', 'prototype'],
	'%TypeErrorPrototype%': ['TypeError', 'prototype'],
	'%Uint8ArrayPrototype%': ['Uint8Array', 'prototype'],
	'%Uint8ClampedArrayPrototype%': ['Uint8ClampedArray', 'prototype'],
	'%Uint16ArrayPrototype%': ['Uint16Array', 'prototype'],
	'%Uint32ArrayPrototype%': ['Uint32Array', 'prototype'],
	'%URIErrorPrototype%': ['URIError', 'prototype'],
	'%WeakMapPrototype%': ['WeakMap', 'prototype'],
	'%WeakSetPrototype%': ['WeakSet', 'prototype']
};

var bind = __webpack_require__(36);
var hasOwn = __webpack_require__(186);
var $concat = bind.call($call, Array.prototype.concat);
var $spliceApply = bind.call($apply, Array.prototype.splice);
var $replace = bind.call($call, String.prototype.replace);
var $strSlice = bind.call($call, String.prototype.slice);
var $exec = bind.call($call, RegExp.prototype.exec);

/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */
var rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */
var stringToPath = function stringToPath(string) {
	var first = $strSlice(string, 0, 1);
	var last = $strSlice(string, -1);
	if (first === '%' && last !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected closing `%`');
	} else if (last === '%' && first !== '%') {
		throw new $SyntaxError('invalid intrinsic syntax, expected opening `%`');
	}
	var result = [];
	$replace(string, rePropName, function (match, number, quote, subString) {
		result[result.length] = quote ? $replace(subString, reEscapeChar, '$1') : number || match;
	});
	return result;
};
/* end adaptation */

var getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
	var intrinsicName = name;
	var alias;
	if (hasOwn(LEGACY_ALIASES, intrinsicName)) {
		alias = LEGACY_ALIASES[intrinsicName];
		intrinsicName = '%' + alias[0] + '%';
	}

	if (hasOwn(INTRINSICS, intrinsicName)) {
		var value = INTRINSICS[intrinsicName];
		if (value === needsEval) {
			value = doEval(intrinsicName);
		}
		if (typeof value === 'undefined' && !allowMissing) {
			throw new $TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
		}

		return {
			alias: alias,
			name: intrinsicName,
			value: value
		};
	}

	throw new $SyntaxError('intrinsic ' + name + ' does not exist!');
};

module.exports = function GetIntrinsic(name, allowMissing) {
	if (typeof name !== 'string' || name.length === 0) {
		throw new $TypeError('intrinsic name must be a non-empty string');
	}
	if (arguments.length > 1 && typeof allowMissing !== 'boolean') {
		throw new $TypeError('"allowMissing" argument must be a boolean');
	}

	if ($exec(/^%?[^%]*%?$/, name) === null) {
		throw new $SyntaxError('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
	}
	var parts = stringToPath(name);
	var intrinsicBaseName = parts.length > 0 ? parts[0] : '';

	var intrinsic = getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
	var intrinsicRealName = intrinsic.name;
	var value = intrinsic.value;
	var skipFurtherCaching = false;

	var alias = intrinsic.alias;
	if (alias) {
		intrinsicBaseName = alias[0];
		$spliceApply(parts, $concat([0, 1], alias));
	}

	for (var i = 1, isOwn = true; i < parts.length; i += 1) {
		var part = parts[i];
		var first = $strSlice(part, 0, 1);
		var last = $strSlice(part, -1);
		if (
			(
				(first === '"' || first === "'" || first === '`')
				|| (last === '"' || last === "'" || last === '`')
			)
			&& first !== last
		) {
			throw new $SyntaxError('property names with quotes must have matching quotes');
		}
		if (part === 'constructor' || !isOwn) {
			skipFurtherCaching = true;
		}

		intrinsicBaseName += '.' + part;
		intrinsicRealName = '%' + intrinsicBaseName + '%';

		if (hasOwn(INTRINSICS, intrinsicRealName)) {
			value = INTRINSICS[intrinsicRealName];
		} else if (value != null) {
			if (!(part in value)) {
				if (!allowMissing) {
					throw new $TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
				}
				return void undefined;
			}
			if ($gOPD && (i + 1) >= parts.length) {
				var desc = $gOPD(value, part);
				isOwn = !!desc;

				// By convention, when a data property is converted to an accessor
				// property to emulate a data property that does not suffer from
				// the override mistake, that accessor's getter is marked with
				// an `originalValue` property. Here, when we detect this, we
				// uphold the illusion by pretending to see that original data
				// property, i.e., returning the value rather than the getter
				// itself.
				if (isOwn && 'get' in desc && !('originalValue' in desc.get)) {
					value = desc.get;
				} else {
					value = value[part];
				}
			} else {
				isOwn = hasOwn(value, part);
				value = value[part];
			}

			if (isOwn && !skipFurtherCaching) {
				INTRINSICS[intrinsicRealName] = value;
			}
		}
	}
	return value;
};


/***/ }),
/* 101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Object;


/***/ }),
/* 102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./Reflect.getPrototypeOf')} */
module.exports = (typeof Reflect !== 'undefined' && Reflect.getPrototypeOf) || null;


/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $Object = __webpack_require__(101);

/** @type {import('./Object.getPrototypeOf')} */
module.exports = $Object.getPrototypeOf || null;


/***/ }),
/* 104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(36);

var $apply = __webpack_require__(62);
var $call = __webpack_require__(61);
var $reflectApply = __webpack_require__(185);

/** @type {import('./actualApply')} */
module.exports = $reflectApply || bind.call($call, $apply);


/***/ }),
/* 105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var RequireObjectCoercible = __webpack_require__(188);
var callBound = __webpack_require__(189);

var $isEnumerable = callBound('Object.prototype.propertyIsEnumerable');

module.exports = function values(O) {
	var obj = RequireObjectCoercible(O);
	var vals = [];
	for (var key in obj) {
		if ($isEnumerable(obj, key)) { // checks own-ness as well
			vals[vals.length] = obj[key];
		}
	}
	return vals;
};


/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var implementation = __webpack_require__(105);

module.exports = function getPolyfill() {
	return typeof Object.values === 'function' ? Object.values : implementation;
};


/***/ }),
/* 107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(20);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUTMFirst() {
    return _rpCookie2.default.sharedPermanent.get(_constants.COOKIE_UTM_KEY_FIRST);
}

exports.default = getUTMFirst;

/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs=e()}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(59);
var $export = __webpack_require__(26);
var redefine = __webpack_require__(207);
var hide = __webpack_require__(27);
var Iterators = __webpack_require__(29);
var $iterCreate = __webpack_require__(208);
var setToStringTag = __webpack_require__(69);
var getPrototypeOf = __webpack_require__(211);
var ITERATOR = __webpack_require__(14)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(13).document;
module.exports = document && document.documentElement;


/***/ }),
/* 111 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(71);
var ITERATOR = __webpack_require__(14)('iterator');
var Iterators = __webpack_require__(29);
module.exports = __webpack_require__(17).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs_plugin_timezone=e()}(this,(function(){"use strict";var t={year:0,month:1,day:2,hour:3,minute:4,second:5},e={};return function(n,i,o){var r,a=function(t,n,i){void 0===i&&(i={});var o=new Date(t),r=function(t,n){void 0===n&&(n={});var i=n.timeZoneName||"short",o=t+"|"+i,r=e[o];return r||(r=new Intl.DateTimeFormat("en-US",{hour12:!1,timeZone:t,year:"numeric",month:"2-digit",day:"2-digit",hour:"2-digit",minute:"2-digit",second:"2-digit",timeZoneName:i}),e[o]=r),r}(n,i);return r.formatToParts(o)},u=function(e,n){for(var i=a(e,n),r=[],u=0;u<i.length;u+=1){var f=i[u],s=f.type,m=f.value,c=t[s];c>=0&&(r[c]=parseInt(m,10))}var d=r[3],l=24===d?0:d,h=r[0]+"-"+r[1]+"-"+r[2]+" "+l+":"+r[4]+":"+r[5]+":000",v=+e;return(o.utc(h).valueOf()-(v-=v%1e3))/6e4},f=i.prototype;f.tz=function(t,e){void 0===t&&(t=r);var n,i=this.utcOffset(),a=this.toDate(),u=a.toLocaleString("en-US",{timeZone:t}),f=Math.round((a-new Date(u))/1e3/60),s=15*-Math.round(a.getTimezoneOffset()/15)-f;if(!Number(s))n=this.utcOffset(0,e);else if(n=o(u,{locale:this.$L}).$set("millisecond",this.$ms).utcOffset(s,!0),e){var m=n.utcOffset();n=n.add(i-m,"minute")}return n.$x.$timezone=t,n},f.offsetName=function(t){var e=this.$x.$timezone||o.tz.guess(),n=a(this.valueOf(),e,{timeZoneName:t}).find((function(t){return"timezonename"===t.type.toLowerCase()}));return n&&n.value};var s=f.startOf;f.startOf=function(t,e){if(!this.$x||!this.$x.$timezone)return s.call(this,t,e);var n=o(this.format("YYYY-MM-DD HH:mm:ss:SSS"),{locale:this.$L});return s.call(n,t,e).tz(this.$x.$timezone,!0)},o.tz=function(t,e,n){var i=n&&e,a=n||e||r,f=u(+o(),a);if("string"!=typeof t)return o(t).tz(a);var s=function(t,e,n){var i=t-60*e*1e3,o=u(i,n);if(e===o)return[i,e];var r=u(i-=60*(o-e)*1e3,n);return o===r?[i,o]:[t-60*Math.min(o,r)*1e3,Math.max(o,r)]}(o.utc(t,i).valueOf(),f,a),m=s[0],c=s[1],d=o(m).utcOffset(c);return d.$x.$timezone=a,d},o.tz.guess=function(){return Intl.DateTimeFormat().resolvedOptions().timeZone},o.tz.setDefault=function(t){r=t}}}));

/***/ }),
/* 113 */
/***/ (function(module, exports, __webpack_require__) {

// 7.3.20 SpeciesConstructor(O, defaultConstructor)
var anObject = __webpack_require__(24);
var aFunction = __webpack_require__(39);
var SPECIES = __webpack_require__(14)('species');
module.exports = function (O, D) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
};


/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(38);
var invoke = __webpack_require__(264);
var html = __webpack_require__(110);
var cel = __webpack_require__(54);
var global = __webpack_require__(13);
var process = global.process;
var setTask = global.setImmediate;
var clearTask = global.clearImmediate;
var MessageChannel = global.MessageChannel;
var Dispatch = global.Dispatch;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var defer, channel, port;
var run = function () {
  var id = +this;
  // eslint-disable-next-line no-prototype-builtins
  if (queue.hasOwnProperty(id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};
var listener = function (event) {
  run.call(event.data);
};
// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!setTask || !clearTask) {
  setTask = function setImmediate(fn) {
    var args = [];
    var i = 1;
    while (arguments.length > i) args.push(arguments[i++]);
    queue[++counter] = function () {
      // eslint-disable-next-line no-new-func
      invoke(typeof fn == 'function' ? fn : Function(fn), args);
    };
    defer(counter);
    return counter;
  };
  clearTask = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (__webpack_require__(41)(process) == 'process') {
    defer = function (id) {
      process.nextTick(ctx(run, id, 1));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(ctx(run, id, 1));
    };
  // Browsers with MessageChannel, includes WebWorkers
  } else if (MessageChannel) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = listener;
    defer = ctx(port.postMessage, port, 1);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
    defer = function (id) {
      global.postMessage(id + '', '*');
    };
    global.addEventListener('message', listener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in cel('script')) {
    defer = function (id) {
      html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run.call(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(ctx(run, id, 1), 0);
    };
  }
}
module.exports = {
  set: setTask,
  clear: clearTask
};


/***/ }),
/* 115 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return { e: false, v: exec() };
  } catch (e) {
    return { e: true, v: e };
  }
};


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(24);
var isObject = __webpack_require__(34);
var newPromiseCapability = __webpack_require__(75);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.mandatoryLoginReducer = exports.errorDialogReducer = exports.forgottenPassReducer = exports.resetPassReducer = exports.emailVerificationReducer = exports.barrierReducer = exports.userReducer = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsCookie = __webpack_require__(28);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _actions = __webpack_require__(12);

var actions = _interopRequireWildcard(_actions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cookie = _jsCookie2.default.get('RDSP');
var isLoggedIn = cookie && JSON.parse(cookie).rp_uid;

var userReducer = exports.userReducer = function userReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !!isLoggedIn;
    var action = arguments[1];

    switch (action.type) {
        case actions.SIGN_IN:
            return true;
        case actions.SIGN_OUT:
            return false;
        default:
            return state;
    }
};

var initialBarrierState = {
    show: false,
    step: 'Subscriptions',
    backUrl: '',
    text: '',
    service: '',
    showTitle: false
};

var barrierReducer = exports.barrierReducer = function barrierReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialBarrierState;
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_BARRIER:
            return _extends({}, state, {
                step: action.step,
                backUrl: action.backUrl,
                text: action.text,
                service: action.service,
                showTitle: action.showTitle || false,
                show: true
            });
        case actions.HIDE_BARRIER:
            return _extends({}, state, {
                show: false
            });
        default:
            return state;
    }
};

var emailVerificationReducer = exports.emailVerificationReducer = function emailVerificationReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isVisible: false,
        message: '',
        accountId: null,
        session: null
    };
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_EMAIL_VERIFICATION:
            return {
                isVisible: true,
                message: action.message || state.message,
                accountId: action.accountId || state.accountId,
                session: action.session || state.session
            };
        case actions.HIDE_EMAIL_VERIFICATION:
            return {
                isVisible: false,
                message: '',
                accountId: null,
                session: null
            };
        case actions.SET_EMAIL_VERIFICATION_MESSAGE:
            return _extends({}, state, {
                message: action.message,
                accountId: action.accountId,
                session: action.session
            });
        default:
            return state;
    }
};

var resetPassReducer = exports.resetPassReducer = function resetPassReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isVisible: false,
        email: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_RESET_PASSWORD:
            return {
                isVisible: true,
                email: action.email
            };
        case actions.HIDE_RESET_PASSWORD:
            return {
                isVisible: false,
                email: ''
            };
        default:
            return state;
    }
};

var forgottenPassReducer = exports.forgottenPassReducer = function forgottenPassReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_FORGOTTEN_PASSWORD:
            return true;
        case actions.HIDE_FORGOTTEN_PASSWORD:
            return false;
        default:
            return state;
    }
};

var errorDialogReducer = exports.errorDialogReducer = function errorDialogReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
        isVisible: false,
        message: ''
    };
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_ERROR_DIALOG:
            return {
                isVisible: true,
                message: action.message
            };
        case actions.HIDE_ERROR_DIALOG:
            return {
                isVisible: false,
                message: ''
            };
        default:
            return state;
    }
};

var initialMandatoryLoginState = {
    show: false,
    step: 'SignUp',
    target: null
};

var mandatoryLoginReducer = exports.mandatoryLoginReducer = function mandatoryLoginReducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialMandatoryLoginState;
    var action = arguments[1];

    switch (action.type) {
        case actions.SHOW_MANDATORY_LOGIN:
            return _extends({}, state, {
                show: true,
                step: action.step,
                target: action.target
            });
        case actions.HIDE_MANDATORY_LOGIN:
            return _extends({}, state, {
                show: false
            });
        default:
            return state;
    }
};

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(302);

/***/ }),
/* 119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);
var settle = __webpack_require__(307);
var buildURL = __webpack_require__(309);
var parseHeaders = __webpack_require__(310);
var isURLSameOrigin = __webpack_require__(311);
var createError = __webpack_require__(121);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    request.open(config.method.toUpperCase(), buildURL(config.url, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      reject(createError('timeout of ' + config.timeout + 'ms exceeded', config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(312);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(config.url)) && config.xsrfCookieName ?
          cookies.read(config.xsrfCookieName) :
          undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (config.withCredentials) {
      request.withCredentials = true;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(308);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSessionStatus = exports.shouldCheckForBarrier = exports.getParams = undefined;

var _parseParams = __webpack_require__(321);

var _parseParams2 = _interopRequireDefault(_parseParams);

var _handleCookie = __webpack_require__(322);

var _handleCookie2 = _interopRequireDefault(_handleCookie);

var _api = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LIGHTBOX_ALLOW_PARAM = 'authme';

var getParams = exports.getParams = function getParams() {
    return (0, _parseParams2.default)((0, _handleCookie2.default)());
};

var shouldCheckForBarrier = exports.shouldCheckForBarrier = function shouldCheckForBarrier() {
    var search = window.location.search;


    return search.indexOf('?' + LIGHTBOX_ALLOW_PARAM) !== -1 || search.indexOf('&' + LIGHTBOX_ALLOW_PARAM) !== -1;
};

exports.getSessionStatus = _api.getSessionStatus;

/***/ }),
/* 125 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_125__;

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(325);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, module) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ponyfill_js__ = __webpack_require__(329);
/* global window */


var root;

if (typeof self !== 'undefined') {
  root = self;
} else if (typeof window !== 'undefined') {
  root = window;
} else if (typeof global !== 'undefined') {
  root = global;
} else if (true) {
  root = module;
} else {
  root = Function('return this')();
}

var result = Object(__WEBPACK_IMPORTED_MODULE_0__ponyfill_js__["a" /* default */])(root);
/* harmony default export */ __webpack_exports__["a"] = (result);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7), __webpack_require__(328)(module)))

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getDisplayText;

var _constants = __webpack_require__(30);

function getDisplayText(isLoggedIn, firstName) {
    if (!isLoggedIn) {
        return _constants.LOG_IN;
    }

    if (firstName) {
        return firstName;
    }

    return _constants.MY_ACCOUNT;
}

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80),
    getRawTag = __webpack_require__(356),
    objectToString = __webpack_require__(357);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 130 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {}, void 0, 'Your details are incorrect. Please try again');

var ForgottenPasswordBtn = function ForgottenPasswordBtn(_ref) {
    var _onClick = _ref.onClick,
        error = _ref.error,
        className = _ref.className;
    return _jsx('div', {
        className: _fields2.default.field + ' ' + className
    }, void 0, _jsx('button', {
        type: 'button',
        className: 'ui-link ui-link_secondary ui-reset-for-btn',
        onClick: function onClick(e) {
            e.preventDefault();
            _onClick();
        }
    }, void 0, 'Forgotten password?'), error && _jsx('div', {
        className: _fields2.default.error,
        id: 'error-sign-in'
    }, void 0, _ref2));
};

ForgottenPasswordBtn.defaultProps = {
    error: false,
    className: ''
};

exports.default = ForgottenPasswordBtn;

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _reactRedux = __webpack_require__(9);

var _Lightbox = __webpack_require__(31);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _EmailVerification = __webpack_require__(133);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailVerificationPopup = function EmailVerificationPopup(_ref) {
    var closePopover = _ref.closePopover,
        message = _ref.message,
        accountId = _ref.accountId,
        session = _ref.session,
        goToSignIn = _ref.goToSignIn,
        goToErrorDialog = _ref.goToErrorDialog;
    return _jsx(_Lightbox2.default, {
        close: closePopover
    }, void 0, _jsx(_EmailVerification2.default, {
        email: message,
        accountId: accountId,
        session: session,
        onSuccess: goToSignIn,
        onError: goToErrorDialog
    }));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EmailVerificationPopup'), (0, _recompose.defaultProps)({
    message: ''
}), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showEmailVerifi = _ref2.showEmailVerification,
        message = _ref2$showEmailVerifi.message,
        accountId = _ref2$showEmailVerifi.accountId,
        session = _ref2$showEmailVerifi.session;
    return { message: message, accountId: accountId, session: session };
}), (0, _recompose.setPropTypes)({
    closePopover: _propTypes2.default.func.isRequired,
    goToErrorDialog: _propTypes2.default.func.isRequired,
    message: _propTypes2.default.string
}))(EmailVerificationPopup);

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmailVerification = __webpack_require__(384);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EmailVerification2.default;

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Lightbox = __webpack_require__(31);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _ErrorDialog = __webpack_require__(84);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorPopup = function ErrorPopup(_ref) {
    var closePopover = _ref.closePopover,
        goToSignIn = _ref.goToSignIn,
        message = _ref.message;
    return _jsx(_Lightbox2.default, {
        close: closePopover
    }, void 0, _jsx(_ErrorDialog2.default, {
        close: goToSignIn,
        message: message
    }));
};

ErrorPopup.defaultProps = {
    message: ''
};

exports.default = ErrorPopup;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint no-mixed-operators: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailErrorSignIn = function EmailErrorSignIn(dirty, empty) {
    return _jsx('div', {
        className: _fields2.default.comment
    }, void 0, _jsx('span', {}, void 0, dirty && empty || !dirty ? 'Please specify your email address' : 'Please use a valid email address'));
};

exports.default = EmailErrorSignIn;

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _classnames = __webpack_require__(48);

var _classnames2 = _interopRequireDefault(_classnames);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchFormBtn = function SwitchFormBtn(_ref) {
    var className = _ref.className,
        label = _ref.label,
        onClick = _ref.onClick,
        hidden = _ref.hidden;
    return _jsx('div', {
        className: (0, _classnames2.default)({ 'hidden-lg-up': hidden }, '' + _fields2.default.switchField, _fields2.default[className])
    }, void 0, _jsx('button', {
        type: 'button',
        className: 'ui-reset-for-btn ui-link ui-link_secondary',
        onClick: onClick
    }, void 0, label));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SwitchFormBtn'), (0, _recompose.defaultProps)({
    className: ''
}), (0, _recompose.setPropTypes)({
    className: _propTypes2.default.string,
    label: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,
    onClick: _propTypes2.default.func.isRequired,
    hidden: _propTypes2.default.bool.isRequired
}))(SwitchFormBtn);

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(403);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./forms.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./forms.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignUpForm = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormField = __webpack_require__(47);

var _FormField2 = _interopRequireDefault(_FormField);

var _PasswordError = __webpack_require__(82);

var _PasswordError2 = _interopRequireDefault(_PasswordError);

var _SubmitBtn = __webpack_require__(49);

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _SwitchFormBtn = __webpack_require__(136);

var _SwitchFormBtn2 = _interopRequireDefault(_SwitchFormBtn);

var _Conditions = __webpack_require__(408);

var _Conditions2 = _interopRequireDefault(_Conditions);

var _EmailErrorSignIn = __webpack_require__(135);

var _EmailErrorSignIn2 = _interopRequireDefault(_EmailErrorSignIn);

var _validation = __webpack_require__(50);

var _validation2 = _interopRequireDefault(_validation);

var _api = __webpack_require__(15);

var _forms = __webpack_require__(137);

var _forms2 = _interopRequireDefault(_forms);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function performSignUp(email_, password_, options_, onSignUpError_, onSignUpLoadComplete_, showErrorDialog_, onSignUpSuccess_) {
    var conditions = _extends({
        horseBetting: false,
        horseNews: false,
        bloodstock: false,
        sportBetting: false,
        competitions: false
    }, options_);

    function onSuccess_(data) {
        onSignUpLoadComplete_();

        if (!onSignUpSuccess_) return;

        var userDetails = {
            email: data.email,
            userId: data.clientUserId
        };

        onSignUpSuccess_(userDetails, conditions);
    }

    function onError_(error_) {
        if (error_ && error_.response && error_.response.data.errorMessage === 'The email is already in use.') {
            onSignUpError_();
            onSignUpLoadComplete_();

            return;
        }

        showErrorDialog_();
    }

    (0, _api.AuthSignUp)({
        email: email_,
        password: password_,
        conditions: conditions
    }).then(onSuccess_, onError_).catch(function (error_) {
        throw error_;
    });
}

function constructGlobalAuthApi() {
    global.authApi = global.authApi || {};

    global.authApi.performSignUp = performSignUp;
}

constructGlobalAuthApi();

var SignUpForm = exports.SignUpForm = function (_Component) {
    _inherits(SignUpForm, _Component);

    function SignUpForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SignUpForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignUpForm.__proto__ || Object.getPrototypeOf(SignUpForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            emailError: false,
            passwordError: false,
            confirmPasswordError: false,
            termsConditionsError: false,
            loading: false,
            signUpError: false
        }, _this.onSubmit = function (event_) {
            event_.preventDefault();

            var _this$form = _this.form,
                email = _this$form.email,
                password = _this$form.password,
                confirmPassword = _this$form.confirmPassword,
                termsConditions = _this$form.termsConditions,
                horseBetting = _this$form.horseBetting,
                horseNews = _this$form.horseNews,
                bloodstock = _this$form.bloodstock,
                sportBetting = _this$form.sportBetting,
                competitions = _this$form.competitions,
                newsletterThirdParty = _this$form.newsletterThirdParty,
                eighteenYears = _this$form.eighteenYears;


            var is_form_valid_ = [email, password, confirmPassword, termsConditions].map(_this.validate).every(function (isValid) {
                return isValid;
            });

            if (!is_form_valid_) return;

            _this.setState({ loading: true });

            var conditions = {};

            var _this$props = _this.props,
                onSignUpSuccess = _this$props.onSignUpSuccess,
                disableConditions = _this$props.disableConditions,
                goToSignUpComplete = _this$props.goToSignUpComplete,
                goToErrorDialog = _this$props.goToErrorDialog;


            if (!disableConditions) {
                conditions = {
                    horseBetting: horseBetting && horseBetting.checked,
                    horseNews: horseNews && horseNews.checked,
                    bloodstock: bloodstock && bloodstock.checked,
                    sportBetting: sportBetting && sportBetting.checked,
                    competitions: competitions && competitions.checked,
                    newsletterThirdParty: newsletterThirdParty && newsletterThirdParty.checked,
                    eighteenYears: eighteenYears && eighteenYears.checked,
                    termsConditions: termsConditions && termsConditions.checked
                };
            } else {
                conditions = {
                    horseBetting: false,
                    horseNews: false,
                    bloodstock: false,
                    sportBetting: false,
                    competitions: false,
                    newsletterThirdParty: false,
                    eighteenYears: false,
                    termsConditions: termsConditions && termsConditions.checked
                };
            }

            var onSignUpSuccess_ = function onSignUpSuccess_(userInfo, conditions_) {
                if (onSignUpSuccess) onSignUpSuccess(userInfo, conditions_);

                goToSignUpComplete();
            };

            var onSignUpError_ = function onSignUpError_() {
                _this.setState({ signUpError: true });
            };

            var onSignUpLoadComplete_ = function onSignUpLoadComplete_() {
                _this.setState({ loading: false });
            };

            performSignUp(email.value, password.value, conditions, onSignUpError_, onSignUpLoadComplete_, goToErrorDialog, onSignUpSuccess_);
        }, _this.validate = function (_ref2) {
            var name = _ref2.name,
                type = _ref2.type,
                checked = _ref2.checked,
                value = _ref2.value;

            var validate = _validation2.default[name];
            var inputValue = type === 'checkbox' ? checked : value;
            var isValid = validate(inputValue, _this.form.password.value);
            _this.setState(function (prevState) {
                var _ref3;

                return _ref3 = {}, _defineProperty(_ref3, name + 'Error', !isValid), _defineProperty(_ref3, 'signUpError', name === 'email' ? false : prevState.signUpError), _ref3;
            });

            return isValid;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SignUpForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                emailError = _state.emailError,
                passwordError = _state.passwordError,
                confirmPasswordError = _state.confirmPasswordError,
                termsConditionsError = _state.termsConditionsError,
                loading = _state.loading,
                signUpError = _state.signUpError;
            var _props = this.props,
                goToForgottenPass = _props.goToForgottenPass,
                disableConditions = _props.disableConditions,
                submitLabel = _props.submitLabel,
                switchFormLabel = _props.switchFormLabel,
                goToSignIn = _props.goToSignIn,
                hidden = _props.hidden;


            return _react2.default.createElement(
                'form',
                {
                    className: _forms2.default.form + ' ' + _forms2.default.signUp,
                    onSubmit: this.onSubmit,
                    noValidate: true,
                    ref: function ref(node) {
                        _this2.form = node;
                    }
                },
                _jsx(_FormField2.default, {
                    name: 'email',
                    validate: this.validate,
                    hasError: emailError,
                    signUpError: signUpError,
                    handleClick: goToForgottenPass,
                    error: _EmailErrorSignIn2.default
                }),
                _jsx(_FormField2.default, {
                    name: 'password',
                    validate: this.validate,
                    hasError: passwordError,
                    error: _PasswordError2.default
                }),
                _jsx(_FormField2.default, {
                    name: 'confirmPassword',
                    type: 'password',
                    validate: this.validate,
                    hasError: confirmPasswordError,
                    error: 'Passwords do not match'
                }),
                _jsx(_Conditions2.default, {
                    validate: this.validate,
                    disableConditions: disableConditions,
                    termsConditionsError: termsConditionsError
                }),
                _jsx(_SubmitBtn2.default, {
                    label: submitLabel,
                    loading: loading
                }),
                _jsx(_SwitchFormBtn2.default, {
                    className: 'signUp',
                    label: switchFormLabel,
                    onClick: goToSignIn,
                    hidden: hidden
                })
            );
        }
    }]);

    return SignUpForm;
}(_react.Component);

SignUpForm.defaultProps = {
    onSignUpSuccess: function onSignUpSuccess() {
        return null;
    },
    disableConditions: false,
    submitLabel: 'Sign Up',
    switchFormLabel: 'Sign In'
};

exports.default = SignUpForm;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(421);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../node_modules/css-loader/index.js??ref--3-1!../node_modules/sass-loader/lib/loader.js!./App.scss", function() {
		var newContent = require("!!../node_modules/css-loader/index.js??ref--3-1!../node_modules/sass-loader/lib/loader.js!./App.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _redux = __webpack_require__(77);

var _reduxDevtoolsExtension = __webpack_require__(438);

var _reducers = __webpack_require__(117);

var composeEnhancers = _redux.compose;
var middlewares = [];

if (false) {
    composeEnhancers = _reduxDevtoolsExtension.composeWithDevTools;
    //   import('redux-logger').then(({ createLogger }) => {
    //       middlewares.push(createLogger());
    //   });
}

var store = (0, _redux.createStore)((0, _redux.combineReducers)({
    userLoggedIn: _reducers.userReducer,
    showBarrier: _reducers.barrierReducer,
    showEmailVerification: _reducers.emailVerificationReducer,
    showResetPassword: _reducers.resetPassReducer,
    showForgottenPassword: _reducers.forgottenPassReducer,
    showErrorDialog: _reducers.errorDialogReducer,
    showMandatoryLogin: _reducers.mandatoryLoginReducer
}), composeEnhancers(_redux.applyMiddleware.apply(undefined, middlewares)));

exports.default = store;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* This is our own custom metering which should replace MPP eMetering
   the purpose of this object is to provide a way to meter the user's access to the site
   There is no need to create object for Free users as they won't have access to the section or page

   example of how to use => customMetering['Analysis']['horse_profile']['entries'] = true; // true is the value for metering
*/
var customMeteringRules = {
    Insights: {
        horse_profile: {
            form: true,
            entries: true
        },
        jockey_profile: {
            form: true,
            booked_rides: true,
            horses: true,
            stats: true
        },
        trainer_profile: {
            form: true,
            entries: true,
            horses: true,
            stats: true
        },
        owner_profile: {
            form: true,
            entries: true,
            horses: true,
            stats: true
        },
        racecards: {
            form: true
        },
        results: {
            full_replay: true,
            closing_stages_replay: true,
            analysis: true,
            my_ratings: true,
            past_winners: true
        }
    },
    Essential: {
        horse_profile: {
            form: true,
            entries: true
        },
        jockey_profile: {
            form: true,
            booked_rides: true,
            horses: true,
            stats: true
        },
        trainer_profile: {
            form: true,
            entries: true,
            horses: true,
            stats: true
        },
        owner_profile: {
            form: true,
            entries: true,
            horses: true,
            stats: true
        },
        racecards: {
            form: true
        },
        results: {
            full_replay: true,
            closing_stages_replay: true,
            analysis: true,
            my_ratings: true,
            past_winners: true
        }
    },
    Tipping: {
        horse_profile: {
            form: false,
            entries: false
        },
        jockey_profile: {
            form: false,
            booked_rides: false,
            horses: false,
            stats: false
        },
        trainer_profile: {
            form: false,
            entries: false,
            horses: false,
            stats: false
        },
        owner_profile: {
            form: false,
            entries: false,
            horses: false,
            stats: false
        },
        racecards: {
            form: false
        },
        results: {
            full_replay: false,
            closing_stages_replay: false,
            analysis: false,
            my_ratings: false,
            past_winners: false
        }
    },
    Free: {
        horse_profile: {
            form: false,
            entries: false
        },
        jockey_profile: {
            form: false,
            booked_rides: false,
            horses: false,
            stats: false
        },
        trainer_profile: {
            form: false,
            entries: false,
            horses: false,
            stats: false
        },
        owner_profile: {
            form: false,
            entries: false,
            horses: false,
            stats: false
        },
        racecards: {
            form: false
        },
        results: {
            full_replay: false,
            closing_stages_replay: false,
            analysis: false,
            my_ratings: false,
            past_winners: false
        }
    }
};

exports.default = customMeteringRules;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getSessionStatus = exports.subscriptionTypes = exports.customMeteringRules = exports.getParams = exports.dispatchSignOut = exports.dispatchSignIn = exports.api = exports.reducers = exports.actions = exports.showMandatoryLoginForm = exports.showEmailVerification = exports.showForgottenPass = exports.showErrorDialog = exports.showResetPass = exports.showError = exports.checkForAccess = exports.createBarriers = exports.render = undefined;

var _actions = __webpack_require__(12);

var actions = _interopRequireWildcard(_actions);

var _reducers = __webpack_require__(117);

var reducers = _interopRequireWildcard(_reducers);

var _api = __webpack_require__(15);

var api = _interopRequireWildcard(_api);

var _helpers = __webpack_require__(124);

var _render = __webpack_require__(323);

var _render2 = _interopRequireDefault(_render);

var _analytics = __webpack_require__(51);

var _authApi = __webpack_require__(439);

var _metering = __webpack_require__(141);

var _metering2 = _interopRequireDefault(_metering);

var _constants = __webpack_require__(30);

var _MandatoryLoginOverlay = __webpack_require__(440);

var MandatoryLoginOverlay = _interopRequireWildcard(_MandatoryLoginOverlay);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var subscriptionTypes = {
    FREE: _constants.FREE,
    INSIGHTS: _constants.INSIGHTS,
    ESSENTIAL: _constants.ESSENTIAL,
    TIPPING: _constants.TIPPING,
    ULTIMATE: _constants.ULTIMATE,
    ESSENTIAL_ULTIMATE: _constants.ESSENTIAL_ULTIMATE
};

function constructGlobalAuthApi() {
    global.authApi = global.authApi || {};

    global.authApi.MandatoryLoginOverlay = MandatoryLoginOverlay;
    global.authApi.checkForAccess = _authApi.checkForAccess;
    global.authApi.showError = _authApi.showError;
    global.authApi.showForgottenPass = _authApi.showForgottenPass;
    global.authApi.showResetPass = _authApi.showResetPass;
    global.authApi.showEmailVerification = _authApi.showEmailVerification;
    global.authApi.onSignInSuccess = _analytics.onSignInSuccess;
    global.authApi.onSignUpSuccess = _analytics.onSignUpSuccess;
    global.authApi.logout = api.handleLogout;
}

constructGlobalAuthApi();

exports.render = _render2.default;
exports.createBarriers = _render.createBarriers;
exports.checkForAccess = _authApi.checkForAccess;
exports.showError = _authApi.showError;
exports.showResetPass = _authApi.showResetPass;
exports.showErrorDialog = _authApi.showErrorDialog;
exports.showForgottenPass = _authApi.showForgottenPass;
exports.showEmailVerification = _authApi.showEmailVerification;
exports.showMandatoryLoginForm = _authApi.showMandatoryLoginForm;
exports.actions = actions;
exports.reducers = reducers;
exports.api = api;
exports.dispatchSignIn = _authApi.dispatchSignIn;
exports.dispatchSignOut = _authApi.dispatchSignOut;
exports.getParams = _helpers.getParams;
exports.customMeteringRules = _metering2.default;
exports.subscriptionTypes = subscriptionTypes;
exports.getSessionStatus = _helpers.getSessionStatus;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _configProvider = __webpack_require__(93);

var _configProvider2 = _interopRequireDefault(_configProvider);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var _logIn = __webpack_require__(158);

var _logIn2 = _interopRequireDefault(_logIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
    _configProvider2.default.registerEvent(_logIn2.default);

    _configProvider2.default.registerEvent(_events.EVENT_BARRIER_SIGN_IN);

    _configProvider2.default.registerEvent(_events.EVENT_BARRIER_SUBSCRIBE);

    _configProvider2.default.registerEvent(_events.EVENT_BETTING_OFFER_CLICK, function () {
        return (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes2.default.string.isRequired);
    }, function (props) {
        return (0, _extends3.default)({}, props);
    });
};

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(145), __esModule: true };

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(146);
module.exports = __webpack_require__(17).Object.assign;


/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(26);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(149) });


/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(25) && !__webpack_require__(53)(function () {
  return Object.defineProperty(__webpack_require__(54)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(34);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(25);
var getKeys = __webpack_require__(86);
var gOPS = __webpack_require__(153);
var pIE = __webpack_require__(154);
var toObject = __webpack_require__(92);
var IObject = __webpack_require__(87);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(53)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(40);
var toIObject = __webpack_require__(55);
var arrayIndexOf = __webpack_require__(151)(false);
var IE_PROTO = __webpack_require__(58)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(55);
var toLength = __webpack_require__(88);
var toAbsoluteIndex = __webpack_require__(152);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 152 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(57);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 153 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 154 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 155 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(156), __esModule: true };

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(157);
var $Object = __webpack_require__(17).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(26);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(25), 'Object', { defineProperty: __webpack_require__(33).f });


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var _getUserPackage = __webpack_require__(42);

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    event: _events.EVENT_LOG_IN,
    validateProps: function validateProps() {
        var _ref;

        return _ref = {}, (0, _defineProperty3.default)(_ref, _traits.TRAIT_EMAIL, _propTypes2.default.string.isRequired), (0, _defineProperty3.default)(_ref, _traits.TRAIT_PACKAGE, _propTypes2.default.string), _ref;
    },
    traitsToProps: function traitsToProps(traits) {
        var _ref2;

        return _ref2 = {}, (0, _defineProperty3.default)(_ref2, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_ref2, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()), _ref2;
    }
};

/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = cleanLegacy;

var _jsCookie = __webpack_require__(28);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var legacyCookies = ['RP_PS_SESSIONID', 'RP_SP_DATA0', 'RP_SP_SESSIONID', 'RP_SS_SESSIONID', 'RP_ST_DATA0', 'RP_ST_DATA1', 'RP_ST_SESSIONID'];

var domain = window.location.hostname.split('.').slice(-2).join('.');

function cleanLegacy() {
    var cookies = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : legacyCookies;

    cookies.forEach(function (name) {
        _jsCookie2.default.remove(name);
        _jsCookie2.default.remove(name, { domain: domain });
    });
}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _qs = __webpack_require__(94);

var _qs2 = _interopRequireDefault(_qs);

var _object = __webpack_require__(161);

var _object2 = _interopRequireDefault(_object);

var _getUTMFirst = __webpack_require__(107);

var _getUTMFirst2 = _interopRequireDefault(_getUTMFirst);

var _setUTMFirst = __webpack_require__(191);

var _setUTMFirst2 = _interopRequireDefault(_setUTMFirst);

var _setUTMLast = __webpack_require__(192);

var _setUTMLast2 = _interopRequireDefault(_setUTMLast);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUTMParams(query) {
    /* eslint-disable camelcase */
    var _qs$parse = _qs2.default.parse(query),
        _qs$parse$utm_source = _qs$parse.utm_source,
        utm_source = _qs$parse$utm_source === undefined ? '' : _qs$parse$utm_source,
        _qs$parse$utm_medium = _qs$parse.utm_medium,
        utm_medium = _qs$parse$utm_medium === undefined ? '' : _qs$parse$utm_medium,
        _qs$parse$utm_campaig = _qs$parse.utm_campaign,
        utm_campaign = _qs$parse$utm_campaig === undefined ? '' : _qs$parse$utm_campaig,
        _qs$parse$utm_term = _qs$parse.utm_term,
        utm_term = _qs$parse$utm_term === undefined ? '' : _qs$parse$utm_term,
        _qs$parse$utm_content = _qs$parse.utm_content,
        utm_content = _qs$parse$utm_content === undefined ? '' : _qs$parse$utm_content;

    /* eslint-enable camelcase */


    var utmCurrent = {
        utm_source: utm_source,
        utm_medium: utm_medium,
        utm_campaign: utm_campaign,
        utm_term: utm_term,
        utm_content: utm_content
    };

    if (!Object.values) {
        _object2.default.shim();
    }

    if (Object.values(utmCurrent).some(function (value) {
        return !!value;
    })) {
        if (!(0, _getUTMFirst2.default)()) {
            (0, _setUTMFirst2.default)(utmCurrent);
        } else {
            (0, _setUTMLast2.default)(utmCurrent);
        }
    }
}

exports.default = setUTMParams;

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var define = __webpack_require__(95);
var callBind = __webpack_require__(165);

var implementation = __webpack_require__(105);
var getPolyfill = __webpack_require__(106);
var shim = __webpack_require__(190);

var polyfill = callBind(getPolyfill(), Object);

define(polyfill, {
	getPolyfill: getPolyfill,
	implementation: implementation,
	shim: shim
});

module.exports = polyfill;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var slice = Array.prototype.slice;
var isArgs = __webpack_require__(96);

var origKeys = Object.keys;
var keysShim = origKeys ? function keys(o) { return origKeys(o); } : __webpack_require__(163);

var originalKeys = Object.keys;

keysShim.shim = function shimObjectKeys() {
	if (Object.keys) {
		var keysWorksWithArguments = (function () {
			// Safari 5.0 bug
			var args = Object.keys(arguments);
			return args && args.length === arguments.length;
		}(1, 2));
		if (!keysWorksWithArguments) {
			Object.keys = function keys(object) { // eslint-disable-line func-name-matching
				if (isArgs(object)) {
					return originalKeys(slice.call(object));
				}
				return originalKeys(object);
			};
		}
	} else {
		Object.keys = keysShim;
	}
	return Object.keys || keysShim;
};

module.exports = keysShim;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var keysShim;
if (!Object.keys) {
	// modified from https://github.com/es-shims/es5-shim
	var has = Object.prototype.hasOwnProperty;
	var toStr = Object.prototype.toString;
	var isArgs = __webpack_require__(96); // eslint-disable-line global-require
	var isEnumerable = Object.prototype.propertyIsEnumerable;
	var hasDontEnumBug = !isEnumerable.call({ toString: null }, 'toString');
	var hasProtoEnumBug = isEnumerable.call(function () {}, 'prototype');
	var dontEnums = [
		'toString',
		'toLocaleString',
		'valueOf',
		'hasOwnProperty',
		'isPrototypeOf',
		'propertyIsEnumerable',
		'constructor'
	];
	var equalsConstructorPrototype = function (o) {
		var ctor = o.constructor;
		return ctor && ctor.prototype === o;
	};
	var excludedKeys = {
		$applicationCache: true,
		$console: true,
		$external: true,
		$frame: true,
		$frameElement: true,
		$frames: true,
		$innerHeight: true,
		$innerWidth: true,
		$onmozfullscreenchange: true,
		$onmozfullscreenerror: true,
		$outerHeight: true,
		$outerWidth: true,
		$pageXOffset: true,
		$pageYOffset: true,
		$parent: true,
		$scrollLeft: true,
		$scrollTop: true,
		$scrollX: true,
		$scrollY: true,
		$self: true,
		$webkitIndexedDB: true,
		$webkitStorageInfo: true,
		$window: true
	};
	var hasAutomationEqualityBug = (function () {
		/* global window */
		if (typeof window === 'undefined') { return false; }
		for (var k in window) {
			try {
				if (!excludedKeys['$' + k] && has.call(window, k) && window[k] !== null && typeof window[k] === 'object') {
					try {
						equalsConstructorPrototype(window[k]);
					} catch (e) {
						return true;
					}
				}
			} catch (e) {
				return true;
			}
		}
		return false;
	}());
	var equalsConstructorPrototypeIfNotBuggy = function (o) {
		/* global window */
		if (typeof window === 'undefined' || !hasAutomationEqualityBug) {
			return equalsConstructorPrototype(o);
		}
		try {
			return equalsConstructorPrototype(o);
		} catch (e) {
			return false;
		}
	};

	keysShim = function keys(object) {
		var isObject = object !== null && typeof object === 'object';
		var isFunction = toStr.call(object) === '[object Function]';
		var isArguments = isArgs(object);
		var isString = isObject && toStr.call(object) === '[object String]';
		var theKeys = [];

		if (!isObject && !isFunction && !isArguments) {
			throw new TypeError('Object.keys called on a non-object');
		}

		var skipProto = hasProtoEnumBug && isFunction;
		if (isString && object.length > 0 && !has.call(object, 0)) {
			for (var i = 0; i < object.length; ++i) {
				theKeys.push(String(i));
			}
		}

		if (isArguments && object.length > 0) {
			for (var j = 0; j < object.length; ++j) {
				theKeys.push(String(j));
			}
		} else {
			for (var name in object) {
				if (!(skipProto && name === 'prototype') && has.call(object, name)) {
					theKeys.push(String(name));
				}
			}
		}

		if (hasDontEnumBug) {
			var skipConstructor = equalsConstructorPrototypeIfNotBuggy(object);

			for (var k = 0; k < dontEnums.length; ++k) {
				if (!(skipConstructor && dontEnums[k] === 'constructor') && has.call(object, dontEnums[k])) {
					theKeys.push(dontEnums[k]);
				}
			}
		}
		return theKeys;
	};
}
module.exports = keysShim;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./gOPD')} */
module.exports = Object.getOwnPropertyDescriptor;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var setFunctionLength = __webpack_require__(166);

var $defineProperty = __webpack_require__(43);

var callBindBasic = __webpack_require__(60);
var applyBind = __webpack_require__(187);

module.exports = function callBind(originalFunction) {
	var func = callBindBasic(arguments);
	var adjustedLength = originalFunction.length - (arguments.length - 1);
	return setFunctionLength(
		func,
		1 + (adjustedLength > 0 ? adjustedLength : 0),
		true
	);
};

if ($defineProperty) {
	$defineProperty(module.exports, 'apply', { value: applyBind });
} else {
	module.exports.apply = applyBind;
}


/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(100);
var define = __webpack_require__(97);
var hasDescriptors = __webpack_require__(99)();
var gOPD = __webpack_require__(44);

var $TypeError = __webpack_require__(35);
var $floor = GetIntrinsic('%Math.floor%');

/** @type {import('.')} */
module.exports = function setFunctionLength(fn, length) {
	if (typeof fn !== 'function') {
		throw new $TypeError('`fn` is not a function');
	}
	if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $floor(length) !== length) {
		throw new $TypeError('`length` must be a positive 32-bit integer');
	}

	var loose = arguments.length > 2 && !!arguments[2];

	var functionLengthIsConfigurable = true;
	var functionLengthIsWritable = true;
	if ('length' in fn && gOPD) {
		var desc = gOPD(fn, 'length');
		if (desc && !desc.configurable) {
			functionLengthIsConfigurable = false;
		}
		if (desc && !desc.writable) {
			functionLengthIsWritable = false;
		}
	}

	if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
		if (hasDescriptors) {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length, true, true);
		} else {
			define(/** @type {Parameters<define>[0]} */ (fn), 'length', length);
		}
	}
	return fn;
};


/***/ }),
/* 167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('.')} */
module.exports = Error;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./eval')} */
module.exports = EvalError;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./range')} */
module.exports = RangeError;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./ref')} */
module.exports = ReferenceError;


/***/ }),
/* 171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./uri')} */
module.exports = URIError;


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./abs')} */
module.exports = Math.abs;


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./floor')} */
module.exports = Math.floor;


/***/ }),
/* 174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./max')} */
module.exports = Math.max;


/***/ }),
/* 175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./min')} */
module.exports = Math.min;


/***/ }),
/* 176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./pow')} */
module.exports = Math.pow;


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./round')} */
module.exports = Math.round;


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $isNaN = __webpack_require__(179);

/** @type {import('./sign')} */
module.exports = function sign(number) {
	if ($isNaN(number) || number === 0) {
		return number;
	}
	return number < 0 ? -1 : +1;
};


/***/ }),
/* 179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./isNaN')} */
module.exports = Number.isNaN || function isNaN(a) {
	return a !== a;
};


/***/ }),
/* 180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var origSymbol = typeof Symbol !== 'undefined' && Symbol;
var hasSymbolSham = __webpack_require__(181);

/** @type {import('.')} */
module.exports = function hasNativeSymbols() {
	if (typeof origSymbol !== 'function') { return false; }
	if (typeof Symbol !== 'function') { return false; }
	if (typeof origSymbol('foo') !== 'symbol') { return false; }
	if (typeof Symbol('bar') !== 'symbol') { return false; }

	return hasSymbolSham();
};


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./shams')} */
/* eslint complexity: [2, 18], max-statements: [2, 33] */
module.exports = function hasSymbols() {
	if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') { return false; }
	if (typeof Symbol.iterator === 'symbol') { return true; }

	/** @type {{ [k in symbol]?: unknown }} */
	var obj = {};
	var sym = Symbol('test');
	var symObj = Object(sym);
	if (typeof sym === 'string') { return false; }

	if (Object.prototype.toString.call(sym) !== '[object Symbol]') { return false; }
	if (Object.prototype.toString.call(symObj) !== '[object Symbol]') { return false; }

	// temp disabled per https://github.com/ljharb/object.assign/issues/17
	// if (sym instanceof Symbol) { return false; }
	// temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
	// if (!(symObj instanceof Symbol)) { return false; }

	// if (typeof Symbol.prototype.toString !== 'function') { return false; }
	// if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }

	var symVal = 42;
	obj[sym] = symVal;
	for (var _ in obj) { return false; } // eslint-disable-line no-restricted-syntax, no-unreachable-loop
	if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) { return false; }

	if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) { return false; }

	var syms = Object.getOwnPropertySymbols(obj);
	if (syms.length !== 1 || syms[0] !== sym) { return false; }

	if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) { return false; }

	if (typeof Object.getOwnPropertyDescriptor === 'function') {
		// eslint-disable-next-line no-extra-parens
		var descriptor = /** @type {PropertyDescriptor} */ (Object.getOwnPropertyDescriptor(obj, sym));
		if (descriptor.value !== symVal || descriptor.enumerable !== true) { return false; }
	}

	return true;
};


/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reflectGetProto = __webpack_require__(102);
var originalGetProto = __webpack_require__(103);

var getDunderProto = __webpack_require__(183);

/** @type {import('.')} */
module.exports = reflectGetProto
	? function getProto(O) {
		// @ts-expect-error TS can't narrow inside a closure, for some reason
		return reflectGetProto(O);
	}
	: originalGetProto
		? function getProto(O) {
			if (!O || (typeof O !== 'object' && typeof O !== 'function')) {
				throw new TypeError('getProto: not an object');
			}
			// @ts-expect-error TS can't narrow inside a closure, for some reason
			return originalGetProto(O);
		}
		: getDunderProto
			? function getProto(O) {
				// @ts-expect-error TS can't narrow inside a closure, for some reason
				return getDunderProto(O);
			}
			: null;


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var callBind = __webpack_require__(60);
var gOPD = __webpack_require__(44);

var hasProtoAccessor;
try {
	// eslint-disable-next-line no-extra-parens, no-proto
	hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ ([]).__proto__ === Array.prototype;
} catch (e) {
	if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') {
		throw e;
	}
}

// eslint-disable-next-line no-extra-parens
var desc = !!hasProtoAccessor && gOPD && gOPD(Object.prototype, /** @type {keyof typeof Object.prototype} */ ('__proto__'));

var $Object = Object;
var $getPrototypeOf = $Object.getPrototypeOf;

/** @type {import('./get')} */
module.exports = desc && typeof desc.get === 'function'
	? callBind([desc.get])
	: typeof $getPrototypeOf === 'function'
		? /** @type {import('./get')} */ function getDunder(value) {
			// eslint-disable-next-line eqeqeq
			return $getPrototypeOf(value == null ? value : $Object(value));
		}
		: false;


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint no-invalid-this: 1 */

var ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var toStr = Object.prototype.toString;
var max = Math.max;
var funcType = '[object Function]';

var concatty = function concatty(a, b) {
    var arr = [];

    for (var i = 0; i < a.length; i += 1) {
        arr[i] = a[i];
    }
    for (var j = 0; j < b.length; j += 1) {
        arr[j + a.length] = b[j];
    }

    return arr;
};

var slicy = function slicy(arrLike, offset) {
    var arr = [];
    for (var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1) {
        arr[j] = arrLike[i];
    }
    return arr;
};

var joiny = function (arr, joiner) {
    var str = '';
    for (var i = 0; i < arr.length; i += 1) {
        str += arr[i];
        if (i + 1 < arr.length) {
            str += joiner;
        }
    }
    return str;
};

module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || toStr.apply(target) !== funcType) {
        throw new TypeError(ERROR_MESSAGE + target);
    }
    var args = slicy(arguments, 1);

    var bound;
    var binder = function () {
        if (this instanceof bound) {
            var result = target.apply(
                this,
                concatty(args, arguments)
            );
            if (Object(result) === result) {
                return result;
            }
            return this;
        }
        return target.apply(
            that,
            concatty(args, arguments)
        );

    };

    var boundLength = max(0, target.length - args.length);
    var boundArgs = [];
    for (var i = 0; i < boundLength; i++) {
        boundArgs[i] = '$' + i;
    }

    bound = Function('binder', 'return function (' + joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);

    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }

    return bound;
};


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** @type {import('./reflectApply')} */
module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var call = Function.prototype.call;
var $hasOwn = Object.prototype.hasOwnProperty;
var bind = __webpack_require__(36);

/** @type {import('.')} */
module.exports = bind.call(call, $hasOwn);


/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(36);
var $apply = __webpack_require__(62);
var actualApply = __webpack_require__(104);

/** @type {import('./applyBind')} */
module.exports = function applyBind() {
	return actualApply(bind, $apply, arguments);
};


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $TypeError = __webpack_require__(35);

/** @type {import('./RequireObjectCoercible')} */
module.exports = function RequireObjectCoercible(value) {
	if (value == null) {
		throw new $TypeError((arguments.length > 0 && arguments[1]) || ('Cannot call method on ' + value));
	}
	return value;
};


/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var GetIntrinsic = __webpack_require__(100);

var callBindBasic = __webpack_require__(60);

/** @type {(thisArg: string, searchString: string, position?: number) => number} */
var $indexOf = callBindBasic([GetIntrinsic('%String.prototype.indexOf%')]);

/** @type {import('.')} */
module.exports = function callBoundIntrinsic(name, allowMissing) {
	/* eslint no-extra-parens: 0 */

	var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ (GetIntrinsic(name, !!allowMissing));
	if (typeof intrinsic === 'function' && $indexOf(name, '.prototype.') > -1) {
		return callBindBasic(/** @type {const} */ ([intrinsic]));
	}
	return intrinsic;
};


/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var getPolyfill = __webpack_require__(106);
var define = __webpack_require__(95);

module.exports = function shimValues() {
	var polyfill = getPolyfill();
	define(Object, { values: polyfill }, {
		values: function testValues() {
			return Object.values !== polyfill;
		}
	});
	return polyfill;
};


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(20);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUTMFirst(currentUTM) {
    _rpCookie2.default.sharedPermanent.set(_constants.COOKIE_UTM_KEY_FIRST, currentUTM);
}

exports.default = setUTMFirst;

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(20);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setUTMLast(currentUTM) {
    _rpCookie2.default.sharedPermanent.set(_constants.COOKIE_UTM_KEY_LAST, currentUTM);
}

exports.default = setUTMLast;

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable no-console */
var EVENT = 'event';
var TRAITS = 'traits';
var OPTIONS = 'options';

var previousEvents = {};

var DEFAULT_SETTINGS = exports.DEFAULT_SETTINGS = {
    alias: true,
    group: true,
    identify: true,
    track: true,
    page: true
};

function logHandler(event, properties, options) {
    console.group(EVENT, event);
    console.log(TRAITS, properties);
    console.log(OPTIONS, options);
    console.groupEnd(EVENT);
}

function enableLogging() {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_SETTINGS;

    Object.keys(previousEvents).forEach(function (event) {
        if (previousEvents[event]) {
            global.analytics.off(event, logHandler);
        }
    });
    Object.keys(events).forEach(function (event) {
        if (events[event]) {
            global.analytics.on(event, logHandler);
        }
    });
    Object.assign(previousEvents, events);
}

exports.default = enableLogging;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(18);

function enableDebug() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

    if (global.analytics) {
        if (global.analytics.debug) {
            if (key) {
                global.analytics.debug();
            } else {
                global.analytics.debug(false);
            }
        } else {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS_DEBUG);
        }
    } else {
        console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
    }
}

exports.default = enableDebug;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(20);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getUTMLast() {
    return _rpCookie2.default.sharedPermanent.get(_constants.COOKIE_UTM_KEY_LAST);
}

exports.default = getUTMLast;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBetslipId = getBetslipId;
function getBetslipId() {
    var betslipId = null;
    var betslipInfoString = window.localStorage.getItem('persist:betslip');

    if (betslipInfoString) {
        var betslipInfo = JSON.parse(betslipInfoString);
        var bookmakerInfo = JSON.parse(betslipInfo.bookmakersInfo);

        betslipId = bookmakerInfo.betslipID;
    }

    return betslipId;
}

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getDeviceType = __webpack_require__(67);

var _getDeviceType2 = _interopRequireDefault(_getDeviceType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getScreenProps = function getScreenProps() {
    return {
        device: {
            type: (0, _getDeviceType2.default)()
        },
        screen: {
            height: window.screen.height,
            width: window.screen.width,
            orientation: window.screen.orientation ? window.screen.orientation.type : null
        }
    };
};

exports.default = getScreenProps;

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

// THIS FILE IS GENERATED - DO NOT EDIT!
/*!mobile-detect v1.4.5 2021-03-13*/
/*global module:false, define:false*/
/*jshint latedef:false*/
/*!@license Copyright 2013, Heinrich Goebl, License: MIT, see https://github.com/hgoebl/mobile-detect.js*/
(function (define, undefined) {
define(function () {
    'use strict';

    var impl = {};

    impl.mobileDetectRules = {
    "phones": {
        "iPhone": "\\biPhone\\b|\\biPod\\b",
        "BlackBerry": "BlackBerry|\\bBB10\\b|rim[0-9]+|\\b(BBA100|BBB100|BBD100|BBE100|BBF100|STH100)\\b-[0-9]+",
        "Pixel": "; \\bPixel\\b",
        "HTC": "HTC|HTC.*(Sensation|Evo|Vision|Explorer|6800|8100|8900|A7272|S510e|C110e|Legend|Desire|T8282)|APX515CKT|Qtek9090|APA9292KT|HD_mini|Sensation.*Z710e|PG86100|Z715e|Desire.*(A8181|HD)|ADR6200|ADR6400L|ADR6425|001HT|Inspire 4G|Android.*\\bEVO\\b|T-Mobile G1|Z520m|Android [0-9.]+; Pixel",
        "Nexus": "Nexus One|Nexus S|Galaxy.*Nexus|Android.*Nexus.*Mobile|Nexus 4|Nexus 5|Nexus 5X|Nexus 6",
        "Dell": "Dell[;]? (Streak|Aero|Venue|Venue Pro|Flash|Smoke|Mini 3iX)|XCD28|XCD35|\\b001DL\\b|\\b101DL\\b|\\bGS01\\b",
        "Motorola": "Motorola|DROIDX|DROID BIONIC|\\bDroid\\b.*Build|Android.*Xoom|HRI39|MOT-|A1260|A1680|A555|A853|A855|A953|A955|A956|Motorola.*ELECTRIFY|Motorola.*i1|i867|i940|MB200|MB300|MB501|MB502|MB508|MB511|MB520|MB525|MB526|MB611|MB612|MB632|MB810|MB855|MB860|MB861|MB865|MB870|ME501|ME502|ME511|ME525|ME600|ME632|ME722|ME811|ME860|ME863|ME865|MT620|MT710|MT716|MT720|MT810|MT870|MT917|Motorola.*TITANIUM|WX435|WX445|XT300|XT301|XT311|XT316|XT317|XT319|XT320|XT390|XT502|XT530|XT531|XT532|XT535|XT603|XT610|XT611|XT615|XT681|XT701|XT702|XT711|XT720|XT800|XT806|XT860|XT862|XT875|XT882|XT883|XT894|XT901|XT907|XT909|XT910|XT912|XT928|XT926|XT915|XT919|XT925|XT1021|\\bMoto E\\b|XT1068|XT1092|XT1052",
        "Samsung": "\\bSamsung\\b|SM-G950F|SM-G955F|SM-G9250|GT-19300|SGH-I337|BGT-S5230|GT-B2100|GT-B2700|GT-B2710|GT-B3210|GT-B3310|GT-B3410|GT-B3730|GT-B3740|GT-B5510|GT-B5512|GT-B5722|GT-B6520|GT-B7300|GT-B7320|GT-B7330|GT-B7350|GT-B7510|GT-B7722|GT-B7800|GT-C3010|GT-C3011|GT-C3060|GT-C3200|GT-C3212|GT-C3212I|GT-C3262|GT-C3222|GT-C3300|GT-C3300K|GT-C3303|GT-C3303K|GT-C3310|GT-C3322|GT-C3330|GT-C3350|GT-C3500|GT-C3510|GT-C3530|GT-C3630|GT-C3780|GT-C5010|GT-C5212|GT-C6620|GT-C6625|GT-C6712|GT-E1050|GT-E1070|GT-E1075|GT-E1080|GT-E1081|GT-E1085|GT-E1087|GT-E1100|GT-E1107|GT-E1110|GT-E1120|GT-E1125|GT-E1130|GT-E1160|GT-E1170|GT-E1175|GT-E1180|GT-E1182|GT-E1200|GT-E1210|GT-E1225|GT-E1230|GT-E1390|GT-E2100|GT-E2120|GT-E2121|GT-E2152|GT-E2220|GT-E2222|GT-E2230|GT-E2232|GT-E2250|GT-E2370|GT-E2550|GT-E2652|GT-E3210|GT-E3213|GT-I5500|GT-I5503|GT-I5700|GT-I5800|GT-I5801|GT-I6410|GT-I6420|GT-I7110|GT-I7410|GT-I7500|GT-I8000|GT-I8150|GT-I8160|GT-I8190|GT-I8320|GT-I8330|GT-I8350|GT-I8530|GT-I8700|GT-I8703|GT-I8910|GT-I9000|GT-I9001|GT-I9003|GT-I9010|GT-I9020|GT-I9023|GT-I9070|GT-I9082|GT-I9100|GT-I9103|GT-I9220|GT-I9250|GT-I9300|GT-I9305|GT-I9500|GT-I9505|GT-M3510|GT-M5650|GT-M7500|GT-M7600|GT-M7603|GT-M8800|GT-M8910|GT-N7000|GT-S3110|GT-S3310|GT-S3350|GT-S3353|GT-S3370|GT-S3650|GT-S3653|GT-S3770|GT-S3850|GT-S5210|GT-S5220|GT-S5229|GT-S5230|GT-S5233|GT-S5250|GT-S5253|GT-S5260|GT-S5263|GT-S5270|GT-S5300|GT-S5330|GT-S5350|GT-S5360|GT-S5363|GT-S5369|GT-S5380|GT-S5380D|GT-S5560|GT-S5570|GT-S5600|GT-S5603|GT-S5610|GT-S5620|GT-S5660|GT-S5670|GT-S5690|GT-S5750|GT-S5780|GT-S5830|GT-S5839|GT-S6102|GT-S6500|GT-S7070|GT-S7200|GT-S7220|GT-S7230|GT-S7233|GT-S7250|GT-S7500|GT-S7530|GT-S7550|GT-S7562|GT-S7710|GT-S8000|GT-S8003|GT-S8500|GT-S8530|GT-S8600|SCH-A310|SCH-A530|SCH-A570|SCH-A610|SCH-A630|SCH-A650|SCH-A790|SCH-A795|SCH-A850|SCH-A870|SCH-A890|SCH-A930|SCH-A950|SCH-A970|SCH-A990|SCH-I100|SCH-I110|SCH-I400|SCH-I405|SCH-I500|SCH-I510|SCH-I515|SCH-I600|SCH-I730|SCH-I760|SCH-I770|SCH-I830|SCH-I910|SCH-I920|SCH-I959|SCH-LC11|SCH-N150|SCH-N300|SCH-R100|SCH-R300|SCH-R351|SCH-R400|SCH-R410|SCH-T300|SCH-U310|SCH-U320|SCH-U350|SCH-U360|SCH-U365|SCH-U370|SCH-U380|SCH-U410|SCH-U430|SCH-U450|SCH-U460|SCH-U470|SCH-U490|SCH-U540|SCH-U550|SCH-U620|SCH-U640|SCH-U650|SCH-U660|SCH-U700|SCH-U740|SCH-U750|SCH-U810|SCH-U820|SCH-U900|SCH-U940|SCH-U960|SCS-26UC|SGH-A107|SGH-A117|SGH-A127|SGH-A137|SGH-A157|SGH-A167|SGH-A177|SGH-A187|SGH-A197|SGH-A227|SGH-A237|SGH-A257|SGH-A437|SGH-A517|SGH-A597|SGH-A637|SGH-A657|SGH-A667|SGH-A687|SGH-A697|SGH-A707|SGH-A717|SGH-A727|SGH-A737|SGH-A747|SGH-A767|SGH-A777|SGH-A797|SGH-A817|SGH-A827|SGH-A837|SGH-A847|SGH-A867|SGH-A877|SGH-A887|SGH-A897|SGH-A927|SGH-B100|SGH-B130|SGH-B200|SGH-B220|SGH-C100|SGH-C110|SGH-C120|SGH-C130|SGH-C140|SGH-C160|SGH-C170|SGH-C180|SGH-C200|SGH-C207|SGH-C210|SGH-C225|SGH-C230|SGH-C417|SGH-C450|SGH-D307|SGH-D347|SGH-D357|SGH-D407|SGH-D415|SGH-D780|SGH-D807|SGH-D980|SGH-E105|SGH-E200|SGH-E315|SGH-E316|SGH-E317|SGH-E335|SGH-E590|SGH-E635|SGH-E715|SGH-E890|SGH-F300|SGH-F480|SGH-I200|SGH-I300|SGH-I320|SGH-I550|SGH-I577|SGH-I600|SGH-I607|SGH-I617|SGH-I627|SGH-I637|SGH-I677|SGH-I700|SGH-I717|SGH-I727|SGH-i747M|SGH-I777|SGH-I780|SGH-I827|SGH-I847|SGH-I857|SGH-I896|SGH-I897|SGH-I900|SGH-I907|SGH-I917|SGH-I927|SGH-I937|SGH-I997|SGH-J150|SGH-J200|SGH-L170|SGH-L700|SGH-M110|SGH-M150|SGH-M200|SGH-N105|SGH-N500|SGH-N600|SGH-N620|SGH-N625|SGH-N700|SGH-N710|SGH-P107|SGH-P207|SGH-P300|SGH-P310|SGH-P520|SGH-P735|SGH-P777|SGH-Q105|SGH-R210|SGH-R220|SGH-R225|SGH-S105|SGH-S307|SGH-T109|SGH-T119|SGH-T139|SGH-T209|SGH-T219|SGH-T229|SGH-T239|SGH-T249|SGH-T259|SGH-T309|SGH-T319|SGH-T329|SGH-T339|SGH-T349|SGH-T359|SGH-T369|SGH-T379|SGH-T409|SGH-T429|SGH-T439|SGH-T459|SGH-T469|SGH-T479|SGH-T499|SGH-T509|SGH-T519|SGH-T539|SGH-T559|SGH-T589|SGH-T609|SGH-T619|SGH-T629|SGH-T639|SGH-T659|SGH-T669|SGH-T679|SGH-T709|SGH-T719|SGH-T729|SGH-T739|SGH-T746|SGH-T749|SGH-T759|SGH-T769|SGH-T809|SGH-T819|SGH-T839|SGH-T919|SGH-T929|SGH-T939|SGH-T959|SGH-T989|SGH-U100|SGH-U200|SGH-U800|SGH-V205|SGH-V206|SGH-X100|SGH-X105|SGH-X120|SGH-X140|SGH-X426|SGH-X427|SGH-X475|SGH-X495|SGH-X497|SGH-X507|SGH-X600|SGH-X610|SGH-X620|SGH-X630|SGH-X700|SGH-X820|SGH-X890|SGH-Z130|SGH-Z150|SGH-Z170|SGH-ZX10|SGH-ZX20|SHW-M110|SPH-A120|SPH-A400|SPH-A420|SPH-A460|SPH-A500|SPH-A560|SPH-A600|SPH-A620|SPH-A660|SPH-A700|SPH-A740|SPH-A760|SPH-A790|SPH-A800|SPH-A820|SPH-A840|SPH-A880|SPH-A900|SPH-A940|SPH-A960|SPH-D600|SPH-D700|SPH-D710|SPH-D720|SPH-I300|SPH-I325|SPH-I330|SPH-I350|SPH-I500|SPH-I600|SPH-I700|SPH-L700|SPH-M100|SPH-M220|SPH-M240|SPH-M300|SPH-M305|SPH-M320|SPH-M330|SPH-M350|SPH-M360|SPH-M370|SPH-M380|SPH-M510|SPH-M540|SPH-M550|SPH-M560|SPH-M570|SPH-M580|SPH-M610|SPH-M620|SPH-M630|SPH-M800|SPH-M810|SPH-M850|SPH-M900|SPH-M910|SPH-M920|SPH-M930|SPH-N100|SPH-N200|SPH-N240|SPH-N300|SPH-N400|SPH-Z400|SWC-E100|SCH-i909|GT-N7100|GT-N7105|SCH-I535|SM-N900A|SGH-I317|SGH-T999L|GT-S5360B|GT-I8262|GT-S6802|GT-S6312|GT-S6310|GT-S5312|GT-S5310|GT-I9105|GT-I8510|GT-S6790N|SM-G7105|SM-N9005|GT-S5301|GT-I9295|GT-I9195|SM-C101|GT-S7392|GT-S7560|GT-B7610|GT-I5510|GT-S7582|GT-S7530E|GT-I8750|SM-G9006V|SM-G9008V|SM-G9009D|SM-G900A|SM-G900D|SM-G900F|SM-G900H|SM-G900I|SM-G900J|SM-G900K|SM-G900L|SM-G900M|SM-G900P|SM-G900R4|SM-G900S|SM-G900T|SM-G900V|SM-G900W8|SHV-E160K|SCH-P709|SCH-P729|SM-T2558|GT-I9205|SM-G9350|SM-J120F|SM-G920F|SM-G920V|SM-G930F|SM-N910C|SM-A310F|GT-I9190|SM-J500FN|SM-G903F|SM-J330F|SM-G610F|SM-G981B|SM-G892A|SM-A530F",
        "LG": "\\bLG\\b;|LG[- ]?(C800|C900|E400|E610|E900|E-900|F160|F180K|F180L|F180S|730|855|L160|LS740|LS840|LS970|LU6200|MS690|MS695|MS770|MS840|MS870|MS910|P500|P700|P705|VM696|AS680|AS695|AX840|C729|E970|GS505|272|C395|E739BK|E960|L55C|L75C|LS696|LS860|P769BK|P350|P500|P509|P870|UN272|US730|VS840|VS950|LN272|LN510|LS670|LS855|LW690|MN270|MN510|P509|P769|P930|UN200|UN270|UN510|UN610|US670|US740|US760|UX265|UX840|VN271|VN530|VS660|VS700|VS740|VS750|VS910|VS920|VS930|VX9200|VX11000|AX840A|LW770|P506|P925|P999|E612|D955|D802|MS323|M257)|LM-G710",
        "Sony": "SonyST|SonyLT|SonyEricsson|SonyEricssonLT15iv|LT18i|E10i|LT28h|LT26w|SonyEricssonMT27i|C5303|C6902|C6903|C6906|C6943|D2533|SOV34|601SO|F8332",
        "Asus": "Asus.*Galaxy|PadFone.*Mobile",
        "Xiaomi": "^(?!.*\\bx11\\b).*xiaomi.*$|POCOPHONE F1|MI 8|Redmi Note 9S|Redmi Note 5A Prime|N2G47H|M2001J2G|M2001J2I|M1805E10A|M2004J11G|M1902F1G|M2002J9G|M2004J19G|M2003J6A1G",
        "NokiaLumia": "Lumia [0-9]{3,4}",
        "Micromax": "Micromax.*\\b(A210|A92|A88|A72|A111|A110Q|A115|A116|A110|A90S|A26|A51|A35|A54|A25|A27|A89|A68|A65|A57|A90)\\b",
        "Palm": "PalmSource|Palm",
        "Vertu": "Vertu|Vertu.*Ltd|Vertu.*Ascent|Vertu.*Ayxta|Vertu.*Constellation(F|Quest)?|Vertu.*Monika|Vertu.*Signature",
        "Pantech": "PANTECH|IM-A850S|IM-A840S|IM-A830L|IM-A830K|IM-A830S|IM-A820L|IM-A810K|IM-A810S|IM-A800S|IM-T100K|IM-A725L|IM-A780L|IM-A775C|IM-A770K|IM-A760S|IM-A750K|IM-A740S|IM-A730S|IM-A720L|IM-A710K|IM-A690L|IM-A690S|IM-A650S|IM-A630K|IM-A600S|VEGA PTL21|PT003|P8010|ADR910L|P6030|P6020|P9070|P4100|P9060|P5000|CDM8992|TXT8045|ADR8995|IS11PT|P2030|P6010|P8000|PT002|IS06|CDM8999|P9050|PT001|TXT8040|P2020|P9020|P2000|P7040|P7000|C790",
        "Fly": "IQ230|IQ444|IQ450|IQ440|IQ442|IQ441|IQ245|IQ256|IQ236|IQ255|IQ235|IQ245|IQ275|IQ240|IQ285|IQ280|IQ270|IQ260|IQ250",
        "Wiko": "KITE 4G|HIGHWAY|GETAWAY|STAIRWAY|DARKSIDE|DARKFULL|DARKNIGHT|DARKMOON|SLIDE|WAX 4G|RAINBOW|BLOOM|SUNSET|GOA(?!nna)|LENNY|BARRY|IGGY|OZZY|CINK FIVE|CINK PEAX|CINK PEAX 2|CINK SLIM|CINK SLIM 2|CINK +|CINK KING|CINK PEAX|CINK SLIM|SUBLIM",
        "iMobile": "i-mobile (IQ|i-STYLE|idea|ZAA|Hitz)",
        "SimValley": "\\b(SP-80|XT-930|SX-340|XT-930|SX-310|SP-360|SP60|SPT-800|SP-120|SPT-800|SP-140|SPX-5|SPX-8|SP-100|SPX-8|SPX-12)\\b",
        "Wolfgang": "AT-B24D|AT-AS50HD|AT-AS40W|AT-AS55HD|AT-AS45q2|AT-B26D|AT-AS50Q",
        "Alcatel": "Alcatel",
        "Nintendo": "Nintendo (3DS|Switch)",
        "Amoi": "Amoi",
        "INQ": "INQ",
        "OnePlus": "ONEPLUS",
        "GenericPhone": "Tapatalk|PDA;|SAGEM|\\bmmp\\b|pocket|\\bpsp\\b|symbian|Smartphone|smartfon|treo|up.browser|up.link|vodafone|\\bwap\\b|nokia|Series40|Series60|S60|SonyEricsson|N900|MAUI.*WAP.*Browser"
    },
    "tablets": {
        "iPad": "iPad|iPad.*Mobile",
        "NexusTablet": "Android.*Nexus[\\s]+(7|9|10)",
        "GoogleTablet": "Android.*Pixel C",
        "SamsungTablet": "SAMSUNG.*Tablet|Galaxy.*Tab|SC-01C|GT-P1000|GT-P1003|GT-P1010|GT-P3105|GT-P6210|GT-P6800|GT-P6810|GT-P7100|GT-P7300|GT-P7310|GT-P7500|GT-P7510|SCH-I800|SCH-I815|SCH-I905|SGH-I957|SGH-I987|SGH-T849|SGH-T859|SGH-T869|SPH-P100|GT-P3100|GT-P3108|GT-P3110|GT-P5100|GT-P5110|GT-P6200|GT-P7320|GT-P7511|GT-N8000|GT-P8510|SGH-I497|SPH-P500|SGH-T779|SCH-I705|SCH-I915|GT-N8013|GT-P3113|GT-P5113|GT-P8110|GT-N8010|GT-N8005|GT-N8020|GT-P1013|GT-P6201|GT-P7501|GT-N5100|GT-N5105|GT-N5110|SHV-E140K|SHV-E140L|SHV-E140S|SHV-E150S|SHV-E230K|SHV-E230L|SHV-E230S|SHW-M180K|SHW-M180L|SHW-M180S|SHW-M180W|SHW-M300W|SHW-M305W|SHW-M380K|SHW-M380S|SHW-M380W|SHW-M430W|SHW-M480K|SHW-M480S|SHW-M480W|SHW-M485W|SHW-M486W|SHW-M500W|GT-I9228|SCH-P739|SCH-I925|GT-I9200|GT-P5200|GT-P5210|GT-P5210X|SM-T311|SM-T310|SM-T310X|SM-T210|SM-T210R|SM-T211|SM-P600|SM-P601|SM-P605|SM-P900|SM-P901|SM-T217|SM-T217A|SM-T217S|SM-P6000|SM-T3100|SGH-I467|XE500|SM-T110|GT-P5220|GT-I9200X|GT-N5110X|GT-N5120|SM-P905|SM-T111|SM-T2105|SM-T315|SM-T320|SM-T320X|SM-T321|SM-T520|SM-T525|SM-T530NU|SM-T230NU|SM-T330NU|SM-T900|XE500T1C|SM-P605V|SM-P905V|SM-T337V|SM-T537V|SM-T707V|SM-T807V|SM-P600X|SM-P900X|SM-T210X|SM-T230|SM-T230X|SM-T325|GT-P7503|SM-T531|SM-T330|SM-T530|SM-T705|SM-T705C|SM-T535|SM-T331|SM-T800|SM-T700|SM-T537|SM-T807|SM-P907A|SM-T337A|SM-T537A|SM-T707A|SM-T807A|SM-T237|SM-T807P|SM-P607T|SM-T217T|SM-T337T|SM-T807T|SM-T116NQ|SM-T116BU|SM-P550|SM-T350|SM-T550|SM-T9000|SM-P9000|SM-T705Y|SM-T805|GT-P3113|SM-T710|SM-T810|SM-T815|SM-T360|SM-T533|SM-T113|SM-T335|SM-T715|SM-T560|SM-T670|SM-T677|SM-T377|SM-T567|SM-T357T|SM-T555|SM-T561|SM-T713|SM-T719|SM-T813|SM-T819|SM-T580|SM-T355Y?|SM-T280|SM-T817A|SM-T820|SM-W700|SM-P580|SM-T587|SM-P350|SM-P555M|SM-P355M|SM-T113NU|SM-T815Y|SM-T585|SM-T285|SM-T825|SM-W708|SM-T835|SM-T830|SM-T837V|SM-T720|SM-T510|SM-T387V|SM-P610|SM-T290|SM-T515|SM-T590|SM-T595|SM-T725|SM-T817P|SM-P585N0|SM-T395|SM-T295|SM-T865|SM-P610N|SM-P615|SM-T970|SM-T380|SM-T5950|SM-T905|SM-T231|SM-T500|SM-T860",
        "Kindle": "Kindle|Silk.*Accelerated|Android.*\\b(KFOT|KFTT|KFJWI|KFJWA|KFOTE|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|WFJWAE|KFSAWA|KFSAWI|KFASWI|KFARWI|KFFOWI|KFGIWI|KFMEWI)\\b|Android.*Silk\/[0-9.]+ like Chrome\/[0-9.]+ (?!Mobile)",
        "SurfaceTablet": "Windows NT [0-9.]+; ARM;.*(Tablet|ARMBJS)",
        "HPTablet": "HP Slate (7|8|10)|HP ElitePad 900|hp-tablet|EliteBook.*Touch|HP 8|Slate 21|HP SlateBook 10",
        "AsusTablet": "^.*PadFone((?!Mobile).)*$|Transformer|TF101|TF101G|TF300T|TF300TG|TF300TL|TF700T|TF700KL|TF701T|TF810C|ME171|ME301T|ME302C|ME371MG|ME370T|ME372MG|ME172V|ME173X|ME400C|Slider SL101|\\bK00F\\b|\\bK00C\\b|\\bK00E\\b|\\bK00L\\b|TX201LA|ME176C|ME102A|\\bM80TA\\b|ME372CL|ME560CG|ME372CG|ME302KL| K010 | K011 | K017 | K01E |ME572C|ME103K|ME170C|ME171C|\\bME70C\\b|ME581C|ME581CL|ME8510C|ME181C|P01Y|PO1MA|P01Z|\\bP027\\b|\\bP024\\b|\\bP00C\\b",
        "BlackBerryTablet": "PlayBook|RIM Tablet",
        "HTCtablet": "HTC_Flyer_P512|HTC Flyer|HTC Jetstream|HTC-P715a|HTC EVO View 4G|PG41200|PG09410",
        "MotorolaTablet": "xoom|sholest|MZ615|MZ605|MZ505|MZ601|MZ602|MZ603|MZ604|MZ606|MZ607|MZ608|MZ609|MZ615|MZ616|MZ617",
        "NookTablet": "Android.*Nook|NookColor|nook browser|BNRV200|BNRV200A|BNTV250|BNTV250A|BNTV400|BNTV600|LogicPD Zoom2",
        "AcerTablet": "Android.*; \\b(A100|A101|A110|A200|A210|A211|A500|A501|A510|A511|A700|A701|W500|W500P|W501|W501P|W510|W511|W700|G100|G100W|B1-A71|B1-710|B1-711|A1-810|A1-811|A1-830)\\b|W3-810|\\bA3-A10\\b|\\bA3-A11\\b|\\bA3-A20\\b|\\bA3-A30|A3-A40",
        "ToshibaTablet": "Android.*(AT100|AT105|AT200|AT205|AT270|AT275|AT300|AT305|AT1S5|AT500|AT570|AT700|AT830)|TOSHIBA.*FOLIO",
        "LGTablet": "\\bL-06C|LG-V909|LG-V900|LG-V700|LG-V510|LG-V500|LG-V410|LG-V400|LG-VK810\\b",
        "FujitsuTablet": "Android.*\\b(F-01D|F-02F|F-05E|F-10D|M532|Q572)\\b",
        "PrestigioTablet": "PMP3170B|PMP3270B|PMP3470B|PMP7170B|PMP3370B|PMP3570C|PMP5870C|PMP3670B|PMP5570C|PMP5770D|PMP3970B|PMP3870C|PMP5580C|PMP5880D|PMP5780D|PMP5588C|PMP7280C|PMP7280C3G|PMP7280|PMP7880D|PMP5597D|PMP5597|PMP7100D|PER3464|PER3274|PER3574|PER3884|PER5274|PER5474|PMP5097CPRO|PMP5097|PMP7380D|PMP5297C|PMP5297C_QUAD|PMP812E|PMP812E3G|PMP812F|PMP810E|PMP880TD|PMT3017|PMT3037|PMT3047|PMT3057|PMT7008|PMT5887|PMT5001|PMT5002",
        "LenovoTablet": "Lenovo TAB|Idea(Tab|Pad)( A1|A10| K1|)|ThinkPad([ ]+)?Tablet|YT3-850M|YT3-X90L|YT3-X90F|YT3-X90X|Lenovo.*(S2109|S2110|S5000|S6000|K3011|A3000|A3500|A1000|A2107|A2109|A1107|A5500|A7600|B6000|B8000|B8080)(-|)(FL|F|HV|H|)|TB-X103F|TB-X304X|TB-X304F|TB-X304L|TB-X505F|TB-X505L|TB-X505X|TB-X605F|TB-X605L|TB-8703F|TB-8703X|TB-8703N|TB-8704N|TB-8704F|TB-8704X|TB-8704V|TB-7304F|TB-7304I|TB-7304X|Tab2A7-10F|Tab2A7-20F|TB2-X30L|YT3-X50L|YT3-X50F|YT3-X50M|YT-X705F|YT-X703F|YT-X703L|YT-X705L|YT-X705X|TB2-X30F|TB2-X30L|TB2-X30M|A2107A-F|A2107A-H|TB3-730F|TB3-730M|TB3-730X|TB-7504F|TB-7504X|TB-X704F|TB-X104F|TB3-X70F|TB-X705F|TB-8504F|TB3-X70L|TB3-710F|TB-X704L",
        "DellTablet": "Venue 11|Venue 8|Venue 7|Dell Streak 10|Dell Streak 7",
        "YarvikTablet": "Android.*\\b(TAB210|TAB211|TAB224|TAB250|TAB260|TAB264|TAB310|TAB360|TAB364|TAB410|TAB411|TAB420|TAB424|TAB450|TAB460|TAB461|TAB464|TAB465|TAB467|TAB468|TAB07-100|TAB07-101|TAB07-150|TAB07-151|TAB07-152|TAB07-200|TAB07-201-3G|TAB07-210|TAB07-211|TAB07-212|TAB07-214|TAB07-220|TAB07-400|TAB07-485|TAB08-150|TAB08-200|TAB08-201-3G|TAB08-201-30|TAB09-100|TAB09-211|TAB09-410|TAB10-150|TAB10-201|TAB10-211|TAB10-400|TAB10-410|TAB13-201|TAB274EUK|TAB275EUK|TAB374EUK|TAB462EUK|TAB474EUK|TAB9-200)\\b",
        "MedionTablet": "Android.*\\bOYO\\b|LIFE.*(P9212|P9514|P9516|S9512)|LIFETAB",
        "ArnovaTablet": "97G4|AN10G2|AN7bG3|AN7fG3|AN8G3|AN8cG3|AN7G3|AN9G3|AN7dG3|AN7dG3ST|AN7dG3ChildPad|AN10bG3|AN10bG3DT|AN9G2",
        "IntensoTablet": "INM8002KP|INM1010FP|INM805ND|Intenso Tab|TAB1004",
        "IRUTablet": "M702pro",
        "MegafonTablet": "MegaFon V9|\\bZTE V9\\b|Android.*\\bMT7A\\b",
        "EbodaTablet": "E-Boda (Supreme|Impresspeed|Izzycomm|Essential)",
        "AllViewTablet": "Allview.*(Viva|Alldro|City|Speed|All TV|Frenzy|Quasar|Shine|TX1|AX1|AX2)",
        "ArchosTablet": "\\b(101G9|80G9|A101IT)\\b|Qilive 97R|Archos5|\\bARCHOS (70|79|80|90|97|101|FAMILYPAD|)(b|c|)(G10| Cobalt| TITANIUM(HD|)| Xenon| Neon|XSK| 2| XS 2| PLATINUM| CARBON|GAMEPAD)\\b",
        "AinolTablet": "NOVO7|NOVO8|NOVO10|Novo7Aurora|Novo7Basic|NOVO7PALADIN|novo9-Spark",
        "NokiaLumiaTablet": "Lumia 2520",
        "SonyTablet": "Sony.*Tablet|Xperia Tablet|Sony Tablet S|SO-03E|SGPT12|SGPT13|SGPT114|SGPT121|SGPT122|SGPT123|SGPT111|SGPT112|SGPT113|SGPT131|SGPT132|SGPT133|SGPT211|SGPT212|SGPT213|SGP311|SGP312|SGP321|EBRD1101|EBRD1102|EBRD1201|SGP351|SGP341|SGP511|SGP512|SGP521|SGP541|SGP551|SGP621|SGP641|SGP612|SOT31|SGP771|SGP611|SGP612|SGP712",
        "PhilipsTablet": "\\b(PI2010|PI3000|PI3100|PI3105|PI3110|PI3205|PI3210|PI3900|PI4010|PI7000|PI7100)\\b",
        "CubeTablet": "Android.*(K8GT|U9GT|U10GT|U16GT|U17GT|U18GT|U19GT|U20GT|U23GT|U30GT)|CUBE U8GT",
        "CobyTablet": "MID1042|MID1045|MID1125|MID1126|MID7012|MID7014|MID7015|MID7034|MID7035|MID7036|MID7042|MID7048|MID7127|MID8042|MID8048|MID8127|MID9042|MID9740|MID9742|MID7022|MID7010",
        "MIDTablet": "M9701|M9000|M9100|M806|M1052|M806|T703|MID701|MID713|MID710|MID727|MID760|MID830|MID728|MID933|MID125|MID810|MID732|MID120|MID930|MID800|MID731|MID900|MID100|MID820|MID735|MID980|MID130|MID833|MID737|MID960|MID135|MID860|MID736|MID140|MID930|MID835|MID733|MID4X10",
        "MSITablet": "MSI \\b(Primo 73K|Primo 73L|Primo 81L|Primo 77|Primo 93|Primo 75|Primo 76|Primo 73|Primo 81|Primo 91|Primo 90|Enjoy 71|Enjoy 7|Enjoy 10)\\b",
        "SMiTTablet": "Android.*(\\bMID\\b|MID-560|MTV-T1200|MTV-PND531|MTV-P1101|MTV-PND530)",
        "RockChipTablet": "Android.*(RK2818|RK2808A|RK2918|RK3066)|RK2738|RK2808A",
        "FlyTablet": "IQ310|Fly Vision",
        "bqTablet": "Android.*(bq)?.*\\b(Elcano|Curie|Edison|Maxwell|Kepler|Pascal|Tesla|Hypatia|Platon|Newton|Livingstone|Cervantes|Avant|Aquaris ([E|M]10|M8))\\b|Maxwell.*Lite|Maxwell.*Plus",
        "HuaweiTablet": "MediaPad|MediaPad 7 Youth|IDEOS S7|S7-201c|S7-202u|S7-101|S7-103|S7-104|S7-105|S7-106|S7-201|S7-Slim|M2-A01L|BAH-L09|BAH-W09|AGS-L09|CMR-AL19",
        "NecTablet": "\\bN-06D|\\bN-08D",
        "PantechTablet": "Pantech.*P4100",
        "BronchoTablet": "Broncho.*(N701|N708|N802|a710)",
        "VersusTablet": "TOUCHPAD.*[78910]|\\bTOUCHTAB\\b",
        "ZyncTablet": "z1000|Z99 2G|z930|z990|z909|Z919|z900",
        "PositivoTablet": "TB07STA|TB10STA|TB07FTA|TB10FTA",
        "NabiTablet": "Android.*\\bNabi",
        "KoboTablet": "Kobo Touch|\\bK080\\b|\\bVox\\b Build|\\bArc\\b Build",
        "DanewTablet": "DSlide.*\\b(700|701R|702|703R|704|802|970|971|972|973|974|1010|1012)\\b",
        "TexetTablet": "NaviPad|TB-772A|TM-7045|TM-7055|TM-9750|TM-7016|TM-7024|TM-7026|TM-7041|TM-7043|TM-7047|TM-8041|TM-9741|TM-9747|TM-9748|TM-9751|TM-7022|TM-7021|TM-7020|TM-7011|TM-7010|TM-7023|TM-7025|TM-7037W|TM-7038W|TM-7027W|TM-9720|TM-9725|TM-9737W|TM-1020|TM-9738W|TM-9740|TM-9743W|TB-807A|TB-771A|TB-727A|TB-725A|TB-719A|TB-823A|TB-805A|TB-723A|TB-715A|TB-707A|TB-705A|TB-709A|TB-711A|TB-890HD|TB-880HD|TB-790HD|TB-780HD|TB-770HD|TB-721HD|TB-710HD|TB-434HD|TB-860HD|TB-840HD|TB-760HD|TB-750HD|TB-740HD|TB-730HD|TB-722HD|TB-720HD|TB-700HD|TB-500HD|TB-470HD|TB-431HD|TB-430HD|TB-506|TB-504|TB-446|TB-436|TB-416|TB-146SE|TB-126SE",
        "PlaystationTablet": "Playstation.*(Portable|Vita)",
        "TrekstorTablet": "ST10416-1|VT10416-1|ST70408-1|ST702xx-1|ST702xx-2|ST80208|ST97216|ST70104-2|VT10416-2|ST10216-2A|SurfTab",
        "PyleAudioTablet": "\\b(PTBL10CEU|PTBL10C|PTBL72BC|PTBL72BCEU|PTBL7CEU|PTBL7C|PTBL92BC|PTBL92BCEU|PTBL9CEU|PTBL9CUK|PTBL9C)\\b",
        "AdvanTablet": "Android.* \\b(E3A|T3X|T5C|T5B|T3E|T3C|T3B|T1J|T1F|T2A|T1H|T1i|E1C|T1-E|T5-A|T4|E1-B|T2Ci|T1-B|T1-D|O1-A|E1-A|T1-A|T3A|T4i)\\b ",
        "DanyTechTablet": "Genius Tab G3|Genius Tab S2|Genius Tab Q3|Genius Tab G4|Genius Tab Q4|Genius Tab G-II|Genius TAB GII|Genius TAB GIII|Genius Tab S1",
        "GalapadTablet": "Android [0-9.]+; [a-z-]+; \\bG1\\b",
        "MicromaxTablet": "Funbook|Micromax.*\\b(P250|P560|P360|P362|P600|P300|P350|P500|P275)\\b",
        "KarbonnTablet": "Android.*\\b(A39|A37|A34|ST8|ST10|ST7|Smart Tab3|Smart Tab2)\\b",
        "AllFineTablet": "Fine7 Genius|Fine7 Shine|Fine7 Air|Fine8 Style|Fine9 More|Fine10 Joy|Fine11 Wide",
        "PROSCANTablet": "\\b(PEM63|PLT1023G|PLT1041|PLT1044|PLT1044G|PLT1091|PLT4311|PLT4311PL|PLT4315|PLT7030|PLT7033|PLT7033D|PLT7035|PLT7035D|PLT7044K|PLT7045K|PLT7045KB|PLT7071KG|PLT7072|PLT7223G|PLT7225G|PLT7777G|PLT7810K|PLT7849G|PLT7851G|PLT7852G|PLT8015|PLT8031|PLT8034|PLT8036|PLT8080K|PLT8082|PLT8088|PLT8223G|PLT8234G|PLT8235G|PLT8816K|PLT9011|PLT9045K|PLT9233G|PLT9735|PLT9760G|PLT9770G)\\b",
        "YONESTablet": "BQ1078|BC1003|BC1077|RK9702|BC9730|BC9001|IT9001|BC7008|BC7010|BC708|BC728|BC7012|BC7030|BC7027|BC7026",
        "ChangJiaTablet": "TPC7102|TPC7103|TPC7105|TPC7106|TPC7107|TPC7201|TPC7203|TPC7205|TPC7210|TPC7708|TPC7709|TPC7712|TPC7110|TPC8101|TPC8103|TPC8105|TPC8106|TPC8203|TPC8205|TPC8503|TPC9106|TPC9701|TPC97101|TPC97103|TPC97105|TPC97106|TPC97111|TPC97113|TPC97203|TPC97603|TPC97809|TPC97205|TPC10101|TPC10103|TPC10106|TPC10111|TPC10203|TPC10205|TPC10503",
        "GUTablet": "TX-A1301|TX-M9002|Q702|kf026",
        "PointOfViewTablet": "TAB-P506|TAB-navi-7-3G-M|TAB-P517|TAB-P-527|TAB-P701|TAB-P703|TAB-P721|TAB-P731N|TAB-P741|TAB-P825|TAB-P905|TAB-P925|TAB-PR945|TAB-PL1015|TAB-P1025|TAB-PI1045|TAB-P1325|TAB-PROTAB[0-9]+|TAB-PROTAB25|TAB-PROTAB26|TAB-PROTAB27|TAB-PROTAB26XL|TAB-PROTAB2-IPS9|TAB-PROTAB30-IPS9|TAB-PROTAB25XXL|TAB-PROTAB26-IPS10|TAB-PROTAB30-IPS10",
        "OvermaxTablet": "OV-(SteelCore|NewBase|Basecore|Baseone|Exellen|Quattor|EduTab|Solution|ACTION|BasicTab|TeddyTab|MagicTab|Stream|TB-08|TB-09)|Qualcore 1027",
        "HCLTablet": "HCL.*Tablet|Connect-3G-2.0|Connect-2G-2.0|ME Tablet U1|ME Tablet U2|ME Tablet G1|ME Tablet X1|ME Tablet Y2|ME Tablet Sync",
        "DPSTablet": "DPS Dream 9|DPS Dual 7",
        "VistureTablet": "V97 HD|i75 3G|Visture V4( HD)?|Visture V5( HD)?|Visture V10",
        "CrestaTablet": "CTP(-)?810|CTP(-)?818|CTP(-)?828|CTP(-)?838|CTP(-)?888|CTP(-)?978|CTP(-)?980|CTP(-)?987|CTP(-)?988|CTP(-)?989",
        "MediatekTablet": "\\bMT8125|MT8389|MT8135|MT8377\\b",
        "ConcordeTablet": "Concorde([ ]+)?Tab|ConCorde ReadMan",
        "GoCleverTablet": "GOCLEVER TAB|A7GOCLEVER|M1042|M7841|M742|R1042BK|R1041|TAB A975|TAB A7842|TAB A741|TAB A741L|TAB M723G|TAB M721|TAB A1021|TAB I921|TAB R721|TAB I720|TAB T76|TAB R70|TAB R76.2|TAB R106|TAB R83.2|TAB M813G|TAB I721|GCTA722|TAB I70|TAB I71|TAB S73|TAB R73|TAB R74|TAB R93|TAB R75|TAB R76.1|TAB A73|TAB A93|TAB A93.2|TAB T72|TAB R83|TAB R974|TAB R973|TAB A101|TAB A103|TAB A104|TAB A104.2|R105BK|M713G|A972BK|TAB A971|TAB R974.2|TAB R104|TAB R83.3|TAB A1042",
        "ModecomTablet": "FreeTAB 9000|FreeTAB 7.4|FreeTAB 7004|FreeTAB 7800|FreeTAB 2096|FreeTAB 7.5|FreeTAB 1014|FreeTAB 1001 |FreeTAB 8001|FreeTAB 9706|FreeTAB 9702|FreeTAB 7003|FreeTAB 7002|FreeTAB 1002|FreeTAB 7801|FreeTAB 1331|FreeTAB 1004|FreeTAB 8002|FreeTAB 8014|FreeTAB 9704|FreeTAB 1003",
        "VoninoTablet": "\\b(Argus[ _]?S|Diamond[ _]?79HD|Emerald[ _]?78E|Luna[ _]?70C|Onyx[ _]?S|Onyx[ _]?Z|Orin[ _]?HD|Orin[ _]?S|Otis[ _]?S|SpeedStar[ _]?S|Magnet[ _]?M9|Primus[ _]?94[ _]?3G|Primus[ _]?94HD|Primus[ _]?QS|Android.*\\bQ8\\b|Sirius[ _]?EVO[ _]?QS|Sirius[ _]?QS|Spirit[ _]?S)\\b",
        "ECSTablet": "V07OT2|TM105A|S10OT1|TR10CS1",
        "StorexTablet": "eZee[_']?(Tab|Go)[0-9]+|TabLC7|Looney Tunes Tab",
        "VodafoneTablet": "SmartTab([ ]+)?[0-9]+|SmartTabII10|SmartTabII7|VF-1497|VFD 1400",
        "EssentielBTablet": "Smart[ ']?TAB[ ]+?[0-9]+|Family[ ']?TAB2",
        "RossMoorTablet": "RM-790|RM-997|RMD-878G|RMD-974R|RMT-705A|RMT-701|RME-601|RMT-501|RMT-711",
        "iMobileTablet": "i-mobile i-note",
        "TolinoTablet": "tolino tab [0-9.]+|tolino shine",
        "AudioSonicTablet": "\\bC-22Q|T7-QC|T-17B|T-17P\\b",
        "AMPETablet": "Android.* A78 ",
        "SkkTablet": "Android.* (SKYPAD|PHOENIX|CYCLOPS)",
        "TecnoTablet": "TECNO P9|TECNO DP8D",
        "JXDTablet": "Android.* \\b(F3000|A3300|JXD5000|JXD3000|JXD2000|JXD300B|JXD300|S5800|S7800|S602b|S5110b|S7300|S5300|S602|S603|S5100|S5110|S601|S7100a|P3000F|P3000s|P101|P200s|P1000m|P200m|P9100|P1000s|S6600b|S908|P1000|P300|S18|S6600|S9100)\\b",
        "iJoyTablet": "Tablet (Spirit 7|Essentia|Galatea|Fusion|Onix 7|Landa|Titan|Scooby|Deox|Stella|Themis|Argon|Unique 7|Sygnus|Hexen|Finity 7|Cream|Cream X2|Jade|Neon 7|Neron 7|Kandy|Scape|Saphyr 7|Rebel|Biox|Rebel|Rebel 8GB|Myst|Draco 7|Myst|Tab7-004|Myst|Tadeo Jones|Tablet Boing|Arrow|Draco Dual Cam|Aurix|Mint|Amity|Revolution|Finity 9|Neon 9|T9w|Amity 4GB Dual Cam|Stone 4GB|Stone 8GB|Andromeda|Silken|X2|Andromeda II|Halley|Flame|Saphyr 9,7|Touch 8|Planet|Triton|Unique 10|Hexen 10|Memphis 4GB|Memphis 8GB|Onix 10)",
        "FX2Tablet": "FX2 PAD7|FX2 PAD10",
        "XoroTablet": "KidsPAD 701|PAD[ ]?712|PAD[ ]?714|PAD[ ]?716|PAD[ ]?717|PAD[ ]?718|PAD[ ]?720|PAD[ ]?721|PAD[ ]?722|PAD[ ]?790|PAD[ ]?792|PAD[ ]?900|PAD[ ]?9715D|PAD[ ]?9716DR|PAD[ ]?9718DR|PAD[ ]?9719QR|PAD[ ]?9720QR|TelePAD1030|Telepad1032|TelePAD730|TelePAD731|TelePAD732|TelePAD735Q|TelePAD830|TelePAD9730|TelePAD795|MegaPAD 1331|MegaPAD 1851|MegaPAD 2151",
        "ViewsonicTablet": "ViewPad 10pi|ViewPad 10e|ViewPad 10s|ViewPad E72|ViewPad7|ViewPad E100|ViewPad 7e|ViewSonic VB733|VB100a",
        "VerizonTablet": "QTAQZ3|QTAIR7|QTAQTZ3|QTASUN1|QTASUN2|QTAXIA1",
        "OdysTablet": "LOOX|XENO10|ODYS[ -](Space|EVO|Xpress|NOON)|\\bXELIO\\b|Xelio10Pro|XELIO7PHONETAB|XELIO10EXTREME|XELIOPT2|NEO_QUAD10",
        "CaptivaTablet": "CAPTIVA PAD",
        "IconbitTablet": "NetTAB|NT-3702|NT-3702S|NT-3702S|NT-3603P|NT-3603P|NT-0704S|NT-0704S|NT-3805C|NT-3805C|NT-0806C|NT-0806C|NT-0909T|NT-0909T|NT-0907S|NT-0907S|NT-0902S|NT-0902S",
        "TeclastTablet": "T98 4G|\\bP80\\b|\\bX90HD\\b|X98 Air|X98 Air 3G|\\bX89\\b|P80 3G|\\bX80h\\b|P98 Air|\\bX89HD\\b|P98 3G|\\bP90HD\\b|P89 3G|X98 3G|\\bP70h\\b|P79HD 3G|G18d 3G|\\bP79HD\\b|\\bP89s\\b|\\bA88\\b|\\bP10HD\\b|\\bP19HD\\b|G18 3G|\\bP78HD\\b|\\bA78\\b|\\bP75\\b|G17s 3G|G17h 3G|\\bP85t\\b|\\bP90\\b|\\bP11\\b|\\bP98t\\b|\\bP98HD\\b|\\bG18d\\b|\\bP85s\\b|\\bP11HD\\b|\\bP88s\\b|\\bA80HD\\b|\\bA80se\\b|\\bA10h\\b|\\bP89\\b|\\bP78s\\b|\\bG18\\b|\\bP85\\b|\\bA70h\\b|\\bA70\\b|\\bG17\\b|\\bP18\\b|\\bA80s\\b|\\bA11s\\b|\\bP88HD\\b|\\bA80h\\b|\\bP76s\\b|\\bP76h\\b|\\bP98\\b|\\bA10HD\\b|\\bP78\\b|\\bP88\\b|\\bA11\\b|\\bA10t\\b|\\bP76a\\b|\\bP76t\\b|\\bP76e\\b|\\bP85HD\\b|\\bP85a\\b|\\bP86\\b|\\bP75HD\\b|\\bP76v\\b|\\bA12\\b|\\bP75a\\b|\\bA15\\b|\\bP76Ti\\b|\\bP81HD\\b|\\bA10\\b|\\bT760VE\\b|\\bT720HD\\b|\\bP76\\b|\\bP73\\b|\\bP71\\b|\\bP72\\b|\\bT720SE\\b|\\bC520Ti\\b|\\bT760\\b|\\bT720VE\\b|T720-3GE|T720-WiFi",
        "OndaTablet": "\\b(V975i|Vi30|VX530|V701|Vi60|V701s|Vi50|V801s|V719|Vx610w|VX610W|V819i|Vi10|VX580W|Vi10|V711s|V813|V811|V820w|V820|Vi20|V711|VI30W|V712|V891w|V972|V819w|V820w|Vi60|V820w|V711|V813s|V801|V819|V975s|V801|V819|V819|V818|V811|V712|V975m|V101w|V961w|V812|V818|V971|V971s|V919|V989|V116w|V102w|V973|Vi40)\\b[\\s]+|V10 \\b4G\\b",
        "JaytechTablet": "TPC-PA762",
        "BlaupunktTablet": "Endeavour 800NG|Endeavour 1010",
        "DigmaTablet": "\\b(iDx10|iDx9|iDx8|iDx7|iDxD7|iDxD8|iDsQ8|iDsQ7|iDsQ8|iDsD10|iDnD7|3TS804H|iDsQ11|iDj7|iDs10)\\b",
        "EvolioTablet": "ARIA_Mini_wifi|Aria[ _]Mini|Evolio X10|Evolio X7|Evolio X8|\\bEvotab\\b|\\bNeura\\b",
        "LavaTablet": "QPAD E704|\\bIvoryS\\b|E-TAB IVORY|\\bE-TAB\\b",
        "AocTablet": "MW0811|MW0812|MW0922|MTK8382|MW1031|MW0831|MW0821|MW0931|MW0712",
        "MpmanTablet": "MP11 OCTA|MP10 OCTA|MPQC1114|MPQC1004|MPQC994|MPQC974|MPQC973|MPQC804|MPQC784|MPQC780|\\bMPG7\\b|MPDCG75|MPDCG71|MPDC1006|MP101DC|MPDC9000|MPDC905|MPDC706HD|MPDC706|MPDC705|MPDC110|MPDC100|MPDC99|MPDC97|MPDC88|MPDC8|MPDC77|MP709|MID701|MID711|MID170|MPDC703|MPQC1010",
        "CelkonTablet": "CT695|CT888|CT[\\s]?910|CT7 Tab|CT9 Tab|CT3 Tab|CT2 Tab|CT1 Tab|C820|C720|\\bCT-1\\b",
        "WolderTablet": "miTab \\b(DIAMOND|SPACE|BROOKLYN|NEO|FLY|MANHATTAN|FUNK|EVOLUTION|SKY|GOCAR|IRON|GENIUS|POP|MINT|EPSILON|BROADWAY|JUMP|HOP|LEGEND|NEW AGE|LINE|ADVANCE|FEEL|FOLLOW|LIKE|LINK|LIVE|THINK|FREEDOM|CHICAGO|CLEVELAND|BALTIMORE-GH|IOWA|BOSTON|SEATTLE|PHOENIX|DALLAS|IN 101|MasterChef)\\b",
        "MediacomTablet": "M-MPI10C3G|M-SP10EG|M-SP10EGP|M-SP10HXAH|M-SP7HXAH|M-SP10HXBH|M-SP8HXAH|M-SP8MXA",
        "MiTablet": "\\bMI PAD\\b|\\bHM NOTE 1W\\b",
        "NibiruTablet": "Nibiru M1|Nibiru Jupiter One",
        "NexoTablet": "NEXO NOVA|NEXO 10|NEXO AVIO|NEXO FREE|NEXO GO|NEXO EVO|NEXO 3G|NEXO SMART|NEXO KIDDO|NEXO MOBI",
        "LeaderTablet": "TBLT10Q|TBLT10I|TBL-10WDKB|TBL-10WDKBO2013|TBL-W230V2|TBL-W450|TBL-W500|SV572|TBLT7I|TBA-AC7-8G|TBLT79|TBL-8W16|TBL-10W32|TBL-10WKB|TBL-W100",
        "UbislateTablet": "UbiSlate[\\s]?7C",
        "PocketBookTablet": "Pocketbook",
        "KocasoTablet": "\\b(TB-1207)\\b",
        "HisenseTablet": "\\b(F5281|E2371)\\b",
        "Hudl": "Hudl HT7S3|Hudl 2",
        "TelstraTablet": "T-Hub2",
        "GenericTablet": "Android.*\\b97D\\b|Tablet(?!.*PC)|BNTV250A|MID-WCDMA|LogicPD Zoom2|\\bA7EB\\b|CatNova8|A1_07|CT704|CT1002|\\bM721\\b|rk30sdk|\\bEVOTAB\\b|M758A|ET904|ALUMIUM10|Smartfren Tab|Endeavour 1010|Tablet-PC-4|Tagi Tab|\\bM6pro\\b|CT1020W|arc 10HD|\\bTP750\\b|\\bQTAQZ3\\b|WVT101|TM1088|KT107"
    },
    "oss": {
        "AndroidOS": "Android",
        "BlackBerryOS": "blackberry|\\bBB10\\b|rim tablet os",
        "PalmOS": "PalmOS|avantgo|blazer|elaine|hiptop|palm|plucker|xiino",
        "SymbianOS": "Symbian|SymbOS|Series60|Series40|SYB-[0-9]+|\\bS60\\b",
        "WindowsMobileOS": "Windows CE.*(PPC|Smartphone|Mobile|[0-9]{3}x[0-9]{3})|Windows Mobile|Windows Phone [0-9.]+|WCE;",
        "WindowsPhoneOS": "Windows Phone 10.0|Windows Phone 8.1|Windows Phone 8.0|Windows Phone OS|XBLWP7|ZuneWP7|Windows NT 6.[23]; ARM;",
        "iOS": "\\biPhone.*Mobile|\\biPod|\\biPad|AppleCoreMedia",
        "iPadOS": "CPU OS 13",
        "SailfishOS": "Sailfish",
        "MeeGoOS": "MeeGo",
        "MaemoOS": "Maemo",
        "JavaOS": "J2ME\/|\\bMIDP\\b|\\bCLDC\\b",
        "webOS": "webOS|hpwOS",
        "badaOS": "\\bBada\\b",
        "BREWOS": "BREW"
    },
    "uas": {
        "Chrome": "\\bCrMo\\b|CriOS|Android.*Chrome\/[.0-9]* (Mobile)?",
        "Dolfin": "\\bDolfin\\b",
        "Opera": "Opera.*Mini|Opera.*Mobi|Android.*Opera|Mobile.*OPR\/[0-9.]+$|Coast\/[0-9.]+",
        "Skyfire": "Skyfire",
        "Edge": "\\bEdgiOS\\b|Mobile Safari\/[.0-9]* Edge",
        "IE": "IEMobile|MSIEMobile",
        "Firefox": "fennec|firefox.*maemo|(Mobile|Tablet).*Firefox|Firefox.*Mobile|FxiOS",
        "Bolt": "bolt",
        "TeaShark": "teashark",
        "Blazer": "Blazer",
        "Safari": "Version((?!\\bEdgiOS\\b).)*Mobile.*Safari|Safari.*Mobile|MobileSafari",
        "WeChat": "\\bMicroMessenger\\b",
        "UCBrowser": "UC.*Browser|UCWEB",
        "baiduboxapp": "baiduboxapp",
        "baidubrowser": "baidubrowser",
        "DiigoBrowser": "DiigoBrowser",
        "Mercury": "\\bMercury\\b",
        "ObigoBrowser": "Obigo",
        "NetFront": "NF-Browser",
        "GenericBrowser": "NokiaBrowser|OviBrowser|OneBrowser|TwonkyBeamBrowser|SEMC.*Browser|FlyFlow|Minimo|NetFront|Novarra-Vision|MQQBrowser|MicroMessenger",
        "PaleMoon": "Android.*PaleMoon|Mobile.*PaleMoon"
    },
    "props": {
        "Mobile": "Mobile\/[VER]",
        "Build": "Build\/[VER]",
        "Version": "Version\/[VER]",
        "VendorID": "VendorID\/[VER]",
        "iPad": "iPad.*CPU[a-z ]+[VER]",
        "iPhone": "iPhone.*CPU[a-z ]+[VER]",
        "iPod": "iPod.*CPU[a-z ]+[VER]",
        "Kindle": "Kindle\/[VER]",
        "Chrome": [
            "Chrome\/[VER]",
            "CriOS\/[VER]",
            "CrMo\/[VER]"
        ],
        "Coast": [
            "Coast\/[VER]"
        ],
        "Dolfin": "Dolfin\/[VER]",
        "Firefox": [
            "Firefox\/[VER]",
            "FxiOS\/[VER]"
        ],
        "Fennec": "Fennec\/[VER]",
        "Edge": "Edge\/[VER]",
        "IE": [
            "IEMobile\/[VER];",
            "IEMobile [VER]",
            "MSIE [VER];",
            "Trident\/[0-9.]+;.*rv:[VER]"
        ],
        "NetFront": "NetFront\/[VER]",
        "NokiaBrowser": "NokiaBrowser\/[VER]",
        "Opera": [
            " OPR\/[VER]",
            "Opera Mini\/[VER]",
            "Version\/[VER]"
        ],
        "Opera Mini": "Opera Mini\/[VER]",
        "Opera Mobi": "Version\/[VER]",
        "UCBrowser": [
            "UCWEB[VER]",
            "UC.*Browser\/[VER]"
        ],
        "MQQBrowser": "MQQBrowser\/[VER]",
        "MicroMessenger": "MicroMessenger\/[VER]",
        "baiduboxapp": "baiduboxapp\/[VER]",
        "baidubrowser": "baidubrowser\/[VER]",
        "SamsungBrowser": "SamsungBrowser\/[VER]",
        "Iron": "Iron\/[VER]",
        "Safari": [
            "Version\/[VER]",
            "Safari\/[VER]"
        ],
        "Skyfire": "Skyfire\/[VER]",
        "Tizen": "Tizen\/[VER]",
        "Webkit": "webkit[ \/][VER]",
        "PaleMoon": "PaleMoon\/[VER]",
        "SailfishBrowser": "SailfishBrowser\/[VER]",
        "Gecko": "Gecko\/[VER]",
        "Trident": "Trident\/[VER]",
        "Presto": "Presto\/[VER]",
        "Goanna": "Goanna\/[VER]",
        "iOS": " \\bi?OS\\b [VER][ ;]{1}",
        "Android": "Android [VER]",
        "Sailfish": "Sailfish [VER]",
        "BlackBerry": [
            "BlackBerry[\\w]+\/[VER]",
            "BlackBerry.*Version\/[VER]",
            "Version\/[VER]"
        ],
        "BREW": "BREW [VER]",
        "Java": "Java\/[VER]",
        "Windows Phone OS": [
            "Windows Phone OS [VER]",
            "Windows Phone [VER]"
        ],
        "Windows Phone": "Windows Phone [VER]",
        "Windows CE": "Windows CE\/[VER]",
        "Windows NT": "Windows NT [VER]",
        "Symbian": [
            "SymbianOS\/[VER]",
            "Symbian\/[VER]"
        ],
        "webOS": [
            "webOS\/[VER]",
            "hpwOS\/[VER];"
        ]
    },
    "utils": {
        "Bot": "Googlebot|facebookexternalhit|Google-AMPHTML|s~amp-validator|AdsBot-Google|Google Keyword Suggestion|Facebot|YandexBot|YandexMobileBot|bingbot|ia_archiver|AhrefsBot|Ezooms|GSLFbot|WBSearchBot|Twitterbot|TweetmemeBot|Twikle|PaperLiBot|Wotbox|UnwindFetchor|Exabot|MJ12bot|YandexImages|TurnitinBot|Pingdom|contentkingapp|AspiegelBot",
        "MobileBot": "Googlebot-Mobile|AdsBot-Google-Mobile|YahooSeeker\/M1A1-R2D2",
        "DesktopMode": "WPDesktop",
        "TV": "SonyDTV|HbbTV",
        "WebKit": "(webkit)[ \/]([\\w.]+)",
        "Console": "\\b(Nintendo|Nintendo WiiU|Nintendo 3DS|Nintendo Switch|PLAYSTATION|Xbox)\\b",
        "Watch": "SM-V700"
    }
};

    // following patterns come from http://detectmobilebrowsers.com/
    impl.detectMobileBrowsers = {
        fullPattern: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
        shortPattern: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,
        tabletPattern: /android|ipad|playbook|silk/i
    };

    var hasOwnProp = Object.prototype.hasOwnProperty,
        isArray;

    impl.FALLBACK_PHONE = 'UnknownPhone';
    impl.FALLBACK_TABLET = 'UnknownTablet';
    impl.FALLBACK_MOBILE = 'UnknownMobile';

    isArray = ('isArray' in Array) ?
        Array.isArray : function (value) { return Object.prototype.toString.call(value) === '[object Array]'; };

    function equalIC(a, b) {
        return a != null && b != null && a.toLowerCase() === b.toLowerCase();
    }

    function containsIC(array, value) {
        var valueLC, i, len = array.length;
        if (!len || !value) {
            return false;
        }
        valueLC = value.toLowerCase();
        for (i = 0; i < len; ++i) {
            if (valueLC === array[i].toLowerCase()) {
                return true;
            }
        }
        return false;
    }

    function convertPropsToRegExp(object) {
        for (var key in object) {
            if (hasOwnProp.call(object, key)) {
                object[key] = new RegExp(object[key], 'i');
            }
        }
    }

    function prepareUserAgent(userAgent) {
        return (userAgent || '').substr(0, 500); // mitigate vulnerable to ReDoS
    }

    (function init() {
        var key, values, value, i, len, verPos, mobileDetectRules = impl.mobileDetectRules;
        for (key in mobileDetectRules.props) {
            if (hasOwnProp.call(mobileDetectRules.props, key)) {
                values = mobileDetectRules.props[key];
                if (!isArray(values)) {
                    values = [values];
                }
                len = values.length;
                for (i = 0; i < len; ++i) {
                    value = values[i];
                    verPos = value.indexOf('[VER]');
                    if (verPos >= 0) {
                        value = value.substring(0, verPos) + '([\\w._\\+]+)' + value.substring(verPos + 5);
                    }
                    values[i] = new RegExp(value, 'i');
                }
                mobileDetectRules.props[key] = values;
            }
        }
        convertPropsToRegExp(mobileDetectRules.oss);
        convertPropsToRegExp(mobileDetectRules.phones);
        convertPropsToRegExp(mobileDetectRules.tablets);
        convertPropsToRegExp(mobileDetectRules.uas);
        convertPropsToRegExp(mobileDetectRules.utils);

        // copy some patterns to oss0 which are tested first (see issue#15)
        mobileDetectRules.oss0 = {
            WindowsPhoneOS: mobileDetectRules.oss.WindowsPhoneOS,
            WindowsMobileOS: mobileDetectRules.oss.WindowsMobileOS
        };
    }());

    /**
     * Test userAgent string against a set of rules and find the first matched key.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {String|null} the matched key if found, otherwise <tt>null</tt>
     * @private
     */
    impl.findMatch = function(rules, userAgent) {
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    return key;
                }
            }
        }
        return null;
    };

    /**
     * Test userAgent string against a set of rules and return an array of matched keys.
     * @param {Object} rules (key is String, value is RegExp)
     * @param {String} userAgent the navigator.userAgent (or HTTP-Header 'User-Agent').
     * @returns {Array} an array of matched keys, may be empty when there is no match, but not <tt>null</tt>
     * @private
     */
    impl.findMatches = function(rules, userAgent) {
        var result = [];
        for (var key in rules) {
            if (hasOwnProp.call(rules, key)) {
                if (rules[key].test(userAgent)) {
                    result.push(key);
                }
            }
        }
        return result;
    };

    /**
     * Check the version of the given property in the User-Agent.
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {String} version or <tt>null</tt> if version not found
     * @private
     */
    impl.getVersionStr = function (propertyName, userAgent) {
        var props = impl.mobileDetectRules.props, patterns, i, len, match;
        if (hasOwnProp.call(props, propertyName)) {
            patterns = props[propertyName];
            len = patterns.length;
            for (i = 0; i < len; ++i) {
                match = patterns[i].exec(userAgent);
                if (match !== null) {
                    return match[1];
                }
            }
        }
        return null;
    };

    /**
     * Check the version of the given property in the User-Agent.
     * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
     *
     * @param {String} propertyName
     * @param {String} userAgent
     * @return {Number} version or <tt>NaN</tt> if version not found
     * @private
     */
    impl.getVersion = function (propertyName, userAgent) {
        var version = impl.getVersionStr(propertyName, userAgent);
        return version ? impl.prepareVersionNo(version) : NaN;
    };

    /**
     * Prepare the version number.
     *
     * @param {String} version
     * @return {Number} the version number as a floating number
     * @private
     */
    impl.prepareVersionNo = function (version) {
        var numbers;

        numbers = version.split(/[a-z._ \/\-]/i);
        if (numbers.length === 1) {
            version = numbers[0];
        }
        if (numbers.length > 1) {
            version = numbers[0] + '.';
            numbers.shift();
            version += numbers.join('');
        }
        return Number(version);
    };

    impl.isMobileFallback = function (userAgent) {
        return impl.detectMobileBrowsers.fullPattern.test(userAgent) ||
            impl.detectMobileBrowsers.shortPattern.test(userAgent.substr(0,4));
    };

    impl.isTabletFallback = function (userAgent) {
        return impl.detectMobileBrowsers.tabletPattern.test(userAgent);
    };

    impl.prepareDetectionCache = function (cache, userAgent, maxPhoneWidth) {
        if (cache.mobile !== undefined) {
            return;
        }
        var phone, tablet, phoneSized;

        // first check for stronger tablet rules, then phone (see issue#5)
        tablet = impl.findMatch(impl.mobileDetectRules.tablets, userAgent);
        if (tablet) {
            cache.mobile = cache.tablet = tablet;
            cache.phone = null;
            return; // unambiguously identified as tablet
        }

        phone = impl.findMatch(impl.mobileDetectRules.phones, userAgent);
        if (phone) {
            cache.mobile = cache.phone = phone;
            cache.tablet = null;
            return; // unambiguously identified as phone
        }

        // our rules haven't found a match -> try more general fallback rules
        if (impl.isMobileFallback(userAgent)) {
            phoneSized = MobileDetect.isPhoneSized(maxPhoneWidth);
            if (phoneSized === undefined) {
                cache.mobile = impl.FALLBACK_MOBILE;
                cache.tablet = cache.phone = null;
            } else if (phoneSized) {
                cache.mobile = cache.phone = impl.FALLBACK_PHONE;
                cache.tablet = null;
            } else {
                cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
                cache.phone = null;
            }
        } else if (impl.isTabletFallback(userAgent)) {
            cache.mobile = cache.tablet = impl.FALLBACK_TABLET;
            cache.phone = null;
        } else {
            // not mobile at all!
            cache.mobile = cache.tablet = cache.phone = null;
        }
    };

    // t is a reference to a MobileDetect instance
    impl.mobileGrade = function (t) {
        // impl note:
        // To keep in sync w/ Mobile_Detect.php easily, the following code is tightly aligned to the PHP version.
        // When changes are made in Mobile_Detect.php, copy this method and replace:
        //     $this-> / t.
        //     self::MOBILE_GRADE_(.) / '$1'
        //     , self::VERSION_TYPE_FLOAT / (nothing)
        //     isIOS() / os('iOS')
        //     [reg] / (nothing)   <-- jsdelivr complaining about unescaped unicode character U+00AE
        var $isMobile = t.mobile() !== null;

        if (
            // Apple iOS 3.2-5.1 - Tested on the original iPad (4.3 / 5.0), iPad 2 (4.3), iPad 3 (5.1), original iPhone (3.1), iPhone 3 (3.2), 3GS (4.3), 4 (4.3 / 5.0), and 4S (5.1)
            t.os('iOS') && t.version('iPad')>=4.3 ||
            t.os('iOS') && t.version('iPhone')>=3.1 ||
            t.os('iOS') && t.version('iPod')>=3.1 ||

            // Android 2.1-2.3 - Tested on the HTC Incredible (2.2), original Droid (2.2), HTC Aria (2.1), Google Nexus S (2.3). Functional on 1.5 & 1.6 but performance may be sluggish, tested on Google G1 (1.5)
            // Android 3.1 (Honeycomb)  - Tested on the Samsung Galaxy Tab 10.1 and Motorola XOOM
            // Android 4.0 (ICS)  - Tested on a Galaxy Nexus. Note: transition performance can be poor on upgraded devices
            // Android 4.1 (Jelly Bean)  - Tested on a Galaxy Nexus and Galaxy 7
            ( t.version('Android')>2.1 && t.is('Webkit') ) ||

            // Windows Phone 7-7.5 - Tested on the HTC Surround (7.0) HTC Trophy (7.5), LG-E900 (7.5), Nokia Lumia 800
            t.version('Windows Phone OS')>=7.0 ||

            // Blackberry 7 - Tested on BlackBerry Torch 9810
            // Blackberry 6.0 - Tested on the Torch 9800 and Style 9670
            t.is('BlackBerry') && t.version('BlackBerry')>=6.0 ||
            // Blackberry Playbook (1.0-2.0) - Tested on PlayBook
            t.match('Playbook.*Tablet') ||

            // Palm WebOS (1.4-2.0) - Tested on the Palm Pixi (1.4), Pre (1.4), Pre 2 (2.0)
            ( t.version('webOS')>=1.4 && t.match('Palm|Pre|Pixi') ) ||
            // Palm WebOS 3.0  - Tested on HP TouchPad
            t.match('hp.*TouchPad') ||

            // Firefox Mobile (12 Beta) - Tested on Android 2.3 device
            ( t.is('Firefox') && t.version('Firefox')>=12 ) ||

            // Chrome for Android - Tested on Android 4.0, 4.1 device
            ( t.is('Chrome') && t.is('AndroidOS') && t.version('Android')>=4.0 ) ||

            // Skyfire 4.1 - Tested on Android 2.3 device
            ( t.is('Skyfire') && t.version('Skyfire')>=4.1 && t.is('AndroidOS') && t.version('Android')>=2.3 ) ||

            // Opera Mobile 11.5-12: Tested on Android 2.3
            ( t.is('Opera') && t.version('Opera Mobi')>11 && t.is('AndroidOS') ) ||

            // Meego 1.2 - Tested on Nokia 950 and N9
            t.is('MeeGoOS') ||

            // Tizen (pre-release) - Tested on early hardware
            t.is('Tizen') ||

            // Samsung Bada 2.0 - Tested on a Samsung Wave 3, Dolphin browser
            // @todo: more tests here!
            t.is('Dolfin') && t.version('Bada')>=2.0 ||

            // UC Browser - Tested on Android 2.3 device
            ( (t.is('UC Browser') || t.is('Dolfin')) && t.version('Android')>=2.3 ) ||

            // Kindle 3 and Fire  - Tested on the built-in WebKit browser for each
            ( t.match('Kindle Fire') ||
                t.is('Kindle') && t.version('Kindle')>=3.0 ) ||

            // Nook Color 1.4.1 - Tested on original Nook Color, not Nook Tablet
            t.is('AndroidOS') && t.is('NookTablet') ||

            // Chrome Desktop 11-21 - Tested on OS X 10.7 and Windows 7
            t.version('Chrome')>=11 && !$isMobile ||

            // Safari Desktop 4-5 - Tested on OS X 10.7 and Windows 7
            t.version('Safari')>=5.0 && !$isMobile ||

            // Firefox Desktop 4-13 - Tested on OS X 10.7 and Windows 7
            t.version('Firefox')>=4.0 && !$isMobile ||

            // Internet Explorer 7-9 - Tested on Windows XP, Vista and 7
            t.version('MSIE')>=7.0 && !$isMobile ||

            // Opera Desktop 10-12 - Tested on OS X 10.7 and Windows 7
            // @reference: http://my.opera.com/community/openweb/idopera/
            t.version('Opera')>=10 && !$isMobile

            ){
            return 'A';
        }

        if (
            t.os('iOS') && t.version('iPad')<4.3 ||
            t.os('iOS') && t.version('iPhone')<3.1 ||
            t.os('iOS') && t.version('iPod')<3.1 ||

            // Blackberry 5.0: Tested on the Storm 2 9550, Bold 9770
            t.is('Blackberry') && t.version('BlackBerry')>=5 && t.version('BlackBerry')<6 ||

            //Opera Mini (5.0-6.5) - Tested on iOS 3.2/4.3 and Android 2.3
            ( t.version('Opera Mini')>=5.0 && t.version('Opera Mini')<=6.5 &&
                (t.version('Android')>=2.3 || t.is('iOS')) ) ||

            // Nokia Symbian^3 - Tested on Nokia N8 (Symbian^3), C7 (Symbian^3), also works on N97 (Symbian^1)
            t.match('NokiaN8|NokiaC7|N97.*Series60|Symbian/3') ||

            // @todo: report this (tested on Nokia N71)
            t.version('Opera Mobi')>=11 && t.is('SymbianOS')
            ){
            return 'B';
        }

        if (
        // Blackberry 4.x - Tested on the Curve 8330
            t.version('BlackBerry')<5.0 ||
            // Windows Mobile - Tested on the HTC Leo (WinMo 5.2)
            t.match('MSIEMobile|Windows CE.*Mobile') || t.version('Windows Mobile')<=5.2

            ){
            return 'C';
        }

        //All older smartphone platforms and featurephones - Any device that doesn't support media queries
        //will receive the basic, C grade experience.
        return 'C';
    };

    impl.detectOS = function (ua) {
        return impl.findMatch(impl.mobileDetectRules.oss0, ua) ||
            impl.findMatch(impl.mobileDetectRules.oss, ua);
    };

    impl.getDeviceSmallerSide = function () {
        return window.screen.width < window.screen.height ?
            window.screen.width :
            window.screen.height;
    };

    /**
     * Constructor for MobileDetect object.
     * <br>
     * Such an object will keep a reference to the given user-agent string and cache most of the detect queries.<br>
     * <div style="background-color: #d9edf7; border: 1px solid #bce8f1; color: #3a87ad; padding: 14px; border-radius: 2px; margin-top: 20px">
     *     <strong>Find information how to download and install:</strong>
     *     <a href="https://github.com/hgoebl/mobile-detect.js/">github.com/hgoebl/mobile-detect.js/</a>
     * </div>
     *
     * @example <pre>
     *     var md = new MobileDetect(window.navigator.userAgent);
     *     if (md.mobile()) {
     *         location.href = (md.mobileGrade() === 'A') ? '/mobile/' : '/lynx/';
     *     }
     * </pre>
     *
     * @param {string} userAgent typically taken from window.navigator.userAgent or http_header['User-Agent']
     * @param {number} [maxPhoneWidth=600] <strong>only for browsers</strong> specify a value for the maximum
     *        width of smallest device side (in logical "CSS" pixels) until a device detected as mobile will be handled
     *        as phone.
     *        This is only used in cases where the device cannot be classified as phone or tablet.<br>
     *        See <a href="http://developer.android.com/guide/practices/screens_support.html">Declaring Tablet Layouts
     *        for Android</a>.<br>
     *        If you provide a value < 0, then this "fuzzy" check is disabled.
     * @constructor
     * @global
     */
    function MobileDetect(userAgent, maxPhoneWidth) {
        this.ua = prepareUserAgent(userAgent);
        this._cache = {};
        //600dp is typical 7" tablet minimum width
        this.maxPhoneWidth = maxPhoneWidth || 600;
    }

    MobileDetect.prototype = {
        constructor: MobileDetect,

        /**
         * Returns the detected phone or tablet type or <tt>null</tt> if it is not a mobile device.
         * <br>
         * For a list of possible return values see {@link MobileDetect#phone} and {@link MobileDetect#tablet}.<br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code>, <code>UnknownTablet</code> or
         * <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>UnknownMobile</code> here.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key for the phone family or tablet family, e.g. "Nexus".
         * @function MobileDetect#mobile
         */
        mobile: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.mobile;
        },

        /**
         * Returns the detected phone type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPhone, BlackBerry, Pixel, HTC, Nexus, Dell, Motorola, Samsung, LG, Sony, Asus,
         * Xiaomi, NokiaLumia, Micromax, Palm, Vertu, Pantech, Fly, Wiko, iMobile,
         * SimValley, Wolfgang, Alcatel, Nintendo, Amoi, INQ, OnePlus, GenericPhone</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownPhone</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the phone family or producer, e.g. "iPhone"
         * @function MobileDetect#phone
         */
        phone: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.phone;
        },

        /**
         * Returns the detected tablet type/family string or <tt>null</tt>.
         * <br>
         * The returned tablet (family or producer) is one of following keys:<br>
         * <br><tt>iPad, NexusTablet, GoogleTablet, SamsungTablet, Kindle, SurfaceTablet,
         * HPTablet, AsusTablet, BlackBerryTablet, HTCtablet, MotorolaTablet, NookTablet,
         * AcerTablet, ToshibaTablet, LGTablet, FujitsuTablet, PrestigioTablet,
         * LenovoTablet, DellTablet, YarvikTablet, MedionTablet, ArnovaTablet,
         * IntensoTablet, IRUTablet, MegafonTablet, EbodaTablet, AllViewTablet,
         * ArchosTablet, AinolTablet, NokiaLumiaTablet, SonyTablet, PhilipsTablet,
         * CubeTablet, CobyTablet, MIDTablet, MSITablet, SMiTTablet, RockChipTablet,
         * FlyTablet, bqTablet, HuaweiTablet, NecTablet, PantechTablet, BronchoTablet,
         * VersusTablet, ZyncTablet, PositivoTablet, NabiTablet, KoboTablet, DanewTablet,
         * TexetTablet, PlaystationTablet, TrekstorTablet, PyleAudioTablet, AdvanTablet,
         * DanyTechTablet, GalapadTablet, MicromaxTablet, KarbonnTablet, AllFineTablet,
         * PROSCANTablet, YONESTablet, ChangJiaTablet, GUTablet, PointOfViewTablet,
         * OvermaxTablet, HCLTablet, DPSTablet, VistureTablet, CrestaTablet,
         * MediatekTablet, ConcordeTablet, GoCleverTablet, ModecomTablet, VoninoTablet,
         * ECSTablet, StorexTablet, VodafoneTablet, EssentielBTablet, RossMoorTablet,
         * iMobileTablet, TolinoTablet, AudioSonicTablet, AMPETablet, SkkTablet,
         * TecnoTablet, JXDTablet, iJoyTablet, FX2Tablet, XoroTablet, ViewsonicTablet,
         * VerizonTablet, OdysTablet, CaptivaTablet, IconbitTablet, TeclastTablet,
         * OndaTablet, JaytechTablet, BlaupunktTablet, DigmaTablet, EvolioTablet,
         * LavaTablet, AocTablet, MpmanTablet, CelkonTablet, WolderTablet, MediacomTablet,
         * MiTablet, NibiruTablet, NexoTablet, LeaderTablet, UbislateTablet,
         * PocketBookTablet, KocasoTablet, HisenseTablet, Hudl, TelstraTablet,
         * GenericTablet</tt><br>
         * <br>
         * If the device is not detected by the regular expressions from Mobile-Detect, a test is made against
         * the patterns of <a href="http://detectmobilebrowsers.com/">detectmobilebrowsers.com</a>. If this test
         * is positive, a value of <code>UnknownTablet</code> or <code>UnknownMobile</code> is returned.<br>
         * When used in browser, the decision whether phone or tablet is made based on <code>screen.width/height</code>.<br>
         * <br>
         * When used server-side (node.js), there is no way to tell the difference between <code>UnknownTablet</code>
         * and <code>UnknownMobile</code>, so you will get <code>null</code> here, while {@link MobileDetect#mobile}
         * will return <code>UnknownMobile</code>.<br>
         * Be aware that since v1.0.0 in this special case you will get <code>UnknownMobile</code> only for:
         * {@link MobileDetect#mobile}, not for {@link MobileDetect#phone} and {@link MobileDetect#tablet}.
         * In versions before v1.0.0 all 3 methods returned <code>UnknownMobile</code> which was tedious to use.
         * <br>
         * In most cases you will use the return value just as a boolean.
         *
         * @returns {String} the key of the tablet family or producer, e.g. "SamsungTablet"
         * @function MobileDetect#tablet
         */
        tablet: function () {
            impl.prepareDetectionCache(this._cache, this.ua, this.maxPhoneWidth);
            return this._cache.tablet;
        },

        /**
         * Returns the (first) detected user-agent string or <tt>null</tt>.
         * <br>
         * The returned user-agent is one of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {String} the key for the detected user-agent or <tt>null</tt>
         * @function MobileDetect#userAgent
         */
        userAgent: function () {
            if (this._cache.userAgent === undefined) {
                this._cache.userAgent = impl.findMatch(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgent;
        },

        /**
         * Returns all detected user-agent strings.
         * <br>
         * The array is empty or contains one or more of following keys:<br>
         * <br><tt>Chrome, Dolfin, Opera, Skyfire, Edge, IE, Firefox, Bolt, TeaShark, Blazer,
         * Safari, WeChat, UCBrowser, baiduboxapp, baidubrowser, DiigoBrowser, Mercury,
         * ObigoBrowser, NetFront, GenericBrowser, PaleMoon</tt><br>
         * <br>
         * In most cases calling {@link MobileDetect#userAgent} will be sufficient. But there are rare
         * cases where a mobile device pretends to be more than one particular browser. You can get the
         * list of all matches with {@link MobileDetect#userAgents} or check for a particular value by
         * providing one of the defined keys as first argument to {@link MobileDetect#is}.
         *
         * @returns {Array} the array of detected user-agent keys or <tt>[]</tt>
         * @function MobileDetect#userAgents
         */
        userAgents: function () {
            if (this._cache.userAgents === undefined) {
                this._cache.userAgents = impl.findMatches(impl.mobileDetectRules.uas, this.ua);
            }
            return this._cache.userAgents;
        },

        /**
         * Returns the detected operating system string or <tt>null</tt>.
         * <br>
         * The operating system is one of following keys:<br>
         * <br><tt>AndroidOS, BlackBerryOS, PalmOS, SymbianOS, WindowsMobileOS, WindowsPhoneOS,
         * iOS, iPadOS, SailfishOS, MeeGoOS, MaemoOS, JavaOS, webOS, badaOS, BREWOS</tt><br>
         *
         * @returns {String} the key for the detected operating system.
         * @function MobileDetect#os
         */
        os: function () {
            if (this._cache.os === undefined) {
                this._cache.os = impl.detectOS(this.ua);
            }
            return this._cache.os;
        },

        /**
         * Get the version (as Number) of the given property in the User-Agent.
         * <br>
         * Will return a float number. (eg. 2_0 will return 2.0, 4.3.1 will return 4.31)
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {Number} the version as float or <tt>NaN</tt> if User-Agent doesn't contain this version.
         *          Be careful when comparing this value with '==' operator!
         * @function MobileDetect#version
         */
        version: function (key) {
            return impl.getVersion(key, this.ua);
        },

        /**
         * Get the version (as String) of the given property in the User-Agent.
         * <br>
         *
         * @param {String} key a key defining a thing which has a version.<br>
         *        You can use one of following keys:<br>
         * <br><tt>Mobile, Build, Version, VendorID, iPad, iPhone, iPod, Kindle, Chrome, Coast,
         * Dolfin, Firefox, Fennec, Edge, IE, NetFront, NokiaBrowser, Opera, Opera Mini,
         * Opera Mobi, UCBrowser, MQQBrowser, MicroMessenger, baiduboxapp, baidubrowser,
         * SamsungBrowser, Iron, Safari, Skyfire, Tizen, Webkit, PaleMoon,
         * SailfishBrowser, Gecko, Trident, Presto, Goanna, iOS, Android, Sailfish,
         * BlackBerry, BREW, Java, Windows Phone OS, Windows Phone, Windows CE, Windows
         * NT, Symbian, webOS</tt><br>
         *
         * @returns {String} the "raw" version as String or <tt>null</tt> if User-Agent doesn't contain this version.
         *
         * @function MobileDetect#versionStr
         */
        versionStr: function (key) {
            return impl.getVersionStr(key, this.ua);
        },

        /**
         * Global test key against userAgent, os, phone, tablet and some other properties of userAgent string.
         *
         * @param {String} key the key (case-insensitive) of a userAgent, an operating system, phone or
         *        tablet family.<br>
         *        For a complete list of possible values, see {@link MobileDetect#userAgent},
         *        {@link MobileDetect#os}, {@link MobileDetect#phone}, {@link MobileDetect#tablet}.<br>
         *        Additionally you have following keys:<br>
         * <br><tt>Bot, MobileBot, DesktopMode, TV, WebKit, Console, Watch</tt><br>
         *
         * @returns {boolean} <tt>true</tt> when the given key is one of the defined keys of userAgent, os, phone,
         *                    tablet or one of the listed additional keys, otherwise <tt>false</tt>
         * @function MobileDetect#is
         */
        is: function (key) {
            return containsIC(this.userAgents(), key) ||
                   equalIC(key, this.os()) ||
                   equalIC(key, this.phone()) ||
                   equalIC(key, this.tablet()) ||
                   containsIC(impl.findMatches(impl.mobileDetectRules.utils, this.ua), key);
        },

        /**
         * Do a quick test against navigator::userAgent.
         *
         * @param {String|RegExp} pattern the pattern, either as String or RegExp
         *                        (a string will be converted to a case-insensitive RegExp).
         * @returns {boolean} <tt>true</tt> when the pattern matches, otherwise <tt>false</tt>
         * @function MobileDetect#match
         */
        match: function (pattern) {
            if (!(pattern instanceof RegExp)) {
                pattern = new RegExp(pattern, 'i');
            }
            return pattern.test(this.ua);
        },

        /**
         * Checks whether the mobile device can be considered as phone regarding <code>screen.width</code>.
         * <br>
         * Obviously this method makes sense in browser environments only (not for Node.js)!
         * @param {number} [maxPhoneWidth] the maximum logical pixels (aka. CSS-pixels) to be considered as phone.<br>
         *        The argument is optional and if not present or falsy, the value of the constructor is taken.
         * @returns {boolean|undefined} <code>undefined</code> if screen size wasn't detectable, else <code>true</code>
         *          when screen.width is less or equal to maxPhoneWidth, otherwise <code>false</code>.<br>
         *          Will always return <code>undefined</code> server-side.
         */
        isPhoneSized: function (maxPhoneWidth) {
            return MobileDetect.isPhoneSized(maxPhoneWidth || this.maxPhoneWidth);
        },

        /**
         * Returns the mobile grade ('A', 'B', 'C').
         *
         * @returns {String} one of the mobile grades ('A', 'B', 'C').
         * @function MobileDetect#mobileGrade
         */
        mobileGrade: function () {
            if (this._cache.grade === undefined) {
                this._cache.grade = impl.mobileGrade(this);
            }
            return this._cache.grade;
        }
    };

    // environment-dependent
    if (typeof window !== 'undefined' && window.screen) {
        MobileDetect.isPhoneSized = function (maxPhoneWidth) {
            return maxPhoneWidth < 0 ? undefined : impl.getDeviceSmallerSide() <= maxPhoneWidth;
        };
    } else {
        MobileDetect.isPhoneSized = function () {};
    }

    // should not be replaced by a completely new object - just overwrite existing methods
    MobileDetect._impl = impl;
    
    MobileDetect.version = '1.4.5 2021-03-13';

    return MobileDetect;
}); // end of call of define()
})((function (undefined) {
    if (typeof module !== 'undefined' && module.exports) {
        return function (factory) { module.exports = factory(); };
    } else if (true) {
        return __webpack_require__(199);
    } else if (typeof window !== 'undefined') {
        return function (factory) { window.MobileDetect = factory(); };
    } else {
        // please file a bug if you get this error!
        throw new Error('unknown environment');
    }
})());

/***/ }),
/* 199 */
/***/ (function(module, exports) {

module.exports = function() {
	throw new Error("define cannot be used indirect");
};


/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getLocationAndSubsection = undefined;

var _slicedToArray2 = __webpack_require__(201);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _dayjs = __webpack_require__(108);

var _dayjs2 = _interopRequireDefault(_dayjs);

var _timezone = __webpack_require__(112);

var _timezone2 = _interopRequireDefault(_timezone);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable no-console */
_dayjs2.default.extend(_timezone2.default);

// The whole logic is based on the requirements in the table from ticket JP-8435
var getLocationAndSubsection = exports.getLocationAndSubsection = function getLocationAndSubsection() {
    var path = window.location.pathname;

    var ukTimeZone = 'Europe/London';
    var today = (0, _dayjs2.default)().tz(ukTimeZone).format('YYYY-MM-DD');
    var tomorrow = (0, _dayjs2.default)().add(1, 'day').tz(ukTimeZone).format('YYYY-MM-DD');
    var yesterday = (0, _dayjs2.default)().subtract(1, 'day').tz(ukTimeZone).format('YYYY-MM-DD');

    // we use includes(), because URL might not end with trailing slash
    // and we can't predict it in advance
    if (path === '/racecards/' || path === '/racecards') {
        return { location: 'Racing Today', subsection: 'Racecards Races Course' };
    } else if (path.includes('/racecards/time-order')) {
        return { location: 'Racing Today', subsection: "Today's Racecards Races Time" };
    } else if (path.includes('/racecards/runners-index')) {
        return { location: 'Racing Today', subsection: "Today's Racecards Runners Index" };
    } else if (path.includes('/racecards/' + today + '/stable-tour')) {
        return { location: 'Racing Today', subsection: 'Today\'s Racecards Stable Tours Entries' };
    } else if (path === '/racecards/tomorrow' || path === '/racecards/tomorrow/' || path === '/racecards/' + tomorrow) {
        return { location: 'Racing Races', subsection: "Tomorrow's Racecards Races Course" };
    } else if (path.includes('/racecards/' + tomorrow + '/time-order') || path.includes('/racecards/tomorrow/time-order')) {
        return { location: 'Racing Races', subsection: 'Tomorrow\'s Racecards Races Time' };
    } else if (path.includes('/racecards/' + tomorrow + '/runners-index')) {
        return { location: 'Racing Races', subsection: 'Tomorrow\'s Racecards Runners Index' };
    } else if (path.includes('/racecards/' + tomorrow + '/stable-tour')) {
        return { location: 'Racing Races', subsection: 'Tomorrow\'s Racecards Stable Tours Entries' };
    } else if (path.includes('/racecards/big-race-entries')) {
        return { location: 'Racing Races', subsection: 'Big Race Entries' };
    } else if (path.includes('/racecards/us-racing')) {
        return { location: 'Racing Races', subsection: 'US Racing' };
    }
    // cases for URLs with raceId and future dates
    else if (path.startsWith('/racecards/')) {
            var splittedPath = path.split('/');

            if (splittedPath.length <= 4) {
                var date = splittedPath[2];

                if (path.includes('/time-order')) {
                    return {
                        location: 'Racing Races',
                        subsection: 'Racecards ' + (0, _dayjs2.default)(date).format('DD MMMM YYYY') + ' Races Time'
                    };
                } else if (path.includes('/runners-index')) {
                    return {
                        location: 'Racing Races',
                        subsection: 'Racecards ' + (0, _dayjs2.default)(date).format('DD MMMM YYYY') + ' Runners Index'
                    };
                } else if (path.includes('/stable-tour')) {
                    return {
                        location: 'Racing Races',
                        subsection: 'Racecards ' + (0, _dayjs2.default)(date).format('DD MMMM YYYY') + ' Stable Tours Entries'
                    };
                }

                return {
                    location: 'Racing Races',
                    subsection: 'Racecards ' + (0, _dayjs2.default)(date).format('DD MMMM YYYY') + ' Races Course'
                };
            } else {
                if (path.includes('/pro')) {
                    return { location: 'Racecards', subsection: 'Pro' };
                } else if (path.includes('/at-a-glance')) {
                    return { location: 'Racecards', subsection: 'At-a-glance' };
                } else if (path.includes('/odds-comparison')) {
                    return { location: 'Racecards', subsection: 'Odds Comparison' };
                } else if (path.includes('/raceday-live')) {
                    return { location: 'Racecards', subsection: 'Raceday Live' };
                }

                return {
                    location: 'Racecards',
                    subsection: 'Standard'
                };
            }
            // cases for results pages and past dates
        } else if (path === '/results' || path === '/results/') {
            return { location: 'Racing Results', subsection: 'Racing Results Course' };
        } else if (path === '/fast-results' || path === '/fast-results/') {
            return { location: 'Racing Results', subsection: 'Fast Results Time' };
        } else if (path === '/results/' + yesterday || path === '/results/' + yesterday + '/') {
            return { location: 'Racing Results', subsection: 'Yesterday\'s Results Course' };
        } else if (path.includes('/results/time-order')) {
            return { location: 'Racing Results', subsection: 'Yesterday\'s Results Time' };
        } else if (path === '/results/' + yesterday + '/time-order' || path === '/results/' + yesterday + '/time-order/') {
            return { location: 'Racing Results', subsection: 'Yesterday\'s Results Time' };
        } else if (path.startsWith('/results/')) {
            var _splittedPath = path.split('/');
            var _date = _splittedPath[2];
            var isDateBeforeYesterday = (0, _dayjs2.default)(_date).isBefore((0, _dayjs2.default)(yesterday));

            if (isDateBeforeYesterday && path.includes('/time-order')) {
                return {
                    location: 'Racing Results',
                    subsection: 'Results ' + (0, _dayjs2.default)(_date).format('DD MMMM YYYY') + ' Time'
                };
            } else if (isDateBeforeYesterday) {
                return {
                    location: 'Racing Results',
                    subsection: 'Results ' + (0, _dayjs2.default)(_date).format('DD MMMM YYYY') + ' Course'
                };
            } else {
                return {
                    location: 'Racing Results',
                    subsection: 'N/A'
                };
            }
            // cases for news and horse tracker
        } else if (path === '/news/live' || path === '/news/live/') {
            return { location: 'Raceday Live', subsection: 'N/A' };
        } else if (path === '/horse-tracker' || path === '/horse-tracker/') {
            return { location: 'Horse Tracker', subsection: 'Entries' };
        } else if (path.includes('/horse-tracker/tracked')) {
            return { location: 'Horse Tracker', subsection: 'Tracked' };
        } else if (path.includes('/horse-tracker/settings')) {
            return { location: 'Horse Tracker', subsection: 'Settings' };
        }
        // cases for horse profiles
        else if (path.startsWith('/profile/')) {
                // Case for horse profiles
                if (path.includes('/horse/')) {
                    var subsectionMap = {
                        '/form': 'Form',
                        '/entries': 'Entries',
                        '/stats': 'Stats',
                        '/quotes': 'Quotes',
                        '/pedigree': 'Pedigree',
                        '/sales': 'Sales',
                        '/notes': 'Notes'
                    };

                    var subsection = Object.keys(subsectionMap).find(function (key) {
                        return path.includes(key);
                    }) || 'N/A';
                    return { location: 'Horse Profile', subsection: subsectionMap[subsection] };
                }

                // Cases for trainer, jockey, and owner profiles
                var profileTypes = { trainer: 'Trainers', jockey: 'Jockeys', owner: 'Owners' };
                var matched = Object.entries(profileTypes).find(function (_ref) {
                    var _ref2 = (0, _slicedToArray3.default)(_ref, 1),
                        type = _ref2[0];

                    return path.startsWith('/profile/' + type + '/');
                });

                if (matched) {
                    var _subsection = matched[1];
                    return { location: 'Profiles', subsection: _subsection };
                }
            }
            // case for my bookmakers page
            else if (path.includes('/my-bookmakers')) {
                    return { location: 'My Bookmakers', subsection: 'N/A' };
                } else if (path.includes('/subscriptions/my-account')) {
                    return { location: 'Members Club', subsection: 'My Account' };
                }

    // in case there is no match
    return { location: 'Unknown', subsection: 'Unknown' };
};

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _isIterable2 = __webpack_require__(202);

var _isIterable3 = _interopRequireDefault(_isIterable2);

var _getIterator2 = __webpack_require__(214);

var _getIterator3 = _interopRequireDefault(_getIterator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if ((0, _isIterable3.default)(Object(arr))) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(203), __esModule: true };

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68);
__webpack_require__(70);
module.exports = __webpack_require__(213);


/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(205);
var step = __webpack_require__(206);
var Iterators = __webpack_require__(29);
var toIObject = __webpack_require__(55);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(109)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 205 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 206 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(27);


/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(209);
var descriptor = __webpack_require__(85);
var setToStringTag = __webpack_require__(69);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(27)(IteratorPrototype, __webpack_require__(14)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(24);
var dPs = __webpack_require__(210);
var enumBugKeys = __webpack_require__(91);
var IE_PROTO = __webpack_require__(58)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(54)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(110).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(33);
var anObject = __webpack_require__(24);
var getKeys = __webpack_require__(86);

module.exports = __webpack_require__(25) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(40);
var toObject = __webpack_require__(92);
var IE_PROTO = __webpack_require__(58)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(57);
var defined = __webpack_require__(56);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(71);
var ITERATOR = __webpack_require__(14)('iterator');
var Iterators = __webpack_require__(29);
module.exports = __webpack_require__(17).isIterable = function (it) {
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    // eslint-disable-next-line no-prototype-builtins
    || Iterators.hasOwnProperty(classof(O));
};


/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(215), __esModule: true };

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(68);
__webpack_require__(70);
module.exports = __webpack_require__(216);


/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(24);
var get = __webpack_require__(111);
module.exports = __webpack_require__(17).getIterator = function (it) {
  var iterFn = get(it);
  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
  return anObject(iterFn.call(it));
};


/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,i){ true?module.exports=i():"function"==typeof define&&define.amd?define(i):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs_plugin_utc=i()}(this,(function(){"use strict";var t="minute",i=/[+-]\d\d(?::?\d\d)?/g,e=/([+-]|\d\d)/g;return function(s,f,n){var u=f.prototype;n.utc=function(t){var i={date:t,utc:!0,args:arguments};return new f(i)},u.utc=function(i){var e=n(this.toDate(),{locale:this.$L,utc:!0});return i?e.add(this.utcOffset(),t):e},u.local=function(){return n(this.toDate(),{locale:this.$L,utc:!1})};var r=u.parse;u.parse=function(t){t.utc&&(this.$u=!0),this.$utils().u(t.$offset)||(this.$offset=t.$offset),r.call(this,t)};var o=u.init;u.init=function(){if(this.$u){var t=this.$d;this.$y=t.getUTCFullYear(),this.$M=t.getUTCMonth(),this.$D=t.getUTCDate(),this.$W=t.getUTCDay(),this.$H=t.getUTCHours(),this.$m=t.getUTCMinutes(),this.$s=t.getUTCSeconds(),this.$ms=t.getUTCMilliseconds()}else o.call(this)};var a=u.utcOffset;u.utcOffset=function(s,f){var n=this.$utils().u;if(n(s))return this.$u?0:n(this.$offset)?a.call(this):this.$offset;if("string"==typeof s&&(s=function(t){void 0===t&&(t="");var s=t.match(i);if(!s)return null;var f=(""+s[0]).match(e)||["-",0,0],n=f[0],u=60*+f[1]+ +f[2];return 0===u?0:"+"===n?u:-u}(s),null===s))return this;var u=Math.abs(s)<=16?60*s:s;if(0===u)return this.utc(f);var r=this.clone();if(f)return r.$offset=u,r.$u=!1,r;var o=this.$u?this.toDate().getTimezoneOffset():-1*this.utcOffset();return(r=this.local().add(u+o,t)).$offset=u,r.$x.$localOffset=o,r};var h=u.format;u.format=function(t){var i=t||(this.$u?"YYYY-MM-DDTHH:mm:ss[Z]":"");return h.call(this,i)},u.valueOf=function(){var t=this.$utils().u(this.$offset)?0:this.$offset+(this.$x.$localOffset||this.$d.getTimezoneOffset());return this.$d.valueOf()-6e4*t},u.isUTC=function(){return!!this.$u},u.toISOString=function(){return this.toDate().toISOString()},u.toString=function(){return this.toDate().toUTCString()};var l=u.toDate;u.toDate=function(t){return"s"===t&&this.$offset?n(this.format("YYYY-MM-DD HH:mm:ss:SSS")).toDate():l.call(this)};var c=u.diff;u.diff=function(t,i,e){if(t&&this.$u===t.$u)return c.call(this,t,i,e);var s=this.local(),f=n(t).local();return c.call(s,f,i,e)}}}));

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.DEFAULT_OPTIONS = undefined;

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = __webpack_require__(6);

var _extends4 = _interopRequireDefault(_extends3);

var _constants = __webpack_require__(18);

var _nonCanonical = __webpack_require__(63);

var _getDeviceType = __webpack_require__(67);

var _getDeviceType2 = _interopRequireDefault(_getDeviceType);

var _getBettingAccountLoggedInStatus = __webpack_require__(64);

var _getBettingAccountLoggedInStatus2 = _interopRequireDefault(_getBettingAccountLoggedInStatus);

var _getUserName = __webpack_require__(65);

var _getUserName2 = _interopRequireDefault(_getUserName);

var _getUserId = __webpack_require__(37);

var _getUserId2 = _interopRequireDefault(_getUserId);

var _commonTraits = __webpack_require__(45);

var _getUTMParams = __webpack_require__(66);

var _getUTMParams2 = _interopRequireDefault(_getUTMParams);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_OPTIONS = exports.DEFAULT_OPTIONS = {
    integrations: {
        All: true
    }
};

function dispatchGlobalPageViewEvent() {
    /* window_.dispatchEvent(new Event('RP_PAGE_VIEW')); IE does not work with this */
    var event = global.document.createEvent('Event');
    event.initEvent('RP_PAGE_VIEW', false, true);
    global.dispatchEvent(event);
}

function page(name) {
    var _extends2;

    var traits = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : DEFAULT_OPTIONS;

    // Overwrite segment defaults to use a non canonical values
    var properties = {
        path: (0, _nonCanonical.getNonCanonicalPath)(),
        url: (0, _nonCanonical.getNonCanonicalUrl)()
    };

    var userName = (0, _getUserName2.default)();
    if (userName) {
        properties[_traits.TRAIT_USER_NAME] = userName;
    }

    var userId = (0, _getUserId2.default)();
    if (userId) {
        properties[_traits.TRAIT_USER_ID] = userId;
    }

    var commonTraits = (0, _commonTraits.getCommonTraits)();
    if (commonTraits && commonTraits[_traits.TRAIT_SITE_SECTION]) {
        properties[_traits.TRAIT_SITE_SECTION] = commonTraits[_traits.TRAIT_SITE_SECTION];
        properties[_traits.TRAIT_SITE_SUB_SECTION_1] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_1];
        properties[_traits.TRAIT_SITE_SUB_SECTION_2] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_2];
        properties[_traits.TRAIT_SITE_SUB_SECTION_3] = commonTraits[_traits.TRAIT_SITE_SUB_SECTION_3];
    }

    var bettingAccountLoggedIn = (0, _getBettingAccountLoggedInStatus2.default)();

    properties = (0, _extends4.default)((_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_DEVICE_TYPE, (0, _getDeviceType2.default)()), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_LOGGED_IN_STATUS, userId ? 'Logged In' : 'Logged Out'), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_BETTING_ACCOUNT_LOGGED_IN_STATUS, bettingAccountLoggedIn ? 'Logged In' : 'Logged Out'), _extends2), properties, (0, _getUTMParams2.default)(), traits);

    return new Promise(function (resolve) {
        // Segment Page event
        if (!global.analytics) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        global.analytics.page(name, properties, options, resolve);
    }).then(dispatchGlobalPageViewEvent);
}

page.DEFAULT_OPTIONS = DEFAULT_OPTIONS;

exports.default = page;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

!function(t,e){ true?module.exports=e():"function"==typeof define&&define.amd?define(e):(t="undefined"!=typeof globalThis?globalThis:t||self).dayjs=e()}(this,(function(){"use strict";var t=1e3,e=6e4,n=36e5,r="millisecond",i="second",s="minute",u="hour",a="day",o="week",c="month",f="quarter",h="year",d="date",l="Invalid Date",$=/^(\d{4})[-/]?(\d{1,2})?[-/]?(\d{0,2})[Tt\s]*(\d{1,2})?:?(\d{1,2})?:?(\d{1,2})?[.:]?(\d+)?$/,y=/\[([^\]]+)]|Y{1,4}|M{1,4}|D{1,2}|d{1,4}|H{1,2}|h{1,2}|a|A|m{1,2}|s{1,2}|Z{1,2}|SSS/g,M={name:"en",weekdays:"Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"),months:"January_February_March_April_May_June_July_August_September_October_November_December".split("_"),ordinal:function(t){var e=["th","st","nd","rd"],n=t%100;return"["+t+(e[(n-20)%10]||e[n]||e[0])+"]"}},m=function(t,e,n){var r=String(t);return!r||r.length>=e?t:""+Array(e+1-r.length).join(n)+t},v={s:m,z:function(t){var e=-t.utcOffset(),n=Math.abs(e),r=Math.floor(n/60),i=n%60;return(e<=0?"+":"-")+m(r,2,"0")+":"+m(i,2,"0")},m:function t(e,n){if(e.date()<n.date())return-t(n,e);var r=12*(n.year()-e.year())+(n.month()-e.month()),i=e.clone().add(r,c),s=n-i<0,u=e.clone().add(r+(s?-1:1),c);return+(-(r+(n-i)/(s?i-u:u-i))||0)},a:function(t){return t<0?Math.ceil(t)||0:Math.floor(t)},p:function(t){return{M:c,y:h,w:o,d:a,D:d,h:u,m:s,s:i,ms:r,Q:f}[t]||String(t||"").toLowerCase().replace(/s$/,"")},u:function(t){return void 0===t}},g="en",D={};D[g]=M;var p="$isDayjsObject",S=function(t){return t instanceof _||!(!t||!t[p])},w=function t(e,n,r){var i;if(!e)return g;if("string"==typeof e){var s=e.toLowerCase();D[s]&&(i=s),n&&(D[s]=n,i=s);var u=e.split("-");if(!i&&u.length>1)return t(u[0])}else{var a=e.name;D[a]=e,i=a}return!r&&i&&(g=i),i||!r&&g},O=function(t,e){if(S(t))return t.clone();var n="object"==typeof e?e:{};return n.date=t,n.args=arguments,new _(n)},b=v;b.l=w,b.i=S,b.w=function(t,e){return O(t,{locale:e.$L,utc:e.$u,x:e.$x,$offset:e.$offset})};var _=function(){function M(t){this.$L=w(t.locale,null,!0),this.parse(t),this.$x=this.$x||t.x||{},this[p]=!0}var m=M.prototype;return m.parse=function(t){this.$d=function(t){var e=t.date,n=t.utc;if(null===e)return new Date(NaN);if(b.u(e))return new Date;if(e instanceof Date)return new Date(e);if("string"==typeof e&&!/Z$/i.test(e)){var r=e.match($);if(r){var i=r[2]-1||0,s=(r[7]||"0").substring(0,3);return n?new Date(Date.UTC(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)):new Date(r[1],i,r[3]||1,r[4]||0,r[5]||0,r[6]||0,s)}}return new Date(e)}(t),this.init()},m.init=function(){var t=this.$d;this.$y=t.getFullYear(),this.$M=t.getMonth(),this.$D=t.getDate(),this.$W=t.getDay(),this.$H=t.getHours(),this.$m=t.getMinutes(),this.$s=t.getSeconds(),this.$ms=t.getMilliseconds()},m.$utils=function(){return b},m.isValid=function(){return!(this.$d.toString()===l)},m.isSame=function(t,e){var n=O(t);return this.startOf(e)<=n&&n<=this.endOf(e)},m.isAfter=function(t,e){return O(t)<this.startOf(e)},m.isBefore=function(t,e){return this.endOf(e)<O(t)},m.$g=function(t,e,n){return b.u(t)?this[e]:this.set(n,t)},m.unix=function(){return Math.floor(this.valueOf()/1e3)},m.valueOf=function(){return this.$d.getTime()},m.startOf=function(t,e){var n=this,r=!!b.u(e)||e,f=b.p(t),l=function(t,e){var i=b.w(n.$u?Date.UTC(n.$y,e,t):new Date(n.$y,e,t),n);return r?i:i.endOf(a)},$=function(t,e){return b.w(n.toDate()[t].apply(n.toDate("s"),(r?[0,0,0,0]:[23,59,59,999]).slice(e)),n)},y=this.$W,M=this.$M,m=this.$D,v="set"+(this.$u?"UTC":"");switch(f){case h:return r?l(1,0):l(31,11);case c:return r?l(1,M):l(0,M+1);case o:var g=this.$locale().weekStart||0,D=(y<g?y+7:y)-g;return l(r?m-D:m+(6-D),M);case a:case d:return $(v+"Hours",0);case u:return $(v+"Minutes",1);case s:return $(v+"Seconds",2);case i:return $(v+"Milliseconds",3);default:return this.clone()}},m.endOf=function(t){return this.startOf(t,!1)},m.$set=function(t,e){var n,o=b.p(t),f="set"+(this.$u?"UTC":""),l=(n={},n[a]=f+"Date",n[d]=f+"Date",n[c]=f+"Month",n[h]=f+"FullYear",n[u]=f+"Hours",n[s]=f+"Minutes",n[i]=f+"Seconds",n[r]=f+"Milliseconds",n)[o],$=o===a?this.$D+(e-this.$W):e;if(o===c||o===h){var y=this.clone().set(d,1);y.$d[l]($),y.init(),this.$d=y.set(d,Math.min(this.$D,y.daysInMonth())).$d}else l&&this.$d[l]($);return this.init(),this},m.set=function(t,e){return this.clone().$set(t,e)},m.get=function(t){return this[b.p(t)]()},m.add=function(r,f){var d,l=this;r=Number(r);var $=b.p(f),y=function(t){var e=O(l);return b.w(e.date(e.date()+Math.round(t*r)),l)};if($===c)return this.set(c,this.$M+r);if($===h)return this.set(h,this.$y+r);if($===a)return y(1);if($===o)return y(7);var M=(d={},d[s]=e,d[u]=n,d[i]=t,d)[$]||1,m=this.$d.getTime()+r*M;return b.w(m,this)},m.subtract=function(t,e){return this.add(-1*t,e)},m.format=function(t){var e=this,n=this.$locale();if(!this.isValid())return n.invalidDate||l;var r=t||"YYYY-MM-DDTHH:mm:ssZ",i=b.z(this),s=this.$H,u=this.$m,a=this.$M,o=n.weekdays,c=n.months,f=n.meridiem,h=function(t,n,i,s){return t&&(t[n]||t(e,r))||i[n].slice(0,s)},d=function(t){return b.s(s%12||12,t,"0")},$=f||function(t,e,n){var r=t<12?"AM":"PM";return n?r.toLowerCase():r};return r.replace(y,(function(t,r){return r||function(t){switch(t){case"YY":return String(e.$y).slice(-2);case"YYYY":return b.s(e.$y,4,"0");case"M":return a+1;case"MM":return b.s(a+1,2,"0");case"MMM":return h(n.monthsShort,a,c,3);case"MMMM":return h(c,a);case"D":return e.$D;case"DD":return b.s(e.$D,2,"0");case"d":return String(e.$W);case"dd":return h(n.weekdaysMin,e.$W,o,2);case"ddd":return h(n.weekdaysShort,e.$W,o,3);case"dddd":return o[e.$W];case"H":return String(s);case"HH":return b.s(s,2,"0");case"h":return d(1);case"hh":return d(2);case"a":return $(s,u,!0);case"A":return $(s,u,!1);case"m":return String(u);case"mm":return b.s(u,2,"0");case"s":return String(e.$s);case"ss":return b.s(e.$s,2,"0");case"SSS":return b.s(e.$ms,3,"0");case"Z":return i}return null}(t)||i.replace(":","")}))},m.utcOffset=function(){return 15*-Math.round(this.$d.getTimezoneOffset()/15)},m.diff=function(r,d,l){var $,y=this,M=b.p(d),m=O(r),v=(m.utcOffset()-this.utcOffset())*e,g=this-m,D=function(){return b.m(y,m)};switch(M){case h:$=D()/12;break;case c:$=D();break;case f:$=D()/3;break;case o:$=(g-v)/6048e5;break;case a:$=(g-v)/864e5;break;case u:$=g/n;break;case s:$=g/e;break;case i:$=g/t;break;default:$=g}return l?$:b.a($)},m.daysInMonth=function(){return this.endOf(c).$D},m.$locale=function(){return D[this.$L]},m.locale=function(t,e){if(!t)return this.$L;var n=this.clone(),r=w(t,e,!0);return r&&(n.$L=r),n},m.clone=function(){return b.w(this.$d,this)},m.toDate=function(){return new Date(this.valueOf())},m.toJSON=function(){return this.isValid()?this.toISOString():null},m.toISOString=function(){return this.$d.toISOString()},m.toString=function(){return this.$d.toUTCString()},M}(),k=_.prototype;return O.prototype=k,[["$ms",r],["$s",i],["$m",s],["$H",u],["$W",a],["$M",c],["$y",h],["$D",d]].forEach((function(t){k[t[1]]=function(e){return this.$g(e,t[0],t[1])}})),O.extend=function(t,e){return t.$i||(t(e,_,O),t.$i=!0),O},O.locale=w,O.isDayjs=S,O.unix=function(t){return O(1e3*t)},O.en=D[g],O.Ls=D,O.p={},O}));

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getUserId = __webpack_require__(37);

var _getUserId2 = _interopRequireDefault(_getUserId);

var _getPreviousId = __webpack_require__(221);

var _getPreviousId2 = _interopRequireDefault(_getPreviousId);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function alias() {
    var userId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _getUserId2.default)();
    var previousId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (0, _getPreviousId2.default)();

    return new Promise(function (resolve) {
        if (!global.analytics) {
            console.warn(_constants.MESSAGE_ERROR_NO_ANALYTICS);
            resolve();
            return;
        }

        global.analytics.alias(userId, previousId, null, resolve);
    });
}

exports.default = alias;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpCookie = __webpack_require__(20);

var _rpCookie2 = _interopRequireDefault(_rpCookie);

var _constants = __webpack_require__(21);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getPreviousId() {
    return _rpCookie2.default.sharedSession.get(_constants.COOKIE_NAME_UNIQUE_USER_ID);
}

exports.default = getPreviousId;

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _identify2 = __webpack_require__(46);

var _identify3 = _interopRequireDefault(_identify2);

var _traits = __webpack_require__(2);

var _getUserPackage = __webpack_require__(42);

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_EMAIL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE, _propTypes3.default.string), _propTypes);

/** *
 * @param traits
 * @returns Object {} with tracking params
 */
function identifyLogin() {
    var _identify;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // eslint-disable-next-line no-console
    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', identifyLogin.displayName + ' method');
    return (0, _identify3.default)((_identify = {}, (0, _defineProperty3.default)(_identify, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_identify, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()), _identify));
}

identifyLogin.displayName = 'identifyLogin';

exports.default = identifyLogin;

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _identify2 = __webpack_require__(46);

var _identify3 = _interopRequireDefault(_identify2);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_EMAIL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CREATED_AT, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number])), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACINGPOST_CONTACT, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_THIRDPARTY_CONTACT, _propTypes3.default.string.isRequired), _propTypes);
/**
 *
 * @param traits
 * @returns Object {} with tracking params
 */
function identifyRegister() {
    var _identify;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // eslint-disable-next-line no-console
    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', identifyRegister.displayName + ' method');
    return (0, _identify3.default)((_identify = {}, (0, _defineProperty3.default)(_identify, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_identify, _traits.TRAIT_CREATED_AT, traits[_traits.TRAIT_CREATED_AT] || Date.now()), (0, _defineProperty3.default)(_identify, _traits.TRAIT_RACINGPOST_CONTACT, traits[_traits.TRAIT_RACINGPOST_CONTACT]), (0, _defineProperty3.default)(_identify, _traits.TRAIT_THIRDPARTY_CONTACT, traits[_traits.TRAIT_THIRDPARTY_CONTACT]), _identify));
}

identifyRegister.displayName = 'identifyRegister';

exports.default = identifyRegister;

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _identify2 = __webpack_require__(46);

var _identify3 = _interopRequireDefault(_identify2);

var _traits = __webpack_require__(2);

var _getUserPackage = __webpack_require__(42);

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_PACKAGE, _propTypes3.default.string);
/**
 * @param traits
 * @returns Object {} with tracking params
 */
function identifySubscriptionSale() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', identifySubscriptionSale.displayName + ' method');
    return (0, _identify3.default)((0, _defineProperty3.default)({}, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()));
}

identifySubscriptionSale.displayName = 'identifySubscriptionSale';

exports.default = identifySubscriptionSale;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

/**
 * Wrapper function to trigger SegmentIO function to track a show of essential barrier
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBarrierEssentialShow() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_ESSENTIAL_SHOW + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_ESSENTIAL_SHOW, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierEssentialShow;

/***/ }),
/* 226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_PRODUCT, _propTypes3.default.string.isRequired);

/**
 * Wrapper function to trigger SegmentIO function to track a click on subscribe of essential barrier
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBarrierEssentialSubscribe() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_ESSENTIAL_SUBSCRIBE + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_ESSENTIAL_SUBSCRIBE, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierEssentialSubscribe;

/***/ }),
/* 227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

/**
 * Wrapper function to trigger SegmentIO function to track a show of barrier
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBarrierShow() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_SHOW + ' event');

    return (0, _track2.default)(_events.EVENT_BARRIER_SHOW, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierShow;

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Wrapper function to trigger SegmentIO function to track sign in from barrier
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBarrierSignIn() {
  return (0, _track2.default)(_events.EVENT_BARRIER_SIGN_IN);
}

exports.default = trackBarrierSignIn;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

function trackBarrierSignInPassword() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_SIGNIN_PASSWORD + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_SIGNIN_PASSWORD, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierSignInPassword;

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

function trackBarrierSignInShow() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_SIGNIN_SHOW + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_SIGNIN_SHOW, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierSignInShow;

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackBarrierInteraction(traits) {
    return (0, _track2.default)(_events.EVENT_BARRIER_INTERACTION, (0, _extends3.default)({}, traits), {}, false, true, true);
}

exports.default = trackBarrierInteraction;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

function trackBarrierUltimateOnlyShow() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_ULTIMATE_ONLY_SHOW + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_ULTIMATE_ONLY_SHOW, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierUltimateOnlyShow;

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackBarrierUltimateOnlyUpgrade() {
    return (0, _track2.default)(_events.EVENT_BARRIER_ULTIMATE_ONLY_UPGRADE);
}

exports.default = trackBarrierUltimateOnlyUpgrade;

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired);

function trackBarrierUltimateShow() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BARRIER_ULTIMATE_SHOW + ' event');
    return (0, _track2.default)(_events.EVENT_BARRIER_ULTIMATE_SHOW, (0, _extends3.default)({}, traits));
}

exports.default = trackBarrierUltimateShow;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackBarrierUltimateSubscribe() {
    return (0, _track2.default)(_events.EVENT_BARRIER_ULTIMATE_SUBSCRIBE);
}

exports.default = trackBarrierUltimateSubscribe;

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOf(['SP', 'Odds'])), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NAME, _propTypes3.default.string.isRequired), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackBetButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BET_BUTTON_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_BET_BUTTON_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackBetButtonClick;

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ODDS, _propTypes3.default.oneOf(['SP', 'Odds'])), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_TIME_OF_EVENT, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BET_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RECEIPT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BET_COUNT, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RECEIPT_TYPE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BET_TYPE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_STAKE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_REVENUE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_WIN_EW, _propTypes3.default.oneOf(['Each Way', 'Win'])), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CURRENCY, _propTypes3.default.string.isRequired), _propTypes);

function trackBetReceipt() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_BET_RECEIPT + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_BET_RECEIPT, (0, _extends3.default)({}, traits));
}

exports.default = trackBetReceipt;

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_POSITION, _propTypes3.default.number), _propTypes);

function trackBettingOfferClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_OPEN_ACCOUNT + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_OPEN_ACCOUNT, (0, _extends3.default)({}, traits));
}

exports.default = trackBettingOfferClick;

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_POSITION, _propTypes3.default.number), _propTypes);

function trackBookmakerLogin() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_LOGIN + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_LOGIN, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerLogin;

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_POSITION, _propTypes3.default.number.isRequired), _propTypes);

function trackBookmakerRegister() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_REGISTER_BUTTON + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_REGISTER_BUTTON, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerRegister;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired);

function trackBookmakerLoginAttempt() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_LOGIN_ATTEMPT + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_LOGIN_ATTEMPT, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerLoginAttempt;

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ERROR, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), _propTypes);

function trackBookmakerLoginFailure() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_LOGIN_FAILURE + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_LOGIN_FAILURE, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerLoginFailure;

/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired);

function trackBookmakerLoginSuccess() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_LOGIN_SUCCESS + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_LOGIN_SUCCESS, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerLoginSuccess;

/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired);

function trackBookmakerOfferClaimButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_OFFER_CLAIM_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_OFFER_CLAIM_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackBookmakerOfferClaimButtonClick;

/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var _getUserPackage = __webpack_require__(42);

var _getUserPackage2 = _interopRequireDefault(_getUserPackage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_PACKAGE, _propTypes3.default.string);

/**
 * Wrapper function to trigger SegmentIO function to track a login
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackLogin() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    // eslint-disable-next-line no-console
    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_LOG_IN + ' event');
    return (0, _track3.default)(_events.EVENT_LOG_IN, (0, _defineProperty3.default)({}, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE] || (0, _getUserPackage2.default)()));
}

exports.default = trackLogin;

/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BETSLIP_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackCancelBetButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CANCEL_BET_BUTTON_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_CANCEL_BET_BUTTON_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackCancelBetButtonClick;

/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_CONDITIONS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_FORM, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_MY_NOTES, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_SPOTLIGHTS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COMMENTS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_OWNER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_QUOTES, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PEDIGREES, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RTF, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DECIMAL_ODDS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE_HISTORY, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_BY_PRICE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BETTING_FORCAST, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_MY_RATINGS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_SHOW_PRICES, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LAST_CHANGED_OPTION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), _propTypes);

function trackCardCustomisation() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CARD_CUSTOMISATION + ' event');
    return (0, _track2.default)(_events.EVENT_CARD_CUSTOMISATION, (0, _extends3.default)({}, traits));
}

exports.default = trackCardCustomisation;

/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BETSLIP_ID, _propTypes3.default.string.isRequired);
/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackDiscardSlipButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_DISCARD_SLIP_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_DISCARD_SLIP_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackDiscardSlipButtonClick;

/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_ENTERED, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_DECLARED, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_SHOW_PEDIGREE, _propTypes3.default.string.isRequired), _propTypes);

function trackHorseTrackerSettings() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_HORSE_TRACKING_SETTINGS + ' event');
    return (0, _track2.default)(_events.EVENT_HORSE_TRACKING_SETTINGS, (0, _extends3.default)({}, traits));
}

exports.default = trackHorseTrackerSettings;

/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track3 = __webpack_require__(4);

var _track4 = _interopRequireDefault(_track3);

var _getUserId = __webpack_require__(37);

var _getUserId2 = _interopRequireDefault(_getUserId);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_OUTCOME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_USER_ID, _propTypes3.default.number), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a email verification
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackEmailVerification() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var userId = (0, _getUserId2.default)();
    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_EMAIL_VERIFICATION + ' event');
    if (userId) {
        var _track;

        return (0, _track4.default)(_events.EVENT_EMAIL_VERIFICATION, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_OUTCOME, traits[_traits.TRAIT_OUTCOME]), (0, _defineProperty3.default)(_track, _traits.TRAIT_USER_ID, userId), _track));
    }

    return (0, _track4.default)(_events.EVENT_EMAIL_VERIFICATION, (0, _defineProperty3.default)({}, _traits.TRAIT_OUTCOME, traits[_traits.TRAIT_OUTCOME]));
}

exports.default = trackEmailVerification;

/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_SELECTION, _propTypes3.default.string.isRequired);

/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackNavigationClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_NAVIGATION_CLICK + ' event');

    return (0, _track2.default)(_events.EVENT_NAVIGATION_CLICK, (0, _extends3.default)({}, traits), {}, true, true, true);
}

exports.default = trackNavigationClick;

/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_SELECTION, _propTypes3.default.string.isRequired);

/**
 * Wrapper function to trigger SegmentIO function to track a click on link in footer
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackFooterClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_FOOTER_CLICK + ' event');

    return (0, _track2.default)(_events.EVENT_FOOTER_CLICK, (0, _extends3.default)({}, traits), {}, true, true, true);
}

exports.default = trackFooterClick;

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(74);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var trackOfferAccordion = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(traits) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', (0, _track2.default)(_events.EVENT_OFFER_ACCORDION, (0, _extends3.default)({}, traits), {}, false, true, true));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function trackOfferAccordion(_x) {
        return _ref.apply(this, arguments);
    };
}();

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = trackOfferAccordion;

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(255);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 255 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(257), __esModule: true };

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(258);
__webpack_require__(70);
__webpack_require__(68);
__webpack_require__(259);
__webpack_require__(270);
__webpack_require__(271);
module.exports = __webpack_require__(17).Promise;


/***/ }),
/* 258 */
/***/ (function(module, exports) {



/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(59);
var global = __webpack_require__(13);
var ctx = __webpack_require__(38);
var classof = __webpack_require__(71);
var $export = __webpack_require__(26);
var isObject = __webpack_require__(34);
var aFunction = __webpack_require__(39);
var anInstance = __webpack_require__(260);
var forOf = __webpack_require__(261);
var speciesConstructor = __webpack_require__(113);
var task = __webpack_require__(114).set;
var microtask = __webpack_require__(265)();
var newPromiseCapabilityModule = __webpack_require__(75);
var perform = __webpack_require__(115);
var userAgent = __webpack_require__(266);
var promiseResolve = __webpack_require__(116);
var PROMISE = 'Promise';
var TypeError = global.TypeError;
var process = global.process;
var versions = process && process.versions;
var v8 = versions && versions.v8 || '';
var $Promise = global[PROMISE];
var isNode = classof(process) == 'process';
var empty = function () { /* empty */ };
var Internal, newGenericPromiseCapability, OwnPromiseCapability, Wrapper;
var newPromiseCapability = newGenericPromiseCapability = newPromiseCapabilityModule.f;

var USE_NATIVE = !!function () {
  try {
    // correct subclassing with @@species support
    var promise = $Promise.resolve(1);
    var FakePromise = (promise.constructor = {})[__webpack_require__(14)('species')] = function (exec) {
      exec(empty, empty);
    };
    // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
    return (isNode || typeof PromiseRejectionEvent == 'function')
      && promise.then(empty) instanceof FakePromise
      // v8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
      // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
      // we can't detect it synchronously, so just check versions
      && v8.indexOf('6.6') !== 0
      && userAgent.indexOf('Chrome/66') === -1;
  } catch (e) { /* empty */ }
}();

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
};
var notify = function (promise, isReject) {
  if (promise._n) return;
  promise._n = true;
  var chain = promise._c;
  microtask(function () {
    var value = promise._v;
    var ok = promise._s == 1;
    var i = 0;
    var run = function (reaction) {
      var handler = ok ? reaction.ok : reaction.fail;
      var resolve = reaction.resolve;
      var reject = reaction.reject;
      var domain = reaction.domain;
      var result, then, exited;
      try {
        if (handler) {
          if (!ok) {
            if (promise._h == 2) onHandleUnhandled(promise);
            promise._h = 1;
          }
          if (handler === true) result = value;
          else {
            if (domain) domain.enter();
            result = handler(value); // may throw
            if (domain) {
              domain.exit();
              exited = true;
            }
          }
          if (result === reaction.promise) {
            reject(TypeError('Promise-chain cycle'));
          } else if (then = isThenable(result)) {
            then.call(result, resolve, reject);
          } else resolve(result);
        } else reject(value);
      } catch (e) {
        if (domain && !exited) domain.exit();
        reject(e);
      }
    };
    while (chain.length > i) run(chain[i++]); // variable length - can't use forEach
    promise._c = [];
    promise._n = false;
    if (isReject && !promise._h) onUnhandled(promise);
  });
};
var onUnhandled = function (promise) {
  task.call(global, function () {
    var value = promise._v;
    var unhandled = isUnhandled(promise);
    var result, handler, console;
    if (unhandled) {
      result = perform(function () {
        if (isNode) {
          process.emit('unhandledRejection', value, promise);
        } else if (handler = global.onunhandledrejection) {
          handler({ promise: promise, reason: value });
        } else if ((console = global.console) && console.error) {
          console.error('Unhandled promise rejection', value);
        }
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      promise._h = isNode || isUnhandled(promise) ? 2 : 1;
    } promise._a = undefined;
    if (unhandled && result.e) throw result.v;
  });
};
var isUnhandled = function (promise) {
  return promise._h !== 1 && (promise._a || promise._c).length === 0;
};
var onHandleUnhandled = function (promise) {
  task.call(global, function () {
    var handler;
    if (isNode) {
      process.emit('rejectionHandled', promise);
    } else if (handler = global.onrejectionhandled) {
      handler({ promise: promise, reason: promise._v });
    }
  });
};
var $reject = function (value) {
  var promise = this;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  promise._v = value;
  promise._s = 2;
  if (!promise._a) promise._a = promise._c.slice();
  notify(promise, true);
};
var $resolve = function (value) {
  var promise = this;
  var then;
  if (promise._d) return;
  promise._d = true;
  promise = promise._w || promise; // unwrap
  try {
    if (promise === value) throw TypeError("Promise can't be resolved itself");
    if (then = isThenable(value)) {
      microtask(function () {
        var wrapper = { _w: promise, _d: false }; // wrap
        try {
          then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
        } catch (e) {
          $reject.call(wrapper, e);
        }
      });
    } else {
      promise._v = value;
      promise._s = 1;
      notify(promise, false);
    }
  } catch (e) {
    $reject.call({ _w: promise, _d: false }, e); // wrap
  }
};

// constructor polyfill
if (!USE_NATIVE) {
  // 25.4.3.1 Promise(executor)
  $Promise = function Promise(executor) {
    anInstance(this, $Promise, PROMISE, '_h');
    aFunction(executor);
    Internal.call(this);
    try {
      executor(ctx($resolve, this, 1), ctx($reject, this, 1));
    } catch (err) {
      $reject.call(this, err);
    }
  };
  // eslint-disable-next-line no-unused-vars
  Internal = function Promise(executor) {
    this._c = [];             // <- awaiting reactions
    this._a = undefined;      // <- checked in isUnhandled reactions
    this._s = 0;              // <- state
    this._d = false;          // <- done
    this._v = undefined;      // <- value
    this._h = 0;              // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
    this._n = false;          // <- notify
  };
  Internal.prototype = __webpack_require__(267)($Promise.prototype, {
    // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
    then: function then(onFulfilled, onRejected) {
      var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
      reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
      reaction.fail = typeof onRejected == 'function' && onRejected;
      reaction.domain = isNode ? process.domain : undefined;
      this._c.push(reaction);
      if (this._a) this._a.push(reaction);
      if (this._s) notify(this, false);
      return reaction.promise;
    },
    // 25.4.5.1 Promise.prototype.catch(onRejected)
    'catch': function (onRejected) {
      return this.then(undefined, onRejected);
    }
  });
  OwnPromiseCapability = function () {
    var promise = new Internal();
    this.promise = promise;
    this.resolve = ctx($resolve, promise, 1);
    this.reject = ctx($reject, promise, 1);
  };
  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === $Promise || C === Wrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
__webpack_require__(69)($Promise, PROMISE);
__webpack_require__(268)(PROMISE);
Wrapper = __webpack_require__(17)[PROMISE];

// statics
$export($export.S + $export.F * !USE_NATIVE, PROMISE, {
  // 25.4.4.5 Promise.reject(r)
  reject: function reject(r) {
    var capability = newPromiseCapability(this);
    var $$reject = capability.reject;
    $$reject(r);
    return capability.promise;
  }
});
$export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
  // 25.4.4.6 Promise.resolve(x)
  resolve: function resolve(x) {
    return promiseResolve(LIBRARY && this === Wrapper ? $Promise : this, x);
  }
});
$export($export.S + $export.F * !(USE_NATIVE && __webpack_require__(269)(function (iter) {
  $Promise.all(iter)['catch'](empty);
})), PROMISE, {
  // 25.4.4.1 Promise.all(iterable)
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var values = [];
      var index = 0;
      var remaining = 1;
      forOf(iterable, false, function (promise) {
        var $index = index++;
        var alreadyCalled = false;
        values.push(undefined);
        remaining++;
        C.resolve(promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[$index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.e) reject(result.v);
    return capability.promise;
  },
  // 25.4.4.4 Promise.race(iterable)
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapability(C);
    var reject = capability.reject;
    var result = perform(function () {
      forOf(iterable, false, function (promise) {
        C.resolve(promise).then(capability.resolve, reject);
      });
    });
    if (result.e) reject(result.v);
    return capability.promise;
  }
});


/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports = function (it, Constructor, name, forbiddenField) {
  if (!(it instanceof Constructor) || (forbiddenField !== undefined && forbiddenField in it)) {
    throw TypeError(name + ': incorrect invocation!');
  } return it;
};


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var ctx = __webpack_require__(38);
var call = __webpack_require__(262);
var isArrayIter = __webpack_require__(263);
var anObject = __webpack_require__(24);
var toLength = __webpack_require__(88);
var getIterFn = __webpack_require__(111);
var BREAK = {};
var RETURN = {};
var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
  var iterFn = ITERATOR ? function () { return iterable; } : getIterFn(iterable);
  var f = ctx(fn, that, entries ? 2 : 1);
  var index = 0;
  var length, step, iterator, result;
  if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
  // fast case for arrays with default iterator
  if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
    result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
    if (result === BREAK || result === RETURN) return result;
  } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
    result = call(iterator, f, step.value, entries);
    if (result === BREAK || result === RETURN) return result;
  }
};
exports.BREAK = BREAK;
exports.RETURN = RETURN;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(24);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(29);
var ITERATOR = __webpack_require__(14)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 264 */
/***/ (function(module, exports) {

// fast apply, http://jsperf.lnkit.com/fast-apply/5
module.exports = function (fn, args, that) {
  var un = that === undefined;
  switch (args.length) {
    case 0: return un ? fn()
                      : fn.call(that);
    case 1: return un ? fn(args[0])
                      : fn.call(that, args[0]);
    case 2: return un ? fn(args[0], args[1])
                      : fn.call(that, args[0], args[1]);
    case 3: return un ? fn(args[0], args[1], args[2])
                      : fn.call(that, args[0], args[1], args[2]);
    case 4: return un ? fn(args[0], args[1], args[2], args[3])
                      : fn.call(that, args[0], args[1], args[2], args[3]);
  } return fn.apply(that, args);
};


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var macrotask = __webpack_require__(114).set;
var Observer = global.MutationObserver || global.WebKitMutationObserver;
var process = global.process;
var Promise = global.Promise;
var isNode = __webpack_require__(41)(process) == 'process';

module.exports = function () {
  var head, last, notify;

  var flush = function () {
    var parent, fn;
    if (isNode && (parent = process.domain)) parent.exit();
    while (head) {
      fn = head.fn;
      head = head.next;
      try {
        fn();
      } catch (e) {
        if (head) notify();
        else last = undefined;
        throw e;
      }
    } last = undefined;
    if (parent) parent.enter();
  };

  // Node.js
  if (isNode) {
    notify = function () {
      process.nextTick(flush);
    };
  // browsers with MutationObserver, except iOS Safari - https://github.com/zloirock/core-js/issues/339
  } else if (Observer && !(global.navigator && global.navigator.standalone)) {
    var toggle = true;
    var node = document.createTextNode('');
    new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    var promise = Promise.resolve(undefined);
    notify = function () {
      promise.then(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessag
  // - onreadystatechange
  // - setTimeout
  } else {
    notify = function () {
      // strange IE + webpack dev server bug - use .call(global)
      macrotask.call(global, flush);
    };
  }

  return function (fn) {
    var task = { fn: fn, next: undefined };
    if (last) last.next = task;
    if (!head) {
      head = task;
      notify();
    } last = task;
  };
};


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(13);
var navigator = global.navigator;

module.exports = navigator && navigator.userAgent || '';


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

var hide = __webpack_require__(27);
module.exports = function (target, src, safe) {
  for (var key in src) {
    if (safe && target[key]) target[key] = src[key];
    else hide(target, key, src[key]);
  } return target;
};


/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(13);
var core = __webpack_require__(17);
var dP = __webpack_require__(33);
var DESCRIPTORS = __webpack_require__(25);
var SPECIES = __webpack_require__(14)('species');

module.exports = function (KEY) {
  var C = typeof core[KEY] == 'function' ? core[KEY] : global[KEY];
  if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
    configurable: true,
    get: function () { return this; }
  });
};


/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(14)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// https://github.com/tc39/proposal-promise-finally

var $export = __webpack_require__(26);
var core = __webpack_require__(17);
var global = __webpack_require__(13);
var speciesConstructor = __webpack_require__(113);
var promiseResolve = __webpack_require__(116);

$export($export.P + $export.R, 'Promise', { 'finally': function (onFinally) {
  var C = speciesConstructor(this, core.Promise || global.Promise);
  var isFunction = typeof onFinally == 'function';
  return this.then(
    isFunction ? function (x) {
      return promiseResolve(C, onFinally()).then(function () { return x; });
    } : onFinally,
    isFunction ? function (e) {
      return promiseResolve(C, onFinally()).then(function () { throw e; });
    } : onFinally
  );
} });


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// https://github.com/tc39/proposal-promise-try
var $export = __webpack_require__(26);
var newPromiseCapability = __webpack_require__(75);
var perform = __webpack_require__(115);

$export($export.S, 'Promise', { 'try': function (callbackfn) {
  var promiseCapability = newPromiseCapability.f(this);
  var result = perform(callbackfn);
  (result.e ? promiseCapability.reject : promiseCapability.resolve)(result.v);
  return promiseCapability.promise;
} });


/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(74);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var trackBookmakerRegistrationTap = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(traits) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', (0, _track2.default)(_events.EVENT_BOOKMAKER_REGISTRATION_TAP, (0, _extends3.default)({}, traits), {}, false, true, true));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function trackBookmakerRegistrationTap(_x) {
        return _ref.apply(this, arguments);
    };
}();

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = trackBookmakerRegistrationTap;

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRODUCT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_TOTAL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number]).isRequired), _propTypes);

function trackOrderCompleted() {
    var _ref, _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_ORDER_COMPLETED + ' event');
    return (0, _track3.default)(_events.EVENT_ORDER_COMPLETED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_ORDER_ID, traits[_traits.TRAIT_ORDER_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_TOTAL, traits[_traits.TRAIT_TOTAL]), (0, _defineProperty3.default)(_track, _traits.TRAIT_COUPON, traits[_traits.TRAIT_COUPON]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCTS, [(_ref = {}, (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRODUCT_ID, traits[_traits.TRAIT_PRODUCT_ID]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_CATEGORY, _constants.CATEGORY_SUBSCRIPTION), (0, _defineProperty3.default)(_ref, _traits.TRAIT_NAME, traits[_traits.TRAIT_NAME]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRICE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_QUANTITY, 1), _ref)]), _track));
}

exports.default = trackOrderCompleted;

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_API_OUTCOME, _propTypes3.default.string.isRequired), _propTypes);

function trackPlaceBet() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BOOKMAKER_PLACE_BET + ' event');
    return (0, _track2.default)(_events.EVENT_BOOKMAKER_PLACE_BET, (0, _extends3.default)({}, traits));
}

exports.default = trackPlaceBet;

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_API_OUTCOME, _propTypes3.default.string.isRequired), _propTypes);

function trackBetslipErrorMessage() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_BETSLIP_ERROR_MESSAGE + ' event');
    return (0, _track2.default)(_events.EVENT_BETSLIP_ERROR_MESSAGE, (0, _extends3.default)({}, traits));
}

exports.default = trackBetslipErrorMessage;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_OVER_EIGHTEEN, _propTypes3.default.number.isRequired);

function trackPreferencesUpdate() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_PREFERENCE_UPDATE + ' event');
    return (0, _track3.default)(_events.EVENT_PREFERENCE_UPDATE, (0, _defineProperty3.default)({}, _traits.TRAIT_OVER_EIGHTEEN, traits[_traits.TRAIT_OVER_EIGHTEEN]));
}

exports.default = trackPreferencesUpdate;

/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BETSLIP_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_HORSE_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ODDS, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_STAKE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackQuickStakeButtonsClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_QUICK_STAKE_BUTTONS_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_QUICK_STAKE_BUTTONS_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackQuickStakeButtonsClick;

/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends3 = __webpack_require__(6);

var _extends4 = _interopRequireDefault(_extends3);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_EMAIL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CREATED_AT, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number])), _propTypes);

/**
 * Wrapper function to trigger SegmentIO function to track registration events
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackRegister() {
    var _extends2;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_REGISTRATION + ' event');
    return (0, _track2.default)(_events.EVENT_REGISTRATION, (0, _extends4.default)((_extends2 = {}, (0, _defineProperty3.default)(_extends2, _traits.TRAIT_EMAIL, traits[_traits.TRAIT_EMAIL]), (0, _defineProperty3.default)(_extends2, _traits.TRAIT_CREATED_AT, traits[_traits.TRAIT_CREATED_AT] || Date.now()), _extends2), traits));
}

exports.default = trackRegister;

/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_BETSLIP_ID, _propTypes3.default.string.isRequired);
/**
 * Wrapper function to trigger SegmentIO function to track a click on bet button
 * @param traits
 * @returns call of SegmentIO track function
 */

function trackRemoveSelectionButtonClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_REMOVE_SELECTION_BUTTON_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_REMOVE_SELECTION_BUTTON_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackRemoveSelectionButtonClick;

/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired);

function trackSubscriptionCompleted() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STEP_COMPLETED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STEP_COMPLETED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STEP, 1), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_CATEGORY, _constants.CATEGORY_SUBSCRIPTION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_NAME, traits[_traits.TRAIT_PRODUCT_NAME]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_PRICE, traits[_traits.TRAIT_PRODUCT_PRICE]), _track));
}

exports.default = trackSubscriptionCompleted;

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired);

function trackSubscriptionDetailsCompleted() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STEP_COMPLETED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STEP_COMPLETED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STEP, 2), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_CATEGORY, _constants.CATEGORY_SUBSCRIPTION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_NAME, traits[_traits.TRAIT_PRODUCT_NAME]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_PRICE, traits[_traits.TRAIT_PRODUCT_PRICE]), _track));
}

exports.default = trackSubscriptionDetailsCompleted;

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired);

function trackSubscriptionDetailsViewed() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STEP_VIEWED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STEP_VIEWED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STEP, 2), _track));
}

exports.default = trackSubscriptionDetailsViewed;

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_STATUS, _propTypes3.default.string.isRequired), _propTypes);

function trackSubscriptionSale() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_SUBSCRIPTION_SALE + ' event');
    return (0, _track3.default)(_events.EVENT_SUBSCRIPTION_SALE, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_PRICE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_track, _traits.TRAIT_REVENUE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PACKAGE, traits[_traits.TRAIT_PACKAGE]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STATUS, traits[_traits.TRAIT_STATUS]), _track));
}

exports.default = trackSubscriptionSale;

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_REWARDS_FOR_RACING, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DAILY_CONTACT, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_FIRST_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LAST_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PHONE_NUMBER, _propTypes3.default.string.isRequired), _propTypes);

function trackSubscriptionSaleAttempt() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_SUBSCRIPTION_SALE_ATTEMPT + ' event');
    return (0, _track2.default)(_events.EVENT_SUBSCRIPTION_SALE_ATTEMPT, (0, _extends3.default)({}, traits), undefined, false);
}

exports.default = trackSubscriptionSaleAttempt;

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRODUCT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number]).isRequired), _propTypes);

function trackSubscriptionStarted() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STARTED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STARTED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_ORDER_ID, traits[_traits.TRAIT_ORDER_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_AFFILIATION, _constants.DEFAULT_AFFILIATION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_CATEGORY, _constants.CATEGORY_SUBSCRIPTION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_NAME, traits[_traits.TRAIT_PRODUCT_NAME]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_PRICE, traits[_traits.TRAIT_PRODUCT_PRICE]), _track));
}

exports.default = trackSubscriptionStarted;

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (0, _defineProperty3.default)({}, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired);

function trackSubscriptionViewed() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STEP_VIEWED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STEP_VIEWED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_STEP, 1), _track));
}

exports.default = trackSubscriptionViewed;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE_ORIGIN, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE_DESTINATION, _propTypes3.default.string.isRequired), _propTypes);

function trackSubscriptionUpgraded() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_PACKAGE_UPGRADE + ' event');
    return (0, _track2.default)(_events.EVENT_PACKAGE_UPGRADE, (0, _extends3.default)({}, traits));
}

exports.default = trackSubscriptionUpgraded;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_CHECKOUT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRODUCT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_TOTAL, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number]).isRequired), _propTypes);

function trackUpgradeCompleted() {
    var _ref, _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_ORDER_COMPLETED + ' event');
    return (0, _track3.default)(_events.EVENT_ORDER_COMPLETED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_CHECKOUT_ID, traits[_traits.TRAIT_CHECKOUT_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_ORDER_ID, traits[_traits.TRAIT_ORDER_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_TOTAL, traits[_traits.TRAIT_TOTAL]), (0, _defineProperty3.default)(_track, _traits.TRAIT_AFFILIATION, _constants.DEFAULT_AFFILIATION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCTS, [(_ref = {}, (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRODUCT_ID, traits[_traits.TRAIT_PRODUCT_ID]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_NAME, traits[_traits.TRAIT_NAME]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_CATEGORY, _constants.CATEGORY_UPGRADE), (0, _defineProperty3.default)(_ref, _traits.TRAIT_PRICE, traits[_traits.TRAIT_PRICE]), (0, _defineProperty3.default)(_ref, _traits.TRAIT_QUANTITY, 1), _ref)]), _track));
}

exports.default = trackUpgradeCompleted;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track2 = __webpack_require__(4);

var _track3 = _interopRequireDefault(_track2);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var _constants = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRODUCT_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_NAME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PRICE, _propTypes3.default.oneOfType([_propTypes3.default.string, _propTypes3.default.number]).isRequired), _propTypes);

function trackUpgradeStarted() {
    var _track;

    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CHECKOUT_STARTED + ' event');
    return (0, _track3.default)(_events.EVENT_CHECKOUT_STARTED, (_track = {}, (0, _defineProperty3.default)(_track, _traits.TRAIT_ORDER_ID, traits[_traits.TRAIT_ORDER_ID]), (0, _defineProperty3.default)(_track, _traits.TRAIT_AFFILIATION, _constants.DEFAULT_AFFILIATION), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_CATEGORY, _constants.CATEGORY_UPGRADE), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_NAME, traits[_traits.TRAIT_PRODUCT_NAME]), (0, _defineProperty3.default)(_track, _traits.TRAIT_PRODUCT_PRICE, traits[_traits.TRAIT_PRODUCT_PRICE]), _track));
}

exports.default = trackUpgradeStarted;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DISCOUNT, _propTypes3.default.string.isRequired), _propTypes);

function trackVoucherCodeApplied() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_COUPON_APPLIED + ' event');
    // TODO
    // import track helper
    // throw an error or track `eventName ERROR`
    // analytics.onload -> logging
    return (0, _track2.default)(_events.EVENT_COUPON_APPLIED, (0, _extends3.default)({}, traits));
}

exports.default = trackVoucherCodeApplied;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON_ID, _propTypes3.default.string.isRequired), _propTypes);

function trackVoucherCodeDenied() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_COUPON_DENIED + ' event');
    return (0, _track2.default)(_events.EVENT_COUPON_DENIED, (0, _extends3.default)({}, traits));
}

exports.default = trackVoucherCodeDenied;

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON_ID, _propTypes3.default.string.isRequired), _propTypes);

function trackVoucherCodeEntered() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_COUPON_ENTERED + ' event');
    return (0, _track2.default)(_events.EVENT_COUPON_ENTERED, (0, _extends3.default)({}, traits));
}

exports.default = trackVoucherCodeEntered;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_ORDER_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_COUPON_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_DISCOUNT, _propTypes3.default.string.isRequired), _propTypes);

function trackVoucherCodeRemoved() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_COUPON_REMOVED + ' event');
    return (0, _track2.default)(_events.EVENT_COUPON_REMOVED, (0, _extends3.default)({}, traits));
}

exports.default = trackVoucherCodeRemoved;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_ID, _propTypes3.default.number.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_RACE_OFFERS_AVAILABLE, _propTypes3.default.string.isRequired), _propTypes);

function trackRaceMatrixClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_RACE_MATRIX_CLICK + ' event');
    return (0, _track2.default)(_events.EVENT_RACE_MATRIX_CLICK, (0, _extends3.default)({}, traits));
}

exports.default = trackRaceMatrixClick;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var traitNames = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), _propTypes);

function trackRacecardOfferAccordionOpened() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_RACECARD_OFFER_ACCORDION_OPENED + ' event');
    return (0, _track2.default)(_events.EVENT_RACECARD_OFFER_ACCORDION_OPENED, (0, _extends3.default)({}, traits));
}

exports.default = trackRacecardOfferAccordionOpened;

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var traitNames = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), _propTypes);

function trackRacecardOfferAccordionClosed() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_RACECARD_OFFER_ACCORDION_CLOSED + ' event');
    return (0, _track2.default)(_events.EVENT_RACECARD_OFFER_ACCORDION_CLOSED, (0, _extends3.default)({}, traits));
}

exports.default = trackRacecardOfferAccordionClosed;

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var traitNames = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_BOOKMAKER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_BOOKMAKER_OFFER, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), _propTypes);

function trackRacecardOfferButtonClicked() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_RACECARD_OFFER_BUTTON_CLICKED + ' event');
    return (0, _track2.default)(_events.EVENT_RACECARD_OFFER_BUTTON_CLICKED, (0, _extends3.default)({}, traits));
}

exports.default = trackRacecardOfferButtonClicked;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

var traitNames = _interopRequireWildcard(_traits);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_OFFERS_AVAILABLE, _propTypes3.default.oneOf(['Yes', 'No'])), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_DATE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACE_TIME, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, traitNames.TRAIT_RACECOURSE, _propTypes3.default.string.isRequired), _propTypes);

function trackCardIndexClick() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_CARD_INDEX_CLICKED + ' event');
    return (0, _track2.default)(_events.EVENT_CARD_INDEX_CLICKED, (0, _extends3.default)({}, traits));
}

exports.default = trackCardIndexClick;

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function trackAllOffers(traits) {
    return (0, _track2.default)(_events.EVENT_ALL_OFFERS_LINK_CLICK, (0, _extends3.default)({}, traits), {}, false, true, true);
}

exports.default = trackAllOffers;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _regenerator = __webpack_require__(73);

var _regenerator2 = _interopRequireDefault(_regenerator);

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _asyncToGenerator2 = __webpack_require__(74);

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var trackFreeBetsTap = function () {
    var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(traits) {
        return _regenerator2.default.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        return _context.abrupt('return', (0, _track2.default)(_events.EVENT_FREE_BETS_TAP, (0, _extends3.default)({}, traits), {}, false, true, true));

                    case 1:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function trackFreeBetsTap(_x) {
        return _ref.apply(this, arguments);
    };
}();

var _events = __webpack_require__(1);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = trackFreeBetsTap;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = __webpack_require__(6);

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = __webpack_require__(3);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _propTypes;

var _propTypes2 = __webpack_require__(0);

var _propTypes3 = _interopRequireDefault(_propTypes2);

var _track = __webpack_require__(4);

var _track2 = _interopRequireDefault(_track);

var _events = __webpack_require__(1);

var _traits = __webpack_require__(2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var propTypes = (_propTypes = {}, (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_PACKAGE, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_BETSLIP_ID, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_LOCATION, _propTypes3.default.string.isRequired), (0, _defineProperty3.default)(_propTypes, _traits.TRAIT_SUBSECTION, _propTypes3.default.string.isRequired), _propTypes);

/**
 * Function to trigger SegmentIO identify event to track subscription sale confirmation
 *
 * @param {Object} traits
 * @returns call of SegmentIO track function
 */
function trackSubscriptionSaleConfirmation() {
    var traits = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    (0, _propTypes2.checkPropTypes)(propTypes, traits, 'trait', _events.EVENT_SUBSCRIPTION_SALE_CONFIRMATION + ' event');

    return (0, _track2.default)(_events.EVENT_SUBSCRIPTION_SALE_CONFIRMATION, (0, _extends3.default)({}, traits));
}

exports.default = trackSubscriptionSaleConfirmation;

/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);
var bind = __webpack_require__(119);
var Axios = __webpack_require__(304);
var defaults = __webpack_require__(76);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(123);
axios.CancelToken = __webpack_require__(318);
axios.isCancel = __webpack_require__(122);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(319);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 303 */
/***/ (function(module, exports) {

/*!
 * Determine if an object is a Buffer
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */

module.exports = function isBuffer (obj) {
  return obj != null && obj.constructor != null &&
    typeof obj.constructor.isBuffer === 'function' && obj.constructor.isBuffer(obj)
}


/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(76);
var utils = __webpack_require__(16);
var InterceptorManager = __webpack_require__(313);
var dispatchRequest = __webpack_require__(314);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, {method: 'get'}, this.defaults, config);
  config.method = config.method.toLowerCase();

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 305 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(121);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.request = request;
  error.response = response;
  return error;
};


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 314 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);
var transformData = __webpack_require__(315);
var isCancel = __webpack_require__(122);
var defaults = __webpack_require__(76);
var isAbsoluteURL = __webpack_require__(316);
var combineURLs = __webpack_require__(317);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 315 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(16);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 318 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(123);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var MPP_ATTRIBUTES = {
    esuitejsEndpoint: {
        selector: '[data-esuitejs-endpoint]',
        defaultValue: 'edeveloperuat.mppglobal.com'
    },
    esuitejsVersion: {
        selector: '[data-esuitejs-version]',
        defaultValue: 'v8'
    },
    esuitejsToken: {
        selector: '[data-esuitejs-token]',
        defaultValue: '46CC6A70007D437688C705F739D431DD'
    },
    esuitejsRestEndpoint: {
        selector: '[data-esuitejs-rest-endpoint]',
        defaultValue: 'https://uat.mppglobal.com'
    },
    esuitejsRestVersion: {
        selector: '[data-esuitejs-rest-version]',
        defaultValue: '9.0.0'
    }
};

exports.default = function () {
    return Object.entries(_extends({}, MPP_ATTRIBUTES)).reduce(function (acc, _ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            key = _ref2[0],
            _ref2$ = _ref2[1],
            selector = _ref2$.selector,
            defaultValue = _ref2$.defaultValue;

        var settings = document.querySelector(selector);

        if (!settings) {
            acc[key] = defaultValue;
        } else {
            acc[key] = settings.dataset[key];
        }

        return acc;
    }, {});
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var parseParams = function parseParams(rawParams) {
    var regexp = /(?:\{\{([a-z]+?) (.+?)}})+?/gi;
    var match = regexp.exec(rawParams);
    var params = {};

    while (match) {
        var _match = match,
            _match2 = _slicedToArray(_match, 3),
            secondMatch = _match2[1],
            thirdMatch = _match2[2];

        params[secondMatch] = thirdMatch;
        match = regexp.exec(rawParams);
    }

    return params;
};

exports.default = parseParams;

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsCookie = __webpack_require__(28);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var COOKIE_NAME = 'x-cookie';

var split = function split(source) {
    var cookies = {};

    source.split(';;').forEach(function (part) {
        cookies[part.split('=')[0]] = part.split('=').slice(1).join('=');
    });

    return cookies;
};

var handleCookie = function handleCookie() {
    var source = _jsCookie2.default.get(COOKIE_NAME);
    var domain = window.location.hostname.split('.').slice(-2).join('.');
    if (!source) {
        return undefined;
    }

    var _split = split(source),
        AccessToken = _split.AccessToken,
        Lightbox = _split.Lightbox;

    if (AccessToken) {
        _jsCookie2.default.set('AccessToken', AccessToken, {
            domain: domain,
            expires: 365
        });
    }

    _jsCookie2.default.remove(COOKIE_NAME, { domain: domain });

    return Lightbox;
};

exports.default = handleCookie;

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createBarriers = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(125);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _reactRedux = __webpack_require__(9);

var _App = __webpack_require__(330);

var _App2 = _interopRequireDefault(_App);

var _AppBarrier = __webpack_require__(422);

var _AppBarrier2 = _interopRequireDefault(_AppBarrier);

var _store = __webpack_require__(140);

var _store2 = _interopRequireDefault(_store);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_reactRedux.Provider, {
    store: _store2.default
}, void 0, _jsx(_App2.default, {}));

var render = function render() {
    _reactDom2.default.render(_ref, document.getElementById('react-rp-auth-root'));
};

var _ref2 = _jsx(_reactRedux.Provider, {
    store: _store2.default
}, void 0, _jsx(_AppBarrier2.default, {}));

var createBarriers = exports.createBarriers = function createBarriers() {
    _reactDom2.default.render(_ref2, document.getElementById('react-rp-auth-root-barriers'));
};

exports.default = render;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(126);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 327 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/* harmony default export */ __webpack_exports__["a"] = (freeGlobal);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(7)))

/***/ }),
/* 328 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = symbolObservablePonyfill;
function symbolObservablePonyfill(root) {
	var result;
	var Symbol = root.Symbol;

	if (typeof Symbol === 'function') {
		if (Symbol.observable) {
			result = Symbol.observable;
		} else {
			result = Symbol('observable');
			Symbol.observable = result;
		}
	} else {
		result = '@@observable';
	}

	return result;
};


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _rpAuthSync = __webpack_require__(78);

var _rpAuthSync2 = _interopRequireDefault(_rpAuthSync);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _NavBtns = __webpack_require__(331);

var _NavBtns2 = _interopRequireDefault(_NavBtns);

var _HamburgerMenuAuthLinks = __webpack_require__(336);

var _HamburgerMenuAuthLinks2 = _interopRequireDefault(_HamburgerMenuAuthLinks);

var _CreatePassword = __webpack_require__(338);

var _CreatePassword2 = _interopRequireDefault(_CreatePassword);

var _ResetPasswordPopup = __webpack_require__(374);

var _ResetPasswordPopup2 = _interopRequireDefault(_ResetPasswordPopup);

var _ForgottenPasswordPopup = __webpack_require__(379);

var _ForgottenPasswordPopup2 = _interopRequireDefault(_ForgottenPasswordPopup);

var _EmailVerificationPopup = __webpack_require__(383);

var _EmailVerificationPopup2 = _interopRequireDefault(_EmailVerificationPopup);

var _ErrorDialogPopup = __webpack_require__(387);

var _ErrorDialogPopup2 = _interopRequireDefault(_ErrorDialogPopup);

var _MandatoryLogin = __webpack_require__(391);

var _MandatoryLogin2 = _interopRequireDefault(_MandatoryLogin);

var _actions = __webpack_require__(12);

var _api = __webpack_require__(15);

__webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref2 = _jsx(_CreatePassword2.default, {});

var _ref3 = _jsx(_ResetPasswordPopup2.default, {});

var _ref4 = _jsx(_ForgottenPasswordPopup2.default, {});

var _ref5 = _jsx(_EmailVerificationPopup2.default, {});

var _ref6 = _jsx(_ErrorDialogPopup2.default, {});

var _ref7 = _jsx(_MandatoryLogin2.default, {});

var App = function (_PureComponent) {
    _inherits(App, _PureComponent);

    function App() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, App);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = App.__proto__ || Object.getPrototypeOf(App)).call.apply(_ref, [this].concat(args))), _this), _this.check = function () {
            if (window.location.hash.indexOf('#forgotten-password') === 0) {
                global.window.authApi.showForgottenPass();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(App, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            _rpAuthSync2.default.run();
            (0, _api.getSession)().then(this.props.dispatchSignIn, this.props.dispatchSignOut);

            this.check();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('hashchange', this.check);
        }
    }, {
        key: 'componentWillUnmont',
        value: function componentWillUnmont() {
            window.removeEventListener('hashchange', this.check);
        }
    }, {
        key: 'render',
        value: function render() {
            return _jsx('div', {
                className: 'ui-flex'
            }, void 0, _jsx(_NavBtns2.default, {
                isLoggedIn: this.props.isLoggedIn
            }), _jsx(_HamburgerMenuAuthLinks2.default, {
                isLoggedIn: this.props.isLoggedIn
            }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
        }
    }]);

    return App;
}(_react.PureComponent);

exports.default = (0, _reactRedux.connect)(function (state) {
    return { isLoggedIn: state.userLoggedIn };
}, {
    dispatchSignIn: _actions.signIn,
    dispatchSignOut: _actions.signOut
})(App);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MyAccountBtn = __webpack_require__(332);

var _MyAccountBtn2 = _interopRequireDefault(_MyAccountBtn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_MyAccountBtn2.default, {
    path: '/subscriptions/my-account'
});

var _ref3 = _jsx(_MyAccountBtn2.default, {
    path: '/api/auth/login/?force=true'
});

var NavBtns = function NavBtns(_ref) {
    var isLoggedIn = _ref.isLoggedIn;
    return isLoggedIn ? _ref2 : _ref3;
};

exports.default = NavBtns;

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _rpAnalytics = __webpack_require__(23);

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _rpUtils = __webpack_require__(72);

var _constants = __webpack_require__(30);

var _myAccountBtn = __webpack_require__(333);

var _myAccountBtn2 = _interopRequireDefault(_myAccountBtn);

var _getDisplayText = __webpack_require__(128);

var _getDisplayText2 = _interopRequireDefault(_getDisplayText);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref3 = _jsx('img', {
    className: 'rn-hamburgerMenu__icon rn-hamburgerMenu__icon--login',
    src: '/svgs/profile_icon.svg',
    alt: 'Account icon'
});

var MyAccountBtn = function (_Component) {
    _inherits(MyAccountBtn, _Component);

    function MyAccountBtn(props) {
        var _this2 = this;

        _classCallCheck(this, MyAccountBtn);

        var _this = _possibleConstructorReturn(this, (MyAccountBtn.__proto__ || Object.getPrototypeOf(MyAccountBtn)).call(this, props));

        _this.fetchUserData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var data, userTraits;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.prev = 0;
                            _context.next = 3;
                            return (0, _rpUtils.getUserMetaData)();

                        case 3:
                            data = _context.sent;

                            if (!(!data || Object.keys(data).length === 0)) {
                                _context.next = 7;
                                break;
                            }

                            _this.setState({
                                firstName: null,
                                hasDataLoaded: true
                            });
                            return _context.abrupt('return');

                        case 7:
                            userTraits = data.userTraits;


                            if (userTraits && Object.keys(userTraits).length > 0) {
                                _this.setState({
                                    firstName: userTraits.firstname || null,
                                    hasDataLoaded: true
                                });
                            } else {
                                _this.setState({
                                    firstName: null,
                                    hasDataLoaded: true
                                });
                            }
                            _context.next = 14;
                            break;

                        case 11:
                            _context.prev = 11;
                            _context.t0 = _context['catch'](0);

                            _this.setState({
                                firstName: null,
                                hasDataLoaded: true
                            });

                        case 14:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2, [[0, 11]]);
        }));

        _this.trackOnClickEvent = function (selectedItem) {
            segmentio.trackNavigationClick(_defineProperty({}, segmentio.TRAIT_SELECTION, selectedItem));
        };

        _this.state = {
            firstName: null,
            hasDataLoaded: false
        };
        return _this;
    }

    _createClass(MyAccountBtn, [{
        key: 'componentDidMount',
        value: function () {
            var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                return regeneratorRuntime.wrap(function _callee2$(_context2) {
                    while (1) {
                        switch (_context2.prev = _context2.next) {
                            case 0:
                                _context2.next = 2;
                                return this.fetchUserData();

                            case 2:
                            case 'end':
                                return _context2.stop();
                        }
                    }
                }, _callee2, this);
            }));

            function componentDidMount() {
                return _ref2.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var path = this.props.path;
            var _state = this.state,
                firstName = _state.firstName,
                hasDataLoaded = _state.hasDataLoaded;


            if (!hasDataLoaded) {
                return null;
            }

            var displayText = (0, _getDisplayText2.default)(this.props.isLoggedIn, firstName);
            var isFirstName = displayText !== _constants.LOG_IN && displayText !== _constants.MY_ACCOUNT;

            return _jsx('div', {
                className: 'rn-topMenu__item'
            }, void 0, _jsx('span', {
                className: _myAccountBtn2.default.myAccountBtn,
                id: 'subscribe-item-top-nav'
            }, void 0, _ref3, _jsx('a', {
                onClick: function onClick() {
                    return _this3.trackOnClickEvent(displayText);
                },
                href: path,
                className: 'ui-link ' + (isFirstName ? _myAccountBtn2.default.normalCase : _myAccountBtn2.default.upperCase)
            }, void 0, _jsx('span', {}, void 0, displayText))));
        }
    }]);

    return MyAccountBtn;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return { isLoggedIn: state.userLoggedIn };
})(MyAccountBtn);

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(334);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./myAccountBtn.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./myAccountBtn.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.myAccountBtn__myAccountBtn___1gR7j {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 2px; }\n  .myAccountBtn__myAccountBtn___1gR7j .myAccountBtn__rn-hamburgerMenu__icon___1Nz0b {\n    width: 20px;\n    height: 20px; }\n  .myAccountBtn__myAccountBtn___1gR7j .myAccountBtn__upperCase___3zbqv {\n    text-transform: uppercase; }\n  .myAccountBtn__myAccountBtn___1gR7j .myAccountBtn__normalCase___3J0Jr {\n    text-transform: none; }\n  .myAccountBtn__myAccountBtn___1gR7j > svg {\n    width: 16px;\n    height: 16px;\n    margin-right: 5px; }\n    @media (max-width: 989.9px) {\n      .myAccountBtn__myAccountBtn___1gR7j > svg {\n        display: none; } }\n", ""]);

// exports
exports.locals = {
	"myAccountBtn": "myAccountBtn__myAccountBtn___1gR7j",
	"rn-hamburgerMenu__icon": "myAccountBtn__rn-hamburgerMenu__icon___1Nz0b",
	"upperCase": "myAccountBtn__upperCase___3zbqv",
	"normalCase": "myAccountBtn__normalCase___3J0Jr"
};

/***/ }),
/* 335 */
/***/ (function(module, exports) {


/**
 * When source maps are enabled, `style-loader` uses a link element with a data-uri to
 * embed the css on the page. This breaks all relative urls because now they are relative to a
 * bundle instead of the current page.
 *
 * One solution is to only use full urls, but that may be impossible.
 *
 * Instead, this function "fixes" the relative urls to be absolute according to the current page location.
 *
 * A rudimentary test suite is located at `test/fixUrls.js` and can be run via the `npm test` command.
 *
 */

module.exports = function (css) {
  // get current location
  var location = typeof window !== "undefined" && window.location;

  if (!location) {
    throw new Error("fixUrls requires window.location");
  }

	// blank or null?
	if (!css || typeof css !== "string") {
	  return css;
  }

  var baseUrl = location.protocol + "//" + location.host;
  var currentDir = baseUrl + location.pathname.replace(/\/[^\/]*$/, "/");

	// convert each url(...)
	/*
	This regular expression is just a way to recursively match brackets within
	a string.

	 /url\s*\(  = Match on the word "url" with any whitespace after it and then a parens
	   (  = Start a capturing group
	     (?:  = Start a non-capturing group
	         [^)(]  = Match anything that isn't a parentheses
	         |  = OR
	         \(  = Match a start parentheses
	             (?:  = Start another non-capturing groups
	                 [^)(]+  = Match anything that isn't a parentheses
	                 |  = OR
	                 \(  = Match a start parentheses
	                     [^)(]*  = Match anything that isn't a parentheses
	                 \)  = Match a end parentheses
	             )  = End Group
              *\) = Match anything and then a close parens
          )  = Close non-capturing group
          *  = Match anything
       )  = Close capturing group
	 \)  = Match a close parens

	 /gi  = Get all matches, not the first.  Be case insensitive.
	 */
	var fixedCss = css.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function(fullMatch, origUrl) {
		// strip quotes (if they exist)
		var unquotedOrigUrl = origUrl
			.trim()
			.replace(/^"(.*)"$/, function(o, $1){ return $1; })
			.replace(/^'(.*)'$/, function(o, $1){ return $1; });

		// already a full url? no change
		if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/|\s*$)/i.test(unquotedOrigUrl)) {
		  return fullMatch;
		}

		// convert the url to a full url
		var newUrl;

		if (unquotedOrigUrl.indexOf("//") === 0) {
		  	//TODO: should we add protocol?
			newUrl = unquotedOrigUrl;
		} else if (unquotedOrigUrl.indexOf("/") === 0) {
			// path should be relative to the base url
			newUrl = baseUrl + unquotedOrigUrl; // already starts with '/'
		} else {
			// path should be relative to current directory
			newUrl = currentDir + unquotedOrigUrl.replace(/^\.\//, ""); // Strip leading './'
		}

		// send back the fixed url(...)
		return "url(" + JSON.stringify(newUrl) + ")";
	});

	// send back the fixed css
	return fixedCss;
};


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HamburgerMenuAuthLinks = __webpack_require__(337);

var _HamburgerMenuAuthLinks2 = _interopRequireDefault(_HamburgerMenuAuthLinks);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HamburgerMenuAuthLinks2.default;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _reactRedux = __webpack_require__(9);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpUtils = __webpack_require__(72);

var _constants = __webpack_require__(30);

var _getDisplayText = __webpack_require__(128);

var _getDisplayText2 = _interopRequireDefault(_getDisplayText);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var HamburgerMenuAuthLinks = function (_Component) {
    _inherits(HamburgerMenuAuthLinks, _Component);

    function HamburgerMenuAuthLinks() {
        _classCallCheck(this, HamburgerMenuAuthLinks);

        return _possibleConstructorReturn(this, (HamburgerMenuAuthLinks.__proto__ || Object.getPrototypeOf(HamburgerMenuAuthLinks)).apply(this, arguments));
    }

    _createClass(HamburgerMenuAuthLinks, [{
        key: 'componentDidMount',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var isLoggedIn, hamburgerParentItem, displayText, userData, isFirstName, link, profileIcon;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                isLoggedIn = this.props.isLoggedIn;
                                hamburgerParentItem = document.getElementById('hamburger-auth');


                                hamburgerParentItem.innerHTML = '';

                                if (!isLoggedIn) {
                                    hamburgerParentItem.classList.add('marginTop');
                                } else {
                                    hamburgerParentItem.classList.remove('marginTop');
                                }

                                displayText = (0, _getDisplayText2.default)(isLoggedIn);

                                if (!isLoggedIn) {
                                    _context.next = 16;
                                    break;
                                }

                                _context.prev = 6;
                                _context.next = 9;
                                return (0, _rpUtils.getUserMetaData)();

                            case 9:
                                userData = _context.sent;

                                if (userData && userData.userTraits) {
                                    displayText = userData.userTraits.firstname || null;
                                }
                                _context.next = 16;
                                break;

                            case 13:
                                _context.prev = 13;
                                _context.t0 = _context['catch'](6);

                                // eslint-disable-next-line no-console
                                console.error('Error fetching user metadata:', _context.t0);
                                // Continue with original displayText if fetch fails

                            case 16:
                                isFirstName = displayText !== _constants.LOG_IN && displayText !== _constants.MY_ACCOUNT;
                                link = document.createElement('a');

                                link.href = isLoggedIn ? '/subscriptions/my-account' : '/api/auth/login/?force=true';
                                link.className = 'rn-hamburgerMenu__link ui-link ui-link_marked bold ' + (isFirstName ? 'normalCase' : 'upperCase');
                                link.style.justifyContent = 'space-between';
                                link.style.textTransform = isFirstName ? 'none' : 'uppercase';
                                link.setAttribute('data-text', displayText);
                                link.textContent = displayText;

                                profileIcon = document.createElement('img');

                                profileIcon.src = '/svgs/profile_icon.svg';
                                profileIcon.className = 'rn-hamburgerMenu__icon rn-hamburgerMenu__icon--login';
                                profileIcon.alt = 'Profile icon';
                                link.appendChild(profileIcon);
                                hamburgerParentItem.appendChild(link);

                            case 30:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this, [[6, 13]]);
            }));

            function componentDidMount() {
                return _ref.apply(this, arguments);
            }

            return componentDidMount;
        }()
    }, {
        key: 'render',
        value: function render() {
            return null;
        }
    }]);

    return HamburgerMenuAuthLinks;
}(_react.Component);

exports.default = (0, _reactRedux.connect)(function (state) {
    return { isLoggedIn: state.userLoggedIn };
})(HamburgerMenuAuthLinks);

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _CreatePassword = __webpack_require__(339);

var _CreatePassword2 = _interopRequireDefault(_CreatePassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CreatePassword2.default;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.CreatePassword = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _Lightbox = __webpack_require__(31);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _CreatePasswordForm = __webpack_require__(343);

var _CreatePasswordForm2 = _interopRequireDefault(_CreatePasswordForm);

var _actions = __webpack_require__(12);

var _modal = __webpack_require__(32);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CreatePassword = exports.CreatePassword = function (_React$Component) {
    _inherits(CreatePassword, _React$Component);

    function CreatePassword() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CreatePassword);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreatePassword.__proto__ || Object.getPrototypeOf(CreatePassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            isVisible: false,
            token: ''
        }, _this.check = function () {
            if (window.location.hash.indexOf('#reset') === 0) {
                _this.setState({
                    isVisible: true,
                    token: window.location.hash.split('=')[1]
                });
                if (!window.history) {
                    window.location.hash = '#' + Math.random();
                } else {
                    window.history.pushState({}, document.title, window.location.href.split('#')[0]);
                }
            }
        }, _this.close = function () {
            _this.setState({
                isVisible: false,
                token: ''
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CreatePassword, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            this.check();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('hashchange', this.check);
        }
    }, {
        key: 'componentWillUnmont',
        value: function componentWillUnmont() {
            window.removeEventListener('hashchange', this.check);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                isVisible = _state.isVisible,
                token = _state.token;
            var showError = this.props.showError;


            if (!isVisible) {
                return null;
            }

            return _jsx(_Lightbox2.default, {
                close: this.close
            }, void 0, _jsx('div', {
                className: _modal2.default.container
            }, void 0, _jsx('h2', {
                className: _modal2.default.title
            }, void 0, 'Create new password'), _jsx('div', {
                className: _modal2.default.content
            }, void 0, _jsx(_CreatePasswordForm2.default, {
                showError: showError,
                close: this.close,
                token: token
            }))));
        }
    }]);

    return CreatePassword;
}(_react2.default.Component);

exports.default = (0, _reactRedux.connect)(null, { showError: _actions.showErrorDialog })(CreatePassword);

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(22);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _lightbox = __webpack_require__(341);

var _lightbox2 = _interopRequireDefault(_lightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'cross',
    size: 'Medium'
});

var Lightbox = function Lightbox(_ref) {
    var close = _ref.close,
        children = _ref.children;

    var overlayContentNode = void 0;

    var initMyAccountRedirect = function initMyAccountRedirect() {
        var path = window.location.pathname;
        var isMyAccountPage = path.replace(/\/$/, '') === '/subscriptions/my-account';

        if (isMyAccountPage) {
            window.location.href = '/';
        }
    };

    var onOutsideClick = function onOutsideClick(event) {
        if (overlayContentNode && !overlayContentNode.contains(event.target)) {
            initMyAccountRedirect();
            close();
        }
    };

    var onCloseBtnClick = function onCloseBtnClick() {
        initMyAccountRedirect();
        close();
    };

    return _jsx('div', {
        role: 'button',
        tabIndex: 0,
        className: 'ui-overlay ' + _lightbox2.default.overlay,
        onClick: onOutsideClick
    }, void 0, _jsx('div', {
        className: 'ui-overlay__container'
    }, void 0, _react2.default.createElement(
        'div',
        {
            className: 'rn-modal lightbox-modal',
            ref: function ref(node) {
                overlayContentNode = node;
            }
        },
        _jsx('button', {
            className: 'ui-reset-for-btn ui-modal__closeBtn ' + _lightbox2.default['close-button'],
            onClick: onCloseBtnClick
        }, void 0, _ref2),
        _jsx('div', {
            className: 'ui-modal__canvas'
        }, void 0, children)
    )));
};

exports.default = Lightbox;

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(342);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./lightbox.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./lightbox.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.lightbox__overlay___1kSfO {\n  z-index: 999; }\n\n.lightbox__close-button___1ofcw {\n  fill: #D9D9D9;\n  padding: 12px; }\n\n@media screen and (min-width: 427px) and (max-width: 768px) {\n  .lightbox__rn-modal___2FD8L .lightbox__lightbox-modal___2IFw7 {\n    width: 360px;\n    height: 220px; } }\n\n@media screen and (min-width: 320px) and (max-width: 426px) {\n  .lightbox__rn-modal___2FD8L .lightbox__lightbox-modal___2IFw7 {\n    width: 300px;\n    margin: auto 10px; } }\n", ""]);

// exports
exports.locals = {
	"overlay": "lightbox__overlay___1kSfO",
	"close-button": "lightbox__close-button___1ofcw",
	"rn-modal": "lightbox__rn-modal___2FD8L",
	"lightbox-modal": "lightbox__lightbox-modal___2IFw7"
};

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormField = __webpack_require__(47);

var _FormField2 = _interopRequireDefault(_FormField);

var _SubmitBtn = __webpack_require__(49);

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _PasswordError = __webpack_require__(82);

var _PasswordError2 = _interopRequireDefault(_PasswordError);

var _validation = __webpack_require__(50);

var _validation2 = _interopRequireDefault(_validation);

var _api = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref3 = _jsx(_PasswordError2.default, {
    className: 'hint'
});

var CreatePasswordForm = function (_Component) {
    _inherits(CreatePasswordForm, _Component);

    function CreatePasswordForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, CreatePasswordForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = CreatePasswordForm.__proto__ || Object.getPrototypeOf(CreatePasswordForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            confirmPasswordError: false,
            passwordError: false,
            loading: false
        }, _this.onSubmit = function (e) {
            e.preventDefault();

            var _this$form = _this.form,
                password = _this$form.password,
                confirmPassword = _this$form.confirmPassword;


            var isFormValid = [password, confirmPassword].map(_this.validate).every(function (isValid) {
                return isValid;
            });

            if (!isFormValid) {
                return;
            }

            _this.setState({ loading: true });

            (0, _api.createUserPassword)(_this.props.token, password.value).then(_this.close).catch(_this.showError);
        }, _this.close = function () {
            _this.setState({ loading: false });
            _this.props.close();
        }, _this.showError = function () {
            _this.setState({ loading: false });
            _this.props.showError('Your password reset link has expired.\n            If you\'re still having problems signing in please\n            try requesting another link or contact customer\n            services on +44 (0)207 748 3771');
        }, _this.validate = function (_ref2) {
            var name = _ref2.name,
                value = _ref2.value;

            var validate = _validation2.default[name];
            var isValid = validate(value, _this.form.password.value);
            _this.setState(_defineProperty({}, name + 'Error', !isValid));
            return isValid;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(CreatePasswordForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                passwordError = _state.passwordError,
                confirmPasswordError = _state.confirmPasswordError,
                loading = _state.loading;


            return _react2.default.createElement(
                'form',
                {
                    onSubmit: this.onSubmit,
                    noValidate: true,
                    ref: function ref(node) {
                        _this2.form = node;
                    }
                },
                _jsx(_FormField2.default, {
                    name: 'password',
                    label: 'Enter a new password',
                    validate: this.validate,
                    hasError: passwordError,
                    error: 'Please enter a valid password',
                    onlyBlur: true
                }),
                _jsx(_FormField2.default, {
                    name: 'confirmPassword',
                    type: 'password',
                    label: 'Confirm your new password',
                    validate: this.validate,
                    hasError: confirmPasswordError,
                    error: 'Passwords do not match',
                    onlyBlur: true
                }, void 0, _ref3),
                _jsx(_SubmitBtn2.default, {
                    label: 'Create',
                    loading: loading
                })
            );
        }
    }]);

    return CreatePasswordForm;
}(_react.Component);

exports.default = CreatePasswordForm;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

var createCompounder = __webpack_require__(345),
    upperFirst = __webpack_require__(363);

/**
 * Converts `string` to
 * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
 *
 * @static
 * @memberOf _
 * @since 3.1.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the start cased string.
 * @example
 *
 * _.startCase('--foo-bar--');
 * // => 'Foo Bar'
 *
 * _.startCase('fooBar');
 * // => 'Foo Bar'
 *
 * _.startCase('__FOO_BAR__');
 * // => 'FOO BAR'
 */
var startCase = createCompounder(function(result, word, index) {
  return result + (index ? ' ' : '') + upperFirst(word);
});

module.exports = startCase;


/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(346),
    deburr = __webpack_require__(347),
    words = __webpack_require__(359);

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]";

/** Used to match apostrophes. */
var reApos = RegExp(rsApos, 'g');

/**
 * Creates a function like `_.camelCase`.
 *
 * @private
 * @param {Function} callback The function to combine each word.
 * @returns {Function} Returns the new compounder function.
 */
function createCompounder(callback) {
  return function(string) {
    return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
  };
}

module.exports = createCompounder;


/***/ }),
/* 346 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

var deburrLetter = __webpack_require__(348),
    toString = __webpack_require__(79);

/** Used to match Latin Unicode letters (excluding mathematical operators). */
var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

/** Used to compose unicode character classes. */
var rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange;

/** Used to compose unicode capture groups. */
var rsCombo = '[' + rsComboRange + ']';

/**
 * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
 * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
 */
var reComboMark = RegExp(rsCombo, 'g');

/**
 * Deburrs `string` by converting
 * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
 * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
 * letters to basic Latin letters and removing
 * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to deburr.
 * @returns {string} Returns the deburred string.
 * @example
 *
 * _.deburr('déjà vu');
 * // => 'deja vu'
 */
function deburr(string) {
  string = toString(string);
  return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
}

module.exports = deburr;


/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

var basePropertyOf = __webpack_require__(349);

/** Used to map Latin Unicode letters to basic Latin letters. */
var deburredLetters = {
  // Latin-1 Supplement block.
  '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
  '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
  '\xc7': 'C',  '\xe7': 'c',
  '\xd0': 'D',  '\xf0': 'd',
  '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
  '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
  '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
  '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
  '\xd1': 'N',  '\xf1': 'n',
  '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
  '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
  '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
  '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
  '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
  '\xc6': 'Ae', '\xe6': 'ae',
  '\xde': 'Th', '\xfe': 'th',
  '\xdf': 'ss',
  // Latin Extended-A block.
  '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
  '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
  '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
  '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
  '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
  '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
  '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
  '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
  '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
  '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
  '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
  '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
  '\u0134': 'J',  '\u0135': 'j',
  '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
  '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
  '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
  '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
  '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
  '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
  '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
  '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
  '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
  '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
  '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
  '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
  '\u0163': 't',  '\u0165': 't', '\u0167': 't',
  '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
  '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
  '\u0174': 'W',  '\u0175': 'w',
  '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
  '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
  '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
  '\u0132': 'IJ', '\u0133': 'ij',
  '\u0152': 'Oe', '\u0153': 'oe',
  '\u0149': "'n", '\u017f': 's'
};

/**
 * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
 * letters to basic Latin letters.
 *
 * @private
 * @param {string} letter The matched letter to deburr.
 * @returns {string} Returns the deburred letter.
 */
var deburrLetter = basePropertyOf(deburredLetters);

module.exports = deburrLetter;


/***/ }),
/* 349 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.propertyOf` without support for deep paths.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyOf(object) {
  return function(key) {
    return object == null ? undefined : object[key];
  };
}

module.exports = basePropertyOf;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80),
    arrayMap = __webpack_require__(353),
    isArray = __webpack_require__(354),
    isSymbol = __webpack_require__(355);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(352);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 353 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 354 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(129),
    isObjectLike = __webpack_require__(358);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(80);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 357 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 358 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

var asciiWords = __webpack_require__(360),
    hasUnicodeWord = __webpack_require__(361),
    toString = __webpack_require__(79),
    unicodeWords = __webpack_require__(362);

/**
 * Splits `string` into an array of its words.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to inspect.
 * @param {RegExp|string} [pattern] The pattern to match words.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {Array} Returns the words of `string`.
 * @example
 *
 * _.words('fred, barney, & pebbles');
 * // => ['fred', 'barney', 'pebbles']
 *
 * _.words('fred, barney, & pebbles', /[^, ]+/g);
 * // => ['fred', 'barney', '&', 'pebbles']
 */
function words(string, pattern, guard) {
  string = toString(string);
  pattern = guard ? undefined : pattern;

  if (pattern === undefined) {
    return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
  }
  return string.match(pattern) || [];
}

module.exports = words;


/***/ }),
/* 360 */
/***/ (function(module, exports) {

/** Used to match words composed of alphanumeric characters. */
var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

/**
 * Splits an ASCII `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function asciiWords(string) {
  return string.match(reAsciiWord) || [];
}

module.exports = asciiWords;


/***/ }),
/* 361 */
/***/ (function(module, exports) {

/** Used to detect strings that need a more robust regexp to match words. */
var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

/**
 * Checks if `string` contains a word composed of Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a word is found, else `false`.
 */
function hasUnicodeWord(string) {
  return reHasUnicodeWord.test(string);
}

module.exports = hasUnicodeWord;


/***/ }),
/* 362 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = '\\u2700-\\u27bf',
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = '\\u2000-\\u206f',
    rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = '\\ufe0e\\ufe0f',
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

/** Used to compose unicode capture groups. */
var rsApos = "['\u2019]",
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq;

/** Used to match complex or compound words. */
var reUnicodeWord = RegExp([
  rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
  rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
  rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
  rsUpper + '+' + rsOptContrUpper,
  rsOrdUpper,
  rsOrdLower,
  rsDigits,
  rsEmoji
].join('|'), 'g');

/**
 * Splits a Unicode `string` into an array of its words.
 *
 * @private
 * @param {string} The string to inspect.
 * @returns {Array} Returns the words of `string`.
 */
function unicodeWords(string) {
  return string.match(reUnicodeWord) || [];
}

module.exports = unicodeWords;


/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(364);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(365),
    hasUnicode = __webpack_require__(130),
    stringToArray = __webpack_require__(367),
    toString = __webpack_require__(79);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(366);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 366 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(368),
    hasUnicode = __webpack_require__(130),
    unicodeToArray = __webpack_require__(369);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 368 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 369 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(129),
    isObject = __webpack_require__(371);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 371 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.fields__label___2HyXF {\n  display: block;\n  font: 14px/19px \"proxima-nova-a\", sans-serif; }\n\n.fields__labelTitle___3r-oo {\n  color: #171717; }\n\n.fields__checkboxIcon___15ALd {\n  position: absolute; }\n\n.fields__labelCheckbox___3zadt {\n  position: relative;\n  display: inline-block;\n  vertical-align: middle;\n  cursor: pointer; }\n  .fields__labelCheckbox___3zadt span {\n    display: block;\n    padding: 0 0 0 32px; }\n  .fields__labelCheckboxText___1TErW {\n    color: #7B7A78; }\n\n.fields__validationWrapper___3D3Kv {\n  position: relative;\n  padding-right: 24px;\n  margin-right: 8px;\n  margin-top: 3px; }\n\n.fields__iconWrapper___3DBgM {\n  position: absolute;\n  top: 0;\n  right: 0;\n  height: 100%; }\n  .fields__iconWrapper___3DBgM svg {\n    height: 100%; }\n\n.fields__icon___O1I5n {\n  display: block;\n  background-size: contain;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  width: 16px;\n  height: 100%; }\n\n.fields__iconError___2WBbV {\n  fill: #D11F25; }\n\n.fields__iconSuccess___2-CLI {\n  fill: #2CB34A; }\n\n.fields__error___FxMe3 {\n  display: block;\n  font: 14px/19px \"proxima-nova-a\", sans-serif;\n  color: #D11F25;\n  margin-top: 8px; }\n\n.fields__commentTitle___3oqGj {\n  display: block;\n  font-family: \"proxima-nova-a-bold\", sans-serif; }\n\n.fields__commentList___2uPWB {\n  margin: 0;\n  padding: 0;\n  list-style: disc inside; }\n\n.fields__buttonContainer___puO3G {\n  padding: 16px; }\n\n.fields__button___3u0VX {\n  width: 100%; }\n\n.fields__submitField___T-_wW {\n  padding: 16px; }\n\n.fields__submit___34l0l {\n  width: 100%; }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .fields__submit___34l0l {\n      display: block;\n      margin: 0 auto;\n      max-width: 304px; } }\n  .fields__submit___34l0l svg {\n    height: 100%; }\n\n.fields__submitActive___3TLb7 {\n  opacity: .6; }\n\n.fields__switchField___38zLD {\n  padding: 0 16px 16px;\n  text-align: center; }\n\n.fields__checkbox___3_nD5 {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer; }\n\n.fields__field___1dXdm.fields__link___3gOtL {\n  padding-left: 0; }\n\n.fields__hint___25qFJ {\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  color: #7B7A78;\n  margin-top: 8px; }\n\n.fields__field___1dXdm {\n  padding: 8px 15px;\n  color: #171717; }\n  .fields__field___1dXdm .ui-input {\n    width: 100%;\n    -webkit-appearance: none;\n    appearance: none; }\n\n.fields__fieldsGroup___10gOH {\n  position: relative;\n  padding: 0 10px 15px 15px; }\n  .fields__fieldsGroup___10gOH .fields__field___1dXdm {\n    padding-left: 0;\n    padding-right: 0; }\n  .fields__fieldsGroup___10gOH .fields__validationWrapper___3D3Kv {\n    padding-right: 0; }\n\n.fields__fieldsGroup___10gOH:after {\n  content: \"\";\n  position: absolute;\n  bottom: 0;\n  height: 1px;\n  width: 90%;\n  background-color: #F0EFF1; }\n\n.fields__fieldsHeader___2vSYc {\n  font-size: 17px; }\n\n.fields__fieldsDelimiter___3vR_h {\n  display: block;\n  padding-top: 12px;\n  padding-bottom: 12px; }\n\n@media screen and (-webkit-min-device-pixel-ratio: 0) {\n  .fields__field___1dXdm .ui-input, .fields__field___1dXdm input.ui-input:focus, .fields__field___1dXdm input.ui-input:hover {\n    font-size: 16px; } }\n\n.RC-mandatoryLogIn .fields__signIn___qhk_N {\n  padding: 0; }\n\n.RC-mandatoryLogIn .fields__signUp___2UIzX {\n  position: absolute;\n  top: 0;\n  right: 0;\n  width: 120px;\n  padding: 0;\n  margin: 16px 16px 0 0;\n  font-size: 16px; }\n  .RC-mandatoryLogIn .fields__signUp___2UIzX .ui-reset-for-btn {\n    text-align: right; }\n", ""]);

// exports
exports.locals = {
	"label": "fields__label___2HyXF",
	"labelTitle": "fields__labelTitle___3r-oo fields__label___2HyXF",
	"checkboxIcon": "fields__checkboxIcon___15ALd",
	"labelCheckbox": "fields__labelCheckbox___3zadt fields__label___2HyXF",
	"labelCheckboxText": "fields__labelCheckboxText___1TErW",
	"validationWrapper": "fields__validationWrapper___3D3Kv",
	"iconWrapper": "fields__iconWrapper___3DBgM",
	"icon": "fields__icon___O1I5n",
	"iconError": "fields__iconError___2WBbV",
	"iconSuccess": "fields__iconSuccess___2-CLI",
	"error": "fields__error___FxMe3",
	"commentTitle": "fields__commentTitle___3oqGj",
	"commentList": "fields__commentList___2uPWB",
	"buttonContainer": "fields__buttonContainer___puO3G",
	"button": "fields__button___3u0VX",
	"submitField": "fields__submitField___T-_wW",
	"submit": "fields__submit___34l0l",
	"submitActive": "fields__submitActive___3TLb7",
	"switchField": "fields__switchField___38zLD",
	"checkbox": "fields__checkbox___3_nD5",
	"field": "fields__field___1dXdm",
	"link": "fields__link___3gOtL",
	"hint": "fields__hint___25qFJ",
	"fieldsGroup": "fields__fieldsGroup___10gOH",
	"fieldsHeader": "fields__fieldsHeader___2vSYc fields__labelTitle___3r-oo fields__label___2HyXF",
	"fieldsDelimiter": "fields__fieldsDelimiter___3vR_h fields__field___1dXdm",
	"signIn": "fields__signIn___qhk_N",
	"signUp": "fields__signUp___2UIzX"
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.modal__container___2q-aa {\n  background-color: #FFFFFF;\n  margin: 0 auto;\n  color: #171717;\n  border-radius: 12px;\n  text-align: center; }\n  .RC-mandatoryLogIn .modal__container___2q-aa {\n    padding: 16px; }\n\n.modal__title___3d9VK {\n  padding: 16px;\n  margin: 0 auto;\n  font: 20px/26px \"proxima-nova-a\", sans-serif;\n  text-align: center;\n  color: #171717; }\n\n.modal__content___35-fc {\n  margin: 0 8px; }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .modal__content___35-fc {\n      width: 464px;\n      margin: 0 auto 8px; } }\n\n.modal__paragraph___1bQON {\n  margin: 0;\n  padding-bottom: 16px; }\n  .modal__paragraph__subtitle___35Kn_ {\n    padding-bottom: 8px;\n    margin: auto;\n    font-family: \"proxima-nova-a-bold\", sans-serif;\n    text-align: center; }\n    @media (min-width: 480px) and (max-width: 719.9px) {\n      .modal__paragraph__subtitle___35Kn_ {\n        width: 400px; } }\n    @media (min-width: 720px) {\n      .modal__paragraph__subtitle___35Kn_ {\n        width: 348px; } }\n\n.modal__form___2tl_S {\n  margin: 0;\n  padding: 0; }\n\n.modal__field___1x69t {\n  padding: 0 0 24px; }\n  .modal__fieldLabel___3iqdw {\n    display: block; }\n    @media (max-width: 479.9px) {\n      .modal__fieldLabel___3iqdw {\n        width: 100%; } }\n  .modal__fieldInput___1Q_bK {\n    width: 248px;\n    margin-right: 16px; }\n    @media (min-width: 480px) and (max-width: 719.9px) {\n      .modal__fieldInput___1Q_bK {\n        width: auto;\n        flex-grow: 1; } }\n\n.modal__button___2hRhc {\n  width: auto;\n  margin: 0; }\n\n.modal__submitActive___bu9Zn {\n  opacity: .6; }\n\n.modal__successTitle___3C94i {\n  padding-bottom: 0;\n  font-family: \"proxima-nova-a\", sans-serif; }\n\n.modal__successContent___2k4nQ {\n  text-align: center;\n  padding-bottom: 24px;\n  white-space: pre-wrap; }\n\n.modal__successIcon___XDNbO {\n  display: block;\n  fill: #2CB34A;\n  margin: 16px auto; }\n\n.modal__description___1i5XU {\n  text-align: center;\n  margin: 8px; }\n\n.modal__barriersTitle___fx_UX {\n  padding: 16px 0;\n  font-family: \"proxima-nova-a\", sans-serif;\n  text-align: left;\n  margin: 0 auto; }\n\n.modal__barriersServices___1l0vD {\n  display: flex;\n  justify-content: center; }\n", ""]);

// exports
exports.locals = {
	"container": "modal__container___2q-aa",
	"title": "modal__title___3d9VK",
	"content": "modal__content___35-fc",
	"paragraph": "modal__paragraph___1bQON",
	"paragraph__subtitle": "modal__paragraph__subtitle___35Kn_",
	"form": "modal__form___2tl_S",
	"field": "modal__field___1x69t",
	"fieldLabel": "modal__fieldLabel___3iqdw",
	"fieldInput": "modal__fieldInput___1Q_bK",
	"button": "modal__button___2hRhc",
	"submitActive": "modal__submitActive___bu9Zn",
	"successTitle": "modal__successTitle___3C94i modal__title___3d9VK",
	"successContent": "modal__successContent___2k4nQ modal__content___35-fc",
	"successIcon": "modal__successIcon___XDNbO",
	"description": "modal__description___1i5XU",
	"barriersTitle": "modal__barriersTitle___fx_UX modal__title___3d9VK",
	"barriersServices": "modal__barriersServices___1l0vD"
};

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ResetPasswordPopup = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _reactRedux = __webpack_require__(9);

var _Lightbox = __webpack_require__(31);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _ResetPasswordForm = __webpack_require__(378);

var _ResetPasswordForm2 = _interopRequireDefault(_ResetPasswordForm);

var _actions = __webpack_require__(12);

var _modal = __webpack_require__(32);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ResetPasswordPopup = exports.ResetPasswordPopup = function ResetPasswordPopup(_ref) {
    var showError = _ref.showError,
        close = _ref.close,
        email = _ref.email;
    return _jsx(_Lightbox2.default, {
        close: close
    }, void 0, _jsx('div', {
        className: _modal2.default.container
    }, void 0, _jsx('h2', {
        className: _modal2.default.title
    }, void 0, 'Reset password'), _jsx('div', {
        className: _modal2.default.content
    }, void 0, _jsx('p', {
        className: _modal2.default.paragraph__subtitle
    }, void 0, 'Please complete the requests below to create and confirm your new password\xA0'), _jsx(_ResetPasswordForm2.default, {
        showError: showError,
        close: close,
        email: email
    }))));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('ResetPasswordPopup'), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showResetPasswo = _ref2.showResetPassword,
        isVisible = _ref2$showResetPasswo.isVisible,
        email = _ref2$showResetPasswo.email;
    return { isVisible: isVisible, email: email };
}, {
    close: _actions.hideResetPassword,
    showError: _actions.showErrorDialog
}), (0, _recompose.branch)(function (_ref3) {
    var isVisible = _ref3.isVisible;
    return !isVisible;
}, _recompose.renderNothing), (0, _recompose.setPropTypes)({
    isVisible: _propTypes2.default.bool.isRequired,
    close: _propTypes2.default.func.isRequired
}))(ResetPasswordPopup);

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 * 
 */

/*eslint-disable no-self-compare */



var hasOwnProperty = Object.prototype.hasOwnProperty;

/**
 * inlined Object.is polyfill to avoid requiring consumers ship their own
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
 */
function is(x, y) {
  // SameValue algorithm
  if (x === y) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    // Added the nonzero y check to make Flow happy, but it is redundant
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    // Step 6.a: NaN == NaN
    return x !== x && y !== y;
  }
}

/**
 * Performs equality by iterating through keys on an object and returning false
 * when any key has values which are not strictly equal between the arguments.
 * Returns true when the values of all keys are strictly equal.
 */
function shallowEqual(objA, objB) {
  if (is(objA, objB)) {
    return true;
  }

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

module.exports = shallowEqual;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var createChangeEmitter = exports.createChangeEmitter = function createChangeEmitter() {
  var currentListeners = [];
  var nextListeners = currentListeners;

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }

  function listen(listener) {
    if (typeof listener !== 'function') {
      throw new Error('Expected listener to be a function.');
    }

    var isSubscribed = true;

    ensureCanMutateNextListeners();
    nextListeners.push(listener);

    return function () {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
    };
  }

  function emit() {
    currentListeners = nextListeners;
    var listeners = currentListeners;
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].apply(listeners, arguments);
    }
  }

  return {
    listen: listen,
    emit: emit
  };
};

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FormField = __webpack_require__(47);

var _FormField2 = _interopRequireDefault(_FormField);

var _SubmitBtn = __webpack_require__(49);

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _PasswordError = __webpack_require__(82);

var _PasswordError2 = _interopRequireDefault(_PasswordError);

var _validation = __webpack_require__(50);

var _validation2 = _interopRequireDefault(_validation);

var _api = __webpack_require__(15);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var errorMessages = {
    password: 'Please enter a valid password',
    newPassword: 'Please enter a valid password',
    confirmPassword: 'Passwords do not match'
};

var _ref3 = _jsx(_PasswordError2.default, {
    className: 'hint'
});

var ResetPasswordForm = function (_Component) {
    _inherits(ResetPasswordForm, _Component);

    function ResetPasswordForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ResetPasswordForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ResetPasswordForm.__proto__ || Object.getPrototypeOf(ResetPasswordForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            passwordError: {
                hasError: false,
                error: ''
            },
            newPasswordError: {
                hasError: false,
                error: ''
            },
            confirmPasswordError: {
                hasError: false,
                error: ''
            },
            loading: false
        }, _this.onSubmit = function (e) {
            e.preventDefault();

            var _this$form = _this.form,
                password = _this$form.password,
                newPassword = _this$form.newPassword,
                confirmPassword = _this$form.confirmPassword;


            var isFormValid = [newPassword, confirmPassword].map(_this.validate).every(function (isValid) {
                return isValid;
            });

            if (!isFormValid) {
                return;
            }

            _this.setState({ loading: true });

            (0, _api.resetUserPassword)(_this.props.email, password.value, newPassword.value).then(function () {
                return _this.close();
            }).catch(function (error) {
                return _this.requestErrorHandler(error);
            });
        }, _this.requestErrorHandler = function (error) {
            if (error && error.response && error.response.data.ErrorNumber === 1009) {
                _this.setState({
                    loading: false,
                    passwordError: {
                        hasError: true,
                        error: 'Current password is invalid'
                    }
                });
            } else {
                _this.showError();
            }
        }, _this.close = function () {
            _this.setState({ loading: false });
            _this.props.close();
        }, _this.showError = function () {
            _this.setState({ loading: false });
            _this.props.showError();
        }, _this.validate = function (_ref2) {
            var name = _ref2.name,
                value = _ref2.value;

            var validate = name === 'password' ? function () {
                return true;
            } : _validation2.default[name];
            var isValid = validate(value, _this.form.newPassword.value);
            _this.setState(_defineProperty({}, name + 'Error', {
                hasError: !isValid,
                error: errorMessages[name]
            }));
            return isValid;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ResetPasswordForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                passwordError = _state.passwordError,
                newPasswordError = _state.newPasswordError,
                confirmPasswordError = _state.confirmPasswordError,
                loading = _state.loading;


            return _react2.default.createElement(
                'form',
                {
                    onSubmit: this.onSubmit,
                    noValidate: true,
                    ref: function ref(node) {
                        _this2.form = node;
                    }
                },
                _react2.default.createElement(_FormField2.default, _extends({
                    name: 'password',
                    label: 'Enter current password',
                    validate: this.validate,
                    noValidate: true
                }, passwordError)),
                _react2.default.createElement(_FormField2.default, _extends({
                    name: 'newPassword',
                    type: 'password',
                    label: 'Enter a new password',
                    validate: this.validate,
                    onlyBlur: true
                }, newPasswordError)),
                _react2.default.createElement(
                    _FormField2.default,
                    _extends({
                        name: 'confirmPassword',
                        type: 'password',
                        label: 'Confirm your new password',
                        validate: this.validate,
                        onlyBlur: true
                    }, confirmPasswordError),
                    _ref3
                ),
                _jsx(_SubmitBtn2.default, {
                    label: 'Create',
                    loading: loading
                })
            );
        }
    }]);

    return ResetPasswordForm;
}(_react.Component);

exports.default = ResetPasswordForm;

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ForgottenPasswordPopup = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _reactRedux = __webpack_require__(9);

var _ForgottenPass = __webpack_require__(380);

var _ForgottenPass2 = _interopRequireDefault(_ForgottenPass);

var _actions = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgottenPasswordPopup = exports.ForgottenPasswordPopup = function ForgottenPasswordPopup(_ref) {
    var close = _ref.close;
    return _jsx(_ForgottenPass2.default, {
        closePopover: close
    });
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('ForgottenPasswordPopup'), (0, _reactRedux.connect)(function (_ref2) {
    var isVisible = _ref2.showForgottenPassword;
    return { isVisible: isVisible };
}, { close: _actions.hideForgottenPassword }), (0, _recompose.branch)(function (_ref3) {
    var isVisible = _ref3.isVisible;
    return !isVisible;
}, _recompose.renderNothing), (0, _recompose.setPropTypes)({
    close: _propTypes2.default.func.isRequired,
    isVisible: _propTypes2.default.bool.isRequired
}))(ForgottenPasswordPopup);

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Lightbox = __webpack_require__(31);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _ForgottenPassword = __webpack_require__(83);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ForgottenPass = function ForgottenPass(_ref) {
    var closePopover = _ref.closePopover;
    return _jsx(_Lightbox2.default, {
        close: closePopover
    }, void 0, _jsx(_ForgottenPassword2.default, {
        close: closePopover
    }));
};

exports.default = ForgottenPass;

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(48);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(22);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _rpAnalytics = __webpack_require__(23);

var _api = __webpack_require__(15);

var _modal = __webpack_require__(32);

var _modal2 = _interopRequireDefault(_modal);

var _PopoverComponent2 = __webpack_require__(382);

var _PopoverComponent3 = _interopRequireDefault(_PopoverComponent2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var onPasswordReset = function onPasswordReset(backUrl, close) {
    (0, _rpAnalytics.identify)().then(function () {
        (0, _rpAnalytics.trackBarrierSignInPassword)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, backUrl));
    }).then(function () {
        return close();
    }).catch(function (err) {
        throw err;
    });
};

function performPasswordReset(email_, back_url_, onSuccess_, onError_, onFinalized_) {
    function onFinalized() {
        if (!onFinalized_) return;

        onFinalized_();
    }

    function onSuccess() {
        onSuccess_();

        if (!back_url_) {
            onFinalized();

            return;
        }

        onPasswordReset(back_url_, onFinalized);
    }

    function onError() {
        if (!onError_) {
            onFinalized_();

            return;
        }

        onError_();

        onFinalized_();
    }

    (0, _api.requestPasswordChange)(email_).then(onSuccess).catch(onError);
}

function constructGlobalAuthApi() {
    global.authApi = global.authApi || {};

    global.authApi.performPasswordReset = performPasswordReset;
}

constructGlobalAuthApi();

var _ref2 = _jsx('a', {
    href: 'mailto:help@racingpost.com',
    className: 'ui-link ui-link_secondary'
}, void 0, 'help@racingpost.com');

var _ref3 = _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'spinner',
    size: 'Large',
    className: 'ui-animation_spinnerAnimation'
});

var ForgottenPassword = function (_PopoverComponent) {
    _inherits(ForgottenPassword, _PopoverComponent);

    function ForgottenPassword() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ForgottenPassword);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ForgottenPassword.__proto__ || Object.getPrototypeOf(ForgottenPassword)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            loading: false
        }, _this.onSubmit = function (event) {
            event.preventDefault();

            var _this$props = _this.props,
                close = _this$props.close,
                backUrl = _this$props.backUrl;
            var email = _this.email.value;


            if (email === '') return;

            _this.setState({ loading: true });

            function onSuccess() {
                this.setState({ loading: false });
            }

            function onError() {
                // close(); // will be closed by onFinalized
            }

            function onFinalized() {
                close();
            }

            performPasswordReset(email, backUrl, onSuccess, onError, onFinalized);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(ForgottenPassword, [{
        key: 'render',


        /* eslint-disable */
        value: function render() {
            var _this2 = this;

            var loading = this.state.loading;

            return _jsx('div', {
                className: _modal2.default.container
            }, void 0, this.props.backLink, _jsx('h2', {
                className: _modal2.default.title
            }, void 0, 'Forgotten Password'), _jsx('div', {
                className: _modal2.default.content
            }, void 0, _jsx('p', {
                className: _modal2.default.paragraph
            }, void 0, 'Please enter the email address that you\u2019ve registered with Racing Post (check your spam folder if it doesn\u2019t appear shortly). If you don\u2019t have the associated email address anymore or you encounter further issues, please contact\xA0', _ref2), _jsx('form', {
                method: 'post',
                action: '/',
                onSubmit: this.onSubmit,
                className: _modal2.default.form,
                noValidate: true
            }, void 0, _jsx('div', {
                className: _modal2.default.field
            }, void 0, _jsx('label', {
                htmlFor: 'input-email',
                className: _modal2.default.fieldLabel
            }, void 0, 'Your Email'), _jsx('div', {
                className: 'ui-flex'
            }, void 0, _react2.default.createElement('input', {
                type: 'email',
                name: 'emailAddress',
                id: 'input-email',
                className: _modal2.default.fieldInput + ' ui-input',
                autoComplete: 'off',
                ref: function ref(node) {
                    _this2.email = node;
                }
            }), _jsx('button', {
                className: (0, _classnames2.default)('ui-btn', 'ui-btn_default', 'ui-btn_primary', _modal2.default.button, _defineProperty({}, _modal2.default.submitActive, loading)),
                type: 'submit',
                id: 'button-pwd-reset'
            }, void 0, loading ? _ref3 : 'Send'))))));
        }
    }]);

    return ForgottenPassword;
}(_PopoverComponent3.default);
/* eslint-enable */

ForgottenPassword.defaultProps = {
    backUrl: undefined,
    backLink: undefined
};

ForgottenPassword.propTypes = {
    close: _propTypes2.default.func.isRequired,
    backUrl: _propTypes2.default.string,
    backLink: _propTypes2.default.node
};

exports.default = ForgottenPassword;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _rpAnalytics = __webpack_require__(23);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverComponent = function (_PureComponent) {
    _inherits(PopoverComponent, _PureComponent);

    function PopoverComponent() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, PopoverComponent);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = PopoverComponent.__proto__ || Object.getPrototypeOf(PopoverComponent)).call.apply(_ref, [this].concat(args))), _this), _this.state = { popoverType: null }, _this.onOutsideClick = function (event) {
            var domNode = _this.node;
            if (!domNode || !domNode.contains(event.target)) {
                _this.closePopover();
            }
        }, _this.closePopover = function () {
            _this.setState({ popoverType: null }); // eslint-disable-line react/no-unused-state
        }, _this.togglePopover = function (popoverType) {
            if (popoverType === 'ForgottenPass') {
                (0, _rpAnalytics.identify)().then(function () {
                    (0, _rpAnalytics.trackBarrierSignInPassword)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, global.location.href));
                });
            }

            _this.setState(function (_ref2) {
                var oldPopoverType = _ref2.popoverType;
                return oldPopoverType === popoverType ? { popoverType: null } : { popoverType: popoverType };
            });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(PopoverComponent, [{
        key: 'componentDidMount',
        // eslint-disable-line react/no-unused-state

        value: function componentDidMount() {
            document.querySelector('.ui-header').classList.add('authModalPopover');

            document.addEventListener('click', this.onOutsideClick, true);
            document.addEventListener('touchstart', this.onOutsideClick, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.querySelector('.ui-header').classList.remove('authModalPopover');

            document.removeEventListener('click', this.onOutsideClick, true);
            document.removeEventListener('touchstart', this.onOutsideClick, true);
        }
    }]);

    return PopoverComponent;
}(_react.PureComponent);

exports.default = PopoverComponent;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmailVerificationPopup = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _reactRedux = __webpack_require__(9);

var _EmailVerificationPopup = __webpack_require__(132);

var _EmailVerificationPopup2 = _interopRequireDefault(_EmailVerificationPopup);

var _actions = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailVerificationPopup = exports.EmailVerificationPopup = function EmailVerificationPopup(_ref) {
    var open = _ref.open,
        close = _ref.close,
        showError = _ref.showError;
    return _jsx(_EmailVerificationPopup2.default, {
        closePopover: close,
        goToSignIn: close,
        goToErrorDialog: function goToErrorDialog() {
            close();showError(null, open);
        }
    });
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EmailVerificationPopup'), (0, _reactRedux.connect)(function (_ref2) {
    var isVisible = _ref2.showEmailVerification.isVisible;
    return { isVisible: isVisible };
}, { open: _actions.showEmailVerification, close: _actions.hideEmailVerification, showError: _actions.showErrorDialog }), (0, _recompose.branch)(function (_ref3) {
    var isVisible = _ref3.isVisible;
    return !isVisible;
}, _recompose.renderNothing), (0, _recompose.setPropTypes)({
    close: _propTypes2.default.func.isRequired,
    isVisible: _propTypes2.default.bool.isRequired
}))(EmailVerificationPopup);

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _api = __webpack_require__(15);

var _EmailVerification = __webpack_require__(385);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailVerification = function EmailVerification(_ref) {
    var email = _ref.email,
        accountId = _ref.accountId,
        session = _ref.session,
        onSuccess = _ref.onSuccess,
        onError = _ref.onError;

    var handleClick = function handleClick() {
        (0, _api.sendVerificationEmail)(accountId, session).then(onSuccess, onError);
    };

    return _jsx('div', {
        className: _EmailVerification2.default.wrapper
    }, void 0, _jsx('h2', {
        className: _EmailVerification2.default.title
    }, void 0, 'Please verify your email address'), _jsx('p', {
        className: _EmailVerification2.default.email
    }, void 0, email), _jsx('p', {
        className: _EmailVerification2.default.paragraph
    }, void 0, 'In order to continue using your Racing Post account we will need to verify the above email address is yours.'), _jsx('p', {
        className: _EmailVerification2.default.paragraph
    }, void 0, 'We will send you an email to the above email address, please click on the link in the email to complete your verification. Please check your junk mail folder if you do not receive the email in your inbox.'), _jsx('button', {
        className: 'ui-btn ui-btn_large ui-btn_primary ' + _EmailVerification2.default.button,
        onClick: handleClick
    }, void 0, 'Continue'), _jsx('p', {
        className: _EmailVerification2.default.copyright
    }, void 0, 'For assistance please contact customer services at help@racingpost.com or call ', _jsx('span', {
        className: _EmailVerification2.default.phone
    }, void 0, '+44 (0) 207 748 3771')));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EmailVerification'), (0, _recompose.setPropTypes)({
    email: _propTypes2.default.string.isRequired,
    accountId: _propTypes2.default.string.isRequired,
    onSuccess: _propTypes2.default.func.isRequired,
    onError: _propTypes2.default.func.isRequired
}))(EmailVerification);

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(386);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./EmailVerification.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./EmailVerification.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.EmailVerification__title___2wXMv {\n  font: 20px/21px \"proxima-nova-a\", sans-serif;\n  margin: 0 auto;\n  padding: 24px 0;\n  text-align: center; }\n\n.EmailVerification__paragraph___11BU_ {\n  font: 14px/19px \"proxima-nova-a\", sans-serif;\n  padding: 0;\n  text-align: center; }\n\n.EmailVerification__button___3effe {\n  margin-top: 24px;\n  margin-bottom: 12px;\n  padding-right: 46px;\n  padding-left: 46px; }\n\n.EmailVerification__wrapper___37MTc {\n  padding: 0 38px 16px;\n  text-align: center;\n  box-sizing: border-box; }\n\n.EmailVerification__email___1DgES {\n  margin-top: 0;\n  font: 20px/26px \"proxima-nova-a\", sans-serif;\n  color: #171717;\n  text-align: center; }\n\n.EmailVerification__copyright___7IvL3 {\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  text-align: center; }\n\n.EmailVerification__phone___2Fros {\n  white-space: nowrap; }\n", ""]);

// exports
exports.locals = {
	"title": "EmailVerification__title___2wXMv",
	"paragraph": "EmailVerification__paragraph___11BU_",
	"button": "EmailVerification__button___3effe",
	"wrapper": "EmailVerification__wrapper___37MTc",
	"email": "EmailVerification__email___1DgES",
	"copyright": "EmailVerification__copyright___7IvL3",
	"phone": "EmailVerification__phone___2Fros"
};

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ErrorDialogPopup = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__(9);

var _recompose = __webpack_require__(8);

var _ErrorPopup = __webpack_require__(134);

var _ErrorPopup2 = _interopRequireDefault(_ErrorPopup);

var _actions = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorDialogPopup = exports.ErrorDialogPopup = function ErrorDialogPopup(_ref) {
    var close = _ref.close,
        message = _ref.message;
    return _jsx(_ErrorPopup2.default, {
        closePopover: function closePopover() {
            close();
        },
        message: message
    });
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('ErrorDialogPopup'), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showErrorDialog = _ref2.showErrorDialog,
        isVisible = _ref2$showErrorDialog.isVisible,
        message = _ref2$showErrorDialog.message;
    return { isVisible: isVisible, message: message };
}, { close: _actions.hideErrorDialog }), (0, _recompose.branch)(function (_ref3) {
    var isVisible = _ref3.isVisible;
    return !isVisible;
}, _recompose.renderNothing), (0, _recompose.setPropTypes)({
    message: _propTypes2.default.string.isRequired,
    isVisible: _propTypes2.default.bool.isRequired,
    close: _propTypes2.default.func.isRequired
}))(ErrorDialogPopup);

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _errorDialog = __webpack_require__(389);

var _errorDialog2 = _interopRequireDefault(_errorDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorDialog = function ErrorDialog(_ref) {
    var goToStep = _ref.goToStep,
        close = _ref.close,
        message = _ref.message;
    return _jsx('div', {
        className: _errorDialog2.default.wrapper
    }, void 0, _jsx('h2', {
        className: _errorDialog2.default.title
    }, void 0, 'Oh no!'), _jsx('p', {
        className: _errorDialog2.default.paragraph
    }, void 0, message || 'Something has gone wrong, please try again.'), _jsx('button', {
        className: 'ui-btn ui-btn_large ui-btn_primary ' + _errorDialog2.default.button,
        onClick: function onClick() {
            return typeof goToStep === 'function' ? goToStep('SignIn') : close();
        }
    }, void 0, 'Try Again'));
};

ErrorDialog.defaultProps = {
    message: ''
};

exports.default = ErrorDialog;

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(390);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./errorDialog.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./errorDialog.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.errorDialog__title___3JzZD {\n  margin: 0 auto;\n  padding: 24px 0;\n  text-align: center; }\n\n.errorDialog__paragraph___1a9dA {\n  padding: 0;\n  text-align: center; }\n\n.errorDialog__button___Za7fG {\n  width: 100%;\n  margin-top: 24px; }\n\n.errorDialog__wrapper___-hcvb {\n  padding: 0 16px 16px;\n  box-sizing: border-box; }\n", ""]);

// exports
exports.locals = {
	"title": "errorDialog__title___3JzZD",
	"paragraph": "errorDialog__paragraph___1a9dA",
	"button": "errorDialog__button___Za7fG",
	"wrapper": "errorDialog__wrapper___-hcvb"
};

/***/ }),
/* 391 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _MandatoryLogin = __webpack_require__(392);

var _MandatoryLogin2 = _interopRequireDefault(_MandatoryLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _MandatoryLogin2.default;

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.MandatoryLogin = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(125);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _reactRedux = __webpack_require__(9);

var _actions = __webpack_require__(12);

var _ForgottenPassword = __webpack_require__(393);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

var _ErrorDialog = __webpack_require__(397);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

var _SignIn = __webpack_require__(399);

var _SignIn2 = _interopRequireDefault(_SignIn);

var _SignUp = __webpack_require__(406);

var _SignUp2 = _interopRequireDefault(_SignUp);

var _SignUpComplete = __webpack_require__(413);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

var _MandatoryLogin = __webpack_require__(419);

var _MandatoryLogin2 = _interopRequireDefault(_MandatoryLogin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var mandatoryLoginSteps = {
    SignIn: _SignIn2.default,
    SignUp: _SignUp2.default,
    ForgottenPassword: _ForgottenPassword2.default,
    SignUpComplete: _SignUpComplete2.default,
    ErrorDialog: _ErrorDialog2.default
};

var MandatoryLogin = exports.MandatoryLogin = function (_PureComponent) {
    _inherits(MandatoryLogin, _PureComponent);

    function MandatoryLogin(props, context) {
        _classCallCheck(this, MandatoryLogin);

        var _this = _possibleConstructorReturn(this, (MandatoryLogin.__proto__ || Object.getPrototypeOf(MandatoryLogin)).call(this, props, context));

        _this.state = {
            prevStep: null,
            step: _this.props.step
        };

        _this.goToStep = _this.goToStep.bind(_this);
        return _this;
    }

    _createClass(MandatoryLogin, [{
        key: 'goToStep',
        value: function goToStep(nextStep) {
            this.setState(function (prevState) {
                return {
                    prevStep: prevState.step,
                    step: nextStep
                };
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var step = this.state.step;
            var _props = this.props,
                target = _props.target,
                close = _props.close;

            var ShownStep = mandatoryLoginSteps[step];

            return (0, _reactDom.createPortal)(_jsx('div', {
                className: _MandatoryLogin2.default.root
            }, void 0, _jsx(ShownStep, {
                goToStep: this.goToStep,
                close: close,
                prevStep: this.state.prevStep
            })), document.querySelector(target));
        }
    }]);

    return MandatoryLogin;
}(_react.PureComponent);

function mergeProps(stateProps, dispatchProps) {
    return _extends({}, stateProps, dispatchProps, {
        onShowMandatoryLogin: function onShowMandatoryLogin(_ref) {
            var _ref$detail = _ref.detail,
                step = _ref$detail.step,
                target = _ref$detail.target;

            dispatchProps.open(step, target);
        },
        onHideMandatoryLogin: function onHideMandatoryLogin() {
            dispatchProps.close();
        }
    });
}

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('MandatoryLogin'), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showMandatoryLo = _ref2.showMandatoryLogin,
        show = _ref2$showMandatoryLo.show,
        step = _ref2$showMandatoryLo.step,
        target = _ref2$showMandatoryLo.target;
    return { show: show, step: step, target: target };
}, { open: _actions.showMandatoryLogin, close: _actions.hideMandatoryLogin }, mergeProps), (0, _recompose.lifecycle)({
    componentWillMount: function componentWillMount() {
        document.addEventListener('rpAuth:ShowMandatoryLogin', this.props.onShowMandatoryLogin);
        document.addEventListener('rpAuth:HideMandatoryLogin', this.props.onHideMandatoryLogin);
    },
    componentDidMount: function componentDidMount() {
        var initializeMandatoryLoginEvent = new CustomEvent('rpAuth:Initialize');
        document.dispatchEvent(initializeMandatoryLoginEvent);
    },
    componentWillUnmount: function componentWillUnmount() {
        document.removeEventListener('rpAuth:ShowMandatoryLogin', this.props.onShowMandatoryLogin);
        document.removeEventListener('rpAuth:HideMandatoryLogin', this.props.onHideMandatoryLogin);
    }
}), (0, _recompose.branch)(function (_ref3) {
    var show = _ref3.show;
    return !show;
}, _recompose.renderNothing), (0, _recompose.setPropTypes)({
    step: _propTypes2.default.string.isRequired,
    target: _propTypes2.default.string.isRequired,
    close: _propTypes2.default.func.isRequired
}))(MandatoryLogin);

/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ForgottenPassword = __webpack_require__(394);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ForgottenPassword2.default;

/***/ }),
/* 394 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(22);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _ForgottenPassword = __webpack_require__(83);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

var _ForgotternPassword = __webpack_require__(395);

var _ForgotternPassword2 = _interopRequireDefault(_ForgotternPassword);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackLink = function BackLink(_ref) {
    var onClick = _ref.onClick;
    return _jsx('button', {
        type: 'button',
        className: 'ui-link ui-link_secondary ui-reset-for-btn',
        onClick: onClick
    }, void 0, _jsx(_rpReactSvgIcon2.default, {
        iconName: 'left',
        size: 'Normal',
        className: _ForgotternPassword2.default.icon
    }), 'Back');
};

var ForgottenPassword = function ForgottenPassword(_ref2) {
    var goToStep = _ref2.goToStep,
        prevStep = _ref2.prevStep;
    return _jsx(_ForgottenPassword2.default, {
        backLink: _jsx(BackLink, {
            onClick: function onClick() {
                return goToStep(prevStep);
            }
        }),
        close: function close() {
            return goToStep(prevStep);
        }
    });
};

exports.default = ForgottenPassword;

/***/ }),
/* 395 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(396);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./ForgotternPassword.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./ForgotternPassword.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 396 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.ForgotternPassword__icon___398ol {\n  margin-right: 4px;\n  fill: #171717; }\n", ""]);

// exports
exports.locals = {
	"icon": "ForgotternPassword__icon___398ol"
};

/***/ }),
/* 397 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ErrorDialog = __webpack_require__(398);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ErrorDialog2.default;

/***/ }),
/* 398 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ErrorDialog = __webpack_require__(84);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ErrorDialog = function ErrorDialog(_ref) {
    var goToStep = _ref.goToStep,
        prevStep = _ref.prevStep;
    return _jsx(_ErrorDialog2.default, {
        close: function close() {
            return goToStep(prevStep);
        }
    });
};

exports.default = ErrorDialog;

/***/ }),
/* 399 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignIn = __webpack_require__(400);

var _SignIn2 = _interopRequireDefault(_SignIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignIn2.default;

/***/ }),
/* 400 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignIn = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _rpReactSvgIcon = __webpack_require__(22);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _analytics = __webpack_require__(51);

var _SignInForm = __webpack_require__(401);

var _SignInForm2 = _interopRequireDefault(_SignInForm);

var _EmailVerificationPopup = __webpack_require__(132);

var _EmailVerificationPopup2 = _interopRequireDefault(_EmailVerificationPopup);

var _ErrorPopup = __webpack_require__(134);

var _ErrorPopup2 = _interopRequireDefault(_ErrorPopup);

var _SignIn = __webpack_require__(404);

var _SignIn2 = _interopRequireDefault(_SignIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchFormLabel = function SwitchFormLabel() {
    return _jsx('span', {}, void 0, _jsx(_rpReactSvgIcon2.default, {
        iconName: 'left',
        size: 'Normal',
        className: _SignIn2.default.icon
    }), 'Back');
};

var _ref2 = _jsx(SwitchFormLabel, {});

var SignIn = exports.SignIn = function SignIn(_ref) {
    var emailVerification = _ref.emailVerification,
        error = _ref.error,
        goToStep = _ref.goToStep,
        showEmailVerification = _ref.showEmailVerification,
        hideEmailVerification = _ref.hideEmailVerification,
        showError = _ref.showError,
        hideError = _ref.hideError;
    return _jsx('div', {
        className: _SignIn2.default.root
    }, void 0, _jsx('h2', {
        className: _SignIn2.default.title
    }, void 0, 'Sign In'), _jsx(_SignInForm2.default, {
        goToSignUp: function goToSignUp() {
            return goToStep('SignUp');
        },
        goToForgottenPass: function goToForgottenPass() {
            return goToStep('ForgottenPassword');
        },
        goToErrorDialog: function goToErrorDialog() {
            return goToStep('ErrorDialog');
        },
        goToEmailVerification: showEmailVerification,
        hidden: false,
        switchFormLabel: _ref2,
        onSignInSuccess: _analytics.onSignInSuccess
    }), emailVerification && !error && _jsx(_EmailVerificationPopup2.default, {
        closePopover: hideEmailVerification,
        goToSignIn: hideEmailVerification,
        goToErrorDialog: showError
    }), error && _jsx(_ErrorPopup2.default, {
        closePopover: hideError
    }));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SignIn'), (0, _recompose.withState)('emailVerification', 'setEmailVerification', false), (0, _recompose.withState)('error', 'setError', false), (0, _recompose.withHandlers)({
    showEmailVerification: function showEmailVerification(_ref3) {
        var setEmailVerification = _ref3.setEmailVerification;
        return function () {
            setEmailVerification(true);
        };
    },
    hideEmailVerification: function hideEmailVerification(_ref4) {
        var setEmailVerification = _ref4.setEmailVerification;
        return function () {
            setEmailVerification(false);
        };
    },
    showError: function showError(_ref5) {
        var setError = _ref5.setError;
        return function () {
            setError(true);
        };
    },
    hideError: function hideError(_ref6) {
        var setError = _ref6.setError;
        return function () {
            setError(false);
        };
    }
}), (0, _recompose.setPropTypes)({
    goToStep: _propTypes2.default.func.isRequired,
    emailVerification: _propTypes2.default.bool.isRequired,
    error: _propTypes2.default.bool.isRequired,
    showEmailVerification: _propTypes2.default.func.isRequired,
    hideEmailVerification: _propTypes2.default.func.isRequired,
    showError: _propTypes2.default.func.isRequired,
    hideError: _propTypes2.default.func.isRequired
}))(SignIn);

/***/ }),
/* 401 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignInForm = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__(9);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpAuthSync = __webpack_require__(78);

var _rpAuthSync2 = _interopRequireDefault(_rpAuthSync);

var _recompose = __webpack_require__(8);

var _actions = __webpack_require__(12);

var _api = __webpack_require__(15);

var _FormField = __webpack_require__(47);

var _FormField2 = _interopRequireDefault(_FormField);

var _PasswordErrorSignIn = __webpack_require__(402);

var _PasswordErrorSignIn2 = _interopRequireDefault(_PasswordErrorSignIn);

var _ForgottenPasswordBtn = __webpack_require__(131);

var _ForgottenPasswordBtn2 = _interopRequireDefault(_ForgottenPasswordBtn);

var _EmailErrorSignIn = __webpack_require__(135);

var _EmailErrorSignIn2 = _interopRequireDefault(_EmailErrorSignIn);

var _SubmitBtn = __webpack_require__(49);

var _SubmitBtn2 = _interopRequireDefault(_SubmitBtn);

var _SwitchFormBtn = __webpack_require__(136);

var _SwitchFormBtn2 = _interopRequireDefault(_SwitchFormBtn);

var _validation = __webpack_require__(50);

var _validation2 = _interopRequireDefault(_validation);

var _forms = __webpack_require__(137);

var _forms2 = _interopRequireDefault(_forms);

var _goToUrl = __webpack_require__(52);

var _goToUrl2 = _interopRequireDefault(_goToUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var counter = 0;

function performSignIn(email_, password_, back_url_, onSignInError_, onSignInLoadComplete_, onSignInSuccess_, goToForgottenPass_, goToEmailVerification_, dispatchSetEmailVerificationData_, goToErrorDialog_) {
    function onSuccess(_ref) {
        var session = _ref.data.session;

        if (!session) return;

        onSignInLoadComplete_();
        (0, _actions.signIn)();
        if (!onSignInSuccess_) return;

        var afterSignInSuccess_ = function afterSignInSuccess_() {
            setTimeout(function () {
                if (back_url_) {
                    (0, _goToUrl2.default)(back_url_);
                } else {
                    _rpAuthSync2.default.reloadAll();
                }
            }, 1000);
        };

        onSignInSuccess_(email_).then(afterSignInSuccess_);
    }

    function onError(error_) {
        if (error_ && error_.response && error_.response.status === 400) {
            onSignInError_();
            onSignInLoadComplete_();

            counter += 1;

            if (counter > 4) goToForgottenPass_();

            return;
        }

        if (error_.accountNotVerified) {
            onSignInLoadComplete_();

            if (!dispatchSetEmailVerificationData_) {
                (0, _actions.setEmailVerificationData)(email_, error_.accountId, error_.session); // mandatory login
            } else {
                dispatchSetEmailVerificationData_(email_, error_.accountId, error_.session);
            }

            goToEmailVerification_(error_.accountId, error_.session);

            return;
        }

        goToErrorDialog_();

        throw error_;
    }

    (0, _api.AuthSignIn)(email_, password_).then(onSuccess, onError).catch(function (error_) {
        throw error_;
    });
}

function constructGlobalAuthApi() {
    global.authApi = global.authApi || {};

    global.authApi.performSignIn = performSignIn;
}

constructGlobalAuthApi();

var SignInForm = exports.SignInForm = function (_Component) {
    _inherits(SignInForm, _Component);

    function SignInForm() {
        var _ref2;

        var _temp, _this, _ret;

        _classCallCheck(this, SignInForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = SignInForm.__proto__ || Object.getPrototypeOf(SignInForm)).call.apply(_ref2, [this].concat(args))), _this), _this.state = {
            emailError: false,
            passwordError: false,
            loading: false,
            signInError: false
        }, _this.onSubmit = function (event_) {
            event_.preventDefault();

            var _this$form = _this.form,
                email = _this$form.email,
                password = _this$form.password;

            var is_form_valid_ = [email, password].map(_this.validate).every(function (isValid) {
                return isValid;
            });

            if (!is_form_valid_) return;

            var _this$props = _this.props,
                backUrl = _this$props.backUrl,
                onSignInSuccess = _this$props.onSignInSuccess,
                goToForgottenPass = _this$props.goToForgottenPass,
                goToEmailVerification = _this$props.goToEmailVerification,
                dispatchSetEmailVerificationData = _this$props.dispatchSetEmailVerificationData,
                goToErrorDialog = _this$props.goToErrorDialog;


            _this.setState({ loading: true });

            var onSignInError_ = function onSignInError_() {
                _this.setState({ signInError: true });
            };

            var onSignInLoadComplete_ = function onSignInLoadComplete_() {
                _this.setState({ loading: false });
            };

            performSignIn(email.value, password.value, backUrl, onSignInError_, onSignInLoadComplete_, onSignInSuccess, goToForgottenPass, goToEmailVerification, dispatchSetEmailVerificationData, goToErrorDialog);
        }, _this.validate = function (_ref3) {
            var name = _ref3.name,
                value = _ref3.value;

            var fieldName = name;
            if (name === 'password') fieldName += 'NotEmpty';
            var validate = _validation2.default[fieldName];
            var isValid = validate(value);
            _this.setState(_defineProperty({}, name + 'Error', !isValid));
            return isValid;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SignInForm, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                emailError = _state.emailError,
                passwordError = _state.passwordError,
                loading = _state.loading,
                signInError = _state.signInError;
            var _props = this.props,
                goToForgottenPass = _props.goToForgottenPass,
                goToSignUp = _props.goToSignUp,
                hidden = _props.hidden,
                switchFormLabel = _props.switchFormLabel;


            return _react2.default.createElement(
                'form',
                {
                    className: _forms2.default.form + ' ' + _forms2.default.signIn,
                    onSubmit: this.onSubmit,
                    noValidate: true,
                    ref: function ref(node) {
                        _this2.form = node;
                    }
                },
                _jsx(_FormField2.default, {
                    name: 'email',
                    validate: this.validate,
                    hasError: emailError,
                    error: _EmailErrorSignIn2.default,
                    onlyBlur: true
                }),
                _jsx(_FormField2.default, {
                    name: 'password',
                    validate: this.validate,
                    hasError: passwordError,
                    error: _PasswordErrorSignIn2.default,
                    onlyBlur: true
                }),
                _jsx(_ForgottenPasswordBtn2.default, {
                    onClick: goToForgottenPass,
                    error: signInError
                }),
                _jsx(_SubmitBtn2.default, {
                    label: 'Sign In',
                    loading: loading
                }),
                _jsx(_SwitchFormBtn2.default, {
                    className: 'signIn',
                    label: switchFormLabel,
                    onClick: goToSignUp,
                    hidden: hidden
                })
            );
        }
    }]);

    return SignInForm;
}(_react.Component);

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SignInForm'), (0, _recompose.defaultProps)({
    backUrl: null,
    switchFormLabel: 'Create account',
    onSignInSuccess: function onSignInSuccess() {
        return null;
    }
}), (0, _reactRedux.connect)(null, {
    dispatchSignIn: _actions.signIn,
    dispatchSetEmailVerificationData: _actions.setEmailVerificationData
}), (0, _recompose.setPropTypes)({
    goToSignUp: _propTypes2.default.func.isRequired,
    goToForgottenPass: _propTypes2.default.func.isRequired,
    goToErrorDialog: _propTypes2.default.func.isRequired,
    goToEmailVerification: _propTypes2.default.func.isRequired,
    dispatchSignIn: _propTypes2.default.func.isRequired,
    dispatchSetEmailVerificationData: _propTypes2.default.func.isRequired,
    hidden: _propTypes2.default.bool.isRequired,
    backUrl: _propTypes2.default.string,
    switchFormLabel: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]),
    onSignInSuccess: _propTypes2.default.func
}))(SignInForm);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 402 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint no-mixed-operators: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('span', {}, void 0, 'Please enter your password');

var PasswordErrorSignIn = function PasswordErrorSignIn() {
    return _jsx('div', {
        className: _fields2.default.comment
    }, void 0, _ref);
};

exports.default = PasswordErrorSignIn;

/***/ }),
/* 403 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, ".RC-mandatoryLogIn .forms__form___3xt5N {\n  flex-grow: 1;\n  display: flex;\n  flex-direction: column; }\n  .RC-mandatoryLogIn .forms__form___3xt5N > *:nth-child(1) {\n    order: 1; }\n  .RC-mandatoryLogIn .forms__form___3xt5N > *:nth-child(2) {\n    order: 2; }\n  .RC-mandatoryLogIn .forms__form___3xt5N > *:nth-child(3) {\n    order: 3; }\n  .RC-mandatoryLogIn .forms__form___3xt5N > *:nth-child(4) {\n    order: 4; }\n  .RC-mandatoryLogIn .forms__form___3xt5N > *:nth-child(5) {\n    order: 5; }\n\n.RC-mandatoryLogIn .forms__signUp___3IrMA > *:nth-child(5) {\n  margin-top: auto; }\n\n.RC-mandatoryLogIn .forms__signIn___EVdcx > *:nth-child(5) {\n  order: 3;\n  margin-top: auto; }\n", ""]);

// exports
exports.locals = {
	"form": "forms__form___3xt5N",
	"signUp": "forms__signUp___3IrMA",
	"signIn": "forms__signIn___EVdcx"
};

/***/ }),
/* 404 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(405);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignIn.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignIn.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 405 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SignIn__root___3pY3A {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-color: #FFFFFF; }\n\n.SignIn__title___3JPBh {\n  margin: 0;\n  padding: 16px 16px 8px;\n  font: 36px/37px \"utopia-std-subh\", serif; }\n\n.SignIn__icon___2RW5f {\n  margin-right: 4px;\n  fill: #171717; }\n", ""]);

// exports
exports.locals = {
	"root": "SignIn__root___3pY3A",
	"title": "SignIn__title___3JPBh",
	"icon": "SignIn__icon___2RW5f"
};

/***/ }),
/* 406 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignUp = __webpack_require__(407);

var _SignUp2 = _interopRequireDefault(_SignUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignUp2.default;

/***/ }),
/* 407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SwitchFormLabel = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _rpReactSvgIcon = __webpack_require__(22);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _SignUpForm = __webpack_require__(138);

var _SignUpForm2 = _interopRequireDefault(_SignUpForm);

var _analytics = __webpack_require__(51);

var _SignUp = __webpack_require__(411);

var _SignUp2 = _interopRequireDefault(_SignUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SwitchFormLabel = exports.SwitchFormLabel = function SwitchFormLabel() {
    return _jsx('span', {}, void 0, _jsx(_rpReactSvgIcon2.default, {
        isInlined: true,
        iconName: 'right',
        size: 'Normal',
        className: _SignUp2.default.icon
    }), 'I already have an account');
};

var _ref2 = _jsx(SwitchFormLabel, {});

var SignUp = function SignUp(_ref) {
    var goToStep = _ref.goToStep;
    return _jsx('div', {
        className: _SignUp2.default.root
    }, void 0, _jsx('h2', {
        className: _SignUp2.default.title
    }, void 0, 'Register'), _jsx(_SignUpForm2.default, {
        goToSignIn: function goToSignIn() {
            return goToStep('SignIn');
        },
        goToForgottenPass: function goToForgottenPass() {
            return goToStep('ForgottenPassword');
        },
        goToSignUpComplete: function goToSignUpComplete() {
            return goToStep('SignUpComplete');
        },
        goToErrorDialog: function goToErrorDialog() {
            return goToStep('ErrorDialog');
        },
        hidden: false,
        disableConditions: true,
        submitLabel: 'Register for FREE',
        switchFormLabel: _ref2,
        onSignUpSuccess: _analytics.onSignUpSuccess
    }));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SignUp'), (0, _recompose.setPropTypes)({
    goToStep: _propTypes2.default.func.isRequired
}))(SignUp);

/***/ }),
/* 408 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CheckField = __webpack_require__(409);

var _CheckField2 = _interopRequireDefault(_CheckField);

var _CheckboxField = __webpack_require__(410);

var _CheckboxField2 = _interopRequireDefault(_CheckboxField);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint max-len: 0 */


var _ref2 = _jsx('a', {
    href: 'https://racingpost.zendesk.com/hc/en-us/articles/208996085-Terms-and-conditions',
    className: 'ui-link ui-link_secondary',
    target: '_blank',
    rel: 'noopener noreferrer'
}, void 0, 'Terms and Conditions');

var _ref3 = _jsx('span', {}, void 0, 'Horseracing betting');

var _ref4 = _jsx('span', {}, void 0, 'Horseracing news');

var _ref5 = _jsx('span', {}, void 0, 'Bloodstock');

var _ref6 = _jsx('span', {}, void 0, 'Football and other sport betting');

var _ref7 = _jsx('span', {}, void 0, 'Competitions, promotions and special offers');

var _ref8 = _jsx(_CheckField2.default, {
    name: 'newsletterThirdParty'
}, void 0, _jsx('span', {}, void 0, 'Carefully selected and relevant third-parties'));

var _ref9 = _jsx('a', {
    href: 'https://racingpost.zendesk.com/hc/en-us/articles/208996085-Terms-and-conditions',
    className: 'ui-link ui-link_secondary',
    target: '_blank',
    rel: 'noopener noreferrer'
}, void 0, 'Terms and Conditions');

var Conditions = function (_Component) {
    _inherits(Conditions, _Component);

    function Conditions(props) {
        _classCallCheck(this, Conditions);

        var _this = _possibleConstructorReturn(this, (Conditions.__proto__ || Object.getPrototypeOf(Conditions)).call(this, props));

        _this.toggleConditions = function (_ref) {
            var checked = _ref.checked,
                name = _ref.name;

            var currentState = _this.state;
            currentState[name] = checked;

            _this.setState(_defineProperty({}, name, checked));
        };

        _this.state = {
            horseBetting: false,
            horseNews: false,
            bloodstock: false,
            sportBetting: false,
            competitions: false
        };
        return _this;
    }

    _createClass(Conditions, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                validate = _props.validate,
                termsConditionsError = _props.termsConditionsError;
            var _state = this.state,
                bloodstock = _state.bloodstock,
                sportBetting = _state.sportBetting,
                competitions = _state.competitions,
                horseBetting = _state.horseBetting,
                horseNews = _state.horseNews;


            return _jsx('div', {}, void 0, this.props.disableConditions ? _jsx(_CheckField2.default, {
                name: 'termsConditions',
                validate: validate,
                hasError: termsConditionsError,
                errorText: 'You need to agree to our terms and conditions to register'
            }, void 0, _jsx('span', {
                className: _fields2.default.labelTitle
            }, void 0, 'I accept the\xA0', _ref2)) : _jsx(_react.Fragment, {}, void 0, _jsx('div', {
                className: _fields2.default.fieldsGroup
            }, void 0, _jsx('h2', {
                className: _fields2.default.fieldsHeader
            }, void 0, 'Email Communication'), _jsx(_CheckboxField2.default, {
                name: 'horseBetting',
                checked: horseBetting,
                onCheck: this.toggleConditions
            }, void 0, _ref3), _jsx(_CheckboxField2.default, {
                name: 'horseNews',
                checked: horseNews,
                onCheck: this.toggleConditions
            }, void 0, _ref4), _jsx(_CheckboxField2.default, {
                name: 'bloodstock',
                checked: bloodstock,
                onCheck: this.toggleConditions
            }, void 0, _ref5), _jsx(_CheckboxField2.default, {
                name: 'sportBetting',
                checked: sportBetting,
                onCheck: this.toggleConditions
            }, void 0, _ref6), _jsx(_CheckboxField2.default, {
                name: 'competitions',
                checked: competitions,
                onCheck: this.toggleConditions
            }, void 0, _ref7)), _jsx('div', {
                className: _fields2.default.fieldsGroup
            }, void 0, _jsx('h2', {
                className: _fields2.default.fieldsHeader
            }, void 0, 'Third-party Communication'), _ref8), _jsx(_CheckField2.default, {
                name: 'eighteenYears'
            }, void 0, _jsx('span', {
                className: _fields2.default.labelTitle
            }, void 0, '18+'), _jsx('span', {
                className: _fields2.default.labelCheckboxText
            }, void 0, 'I confirm I am 18 years old or over')), _jsx(_CheckField2.default, {
                name: 'termsConditions',
                validate: validate,
                hasError: termsConditionsError,
                errorText: 'You need to agree to our terms and conditions to register'
            }, void 0, _jsx('span', {
                className: _fields2.default.labelTitle
            }, void 0, 'I accept the\xA0', _ref9))));
        }
    }]);

    return Conditions;
}(_react.Component);

Conditions.defaultProps = {
    disableConditions: false
};

exports.default = Conditions;

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ValidationIcon = __webpack_require__(81);

var _ValidationIcon2 = _interopRequireDefault(_ValidationIcon);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var id = function id(name) {
    return 'rp-auth-input-' + name;
};

var CheckField = function CheckField(_ref) {
    var hasError = _ref.hasError,
        validate = _ref.validate,
        children = _ref.children,
        errorText = _ref.errorText,
        name = _ref.name,
        checked = _ref.checked;
    return _jsx('div', {
        className: _fields2.default.field
    }, void 0, _jsx('div', {
        className: _fields2.default.validationWrapper
    }, void 0, _jsx('input', {
        type: 'checkbox',
        name: name,
        className: _fields2.default.checkbox + ' ui-checkbox_input',
        onChange: function onChange(e) {
            return validate(e.target);
        },
        defaultChecked: checked,
        id: id(name)
    }), _jsx('div', {
        className: _fields2.default.checkboxIcon + ' ui-checkbox'
    }), _jsx('label', {
        className: _fields2.default.labelCheckbox,
        htmlFor: id(name)
    }, void 0, children), hasError && _jsx(_ValidationIcon2.default, {
        hasError: hasError
    })), hasError && _jsx('div', {
        className: _fields2.default.error
    }, void 0, errorText));
};

CheckField.defaultProps = {
    hasError: false,
    validate: function validate() {
        return null;
    },
    errorText: '',
    checked: false
};

exports.default = CheckField;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ValidationIcon = __webpack_require__(81);

var _ValidationIcon2 = _interopRequireDefault(_ValidationIcon);

var _fields = __webpack_require__(19);

var _fields2 = _interopRequireDefault(_fields);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var id = function id(name) {
    return 'rp-auth-input-' + name;
};

var CheckboxField = function (_PureComponent) {
    _inherits(CheckboxField, _PureComponent);

    function CheckboxField(props) {
        _classCallCheck(this, CheckboxField);

        var _this = _possibleConstructorReturn(this, (CheckboxField.__proto__ || Object.getPrototypeOf(CheckboxField)).call(this, props));

        _this.state = {
            checked: _this.props.checked || false
        };
        return _this;
    }

    _createClass(CheckboxField, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            this.setState({ checked: nextProps.checked });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                hasError = _props.hasError,
                validate = _props.validate,
                children = _props.children,
                errorText = _props.errorText,
                name = _props.name,
                onCheck = _props.onCheck;

            return _jsx('div', {
                className: _fields2.default.field
            }, void 0, _jsx('div', {
                className: _fields2.default.validationWrapper
            }, void 0, _jsx('input', {
                type: 'checkbox',
                name: name,
                className: _fields2.default.checkbox + ' ui-checkbox_input',
                onChange: function onChange(e) {
                    _this2.setState({ checked: e.target.checked });
                    if (onCheck) {
                        onCheck(e.target);
                    }
                    validate(e.target);
                },
                checked: this.state.checked,
                id: id(name)
            }), _jsx('div', {
                className: _fields2.default.checkboxIcon + ' ui-checkbox'
            }), _jsx('label', {
                className: _fields2.default.labelCheckbox,
                htmlFor: id(name)
            }, void 0, children), hasError && _jsx(_ValidationIcon2.default, {
                hasError: hasError
            })), hasError && _jsx('div', {
                className: _fields2.default.error
            }, void 0, errorText));
        }
    }]);

    return CheckboxField;
}(_react.PureComponent);

CheckboxField.defaultProps = {
    hasError: false,
    validate: function validate() {
        return null;
    },
    errorText: '',
    checked: false,
    onCheck: undefined
};

exports.default = CheckboxField;

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(412);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignUp.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignUp.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SignUp__root___lBkgu {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background-color: #FFFFFF; }\n\n.SignUp__title___2A6Ra {\n  margin: 0;\n  padding: 16px 16px 8px;\n  font: 36px/37px \"utopia-std-subh\", serif; }\n\n.SignUp__icon___hprUn {\n  margin-right: 4px;\n  fill: #171717; }\n", ""]);

// exports
exports.locals = {
	"root": "SignUp__root___lBkgu",
	"title": "SignUp__title___2A6Ra",
	"icon": "SignUp__icon___hprUn"
};

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignUpComplete = __webpack_require__(414);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignUpComplete2.default;

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignUpComplete = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SignUpComplete = __webpack_require__(415);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref2 = _jsx('br', {});

var SignUpComplete = exports.SignUpComplete = function (_PureComponent) {
    _inherits(SignUpComplete, _PureComponent);

    function SignUpComplete() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SignUpComplete);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SignUpComplete.__proto__ || Object.getPrototypeOf(SignUpComplete)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            _this.props.close();
            var closeEvent = new CustomEvent('rpAuth:Close', {
                detail: {
                    status: 'success'
                },
                bubbles: true,
                cancelable: false
            });

            document.dispatchEvent(closeEvent);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SignUpComplete, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var successEvent = new CustomEvent('rpAuth:SignUp', {
                detail: {
                    status: 'success'
                },
                bubbles: true,
                cancelable: false
            });

            document.dispatchEvent(successEvent);
        }
    }, {
        key: 'render',
        value: function render() {
            return _jsx('div', {
                className: _SignUpComplete2.default.root
            }, void 0, _jsx('h2', {
                className: _SignUpComplete2.default.successTitle
            }, void 0, 'Sign up complete'), _jsx('div', {
                className: _SignUpComplete2.default.icon
            }), _jsx('p', {
                className: _SignUpComplete2.default.successContent
            }, void 0, 'Thank you for signing up ', _ref2, 'An email has been sent to you to confirm your registration'), _jsx('button', {
                type: 'button',
                className: 'ui-btn ui-btn_large ui-btn_primary',
                onClick: this.handleClick
            }, void 0, 'Continue to Racing Post'));
        }
    }]);

    return SignUpComplete;
}(_react.PureComponent);

exports.default = SignUpComplete;

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(416);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignUpComplete.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignUpComplete.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 416 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(417);
exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SignUpComplete__root___-N13a {\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  height: 100%; }\n\n.SignUpComplete__icon___XDkTM {\n  background-image: url(" + escape(__webpack_require__(418)) + ");\n  width: 150px;\n  height: 150px;\n  background-size: contain;\n  align-self: center;\n  margin: auto; }\n\n.SignUpComplete__title___12a5o {\n  margin: 0 auto;\n  padding: 24px 0 8px;\n  font: 20px/26px \"proxima-nova-a-bold\", sans-serif;\n  text-align: center;\n  color: #171717; }\n  @media (min-width: 720px) {\n    .SignUpComplete__title___12a5o {\n      padding: 24px 0 16px; } }\n\n.SignUpComplete__content___3TOVe {\n  margin: 0 8px; }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SignUpComplete__content___3TOVe {\n      width: 464px;\n      margin: 0 auto 8px; } }\n\n.SignUpComplete__successTitle___1M7BR {\n  padding-bottom: 0;\n  font-family: \"proxima-nova-a\", sans-serif; }\n\n.SignUpComplete__successContent___9Oikx {\n  text-align: center;\n  padding-bottom: 24px;\n  white-space: pre-wrap; }\n", ""]);

// exports
exports.locals = {
	"root": "SignUpComplete__root___-N13a",
	"icon": "SignUpComplete__icon___XDkTM",
	"title": "SignUpComplete__title___12a5o",
	"content": "SignUpComplete__content___3TOVe",
	"successTitle": "SignUpComplete__successTitle___1M7BR SignUpComplete__title___12a5o",
	"successContent": "SignUpComplete__successContent___9Oikx SignUpComplete__content___3TOVe"
};

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = function escape(url) {
    if (typeof url !== 'string') {
        return url
    }
    // If url is already wrapped in quotes, remove them
    if (/^['"].*['"]$/.test(url)) {
        url = url.slice(1, -1);
    }
    // Should url be wrapped?
    // See https://drafts.csswg.org/css-values-3/#urls
    if (/["'() \t\n]/.test(url)) {
        return '"' + url.replace(/"/g, '\\"').replace(/\n/g, '\\n') + '"'
    }

    return url
}


/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 419 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(420);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/sass-loader/lib/loader.js!./MandatoryLogin.scss", function() {
		var newContent = require("!!../../node_modules/css-loader/index.js??ref--3-1!../../node_modules/sass-loader/lib/loader.js!./MandatoryLogin.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, ".MandatoryLogin__root___2WvPw {\n  height: 100%; }\n", ""]);

// exports
exports.locals = {
	"root": "MandatoryLogin__root___2WvPw"
};

/***/ }),
/* 421 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.rpAuthRoot {\n  justify-content: center; }\n  @media (max-width: 719.9px) {\n    .rpAuthRoot {\n      width: 20%; }\n      .rpAuthRoot .rn-menuBar__navItem {\n        width: 100%;\n        border: none; } }\n  .rpAuthRoot .ui-flex {\n    height: 100%;\n    width: 100%; }\n\n@media (max-width: 719.9px) {\n  .authModalPopover .rn-canvas {\n    position: static; } }\n", ""]);

// exports


/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _rpAuthSync = __webpack_require__(78);

var _rpAuthSync2 = _interopRequireDefault(_rpAuthSync);

var _Barrier = __webpack_require__(423);

var _Barrier2 = _interopRequireDefault(_Barrier);

__webpack_require__(139);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('div', {
    className: 'ui-flex'
}, void 0, _jsx(_Barrier2.default, {}));

var AppBarrier = function (_React$Component) {
    _inherits(AppBarrier, _React$Component);

    function AppBarrier() {
        _classCallCheck(this, AppBarrier);

        return _possibleConstructorReturn(this, (AppBarrier.__proto__ || Object.getPrototypeOf(AppBarrier)).apply(this, arguments));
    }

    _createClass(AppBarrier, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            _rpAuthSync2.default.run();
        }
    }, {
        key: 'render',
        value: function render() {
            return _ref;
        }
    }]);

    return AppBarrier;
}(_react2.default.Component);

exports.default = AppBarrier;

/***/ }),
/* 423 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Barrier = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _reactRedux = __webpack_require__(9);

var _BarrierContent = __webpack_require__(424);

var _BarrierContent2 = _interopRequireDefault(_BarrierContent);

var _Lightbox = __webpack_require__(31);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _actions = __webpack_require__(12);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var Barrier = exports.Barrier = function (_React$Component) {
    _inherits(Barrier, _React$Component);

    function Barrier(props) {
        _classCallCheck(this, Barrier);

        var _this = _possibleConstructorReturn(this, (Barrier.__proto__ || Object.getPrototypeOf(Barrier)).call(this, props));

        _this.goToStep = function (nextStep) {
            _this.setState({ step: nextStep });
        };

        _this.state = {
            step: props.step
        };
        return _this;
    }

    _createClass(Barrier, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var step = _ref.step;

            if (step !== this.state.step) {
                this.goToStep(step);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                show = _props.show,
                _close = _props.close,
                backUrl = _props.backUrl,
                showTitle = _props.showTitle;
            var step = this.state.step;

            return show ? _jsx(_Lightbox2.default, {
                close: function close() {
                    if (_this2.state.step === 'SignUpComplete') {
                        _this2.goToStep('SignIn');
                    } else {
                        _close();
                    }
                }
            }, void 0, _jsx(_BarrierContent2.default, {
                step: step,
                close: _close,
                backUrl: backUrl,
                onStepChange: this.goToStep,
                showTitle: showTitle
            })) : null;
        }
    }]);

    return Barrier;
}(_react2.default.Component);

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Barrier'), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showBarrier = _ref2.showBarrier,
        show = _ref2$showBarrier.show,
        step = _ref2$showBarrier.step,
        backUrl = _ref2$showBarrier.backUrl,
        showTitle = _ref2$showBarrier.showTitle;
    return {
        show: show, step: step, backUrl: backUrl, showTitle: showTitle
    };
}, { close: _actions.hideBarriers }), (0, _recompose.setPropTypes)({
    show: _propTypes2.default.bool.isRequired,
    close: _propTypes2.default.func.isRequired,
    step: _propTypes2.default.string.isRequired,
    backUrl: _propTypes2.default.string,
    showTitle: _propTypes2.default.bool.isRequired
}))(Barrier);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BarrierContent = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _rpAnalytics = __webpack_require__(23);

var _Subscriptions = __webpack_require__(425);

var _Subscriptions2 = _interopRequireDefault(_Subscriptions);

var _ForgottenPassword = __webpack_require__(83);

var _ForgottenPassword2 = _interopRequireDefault(_ForgottenPassword);

var _SignUpComplete = __webpack_require__(428);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

var _ErrorDialog = __webpack_require__(84);

var _ErrorDialog2 = _interopRequireDefault(_ErrorDialog);

var _EmailVerification = __webpack_require__(430);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

var _SignIn = __webpack_require__(432);

var _SignIn2 = _interopRequireDefault(_SignIn);

var _SignUp = __webpack_require__(436);

var _SignUp2 = _interopRequireDefault(_SignUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var barrierSteps = {
    Subscriptions: _Subscriptions2.default,
    SignIn: _SignIn2.default,
    SignUp: _SignUp2.default,
    ForgottenPassword: _ForgottenPassword2.default,
    SignUpComplete: _SignUpComplete2.default,
    ErrorDialog: _ErrorDialog2.default,
    EmailVerification: _EmailVerification2.default
};

var BarrierContent = exports.BarrierContent = function (_PureComponent) {
    _inherits(BarrierContent, _PureComponent);

    function BarrierContent(props) {
        _classCallCheck(this, BarrierContent);

        var _this = _possibleConstructorReturn(this, (BarrierContent.__proto__ || Object.getPrototypeOf(BarrierContent)).call(this, props));

        _this.goToStep = function (step) {
            _this.setState({ step: step }, function () {
                _this.props.onStepChange(_this.state.step);
            });

            if (step === 'Subscriptions') {
                (0, _rpAnalytics.identify)().then(function () {
                    return (0, _rpAnalytics.trackBarrierShow)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, _this.props.backUrl));
                });
            } else if (step === 'ForgottenPassword') {
                (0, _rpAnalytics.trackBarrierSignInPassword)(_defineProperty({}, _rpAnalytics.TRAIT_LOCATION, _this.props.backUrl));
            }
        };

        _this.state = {
            step: _this.props.step
        };
        return _this;
    }

    _createClass(BarrierContent, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var step = _ref.step;

            if (step === 'SignIn') {
                this.goToStep('SignIn');
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var step = this.state.step;
            var _props = this.props,
                backUrl = _props.backUrl,
                close = _props.close,
                showTitle = _props.showTitle;

            var ShownStep = barrierSteps[step];

            return _jsx(ShownStep, {
                goToStep: this.goToStep,
                backUrl: backUrl,
                close: close,
                showTitle: showTitle
            });
        }
    }]);

    return BarrierContent;
}(_react.PureComponent);

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('BarrierContent'), (0, _recompose.setPropTypes)({
    step: _propTypes2.default.string.isRequired,
    backUrl: _propTypes2.default.string,
    close: _propTypes2.default.func.isRequired,
    onStepChange: _propTypes2.default.func.isRequired,
    showTitle: _propTypes2.default.bool.isRequired
}), (0, _recompose.defaultProps)({
    backUrl: undefined
}))(BarrierContent);

/***/ }),
/* 425 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Subscriptions = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _rpAnalytics = __webpack_require__(23);

var _reactRedux = __webpack_require__(9);

var _rpReactSvgIcon = __webpack_require__(22);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _goToUrl = __webpack_require__(52);

var _goToUrl2 = _interopRequireDefault(_goToUrl);

var _Subscriptions = __webpack_require__(426);

var _Subscriptions2 = _interopRequireDefault(_Subscriptions);

var _modal = __webpack_require__(32);

var _modal2 = _interopRequireDefault(_modal);

var _api = __webpack_require__(15);

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prop-types: 0 */


var Subscriptions = exports.Subscriptions = function (_PureComponent) {
    _inherits(Subscriptions, _PureComponent);

    function Subscriptions(props) {
        var _this2 = this;

        _classCallCheck(this, Subscriptions);

        var _this = _possibleConstructorReturn(this, (Subscriptions.__proto__ || Object.getPrototypeOf(Subscriptions)).call(this, props));

        _this.componentDidMount = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
            var session;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while (1) {
                    switch (_context.prev = _context.next) {
                        case 0:
                            _context.next = 2;
                            return (0, _api.getSessionStatus)();

                        case 2:
                            session = _context.sent;


                            _this.setState({
                                isShortSessionExpired: session.sessionStatus ? session.sessionStatus.shortSessionActive : false
                            });

                        case 4:
                        case 'end':
                            return _context.stop();
                    }
                }
            }, _callee, _this2);
        }));

        _this.handleButtonClick = function (e, urlPath, btnDisplayText) {
            var identifyAction = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

            e.preventDefault();

            var trackAndRedicrect = function trackAndRedicrect() {
                (0, _rpAnalytics.trackBarrierInteraction)(_defineProperty({}, _rpAnalytics.TRAIT_SELECTION, btnDisplayText));
                (0, _goToUrl2.default)('' + global.location.origin + urlPath);
            };

            if (identifyAction) {
                (0, _rpAnalytics.identify)().then(trackAndRedicrect);
            } else {
                trackAndRedicrect();
            }
        };

        _this.state = {
            isShortSessionExpired: false
        };
        return _this;
    }

    _createClass(Subscriptions, [{
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props = this.props,
                text = _props.text,
                step = _props.step,
                backUrl = _props.backUrl;

            var userRole = localStorage.getItem('userRole');
            var isFreeTrial = sessionStorage.getItem('isFreeTrial') === 'true';
            var buttonText = isFreeTrial ? 'Sign up' : 'Subscribe';
            if (userRole === _constants.TIPPING || userRole === _constants.INSIGHTS || userRole === _constants.ESSENTIAL) buttonText = 'Upgrade';
            var subscribeUrl = isFreeTrial ? '/api/auth/login/?signup=true&state=' + btoa(window.location.href) + '&force=true' : '/subscriptions';
            var loginUrl = '/api/auth/login/?state=' + btoa(backUrl || '') + '&force=true';

            return _jsx('div', {
                className: _modal2.default.container + ' ' + _Subscriptions2.default.container
            }, void 0, _jsx('div', {}, void 0, _jsx('div', {
                className: _Subscriptions2.default['barrier-cover']
            }), _jsx('div', {
                className: _Subscriptions2.default['barrier-heading']
            }, void 0, _jsx('div', {
                className: _Subscriptions2.default['barrier-lock']
            }, void 0, _jsx(_rpReactSvgIcon2.default, {
                iconName: 'premium-lock',
                className: _Subscriptions2.default['icon-lock']
            })))), _jsx('img', {
                src: '/svgs/racing_post_plus_logo.svg',
                className: _Subscriptions2.default['barrier-logo'],
                alt: 'barrier-rp-logo-plus'
            }), _jsx('h2', {
                className: _modal2.default.barriersTitle + ' ' + _Subscriptions2.default['barrier-content']
            }, void 0, text && step === 'Subscriptions' && (text.indexOf('^') !== -1 ? text.split('^').map(function (txt) {
                return _jsx('div', {}, txt, txt);
            }) : text), !text && 'Subscribe now to see this premium content'), _jsx('button', {
                className: 'js-popup-link ui-btn ui-btn_primary ui-btn_large ' + _Subscriptions2.default.btn,
                onClick: function onClick(e) {
                    return _this3.handleButtonClick(e, subscribeUrl, buttonText, true);
                }
            }, void 0, buttonText), !this.state.isShortSessionExpired && _jsx('div', {
                className: _Subscriptions2.default.footer
            }, void 0, isFreeTrial ? 'Already have an account?' : 'Already a subscriber?', _jsx('button', {
                className: 'ui-reset-for-btn ui-link ui-link_primary ' + _Subscriptions2.default.link,
                onClick: function onClick(e) {
                    return _this3.handleButtonClick(e, loginUrl, 'Login');
                }
            }, void 0, 'Log in')));
        }
    }]);

    return Subscriptions;
}(_react.PureComponent);

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('Subscriptions'), (0, _recompose.setPropTypes)({
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        id: _propTypes2.default.number.isRequired,
        title: _propTypes2.default.string.isRequired,
        description: _propTypes2.default.string.isRequired,
        features: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
        priceId: _propTypes2.default.number.isRequired,
        price: _propTypes2.default.string.isRequired,
        pricePerMonth: _propTypes2.default.string.isRequired,
        period: _propTypes2.default.number.isRequired,
        periodUnit: _propTypes2.default.string.isRequired
    })).isRequired,
    userLoggedIn: _propTypes2.default.bool.isRequired,
    text: _propTypes2.default.string.isRequired,
    step: _propTypes2.default.string.isRequired,
    backUrl: _propTypes2.default.string.isRequired
}), (0, _recompose.defaultProps)({
    backUrl: undefined
}), (0, _reactRedux.connect)(function (_ref2) {
    var userLoggedIn = _ref2.userLoggedIn,
        _ref2$showBarrier = _ref2.showBarrier,
        text = _ref2$showBarrier.text,
        step = _ref2$showBarrier.step;
    return {
        userLoggedIn: userLoggedIn, text: text, step: step
    };
}))(Subscriptions);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(427);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./Subscriptions.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./Subscriptions.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.Subscriptions__container___3eEfl {\n  box-shadow: 0px 10px 50px rgba(0, 0, 0, 0.25);\n  padding: 32px;\n  border-radius: 12px; }\n\n.Subscriptions__footer___3Ri15 {\n  display: flex;\n  justify-content: center;\n  font: 16px/22px \"proxima-nova-a\", sans-serif;\n  padding: 12px; }\n\n.Subscriptions__link___2LElU {\n  cursor: pointer;\n  font-family: \"proxima-nova-a-bold\", sans-serif;\n  color: #D11F25;\n  margin-left: 3px; }\n\n.Subscriptions__btn___2Jiby {\n  font-family: \"proxima-nova-a-bold\", sans-serif;\n  display: flex;\n  margin: 0 auto;\n  width: 100%;\n  width: 292px;\n  height: 40px;\n  padding: 8px 16px;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase;\n  gap: 10px; }\n\n.Subscriptions__logo___1L0UR {\n  width: 281px;\n  height: 58px; }\n  @media (max-width: 479.9px) {\n    .Subscriptions__logo___1L0UR {\n      width: 233px;\n      height: 41px; } }\n\n.Subscriptions__barrier-content___VCWZQ {\n  padding: 10px 0px 18px 0px;\n  font-weight: 400;\n  line-height: 20px;\n  font-size: 16px;\n  text-align: center; }\n  .Subscriptions__barrier-content___VCWZQ h2 {\n    padding: 0 0 16px 0; }\n\n.Subscriptions__barrier-heading___2FrtM {\n  display: flex;\n  align-items: end;\n  justify-content: space-between;\n  margin-top: -26px; }\n\n.Subscriptions__barrier-lock___2jUTy {\n  display: flex;\n  align-items: center;\n  justify-content: center; }\n\n.Subscriptions__icon-lock___3uabF {\n  position: absolute;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 112px;\n  height: 112px; }\n\n.Subscriptions__lock-tagline___3Q9p_ {\n  color: #D11F25;\n  font: 14px/18px \"proxima-nova-a\", sans-serif;\n  font-weight: 700; }\n\n.Subscriptions__barrier-logo___2lOes {\n  width: 580px;\n  height: 110px;\n  margin-top: 76px; }\n\n@media screen and (max-width: 375px) and (min-width: 320px) {\n  .Subscriptions__barrier-logo___2lOes {\n    max-width: 315px;\n    height: 60px;\n    margin-top: 30px; } }\n\n@media screen and (max-width: 768px) and (min-width: 320px) {\n  .Subscriptions__barrier-logo___2lOes {\n    max-width: 315px;\n    height: 60px;\n    margin-top: 45px; }\n  .Subscriptions__container___3eEfl {\n    padding: 18px; }\n  .Subscriptions__icon-lock___3uabF {\n    width: 60px;\n    height: 60px;\n    top: -30px; }\n  .Subscriptions__btn___2Jiby {\n    width: 290px; }\n  .Subscriptions__barrier-content___VCWZQ {\n    padding: 0px 0px 10px 0px;\n    font-size: 14px;\n    line-height: 18px; }\n  .Subscriptions__footer___3Ri15 {\n    font-size: 12px;\n    line-height: normal;\n    padding: 10px 10px 6px 10px; } }\n\n@media screen and (max-width: 320px) {\n  .Subscriptions__container___3eEfl {\n    padding: 18px 12px; }\n  .Subscriptions__barrier-logo___2lOes {\n    width: 255px;\n    height: 50px;\n    margin-top: 45px; }\n  .Subscriptions__btn___2Jiby {\n    width: 230px; } }\n", ""]);

// exports
exports.locals = {
	"container": "Subscriptions__container___3eEfl",
	"footer": "Subscriptions__footer___3Ri15",
	"link": "Subscriptions__link___2LElU",
	"btn": "Subscriptions__btn___2Jiby",
	"logo": "Subscriptions__logo___1L0UR",
	"barrier-content": "Subscriptions__barrier-content___VCWZQ",
	"barrier-heading": "Subscriptions__barrier-heading___2FrtM",
	"barrier-lock": "Subscriptions__barrier-lock___2jUTy",
	"icon-lock": "Subscriptions__icon-lock___3uabF",
	"lock-tagline": "Subscriptions__lock-tagline___3Q9p_",
	"barrier-logo": "Subscriptions__barrier-logo___2lOes"
};

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignUpComplete = __webpack_require__(429);

var _SignUpComplete2 = _interopRequireDefault(_SignUpComplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignUpComplete2.default;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(22);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _modal = __webpack_require__(32);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('br', {});

var SignUpComplete = function SignUpComplete() {
    return _jsx('div', {
        className: 'ui-modal__canvas'
    }, void 0, _jsx('h2', {
        className: _modal2.default.successTitle
    }, void 0, 'Sign up complete'), _jsx(_rpReactSvgIcon2.default, {
        isInlined: true,
        iconName: 'tick',
        className: 'ui-icon ui-icon_size3XL ' + _modal2.default.successIcon
    }), _jsx('p', {
        className: _modal2.default.successContent
    }, void 0, 'Thank you for signing up ', _ref, 'An email has been sent to you to confirm your registration'));
};

exports.default = SignUpComplete;

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _EmailVerification = __webpack_require__(431);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _EmailVerification2.default;

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.EmailVerification = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _reactRedux = __webpack_require__(9);

var _EmailVerification = __webpack_require__(133);

var _EmailVerification2 = _interopRequireDefault(_EmailVerification);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EmailVerification = exports.EmailVerification = function EmailVerification(_ref) {
    var goToStep = _ref.goToStep,
        message = _ref.message,
        accountId = _ref.accountId,
        session = _ref.session;
    return _jsx(_EmailVerification2.default, {
        accountId: accountId,
        session: session,
        email: message,
        onSuccess: function onSuccess() {
            return goToStep('SignIn');
        },
        onError: function onError() {
            return goToStep('ErrorDialog');
        }
    });
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('EmailVerification'), (0, _reactRedux.connect)(function (_ref2) {
    var _ref2$showEmailVerifi = _ref2.showEmailVerification,
        message = _ref2$showEmailVerifi.message,
        accountId = _ref2$showEmailVerifi.accountId,
        session = _ref2$showEmailVerifi.session;
    return { message: message, accountId: accountId, session: session };
}), (0, _recompose.setPropTypes)({
    message: _propTypes2.default.string.isRequired,
    accountId: _propTypes2.default.string.isRequired,
    session: _propTypes2.default.string.isRequired,
    goToStep: _propTypes2.default.func.isRequired
}))(EmailVerification);

/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignIn = __webpack_require__(433);

var _SignIn2 = _interopRequireDefault(_SignIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignIn2.default;

/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpAnalytics = __webpack_require__(23);

var _goToUrl = __webpack_require__(52);

var _goToUrl2 = _interopRequireDefault(_goToUrl);

var _SignIn = __webpack_require__(434);

var _SignIn2 = _interopRequireDefault(_SignIn);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var _ref2 = _jsx('span', {}, void 0, 'Don\'t have an account?');

var SignIn = function SignIn(_ref) {
    var backUrl = _ref.backUrl;

    var handleLoginClick = function handleLoginClick(e) {
        e.preventDefault();

        (0, _rpAnalytics.trackBarrierInteraction)(_defineProperty({}, _rpAnalytics.TRAIT_SELECTION, 'Login'));

        (0, _goToUrl2.default)('/api/auth/login/?state=' + btoa(backUrl) + '&force=true');
    };

    return _jsx('div', {
        className: _SignIn2.default.root
    }, void 0, _jsx('h2', {
        className: _SignIn2.default.title
    }, void 0, 'Please Log In to access your account'), _jsx('button', {
        className: 'js-popup-link ui-btn ui-btn_primary ui-btn_XL ' + _SignIn2.default.btn,
        onClick: handleLoginClick
    }, void 0, 'Log In'), _jsx('div', {
        className: _SignIn2.default.description
    }, void 0, _ref2, _jsx('a', {
        className: 'ui-reset-for-btn ui-link ui-link_secondary ' + _SignIn2.default.link,
        href: '/api/auth/login/?signup=true&state=' + btoa(backUrl) + '&force=true'
    }, void 0, 'Sign Up')));
};

exports.default = SignIn;

/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {


var content = __webpack_require__(435);

if(typeof content === 'string') content = [[module.i, content, '']];

var transform;
var insertInto;



var options = {"hmr":true}

options.transform = transform
options.insertInto = undefined;

var update = __webpack_require__(11)(content, options);

if(content.locals) module.exports = content.locals;

if(false) {
	module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignIn.scss", function() {
		var newContent = require("!!../../../node_modules/css-loader/index.js??ref--3-1!../../../node_modules/sass-loader/lib/loader.js!./SignIn.scss");

		if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];

		var locals = (function(a, b) {
			var key, idx = 0;

			for(key in a) {
				if(!b || a[key] !== b[key]) return false;
				idx++;
			}

			for(key in b) idx--;

			return idx === 0;
		}(content.locals, newContent.locals));

		if(!locals) throw new Error('Aborting CSS HMR due to changed css-modules locals.');

		update(newContent);
	});

	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(10)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-blockTabs(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-blockTabs(2xl);\n * }\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n/**\n * Create CSS classes with rules for tabs with specified size modificator\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS classes with modificators for tabs with given size\n *\n * @example\n * <code>\n *\n * @include ui-block-tab-sizeModificator(2xl);\n * @include ui-block-tab-sizeModificator(default);\n *\n * </code>\n **/\n/**\n * Create CSS rules for tabs with specified size\n *\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab(default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab(2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with custom class\n *\n * @param {String} $className - className\n * @param {String} $size - tabs size\n *                 small\n *                 default\n *                 large\n *                 xl\n *                 2xl\n *                 3xl\n *                 4xl\n *                 5xl\n *                 6xl\n *\n * @return CSS rules for tabs with customClass given size\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-custom(customClass, default);\n * }\n *\n * #include breakpoint($size-medium) {\n *\n *  @include ui-block-tab-custom(customClass, 2xl);\n * }\n * </code>\n **/\n/**\n * Create CSS rules for tabs with max width behavior\n *\n * @return CSS rules for tabs with max width behavior\n *\n * @example\n * <code>\n *\n * #include breakpoint($size-extraNarrow) {\n *\n *  @include ui-block-tab-minToMax();\n * }\n * </code>\n **/\n/**\n * Create CSS rules for generic behavior of tabs on breakpoints\n *\n * @return CSS rules for generic behavior of tabs on breakpoints\n *\n * @example\n * <code>\n *\n *  @include ui-block-tab-defaultBreakpoints();\n *\n * </code>\n **/\n/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SignIn__root___2sNmv {\n  display: flex;\n  flex-direction: column; }\n\n.SignIn__title___2OTvB {\n  padding: 16px;\n  margin: 0 auto;\n  font: 20px/26px \"proxima-nova-a\", sans-serif;\n  text-align: center;\n  color: #171717;\n  max-width: calc(100% - 48px); }\n\n.SignIn__link___jkwhX {\n  cursor: pointer;\n  font-family: \"proxima-nova-a-bold\", sans-serif;\n  padding-left: 4px;\n  font-weight: 600; }\n\n.SignIn__btn___H5f8Z {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin: 16px auto;\n  padding: 0 32px; }\n\n.SignIn__description___-ZZQK {\n  text-align: center;\n  margin: 8px; }\n", ""]);

// exports
exports.locals = {
	"root": "SignIn__root___2sNmv",
	"title": "SignIn__title___2OTvB",
	"link": "SignIn__link___jkwhX",
	"btn": "SignIn__btn___H5f8Z",
	"description": "SignIn__description___-ZZQK"
};

/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SignUp = __webpack_require__(437);

var _SignUp2 = _interopRequireDefault(_SignUp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SignUp2.default;

/***/ }),
/* 437 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.SignUp = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(5);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _recompose = __webpack_require__(8);

var _SignUpForm = __webpack_require__(138);

var _SignUpForm2 = _interopRequireDefault(_SignUpForm);

var _analytics = __webpack_require__(51);

var _modal = __webpack_require__(32);

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SignUp = exports.SignUp = function SignUp(_ref) {
    var goToStep = _ref.goToStep,
        backUrl = _ref.backUrl;
    return _jsx('div', {}, void 0, _jsx('h2', {
        className: _modal2.default.title
    }, void 0, 'Sign Up'), _jsx(_SignUpForm2.default, {
        goToSignIn: function goToSignIn() {
            return goToStep('SignIn');
        },
        goToForgottenPass: function goToForgottenPass() {
            return goToStep('ForgottenPassword');
        },
        goToSignUpComplete: function goToSignUpComplete() {
            return goToStep('SignUpComplete');
        },
        goToErrorDialog: function goToErrorDialog() {
            return goToStep('ErrorDialog');
        },
        hidden: false,
        backUrl: backUrl,
        onSignUpSuccess: _analytics.onSignUpSuccess
    }));
};

exports.default = (0, _recompose.compose)((0, _recompose.setDisplayName)('SignUp'), (0, _recompose.setPropTypes)({
    goToStep: _propTypes2.default.func.isRequired,
    backUrl: _propTypes2.default.string
}), (0, _recompose.defaultProps)({
    backUrl: undefined
}))(SignUp);

/***/ }),
/* 438 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var compose = __webpack_require__(77).compose;

exports.__esModule = true;
exports.composeWithDevTools =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    : function () {
        if (arguments.length === 0) return undefined;
        if (typeof arguments[0] === 'object') return compose;
        return compose.apply(null, arguments);
      };

exports.devToolsEnhancer =
  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__
    ? window.__REDUX_DEVTOOLS_EXTENSION__
    : function () {
        return function (noop) {
          return noop;
        };
      };


/***/ }),
/* 439 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.hideMandatoryLoginForm = exports.showMandatoryLoginForm = exports.dispatchSignOut = exports.dispatchSignIn = exports.showError = exports.showEmailVerification = exports.showForgottenPass = exports.showResetPass = exports.checkForAccess = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _store = __webpack_require__(140);

var _store2 = _interopRequireDefault(_store);

var _actions = __webpack_require__(12);

var _helpers = __webpack_require__(124);

var _goToUrl = __webpack_require__(52);

var _goToUrl2 = _interopRequireDefault(_goToUrl);

var _api = __webpack_require__(15);

var _metering = __webpack_require__(141);

var _metering2 = _interopRequireDefault(_metering);

var _constants = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var steps = {
    subscribe: 'Subscriptions',
    signin: 'SignIn',
    signup: 'SignUp',
    'sign-in': 'SignIn',
    'sign-up': 'SignUp',
    forgottenPassword: 'ForgottenPassword'
};

var checkForAccess = exports.checkForAccess = function checkForAccess(step) // if we should not use MPP metering, then we need to pass the section which we will check for access
{
    var show = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var isHighSecure = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    var barrierParams = arguments[3];
    var shouldUseCustomMetering = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var userRole = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var page = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    var section = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

    var cookieParams = (0, _helpers.getParams)();

    var _cookieParams$barrier = _extends({}, cookieParams, barrierParams),
        type = _cookieParams$barrier.type,
        r = _cookieParams$barrier.r,
        text = _cookieParams$barrier.text,
        service = _cookieParams$barrier.service;

    if (shouldUseCustomMetering) {
        if (!userRole || !section) {
            // eslint-disable-next-line no-console
            console.error('You need to pass the user role and the section to check for access');
            return false;
        }

        if (userRole === _constants.ULTIMATE) {
            return true;
        }

        var hasAccess = _metering2.default[userRole][page][section];

        if (!hasAccess) {
            _store2.default.dispatch((0, _actions.showBarriers)(steps.subscribe, r, text, service, show));
        }

        return hasAccess;
    }

    var isAuthorized = null;

    if (r && !cookieParams.r) {
        isAuthorized = (0, _api.getAccess)({ requestUrl: r }).then(function (hasAccess) {
            var href = global.location.href;


            if (!hasAccess && ((0, _helpers.shouldCheckForBarrier)() || show) || hasAccess && !isHighSecure && ((0, _helpers.shouldCheckForBarrier)() || show)) {
                if (!steps[type] && !show && !(0, _helpers.shouldCheckForBarrier)()) {
                    (0, _goToUrl2.default)(href.replace('?authme', ''));
                    return null;
                }

                var cookie = (0, _helpers.getParams)();
                _store2.default.dispatch((0, _actions.showBarriers)(steps[type] || step, href, cookie.text || text, service, show));
            }

            return hasAccess;
        });
    } else {
        isAuthorized = Promise.resolve(false);

        if ((0, _helpers.shouldCheckForBarrier)() || show) {
            _store2.default.dispatch((0, _actions.showBarriers)(steps[type] || step, r, text, service, show));
        }
    }

    return isAuthorized;
};

var showResetPass = exports.showResetPass = function showResetPass(email) {
    _store2.default.dispatch((0, _actions.showResetPassword)(email));
};

var showForgottenPass = exports.showForgottenPass = function showForgottenPass() {
    _store2.default.dispatch((0, _actions.showForgottenPassword)());
};

var showEmailVerification = exports.showEmailVerification = function showEmailVerification(email, guid) {
    _store2.default.dispatch((0, _actions.showEmailVerification)(email, guid));
};

var showError = exports.showError = function showError() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    _store2.default.dispatch((0, _actions.showErrorDialog)(message));
};

var dispatchSignIn = exports.dispatchSignIn = function dispatchSignIn() {
    _store2.default.dispatch((0, _actions.signIn)());
};

var dispatchSignOut = exports.dispatchSignOut = function dispatchSignOut() {
    _store2.default.dispatch((0, _actions.signOut)());
};

var showMandatoryLoginForm = exports.showMandatoryLoginForm = function showMandatoryLoginForm(step, target) {
    _store2.default.dispatch((0, _actions.showMandatoryLogin)(step, target));
};

var hideMandatoryLoginForm = exports.hideMandatoryLoginForm = function hideMandatoryLoginForm() {
    _store2.default.dispatch((0, _actions.hideMandatoryLogin)());
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(7)))

/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.show = exports.open = exports.run = undefined;

var _scriptRaw = __webpack_require__(441);

var _scriptRaw2 = _interopRequireDefault(_scriptRaw);

var _ml = __webpack_require__(442);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var was_run_ = false;

var run = exports.run = function run() {

    if (was_run_) return;

    console.log('authApi.MandatoryLoginOverlay.run()');

    was_run_ = true;

    var new_script_ = document.createElement('script');
    var inline_script_ = document.createTextNode(_scriptRaw2.default);
    new_script_.appendChild(inline_script_);

    var html_ = (0, _ml.getHtml)();
    var new_html_ = document.createElement('div');
    new_html_.innerHTML = html_;

    new_html_.appendChild(new_script_);

    document.getElementsByTagName('body')[0].appendChild(new_html_);
};

var open = exports.open = function open(is_debug_) {
    console.log('Run first: authApi.MandatoryLoginOverlay.run();');
};

var show = exports.show = function show(is_debug_) {
    console.log('authApi.MandatoryLoginOverlay.show()');

    run();
    authApi.MandatoryLoginOverlay.open(is_debug_);
};
/* eslint-enable */

/***/ }),
/* 441 */
/***/ (function(module, exports) {

module.exports = "/* eslint-disable */\n(function MandatoryLoginOverlay(auth_api_) {\n\n    var DEBUG = false;\n\n    function consoleLog()\n    {\n        if (!DEBUG) return;\n        \n        console.log.apply(this, arguments);\n    }\n\n    /* will be handled inside optimizely code checks\n    \n    function getCookie(cookie_name_) \n    {\n        //consoleLog(document.cookie);\n\n        var name_ = cookie_name_ + \"=\";\n\n        var ca = document.cookie.split(';');\n\n        for(var i = 0; i < ca.length; i++) \n        {\n            var c = ca[i];\n\n            while (c.charAt(0) == ' ') {\n                c = c.substring(1);\n            }\n\n            if (c.indexOf(name_) == 0) {\n                return c.substring(name_.length, c.length);\n            }\n        }\n\n        return '';\n    }\n\n    function getCookieObject(cookie_name_)\n    {\n        var cookie_string_ = getCookie(cookie_name_);\n        \n        //cookie_string_ = '{\"rp_package\":\"Free\",\"rp_email\":\"jordan.enchev.ext@racingpost.com\",\"rp_md5cookie\":\"b2b0d112439ce46a8f425f0398e28068\"}';\n        \n        var object_string_ = decodeURIComponent(cookie_string_ ? cookie_string_ : encodeURIComponent('{}'));\n\n        var object_ = JSON.parse(object_string_);\n        \n        return object_;\n    }\n\n    var RDSP_cookie_ = getCookieObject('RDSP');\n    var RFPV_cookie_ = getCookieObject('PathforaPageView'); \n\n    consoleLog('RDSP_cookie', RDSP_cookie_);\n    consoleLog('RFPV_cookie', RFPV_cookie_);\n    */\n\n    function showState()\n    {\n        consoleLog('.showState()', state_);\n\n        validateAll();\n\n        pageShowState();\n        buttonsShowState();\n        backgroundsShowState();\n        inputsShowState();\n\n        onShowAction();\n    }\n\n    function pageShowState()\n    {\n        consoleLog('.pageShowState()');\n\n        var state_item_;\n\n        var index_;\n        var length_ = states_.length;\n\n        for(index_ = 0; index_ < length_; index_++) \n        {\n            state_item_ = states_[index_];\n\n            if (state_item_ == state_) continue;\n\n            box_.toggleClass(state_item_ + '_size', false);\n\n            box_.find('.' + state_item_).hide();\n        }\n\n        box_.toggleClass(state_ + '_size', true);\n\n        box_.find('.' + state_).show();\n        box_.find('.' + state_).fadeIn();\n\n        content_.toggleClass('align_left'   , state_ == 'register');\n        content_.toggleClass('align_right'  , state_ == 'login' || state_ == 'reset' || state_ == 'reset_done');\n    }\n\n    function buttonsShowState()\n    {\n        consoleLog('.buttonsShowState()');\n\n        var button_name_;\n        var button_on_state_;\n        var button_;\n\n        var index_;\n        var length_ = buttons_names_.length;\n\n        for(index_ = 0; index_ < length_; index_++) \n        {\n            button_name_        = buttons_names_[index_];\n            button_             = buttons_[index_];\n\n            button_on_state_    = button_name_;\n\n            if (button_name_ == 'back')\n            {\n                button_on_state_  = state_ == 'terms_and_conditions' ? state_ : '';\n            }\n\n            if (button_name_ == 'login')\n            {\n                button_on_state_  = state_ == 'reset' || state_ == 'reset_done' ? state_ : button_name_;\n            }\n\n            button_.toggleClass('button_selected', button_on_state_ == state_);\n\n            selector_underline_.toggleClass(button_name_ + '_size_position', button_on_state_ == state_);\n        }\n\n        selector_underline_.toggleClass('full_size_position', state_ == 'register_done');\n        (state_ == 'terms_and_conditions') || (state_ == 'register_done') ? vertical_separator_.hide() : vertical_separator_.show();\n\n        if (state_ == 'register_done')\n        {\n            button_login_.fadeOut();\n            button_register_.fadeOut();\n            button_back_.fadeOut();\n\n            return;\n        }\n\n        if (state_ == 'terms_and_conditions')\n        {\n            button_login_.fadeOut();\n            button_register_.fadeOut();\n\n            button_back_.fadeIn();\n\n            return;\n        } \n\n        button_login_.fadeIn();\n        button_register_.fadeIn();\n        \n        button_back_.fadeOut();\n    }\n\n    function backgroundsShowState()\n    {\n        consoleLog('.backgroundsShowState()');\n\n        var fade_duration_ = 250;\n\n        (state_ == 'login' || state_ == 'reset' || state_ == 'reset_done') ? background_login_.fadeIn(fade_duration_) : background_login_.fadeOut(fade_duration_);\n\n        state_ == 'register'        ?  background_register_.fadeIn(fade_duration_)      : background_register_.fadeOut(fade_duration_);\n        state_ == 'register_done'   ?  background_registered_.fadeIn(fade_duration_)    : background_registered_.fadeOut(fade_duration_);\n    }\n\n    function inputsShowState()\n    {\n        consoleLog('.inputsShowState()');\n\n        var should_show_email_ = state_ == 'register' || state_ == 'login' || state_ == 'reset';\n\n        should_show_email_ ? email_.parent().show('fast') : email_.parent().hide('fast');\n\n        var should_show_password_ = state_ == 'register' || state_ == 'login';\n\n        should_show_password_ ? password_.parent().show('fast') : password_.parent().hide('fast');\n\n        var should_show_forgotten_password_ = state_ == 'login';\n\n        should_show_forgotten_password_ ? forgotten_password_.show('fast') : forgotten_password_.hide('fast');\n\n        var should_show_action_button_ = state_ != 'terms_and_conditions';\n\n        should_show_action_button_ ? action_button_.show('fast') : action_button_.hide('fast');\n\n        state_ == 'register' ? register_input_.show('fast') : register_input_.hide('fast');\n    }\n\n    function showRegister()\n    {\n        consoleLog('.showRegister()');\n\n        state_ = 'register';\n\n        showState();\n    }\n\n    function showRegisterDone()\n    {\n        consoleLog('.showRegisterDone()');\n\n        state_ = 'register_done';\n\n        showState();\n    }\n\n    function showLogin()\n    {\n        consoleLog('.showLogin()');\n\n        state_ = 'login';\n\n        showState();\n    }\n\n    function showReset()\n    {\n        consoleLog('.showReset()');\n\n        state_ = 'reset';\n\n        showState();\n    }\n\n    function showResetSent()\n    {\n        consoleLog('.showResetSent()');\n\n        state_ = 'reset_done';\n\n        showState();\n    }\n\n    function showTermsAndConditions()\n    {\n        consoleLog('.showTermsAndConditions()');\n\n        state_ = 'terms_and_conditions';\n\n        showState();\n    }\n\n    function onForgottenPassword()\n    {\n        consoleLog('.onForgottenPassword()');\n\n    }\n\n    function onAction(target_)\n    {\n        consoleLog('.onAction() state: ', state_, target_);\n\n        if (action_button_loading_) return;\n\n        var actions_ = {\n            'register'      : register,\n            'register_done' : close,\n            'login'         : login,\n            'reset'         : reset,\n            'reset_done'    : close\n        };\n\n        showSpinner();\n\n        actions_[state_]();\n    }\n\n    function showSpinner()\n    {\n        consoleLog('.showSpinner()');\n\n        action_button_loading_ = true;\n\n        action_button_text_.hide();\n        action_button_spinner_.show();\n\n        hideSignInUpErrors();\n    }\n\n    function hideSpinner()\n    {\n        consoleLog('.hideSpinner()');\n\n        action_button_loading_ = false\n\n        action_button_text_.show();\n        action_button_spinner_.hide();\n    }\n\n    function hideSignInUpErrors()\n    {\n        consoleLog('.hideSignInUpErrors()');\n\n        sign_in_error_.hide();\n        sign_up_error_.hide();\n    }\n\n    function onShowAction()\n    {\n        consoleLog('.onShowAction()');\n\n        var actions_ = {\n            'register'      : 'Register',\n            'register_done' : 'Close',\n            'login'         : 'Login',\n            'reset'         : 'Reset password',\n            'reset_done'    : 'Close'\n        };\n\n        action_button_text_.text(actions_[state_]);\n    }\n\n    function open(is_debug_)\n    {\n        DEBUG = is_debug_;\n\n        consoleLog('.open() is_debug: ' + is_debug_);\n\n        if (auth_api_.checkForAccess())\n        {\n            consoleLog('.open() user is already logged in');\n\n            return;\n        }\n\n        /*\n        if (RFPV_cookie_ < 3)\n        {\n            consoleLog('.open() show only on 3 or more page views');\n\n            return;\n        }\n        */\n\n        showRegister();\n\n        mandatory_.fadeIn();\n    }\n\n    function close()\n    {\n        consoleLog('.close()');\n\n        mandatory_.fadeOut();\n    }\n\n    function login()\n    {\n        consoleLog('.login()');\n\n        if (!validateAll(true)) return;\n\n        var back_url_                           = undefined;\n        var onSignInSuccess_                    = function(email_) { consoleLog('.login() -> success email: ' + email_); return auth_api_.onSignInSuccess(email_); };\n        var onSignInError_                      = function() { consoleLog('.login() -> sign error'  ); hideSpinner(); sign_in_error_.show(); };\n        var showForgottenPasswordDialog_        = function() { consoleLog('.login() -> forotten'    ); hideSpinner(); auth_api_.showForgottenPass();   close(); };\n        var goToEmailVerification_              = function(account_id_) { consoleLog('.login() -> unverified account_id: ' + account_id_); hideSpinner(); auth_api_.showEmailVerification(email_.val(), account_id_); close(); };\n        var dispatchSetEmailVerificationData_   = null;\n        var showErrorDialog_                    = function() { consoleLog('.login() -> error'       ); hideSpinner(); auth_api_.showError();           close(); };\n        var onSignInLoadComplete_               = function() { consoleLog('.login() -> load done'   ); hideSpinner(); };\n\n        auth_api_.performSignIn(\n            email_.val(), \n            password_.val(),\n            back_url_, \n            onSignInError_,\n            onSignInLoadComplete_,\n            onSignInSuccess_,\n            showForgottenPasswordDialog_,\n            goToEmailVerification_,\n            dispatchSetEmailVerificationData_,\n            showErrorDialog_\n        );\n    }\n\n    function reset()\n    {\n        consoleLog('.reset()');\n\n        if (!validateAll(true)) return;\n\n        var back_url_                       = undefined;\n        var onPasswordResetSuccess_         = function() { consoleLog('.reset() -> success'     ); hideSpinner(); showResetSent(); };\n        var onPasswordResetError_           = function() { consoleLog('.reset() -> error'       ); hideSpinner(); auth_api_.showError(); close(); };\n        var onPasswordResetLoadComplete_    = function() { consoleLog('.reset() -> load done'   ); hideSpinner(); };\n\n        auth_api_.performPasswordReset(\n            email_.val(),\n            back_url_,\n            onPasswordResetSuccess_,\n            onPasswordResetError_,\n            onPasswordResetLoadComplete_\n        );\n    }\n\n    function register()\n    {\n        consoleLog('.register()');\n\n        if (!validateAll(true)) return;\n\n        var should_recieve_mails_   = recieve_mails_.prop('checked');\n        var is_over_18_             = over_18_.prop('checked');\n\n        var options_ = {\n            horseBetting    : should_recieve_mails_,\n            horseNews       : should_recieve_mails_,\n            bloodstock      : should_recieve_mails_,\n            sportBetting    : should_recieve_mails_,\n            competitions    : should_recieve_mails_,\n            eighteenYears   : is_over_18_,\n            termsConditions : true,\n        };\n\n        var onSignUpError_          = function() { consoleLog('.register() -> sign up error'); hideSpinner(); sign_up_error_.show(); };\n        var onSignUpLoadComplete_   = function() { consoleLog('.register() -> load done'    ); hideSpinner(); };\n        var showErrorDialog_        = function() { consoleLog('.register() -> error dialog' ); hideSpinner(); auth_api_.showError(); close(); };\n        var onSignUpSuccess_        = function(email_, options_) { consoleLog('.register() -> succcess'); hideSpinner(); auth_api_.onSignUpSuccess(email_, options_); showRegisterDone(); };\n\n        auth_api_.performSignUp(\n            email_.val(),\n            password_.val(), \n            options_,\n            onSignUpError_,\n            onSignUpLoadComplete_,\n            showErrorDialog_,\n            onSignUpSuccess_\n        );\n    }\n\n    function onChange()\n    {\n        consoleLog('.onChange()');\n\n        validateAll();\n    }\n\n    function combinationsOf(values_)\n    {\n        var combinations_ = [];\n        var permutations_;\n\n        var no_repeat_;\n\n        var index_;\n        var index_;\n        var length_ = values_.length;\n\n        for(index_ = 1; index_ <= length_; index_++)\n        {\n            permutations_   = permutationsOf(values_, index_, no_repeat_ = true);\n\n            combinations_   = combinations_.concat(permutations_);\n        }\n\n        return combinations_;\n    }\n\n    function addNexpermValue(permutations_, values_, position_, of_n_, permutation_, no_repeat_)\n    {\n        if (position_ == of_n_) \n        {\n            permutations_.push(permutation_);\n\n            return;\n        }\n\n        var value_;\n        var index_;\n        var length_ = values_.length;\n\n        for(index_ = 0; index_ < length_; index_++)\n        {\n            value_ = values_[index_];\n\n            if (no_repeat_ && permutation_.indexOf(value_) != -1) continue;\n\n            permutation_[position_] = value_;\n\n            addNexpermValue(permutations_, values_, position_ + 1, of_n_, permutation_.concat(), no_repeat_);\n        }\n    }\n\n    function permutationsOf(values_, of_n_, no_repeat_)\n    {\n        var permutations_ = [];\n\n        var index_;\n        var length_ = values_.length;\n\n        for(index_ = 0; index_ < length_; index_++)\n        {\n            addNexpermValue(permutations_, values_, 0, of_n_, [], no_repeat_);\n        }\n\n        return permutations_;\n    }\n\n    function removeCombinationOfClassesFrom(classes_, delimiter_, end_, element_)\n    {\n        var combinations_ = combinationsOf(classes_);\n\n        //consoleLog(combinations_);\n\n        var class_;\n\n        var index_;\n        var length_ = combinations_.length;\n\n        for(index_ = 0; index_ < length_; index_++)\n        {\n            class_ = combinations_[index_].join(delimiter_) + end_;\n\n            //consoleLog('| ' + class_);\n\n            element_.toggleClass(class_, false);\n        }\n    }\n\n    function validate(input_, validator_, is_strong_)\n    {\n        //consoleLog('.validate() input: ',input_);\n\n        var is_valid_ = validator_(input_, is_strong_);\n\n        if (is_strong_ && (is_valid_ == null)) is_valid_ = false;\n\n        consoleLog('.validate() input: ', input_, ' is_valid: ' + is_valid_ + ' is_strong: ' + is_strong_);\n\n        return is_valid_;\n    }\n\n    function validateEmail(value_)\n    {\n        consoleLog('.validateEmail() value: ' + value_);\n\n        if (!value_) return is_valid_ = null;\n\n        var email_validator_ = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9]{2}(?:[a-z0-9-]*[a-z0-9])?$/i;\n\n        var is_valid_ = email_validator_.test(value_);\n\n        return is_valid_;\n    }\n\n    function validatePassword(value_)\n    {\n        consoleLog('.validatePassword() value: ' + value_);\n\n        if (!value_) return is_valid_ = null;\n\n        var passowrd_validator_ = new RegExp('(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9]).{8,}$');\n        \n        var is_valid_ = passowrd_validator_.test(value_);\n\n        return is_valid_;\n    }\n\n    function validateConfirmPassword(value_, other_value_)\n    {\n        consoleLog('.validateConfirmPassword() value: ' + value_ + ' other_value: ' + other_value_);\n\n        var is_valid_ = value_ == other_value_;\n\n        if (other_value_ == '') return null;\n\n        return is_valid_;\n    }\n\n    function validateIsSelected(input_, is_strong_)\n    {\n        // consoleLog('.validateIsSelected() input: ' + input_);\n\n        var is_checked_ = input_.prop('checked');\n\n        consoleLog('.validateIsSelected()  input: ', input_,' is_checked: ' + is_checked_ + ' is_strong: ' + is_strong_);\n\n        var is_valid_   = is_checked_;\n\n        if (!is_strong_ && !is_valid_) is_valid_ = true;\n\n        return is_valid_;\n    }\n\n    function resetField(input_, name_)\n    {\n        consoleLog('.resetField() name: '+ name_);\n\n        var ok_     = input_.parent().find('.ok');\n        var not_ok_ = input_.parent().find('.not_ok');\n\n        input_.toggleClass('valid'     , false);\n        input_.toggleClass('invalid'   , false);\n\n        not_ok_.hide();\n        ok_.hide();\n\n        input_.parent().toggleClass('invalid'   , false);\n        input_.parent().toggleClass('valid'     , false);\n    }\n\n    function updateFieldView(input_, name_, is_valid_, is_valid_overal_, is_strong_)\n    {\n        consoleLog('.updateFieldView()  name: '+ name_,' is_valid: ' + is_valid_ + ' is_valid_overal: ' + is_valid_overal_ + ' is_strong: ' + is_strong_);\n\n        resetField(input_, name_);\n\n        var ok_     = input_.parent().find('.ok');\n        var not_ok_ = input_.parent().find('.not_ok');\n\n        if (is_valid_ == null)\n        {\n            is_valid_ = true;\n\n        } else {\n\n            if (is_strong_ || !is_valid_overal_ || (is_valid_overal_ && name_ != undefined)) \n            {\n                input_.toggleClass('valid'     , is_valid_);\n                input_.toggleClass('invalid'   , !is_valid_);\n\n            } else if (is_valid_overal_ && name_ == undefined) {\n                is_valid_ = true;\n            }\n\n            is_valid_   ? not_ok_.hide() : not_ok_.show();\n            !is_valid_  ? ok_.hide()     : ok_.show();\n        }\n\n        updateErrorView(input_, is_valid_, is_valid_overal_);\n\n        return is_valid_;\n    }\n\n    function updateErrorView(input_, is_valid_, is_valid_overal_)\n    {\n        var error_ = input_.parent().find('.error');\n\n        if (error_.length == 0 ) \n        {\n            if (is_valid_overal_ && !is_valid_)\n            {\n                input_.parent().toggleClass('invalid'   , true);\n                input_.parent().toggleClass('valid'     , false);\n            }  else if (is_valid_overal_ && is_valid_)\n            {\n                input_.parent().toggleClass('invalid'   , false);\n                input_.parent().toggleClass('valid'     , true);\n            } else {\n                input_.parent().toggleClass('invalid'   , !is_valid_);\n                input_.parent().toggleClass('valid'     , is_valid_);\n            }\n        }\n\n        is_valid_ ? error_.hide() : error_.show();\n    }\n\n    function setInputIsValid(input_, is_valid_)\n    {\n        input_.toggleClass('valid'     , is_valid_);\n    }\n\n    function validateAll(is_strong_)\n    {\n        consoleLog('.validateAll() is_strong: ' + is_strong_);\n\n        var validations_ = [\n            {\n                'name'      : 'email',\n                'input'     : email_,\n                'validator' : function() {return validateEmail(email_.val());}\n            },\n            {\n                'is_enabled': state_ == 'register' || state_ == 'login',\n                'name'      : 'password',\n                'input'     : password_,\n                'validator' : function() {return validatePassword(password_.val());}\n            },\n            {\n                'is_enabled': state_ == 'register',\n                'name'      : 'confirm_password',\n                'input'     : confirm_password_,\n                'validator' : function() {return validateConfirmPassword(password_.val(), confirm_password_.val());}\n            },\n            {\n                'is_enabled': state_ == 'register',\n                'input'     : accepts_terms_,\n                'validator' : function() {return validateIsSelected(accepts_terms_, is_strong_);}\n            } \n        ];\n\n        var possible_errors_ = validations_.map(function(value_) {\n            return value_.name;\n        });\n\n        possible_errors_ = possible_errors_.filter(function(value_) {\n            return value_ !== undefined}\n        );\n\n        consoleLog('.validateAll() possible_errors: ', possible_errors_);\n\n        var name_;\n        var input_;\n        var validation_;\n        var validator_;\n        var is_valid_;\n        var is_valid_overal_ = true;\n\n        var errors_ = [];\n\n        var index_;\n        var length_ = validations_.length\n\n        for(index_ = 0; index_ < length_; index_++)\n        {\n            validation_ = validations_[index_];\n\n            if (validation_.is_enabled === false) continue;\n\n            name_       = validation_.name;\n            input_      = validation_.input;\n            validator_  = validation_.validator;\n\n            is_valid_   = validate(input_, validator_, is_strong_);\n\n            is_valid_   = updateFieldView(input_, name_, is_valid_, is_valid_overal_, is_strong_);\n\n            if (!is_valid_ && name_) errors_.push(name_);\n\n            is_valid_overal_ = is_valid_overal_ && is_valid_;\n        }\n\n        removeCombinationOfClassesFrom(possible_errors_, '_', '_error', box_);\n\n        consoleLog('.validateAll() errors: ' + errors_);\n\n        if (errors_.length > 0) box_.toggleClass(errors_.join('_') + '_error', !is_valid_overal_);\n\n        if (!is_valid_overal_) hideSpinner();\n\n        hideSignInUpErrors();\n\n        consoleLog('.validateAll() is_valid_overal: ' + is_valid_overal_);\n\n        return is_valid_overal_;\n    }\n\n    var mandatory_              = $('.mandatory_login');\n    var box_                    = mandatory_.find('.box');\n    var content_                = box_.find('.content');\n\n    var email_                  = box_.find('.email');\n    var password_               = box_.find('.password');\n    var confirm_password_       = box_.find('.confirm_password');\n\n    var register_input_         = box_.find('.register_input');\n    var recieve_mails_          = box_.find('.recieve_mails input');\n    var over_18_                = box_.find('.over_18 input');\n    var accepts_terms_          = box_.find('.accepts_terms input');\n\n    var forgotten_password_     = box_.find('.forgotten_passoword');\n    var terms_and_conditions_   = box_.find('.go_to_terms_and_conditions');\n    var action_button_          = box_.find('.action_button');\n    var action_button_text_     = box_.find('.action_button_text');\n    var action_button_spinner_  = box_.find('.action_button_spinner');\n    var sign_in_error_          = box_.find('.sign_in_error');\n    var sign_up_error_          = box_.find('.sign_up_error');\n    var action_button_loading_  = false;\n\n    var background_login_       = box_.find('.background_login');\n    var background_register_    = box_.find('.background_register');\n    var background_registered_  = box_.find('.background_registered');\n\n    var button_login_           = box_.find('.button_login');\n    var button_register_        = box_.find('.button_register');\n    var button_back_            = box_.find('.button_back');\n\n    var selector_underline_     = box_.find('.selector_underline');\n    var vertical_separator_     = box_.find('.vertical_separator');\n\n    var state_                  = 'register';\n    var states_                 = ['register', 'register_done', 'login', 'reset', 'reset_done', 'terms_and_conditions'];\n\n    var buttons_names_          = ['register'       , 'login'           , 'back'        ];\n    var buttons_                = [button_register_ , button_login_     , button_back_  ];\n\n    button_login_.on(           'click', showLogin      );\n    button_register_.on(        'click', showRegister   );\n    button_back_.on(            'click', showRegister   );\n\n    action_button_.on(          'click', onAction       );\n\n    forgotten_password_.on(     'click', showReset              );\n    terms_and_conditions_.on(   'click', showTermsAndConditions );\n\n    email_.on(                  'input', onChange);\n    password_.on(               'input', onChange);\n    confirm_password_.on(       'input', onChange);\n\n    recieve_mails_.change(      onChange);\n    over_18_.change(            onChange);\n    accepts_terms_.change(      onChange);\n\n    auth_api_.MandatoryLoginOverlay.open = open;\n\n})(global.authApi);\n/* eslint-enable */\n"

/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getHtml = undefined;

var _loginRaw = __webpack_require__(443);

var _loginRaw2 = _interopRequireDefault(_loginRaw);

var _register_contentRaw = __webpack_require__(444);

var _register_contentRaw2 = _interopRequireDefault(_register_contentRaw);

var _register_done_contentRaw = __webpack_require__(445);

var _register_done_contentRaw2 = _interopRequireDefault(_register_done_contentRaw);

var _login_contentRaw = __webpack_require__(446);

var _login_contentRaw2 = _interopRequireDefault(_login_contentRaw);

var _reset_contentRaw = __webpack_require__(447);

var _reset_contentRaw2 = _interopRequireDefault(_reset_contentRaw);

var _reset_done_contentRaw = __webpack_require__(448);

var _reset_done_contentRaw2 = _interopRequireDefault(_reset_done_contentRaw);

var _background_loginPngRaw = __webpack_require__(449);

var _background_loginPngRaw2 = _interopRequireDefault(_background_loginPngRaw);

var _background_registerPngRaw = __webpack_require__(450);

var _background_registerPngRaw2 = _interopRequireDefault(_background_registerPngRaw);

var _background_registeredPngRaw = __webpack_require__(451);

var _background_registeredPngRaw2 = _interopRequireDefault(_background_registeredPngRaw);

var _register_successPngRaw = __webpack_require__(452);

var _register_successPngRaw2 = _interopRequireDefault(_register_successPngRaw);

var _terms_and_conditionsRaw = __webpack_require__(453);

var _terms_and_conditionsRaw2 = _interopRequireDefault(_terms_and_conditionsRaw);

var _stylesRaw = __webpack_require__(454);

var _stylesRaw2 = _interopRequireDefault(_stylesRaw);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable */
var getHtml = exports.getHtml = function getHtml() {
	var html = _loginRaw2.default.replace('%REGISTER_CONTENT%', _register_contentRaw2.default);
	html = html.replace('%REGISTER_DONE_CONTENT%', _register_done_contentRaw2.default);

	html = html.replace('%LOGIN_CONTENT%', _login_contentRaw2.default);

	html = html.replace('%RESET_CONTENT%', _reset_contentRaw2.default);
	html = html.replace('%RESET_DONE_CONTENT%', _reset_done_contentRaw2.default);

	html = html.replace('%TERMS_AND_CONDITIONS%', _terms_and_conditionsRaw2.default);

	// images
	html = html.replace('%BACKGROUND_LOGIN%', _background_loginPngRaw2.default);
	html = html.replace('%BACKGROUND_REGISTER%', _background_registerPngRaw2.default);
	html = html.replace('%BACKGROUND_REGISTERED%', _background_registeredPngRaw2.default);
	html = html.replace('%REGISTER_SUCCESS%', _register_successPngRaw2.default);

	html += '<style type="text/css">' + "\n" + _stylesRaw2.default + "\n" + '</style>';

	return html;
};
/* eslint-enable */

/***/ }),
/* 443 */
/***/ (function(module, exports) {

module.exports = "<div class=\"mandatory_login\" style=\"display:none;\">\n\n\t<div class=\"overlay\" ></div>\n\n\t<div class=\"box\">\n\n\t\t<div class=\"form\">\n\n\t\t\t<div class=\"content\">\n\n\t\t\t\t<img class=\"background_login\" \t\talt=\"background login\" \t\tsrc=\"%BACKGROUND_LOGIN%\" />\n\t\t\t\t<img class=\"background_register\" \talt=\"background register\" \tsrc=\"%BACKGROUND_REGISTER%\" />\n\t\t\t\t<img class=\"background_registered\" \talt=\"background registered\" src=\"%BACKGROUND_REGISTERED%\" />\n\n\t\t\t\t<div class=\"sub_content\">\n\n\t\t\t\t\t<div class=\"register\"\t\t>%REGISTER_CONTENT%</div>\n\t\t\t\t\t<div class=\"register_done\"\t>%REGISTER_DONE_CONTENT%</div>\n\t\t\t\t\t<div class=\"login\"\t\t\t>%LOGIN_CONTENT%</div>\n\t\t\t\t\t<div class=\"reset\" \t\t\t>%RESET_CONTENT%</div>\n\t\t\t\t\t<div class=\"reset_done\" \t>%RESET_DONE_CONTENT%</div>\n\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<div class=\"field field_email\">\n\t\t\t\t\t\t\t<input class=\"email\" name=\"email\" type=\"email\" placeholder=\"Email\" onfocus=\"this.placeholder=''\" onblur=\"this.placeholder='Email'\"/>\n\t\t\t\t\t\t\t<div class=\"error invalid\">Please use a valid email adress</div>\n\n\t\t\t\t\t\t\t<div class=\"ok\">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\">\n\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t\t\t<circle cx=\"7\" cy=\"7\" r=\"7\" fill=\"#78BE20\" fill-rule=\"nonzero\" />\n\t\t\t\t\t\t\t\t\t\t<path d=\"M0 0h12.727v12.727H0z\" />\n\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M5.38 8.852L3.254 6.858l-.709.664 2.835 2.66 6.075-5.699-.71-.665z\" />\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"not_ok\">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 11 11\">\n\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"nonzero\">\n\t\t\t\t\t\t\t\t\t\t<circle cx=\"5.5\" cy=\"5.5\" r=\"5.5\" fill=\"#EE4341\" />\n\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" d=\"M5.944 5.5l1.778 1.778-.444.444L5.5 5.944 3.722 7.722l-.444-.444L5.056 5.5 3.278 3.722l.444-.444L5.5 5.056l1.778-1.778.444.444L5.944 5.5z\" />\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<div class=\"field field_password\">\n\t\t\t\t\t\t\t<input class=\"password\" name=\"password\" type=\"password\" placeholder=\"Password\" onfocus=\"this.placeholder=''\" onblur=\"this.placeholder='Password'\"/>\n\t\t\t\t\t\t\t<div class=\"error invalid\">\n\t\t\t\t\t\t\t\t<strong>Please use a valid password:</strong><br />\n\t\t\t\t\t\t\t\t• Contain at least 1 number <br />\n\t\t\t\t\t\t\t\t• Contain an upper and lower case character <br />\n\t\t\t\t\t\t\t\t• Be at least 8 characters long\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"ok\">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\">\n\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t\t\t<circle cx=\"7\" cy=\"7\" r=\"7\" fill=\"#78BE20\" fill-rule=\"nonzero\" />\n\t\t\t\t\t\t\t\t\t\t<path d=\"M0 0h12.727v12.727H0z\" />\n\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M5.38 8.852L3.254 6.858l-.709.664 2.835 2.66 6.075-5.699-.71-.665z\" />\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"not_ok\">\n\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 11 11\">\n\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"nonzero\">\n\t\t\t\t\t\t\t\t\t\t<circle cx=\"5.5\" cy=\"5.5\" r=\"5.5\" fill=\"#EE4341\" />\n\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" d=\"M5.944 5.5l1.778 1.778-.444.444L5.5 5.944 3.722 7.722l-.444-.444L5.056 5.5 3.278 3.722l.444-.444L5.5 5.056l1.778-1.778.444.444L5.944 5.5z\" />\n\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\n\t\t\t\t\t\t<div class=\"forgotten_passoword\">Forgot password?</div>\n\n\t\t\t\t\t\t<div class=\"register_input\">\n\n\t\t\t\t\t\t\t<div class=\"field field_confirm_password\">\n\t\t\t\t\t\t\t\t<input class=\"confirm_password\" name=\"confirm_password\" type=\"password\" placeholder=\"Confirm Password\" onfocus=\"this.placeholder=''\" onblur=\"this.placeholder='Confirm Password'\"/>\n\t\t\t\t\t\t\t\t<div class=\"error invalid\">Passwords do not match</div>\n\n\t\t\t\t\t\t\t\t<div class=\"ok\">\n\t\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 14 14\">\n\t\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"evenodd\">\n\t\t\t\t\t\t\t\t\t\t\t<circle cx=\"7\" cy=\"7\" r=\"7\" fill=\"#78BE20\" fill-rule=\"nonzero\" />\n\t\t\t\t\t\t\t\t\t\t\t<path d=\"M0 0h12.727v12.727H0z\" />\n\t\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" fill-rule=\"nonzero\" d=\"M5.38 8.852L3.254 6.858l-.709.664 2.835 2.66 6.075-5.699-.71-.665z\" />\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t\t<div class=\"not_ok\">\n\t\t\t\t\t\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"14\" height=\"14\" viewBox=\"0 0 11 11\">\n\t\t\t\t\t\t\t\t\t\t<g fill=\"none\" fill-rule=\"nonzero\">\n\t\t\t\t\t\t\t\t\t\t\t<circle cx=\"5.5\" cy=\"5.5\" r=\"5.5\" fill=\"#EE4341\" />\n\t\t\t\t\t\t\t\t\t\t\t<path fill=\"#FFF\" d=\"M5.944 5.5l1.778 1.778-.444.444L5.5 5.944 3.722 7.722l-.444-.444L5.056 5.5 3.278 3.722l.444-.444L5.5 5.056l1.778-1.778.444.444L5.944 5.5z\" />\n\t\t\t\t\t\t\t\t\t\t</g>\n\t\t\t\t\t\t\t\t\t</svg>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t\t<div class=\"info_text smaller recieve_mails specBox\">\n\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"recieve_mails\" \tvalue=\"\" />\n\t\t\t\t\t\t\t\t<span class=\"checkmark\"></span>\n\t\t\t\t\t\t\t\t<div>\n\t\t\t\t\t\t\t\t\tSubscribe to emails and receive free tipping&nbsp;advice,&nbsp;news and special&nbsp;offers\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"info_text smaller over_18 specBox\">\n\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"over_18\" value=\"\" />\n\t\t\t\t\t\t\t\t<span class=\"checkmark\"></span>\n\t\t\t\t\t\t\t\t<div>I am over the age of 18</div>\n\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t<div class=\"info_text smaller accepts_terms specBox\">\n\t\t\t\t\t\t\t\t<input type=\"checkbox\" name=\"accepts_terms\" value=\"\" />\n\t\t\t\t\t\t\t\t<span class=\"checkmark\"></span>\n\t\t\t\t\t\t\t\t<div>I accept the <span class=\"go_to_terms_and_conditions\">Terms and Conditions</span></div>\n\t\t\t\t\t\t\t</div>\n\n\t\t\t\t\t\t</div>\n\n\t\t\t\t\t</div>\n\n\t\t\t\t</div>\n\n\t\t\t\t<div class=\"terms_and_conditions info_text\">%TERMS_AND_CONDITIONS%</div>\n\n\t\t\t</div>\n\n\t\t</div>\n\n\t\t<div class=\"button_register\"\t>Register\t</div>\n\t\t<div class=\"button_login\"\t\t>Login\t\t</div>\n\n\t\t<div class=\"button_back button_selected\">\n\n\t\t\t<div class=\"left_arrow\">\n\t\t\t\t<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"13\" height=\"21\" viewBox=\"0 0 13 21\">\n\t\t\t\t\t<path fill=\"#0072DD\" fill-rule=\"evenodd\" d=\"M0 10.5L10.5 0l2 2L4 10.5l8.5 8.5-2 2z\" />\n\t\t\t\t</svg>\n\t\t\t</div>\n\n\t\t\t<span>Back</span>\n\n\t\t</div>\n\n\t\t<div class=\"selector_underline\"></div>\n\n\t\t<div class=\"vertical_separator\"></div> \n\n\t\t<div class=\"sign_in_error error\">Your details are incorrect. Please try again.</div>\n\t\t<div class=\"sign_up_error error\">The email is already in use.</div>\n\n\t\t<div class=\"action_button\">\n\t\t\t<div class=\"action_button_text\"></div>\n\t\t\t<div class=\"action_button_spinner\">\n\t\t\t\t<svg class=\"ui-icon ui-icon_sizeLarge ui-animation_spinnerAnimation\" viewBox=\"0 0 100 100\">\n\t\t\t\t\t<path fill=\"#E3E7EA\" d=\"M50,3.1C24.1,3.1,3.1,24.1,3.1,50c0,25.9,21,46.9,46.9,46.9s46.9-21,46.9-46.9C96.9,24.1,75.9,3.1,50,3.1z\n\t\t\t\t\t\tM50,90.6C27.6,90.6,9.4,72.4,9.4,50S27.6,9.4,50,9.4S90.6,27.6,90.6,50S72.4,90.6,50,90.6z\"></path>\n\t\t\t\t\t<path fill=\"#0073DE\" d=\"M21.6,21c3.8-3.7,8.4-6.7,13.4-8.7l-2.4-5.8c-5.8,2.3-11,5.7-15.4,10L21.6,21z\"></path>\n\t\t\t\t\t<path fill=\"#0073DE\" d=\"M83.4,82.8L79,78.5c-3.7,3.7-8,6.8-12.9,8.9l2.3,5.8C74.1,90.7,79.2,87.2,83.4,82.8z\"></path>\n\t\t\t\t</svg>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<div class=\"form_cap\"></div>\n\n\t</div>\n\n</div>\n"

/***/ }),
/* 444 */
/***/ (function(module, exports) {

module.exports = "<div class=\"info_text\">Please register to access<br/>racingpost.com for free</div>\n<div class=\"info_text small\">Don't worry, registration is quick and easy.<br/>You'll also stay signed in for 30 days.</div>\n"

/***/ }),
/* 445 */
/***/ (function(module, exports) {

module.exports = "<div class=\"register_done_title\"><!--<img alt=\"register success\" src=\"%REGISTER_SUCCESS%\" />-->Almost there</div>\n\n<div class=\"info_text middle\">We've now sent a link to the email you just provided us. Please click on it to verify that address and you're all done.</div>\n"

/***/ }),
/* 446 */
/***/ (function(module, exports) {

module.exports = "<div class=\"info_text\">Please login to access<br/> racingpost.com for free</div>\n<div class=\"info_text small\">Don't worry, login is quick and easy.<br/>You'll also stay signed in for 30 days.</div>\n<br/>"

/***/ }),
/* 447 */
/***/ (function(module, exports) {

module.exports = "<div class=\"info_text\">Please enter your email<br/>to reset your password</div>\n"

/***/ }),
/* 448 */
/***/ (function(module, exports) {

module.exports = "<div class=\"info_text\">Mail has been sent.<br/> Please follow instructions<br/> to complete the process</div>\n"

/***/ }),
/* 449 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAATsAAAOKCAMAAADTCwcMAAADAFBMVEUAAABclZ5gpLpnp8B3rcT6zrd2rcO93uF2rMJ2rMN3rcLo7Oksjnl2rMN2rcRMQDkpi3J3rcN2rcREmbgvLi0oinYsi3XkvKgqLCwvlXREmLgyMTMYemgtjLAulHMtknQsi7AqKCcXEhEwlXQpibBTnLlTnLkxkHVTnboZe2nww6wriq8vj7IJCQgaf2hTnrlTn7hTnLkZFBKMX0ozPEGMXUf5xKkYemuNXUWLXUWKXEaOXkYHZlzl8PD70Lj6z7f3r4yFkJDg8PHHnIVVgIVuxNu/3d2BlJHKm4b3r4vInYbx9fNqsJp2rMMwlXRTnLn3r4wDZ1wafmgsi7AcgGnYq0/HnIYBAAExHRzFblO5o5uHkpLC4+V5rsUzmXZ9iz0yPURVnbqmk2klia8BYllGclhxxtr4s5BNmrh9sMVXoLwYfGYsk3JdNjHcrE/NblMHaV0okHAnFhX+/f729vcNbWCRX0fx8fHCZEsyjrMckW92iD0Vd2Q6krRElrZ6sskhhWwRc2IXDQ4dKC7vq4nJ5+g/JSX8uJRxqsK+qaEmim44Q0lqp8BdobywmGc9u85jpL4ahq1uTT9Xf4fB5u3MpVMPjGi2npafzsB6YFbOoIjilneAVUJOLypqw9GVx7nPel0tMSnroYCAj48FXFBPd1e2aE+IvbBnw9vYiGrgpYeGkUF1yeH91L7kslG+n106b1fP6/AUHSKoYEqRl5ZshEKCamCWQzBygjIoNDfBzcugTjk9noCfb1bC2NVYekxChILX39hNpouZjWNif0qOdmsveHCagnl5uqVrs5y1mUiP0dxcqpOp2uCEtMe9wLzDjna8fWdlfWt6iWCjj4RuiIQ1aEutl42u0slXlo0kt8y+sKh5rqnPmHlBbk8oh42alURNo8POzrb4v6ItQjmim5fp5tx/lJeSn2dLVFwPg2whgnqiekVktsdRXjjasJpwo5ktn5NXw9+dr6c7rbTly6uqsoaruq8qiaPawIeOZ1Petm3y4Mq+wp27qHZJjaTZBnCmAAAATXRSTlMAEiE29P2u/mJJxv4r2JQkcOd8TUFAWSNf7Genzau/oNCA1dn18tSJtbFC5YTq55uD5bWK4M5ljUGuY+vmUZzTzcyyftDChnS1k9SA8GuebhcAAGzMSURBVHja7Js/j9NAEMWdIvU1SCBRQUlJAOWCBLR0qXDyCbZaWdoiSr2y7N4dZ1uyXERKpFQpUkSuaY+KKlU+ABXNVbxZr/MfEwMNmjyRnO8MzY8382bWF+d/Vat323Wu+hPdvB6N3nbM5RVhQ88BHeB1Wzed29e3N85Vl5IDOCiS6aunb+nq1rmqDthNt9vrdm9allwiA0VK6Sp45Fz1C1FhwmDQ29eGnAwGagARu1SpwbNr1Z5Xt1NyS5IISpJRBHAkfJGFpOuXV+OdjwXDLSKrQXowSiw6pWRB6KDnV3Yn6pZ5GkmAMpCCdIduEBUJ0F3ZnUdHxVqMUm1rVA/w3dZ1SZHAhld2Z9UrTRcAlg2GBCAtuiAq7J1rvztRt2x0AYq1ogVyu3wtJO5YPb3m7L56qFdK1G2kRqOiCliQs6azetJyrqrUIdMlFo/1WZJWIYExJVV76IKr7ba6MeUqd56TICcr08mdHe39l85Vu3g16HaeO/DZrlqrRthzrsLWetNDuZLSXUQc+QzXhxrd3lyLttXBulpKagsKIx3Nd7+WksUoeOrwVrdjF/5kNAq2rjPzXY0IrtQp5wPQVvf2rV1cE7N2WaWBqkUHuGan5RsXN3ZvTWkAMWPczlb1CmxnfM6047XokMlmaWoC9mKplEqaL7vt2qqodyV17U2dXtqSfslxs7BzMBjQ1Jukde1Nu4FlprTev8Gy37VobS2qbJB15ALtusBnmNElFOzuMhxSOqhXMtsF0QBeCm+qvNR7f1txZHewt9ZLuUCHNx0QOde6z9xyNUN25pipNht2noM0vasBXSqiWX7B9wx91yFysnaCs8uYS9IGmjKX1oh0z5J85jBSi9BFteVqi1JZdEYWnaoKV1uETxw+MujSOnLAY4OhkqIFjeZnfNWQUiVCZqNxl/K1ttOZ5mZNZwilKy/zjIak8WSykOYGtxHldlS3e8FWVW1WZapWmUfE8KeSF+d3n6liebU7OhlOaquVZGoSUkG0WHjTaZzH0zieGmVZFm/a7R+fNbPns63XhE7VggOxNJVJkiwWQ8+b5r44Ub/dns8BD+j4bLM97GGnOWHXVENsAWJAZgSH+UTqVOG8PW9Lxanbke3OodM6XUyACrKJQJVpwZ1VG/B+BIrRgALbRfpMsMph5tkswHuW+6BD3H6tsI2yLZjZ7ky1phOvdBryIM7z3FKrlR/OQe+Fw0bdM+OJGqwIWt7fS4KLtIHx3jls1DmdilU6ycZ5GIp+U23IeI8dLno9Sk5sl2TjDOCaS7Q5FW3r7UnJqmDoDf0/Yudv5oyKtnuaFCrxxnHY/zOh4b3nUrS9UXJyRjfxpg1cd9rx3jGB10HJHp2XyD9HB9GM98ZhoUN2AbFLvDi8sruE3dE+5rp64vl/4buQz4h3e8hOaVePvb7o/7nabEa8A98pF1LDDAT+jh2Poj1lN/Bi8Vfs2BRt77Bm/wE7QSOew0Fdy27nvOAv2dF4zKPh3bw9mO8C/Ze+gzZcppTW6+gkZ/O/Y8dnp+0kR7OxnvwlOzHn0vA6yeBor1g0YMf7PKA3Ov7lsNXZtUKEeImLzkM3XNgdhQWMJ/viDDn/IU2lLNb93+MT7TmTA9DX8nhIOa1ZkAu0kUqLmQjD3xhvziNonY4NWl0ZT6/FEbn+OnV1WjzIQCulg6i4r6EnBJ5yMwna7qiCpuxqcX8E5h6ekwXcJmaFHBA+Je/R+85xC31/NuvPmQRtC0W7gwcwbnFAJfyqomJdkhLAh+pVkJQP4rAjgq2/LmQwUOl3JpuFc5uo3TKrXO1Gh47KZ8CynxpFZPDpfX8StkgGShsFP+Y8wgLT8TYnNAAesxPiOHPzgp5rKLDboSskcVN4k6nS35iw6yX7H5rAa/C7c2OBxhfoVOy+F1KTBmnydS1E4UZM2LXepjvjufRaw1D1EuHs4V5U3wyHYDeIHoq1T+UtxOfBDx5Dip1SqgkFxnsw7Oq1WzHC6XKBdoeuuP3R5ssPHkOK060+kaIoL2xYXCzhL5exgNk4DsflWqYUyOHNhdK604DjsTgcLrOTxYLLIwt6WBbooPi6nq2LwIUGRQ27r8WR7VarE9RsHvcgaYs0QrsSAhEQUdXKX7ITa4XZ+ZDdcto/EpdTd7OWyXVYbREuFPySXbhW+jBKxGQ59O11lRZsHtGi4b0GOjsEhw/17O6VTkpCu5hdTkua4iGaCfrKiN3jD6KPQ7s8x5vwKWvvw1+y0zo6YCfy1XIiSk9qNzH/CVwO3aEX5LnYG3v0iCwcgd3XX7ETs1QXRzvbYrnMhal3rdix+xAKPwM50KM0qJuOAW99bMV4ucxC2wulqVkuD8rKkgU20pimXInjgNqzzWMtlovyVmQ86bM5+6SSDePx0DOaomgTTMeiyWYRr5ZxCXuGF9ixWSucN2FOnxMrnYdFtaCjlCbsaLWwSWvYCU7s4nGcxyU8X6DlN2NHY8pkv8g5+a7vZQKalg1PzJSrMKfVqm4v8zdzJsd3YBePfTPgjcc5NTyRuroBO7tbhHu+4/J8FlkRx4IAZF4eTjMTtPquGbt4udj/B3w+3PNCGHT5OA8FWTCMXHXXqOHRfBwLluysd4idj4aHIUV/asYuHB4U7YZNv3vsG9/5XpYLgYYXFlp/mvUbFu1+WmzY5Cx2sjItx+MpNTx6mv39E37SLC3icMeOzV7hfCwdI6bYZ6ceNtrP93dNizbDeCwYsntjHSNoRvZw4d99ArumReuLLUk+5yiPP9iTOM/DCwj8T58aNjw6EMi28EImv7wItd74VdLiRCUv2d01Q4e9bDUNKxfyOTdGWljHCACkvAS7RkUrRCjo+JjfgGfTosIH3V3MTpjna76fxwt6xs2QHR1/7uvu0oYn8ulwsVisVqvlcm/E2zBih6g9YXd3CbrhcqvVEBMeR3aPP4RN2Pn0q7G+j5EYzKDFIpvGKHKW7H6Sdz6vTQRxFM8qCIVFgtCUQmwPHko9eLQXD4II2oO0IQgrxVPYESOYHgJ7CGpgZLHngjALNSwlNsveehAU/AfEujlL8OBRSqAePOp35ru/ppsm67E7rzGJ1V4+vDfzvrMbegoeO2OzoB5j8G+xGBsGwcijeMusquxKC/dTV3E4l+yC5yE2SciSMU8irVJHEbp5m9ghpAw7/O5UMS/mR9SZK2Lr3cQBgzKEIaNjD2fLo6rNs3LRSyjFMUSeucSoWmdQiTToeVTikM0r80DsbJRUrWoc67qMyYtdJ7ERomcSpAodBUiRlS02IbA07iKUawI996eK7K7TUx7zMruEZ/f6MPiHEv7LwFNxq8BzPJrGcBodE/cAUJeCoIvgp8g8ufgFYwW3ivs2FmPJeHIqqQszGIz+OIgd9g0YxQCfXJvHqjVjsN0GyRY5OZHM7n+gYv5HfOJNf8DxUZb4TrlmDLabOT9Q4jg2cZ1en3P7FAFEfB6L2Cm23GnagktmThB46yJf5aiL/FL4SPSDY5WWuwtzc1cuX6YzB1eWPi6mzgDwcW6oT9RGdgFTqBnP3TVN3zfprPlLvkmFoP2AYK9n9I3+IbVD6OslZaTd9U3TPHk3c+73Jl/l4SLwiOoNu1NSRnMm10GaDJ3suyw8UPbH1IlsaLujPGd1dDo79OsdddrdZd8E7Y03/hMehbySSezUQXcRE3tEMxim7bSUlznPo7aMj8H/uFcqqfJLZ+76gt3BOLN2TZQXuzLg3W4wID/T7JTaKS7s+SbXyfeNXJcnWHJ0cigmMsORrhEBO2V8dwnQYWgzm+YZqY2/z4b9Q96MDx3JqwuqoLtoRsqElrgzr00wFgxBgSctd4qI9xMUdmNZvSHAmM0vvtGRKhXZK37iO5Nm7uU0grxXxzDkCkVWu2KisrsFyrGCh/lEo5tY1jUV2Gnlq75vJjrYyxiPPLdysvMwsRBZFdBVbu0f+6ZkvLErkeOptYycqeW2w1m28GOFvlbd/+FHjgvZ/ZHYueJzUnmXPC9kt1Bsdpq+tnqj3m2IViyFdkxTtutRAk+GlRMeE0/rJa247PQKcONqNp4COxneSbrjATsRWiPfflHsoztNr5RX6/Uaf9Rq9cYvP4UN2R3J7ODZAIGn8qioZygX9PJatdYEboAN2XVbGFrkhkobz3CJ+JwUwBvmglfAoUKfL69Wb4ig1sSj3UGA+0+AnayT9/HthxTZuQbIClSLrKZplfLy6g3hMqEaGm4T3sHr5i+p38lTLaGWi5/mtnLBK9Rpu1YqV6vNTi2BxgmKvG52BLt2e09uKfD65ZtL0r7D0IJy2W79/C93mj5fWami4WLHCXb41Wo3eXY7jScZ2339OCCy71zBzhoWf7kDbGurVaCGQnoRNhQYrtHB0NaOT1e8rd1HDsETKGTHKx6qqMudrpeXlyvlFfBaM6EWooviGmPsNlrCf939v76U2IMvr3c/9zZkdo4VwWOFayjz5ZWla4uPHz9+wP9s7+zUoYuEoBJsuObh2+Zmo1nnr/tJxUN2X1+D8XpEYkeNSEFQoMhq8/MrS4CMQ4sE757tvEJ+0c6KKJO/txtd/oIVL8XO3+IyHJvbDdnhToviw21BIquXry0+QGooid828KsBwZTqUXI7rRb2llNz2dfXgG73jeWQNDsMLSqYZrtzE9nK0qLMTRZABX7cgCgglbIf7hb1V208S4kKypbQ7hDgITshaqTgDQtQ7nQkN108yyK/oNB4SLHLQwtfna6ZZge2Q+P1bGQnhxY05VjlvJS7yvLig/wC/wFBwBZl+FWn0cbG3Dr2U+UuZPcxsBw7xW5gpDUcPRyNJhXjc3FgrC3LnsvjP4Fwe3un3hTua22GVe+FH6Mzt0LtfjYM8J0TsaMwWySyhi+Pfr8djRhKNBfGzslqpy9NIZcjw7V4p4XQ/vLlyEap/cfM2bw2DcZxvCqYgx52cdCLO+ywo/4X3oopVRDKLzDS+pIgCV2wdEFTMIg9eOrGQKiiG5sQtAUHQ0Z9Zfg+tb6iTBEEL0NRUTwo/p4nT5auWZMHhKY/0OpSJvvk+/29PamXLjB2GKcuHGhn9/zbt29zjx9fff78+StPdc9fDG5P9H8MJEPQ8fBTKxm3PcZgpvUty+Jp8bzP7uDedew+zdF+5sdkiYa+CDq+qMmdI/3ObwC1858BKajIooIlBGeLQ45nWcFHV10uHvDYsYWAz+47nUOcVRW/FflVUtdUndw50MdZbwAiuFRULnyGrOikfpTRtH5j7MN7UjzA2LEWz4/DbIYDlfDqvC3JocEdfclvx1AkFT0NPOwysuF2gOaqsz7dsVpbLF5q+y8820sFQ+f8qKigZJjiSHjySw6PDPYfviEOLmUudmhaHfAVMseD7FjGO9V2aNbG7htjtzqpgyabaauip6ADH/SddweTHFSUCgc80EXZAqrT906wVNBSS+faILvTDhNebVGHiiFjiJpRNjF5UoiM4PBQX4lvO5eiLAP4Ep4JbuPsd3cdwsOMF0x4xY+P5uaY8BZVAB2HE0OUWWhlJWNVkCAV3/BIv6S+zTu5oOiyDlwJT2N/OOIELUuFV/RHiwu+7q7ZDmPnHNEpIkD1WmnTMDSRETTX8O3sj7YFkx1XaCYPO9U3bYAdDeFpsYirPBa+aZt21vGEh+xoMKuquP0yXYKiqVPvQnJoIH58g5zowJRV4DQtfZ9VC6Y7jOpbv8fzO7zik2rWfuSV2kXWEHUgrOCWi6hPpfQQ345ErLE9ycsuLaeB620a/dlYpc0Gokl2T3s72e2vZrP2Aya8H3rX2U9HE4uKytZhI4kYgzmWL+EZADxvk023XcFz2jnHl53fHzPhtReL4nKV+Jmxq+lhszPoiuL9bSgRX2waBu6VkyiqHOxSmqy5VcU84tB0FzDtAdogs6Mfr1QQdrbXp0D4v+FPOYsxJr0dkOJnJ5s88MqynAGaIN9vzK65H4GdbD/xQZhNcsnLeM4tPeoOuaHPbk3EEIG9E0RXAdECnoQnlyk7S1slpSIIj5Tas+vZna7SS3Z+zmPHFfrdqS2JeGL7cMoPi0NQZeAay0SVClV+7wjZDeLRsl8tfHTtwgOVk929qT2JXkewUICSgai2ly/jGSIzbbrsBMFhNa1V968J77zboAg17+IcqxW87HYnYontyXV6MaKmMlmU+U2LoWon7CA6oZa3sU85v8au+FRAng9s9+oca455PbsrEUsMwLr0K1cgYmTAasFlWmzxXAW+aQTZ5WuPbBQeVgva4KHqrlXxi3lfeM5DXnalu1MxdCnB/gTKUWA0UeRaCBhMn5BZEgLoHtXygk0a5EsuO1RdNYtarLGyIszRuYIrVDh3Lp72eEfnlsmIZqfxdNGKKKfBVeBrO5jtHgg23eMxdqerFCg1LevxgJfd4lRM7Eagc/emQ4SeRLHCYVrVkNltmH7XaVqhVnuAL8S0e0+RfPdUoGIkprVZqV1NcYa+OHVvIBFDbOrcPYGWiWSHFZRHeLLoKkdcagRkR82JpsVNFGG3XKVfzaPwPFevqrzsbk0txsJuR3BTYugQ3uDxFAvqVZbwzOkpu6PIMnYovPME3hfa2dUIOy/jNc6VeEvFw1k9ll3KyAY/cjmUHfGswXXYqLmMwZpur7SuwGqCzY4bsVqcbDIjIzyv1DZmJ7lblFvJzYkYYoN1sSarEK470eDc9WlsqbLkg/PzmreK2nvyY9UjmvcUaQu3onRXqaSAnuLeS+2MYfseXNxRi1kQSoQWWi7TsmbRmJ5tFx4iommNVYsLBwVPjXjFqb0j7BpTkWVWVVR3k6JDLGV2EDaaukwI9yzPVEYnCtallKdvuOx8Rv4jZcVLN6tt7N4tGcTO9t1SZK3IZDz9x5LuBjZgZ4lGuGd52aUMWQFXqks+Otup1Xx2b5Fdk8mRsvv8klYW+140O8v09B/H/m7T8EaNWeiZBCiEnQ5c7TGWHTbbnlsT3oNaO7vlYvGJK7ssyXVzd+/X5SVy7aEerTuPXTKWdNclT2UgPN/JfOx0GQVKv+H0T9tv7fJt7JpFXLSzxgV1d1i6boiYHW2hVIpMCemyFuPOfXDjZbZmQohnedlhaLTDA1UW73+sshrrVtO1x0CLB/zNSj7fkuqaKJeFxtRkJDs9Y7jJBWLpjHfChuzKWhg7Ps8yjSpAGRoTv112n985eQJPyDJ2B/BszKPqfF2QFKziOMSdi2QHlpcSkv2S7tw8FcLGEPnZsT4bb8bEUSK8xveF1irVXZbFtdNNhi5fc1YlSYISmVtsZBed7mQlPt0NQrf9phXBTuV9jEBz9Yfs9jXRl9K4JCE8bI1ZNJttTV9LksZLqYwsT9+bnYxs7zKGl5eHY6gVI9AtxyvQ3bMi6435HyOAtDFx9OifauPzgiQttPz2DtkJa47Nt/DqfEkFy7R0iNZ0WhOtFEBMPcpQF3aqXA7VHT+7NHU/ZIyJy/d/NpooOwy/zK5vmJHrAmGXUkEtQWS6S4taJaXSuWww0evYPtx1dtBChoWoXUCw3QFLm/iwMC78XJBItJwAu2wexShJPz+3SEtMuXGkO0OHtIZjH/R8nt20M8RqKQhlBynO0EzKbunP59ad1vj8vDQ+Ly189U67fdnl37W+SvPHChy9Ccsr5KMIOmTIzNz7oWxH2EGiDl2VxHXY428DaXO8dGxs7NpKLpebydVncjOrnafd+dWZldxKblthlgMd61BEWVEhLZJlTc+XAaxS8BdahpVzb8xQ08dSkN2xArIjUc/lVmZ8dqxSILpc/dlY4SEnuwpaVsx4W+xemxa37SFpSoGwkQxtwhsauQulG2PHCssvCbqZFv628rWxXnY3CNeVi4XCLT52qoKWNSzXBWXy4YEewQuu7vgLrSpyl1nG2kwxdr8Iu3rrbytXr68sV9tl94ZK8uXVwtiizidnJY3MKmgQ2m32eg01CGFqMbo+ws5dKpj9y4TdG8auPjM6eub2zMztM4IPr/EOrxB23ws3OS2byZiiaKokg1DT9ni2GAhfcKohpYKJkk8hporsZpHdxZf1eq51ZnR09Pbt0dFfa/BsAR1L2f3iZaemLcwdpFRQdmXo7S4F012Y07oUWlBYqeAPMiNMniuMFV5cR2aIDpV35czo7Vdrln32coayW7lWeF3iuyHkw5KaxRYToqamoJdz2fZk+DxQgY3PvtgmgD+AeHaqcGzs777LR/ftm7iyb2Lf0aNXrtz/S4VXrf6W5qX5cWl8fPxm4e4kp2XLNN2hP0iQrgB6OFsMQGiW6lJKLSI7L93xxz/ezi6mzSqM45nJQgwmeqPGxOiFF0ZvjTExeqExekccYWaCeZeYqjGttKUtkNILmFWDGpaw8SVo3Sg0QMZAtmYSkAKDwcRsY3wOpmZuzo/FbU5d/Iz/55ynfTmc9vUFWx4J7RBY+9vzfZ5zTuMS2P25EwJsO0vpAY9oS6H5+Xvp16jUIMe+84GdPbVDLUsmi0RdSGBLjRYma/nq0iZ48C9sshsTV0G+v+LbnesF8PZ/BownTXbTQZuRAlulijhyQcjDWHTxttJk8aLSbgUITiccsBXvRtl5x/wVFb/uTAMP6NayQ4piR+2Q3EHXYLIIs0LEq90yo33QsNaUdGWXd2jVw94uK+xYShuY3W++ClvpHTaFU2PeJYocKegKbJ3RWpospcB6HmI0Ti1HPUgINswuOOOvyLdgtzvJLr/gv9kZqClCwFXI/X8SkLTdAc39joo0+a/XGyOTLdo4usZpn//b3zOy29kj2V3w5Vssyrq8LjZZya7IkL1EFpddh5f7/WMejZ0L80Y8TrFBdBcPHLjk+0sG2VL5qVR+4pjbU1Ul2S01Zrb7oAunLjQGvV4nuTva+sKhIpmm5Li00DvG9rufwenmhMPG2KKG/GJZWdmelgt1dciJDx9++WV8qsMHhJ7UIVWe7Xulo6Ojb9SXefapsWApbykSmZoZczlDNdFo1OOlbMBkF9iqZso2LcrqqxL6dOWqZxNqZwQXynbt2lX2Yb2sKXQhdlRVzFZkTu+CBZH+t97q78enl75ojqwuLy8PBYOBaNQBwavyUG9nK4yW17QNy/bH+oI2GIsleHpsw/B2lQHeng8zwas7K9jN+/wZO1DB5jXDQIAIAcPVmeVEYhI748EwGtqSfgCbLG/hsbdEGxxrTnC3fePwluv3kOrtGv/Hgp1VB6pxul/foyEQ4ut5zbFry4nJQlfwvqwBsi4qjHexyGq76445/Bi2JnILZcMVWcURAa+s7R8LdjeRorjS+0wXxsoyCttyHvzhs08+meuTo9D2BB3PBtgFh5qvOTbPzpf/BmteXXp2lt07KH3SYvdD0gKUOpj39NPA9/DdOQR4hyHmHFyWzQCV3VRkEt5uk+wG/b4LH+4pI82L/wNWdevZfYk1oC8vgJ0rfagWyxt5K7WnTg0OfpaXB4YkaQhCYMR5kuHduYi79xG7QMCyZlQaKcEZqB3Q2Vkh02vjofyKij93nhROb099AzK6w2hFNUB24g8NDWikoAV1bBQLjOnZTwm1W2lqKp5raWmJT0ycuHTz5imMFOy3YAiIT2cf3oOUoRgeS3ZeZsd9kEgssVl2SAx9aKKU9vZeKSsju73Sy8kxHvCB/0PNgGO7KzKkd17h7fYPNhUX1861nJg7MREHQWJ4Yu7SzVODn2W05f5ns43uNoEOVZf1ljuwM/1NBLndZtlR01hUFb0n394jIkZpr1KUSXbf+X1TwbQ/H+sHnJdqmwjdYi1J8eLcGoRzc2TMsGYx3LIWYh4cX9a9HeBgm6HlnLXJzoXcbtKxWXau4Gd+/68SUmk9qd6et0/2pmU35M0cKE4BXVPLiZViKYJg09zEBAhKHVxsoi+uSI/IDN96dlv2vR0ZpceymQR2ZiEbWQa6zbIryK/wcyMA5rlLqN6VXpUdOu7oQBV4MwaKFbLYeLxYkVqSpsUT8TjhI3701SZ8KxgCYt5bedm12lvu4WCAKSILCaTYNRrNrHabirPeoQqEihSnhjYRMtp6exV2x3ou+D4Lpk+LhbNjiy3WRdrwRJzDyOIKFJJlcWUlq1Z7Z2qx0HILSmpXmSs4tll2/ON+f36KE1zdh6R5u06a8Hq/BrvvwK4xjcUGmylQCLWbaDGBafq3OBePs/sj4yX9K16EKj5ye3Y7xsyusMCSXSpMRmJksvbZGQq7xhiHiiSp0rayMpjth+z0mN1v36IDZejkm8V+Rxlj54AkkwCXtF52frXEbxHaGH9kWza7nsyuxmXVSGF2XqM5EsPSCkvABjnlkDwvhwpTShFvy3bt2QO7LTXZ/Z3vizRmTO2gSostcdCwEonrxEQygWmqXVmpfSoefySbGQqzswoWhtOlqJ1tdsa7NQ6XklaLUKFI7+/FH0z8Uf922xq9u+D3TWvsvAa0jlO7CcXbWQEEvqT5Ls7tm40/ms0Mhdk5qq0KWldS7WKrAZOd578njNWuvGupooLdXTIX/jN8MHyI5OrV1/6kL/Qgzn7LXRSt9cRqh6zYAp0ePFLpH/Quu9sCwM7e0gPUbhUlhS12jC6kNmBGK/zfUgnL/eLzB+l4ALpT8JtvthPA7dt/rxsZOVvhy/e60qZ2+5HaQes4P7HP70j7RJzk8Wzv5DG8trZfeznGmuL6r1N7nPB4akHmvzDOVf/46W55dNZryctAv9m+HQSvzs779E6AK7jEgQLOjgOFbblUAtkHQUM02+xctoYjglOoxqIem+zQMaUlSLWgAru/xxndeXEKeZc4joclHH4e/A796tcXeoIzbLFC7TaArrb4SHt7ScmReaB7JvuLPIatszpcrghKCkXvrOKLVx8JbaQpnuJxRhfmKyvCSXam+h3662ajVggTu7ziJhRj9r0dpOlISXtS7e7KalHBErCxpQ69p9WQw1Q7hY2ODr1Rp7EO/iiWtesEubpuwQlq18XoFH7hb64F17X53zK93eIG0BE5knlo3R25WJc1aiyDBTuciKxklXVQK3QBQ5+m8I+OE7nzUDZC1IoTAvBMl+2/FgSVv1w02k8JbzdRW2vXXC/BXIW0Q+vuzG4fwGSnVwn6kuxqzTp2hRmHuMUQoaFPUyBU1NWdT50pKw4f0wQ4uw6tyNsD+EdFWjxIlX28pWmD1soW+2B2Rylsn5nA3i6qoOPYbHv+HaGCMuM/iQ7HCVybImFJed68A+TqofnZiYmz8u6AxiHp7KB2J2w6u9omChEsRyhObMvNKAVWJFQL1NHpaqfEZh2drpMoyNBEOZhSroPiLBlpu63h1oPhsOSHoxdx4PGhb9wkE4AXNEQPQHTt4nG7aQmTSzq7W7LeumPxptUidW0sklDRKWapoQvp6ODuvt2+xjC7SOv4mp5K/Af5uOvga6+F6cqjyu6/uulLBM/1RaoHMMGpnV1y7Ow4xOZmr7HHukzwGlPNMa7GrJMU1mGUsXp66Nt+kLWO70gJr7nEcqDTLY5I7Xoe6Ei2HxJP3LONM/2sdivUA7CV0ZWsFbLYrKK78x79oBOL/CQSuaaRY5+mRVhWO83dHXo+zODYZNecjurubHsR8Ej36BMrXqVg1yy8Xa1db3fpSIki89lWu9vuU4sAS4eHSQBZjoGLlqRoVy540jH1BudNcEpFAdslau6BetI8Uyq/OdQl9G6aC1lCF2/6L3YcI1SLRYzN2dCdYT2zjkARWWVelkkKNsc6dKREbugFZqaZLNSuc4AglavwEC7+Ol/priyQ3o4anjYKWTJXVTjG5iZSsKVlLi28Q5EIIoVHZ4eCVQsTaj3hknOG7YrSyTvwkkGW7HXALeC1KYp3/q/tbZUdsbWFrN0YoVts7vbLGkX8ptM3AaB28Ii6eNayM5Bir/V1LoBrDI4tjRW8YJLTLDbspkDRhs8SnnsNvK7tV98e4o4nqV3cuhq7pCsdWewzD2Z/XVZtjtcQioxqx307y0ALdB7T8r2YaB0am17qf2ux+3kNXavITzjKgpcwVyggwausdLsZ3ouHhm9woEBFYW2xTSWXLxMt3WJZ7XI12m5Y7DQJxpDbcYKiOTwFnWzE09UccHAzsak8MRLXqqGDnXatvb/S7W4rBy6C2LZQ++vpP/5I+bztL5HIQIHFbGtHB3q6xSZcWR7Fs7spkY+9jTm4b6c5vGQex/sbPAixsNTGgplIc6S5X5ib3ikJf5xqeIaBTgZZPBDFnyK+SNQx7DZvE8CvABuonVWMLbncjm8/Ieipaveu8UBu2QGRgMMo1k15Nq86dLUTpFKr3oY3CdPrGpqZjkWInewbmffJmBcaCZ5sstJYES0kxVO+a9EdfdLvVZ4RkyQr0ttZJiYlZ/D9kt5lJT+pyfa2Rh2R4UxfSrlcMTPI6lJtrEHnQLQZA7dmSCQ2NiXY1WrsYKdrnkoFa6NoIel9S39bHznASql2p2T/JHOguHS5/fKZSvnTivIROujDHTnWO8PLLHS1i6w6MpBj2FiG3eGATM6AM3GLTI0Z3sbPBbvTKjuyU/QAlHvw1My4NUSz6oFOtxv3znAha1VRUJPucolycy3wsdpN4t8zy4qXqf2hlwRYpWhOZGYXEOsdnmi0JjGD74TEpmeGggiyBcFXxYTmGY1daxfFWO4bv8jSlsrtumZl0GkZPs1qR1NPGbxdE3SOaMFipbD2nQE9WqMgz1Jk3JVrdl7BzqMtjkXULoBnXUmLbCQ0uTwtuU1NDyHGesVPXucjnzWbDYdTGgiF4wg7wB4PBW2cf/d10QMYtFA76NxlcnRt5dBalR6Z7r72SXqJO7J7ZEqGRUEtQfYiL25ezqx2jmghebhmYagzQy4onCv5o798Id46l/ya8D3H6AGw4tUn3/Ywq7Q8+r1W9k/SdkwuwVrPuMUPlyNGr6PXOccDqkUw2hyzk6FWHS7GKgUmszOAC4QS8HCCW0wYqpLanEteMJueHN+n5UY9xqG23C2fSb2LynNTqKJYzNC2I3QnWG1Bj9IcFd8fgR2yu3ZnTtlB1JqKe54RYbK6RKM7Essx4kYubsxoFN1xnV1tRnbvyOZTuTRasxfg7hBvOAq140HFCXi7NG06FK+CHWfV9W0CvgqPt3LfkXN2XrUrR+XYVESPsnQRYmByWYYGaNyYwaaqsLu+N3ngcziNykFaP2Z9e5GlHipIFAIidZxMFbKLaVdkmwgdTDZlouX19W2a2xsOCHW4L6fsuBWlttLRfFKjrINkcvlaTLq4aeLm1bgJdr/sFXpzBuzekSs5tBbBEg63IrOTQvUYU4TmVX7cJ/+mZhGli0VqF09rr0IUB0dub73Xa6Ffls2teZYHFnM5z6VszMPB1RF1BCYTy6sS29T02BAV/C4TnHqz8969MlSgT9fa1YWlnNegfwfx9GMI1fkQttUXk/BgtldvitouuswdT6VtpxQSECQiKii4vQHVcN3ulgAC4B25ZgdB89Ije5rcQWlejkp1A7drJjYjqOsbjB5HWqVM9mdmB04k1Ex342lyYScVFxEkUu+z/KpvNeqh2k4EaaTF6fontWafrp25m5aLmKF8zf1yH/41Hso9O8Nwren8eqdBapIu2mR1iwGb4SVxpd+IEXClTPYcUmNxx2dSKlVjgpa1DbDilZsFmU+sAuNkXi5kkdpNrNSq5ITSMbtZ8XMqvbWWW9kqUu0nbssxO+7kiY4KMBrV06uJ0I7Ja5SHYJu0USDyN5fVSbKGyo7CrC6kcrDPVDZMfo7v2Pb7kRF5+Lz8WqooNGenLEjMJ2bd6xM794D4hdzF+kAm84/lnB0EyAIOaog4cRBkILrDkZgeS9rofw3cvWuYURbsRJhV3hpbKVSuntFxciafVF7y5aM0jDqWeFURjXaKsWp4VRt0ie/TFBXlKdULz8r498S2nLPjAxKpnnSAoAMWXBRsbAzaOW/DgSO4NXbuzmGC504JVnYEOdYNsyAjdjeInSda81IytStuiaupnb722vKG0qlnx0mZNqldmMI2Ge0tW8NO2K1DlIKeQmV001Lt2EtyhnLuI2J3+o0DBz4s7xxuKx8Y6BwYGCgHt59+qm+DqxvgkMh5MT5f2f237zP8zZOxfrOQnai1QHdkX2Je1BTr6eG3t+GLlQf/wZsg8dy5JexgtDKX8zi94GgTnVMWJCY70Ub5/pMDBw588v3gyStVP7EsLIyM/AFqtLQDemaSd+XYsVFqGge+SHq7YuqfaAar6F2i000mqmfFnW349a2vzc+EokixshhpLW0PSicWbYoKbJMD77UdGBeyO2L3Vt7FA5CLg3+VnsSJvEKw166nZ/cVd7IITWYqV7BttiofTePoNU7tuH+iJXUKu1m5SKSrnkB6fu76UmRMqJ7ntpyzw9kBDlHnV9sFxw0sDhQ8vwJ21PrMe4/Yfe/7/djR3YpUXcFbddN7pjyF7LWKNpL5kaKE8kRFQeho/kTpcerswJ5jq2647tPD40NoBE2LkYY7tuWWnTjOi8Zd37VNjucBlN6V9zrYfZRk90n7Xz3QtnXwdjO9AUa3u4dOH8sPOOQSkVij4EY7o9PJYYVHyesGFHhYxwwfXAwiwZohxbv3rtzWZO/i+Ees4LCbsysAjjpOKWZNdpDB73anEdAifNLmyJKrsH9xkFI7DhRNcQQKJUjo7M4oFZmqeq1UQL/QaEzLFqQnSx7P0l5DSmi1d4GWssLmGvplLyTJ7vtRnD+ell5VT6f0daSWYg9ejO/NkxWFmZ9wkNDkzLr4wN1ACK+ef4fBW5REk8i2UFvkkF0NaZ1HQ7fRu6OR3ZEQhPfKDnwyP7jQcfz40aoqsktVoHqdnVd6qiS7v/2+a/K+xs9UtaMGcVq5rLg4bsW4ZUEhZ3Dng7RugKocmWp20pSMl9chvG4YHa5+wuG7GrtzXyDQxvre+2TwxkLfK0I6jneMHB85fnxk5PjRo8fpMHw6Ep8eSAtx+JhveVWYLBeyi7VqgNWlfThTL0CuxYUNrxwfpE7aHblhxw2ozaCrBjryj6q740CLI3KOjL6SQTrEx8jxDqI68sqXoz7/qrx9Ro4WN9VmDLBmPTuBgKParUj2eIC+9roY9sY0EgrNe7MSaTM2Pp0bRveuiBOqgJ1M8CD9dHi7tfT19XXQA/YvymZxbROPFmcMsOYE+yxSYFI0Vfd4zCr8umDnNWIULhxZibRpGdi6iFfv03Oc0NntxelCeS9V+G5o7HDGXV9fChzOxH95vE8c3Ibvp9ROdDzZ2en2qtaz6BaL5ETVvZYz74Dc81fPgZ1Yd0G4iGbHaNOF2E2hc3k4KVYE5ITDW1pN5Pv9832qmfa9Mjv+8vjZDvmF2bPYrkLH3i20+/x5SWeHQNFkAx3VFXpNhg7A+eE6jJWG32d2FC+mJx1ZMVodncdi/7FV5WtuL9bYffVKNLqM0z07RkZG1ipdxzhtoRWHueOhTjwRB7f53yJ23AOAxTI6K0mIWKG0A4AOOzW6x8dbn79xbi+zQ7xYinmyYrRpbvHYDDrkxOnGfwwil7i461NcmOrzXTgmUrmjiKy7q0ZGvjxbx+hY6NnZPrC7ISyWD91BMcbLiNbsJtycF6fcHl22TwPN3d1At3fIlVp7WRqLPpYDdtTt9GwYnfixNHZu/Lz3l68ulh2IosDy+/8mdjKz6+kBwgacnVWHjzroHKFrwJPZvuMdCzehdsroDocJS5udd5slGa/P8oDa1dhehd1YZMqRjdJCy06QErtss7Pe/ojWfKLv010oKKLRSWyDUmrZqh4c7CFFHGe8swFPGhro/PujOAiL96BQfmJ2nCzZseKR3VJq5+Z6AhI7B3R7DcHOoETFGzEcWUiPtRDr2PgR2Uil9fFugMP1OWVlIEfsrsHd7VbQAZUi4qBeeQjUfq4oeIaC0VnLPMGT9PAAr5dC1w2tg/CVPlLzxgKPZZUdb3nfFDoVuCHAOQsLf7h4QLJzNPv8cHcsUK2ve0vTHabdUwWqMFjueKIYI3R2pH0fJFVbUCfqNO+HXAU6iFS7gDAPb4H3iSyzQzlaaGwKHfs61jhvdZHTWViUYnfRsTzq9393zFS6BiKns/v6KNTuprl9B81ipYK1NFoS2C3Lx8Mtp7vFkN8vAt0vkl1NyODE4P8b7bqayrnxMBFSwkRS44qKwK4oyW7HUgVMtsq0194M599D7c5C7cQMBTU852yi470nKadX2fVO+PRwnFK7Cal215ldwGC3d39W9c7jKNp4Shwy00GDNY7B4eGHBWmydIvbaBKdYq/akXdVS/tZ7WiymNHZV7zELCIt0FFy0n16eLi7a1Kg4zBr8I3S3gKc9J5NdtWkPhtv2IE4k6suBDgImaug90ONUDxEigqRoTC6tOQQKXYn2e3Pa5JZMWfEthUP8PahBS2nJJEXD5+Pn5PslDtICwLeLNypoqDYnMEip2GdKwQ5lV1IslsFu9+OcZuzoTfzlRXMLk+eQ2G2nOxGCwj1U1Ij4Odbl8+xu1Pua/JgKeGeW7LBzr7oLVJCR+DIy0GkvUKkzRYSu08dg5zdWaHjq1KO3difbBafYHS2jVZKaOHlbrCT0s1q95XX4ASWjMsIhOii0Lu2kp0+sAJ0rHFARcCYH/+psYbU7kd/BWcoR3cnM2KCtY6doFv13X5MPYlAwUg2qnhItPoWn+fkrpbZOZ1evpm/2hAIXcb/vpP7/6IrdLmqzbiatNbUsx+cxE5cgPflCOTrw4dRPOCjQXo48SGlFyYrZGm/3JmtKJ19jyeGoqP1pyW8jzjK4iUKhStEFpa6xNn4fxc2/g90VMOGYKqMiTWOHwVMyvDQCIhG4O7aF+jeRbPwpz7A4cP4QEXbQJ92nh05Sk34kZuDOB+RA+wm4IkJy0/fPPDGy68dDI/+LNWu0FlUSJpnFPEmmoDHvNB8q9nJ8byQcHJMjvMS8Zn/DHbOixcDSIzzO74U6CyEO1MLg6MrRzBZhy0lJBu1WlK7QBRrwe9F6N5uUY/9fD1Er8VZTTlsjWm7SFTu3Gp2iA2hHQIdI2JyKYtldtJsHZP5dFeqhk47+57ZfYaJT7z/QM3kZGLfPB0dJsWe4oWI3adl711+qR9nR+dJiw0VFkp4YBcQ7N7lxwe2bSk7ig0BsXxbLUDxf/LB/JO04OrCgMjuShYs0YGdJCca7tei5jy4JxCYBMR5QLQDMCG2LVy8AXLiRsxzhK6mkK3BWQB2XAjIYsh4cKvYcZlfLXacBYpIlNBQqNgsPTgDO6I3fP6K+YVXXrZEN96XZOcHO3O/FV8fUwOA+wDwP/C1y0hxub+fL7Eldj+GOHMqcnqZHRweV0P/4z6fjXPDq6ih9wR0jIvh0ROmxuScHmLgwJmyF2b7xq3RARuz8/kBQBcHUQwAYLuFBe8LCL1bNdGZFktSxFNa0vEJxbt/C9hR/ltdCBHoPDUmKXZ0DI9NFuT4Ps5JHKH9XdVJ3PUpIiqEuuuqAZ/F4iK7uxLfaIBxpScIHdzHBHWT5e+K9ZPBvkrofpHkOIw5iR0v63G6fFdu2UHhUDggASYoNWREbK74pKQo8ivifzIAbJBAH+DYSU6JRT7XUNpAH4ep5Y6Eb+fhs1+OHN2NEYERyCnfqGOHtUgNfOa5p55SyR1pv1fOFDuiMdyXInuePzqLmBu9shCxY6MNSXibzpBtxoYiqvLla/A4THsVxFIQzeehABkrs0Pb81e1huCUOCl0lLEUvswtusOG0FLXtm23PPccEJKUHCl56rlbnkjSje0/J9B9hWTAFLDb4UqtanHH7YFNap4dD1fIQugC4iwAQY7hqeU/xBkCOFMou/tzZ2YpFbWYORH1LU3LWlLTZq6B8JZbbn3uObj9Oz38L3YRLU+R2a159cQudRSCC1kWv8sH/qXufF/bKqM4nir4JgULWn/W3yIMpYIIIugL/QMqq3cgCNFpB8LNRkISw5IoCYWBFftikOILh4iGvSjMMiy4ItbavtjKQFAmijCLVNEpIqhTEcXveZ5zc+7pk3t7e6vjemySRkWTz855zo/nPOcZ/rfZsWfwJfhlQ2yFImEhB7Eqxz3RYrL1fCy6Db0FVMcY8k4CdmMRA18eIno1pDME75cW/4EG+EjvpEoeFB5v/nf7Prmo5IfhmKUOTbSibwKR/UOH0g3F7id1Q68jJ7qos2t2ZxpUUY2VmJbrsb0mKXvjiQ9MeCJlHRLWOy5Hmdw2fYQcZaplVjkPEug7OVgMy9eRiCxyAOc4yFIJtTt1Y4B7V2pI7exNKWcbPBUpVqI2uoax5JWQlAEe5WIq9jTsyoV+yxLlFunzWgeb5cYK50k5jh1sxxfPKs8EGMbqCEd3f0Rr3T6NDi2f5hLBQjnWbGPPhY0+BLUjdpuonvTZ4VnpHWRvv4Mm3Y2XWz2D4WYUTvw6M0QeVmqJU1WhnDhWLSUT3SXQOmHH9822W7Ho4lrorhmD2kE6F4JPKebhG71jo+Wj6WnjFMEGbjBTi00KIfwrfEBpikMT5sVGIKbqCnmN07hLy94wO0DrNqjPU9ss3zJTKE/6qUyW5Or7CV3rQuDTBJ3VO+lH5+Q23b3cxp8ah+qRvkmEKwDNA+TIv0om4WqcK+igbVBCtk4BMKJh4ufEdc35jTC8lWCEO0Ij8TuujMagu50K/RcuWGyS60AUu4lJaXtLs+DBSGeMujG0AIs2TJ+UjtUsqGtaryrW6ZLDhkqjsVKlye02C5sNbl1ASgHZQE8U8okuurdR9cQz9R7zTSlQPJ9DovjozpUrSes2gQ6igiiPY2OpQdKGdHpnMSlhSGiJcxZYTPEQ38o6CXBTkeT4hMHcWUQocQW7hQPUNtaX8z26CM9+H8+YmCMlHaG4chuV+WGvfavhxYW/SknNOCRPm7YUxfrmshPjpDSspAskEKADuRitq5FtzJ2uVr+JqKD0DLuPZ/HKQm8rfXZtygLdsSLbnSAeIrUjrePvoNn5YCfwOLtNWU2x5ilBnAi7WDJYxHT6U7Sgc7ECC4fWobt3CcvdQHazjI4Ld1KBqgT3HBcnPQVPAbwmTu02ycPyt1IFC0+zoxCvmH69Cy9s4lWFH5lNLbzYcr4aT67E5/cax9Fl/NJqBDoIWj/FZG0FSm7oaaMCMhheKTq6u3JT1jpel8VZ4Hd1SXORW2mw3qXWO7FaZcF4hjvw2YiTgQO5/lmqYoMuqhhEjlqyIXRrL7duM7ufK/UC2LG3MN+7liy6E7XzL0guwSIuY29HTyb1CqnXu0kVy4lPD/ZbW/AREugxuFihEYxy6yKWOyrTUdFTrudFRzbQLVApWavdAt0RLaMvPNOINkDz3opWkz2n3rogIaqbP+5t6dYvv5A6vjOURN/4jQQqDJaEwSUwV7k2sYIr3LhYtw/SPYTqMThiH3att9bdh6AFoUkPRU9qgV/EMSkKjYv9TiGbUDvwph4ajfQUY2SwyrPpd6VWUY02gBqm3Wu02MRGRcTlmkgObjWJznnqCrfP0Ezxp1v0nG9yvzGqKDqrQPXuVeNm2VuYhNQ12z3D0ew8UQKJVkU5On5bGW3NshtKxc4CklfxTQIxLjHXgytV2ygtd24ya9E9RUkGUgvN7qm8uqu3TewgbVWTij15PToeShz7KiA7KlBlNB+J0YJd2gIes9LsxFYnOSJJRE4G9cpy59Q9WdWauLSS2M1rdvN1xW4m0BiteaVRsItRvEh2/CeB5js5Y51+lzbQZrXGSXKGB4NL5CMUOkR39brU7lRjLKEjWVfo0ARVqZyeC9E3iudxsb8kJeMYEaPFkyAMJ+e+N9P/U+7QU7qRglKj8yC6hk7LHJgkI7fXK0Tcy6PRoWBHvdonuOOuqdCBnQmNZS1ndjpIju3vH5HvwEogFkSvTC+oRLVN3ThVG6MK7OwPc2u3qbaUVOfaYq7Cbsm4Co0ORkpuQvraVcH9r0rlbJjdBAe2Gl68lozInp1TSmOmeBWXkbqxIiAniYPl1oJjTUyuNHCASplM9pst6DaAbgPO1r4jrdPsOK2QtZy/L9etpWQcI3varKtMXZCJ6gm89Du04ioC94r2m5ZPm7BJye3VIxn0jZW/bnETjE762rWr+EpC4yC3kCAjgLfdNKyhkTEmhx9lTyoN8GcmdCEgvd5ZQZWmRnXOxDoXPQdk7nUkFX/qtY7RsTgF929XnPu1xRpM8TrZFLbhMSdHVzVQehHNuz5lByPM0zDD66Qv1fOkEjO1p1zMb9nlQTBnTwhIX7uzWWGqxspofdWxQfBGcjuBJxSl6MEOw+e6Z8pWqJZPf+E/02rVakIuKbqOKJ3DrlAnT6GjE1SJWetck6XZHsJOQjzxZtyCxblnEoehYxNPp03URbubfhRDwGGSLqJzr3Cr/wlU/V0KTD/ZMMGJsVq8N8D0Rg9X3PWCxwjMo5NwMsw146FymhTwlPfFwKbdNJGlxCZZv4gb3aFkTCMAqG8MxRRsSaye6L4NaHgC0PUmticwFWWt2VxbXqRRKWtgd6YxoUWsjXdrEp71Hx4XjZNflO0adojtLi07eBNPe1eXnS4Zo9jEXbOzs1LC48ody8IKh3c6SplU213tpEeuhxGrcOggUYre5GvvqtU9JbmaJDVKVDJbr/6temJXZwf1tauNHmGnclpV7XHcbFys4klZgzHyK4QcLVpRLim7RCPxGqfNDpmgW9DopOgp0ssjNAY7Lb5utdrJdOehPcrR6tMzENjOLg4J/PvrnNypjbuNpZ14QXfJYqoC8+KnntnokYq7WvBUZ+6Ovu0DxlCZlVuELyIbu2TsUGiKX+ekdhde7hY+hdZp6TE4vUmWh7FvEZOWyabnOBtZYngQXt+Yo6S43tjQpWOHPe5iInTF8jeIjNeNhsE+Sz2NjrYsHPmU2BWN3unoWO3b7JDdsIUHYYQqxNvVxIWdmquT9EdHxojuDplTd2/vW11FF4UNVrDtQxjf3jjfWzvQw180za3XoxBl+btKZUUvd7xdFl7rdzzZZMREenrLnp3v7s7i7YgchSXJpDh3vGrKnkHbjn2xb6XwrhLa+R+hdyad1VIMfWe87jyUHR3Z05bYWDakx4HuUrCjGcdELjG7z2iHzBU3lxV2b5xT7JSzkI76NKv7EOBJawX/jO92UkXigI7IJZdGYSWO3SHOZbWcfFPSWe0sQuKN5NLBM8CkTEnoLgG7KUlcE7N7nZa7JOcCRO2aJ99BI080O/aU6Q5DDD0w3qZqUb/3XLYpU0v6UDjeyy7V6/kYk9Vqx8vdySXNTm1x9/dT0qrL8MieMb9dbpsCyvi/MR86SUAn5JJKmUw27mTAxgB2p6LYFf1Q19/4LvRl6BbyduWWr+w1tWzvImSnP7k00LIYt9x15112zWmwkx1G7WgD8Sg0Ti+Xjd5yxx03PzAyPPSfs4POzSR2ETqZrcSyW18cZLLTS1IKUOL5kguM5XYnQ4ztv2bXSeoi3GRW7cy6M7MGs1vhXTI3s5Cy+Z5cZiSGHOf8KQTd7ZVoNyubPNpkp5/OSynAdRb880AuMxK5cVhrTZZToePaXT2/s8B4cfrky/UodqHutpFcZiTKWumzlidSSpkbUWQCDx9OsU8nBkYo0ye/q1byA29RKvt9k/WvyWVGBhprR3aRUglt8+BEyiwdzbYbFF2rcMwPBytAjx7GeBcX8X7TsFtpRLALUgJ/NJcZGbjPT3X+3bCbOwN2X6zS2GLILMbvrM7akbIYKouxAfPo88RPD6N68VimgdoHpqdPYsoCpWSuFA078/CHc5kRl13Nt8HAbtgdB7uLkTMpUPZk6eE3++Y82J1jdq7IAWgvu+zooCKj89Kwk17Z/LfPRMnqgJ2Kl8HuyYo0G0eV3REaZ0Y0uU5wCM+ud2ldRTEPdp/ETy/S6HqbVu9eFb1zy+4kY5lkN0U6J9OcIDOpXUW9XlmKHGFkN2aNtQq7aaN3+eONwkB2/Kkyyq4GcgzOY3p8TiJVRlb5LVLvZLkT+ZTY/Qx2c4PHigalzyylFTmJ52QfLjh6lYod98pWLm506bQnBM/G2+Lhbmpjl6J3YHl5k9mdHsyuHBQsUTXOjgg56StV7Wlps9lvZRKPDero6HHXyFoT52WbiyasM+kYAmNi91tlRbpRlBQ9P3tpRU7iuQCZ7CelZUdntVfm14GMxfKjH8iJdZNHmAcLs8M0o7MR7Nqkc5ljV+v4+iwet76kYidHUr5qdg8lqBlLDQWyVHn/w0h2/AkzlJLlAM6CYnZqqENKdO/Vq/WLi5HsNlx2m4bdirCL3O7JUEpm2MnMP9WrlprdGYqM341kN+BKxmkj31TeL2zDbjxL7IzN6mZwWfaK6di9WsU0Y2WzShx288tQO0i+8lkxgt2Mbz/V+GW57IgK7UTt7F/ldOyWcL1MFDt4jEH1J5JTeez0FKPY2bxiPEPpbM5ODSu13FGAaRPaInVAXYxm1x2w3Bk3+3Rddnqc4JirKGO5DIk5Mkb0jPLp41FpgmM+rP0tsUvsZk8BnSnfvc5657Iz1c+MscMxng5vJrbE5e4moS2Sm51vpmRXjtK7LLKzEwGlXmwAsmCzJ42bRX87MoZ9MRd8aFmcDmz2jLJZt4/Mz1I6a87PykhYdhssHp3S3Sm+gjkbAD79mZ6cUIQO92iZX5sO9O5sNDt8nKyxCzKwVn8eQK0T7pBszwDfzlpR4Cp+Pt9bRnF9H+1X4Jl+uhZhF3uzwUZFc23NTISybhYl91h2GdQ76THqlIJCHkI+CVh8T+glbPisYIr2gsxC4foJlVTw+9qCqZ4ckKsZN/vsPtzGZlu35DIk/fIJm67gw3v+u/5km8cTJN1fPHf+wIHE1bveKcvuXJzesZ/NUgkqp0aw6KlstZZ4DthuQnyNs+iAAp/E7GiLjPWu+l4UuyKHnBnqCsjlZDClTDyVKrzFZ5dpOA7QS1I0ri6dT8iuF2Z3Lo6dzRQzVfrkeVDhqTxtT+Ah6OOlzyx8SVSP3Ky5GzpqgzGAxgyF3Tvx7IzNZql8Z9c7aWPmX8MDnks1X4Yrc8wSX7yju6HhKyLE3atIxg6fIGPsPBkAJBN57QDUUmjvsWXIku6x5cayu0jznmYRl5jzFLiUhx0tOdxV1jb8K73ecg/HQDeTsLOfsp0pdmNb5tj3rymSifYlu/R1fMbXjotZ5uBm7a2V+2xYzNV2gLSBXreJ6Z7cQ2ae54VdfSKSHZ/ZzFLZGM3zREtf7sTSxyeOl49OTkY73Tk6rc3spOwUZBdmovHgtIK2yaqFGHamjJKl0idkmOhB1CQ8Rskj2kNdeZ2WpdcefDqqOIcQJT/fZHbJeu+Y3dfbs8tU2ZiP1vtybkabr7v4cbXKj4hZ5k7zjZ87YLfJNhvPjjpkxrJU+rRyw5eAx25W/K3Qo79D/Ka2NOh5Dr3i9uyiysbE7sPY9S57Ngu55/Hvg1tj9SAyWQiV8U5x04+BV9DsXqfNirTs3vv/sbvp8OEvv5/0ZVhh8Jc6JK6M15ZbfDsNTaRMZ/D+imdHFRTFjvPZN2PZQbwMsrvs7scfP3z4d6KnZsaxiAP2+vymzE0W/UJB6Aze+1V702yzm0zv0FCRIL6bsJ8rWzEKyVWPG2F6MqlQ+w+26MB8wQ/0rNMVeo0PV7ZlZ3tQQg3uzO5JrqNE91S0Hsicr7gJ4Cy9x7+k8e7MaKsOSkdooH+ke35Ar2ArAXmExswufouRbXf+xutuu+/2UzE1qELR4zmGD2Wo+Y7lVgOOde934LOYGCDzY98RAsl5b4n3xo3PbRzfnl1Te4oHaRj2ldddd9sjFdqvcM2VTh5aP5WpqnGw3InQwvclvK7VOpGQ69W3zfo1RCwkPuI9nJsVdiesHGJRbQFNBocZUDfmWB4edBKvUJYrMkqZqt7JchemB6/r+ax8YcdrRfU4svWa96CHnoB6NX/02MGjR4++9vzzP0DWu3RMOyS2ewzPIPjjwSNHhJ2jdwiA2q2aZDWZ8xS5Gw4rdHbdg9twkg31Er4p1Q/0sV2kc7MHjx2E4InkNSJoIFrp0sBPyLvvvnv0xyNHnjgyUO8KRiZm2nJJBhKazEUouSuEndAjfJ4vKa4CZ0g51zBCWjN5pBUHlRwL5KB5hP7BERLF7rMJ28uDHtmZGboiSLh1/Gw1oxgZuutZBubi8/y+21X+Q5uvOGWf2SWRI1aO3ZZjubZK/Xc87XqKhLlx/cbLVBOUdRV3CjvHdn//niIQ1jErwW9itHKFT+uDakJ2UDqW6/p/iHXqmWWTnaEQEncet1o+bTOVzf8ma3p32b2ELpKezTd8T5X1nJCZbdiy++hYUnLm5epcIHnT5y5uAvvqZUydNXfak+vKVMMsyeV3O+yefVbjCzyHDJQPu47wu9bnlWoF7BKZq+gdy6N0NkX7WUiopyJLB1OMl3V07bnnXhCAEvN5ckGfNdD+OwlbErE7xjrHP7cJOzpPFrm3jcUja+zucdjtf2X/cy8efhbwtPJZ02VonlwoKDgtuy/i2RG4J0Ttjml2cxHskFlc8LMWG9+01WBf2P/Y/v37H3sM/JTyWdMVxyCVURku3fmHu+t3kaSIwnMqoouKp6goqAf+RAX1DzAxMNGygjIw8IlFJa8aE38kLde9KgiNVw3dHJj5R2goBmYiyEQGBoIYHiaGZme9nnfT1VM7vdPTp07Nt79mdmZ7mW+/9973XlVv/+zPSvnl63NF960nb3Ur1N3rH/F52/FW0q8uv/nXMw8emOy4me1hSi07aJ3JsuDgDUOXXV/vVTgFMncf/UjEsJcLPR6TxdwxmDs2eHQVgZi4T97/+Y2TV19ZHBq4mQ1kJxlEIQkQi5y+30F5/M0NWzBoWZeMz37zurM/XLtCPL39+Yf+E791n9bwj1y5du3a1avXr5f3L3qDx11ZsCHtk0/e/fnkteeee2hxeLj1STUEaqmZOuYwywpTYElALIuePi4X/ah+xd2y/OMPxOvXr14jfvynK+9d+fqK/0T3Osau/t1e13+s8NStPXevvv7KS5+Egnv3+zdOXjs8wTHu35RdLb3WBvDUGakZWUZVOPf0fcrJL7xIyWe/+v+L4kpPOFGT58wP+jf/3iNvy4z/Mp67EA94Y9I5unc/+P6nk9dff+7QclxYZvMhd+vXNKAOg+/qTBbKKMX0DWzyZ98Rd8jPJRHTV+3fCeuDas+d5qPJ+4cd4hNPPPHww0889vi9D7zyyiEG6mCZRw2g5RA+YL0Ylxn2DxAXVIM79XUrFmxb/LoZXQcvk1kHNEpnpFQdQBJ0YfKYOxbeXYtbLhyw2LZblHyDO61RqTZbNrjBKJaK2Mt//71fnvQDPPp/PMgBXhol9QDMI3NH6LhLFc9HBmVIXW6UQSugkSF7XRBSATZcOVbiu/yl38jzRRs1xYyi6MqNj3pPq9brfJcq4iobQGNXPgQI/x5IjytxprH0/HmsfN9bl//85uOP3mnVFpgViEyjyu4QR8RdGLIkD3q9RQOCAFWNm/ZFe/5k6Qn0CvTqu/yn0afuTO7MwGMXuclLPCrdDUJWy8J40aGuxAoALkMZgfjTEkmCv/+t2rYNfHQvNI+CYhZXjHe58Ki4U6jDIkHUZbIGIXr2PEsyAkvQw99CTyOhUMpzxRlO8+Pag/No54b00XCX0wtjC9cNUjCTWIHoASBcLUegb2BlCzVDboCEh55KPBbuSAraE7cyv0aV9Jo524X0VY1GL6YxkLIUhyVugB7N6tyovFBF9vLBLULspzusNQFX1BVEnXYgNgCWtIdB8OqzuFOeu+45Gw6vrpvGOYGtMa3Co+EuLzxoaueJK5GYQ2dFDArdyjW1lluA/l2ZPKs9S5UAAVyqA9g6L0rPevbIIlWc4cBUR1y2KoMCRAymgQj0DNaU1ULFEWWVNKa0QBCE+DB22ZSUIZ5OowEb567jjCA9GayfBuIXHlPoUd0Af3dZGqOt2A7ro5a4kzpZ4akApDhdZ6GGxM6ADut7LjcmSJVxypSm9QbII3s5VeENVEcBm5dMHstuJ8T1RPpDwTbJ2ab0JvrG78lSnQaEDqXG3PivOWaSwaRMR1VQutvCXF20ps2dQzbhlxIVXsAdrgytMqbkfFfDfqoTtmkVpbv4ObB0ObmTwloeKBTm+URtiurBPSxZu1XcottXdjZrVVvbM2qr9abYAysr1vOG51PXnSmIrhvGuEBiT+wLS2MEB3GeQx+uXtfVEqBB8o/+ierRRZqIZig6I/aoZkgHcWzuGMREP2yUVmg8cR6Fs+Dv06ISqVxdSjRkmbuuQuh+hJIbos/H1a7Y4Ml10+aQOCuyvGMub/xtgpYyN/R7n000ZHvdlRtTT+OBFvYLWRyELFjBB1TIzHnQkKubN2SpkheOnwLQShhVQzEqPdgSyECCEsBEWkcs0dFqf0cwQFNBl1nCBm9dKTIth+zVTW5a5ayYDHB9ugNwpTGr2b0No5j4ZRueaksbmrsBd+h8s27aFpcw3aEY1UrbeZIqbz2RrfKl1YoAS183JHtwnegspedO0uxE9wO5Ciz4DoBImAgrTefuwDpZGOohsK4ABk9xhiatDP3iIkX0xrigoZ1cj5MccK4yJZClmObuTFFZ60qvW3/URtiNomMr1a6pQ11dvGeRIAJjTNVB5QUSfVjD2l3IshJTAJU/YLNsck9ciQ144uKWrWU7iZg58LhzkR7Wxph9HeV1qn4VBCKpJrljW9MwS5lcV52xi2ArT2rGzK2CGU4SLBfh4iKzR0sVWagVmOzuTFHXPmgBzhYmrQJpCla3ToMpCm9j+9N6oUc6C/s3s0YvLYxwm62YC4elJ4vkEMwBJGtP0haT1uShtZsgQhAqbCpi2LJbJGqGqoQ7Fqlhne502JG15Gbbegl7xC1UxigxigZRbjbLp+kJb+3uGLr7QEXkqXqfuIXGmBxGg7pBGQvzYnLjlDN3e2orvKf1gVtU09mz2lBDNgpXQcx5ch6vT3cE9lwNgK2wG79rYceCts/1gzKLVowCYHiX7sNtqQmv36AdoFoNeZWhmiEnSs+Wps1sROnYCjkB4DQ14fXprkcGKxKgNMReKexUi9LwT5yvvqpZNdE6y5q7ExPeGekOHQQdO9WMZsoAGQqjKhDjiHejoXSn9y2SQp/u+jIrGL300O5OHeSjZbbfiEZ89SCjfDGtvXh9umMCeQzAANt05DXLnewxLJfW5aY4r1TYqsGeOE0DAZueP+ZmNg5ZBljX9Wju/BEo9f01bXw3aM/RXK2DPxYxx4/cnlRXqzxC1WmuFD2sKFpFlm2cPGurulCmmxI7GGPO1aEjQt3wQCC5cUp0Lg82EOlJGqPacfLAE0ed3HhpAWIOg/qgGycCDwRJRS2Xih66OquJUsHqzZaZHRFH669SbKdOBMyhrElxMOxq705IeJ27C8ljexHHrRkrAUA7dFpV1AK2WmkITqxCmTUCmLhUxymU7nRQ8WoLWypj3o5ZFagQu3HnSJ7TuFacqwL9QqLjFKUKGcJtVw2ath4hz44QR/ysozVzfajGuC0d4SlV6nCfvxjxbkWbWzEJ0DPL1CE2IuQ45XGKygfurh51FyU1+VPBji4oD2KUu9uSaS5MEdhUPb5bEWxm3HTyOF4py3F5GEU64xRT1jIQnhiHdaWDydQ5iSjZAu+AZLpaFYXsKGCfIXyNdeNg5x89vX2RBpQM3B1WIP4VwATO01m5GJ6pLQ4CqczxSj3SyhJA/OeARIRXcpmdcU4AYyLtR2BTUGs9WmX/DzbhviSEF1XZiYCby2BSc7yeuykhCzeb077XSGhbVHZ+lYXppIBwYgzHIbxAdw2ImwRbqaISU5DkHE9LfdONsXWmbWuYx10CA2Spb7Yxhm7+vsv2eEhceH2lGBUK7MqCtUvX7WPRdvS5QB9jR4bDby6iKjsLVjRZsVr1yeHom4tedhXMj1at6ISKDqa2x97Vruee82VHy0EmOB/XHrvwJKO2MMvc8hJtiJ0PkWrG68+8mx2vrRqgbY5deJIxK9vBqRXlBnXdjp7jFl6/1XMGcxfvednEV8FQM2P24FcuZoxQGKfi7ntuebRVEcxObRmMHfq+g24uqKGYZe5Ob7/Tv8ALLzwfc5fNDtq7D7q5YIciYG/qWBr3P6kY81xKQtui9u9lmbpbt1+AxTiYTd4hC69f5NlrZBlk8wuPxsKDaUc7a453wD5lnkOxL41dCsPkDqbUh9Q6s0kOBQa3otOY4qjFaUJObI7Xj5/mv7BbonJRNrMXO2473JULTnf7ObDTkwvnXHNq2iA/sd0pfO7dPoj3aN5yiQhTATiVzsHhnt64d0MWN+uc8fSg0spsvvAONePNCdk4nC5cyk1Rhj0tThsMJrXDYoZDiecccXdhci13O9bIQ4ea8eZsQ/EhG5N3SQ2BctrwPaElsz1mKOOnQjwSXaJw9irS6YFuEuB0NxmwbVP1rVHQYnakA2TeD7BX23R2KL1gNoJWz95xAPccJHkz5k8Xo0hik2c2glbqKb8hnfMGpKzFZIyfgHMHthsXssFmbrk4SJ/yD3dXs+I2DISJExZaaKHkZjD4kFvyKkMOPs9B+GL5DXxI9prDBuoX22cqLtvIyjjOaLy1xvuV0kILqyij+fnm0+hoxJ78UaG5eqla3/CCur/Lqcwm8AAPfdDa1qVneNN7mCrHMAg/1LgL+vl+Ku9f7rrglzM8/mcKULUmv+q28CfFV5y6lvwX3VzU8SKUosPYIXp5a/uGZ8IMbykEsmEo68I7WN825NCGO1b0/kR9E484RYWgQH+py/6hrQMFfsuoat9QGCnG417yvfGkKWZSE1ip4YEAnPsPSeYbnhnnWHGJHg+F6VYS9vh+FXhfbREtM4RAIDfbco0f97LIBb9SqEVgQFReJvuChItnbBQuyvCQ8TFQ1rvKGp97d4bH2LYl5MfAgNAAtrs7RmCqy9M2eAYYkNJpmUdF1X/3zgAPuICqlnFaxGnqKh8wvOvXMTxgQNw/SOn7+/zOj34xI89j05MjNLwOvJ+3gMoMBHB5VlC4aIwTSgqxUZWnQDgwIFU47ElVy7+oq11Fyzo28nZpkjVefhxkeNpbZsCEdDTidu9VtUESXe2NbuBBPt3v0NzTKUdev1Z/5wLYcGExqGWV5NTw2P1a3ZoyYEJekad9RuBqWDMxcBGG91/PDL13cTa3sV3LNzzgQn4zc70jCTL7PWrVmjJgjW2j3J00XDT1U8PD52dZx/1GboxwCM8RtkUPt7msgCDGDxWn9lE/dDw3FXs894zcuMej/4b6wgXwIW8aJDtSmfEzZL2asnlWffBIUP49e915CgRAHuOSfEcNr/q9cMODMOAPWZ9vnXtcVOCpVTr2HcLwKn1RxzF57im5qpbfq9XwUnLg4uW0bUYNr1ODLtnwIAxy5jG9pwS631emqemcajnSzP5kF535xUVwhoyorXPhljK+adNfdl7ve6G2JhML2UA1r0wDF9MJ74xUZjyhgNqWGbCBYndHxT1lw5i/T8ceK3tlOvC4TMpIU1LWyjhkJxKIGy6Aj+my1ey+rHWiPNFkm01cQR7wMZ10TIuhWBtyRVTVK3ojXzavApf3fdilmdaqNowznhrZ0pIYnuEQKqiSTglZ7vRRJatDv6wV5Cmoqe1D8nVBZixl8nqPjuATi1cp3x6xMllmzJeVlSdXXQBy1qFsxhtQCPRPQjKq8gfxL83wRtwJU0UjP7Vl4T1RNQ6F9wa4cQI/bZnb/tzyq/CdJXRFW7xoAT5E2Z3c4zVHE2R4ugZIP14Tn/eUt7rL8hiYIaOiQ8um7jZj2Z28rHWNn5o/jF/Jk1JwjxkUNMmACNkYwanFuPPxZnZ3VP5+MpPr2liGBwTSzFhORj3n33VGC/Aw19ebZDtSXYj599cwVjECB4XjoUKeqLhoUV0tggSR+GMS12bqDhx8PuUDwl73jzgeDzzMVziucsKnmGcvLmm76xNtfekQJVCN3JfSpxF4vi4eiSIQgzZ+fjwuytOYpoDDzHzFeu8ZHqeuVXbJDHjADSMzFp/ahvFOv0ImCpl3ab4zToU4XJTnmnNqtekrgACHD8V/+GIPDc2Pw+feYrRDCw6z1z2rvH9Xqvv1rDTTddUHPhAlkG13jn03rNdcVd0xAw42bpbx5yLrezy3e8FDIOP0fOLmAKv0xgkcHarro56xLkFZ7DCWlU5UJhM0CnL3GXqMc2hmVnsiBXXvQypPj8FDhPkGKVEzjta1mib2AEZO2xNneL7LC+76zB5pwSHSPZB0qLjw3m24eT9l6goWifIq8MOCDPlG43Wo3SKOv0f55Gh3BoBg9ifC1juPQKYabns2/aRFjQhUgxs++KGWtBwRm+Ji9UVa8BBJmZo1d5SA8af3oD23jM2bO9LCCFCYGcs13Mf6OEiDoj3RzaNrfZm32QgdojPah9KF2h76W9M27wi6ej7gEHGQ+jr35/ZQ/t1WbWWVeTwYA84mxF/lPSWoGWKjbNOeLaqi3rUkndtdL1w44+u5PCjak7WaDi0MASMs6ODd6TZ0iIp9K8vSvMM/xH/2Mi4RQBMVJ0+5Ly/AmrZ85vRmHcqoh1VMcj/W0iui9tyWndPT0i+DDjrkbR8u76bfJqcW8VQW7Rm1qCsUtT5XuVMJ9AiVq735Xwvd5l1tfAfj9k6JFjp1E1X76N2Xen9ri7K8WB2R1m2Rgpwpo3yK8afS2uvQ5mGcW6HxiQCfjXJ8ihmU99iq27yrRQVMlJ5Q0SHNP64l+7H2gtAPtsXfaBv/0ALMJjPmJyrlyVld9xeP+uyCbdFtXvRz8pwU+8Pe2etIDQNx/IATAgRIcKJBQqIAdAXSHQ8SuUg9heUmzhu4SGhT7ErJi+0zsc7OnuM48eaQ1vZI/hdcefBj4hnPl2+C6g7vtdwyvBotDy9nJ3jRuysujS9+CN2c9dvca/kE3vSr7QTCi2x4hU8QfC7ajIhyvnrkHZqhPMLrZMx7ELJLa8vct1n+3d1lAUU76O+6gLjvNqZyqXCvF6Yzis8DFZBcw1MwtTwI7mmjVhf9XXmVHSJ3FrxqhDe7nkHYO63rIQB/xOuB/motn7HXDMIkzCvFsJcRd2wlkDJ29GJ+5HFnETfCK4deLrAL5OCKBGc+jhGycDIqHKsXVkKqFGIno90t/HWeWG/jvP8tTpWf2v5qpwJQIzzX24Ya5b6Qbo81Tv7lh5NRcaYHZD3oGJnLWFm8+W+NVzpxrxfKivLcrbSSC215vYyUTDGcknEV2NI4sjuvZ0Rx2/IOXSnwyItR5E6rK2v2sFlj9UZxvNdOJE/wOhklYZvcsMw0ylMNfrVOE7eVFxADO8S4D6WSMl6O8lSDgcry0A9WvMdEcoS/ejIp45UjT2Eqz6hbhLeT4T1tGhWyZemhn+Y0PGD6LHTNcQ5Ph4IAwd1cqq5iangM2c0jZNMUKvByFja8SqCZwu9r1azLgjszogCt9rYdhPzLu+wgkehu+vSvcjoFnHmLg26RamzDCzBflvBxdy79KKEWOgWcUGVgMnB4PEKK39rhu5sprDka1eDAK8pBdBKCjqqkNCezGuWZCHn1rRoomqE5QMAIC+0uhcZnr7MVJgHPubtTAE7uVnQQ7l7mt7sEXk/D8kVzTsBz33SynP/nX/sfkG50N6mbqcbkBNb3DIIMnD1Opd/e3x2llFDIzhhe9GmLKa2EEgEzXytKZYI853oBkdJAiZXIPL7WGB7ftoIGbj9eF15qJbIVeEd/MV7NuF29iFuZXzP729epHHenPSqlUtjeY5ZJx24zXx3yeHOTlL6VahzU45a7iOstVr1sCheyWZTXGHDO1SyGt0gy3b7iL7TdeXICwS0gfsfzM0Jkww6fii8g5vqFxC8V1n5QZ2qF7SDmTGiK1cX1x81a/80MBYGcBZHjbtTvebW24sWiIEzVIonB+6365jQ0dhBxV0/6lwqrL++HaLjNLuLctP4FCfWOXY5URFuvh8cQNBmUcLp9ZRm3Z60qhDUCSsfd6XohSs4Nu5gBHpHIGD9ZXa/V/oJ72IWr0iazLHiLHoXA9ZacG3bRMilpp9ttvdm16gSvPNJDdhEH9hNPGVt+4lPHWCtwSLTV9Ko+5qUs1WaKBb3721Wsrkqkp5x5ldBmEH9Ue6tefIIjO1YzcYbHa9ZDxOxnso0ojl6e2DFeKRyxVW1ydhe/727Z7j5Ax7Rq3pQnlyFELdOyu1Qj49d/j+yQXnt+g7WX8TaU0Mh7jnp7WzAU57xqhIY37JaKFhCEXUpDZJf0GSY1Rk1PsytltIV4lBIBL17b02U1rypeddFefaNz3Gl4D3+YrV7KeBtA6SQCRj1aLe/edy4gvN1BojljtLz7S8UeiMnuU6JuFnVfo6sw7Hy6puOjEhlPzrzasruIrVCUXIUDj7M9RNynntrw4jZ4NeY+E2OXtKtA/W6rreddYUUNV2b3Lskkyryv50fDOLIzT0VEsjtIs99zfV4FF+SlZHdw+5EGOw0P7S7autK5rd++IcBu3FQmWp6Y3SWbRFl4ZgXnkKMlP9N4bf6/VzPuIeJ6ZmqR8cnNKtwhnRa7JJsW19i1bp3Mf8XMdnd+hVA0K3UyCMOORkuAG6IYdrFGLFx2BG5k5olz1Y7sLH4QbsSCSI3MZqdK1MguWtdsUQCBDqh5v3sq7CglPu2X9YUy5x1EKJQRDFFuvp/ZVRijRCqUUUt8Tp6GF209Ywdhe1gnv4VI4vPm5R8ljirbekvuMwA7FIHE582rn6xq27bibu9iWLsj0Whs646fpHOffRJ2B1SOu5s7U2RcYgdxYpRbCsfdkR039dlUvlkaic9JTwqed34FYPfhE5Ho7ubhvCcFfUW0CQvTuHFL5JPVHSmoVGIUIOJlj61Q5iH9Kg0/S+VCdgyNNTlUGt9sUUDKTYtGL5Cd+WZjTUVRy6EcQxTGf/K02EHSvbIWO5TNzkAMlgmnFtwd16Rw9jOxb/aWiNlpu0vtvPtIIYWi9chTY0eihwevZHzr4kq4btWUVmx3tjvOUPuY22bTHtVeuc6ikF20CVpKSc9E2VFxsoYdN+xivT5MK7Zz7K4GP7irnnd0Sotn3W9nB91VvWDaE7MX2XEvOsmuOn0MtAIUw44jO5/hyeqq7HYdLU8xtTvOL9jdjh3JXo9dBQWQMjvnm/WoYvKaBxKku3XM42c3rYeW/bC/Ljtip93M7pj3tBv6q1ZhqJ12c3adh10z7DS7m2uJxvDd+jfbwXpwN5TdVe0OqKG7edzITu6H5roBGLUv9hnsqqG9buBPKIHisPNvwwc1MLhqIxSFOR6nXrGFHXSi3F+XHZUqhdGrbexkPagdJLsJMYpMX4C/IUU2oikyuxm7X8hu/LG6O7ATopUpL2uOovt6g93JvRDVgcyYVygZR8v5OrtKCH6gsvAlmL5eZgeFbE/sINvdc5sqoChLsT+ku605kl795BfZyV6Uopf5vHMcbX2ZXXVktxvZ5RhlzdHWq9FdWRaQfYWvus1XLmR6Ih7S38EZXHf1paQ79EMpGklmKV0Quew6WDvuWpntbs3Rcg+79siuynbn6iU62gV2gD9UWYo6s1sJUvxJKD0S32df4S/3VDtYznuWZQfZ7lx95f5EyqEWpVC0xpWCCFPHfL3zEw7aVTQys1s88H5yz3ZoKJoxRKGzdDigXjz+4Z7uRei1q2CZ3aK+/qnR7pCdvdVqL84hCiT+pkRIuVEKB3DsrtLsdkBopV9IPRh2CxGK0uy6zM6fd+eMLfXd6fCuyOyW9armZ3adw44Nep8lAKEVpkHkHngdLCQCdIhCaf1rUD3Uq5cyKMuRHaX1r0F177KD6WVWVJLCu1fB5bc7ZMfyN7umr6vJAOhHdvvMbk13q2Ogko/seqA3Vh1IppOsBtfNHtVldh5nwZcvFtDoEKUc0dGblguih6eVC/O9Mmpc9S5JrfcPq8eV4Bh2pxAls1vXnZ8dk8TWq4WU6YbqlkKUOrPz3mgXg2O51+yGvaT1BFFQmWzAjB0b7W4HtJY2h9V97V4s3PCO3oxrCH3li+2LcgzvGiC2LDysXi2zAyUwvDuL0vKXMDKOtna6Fk14l5tm/ftm+QI7ltldmo1yg2PYTTJQAPrPPCTgcbRTdnJvZaAyO+/ySjs4lvXIrsvsvLpbyhzLymFX5OGUBUeL8GoJ89C4AFqvr4eWuZUdSYFVnFWQ2fmF7KxMCpyvFfmb3VZn3M3YDa3M7C6mjnHrZ/eEDsqjhlNoTG+HbjiZIeRJb8DIbi+pPVgXWnijxSjFNAUI0Ut673KE1cs/tZ1KwSuZUDvI7DY3kpm+xdHN2uWfzG5BDz/thh68komqKLLdXWKHB55ZVyHZmV2Ojf16xAOPsyd2lWbHgNyjusF193Tg1TC9ku0zu4t6afZEF2DYlX1mt6VWZnJ4pkqmOptdbkhZ0h2fFctAiafxgNzMs/F9wRqvYGosMAK9x+uD66VZb2SqZKI9EHz4P6zQ7lCdYVcdst09e8wC2bEZO3IrnMPIsNsbdnuZv9nn7WA0aZQ+s9ua/kR1cGbXgc3uXU66ewI8PPCQXWGzgw85GeBnx/ZwbjaGbHdb9MoEKbyAUzeKgiLb3aYAjz2pW2H3NzdrX0q7V7sTO5Ht7vnsehhT7qKRc3Y56f6PvTPGkRuGoSiC7Clyglxm4EI1C0KN5BuokGoXNuC9cSyLHmoyGJtuAgT43AUW2z5QMkmRnyfBMUv9s5bcfSGwu7tBOkwUg+ot6ojeF4Ljj5MCLJ63xsqub6gQdv/Vvsl/ZyqFx2Fp7EawswbHqoXHUyxe01k1TKd8qH5WcmJzY0eNGKZTbJMCouf22Ni5WdihW9uoucAtPK7sXssoWDtjWzEY1o1dEmI9OyQW16vexlxTMrCzVz95+2nG6e+UjNBFZtuiMoxv7FYCu7MgRYwbu/LCLoDdmd+9s6NnLjsVQjfPZ+vX5HF6HTumNUd0pJwGeELvnV0ccoT04lUFT9mNPbuSI15obQHemF67AsgVsLNIHYvfrdSvK99PMIHdhaiWsJupX1c+wO9sPXgDZy9+J3ssWiGUUPw8m4xSdktUdvl7IchpGZ4ZubJzjklz2fS9EmSNLtip37lOLHrxfga7ywCPB27s0lO0l6bsaz8Z9pVfB3jCjgf9ynr3eGB/r0Enhbff4vMY5njsYvCZIBlwyo6FXGPHw3gkZN++RLAzPJUpu2E9JCt8iBihvcduOSQrwO4Gu+DL9k84+rb9CHa2Z0Zlt1Ab4fYzYQzUEKQou82OcVCMgZo+tMpOBgaS84kwnmIcFOCn3420X3clwu9MVSiufudK4zjFcW/Fg99ZFWd5cIErxbDG4v1eRdl+v1DAMwQpO7tqS8wbu/0zi+Lnmf2uh7YxS0E4Ts77NBF0yS/s17OExwc6DrvGDDTdr+ynvtGyZmcuTWBnzyzUOFfNBWWHAt4H+yF+15tznpteBQrHtqyM5dBy2IcFwM7ETnILve68Q7e2fbqHe3bOOQI7e1b22rSdJz2z0A80bLbsPhWl3ndY4HsnKzs+FS7wTGB3p4FRI+N9zSWWbt8Njjk5l8daAgU7WwOjGjvn92IUQT/QFhwzd4UA18bgHwR2Zr/T665pV8DvLM89akv2PnOTskTx0/rcI/lFHe9hEZwBO6PfaULWMIYF7OzTjPVvdi7r0jx04JmeyrT+VHQtCIpQN5rdi9+PrBjkFmwN23w0bCfulI5wZg3sNKmQ604PLQp4FnY8tIRMDy2BnbGQMnbXnYR4KBwbCymjJBU63Igza+1flCOr7xf7zAAkUgzFAA7idmrLg8DuTztnzyI1EAbgDRYWW6Qw4GCqCSg2QQ35AwraWFhOYTNBWJZtV1gsbBIE4UXwF1y9hY3BZuyuFhEEf4ClxTZa2DqZvLnszN1OoqsWk3nguM/q4f2cSc7CpUdFP921YdeH3mvvzuqua6yr5rUo9U1P4S/KBuNOIfex7uW8fsbz7oZuaDFlu1TtnxVYeXf2wwB8+xg7BWrrWq2vdxZ3uFgUOKAY+lbe3cBShi+BPrqAl96dfSkr5MXsEww3g+t+rxh6833Zhl2ht4qiKLy7oYW2eI7VzqS47s/vhh7BW6I6k+KOf1jb4s5IU6PP3px5bHF3MUtpbnXDlzsLV4yRbrlcqoB7tTtZLBb+kYox7tDaarfbnZycbBeLNwvvbsz/m1XWXkttUpl01uPfAR0Y8FbPnz/7upPWpDeD+77N2rh26/aVB5ffbM/w7n6Lh0838xcfP36QvFlst9+/b5H7fjS2EhByd77ePFVsNpv52xcvLjceZQ7f90cBNoKYc/Ht/XrTs+fx4cxzGMolgv9AeQb3roaE0jgOZ55zRGUNyt67tQw0pI+/T3HOG3Iv7zwZYzVAI+/L/Jy8958FR3LiW65BmDIpjzfyqnfr9Wa+F3Sbn1Dxnmjm0SCsoQTgks+fVINAdfMvQvA9cuLz1khZRclV2oovp13VW59+08wBiDKlPm97goQhdWuPP54/Xcv5ZP2JC81cVTJJ4kNPK3dIWQGAtAeff7w/PX2sqxMl/k3uq15HhO7QDGYuB90cr7tfS3y/RSKmUwFwE1DmagHQisx86OFkzHRKAaa6sv0xnIVgmXh76M6Ag65OMAkaBahZQ+bzFnNWB9cMBDjWQRxTMDj9fqv1CqNn9BnbuYSqDTrVMny/7WeUAz0D6rN05Z05/J7OJk5guDN7BlQC+gkPJ2gkjiZe9RKmY5Y9VAUVCgXeAxOvepSZaIsGSuJlG3PAdXIymzARs1Fh7PVJbBJPOG/t7rBRCPzqIiYceYcarXG8oj6ZTL3f4iHUQN4C8IPAdPstZUOUQgWdzR6JoiiUTEwiJu1w7A2RN8RxTAlRKoMgcF5lwsaAk90g0H0GTaWMSRdnwZiNohZ2eXadKNK126KoZOOoAYYkDZK71ZWx4B2Zt8DHAW6dv9iT1t4z7Li/iIwOPNzMjgPcWkTGBx4uGkfhVsXDbvF/Ete1A2eqZ21CSGJN3GPsxTPHIEm6744GAcn+RdkD1/qsIiTJXuZGjc/07yYuSIRwq1MgAaFZ1oVfhJls7xnj9YH6W1FV6pTewdCTBGHUGIwDjMUstZY967CMtE+4VHVZJhmuZLlTI95BQlvw4U1uD/B9X6KSxiSsIaX9KR93bKu15HLCbCh70NJGWCNMN5zox6MTevo2iKhVX32mjJ0nzSgxz5VhKnGHwZeV7HdJkywmqE3DrZV2BFGW/p43ElyoyNk+ayW0ZK5Z3qw3F1MLuwZCB+ylMtxknrp2OvzX6l6Spmmp+0qkMUqbWwn3b3eOHJ/DMIoiIqHy4w+uFn8BY6jUrFZ/BdcAAAAASUVORK5CYII="

/***/ }),
/* 450 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 451 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 452 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFQAAABUCAMAAAArteDzAAABAlBMVEUAAABftQBfsQBgtQBgtQBgtgBgtQBgtgBgtABftABctgBgtgBUuQBgtQBftQBhuABgtQBhuQBgtwBgtABhtwBhtQBhtgBhtwBhtwBhuABgtQBgtABftQBgtgBgtgBftQBguQBitwBctwBgtAD///9gtQBiuABbswBetABasgBjuwDw+Ob2+/Hj8tJ4wSbz+uvb78WOy0qAxDNuvBec0V9muAt8wy50vyGGxz2Exjnp9dvd8Mnu9+Ps9+CJyUL1+u34/POj1Gxzvh/m89bR6rTO6K/E5KG74JK534+43o2m1nCk1WyRzE7V7LuVzlTW7LzJ5qjJ5qff8cuv2oCf0mZitgt1nNt5AAAAJHRSTlMAag3S972lhzsuEdcG5Sb8+/dvZl9848+79O/vwsGSU1AnJ30aeuDLAAAELUlEQVRYw6SV2XKiQBiFQRBR4262yV7VNIuoqKAmZpIYdzPZat7/XeZ0NGEYB0PLuaCKbuqr868I3ypzpZaVMyknyznpTCmrVxkhnhJpUZFOKKR9iEInkiKmE7sS99KpwyK1AAyI4qh4mErv7WKyeiRbjGfopm4YK6Dx8cLIlnxU5bWbESVqrYheuzWcTZ4Ho9HgeTIbttreimtRSczwBF7JMpOGqTXcad0mAdn1qdvQTIPZzVYiJ0FNUobUO+7YBwbBY7ejMyw9UqMlM3VsMWRjfku26HbeYFjrOBUhtfmkRYHsLZrkGzUXPWCplcx/x7w4gE3dG9ZIBNWGng6zBxfbmWKJ2ew7JKKcPjNbErcx9wtgakubRJa91EAt7Iczz1F1vfNOuPTe0dEF56E+KdL56BBOOY9ILA3xKhbA7NYJt+pdUAv/zetliYJ5Q3bQDai0dLnJzOfA7Pk++bz2QM3lN+YoaWlGxyE7yukYmpX8d7ZSYGpvZGe9aaCmgkxVRvBLEkNLJEBWA7sOwevXD3GgD9c6EvD3JqxgkDyHxJLjYbQqPjOTRfBPJKaekIBsxm97VKlXiwut9VAr8audmNEFia0Fs/rZVlUYbTS5GbfDl0FwazdgtbqGstLPuZk/26bZeQ4czVkDrJhpGbNU42b2Teyf4AzWMFdy+nOYTJc79rauQeZL4NQ112OVkLBGx7zMa/hk0N+B4zEWq5Rg0RdRJpuT2YdPSP8VnEIbpSqy+EX0E2f0tb65Yr7ck6BcdJUIqILaT/mYd+vYW2AGNUX9FYwoUurVuZifsW8ySd1DUjNC/gfVu3Y8n77srk5P8oJKcc3HDPUJtUyNqkKZb0E1v5jN0FVVFhSs0ll0Zmsd+13IrphhqSrCKaCT6D7XNQpjkgmgp4KEb17j+vT1imtJyOE5iMv0NcB9TpDxHG1ePtxs/AbvwVzFvmWljfCB/Kc4a1dBIAhiIAhWFhYKoo0Wy4Inclj4Rq4+FUT//1fkdCDqaFbB4HY2Ibs3zmSSN6CL/LxZPWGWxnNmmATUru8lV8zXjzxDChPXrz7U7vmieUUq3KOOKE+c3fVD9V+UVHZd8MAVmGHOMK2k+ih+xxRcgcl4ovhf/02zsT3gjdhoH+3n6hNF0bKG4lGNWgWzLYNhrhkeGgpan+dqj7jdc0zf+tCkvTi2ZywDHpgdNGk3Thyq7fohxRPjhA2+o6GivOjB4KMj+lhEYCbXFoxoLiaWRUhiOjHRqUH2EFS+XnnZA4FGUAPj6QVaWkpOihg5Ty8l06I3m54Yphe9EnmuWCQkK49iOZOskYqFV7GaS0yE39sd7abCmFFYSBqzS2/L4QwFBqLA6lSYsnYG39vHA4XR/XNLvt74Q3hAY45DFXMcXMzx/0BGFB0h5Oo+hlzdL0IuHsf1bnFc77M47gIY8ig5ZQYHNwAAAABJRU5ErkJggg=="

/***/ }),
/* 453 */
/***/ (function(module, exports) {

module.exports = "<b>USER TERMS & CONDITIONS (\"the Agreement\")</b>\n\n\nPLEASE READ THIS AGREEMENT CAREFULLY. IT SETS OUT THE TERMS UNDER WHICH CENTURYCOMM LIMITED TRADING AS RACING POST OFFERS YOU USE OF ITS INTERACTIVE SERVICES AS DEFINED IN CLAUSE 1.1 OF THIS AGREEMENT AND ITS WEB SITE RACING POST ONLINE LOCATED AT WWW.RACINGPOST.COM AND ITS MOBILE AND TABLET APPS, FOR EXAMPLE, ITS ANDROID, IPHONE AND IPAD APPS   (\"THE SITE\"). BY USING ANY OF THE INTERACTIVE SERVICES AND/OR THE SITE YOU AGREE THAT YOU HAVE READ AND ACCEPT THESE TERMS AND CONDITIONS AND  THAT THEY SHALL APPLY TO YOUR USE. IF YOU DO NOT WISH TO BE BOUND BY THEM, PLEASE LEAVE THIS WEB SITE.  \n\nThis Agreement is made between you and Centurycomm Limited trading as Racing Post (registered number 3387163)   whose registered office is 5 Fleet Place, London, EC4M 7RD, London, England (\"we\" or \"us\").\n\n1. Interactive Services\n\n1.1 We may make available to you on or via the Site chat areas, forums and/or other means by which communications may be made available and/or disseminated publicly; shopping and other commercial and/or transactional services including, without limitation, the supply of goods and/or services; advisory services; and/or competitions and/or prize draws (all together the \"Interactive Services\").\n\nInteractive Services also include the content on the Site which is only available by subscription (\"the Racing Post Members' Club Services\")  or the iPad App. You should visit the Terms and Conditions and the More Information about the Racing Post Members' Club section of the Site relating to the Racing Post Members' Club Services for more details about them, including access, costs and cancellation.\n\nThe information in any More Information about the Racing Post Members' Club sections of the Site,  More Information about Racing Post Members' Club Daily and Multi Day Passes as part Racing Post Members' Club Services are also incorporated into these Terms and Conditions.\n\n1.2 The Interactive Services may be operated by third parties and where they are this will be made clear to you. Where such Interactive Services are operated by a third party you may be asked to supply information and/or data (including, without limitation, financial, credit card and/or bank data), where that third party may have specific additional terms and conditions which apply. Further, when using such Interactive Services operated by such third parties, you will be dealing with them directly and as such any contracts and/or arrangements will be formed between you and them, without us as a party and we cannot be held liable for your use of or any liability arising out of the same (save to the extent required by law).\n\n2. Use of the Site and the Interactive Services\n\n2.1 The Site and the Interactive Services are for personal and non-commercial use only. You may copy electronically and print portions of the Site and/or the Interactive Services for your personal, non-commercial use only. In particular, you may not use any information from any directory or other listing or information retrieval service (if any) made available on or by the Site and/or the Interactive Services, in connection with any business or commercial undertaking (whether or not for profit). You must not display the Site or the Interactive Services or any part thereof in public. Any other use of materials on the Site and/or the Interactive Services, including User Generated Content (including without limitation reproduction for a purpose other than that noted above and any modification, distribution or republication) without our prior written permission is strictly prohibited. You also agree not to deep-link and/or frame to any of the Site for any purpose, unless specifically authorised by us to do so.\n\nYou agree that:\n\n(a) you shall not use the Site or the Interactive Services to transmit or knowingly or recklessly receive (or knowingly or recklessly authorise or permit any other person to receive or transmit) material which is obscene, threatening, menacing, offensive, defamatory, abusive, in breach of confidence, in breach of any intellectual property right (including copyright) or otherwise violates any applicable law or regulation or code, or which makes excessive demands for bandwidth or contains any virus or which may otherwise impair or harm our computer systems or any third party computer system; and\n\n(b) you will keep your password(s) if any relevant to the Site and/or the Interactive Services secure and not let them become public knowledge or be used by any third party.\n\n2.2 You agree that you will not submit any material to us (\"User Generated Content\") :\n\n(a) that is in any way, threatening, abusive, offensive, defamatory, invasive of another ‘s privacy, in breach of confidence or privacy, embarrassing to any person, hateful, blasphemous, pornographic, or racially, ethnically or otherwise objectionable;\n\n(b) in respect of which you do not have the necessary licences or approvals;\n\n(c) which constitutes or encourages conduct that would be considered a criminal offenceor otherwise contrary to any law,  regulation or code of practice, give rise to civil liability  or infringe the rights of any third party;\n\n(d) which is technically harmful;\n\n(e) which is or may be deemed to be advertising or promotional materials;\n\n(f)  collect or store other users' personal data.\n\nYou will not impersonate any person or entity when submitting User Generated Content or misrepresent any affiliation with any person or entity.\n\nWe reserve the right to require you to change your user name for any reason.\n\nYou acknowledge that we have no obligation to monitor any User Generated Content but we have the sole discretion to display, modify, distribute or delete any such User Generated Content in our sole discretion and may remove any such material at any time. Notwithstanding this, you are solely responsible for and bear the risk associated with such User Generated Content, including any reliance on the accuracy, completeness or usefulness of the same.\n\nIn the event that you are in breach of these Terms and Conditions and/or our Standards for User Generated Content at any time, we may suspend or  terminate any account that you have with us. You may not open another account with us and if you do, we reserve the right to terminate any such account. In the event that you continue to contravene these Terms and Conditions and/or the Standards for User Generated Content we reserve the right to contact your employer or your internet service provider.\n\nWe will co-operate with law enforcement or regulatory authorities or any court order requesting or requiring us to disclose the identity or location of anyone who has submitted User Generated Content to us in breach or allegedly in breach of these Terms and Conditions and/or the Standards for User Generated Content\n\nIn relation to any User Generated Content, you automatically and  hereby grant to us a perpetual, royalty free, irrevocable, non-exclusive right and licence to use, edit, reproduce, modify, publish, translate, create derivative works from and distribute such User Generated Content, in whole or on part,  in any form, medium or technology now known or hereafter developed. In addition, as between you and us, you waive any and all moral rights in such User Generated Content.\n\nPlease also see our Standards for User Generated Content which also apply to User Generated Content and which are incorporated into these Terms and Conditions. In the event that you submit any material to us for publication, you will be deemed to have accepted these Terms and Conditions and Standards.\n\nIf you see in the Site and/or the Interactive Services any material submitted by a third party user of the Site which you believe to be in breach of these Terms and Conditions and/or the Standards for User Generated Content you may report it by sending an email to help@racingpost.com. We cannot guarantee that any action will be taken as a result of your email.\n\n2.3 The intellectual property in all design, text, graphics and other material and the selection or arrangement of such material in the Site and/or the Interactive Services is owned by us and/or our respective licensors.\n\n2.4 Save to the extent required by law, we make no representations, warranties or terms of any kind including (without limitation) implied warranties as to completeness, accuracy, satisfactory quality and fitness for a particular purpose are made in respect of the Site and/or the Interactive Services or their contents (including, without limitation, any views or comment made) which are provided on an \"as is\" basis). We do not warrant that the Site and/or the Interactive Services or their contents (including, without limitation, any views or comment made) will meet your particular expectations or requirements or that they will be uninterrupted, timely, secure or error-free; nor do we make any warranty as to results or the accuracy of any information obtained by you through the Site and/or the Interactive Services or their contents (including, without limitation, any views or comment made), all of which arehereby excluded to the greatest extent permitted by law. All information and/or data included in and/or on the Site, the Interactive Services and/or in any directory or other listings or information retrieval service made available on or by the Site and/or the Interactive Services has been so made available for guidance only. Your use of such information and/or data is therefore entirely at your own risk. Nothing in these terms of use excludes or limits our liability for death or personal injury arising from our negligence, or our fraud or fraudulent misrepresentation, or any other liability that cannot be excluded or limited by English law. We will not be liable to any user for any loss or damage, whether in contract, tort (including negligence), breach of statutory duty, or otherwise, even if foreseeable, arising under or in connection with:\n\n•     use of, or inability to use, our site; or\n•     use of, or reliance on, any content displayed on our site.\n\nPlease note that we only provide our site for domestic and private use. You agree not to use our site for any commercial or business purposes, and we have no liability to you for any loss of profit, loss of business, business interruption, or loss of business opportunity.\nWe will not be liable for any loss or damage caused by a virus, distributed denial-of-service attack, or other technologically harmful material that may infect your computer equipment, computer programs, data or other proprietary material due to your use of our site or to your downloading of any content on it, or on any website linked to it. We assume no responsibility for the content of websites linked on our site. Such links should not be interpreted as endorsement by us of those linked websites. We will not be liable for any loss or damage that may arise from your use of them.\n\n2.5 The Site and/or the Interactive Services may include links to web sites and/or services owned and/or operated by third parties. These are provided for your convenience only and we are not responsible for and do not give any warranties or make any representations regarding any such web sites and/or services and is not responsible for or liable in relation to the content or your use of such web sites (save to the extent required by law).\n\n2.6 We are the owner of:\n\n(a) those trade mark(s) indicated as such throughout the Site from time to time; and\n\n(b) all other trade marks used in the Site and/or the Interactive Service which are not licensed to it by any third party. All other trade marks, product names and company names or logos cited therein are the property of their respective owners\n\n2.7 The provisions in clause 5 and our Privacy Policy on Data Protection and Use of Personal Information apply in respect of your use of the Site and/or the Interactive Services.\n \n2.8 Viruses\n \n(a) We do not guarantee that our site will be secure or free from bugs or viruses. You are responsible for configuring your information technology, computer programmes and platform in order to access our site. You should use your own virus protection software. You must not misuse our site by knowingly introducing viruses, trojans, worms, logic bombs or other material which is malicious or technologically harmful. You must not attempt to gain unauthorized access to our site, the server on which our site is stored or any server, computer or database connected to our site. You must not attack our site via a denial-of-service attack or a distributed denial-of service attack. By breaching this provision, you would commit a criminal offence under the Computer Misuse Act 1990. We will report any such breach to the relevant law enforcement authorities and we will co-operate with those authorities by disclosing your identity to them. In the event of such a breach, your right to use our site will cease immediately.\n\n3. Availability and Security of the Site and the Interactive Service\n3.1 Due to the nature of the Internet, we do not promise full and error free operation of the Site and/or the Interactive Services at all times. All of our liability and that of our directors or employees howsoever arising for any loss whatsoever arising from your use of or inability to use the Site and/or the Interactive Services is excluded, insofar as it is possible to do so in law.\n\n3.2 Any and all information or material of whatever nature added to or stored by you on the Site (\"your material\") is so added or stored entirely at your own risk. All of our and the liability of our directors or employees in respect of the loss or deletion of your material or your inability for whatever reason to access your material is excluded to the fullest extent permitted by law.\n\n3.3 We shall use reasonable endeavours to ensure that the Site, the Interactive Services and any information it holds on you are kept secure. However, due to the nature of the Internet, we cannot accept any liability for those who intentionally attempt to and/or gain unauthorised access to the same by means such as, without limitation, computer hacking (save to the extent that we are unable to exclude such liability by law).\n\n3.4 From time to time, your access to the Site and/or the Interactive Services may be suspended in order for work to be carried out relating to upgrading or maintenance or otherwise as necessary for the provision of the Site and/or the Interactive Services. We shall endeavour to ensure that such works are carried out as expeditiously as is possible in the circumstances.\n\n4. Registration\n\nWhere you are asked to complete a registration form for us the personal details that you provide must be true, accurate and complete.\n\n5. Data Protection and Use of Personal Information\n\nFull details of the way we hold and process information  which you provide to us and/or from which we can identify you are set out in our Privacy Policy\n\n6. Payment\n\n6.1 Subject to the remainder of clause 6 below and to any charges made for Racing Post Members' Club Services or the iPad App Edition,  the Site is currently made available without charge to you by us. However, you are responsible for all telephone charges necessary to access and use the Site including, for the avoidance of doubt, the Interactive Services which are made available.\n\n6.2 In addition to the Racing Post Members' Club Services, access to some other parts of the Interactive Services is currently made available by payment only.  These include Racing Post Members' Club Daily / Multi Day Pass Services and the iPad App edition.\n\n6.3 The iPad App edition is available via iTunes.  If you have any problems with any payments in respect of the iPad App edition, please contact our Support Centre on +44 (0) 20 7748 3771.\n\n6.4 You must provide us with complete and accurate payment information. You can pay by either credit or debit card. By submitting credit or debit card payment details to us you warrant that you are entitled to purchase the Interactive Services, including  the Racing Post Members' Club Services, using those payment details. We will continue to collect these recurring payments for your subscription until you cancel the service, see 7 below. We will use the standard card Updater file service used by banks and subscription providers to collect expiring and other card details if and when these become out of date. This is done according to the UK banks procedures for collecting and distributing this data. In the case of unauthorised payments we reserve the right to suspend or terminate your access to the Interactive Services and the Racing Post Members' Club Services. If we do not receive payment authorisation or any authorisation is subsequently cancelled, we may immediately terminate or suspend your access to any Interactive Services, including the Racing Post Members' Club Services. Please ensure that your payment card details are kept up to date. If we are unable to process payment from your card, it will be necessary to suspend your access to the Interactive Services, until you provide us with details of a valid credit card. You can do this by telephoning Racing Post Customer Services on the numbers provided or by updating your card details on your www.racingpost.com ‘My Account' page. You will still be liable for any outstanding payments that could not be met when your access to the Interactive Services was suspended.\n\n6.5 We will try to process your payment promptly but this does not guarantee that the Interactive Services or the Racing Post Members' Club Services will be available to you by any specified time. A contract with you for receipt of the Interactive Services or the Racing Post Members' Club Services or Racing Post Members' Club Daily / Multi Day Pass Services will become legally binding from the time at which we take payment from you.\n\n6.6 We will charge you in British PoundsSterling or, at our discretion, in Euros, depending on the service and your country of residence. You may also have to pay any applicable local taxes.\n\n6.7  If a free trial is made available to you, you will only be charged with effect from the expiry of that free trial period. No more than one free trial per subscriber is allowed. We reserve the right without notice and at any time to terminate any free trial.\n\nIpad app edition\n\n6.8 We offer a 30 day free trial for the iPad App Edition, valid from the time you first download the iPad App if you provide us with your name and email address  and agree to these Terms and Conditions. We may use this information  to seek your feedback on the Site, including  the iPad App Edition and to notify you of new products and features and otherwise in accordance with our Privacy Policy [link] but we will not make it available to any third party. If you access the Site or the Interactive Services via the iPad App Edition as part of the free trial, then these terms and conditions will apply to you other than in relation to payment for the iPad App Edition. No more than one free trial per subscriber is allowed. We may terminate the free trial at any time for any reason and if you wish to continue to use the  iPad App Edition you will need to pay for it.\n7. Refunds, Returns & Cancellation\n\nThese Terms & Conditions relating to refunds, returns & cancellation do not affect Your Statutory Right to Cancel\n\n7.1  Refunds for all Interactive Services including Racing Post Members' Club Services\n\n(a) Any reimbursement or refund made by us in relation to Interactive Services, including Racing Post Members' Club Services will only be made to the bank account or debit/credit card used to make payment or part payment for the Interactive Services, including the Racing Post Members' Club Services concerned.  We will in no circumstances pay money to the credit of a third party or to any other bank account, debit or credit card. If we are for any reason unable to make a refund to your bank account or debit/credit card for any reason the refund will be sent by cheque to you to the address you have notified to us as part of the original registration process or any update of such address. \n\n(b) We may also charge you a reasonable sum to cover our administrative costs in processing any request for a refund.\n\n(c) We will refund to you all monies due to you in relation to your cancellation or downgrading of your subscription package within 30 days of the date on which such cancellation or downgrade takes effect.\n\nTo upgrade, downgrade please email help@racingpost.com or telephone our Customer Services team on 020 7748 3771 Monday to Saturday 8am-10pm, Sundays and bank holidays 10am-10pm.\n\nTo cancel your subscription please telephone our Members' Club subscription cancellation team on +44 (0) 1933 445177 Monday - Friday 9am-8pm.\n\n7.1 Returns Policy for books, audio, DVD and software and other items purchased from the Racing Post shop\n\n21-day Returns Policy\n\nOur 21-day returns guarantee\n\nOur 21-day returns policy guarantee means that if for any reason you are unhappy with any purchase, you can return it to us in its original condition so that we receive it within 21 days of the date you received the item, (with any seals and shrink-wrap intact in the case of audio, video or DVD or software products) and we will issue a full refund for the price you paid for the item--see our Refunds Policy in paragraph 7.2. We can only accept the return of opened items of audio, video or DVD or software products if they are faulty.\n\n7.2 Refunds Policy for books, audio, DVD and software and other items purchased from the Racing Post shop\n\nOur refunds policy for books, audio, DVD and software and other items purchased from the Racing Post shop does not affect your statutory rights.\n\nWhen you send your item back to us, we'll process the returned item then notify you via e-mail of your refund. You can expect a refund in the same form of payment originally used for purchase within three weeks of our receiving your return.\n\nFor more information on shop refunds please contact the shop team on +44 (0)19 33304 845 for further assistance.\n\n7.3  Your Statutory Right to cancel and cancellation of Racing Post Members' Club Services\n\nBy law, you have the right to cancel the contract for the purchase of goods and services within seven working days beginning with the day after the date an item is delivered. To cancel any purchase, when it consists of physical products such as books, videos, DVDs or software products, within the seven working-day period, please contact our Support Centre on +44 (0) 1933 304 858 or e-mail us at shop@racingpost.com  for advice on how to  return purchased items.\n\nHowever, we cannot accept cancellations of contracts for audio, video or DVD or software products where the item has been unsealed.\n\nAdditionally, we are unable to accept cancellation of, or make refunds for, digital items such as PDFs where the item has been downloaded or in relation to any part of the Interactive Services for which payment is required, once these Services have been accessed in respect of which you may cancel in accordance with the More Information about Member's Club Services section of the Site following which refunds will be made in accordance with paragraph 7.1.\n\nHowever, if you have not downloaded the digital item or accessed it via the Interactive Services or accessed Racing Post Members' Club Services (whether  you are a new subscriber or have upgraded or downgraded your package),  you may cancel the contract (or your upgrade or downgrade) at any time before the end of the seven working-day period by contacting  +44 (0) 2077 483 771.\n\nThis means that in relation to Racing Post Members' Club Services if you have not accessed the package to which you have subscribed (whether  you are a new subscriber or have upgraded or downgraded your package) within the seven working-day period you may cancel the contract (or your upgrade or downgrade) pursuant to your statutory right to cancel by contacting +44 (0) 207 7483 771. If you do not cancel within this time you will be able to cancel in accordance with the More Information about Member's Club Services. In both cases any refunds due to you will be paid in accordance with paragraph 7.1 and 7.1.1.\n\nYour statutory right to cancel an upgrade or downgrade does not mean that  you can cancel the whole contract.  If you cancel an upgrade or a downgrade pursuant to your statutory right to cancel you will revert to the package you were subscribed to before.\n\n8. Termination\n\n8.1 We may permanently terminate your access to the Interactive Services immediately for any reason.\n\n8.2 There is no specific time limit applying to your use of the Interactive Services on these terms and conditions. However, we reserve the right to suspend or terminate your access to the Interactive Services if you breach these terms and conditions, with or without notice and without further obligation to you.\n\n8.3  In the event that we terminate your access to the Interactive Services as a result of your breach of these Terms and Conditions or the Racing Post Members' Club Terms and Conditions there will be no refund to you of the unused portion of any Membership Fees.\n\n9. Claims\n\nWhere a claim is brought against us by a third party in relation to your use of the Site and/or the Interactive Services or any User Generated Content,  you agree to fully reimburse us and all companies within our group of companies  (i.e. companies which share the same ultimate parent company) for all losses, costs, actions, claims, damages, expenses (including reasonable legal costs and expenses) or liabilities, whatsoever suffered or incurred by us or companies within our group  (i.e. companies which share the same ultimate parent company)  in or as a consequence of your breach of this Agreement and/or your use of the Site and/or Interactive Service and/or any User Generated Content which is included in the Site and/or the Interactive Service.\n\n10. Force Majeure\n\nNeither party shall be liable to the other, for any loss or damage which may be suffered by the other party due to any cause beyond the first party's reasonable control including without limitation any power failure.\n\n11. Notices\n\nAny notices we send to you will be sent to the email address you supply during the Racing Post registration process or any updated email address. Any notices you send us should be sent by email to help@racingpost.com. Notices will be deemed to have been delivered at the time and date of sending of the email, which time and date are specified in the email.\n\nEither party may also give notice to the other by first class post to the other party's address. Any notices we send to you by first class post will be sent to the address you supply during the Racing Post registration process or any updated address. You may send notices to us at the address set out at the head of these Terms and Conditions.   Any notice sent by first class post shall be deemed (in the absence of evidence of early receipt) to have been delivered two days after posting.\n\n12. Assignment\n\n12.1 This Agreement shall be personal to you and you may not assign, transfer, sublet, lease or delegate all or any of your rights and obligations, without our prior written consent.\n\n12.2 We reserve the right to assign or transfer all or any of our rights and obligations under this Agreement to any companies in the same group (i.e. companies which share the same ultimate parent company) or another third party. In the event of assignment or transfer, notification will either be given to you by e-mail or posted on the Site.\n\n13. No Waiver\n\nFailure by either party to exercise or enforce any right conferred shall not be deemed to be a waiver of any such right nor operate so as to bar that exercise or enforcement thereof or of any other right on any later occasion.\n\n14. Entire Agreement\n\nThis Agreement, together with any other terms and conditions or other contractual terms relating to your access to or use of any Interactive Services, including, without limitation, the Racing Post Members’ Club Daily / Multi day pass services, constitutes the entire agreement between us and you with respect to this subject-matter and excludes any representations or warranties previously given or made (other than any fraudulent misrepresentation) and it may be amended only by us on notice to you.\n\n15. Variation of Terms\n\nWe reserve the right to vary this Agreement from time to time. Such changes shall either be notified to you by e-mail or posted here. We recommend you check back regularly to ensure you are aware of any changes. Changes  made in this manner shall be deemed to have been accepted if you continue to use the Site and/or the Interactive Services after the date of transmission of the e-mail or of posting here, whichever occurs later.\n\n16. Law and Jurisdiction\n\nThese Terms and Conditions and your access to and use of Site and/or the Interactive Services are subject to the laws of England and you submit to the exclusive jurisdiction of the courts of England.\n\n17. Invalidity\n\nIf the whole or any part of any provision of these Terms is or becomes invalid, void or unenforceable for any reason the same shall to the extent required be severed from these Terms and rendered ineffective so far as is possible without modifying the remaining provisions of these Terms and shall in no way affect the validity or enforceability of any other provisions.\n\n18. ThirdParty Rights\n\nThese Terms are not intended to create and shall not create any rights, entitlements, claims or benefits enforceable by any third party by virtue of the Contracts (Rights of Third Parties) Act 1999.\n"

/***/ }),
/* 454 */
/***/ (function(module, exports) {

module.exports = ".mandatory_login \n{\n  position  : fixed;\n  overflow  : auto;\n\n  top       : 0;\n  left      : 0;\n  \n  width     : 100%;\n  height    : 100%;\n\n  z-index   : 9999;\n}\n\n.mandatory_login div \n{\n  box-sizing: border-box;\n}\n\n.mandatory_login .overlay \n{\n  position  : fixed;\n  top       : 0;\n  left      : 0;\n\n  width     : 100%;\n  height    : 100%;\n\n  background-color: #000;\n  \n  opacity   : 0.85;\n}\n\n.mandatory_login .box \n{\n  position        : relative;\n  top             : 0px;\n  left            : 0px;\n\n  width           : 320px;\n  height          : 320px;\n  min-width       : 320px;\n\n  margin          : auto;\n  margin-top      : 100px;\n  margin-bottom   : 10px;\n\n  overflow        : hidden;\n\n  font-family     : var(--font-montserrat);\n  font-weight     : normal;\n  font-style      : normal;\n  font-stretch    : normal;\n  line-height     : normal;\n  font-size       : 18px;\n  letter-spacing  : -0.4px;\n\n  transition      : width 0.5s, height 0.5s;\n  /*transition-timing-function: ease-in-out;*/\n}\n\n.mandatory_login .box.register_size\n{\n  width     : 320px;\n  max-width : 98%;\n  min-width : 320px;\n  height    : 456px;\n}\n\n.mandatory_login .box.register_size.email_error\n{\n  height  : 470px;\n}\n\n.mandatory_login .box.register_size.password_error\n{\n  height  : 500px;\n}\n\n.mandatory_login .box.register_size.confirm_password_error\n{\n  height  : 496px;\n}\n\n.mandatory_login .box.register_size.email_password_error\n{\n  height  : 516px;\n}\n\n.mandatory_login .box.register_size.email_confirm_password_error\n{\n  height  : 530px;\n}\n\n.mandatory_login .box.register_size.email_password_confirm_password_error\n{\n  height  : 530px;\n}\n\n.mandatory_login .box.register_size.password_confirm_password_error\n{\n  height  : 530px;\n}\n\n.mandatory_login .box.register_done_size\n{\n  width   : 320px;\n  height  : 395px;\n}\n\n.mandatory_login .box.login_size\n{\n  width   : 320px;\n  height  : 360px;\n}\n\n.mandatory_login .box.login_size.email_error\n{\n  height  : 374px;\n}\n\n.mandatory_login .box.login_size.password_error\n{\n  height  : 400px;\n}\n\n.mandatory_login .box.login_size.email_password_error\n{\n  height  : 414px;\n}\n\n.mandatory_login .box.reset_size\n{\n  width   :320px;\n  height  :248px;\n}\n\n.mandatory_login .box.reset_done_size\n{\n  width   :320px;\n  height  :248px;\n}\n\n.mandatory_login .box.terms_and_conditions_size\n{\n  width     :820px;\n  max-width :98%;\n  height    :520px;\n}\n\n.mandatory_login .form_cap \n{\n  width     : 100%;\n  height    : 5px;\n  \n  position  : relative;\n  \n  top       : 0px;\n  left      : 0px;\n  \n  background-color: #d8e8f3;\n\n  border-top-left-radius  : 4px;\n  border-top-right-radius : 4px;\n\n  box-shadow: 0 1px 0 0 rgba(95, 125, 145, 0.5);\n}\n\n.mandatory_login .form\n{\n  position        : absolute;\n  height          : 100%;\n  width           : 100%;\n  top             : 0;\n  \n  background-color: #fff;\n  border-radius   : 4px;\n\n  box-shadow      : 0 2px 7px 0 rgba(0, 0, 0, 0.12);\n}\n\n.mandatory_login .content\n{\n  position      : absolute;\n  top           : 0px;\n\n  width         : 100%;\n  height        : 100%;\n\n  padding-left  : 26px;\n  padding-right : 26px;\n\n  text-align    : center;\n}\n\n.mandatory_login .terms_and_conditions_size .content\n{\n  padding-left  : 0px;\n  padding-right : 0px;\n}\n\n.mandatory_login .sub_content \n{\n  position      : relative;\n  padding-top   : 54px;\n}\n\n.mandatory_login .button_login, .mandatory_login .button_register , .mandatory_login .button_back \n{\n  position        : relative;\n  height          : 54px;\n  width           : 50%;\n\n  line-height     : 54px;\n  text-align      : center;\n  \n  color           : #cac9ca;\n\n  cursor          : pointer;\n}\n\n.mandatory_login .button_login, .mandatory_login .button_register \n{\n  float           : left;\n}\n\n.mandatory_login .button_back \n{\n  position        : absolute;\n\n  width           : 160px;\n\n  text-align      : left;\n}\n.mandatory_login .button_back span\n{\n  display         : block;\n}\n\n.mandatory_login .button_selected \n{\n  color         : #4a4a4a !important;\n}\n\n.mandatory_login .action_button \n{\n  position        : absolute;\n  bottom          : 16px;\n\n  width           : 85%;\n  height          : 40px;\n\n  margin-left     : 7.5%;\n\n  border-radius   : 4px;\n\n  background-color: #0072dd;\n\n  box-shadow      : inset 0 -3px 0 0 rgba(0, 0, 0, 0.08);\n\n  line-height     : 40px;\n  font-size       : 14px;\n  letter-spacing  : 0.3px;\n  text-align      : center;\n  color           : #ffffff;\n\n  cursor          : pointer;\n}\n\n.mandatory_login .action_button_spinner\n{\n  display         : none;\n  padding-top     : 6px;\n}\n\n.mandatory_login .selector_underline\n{\n  position          : absolute;\n  top               : 54px;\n  left              : 0;\n  height            : 2px;\n  width             : 50%;\n\n  background-color  : #0072dd;\n  \n  transition        : left 0.4s, top 0.4s;\n}\n\n.mandatory_login .selector_underline.full_size_position\n{\n  width   : 100%;\n}\n\n.mandatory_login .selector_underline.login_size_position\n{\n  left    : 50%;\n}\n\n.mandatory_login .selector_underline.register_size_position\n{\n  left    : 0;\n}\n\n.mandatory_login .selector_underline.back_size_position\n{\n  left    : 0;\n  width   : 160px;\n}\n\n.mandatory_login .vertical_separator\n{\n  position          : absolute;\n  left              : 50%;\n  top               : 8px;\n\n  width             : 1px;\n  height            : 44px;\n  opacity           : 0.1;\n  background-color  : #979797;\n}\n\n.mandatory_login .left_arrow \n{\n  margin-top  : 4px;\n  margin-left : 41px;\n  margin-right: 10px;\n\n  width       : 12.5px;\n  height      : 21px;\n\n  float       : left;\n}\n\n.mandatory_login .info_text \n{\n  color           : #4a4a4a;\n\n  padding-top     : 15px;\n  padding-bottom  : 7px;\n}\n\n.mandatory_login .info_text.middle\n{\n  font-size       : 14px;\n}\n\n.mandatory_login .register_done .info_text.middle\n{\n  padding-top: 20px;\n}\n\n.mandatory_login .info_text.small, .mandatory_login .info_text.smaller\n{\n  letter-spacing  : -0.2px;\n  color           : #9b9b9b;\n}\n\n.mandatory_login .info_text.small\n{\n  font-size       : 12px;\n\n  padding-top     : 2px;\n}\n\n.mandatory_login .info_text.smaller\n{\n  font-size       : 10px;\n\n  clear           : both;\n  padding-top     : 10px;\n  padding-bottom  : 10px;\n}\n\n.mandatory_login .info_text.smaller input\n{\n  float         : left;\n\n  margin-right  : 5px; \n  font-size     : 12px;\n\n  padding       : 10px;\n\n  color         : #9b9b9b;\n}\n\n.mandatory_login .info_text.smaller input.invalid\n{\n  border-color  : #ee4341;\n}\n\n.mandatory_login .info_text.smaller div\n{\n  float       : left;\n  margin-top  : 2px;\n  width       : 180px;\n}\n\n.mandatory_login .terms_and_conditions\n{\n  padding-left  : 24px;\n  padding-right : 24px;\n  \n  height        : 438px;\n  \n  white-space   : pre-wrap;\n  \n  text-align    : left;\n  overflow      : auto;\n}\n\n.mandatory_login .background_login\n{\n  width   :auto;\n  height  :306px;\n\n  position: absolute;\n  top     : 50px;\n  left    : 0px;\n}\n\n.mandatory_login .background_register\n{\n  width   :auto;\n  height  :387px;\n\n  position: absolute;\n  bottom  : 4px;\n  right   : 0px;\n}\n\n.mandatory_login .background_registered\n{\n  width   :auto;\n  height  :180px;\n\n  position: absolute;\n  top     : 135px;\n  left    : 19px;\n}\n\n.mandatory_login input\n{\n  outline : none;\n}\n\n.mandatory_login input:hover, .mandatory_login input:focus\n{\n  border-color  : #3c99dc;\n}\n\n.mandatory_login input:checked \n{\n  color         : #78be20;\n  border-color  : #78be20;\n}\n\n.mandatory_login .email, .mandatory_login .password, .mandatory_login .confirm_password\n{\n  width           : 75%;\n  height          : 35px;\n\n  margin-top      : 11px;\n  padding         : 10px 25px 10px 10px;\n\n  font-size       : 12px;\n\n  background-color: #ffffff;\n  \n  border          : solid 1px #9b9b9b;\n  border-radius   : 4px;\n}\n\n.mandatory_login .valid\n{\n  color         : #78be20 !important;\n  border-color  : #78be20 !important;\n}\n\n.mandatory_login .invalid\n{\n  color         : #ee4341 !important;\n  border-color  : #ee4341 !important;\n}\n\n.mandatory_login .error\n{\n  display         : none;\n\n  padding-top     : 4px;\n  padding-bottom  : 4px;\n\n  font-size       : 9px;\n  letter-spacing  : -0.2px;\n}\n\n.mandatory_login input.email\n{\n  margin-top  :0px;\n}\n\n.mandatory_login .register_done_title\n{\n  font-size       : 14px;\n  letter-spacing  : -0.3px;\n  text-align      : center;\n  margin-top      : 8px;\n  height          : 30px;\n}\n\n.mandatory_login .register_done_title img\n{\n  position  : relative;\n\n  top       : 6px;\n  right     : 4px;\n}\n\n.mandatory_login .forgotten_passoword\n{\n  padding-top     : 5px;\n  font-size       : 10px;\n  letter-spacing  : -0.2px;\n  text-decoration : underline;\n\n  color           : #3c99dc;\n  cursor          : pointer;\n}\n\n.mandatory_login .accepts_terms.invalid .checkmark\n{\n  border-color     : #ee4341!important;\n}\n\n.mandatory_login .accepts_terms.invalid\n{\n  color           : #ee4341!important;\n  font-weight     : bold;\n}\n\n.mandatory_login .accepts_terms.valid\n{\n  color           : #9b9b9b!important;\n}\n\n.mandatory_login .go_to_terms_and_conditions\n{\n  color           : #00abee;\n  cursor          : pointer;\n  text-decoration : underline;\n}\n\n.mandatory_login .invalid .go_to_terms_and_conditions\n{\n  color           : #ee4341;\n}\n\n.mandatory_login .register_done\n{\n  position  : relative;\n  top       : -45px;\n  text-align: center;\n}\n\n.mandatory_login .register_done_title \n{\n  font-size   : 21px;\n  text-align  : center;\n}\n\n.mandatory_login .register_done_title img\n{\n  width   :28px;\n  height  :28px;\n}\n\n.mandatory_login .clear\n{\n  background: #3333;\n}\n\n.mandatory_login .align_right\n{\n  text-align: right;\n}\n\n.mandatory_login .align_left\n{\n  text-align: left;\n}\n\n.mandatory_login .field\n{\n  position : relative;\n}\n\n.mandatory_login .ok,\n.mandatory_login .not_ok\n{\n  display  : none;\n  position : absolute;\n  right    : 7px;\n  top      : 8px;\n  cursor   : default;\n}\n\n.mandatory_login .field_password .ok,\n.mandatory_login .field_password .not_ok,\n.mandatory_login .field_confirm_password .ok,\n.mandatory_login .field_confirm_password .not_ok\n{\n  top      : 18px;\n}\n\n.mandatory_login .align_left .ok,\n.mandatory_login .align_left .not_ok\n{\n  right    : auto;\n  left     : calc(75% - 20px);\n}\n\n.mandatory_login .sign_in_error,\n.mandatory_login .sign_up_error\n{\n  position  : absolute;\n  bottom    : 60px;\n  display   : none;\n  color     : #ee4341 !important;\n}\n\n.mandatory_login .sign_in_error\n{\n  right     : 26px;\n}\n\n.mandatory_login .sign_up_error\n{\n  left     : 26px;\n}\n\n\n\n\n\n.specBox {\n  display: block;\n  position: relative;\n  padding-left: 20px;\n  margin-bottom: 6px;\n  cursor: pointer;\n  font-size: 22px;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n/* Hide the browser's default checkbox */\n.specBox input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  position: absolute;\n  left: 0;\n  width: 15px;\n  height: 15px;\n  z-index: 1000;\n}\n/* Create a custom checkbox */\n.checkmark {\n  position: absolute;\n  left: 0;\n  height: 15px;\n  width: 15px;\n  border: 1px solid #979797;\n  border-radius: 2px;\n  z-index: 1;\n}\n/* When the checkbox is checked, add a #78be20 background */\n.specBox input:checked ~ .checkmark {\n  border: 1px solid #78be20;\n}\n/* Create the checkmark/indicator (hidden when not checked) */\n.checkmark:after {\n  content: \"\";\n  position: absolute;\n  display: none;\n}\n/* Show the checkmark when checked */\n.specBox input:checked ~ .checkmark:after {\n  display: block;\n}\n/* Style the checkmark/indicator */\n.specBox .checkmark:after {\n  left: 4px;\n  top: 1px;\n  width: 5px;\n  height: 10px;\n  border: solid #78be20;\n  border-width: 0 2px 2px 0;\n  -webkit-transform: rotate(45deg);\n  -ms-transform: rotate(45deg);\n  transform: rotate(45deg);\n}\n\n\n@media only screen and (max-width: 479px) \n{\n  .mandatory_login .box  \n  {\n    top       : 50%;\n    transform : translateY(-50%);\n\n    width     : 98%!important;\n    margin    : auto;\n  }\n\n  .mandatory_login .box.register_size \n  {\n    height: 554px!important;\n  }\n\n  .mandatory_login .box.register_size.email_error \n  {\n    height: 554px!important;\n  }\n\n  .mandatory_login .box.register_size.password_error \n  {\n    height: 582px!important;\n  }\n\n  .mandatory_login .box.register_size.email_confirm_password_error \n  {\n    height: 564px!important;\n  }\n\n  .mandatory_login .box.register_size.email_password_error \n  {\n    height: 615px!important;\n  }\n\n  .box.register_size.password_confirm_password_error \n  {\n    height: 604px!important;\n  }\n\n  .box.register_size.email_password_confirm_password_error \n  {\n    height: 635px!important;\n  }\n\n  .mandatory_login .box.register_size.password_confirm_password_error \n  {\n    height: 604px!important;\n  }\n\n  .mandatory_login .box.login_size \n  {\n    height: 440px!important;\n  }\n\n  .mandatory_login .box.login_size.email_error \n  {\n    height: 440px!important;\n  }\n\n  .mandatory_login .box.login_size.email_password_error \n  {\n    height: 495px!important;\n  }\n\n  .mandatory_login .box.login_size.password_error \n  {\n    height: 475px!important;\n  }\n\n  .mandatory_login .box.reset_size \n  {\n    height: 300px!important;\n  }\n\n  .mandatory_login .box.reset_done_size\n  {\n    height  :300px!important;\n  }\n\n  .mandatory_login .box.terms_and_conditions_size \n  {\n    height: 554px!important;\n}\n\n  .mandatory_login .register_done \n  {\n    top: -50px;\n  }\n\n  .mandatory_login .button_login, .mandatory_login .button_register , .mandatory_login .button_back \n  {\n    height      : 66px;\n    line-height : 66px;\n\n    width       : 50%;\n  }\n\n  .mandatory_login .vertical_separator\n  {\n    height      : 56px;\n  }\n\n  .mandatory_login .selector_underline\n  {\n    top         : 66px!important;\n  }\n\n  .mandatory_login .selector_underline.back_size_position \n  {\n    width: 50%;\n  }\n\n  .mandatory_login .sub_content \n  {\n    padding-top   : 66px;\n  }\n\n  .mandatory_login .action_button \n  {\n    height          : 50px;\n\n    line-height     : 50px;\n  }\n\n  .mandatory_login .background_login \n  {\n    height  : 360px;\n    top     : 72px;\n    left    : calc(20% - 100px);\n  }\n\n  .mandatory_login .background_registered \n  {\n    left      : 50%;\n    transform : translateX(-50%);\n  }\n\n  .mandatory_login .info_text \n  {\n    font-size       : 23px;\n    letter-spacing  : -0.5px;\n    line-height     : 23px;\n  }\n\n  .mandatory_login .align_right .info_text \n  {\n    padding-left: 20px;\n  }\n\n  .mandatory_login .register_done .info_text\n  {\n    line-height   : 17px;\n    letter-spacing: -0.3px;\n  }\n\n  .mandatory_login .info_text.small \n  {\n    font-size       : 15px;\n    letter-spacing  : -0.3px;\n  }\n\n  .mandatory_login .login .info_text.small \n  {\n    width: 100%;\n  }\n\n  .mandatory_login .info_text.smaller \n  {\n    font-size       : 14px;\n    letter-spacing  : -0.3px;\n    line-height     : 14px;\n  }\n\n  .mandatory_login .forgotten_passoword \n  {\n    font-size       : 13px;\n    letter-spacing  : -0.3px;\n  }\n\n  .mandatory_login .info_text.smaller div \n  {\n    margin-top      : 0px;\n    width           : 82%;\n    padding-left    : 10px;\n  }\n\n  .mandatory_login .email, .mandatory_login .password, .mandatory_login .confirm_password\n  {\n    height          : 44px;\n    font-size       : 14px;\n  }\n\n  .mandatory_login .align_left .ok, .mandatory_login .align_left .not_ok \n  {\n    left: calc(75% - 26px);\n  }\n\n  .mandatory_login .ok, .mandatory_login .not_ok \n  {\n    right: 10px;\n  }\n\n  .mandatory_login .ok,\n  .mandatory_login .not_ok\n  {\n    top         : 13px;\n    transform   : scale(1.3);\n  }\n\n  .mandatory_login .field_password .ok,\n  .mandatory_login .field_password .not_ok,\n  .mandatory_login .field_confirm_password .ok,\n  .mandatory_login .field_confirm_password .not_ok\n  {\n    top      : 24px!important;\n  }\n\n  .mandatory_login .error \n  {\n    font-size     : 11px!important;\n  }\n\n  .mandatory_login .accepts_terms \n  {\n    white-space   : nowrap;\n  }\n\n  .mandatory_login .terms_and_conditions\n  {\n    height        : 460px!important;\n    font-size     : 18px!important;\n  }\n\n  .mandatory_login .sign_in_error, .mandatory_login .sign_up_error \n  {\n    bottom: 70px;\n  }\n\n  .specBox input \n  {\n    width   : 20px;\n    height  : 20px;\n  }\n\n  .checkmark\n  {\n    height      : 20px;\n    width       : 20px;\n    margin-top  : -2px;\n  }\n\n  .specBox .checkmark:after \n  {\n      left    : 6px;\n      top     : 2px;\n      width   : 6px;\n      height  : 12px;\n  }\n}\n\n@media only screen and (max-height: 635px)\n{\n  .mandatory_login .box  \n  {\n    top       : 0px!important;\n    transform : none!important;\n  }\n}"

/***/ })
/******/ ]);
});
//# sourceMappingURL=rp-auth.js.map

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FiltersInput = __webpack_require__(199);

var _FiltersInput2 = _interopRequireDefault(_FiltersInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FiltersInput2.default;

/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FiltersInput;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Input = __webpack_require__(70);

var _Input2 = _interopRequireDefault(_Input);

var _FiltersInput = __webpack_require__(203);

var _FiltersInput2 = _interopRequireDefault(_FiltersInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FiltersInput(_ref) {
    var className = _ref.className,
        label = _ref.label,
        value = _ref.value,
        onChange = _ref.onChange;

    /* eslint-disable jsx-a11y/label-has-for */
    return _react2.default.createElement(
        'label',
        { className: _FiltersInput2.default.root + ' ' + className },
        _react2.default.createElement(
            'div',
            null,
            label
        ),
        _react2.default.createElement(_Input2.default, {
            className: _FiltersInput2.default.input,
            placeholder: label,
            debounce: 300,
            value: value,
            onChange: onChange
        })
    );
    /* eslint-enable jsx-a11y/label-has-for */
}

FiltersInput.propTypes = {
    className: _propTypes2.default.string,
    label: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired
};

FiltersInput.defaultProps = {
    className: '',
    value: ''
};

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _debounce2 = __webpack_require__(201);

var _debounce3 = _interopRequireDefault(_debounce2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Input = function (_PureComponent) {
    _inherits(Input, _PureComponent);

    function Input() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Input);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Input.__proto__ || Object.getPrototypeOf(Input)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            value: _this.props.value
        }, _this.changeDebounced = (0, _debounce3.default)(_this.change, _this.props.debounce), _this.handleChange = function (ev) {
            var value = ev.target.value;
            var debounce = _this.props.debounce;

            if (debounce) {
                _this.setState({ value: value });
                _this.changeDebounced(value);
            } else {
                _this.change(value);
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Input, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var debounce = _ref2.debounce,
                value = _ref2.value,
                onChange = _ref2.onChange;

            if (value !== this.props.value) {
                this.setState({ value: value });
            }
            if (debounce !== this.props.debounce || onChange !== this.props.onChange) {
                this.changeDebounced = (0, _debounce3.default)(onChange, debounce);
            }
        }
    }, {
        key: 'getValue',
        value: function getValue() {
            return this.props.formatter(this.props.debounce ? this.state.value : this.props.value) || '';
        }
    }, {
        key: 'change',
        value: function change(value) {
            return this.props.onChange(this.props.parser(value));
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                debounce = _props.debounce,
                value = _props.value,
                parser = _props.parser,
                formatter = _props.formatter,
                onChange = _props.onChange,
                otherProps = _objectWithoutProperties(_props, ['className', 'debounce', 'value', 'parser', 'formatter', 'onChange']);

            return _react2.default.createElement('input', _extends({
                className: 'ui-input ' + className,
                value: this.getValue(),
                onChange: this.handleChange
            }, otherProps));
        }
    }]);

    return Input;
}(_react.PureComponent);

Input.propTypes = {
    className: _propTypes2.default.string,
    debounce: _propTypes2.default.number,
    // value is string by default, any other with parser/formatter
    value: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    parser: _propTypes2.default.func,
    formatter: _propTypes2.default.func,
    onChange: _propTypes2.default.func.isRequired
};
Input.defaultProps = {
    className: '',
    debounce: 0,
    parser: function parser(value) {
        return value;
    },
    formatter: function formatter(value) {
        return value;
    }
};
exports.default = Input;

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16),
    now = __webpack_require__(202),
    toNumber = __webpack_require__(40);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        timeWaiting = wait - timeSinceLastCall;

    return maxing
      ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke)
      : timeWaiting;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        clearTimeout(timerId);
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

module.exports = debounce;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(8);

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

module.exports = now;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(204);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersInput.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersInput.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.FiltersInput__root___16bED {\n  display: block; }\n\n.FiltersInput__input___GG4Af {\n  width: 100%; }\n  @media (max-width: 989.9px) {\n    .FiltersInput__input___GG4Af {\n      font: 16px/22px \"proxima-nova-a\", sans-serif; } }\n", ""]);

// exports
exports.locals = {
	"root": "FiltersInput__root___16bED",
	"input": "FiltersInput__input___GG4Af"
};

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FiltersNav = __webpack_require__(206);

var _FiltersNav2 = _interopRequireDefault(_FiltersNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FiltersNav2.default;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ALIGN_VERTICAL = exports.ALIGN_HORIZONTAL = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = FiltersNav;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RadioButton = __webpack_require__(207);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

var _FiltersNav = __webpack_require__(211);

var _FiltersNav2 = _interopRequireDefault(_FiltersNav);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ALIGN_HORIZONTAL = exports.ALIGN_HORIZONTAL = 'horizontal';
var ALIGN_VERTICAL = exports.ALIGN_VERTICAL = 'vertical';

function FiltersNav(_ref) {
    var className = _ref.className,
        name = _ref.name,
        options = _ref.options,
        value = _ref.value,
        onChange = _ref.onChange,
        align = _ref.align;

    var alignRoot = 'root_align_' + align;
    var alignOption = 'option_align_' + align;

    function handleChange(val) {
        onChange(val);
    }

    return _react2.default.createElement(
        'div',
        { className: _FiltersNav2.default.root + ' ' + _FiltersNav2.default[alignRoot] + ' ' + className },
        options.map(function (option) {
            return _react2.default.createElement(_RadioButton2.default, _extends({
                key: option.value,
                className: _FiltersNav2.default.option + ' ' + _FiltersNav2.default[alignOption],
                name: name,
                checked: option.value === value,
                onChange: handleChange // eslint-disable-line react/jsx-no-bind
            }, option));
        })
    );
}

FiltersNav.ALIGN_HORIZONTAL = ALIGN_HORIZONTAL;
FiltersNav.ALIGN_VERTICAL = ALIGN_VERTICAL;

FiltersNav.propTypes = {
    className: _propTypes2.default.string,
    name: _propTypes2.default.string.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: _propTypes2.default.any.isRequired // eslint-disable-line react/forbid-prop-types
    })).isRequired,
    value: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    align: _propTypes2.default.oneOf([ALIGN_VERTICAL, ALIGN_HORIZONTAL]),
    onChange: _propTypes2.default.func.isRequired
};

FiltersNav.defaultProps = {
    className: '',
    align: ALIGN_HORIZONTAL
};

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RadioButton = __webpack_require__(208);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RadioButton2.default;

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _RadioButton = __webpack_require__(209);

var _RadioButton2 = _interopRequireDefault(_RadioButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RadioButton = function (_PureComponent) {
    _inherits(RadioButton, _PureComponent);

    function RadioButton() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RadioButton);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RadioButton.__proto__ || Object.getPrototypeOf(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function () {
            return _this.props.onChange(_this.props.value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RadioButton, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                label = _props.label,
                name = _props.name,
                value = _props.value,
                checked = _props.checked;

            return (
                /* eslint-disable jsx-a11y/label-has-for */
                _react2.default.createElement(
                    'label',
                    {
                        className: 'ui-btn ' + (checked ? 'ui-btn_primary' : 'ui-btn_secondary') + ' ' + className
                    },
                    _react2.default.createElement('input', {
                        className: _RadioButton2.default.input,
                        type: 'radio',
                        name: name,
                        value: value,
                        checked: checked,
                        onChange: this.handleChange
                    }),
                    label
                )
                /* eslint-enable jsx-a11y/label-has-for */

            );
        }
    }]);

    return RadioButton;
}(_react.PureComponent);

RadioButton.propTypes = {
    className: _propTypes2.default.string,
    label: _propTypes2.default.string.isRequired,
    name: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.string.isRequired,
    checked: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired
};
RadioButton.defaultProps = {
    className: '',
    checked: false
};
exports.default = RadioButton;

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(210);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RadioButton.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RadioButton.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".RadioButton__input___3fikD {\n  display: none; }\n", ""]);

// exports
exports.locals = {
	"input": "RadioButton__input___3fikD"
};

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(212);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersNav.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersNav.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".FiltersNav__root___1JmaU {\n  display: flex;\n  flex-direction: column; }\n  @media (max-width: 479.9px) {\n    .FiltersNav__root_align_horizontal___Pi63c {\n      flex-direction: row;\n      flex-wrap: wrap; } }\n\n.FiltersNav__option___2Lcg4 {\n  margin: 8px 0 0 0; }\n  @media (max-width: 479.9px) {\n    .FiltersNav__option_align_horizontal___1bhQH {\n      margin-right: 2%;\n      width: 48%; } }\n", ""]);

// exports
exports.locals = {
	"root": "FiltersNav__root___1JmaU",
	"root_align_horizontal": "FiltersNav__root_align_horizontal___Pi63c",
	"option": "FiltersNav__option___2Lcg4",
	"option_align_horizontal": "FiltersNav__option_align_horizontal___1bhQH"
};

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FiltersReset = __webpack_require__(214);

var _FiltersReset2 = _interopRequireDefault(_FiltersReset);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FiltersReset2.default;

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FiltersReset;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FiltersReset(_ref) {
    var className = _ref.className,
        disabled = _ref.disabled,
        onClick = _ref.onClick;

    return _react2.default.createElement(
        'button',
        {
            className: (0, _classnames2.default)(className, 'ui-btn', 'ui-btn_secondary'),
            disabled: disabled,
            onClick: onClick
        },
        _react2.default.createElement(
            'span',
            null,
            'Reset'
        )
    );
}

FiltersReset.propTypes = {
    className: _propTypes2.default.string,
    disabled: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};

FiltersReset.defaultProps = {
    className: '',
    disabled: false,
    onClick: null
};

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FiltersSelect = __webpack_require__(216);

var _FiltersSelect2 = _interopRequireDefault(_FiltersSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FiltersSelect2.default;

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = FiltersSelect;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSelect = __webpack_require__(217);

var _rpReactSelect2 = _interopRequireDefault(_rpReactSelect);

var _FiltersSelect = __webpack_require__(218);

var _FiltersSelect2 = _interopRequireDefault(_FiltersSelect);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function FiltersSelect(_ref) {
    var className = _ref.className,
        label = _ref.label,
        onOpen = _ref.onOpen,
        otherProps = _objectWithoutProperties(_ref, ['className', 'label', 'onOpen']);

    /* eslint-disable jsx-a11y/label-has-for */
    return _react2.default.createElement(
        'label',
        { className: _FiltersSelect2.default.root + ' ' + className },
        _react2.default.createElement(
            'span',
            null,
            label
        ),
        _react2.default.createElement(_rpReactSelect2.default, _extends({
            title: label,
            onPopoverDidOpen: onOpen
        }, otherProps))
    );
    /* eslint-enable jsx-a11y/label-has-for */
}

FiltersSelect.propTypes = {
    className: _propTypes2.default.string,
    label: _propTypes2.default.string.isRequired,
    onOpen: _propTypes2.default.func
};

FiltersSelect.defaultProps = {
    className: '',
    onOpen: null
};

/***/ }),
/* 217 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_217__;

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(219);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersSelect.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersSelect.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".FiltersSelect__root___sFwHz {\n  display: block; }\n", ""]);

// exports
exports.locals = {
	"root": "FiltersSelect__root___sFwHz"
};

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FiltersToggle = __webpack_require__(221);

var _FiltersToggle2 = _interopRequireDefault(_FiltersToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _FiltersToggle2.default;

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = FiltersToggle;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _FiltersToggle = __webpack_require__(222);

var _FiltersToggle2 = _interopRequireDefault(_FiltersToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function FiltersToggle(_ref) {
    var className = _ref.className,
        open = _ref.open,
        onClick = _ref.onClick;

    return _react2.default.createElement(
        'div',
        { className: _FiltersToggle2.default.root + ' ' + className },
        _react2.default.createElement(
            'button',
            {
                className: _FiltersToggle2.default.button + ' ui-btn ui-btn_tiertiary',
                onClick: onClick
            },
            _react2.default.createElement(
                'span',
                null,
                open ? 'Close' : 'Refine Search'
            )
        )
    );
}

FiltersToggle.propTypes = {
    className: _propTypes2.default.string,
    open: _propTypes2.default.bool,
    onClick: _propTypes2.default.func
};

FiltersToggle.defaultProps = {
    className: '',
    open: false,
    onClick: null
};

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(223);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersToggle.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./FiltersToggle.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 223 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".FiltersToggle__root___LhWHb {\n  position: relative; }\n\n.FiltersToggle__button___h3_oH {\n  display: block;\n  margin: 0 auto; }\n  .FiltersToggle__button___h3_oH::before {\n    z-index: -1;\n    content: \"\";\n    position: absolute;\n    display: block;\n    width: 100%;\n    height: 1px;\n    top: 50%;\n    left: 0;\n    background-color: #F0EFF1; }\n\n.FiltersToggle__icon___gKTg5 {\n  fill: #D11F25;\n  height: 12px;\n  width: 12px;\n  margin-left: 8px; }\n", ""]);

// exports
exports.locals = {
	"root": "FiltersToggle__root___LhWHb",
	"button": "FiltersToggle__button___h3_oH",
	"icon": "FiltersToggle__icon___gKTg5"
};

/***/ }),
/* 224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DatePicker = __webpack_require__(225);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _DatePicker2.default;

/***/ }),
/* 225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__webpack_require__(226);

var _jquery = __webpack_require__(227);

var _jquery2 = _interopRequireDefault(_jquery);

var _dateFns = __webpack_require__(228);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _DatePicker = __webpack_require__(229);

var _DatePicker2 = _interopRequireDefault(_DatePicker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Represents date field with integrated datepicker jquery component
 */
var DatePicker = function (_PureComponent) {
    _inherits(DatePicker, _PureComponent);

    function DatePicker() {
        _classCallCheck(this, DatePicker);

        return _possibleConstructorReturn(this, (DatePicker.__proto__ || Object.getPrototypeOf(DatePicker)).apply(this, arguments));
    }

    _createClass(DatePicker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var _props = this.props,
                min = _props.min,
                max = _props.max,
                value = _props.value;

            (0, _jquery2.default)(this.buttonRef).datePicker({
                minDate: min,
                maxDate: max,
                date: value,
                autoClose: true,
                track: true
            }).on('change.rp.datePicker', function (ev, date) {
                return _this2.props.onChange((0, _dateFns.format)(date, _this2.props.valueFormat));
            });
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref) {
            var min = _ref.min,
                max = _ref.max;

            if (this.isValueChanged(min, this.props.min)) {
                (0, _jquery2.default)(this.buttonRef).datePicker('minDate', min);
            }
            if (this.isValueChanged(max, this.props.max)) {
                (0, _jquery2.default)(this.buttonRef).datePicker('maxDate', max);
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            (0, _jquery2.default)(this.buttonRef).datePicker('destroy');
        }
    }, {
        key: 'isValueChanged',
        value: function isValueChanged(next, current) {
            var fmt = this.props.valueFormat;
            return (0, _dateFns.format)(next, fmt) !== (0, _dateFns.format)(current, fmt);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var _props2 = this.props,
                className = _props2.className,
                label = _props2.label,
                placeholder = _props2.placeholder,
                displayFormat = _props2.displayFormat,
                value = _props2.value;

            return _react2.default.createElement(
                'div',
                { className: _DatePicker2.default.root + ' ' + className },
                _react2.default.createElement(
                    'div',
                    null,
                    label
                ),
                _react2.default.createElement(
                    'button',
                    {
                        ref: function ref(_ref2) {
                            _this3.buttonRef = _ref2;
                        },
                        className: _DatePicker2.default.button + ' ui-btn ui-btn_tiertiary',
                        type: 'button'
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _DatePicker2.default.date },
                        _react2.default.createElement(
                            'span',
                            null,
                            value ? (0, _dateFns.format)(value, displayFormat) : placeholder
                        ),
                        _react2.default.createElement(_rpReactSvgIcon2.default, {
                            size: 'Medium',
                            iconName: 'date'
                        })
                    )
                )
            );
        }
    }]);

    return DatePicker;
}(_react.PureComponent);

DatePicker.propTypes = {
    className: _propTypes2.default.string,
    label: _propTypes2.default.string.isRequired,
    placeholder: _propTypes2.default.string,
    displayFormat: _propTypes2.default.string,
    valueFormat: _propTypes2.default.string,
    value: _propTypes2.default.string,
    min: _propTypes2.default.string,
    max: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired
};
DatePicker.defaultProps = {
    className: '',
    placeholder: 'Select date',
    displayFormat: 'DD.MM.YYYY',
    valueFormat: 'YYYY-MM-DD',
    value: null,
    min: null,
    max: null
};
exports.default = DatePicker;

/***/ }),
/* 226 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_226__;

/***/ }),
/* 227 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_227__;

/***/ }),
/* 228 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_228__;

/***/ }),
/* 229 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(230);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./DatePicker.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./DatePicker.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 230 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".DatePicker__root___1ILA7 {\n  display: inline-block;\n  min-width: 120px; }\n\n.DatePicker__button___1vpKZ {\n  width: 100%; }\n\n.DatePicker__date___1q1ox {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  fill: #D11F25; }\n", ""]);

// exports
exports.locals = {
	"root": "DatePicker__root___1ILA7",
	"button": "DatePicker__button___1vpKZ",
	"date": "DatePicker__date___1q1ox"
};

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Checkbox = __webpack_require__(232);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Checkbox = function (_PureComponent) {
    _inherits(Checkbox, _PureComponent);

    function Checkbox() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Checkbox);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Checkbox.__proto__ || Object.getPrototypeOf(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (ev) {
            return _this.props.onChange(ev.target.checked);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Checkbox, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                disabled = _props.disabled,
                value = _props.value;
            /* eslint-disable jsx-a11y/label-has-for */

            return _react2.default.createElement(
                'label',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _Checkbox2.default.wrap },
                    _react2.default.createElement('input', {
                        className: _Checkbox2.default.input + ' ui-checkbox_input',
                        type: 'checkbox',
                        disabled: disabled,
                        checked: value || false,
                        onChange: this.handleChange
                    }),
                    _react2.default.createElement('div', { className: _Checkbox2.default.tick + ' ui-checkbox' }),
                    _react2.default.createElement(
                        'span',
                        { className: _Checkbox2.default.label },
                        label
                    )
                )
            );
            /* eslint-enable jsx-a11y/label-has-for */
        }
    }]);

    return Checkbox;
}(_react.PureComponent);

Checkbox.propTypes = {
    label: _propTypes2.default.string.isRequired,
    disabled: _propTypes2.default.bool,
    value: _propTypes2.default.bool,
    onChange: _propTypes2.default.func.isRequired
};
Checkbox.defaultProps = {
    value: false,
    disabled: false
};
exports.default = Checkbox;

/***/ }),
/* 232 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(233);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Checkbox.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Checkbox.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".Checkbox__input___1srz1 {\n  display: none; }\n  .Checkbox__input___1srz1:checked + .Checkbox__tick___Qg7gs:after {\n    left: 5px;\n    top: 1px;\n    width: 5px;\n    height: 10px; }\n\n.Checkbox__tick___Qg7gs {\n  display: inline-block;\n  width: 16px;\n  height: 16px; }\n\n.Checkbox__label___2e-fu {\n  margin: 0 0 0 8px; }\n", ""]);

// exports
exports.locals = {
	"input": "Checkbox__input___1srz1",
	"tick": "Checkbox__tick___Qg7gs",
	"label": "Checkbox__label___2e-fu"
};

/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchResultsFiltersSale = __webpack_require__(235);

var _SearchResultsFiltersSale2 = _interopRequireDefault(_SearchResultsFiltersSale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SearchResultsFiltersSale2.default;

/***/ }),
/* 235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Input = __webpack_require__(70);

var _Input2 = _interopRequireDefault(_Input);

var _SearchResultsFiltersSale = __webpack_require__(236);

var _SearchResultsFiltersSale2 = _interopRequireDefault(_SearchResultsFiltersSale);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchResultsFiltersSale = function (_PureComponent) {
    _inherits(SearchResultsFiltersSale, _PureComponent);

    function SearchResultsFiltersSale() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchResultsFiltersSale);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchResultsFiltersSale.__proto__ || Object.getPrototypeOf(SearchResultsFiltersSale)).call.apply(_ref, [this].concat(args))), _this), _this.handleButtonClick = function () {
            return _this.props.onChange('');
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchResultsFiltersSale, [{
        key: 'render',
        value: function render() {
            /* eslint-disable jsx-a11y/label-has-for */
            var _props = this.props,
                className = _props.className,
                value = _props.value,
                onChange = _props.onChange;

            return _react2.default.createElement(
                'label',
                { className: _SearchResultsFiltersSale2.default.root + ' ' + className },
                _react2.default.createElement(
                    'span',
                    null,
                    'Sale Name'
                ),
                _react2.default.createElement(
                    'div',
                    { className: _SearchResultsFiltersSale2.default.group },
                    _react2.default.createElement(_Input2.default, {
                        className: _SearchResultsFiltersSale2.default.input,
                        placeholder: 'All sales',
                        debounce: 300,
                        value: value,
                        onChange: onChange
                    }),
                    _react2.default.createElement(
                        'button',
                        {
                            className: _SearchResultsFiltersSale2.default.button + ' ui-btn ui-btn_secondary',
                            disabled: !value,
                            onClick: this.handleButtonClick
                        },
                        _react2.default.createElement(
                            'span',
                            {
                                className: _SearchResultsFiltersSale2.default.buttonLabel
                            },
                            'All Sales'
                        )
                    )
                )
            );
            /* eslint-enable jsx-a11y/label-has-for */
        }
    }]);

    return SearchResultsFiltersSale;
}(_react.PureComponent);

exports.default = SearchResultsFiltersSale;


SearchResultsFiltersSale.propTypes = {
    className: _propTypes2.default.string,
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired
};

SearchResultsFiltersSale.defaultProps = {
    className: '',
    value: ''
};

/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(237);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsFiltersSale.scss", function() {
			var newContent = require("!!../../../../../node_modules/css-loader/index.js??ref--2-1!../../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsFiltersSale.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SearchResultsFiltersSale__root___3cAEK {\n  width: 100%; }\n\n.SearchResultsFiltersSale__group___3lBoZ {\n  display: flex; }\n\n.SearchResultsFiltersSale__input___3bSEt {\n  flex-grow: 1;\n  border-right: none;\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFiltersSale__input___3bSEt {\n      width: 100%;\n      flex-basis: auto; } }\n  @media (max-width: 719.9px) {\n    .SearchResultsFiltersSale__input___3bSEt {\n      min-width: 0;\n      flex: 1 1; } }\n  @media (max-width: 989.9px) {\n    .SearchResultsFiltersSale__input___3bSEt {\n      font: 16px/22px \"proxima-nova-a\", sans-serif; } }\n\n.SearchResultsFiltersSale__button___3KuVm {\n  flex-grow: 0;\n  flex-shrink: 0;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  height: 36px; }\n  .SearchResultsFiltersSale__buttonLabel___2GLtL {\n    margin: 0; }\n", ""]);

// exports
exports.locals = {
	"root": "SearchResultsFiltersSale__root___3cAEK",
	"group": "SearchResultsFiltersSale__group___3lBoZ",
	"input": "SearchResultsFiltersSale__input___3bSEt",
	"button": "SearchResultsFiltersSale__button___3KuVm",
	"buttonLabel": "SearchResultsFiltersSale__buttonLabel___2GLtL"
};

/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(239);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsFilters.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsFilters.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 239 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SearchResultsFilters__top___7HEAg {\n  align-items: baseline;\n  justify-content: center; }\n  @media (min-width: 720px) {\n    .SearchResultsFilters__top___7HEAg {\n      text-align: center; } }\n\n.SearchResultsFilters__heading___nqmlz {\n  display: none; }\n  @media (min-width: 720px) {\n    .SearchResultsFilters__heading___nqmlz {\n      display: block; } }\n\n.SearchResultsFilters__description___3ghYo {\n  font: 12px/17px \"proxima-nova-a\", sans-serif; }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchResultsFilters__description___3ghYo {\n      margin-left: 190px;\n      width: 328px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchResultsFilters__description___3ghYo {\n      margin-left: 176px;\n      width: 306px; } }\n  @media (min-width: 1278px) {\n    .SearchResultsFilters__description___3ghYo {\n      margin-left: 224px;\n      width: 459px; } }\n\n.SearchResultsFilters__date___3UETw {\n  display: block;\n  margin-bottom: 8px; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__date___3UETw {\n      flex-basis: 48%;\n      margin-right: 2%; } }\n\n.SearchResultsFilters__center___3dnRy {\n  display: flex;\n  flex: 1;\n  flex-wrap: wrap; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__center___3dnRy {\n      flex: 100% 1 1; } }\n\n@media (max-width: 479.9px) {\n  .SearchResultsFilters__content___u_3lw {\n    order: 2;\n    padding-top: 8px;\n    flex-wrap: nowrap; } }\n\n.SearchResultsFilters__wrap___2AnDq {\n  flex-wrap: wrap; }\n\n.SearchResultsFilters__nav___2-Xa- {\n  flex-grow: 0;\n  flex-shrink: 0; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__nav___2-Xa- {\n      width: 84%;\n      order: 0; } }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchResultsFilters__nav___2-Xa- {\n      flex-basis: 120px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchResultsFilters__nav___2-Xa- {\n      flex-basis: 174px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchResultsFilters__nav___2-Xa- {\n      flex-basis: 160px; } }\n  @media (min-width: 1278px) {\n    .SearchResultsFilters__nav___2-Xa- {\n      flex-basis: 208px; } }\n\n.SearchResultsFilters__buttons___1SjGT {\n  display: flex;\n  flex: 100% 1 0;\n  margin-top: 24px;\n  justify-content: center; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__buttons___1SjGT {\n      margin-bottom: 16px;\n      order: 1;\n      justify-content: flex-start; } }\n\n.SearchResultsFilters__reset___3jwrG {\n  margin-right: 8px; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__reset___3jwrG {\n      width: calc(50% - 16px); } }\n  @media (min-width: 480px) {\n    .SearchResultsFilters__reset___3jwrG {\n      width: 200px; } }\n  @media (min-width: 1278px) {\n    .SearchResultsFilters__reset___3jwrG {\n      margin-right: 16px; } }\n\n@media (max-width: 479.9px) {\n  .SearchResultsFilters__search___2lLxO {\n    width: calc(50% - 16px); } }\n\n@media (min-width: 480px) {\n  .SearchResultsFilters__search___2lLxO {\n    width: 200px; } }\n\n.SearchResultsFilters__filter___3dLWx {\n  width: 100%; }\n  .SearchResultsFilters__filter___3dLWx:nth-child(n+2) {\n    margin-top: 8px; }\n\n.SearchResultsFilters__form___38Q5S {\n  flex: 1 0;\n  margin: 0 0 0 8px;\n  padding: 0 0 0 8px;\n  border-left: 1px solid #171717; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__form___38Q5S {\n      flex: 0 1 66.66667%;\n      border-left: 0;\n      margin: 0; } }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchResultsFilters__form___38Q5S {\n      flex: 0;\n      flex-basis: 233px;\n      width: 233px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchResultsFilters__form___38Q5S {\n      flex: 0;\n      flex-basis: 337px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchResultsFilters__form___38Q5S {\n      flex: 0;\n      flex-basis: 313px; } }\n  @media (min-width: 1278px) {\n    .SearchResultsFilters__form___38Q5S {\n      flex: 0;\n      flex-basis: 465px; } }\n\n.SearchResultsFilters__lots___1Wffi {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 0 8px;\n  padding: 0 0 0 8px;\n  border-left: 1px solid #171717; }\n  @media (min-width: 990px) {\n    .SearchResultsFilters__lots___1Wffi {\n      margin: 0 0 0 32px; } }\n  .SearchResultsFilters__lotsInfo___UvPe1 {\n    flex-grow: 1;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center; }\n  .SearchResultsFilters__lotsNum___3puEU {\n    margin-top: 16px;\n    font-size: 38px;\n    font-weight: bold; }\n  .SearchResultsFilters__lotsFilter___2_M1a {\n    flex-grow: 0;\n    flex-shrink: 0; }\n\n.SearchResultsFilters__bottom___2u52I {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 24px; }\n\n.SearchResultsFilters__status___3j5dX {\n  font-size: 20px; }\n  .SearchResultsFilters__statusLotsNum___3uvov {\n    display: inline-block;\n    vertical-align: middle;\n    margin-left: 8px;\n    padding: 1px 4px;\n    background: #2CB34A;\n    border-radius: 4px;\n    color: #FFFFFF;\n    font: 12px/17px \"proxima-nova-a-bold\", sans-serif; }\n\n.SearchResultsFilters__priceRange___2GNke {\n  display: flex; }\n  .SearchResultsFilters__priceRangeMax___2f0SO {\n    margin-left: 8px; }\n\n.SearchResultsFilters__history___BJUwB {\n  margin-top: 16px;\n  font: 16px/22px \"proxima-nova-a-bold\", sans-serif;\n  overflow-wrap: break-word; }\n\n.SearchResultsFilters__datepicker___1v__C {\n  padding: 8px 0; }\n  @media (max-width: 479.9px) {\n    .SearchResultsFilters__datepicker___1v__C {\n      display: flex; } }\n\n.SearchResultsFilters__toggle___1zA_i {\n  margin-bottom: 16px; }\n", ""]);

// exports
exports.locals = {
	"top": "SearchResultsFilters__top___7HEAg",
	"heading": "SearchResultsFilters__heading___nqmlz",
	"description": "SearchResultsFilters__description___3ghYo",
	"date": "SearchResultsFilters__date___3UETw",
	"center": "SearchResultsFilters__center___3dnRy",
	"content": "SearchResultsFilters__content___u_3lw",
	"wrap": "SearchResultsFilters__wrap___2AnDq",
	"nav": "SearchResultsFilters__nav___2-Xa-",
	"buttons": "SearchResultsFilters__buttons___1SjGT",
	"reset": "SearchResultsFilters__reset___3jwrG",
	"search": "SearchResultsFilters__search___2lLxO",
	"filter": "SearchResultsFilters__filter___3dLWx",
	"form": "SearchResultsFilters__form___38Q5S",
	"lots": "SearchResultsFilters__lots___1Wffi",
	"lotsInfo": "SearchResultsFilters__lotsInfo___UvPe1",
	"lotsNum": "SearchResultsFilters__lotsNum___3puEU",
	"lotsFilter": "SearchResultsFilters__lotsFilter___2_M1a",
	"bottom": "SearchResultsFilters__bottom___2u52I",
	"status": "SearchResultsFilters__status___3j5dX",
	"statusLotsNum": "SearchResultsFilters__statusLotsNum___3uvov",
	"priceRange": "SearchResultsFilters__priceRange___2GNke",
	"priceRangeMax": "SearchResultsFilters__priceRangeMax___2f0SO",
	"history": "SearchResultsFilters__history___BJUwB",
	"datepicker": "SearchResultsFilters__datepicker___1v__C",
	"toggle": "SearchResultsFilters__toggle___1zA_i"
};

/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpMqBreakpoints = __webpack_require__(24);

var _Table = __webpack_require__(18);

var _Table2 = _interopRequireDefault(_Table);

var _Cell = __webpack_require__(13);

var _RelativesRow = __webpack_require__(83);

var _RelativesRow2 = _interopRequireDefault(_RelativesRow);

var _SearchResultsTable = __webpack_require__(373);

var _SearchResultsTable2 = _interopRequireDefault(_SearchResultsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
    MEDIUM = _rpMqBreakpoints.breakpointCodes.MEDIUM,
    WIDE = _rpMqBreakpoints.breakpointCodes.WIDE,
    EXTRA_WIDE = _rpMqBreakpoints.breakpointCodes.EXTRA_WIDE;

var SearchResultsTable = function (_PureComponent) {
    _inherits(SearchResultsTable, _PureComponent);

    function SearchResultsTable() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchResultsTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchResultsTable.__proto__ || Object.getPrototypeOf(SearchResultsTable)).call.apply(_ref, [this].concat(args))), _this), _this.row = { children: _RelativesRow2.default }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchResultsTable, [{
        key: 'getColumns',
        value: function getColumns() {
            var breakpointCode = this.props.breakpointCode;

            var exNarrow = breakpointCode === EXTRA_NARROW;
            var fromMedium = [MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            var exWide = breakpointCode === EXTRA_WIDE;
            return [{
                className: _SearchResultsTable2.default.toggle,
                name: '_toggle',
                head: '',
                cell: { children: _Table.TableToggle }
            }, {
                className: _SearchResultsTable2.default.lot,
                name: 'lot_no',
                head: 'Lot',
                cell: { children: _Cell.CellLot }
            }, fromMedium ? {
                className: _SearchResultsTable2.default.horse,
                name: 'horse_style_name',
                head: {
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            'Horse name'
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Sire'
                        )
                    )
                },
                cell: { children: _Cell.CellHorseSireUGC }
            } : {
                className: _SearchResultsTable2.default.horse,
                name: 'horse_style_name',
                head: 'Horse name',
                cell: { children: _Cell.CellHorseUGC }
            }, exWide && {
                className: _SearchResultsTable2.default.color,
                name: 'horse_first_colour_code',
                head: 'Col'
            }, fromMedium && {
                className: _SearchResultsTable2.default.sex,
                name: 'horse_sex',
                head: 'Sex'
            }, exWide && {
                className: _SearchResultsTable2.default.age,
                name: 'horse_age',
                head: 'Age'
            }, fromMedium && {
                className: _SearchResultsTable2.default.dam,
                name: 'dam_style_name',
                head: {
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            'Dam'
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Dam\'s Sire'
                        )
                    )
                },
                cell: { children: _Cell.CellDamDamsSire }
            }, fromMedium && {
                className: _SearchResultsTable2.default.vendor,
                name: 'seller_name',
                head: 'Vendor'
            }, {
                className: _SearchResultsTable2.default.price,
                name: 'price',
                head: 'Price',
                cell: { children: _Cell.CellPrice }
            }, !exNarrow && {
                className: _SearchResultsTable2.default.buyer,
                name: 'buyer_detail',
                head: 'Buyer'
            }, fromMedium && {
                className: _SearchResultsTable2.default.date,
                name: 'sale_date',
                head: 'Date'
            }, fromMedium && {
                className: _SearchResultsTable2.default.sale,
                name: 'sale_name',
                head: 'Sale'
            }].filter(function (item) {
                return !!item;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                data = _props.data,
                loading = _props.loading,
                expansion = _props.expansion,
                sorting = _props.sorting,
                onToggle = _props.onToggle,
                onSort = _props.onSort,
                errorMessage = _props.errorMessage,
                canSortByColumn = _props.canSortByColumn;

            return _react2.default.createElement(_Table2.default, {
                type: 1,
                columns: this.getColumns(),
                row: this.row,
                identity: SearchResultsTable.identity,
                data: data,
                loading: loading,
                expansion: expansion,
                sorting: sorting,
                onToggle: onToggle,
                onSort: onSort,
                placeholder: errorMessage,
                className: _SearchResultsTable2.default.root,
                canSortByColumn: canSortByColumn
            });
        }
    }], [{
        key: 'identity',
        value: function identity(data) {
            return [data.venue_uid, data.sale_date_raw, data.lot_no, data.lot_letter].join('|');
        }
    }]);

    return SearchResultsTable;
}(_react.PureComponent);

SearchResultsTable.propTypes = {
    breakpointCode: _propTypes2.default.string.isRequired,
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        venue_uid: _propTypes2.default.number.isRequired,
        sale_date_raw: _propTypes2.default.string.isRequired,
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string.isRequired
    })).isRequired,
    loading: _propTypes2.default.bool,
    expansion: _propTypes2.default.string,
    sorting: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    onToggle: _propTypes2.default.func.isRequired,
    onSort: _propTypes2.default.func.isRequired,
    errorMessage: _propTypes2.default.string.isRequired,
    canSortByColumn: _propTypes2.default.func.isRequired
};
SearchResultsTable.defaultProps = {
    loading: false,
    expansion: null,
    sorting: null
};
exports.default = SearchResultsTable;

/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = __webpack_require__(242);

var _get2 = _interopRequireDefault(_get);

var _isArray = __webpack_require__(9);

var _isArray2 = _interopRequireDefault(_isArray);

var _isNil = __webpack_require__(250);

var _isNil2 = _interopRequireDefault(_isNil);

var _isFunction = __webpack_require__(15);

var _isFunction2 = _interopRequireDefault(_isFunction);

var _isPlainObject = __webpack_require__(41);

var _isPlainObject2 = _interopRequireDefault(_isPlainObject);

var _isString = __webpack_require__(251);

var _isString2 = _interopRequireDefault(_isString);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _TableHead = __webpack_require__(72);

var _TableHead2 = _interopRequireDefault(_TableHead);

var _TableHeadRow = __webpack_require__(252);

var _TableHeadRow2 = _interopRequireDefault(_TableHeadRow);

var _TableHeadCell = __webpack_require__(73);

var _TableHeadCell2 = _interopRequireDefault(_TableHeadCell);

var _TableBody = __webpack_require__(75);

var _TableBody2 = _interopRequireDefault(_TableBody);

var _TableBodySpinner = __webpack_require__(255);

var _TableBodySpinner2 = _interopRequireDefault(_TableBodySpinner);

var _TableBodyPlaceholder = __webpack_require__(258);

var _TableBodyPlaceholder2 = _interopRequireDefault(_TableBodyPlaceholder);

var _TableRowConstructor = __webpack_require__(76);

var _TableRowConstructor2 = _interopRequireDefault(_TableRowConstructor);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TYPE_1 = 1;
var TYPE_2 = 2;
var TYPE_3 = 3;
var TYPE_4 = 4;
var TYPE_5 = 5;

var Table = function (_Component) {
    _inherits(Table, _Component);

    function Table() {
        _classCallCheck(this, Table);

        return _possibleConstructorReturn(this, (Table.__proto__ || Object.getPrototypeOf(Table)).apply(this, arguments));
    }

    _createClass(Table, [{
        key: 'identify',
        value: function identify(data, i) {
            var identity = this.props.identity;


            if (!identity) return i;

            if ((0, _isString2.default)(identity) || (0, _isArray2.default)(identity)) {
                return (0, _get2.default)(data, identity);
            }

            if ((0, _isFunction2.default)(identity)) {
                return identity(data);
            }

            throw new Error('Table has invalid identity ' + identity);
        }
    }, {
        key: 'render',
        value: function render() {
            var _classnames,
                _this2 = this;

            var _props = this.props,
                className = _props.className,
                type = _props.type,
                head = _props.head,
                row = _props.row,
                columns = _props.columns,
                data = _props.data,
                loading = _props.loading,
                sorting = _props.sorting,
                expansion = _props.expansion,
                placeholder = _props.placeholder,
                canSortByColumn = _props.canSortByColumn,
                onSort = _props.onSort,
                onToggle = _props.onToggle;

            return _react2.default.createElement(
                'table',
                {
                    className: (0, _classnames3.default)('ui-table', (_classnames = {}, _defineProperty(_classnames, 'ui-table_type' + type, !!type), _defineProperty(_classnames, 'ui-table_sortable', !!sorting), _defineProperty(_classnames, className, !!className), _classnames))
                },

                /**
                    Table Head
                */
                function () {
                    if (head) return head;

                    return _react2.default.createElement(
                        _TableHead2.default,
                        null,
                        _react2.default.createElement(
                            _TableHeadRow2.default,
                            null,
                            columns.map(function (column) {
                                if (_react2.default.isValidElement(column.head)) return column.head;

                                if ((0, _isString2.default)(column.head)) {
                                    return _react2.default.createElement(
                                        _TableHeadCell2.default,
                                        {
                                            key: column.name,
                                            className: column.className,
                                            type: type,
                                            sorting: sorting[column.name],
                                            sortable: canSortByColumn(column.name),
                                            onClick: function onClick() {
                                                return onSort(column.name);
                                            }
                                        },
                                        column.head
                                    );
                                }

                                if ((0, _isPlainObject2.default)(column.head)) {
                                    return _react2.default.createElement(_TableHeadCell2.default, _extends({
                                        key: column.name,
                                        className: column.className,
                                        type: type,
                                        sorting: sorting[column.name],
                                        sortable: canSortByColumn(column.name),
                                        onClick: function onClick() {
                                            return onSort(column.name);
                                        }
                                    }, column.head));
                                }

                                throw new Error('Column ' + column.name + ' has invalid head ' + column.cell);
                            })
                        )
                    );
                }(),

                /**
                    Table Body
                 */
                _react2.default.createElement(
                    _TableBody2.default,
                    { rootRef: function rootRef(ref) {
                            _this2.tableBodyRef = ref;
                        } },
                    function () {
                        if (loading) {
                            var _ref = _this2.tableBodyRef ? _this2.tableBodyRef.getBoundingClientRect() : {},
                                height = _ref.height,
                                top = _ref.top,
                                bottom = _ref.bottom;

                            return _react2.default.createElement(_TableBodySpinner2.default, {
                                colSpan: columns.length,
                                height: height,
                                top: top,
                                bottom: bottom
                            });
                        }

                        if (!data.length) {
                            return _react2.default.createElement(
                                _TableBodyPlaceholder2.default,
                                { colSpan: columns.length },
                                placeholder
                            );
                        }

                        var Row = (0, _isFunction2.default)(row) ? row : _TableRowConstructor2.default;
                        return data.map(function (item, i) {
                            var identity = _this2.identify(item, i);
                            var expanded = !(0, _isNil2.default)(expansion) && [].concat(expansion).includes(identity);
                            return _react2.default.createElement(Row, _extends({
                                key: identity,
                                type: type,
                                columns: columns,
                                data: item,
                                identity: identity,
                                expanded: expanded,
                                onToggle: onToggle
                            }, (0, _isPlainObject2.default)(row) ? row : null));
                        });
                    }()
                )
            );
        }
    }]);

    return Table;
}(_react.Component);

Table.TYPE_1 = TYPE_1;
Table.TYPE_2 = TYPE_2;
Table.TYPE_3 = TYPE_3;
Table.TYPE_4 = TYPE_4;
Table.TYPE_5 = TYPE_5;
exports.default = Table;


Table.propTypes = {
    className: _propTypes2.default.string,
    type: _propTypes2.default.oneOf([TYPE_1, TYPE_2, TYPE_3, TYPE_4, TYPE_5]).isRequired,
    head: _propTypes2.default.node,
    row: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.object] // eslint-disable-next-line react/forbid-prop-types
    ),
    columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        className: _propTypes2.default.string,
        name: _propTypes2.default.string.isRequired,
        head: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object, // eslint-disable-next-line react/forbid-prop-types
        _propTypes2.default.node]),
        cell: _propTypes2.default.oneOfType([_propTypes2.default.object, // eslint-disable-next-line react/forbid-prop-types
        _propTypes2.default.node, _propTypes2.default.func])
    })).isRequired,
    identity: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.func]),
    // eslint-disable-next-line react/forbid-prop-types
    data: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
    loading: _propTypes2.default.bool,
    sorting: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    expansion: _propTypes2.default.any, // eslint-disable-line react/forbid-prop-types
    placeholder: _propTypes2.default.string,
    onSort: _propTypes2.default.func,
    onToggle: _propTypes2.default.func,
    canSortByColumn: _propTypes2.default.func.isRequired
};

Table.defaultProps = {
    className: '',
    head: null,
    row: null,
    identity: null,
    loading: false,
    sorting: {},
    expansion: null,
    placeholder: 'No data found',
    onSort: function onSort() {
        return null;
    },
    onToggle: function onToggle() {
        return null;
    }
};

/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(243);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(244),
    toKey = __webpack_require__(249);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(9),
    isKey = __webpack_require__(245),
    stringToPath = __webpack_require__(246),
    toString = __webpack_require__(26);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(9),
    isSymbol = __webpack_require__(25);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(247);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(248);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(35);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(25);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 250 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is `null` or `undefined`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
 * @example
 *
 * _.isNil(null);
 * // => true
 *
 * _.isNil(void 0);
 * // => true
 *
 * _.isNil(NaN);
 * // => false
 */
function isNil(value) {
  return value == null;
}

module.exports = isNil;


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(11),
    isArray = __webpack_require__(9),
    isObjectLike = __webpack_require__(12);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableHead;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableHead(props) {
    return _react2.default.createElement('tr', props);
}

/***/ }),
/* 253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableHeadSortIcon;

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _TableHead = __webpack_require__(74);

var _TableHead2 = _interopRequireDefault(_TableHead);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DIRECTION_ASC = 'asc';
var DIRECTION_DESC = 'desc';

function TableHeadSortIcon(_ref) {
    var className = _ref.className,
        direction = _ref.direction;

    if (!direction) {
        return null;
    }

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames3.default)(_TableHead2.default.sortIcon, _defineProperty({}, _TableHead2.default.sortIcon_desc, direction === 'desc'), className)
        },
        _react2.default.createElement(_rpReactSvgIcon2.default, { className: _TableHead2.default.sortIcon__down, size: 'small', iconName: 'down' }),
        _react2.default.createElement(_rpReactSvgIcon2.default, { className: _TableHead2.default.sortIcon__minus, size: 'small', iconName: 'minus' })
    );
}

TableHeadSortIcon.DIRECTION_ASC = DIRECTION_ASC;
TableHeadSortIcon.DIRECTION_DESC = DIRECTION_DESC;

TableHeadSortIcon.propTypes = {
    className: _propTypes2.default.string,
    direction: _propTypes2.default.oneOf(['asc', 'desc'])
};

TableHeadSortIcon.defaultProps = {
    className: '',
    direction: null
};

/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".TableHead__cell__sortIcon___N8HKh {\n  margin-left: 4px; }\n\n.TableHead__cell_unsortable___o_c0c {\n  cursor: default !important; }\n\n.TableHead__sortIcon___NhMiP {\n  display: inline-block;\n  position: relative;\n  width: 8px; }\n  .TableHead__sortIcon__down___1Pusa {\n    position: absolute;\n    left: 0;\n    bottom: -2px;\n    width: 8px;\n    height: 8px; }\n  .TableHead__sortIcon__minus___2HftZ {\n    position: absolute;\n    left: 0;\n    bottom: 1px;\n    width: 8px;\n    height: 8px;\n    transform: rotate(90deg); }\n  .TableHead__sortIcon_desc___3J5ER {\n    transform: rotate(180deg) translate(-8px, 8px); }\n", ""]);

// exports
exports.locals = {
	"cell__sortIcon": "TableHead__cell__sortIcon___N8HKh",
	"cell_unsortable": "TableHead__cell_unsortable___o_c0c",
	"sortIcon": "TableHead__sortIcon___NhMiP",
	"sortIcon__down": "TableHead__sortIcon__down___1Pusa",
	"sortIcon__minus": "TableHead__sortIcon__minus___2HftZ",
	"sortIcon_desc": "TableHead__sortIcon_desc___3J5ER"
};

/***/ }),
/* 255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableBodySpinner;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _TableRow = __webpack_require__(27);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableCell = __webpack_require__(28);

var _TableCell2 = _interopRequireDefault(_TableCell);

var _TableBody = __webpack_require__(256);

var _TableBody2 = _interopRequireDefault(_TableBody);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ICON_HEIGHT = 40;

function TableBodySpinner(_ref) {
    var colSpan = _ref.colSpan,
        height = _ref.height,
        top = _ref.top,
        bottom = _ref.bottom;

    var viewHeight = window.innerHeight;
    var center = function () {
        // We see the table bottom
        if (top < 0 && bottom > 0 && bottom < viewHeight) {
            return Math.abs(top) + bottom / 2;
        }

        // We see the table body between top and bottom
        if (top < 0 && bottom >= viewHeight) {
            return Math.abs(top) + viewHeight / 2;
        }

        // We see the table top
        if (top >= 0 && bottom > viewHeight) {
            return (viewHeight - top) / 2;
        }

        // We see the whole table or we don't see it at all
        return height / 2;
    }();
    var paddingTop = Math.floor(center - ICON_HEIGHT / 2);
    return _react2.default.createElement(
        _TableRow2.default,
        null,
        _react2.default.createElement(
            _TableCell2.default,
            {
                className: _TableBody2.default.spinner__cell,
                colSpan: colSpan,
                style: {
                    paddingTop: paddingTop,
                    height: height
                }
            },
            _react2.default.createElement(_rpReactSvgIcon2.default, {
                className: _TableBody2.default.spinner__icon,
                size: '2XL',
                iconName: 'spinner'
            })
        )
    );
}

TableBodySpinner.propTypes = {
    colSpan: _propTypes2.default.number.isRequired,
    // table height
    height: _propTypes2.default.number,
    // space between top of current view and top of table
    top: _propTypes2.default.number,
    // space between top of current view and bottom of table
    bottom: _propTypes2.default.number
};

TableBodySpinner.defaultProps = {
    height: 72,
    top: 0,
    bottom: 0
};

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(257);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableBody.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableBody.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".TableBody__spinner__cell___2Tw_- {\n  padding: 0;\n  box-sizing: border-box;\n  vertical-align: top; }\n\n.TableBody__spinner__icon___368CM {\n  display: block;\n  margin: 0 auto;\n  -webkit-animation-name: TableBody__spinner___3krV0;\n  animation-name: TableBody__spinner___3krV0;\n  -webkit-animation-duration: .8s;\n  animation-duration: .8s;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  background-size: cover; }\n", ""]);

// exports
exports.locals = {
	"spinner__cell": "TableBody__spinner__cell___2Tw_-",
	"spinner__icon": "TableBody__spinner__icon___368CM",
	"spinner": "TableBody__spinner___3krV0"
};

/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableBodyPlaceholder;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _TableRow = __webpack_require__(27);

var _TableRow2 = _interopRequireDefault(_TableRow);

var _TableCell = __webpack_require__(28);

var _TableCell2 = _interopRequireDefault(_TableCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableBodyPlaceholder(_ref) {
    var children = _ref.children,
        colSpan = _ref.colSpan;

    return _react2.default.createElement(
        _TableRow2.default,
        null,
        _react2.default.createElement(
            _TableCell2.default,
            {
                className: 'ui-table__cell_errorMessage',
                colSpan: colSpan
            },
            _react2.default.createElement(
                'div',
                { className: 'ui-errorMessage' },
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__icon' },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'XL', iconName: 'results' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__text' },
                    children
                )
            )
        )
    );
}

TableBodyPlaceholder.propTypes = {
    children: _propTypes2.default.node.isRequired,
    colSpan: _propTypes2.default.number.isRequired
};

/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(260);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableRowConstructor.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableRowConstructor.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".TableRowConstructor__expansion__cell___R9jOw {\n  border-bottom: 1px solid #F0EFF1; }\n\n.TableRowConstructor__expansion__table___2EbfQ {\n  width: 100%;\n  margin: 0;\n  padding: 0; }\n", ""]);

// exports
exports.locals = {
	"expansion__cell": "TableRowConstructor__expansion__cell___R9jOw",
	"expansion__table": "TableRowConstructor__expansion__table___2EbfQ"
};

/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = TableToggle;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _TableToggle = __webpack_require__(262);

var _TableToggle2 = _interopRequireDefault(_TableToggle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function TableToggle(_ref) {
    var identity = _ref.identity,
        expanded = _ref.expanded,
        onToggle = _ref.onToggle;

    return _react2.default.createElement(
        'button',
        {
            className: '' + _TableToggle2.default.root,
            onClick: function onClick() {
                return onToggle(identity);
            }
        },
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            className: 'tableShowIcon ' + _TableToggle2.default.icon,
            size: 'Medium',
            iconName: expanded ? 'up' : 'down'
        })
    );
}

TableToggle.propTypes = {
    identity: _propTypes2.default.any.isRequired, // eslint-disable-line react/forbid-prop-types
    expanded: _propTypes2.default.bool.isRequired,
    onToggle: _propTypes2.default.func.isRequired
};

/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(263);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableToggle.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./TableToggle.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".TableToggle__root___EosCd {\n  padding: 0;\n  background: none;\n  border: none;\n  outline: none;\n  cursor: pointer; }\n\n.TableToggle__icon___3LCff {\n  vertical-align: middle;\n  fill: #D11F25; }\n", ""]);

// exports
exports.locals = {
	"root": "TableToggle__root___EosCd",
	"icon": "TableToggle__icon___3LCff"
};

/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellLot;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellLot(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'span',
        null,
        data.lot_no,
        data.lot_letter
    );
}

CellLot.propTypes = {
    data: _propTypes2.default.shape({
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TYPE_HORSE = undefined;
exports.default = ProfileLink;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _url = __webpack_require__(30);

var _ProfileLink = __webpack_require__(268);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPE_HORSE = exports.TYPE_HORSE = 'horse';

function ProfileLink(_ref) {
    var className = _ref.className,
        children = _ref.children,
        type = _ref.type,
        uid = _ref.uid,
        name = _ref.name,
        bold = _ref.bold;

    if (!uid || !name) {
        if (!children) {
            return null;
        }
        return _react2.default.createElement(
            'span',
            {
                className: (0, _classnames2.default)(_ProfileLink2.default.root, className)
            },
            children
        );
    }
    return _react2.default.createElement(
        'a',
        {
            className: (0, _classnames2.default)('js-popupLink ui-link ui-link_table', _ProfileLink2.default.root, _ProfileLink2.default.root_link, bold && _ProfileLink2.default.root_bold, className),
            href: (0, _url.profileUrl)(type, uid, name)
        },
        children,
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            className: _ProfileLink2.default.icon,
            iconName: 'right'
        })
    );
}

ProfileLink.TYPE_HORSE = TYPE_HORSE;

ProfileLink.propTypes = {
    className: _propTypes2.default.string,
    children: _propTypes2.default.node,
    type: _propTypes2.default.oneOf([TYPE_HORSE]).isRequired,
    uid: _propTypes2.default.number,
    name: _propTypes2.default.string,
    bold: _propTypes2.default.bool
};

ProfileLink.defaultProps = {
    className: '',
    children: null,
    uid: null,
    name: null,
    bold: false
};

/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * Copyright Joyent, Inc. and other Node contributors.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a
 * copy of this software and associated documentation files (the
 * "Software"), to deal in the Software without restriction, including
 * without limitation the rights to use, copy, modify, merge, publish,
 * distribute, sublicense, and/or sell copies of the Software, and to permit
 * persons to whom the Software is furnished to do so, subject to the
 * following conditions:
 *
 * The above copyright notice and this permission notice shall be included
 * in all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
 * OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
 * NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
 * DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
 * OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
 * USE OR OTHER DEALINGS IN THE SOFTWARE.
 */



var punycode = __webpack_require__(267);

function Url() {
  this.protocol = null;
  this.slashes = null;
  this.auth = null;
  this.host = null;
  this.port = null;
  this.hostname = null;
  this.hash = null;
  this.search = null;
  this.query = null;
  this.pathname = null;
  this.path = null;
  this.href = null;
}

// Reference: RFC 3986, RFC 1808, RFC 2396

/*
 * define these here so at least they only have to be
 * compiled once on the first module load.
 */
var protocolPattern = /^([a-z0-9.+-]+:)/i,
  portPattern = /:[0-9]*$/,

  // Special case for a simple path URL
  simplePathPattern = /^(\/\/?(?!\/)[^?\s]*)(\?[^\s]*)?$/,

  /*
   * RFC 2396: characters reserved for delimiting URLs.
   * We actually just auto-escape these.
   */
  delims = [
    '<', '>', '"', '`', ' ', '\r', '\n', '\t'
  ],

  // RFC 2396: characters not allowed for various reasons.
  unwise = [
    '{', '}', '|', '\\', '^', '`'
  ].concat(delims),

  // Allowed by RFCs, but cause of XSS attacks.  Always escape these.
  autoEscape = ['\''].concat(unwise),
  /*
   * Characters that are never ever allowed in a hostname.
   * Note that any invalid chars are also handled, but these
   * are the ones that are *expected* to be seen, so we fast-path
   * them.
   */
  nonHostChars = [
    '%', '/', '?', ';', '#'
  ].concat(autoEscape),
  hostEndingChars = [
    '/', '?', '#'
  ],
  hostnameMaxLen = 255,
  hostnamePartPattern = /^[+a-z0-9A-Z_-]{0,63}$/,
  hostnamePartStart = /^([+a-z0-9A-Z_-]{0,63})(.*)$/,
  // protocols that can allow "unsafe" and "unwise" chars.
  unsafeProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that never have a hostname.
  hostlessProtocol = {
    javascript: true,
    'javascript:': true
  },
  // protocols that always contain a // bit.
  slashedProtocol = {
    http: true,
    https: true,
    ftp: true,
    gopher: true,
    file: true,
    'http:': true,
    'https:': true,
    'ftp:': true,
    'gopher:': true,
    'file:': true
  },
  querystring = __webpack_require__(17);

function urlParse(url, parseQueryString, slashesDenoteHost) {
  if (url && typeof url === 'object' && url instanceof Url) { return url; }

  var u = new Url();
  u.parse(url, parseQueryString, slashesDenoteHost);
  return u;
}

Url.prototype.parse = function (url, parseQueryString, slashesDenoteHost) {
  if (typeof url !== 'string') {
    throw new TypeError("Parameter 'url' must be a string, not " + typeof url);
  }

  /*
   * Copy chrome, IE, opera backslash-handling behavior.
   * Back slashes before the query string get converted to forward slashes
   * See: https://code.google.com/p/chromium/issues/detail?id=25916
   */
  var queryIndex = url.indexOf('?'),
    splitter = queryIndex !== -1 && queryIndex < url.indexOf('#') ? '?' : '#',
    uSplit = url.split(splitter),
    slashRegex = /\\/g;
  uSplit[0] = uSplit[0].replace(slashRegex, '/');
  url = uSplit.join(splitter);

  var rest = url;

  /*
   * trim before proceeding.
   * This is to support parse stuff like "  http://foo.com  \n"
   */
  rest = rest.trim();

  if (!slashesDenoteHost && url.split('#').length === 1) {
    // Try fast path regexp
    var simplePath = simplePathPattern.exec(rest);
    if (simplePath) {
      this.path = rest;
      this.href = rest;
      this.pathname = simplePath[1];
      if (simplePath[2]) {
        this.search = simplePath[2];
        if (parseQueryString) {
          this.query = querystring.parse(this.search.substr(1));
        } else {
          this.query = this.search.substr(1);
        }
      } else if (parseQueryString) {
        this.search = '';
        this.query = {};
      }
      return this;
    }
  }

  var proto = protocolPattern.exec(rest);
  if (proto) {
    proto = proto[0];
    var lowerProto = proto.toLowerCase();
    this.protocol = lowerProto;
    rest = rest.substr(proto.length);
  }

  /*
   * figure out if it's got a host
   * user@server is *always* interpreted as a hostname, and url
   * resolution will treat //foo/bar as host=foo,path=bar because that's
   * how the browser resolves relative URLs.
   */
  if (slashesDenoteHost || proto || rest.match(/^\/\/[^@/]+@[^@/]+/)) {
    var slashes = rest.substr(0, 2) === '//';
    if (slashes && !(proto && hostlessProtocol[proto])) {
      rest = rest.substr(2);
      this.slashes = true;
    }
  }

  if (!hostlessProtocol[proto] && (slashes || (proto && !slashedProtocol[proto]))) {

    /*
     * there's a hostname.
     * the first instance of /, ?, ;, or # ends the host.
     *
     * If there is an @ in the hostname, then non-host chars *are* allowed
     * to the left of the last @ sign, unless some host-ending character
     * comes *before* the @-sign.
     * URLs are obnoxious.
     *
     * ex:
     * http://a@b@c/ => user:a@b host:c
     * http://a@b?@c => user:a host:c path:/?@c
     */

    /*
     * v0.12 TODO(isaacs): This is not quite how Chrome does things.
     * Review our test case against browsers more comprehensively.
     */

    // find the first instance of any hostEndingChars
    var hostEnd = -1;
    for (var i = 0; i < hostEndingChars.length; i++) {
      var hec = rest.indexOf(hostEndingChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }

    /*
     * at this point, either we have an explicit point where the
     * auth portion cannot go past, or the last @ char is the decider.
     */
    var auth, atSign;
    if (hostEnd === -1) {
      // atSign can be anywhere.
      atSign = rest.lastIndexOf('@');
    } else {
      /*
       * atSign must be in auth portion.
       * http://a@b/c@d => host:b auth:a path:/c@d
       */
      atSign = rest.lastIndexOf('@', hostEnd);
    }

    /*
     * Now we have a portion which is definitely the auth.
     * Pull that off.
     */
    if (atSign !== -1) {
      auth = rest.slice(0, atSign);
      rest = rest.slice(atSign + 1);
      this.auth = decodeURIComponent(auth);
    }

    // the host is the remaining to the left of the first non-host char
    hostEnd = -1;
    for (var i = 0; i < nonHostChars.length; i++) {
      var hec = rest.indexOf(nonHostChars[i]);
      if (hec !== -1 && (hostEnd === -1 || hec < hostEnd)) { hostEnd = hec; }
    }
    // if we still have not hit it, then the entire thing is a host.
    if (hostEnd === -1) { hostEnd = rest.length; }

    this.host = rest.slice(0, hostEnd);
    rest = rest.slice(hostEnd);

    // pull out port.
    this.parseHost();

    /*
     * we've indicated that there is a hostname,
     * so even if it's empty, it has to be present.
     */
    this.hostname = this.hostname || '';

    /*
     * if hostname begins with [ and ends with ]
     * assume that it's an IPv6 address.
     */
    var ipv6Hostname = this.hostname[0] === '[' && this.hostname[this.hostname.length - 1] === ']';

    // validate a little.
    if (!ipv6Hostname) {
      var hostparts = this.hostname.split(/\./);
      for (var i = 0, l = hostparts.length; i < l; i++) {
        var part = hostparts[i];
        if (!part) { continue; }
        if (!part.match(hostnamePartPattern)) {
          var newpart = '';
          for (var j = 0, k = part.length; j < k; j++) {
            if (part.charCodeAt(j) > 127) {
              /*
               * we replace non-ASCII char with a temporary placeholder
               * we need this to make sure size of hostname is not
               * broken by replacing non-ASCII by nothing
               */
              newpart += 'x';
            } else {
              newpart += part[j];
            }
          }
          // we test again with ASCII char only
          if (!newpart.match(hostnamePartPattern)) {
            var validParts = hostparts.slice(0, i);
            var notHost = hostparts.slice(i + 1);
            var bit = part.match(hostnamePartStart);
            if (bit) {
              validParts.push(bit[1]);
              notHost.unshift(bit[2]);
            }
            if (notHost.length) {
              rest = '/' + notHost.join('.') + rest;
            }
            this.hostname = validParts.join('.');
            break;
          }
        }
      }
    }

    if (this.hostname.length > hostnameMaxLen) {
      this.hostname = '';
    } else {
      // hostnames are always lower case.
      this.hostname = this.hostname.toLowerCase();
    }

    if (!ipv6Hostname) {
      /*
       * IDNA Support: Returns a punycoded representation of "domain".
       * It only converts parts of the domain name that
       * have non-ASCII characters, i.e. it doesn't matter if
       * you call it with a domain that already is ASCII-only.
       */
      this.hostname = punycode.toASCII(this.hostname);
    }

    var p = this.port ? ':' + this.port : '';
    var h = this.hostname || '';
    this.host = h + p;
    this.href += this.host;

    /*
     * strip [ and ] from the hostname
     * the host field still retains them, though
     */
    if (ipv6Hostname) {
      this.hostname = this.hostname.substr(1, this.hostname.length - 2);
      if (rest[0] !== '/') {
        rest = '/' + rest;
      }
    }
  }

  /*
   * now rest is set to the post-host stuff.
   * chop off any delim chars.
   */
  if (!unsafeProtocol[lowerProto]) {

    /*
     * First, make 100% sure that any "autoEscape" chars get
     * escaped, even if encodeURIComponent doesn't think they
     * need to be.
     */
    for (var i = 0, l = autoEscape.length; i < l; i++) {
      var ae = autoEscape[i];
      if (rest.indexOf(ae) === -1) { continue; }
      var esc = encodeURIComponent(ae);
      if (esc === ae) {
        esc = escape(ae);
      }
      rest = rest.split(ae).join(esc);
    }
  }

  // chop off from the tail first.
  var hash = rest.indexOf('#');
  if (hash !== -1) {
    // got a fragment string.
    this.hash = rest.substr(hash);
    rest = rest.slice(0, hash);
  }
  var qm = rest.indexOf('?');
  if (qm !== -1) {
    this.search = rest.substr(qm);
    this.query = rest.substr(qm + 1);
    if (parseQueryString) {
      this.query = querystring.parse(this.query);
    }
    rest = rest.slice(0, qm);
  } else if (parseQueryString) {
    // no query string, but parseQueryString still requested
    this.search = '';
    this.query = {};
  }
  if (rest) { this.pathname = rest; }
  if (slashedProtocol[lowerProto] && this.hostname && !this.pathname) {
    this.pathname = '/';
  }

  // to support http.request
  if (this.pathname || this.search) {
    var p = this.pathname || '';
    var s = this.search || '';
    this.path = p + s;
  }

  // finally, reconstruct the href based on what has been validated.
  this.href = this.format();
  return this;
};

// format a parsed object into a url string
function urlFormat(obj) {
  /*
   * ensure it's an object, and not a string url.
   * If it's an obj, this is a no-op.
   * this way, you can call url_format() on strings
   * to clean up potentially wonky urls.
   */
  if (typeof obj === 'string') { obj = urlParse(obj); }
  if (!(obj instanceof Url)) { return Url.prototype.format.call(obj); }
  return obj.format();
}

Url.prototype.format = function () {
  var auth = this.auth || '';
  if (auth) {
    auth = encodeURIComponent(auth);
    auth = auth.replace(/%3A/i, ':');
    auth += '@';
  }

  var protocol = this.protocol || '',
    pathname = this.pathname || '',
    hash = this.hash || '',
    host = false,
    query = '';

  if (this.host) {
    host = auth + this.host;
  } else if (this.hostname) {
    host = auth + (this.hostname.indexOf(':') === -1 ? this.hostname : '[' + this.hostname + ']');
    if (this.port) {
      host += ':' + this.port;
    }
  }

  if (this.query && typeof this.query === 'object' && Object.keys(this.query).length) {
    query = querystring.stringify(this.query, {
      arrayFormat: 'repeat',
      addQueryPrefix: false
    });
  }

  var search = this.search || (query && ('?' + query)) || '';

  if (protocol && protocol.substr(-1) !== ':') { protocol += ':'; }

  /*
   * only the slashedProtocols get the //.  Not mailto:, xmpp:, etc.
   * unless they had them to begin with.
   */
  if (this.slashes || (!protocol || slashedProtocol[protocol]) && host !== false) {
    host = '//' + (host || '');
    if (pathname && pathname.charAt(0) !== '/') { pathname = '/' + pathname; }
  } else if (!host) {
    host = '';
  }

  if (hash && hash.charAt(0) !== '#') { hash = '#' + hash; }
  if (search && search.charAt(0) !== '?') { search = '?' + search; }

  pathname = pathname.replace(/[?#]/g, function (match) {
    return encodeURIComponent(match);
  });
  search = search.replace('#', '%23');

  return protocol + host + pathname + search + hash;
};

function urlResolve(source, relative) {
  return urlParse(source, false, true).resolve(relative);
}

Url.prototype.resolve = function (relative) {
  return this.resolveObject(urlParse(relative, false, true)).format();
};

function urlResolveObject(source, relative) {
  if (!source) { return relative; }
  return urlParse(source, false, true).resolveObject(relative);
}

Url.prototype.resolveObject = function (relative) {
  if (typeof relative === 'string') {
    var rel = new Url();
    rel.parse(relative, false, true);
    relative = rel;
  }

  var result = new Url();
  var tkeys = Object.keys(this);
  for (var tk = 0; tk < tkeys.length; tk++) {
    var tkey = tkeys[tk];
    result[tkey] = this[tkey];
  }

  /*
   * hash is always overridden, no matter what.
   * even href="" will remove it.
   */
  result.hash = relative.hash;

  // if the relative url is empty, then there's nothing left to do here.
  if (relative.href === '') {
    result.href = result.format();
    return result;
  }

  // hrefs like //foo/bar always cut to the protocol.
  if (relative.slashes && !relative.protocol) {
    // take everything except the protocol from relative
    var rkeys = Object.keys(relative);
    for (var rk = 0; rk < rkeys.length; rk++) {
      var rkey = rkeys[rk];
      if (rkey !== 'protocol') { result[rkey] = relative[rkey]; }
    }

    // urlParse appends trailing / to urls like http://www.example.com
    if (slashedProtocol[result.protocol] && result.hostname && !result.pathname) {
      result.pathname = '/';
      result.path = result.pathname;
    }

    result.href = result.format();
    return result;
  }

  if (relative.protocol && relative.protocol !== result.protocol) {
    /*
     * if it's a known url protocol, then changing
     * the protocol does weird things
     * first, if it's not file:, then we MUST have a host,
     * and if there was a path
     * to begin with, then we MUST have a path.
     * if it is file:, then the host is dropped,
     * because that's known to be hostless.
     * anything else is assumed to be absolute.
     */
    if (!slashedProtocol[relative.protocol]) {
      var keys = Object.keys(relative);
      for (var v = 0; v < keys.length; v++) {
        var k = keys[v];
        result[k] = relative[k];
      }
      result.href = result.format();
      return result;
    }

    result.protocol = relative.protocol;
    if (!relative.host && !hostlessProtocol[relative.protocol]) {
      var relPath = (relative.pathname || '').split('/');
      while (relPath.length && !(relative.host = relPath.shift())) { }
      if (!relative.host) { relative.host = ''; }
      if (!relative.hostname) { relative.hostname = ''; }
      if (relPath[0] !== '') { relPath.unshift(''); }
      if (relPath.length < 2) { relPath.unshift(''); }
      result.pathname = relPath.join('/');
    } else {
      result.pathname = relative.pathname;
    }
    result.search = relative.search;
    result.query = relative.query;
    result.host = relative.host || '';
    result.auth = relative.auth;
    result.hostname = relative.hostname || relative.host;
    result.port = relative.port;
    // to support http.request
    if (result.pathname || result.search) {
      var p = result.pathname || '';
      var s = result.search || '';
      result.path = p + s;
    }
    result.slashes = result.slashes || relative.slashes;
    result.href = result.format();
    return result;
  }

  var isSourceAbs = result.pathname && result.pathname.charAt(0) === '/',
    isRelAbs = relative.host || relative.pathname && relative.pathname.charAt(0) === '/',
    mustEndAbs = isRelAbs || isSourceAbs || (result.host && relative.pathname),
    removeAllDots = mustEndAbs,
    srcPath = result.pathname && result.pathname.split('/') || [],
    relPath = relative.pathname && relative.pathname.split('/') || [],
    psychotic = result.protocol && !slashedProtocol[result.protocol];

  /*
   * if the url is a non-slashed url, then relative
   * links like ../.. should be able
   * to crawl up to the hostname, as well.  This is strange.
   * result.protocol has already been set by now.
   * Later on, put the first path part into the host field.
   */
  if (psychotic) {
    result.hostname = '';
    result.port = null;
    if (result.host) {
      if (srcPath[0] === '') { srcPath[0] = result.host; } else { srcPath.unshift(result.host); }
    }
    result.host = '';
    if (relative.protocol) {
      relative.hostname = null;
      relative.port = null;
      if (relative.host) {
        if (relPath[0] === '') { relPath[0] = relative.host; } else { relPath.unshift(relative.host); }
      }
      relative.host = null;
    }
    mustEndAbs = mustEndAbs && (relPath[0] === '' || srcPath[0] === '');
  }

  if (isRelAbs) {
    // it's absolute.
    result.host = relative.host || relative.host === '' ? relative.host : result.host;
    result.hostname = relative.hostname || relative.hostname === '' ? relative.hostname : result.hostname;
    result.search = relative.search;
    result.query = relative.query;
    srcPath = relPath;
    // fall through to the dot-handling below.
  } else if (relPath.length) {
    /*
     * it's relative
     * throw away the existing file, and take the new path instead.
     */
    if (!srcPath) { srcPath = []; }
    srcPath.pop();
    srcPath = srcPath.concat(relPath);
    result.search = relative.search;
    result.query = relative.query;
  } else if (relative.search != null) {
    /*
     * just pull out the search.
     * like href='?foo'.
     * Put this after the other two cases because it simplifies the booleans
     */
    if (psychotic) {
      result.host = srcPath.shift();
      result.hostname = result.host;
      /*
       * occationaly the auth can get stuck only in host
       * this especially happens in cases like
       * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
       */
      var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
      if (authInHost) {
        result.auth = authInHost.shift();
        result.hostname = authInHost.shift();
        result.host = result.hostname;
      }
    }
    result.search = relative.search;
    result.query = relative.query;
    // to support http.request
    if (result.pathname !== null || result.search !== null) {
      result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
    }
    result.href = result.format();
    return result;
  }

  if (!srcPath.length) {
    /*
     * no path at all.  easy.
     * we've already handled the other stuff above.
     */
    result.pathname = null;
    // to support http.request
    if (result.search) {
      result.path = '/' + result.search;
    } else {
      result.path = null;
    }
    result.href = result.format();
    return result;
  }

  /*
   * if a url ENDs in . or .., then it must get a trailing slash.
   * however, if it ends in anything else non-slashy,
   * then it must NOT get a trailing slash.
   */
  var last = srcPath.slice(-1)[0];
  var hasTrailingSlash = (result.host || relative.host || srcPath.length > 1) && (last === '.' || last === '..') || last === '';

  /*
   * strip single dots, resolve double dots to parent dir
   * if the path tries to go above the root, `up` ends up > 0
   */
  var up = 0;
  for (var i = srcPath.length; i >= 0; i--) {
    last = srcPath[i];
    if (last === '.') {
      srcPath.splice(i, 1);
    } else if (last === '..') {
      srcPath.splice(i, 1);
      up++;
    } else if (up) {
      srcPath.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (!mustEndAbs && !removeAllDots) {
    for (; up--; up) {
      srcPath.unshift('..');
    }
  }

  if (mustEndAbs && srcPath[0] !== '' && (!srcPath[0] || srcPath[0].charAt(0) !== '/')) {
    srcPath.unshift('');
  }

  if (hasTrailingSlash && (srcPath.join('/').substr(-1) !== '/')) {
    srcPath.push('');
  }

  var isAbsolute = srcPath[0] === '' || (srcPath[0] && srcPath[0].charAt(0) === '/');

  // put the host back
  if (psychotic) {
    result.hostname = isAbsolute ? '' : srcPath.length ? srcPath.shift() : '';
    result.host = result.hostname;
    /*
     * occationaly the auth can get stuck only in host
     * this especially happens in cases like
     * url.resolveObject('mailto:local1@domain1', 'local2@domain2')
     */
    var authInHost = result.host && result.host.indexOf('@') > 0 ? result.host.split('@') : false;
    if (authInHost) {
      result.auth = authInHost.shift();
      result.hostname = authInHost.shift();
      result.host = result.hostname;
    }
  }

  mustEndAbs = mustEndAbs || (result.host && srcPath.length);

  if (mustEndAbs && !isAbsolute) {
    srcPath.unshift('');
  }

  if (srcPath.length > 0) {
    result.pathname = srcPath.join('/');
  } else {
    result.pathname = null;
    result.path = null;
  }

  // to support request.http
  if (result.pathname !== null || result.search !== null) {
    result.path = (result.pathname ? result.pathname : '') + (result.search ? result.search : '');
  }
  result.auth = relative.auth || result.auth;
  result.slashes = result.slashes || relative.slashes;
  result.href = result.format();
  return result;
};

Url.prototype.parseHost = function () {
  var host = this.host;
  var port = portPattern.exec(host);
  if (port) {
    port = port[0];
    if (port !== ':') {
      this.port = port.substr(1);
    }
    host = host.substr(0, host.length - port.length);
  }
  if (host) { this.hostname = host; }
};

exports.parse = urlParse;
exports.resolve = urlResolve;
exports.resolveObject = urlResolveObject;
exports.format = urlFormat;

exports.Url = Url;


/***/ }),
/* 267 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module, global) {var __WEBPACK_AMD_DEFINE_RESULT__;/*! https://mths.be/punycode v1.4.1 by @mathias */
;(function(root) {

	/** Detect free variables */
	var freeExports = typeof exports == 'object' && exports &&
		!exports.nodeType && exports;
	var freeModule = typeof module == 'object' && module &&
		!module.nodeType && module;
	var freeGlobal = typeof global == 'object' && global;
	if (
		freeGlobal.global === freeGlobal ||
		freeGlobal.window === freeGlobal ||
		freeGlobal.self === freeGlobal
	) {
		root = freeGlobal;
	}

	/**
	 * The `punycode` object.
	 * @name punycode
	 * @type Object
	 */
	var punycode,

	/** Highest positive signed 32-bit float value */
	maxInt = 2147483647, // aka. 0x7FFFFFFF or 2^31-1

	/** Bootstring parameters */
	base = 36,
	tMin = 1,
	tMax = 26,
	skew = 38,
	damp = 700,
	initialBias = 72,
	initialN = 128, // 0x80
	delimiter = '-', // '\x2D'

	/** Regular expressions */
	regexPunycode = /^xn--/,
	regexNonASCII = /[^\x20-\x7E]/, // unprintable ASCII chars + non-ASCII chars
	regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g, // RFC 3490 separators

	/** Error messages */
	errors = {
		'overflow': 'Overflow: input needs wider integers to process',
		'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
		'invalid-input': 'Invalid input'
	},

	/** Convenience shortcuts */
	baseMinusTMin = base - tMin,
	floor = Math.floor,
	stringFromCharCode = String.fromCharCode,

	/** Temporary variable */
	key;

	/*--------------------------------------------------------------------------*/

	/**
	 * A generic error utility function.
	 * @private
	 * @param {String} type The error type.
	 * @returns {Error} Throws a `RangeError` with the applicable error message.
	 */
	function error(type) {
		throw new RangeError(errors[type]);
	}

	/**
	 * A generic `Array#map` utility function.
	 * @private
	 * @param {Array} array The array to iterate over.
	 * @param {Function} callback The function that gets called for every array
	 * item.
	 * @returns {Array} A new array of values returned by the callback function.
	 */
	function map(array, fn) {
		var length = array.length;
		var result = [];
		while (length--) {
			result[length] = fn(array[length]);
		}
		return result;
	}

	/**
	 * A simple `Array#map`-like wrapper to work with domain name strings or email
	 * addresses.
	 * @private
	 * @param {String} domain The domain name or email address.
	 * @param {Function} callback The function that gets called for every
	 * character.
	 * @returns {Array} A new string of characters returned by the callback
	 * function.
	 */
	function mapDomain(string, fn) {
		var parts = string.split('@');
		var result = '';
		if (parts.length > 1) {
			// In email addresses, only the domain name should be punycoded. Leave
			// the local part (i.e. everything up to `@`) intact.
			result = parts[0] + '@';
			string = parts[1];
		}
		// Avoid `split(regex)` for IE8 compatibility. See #17.
		string = string.replace(regexSeparators, '\x2E');
		var labels = string.split('.');
		var encoded = map(labels, fn).join('.');
		return result + encoded;
	}

	/**
	 * Creates an array containing the numeric code points of each Unicode
	 * character in the string. While JavaScript uses UCS-2 internally,
	 * this function will convert a pair of surrogate halves (each of which
	 * UCS-2 exposes as separate characters) into a single code point,
	 * matching UTF-16.
	 * @see `punycode.ucs2.encode`
	 * @see <https://mathiasbynens.be/notes/javascript-encoding>
	 * @memberOf punycode.ucs2
	 * @name decode
	 * @param {String} string The Unicode input string (UCS-2).
	 * @returns {Array} The new array of code points.
	 */
	function ucs2decode(string) {
		var output = [],
		    counter = 0,
		    length = string.length,
		    value,
		    extra;
		while (counter < length) {
			value = string.charCodeAt(counter++);
			if (value >= 0xD800 && value <= 0xDBFF && counter < length) {
				// high surrogate, and there is a next character
				extra = string.charCodeAt(counter++);
				if ((extra & 0xFC00) == 0xDC00) { // low surrogate
					output.push(((value & 0x3FF) << 10) + (extra & 0x3FF) + 0x10000);
				} else {
					// unmatched surrogate; only append this code unit, in case the next
					// code unit is the high surrogate of a surrogate pair
					output.push(value);
					counter--;
				}
			} else {
				output.push(value);
			}
		}
		return output;
	}

	/**
	 * Creates a string based on an array of numeric code points.
	 * @see `punycode.ucs2.decode`
	 * @memberOf punycode.ucs2
	 * @name encode
	 * @param {Array} codePoints The array of numeric code points.
	 * @returns {String} The new Unicode string (UCS-2).
	 */
	function ucs2encode(array) {
		return map(array, function(value) {
			var output = '';
			if (value > 0xFFFF) {
				value -= 0x10000;
				output += stringFromCharCode(value >>> 10 & 0x3FF | 0xD800);
				value = 0xDC00 | value & 0x3FF;
			}
			output += stringFromCharCode(value);
			return output;
		}).join('');
	}

	/**
	 * Converts a basic code point into a digit/integer.
	 * @see `digitToBasic()`
	 * @private
	 * @param {Number} codePoint The basic numeric code point value.
	 * @returns {Number} The numeric value of a basic code point (for use in
	 * representing integers) in the range `0` to `base - 1`, or `base` if
	 * the code point does not represent a value.
	 */
	function basicToDigit(codePoint) {
		if (codePoint - 48 < 10) {
			return codePoint - 22;
		}
		if (codePoint - 65 < 26) {
			return codePoint - 65;
		}
		if (codePoint - 97 < 26) {
			return codePoint - 97;
		}
		return base;
	}

	/**
	 * Converts a digit/integer into a basic code point.
	 * @see `basicToDigit()`
	 * @private
	 * @param {Number} digit The numeric value of a basic code point.
	 * @returns {Number} The basic code point whose value (when used for
	 * representing integers) is `digit`, which needs to be in the range
	 * `0` to `base - 1`. If `flag` is non-zero, the uppercase form is
	 * used; else, the lowercase form is used. The behavior is undefined
	 * if `flag` is non-zero and `digit` has no uppercase form.
	 */
	function digitToBasic(digit, flag) {
		//  0..25 map to ASCII a..z or A..Z
		// 26..35 map to ASCII 0..9
		return digit + 22 + 75 * (digit < 26) - ((flag != 0) << 5);
	}

	/**
	 * Bias adaptation function as per section 3.4 of RFC 3492.
	 * https://tools.ietf.org/html/rfc3492#section-3.4
	 * @private
	 */
	function adapt(delta, numPoints, firstTime) {
		var k = 0;
		delta = firstTime ? floor(delta / damp) : delta >> 1;
		delta += floor(delta / numPoints);
		for (/* no initialization */; delta > baseMinusTMin * tMax >> 1; k += base) {
			delta = floor(delta / baseMinusTMin);
		}
		return floor(k + (baseMinusTMin + 1) * delta / (delta + skew));
	}

	/**
	 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
	 * symbols.
	 * @memberOf punycode
	 * @param {String} input The Punycode string of ASCII-only symbols.
	 * @returns {String} The resulting string of Unicode symbols.
	 */
	function decode(input) {
		// Don't use UCS-2
		var output = [],
		    inputLength = input.length,
		    out,
		    i = 0,
		    n = initialN,
		    bias = initialBias,
		    basic,
		    j,
		    index,
		    oldi,
		    w,
		    k,
		    digit,
		    t,
		    /** Cached calculation results */
		    baseMinusT;

		// Handle the basic code points: let `basic` be the number of input code
		// points before the last delimiter, or `0` if there is none, then copy
		// the first basic code points to the output.

		basic = input.lastIndexOf(delimiter);
		if (basic < 0) {
			basic = 0;
		}

		for (j = 0; j < basic; ++j) {
			// if it's not a basic code point
			if (input.charCodeAt(j) >= 0x80) {
				error('not-basic');
			}
			output.push(input.charCodeAt(j));
		}

		// Main decoding loop: start just after the last delimiter if any basic code
		// points were copied; start at the beginning otherwise.

		for (index = basic > 0 ? basic + 1 : 0; index < inputLength; /* no final expression */) {

			// `index` is the index of the next character to be consumed.
			// Decode a generalized variable-length integer into `delta`,
			// which gets added to `i`. The overflow checking is easier
			// if we increase `i` as we go, then subtract off its starting
			// value at the end to obtain `delta`.
			for (oldi = i, w = 1, k = base; /* no condition */; k += base) {

				if (index >= inputLength) {
					error('invalid-input');
				}

				digit = basicToDigit(input.charCodeAt(index++));

				if (digit >= base || digit > floor((maxInt - i) / w)) {
					error('overflow');
				}

				i += digit * w;
				t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);

				if (digit < t) {
					break;
				}

				baseMinusT = base - t;
				if (w > floor(maxInt / baseMinusT)) {
					error('overflow');
				}

				w *= baseMinusT;

			}

			out = output.length + 1;
			bias = adapt(i - oldi, out, oldi == 0);

			// `i` was supposed to wrap around from `out` to `0`,
			// incrementing `n` each time, so we'll fix that now:
			if (floor(i / out) > maxInt - n) {
				error('overflow');
			}

			n += floor(i / out);
			i %= out;

			// Insert `n` at position `i` of the output
			output.splice(i++, 0, n);

		}

		return ucs2encode(output);
	}

	/**
	 * Converts a string of Unicode symbols (e.g. a domain name label) to a
	 * Punycode string of ASCII-only symbols.
	 * @memberOf punycode
	 * @param {String} input The string of Unicode symbols.
	 * @returns {String} The resulting Punycode string of ASCII-only symbols.
	 */
	function encode(input) {
		var n,
		    delta,
		    handledCPCount,
		    basicLength,
		    bias,
		    j,
		    m,
		    q,
		    k,
		    t,
		    currentValue,
		    output = [],
		    /** `inputLength` will hold the number of code points in `input`. */
		    inputLength,
		    /** Cached calculation results */
		    handledCPCountPlusOne,
		    baseMinusT,
		    qMinusT;

		// Convert the input in UCS-2 to Unicode
		input = ucs2decode(input);

		// Cache the length
		inputLength = input.length;

		// Initialize the state
		n = initialN;
		delta = 0;
		bias = initialBias;

		// Handle the basic code points
		for (j = 0; j < inputLength; ++j) {
			currentValue = input[j];
			if (currentValue < 0x80) {
				output.push(stringFromCharCode(currentValue));
			}
		}

		handledCPCount = basicLength = output.length;

		// `handledCPCount` is the number of code points that have been handled;
		// `basicLength` is the number of basic code points.

		// Finish the basic string - if it is not empty - with a delimiter
		if (basicLength) {
			output.push(delimiter);
		}

		// Main encoding loop:
		while (handledCPCount < inputLength) {

			// All non-basic code points < n have been handled already. Find the next
			// larger one:
			for (m = maxInt, j = 0; j < inputLength; ++j) {
				currentValue = input[j];
				if (currentValue >= n && currentValue < m) {
					m = currentValue;
				}
			}

			// Increase `delta` enough to advance the decoder's <n,i> state to <m,0>,
			// but guard against overflow
			handledCPCountPlusOne = handledCPCount + 1;
			if (m - n > floor((maxInt - delta) / handledCPCountPlusOne)) {
				error('overflow');
			}

			delta += (m - n) * handledCPCountPlusOne;
			n = m;

			for (j = 0; j < inputLength; ++j) {
				currentValue = input[j];

				if (currentValue < n && ++delta > maxInt) {
					error('overflow');
				}

				if (currentValue == n) {
					// Represent delta as a generalized variable-length integer
					for (q = delta, k = base; /* no condition */; k += base) {
						t = k <= bias ? tMin : (k >= bias + tMax ? tMax : k - bias);
						if (q < t) {
							break;
						}
						qMinusT = q - t;
						baseMinusT = base - t;
						output.push(
							stringFromCharCode(digitToBasic(t + qMinusT % baseMinusT, 0))
						);
						q = floor(qMinusT / baseMinusT);
					}

					output.push(stringFromCharCode(digitToBasic(q, 0)));
					bias = adapt(delta, handledCPCountPlusOne, handledCPCount == basicLength);
					delta = 0;
					++handledCPCount;
				}
			}

			++delta;
			++n;

		}
		return output.join('');
	}

	/**
	 * Converts a Punycode string representing a domain name or an email address
	 * to Unicode. Only the Punycoded parts of the input will be converted, i.e.
	 * it doesn't matter if you call it on a string that has already been
	 * converted to Unicode.
	 * @memberOf punycode
	 * @param {String} input The Punycoded domain name or email address to
	 * convert to Unicode.
	 * @returns {String} The Unicode representation of the given Punycode
	 * string.
	 */
	function toUnicode(input) {
		return mapDomain(input, function(string) {
			return regexPunycode.test(string)
				? decode(string.slice(4).toLowerCase())
				: string;
		});
	}

	/**
	 * Converts a Unicode string representing a domain name or an email address to
	 * Punycode. Only the non-ASCII parts of the domain name will be converted,
	 * i.e. it doesn't matter if you call it with a domain that's already in
	 * ASCII.
	 * @memberOf punycode
	 * @param {String} input The domain name or email address to convert, as a
	 * Unicode string.
	 * @returns {String} The Punycode representation of the given domain name or
	 * email address.
	 */
	function toASCII(input) {
		return mapDomain(input, function(string) {
			return regexNonASCII.test(string)
				? 'xn--' + encode(string)
				: string;
		});
	}

	/*--------------------------------------------------------------------------*/

	/** Define the public API */
	punycode = {
		/**
		 * A string representing the current Punycode.js version number.
		 * @memberOf punycode
		 * @type String
		 */
		'version': '1.4.1',
		/**
		 * An object of methods to convert from JavaScript's internal character
		 * representation (UCS-2) to Unicode code points, and back.
		 * @see <https://mathiasbynens.be/notes/javascript-encoding>
		 * @memberOf punycode
		 * @type Object
		 */
		'ucs2': {
			'decode': ucs2decode,
			'encode': ucs2encode
		},
		'decode': decode,
		'encode': encode,
		'toASCII': toASCII,
		'toUnicode': toUnicode
	};

	/** Expose `punycode` */
	// Some AMD build optimizers, like r.js, check for specific condition patterns
	// like the following:
	if (
		true
	) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
			return punycode;
		}).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (freeExports && freeModule) {
		if (module.exports == freeExports) {
			// in Node.js, io.js, or RingoJS v0.8.0+
			freeModule.exports = punycode;
		} else {
			// in Narwhal or RingoJS v0.7.0-
			for (key in punycode) {
				punycode.hasOwnProperty(key) && (freeExports[key] = punycode[key]);
			}
		}
	} else {
		// in Rhino or a web browser
		root.punycode = punycode;
	}

}(this));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)(module), __webpack_require__(47)))

/***/ }),
/* 268 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(269);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./ProfileLink.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./ProfileLink.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.ProfileLink__root___8nP9M {\n  font-weight: normal !important; }\n  .ProfileLink__root_bold___3Wx2I {\n    font-family: \"proxima-nova-a-bold\", sans-serif; }\n  .ProfileLink__root_link___OjVS2 {\n    color: #171717; }\n", ""]);

// exports
exports.locals = {
	"root": "ProfileLink__root___8nP9M",
	"root_bold": "ProfileLink__root_bold___3Wx2I",
	"root_link": "ProfileLink__root_link___OjVS2"
};

/***/ }),
/* 270 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellDamDamsSire;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CellDam = __webpack_require__(79);

var _CellDam2 = _interopRequireDefault(_CellDam);

var _CellDamsSire = __webpack_require__(80);

var _CellDamsSire2 = _interopRequireDefault(_CellDamsSire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellDamDamsSire(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_CellDam2.default, { data: data })
        ),
        _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(_CellDamsSire2.default, { data: data })
        )
    );
}

CellDamDamsSire.propTypes = {
    // data is a row with dam and dam's sire data
    // see CellDam and CellDamsSire for details
    data: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
};

/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellPrice;

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CellPrice = __webpack_require__(272);

var _CellPrice2 = _interopRequireDefault(_CellPrice);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function CellPrice(_ref) {
    var data = _ref.data,
        bold = _ref.bold;

    return _react2.default.createElement(
        'div',
        {
            className: (0, _classnames3.default)(_CellPrice2.default.root, _defineProperty({}, _CellPrice2.default.root_bold, bold))
        },
        data.price_styled_long
    );
}

CellPrice.propTypes = {
    data: _propTypes2.default.shape({
        price_styled_long: _propTypes2.default.string
    }).isRequired,
    bold: _propTypes2.default.bool
};

CellPrice.defaultProps = {
    bold: true
};

/***/ }),
/* 272 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(273);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellPrice.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellPrice.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 273 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.CellPrice__root_bold___1bHHe {\n  font-family: \"proxima-nova-a-bold\", sans-serif; }\n", ""]);

// exports
exports.locals = {
	"root_bold": "CellPrice__root_bold___1bHHe"
};

/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.toggleShortlist = toggleShortlist;
exports.toggleNote = toggleNote;
exports.fetchNote = fetchNote;
exports.submitNote = submitNote;
exports.bindCatalogue = bindCatalogue;

var _qs = __webpack_require__(17);

var _qs2 = _interopRequireDefault(_qs);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpNavigation = __webpack_require__(275);

var _api = __webpack_require__(7);

var _ugc = __webpack_require__(82);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var promise = null;
var catalogue = [];
var listeners = [];

function notify() {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
        return listener.apply(undefined, args);
    });
}

function fetchCatalogue() {
    return _rpNavigation.authReady.then(function (auth) {
        if (auth.user.isLoggedIn) {
            return (0, _api.callApi)('/bloodstock/sales/ugc/catalogue/data.json').then(function (data) {
                notify(catalogue = [].concat(_toConsumableArray(data)));
            });
        }
        return null;
    });
}

function changeCatalogue(payload) {
    var venueId = payload.venueId,
        saleDate = payload.saleDate,
        lotNo = payload.lotNo,
        lotLetter = payload.lotLetter;

    var foundItem = (0, _ugc.findCatalogueItem)(catalogue, venueId, saleDate, lotNo, lotLetter);
    catalogue = catalogue.filter(function (item) {
        return item !== foundItem;
    }).concat(_extends({}, (0, _ugc.getDefaultCatalogueItem)(catalogue, venueId, saleDate, lotNo, lotLetter), foundItem, payload));
    notify(catalogue);
}

function toggleShortlist(venueId, saleDate, lotNo, lotLetter, shortlist) {
    var query = { lotNo: lotNo, lotLetter: lotLetter };
    var url = '/bloodstock/sales/ugc/shortlist/' + venueId + '/' + saleDate;
    return _rpNavigation.authReady.then(function () {
        return (0, _rpNavigation.checkForAccess)('SignIn', true, true, {
            text: 'Please sign in to edit your shortlist',
            r: window.location.origin + '/bloodstock/sales/my-shortlist'
        }).then(function (hasAccess) {
            return hasAccess && (0, _api.callApi)(url, { query: query, method: shortlist ? 'PUT' : 'DELETE' }).then(function () {
                return changeCatalogue({
                    venueId: venueId,
                    saleDate: saleDate,
                    lotNo: lotNo,
                    lotLetter: lotLetter,
                    shortlist: shortlist
                });
            });
        });
    });
}

function toggleNote(sireUrl) {
    return _rpNavigation.authReady.then(function () {
        return (0, _rpNavigation.checkForAccess)('Subscriptions', true, true, { r: '' + window.location.origin + sireUrl + '/notes' });
    });
}

function fetchNote(venueId, saleDate, lotNo, lotLetter) {
    var query = {
        lotNo: lotNo,
        lotLetter: lotLetter || ' '
    };
    return (0, _api.callApi)('/bloodstock/sales/ugc/notes/' + venueId + '/' + saleDate, { query: query });
}

function submitNote(venueId, saleDate, lotNo, lotLetter, comment, rating) {
    var url = '/bloodstock/sales/ugc/notes/' + venueId + '/' + saleDate;
    var init = {
        method: 'PUT',
        body: _qs2.default.stringify({
            lotNo: lotNo,
            lotLetter: lotLetter,
            comment: comment,
            rating: rating
        })
    };
    return (0, _api.callApi)(url, init).then(function () {
        return changeCatalogue({
            venueId: venueId,
            saleDate: saleDate,
            lotNo: lotNo,
            lotLetter: lotLetter,
            note: !!comment || !!rating
        });
    });
}

function bindCatalogue(Component) {
    var makeProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (data) {
        return { catalogue: data };
    };

    return function (_PureComponent) {
        _inherits(UGC, _PureComponent);

        function UGC() {
            var _ref;

            var _temp, _this, _ret;

            _classCallCheck(this, UGC);

            for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
                args[_key2] = arguments[_key2];
            }

            return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UGC.__proto__ || Object.getPrototypeOf(UGC)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
                data: [].concat(_toConsumableArray(catalogue))
            }, _this.listener = function (data) {
                return _this.setState({ data: data });
            }, _temp), _possibleConstructorReturn(_this, _ret);
        }

        _createClass(UGC, [{
            key: 'componentDidMount',
            value: function componentDidMount() {
                listeners = listeners.concat(this.listener);

                if (!promise) {
                    promise = fetchCatalogue();
                }
            }
        }, {
            key: 'componentWillUnmount',
            value: function componentWillUnmount() {
                var _this2 = this;

                listeners = listeners.filter(function (listener) {
                    return listener !== _this2.listener;
                });
            }
        }, {
            key: 'render',
            value: function render() {
                var data = this.state.data;

                return _react2.default.createElement(Component, _extends({}, this.props, makeProps(data, this.props)));
            }
        }]);

        return UGC;
    }(_react.PureComponent);
}

/***/ }),
/* 275 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_275__;

/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(277),
    getMatchData = __webpack_require__(278);

/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || baseIsMatch(object, source, getMatchData(source));
}

module.exports = isMatch;


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(45),
    baseIsEqual = __webpack_require__(44);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(279),
    keys = __webpack_require__(36);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(16);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(281);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellHorseUGC.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellHorseUGC.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".CellHorseUGC__root___38-wt {\n  display: flex;\n  align-items: center;\n  justify-content: space-between; }\n\n.CellHorseUGC__horse___lQhmn {\n  flex: 1;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -ms-word-break: break-all;\n  word-break: break-word;\n  -ms-hyphens: auto;\n  -moz-hyphens: auto;\n  -webkit-hyphens: auto;\n  hyphens: auto; }\n\n.CellHorseUGC__ugc___3ZN7o {\n  display: flex; }\n\n.CellHorseUGC__icon___320nt {\n  margin-left: 4px;\n  fill: #D11F25; }\n", ""]);

// exports
exports.locals = {
	"root": "CellHorseUGC__root___38-wt",
	"horse": "CellHorseUGC__horse___lQhmn",
	"ugc": "CellHorseUGC__ugc___3ZN7o",
	"icon": "CellHorseUGC__icon___320nt"
};

/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellHorseSireUGC;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _CellHorseUGC = __webpack_require__(81);

var _CellHorseUGC2 = _interopRequireDefault(_CellHorseUGC);

var _CellSire = __webpack_require__(78);

var _CellSire2 = _interopRequireDefault(_CellSire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellHorseSireUGC(props) {
    return _react2.default.createElement(
        _CellHorseUGC2.default,
        props,
        _react2.default.createElement(_CellSire2.default, { data: props.data, bold: true })
    );
}

CellHorseSireUGC.propTypes = {
    data: _propTypes2.default.object.isRequired // eslint-disable-line react/forbid-prop-types
};

/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellDateSale;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellDateSale(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
            'div',
            null,
            data.sale_date
        ),
        _react2.default.createElement(
            'div',
            null,
            data.sale_name
        )
    );
}

CellDateSale.propTypes = {
    data: _propTypes2.default.shape({
        sale_date: _propTypes2.default.string,
        sale_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = CellRace;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _url = __webpack_require__(30);

var _CellRace = __webpack_require__(285);

var _CellRace2 = _interopRequireDefault(_CellRace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CellRace(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'a',
        {
            className: 'js-popupLink ui-link ui-link_primary ' + _CellRace2.default.root,
            href: (0, _url.raceUrl)(data.course_uid, data.course_style_name, data.race_date, data.race_instance_uid)
        },
        data.title
    );
}

CellRace.propTypes = {
    data: _propTypes2.default.shape({
        race_instance_uid: _propTypes2.default.number.isRequired,
        race_date: _propTypes2.default.string.isRequired,
        course_uid: _propTypes2.default.number.isRequired,
        course_style_name: _propTypes2.default.string.isRequired,
        title: _propTypes2.default.string.isRequired
    }).isRequired
};

/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(286);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellRace.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./CellRace.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".CellRace__root___lJMCF {\n  color: #D11F25 !important; }\n", ""]);

// exports
exports.locals = {
	"root": "CellRace__root___lJMCF"
};

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesRow;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Relatives = __webpack_require__(84);

var _Relatives2 = _interopRequireDefault(_Relatives);

var _url = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesRow(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(_Relatives2.default, {
        damUid: data.dam_uid,
        venueId: data.venue_uid,
        saleDate: data.sale_date_raw,
        saleEndDate: data.sale_date_raw,
        birthDate: data.dam_date_of_birth,
        lotNo: data.lot_no,
        lotLetter: data.lot_letter,
        catalogueUrl: data.catalogue_pedigree_pdf_url,
        sireUrl: (0, _url.profileUrl)('horse', data.sire_uid, data.sire_style_name)
    });
}

RelativesRow.propTypes = {
    data: _propTypes2.default.shape({
        dam_uid: _propTypes2.default.number,
        venue_uid: _propTypes2.default.number.isRequired,
        sale_date_raw: _propTypes2.default.string.isRequired,
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string.isRequired,
        catalogue_pedigree_pdf_url: _propTypes2.default.string,
        dam_date_of_birth: _propTypes2.default.string,
        sire_uid: _propTypes2.default.string,
        sire_style_name: _propTypes2.default.string
    }).isRequired
};

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Tab = __webpack_require__(31);

var _Tab2 = _interopRequireDefault(_Tab);

var _Actions = __webpack_require__(299);

var _Actions2 = _interopRequireDefault(_Actions);

var _Results = __webpack_require__(339);

var _Results2 = _interopRequireDefault(_Results);

var _Entries = __webpack_require__(360);

var _Entries2 = _interopRequireDefault(_Entries);

var _Sales = __webpack_require__(364);

var _Sales2 = _interopRequireDefault(_Sales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Relatives = function (_PureComponent) {
    _inherits(Relatives, _PureComponent);

    function Relatives() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Relatives);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Relatives.__proto__ || Object.getPrototypeOf(Relatives)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            tab: _Tab2.default.TAB_RESULTS
        }, _this.handleTabChange = function (tab) {
            return _this.setState({ tab: tab });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Relatives, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                venueId = _props.venueId,
                saleDate = _props.saleDate,
                saleEndDate = _props.saleEndDate,
                lotNo = _props.lotNo,
                lotLetter = _props.lotLetter,
                damUid = _props.damUid,
                catalogueUrl = _props.catalogueUrl,
                showShortlist = _props.showShortlist,
                birthDate = _props.birthDate,
                sireUrl = _props.sireUrl;
            var tab = this.state.tab;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(_Actions2.default, {
                    venueId: venueId,
                    saleDate: saleDate,
                    saleEndDate: saleEndDate,
                    lotNo: lotNo,
                    lotLetter: lotLetter,
                    catalogueUrl: catalogueUrl,
                    showShortlist: showShortlist,
                    sireUrl: sireUrl
                }),
                function () {
                    switch (tab) {
                        case _Tab2.default.TAB_RESULTS:
                            return _react2.default.createElement(_Results2.default, {
                                damUid: damUid,
                                onTabChange: _this2.handleTabChange
                            });
                        case _Tab2.default.TAB_ENTRIES:
                            return _react2.default.createElement(_Entries2.default, {
                                damUid: damUid,
                                onTabChange: _this2.handleTabChange
                            });
                        case _Tab2.default.TAB_SALES:
                            return _react2.default.createElement(_Sales2.default, {
                                venueId: venueId,
                                lotNo: lotNo,
                                damUid: damUid,
                                birthDate: birthDate,
                                saleDate: saleDate,
                                onTabChange: _this2.handleTabChange
                            });
                        default:
                            throw new Error('Unknown tab ' + tab);
                    }
                }()
            );
        }
    }]);

    return Relatives;
}(_react.PureComponent);

Relatives.propTypes = {
    damUid: _propTypes2.default.number.isRequired,
    venueId: _propTypes2.default.number.isRequired,
    saleDate: _propTypes2.default.string.isRequired,
    saleEndDate: _propTypes2.default.string.isRequired,
    birthDate: _propTypes2.default.string.isRequired,
    lotNo: _propTypes2.default.number.isRequired,
    lotLetter: _propTypes2.default.string,
    catalogueUrl: _propTypes2.default.string,
    showShortlist: _propTypes2.default.bool,
    sireUrl: _propTypes2.default.string.isRequired
};
Relatives.defaultProps = {
    lotLetter: ' ',
    catalogueUrl: null,
    showShortlist: true
};
exports.default = Relatives;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesTab;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Switch = __webpack_require__(290);

var _Switch2 = _interopRequireDefault(_Switch);

var _RelativesTab = __webpack_require__(297);

var _RelativesTab2 = _interopRequireDefault(_RelativesTab);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesTab(_ref) {
    var children = _ref.children,
        tab = _ref.tab,
        filter = _ref.filter,
        onTabChange = _ref.onTabChange;

    return _react2.default.createElement(
        'div',
        { className: _RelativesTab2.default.root },
        _react2.default.createElement(
            'div',
            { className: _RelativesTab2.default.toolbar },
            _react2.default.createElement(_Switch2.default, {
                className: _RelativesTab2.default.switch,
                value: tab,
                onChange: onTabChange
            }),
            _react2.default.createElement(
                'div',
                { className: _RelativesTab2.default.filter },
                filter
            )
        ),
        _react2.default.createElement(
            'div',
            { className: _RelativesTab2.default.content },
            children
        )
    );
}

RelativesTab.TAB_RESULTS = _Switch2.default.TAB_RESULTS;
RelativesTab.TAB_ENTRIES = _Switch2.default.TAB_ENTRIES;
RelativesTab.TAB_SALES = _Switch2.default.TAB_SALES;

RelativesTab.propTypes = {
    children: _propTypes2.default.node.isRequired,
    tab: _propTypes2.default.string.isRequired,
    filter: _propTypes2.default.node,
    onTabChange: _propTypes2.default.func.isRequired
};

RelativesTab.defaultProps = {
    filter: null
};

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesTabSwitch = __webpack_require__(291);

var _RelativesTabSwitch2 = _interopRequireDefault(_RelativesTabSwitch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesTabSwitch2.default;

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesSwitch;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Switch = __webpack_require__(292);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TAB_RESULTS = 'TAB_RESULTS';
var TAB_ENTRIES = 'TAB_ENTRIES';
var TAB_SALES = 'TAB_SALES';

var options = [{ value: TAB_RESULTS, label: 'Results' }, { value: TAB_ENTRIES, label: 'Entries' }, { value: TAB_SALES, label: 'Sales' }];

function RelativesSwitch(_ref) {
    var className = _ref.className,
        value = _ref.value,
        onChange = _ref.onChange;

    return _react2.default.createElement(_Switch2.default, {
        className: className,
        title: 'Relatives',
        options: options,
        value: value,
        onChange: onChange
    });
}

RelativesSwitch.TAB_RESULTS = TAB_RESULTS;
RelativesSwitch.TAB_ENTRIES = TAB_ENTRIES;
RelativesSwitch.TAB_SALES = TAB_SALES;

RelativesSwitch.propTypes = {
    className: _propTypes2.default.string,
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired
};

RelativesSwitch.defaultProps = {
    className: '',
    value: null
};

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Switch = __webpack_require__(293);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Switch2.default;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = Switch;

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _SwitchItem = __webpack_require__(294);

var _SwitchItem2 = _interopRequireDefault(_SwitchItem);

var _Switch = __webpack_require__(295);

var _Switch2 = _interopRequireDefault(_Switch);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Switch(_ref) {
    var className = _ref.className,
        title = _ref.title,
        options = _ref.options,
        value = _ref.value,
        onChange = _ref.onChange;

    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_Switch2.default.switch, className) },
        title && _react2.default.createElement(
            'div',
            {
                className: _Switch2.default.switch__title
            },
            title
        ),
        _react2.default.createElement(
            'div',
            { className: 'ui-switcher' },
            options.map(function (option) {
                return _react2.default.createElement(_SwitchItem2.default, _extends({
                    key: option.value,
                    active: option.value === value,
                    onClick: onChange
                }, option));
            })
        )
    );
}

Switch.propTypes = {
    className: _propTypes2.default.string,
    title: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        label: _propTypes2.default.string.isRequired,
        value: _propTypes2.default.string.isRequired
    })).isRequired,
    value: _propTypes2.default.string,
    onChange: _propTypes2.default.func.isRequired
};

Switch.defaultProps = {
    className: '',
    title: null,
    value: null
};

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Switch = function (_PureComponent) {
    _inherits(Switch, _PureComponent);

    function Switch() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Switch);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Switch.__proto__ || Object.getPrototypeOf(Switch)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
            return _this.props.onClick(_this.props.value);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Switch, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                label = _props.label,
                active = _props.active;

            return _react2.default.createElement(
                'button',
                {
                    className: (0, _classnames2.default)('ui-switcher__btn ui-btn ui-btn_xl', active ? 'ui-btn_primary' : 'ui-btn_secondary'),
                    onClick: this.handleClick
                },
                _react2.default.createElement(
                    'span',
                    { className: 'ui-switcher__title' },
                    label
                )
            );
        }
    }]);

    return Switch;
}(_react.PureComponent);

Switch.propTypes = {
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]).isRequired,
    value: _propTypes2.default.string.isRequired,
    active: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired
};
Switch.defaultProps = {
    active: false
};
exports.default = Switch;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(296);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Switch.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Switch.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.Switch__switch___3zjYZ {\n  display: flex;\n  align-items: center; }\n  .Switch__switch__title___1Surx {\n    font: 16px/22px \"proxima-nova-a\", sans-serif;\n    margin: 0 8px 0 0; }\n", ""]);

// exports
exports.locals = {
	"switch": "Switch__switch___3zjYZ",
	"switch__title": "Switch__switch__title___1Surx"
};

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(298);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesTab.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesTab.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".RelativesTab__root___34W1u {\n  padding: 0 8px 8px; }\n\n.RelativesTab__toolbar___1hEo5 {\n  display: flex;\n  justify-content: space-between; }\n  @media (max-width: 719.9px) {\n    .RelativesTab__toolbar___1hEo5 {\n      flex-direction: column; } }\n\n.RelativesTab__switch___2aJLf, .RelativesTab__filter___3ZnBa {\n  margin-top: 8px; }\n\n.RelativesTab__content___2uRcZ {\n  margin-top: 24px; }\n", ""]);

// exports
exports.locals = {
	"root": "RelativesTab__root___34W1u",
	"toolbar": "RelativesTab__toolbar___1hEo5",
	"switch": "RelativesTab__switch___2aJLf",
	"filter": "RelativesTab__filter___3ZnBa",
	"content": "RelativesTab__content___2uRcZ"
};

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActions = __webpack_require__(300);

var _RelativesActions2 = _interopRequireDefault(_RelativesActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActions2.default;

/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _is_past = __webpack_require__(301);

var _is_past2 = _interopRequireDefault(_is_past);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _UGC = __webpack_require__(42);

var _Shortlist = __webpack_require__(302);

var _Shortlist2 = _interopRequireDefault(_Shortlist);

var _Note = __webpack_require__(306);

var _Note2 = _interopRequireDefault(_Note);

var _NoteForm = __webpack_require__(310);

var _NoteForm2 = _interopRequireDefault(_NoteForm);

var _Link = __webpack_require__(332);

var _Link2 = _interopRequireDefault(_Link);

var _RelativesActions = __webpack_require__(336);

var _RelativesActions2 = _interopRequireDefault(_RelativesActions);

var _externalResources = __webpack_require__(338);

var _externalResources2 = _interopRequireDefault(_externalResources);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelativesActions = function (_PureComponent) {
    _inherits(RelativesActions, _PureComponent);

    function RelativesActions() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesActions);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelativesActions.__proto__ || Object.getPrototypeOf(RelativesActions)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            noteOpen: false
        }, _this.handleShortlistClick = function () {
            var _this$props = _this.props,
                venueId = _this$props.venueId,
                saleDate = _this$props.saleDate,
                lotNo = _this$props.lotNo,
                lotLetter = _this$props.lotLetter,
                shortlist = _this$props.shortlist;

            return (0, _UGC.toggleShortlist)(venueId, saleDate, lotNo, lotLetter, !shortlist);
        }, _this.handleNoteClick = function () {
            (0, _UGC.toggleNote)(_this.props.sireUrl).then(function (access) {
                _this.setState({
                    noteOpen: access
                });
            });
        }, _this.handleNoteFormFetch = function () {
            var _this$props2 = _this.props,
                venueId = _this$props2.venueId,
                saleDate = _this$props2.saleDate,
                lotNo = _this$props2.lotNo,
                lotLetter = _this$props2.lotLetter;

            return (0, _UGC.fetchNote)(venueId, saleDate, lotNo, lotLetter);
        }, _this.handleNoteFormSubmit = function (_ref2) {
            var comment = _ref2.comment,
                rating = _ref2.rating;
            var _this$props3 = _this.props,
                venueId = _this$props3.venueId,
                saleDate = _this$props3.saleDate,
                lotNo = _this$props3.lotNo,
                lotLetter = _this$props3.lotLetter;

            return (0, _UGC.submitNote)(venueId, saleDate, lotNo, lotLetter, comment, rating);
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesActions, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            if (this.state.noteOpen && !this.isNoteAvailable(nextProps)) {
                this.setState({ noteOpen: false });
            }
        }
    }, {
        key: 'isShortlistAvailable',
        value: function isShortlistAvailable() {
            return this.props.showShortlist && (this.props.shortlist || !(0, _is_past2.default)(this.props.saleEndDate));
        }
    }, {
        key: 'isNoteAvailable',
        value: function isNoteAvailable() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;

            return props.note || !(0, _is_past2.default)(props.saleEndDate);
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                className = _props.className,
                shortlist = _props.shortlist,
                note = _props.note,
                catalogueUrl = _props.catalogueUrl;

            return _react2.default.createElement(
                'div',
                { className: className },
                _react2.default.createElement(
                    'div',
                    { className: _RelativesActions2.default.panel },
                    _react2.default.createElement(
                        'div',
                        { className: _RelativesActions2.default.group },
                        this.isShortlistAvailable() && _react2.default.createElement(_Shortlist2.default, {
                            className: _RelativesActions2.default.action,
                            shortlist: shortlist,
                            onClick: this.handleShortlistClick
                        }),
                        this.isNoteAvailable() && _react2.default.createElement(_Note2.default, {
                            className: _RelativesActions2.default.action,
                            note: note,
                            onClick: this.handleNoteClick
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _RelativesActions2.default.group },
                        catalogueUrl && _react2.default.createElement(_Link2.default, {
                            className: _RelativesActions2.default.action,
                            href: catalogueUrl,
                            label: 'Catalogue page',
                            iconClassName: 'tableShowIcon ' + _RelativesActions2.default.catalogueIcon,
                            icon: 'pdf'
                        }),
                        _react2.default.createElement(_Link2.default, {
                            className: _RelativesActions2.default.action,
                            href: _externalResources2.default.BLOODSTOCK_REPORTS,
                            label: 'Weatherbys Pedigree',
                            iconClassName: 'tableShowIcon',
                            icon: 'weatherby'
                        })
                    )
                ),
                this.state.noteOpen && _react2.default.createElement(
                    'div',
                    { className: _RelativesActions2.default.form },
                    _react2.default.createElement(_NoteForm2.default, {
                        onFetch: this.handleNoteFormFetch,
                        onSubmit: this.handleNoteFormSubmit
                    })
                )
            );
        }
    }]);

    return RelativesActions;
}(_react.PureComponent);

RelativesActions.propTypes = {
    className: _propTypes2.default.string,
    venueId: _propTypes2.default.number.isRequired,
    saleDate: _propTypes2.default.string.isRequired,
    saleEndDate: _propTypes2.default.string.isRequired,
    lotNo: _propTypes2.default.number.isRequired,
    lotLetter: _propTypes2.default.string,
    shortlist: _propTypes2.default.bool.isRequired,
    note: _propTypes2.default.bool.isRequired,
    catalogueUrl: _propTypes2.default.string,
    showShortlist: _propTypes2.default.bool,
    sireUrl: _propTypes2.default.string.isRequired
};
RelativesActions.defaultProps = {
    className: '',
    lotLetter: ' ',
    catalogueUrl: null,
    showShortlist: true,
    lightbox: null
};
exports.default = (0, _UGC.bindCatalogue)(RelativesActions, function (catalogue, ownProps) {
    var venueId = ownProps.venueId,
        saleDate = ownProps.saleDate,
        lotNo = ownProps.lotNo,
        lotLetter = ownProps.lotLetter;

    var _getCatalogueItemSafe = (0, _UGC.getCatalogueItemSafe)(catalogue, venueId, saleDate, lotNo, lotLetter),
        shortlist = _getCatalogueItemSafe.shortlist,
        note = _getCatalogueItemSafe.note;

    return { shortlist: shortlist, note: note };
});

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(6)

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActionsShortlist = __webpack_require__(303);

var _RelativesActionsShortlist2 = _interopRequireDefault(_RelativesActionsShortlist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActionsShortlist2.default;

/***/ }),
/* 303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isFunction2 = __webpack_require__(15);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _classnames3 = __webpack_require__(5);

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _api = __webpack_require__(7);

var _RelativesActionsShortlist = __webpack_require__(304);

var _RelativesActionsShortlist2 = _interopRequireDefault(_RelativesActionsShortlist);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RelativesActionsShortlist = function (_PureComponent) {
    _inherits(RelativesActionsShortlist, _PureComponent);

    function RelativesActionsShortlist() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesActionsShortlist);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelativesActionsShortlist.__proto__ || Object.getPrototypeOf(RelativesActionsShortlist)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            toggling: false
        }, _this.handleButtonClick = function () {
            var result = _this.props.onClick();
            if ((0, _isFunction3.default)(result.then) && (0, _isFunction3.default)(result.catch)) {
                _this.setState({ toggling: true });
                result.catch(function (resp) {
                    return !(0, _api.isUnauthorized)(resp);
                }).then(function (payload) {
                    return _this.setState(_extends({}, payload, { toggling: false }));
                });
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesActionsShortlist, [{
        key: 'render',
        value: function render() {
            var _classnames, _classnames2;

            var _props = this.props,
                className = _props.className,
                shortlist = _props.shortlist;
            var toggling = this.state.toggling;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'button',
                    {
                        className: (0, _classnames4.default)(_RelativesActionsShortlist2.default.button, className, 'ui-btn ui-btn_tiertiary'),
                        disabled: toggling,
                        onClick: this.handleButtonClick
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, {
                        className: (0, _classnames4.default)((_classnames = {}, _defineProperty(_classnames, _RelativesActionsShortlist2.default.icon, true), _defineProperty(_classnames, _RelativesActionsShortlist2.default.icon_highlighted, !shortlist), _classnames)),
                        size: 'Medium',
                        iconName: 'starHollow'
                    }),
                    _react2.default.createElement(_rpReactSvgIcon2.default, {
                        className: (0, _classnames4.default)((_classnames2 = {}, _defineProperty(_classnames2, _RelativesActionsShortlist2.default.icon, true), _defineProperty(_classnames2, _RelativesActionsShortlist2.default.icon_highlighted, shortlist), _classnames2)),
                        size: 'Medium',
                        iconName: 'starFilled'
                    }),
                    'Add to My Shortlist'
                )
            );
        }
    }]);

    return RelativesActionsShortlist;
}(_react.PureComponent);

RelativesActionsShortlist.propTypes = {
    className: _propTypes2.default.string,
    shortlist: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
};
RelativesActionsShortlist.defaultProps = {
    className: ''
};
exports.default = RelativesActionsShortlist;

/***/ }),
/* 304 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(305);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsShortlist.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsShortlist.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActionsShortlist__button___TdsFl {\n  display: flex;\n  align-items: center;\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  height: 24px; }\n\n.RelativesActionsShortlist__icon___1xV8x {\n  margin-right: 4px;\n  display: none; }\n  .RelativesActionsShortlist__icon_highlighted___1wEyA {\n    fill: #D11F25;\n    display: inline-block; }\n", ""]);

// exports
exports.locals = {
	"button": "RelativesActionsShortlist__button___TdsFl",
	"icon": "RelativesActionsShortlist__icon___1xV8x",
	"icon_highlighted": "RelativesActionsShortlist__icon_highlighted___1wEyA"
};

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActionsNote = __webpack_require__(307);

var _RelativesActionsNote2 = _interopRequireDefault(_RelativesActionsNote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActionsNote2.default;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesActionsNote;

var _classnames3 = __webpack_require__(5);

var _classnames4 = _interopRequireDefault(_classnames3);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _RelativesActionsNote = __webpack_require__(308);

var _RelativesActionsNote2 = _interopRequireDefault(_RelativesActionsNote);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function RelativesActionsNote(_ref) {
    var _classnames, _classnames2;

    var className = _ref.className,
        note = _ref.note,
        onClick = _ref.onClick;

    return _react2.default.createElement(
        'button',
        {
            className: (0, _classnames4.default)(_RelativesActionsNote2.default.root, className, 'ui-btn ui-btn_tiertiary'),
            onClick: onClick
        },
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            className: (0, _classnames4.default)((_classnames = {}, _defineProperty(_classnames, _RelativesActionsNote2.default.icon, true), _defineProperty(_classnames, _RelativesActionsNote2.default.icon_highlighted, !note), _classnames)),
            size: 'Medium',
            iconName: 'note'
        }),
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            className: (0, _classnames4.default)((_classnames2 = {}, _defineProperty(_classnames2, _RelativesActionsNote2.default.icon, true), _defineProperty(_classnames2, _RelativesActionsNote2.default.icon_highlighted, note), _classnames2)),
            size: 'Medium',
            iconName: 'note-dark'
        }),
        note ? 'View/edit notes' : 'Add a note'
    );
}

RelativesActionsNote.propTypes = {
    className: _propTypes2.default.string,
    note: _propTypes2.default.bool.isRequired,
    onClick: _propTypes2.default.func.isRequired
};

RelativesActionsNote.defaultProps = {
    className: ''
};

/***/ }),
/* 308 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(309);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsNote.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsNote.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActionsNote__root___ux4Zm {\n  display: flex;\n  align-items: center;\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  height: 24px; }\n\n.RelativesActionsNote__icon___25eG0 {\n  margin-right: 4px;\n  display: none; }\n  .RelativesActionsNote__icon_highlighted___1vQ3Q {\n    fill: #D11F25;\n    display: inline-block; }\n", ""]);

// exports
exports.locals = {
	"root": "RelativesActionsNote__root___ux4Zm",
	"icon": "RelativesActionsNote__icon___25eG0",
	"icon_highlighted": "RelativesActionsNote__icon_highlighted___1vQ3Q"
};

/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActionsNoteForm = __webpack_require__(311);

var _RelativesActionsNoteForm2 = _interopRequireDefault(_RelativesActionsNoteForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActionsNoteForm2.default;

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _isEqual2 = __webpack_require__(32);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _isFunction2 = __webpack_require__(15);

var _isFunction3 = _interopRequireDefault(_isFunction2);

var _trim2 = __webpack_require__(312);

var _trim3 = _interopRequireDefault(_trim2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactTextareaAutosize = __webpack_require__(318);

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _Rate = __webpack_require__(319);

var _Rate2 = _interopRequireDefault(_Rate);

var _Lightbox = __webpack_require__(323);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _api = __webpack_require__(7);

var _RelativesActionsNoteForm = __webpack_require__(330);

var _RelativesActionsNoteForm2 = _interopRequireDefault(_RelativesActionsNoteForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LIGHTBOX_SUBMIT_FAILURE = 'submitFailure';

var RelativesActionsNoteForm = function (_PureComponent) {
    _inherits(RelativesActionsNoteForm, _PureComponent);

    function RelativesActionsNoteForm() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesActionsNoteForm);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelativesActionsNoteForm.__proto__ || Object.getPrototypeOf(RelativesActionsNoteForm)).call.apply(_ref, [this].concat(args))), _this), _this.state = _extends({}, RelativesActionsNoteForm.nilValue, {
            lightbox: null,
            mounting: false,
            submitting: false,
            submitted: false
        }), _this.handleSubmit = function (e) {
            e.preventDefault();
            _this.submit();
        }, _this.handleCommentChange = function (e) {
            return _this.setState({ comment: e.target.value });
        }, _this.handleRatingChange = function (rating) {
            return _this.setState({ rating: rating });
        }, _this.handleRatingClear = function () {
            return _this.setState({ rating: RelativesActionsNoteForm.nilValue.rating });
        }, _this.handleClear = function () {
            return _this.setState(RelativesActionsNoteForm.nilValue);
        }, _this.handleHereClick = function () {
            _this.fetch();
            _this.closeLightbox();
        }, _this.handleLightboxClose = function () {
            return _this.closeLightbox();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesActionsNoteForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetch();
        }
    }, {
        key: 'fetch',
        value: function fetch() {
            var _this2 = this;

            var result = this.props.onFetch();
            if ((0, _isFunction3.default)(result.then) && (0, _isFunction3.default)(result.catch)) {
                this.setState({ mounting: true }); // eslint-disable-line react/no-did-mount-set-state
                result.then(function (data) {
                    _this2.srvValue = RelativesActionsNoteForm.getValue(data);
                    return _this2.srvValue;
                }).catch(function (resp) {
                    return !(0, _api.isUnauthorized)(resp);
                }).then(function (payload) {
                    _this2.setState(_extends({}, payload, { mounting: false }));
                });
            }
        }
    }, {
        key: 'submit',
        value: function submit() {
            var _this3 = this;

            var value = RelativesActionsNoteForm.getValue(this.state);
            var result = this.props.onSubmit(value);
            if ((0, _isFunction3.default)(result.then) && (0, _isFunction3.default)(result.catch)) {
                this.setState({ submitting: true });
                result.then(function () {
                    _this3.srvValue = value;
                    return { submitted: true };
                }).catch(function (resp) {
                    return !(0, _api.isUnauthorized)(resp) && { lightbox: LIGHTBOX_SUBMIT_FAILURE };
                }).then(function (payload) {
                    return _this3.setState(_extends({}, payload, { submitting: false }));
                });
            }
        }
    }, {
        key: 'closeLightbox',
        value: function closeLightbox() {
            this.setState({ lightbox: null });
        }
    }, {
        key: 'isSubmitDisabled',
        value: function isSubmitDisabled() {
            return this.state.submitting || (0, _isEqual3.default)(RelativesActionsNoteForm.getValue(this.state), this.srvValue);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                comment = _state.comment,
                rating = _state.rating,
                lightbox = _state.lightbox,
                mounting = _state.mounting,
                submitted = _state.submitted;

            var submitDisabled = this.isSubmitDisabled();

            if (mounting) {
                return _react2.default.createElement(_rpReactSvgIcon2.default, {
                    className: _RelativesActionsNoteForm2.default.spinner,
                    size: '2XL',
                    iconName: 'spinner'
                });
            }

            return _react2.default.createElement(
                'form',
                {
                    className: _RelativesActionsNoteForm2.default.root,
                    onSubmit: this.handleSubmit
                },
                _react2.default.createElement(_Lightbox2.default, {
                    open: lightbox === LIGHTBOX_SUBMIT_FAILURE,
                    title: 'Something\'s gone wrong and your changes could not be saved',
                    text: 'Press save to try again',
                    onClose: this.handleLightboxClose
                }),
                _react2.default.createElement(
                    'div',
                    { className: _RelativesActionsNoteForm2.default.content },
                    _react2.default.createElement(_reactTextareaAutosize2.default, {
                        className: _RelativesActionsNoteForm2.default.comment,
                        placeholder: 'add a note...',
                        value: comment,
                        onChange: this.handleCommentChange
                    }),
                    _react2.default.createElement(
                        'div',
                        { className: _RelativesActionsNoteForm2.default.rating },
                        'My Rating',
                        _react2.default.createElement(_Rate2.default, {
                            className: _RelativesActionsNoteForm2.default.ratingInput,
                            value: rating,
                            onChange: this.handleRatingChange
                        }),
                        _react2.default.createElement(
                            'button',
                            {
                                className: _RelativesActionsNoteForm2.default.ratingClear,
                                type: 'button',
                                onClick: this.handleRatingClear
                            },
                            _react2.default.createElement(_rpReactSvgIcon2.default, {
                                className: _RelativesActionsNoteForm2.default.ratingClearIcon,
                                size: 'Medium',
                                iconName: 'cross'
                            })
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _RelativesActionsNoteForm2.default.panel },
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'ui-btn ui-btn_primary ui-btn_small ' + _RelativesActionsNoteForm2.default.panelButton,
                            type: 'submit',
                            disabled: submitDisabled
                        },
                        submitted && submitDisabled ? _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement(_rpReactSvgIcon2.default, {
                                className: _RelativesActionsNoteForm2.default.saveIcon,
                                iconName: 'tick',
                                size: 'Medium'
                            }),
                            'Saved'
                        ) : 'Save'
                    ),
                    _react2.default.createElement(
                        'button',
                        {
                            className: 'ui-btn ui-btn_secondary ui-btn_small ' + _RelativesActionsNoteForm2.default.panelButton,
                            type: 'button',
                            onClick: this.handleClear
                        },
                        'Clear'
                    )
                )
            );
        }
    }], [{
        key: 'getValue',
        value: function getValue(_ref2) {
            var comment = _ref2.comment,
                rating = _ref2.rating;

            return {
                comment: (0, _trim3.default)(comment),
                rating: rating || 0
            };
        }
    }]);

    return RelativesActionsNoteForm;
}(_react.PureComponent);

RelativesActionsNoteForm.propTypes = {
    onFetch: _propTypes2.default.func.isRequired,
    onSubmit: _propTypes2.default.func.isRequired
};
RelativesActionsNoteForm.nilValue = {
    comment: '',
    rating: 0
};
exports.default = RelativesActionsNoteForm;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(63),
    baseTrim = __webpack_require__(62),
    castSlice = __webpack_require__(65),
    charsEndIndex = __webpack_require__(313),
    charsStartIndex = __webpack_require__(317),
    stringToArray = __webpack_require__(67),
    toString = __webpack_require__(26);

/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */
function trim(string, chars, guard) {
  string = toString(string);
  if (string && (guard || chars === undefined)) {
    return baseTrim(string);
  }
  if (!string || !(chars = baseToString(chars))) {
    return string;
  }
  var strSymbols = stringToArray(string),
      chrSymbols = stringToArray(chars),
      start = charsStartIndex(strSymbols, chrSymbols),
      end = charsEndIndex(strSymbols, chrSymbols) + 1;

  return castSlice(strSymbols, start, end).join('');
}

module.exports = trim;


/***/ }),
/* 313 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(85);

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */
function charsEndIndex(strSymbols, chrSymbols) {
  var index = strSymbols.length;

  while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsEndIndex;


/***/ }),
/* 314 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 315 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 316 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 317 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(85);

/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */
function charsStartIndex(strSymbols, chrSymbols) {
  var index = -1,
      length = strSymbols.length;

  while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
  return index;
}

module.exports = charsStartIndex;


/***/ }),
/* 318 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_318__;

/***/ }),
/* 319 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Rate = __webpack_require__(320);

var _Rate2 = _interopRequireDefault(_Rate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Rate2.default;

/***/ }),
/* 320 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _Rate = __webpack_require__(321);

var _Rate2 = _interopRequireDefault(_Rate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Rate = function (_PureComponent) {
    _inherits(Rate, _PureComponent);

    function Rate() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Rate);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Rate.__proto__ || Object.getPrototypeOf(Rate)).call.apply(_ref, [this].concat(args))), _this), _this.handleChange = function (e) {
            return _this.props.onChange(Number(e.target.value));
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(Rate, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                className = _props.className,
                value = _props.value;
            /* eslint-disable jsx-a11y/label-has-for */

            return _react2.default.createElement(
                'div',
                { className: _Rate2.default.root + ' ' + className },
                [5, 4, 3, 2, 1].map(function (i) {
                    var checked = i === value;
                    return _react2.default.createElement(
                        'label',
                        {
                            key: i,
                            className: (0, _classnames3.default)(_Rate2.default.tick, _defineProperty({}, _Rate2.default.tick_checked, checked))
                        },
                        _react2.default.createElement('input', {
                            className: _Rate2.default.input,
                            type: 'radio',
                            name: 'rating',
                            value: i,
                            checked: checked,
                            onChange: _this2.handleChange
                        }),
                        _react2.default.createElement(_rpReactSvgIcon2.default, {
                            className: _Rate2.default.icon,
                            iconName: 'tick'
                        })
                    );
                })
            );
            /* eslint-enable jsx-a11y/label-has-for */
        }
    }]);

    return Rate;
}(_react.PureComponent);

exports.default = Rate;


Rate.propTypes = {
    className: _propTypes2.default.string,
    value: _propTypes2.default.number,
    onChange: _propTypes2.default.func.isRequired
};

Rate.defaultProps = {
    className: '',
    value: 0
};

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(322);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Rate.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./Rate.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.Rate__root___2D5tX {\n  background: #FFFFFF;\n  border-radius: 4px;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  height: 16px;\n  width: 80px; }\n\n.Rate__tick___1hdWY {\n  background: #FFFFFF;\n  border: 1px solid #F0EFF1;\n  cursor: pointer;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 16px;\n  width: 16px;\n  transition: background linear 100ms; }\n  .Rate__tick___1hdWY:not(:last-of-type) {\n    border-width: 1px 1px 1px 0; }\n  .Rate__tick___1hdWY:last-of-type {\n    border-top-left-radius: 4px;\n    border-bottom-left-radius: 4px; }\n  .Rate__tick___1hdWY:first-of-type {\n    border-top-right-radius: 4px;\n    border-bottom-right-radius: 4px; }\n  .Rate__tick___1hdWY:hover,\n  .Rate__tick___1hdWY:hover ~ .Rate__tick___1hdWY, .Rate__tick_checked____Sjxo,\n  .Rate__tick_checked____Sjxo ~ .Rate__tick___1hdWY {\n    background-color: #2CB34A; }\n\n.Rate__input___2zgK8 {\n  display: none; }\n\n.Rate__icon___bb7_W {\n  height: 8px;\n  width: 8px;\n  fill: #F0EFF1;\n  transition: fill linear 100ms; }\n  .Rate__icon___bb7_W:hover {\n    fill: #F0EFF1; }\n\n.Rate__tick___1hdWY:hover > .Rate__icon___bb7_W,\n.Rate__tick___1hdWY:hover ~ .Rate__tick___1hdWY > .Rate__icon___bb7_W,\n.Rate__tick_checked____Sjxo > .Rate__icon___bb7_W,\n.Rate__tick_checked____Sjxo ~ .Rate__tick___1hdWY > .Rate__icon___bb7_W {\n  fill: #FFFFFF; }\n", ""]);

// exports
exports.locals = {
	"root": "Rate__root___2D5tX",
	"tick": "Rate__tick___1hdWY",
	"tick_checked": "Rate__tick_checked____Sjxo",
	"input": "Rate__input___2zgK8",
	"icon": "Rate__icon___bb7_W"
};

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActionsLightbox = __webpack_require__(324);

var _RelativesActionsLightbox2 = _interopRequireDefault(_RelativesActionsLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActionsLightbox2.default;

/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesActionsLightbox;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Lightbox = __webpack_require__(43);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _RelativesActionsLightbox = __webpack_require__(328);

var _RelativesActionsLightbox2 = _interopRequireDefault(_RelativesActionsLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesActionsLightbox(_ref) {
    var title = _ref.title,
        text = _ref.text,
        open = _ref.open,
        onClose = _ref.onClose;

    return _react2.default.createElement(
        _Lightbox2.default,
        {
            open: open,
            onClose: onClose,
            closeButton: true
        },
        _react2.default.createElement(
            'div',
            { className: _RelativesActionsLightbox2.default.lightbox__wrap },
            _react2.default.createElement(
                'h2',
                { className: _RelativesActionsLightbox2.default.lightbox__title },
                title
            ),
            _react2.default.createElement(
                'p',
                { className: _RelativesActionsLightbox2.default.lightbox__text },
                text
            ),
            _react2.default.createElement(
                'button',
                {
                    className: 'ui-btn ui-btn_primary ui-btn_large ' + _RelativesActionsLightbox2.default.lightbox__button,
                    onClick: onClose
                },
                'ok'
            )
        )
    );
}

RelativesActionsLightbox.propTypes = {
    title: _propTypes2.default.string.isRequired,
    text: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node]),
    open: _propTypes2.default.bool.isRequired,
    onClose: _propTypes2.default.func.isRequired
};

RelativesActionsLightbox.defaultProps = {
    text: ''
};

/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Lightbox;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _LightboxBackdrop = __webpack_require__(86);

var _LightboxBackdrop2 = _interopRequireDefault(_LightboxBackdrop);

var _LightboxDialog = __webpack_require__(87);

var _LightboxDialog2 = _interopRequireDefault(_LightboxDialog);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Lightbox(_ref) {
    var children = _ref.children,
        open = _ref.open,
        closeButton = _ref.closeButton,
        onClose = _ref.onClose;

    return _react2.default.createElement(
        _LightboxBackdrop2.default,
        {
            open: open,
            onClose: onClose
        },
        _react2.default.createElement(
            _LightboxDialog2.default,
            {
                closeButton: closeButton,
                onClose: onClose
            },
            children
        )
    );
}

Lightbox.propTypes = {
    children: _propTypes2.default.node,
    open: _propTypes2.default.bool,
    closeButton: _propTypes2.default.bool,
    onClose: _propTypes2.default.func
};

Lightbox.defaultProps = {
    children: null,
    open: false,
    closeButton: false,
    onClose: null
};

/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(327);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./LightboxDialog.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./LightboxDialog.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".LightboxDialog__closeButton___1CBYh {\n  position: absolute;\n  right: 0;\n  top: 0;\n  display: block;\n  border: 0;\n  background: none;\n  padding: 16px;\n  margin-left: auto;\n  line-height: 0;\n  cursor: pointer;\n  outline: none; }\n  .LightboxDialog__closeButtonIcon___3HcCb {\n    padding: 0;\n    margin: 0;\n    fill: #F0EFF1; }\n", ""]);

// exports
exports.locals = {
	"closeButton": "LightboxDialog__closeButton___1CBYh",
	"closeButtonIcon": "LightboxDialog__closeButtonIcon___3HcCb"
};

/***/ }),
/* 328 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(329);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsLightbox.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsLightbox.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActionsLightbox__lightbox__wrap___3_McO {\n  font-size: 14px/19px \"proxima-nova-a\", sans-serif;\n  text-align: center;\n  padding: 40px 17px 24px 17px; }\n  @media (min-width: 720px) {\n    .RelativesActionsLightbox__lightbox__wrap___3_McO {\n      width: 304px; } }\n\n.RelativesActionsLightbox__lightbox__title___1948F {\n  color: #D11F25;\n  font: 20px/26px \"proxima-nova-a-bold\", sans-serif;\n  margin: 0; }\n\n.RelativesActionsLightbox__lightbox__text___2mZ-2 {\n  font: 14px/19px \"proxima-nova-a\", sans-serif;\n  margin: 16px 0 0 0; }\n\n.RelativesActionsLightbox__lightbox__button___3ASNN {\n  margin: 16px 0 0 0;\n  width: 100%; }\n", ""]);

// exports
exports.locals = {
	"lightbox__wrap": "RelativesActionsLightbox__lightbox__wrap___3_McO",
	"lightbox__title": "RelativesActionsLightbox__lightbox__title___1948F",
	"lightbox__text": "RelativesActionsLightbox__lightbox__text___2mZ-2",
	"lightbox__button": "RelativesActionsLightbox__lightbox__button___3ASNN"
};

/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(331);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsNoteForm.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsNoteForm.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 331 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActionsNoteForm__root___2Ca4g {\n  display: flex;\n  padding: 0 0 16px 0; }\n  @media (max-width: 479.9px) {\n    .RelativesActionsNoteForm__root___2Ca4g {\n      flex-direction: column; } }\n\n.RelativesActionsNoteForm__spinner___2j4zk {\n  display: block;\n  margin: 16px auto;\n  -webkit-animation-name: RelativesActionsNoteForm__spinner___2j4zk;\n  animation-name: RelativesActionsNoteForm__spinner___2j4zk;\n  -webkit-animation-duration: .8s;\n  animation-duration: .8s;\n  -webkit-animation-iteration-count: infinite;\n  animation-iteration-count: infinite;\n  -webkit-animation-timing-function: linear;\n  animation-timing-function: linear;\n  -webkit-transform: translateZ(0);\n  transform: translateZ(0);\n  background-size: cover; }\n\n.RelativesActionsNoteForm__content___2OCpg {\n  flex: 1;\n  display: flex;\n  flex-direction: column; }\n\n.RelativesActionsNoteForm__comment___3M1Ki {\n  border: 1px solid #F0EFF1;\n  resize: none;\n  outline: none;\n  font: 16px/22px \"proxima-nova-a\", sans-serif;\n  flex: 1;\n  min-height: 56px;\n  margin: 8px 0 0 0;\n  padding: 4px; }\n\n.RelativesActionsNoteForm__rating___2Nmrz {\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-end;\n  height: 16px;\n  margin: 8px 0 0 0; }\n  .RelativesActionsNoteForm__ratingInput___4Ug10 {\n    margin: 0 8px; }\n  .RelativesActionsNoteForm__ratingClear___2OEqt {\n    background: none;\n    border: none;\n    outline: none;\n    cursor: pointer;\n    height: 16px;\n    padding: 0; }\n    .RelativesActionsNoteForm__ratingClearIcon___FtcHb {\n      fill: #F0EFF1; }\n\n.RelativesActionsNoteForm__panel___1c5W6 {\n  display: flex;\n  flex-direction: column;\n  margin: 0 0 0 8px; }\n  @media (max-width: 479.9px) {\n    .RelativesActionsNoteForm__panel___1c5W6 {\n      flex-direction: row-reverse;\n      justify-content: flex-start;\n      flex: 1;\n      margin-top: 8px; } }\n  .RelativesActionsNoteForm__panelButton___1UOpg {\n    width: 60px;\n    margin: 8px 0 0;\n    padding: 0; }\n    @media (max-width: 479.9px) {\n      .RelativesActionsNoteForm__panelButton___1UOpg {\n        margin-left: 8px; } }\n    .RelativesActionsNoteForm__panelButton___1UOpg:disabled {\n      opacity: .4; }\n\n.RelativesActionsNoteForm__saveIcon___28otZ {\n  fill: #FFFFFF;\n  margin: -1px 2px 0 0; }\n\n.RelativesActionsNoteForm__here___2STOf {\n  background: none;\n  border: none;\n  outline: none;\n  font-family: \"proxima-nova-a-bold\", sans-serif;\n  cursor: pointer;\n  margin: 0;\n  padding: 0; }\n", ""]);

// exports
exports.locals = {
	"root": "RelativesActionsNoteForm__root___2Ca4g",
	"spinner": "RelativesActionsNoteForm__spinner___2j4zk",
	"content": "RelativesActionsNoteForm__content___2OCpg",
	"comment": "RelativesActionsNoteForm__comment___3M1Ki",
	"rating": "RelativesActionsNoteForm__rating___2Nmrz",
	"ratingInput": "RelativesActionsNoteForm__ratingInput___4Ug10",
	"ratingClear": "RelativesActionsNoteForm__ratingClear___2OEqt",
	"ratingClearIcon": "RelativesActionsNoteForm__ratingClearIcon___FtcHb",
	"panel": "RelativesActionsNoteForm__panel___1c5W6",
	"panelButton": "RelativesActionsNoteForm__panelButton___1UOpg",
	"saveIcon": "RelativesActionsNoteForm__saveIcon___28otZ",
	"here": "RelativesActionsNoteForm__here___2STOf"
};

/***/ }),
/* 332 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesActionsLink = __webpack_require__(333);

var _RelativesActionsLink2 = _interopRequireDefault(_RelativesActionsLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesActionsLink2.default;

/***/ }),
/* 333 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesActionsLink;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _RelativesActionsLink = __webpack_require__(334);

var _RelativesActionsLink2 = _interopRequireDefault(_RelativesActionsLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesActionsLink(_ref) {
    var className = _ref.className,
        href = _ref.href,
        label = _ref.label,
        iconClassName = _ref.iconClassName,
        icon = _ref.icon;

    return _react2.default.createElement(
        'a',
        {
            className: _RelativesActionsLink2.default.root + ' ' + className + ' ui-link ui-link_table',
            href: href,
            target: '_blank',
            rel: 'noopener noreferrer'
        },
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            className: _RelativesActionsLink2.default.icon + ' ' + iconClassName,
            size: 'Medium',
            iconName: icon
        }),
        label
    );
}

RelativesActionsLink.propTypes = {
    className: _propTypes2.default.string,
    href: _propTypes2.default.string.isRequired,
    label: _propTypes2.default.string.isRequired,
    iconClassName: _propTypes2.default.string,
    icon: _propTypes2.default.string.isRequired
};

RelativesActionsLink.defaultProps = {
    className: '',
    iconClassName: ''
};

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(335);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsLink.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./RelativesActionsLink.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActionsLink__root___3EplX {\n  display: flex;\n  align-items: center;\n  padding: 0;\n  background: none;\n  border: none;\n  color: #171717;\n  cursor: pointer;\n  font: 12px/17px \"proxima-nova-a\", sans-serif;\n  text-decoration: none;\n  outline: none; }\n\n.RelativesActionsLink__icon___3xtS8 {\n  margin-right: 4px; }\n", ""]);

// exports
exports.locals = {
	"root": "RelativesActionsLink__root___3EplX",
	"icon": "RelativesActionsLink__icon___3xtS8"
};

/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(337);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesActions.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesActions.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesActions__panel___f-dhn {\n  display: flex;\n  justify-content: center;\n  background-color: #F0EFF1; }\n  @media (max-width: 479.9px) {\n    .RelativesActions__panel___f-dhn {\n      flex-direction: column;\n      align-items: center; } }\n\n.RelativesActions__group___V_Qq0 {\n  display: flex;\n  margin: 4px 0; }\n\n.RelativesActions__action___3OSvl {\n  margin: 0 8px; }\n  .RelativesActions__action___3OSvl:hover {\n    text-decoration: underline; }\n\n.RelativesActions__catalogueIcon___2h42X {\n  fill: #D11F25; }\n\n.RelativesActions__form___3E953 {\n  padding: 0 8px 8px; }\n", ""]);

// exports
exports.locals = {
	"panel": "RelativesActions__panel___f-dhn",
	"group": "RelativesActions__group___V_Qq0",
	"action": "RelativesActions__action___3OSvl",
	"catalogueIcon": "RelativesActions__catalogueIcon___2h42X",
	"form": "RelativesActions__form___3E953"
};

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    BLOODSTOCK_REPORTS: 'https://www.bloodstockreports.co.uk'
};

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesResults = __webpack_require__(340);

var _RelativesResults2 = _interopRequireDefault(_RelativesResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesResults2.default;

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Filter = __webpack_require__(341);

var _Filter2 = _interopRequireDefault(_Filter);

var _Breakpoints = __webpack_require__(10);

var _Table = __webpack_require__(18);

var _Table2 = _interopRequireDefault(_Table);

var _Cell = __webpack_require__(13);

var _Tab = __webpack_require__(31);

var _Tab2 = _interopRequireDefault(_Tab);

var _api = __webpack_require__(7);

var _RelativesResults = __webpack_require__(358);

var _RelativesResults2 = _interopRequireDefault(_RelativesResults);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EXTRA_NARROW = _Breakpoints.codes.EXTRA_NARROW,
    NARROW = _Breakpoints.codes.NARROW,
    MEDIUM = _Breakpoints.codes.MEDIUM,
    WIDE = _Breakpoints.codes.WIDE,
    EXTRA_WIDE = _Breakpoints.codes.EXTRA_WIDE;


function getParamOptions(parameters, name) {
    return ((parameters.find(function (param) {
        return param.name === name;
    }) || {}).options || []).map(function (_ref) {
        var value = _ref.value,
            displayName = _ref.displayName;
        return {
            value: value,
            label: displayName
        };
    });
}
function getSelectedValue(filter) {
    return filter && filter.options.find(function (option) {
        return option.selected;
    }).value;
}

function setCategories(_ref2, flat, jumps) {
    var raceType = _ref2.raceType,
        yearFlat = _ref2.yearFlat,
        yearJumps = _ref2.yearJumps;

    var params = {
        raceType: {
            title: 'Race Type',
            options: [flat.length > 0 && { value: 'flat', label: 'Flat' }, jumps.length > 0 && { value: 'jumps', label: 'Jumps' }].filter(function (item) {
                return !!item;
            })
        }
    };
    params.raceType.options.forEach(function (option) {
        if (option.value === raceType) option.selected = true;
    });

    if (raceType === 'flat' && flat.length > 0) {
        params.yearFlat = {
            title: 'Time period',
            options: flat
        };
        params.yearFlat.options.forEach(function (option) {
            if (option.value === yearFlat) option.selected = true;
        });
    } else if (raceType === 'jumps' && jumps.length > 0) {
        params.yearJumps = {
            title: 'Time period',
            options: jumps
        };
        params.yearJumps.options.forEach(function (option) {
            if (option.value === yearJumps) option.selected = true;
        });
    }

    return params;
}

var RelativesResults = function (_PureComponent) {
    _inherits(RelativesResults, _PureComponent);

    function RelativesResults() {
        var _ref3;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesResults);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = RelativesResults.__proto__ || Object.getPrototypeOf(RelativesResults)).call.apply(_ref3, [this].concat(args))), _this), _this.state = {
            results: [],
            flat: [],
            jumps: [],
            fetching: true,
            sort: 'horse_name',
            categories: {}
        }, _this.handleFilterApply = function (categories) {
            return _this.reloadResults({ categories: categories });
        }, _this.handleTableSort = function (sort) {
            return _this.reloadResults({ sort: sort });
        }, _this.categoriesReducer = function (categories) {
            return categories;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesResults, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            Promise.all([this.fetchSeasons(), this.fetchResults()]).then(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    seasons = _ref5[0],
                    results = _ref5[1];

                var _seasons$defaults = seasons.defaults,
                    yearFlat = _seasons$defaults.yearFlat,
                    yearJumps = _seasons$defaults.yearJumps,
                    parameters = seasons.parameters;

                var filter = {
                    yearFlat: yearFlat,
                    yearJumps: yearJumps,
                    raceType: results.length ? results[0].main_type.toLowerCase() : null
                };
                var flat = getParamOptions(parameters, 'yearFlat');
                var jumps = getParamOptions(parameters, 'yearJumps');

                _this2.setState({
                    results: results,
                    flat: flat,
                    jumps: jumps,
                    fetching: false,
                    categories: setCategories(filter, flat, jumps)
                });
            }).catch(function () {
                return _this2.setState({ fetching: false });
            });
        }
    }, {
        key: 'getTableColumns',
        value: function getTableColumns() {
            var breakpointCode = this.props.breakpointCode;

            var exNarrow = breakpointCode === EXTRA_NARROW;
            var exWide = breakpointCode === EXTRA_WIDE;
            var fromNarrow = [NARROW, MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            var fromMedium = [MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            var toMedium = [EXTRA_NARROW, NARROW].includes(breakpointCode);
            return [{
                className: _RelativesResults2.default.table__horse,
                name: 'horse_name',
                head: 'Horse',
                cell: { children: _Cell.CellHorse }
            }, {
                className: _RelativesResults2.default.table__sire,
                name: 'sire_name',
                head: exWide ? 'Sire' : 'Sire (Awd)',
                cell: { children: _Cell.CellSire }
            }, fromMedium && {
                className: _RelativesResults2.default.table__wins,
                name: 'wins',
                head: 'Wins'
            }, fromMedium && {
                className: _RelativesResults2.default.table__places,
                name: 'places',
                head: 'Places'
            }, fromMedium && {
                className: _RelativesResults2.default.table__runs,
                name: 'runs',
                head: 'Runs'
            }, toMedium && {
                className: _RelativesResults2.default.table__winsRuns,
                name: 'wins_runs',
                head: exNarrow ? 'W / R' : 'Wins / Runs'
            }, fromMedium && {
                className: _RelativesResults2.default.table__prize,
                name: 'prize',
                head: '\xA3 Prize'
            }, fromNarrow && {
                className: _RelativesResults2.default.table__rpr,
                name: 'rpr',
                head: 'Rpr'
            }, fromMedium && {
                className: _RelativesResults2.default.table__dist,
                name: 'dist',
                head: 'Dist'
            }].filter(function (column) {
                return !!column;
            });
        }
    }, {
        key: 'fetchSeasons',
        value: function fetchSeasons() {
            var damUid = this.props.damUid;

            return (0, _api.callApi)('/bloodstock/sales/relatives/results/seasons/' + damUid + '/data.json').catch(function () {
                return {
                    defaults: { yearFlat: null, yearJumps: null },
                    parameters: []
                };
            });
        }
    }, {
        key: 'fetchResults',
        value: function fetchResults(nextState) {
            var damUid = this.props.damUid;
            var sort = this.state.sort;

            var raceType = nextState && getSelectedValue(nextState.raceType);
            var query = {
                sort: sort,
                filter: {
                    raceType: raceType,
                    year: function () {
                        switch (raceType) {
                            case 'flat':
                                return getSelectedValue(nextState.yearFlat);
                            case 'jumps':
                                return getSelectedValue(nextState.yearJumps);
                            default:
                                return null;
                        }
                    }()
                }
            };
            return (0, _api.callApi)('/bloodstock/sales/relatives/results/' + damUid + '/data.json', { query: query }).then(function (data) {
                return data.rows;
            }).catch(function () {
                return [];
            });
        }
    }, {
        key: 'reloadResults',
        value: function reloadResults(nextState) {
            var _this3 = this;

            this.setState(_extends({}, nextState, { fetching: true }));
            this.fetchResults(nextState).then(function (results) {
                return _this3.setState({ results: results, fetching: false });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var onTabChange = this.props.onTabChange;
            var _state = this.state,
                results = _state.results,
                fetching = _state.fetching,
                sort = _state.sort,
                categories = _state.categories;

            return _react2.default.createElement(
                _Tab2.default,
                {
                    tab: _Tab2.default.TAB_RESULTS,
                    filter: !fetching && _react2.default.createElement(
                        'div',
                        { className: _RelativesResults2.default.filter + ' RelativesResults__filter' },
                        _react2.default.createElement(_Filter2.default, {
                            onFilterApply: this.handleFilterApply,
                            categories: categories,
                            categoriesReducer: this.categoriesReducer
                        })
                    ),
                    onTabChange: onTabChange
                },
                _react2.default.createElement(_Table2.default, {
                    className: _RelativesResults2.default.table,
                    type: 5,
                    placeholder: 'No relatives results in our records',
                    loading: fetching,
                    columns: this.getTableColumns(),
                    data: results,
                    canSortByColumn: function canSortByColumn() {
                        return true;
                    },
                    sorting: _defineProperty({}, sort, 'asc'),
                    onSort: this.handleTableSort
                })
            );
        }
    }]);

    return RelativesResults;
}(_react.PureComponent);

RelativesResults.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    // it's assumed that props 'damUid'
    // do not change after component rendered
    damUid: _propTypes2.default.number.isRequired,
    onTabChange: _propTypes2.default.func.isRequired
};
exports.default = (0, _Breakpoints.bindCode)(RelativesResults);

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.selection = undefined;

var _Filter = __webpack_require__(342);

var _Filter2 = _interopRequireDefault(_Filter);

var _selection = __webpack_require__(89);

var _selection2 = _interopRequireDefault(_selection);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.selection = _selection2.default;
exports.default = _Filter2.default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Popover = __webpack_require__(343);

var _Popover2 = _interopRequireDefault(_Popover);

var _FilterStatus = __webpack_require__(356);

var _FilterStatus2 = _interopRequireDefault(_FilterStatus);

var _updateCategories = __webpack_require__(357);

var _updateCategories2 = _interopRequireDefault(_updateCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = function (_PureComponent) {
    _inherits(Filter, _PureComponent);

    function Filter(props) {
        _classCallCheck(this, Filter);

        var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

        _this.dispatch = function (action) {
            var categoriesReducer = _this.props.categoriesReducer;


            _this.setState(function (_ref) {
                var categories = _ref.categories;
                return {
                    categories: (0, _updateCategories2.default)(categories, categoriesReducer, action)
                };
            });
        };

        _this.resetCategories = function () {
            _this.setState({ categories: _this.props.categories });
        };

        _this.applyFilter = function () {
            _this.props.onFilterApply(_this.state.categories);
        };

        _this.state = {
            categories: props.categories
        };
        return _this;
    }

    _createClass(Filter, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var categories = _ref2.categories;

            this.setState({ categories: categories });
        }

        /**
         * When some option is changed we are using two reducers
         * (one that passed through props and one that change selected option)
         * to handle options transformations
         */

    }, {
        key: 'render',
        value: function render() {
            var children = this.props.children;
            var categories = this.state.categories;


            if (!categories) return null;

            return _react2.default.createElement(
                'div',
                { className: 'cmn-filter' },
                children || _react2.default.createElement(_FilterStatus2.default, { categories: this.props.categories }),
                _react2.default.createElement(_Popover2.default, {
                    categories: categories,
                    resetCategories: this.resetCategories,
                    applyFilter: this.applyFilter,
                    dispatch: this.dispatch
                })
            );
        }
    }]);

    return Filter;
}(_react.PureComponent);

Filter.defaultProps = {
    categoriesReducer: function categoriesReducer(categories) {
        return categories;
    }
};

var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
Filter.propTypes = {
    categories: _propTypes2.default.objectOf(_propTypes2.default.shape({
        title: _propTypes2.default.string.isRequired,
        options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            value: strOrNum.isRequired,
            label: strOrNum.isRequired,
            statusLabel: strOrNum
        }))
    })),
    categoriesReducer: _propTypes2.default.func,
    children: _propTypes2.default.node,
    onFilterApply: _propTypes2.default.func.isRequired
};

exports.default = Filter;

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _PopoverComponent2 = __webpack_require__(344);

var _PopoverComponent3 = _interopRequireDefault(_PopoverComponent2);

var _PopoverHeader = __webpack_require__(346);

var _PopoverHeader2 = _interopRequireDefault(_PopoverHeader);

var _PopoverFooter = __webpack_require__(347);

var _PopoverFooter2 = _interopRequireDefault(_PopoverFooter);

var _PopoverBody = __webpack_require__(348);

var _PopoverBody2 = _interopRequireDefault(_PopoverBody);

var _getFilterPosition = __webpack_require__(355);

var _getFilterPosition2 = _interopRequireDefault(_getFilterPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popover = function (_PopoverComponent) {
    _inherits(Popover, _PopoverComponent);

    function Popover() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Popover);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.closePopover = function () {
            _this.setState({ expanded: false });
            _this.props.resetCategories();
        }, _this.openPopover = function (_ref2) {
            var currentTarget = _ref2.currentTarget;

            _this.setState({
                expanded: true,
                position: (0, _getFilterPosition2.default)(currentTarget)
            });
        }, _this.applyFilter = function () {
            _this.props.applyFilter();
            _this.setState({ expanded: false });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * Overriding "closePopover" function from PopoverComponent.
     * So when popover is closed, categories went back to default
     */


    /**
     * Overriding "openPopover" function from PopoverComponent.
     * So we can calculate position of filter popover
     */


    _createClass(Popover, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                expanded = _state.expanded,
                position = _state.position;
            var _props = this.props,
                categories = _props.categories,
                dispatch = _props.dispatch;


            return _react2.default.createElement(
                'div',
                { ref: function ref(node) {
                        _this2.node = node;
                    } },
                _react2.default.createElement(
                    'button',
                    {
                        className: 'ui-btn ui-btn_tiertiary',
                        onClick: this.togglePopover
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, {
                        iconName: 'filter',
                        size: 'Medium',
                        className: 'cmn-filter__btnIcon tableShowIcon'
                    }),
                    'Filter'
                ),
                expanded && _react2.default.createElement(
                    'div',
                    { className: 'ui-popover cmn-filter__popover pos_' + position },
                    _react2.default.createElement('div', { className: 'cmn-filter__pointer ui-popoverPointer' }),
                    _react2.default.createElement(_PopoverHeader2.default, {
                        cancelFilter: this.closePopover
                    }),
                    _react2.default.createElement(_PopoverBody2.default, {
                        categories: categories,
                        dispatch: dispatch
                    }),
                    _react2.default.createElement(_PopoverFooter2.default, {
                        cancelFilter: this.closePopover,
                        applyFilter: this.applyFilter
                    })
                )
            );
        }
    }]);

    return Popover;
}(_PopoverComponent3.default);

Popover.propTypes = {
    categories: _propTypes2.default.shape({}),
    resetCategories: _propTypes2.default.func.isRequired,
    applyFilter: _propTypes2.default.func.isRequired
};

exports.default = Popover;

/***/ }),
/* 344 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PopoverComponent = __webpack_require__(345);

var _PopoverComponent2 = _interopRequireDefault(_PopoverComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PopoverComponent2.default;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverComponent = function (_PureComponent) {
    _inherits(PopoverComponent, _PureComponent);

    function PopoverComponent(props) {
        _classCallCheck(this, PopoverComponent);

        var _this = _possibleConstructorReturn(this, (PopoverComponent.__proto__ || Object.getPrototypeOf(PopoverComponent)).call(this, props));

        _this.onOutsideClick = function (event) {
            var domNode = _this.node;
            if (!domNode || !domNode.contains(event.target)) {
                _this.closePopover();
            }
        };

        _this.closePopover = function () {
            _this.setState({ expanded: false });
        };

        _this.openPopover = function () {
            _this.setState({ expanded: true });
        };

        _this.togglePopover = function (e) {
            if (_this.state.expanded) {
                _this.closePopover(e);
            } else {
                _this.openPopover(e);
            }
        };

        _this.state = { expanded: false };
        return _this;
    }

    _createClass(PopoverComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.onOutsideClick, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.onOutsideClick, true);
        }
    }]);

    return PopoverComponent;
}(_react.PureComponent);

exports.default = PopoverComponent;

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PopoverHeader = function PopoverHeader(_ref) {
    var cancelFilter = _ref.cancelFilter;
    return _react2.default.createElement(
        'div',
        { className: 'ui-popoverHeader cmn-filter__popoverHeader' },
        'Choose Filters',
        _react2.default.createElement(
            'button',
            {
                className: 'ui-btn ui-btn_secondary cmn-filter__crossBtn',
                onClick: cancelFilter
            },
            _react2.default.createElement(_rpReactSvgIcon2.default, { isInlined: true, iconName: 'cross', className: 'tableShowIcon', size: 'Medium' })
        )
    );
};

PopoverHeader.propTypes = {
    cancelFilter: _propTypes2.default.func.isRequired
};

exports.default = PopoverHeader;

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var btnCls = 'cmn-filter__footerBtn ui-btn';

var PopoverFooter = function PopoverFooter(_ref) {
    var cancelFilter = _ref.cancelFilter,
        applyFilter = _ref.applyFilter;
    return _react2.default.createElement(
        'div',
        { className: 'cmn-filter__popoverFooter' },
        _react2.default.createElement(
            'button',
            {
                className: btnCls + ' ' + btnCls + '_secondary',
                onClick: cancelFilter
            },
            'Cancel'
        ),
        _react2.default.createElement(
            'button',
            {
                className: btnCls + ' ' + btnCls + '_primary',
                onClick: applyFilter
            },
            'Apply'
        )
    );
};

PopoverFooter.propTypes = {
    applyFilter: _propTypes2.default.func.isRequired,
    cancelFilter: _propTypes2.default.func.isRequired
};

exports.default = PopoverFooter;

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _entries = __webpack_require__(88);

var _entries2 = _interopRequireDefault(_entries);

var _Category = __webpack_require__(353);

var _Category2 = _interopRequireDefault(_Category);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverBody = function (_PureComponent) {
    _inherits(PopoverBody, _PureComponent);

    function PopoverBody(props) {
        _classCallCheck(this, PopoverBody);

        var _this = _possibleConstructorReturn(this, (PopoverBody.__proto__ || Object.getPrototypeOf(PopoverBody)).call(this, props));

        _initialiseProps.call(_this);

        var expandedCategory = (0, _entries2.default)(props.categories).length === 1 ? (0, _entries2.default)(props.categories)[0][0] : null;

        _this.state = { expandedCategory: expandedCategory };
        return _this;
    }

    // setting current expanded category


    _createClass(PopoverBody, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                categories = _props.categories,
                dispatch = _props.dispatch;
            var expandedCategory = this.state.expandedCategory;


            return _react2.default.createElement(
                'div',
                { className: 'cmn-filter__popoverBody' },
                (0, _entries2.default)(categories).map(function (_ref) {
                    var _ref2 = _slicedToArray(_ref, 2),
                        categoryName = _ref2[0],
                        category = _ref2[1];

                    return _react2.default.createElement(_Category2.default, {
                        key: categoryName,
                        type: categoryName,
                        toggleExpanded: _this2.toggleExpanded,
                        expanded: expandedCategory === categoryName,
                        title: category.title,
                        options: category.options,
                        dispatch: dispatch,
                        isHidden: category.isHidden
                    });
                })
            );
        }
    }]);

    return PopoverBody;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.toggleExpanded = function (category) {
        _this3.setState(function (_ref3) {
            var expandedCategory = _ref3.expandedCategory;
            return {
                expandedCategory: expandedCategory === category ? null : category
            };
        });
    };
};

PopoverBody.propTypes = {
    categories: _propTypes2.default.shape({}),
    dispatch: _propTypes2.default.func.isRequired
};

exports.default = PopoverBody;

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

var createToPairs = __webpack_require__(350),
    keys = __webpack_require__(36);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

var baseToPairs = __webpack_require__(351),
    getTag = __webpack_require__(57),
    mapToArray = __webpack_require__(50),
    setToPairs = __webpack_require__(352);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(64);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),
/* 352 */
/***/ (function(module, exports) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _Option = __webpack_require__(354);

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Category = function Category(_ref) {
    var type = _ref.type,
        options = _ref.options,
        title = _ref.title,
        dispatch = _ref.dispatch,
        expanded = _ref.expanded,
        toggleExpanded = _ref.toggleExpanded,
        isHidden = _ref.isHidden;
    return options && !isHidden ? _react2.default.createElement(
        'div',
        {
            className: 'cmn-filter__category',
            onClick: function onClick() {
                return toggleExpanded(type);
            }
        },
        _react2.default.createElement(
            'div',
            {
                className: (0, _classnames2.default)('ui-accordion__header', 'cmn-filter__categoryRow', { 'ui-accordion__header_active': expanded })
            },
            _react2.default.createElement(
                'span',
                { className: 'cmn-filter__categoryName' },
                title,
                _react2.default.createElement(
                    'span',
                    { className: 'cmn-filter__categorySelected' },
                    options.find(function (option) {
                        return option.selected;
                    }).label !== 'No filter' && options.find(function (option) {
                        return option.selected;
                    }).label
                )
            ),
            _react2.default.createElement(_rpReactSvgIcon2.default, {
                iconName: 'minus',
                size: 'Medium',
                className: 'accordionMinus ui-accordion__arrow tableShowIcon'
            }),
            _react2.default.createElement(_rpReactSvgIcon2.default, {
                iconName: 'plus',
                size: 'Medium',
                className: 'accordionPlus ui-accordion__arrow tableShowIcon'
            })
        ),
        expanded && _react2.default.createElement(
            'ul',
            null,
            options.map(function (_ref2) {
                var value = _ref2.value,
                    label = _ref2.label,
                    selected = _ref2.selected;
                return _react2.default.createElement(_Option2.default, {
                    key: label,
                    label: label,
                    selected: selected,
                    onClick: function onClick() {
                        return dispatch({ type: type, value: value, label: label });
                    }
                });
            })
        )
    ) : null;
}; /* eslint jsx-a11y/no-static-element-interactions:0 */


var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
Category.propTypes = {
    title: _propTypes2.default.string.isRequired,
    type: _propTypes2.default.string.isRequired,
    dispatch: _propTypes2.default.func.isRequired,
    options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        value: strOrNum.isRequired,
        label: strOrNum.isRequired
    })),
    expanded: _propTypes2.default.bool,
    toggleExpanded: _propTypes2.default.func,
    isHidden: _propTypes2.default.bool
};

exports.default = Category;

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(5);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint jsx-a11y/no-static-element-interactions:0 */
var Option = function Option(_ref) {
    var label = _ref.label,
        selected = _ref.selected,
        onClick = _ref.onClick;
    return _react2.default.createElement(
        'li',
        {
            className: (0, _classnames2.default)('ui-popoverList__link cmn-filter__option', selected && 'cmn-filter__option_selected'),
            onClick: onClick
        },
        label,
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            isInlined: true,
            iconName: 'tick',
            size: 'Medium',
            className: 'cmn-filter__optionTick tableShowIcon'
        })
    );
};

Option.propTypes = {
    label: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]).isRequired,
    selected: _propTypes2.default.bool,
    onClick: _propTypes2.default.func.isRequired
};

exports.default = Option;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var requiredHeight = 450;

var getFilterPosition = function getFilterPosition(btn) {
    var _btn$getBoundingClien = btn.getBoundingClientRect(),
        topSpace = _btn$getBoundingClien.top,
        bottom = _btn$getBoundingClien.bottom;

    var bottomSpace = window.innerHeight - bottom;

    if (bottomSpace > requiredHeight) {
        return 'bottom';
    } else if (topSpace > requiredHeight) {
        return 'top';
    }
    return 'left';
};

exports.default = getFilterPosition;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _selection = __webpack_require__(89);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prefer-stateless-function: 0 */


var FilterStatus = function (_PureComponent) {
    _inherits(FilterStatus, _PureComponent);

    function FilterStatus() {
        _classCallCheck(this, FilterStatus);

        return _possibleConstructorReturn(this, (FilterStatus.__proto__ || Object.getPrototypeOf(FilterStatus)).apply(this, arguments));
    }

    _createClass(FilterStatus, [{
        key: 'render',
        value: function render() {
            var labels = (0, _selection.getStatusLabels)(this.props.categories);

            return _react2.default.createElement(
                'h2',
                { className: 'cmn-filter__status' },
                Object.values(labels).filter(function (label) {
                    return label && label !== 'No filter';
                }).join(', ')
            );
        }
    }]);

    return FilterStatus;
}(_react.PureComponent);

var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
FilterStatus.propTypes = {
    categories: _propTypes2.default.shape({
        options: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            value: strOrNum.isRequired,
            label: strOrNum.isRequired,
            statusLabel: strOrNum
        }))
    }).isRequired
};

exports.default = FilterStatus;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toggleSelected = function toggleSelected(arr, value) {
    return arr.map(function (item) {
        if (item.value === value) {
            return _extends({}, item, { selected: true });
        }
        if (item.selected) {
            return _extends({}, item, { selected: false });
        }
        return item;
    });
};

var setSelectReducer = function setSelectReducer(categories, _ref) {
    var type = _ref.type,
        value = _ref.value;
    return _extends({}, categories, _defineProperty({}, type, _extends({}, categories[type], {
        options: toggleSelected(categories[type].options, value)
    })));
};

/**
 * When some option is changed we are using two reducers
 * (one that passed through props and one that change selected option)
 * to handle options transformations
 */
var updateCategories = function updateCategories(categories, reducer, action) {
    return setSelectReducer(reducer(categories, action), action);
};

exports.default = updateCategories;

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(359);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesResults.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesResults.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.RelativesResults__table___20RTN .ui-table__cell {\n  background: transparent !important; }\n\n.RelativesResults__table__horse___2YpNy, .RelativesResults__table__sire___1IWym {\n  text-align: left !important; }\n\n.RelativesResults__table__wins___2g6qq, .RelativesResults__table__places___3AYx_, .RelativesResults__table__runs___3eZ4X {\n  text-align: center !important; }\n\n.RelativesResults__table__prize___3x0kn, .RelativesResults__table__rpr___2sVT4, .RelativesResults__table__dist___18K77 {\n  text-align: right !important; }\n\n.RelativesResults__table__horse___2YpNy {\n  padding-right: 4px !important; }\n\n@media (max-width: 479.9px) {\n  .RelativesResults__table__horse___2YpNy {\n    width: 38%; }\n  .RelativesResults__table__sire___1IWym {\n    width: 40%; }\n  .RelativesResults__table__winsRuns___Tyf9q {\n    text-align: right !important;\n    width: 22%; } }\n\n@media (min-width: 480px) and (max-width: 719.9px) {\n  .RelativesResults__table__horse___2YpNy, .RelativesResults__table__sire___1IWym {\n    width: 30%; }\n  .RelativesResults__table__winsRuns___Tyf9q {\n    width: 25%; }\n  .RelativesResults__table__rpr___2sVT4 {\n    width: 15%; }\n  .RelativesResults__table__winsRuns___Tyf9q {\n    text-align: center !important; } }\n\n@media (min-width: 720px) {\n  .RelativesResults__table__horse___2YpNy {\n    width: 23%; }\n  .RelativesResults__table__sire___1IWym {\n    width: 20%; }\n  .RelativesResults__table__wins___2g6qq {\n    width: 10%; }\n  .RelativesResults__table__places___3AYx_ {\n    width: 11%; }\n  .RelativesResults__table__runs___3eZ4X {\n    width: 9%; }\n  .RelativesResults__table__prize___3x0kn {\n    width: 11%; }\n  .RelativesResults__table__rpr___2sVT4, .RelativesResults__table__dist___18K77 {\n    width: 8%; } }\n\n.RelativesResults__filter___1bVpy {\n  display: flex;\n  align-items: center; }\n  .RelativesResults__filter__status___1x5Re {\n    font: 16px/22px \"proxima-nova-a-bold\", sans-serif; }\n  .RelativesResults__filter__filter___2IgyI {\n    margin: 0 0 0 8px; }\n", ""]);

// exports
exports.locals = {
	"table": "RelativesResults__table___20RTN",
	"table__horse": "RelativesResults__table__horse___2YpNy",
	"table__sire": "RelativesResults__table__sire___1IWym",
	"table__wins": "RelativesResults__table__wins___2g6qq",
	"table__places": "RelativesResults__table__places___3AYx_",
	"table__runs": "RelativesResults__table__runs___3eZ4X",
	"table__prize": "RelativesResults__table__prize___3x0kn",
	"table__rpr": "RelativesResults__table__rpr___2sVT4",
	"table__dist": "RelativesResults__table__dist___18K77",
	"table__winsRuns": "RelativesResults__table__winsRuns___Tyf9q",
	"filter": "RelativesResults__filter___1bVpy",
	"filter__status": "RelativesResults__filter__status___1x5Re",
	"filter__filter": "RelativesResults__filter__filter___2IgyI"
};

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesEntries = __webpack_require__(361);

var _RelativesEntries2 = _interopRequireDefault(_RelativesEntries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesEntries2.default;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Breakpoints = __webpack_require__(10);

var _Table = __webpack_require__(18);

var _Table2 = _interopRequireDefault(_Table);

var _Cell = __webpack_require__(13);

var _Tab = __webpack_require__(31);

var _Tab2 = _interopRequireDefault(_Tab);

var _api = __webpack_require__(7);

var _RelativesEntries = __webpack_require__(362);

var _RelativesEntries2 = _interopRequireDefault(_RelativesEntries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MEDIUM = _Breakpoints.codes.MEDIUM,
    WIDE = _Breakpoints.codes.WIDE,
    EXTRA_WIDE = _Breakpoints.codes.EXTRA_WIDE;

var RelativesEntries = function (_PureComponent) {
    _inherits(RelativesEntries, _PureComponent);

    function RelativesEntries() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesEntries);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelativesEntries.__proto__ || Object.getPrototypeOf(RelativesEntries)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            data: [],
            fetching: true,
            sort: 'date'
        }, _this.handleSort = function (sort) {
            return _this.fetchData({ sort: sort });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesEntries, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchData();
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var damUid = _ref2.damUid;

            if (damUid !== this.props.damUid) {
                this.fetchData();
            }
        }
    }, {
        key: 'getColumns',
        value: function getColumns() {
            var fromMedium = [MEDIUM, WIDE, EXTRA_WIDE].includes(this.props.breakpointCode);
            return [{
                className: _RelativesEntries2.default.table__horse,
                name: 'horse_name',
                head: 'Horse',
                cell: { children: _Cell.CellHorse }
            }, fromMedium && {
                className: _RelativesEntries2.default.table__title,
                name: 'title',
                head: 'Title',
                cell: { children: _Cell.CellRace }
            }, {
                className: _RelativesEntries2.default.table__course,
                name: 'course_time',
                head: 'Course / Time'
            }, {
                className: _RelativesEntries2.default.table__places,
                name: 'date',
                head: 'Date'
            }].filter(function (column) {
                return !!column;
            });
        }
    }, {
        key: 'fetchData',
        value: function fetchData(nextState) {
            var _this2 = this;

            this.setState(_extends({}, nextState, { fetching: true }));

            var damUid = this.props.damUid;

            var _state$nextState = _extends({}, this.state, nextState),
                sort = _state$nextState.sort;

            (0, _api.callApi)('/bloodstock/sales/relatives/entries/' + damUid + '/data.json', { query: { sort: sort } }).then(function (data) {
                return data.rows;
            }).catch(function () {
                return [];
            }).then(function (data) {
                return _this2.setState({ data: data, fetching: false });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var onTabChange = this.props.onTabChange;
            var _state = this.state,
                data = _state.data,
                fetching = _state.fetching,
                sort = _state.sort;

            return _react2.default.createElement(
                _Tab2.default,
                {
                    tab: _Tab2.default.TAB_ENTRIES,
                    onTabChange: onTabChange
                },
                _react2.default.createElement(_Table2.default, {
                    className: _RelativesEntries2.default.table,
                    type: 5,
                    placeholder: 'No relatives entries in our records',
                    loading: fetching,
                    columns: this.getColumns(),
                    data: data,
                    sorting: _defineProperty({}, sort, 'asc'),
                    canSortByColumn: function canSortByColumn() {
                        return true;
                    },
                    onSort: this.handleSort
                })
            );
        }
    }]);

    return RelativesEntries;
}(_react.PureComponent);

RelativesEntries.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    // it's assumed that props 'damUid'
    // do not change after component rendered
    damUid: _propTypes2.default.number.isRequired,
    onTabChange: _propTypes2.default.func.isRequired
};
exports.default = (0, _Breakpoints.bindCode)(RelativesEntries);

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(363);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesEntries.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesEntries.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".RelativesEntries__table___38-P_ .ui-table__cell {\n  background: transparent !important; }\n\n.RelativesEntries__table__horse___3zPI9, .RelativesEntries__table__title___YbcGg {\n  text-align: left !important; }\n\n.RelativesEntries__table__course___34Hvb, .RelativesEntries__table__date___1dgEf {\n  text-align: right !important; }\n\n.RelativesEntries__table__horse___3zPI9 {\n  padding-right: 4px !important; }\n\n@media (max-width: 719.9px) {\n  .RelativesEntries__table__horse___3zPI9, .RelativesEntries__table__course___34Hvb {\n    width: 40%; }\n  .RelativesEntries__table__date___1dgEf {\n    width: 20%; } }\n\n@media (min-width: 720px) {\n  .RelativesEntries__table__horse___3zPI9 {\n    width: 26%; }\n  .RelativesEntries__table__title___YbcGg {\n    width: 46%; }\n  .RelativesEntries__table__course___34Hvb {\n    width: 17%; }\n  .RelativesEntries__table__date___1dgEf {\n    width: 12%; } }\n", ""]);

// exports
exports.locals = {
	"table": "RelativesEntries__table___38-P_",
	"table__horse": "RelativesEntries__table__horse___3zPI9",
	"table__title": "RelativesEntries__table__title___YbcGg",
	"table__course": "RelativesEntries__table__course___34Hvb",
	"table__date": "RelativesEntries__table__date___1dgEf"
};

/***/ }),
/* 364 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _RelativesSales = __webpack_require__(365);

var _RelativesSales2 = _interopRequireDefault(_RelativesSales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _RelativesSales2.default;

/***/ }),
/* 365 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _format = __webpack_require__(38);

var _format2 = _interopRequireDefault(_format);

var _add_years = __webpack_require__(366);

var _add_years2 = _interopRequireDefault(_add_years);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Breakpoints = __webpack_require__(10);

var _Table = __webpack_require__(18);

var _Table2 = _interopRequireDefault(_Table);

var _Tab = __webpack_require__(31);

var _Tab2 = _interopRequireDefault(_Tab);

var _RelativesSalesCellHorse = __webpack_require__(367);

var _RelativesSalesCellHorse2 = _interopRequireDefault(_RelativesSalesCellHorse);

var _RelativesSalesCellSire = __webpack_require__(368);

var _RelativesSalesCellSire2 = _interopRequireDefault(_RelativesSalesCellSire);

var _RelativesSalesCellSale = __webpack_require__(369);

var _RelativesSalesCellSale2 = _interopRequireDefault(_RelativesSalesCellSale);

var _RelativesSalesCellPrice = __webpack_require__(370);

var _RelativesSalesCellPrice2 = _interopRequireDefault(_RelativesSalesCellPrice);

var _api = __webpack_require__(7);

var _RelativesSales = __webpack_require__(371);

var _RelativesSales2 = _interopRequireDefault(_RelativesSales);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NARROW = _Breakpoints.codes.NARROW,
    MEDIUM = _Breakpoints.codes.MEDIUM,
    WIDE = _Breakpoints.codes.WIDE,
    EXTRA_WIDE = _Breakpoints.codes.EXTRA_WIDE;


var DATE_OF_BIRTH_DIFF = 4;
var DATE_FORMAT = 'YYYY-MM-DD';

var RelativesSales = function (_PureComponent) {
    _inherits(RelativesSales, _PureComponent);

    function RelativesSales() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RelativesSales);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RelativesSales.__proto__ || Object.getPrototypeOf(RelativesSales)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            data: [],
            fetching: true,
            sort: 'horse_name'
        }, _this.handleSort = function (sort) {
            return _this.fetchData({ sort: sort });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RelativesSales, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.fetchData();
        }
    }, {
        key: 'fetchData',
        value: function fetchData(nextState) {
            var _this2 = this;

            this.setState(_extends({}, nextState, { fetching: true }));
            var _props = this.props,
                damUid = _props.damUid,
                birthDate = _props.birthDate,
                saleDate = _props.saleDate,
                lotNo = _props.lotNo,
                venueId = _props.venueId;

            var currentDate = (0, _format2.default)(Date.now(), DATE_FORMAT);
            var birthSaleDate = (0, _format2.default)((0, _add_years2.default)(birthDate, DATE_OF_BIRTH_DIFF), DATE_FORMAT);

            var _state$nextState = _extends({}, this.state, nextState),
                sort = _state$nextState.sort;

            var url = '/bloodstock/sales/relatives/sales/' + damUid + '/' + birthSaleDate + '/' + currentDate + '/data.json';
            var init = { query: { sort: sort, filter: { lotNo: lotNo, venueId: venueId, saleDate: saleDate } } };
            (0, _api.callApi)(url, init).then(function (json) {
                return json.rows;
            }).catch(function () {
                return [];
            }).then(function (data) {
                return _this2.setState({ data: data, fetching: false });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                breakpointCode = _props2.breakpointCode,
                onTabChange = _props2.onTabChange;
            var _state = this.state,
                data = _state.data,
                fetching = _state.fetching,
                sort = _state.sort;

            var fromNarrow = [NARROW, MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            var fromMedium = [MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            return _react2.default.createElement(
                _Tab2.default,
                {
                    tab: _Tab2.default.TAB_SALES,
                    onTabChange: onTabChange
                },
                _react2.default.createElement(_Table2.default, {
                    className: _RelativesSales2.default.table,
                    type: 5,
                    placeholder: 'No relatives sales in our records',
                    loading: fetching,
                    columns: [{
                        className: _RelativesSales2.default.table__horse,
                        name: 'horse_name',
                        head: 'Horse',
                        cell: { children: _RelativesSalesCellHorse2.default }
                    }, fromNarrow && {
                        className: _RelativesSales2.default.table__sire,
                        name: 'sire_name',
                        head: 'Sire (Dam\'s Sire)',
                        cell: { children: _RelativesSalesCellSire2.default }
                    }, {
                        className: _RelativesSales2.default.table__price,
                        name: 'price',
                        head: 'Price',
                        cell: { children: _RelativesSalesCellPrice2.default }
                    }, {
                        className: _RelativesSales2.default.table__buyer,
                        name: 'buyer',
                        head: 'Buyer'
                    }, fromMedium && {
                        className: _RelativesSales2.default.table__sale,
                        name: 'sale',
                        head: 'Sale',
                        cell: { children: _RelativesSalesCellSale2.default }
                    }].filter(function (column) {
                        return !!column;
                    }),
                    data: data,
                    sorting: _defineProperty({}, sort, 'asc'),
                    canSortByColumn: function canSortByColumn() {
                        return true;
                    },
                    onSort: this.handleSort
                })
            );
        }
    }]);

    return RelativesSales;
}(_react.PureComponent);

RelativesSales.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    // it's assumed that props 'damUid', 'birthDate', 'saleDate'
    // do not change after component has been rendered
    damUid: _propTypes2.default.number.isRequired,
    birthDate: _propTypes2.default.string.isRequired,
    saleDate: _propTypes2.default.string.isRequired,
    onTabChange: _propTypes2.default.func.isRequired,
    venueId: _propTypes2.default.number.isRequired,
    lotNo: _propTypes2.default.number.isRequired
};
exports.default = (0, _Breakpoints.bindCode)(RelativesSales);

/***/ }),
/* 366 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(59)

/**
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added
 * @returns {Date} the new date with the years added
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * var result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, amount * 12)
}

module.exports = addYears


/***/ }),
/* 367 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesSalesCellHorse;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Cell = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesSalesCellHorse(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_Cell.CellHorse, { data: data }),
        '\xA0',
        data.horse_name_codes
    );
}

RelativesSalesCellHorse.propTypes = {
    data: _propTypes2.default.shape({
        horse_name_codes: _propTypes2.default.string.isRequired
    }).isRequired
};

/***/ }),
/* 368 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesSalesCellSire;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Cell = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesSalesCellSire(props) {
    return _react2.default.createElement(
        'span',
        null,
        _react2.default.createElement(_Cell.CellSire, props),
        ' ',
        '(',
        _react2.default.createElement(_Cell.CellDamsSire, props),
        ')'
    );
}

/***/ }),
/* 369 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = RelativesSalesCellSale;

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _url = __webpack_require__(30);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesSalesCellSale(_ref) {
    var data = _ref.data;

    return _react2.default.createElement(
        'a',
        {
            className: 'ui-link ui-link_table',
            href: (0, _url.lotUrl)(data.venue_uid, data.sale_raw_date, data.lot_no || data.sale, data.lot_letter)
        },
        data.sale,
        _react2.default.createElement(_rpReactSvgIcon2.default, {
            iconName: 'right',
            size: 'XSmall'
        })
    );
}

RelativesSalesCellSale.propTypes = {
    data: _propTypes2.default.shape({
        venue_uid: _propTypes2.default.number.isRequired,
        sale_raw_date: _propTypes2.default.string,
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string.isRequired,
        sale: _propTypes2.default.string.isRequired
    }).isRequired
};

/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = RelativesSalesCellPrice;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Cell = __webpack_require__(13);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function RelativesSalesCellPrice(props) {
    return _react2.default.createElement(_Cell.CellPrice, _extends({}, props, { bold: false }));
}

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(372);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesSales.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./RelativesSales.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".RelativesSales__table___2tPBi .ui-table__cell {\n  background: transparent !important; }\n\n.RelativesSales__table__horse___iN5lA, .RelativesSales__table__sire___10qfj, .RelativesSales__table__price___6roeC, .RelativesSales__table__buyer___3poq4 {\n  text-align: left !important;\n  padding-right: 4px !important; }\n\n.RelativesSales__table__sale___zJVmh {\n  text-align: left !important;\n  padding-right: 0 !important; }\n\n@media (max-width: 479.9px) {\n  .RelativesSales__table__horse___iN5lA, .RelativesSales__table__buyer___3poq4 {\n    width: 40%; }\n  .RelativesSales__table__price___6roeC {\n    width: 20%; } }\n\n@media (min-width: 480px) and (max-width: 719.9px) {\n  .RelativesSales__table__horse___iN5lA, .RelativesSales__table__sire___10qfj, .RelativesSales__table__buyer___3poq4 {\n    width: 29%; }\n  .RelativesSales__table__price___6roeC {\n    width: 13%; } }\n\n@media (min-width: 720px) and (max-width: 1277.9px) {\n  .RelativesSales__table__horse___iN5lA, .RelativesSales__table__sire___10qfj {\n    width: 25%; }\n  .RelativesSales__table__price___6roeC, .RelativesSales__table__sale___zJVmh {\n    width: 15%; }\n  .RelativesSales__table__buyer___3poq4 {\n    width: 20%; } }\n\n@media (min-width: 1278px) {\n  .RelativesSales__table__horse___iN5lA, .RelativesSales__table__sire___10qfj {\n    width: 23%; }\n  .RelativesSales__table__price___6roeC, .RelativesSales__table__sale___zJVmh {\n    width: 15%; }\n  .RelativesSales__table__buyer___3poq4 {\n    width: 24%; } }\n", ""]);

// exports
exports.locals = {
	"table": "RelativesSales__table___2tPBi",
	"table__horse": "RelativesSales__table__horse___iN5lA",
	"table__sire": "RelativesSales__table__sire___10qfj",
	"table__price": "RelativesSales__table__price___6roeC",
	"table__buyer": "RelativesSales__table__buyer___3poq4",
	"table__sale": "RelativesSales__table__sale___zJVmh"
};

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(374);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsTable.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsTable.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".SearchResultsTable__root___3n-9S {\n  color: #171717; }\n\n.SearchResultsTable__toggle___2DjXo,\n.SearchResultsTable__lot___2zz_n,\n.SearchResultsTable__color___3S-ja,\n.SearchResultsTable__sex___1lE0g,\n.SearchResultsTable__age___18Ltc {\n  text-align: center; }\n\n.SearchResultsTable__horse___32Whn,\n.SearchResultsTable__dam___K7J5s,\n.SearchResultsTable__vendor___1Vo1r,\n.SearchResultsTable__price___KovC0,\n.SearchResultsTable__buyer___3HVL9,\n.SearchResultsTable__date___35W4r {\n  text-align: left; }\n\n.SearchResultsTable__sale___26NZg {\n  text-align: right; }\n\n@media (max-width: 479.9px) {\n  .SearchResultsTable__toggle___2DjXo {\n    width: 11%; }\n  .SearchResultsTable__lot___2zz_n {\n    width: 13%; }\n  .SearchResultsTable__horse___32Whn {\n    width: 46%; }\n  .SearchResultsTable__price___KovC0 {\n    width: 30%; } }\n\n@media (min-width: 480px) and (max-width: 719.9px) {\n  .SearchResultsTable__toggle___2DjXo {\n    width: 7%; }\n  .SearchResultsTable__lot___2zz_n {\n    width: 9%; }\n  .SearchResultsTable__horse___32Whn {\n    width: 30%; }\n  .SearchResultsTable__price___KovC0 {\n    width: 24%; }\n  .SearchResultsTable__buyer___3HVL9 {\n    width: 30%; } }\n\n@media (min-width: 720px) {\n  .SearchResultsTable__toggle___2DjXo {\n    width: 4%; }\n  .SearchResultsTable__lot___2zz_n,\n  .SearchResultsTable__sex___1lE0g {\n    width: 5%; }\n  .SearchResultsTable__dam___K7J5s {\n    width: 12%; }\n  .SearchResultsTable__horse___32Whn,\n  .SearchResultsTable__vendor___1Vo1r {\n    width: 14%; }\n  .SearchResultsTable__buyer___3HVL9 {\n    width: 12%; }\n  .SearchResultsTable__price___KovC0,\n  .SearchResultsTable__date___35W4r {\n    width: 9%; }\n  .SearchResultsTable__sale___26NZg {\n    width: 16%; } }\n\n@media (min-width: 1278px) {\n  .SearchResultsTable__toggle___2DjXo {\n    width: 3%; }\n  .SearchResultsTable__lot___2zz_n,\n  .SearchResultsTable__color___3S-ja,\n  .SearchResultsTable__sex___1lE0g,\n  .SearchResultsTable__age___18Ltc {\n    width: 4%; }\n  .SearchResultsTable__horse___32Whn,\n  .SearchResultsTable__dam___K7J5s,\n  .SearchResultsTable__vendor___1Vo1r,\n  .SearchResultsTable__buyer___3HVL9 {\n    width: 14%; }\n  .SearchResultsTable__price___KovC0 {\n    width: 7%; }\n  .SearchResultsTable__date___35W4r {\n    width: 6%; }\n  .SearchResultsTable__sale___26NZg {\n    width: 12%; } }\n", ""]);

// exports
exports.locals = {
	"root": "SearchResultsTable__root___3n-9S",
	"toggle": "SearchResultsTable__toggle___2DjXo",
	"lot": "SearchResultsTable__lot___2zz_n",
	"color": "SearchResultsTable__color___3S-ja",
	"sex": "SearchResultsTable__sex___1lE0g",
	"age": "SearchResultsTable__age___18Ltc",
	"horse": "SearchResultsTable__horse___32Whn",
	"dam": "SearchResultsTable__dam___K7J5s",
	"vendor": "SearchResultsTable__vendor___1Vo1r",
	"price": "SearchResultsTable__price___KovC0",
	"buyer": "SearchResultsTable__buyer___3HVL9",
	"date": "SearchResultsTable__date___35W4r",
	"sale": "SearchResultsTable__sale___26NZg"
};

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = undefined;

var _SearchResultsLightbox = __webpack_require__(376);

var _SearchResultsLightbox2 = _interopRequireDefault(_SearchResultsLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SearchResultsLightbox2.default;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = SearchResultsLightbox;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(4);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _Lightbox = __webpack_require__(43);

var _Lightbox2 = _interopRequireDefault(_Lightbox);

var _SearchResultsLightbox = __webpack_require__(377);

var _SearchResultsLightbox2 = _interopRequireDefault(_SearchResultsLightbox);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SearchResultsLightbox(_ref) {
    var open = _ref.open,
        onClose = _ref.onClose;

    return _react2.default.createElement(
        _Lightbox2.default,
        {
            open: open,
            closeButton: true,
            onClose: onClose
        },
        _react2.default.createElement(
            'div',
            { className: _SearchResultsLightbox2.default.wrap },
            _react2.default.createElement(
                'div',
                { className: 'ui-errorMessage' },
                _react2.default.createElement(_rpReactSvgIcon2.default, {
                    iconName: 'results',
                    size: 'XL'
                }),
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__text' },
                    'Your search is too broad. Please limit your date range to one month or select two of the following filters: Sale Name, Horse name, pedigree, vendor or price range.'
                )
            ),
            _react2.default.createElement(
                'button',
                {
                    className: _SearchResultsLightbox2.default.button + ' ui-btn ui-btn_primary ui-btn_large',
                    onClick: onClose
                },
                'OK'
            )
        )
    );
}

SearchResultsLightbox.propTypes = {
    open: _propTypes2.default.bool.isRequired,
    onClose: _propTypes2.default.func.isRequired
};

/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(378);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsLightbox.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchResultsLightbox.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".SearchResultsLightbox__wrap___1q_Qb {\n  padding: 0 8px 16px;\n  width: 100%;\n  text-align: center; }\n  @media (min-width: 720px) {\n    .SearchResultsLightbox__wrap___1q_Qb {\n      padding: 0 16px 24px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchResultsLightbox__wrap___1q_Qb {\n      width: 464px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchResultsLightbox__wrap___1q_Qb {\n      width: 640px; } }\n  @media (min-width: 1278px) {\n    .SearchResultsLightbox__wrap___1q_Qb {\n      width: 832px; } }\n\n.SearchResultsLightbox__button___1skm7 {\n  width: 100%; }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchResultsLightbox__button___1skm7 {\n      width: 304px; } }\n", ""]);

// exports
exports.locals = {
	"wrap": "SearchResultsLightbox__wrap___1q_Qb",
	"button": "SearchResultsLightbox__button___1skm7"
};

/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(380);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./SearchResults.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./SearchResults.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".SearchResults__table___3MRcj {\n  margin-top: 16px;\n  color: #171717; }\n\n.SearchResults__filters___2k8Yd {\n  margin-top: 24px;\n  color: #171717; }\n", ""]);

// exports
exports.locals = {
	"table": "SearchResults__table___3MRcj",
	"filters": "SearchResults__filters___2k8Yd"
};

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SearchEntries = __webpack_require__(382);

var _SearchEntries2 = _interopRequireDefault(_SearchEntries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SearchEntries2.default;

/***/ }),
/* 382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _isEqual2 = __webpack_require__(32);

var _isEqual3 = _interopRequireDefault(_isEqual2);

var _Breakpoints = __webpack_require__(10);

var _Pagination = __webpack_require__(61);

var _Pagination2 = _interopRequireDefault(_Pagination);

var _SearchEntriesFilters = __webpack_require__(383);

var _SearchEntriesFilters2 = _interopRequireDefault(_SearchEntriesFilters);

var _SearchEntriesTable = __webpack_require__(386);

var _SearchEntriesTable2 = _interopRequireDefault(_SearchEntriesTable);

var _api = __webpack_require__(7);

var _SearchEntries = __webpack_require__(389);

var _SearchEntries2 = _interopRequireDefault(_SearchEntries);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SearchEntries = function (_PureComponent) {
    _inherits(SearchEntries, _PureComponent);

    function SearchEntries() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchEntries);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchEntries.__proto__ || Object.getPrototypeOf(SearchEntries)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            fetching: false,
            totalLotsNum: 0,
            totalPagesNum: 0,
            filters: SearchEntries.getInitialFilters(),
            filtersUsed: false,
            page: 0,
            data: [],
            header: [],
            expansion: null,
            sort: 'lot_no'
        }, _this.isSortable = function (sort) {
            return _this.state.header.find(function (headerCellData) {
                return headerCellData.name === sort && headerCellData.sortLink;
            });
        }, _this.handleFiltersChange = function (filters) {
            if ((0, _isEqual3.default)(filters, SearchEntries.getInitialFilters())) {
                _this.handleFiltersReset();
            } else {
                _this.fetchData({ filters: filters });
            }
        }, _this.handleFiltersReset = function () {
            _this.setState({
                fetching: false,
                filtersUsed: false,
                filters: SearchEntries.getInitialFilters(),
                totalLotsNum: 0,
                totalPagesNum: 0,
                data: []
            });
        }, _this.handleTableToggle = function (expansion) {
            return _this.setState({
                expansion: expansion === _this.state.expansion ? null : expansion
            });
        }, _this.handleTableSort = function (sort) {
            return _this.fetchData({ sort: sort });
        }, _this.handlePageChange = function (page) {
            return _this.fetchData({ page: page });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchEntries, [{
        key: 'fetchData',
        value: function fetchData(params) {
            var _this2 = this;

            var _state$params = _extends({}, this.state, params),
                filters = _state$params.filters,
                sort = _state$params.sort,
                page = _state$params.page;

            this.setState({ filters: filters, sort: sort, page: page, fetching: true, filtersUsed: true });
            var sireName = this.props.sireName;

            var query = {
                sort: sort,
                page: page,
                q: Object.keys(filters).reduce(function (result, key) {
                    var value = key === _SearchEntriesFilters.FILTERS_PROP_SIRE && sireName ? sireName : filters[key];
                    return value ? _extends({}, result, _defineProperty({}, key, value)) : result;
                }, {})
            };

            return (0, _api.callApi)('/bloodstock/sales/search/entries/data.json', { query: query }).then(function (data) {
                return _this2.setState({
                    fetching: false,
                    totalLotsNum: data.pagination.totalItems,
                    totalPagesNum: data.pagination.totalPages,
                    page: data.pagination.currentPage,
                    data: data.rows,
                    header: data.header
                });
            }).catch(function () {
                return _this2.setState({
                    fetching: false,
                    totalLotsNum: 0,
                    totalPagesNum: 0,
                    data: [],
                    header: []
                });
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                breakpointCode = _props.breakpointCode,
                sireUid = _props.sireUid;
            var _state = this.state,
                fetching = _state.fetching,
                totalLotsNum = _state.totalLotsNum,
                totalPagesNum = _state.totalPagesNum,
                filters = _state.filters,
                page = _state.page,
                data = _state.data,
                expansion = _state.expansion,
                sort = _state.sort,
                filtersUsed = _state.filtersUsed;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'div',
                    { className: _SearchEntries2.default.filters },
                    _react2.default.createElement(_SearchEntriesFilters2.default, {
                        breakpointCode: breakpointCode,
                        sireUid: sireUid,
                        filters: filters,
                        lotsNum: totalLotsNum,
                        onChange: this.handleFiltersChange,
                        onReset: this.handleFiltersReset
                    })
                ),
                (fetching || filtersUsed) && _react2.default.createElement(
                    'div',
                    null,
                    _react2.default.createElement(
                        'div',
                        { className: _SearchEntries2.default.table },
                        _react2.default.createElement(_SearchEntriesTable2.default, {
                            breakpointCode: breakpointCode,
                            data: data,
                            loading: fetching,
                            expansion: expansion,
                            sorting: _defineProperty({}, sort, 'asc'),
                            onToggle: this.handleTableToggle,
                            onSort: this.handleTableSort,
                            canSortByColumn: this.isSortable
                        })
                    ),
                    _react2.default.createElement(_Pagination2.default, {
                        displayedPagesNum: 5,
                        totalPagesNum: totalPagesNum,
                        page: page,
                        onPageChange: this.handlePageChange
                    })
                )
            );
        }
    }], [{
        key: 'getInitialFilters',
        value: function getInitialFilters() {
            return _SearchEntriesFilters.FILTERS_PROPS_ALL.reduce(function (result, prop) {
                return _extends({}, result, _defineProperty({}, prop, _SearchEntriesFilters.FILTERS_PROP_ENTERED !== prop ? null : false));
            }, {});
        }
    }]);

    return SearchEntries;
}(_react.PureComponent);

SearchEntries.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    sireUid: _propTypes2.default.number,
    sireName: _propTypes2.default.string
};
SearchEntries.defaultProps = {
    sireUid: null,
    sireName: null
};
exports.default = (0, _Breakpoints.bindCode)(SearchEntries);

/***/ }),
/* 383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FILTERS_PROPS_ALL = exports.FILTERS_PROP_ENTERED = exports.FILTERS_PROP_VENDOR = exports.FILTERS_PROP_DAM_SIRE = exports.FILTERS_PROP_DAM = exports.FILTERS_PROP_SIRE = exports.FILTERS_PROP_NAME = exports.FILTERS_PROP_AGE = exports.FILTERS_PROP_SEX = exports.FILTERS_PROP_SALE = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _FILTER_STATE_TO_URL_, _filtersLabels, _propTypes$shape;

var _classnames2 = __webpack_require__(5);

var _classnames3 = _interopRequireDefault(_classnames2);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _Filters = __webpack_require__(69);

var _Checkbox = __webpack_require__(71);

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Breakpoints = __webpack_require__(10);

var _api = __webpack_require__(7);

var _SearchEntriesFilters = __webpack_require__(384);

var _SearchEntriesFilters2 = _interopRequireDefault(_SearchEntriesFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var TAB_SALE = 'TAB_SALE';
var TAB_HORSE = 'TAB_HORSE';
var TAB_PEDIGREE = 'TAB_PEDIGREE';
var TAB_VENDOR = 'TAB_VENDOR';

var NAV_OPTIONS = [{ label: 'Sale', value: TAB_SALE }, { label: 'Horse', value: TAB_HORSE }, { label: 'Pedigree', value: TAB_PEDIGREE }, { label: 'Vendor', value: TAB_VENDOR }];

var ONLY_WITH_ENTRIES_LABEL = 'Show only lots with entries';

var FILTERS_PROP_SALE = exports.FILTERS_PROP_SALE = 'sale';
var FILTERS_PROP_SEX = exports.FILTERS_PROP_SEX = 'sex';
var FILTERS_PROP_AGE = exports.FILTERS_PROP_AGE = 'age';
var FILTERS_PROP_NAME = exports.FILTERS_PROP_NAME = 'name';
var FILTERS_PROP_SIRE = exports.FILTERS_PROP_SIRE = 'sire';
var FILTERS_PROP_DAM = exports.FILTERS_PROP_DAM = 'dam';
var FILTERS_PROP_DAM_SIRE = exports.FILTERS_PROP_DAM_SIRE = 'damSire';
var FILTERS_PROP_VENDOR = exports.FILTERS_PROP_VENDOR = 'vendor';
var FILTERS_PROP_ENTERED = exports.FILTERS_PROP_ENTERED = 'entered';

var FILTERS_PROPS_SELECT = [FILTERS_PROP_SALE, FILTERS_PROP_SEX, FILTERS_PROP_AGE, FILTERS_PROP_NAME, FILTERS_PROP_SIRE, FILTERS_PROP_DAM, FILTERS_PROP_DAM_SIRE, FILTERS_PROP_VENDOR];
var FILTERS_PROPS_ALL = exports.FILTERS_PROPS_ALL = [].concat(FILTERS_PROPS_SELECT, [FILTERS_PROP_ENTERED]);

var FILTER_STATE_TO_URL_HASH = (_FILTER_STATE_TO_URL_ = {}, _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_SALE, 'sale_name'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_SEX, 'horse_sex'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_AGE, 'horse_age'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_NAME, 'horse_name'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_SIRE, 'sire_name'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_DAM, 'dam_name'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_DAM_SIRE, 'sire_of_dam_name'), _defineProperty(_FILTER_STATE_TO_URL_, FILTERS_PROP_VENDOR, 'seller_name'), _FILTER_STATE_TO_URL_);

var filtersLabels = (_filtersLabels = {}, _defineProperty(_filtersLabels, FILTERS_PROP_SEX, 'Sex'), _defineProperty(_filtersLabels, FILTERS_PROP_AGE, 'Age'), _defineProperty(_filtersLabels, FILTERS_PROP_NAME, 'Name'), _defineProperty(_filtersLabels, FILTERS_PROP_SIRE, 'Sire'), _defineProperty(_filtersLabels, FILTERS_PROP_DAM, 'Dam'), _defineProperty(_filtersLabels, FILTERS_PROP_DAM_SIRE, 'Dam\'s Sire'), _defineProperty(_filtersLabels, FILTERS_PROP_VENDOR, 'Vendor'), _filtersLabels);

var SearchEntriesFilters = function (_PureComponent) {
    _inherits(SearchEntriesFilters, _PureComponent);

    function SearchEntriesFilters() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchEntriesFilters);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchEntriesFilters.__proto__ || Object.getPrototypeOf(SearchEntriesFilters)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            open: true,
            tab: TAB_SALE,
            options: FILTERS_PROPS_SELECT.reduce(function (result, prop) {
                return _extends({}, result, _defineProperty({}, prop, []));
            }, {}),
            history: []
        }, _this.createFilterOpenHandler = function (urlProp, stateProp) {
            return function () {
                var _this$props = _this.props,
                    sireUid = _this$props.sireUid,
                    filters = _this$props.filters;

                var url = '/bloodstock/sales/search/entries/' + urlProp + '/data.json';
                var init = {
                    query: {
                        refine: FILTERS_PROPS_SELECT.reduce(function (result, prop) {
                            var value = filters[prop];
                            if (prop === stateProp || !value) {
                                return result;
                            }
                            return _extends({}, result, _defineProperty({}, FILTER_STATE_TO_URL_HASH[prop], value));
                        }, sireUid ? { sire_uid: sireUid } : {})
                    }
                };
                return (0, _api.callApi)(url, init).then(function (options) {
                    return _this.setState({
                        options: _extends({}, _this.state.options, _defineProperty({}, stateProp, options))
                    });
                });
            };
        }, _this.filterOpenHandlers = FILTERS_PROPS_SELECT.reduce(function (result, prop) {
            return _extends({}, result, _defineProperty({}, prop, _this.createFilterOpenHandler(FILTER_STATE_TO_URL_HASH[prop], prop)));
        }, {}), _this.createFilterChangeHandler = function (prop) {
            return function (value, option) {
                var filters = _this.props.filters;

                if (filters[prop] === value) {
                    return;
                }

                _this.setState({
                    history: _this.state.history.filter(function (item) {
                        return item.prop !== prop;
                    }).concat(value ? {
                        prop: prop,
                        value: function () {
                            switch (prop) {
                                case FILTERS_PROP_ENTERED:
                                    return ONLY_WITH_ENTRIES_LABEL;
                                default:
                                    return option.name;
                            }
                        }()
                    } : [])
                });

                _this.props.onChange(_extends({}, filters, _defineProperty({}, prop, value)));
            };
        }, _this.filterChangeHandlers = FILTERS_PROPS_ALL.reduce(function (result, prop) {
            return _extends({}, result, _defineProperty({}, prop, _this.createFilterChangeHandler(prop)));
        }, {}), _this.handleToggleClick = function () {
            return _this.setState({ open: !_this.state.open });
        }, _this.handleTabChange = function (tab) {
            return _this.setState({ tab: tab });
        }, _this.handleResetClick = function () {
            _this.setState({ history: [] });
            return _this.props.onReset();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchEntriesFilters, [{
        key: 'getFilterProps',
        value: function getFilterProps(prop) {
            return {
                className: _SearchEntriesFilters2.default.filter,
                options: this.state.options[prop],
                labelGetter: 'name',
                value: this.props.filters[prop],
                disabled: prop === FILTERS_PROP_NAME ? this.isNameDisabled() : this.isNameSelected(),
                onOpen: this.filterOpenHandlers[prop],
                onChange: this.filterChangeHandlers[prop]
            };
        }
    }, {
        key: 'isNameSelected',
        value: function isNameSelected() {
            return !!this.props.filters[FILTERS_PROP_NAME];
        }
    }, {
        key: 'isNameDisabled',
        value: function isNameDisabled() {
            var _this2 = this;

            return FILTERS_PROPS_ALL.some(function (prop) {
                if (prop === FILTERS_PROP_NAME) {
                    return false;
                }
                return !!_this2.props.filters[prop];
            });
        }
    }, {
        key: 'isResetDisabled',
        value: function isResetDisabled() {
            var _this3 = this;

            return FILTERS_PROPS_ALL.every(function (prop) {
                return !_this3.props.filters[prop];
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props = this.props,
                breakpointCode = _props.breakpointCode,
                filters = _props.filters,
                lotsNum = _props.lotsNum;
            var _state = this.state,
                open = _state.open,
                tab = _state.tab,
                options = _state.options,
                history = _state.history;

            var exNarrow = breakpointCode === _Breakpoints.codes.EXTRA_NARROW;
            var toNarrow = [_Breakpoints.codes.EXTRA_NARROW, _Breakpoints.codes.NARROW].includes(breakpointCode);
            var toWide = [_Breakpoints.codes.WIDE, _Breakpoints.codes.EXTRA_WIDE].includes(breakpointCode);
            var historyFiltered = history.filter(function (item) {
                return item.prop !== FILTERS_PROP_SALE;
            });
            return _react2.default.createElement(
                'div',
                null,
                toNarrow && _react2.default.createElement(_Filters.FiltersToggle, {
                    open: open,
                    onClick: this.handleToggleClick
                }),
                (open || !toNarrow) && _react2.default.createElement(
                    'div',
                    {
                        className: (0, _classnames3.default)(_SearchEntriesFilters2.default.filters, _defineProperty({}, _SearchEntriesFilters2.default.filters_open, toNarrow))
                    },
                    _react2.default.createElement(
                        'div',
                        { className: _SearchEntriesFilters2.default.navWrap },
                        _react2.default.createElement(_Filters.FiltersNav, {
                            className: _SearchEntriesFilters2.default.nav,
                            name: 'tab',
                            options: NAV_OPTIONS,
                            value: tab,
                            align: exNarrow ? _Filters.FiltersNav.ALIGN_HORIZONTAL : _Filters.FiltersNav.ALIGN_VERTICAL,
                            onChange: this.handleTabChange
                        }),
                        _react2.default.createElement(_Filters.FiltersReset, {
                            className: _SearchEntriesFilters2.default.reset,
                            disabled: this.isResetDisabled(),
                            onClick: this.handleResetClick
                        })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: _SearchEntriesFilters2.default.tabWrap },
                        _react2.default.createElement(
                            'div',
                            { className: _SearchEntriesFilters2.default.tab },
                            function () {
                                switch (tab) {
                                    case TAB_SALE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Sale Name',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_SALE)))
                                        );
                                    case TAB_HORSE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Sex'
                                            }, _this4.getFilterProps(FILTERS_PROP_SEX))),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Age'
                                            }, _this4.getFilterProps(FILTERS_PROP_AGE))),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Name',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_NAME)))
                                        );
                                    case TAB_PEDIGREE:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Sire',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_SIRE))),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Dam',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_DAM))),
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Dam\'s Sire',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_DAM_SIRE)))
                                        );
                                    case TAB_VENDOR:
                                        return _react2.default.createElement(
                                            'div',
                                            null,
                                            _react2.default.createElement(_Filters.FiltersSelect, _extends({
                                                label: 'Vendor Name',
                                                alphabet: true,
                                                showSearch: true
                                            }, _this4.getFilterProps(FILTERS_PROP_VENDOR)))
                                        );
                                    default:
                                        return null;
                                }
                            }()
                        ),
                        _react2.default.createElement(
                            'div',
                            { className: _SearchEntriesFilters2.default.panel },
                            _react2.default.createElement(
                                'div',
                                { className: _SearchEntriesFilters2.default.lots },
                                _react2.default.createElement(
                                    'div',
                                    null,
                                    'Lots found'
                                ),
                                _react2.default.createElement(
                                    'div',
                                    {
                                        className: _SearchEntriesFilters2.default.lots__num,
                                        'data-test-selector': 'lots_found_right_block'
                                    },
                                    lotsNum
                                )
                            ),
                            _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement(_Checkbox2.default, {
                                    label: ONLY_WITH_ENTRIES_LABEL,
                                    value: filters[FILTERS_PROP_ENTERED],
                                    onChange: this.filterChangeHandlers[FILTERS_PROP_ENTERED]
                                })
                            )
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _SearchEntriesFilters2.default.status },
                    history && history.length > 0 && _react2.default.createElement(
                        'div',
                        { className: _SearchEntriesFilters2.default.status__container },
                        _react2.default.createElement(
                            'span',
                            {
                                className: _SearchEntriesFilters2.default.status__sale,
                                'data-test-selector': 'filters_applied_sale_name'
                            },
                            filters[FILTERS_PROP_SALE] ? options[FILTERS_PROP_SALE].find(function (option) {
                                return option.value === filters[FILTERS_PROP_SALE];
                            }).name : 'All sales'
                        ),
                        ' - ',
                        _react2.default.createElement(
                            'span',
                            null,
                            'Lots found'
                        ),
                        _react2.default.createElement(
                            'span',
                            { className: _SearchEntriesFilters2.default.status__lots, 'data-test-selector': 'lots_found_above_table' },
                            lotsNum
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: _SearchEntriesFilters2.default.history },
                    toWide && history && historyFiltered.length > 0 && _react2.default.createElement(
                        'span',
                        { 'data-test-selector': 'filters_applied' },
                        'Filters Applied: ',
                        historyFiltered.map(function (item) {
                            if (item.prop === FILTERS_PROP_ENTERED) {
                                return item.value;
                            }
                            return filtersLabels[item.prop] + ' - ' + item.value;
                        }).join(', ')
                    )
                )
            );
        }
    }]);

    return SearchEntriesFilters;
}(_react.PureComponent);

SearchEntriesFilters.propTypes = {
    breakpointCode: _propTypes2.default.oneOf(Object.values(_Breakpoints.codes)).isRequired,
    sireUid: _propTypes2.default.string,
    filters: _propTypes2.default.shape((_propTypes$shape = {}, _defineProperty(_propTypes$shape, FILTERS_PROP_SALE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_SEX, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_AGE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_NAME, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_SIRE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_DAM, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_DAM_SIRE, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_VENDOR, _propTypes2.default.string), _defineProperty(_propTypes$shape, FILTERS_PROP_ENTERED, _propTypes2.default.bool), _propTypes$shape)).isRequired,
    lotsNum: _propTypes2.default.number.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    onReset: _propTypes2.default.func.isRequired
};
SearchEntriesFilters.defaultProps = {
    sireUid: null
};
exports.default = SearchEntriesFilters;

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(385);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchEntriesFilters.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchEntriesFilters.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, "/* Default font weight */\n/* dt - Data Theme */\n/* bc - Body Copy */\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* hd - Headers*/\n/* bc - Body Copy Bold */\n/* bc - Body Copy Semibold*/\n/* et - Editorial Theme */\n/* bc - Body Copy */\n/* bc-b - Body Copy Bold */\n/* hd - Headers*/\n/* hd-b - Headers Bold*/\n.SearchEntriesFilters__filters___28pxi {\n  display: flex; }\n  .SearchEntriesFilters__filters_open___1YWNi {\n    margin-top: 16px; }\n  @media (max-width: 479.9px) {\n    .SearchEntriesFilters__filters___28pxi {\n      flex-direction: column; } }\n\n.SearchEntriesFilters__navWrap___2eFqR {\n  flex-shrink: 0; }\n  @media (max-width: 479.9px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      margin-bottom: 8px;\n      padding-bottom: 16px;\n      border-bottom: 1px solid #171717; } }\n  @media (min-width: 480px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      padding-right: 8px;\n      border-right: 1px solid #171717; } }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      width: 120px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      width: 174px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      width: 160px; } }\n  @media (min-width: 1278px) {\n    .SearchEntriesFilters__navWrap___2eFqR {\n      width: 208px; } }\n\n@media (max-width: 479.9px) {\n  .SearchEntriesFilters__nav___3cHwL {\n    flex: 1; } }\n\n@media (max-width: 479.9px) {\n  .SearchEntriesFilters__reset___fuqpa {\n    margin: 8px auto 0;\n    width: 48%;\n    display: block; } }\n\n@media (min-width: 480px) {\n  .SearchEntriesFilters__reset___fuqpa {\n    width: 100%;\n    margin-top: 24px; } }\n\n.SearchEntriesFilters__tabWrap___p62bW {\n  display: flex; }\n\n.SearchEntriesFilters__tab___3Tvli {\n  flex-shrink: 0;\n  padding: 0 8px; }\n  @media (max-width: 479.9px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      width: 66.66667%;\n      height: 168px; } }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      width: 240px; } }\n  @media (min-width: 720px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      padding-right: 32px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      width: 368px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      width: 344px; } }\n  @media (min-width: 1278px) {\n    .SearchEntriesFilters__tab___3Tvli {\n      width: 496px; } }\n\n.SearchEntriesFilters__filter___kuoNe {\n  width: 100%; }\n  .SearchEntriesFilters__filter___kuoNe:nth-child(n+2) {\n    margin-top: 8px; }\n\n.SearchEntriesFilters__panel___IJaez {\n  display: flex;\n  flex-direction: column;\n  padding-left: 8px;\n  border-left: 1px solid #171717; }\n  @media (max-width: 479.9px) {\n    .SearchEntriesFilters__panel___IJaez {\n      width: 33.33%; } }\n  @media (min-width: 480px) and (max-width: 719.9px) {\n    .SearchEntriesFilters__panel___IJaez {\n      width: 104px; } }\n  @media (min-width: 720px) and (max-width: 989.9px) {\n    .SearchEntriesFilters__panel___IJaez {\n      width: 138px; } }\n  @media (min-width: 990px) and (max-width: 1277.9px) {\n    .SearchEntriesFilters__panel___IJaez {\n      width: 120px; } }\n  @media (min-width: 1278px) {\n    .SearchEntriesFilters__panel___IJaez {\n      width: 198px; } }\n\n.SearchEntriesFilters__lots___1q9E_ {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center; }\n  .SearchEntriesFilters__lots__num___3BjxY {\n    font-size: 48px;\n    font-family: \"proxima-nova-a-bold\", sans-serif;\n    line-height: 52px; }\n\n.SearchEntriesFilters__status___39B7h {\n  margin-top: 24px;\n  font: 20px/26px \"proxima-nova-a\", sans-serif;\n  white-space: pre; }\n  .SearchEntriesFilters__status__container___OTZRf {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    white-space: pre-wrap; }\n  .SearchEntriesFilters__status__sale___2IqHr {\n    font-family: \"proxima-nova-a-bold\", sans-serif; }\n  .SearchEntriesFilters__status__lots___1f2HH {\n    display: flex;\n    align-items: center;\n    height: 16px;\n    margin-left: 8px;\n    padding: 0 3px;\n    background: #2CB34A;\n    border-radius: 4px;\n    color: #FFFFFF;\n    font: 12px/17px \"proxima-nova-a-bold\", sans-serif; }\n\n.SearchEntriesFilters__history___1_u8e {\n  margin-top: 16px;\n  font: 16px/22px \"proxima-nova-a-bold\", sans-serif; }\n", ""]);

// exports
exports.locals = {
	"filters": "SearchEntriesFilters__filters___28pxi",
	"filters_open": "SearchEntriesFilters__filters_open___1YWNi",
	"navWrap": "SearchEntriesFilters__navWrap___2eFqR",
	"nav": "SearchEntriesFilters__nav___3cHwL",
	"reset": "SearchEntriesFilters__reset___fuqpa",
	"tabWrap": "SearchEntriesFilters__tabWrap___p62bW",
	"tab": "SearchEntriesFilters__tab___3Tvli",
	"filter": "SearchEntriesFilters__filter___kuoNe",
	"panel": "SearchEntriesFilters__panel___IJaez",
	"lots": "SearchEntriesFilters__lots___1q9E_",
	"lots__num": "SearchEntriesFilters__lots__num___3BjxY",
	"status": "SearchEntriesFilters__status___39B7h",
	"status__container": "SearchEntriesFilters__status__container___OTZRf",
	"status__sale": "SearchEntriesFilters__status__sale___2IqHr",
	"status__lots": "SearchEntriesFilters__status__lots___1f2HH",
	"history": "SearchEntriesFilters__history___1_u8e"
};

/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _rpMqBreakpoints = __webpack_require__(24);

var _Table = __webpack_require__(18);

var _Table2 = _interopRequireDefault(_Table);

var _Cell = __webpack_require__(13);

var _RelativesRow = __webpack_require__(83);

var _RelativesRow2 = _interopRequireDefault(_RelativesRow);

var _SearchEntriesTable = __webpack_require__(387);

var _SearchEntriesTable2 = _interopRequireDefault(_SearchEntriesTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NARROW = _rpMqBreakpoints.breakpointCodes.NARROW,
    MEDIUM = _rpMqBreakpoints.breakpointCodes.MEDIUM,
    WIDE = _rpMqBreakpoints.breakpointCodes.WIDE,
    EXTRA_WIDE = _rpMqBreakpoints.breakpointCodes.EXTRA_WIDE;

var SearchEntriesTable = function (_PureComponent) {
    _inherits(SearchEntriesTable, _PureComponent);

    function SearchEntriesTable() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SearchEntriesTable);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SearchEntriesTable.__proto__ || Object.getPrototypeOf(SearchEntriesTable)).call.apply(_ref, [this].concat(args))), _this), _this.row = { children: _RelativesRow2.default }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SearchEntriesTable, [{
        key: 'getColumns',
        value: function getColumns() {
            var breakpointCode = this.props.breakpointCode;

            var narrow = breakpointCode === NARROW;
            var fromMedium = [MEDIUM, WIDE, EXTRA_WIDE].includes(breakpointCode);
            return [{
                className: _SearchEntriesTable2.default.toggle,
                name: '_toggle',
                head: '',
                cell: { children: _Table.TableToggle }
            }, {
                className: _SearchEntriesTable2.default.lot,
                name: 'lot_no',
                head: 'Lot',
                cell: { children: _Cell.CellLot }
            }, {
                className: _SearchEntriesTable2.default.horse,
                name: 'horse_style_name',
                head: {
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            'Horse name'
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Sire'
                        )
                    )
                },
                cell: { children: _Cell.CellHorseSireUGC }
            }, fromMedium && {
                className: _SearchEntriesTable2.default.color,
                name: 'horse_first_colour_code',
                head: 'Col'
            }, fromMedium && {
                className: _SearchEntriesTable2.default.sex,
                name: 'horse_sex',
                head: 'Sex'
            }, fromMedium && {
                className: _SearchEntriesTable2.default.age,
                name: 'horse_age',
                head: 'Age'
            }, fromMedium && {
                className: _SearchEntriesTable2.default.dam,
                name: 'dam_style_name',
                head: {
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            'Dam'
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Dam\'s Sire'
                        )
                    )
                },
                cell: { children: _Cell.CellDamDamsSire }
            }, fromMedium && {
                className: _SearchEntriesTable2.default.vendor,
                name: 'seller_name',
                head: 'Vendor'
            }, narrow && {
                className: _SearchEntriesTable2.default.date,
                name: 'sale_date',
                head: {
                    children: _react2.default.createElement(
                        'div',
                        null,
                        _react2.default.createElement(
                            'div',
                            null,
                            'Date'
                        ),
                        _react2.default.createElement(
                            'div',
                            null,
                            'Sale'
                        )
                    )
                },
                cell: { children: _Cell.CellDateSale }
            }, !narrow && {
                className: _SearchEntriesTable2.default.date,
                name: 'sale_date',
                head: 'Date'
            }, fromMedium && {
                className: _SearchEntriesTable2.default.sale,
                name: 'sale_name',
                head: 'Sale'
            }].filter(function (item) {
                return !!item;
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                data = _props.data,
                loading = _props.loading,
                expansion = _props.expansion,
                sorting = _props.sorting,
                onToggle = _props.onToggle,
                onSort = _props.onSort,
                canSortByColumn = _props.canSortByColumn;

            return _react2.default.createElement(_Table2.default, {
                type: 1,
                columns: this.getColumns(),
                row: this.row,
                identity: SearchEntriesTable.identity,
                data: data,
                loading: loading,
                expansion: expansion,
                sorting: sorting,
                onToggle: onToggle,
                onSort: onSort,
                canSortByColumn: canSortByColumn,
                placeholder: 'No results found'
            });
        }
    }], [{
        key: 'identity',
        value: function identity(data) {
            return [data.venue_uid, data.sale_date_raw, data.lot_no, data.lot_letter].join('|');
        }
    }]);

    return SearchEntriesTable;
}(_react.PureComponent);

SearchEntriesTable.propTypes = {
    breakpointCode: _propTypes2.default.string.isRequired,
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        venue_uid: _propTypes2.default.number.isRequired,
        sale_date_raw: _propTypes2.default.string.isRequired,
        lot_no: _propTypes2.default.number.isRequired,
        lot_letter: _propTypes2.default.string.isRequired
    })).isRequired,
    loading: _propTypes2.default.bool,
    expansion: _propTypes2.default.string,
    sorting: _propTypes2.default.object, // eslint-disable-line react/forbid-prop-types
    onToggle: _propTypes2.default.func.isRequired,
    onSort: _propTypes2.default.func.isRequired,
    canSortByColumn: _propTypes2.default.func.isRequired
};
SearchEntriesTable.defaultProps = {
    loading: false,
    expansion: null,
    sorting: null
};
exports.default = SearchEntriesTable;

/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(388);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchEntriesTable.scss", function() {
			var newContent = require("!!../../../../node_modules/css-loader/index.js??ref--2-1!../../../../node_modules/sass-loader/lib/loader.js!./SearchEntriesTable.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 388 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".SearchEntriesTable__toggle___1u30g,\n.SearchEntriesTable__lot___3V4Fl,\n.SearchEntriesTable__color___2R7qF,\n.SearchEntriesTable__sex___1X3vX,\n.SearchEntriesTable__age___3gnfT {\n  text-align: center; }\n\n.SearchEntriesTable__horse___2gh4w,\n.SearchEntriesTable__dam___35TI_,\n.SearchEntriesTable__vendor___O39Xn,\n.SearchEntriesTable__date___30leV {\n  text-align: left; }\n\n.SearchEntriesTable__sale___1RaTK {\n  text-align: right; }\n\n@media (max-width: 479.9px) {\n  .SearchEntriesTable__toggle___1u30g {\n    width: 11%; }\n  .SearchEntriesTable__lot___3V4Fl {\n    width: 13%; }\n  .SearchEntriesTable__horse___2gh4w {\n    width: 52%; }\n  .SearchEntriesTable__price___2mWuI {\n    width: 24%; } }\n\n@media (min-width: 480px) and (max-width: 719.9px) {\n  .SearchEntriesTable__toggle___1u30g {\n    width: 7%; }\n  .SearchEntriesTable__lot___3V4Fl {\n    width: 9%; }\n  .SearchEntriesTable__horse___2gh4w {\n    width: 42%; }\n  .SearchEntriesTable__date___30leV {\n    width: 42%; } }\n\n@media (min-width: 720px) {\n  .SearchEntriesTable__toggle___1u30g {\n    width: 4%; }\n  .SearchEntriesTable__lot___3V4Fl,\n  .SearchEntriesTable__color___2R7qF,\n  .SearchEntriesTable__sex___1X3vX,\n  .SearchEntriesTable__age___3gnfT {\n    width: 5%; }\n  .SearchEntriesTable__horse___2gh4w,\n  .SearchEntriesTable__dam___35TI_,\n  .SearchEntriesTable__vendor___O39Xn,\n  .SearchEntriesTable__sale___1RaTK {\n    width: 17%; }\n  .SearchEntriesTable__date___30leV {\n    width: 8%; } }\n", ""]);

// exports
exports.locals = {
	"toggle": "SearchEntriesTable__toggle___1u30g",
	"lot": "SearchEntriesTable__lot___3V4Fl",
	"color": "SearchEntriesTable__color___2R7qF",
	"sex": "SearchEntriesTable__sex___1X3vX",
	"age": "SearchEntriesTable__age___3gnfT",
	"horse": "SearchEntriesTable__horse___2gh4w",
	"dam": "SearchEntriesTable__dam___35TI_",
	"vendor": "SearchEntriesTable__vendor___O39Xn",
	"date": "SearchEntriesTable__date___30leV",
	"sale": "SearchEntriesTable__sale___1RaTK",
	"price": "SearchEntriesTable__price___2mWuI"
};

/***/ }),
/* 389 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(390);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(3)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./SearchEntries.scss", function() {
			var newContent = require("!!../../../node_modules/css-loader/index.js??ref--2-1!../../../node_modules/sass-loader/lib/loader.js!./SearchEntries.scss");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(2)(false);
// imports


// module
exports.push([module.i, ".SearchEntries__table___2dmsi {\n  margin-top: 16px;\n  color: #171717; }\n\n.SearchEntries__filters___2jsS0 {\n  margin-top: 24px;\n  color: #171717; }\n", ""]);

// exports
exports.locals = {
	"table": "SearchEntries__table___2dmsi",
	"filters": "SearchEntries__filters___2jsS0"
};

/***/ })
/******/ ]);
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _commonMenuItemActiveNarrow = __webpack_require__(579);

var _commonMenuItemActiveNarrow2 = _interopRequireDefault(_commonMenuItemActiveNarrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Common Menu Container
 * Contains general methods that can be used in primary and secondary navigation
 * @param {string} selector
 * @property {CommonMenuItemBuilder} itemBuilder
 * @property {CommonMenuItemActiveNarrow} activeItemNarrow
 * @constructor
 */
/**
 * @module navigation/commonMenu
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function CommonMenu(selector) {
    this.selector = selector;
}

/**
 * General navigation container selector
 * @type {*|jQuery|HTMLElement}
 */


/**
 * @type {CommonMenuItemActiveNarrow|Function|exports|module.exports}
 */
CommonMenu.prototype.navigationContainerSelector = '#navigationContainer';

/**
 * Get object of general navigation container
 * It's contains primary and secondary navigation
 * @protected
 * @returns {*|jQuery|HTMLElement}
 */
CommonMenu.prototype.getNavigationContainer = function () {
    var $navigationContainer = (0, _jquery2.default)(this.navigationContainerSelector);

    CommonMenu.prototype.getNavigationContainer = function () {
        return $navigationContainer;
    };

    return $navigationContainer;
};

/**
 * Initialization method
 * @protected
 * @returns {CommonMenu}
 */
CommonMenu.prototype.init = function () {
    /**
     * Menu container object
     * @type {*|jQuery|HTMLElement}
     */
    this.$obj = (0, _jquery2.default)(this.selector);

    /**
     * Parse server side rendered items
     * @type {Array}
     */
    this.items = this.parseDOM();

    this.updateActiveNarrowItem();

    /**
     * Bind events
     */
    if (this._bindEvents instanceof Function) {
        this._bindEvents();
    }

    return this;
};

/**
 * Add new menu item
 * @public
 * @param {string} title
 * @param {string} href
 * @param {int} [position]
 * @param {object} [attributes]
 * @returns {CommonMenu}
 */
CommonMenu.prototype.addItem = function (title, href, position, attributes) {
    var lowerCaseTitle = title.toLowerCase(),
        existingItems = this.items.filter(function (obj) {
        return obj.title.toLowerCase() === lowerCaseTitle;
    });

    if (existingItems.length > 0) {
        throw new Error('Item with the same title is already exists!');
    }

    this._insertItem(this.itemBuilder.getMenuItem(title, href, attributes), position);

    return this;
};

/**
 * Mark item to be removed
 * @public
 * @param {CommonMenuItem} menuItem
 * @returns {CommonMenu}
 */
CommonMenu.prototype.removeItem = function (menuItem) {
    menuItem.toBeRemoved = true;
    return this;
};

/**
 * Set menu item active
 * @public
 * @param {CommonMenuItem} menuItem
 * @returns {CommonMenu}
 */
CommonMenu.prototype.setActiveItem = function (menuItem) {
    /**
     * Deselect current selected item
     */
    var activeItem = this.getActiveItem();
    if (activeItem) {
        activeItem.isActive = false;
    }

    if (menuItem) {
        menuItem.isActive = true;
    }

    return this;
};

/**
 * Get object of highlighted menu item
 * @public
 * @returns {CommonMenuItem}
 */
CommonMenu.prototype.getActiveItem = function () {
    var activeItems = this.items.filter(function (obj) {
        return !!obj.isActive;
    });

    if (activeItems.length === 0) {
        return null;
    }

    if (activeItems.length > 1) {
        throw new Error('Something went wrong! Unexpected number of active items!');
    }

    return activeItems[0];
};

/**
 * Apply all changes to DOM
 * @public
 * @returns {CommonMenu}
 */
CommonMenu.prototype.render = function () {
    this.items = this.items.filter(function (item) {
        return item && !item.toBeRemoved;
    });

    var updatedItems = [];
    for (var itemIndex in this.items) {
        if (!this.items.hasOwnProperty(itemIndex)) {
            continue;
        }

        var item = this.items[itemIndex];

        item.render();
        updatedItems.push(item.$obj);
    }

    this.updateActiveNarrowItem();

    this.$obj.empty().append(updatedItems);

    return this;
};

/**
 * @protected
 */
CommonMenu.prototype.updateActiveNarrowItem = function () {
    if (!(this.activeItemNarrow instanceof _commonMenuItemActiveNarrow2.default)) {
        return;
    }

    var activeItem = this.getActiveItem();

    if (activeItem) {
        this.activeItemNarrow.setTitle(activeItem.getTitle());
        this.activeItemNarrow.setHref(activeItem.getHref());
        this.activeItemNarrow.addClasses(activeItem.getJsClasses());
    }
};

/**
 * Get menu item by position
 * @public
 * @param {int} position
 * @returns {CommonMenuItem}
 */
CommonMenu.prototype.getItemByPosition = function (position) {
    return this.items[position];
};

/**
 * Get menu item by title
 * @public
 * @param {string} title
 * @returns {CommonMenuItem}
 */
CommonMenu.prototype.getItemByTitle = function (title) {
    var lowerCaseTitle = title.toLowerCase();

    var selectedItems = this.items.filter(function (item) {
        return item.title.toLowerCase() === lowerCaseTitle;
    });

    return selectedItems[0];
};

/**
 * Get item or items by selector
 * @public
 * @param {string} selector
 * @returns {Array}
 */
CommonMenu.prototype.getItemsBySelector = function (selector) {
    var selectedPositions = this.getPositionsBySelector(selector);

    return this.items.filter(function (item, position) {
        return selectedPositions.indexOf(position) !== -1;
    });
};

/**
 * Insert menu item on specific position
 * @private
 * @param {CommonMenuItem} menuItem
 * @param {int} [position]
 */
CommonMenu.prototype._insertItem = function (menuItem, position) {
    if (_jquery2.default.isNumeric(position)) {
        if (this.getItemByPosition(position)) {
            this.items.splice(position, 0, menuItem);
        } else {
            this.items[position] = menuItem;
        }
    } else {
        this.items.push(menuItem);
    }
};

/**
 * Get positions of elements of menu that match selector
 * @protected
 * @param {string } selector
 * @returns {Array}
 */
CommonMenu.prototype.getPositionsBySelector = function (selector) {
    var positions = [];

    this.items.forEach(function (item, position) {
        if (item.hasSelector(selector)) {
            positions.push(position);
        }
    });

    return positions;
};

/**
 * Create array of items that were rendered by server side
 * @protected
 * @returns {Array}
 */
CommonMenu.prototype.parseDOM = function () {
    var self = this,
        items = [],
        $renderedItems = this.getRenderedItems();

    $renderedItems.each(function () {
        items.push(self.itemBuilder.getMenuItem((0, _jquery2.default)(this)));
    });

    return items;
};

/**
 * Get jQuery object of rendered items
 * @protected
 * @returns {jQuery}
 */
CommonMenu.prototype.getRenderedItems = function () {
    return this.$obj.find(this.itemSelector);
};

exports.default = CommonMenu;

/***/ }),
/* 987 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _commonMenuItem = __webpack_require__(578);

var _commonMenuItem2 = _interopRequireDefault(_commonMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Builder for menu item
 * @property {CommonMenuItem|Function|exports|module.exports} ItemConstructor
 * @constructor
 */
/**
 * @module navigation/commonItemBuilder
 * @requires module: navigation/commonMenuItem
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function CommonMenuItemBuilder() {}

/**
 * Default class for highlighted menu item
 * @type {string}
 */


/**
 * @type {CommonMenuItem|Function|exports|module.exports}
 */
CommonMenuItemBuilder.prototype.activeClass = 'ui-link_selected';

/**
 * Default menu item link attributes
 * @type {{target: string}}
 */
CommonMenuItemBuilder.prototype.defaultAttributes = {
    target: '_self'
};

/**
 * Default item HTML template
 * @type {string}
 */
CommonMenuItemBuilder.prototype.template = '<li class="{{outerClass}}"><a href="{{href}}" class="{{innerClass}}">{{title}}</a></li>';

/**
 * Build item object
 * @public
 * @param {string|jQuery} [title]
 * @param {string} [href]
 * @param {object} [attributes]
 * @returns {CommonMenuItem|*}
 */
CommonMenuItemBuilder.prototype.getMenuItem = function (title, href, attributes) {
    var $object;
    var clonedAttributes = _jquery2.default.extend({}, attributes);

    if (arguments[0] instanceof _jquery2.default) {
        $object = (0, _jquery2.default)(arguments[0]);
    } else {
        $object = (0, _jquery2.default)(this.buildTemplate(title, href));
        clonedAttributes.class = this.innerClass + ' ' + (clonedAttributes.class || '');
        $object.children().attr(_jquery2.default.extend({}, this.defaultAttributes, clonedAttributes));
    }

    return this.buildItem($object);
};

/**
 * @protected
 * @param {jQuery} $object
 * @returns {CommonMenuItem|*}
 */
CommonMenuItemBuilder.prototype.buildItem = function ($object) {
    if (typeof this.ItemConstructor !== 'function') {
        throw new Error('ItemConstructor property is not a function');
    }

    var item = new this.ItemConstructor($object, this.activeClass);

    if (!(item instanceof _commonMenuItem2.default)) {
        throw new Error('Item object is not instance of CommonMenuItem');
    }

    return item;
};

/**
 * @protected
 * @returns {string}
 */
CommonMenuItemBuilder.prototype.buildTemplate = function (title, href) {
    return this.template.replace('{{outerClass}}', this.outerClass).replace('{{innerClass}}', this.innerClass).replace('{{title}}', title).replace('{{href}}', href);
};

exports.default = CommonMenuItemBuilder;

/***/ }),
/* 988 */,
/* 989 */,
/* 990 */,
/* 991 */,
/* 992 */,
/* 993 */,
/* 994 */,
/* 995 */,
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.pricesProvider = exports.PRICE_HANDLER_EVENTS = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = __webpack_require__(192);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _rpDiffusionConnector = __webpack_require__(291);

var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);

var _DiffusionServiceUtils = __webpack_require__(229);

var _PricesStateStore = __webpack_require__(228);

var _HorsesListStore = __webpack_require__(998);

var _PubSub2 = __webpack_require__(2603);

var _PubSub3 = _interopRequireDefault(_PubSub2);

var _DiffusionSubscriber = __webpack_require__(2601);

var _DiffusionSubscriber2 = _interopRequireDefault(_DiffusionSubscriber);

var _EVENTS = __webpack_require__(997);

var _EVENTS2 = _interopRequireDefault(_EVENTS);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PRICE_HANDLER_EVENTS = exports.PRICE_HANDLER_EVENTS = {
    PRICE_RECEIVED: 'PRICE_RECEIVED',
    PRICES_WILL_BE_UPDATED: 'PRICES_WILL_BE_UPDATED',
    PRICES_SETTINGS_CHANGED: 'PRICES_SETTINGS_CHANGED',
    RACE_INFO_RECEIVED: 'RACE_INFO_RECEIVED'
};

var PricesProvider = function (_PubSub) {
    _inherits(PricesProvider, _PubSub);

    function PricesProvider() {
        _classCallCheck(this, PricesProvider);

        var _this = _possibleConstructorReturn(this, (PricesProvider.__proto__ || Object.getPrototypeOf(PricesProvider)).call(this));

        _this.config = {
            session: {
                onDataFunction: _this.onDataReceive.bind(_this),
                onCallbackFunction: _this.onConnectionStatusChange.bind(_this)
            }
        };
        return _this;
    }

    _createClass(PricesProvider, [{
        key: 'init',
        value: function init(bookmakerName) {
            _PricesStateStore.pricesStateStore.setCurrentBookmaker(bookmakerName);
            if (_jsCookie2.default.get('customizeSettings')) {
                this.setPriceViewType();
            }

            if (!(0, _rpDiffusionConnector.shouldEstablishSession)()) {
                this.session = null;
                this.subscriber = null;
                return;
            }

            this.session = new _rpDiffusionConnector2.default(this.config.session);
            this.subscriber = new _DiffusionSubscriber2.default(this.session);
            this.subscriber.run();
            this.bindEvents();
            _HorsesListStore.horsesListStore.updateHorsesData();
            // TODO: move it out of provider (JIRA: PC-4559)
            this.subscribeForPrices(_HorsesListStore.horsesListStore.getHorsesList(), bookmakerName);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            (0, _jquery2.default)(document).on(_EVENTS2.default.BOOKMAKER_CHANGED, this.onBookmakerChanged.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.DYNAMIC_PRICES_UPDATED, this.onDynamicPricesUpdated.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.HORSES_LIST_CHANGED, this.onHorsesListChanged.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.USER_SETTINGS_CHANGED, this.onUserSettingsChanged.bind(this));
        }

        /* eslint-disable class-methods-use-this */

    }, {
        key: 'setPriceViewType',
        value: function setPriceViewType() {
            var showDecimal = JSON.parse(_jsCookie2.default.get('customizeSettings')).decimalOdds;
            if (_PricesStateStore.pricesStateStore.isDecimalPrice() !== showDecimal) {
                _PricesStateStore.pricesStateStore.setPriceViewType({ showDecimal: showDecimal });
            }
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'onBookmakerChanged',
        value: function onBookmakerChanged(event, newBookmakerName) {
            var horsesList = _HorsesListStore.horsesListStore.getHorsesList();

            this.unsubscribeAll();
            _PricesStateStore.pricesStateStore.setCurrentBookmaker(newBookmakerName);
            this.publish(PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED);
            this.subscribeForPrices(horsesList, newBookmakerName);
        }
    }, {
        key: 'onDynamicPricesUpdated',
        value: function onDynamicPricesUpdated() {
            var newHorsesData = _HorsesListStore.horsesListStore.updateHorsesData();
            var bookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();

            this.subscribeForPrices(newHorsesData, bookmaker);
        }
    }, {
        key: 'onHorsesListChanged',
        value: function onHorsesListChanged() {
            var bookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();

            this.unsubscribeAll();
            _HorsesListStore.horsesListStore.updateHorsesData();
            this.subscribeForPrices(_HorsesListStore.horsesListStore.getHorsesList(), bookmaker);
        }
    }, {
        key: 'onUserSettingsChanged',
        value: function onUserSettingsChanged(event, userSettings) {
            var showDecimal = userSettings.decimalOdds;

            if (_PricesStateStore.pricesStateStore.isDecimalPrice() !== showDecimal) {
                _PricesStateStore.pricesStateStore.setPriceViewType({ showDecimal: showDecimal });
                this.publish(PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, { showDecimal: showDecimal });
            }
        }
    }, {
        key: 'unsubscribeAll',
        value: function unsubscribeAll() {
            // this.subscriber.unsubscribeAll();

            // todo: add check - JP-10398
            if (this.subscriber) {
                this.subscriber.unsubscribeAll();
            }
        }
    }, {
        key: 'subscribeForPrices',
        value: function subscribeForPrices(horsesList, bookmaker) {
            if (!bookmaker) {
                return;
            }

            var topics = horsesList.filter(function (horseData) {
                return horseData;
            }).map(function (horseData) {
                var courseName = horseData.courseName,
                    raceTime = horseData.raceTime,
                    raceDate = horseData.raceDate,
                    horseName = horseData.horseName;

                var priceTopic = _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic({
                    courseName: courseName,
                    raceTime: raceTime,
                    raceDate: raceDate,
                    horseName: horseName,
                    bookmaker: bookmaker
                });
                var infoTopic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic({
                    courseName: courseName,
                    raceTime: raceTime,
                    raceDate: raceDate,
                    bookmaker: bookmaker
                });

                return [priceTopic, infoTopic];
            }).reduce(function (acum, value) {
                return acum.concat(value);
            }, []).filter(function (topic) {
                return topic;
            });

            this.subscriber.subscribe(topics);
            // todo: add check - JP-10398
            // if (this.subscriber) {
            //     this.subscriber.subscribe(topics);
            // }
        }
    }, {
        key: 'unsubscribeFromPrices',
        value: function unsubscribeFromPrices(horsesList, bookmaker) {
            var _this2 = this;

            // todo: add check - JP-10398
            if (!this.session) return;

            horsesList.map(function (horseData) {
                return _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic(_extends(horseData, { bookmaker: bookmaker }));
            }).filter(function (topic) {
                return topic;
            }).forEach(function (topic) {
                return _this2.session.unsubscribe({ topic: topic });
            });
        }
    }, {
        key: 'onDataReceive',
        value: function onDataReceive(WebClientMessage) {
            // todo: add check - JP-0
            // if (!WebClientMessage) return;

            var topic = WebClientMessage.getTopic();

            if (topic.includes('#INFO')) {
                this.handleRaceInfo(WebClientMessage);
            } else {
                this.handleHorsePrice(WebClientMessage);
            }
        }
    }, {
        key: 'onConnectionStatusChange',
        value: function onConnectionStatusChange(isOpened) {
            // todo: add check - JP-10398
            // if (!this.subscriber) return;

            if (isOpened) {
                this.subscriber.run();
            } else {
                this.subscriber.stop();
            }
        }
    }, {
        key: 'handleHorsePrice',
        value: function handleHorsePrice(WebClientMessage) {
            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parsePriceTopicData(WebClientMessage);

            this.publish(PRICE_HANDLER_EVENTS.PRICE_RECEIVED, renderConfig);
            (0, _jquery2.default)(document).trigger(_EVENTS2.default.PRICES_NEED_SORTING);
        }
    }, {
        key: 'handleRaceInfo',
        value: function handleRaceInfo(WebClientMessage) {
            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parseInfoTopicData(WebClientMessage);

            _PricesStateStore.pricesStateStore.updateRaceInfo(renderConfig);
            this.publish(PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, renderConfig);
        }
    }]);

    return PricesProvider;
}(_PubSub3.default);
// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)


var pricesProvider = exports.pricesProvider = new PricesProvider();

/***/ }),
/* 997 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    USER_SETTINGS_CHANGED: 'userSettingsChanged.SETTINGS',
    DYNAMIC_PRICES_UPDATED: 'dynamicPricesUpdated.PRICES',
    RESIZE: 'resize',
    SWITCH_BREAKPOINTS: 'rpBreakpointsSwitch',
    MAKE_SELECTION: 'RC.makeSelection',
    BOOKMAKER_CHANGED: 'bookieChanged.BOOKMAKER',
    INFO_TOPIC_UPDATED: 'infoTopicUpdate.PRICES',
    HORSES_LIST_CHANGED: 'horsesListChanged',
    // TODO: RC - Race card related prefix (JIRA: PC-4557)
    PRICES_NEED_SORTING: 'RC.priceUpdatedToSort'
};

/***/ }),
/* 998 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.horsesListStore = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _DiffusionServiceUtils = __webpack_require__(229);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var newHorseElementsSelector = '.js-diffusionHorsesList:not(.js-PC-subscribed)';
var subscribedHorseseClass = 'js-PC-subscribed';

var HorsesListStore = function () {
    function HorsesListStore() {
        _classCallCheck(this, HorsesListStore);

        this.horsesList = [];
    }

    _createClass(HorsesListStore, [{
        key: 'getHorsesList',
        value: function getHorsesList() {
            return this.horsesList;
        }

        // TODO: move to private function, utils or static method (JIRA: PC-4559)
        /* eslint-disable class-methods-use-this */

    }, {
        key: 'getNotSubscribedHorses',
        value: function getNotSubscribedHorses() {
            var diffusionHorsesNodeList = (0, _jquery2.default)(newHorseElementsSelector).toArray();
            var notSubscribedHorses = diffusionHorsesNodeList.map(_DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData.bind(_DiffusionServiceUtils.diffusionServiceUtils));

            diffusionHorsesNodeList.forEach(function (element) {
                element.classList.add(subscribedHorseseClass);
            });

            return notSubscribedHorses;
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'updateHorsesData',
        value: function updateHorsesData() {
            var notSubscribedHorses = this.getNotSubscribedHorses();

            this.horsesList = this.horsesList.concat(notSubscribedHorses);

            return notSubscribedHorses;
        }
    }]);

    return HorsesListStore;
}();
// TODO: export constructor and instantiate it in place of usage (JIRA: PC-4559)
/* eslint-disable import/prefer-default-export */


var horsesListStore = exports.horsesListStore = new HorsesListStore();

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpAnalytics = __webpack_require__(59);

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopOver = function () {
    function PopOver(popOverConfig) {
        _classCallCheck(this, PopOver);

        var defaultConfig = {
            popOverSelector: '.js-popOver',
            openAreaSelectors: ['.js-popOver__openArea'],
            toggleAreaSelector: '.js-popOver__toggleArea',
            closeAreaSelectors: ['.js-popOver__shadow', '.js-popOver__closeBtn'],
            activeClass: 'ui-popOver_active',
            onOpen: null,
            onClose: null,
            name: ''
        };
        this.config = _jquery2.default.extend(true, defaultConfig, popOverConfig);
        this.init();
    }

    _createClass(PopOver, [{
        key: 'init',
        value: function init() {
            this.popOver = (0, _jquery2.default)(this.config.popOverSelector)[0];
            this.openArea = (0, _jquery2.default)(this.config.openAreaSelectors.join(','));
            this.toggleArea = (0, _jquery2.default)(this.config.toggleAreaSelector)[0];
            this.closeArea = (0, _jquery2.default)(this.config.closeAreaSelectors.join(','));

            this.bindEvents();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this = this;

            Array.prototype.forEach.call(this.openArea, function (element) {
                return element.addEventListener('click', function (e) {
                    _this.onOpenAreaClicked(e);
                }, false);
            });

            if (this.toggleArea) {
                this.toggleArea.addEventListener('click', function (e) {
                    _this.onTogglePopOver(e);
                }, false);
            }

            Array.prototype.forEach.call(this.closeArea, function (element) {
                return element.addEventListener('click', function (e) {
                    _this.onCloseAreaClicked(e);
                }, false);
            });
        }
    }, {
        key: 'onOpenAreaClicked',
        value: function onOpenAreaClicked(event) {
            event.preventDefault();
            this.open(event);

            // Note:
            // This is a solution for the re-rendering
            // If we don't remove the click event listener first,
            // multiple Segment events will trigger due to re-rendering
            (0, _jquery2.default)('.PC-bestOdds__bookieRow__name_account.ui-link').off('click');
            (0, _jquery2.default)('.PC-bestOdds__bookieRow__name_account.ui-link').on('click', function () {
                var _SegmentIO$trackBookm;

                var bookmakerNode = (0, _jquery2.default)('.PC-bestOdds__bookieRow:hover');
                var bookmakerNameFound = bookmakerNode.find('.PC-bestOdds__bookieRow__name > div').text().trim();
                var bookmakerName = bookmakerNameFound === 'Sky bet' ? 'SkyBet' : bookmakerNameFound;
                var bookmakerPosition = Number(Number((0, _jquery2.default)('.PC-bestOdds__bookieRow:hover').css('order')) + 1);

                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm = {}, _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_OFFERS_BANNER, null), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_POSITION, bookmakerPosition), _SegmentIO$trackBookm));
            });
        }
    }, {
        key: 'onTogglePopOver',
        value: function onTogglePopOver(event) {
            event.preventDefault();
            this.toggle();
        }
    }, {
        key: 'onCloseAreaClicked',
        value: function onCloseAreaClicked(event) {
            (0, _jquery2.default)('.PC-bestOdds__bookieRow__name_account.ui-link').off('click');

            this.close(event);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            var _this2 = this;

            Array.prototype.forEach.call(this.openArea, function (element) {
                element.removeEventListener('click', function (e) {
                    _this2.onOpenAreaClicked(e);
                }, false);
            });

            if (this.toggleArea) {
                this.toggleArea.removeEventListener('click', function (e) {
                    _this2.onTogglePopOver(e);
                }, false);
            }

            Array.prototype.forEach.call(this.closeArea, function (element) {
                element.removeEventListener('click', function (e) {
                    _this2.onCloseAreaClicked(e);
                }, false);
            });
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (this.isActive()) {
                this.close();
            } else {
                this.open();
            }
        }
    }, {
        key: 'open',
        value: function open(event) {
            if (this.popOver) {
                this.popOver.classList.add(this.config.activeClass);
            }

            if (this.config.onOpen instanceof Function) {
                this.config.onOpen(event);
            }

            _jquery2.default.event.trigger('popoverOpened' + this.config.name);
        }
    }, {
        key: 'close',
        value: function close() {
            if (this.config.onClose instanceof Function) {
                this.config.onClose();
            }

            if (this.popOver) {
                this.popOver.classList.remove(this.config.activeClass);
            }

            _jquery2.default.event.trigger('popoverClosed' + this.config.name);
        }
    }, {
        key: 'isActive',
        value: function isActive() {
            return this.popOver.classList.contains(this.config.activeClass);
        }
    }]);

    return PopOver;
}();

exports.default = PopOver;

/***/ }),
/* 1000 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Loading = function Loading() {
  return _react2.default.createElement(
    'div',
    { className: 'ui-centered-wrapper' },
    _react2.default.createElement(_rpReactSvgIcon2.default, {
      iconName: 'spinner',
      size: '2XL',
      className: 'ui-animation_spinnerAnimation'
    })
  );
};

exports.default = Loading;

/***/ }),
/* 1001 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoData = function NoData(_ref) {
  var text = _ref.text;
  return _react2.default.createElement(
    'div',
    { className: 'ui-errorMessage' },
    _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'results', size: '2XL' }),
    _react2.default.createElement(
      'div',
      { className: 'ui-errorMessage__text' },
      text
    )
  );
};

NoData.propTypes = {
  text: _propTypes2.default.string
};

exports.default = NoData;

/***/ }),
/* 1002 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ShowMore = function ShowMore(_ref) {
  var onClick = _ref.onClick;
  return _react2.default.createElement(
    'div',
    { className: 'ui-centered-wrapper' },
    _react2.default.createElement(
      'button',
      {
        className: 'rp-table-showmore ui-link ui-link_chevron',
        onClick: onClick
      },
      'Show more',
      _react2.default.createElement(_rpReactSvgIcon2.default, {
        iconName: 'down',
        size: 'Small',
        className: 'ui-icon ui-icon__btn'
      })
    )
  );
};

ShowMore.propTypes = {
  onClick: _propTypes2.default.func.isRequired
};

exports.default = ShowMore;

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _shortid = __webpack_require__(386);

var _shortid2 = _interopRequireDefault(_shortid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addId = function addId(data) {
  return data.map(function (item) {
    return _extends({}, item, {
      __id: _shortid2.default.generate()
    });
  });
};

exports.default = addId;

/***/ }),
/* 1004 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var EMPTINESS_SIGN = exports.EMPTINESS_SIGN = '—';

var isFinite = Number.isFinite;


var handleEmpty = function handleEmpty(value) {
  return isFinite(value) || value ? value : EMPTINESS_SIGN;
};

exports.default = handleEmpty;

/***/ }),
/* 1005 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(9);

var _compareFns = __webpack_require__(1006);

var _compareFns2 = _interopRequireDefault(_compareFns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var addSortFn = function addSortFn(col) {
  var sortFn = col.sortFn,
      key = col.key;


  if (!sortFn) return _extends({}, col, { sortFn: _compareFns2.default.numeric(key) });

  if ((0, _lodash.isFunction)(sortFn)) return col;

  return _extends({}, col, { sortFn: _compareFns2.default[sortFn](key) });
};

var addSortFns = function addSortFns(cols, sortable, initialIdx, defaultIdx) {
  if (sortable) {
    return cols.map(addSortFn);
  }

  return cols.map(function (col, idx) {
    return idx === initialIdx || idx === defaultIdx ? addSortFn(col) : col;
  });
};

exports.default = addSortFns;

/***/ }),
/* 1006 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _alphabetic = __webpack_require__(2616);

var _alphabetic2 = _interopRequireDefault(_alphabetic);

var _numeric = __webpack_require__(2618);

var _byLastName = __webpack_require__(2617);

var _byLastName2 = _interopRequireDefault(_byLastName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  alphabetic: _alphabetic2.default, numeric: _numeric.numeric, numericReverse: _numeric.numericReverse, byLastName: _byLastName2.default
};

/***/ }),
/* 1007 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _thenby = __webpack_require__(2632);

var _thenby2 = _interopRequireDefault(_thenby);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } } /*
                                                                                                                                                                                                     * Sort table using particular column's sorting fn
                                                                                                                                                                                                     */


var sortData = function sortData(data, columns, idx, defaultIdx) {
  return [].concat(_toConsumableArray(data)).sort((0, _thenby2.default)(columns[idx].sortFn).thenBy(columns[defaultIdx].sortFn));
};

exports.default = sortData;

/***/ }),
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _CoursePage = __webpack_require__(1086);

var _CoursePage2 = _interopRequireDefault(_CoursePage);

var _CourseMap = __webpack_require__(1089);

var _CourseMap2 = _interopRequireDefault(_CourseMap);

var _CourseInfo = __webpack_require__(1087);

var _CourseInfo2 = _interopRequireDefault(_CourseInfo);

var _Signposts = __webpack_require__(1103);

var _Signposts2 = _interopRequireDefault(_Signposts);

var _Stats = __webpack_require__(1109);

var _Stats2 = _interopRequireDefault(_Stats);

var _Favourites = __webpack_require__(1093);

var _Favourites2 = _interopRequireDefault(_Favourites);

var _Results = __webpack_require__(1100);

var _Results2 = _interopRequireDefault(_Results);

var _CourseRecords = __webpack_require__(1091);

var _CourseRecords2 = _interopRequireDefault(_CourseRecords);

var _PageProvider = __webpack_require__(406);

var _PageProvider2 = _interopRequireDefault(_PageProvider);

var _TabFetchProvider = __webpack_require__(298);

var _TabFetchProvider2 = _interopRequireDefault(_TabFetchProvider);

var _TabProvider = __webpack_require__(407);

var _TabProvider2 = _interopRequireDefault(_TabProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = {
    path: 'course/:id/:name',
    component: _PageProvider2.default,
    Page: _CoursePage2.default,
    indexRoute: {
        component: _TabFetchProvider2.default,
        Tab: _Stats2.default,
        fetchPath: 'stats'
    },
    childRoutes: [{
        path: 'stats',
        component: _TabFetchProvider2.default,
        Tab: _Stats2.default
    }, {
        path: 'course-map',
        component: _TabProvider2.default,
        Tab: _CourseMap2.default
    }, {
        path: 'course-records',
        component: _TabProvider2.default,
        Tab: _CourseRecords2.default
    }, {
        path: 'favourites',
        component: _TabFetchProvider2.default,
        Tab: _Favourites2.default
    }, {
        path: 'signposts',
        component: _TabFetchProvider2.default,
        Tab: _Signposts2.default
    }, {
        path: 'course-info',
        component: _TabProvider2.default,
        Tab: _CourseInfo2.default
    }, {
        path: 'results',
        component: _TabFetchProvider2.default,
        Tab: _Results2.default
    }]
};

exports.default = routes;

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // data providers


// page and index tab


// common horse tabs


// progeny present on stallion and dam


// dam tabs


// stallion tabs


var _PageProvider = __webpack_require__(406);

var _PageProvider2 = _interopRequireDefault(_PageProvider);

var _TabFetchProvider = __webpack_require__(298);

var _TabFetchProvider2 = _interopRequireDefault(_TabFetchProvider);

var _TabProvider = __webpack_require__(407);

var _TabProvider2 = _interopRequireDefault(_TabProvider);

var _HorsePage = __webpack_require__(1112);

var _HorsePage2 = _interopRequireDefault(_HorsePage);

var _IndexTab = __webpack_require__(1113);

var _IndexTab2 = _interopRequireDefault(_IndexTab);

var _Form = __webpack_require__(610);

var _Form2 = _interopRequireDefault(_Form);

var _Entries = __webpack_require__(625);

var _Entries2 = _interopRequireDefault(_Entries);

var _Stats = __webpack_require__(1198);

var _Stats2 = _interopRequireDefault(_Stats);

var _Quotes = __webpack_require__(1181);

var _Quotes2 = _interopRequireDefault(_Quotes);

var _Pedigree = __webpack_require__(1156);

var _Pedigree2 = _interopRequireDefault(_Pedigree);

var _Sales = __webpack_require__(1188);

var _Sales2 = _interopRequireDefault(_Sales);

var _Notes = __webpack_require__(1151);

var _Notes2 = _interopRequireDefault(_Notes);

var _Progeny = __webpack_require__(614);

var _Progeny2 = _interopRequireDefault(_Progeny);

var _ProgenyEntries = __webpack_require__(1169);

var _ProgenyEntries2 = _interopRequireDefault(_ProgenyEntries);

var _ProgenySales = __webpack_require__(1174);

var _ProgenySales2 = _interopRequireDefault(_ProgenySales);

var _WeatherbysOverview = __webpack_require__(619);

var _WeatherbysOverview2 = _interopRequireDefault(_WeatherbysOverview);

var _SireReference = __webpack_require__(1196);

var _SireReference2 = _interopRequireDefault(_SireReference);

var _RecentStakesPerformers = __webpack_require__(1182);

var _RecentStakesPerformers2 = _interopRequireDefault(_RecentStakesPerformers);

var _ProgenyStatistics = __webpack_require__(1178);

var _ProgenyStatistics2 = _interopRequireDefault(_ProgenyStatistics);

var _SalesStatistics = __webpack_require__(1192);

var _SalesStatistics2 = _interopRequireDefault(_SalesStatistics);

var _FeeHistory = __webpack_require__(1122);

var _FeeHistory2 = _interopRequireDefault(_FeeHistory);

var _Nicks = __webpack_require__(1147);

var _Nicks2 = _interopRequireDefault(_Nicks);

var _ProgenyResults = __webpack_require__(1170);

var _ProgenyResults2 = _interopRequireDefault(_ProgenyResults);

var _SalesResults = __webpack_require__(1191);

var _SalesResults2 = _interopRequireDefault(_SalesResults);

var _SalesEntries = __webpack_require__(1190);

var _SalesEntries2 = _interopRequireDefault(_SalesEntries);

var _BestProgeny = __webpack_require__(1114);

var _BestProgeny2 = _interopRequireDefault(_BestProgeny);

var _StallionBookPdf = __webpack_require__(1197);

var _StallionBookPdf2 = _interopRequireDefault(_StallionBookPdf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var childRoutes = [
// common horse tabs
{ path: 'form', Tab: _Form2.default, childRoutes: [{ path: 'my-ratings' }] }, { path: 'entries', Tab: _Entries2.default }, { path: 'stats', Tab: _Stats2.default }, { path: 'quotes', Tab: _Quotes2.default }, { path: 'pedigree', Tab: _Pedigree2.default }, { path: 'sales', Tab: _Sales2.default }, { path: 'notes', Tab: _Notes2.default },

// progeny present on stallion and dam
{ path: 'progeny', Tab: _Progeny2.default },

// dam tabs
{ path: 'progeny-entries', Tab: _ProgenyEntries2.default }, { path: 'progeny-sales', Tab: _ProgenySales2.default },

// stallion tabs
{ path: 'weatherbys-overview', Tab: _WeatherbysOverview2.default }, { path: 'best-progeny', Tab: _BestProgeny2.default }, { path: 'sire-reference', Tab: _SireReference2.default }, { path: 'recent-stakes-performers', Tab: _RecentStakesPerformers2.default }, { path: 'stallion-book-pdf', Tab: _StallionBookPdf2.default }, { path: 'progeny-dams-sire', Tab: _Progeny2.default }, { path: 'progeny-statistics', Tab: _ProgenyStatistics2.default }, { path: 'progeny-results', Tab: _ProgenyResults2.default }, { path: 'nicks', Tab: _Nicks2.default }, { path: 'fee-history', Tab: _FeeHistory2.default }, { path: 'sales-statistics', Tab: _SalesStatistics2.default }, { path: 'sales-results', Tab: _SalesResults2.default }, { path: 'sales-entries', Tab: _SalesEntries2.default }];

var noFetchTabs = ['entries', 'sales-results', 'sales-entries'];

var routes = {
    path: 'horse/:id/:name',
    component: _PageProvider2.default,
    Page: _HorsePage2.default,
    indexRoute: { component: _IndexTab2.default },
    childRoutes: childRoutes.map(function (route) {
        return _extends({}, route, {
            component: noFetchTabs.includes(route.path) ? _TabProvider2.default : _TabFetchProvider2.default
        });
    })
};

exports.default = routes;

/***/ }),
/* 1013 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _HumanPage = __webpack_require__(1203);

var _HumanPage2 = _interopRequireDefault(_HumanPage);

var _Form = __webpack_require__(1209);

var _Form2 = _interopRequireDefault(_Form);

var _Entries = __webpack_require__(625);

var _Entries2 = _interopRequireDefault(_Entries);

var _Horses = __webpack_require__(1221);

var _Horses2 = _interopRequireDefault(_Horses);

var _Stats = __webpack_require__(1228);

var _Stats2 = _interopRequireDefault(_Stats);

var _PageProvider = __webpack_require__(406);

var _PageProvider2 = _interopRequireDefault(_PageProvider);

var _TabFetchProvider = __webpack_require__(298);

var _TabFetchProvider2 = _interopRequireDefault(_TabFetchProvider);

var _TabProvider = __webpack_require__(407);

var _TabProvider2 = _interopRequireDefault(_TabProvider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var humans = ['jockey', 'trainer', 'owner'];

var routes = humans.map(function (human) {
    return {
        path: human + '/:id/:name',
        component: _PageProvider2.default,
        Page: _HumanPage2.default,
        indexRoute: {
            component: _TabProvider2.default,
            Tab: _Form2.default
        },
        childRoutes: [{
            path: 'form',
            component: _TabProvider2.default,
            Tab: _Form2.default
        }, {
            path: human === 'jockey' ? 'booked-rides' : 'entries',
            component: _TabProvider2.default,
            Tab: _Entries2.default
        }, {
            path: 'horses',
            component: _TabFetchProvider2.default,
            Tab: _Horses2.default
        }, {
            path: 'stats',
            component: _TabFetchProvider2.default,
            Tab: _Stats2.default
        }]
    };
});

exports.default = routes;

/***/ }),
/* 1014 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpBettingSpecialOffer = __webpack_require__(2535);

var _rpBettingSpecialOffer2 = _interopRequireDefault(_rpBettingSpecialOffer);

var _rpGuiGuide = __webpack_require__(126);

var _rpGuiGuide2 = _interopRequireDefault(_rpGuiGuide);

var _rpPopup = __webpack_require__(390);

var _rpPopup2 = _interopRequireDefault(_rpPopup);

var _rpUrlNavigationPrefs = __webpack_require__(2619);

var _rpUrlNavigationPrefs2 = _interopRequireDefault(_rpUrlNavigationPrefs);

var _initAds = __webpack_require__(1234);

var _initAds2 = _interopRequireDefault(_initAds);

var _initPrices = __webpack_require__(1235);

var _initPrices2 = _interopRequireDefault(_initPrices);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    beforeRender: function beforeRender() {
        (0, _rpGuiGuide2.default)({
            // transform svg to inline
            svg: { polyfill: true }
        });
    },
    afterRender: function afterRender() {
        (0, _rpBettingSpecialOffer2.default)();
        (0, _initAds2.default)();
        (0, _initPrices2.default)();
        (0, _rpPopup2.default)();
        (0, _rpPopup.backLink)();
        (0, _rpUrlNavigationPrefs2.default)();
    }
};

/***/ }),
/* 1015 */,
/* 1016 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1017 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.locationsAreEqual = exports.Actions = exports.useQueries = exports.useBeforeUnload = exports.useBasename = exports.createMemoryHistory = exports.createHashHistory = exports.createHistory = undefined;

var _LocationUtils = __webpack_require__(190);

Object.defineProperty(exports, 'locationsAreEqual', {
  enumerable: true,
  get: function get() {
    return _LocationUtils.locationsAreEqual;
  }
});

var _createBrowserHistory = __webpack_require__(845);

var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);

var _createHashHistory2 = __webpack_require__(846);

var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);

var _createMemoryHistory2 = __webpack_require__(847);

var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);

var _useBasename2 = __webpack_require__(519);

var _useBasename3 = _interopRequireDefault(_useBasename2);

var _useBeforeUnload2 = __webpack_require__(2122);

var _useBeforeUnload3 = _interopRequireDefault(_useBeforeUnload2);

var _useQueries2 = __webpack_require__(520);

var _useQueries3 = _interopRequireDefault(_useQueries2);

var _Actions2 = __webpack_require__(270);

var _Actions = _interopRequireWildcard(_Actions2);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.createHistory = _createBrowserHistory2.default;
exports.createHashHistory = _createHashHistory3.default;
exports.createMemoryHistory = _createMemoryHistory3.default;
exports.useBasename = _useBasename3.default;
exports.useBeforeUnload = _useBeforeUnload3.default;
exports.useQueries = _useQueries3.default;
exports.Actions = _Actions;

/***/ }),
/* 1018 */,
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/*!
 * Glide.js v3.4.1
 * (c) 2013-2019 Jędrzej Chałubek <jedrzej.chalubek@gmail.com> (http://jedrzejchalubek.com/)
 * Released under the MIT License.
 */

var defaults = {
  /**
   * Type of the movement.
   *
   * Available types:
   * `slider` - Rewinds slider to the start/end when it reaches the first or last slide.
   * `carousel` - Changes slides without starting over when it reaches the first or last slide.
   *
   * @type {String}
   */
  type: 'slider',

  /**
   * Start at specific slide number defined with zero-based index.
   *
   * @type {Number}
   */
  startAt: 0,

  /**
   * A number of slides visible on the single viewport.
   *
   * @type {Number}
   */
  perView: 1,

  /**
   * Focus currently active slide at a specified position in the track.
   *
   * Available inputs:
   * `center` - Current slide will be always focused at the center of a track.
   * `0,1,2,3...` - Current slide will be focused on the specified zero-based index.
   *
   * @type {String|Number}
   */
  focusAt: 0,

  /**
   * A size of the gap added between slides.
   *
   * @type {Number}
   */
  gap: 10,

  /**
   * Change slides after a specified interval. Use `false` for turning off autoplay.
   *
   * @type {Number|Boolean}
   */
  autoplay: false,

  /**
   * Stop autoplay on mouseover event.
   *
   * @type {Boolean}
   */
  hoverpause: true,

  /**
   * Allow for changing slides with left and right keyboard arrows.
   *
   * @type {Boolean}
   */
  keyboard: true,

  /**
   * Stop running `perView` number of slides from the end. Use this
   * option if you don't want to have an empty space after
   * a slider. Works only with `slider` type and a
   * non-centered `focusAt` setting.
   *
   * @type {Boolean}
   */
  bound: false,

  /**
   * Minimal swipe distance needed to change the slide. Use `false` for turning off a swiping.
   *
   * @type {Number|Boolean}
   */
  swipeThreshold: 80,

  /**
   * Minimal mouse drag distance needed to change the slide. Use `false` for turning off a dragging.
   *
   * @type {Number|Boolean}
   */
  dragThreshold: 120,

  /**
   * A maximum number of slides to which movement will be made on swiping or dragging. Use `false` for unlimited.
   *
   * @type {Number|Boolean}
   */
  perTouch: false,

  /**
   * Moving distance ratio of the slides on a swiping and dragging.
   *
   * @type {Number}
   */
  touchRatio: 0.5,

  /**
   * Angle required to activate slides moving on swiping or dragging.
   *
   * @type {Number}
   */
  touchAngle: 45,

  /**
   * Duration of the animation in milliseconds.
   *
   * @type {Number}
   */
  animationDuration: 400,

  /**
   * Allows looping the `slider` type. Slider will rewind to the first/last slide when it's at the start/end.
   *
   * @type {Boolean}
   */
  rewind: true,

  /**
   * Duration of the rewinding animation of the `slider` type in milliseconds.
   *
   * @type {Number}
   */
  rewindDuration: 800,

  /**
   * Easing function for the animation.
   *
   * @type {String}
   */
  animationTimingFunc: 'cubic-bezier(.165, .840, .440, 1)',

  /**
   * Throttle costly events at most once per every wait milliseconds.
   *
   * @type {Number}
   */
  throttle: 10,

  /**
   * Moving direction mode.
   *
   * Available inputs:
   * - 'ltr' - left to right movement,
   * - 'rtl' - right to left movement.
   *
   * @type {String}
   */
  direction: 'ltr',

  /**
   * The distance value of the next and previous viewports which
   * have to peek in the current view. Accepts number and
   * pixels as a string. Left and right peeking can be
   * set up separately with a directions object.
   *
   * For example:
   * `100` - Peek 100px on the both sides.
   * { before: 100, after: 50 }` - Peek 100px on the left side and 50px on the right side.
   *
   * @type {Number|String|Object}
   */
  peek: 0,

  /**
   * Collection of options applied at specified media breakpoints.
   * For example: display two slides per view under 800px.
   * `{
   *   '800px': {
   *     perView: 2
   *   }
   * }`
   */
  breakpoints: {},

  /**
   * Collection of internally used HTML classes.
   *
   * @todo Refactor `slider` and `carousel` properties to single `type: { slider: '', carousel: '' }` object
   * @type {Object}
   */
  classes: {
    direction: {
      ltr: 'glide--ltr',
      rtl: 'glide--rtl'
    },
    slider: 'glide--slider',
    carousel: 'glide--carousel',
    swipeable: 'glide--swipeable',
    dragging: 'glide--dragging',
    cloneSlide: 'glide__slide--clone',
    activeNav: 'glide__bullet--active',
    activeSlide: 'glide__slide--active',
    disabledArrow: 'glide__arrow--disabled'
  }
};

/**
 * Outputs warning message to the bowser console.
 *
 * @param  {String} msg
 * @return {Void}
 */
function warn(msg) {
  console.error("[Glide warn]: " + msg);
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var get = function get(object, property, receiver) {
  if (object === null) object = Function.prototype;
  var desc = Object.getOwnPropertyDescriptor(object, property);

  if (desc === undefined) {
    var parent = Object.getPrototypeOf(object);

    if (parent === null) {
      return undefined;
    } else {
      return get(parent, property, receiver);
    }
  } else if ("value" in desc) {
    return desc.value;
  } else {
    var getter = desc.get;

    if (getter === undefined) {
      return undefined;
    }

    return getter.call(receiver);
  }
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

/**
 * Converts value entered as number
 * or string to integer value.
 *
 * @param {String} value
 * @returns {Number}
 */
function toInt(value) {
  return parseInt(value);
}

/**
 * Converts value entered as number
 * or string to flat value.
 *
 * @param {String} value
 * @returns {Number}
 */
function toFloat(value) {
  return parseFloat(value);
}

/**
 * Indicates whether the specified value is a string.
 *
 * @param  {*}   value
 * @return {Boolean}
 */
function isString(value) {
  return typeof value === 'string';
}

/**
 * Indicates whether the specified value is an object.
 *
 * @param  {*} value
 * @return {Boolean}
 *
 * @see https://github.com/jashkenas/underscore
 */
function isObject(value) {
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);

  return type === 'function' || type === 'object' && !!value; // eslint-disable-line no-mixed-operators
}

/**
 * Indicates whether the specified value is a number.
 *
 * @param  {*} value
 * @return {Boolean}
 */
function isNumber(value) {
  return typeof value === 'number';
}

/**
 * Indicates whether the specified value is a function.
 *
 * @param  {*} value
 * @return {Boolean}
 */
function isFunction(value) {
  return typeof value === 'function';
}

/**
 * Indicates whether the specified value is undefined.
 *
 * @param  {*} value
 * @return {Boolean}
 */
function isUndefined(value) {
  return typeof value === 'undefined';
}

/**
 * Indicates whether the specified value is an array.
 *
 * @param  {*} value
 * @return {Boolean}
 */
function isArray(value) {
  return value.constructor === Array;
}

/**
 * Creates and initializes specified collection of extensions.
 * Each extension receives access to instance of glide and rest of components.
 *
 * @param {Object} glide
 * @param {Object} extensions
 *
 * @returns {Object}
 */
function mount(glide, extensions, events) {
  var components = {};

  for (var name in extensions) {
    if (isFunction(extensions[name])) {
      components[name] = extensions[name](glide, components, events);
    } else {
      warn('Extension must be a function');
    }
  }

  for (var _name in components) {
    if (isFunction(components[_name].mount)) {
      components[_name].mount();
    }
  }

  return components;
}

/**
 * Defines getter and setter property on the specified object.
 *
 * @param  {Object} obj         Object where property has to be defined.
 * @param  {String} prop        Name of the defined property.
 * @param  {Object} definition  Get and set definitions for the property.
 * @return {Void}
 */
function define(obj, prop, definition) {
  Object.defineProperty(obj, prop, definition);
}

/**
 * Sorts aphabetically object keys.
 *
 * @param  {Object} obj
 * @return {Object}
 */
function sortKeys(obj) {
  return Object.keys(obj).sort().reduce(function (r, k) {
    r[k] = obj[k];

    return r[k], r;
  }, {});
}

/**
 * Merges passed settings object with default options.
 *
 * @param  {Object} defaults
 * @param  {Object} settings
 * @return {Object}
 */
function mergeOptions(defaults, settings) {
  var options = _extends({}, defaults, settings);

  // `Object.assign` do not deeply merge objects, so we
  // have to do it manually for every nested object
  // in options. Although it does not look smart,
  // it's smaller and faster than some fancy
  // merging deep-merge algorithm script.
  if (settings.hasOwnProperty('classes')) {
    options.classes = _extends({}, defaults.classes, settings.classes);

    if (settings.classes.hasOwnProperty('direction')) {
      options.classes.direction = _extends({}, defaults.classes.direction, settings.classes.direction);
    }
  }

  if (settings.hasOwnProperty('breakpoints')) {
    options.breakpoints = _extends({}, defaults.breakpoints, settings.breakpoints);
  }

  return options;
}

var EventsBus = function () {
  /**
   * Construct a EventBus instance.
   *
   * @param {Object} events
   */
  function EventsBus() {
    var events = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, EventsBus);

    this.events = events;
    this.hop = events.hasOwnProperty;
  }

  /**
   * Adds listener to the specifed event.
   *
   * @param {String|Array} event
   * @param {Function} handler
   */


  createClass(EventsBus, [{
    key: 'on',
    value: function on(event, handler) {
      if (isArray(event)) {
        for (var i = 0; i < event.length; i++) {
          this.on(event[i], handler);
        }
      }

      // Create the event's object if not yet created
      if (!this.hop.call(this.events, event)) {
        this.events[event] = [];
      }

      // Add the handler to queue
      var index = this.events[event].push(handler) - 1;

      // Provide handle back for removal of event
      return {
        remove: function remove() {
          delete this.events[event][index];
        }
      };
    }

    /**
     * Runs registered handlers for specified event.
     *
     * @param {String|Array} event
     * @param {Object=} context
     */

  }, {
    key: 'emit',
    value: function emit(event, context) {
      if (isArray(event)) {
        for (var i = 0; i < event.length; i++) {
          this.emit(event[i], context);
        }
      }

      // If the event doesn't exist, or there's no handlers in queue, just leave
      if (!this.hop.call(this.events, event)) {
        return;
      }

      // Cycle through events queue, fire!
      this.events[event].forEach(function (item) {
        item(context || {});
      });
    }
  }]);
  return EventsBus;
}();

var Glide = function () {
  /**
   * Construct glide.
   *
   * @param  {String} selector
   * @param  {Object} options
   */
  function Glide(selector) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    classCallCheck(this, Glide);

    this._c = {};
    this._t = [];
    this._e = new EventsBus();

    this.disabled = false;
    this.selector = selector;
    this.settings = mergeOptions(defaults, options);
    this.index = this.settings.startAt;
  }

  /**
   * Initializes glide.
   *
   * @param {Object} extensions Collection of extensions to initialize.
   * @return {Glide}
   */


  createClass(Glide, [{
    key: 'mount',
    value: function mount$$1() {
      var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this._e.emit('mount.before');

      if (isObject(extensions)) {
        this._c = mount(this, extensions, this._e);
      } else {
        warn('You need to provide a object on `mount()`');
      }

      this._e.emit('mount.after');

      return this;
    }

    /**
     * Collects an instance `translate` transformers.
     *
     * @param  {Array} transformers Collection of transformers.
     * @return {Void}
     */

  }, {
    key: 'mutate',
    value: function mutate() {
      var transformers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

      if (isArray(transformers)) {
        this._t = transformers;
      } else {
        warn('You need to provide a array on `mutate()`');
      }

      return this;
    }

    /**
     * Updates glide with specified settings.
     *
     * @param {Object} settings
     * @return {Glide}
     */

  }, {
    key: 'update',
    value: function update() {
      var settings = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      this.settings = mergeOptions(this.settings, settings);

      if (settings.hasOwnProperty('startAt')) {
        this.index = settings.startAt;
      }

      this._e.emit('update');

      return this;
    }

    /**
     * Change slide with specified pattern. A pattern must be in the special format:
     * `>` - Move one forward
     * `<` - Move one backward
     * `={i}` - Go to {i} zero-based slide (eq. '=1', will go to second slide)
     * `>>` - Rewinds to end (last slide)
     * `<<` - Rewinds to start (first slide)
     *
     * @param {String} pattern
     * @return {Glide}
     */

  }, {
    key: 'go',
    value: function go(pattern) {
      this._c.Run.make(pattern);

      return this;
    }

    /**
     * Move track by specified distance.
     *
     * @param {String} distance
     * @return {Glide}
     */

  }, {
    key: 'move',
    value: function move(distance) {
      this._c.Transition.disable();
      this._c.Move.make(distance);

      return this;
    }

    /**
     * Destroy instance and revert all changes done by this._c.
     *
     * @return {Glide}
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      this._e.emit('destroy');

      return this;
    }

    /**
     * Start instance autoplaying.
     *
     * @param {Boolean|Number} interval Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Glide}
     */

  }, {
    key: 'play',
    value: function play() {
      var interval = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (interval) {
        this.settings.autoplay = interval;
      }

      this._e.emit('play');

      return this;
    }

    /**
     * Stop instance autoplaying.
     *
     * @return {Glide}
     */

  }, {
    key: 'pause',
    value: function pause() {
      this._e.emit('pause');

      return this;
    }

    /**
     * Sets glide into a idle status.
     *
     * @return {Glide}
     */

  }, {
    key: 'disable',
    value: function disable() {
      this.disabled = true;

      return this;
    }

    /**
     * Sets glide into a active status.
     *
     * @return {Glide}
     */

  }, {
    key: 'enable',
    value: function enable() {
      this.disabled = false;

      return this;
    }

    /**
     * Adds cuutom event listener with handler.
     *
     * @param  {String|Array} event
     * @param  {Function} handler
     * @return {Glide}
     */

  }, {
    key: 'on',
    value: function on(event, handler) {
      this._e.on(event, handler);

      return this;
    }

    /**
     * Checks if glide is a precised type.
     *
     * @param  {String} name
     * @return {Boolean}
     */

  }, {
    key: 'isType',
    value: function isType(name) {
      return this.settings.type === name;
    }

    /**
     * Gets value of the core options.
     *
     * @return {Object}
     */

  }, {
    key: 'settings',
    get: function get$$1() {
      return this._o;
    }

    /**
     * Sets value of the core options.
     *
     * @param  {Object} o
     * @return {Void}
     */
    ,
    set: function set$$1(o) {
      if (isObject(o)) {
        this._o = o;
      } else {
        warn('Options must be an `object` instance.');
      }
    }

    /**
     * Gets current index of the slider.
     *
     * @return {Object}
     */

  }, {
    key: 'index',
    get: function get$$1() {
      return this._i;
    }

    /**
     * Sets current index a slider.
     *
     * @return {Object}
     */
    ,
    set: function set$$1(i) {
      this._i = toInt(i);
    }

    /**
     * Gets type name of the slider.
     *
     * @return {String}
     */

  }, {
    key: 'type',
    get: function get$$1() {
      return this.settings.type;
    }

    /**
     * Gets value of the idle status.
     *
     * @return {Boolean}
     */

  }, {
    key: 'disabled',
    get: function get$$1() {
      return this._d;
    }

    /**
     * Sets value of the idle status.
     *
     * @return {Boolean}
     */
    ,
    set: function set$$1(status) {
      this._d = !!status;
    }
  }]);
  return Glide;
}();

function Run (Glide, Components, Events) {
  var Run = {
    /**
     * Initializes autorunning of the glide.
     *
     * @return {Void}
     */
    mount: function mount() {
      this._o = false;
    },


    /**
     * Makes glides running based on the passed moving schema.
     *
     * @param {String} move
     */
    make: function make(move) {
      var _this = this;

      if (!Glide.disabled) {
        Glide.disable();

        this.move = move;

        Events.emit('run.before', this.move);

        this.calculate();

        Events.emit('run', this.move);

        Components.Transition.after(function () {
          if (_this.isStart()) {
            Events.emit('run.start', _this.move);
          }

          if (_this.isEnd()) {
            Events.emit('run.end', _this.move);
          }

          if (_this.isOffset('<') || _this.isOffset('>')) {
            _this._o = false;

            Events.emit('run.offset', _this.move);
          }

          Events.emit('run.after', _this.move);

          Glide.enable();
        });
      }
    },


    /**
     * Calculates current index based on defined move.
     *
     * @return {Void}
     */
    calculate: function calculate() {
      var move = this.move,
          length = this.length;
      var steps = move.steps,
          direction = move.direction;


      var countableSteps = isNumber(toInt(steps)) && toInt(steps) !== 0;

      switch (direction) {
        case '>':
          if (steps === '>') {
            Glide.index = length;
          } else if (this.isEnd()) {
            if (!(Glide.isType('slider') && !Glide.settings.rewind)) {
              this._o = true;

              Glide.index = 0;
            }
          } else if (countableSteps) {
            Glide.index += Math.min(length - Glide.index, -toInt(steps));
          } else {
            Glide.index++;
          }
          break;

        case '<':
          if (steps === '<') {
            Glide.index = 0;
          } else if (this.isStart()) {
            if (!(Glide.isType('slider') && !Glide.settings.rewind)) {
              this._o = true;

              Glide.index = length;
            }
          } else if (countableSteps) {
            Glide.index -= Math.min(Glide.index, toInt(steps));
          } else {
            Glide.index--;
          }
          break;

        case '=':
          Glide.index = steps;
          break;

        default:
          warn('Invalid direction pattern [' + direction + steps + '] has been used');
          break;
      }
    },


    /**
     * Checks if we are on the first slide.
     *
     * @return {Boolean}
     */
    isStart: function isStart() {
      return Glide.index === 0;
    },


    /**
     * Checks if we are on the last slide.
     *
     * @return {Boolean}
     */
    isEnd: function isEnd() {
      return Glide.index === this.length;
    },


    /**
     * Checks if we are making a offset run.
     *
     * @param {String} direction
     * @return {Boolean}
     */
    isOffset: function isOffset(direction) {
      return this._o && this.move.direction === direction;
    }
  };

  define(Run, 'move', {
    /**
     * Gets value of the move schema.
     *
     * @returns {Object}
     */
    get: function get() {
      return this._m;
    },


    /**
     * Sets value of the move schema.
     *
     * @returns {Object}
     */
    set: function set(value) {
      var step = value.substr(1);

      this._m = {
        direction: value.substr(0, 1),
        steps: step ? toInt(step) ? toInt(step) : step : 0
      };
    }
  });

  define(Run, 'length', {
    /**
     * Gets value of the running distance based
     * on zero-indexing number of slides.
     *
     * @return {Number}
     */
    get: function get() {
      var settings = Glide.settings;
      var length = Components.Html.slides.length;

      // If the `bound` option is acitve, a maximum running distance should be
      // reduced by `perView` and `focusAt` settings. Running distance
      // should end before creating an empty space after instance.

      if (Glide.isType('slider') && settings.focusAt !== 'center' && settings.bound) {
        return length - 1 - (toInt(settings.perView) - 1) + toInt(settings.focusAt);
      }

      return length - 1;
    }
  });

  define(Run, 'offset', {
    /**
     * Gets status of the offsetting flag.
     *
     * @return {Boolean}
     */
    get: function get() {
      return this._o;
    }
  });

  return Run;
}

/**
 * Returns a current time.
 *
 * @return {Number}
 */
function now() {
  return new Date().getTime();
}

/**
 * Returns a function, that, when invoked, will only be triggered
 * at most once during a given window of time.
 *
 * @param {Function} func
 * @param {Number} wait
 * @param {Object=} options
 * @return {Function}
 *
 * @see https://github.com/jashkenas/underscore
 */
function throttle(func, wait, options) {
  var timeout = void 0,
      context = void 0,
      args = void 0,
      result = void 0;
  var previous = 0;
  if (!options) options = {};

  var later = function later() {
    previous = options.leading === false ? 0 : now();
    timeout = null;
    result = func.apply(context, args);
    if (!timeout) context = args = null;
  };

  var throttled = function throttled() {
    var at = now();
    if (!previous && options.leading === false) previous = at;
    var remaining = wait - (at - previous);
    context = this;
    args = arguments;
    if (remaining <= 0 || remaining > wait) {
      if (timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
      previous = at;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    } else if (!timeout && options.trailing !== false) {
      timeout = setTimeout(later, remaining);
    }
    return result;
  };

  throttled.cancel = function () {
    clearTimeout(timeout);
    previous = 0;
    timeout = context = args = null;
  };

  return throttled;
}

var MARGIN_TYPE = {
  ltr: ['marginLeft', 'marginRight'],
  rtl: ['marginRight', 'marginLeft']
};

function Gaps (Glide, Components, Events) {
  var Gaps = {
    /**
     * Applies gaps between slides. First and last
     * slides do not receive it's edge margins.
     *
     * @param {HTMLCollection} slides
     * @return {Void}
     */
    apply: function apply(slides) {
      for (var i = 0, len = slides.length; i < len; i++) {
        var style = slides[i].style;
        var direction = Components.Direction.value;

        if (i !== 0) {
          style[MARGIN_TYPE[direction][0]] = this.value / 2 + 'px';
        } else {
          style[MARGIN_TYPE[direction][0]] = '';
        }

        if (i !== slides.length - 1) {
          style[MARGIN_TYPE[direction][1]] = this.value / 2 + 'px';
        } else {
          style[MARGIN_TYPE[direction][1]] = '';
        }
      }
    },


    /**
     * Removes gaps from the slides.
     *
     * @param {HTMLCollection} slides
     * @returns {Void}
    */
    remove: function remove(slides) {
      for (var i = 0, len = slides.length; i < len; i++) {
        var style = slides[i].style;

        style.marginLeft = '';
        style.marginRight = '';
      }
    }
  };

  define(Gaps, 'value', {
    /**
     * Gets value of the gap.
     *
     * @returns {Number}
     */
    get: function get() {
      return toInt(Glide.settings.gap);
    }
  });

  define(Gaps, 'grow', {
    /**
     * Gets additional dimentions value caused by gaps.
     * Used to increase width of the slides wrapper.
     *
     * @returns {Number}
     */
    get: function get() {
      return Gaps.value * (Components.Sizes.length - 1);
    }
  });

  define(Gaps, 'reductor', {
    /**
     * Gets reduction value caused by gaps.
     * Used to subtract width of the slides.
     *
     * @returns {Number}
     */
    get: function get() {
      var perView = Glide.settings.perView;

      return Gaps.value * (perView - 1) / perView;
    }
  });

  /**
   * Apply calculated gaps:
   * - after building, so slides (including clones) will receive proper margins
   * - on updating via API, to recalculate gaps with new options
   */
  Events.on(['build.after', 'update'], throttle(function () {
    Gaps.apply(Components.Html.wrapper.children);
  }, 30));

  /**
   * Remove gaps:
   * - on destroying to bring markup to its inital state
   */
  Events.on('destroy', function () {
    Gaps.remove(Components.Html.wrapper.children);
  });

  return Gaps;
}

/**
 * Finds siblings nodes of the passed node.
 *
 * @param  {Element} node
 * @return {Array}
 */
function siblings(node) {
  if (node && node.parentNode) {
    var n = node.parentNode.firstChild;
    var matched = [];

    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n !== node) {
        matched.push(n);
      }
    }

    return matched;
  }

  return [];
}

/**
 * Checks if passed node exist and is a valid element.
 *
 * @param  {Element} node
 * @return {Boolean}
 */
function exist(node) {
  if (node && node instanceof window.HTMLElement) {
    return true;
  }

  return false;
}

var TRACK_SELECTOR = '[data-glide-el="track"]';

function Html (Glide, Components) {
  var Html = {
    /**
     * Setup slider HTML nodes.
     *
     * @param {Glide} glide
     */
    mount: function mount() {
      this.root = Glide.selector;
      this.track = this.root.querySelector(TRACK_SELECTOR);
      this.slides = Array.prototype.slice.call(this.wrapper.children).filter(function (slide) {
        return !slide.classList.contains(Glide.settings.classes.cloneSlide);
      });
    }
  };

  define(Html, 'root', {
    /**
     * Gets node of the glide main element.
     *
     * @return {Object}
     */
    get: function get() {
      return Html._r;
    },


    /**
     * Sets node of the glide main element.
     *
     * @return {Object}
     */
    set: function set(r) {
      if (isString(r)) {
        r = document.querySelector(r);
      }

      if (exist(r)) {
        Html._r = r;
      } else {
        warn('Root element must be a existing Html node');
      }
    }
  });

  define(Html, 'track', {
    /**
     * Gets node of the glide track with slides.
     *
     * @return {Object}
     */
    get: function get() {
      return Html._t;
    },


    /**
     * Sets node of the glide track with slides.
     *
     * @return {Object}
     */
    set: function set(t) {
      if (exist(t)) {
        Html._t = t;
      } else {
        warn('Could not find track element. Please use ' + TRACK_SELECTOR + ' attribute.');
      }
    }
  });

  define(Html, 'wrapper', {
    /**
     * Gets node of the slides wrapper.
     *
     * @return {Object}
     */
    get: function get() {
      return Html.track.children[0];
    }
  });

  return Html;
}

function Peek (Glide, Components, Events) {
  var Peek = {
    /**
     * Setups how much to peek based on settings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.value = Glide.settings.peek;
    }
  };

  define(Peek, 'value', {
    /**
     * Gets value of the peek.
     *
     * @returns {Number|Object}
     */
    get: function get() {
      return Peek._v;
    },


    /**
     * Sets value of the peek.
     *
     * @param {Number|Object} value
     * @return {Void}
     */
    set: function set(value) {
      if (isObject(value)) {
        value.before = toInt(value.before);
        value.after = toInt(value.after);
      } else {
        value = toInt(value);
      }

      Peek._v = value;
    }
  });

  define(Peek, 'reductor', {
    /**
     * Gets reduction value caused by peek.
     *
     * @returns {Number}
     */
    get: function get() {
      var value = Peek.value;
      var perView = Glide.settings.perView;

      if (isObject(value)) {
        return value.before / perView + value.after / perView;
      }

      return value * 2 / perView;
    }
  });

  /**
   * Recalculate peeking sizes on:
   * - when resizing window to update to proper percents
   */
  Events.on(['resize', 'update'], function () {
    Peek.mount();
  });

  return Peek;
}

function Move (Glide, Components, Events) {
  var Move = {
    /**
     * Constructs move component.
     *
     * @returns {Void}
     */
    mount: function mount() {
      this._o = 0;
    },


    /**
     * Calculates a movement value based on passed offset and currently active index.
     *
     * @param  {Number} offset
     * @return {Void}
     */
    make: function make() {
      var _this = this;

      var offset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.offset = offset;

      Events.emit('move', {
        movement: this.value
      });

      Components.Transition.after(function () {
        Events.emit('move.after', {
          movement: _this.value
        });
      });
    }
  };

  define(Move, 'offset', {
    /**
     * Gets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    get: function get() {
      return Move._o;
    },


    /**
     * Sets an offset value used to modify current translate.
     *
     * @return {Object}
     */
    set: function set(value) {
      Move._o = !isUndefined(value) ? toInt(value) : 0;
    }
  });

  define(Move, 'translate', {
    /**
     * Gets a raw movement value.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Sizes.slideWidth * Glide.index;
    }
  });

  define(Move, 'value', {
    /**
     * Gets an actual movement value corrected by offset.
     *
     * @return {Number}
     */
    get: function get() {
      var offset = this.offset;
      var translate = this.translate;

      if (Components.Direction.is('rtl')) {
        return translate + offset;
      }

      return translate - offset;
    }
  });

  /**
   * Make movement to proper slide on:
   * - before build, so glide will start at `startAt` index
   * - on each standard run to move to newly calculated index
   */
  Events.on(['build.before', 'run'], function () {
    Move.make();
  });

  return Move;
}

function Sizes (Glide, Components, Events) {
  var Sizes = {
    /**
     * Setups dimentions of slides.
     *
     * @return {Void}
     */
    setupSlides: function setupSlides() {
      var width = this.slideWidth + 'px';
      var slides = Components.Html.slides;

      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = width;
      }
    },


    /**
     * Setups dimentions of slides wrapper.
     *
     * @return {Void}
     */
    setupWrapper: function setupWrapper(dimention) {
      Components.Html.wrapper.style.width = this.wrapperSize + 'px';
    },


    /**
     * Removes applied styles from HTML elements.
     *
     * @returns {Void}
     */
    remove: function remove() {
      var slides = Components.Html.slides;

      for (var i = 0; i < slides.length; i++) {
        slides[i].style.width = '';
      }

      Components.Html.wrapper.style.width = '';
    }
  };

  define(Sizes, 'length', {
    /**
     * Gets count number of the slides.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Html.slides.length;
    }
  });

  define(Sizes, 'width', {
    /**
     * Gets width value of the glide.
     *
     * @return {Number}
     */
    get: function get() {
      return Components.Html.root.offsetWidth;
    }
  });

  define(Sizes, 'wrapperSize', {
    /**
     * Gets size of the slides wrapper.
     *
     * @return {Number}
     */
    get: function get() {
      return Sizes.slideWidth * Sizes.length + Components.Gaps.grow + Components.Clones.grow;
    }
  });

  define(Sizes, 'slideWidth', {
    /**
     * Gets width value of the single slide.
     *
     * @return {Number}
     */
    get: function get() {
      return Sizes.width / Glide.settings.perView - Components.Peek.reductor - Components.Gaps.reductor;
    }
  });

  /**
   * Apply calculated glide's dimensions:
   * - before building, so other dimentions (e.g. translate) will be calculated propertly
   * - when resizing window to recalculate sildes dimensions
   * - on updating via API, to calculate dimensions based on new options
   */
  Events.on(['build.before', 'resize', 'update'], function () {
    Sizes.setupSlides();
    Sizes.setupWrapper();
  });

  /**
   * Remove calculated glide's dimensions:
   * - on destoting to bring markup to its inital state
   */
  Events.on('destroy', function () {
    Sizes.remove();
  });

  return Sizes;
}

function Build (Glide, Components, Events) {
  var Build = {
    /**
     * Init glide building. Adds classes, sets
     * dimensions and setups initial state.
     *
     * @return {Void}
     */
    mount: function mount() {
      Events.emit('build.before');

      this.typeClass();
      this.activeClass();

      Events.emit('build.after');
    },


    /**
     * Adds `type` class to the glide element.
     *
     * @return {Void}
     */
    typeClass: function typeClass() {
      Components.Html.root.classList.add(Glide.settings.classes[Glide.settings.type]);
    },


    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    activeClass: function activeClass() {
      var classes = Glide.settings.classes;
      var slide = Components.Html.slides[Glide.index];

      if (slide) {
        slide.classList.add(classes.activeSlide);

        siblings(slide).forEach(function (sibling) {
          sibling.classList.remove(classes.activeSlide);
        });
      }
    },


    /**
     * Removes HTML classes applied at building.
     *
     * @return {Void}
     */
    removeClasses: function removeClasses() {
      var classes = Glide.settings.classes;

      Components.Html.root.classList.remove(classes[Glide.settings.type]);

      Components.Html.slides.forEach(function (sibling) {
        sibling.classList.remove(classes.activeSlide);
      });
    }
  };

  /**
   * Clear building classes:
   * - on destroying to bring HTML to its initial state
   * - on updating to remove classes before remounting component
   */
  Events.on(['destroy', 'update'], function () {
    Build.removeClasses();
  });

  /**
   * Remount component:
   * - on resizing of the window to calculate new dimentions
   * - on updating settings via API
   */
  Events.on(['resize', 'update'], function () {
    Build.mount();
  });

  /**
   * Swap active class of current slide:
   * - after each move to the new index
   */
  Events.on('move.after', function () {
    Build.activeClass();
  });

  return Build;
}

function Clones (Glide, Components, Events) {
  var Clones = {
    /**
     * Create pattern map and collect slides to be cloned.
     */
    mount: function mount() {
      this.items = [];

      if (Glide.isType('carousel')) {
        this.items = this.collect();
      }
    },


    /**
     * Collect clones with pattern.
     *
     * @return {Void}
     */
    collect: function collect() {
      var items = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var slides = Components.Html.slides;
      var _Glide$settings = Glide.settings,
          perView = _Glide$settings.perView,
          classes = _Glide$settings.classes;


      var peekIncrementer = +!!Glide.settings.peek;
      var part = perView + peekIncrementer;
      var start = slides.slice(0, part);
      var end = slides.slice(-part);

      for (var r = 0; r < Math.max(1, Math.floor(perView / slides.length)); r++) {
        for (var i = 0; i < start.length; i++) {
          var clone = start[i].cloneNode(true);

          clone.classList.add(classes.cloneSlide);

          items.push(clone);
        }

        for (var _i = 0; _i < end.length; _i++) {
          var _clone = end[_i].cloneNode(true);

          _clone.classList.add(classes.cloneSlide);

          items.unshift(_clone);
        }
      }

      return items;
    },


    /**
     * Append cloned slides with generated pattern.
     *
     * @return {Void}
     */
    append: function append() {
      var items = this.items;
      var _Components$Html = Components.Html,
          wrapper = _Components$Html.wrapper,
          slides = _Components$Html.slides;


      var half = Math.floor(items.length / 2);
      var prepend = items.slice(0, half).reverse();
      var append = items.slice(half, items.length);
      var width = Components.Sizes.slideWidth + 'px';

      for (var i = 0; i < append.length; i++) {
        wrapper.appendChild(append[i]);
      }

      for (var _i2 = 0; _i2 < prepend.length; _i2++) {
        wrapper.insertBefore(prepend[_i2], slides[0]);
      }

      for (var _i3 = 0; _i3 < items.length; _i3++) {
        items[_i3].style.width = width;
      }
    },


    /**
     * Remove all cloned slides.
     *
     * @return {Void}
     */
    remove: function remove() {
      var items = this.items;


      for (var i = 0; i < items.length; i++) {
        Components.Html.wrapper.removeChild(items[i]);
      }
    }
  };

  define(Clones, 'grow', {
    /**
     * Gets additional dimentions value caused by clones.
     *
     * @return {Number}
     */
    get: function get() {
      return (Components.Sizes.slideWidth + Components.Gaps.value) * Clones.items.length;
    }
  });

  /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */
  Events.on('update', function () {
    Clones.remove();
    Clones.mount();
    Clones.append();
  });

  /**
   * Append additional slide's clones:
   * - while glide's type is `carousel`
   */
  Events.on('build.before', function () {
    if (Glide.isType('carousel')) {
      Clones.append();
    }
  });

  /**
   * Remove clones HTMLElements:
   * - on destroying, to bring HTML to its initial state
   */
  Events.on('destroy', function () {
    Clones.remove();
  });

  return Clones;
}

var EventsBinder = function () {
  /**
   * Construct a EventsBinder instance.
   */
  function EventsBinder() {
    var listeners = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    classCallCheck(this, EventsBinder);

    this.listeners = listeners;
  }

  /**
   * Adds events listeners to arrows HTML elements.
   *
   * @param  {String|Array} events
   * @param  {Element|Window|Document} el
   * @param  {Function} closure
   * @param  {Boolean|Object} capture
   * @return {Void}
   */


  createClass(EventsBinder, [{
    key: 'on',
    value: function on(events, el, closure) {
      var capture = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

      if (isString(events)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        this.listeners[events[i]] = closure;

        el.addEventListener(events[i], this.listeners[events[i]], capture);
      }
    }

    /**
     * Removes event listeners from arrows HTML elements.
     *
     * @param  {String|Array} events
     * @param  {Element|Window|Document} el
     * @param  {Boolean|Object} capture
     * @return {Void}
     */

  }, {
    key: 'off',
    value: function off(events, el) {
      var capture = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (isString(events)) {
        events = [events];
      }

      for (var i = 0; i < events.length; i++) {
        el.removeEventListener(events[i], this.listeners[events[i]], capture);
      }
    }

    /**
     * Destroy collected listeners.
     *
     * @returns {Void}
     */

  }, {
    key: 'destroy',
    value: function destroy() {
      delete this.listeners;
    }
  }]);
  return EventsBinder;
}();

function Resize (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var Resize = {
    /**
     * Initializes window bindings.
     */
    mount: function mount() {
      this.bind();
    },


    /**
     * Binds `rezsize` listener to the window.
     * It's a costly event, so we are debouncing it.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('resize', window, throttle(function () {
        Events.emit('resize');
      }, Glide.settings.throttle));
    },


    /**
     * Unbinds listeners from the window.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('resize', window);
    }
  };

  /**
   * Remove bindings from window:
   * - on destroying, to remove added EventListener
   */
  Events.on('destroy', function () {
    Resize.unbind();
    Binder.destroy();
  });

  return Resize;
}

var VALID_DIRECTIONS = ['ltr', 'rtl'];
var FLIPED_MOVEMENTS = {
  '>': '<',
  '<': '>',
  '=': '='
};

function Direction (Glide, Components, Events) {
  var Direction = {
    /**
     * Setups gap value based on settings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.value = Glide.settings.direction;
    },


    /**
     * Resolves pattern based on direction value
     *
     * @param {String} pattern
     * @returns {String}
     */
    resolve: function resolve(pattern) {
      var token = pattern.slice(0, 1);

      if (this.is('rtl')) {
        return pattern.split(token).join(FLIPED_MOVEMENTS[token]);
      }

      return pattern;
    },


    /**
     * Checks value of direction mode.
     *
     * @param {String} direction
     * @returns {Boolean}
     */
    is: function is(direction) {
      return this.value === direction;
    },


    /**
     * Applies direction class to the root HTML element.
     *
     * @return {Void}
     */
    addClass: function addClass() {
      Components.Html.root.classList.add(Glide.settings.classes.direction[this.value]);
    },


    /**
     * Removes direction class from the root HTML element.
     *
     * @return {Void}
     */
    removeClass: function removeClass() {
      Components.Html.root.classList.remove(Glide.settings.classes.direction[this.value]);
    }
  };

  define(Direction, 'value', {
    /**
     * Gets value of the direction.
     *
     * @returns {Number}
     */
    get: function get() {
      return Direction._v;
    },


    /**
     * Sets value of the direction.
     *
     * @param {String} value
     * @return {Void}
     */
    set: function set(value) {
      if (VALID_DIRECTIONS.indexOf(value) > -1) {
        Direction._v = value;
      } else {
        warn('Direction value must be `ltr` or `rtl`');
      }
    }
  });

  /**
   * Clear direction class:
   * - on destroy to bring HTML to its initial state
   * - on update to remove class before reappling bellow
   */
  Events.on(['destroy', 'update'], function () {
    Direction.removeClass();
  });

  /**
   * Remount component:
   * - on update to reflect changes in direction value
   */
  Events.on('update', function () {
    Direction.mount();
  });

  /**
   * Apply direction class:
   * - before building to apply class for the first time
   * - on updating to reapply direction class that may changed
   */
  Events.on(['build.before', 'update'], function () {
    Direction.addClass();
  });

  return Direction;
}

/**
 * Reflects value of glide movement.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function Rtl (Glide, Components) {
  return {
    /**
     * Negates the passed translate if glide is in RTL option.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      if (Components.Direction.is('rtl')) {
        return -translate;
      }

      return translate;
    }
  };
}

/**
 * Updates glide movement with a `gap` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function Gap (Glide, Components) {
  return {
    /**
     * Modifies passed translate value with number in the `gap` settings.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      return translate + Components.Gaps.value * Glide.index;
    }
  };
}

/**
 * Updates glide movement with width of additional clones width.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function Grow (Glide, Components) {
  return {
    /**
     * Adds to the passed translate width of the half of clones.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      return translate + Components.Clones.grow / 2;
    }
  };
}

/**
 * Updates glide movement with a `peek` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function Peeking (Glide, Components) {
  return {
    /**
     * Modifies passed translate value with a `peek` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      if (Glide.settings.focusAt >= 0) {
        var peek = Components.Peek.value;

        if (isObject(peek)) {
          return translate - peek.before;
        }

        return translate - peek;
      }

      return translate;
    }
  };
}

/**
 * Updates glide movement with a `focusAt` settings.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function Focusing (Glide, Components) {
  return {
    /**
     * Modifies passed translate value with index in the `focusAt` setting.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    modify: function modify(translate) {
      var gap = Components.Gaps.value;
      var width = Components.Sizes.width;
      var focusAt = Glide.settings.focusAt;
      var slideWidth = Components.Sizes.slideWidth;

      if (focusAt === 'center') {
        return translate - (width / 2 - slideWidth / 2);
      }

      return translate - slideWidth * focusAt - gap * focusAt;
    }
  };
}

/**
 * Applies diffrent transformers on translate value.
 *
 * @param  {Object} Glide
 * @param  {Object} Components
 * @return {Object}
 */
function mutator (Glide, Components, Events) {
  /**
   * Merge instance transformers with collection of default transformers.
   * It's important that the Rtl component be last on the list,
   * so it reflects all previous transformations.
   *
   * @type {Array}
   */
  var TRANSFORMERS = [Gap, Grow, Peeking, Focusing].concat(Glide._t, [Rtl]);

  return {
    /**
     * Piplines translate value with registered transformers.
     *
     * @param  {Number} translate
     * @return {Number}
     */
    mutate: function mutate(translate) {
      for (var i = 0; i < TRANSFORMERS.length; i++) {
        var transformer = TRANSFORMERS[i];

        if (isFunction(transformer) && isFunction(transformer().modify)) {
          translate = transformer(Glide, Components, Events).modify(translate);
        } else {
          warn('Transformer should be a function that returns an object with `modify()` method');
        }
      }

      return translate;
    }
  };
}

function Translate (Glide, Components, Events) {
  var Translate = {
    /**
     * Sets value of translate on HTML element.
     *
     * @param {Number} value
     * @return {Void}
     */
    set: function set(value) {
      var transform = mutator(Glide, Components).mutate(value);

      Components.Html.wrapper.style.transform = 'translate3d(' + -1 * transform + 'px, 0px, 0px)';
    },


    /**
     * Removes value of translate from HTML element.
     *
     * @return {Void}
     */
    remove: function remove() {
      Components.Html.wrapper.style.transform = '';
    }
  };

  /**
   * Set new translate value:
   * - on move to reflect index change
   * - on updating via API to reflect possible changes in options
   */
  Events.on('move', function (context) {
    var gap = Components.Gaps.value;
    var length = Components.Sizes.length;
    var width = Components.Sizes.slideWidth;

    if (Glide.isType('carousel') && Components.Run.isOffset('<')) {
      Components.Transition.after(function () {
        Events.emit('translate.jump');

        Translate.set(width * (length - 1));
      });

      return Translate.set(-width - gap * length);
    }

    if (Glide.isType('carousel') && Components.Run.isOffset('>')) {
      Components.Transition.after(function () {
        Events.emit('translate.jump');

        Translate.set(0);
      });

      return Translate.set(width * length + gap * length);
    }

    return Translate.set(context.movement);
  });

  /**
   * Remove translate:
   * - on destroying to bring markup to its inital state
   */
  Events.on('destroy', function () {
    Translate.remove();
  });

  return Translate;
}

function Transition (Glide, Components, Events) {
  /**
   * Holds inactivity status of transition.
   * When true transition is not applied.
   *
   * @type {Boolean}
   */
  var disabled = false;

  var Transition = {
    /**
     * Composes string of the CSS transition.
     *
     * @param {String} property
     * @return {String}
     */
    compose: function compose(property) {
      var settings = Glide.settings;

      if (!disabled) {
        return property + ' ' + this.duration + 'ms ' + settings.animationTimingFunc;
      }

      return property + ' 0ms ' + settings.animationTimingFunc;
    },


    /**
     * Sets value of transition on HTML element.
     *
     * @param {String=} property
     * @return {Void}
     */
    set: function set() {
      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'transform';

      Components.Html.wrapper.style.transition = this.compose(property);
    },


    /**
     * Removes value of transition from HTML element.
     *
     * @return {Void}
     */
    remove: function remove() {
      Components.Html.wrapper.style.transition = '';
    },


    /**
     * Runs callback after animation.
     *
     * @param  {Function} callback
     * @return {Void}
     */
    after: function after(callback) {
      setTimeout(function () {
        callback();
      }, this.duration);
    },


    /**
     * Enable transition.
     *
     * @return {Void}
     */
    enable: function enable() {
      disabled = false;

      this.set();
    },


    /**
     * Disable transition.
     *
     * @return {Void}
     */
    disable: function disable() {
      disabled = true;

      this.set();
    }
  };

  define(Transition, 'duration', {
    /**
     * Gets duration of the transition based
     * on currently running animation type.
     *
     * @return {Number}
     */
    get: function get() {
      var settings = Glide.settings;

      if (Glide.isType('slider') && Components.Run.offset) {
        return settings.rewindDuration;
      }

      return settings.animationDuration;
    }
  });

  /**
   * Set transition `style` value:
   * - on each moving, because it may be cleared by offset move
   */
  Events.on('move', function () {
    Transition.set();
  });

  /**
   * Disable transition:
   * - before initial build to avoid transitioning from `0` to `startAt` index
   * - while resizing window and recalculating dimentions
   * - on jumping from offset transition at start and end edges in `carousel` type
   */
  Events.on(['build.before', 'resize', 'translate.jump'], function () {
    Transition.disable();
  });

  /**
   * Enable transition:
   * - on each running, because it may be disabled by offset move
   */
  Events.on('run', function () {
    Transition.enable();
  });

  /**
   * Remove transition:
   * - on destroying to bring markup to its inital state
   */
  Events.on('destroy', function () {
    Transition.remove();
  });

  return Transition;
}

/**
 * Test via a getter in the options object to see
 * if the passive property is accessed.
 *
 * @see https://github.com/WICG/EventListenerOptions/blob/gh-pages/explainer.md#feature-detection
 */

var supportsPassive = false;

try {
  var opts = Object.defineProperty({}, 'passive', {
    get: function get() {
      supportsPassive = true;
    }
  });

  window.addEventListener('testPassive', null, opts);
  window.removeEventListener('testPassive', null, opts);
} catch (e) {}

var supportsPassive$1 = supportsPassive;

var START_EVENTS = ['touchstart', 'mousedown'];
var MOVE_EVENTS = ['touchmove', 'mousemove'];
var END_EVENTS = ['touchend', 'touchcancel', 'mouseup', 'mouseleave'];
var MOUSE_EVENTS = ['mousedown', 'mousemove', 'mouseup', 'mouseleave'];

function Swipe (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var swipeSin = 0;
  var swipeStartX = 0;
  var swipeStartY = 0;
  var disabled = false;
  var capture = supportsPassive$1 ? { passive: true } : false;

  var Swipe = {
    /**
     * Initializes swipe bindings.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.bindSwipeStart();
    },


    /**
     * Handler for `swipestart` event. Calculates entry points of the user's tap.
     *
     * @param {Object} event
     * @return {Void}
     */
    start: function start(event) {
      if (!disabled && !Glide.disabled) {
        this.disable();

        var swipe = this.touches(event);

        swipeSin = null;
        swipeStartX = toInt(swipe.pageX);
        swipeStartY = toInt(swipe.pageY);

        this.bindSwipeMove();
        this.bindSwipeEnd();

        Events.emit('swipe.start');
      }
    },


    /**
     * Handler for `swipemove` event. Calculates user's tap angle and distance.
     *
     * @param {Object} event
     */
    move: function move(event) {
      if (!Glide.disabled) {
        var _Glide$settings = Glide.settings,
            touchAngle = _Glide$settings.touchAngle,
            touchRatio = _Glide$settings.touchRatio,
            classes = _Glide$settings.classes;


        var swipe = this.touches(event);

        var subExSx = toInt(swipe.pageX) - swipeStartX;
        var subEySy = toInt(swipe.pageY) - swipeStartY;
        var powEX = Math.abs(subExSx << 2);
        var powEY = Math.abs(subEySy << 2);
        var swipeHypotenuse = Math.sqrt(powEX + powEY);
        var swipeCathetus = Math.sqrt(powEY);

        swipeSin = Math.asin(swipeCathetus / swipeHypotenuse);

        if (swipeSin * 180 / Math.PI < touchAngle) {
          event.stopPropagation();

          Components.Move.make(subExSx * toFloat(touchRatio));

          Components.Html.root.classList.add(classes.dragging);

          Events.emit('swipe.move');
        } else {
          return false;
        }
      }
    },


    /**
     * Handler for `swipeend` event. Finitializes user's tap and decides about glide move.
     *
     * @param {Object} event
     * @return {Void}
     */
    end: function end(event) {
      if (!Glide.disabled) {
        var settings = Glide.settings;

        var swipe = this.touches(event);
        var threshold = this.threshold(event);

        var swipeDistance = swipe.pageX - swipeStartX;
        var swipeDeg = swipeSin * 180 / Math.PI;
        var steps = Math.round(swipeDistance / Components.Sizes.slideWidth);

        this.enable();

        if (swipeDistance > threshold && swipeDeg < settings.touchAngle) {
          // While swipe is positive and greater than threshold move backward.
          if (settings.perTouch) {
            steps = Math.min(steps, toInt(settings.perTouch));
          }

          if (Components.Direction.is('rtl')) {
            steps = -steps;
          }

          Components.Run.make(Components.Direction.resolve('<' + steps));
        } else if (swipeDistance < -threshold && swipeDeg < settings.touchAngle) {
          // While swipe is negative and lower than negative threshold move forward.
          if (settings.perTouch) {
            steps = Math.max(steps, -toInt(settings.perTouch));
          }

          if (Components.Direction.is('rtl')) {
            steps = -steps;
          }

          Components.Run.make(Components.Direction.resolve('>' + steps));
        } else {
          // While swipe don't reach distance apply previous transform.
          Components.Move.make();
        }

        Components.Html.root.classList.remove(settings.classes.dragging);

        this.unbindSwipeMove();
        this.unbindSwipeEnd();

        Events.emit('swipe.end');
      }
    },


    /**
     * Binds swipe's starting event.
     *
     * @return {Void}
     */
    bindSwipeStart: function bindSwipeStart() {
      var _this = this;

      var settings = Glide.settings;

      if (settings.swipeThreshold) {
        Binder.on(START_EVENTS[0], Components.Html.wrapper, function (event) {
          _this.start(event);
        }, capture);
      }

      if (settings.dragThreshold) {
        Binder.on(START_EVENTS[1], Components.Html.wrapper, function (event) {
          _this.start(event);
        }, capture);
      }
    },


    /**
     * Unbinds swipe's starting event.
     *
     * @return {Void}
     */
    unbindSwipeStart: function unbindSwipeStart() {
      Binder.off(START_EVENTS[0], Components.Html.wrapper, capture);
      Binder.off(START_EVENTS[1], Components.Html.wrapper, capture);
    },


    /**
     * Binds swipe's moving event.
     *
     * @return {Void}
     */
    bindSwipeMove: function bindSwipeMove() {
      var _this2 = this;

      Binder.on(MOVE_EVENTS, Components.Html.wrapper, throttle(function (event) {
        _this2.move(event);
      }, Glide.settings.throttle), capture);
    },


    /**
     * Unbinds swipe's moving event.
     *
     * @return {Void}
     */
    unbindSwipeMove: function unbindSwipeMove() {
      Binder.off(MOVE_EVENTS, Components.Html.wrapper, capture);
    },


    /**
     * Binds swipe's ending event.
     *
     * @return {Void}
     */
    bindSwipeEnd: function bindSwipeEnd() {
      var _this3 = this;

      Binder.on(END_EVENTS, Components.Html.wrapper, function (event) {
        _this3.end(event);
      });
    },


    /**
     * Unbinds swipe's ending event.
     *
     * @return {Void}
     */
    unbindSwipeEnd: function unbindSwipeEnd() {
      Binder.off(END_EVENTS, Components.Html.wrapper);
    },


    /**
     * Normalizes event touches points accorting to different types.
     *
     * @param {Object} event
     */
    touches: function touches(event) {
      if (MOUSE_EVENTS.indexOf(event.type) > -1) {
        return event;
      }

      return event.touches[0] || event.changedTouches[0];
    },


    /**
     * Gets value of minimum swipe distance settings based on event type.
     *
     * @return {Number}
     */
    threshold: function threshold(event) {
      var settings = Glide.settings;

      if (MOUSE_EVENTS.indexOf(event.type) > -1) {
        return settings.dragThreshold;
      }

      return settings.swipeThreshold;
    },


    /**
     * Enables swipe event.
     *
     * @return {self}
     */
    enable: function enable() {
      disabled = false;

      Components.Transition.enable();

      return this;
    },


    /**
     * Disables swipe event.
     *
     * @return {self}
     */
    disable: function disable() {
      disabled = true;

      Components.Transition.disable();

      return this;
    }
  };

  /**
   * Add component class:
   * - after initial building
   */
  Events.on('build.after', function () {
    Components.Html.root.classList.add(Glide.settings.classes.swipeable);
  });

  /**
   * Remove swiping bindings:
   * - on destroying, to remove added EventListeners
   */
  Events.on('destroy', function () {
    Swipe.unbindSwipeStart();
    Swipe.unbindSwipeMove();
    Swipe.unbindSwipeEnd();
    Binder.destroy();
  });

  return Swipe;
}

function Images (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var Images = {
    /**
     * Binds listener to glide wrapper.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.bind();
    },


    /**
     * Binds `dragstart` event on wrapper to prevent dragging images.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('dragstart', Components.Html.wrapper, this.dragstart);
    },


    /**
     * Unbinds `dragstart` event on wrapper.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('dragstart', Components.Html.wrapper);
    },


    /**
     * Event handler. Prevents dragging.
     *
     * @return {Void}
     */
    dragstart: function dragstart(event) {
      event.preventDefault();
    }
  };

  /**
   * Remove bindings from images:
   * - on destroying, to remove added EventListeners
   */
  Events.on('destroy', function () {
    Images.unbind();
    Binder.destroy();
  });

  return Images;
}

function Anchors (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  /**
   * Holds detaching status of anchors.
   * Prevents detaching of already detached anchors.
   *
   * @private
   * @type {Boolean}
   */
  var detached = false;

  /**
   * Holds preventing status of anchors.
   * If `true` redirection after click will be disabled.
   *
   * @private
   * @type {Boolean}
   */
  var prevented = false;

  var Anchors = {
    /**
     * Setups a initial state of anchors component.
     *
     * @returns {Void}
     */
    mount: function mount() {
      /**
       * Holds collection of anchors elements.
       *
       * @private
       * @type {HTMLCollection}
       */
      this._a = Components.Html.wrapper.querySelectorAll('a');

      this.bind();
    },


    /**
     * Binds events to anchors inside a track.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('click', Components.Html.wrapper, this.click);
    },


    /**
     * Unbinds events attached to anchors inside a track.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('click', Components.Html.wrapper);
    },


    /**
     * Handler for click event. Prevents clicks when glide is in `prevent` status.
     *
     * @param  {Object} event
     * @return {Void}
     */
    click: function click(event) {
      if (prevented) {
        event.stopPropagation();
        event.preventDefault();
      }
    },


    /**
     * Detaches anchors click event inside glide.
     *
     * @return {self}
     */
    detach: function detach() {
      prevented = true;

      if (!detached) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].draggable = false;

          this.items[i].setAttribute('data-href', this.items[i].getAttribute('href'));

          this.items[i].removeAttribute('href');
        }

        detached = true;
      }

      return this;
    },


    /**
     * Attaches anchors click events inside glide.
     *
     * @return {self}
     */
    attach: function attach() {
      prevented = false;

      if (detached) {
        for (var i = 0; i < this.items.length; i++) {
          this.items[i].draggable = true;

          this.items[i].setAttribute('href', this.items[i].getAttribute('data-href'));
        }

        detached = false;
      }

      return this;
    }
  };

  define(Anchors, 'items', {
    /**
     * Gets collection of the arrows HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function get() {
      return Anchors._a;
    }
  });

  /**
   * Detach anchors inside slides:
   * - on swiping, so they won't redirect to its `href` attributes
   */
  Events.on('swipe.move', function () {
    Anchors.detach();
  });

  /**
   * Attach anchors inside slides:
   * - after swiping and transitions ends, so they can redirect after click again
   */
  Events.on('swipe.end', function () {
    Components.Transition.after(function () {
      Anchors.attach();
    });
  });

  /**
   * Unbind anchors inside slides:
   * - on destroying, to bring anchors to its initial state
   */
  Events.on('destroy', function () {
    Anchors.attach();
    Anchors.unbind();
    Binder.destroy();
  });

  return Anchors;
}

var NAV_SELECTOR = '[data-glide-el="controls[nav]"]';
var CONTROLS_SELECTOR = '[data-glide-el^="controls"]';

function Controls (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var capture = supportsPassive$1 ? { passive: true } : false;

  var Controls = {
    /**
     * Inits arrows. Binds events listeners
     * to the arrows HTML elements.
     *
     * @return {Void}
     */
    mount: function mount() {
      /**
       * Collection of navigation HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */
      this._n = Components.Html.root.querySelectorAll(NAV_SELECTOR);

      /**
       * Collection of controls HTML elements.
       *
       * @private
       * @type {HTMLCollection}
       */
      this._c = Components.Html.root.querySelectorAll(CONTROLS_SELECTOR);

      this.addBindings();
    },


    /**
     * Sets active class to current slide.
     *
     * @return {Void}
     */
    setActive: function setActive() {
      for (var i = 0; i < this._n.length; i++) {
        this.addClass(this._n[i].children);
      }
    },


    /**
     * Removes active class to current slide.
     *
     * @return {Void}
     */
    removeActive: function removeActive() {
      for (var i = 0; i < this._n.length; i++) {
        this.removeClass(this._n[i].children);
      }
    },


    /**
     * Toggles active class on items inside navigation.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    addClass: function addClass(controls) {
      var settings = Glide.settings;
      var item = controls[Glide.index];

      if (item) {
        item.classList.add(settings.classes.activeNav);

        siblings(item).forEach(function (sibling) {
          sibling.classList.remove(settings.classes.activeNav);
        });
      }
    },


    /**
     * Removes active class from active control.
     *
     * @param  {HTMLElement} controls
     * @return {Void}
     */
    removeClass: function removeClass(controls) {
      var item = controls[Glide.index];

      if (item) {
        item.classList.remove(Glide.settings.classes.activeNav);
      }
    },


    /**
     * Adds handles to the each group of controls.
     *
     * @return {Void}
     */
    addBindings: function addBindings() {
      for (var i = 0; i < this._c.length; i++) {
        this.bind(this._c[i].children);
      }
    },


    /**
     * Removes handles from the each group of controls.
     *
     * @return {Void}
     */
    removeBindings: function removeBindings() {
      for (var i = 0; i < this._c.length; i++) {
        this.unbind(this._c[i].children);
      }
    },


    /**
     * Binds events to arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    bind: function bind(elements) {
      for (var i = 0; i < elements.length; i++) {
        Binder.on('click', elements[i], this.click);
        Binder.on('touchstart', elements[i], this.click, capture);
      }
    },


    /**
     * Unbinds events binded to the arrows HTML elements.
     *
     * @param {HTMLCollection} elements
     * @return {Void}
     */
    unbind: function unbind(elements) {
      for (var i = 0; i < elements.length; i++) {
        Binder.off(['click', 'touchstart'], elements[i]);
      }
    },


    /**
     * Handles `click` event on the arrows HTML elements.
     * Moves slider in driection precised in
     * `data-glide-dir` attribute.
     *
     * @param {Object} event
     * @return {Void}
     */
    click: function click(event) {
      event.preventDefault();

      Components.Run.make(Components.Direction.resolve(event.currentTarget.getAttribute('data-glide-dir')));
    }
  };

  define(Controls, 'items', {
    /**
     * Gets collection of the controls HTML elements.
     *
     * @return {HTMLElement[]}
     */
    get: function get() {
      return Controls._c;
    }
  });

  /**
   * Swap active class of current navigation item:
   * - after mounting to set it to initial index
   * - after each move to the new index
   */
  Events.on(['mount.after', 'move.after'], function () {
    Controls.setActive();
  });

  /**
   * Remove bindings and HTML Classes:
   * - on destroying, to bring markup to its initial state
   */
  Events.on('destroy', function () {
    Controls.removeBindings();
    Controls.removeActive();
    Binder.destroy();
  });

  return Controls;
}

function Keyboard (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var Keyboard = {
    /**
     * Binds keyboard events on component mount.
     *
     * @return {Void}
     */
    mount: function mount() {
      if (Glide.settings.keyboard) {
        this.bind();
      }
    },


    /**
     * Adds keyboard press events.
     *
     * @return {Void}
     */
    bind: function bind() {
      Binder.on('keyup', document, this.press);
    },


    /**
     * Removes keyboard press events.
     *
     * @return {Void}
     */
    unbind: function unbind() {
      Binder.off('keyup', document);
    },


    /**
     * Handles keyboard's arrows press and moving glide foward and backward.
     *
     * @param  {Object} event
     * @return {Void}
     */
    press: function press(event) {
      if (event.keyCode === 39) {
        Components.Run.make(Components.Direction.resolve('>'));
      }

      if (event.keyCode === 37) {
        Components.Run.make(Components.Direction.resolve('<'));
      }
    }
  };

  /**
   * Remove bindings from keyboard:
   * - on destroying to remove added events
   * - on updating to remove events before remounting
   */
  Events.on(['destroy', 'update'], function () {
    Keyboard.unbind();
  });

  /**
   * Remount component
   * - on updating to reflect potential changes in settings
   */
  Events.on('update', function () {
    Keyboard.mount();
  });

  /**
   * Destroy binder:
   * - on destroying to remove listeners
   */
  Events.on('destroy', function () {
    Binder.destroy();
  });

  return Keyboard;
}

function Autoplay (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  var Autoplay = {
    /**
     * Initializes autoplaying and events.
     *
     * @return {Void}
     */
    mount: function mount() {
      this.start();

      if (Glide.settings.hoverpause) {
        this.bind();
      }
    },


    /**
     * Starts autoplaying in configured interval.
     *
     * @param {Boolean|Number} force Run autoplaying with passed interval regardless of `autoplay` settings
     * @return {Void}
     */
    start: function start() {
      var _this = this;

      if (Glide.settings.autoplay) {
        if (isUndefined(this._i)) {
          this._i = setInterval(function () {
            _this.stop();

            Components.Run.make('>');

            _this.start();
          }, this.time);
        }
      }
    },


    /**
     * Stops autorunning of the glide.
     *
     * @return {Void}
     */
    stop: function stop() {
      this._i = clearInterval(this._i);
    },


    /**
     * Stops autoplaying while mouse is over glide's area.
     *
     * @return {Void}
     */
    bind: function bind() {
      var _this2 = this;

      Binder.on('mouseover', Components.Html.root, function () {
        _this2.stop();
      });

      Binder.on('mouseout', Components.Html.root, function () {
        _this2.start();
      });
    },


    /**
     * Unbind mouseover events.
     *
     * @returns {Void}
     */
    unbind: function unbind() {
      Binder.off(['mouseover', 'mouseout'], Components.Html.root);
    }
  };

  define(Autoplay, 'time', {
    /**
     * Gets time period value for the autoplay interval. Prioritizes
     * times in `data-glide-autoplay` attrubutes over options.
     *
     * @return {Number}
     */
    get: function get() {
      var autoplay = Components.Html.slides[Glide.index].getAttribute('data-glide-autoplay');

      if (autoplay) {
        return toInt(autoplay);
      }

      return toInt(Glide.settings.autoplay);
    }
  });

  /**
   * Stop autoplaying and unbind events:
   * - on destroying, to clear defined interval
   * - on updating via API to reset interval that may changed
   */
  Events.on(['destroy', 'update'], function () {
    Autoplay.unbind();
  });

  /**
   * Stop autoplaying:
   * - before each run, to restart autoplaying
   * - on pausing via API
   * - on destroying, to clear defined interval
   * - while starting a swipe
   * - on updating via API to reset interval that may changed
   */
  Events.on(['run.before', 'pause', 'destroy', 'swipe.start', 'update'], function () {
    Autoplay.stop();
  });

  /**
   * Start autoplaying:
   * - after each run, to restart autoplaying
   * - on playing via API
   * - while ending a swipe
   */
  Events.on(['run.after', 'play', 'swipe.end'], function () {
    Autoplay.start();
  });

  /**
   * Remount autoplaying:
   * - on updating via API to reset interval that may changed
   */
  Events.on('update', function () {
    Autoplay.mount();
  });

  /**
   * Destroy a binder:
   * - on destroying glide instance to clearup listeners
   */
  Events.on('destroy', function () {
    Binder.destroy();
  });

  return Autoplay;
}

/**
 * Sorts keys of breakpoint object so they will be ordered from lower to bigger.
 *
 * @param {Object} points
 * @returns {Object}
 */
function sortBreakpoints(points) {
  if (isObject(points)) {
    return sortKeys(points);
  } else {
    warn('Breakpoints option must be an object');
  }

  return {};
}

function Breakpoints (Glide, Components, Events) {
  /**
   * Instance of the binder for DOM Events.
   *
   * @type {EventsBinder}
   */
  var Binder = new EventsBinder();

  /**
   * Holds reference to settings.
   *
   * @type {Object}
   */
  var settings = Glide.settings;

  /**
   * Holds reference to breakpoints object in settings. Sorts breakpoints
   * from smaller to larger. It is required in order to proper
   * matching currently active breakpoint settings.
   *
   * @type {Object}
   */
  var points = sortBreakpoints(settings.breakpoints);

  /**
   * Cache initial settings before overwritting.
   *
   * @type {Object}
   */
  var defaults = _extends({}, settings);

  var Breakpoints = {
    /**
     * Matches settings for currectly matching media breakpoint.
     *
     * @param {Object} points
     * @returns {Object}
     */
    match: function match(points) {
      if (typeof window.matchMedia !== 'undefined') {
        for (var point in points) {
          if (points.hasOwnProperty(point)) {
            if (window.matchMedia('(max-width: ' + point + 'px)').matches) {
              return points[point];
            }
          }
        }
      }

      return defaults;
    }
  };

  /**
   * Overwrite instance settings with currently matching breakpoint settings.
   * This happens right after component initialization.
   */
  _extends(settings, Breakpoints.match(points));

  /**
   * Update glide with settings of matched brekpoint:
   * - window resize to update slider
   */
  Binder.on('resize', window, throttle(function () {
    Glide.settings = mergeOptions(settings, Breakpoints.match(points));
  }, Glide.settings.throttle));

  /**
   * Resort and update default settings:
   * - on reinit via API, so breakpoint matching will be performed with options
   */
  Events.on('update', function () {
    points = sortBreakpoints(points);

    defaults = _extends({}, settings);
  });

  /**
   * Unbind resize listener:
   * - on destroying, to bring markup to its initial state
   */
  Events.on('destroy', function () {
    Binder.off('resize', window);
  });

  return Breakpoints;
}

var COMPONENTS = {
  // Required
  Html: Html,
  Translate: Translate,
  Transition: Transition,
  Direction: Direction,
  Peek: Peek,
  Sizes: Sizes,
  Gaps: Gaps,
  Move: Move,
  Clones: Clones,
  Resize: Resize,
  Build: Build,
  Run: Run,

  // Optional
  Swipe: Swipe,
  Images: Images,
  Anchors: Anchors,
  Controls: Controls,
  Keyboard: Keyboard,
  Autoplay: Autoplay,
  Breakpoints: Breakpoints
};

var Glide$1 = function (_Core) {
  inherits(Glide$$1, _Core);

  function Glide$$1() {
    classCallCheck(this, Glide$$1);
    return possibleConstructorReturn(this, (Glide$$1.__proto__ || Object.getPrototypeOf(Glide$$1)).apply(this, arguments));
  }

  createClass(Glide$$1, [{
    key: 'mount',
    value: function mount() {
      var extensions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return get(Glide$$1.prototype.__proto__ || Object.getPrototypeOf(Glide$$1.prototype), 'mount', this).call(this, _extends({}, COMPONENTS, extensions));
    }
  }]);
  return Glide$$1;
}(Glide);

/* harmony default export */ __webpack_exports__["default"] = (Glide$1);


/***/ }),
/* 1020 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);
var bind = __webpack_require__(596);
var Axios = __webpack_require__(1022);
var defaults = __webpack_require__(391);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(utils.merge(defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(593);
axios.CancelToken = __webpack_require__(1021);
axios.isCancel = __webpack_require__(594);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(1036);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 1021 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(593);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 1022 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var defaults = __webpack_require__(391);
var utils = __webpack_require__(87);
var InterceptorManager = __webpack_require__(1023);
var dispatchRequest = __webpack_require__(1024);
var isAbsoluteURL = __webpack_require__(1032);
var combineURLs = __webpack_require__(1030);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = utils.merge({
      url: arguments[0]
    }, arguments[1]);
  }

  config = utils.merge(defaults, this.defaults, { method: 'get' }, config);

  // Support baseURL config
  if (config.baseURL && !isAbsoluteURL(config.url)) {
    config.url = combineURLs(config.baseURL, config.url);
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 1023 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 1024 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);
var transformData = __webpack_require__(1027);
var isCancel = __webpack_require__(594);
var defaults = __webpack_require__(391);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers || {}
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 @ @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }
  error.response = response;
  return error;
};


/***/ }),
/* 1026 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(595);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  // Note: status is not exposed by XDomainRequest
  if (!response.status || !validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response
    ));
  }
};


/***/ }),
/* 1027 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// btoa polyfill for IE<10 courtesy https://github.com/davidchambers/Base64.js

var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';

function E() {
  this.message = 'String contains an invalid character';
}
E.prototype = new Error;
E.prototype.code = 5;
E.prototype.name = 'InvalidCharacterError';

function btoa(input) {
  var str = String(input);
  var output = '';
  for (
    // initialize result and counter
    var block, charCode, idx = 0, map = chars;
    // if the next str index does not exist:
    //   change the mapping table to "="
    //   check if d has no fractional digits
    str.charAt(idx | 0) || (map = '=', idx % 1);
    // "8 - idx % 1 * 8" generates the sequence 2, 4, 6, 8
    output += map.charAt(63 & block >> 8 - idx % 1 * 8)
  ) {
    charCode = str.charCodeAt(idx += 3 / 4);
    if (charCode > 0xFF) {
      throw new E();
    }
    block = block << 8 | charCode;
  }
  return output;
}

module.exports = btoa;


/***/ }),
/* 1029 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      }

      if (!utils.isArray(val)) {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 1030 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '');
};


/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
  (function standardBrowserEnv() {
    return {
      write: function write(name, value, expires, path, domain, secure) {
        var cookie = [];
        cookie.push(name + '=' + encodeURIComponent(value));

        if (utils.isNumber(expires)) {
          cookie.push('expires=' + new Date(expires).toGMTString());
        }

        if (utils.isString(path)) {
          cookie.push('path=' + path);
        }

        if (utils.isString(domain)) {
          cookie.push('domain=' + domain);
        }

        if (secure === true) {
          cookie.push('secure');
        }

        document.cookie = cookie.join('; ');
      },

      read: function read(name) {
        var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
        return (match ? decodeURIComponent(match[3]) : null);
      },

      remove: function remove(name) {
        this.write(name, '', Date.now() - 86400000);
      }
    };
  })() :

  // Non standard browser env (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return {
      write: function write() {},
      read: function read() { return null; },
      remove: function remove() {}
    };
  })()
);


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  (function standardBrowserEnv() {
    var msie = /(msie|trident)/i.test(navigator.userAgent);
    var urlParsingNode = document.createElement('a');
    var originURL;

    /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
    function resolveURL(url) {
      var href = url;

      if (msie) {
        // IE needs attribute set twice to normalize properties
        urlParsingNode.setAttribute('href', href);
        href = urlParsingNode.href;
      }

      urlParsingNode.setAttribute('href', href);

      // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
      return {
        href: urlParsingNode.href,
        protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
        host: urlParsingNode.host,
        search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
        hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
        hostname: urlParsingNode.hostname,
        port: urlParsingNode.port,
        pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
                  urlParsingNode.pathname :
                  '/' + urlParsingNode.pathname
      };
    }

    originURL = resolveURL(window.location.href);

    /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
    return function isURLSameOrigin(requestURL) {
      var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
      return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
    };
  })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
  (function nonStandardBrowserEnv() {
    return function isURLSameOrigin() {
      return true;
    };
  })()
);


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(87);

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
    }
  });

  return parsed;
};


/***/ }),
/* 1036 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Abbr = function Abbr(_ref) {
    var title = _ref.title,
        children = _ref.children,
        breakpoint = _ref.breakpoint;
    return _jsx('abbr', {
        className: 'cmn-abbr cmn-abbr_from-' + breakpoint,
        title: title
    }, void 0, _jsx('span', {
        className: 'cmn-abbr__inner'
    }, void 0, children || title.charAt(0)));
};

exports.default = Abbr;

/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Abbr = __webpack_require__(1037);

var _Abbr2 = _interopRequireDefault(_Abbr);

__webpack_require__(2098);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _Abbr2.default;

/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Popover = __webpack_require__(1043);

var _Popover2 = _interopRequireDefault(_Popover);

var _FilterStatus = __webpack_require__(1041);

var _FilterStatus2 = _interopRequireDefault(_FilterStatus);

var _updateCategories = __webpack_require__(1048);

var _updateCategories2 = _interopRequireDefault(_updateCategories);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Filter = function (_PureComponent) {
    _inherits(Filter, _PureComponent);

    function Filter(props) {
        _classCallCheck(this, Filter);

        var _this = _possibleConstructorReturn(this, (Filter.__proto__ || Object.getPrototypeOf(Filter)).call(this, props));

        _this.dispatch = function (action) {
            var categoriesReducer = _this.props.categoriesReducer;


            _this.setState(function (_ref) {
                var categories = _ref.categories;
                return {
                    categories: (0, _updateCategories2.default)(categories, categoriesReducer, action)
                };
            });
        };

        _this.resetCategories = function () {
            _this.setState({ categories: _this.props.categories });
        };

        _this.applyFilter = function () {
            _this.props.onFilterApply(_this.state.categories);
        };

        _this.state = {
            categories: props.categories
        };
        return _this;
    }

    _createClass(Filter, [{
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(_ref2) {
            var categories = _ref2.categories;

            this.setState({ categories: categories });
        }

        /**
         * When some option is changed we are using two reducers
         * (one that passed through props and one that change selected option)
         * to handle options transformations
         */

    }, {
        key: 'render',
        value: function render() {
            var children = this.props.children;
            var categories = this.state.categories;


            if (!categories) return null;

            return _jsx('div', {
                className: 'cmn-filter'
            }, void 0, children || _jsx(_FilterStatus2.default, {
                categories: this.props.categories
            }), _jsx(_Popover2.default, {
                categories: categories,
                resetCategories: this.resetCategories,
                applyFilter: this.applyFilter,
                dispatch: this.dispatch
            }));
        }
    }]);

    return Filter;
}(_react.PureComponent);

Filter.defaultProps = {
    categoriesReducer: function categoriesReducer(categories) {
        return categories;
    }
};

var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
exports.default = Filter;

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _Option = __webpack_require__(1042);

var _Option2 = _interopRequireDefault(_Option);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'minus',
    size: 'Medium',
    className: 'accordionMinus ui-accordion__arrow tableShowIcon'
});

var _ref3 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'plus',
    size: 'Medium',
    className: 'accordionPlus ui-accordion__arrow tableShowIcon'
});

var Category = function Category(_ref) {
    var type = _ref.type,
        options = _ref.options,
        title = _ref.title,
        dispatch = _ref.dispatch,
        expanded = _ref.expanded,
        toggleExpanded = _ref.toggleExpanded,
        isHidden = _ref.isHidden;
    return options && !isHidden ? _jsx('div', {
        className: 'cmn-filter__category',
        onClick: function onClick() {
            return toggleExpanded(type);
        }
    }, void 0, _jsx('div', {
        className: (0, _classnames2.default)('ui-accordion__header', 'cmn-filter__categoryRow', { 'ui-accordion__header_active': expanded })
    }, void 0, _jsx('span', {
        className: 'cmn-filter__categoryName'
    }, void 0, title, _jsx('span', {
        className: 'cmn-filter__categorySelected'
    }, void 0, options.find(function (option) {
        return option.selected;
    }).label !== 'No filter' && options.find(function (option) {
        return option.selected;
    }).label)), _ref2, _ref3), expanded && _jsx('ul', {}, void 0, options.map(function (_ref4) {
        var value = _ref4.value,
            label = _ref4.label,
            selected = _ref4.selected;
        return _jsx(_Option2.default, {
            label: label,
            selected: selected,
            onClick: function onClick() {
                return dispatch({ type: type, value: value, label: label });
            }
        }, label);
    }))) : null;
};

var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
exports.default = Category;

/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _selection = __webpack_require__(597);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint react/prefer-stateless-function: 0 */


var FilterStatus = function (_PureComponent) {
    _inherits(FilterStatus, _PureComponent);

    function FilterStatus() {
        _classCallCheck(this, FilterStatus);

        return _possibleConstructorReturn(this, (FilterStatus.__proto__ || Object.getPrototypeOf(FilterStatus)).apply(this, arguments));
    }

    _createClass(FilterStatus, [{
        key: 'render',
        value: function render() {
            var labels = (0, _selection.getStatusLabels)(this.props.categories);

            return _jsx('h2', {
                className: 'cmn-filter__status'
            }, void 0, Object.values(labels).filter(function (label) {
                return label && label !== 'No filter';
            }).join(', '));
        }
    }]);

    return FilterStatus;
}(_react.PureComponent);

var strOrNum = _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]);
exports.default = FilterStatus;

/***/ }),
/* 1042 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'tick',
    size: 'Medium',
    className: 'cmn-filter__optionTick tableShowIcon'
});

var Option = function Option(_ref) {
    var label = _ref.label,
        selected = _ref.selected,
        onClick = _ref.onClick;
    return _jsx('li', {
        className: (0, _classnames2.default)('ui-popoverList__link cmn-filter__option', selected && 'cmn-filter__option_selected'),
        onClick: onClick
    }, void 0, label, _ref2);
};

exports.default = Option;

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _PopoverComponent2 = __webpack_require__(598);

var _PopoverComponent3 = _interopRequireDefault(_PopoverComponent2);

var _PopoverHeader = __webpack_require__(1046);

var _PopoverHeader2 = _interopRequireDefault(_PopoverHeader);

var _PopoverFooter = __webpack_require__(1045);

var _PopoverFooter2 = _interopRequireDefault(_PopoverFooter);

var _PopoverBody = __webpack_require__(1044);

var _PopoverBody2 = _interopRequireDefault(_PopoverBody);

var _getFilterPosition = __webpack_require__(1047);

var _getFilterPosition2 = _interopRequireDefault(_getFilterPosition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref3 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'filter',
    size: 'Medium',
    className: 'cmn-filter__btnIcon tableShowIcon'
});

var _ref4 = _jsx('div', {
    className: 'cmn-filter__pointer ui-popoverPointer'
});

var Popover = function (_PopoverComponent) {
    _inherits(Popover, _PopoverComponent);

    function Popover() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, Popover);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Popover.__proto__ || Object.getPrototypeOf(Popover)).call.apply(_ref, [this].concat(args))), _this), _this.closePopover = function () {
            _this.setState({ expanded: false });
            _this.props.resetCategories();
        }, _this.openPopover = function (_ref2) {
            var currentTarget = _ref2.currentTarget;

            _this.setState({
                expanded: true,
                position: (0, _getFilterPosition2.default)(currentTarget)
            });
        }, _this.applyFilter = function () {
            _this.props.applyFilter();
            _this.setState({ expanded: false });
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }
    /**
     * Overriding "closePopover" function from PopoverComponent.
     * So when popover is closed, categories went back to default
     */


    /**
     * Overriding "openPopover" function from PopoverComponent.
     * So we can calculate position of filter popover
     */


    _createClass(Popover, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                expanded = _state.expanded,
                position = _state.position;
            var _props = this.props,
                categories = _props.categories,
                dispatch = _props.dispatch;


            return _react2.default.createElement(
                'div',
                { ref: function ref(node) {
                        _this2.node = node;
                    } },
                _jsx('button', {
                    className: 'ui-btn ui-btn_tiertiary',
                    onClick: this.togglePopover
                }, void 0, _ref3, 'Filter'),
                expanded && _jsx('div', {
                    className: 'ui-popover cmn-filter__popover pos_' + position
                }, void 0, _ref4, _jsx(_PopoverHeader2.default, {
                    cancelFilter: this.closePopover
                }), _jsx(_PopoverBody2.default, {
                    categories: categories,
                    dispatch: dispatch
                }), _jsx(_PopoverFooter2.default, {
                    cancelFilter: this.closePopover,
                    applyFilter: this.applyFilter
                }))
            );
        }
    }]);

    return Popover;
}(_PopoverComponent3.default);

Popover.propTypes = {
    categories: _propTypes2.default.shape({}),
    resetCategories: _propTypes2.default.func.isRequired,
    applyFilter: _propTypes2.default.func.isRequired
};

exports.default = Popover;

/***/ }),
/* 1044 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _entries = __webpack_require__(895);

var _entries2 = _interopRequireDefault(_entries);

var _Category = __webpack_require__(1040);

var _Category2 = _interopRequireDefault(_Category);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverBody = function (_PureComponent) {
    _inherits(PopoverBody, _PureComponent);

    function PopoverBody(props) {
        _classCallCheck(this, PopoverBody);

        var _this = _possibleConstructorReturn(this, (PopoverBody.__proto__ || Object.getPrototypeOf(PopoverBody)).call(this, props));

        _initialiseProps.call(_this);

        var expandedCategory = (0, _entries2.default)(props.categories).length === 1 ? (0, _entries2.default)(props.categories)[0][0] : null;

        _this.state = { expandedCategory: expandedCategory };
        return _this;
    }

    // setting current expanded category


    _createClass(PopoverBody, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                categories = _props.categories,
                dispatch = _props.dispatch;
            var expandedCategory = this.state.expandedCategory;


            return _jsx('div', {
                className: 'cmn-filter__popoverBody'
            }, void 0, (0, _entries2.default)(categories).map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                    categoryName = _ref2[0],
                    category = _ref2[1];

                return _jsx(_Category2.default, {
                    type: categoryName,
                    toggleExpanded: _this2.toggleExpanded,
                    expanded: expandedCategory === categoryName,
                    title: category.title,
                    options: category.options,
                    dispatch: dispatch,
                    isHidden: category.isHidden
                }, categoryName);
            }));
        }
    }]);

    return PopoverBody;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.toggleExpanded = function (category) {
        _this3.setState(function (_ref3) {
            var expandedCategory = _ref3.expandedCategory;
            return {
                expandedCategory: expandedCategory === category ? null : category
            };
        });
    };
};

exports.default = PopoverBody;

/***/ }),
/* 1045 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var btnCls = 'cmn-filter__footerBtn ui-btn';

var PopoverFooter = function PopoverFooter(_ref) {
    var cancelFilter = _ref.cancelFilter,
        applyFilter = _ref.applyFilter;
    return _jsx('div', {
        className: 'cmn-filter__popoverFooter'
    }, void 0, _jsx('button', {
        className: btnCls + ' ' + btnCls + '_secondary',
        onClick: cancelFilter
    }, void 0, 'Cancel'), _jsx('button', {
        className: btnCls + ' ' + btnCls + '_primary',
        onClick: applyFilter
    }, void 0, 'Apply'));
};

exports.default = PopoverFooter;

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'cross',
    className: 'tableShowIcon',
    size: 'Medium'
});

var PopoverHeader = function PopoverHeader(_ref) {
    var cancelFilter = _ref.cancelFilter;
    return _jsx('div', {
        className: 'ui-popoverHeader cmn-filter__popoverHeader'
    }, void 0, 'Choose Filters', _jsx('button', {
        className: 'ui-btn ui-btn_secondary cmn-filter__crossBtn',
        onClick: cancelFilter
    }, void 0, _ref2));
};

exports.default = PopoverHeader;

/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var requiredHeight = 450;

var getFilterPosition = function getFilterPosition(btn) {
    var _btn$getBoundingClien = btn.getBoundingClientRect(),
        topSpace = _btn$getBoundingClien.top,
        bottom = _btn$getBoundingClien.bottom;

    var bottomSpace = window.innerHeight - bottom;

    if (bottomSpace > requiredHeight) {
        return 'bottom';
    } else if (topSpace > requiredHeight) {
        return 'top';
    }
    return 'left';
};

exports.default = getFilterPosition;

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toggleSelected = function toggleSelected(arr, value) {
    return arr.map(function (item) {
        if (item.value === value) {
            return _extends({}, item, { selected: true });
        }
        if (item.selected) {
            return _extends({}, item, { selected: false });
        }
        return item;
    });
};

var setSelectReducer = function setSelectReducer(categories, _ref) {
    var type = _ref.type,
        value = _ref.value;
    return _extends({}, categories, _defineProperty({}, type, _extends({}, categories[type], {
        options: toggleSelected(categories[type].options, value)
    })));
};

/**
 * When some option is changed we are using two reducers
 * (one that passed through props and one that change selected option)
 * to handle options transformations
 */
var updateCategories = function updateCategories(categories, reducer, action) {
    return setSelectReducer(reducer(categories, action), action);
};

exports.default = updateCategories;

/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PopoverComponent = function (_PureComponent) {
    _inherits(PopoverComponent, _PureComponent);

    function PopoverComponent(props) {
        _classCallCheck(this, PopoverComponent);

        var _this = _possibleConstructorReturn(this, (PopoverComponent.__proto__ || Object.getPrototypeOf(PopoverComponent)).call(this, props));

        _this.onOutsideClick = function (event) {
            var domNode = _this.node;
            if (!domNode || !domNode.contains(event.target)) {
                _this.closePopover();
            }
        };

        _this.closePopover = function () {
            _this.setState({ expanded: false });
        };

        _this.openPopover = function () {
            _this.setState({ expanded: true });
        };

        _this.togglePopover = function (e) {
            if (_this.state.expanded) {
                _this.closePopover(e);
            } else {
                _this.openPopover(e);
            }
        };

        _this.state = { expanded: false };
        return _this;
    }

    _createClass(PopoverComponent, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.onOutsideClick, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.onOutsideClick, true);
        }
    }]);

    return PopoverComponent;
}(_react.PureComponent);

exports.default = PopoverComponent;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

__webpack_require__(2099);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'ui-popoverList__icon'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    isInlined: true,
    iconName: 'tick',
    size: 'Medium'
}));

var PopoverListItem = function PopoverListItem(_ref) {
    var isSelected = _ref.isSelected,
        text = _ref.text,
        onSelect = _ref.onSelect;
    return _jsx('div', {
        className: (0, _classnames2.default)('ui-popoverList__item', 'cm-popoverList__popoverLink', { 'cm-popoverList__popoverLink_selected': isSelected }),
        onClick: onSelect
    }, void 0, _jsx('span', {
        className: (0, _classnames2.default)('ui-popoverList__label', 'cm-popoverList__popoverLabel')
    }, void 0, text), _ref2);
};

PopoverListItem.defaultProps = {
    text: null
};

exports.default = PopoverListItem;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _PopoverListItem = __webpack_require__(1050);

var _PopoverListItem2 = _interopRequireDefault(_PopoverListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _PopoverListItem2.default;

/***/ }),
/* 1052 */,
/* 1053 */,
/* 1054 */,
/* 1055 */,
/* 1056 */,
/* 1057 */,
/* 1058 */,
/* 1059 */,
/* 1060 */,
/* 1061 */,
/* 1062 */,
/* 1063 */,
/* 1064 */,
/* 1065 */,
/* 1066 */,
/* 1067 */,
/* 1068 */,
/* 1069 */,
/* 1070 */,
/* 1071 */,
/* 1072 */,
/* 1073 */,
/* 1074 */,
/* 1075 */,
/* 1076 */,
/* 1077 */,
/* 1078 */,
/* 1079 */,
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */,
/* 1084 */,
/* 1085 */,
/* 1086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MetaData = __webpack_require__(404);

var _MetaData2 = _interopRequireDefault(_MetaData);

var _NameRow = __webpack_require__(1097);

var _NameRow2 = _interopRequireDefault(_NameRow);

var _RaceDays = __webpack_require__(1098);

var _RaceDays2 = _interopRequireDefault(_RaceDays);

var _Nav = __webpack_require__(405);

var _Nav2 = _interopRequireDefault(_Nav);

var _object = __webpack_require__(300);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CoursePage = function CoursePage(_ref) {
    var data = _ref.data,
        children = _ref.children,
        params = _ref.params,
        userRole = _ref.userRole,
        pageName = _ref.pageName;

    var courseInfoTab = Object.assign({}, data.admission, data.directions);

    var tabsToExclude = [(0, _object.areAllFieldsEmpty)(data.standardTimes) && 'course-records', (0, _object.areAllFieldsEmpty)(courseInfoTab) && 'course-info', !data.courseMap && 'course-map'];

    return _jsx('div', {}, void 0, _jsx('section', {}, void 0, _jsx(_MetaData2.default, {
        type: params.type,
        page: params.tab ? params.tab : 'stats',
        name: data.profile.courseStyleName
    }), _jsx(_NameRow2.default, {
        profile: data.profile
    }), _jsx(_RaceDays2.default, {
        data: data.upcomingRaces || [],
        params: params
    })), _jsx(_Nav2.default, {
        params: params,
        helpUrl: data.helpCenterUrl,
        tabsToExclude: tabsToExclude,
        userRole: userRole,
        pageName: pageName
    }), (0, _react.cloneElement)(children, { data: data, params: params }));
};

exports.default = CoursePage;

/***/ }),
/* 1087 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('h3', {
    className: 'cp-courseInfo__title'
}, void 0, 'Address');

var _ref3 = _jsx('h3', {
    className: 'cp-courseInfo__title'
}, void 0, 'Admission');

var _ref4 = _jsx('h3', {
    className: 'cp-courseInfo__title'
}, void 0, 'How to get there');

var _ref5 = _jsx('h3', {
    className: 'cp-courseInfo__title'
}, void 0, 'Parking');

var _ref6 = _jsx('h3', {
    className: 'cp-courseInfo__title'
}, void 0, 'Disabled');

var CourseInfo = function CourseInfo(_ref) {
    var _ref$data = _ref.data,
        _ref$data$directions = _ref$data.directions,
        courseAddress = _ref$data$directions.courseAddress,
        rpParking = _ref$data$directions.rpParking,
        rpDisabled = _ref$data$directions.rpDisabled,
        howToGetThere = _ref$data$directions.howToGetThere,
        _ref$data$admission = _ref$data.admission,
        rpAdmissionPrices = _ref$data$admission.rpAdmissionPrices,
        rpChildren = _ref$data$admission.rpChildren;
    return _jsx('section', {
        className: 'cp-courseInfo'
    }, void 0, courseAddress && _jsx('div', {
        className: 'cp-courseInfo__block'
    }, void 0, _ref2, courseAddress), ((0, _lodash.trim)(rpAdmissionPrices) || (0, _lodash.trim)(rpChildren)) && _jsx('div', {
        className: 'cp-courseInfo__block'
    }, void 0, _ref3, (0, _lodash.trim)(rpAdmissionPrices) && _jsx('p', {
        className: 'cp-courseInfo__row'
    }, void 0, 'General Admission: ', rpAdmissionPrices), (0, _lodash.trim)(rpChildren) && _jsx('p', {
        className: 'cp-courseInfo__row'
    }, void 0, 'Children: ', rpChildren)), _jsx('div', {
        className: 'cp-courseInfo__block'
    }, void 0, _ref4, (0, _lodash.keys)(howToGetThere).map(function (key) {
        return howToGetThere[key] ? _jsx('span', {}, key, _jsx('span', {
            className: 'cp-courseInfo__subtitle'
        }, void 0, key, ': '), howToGetThere[key], '\xA0') : null;
    })), (0, _lodash.trim)(rpParking) && _jsx('div', {
        className: 'cp-courseInfo__block'
    }, void 0, _ref5, rpParking), (0, _lodash.trim)(rpDisabled) && _jsx('div', {
        className: 'cp-courseInfo__block'
    }, void 0, _ref6, rpDisabled));
};

exports.default = CourseInfo;

/***/ }),
/* 1088 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactGoogleMaps = __webpack_require__(2384);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseGoogleMap = (0, _reactGoogleMaps.withGoogleMap)(function (_ref) {
    var defaultZoom = _ref.defaultZoom,
        pos = _ref.pos;
    return _jsx(_reactGoogleMaps.GoogleMap, {
        defaultZoom: defaultZoom,
        defaultCenter: pos,
        defaultMapTypeId: 'satellite'
    }, void 0, _jsx(_reactGoogleMaps.Marker, {
        position: pos
    }));
});

CourseGoogleMap.propTypes = {
    defaultZoom: _propTypes2.default.number.isRequired,
    pos: _propTypes2.default.shape({
        lat: _propTypes2.default.number.isRequired,
        lng: _propTypes2.default.number.isRequired
    }).isRequired
};

exports.default = CourseGoogleMap;

/***/ }),
/* 1089 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Switcher = __webpack_require__(295);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(200);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

var _helpers = __webpack_require__(1090);

var _CourseGoogleMap = __webpack_require__(1088);

var _CourseGoogleMap2 = _interopRequireDefault(_CourseGoogleMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var mapWrappers = {
    containerElement: _jsx('div', {
        className: 'cp-courseMap__container'
    }),
    mapElement: _jsx('div', {
        className: 'cp-courseMap__map'
    })
};

var CourseMap = function (_PureComponent) {
    _inherits(CourseMap, _PureComponent);

    function CourseMap(props) {
        _classCallCheck(this, CourseMap);

        var _this = _possibleConstructorReturn(this, (CourseMap.__proto__ || Object.getPrototypeOf(CourseMap)).call(this, props));

        _this.setSelected = function (selected) {
            _this.setState({ selected: selected }, function () {
                (0, _fixMobileSafariWhiteScreenBug2.default)();
            });
        };

        _this.state = { selected: 0 };
        return _this;
    }

    _createClass(CourseMap, [{
        key: 'render',
        value: function render() {
            var selected = this.state.selected;
            var courseMap = this.props.data.courseMap;

            var titles = courseMap.map(_helpers.getSwitcherTitle);
            var item = courseMap[selected];

            var _courseMap$ = courseMap[0],
                zoom = _courseMap$.zoom,
                lat = _courseMap$.latitude,
                lng = _courseMap$.longitude;

            var pos = { lat: lat, lng: lng };

            return _jsx('section', {
                className: 'cp-courseMap'
            }, void 0, _jsx('div', {
                className: 'cp-courseMap__switchDescWrapper'
            }, void 0, _jsx(_Switcher2.default, {
                items: titles,
                selected: selected,
                setSelected: this.setSelected
            }), _jsx('div', {
                className: 'cp-courseMap__description'
            }, void 0, (0, _helpers.getDescription)(item))), item.largeMapImagePath && _jsx('figure', {
                className: 'pp-figure'
            }, void 0, _jsx('img', {
                src: item.largeMapImagePath,
                alt: 'Course Map'
            })), _react2.default.createElement(_CourseGoogleMap2.default, _extends({
                defaultZoom: zoom,
                pos: pos
            }, mapWrappers)));
        }
    }]);

    return CourseMap;
}(_react.PureComponent);

exports.default = CourseMap;

/***/ }),
/* 1090 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getDescription = exports.getSwitcherTitle = undefined;

var _lodash = __webpack_require__(9);

var getSwitcherTitle = exports.getSwitcherTitle = function getSwitcherTitle(_ref) {
    var code = _ref.raceTypeCode[0];

    switch (code) {
        case 'F':
        case 'W':
        case 'X':
            return 'Flat';
        case 'H':
            return 'Hurdle';
        case 'U':
        case 'C':
            return 'Chase';
        default:
            return '';
    }
};

var getDescription = exports.getDescription = function getDescription(_ref2) {
    var raceTypeCode = _ref2.raceTypeCode,
        rpDetailedAwDesc = _ref2.rpDetailedAwDesc,
        rpDetailedFlatDesc = _ref2.rpDetailedFlatDesc,
        rpDetailedJumpDesc = _ref2.rpDetailedJumpDesc;

    if ((0, _lodash.intersection)(raceTypeCode, ['W', 'X', 'Y', 'Z']).length) {
        return rpDetailedAwDesc;
    } else if (raceTypeCode.includes('F')) {
        return rpDetailedFlatDesc;
    } else if ((0, _lodash.intersection)(raceTypeCode, ['U', 'C', 'P', 'H', 'B']).length) {
        return rpDetailedJumpDesc;
    }
    return '';
};

/***/ }),
/* 1091 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _lodash = __webpack_require__(9);

var _Switcher = __webpack_require__(295);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(200);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

var _columns = __webpack_require__(1092);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_rpReactTable.NoData, {});

var CourseRecords = function (_PureComponent) {
    _inherits(CourseRecords, _PureComponent);

    function CourseRecords(props) {
        _classCallCheck(this, CourseRecords);

        var _this = _possibleConstructorReturn(this, (CourseRecords.__proto__ || Object.getPrototypeOf(CourseRecords)).call(this, props));

        _this.setSelected = function (selected) {
            _this.setState({ selected: selected }, function () {
                (0, _fixMobileSafariWhiteScreenBug2.default)();
            });
        };

        _this.state = { selected: 0 };
        return _this;
    }

    _createClass(CourseRecords, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                standardTimes = _props.data.standardTimes,
                _props$params = _props.params,
                id = _props$params.id,
                name = _props$params.name;
            var selected = this.state.selected;

            var availableTypes = [];

            if (standardTimes.flat) {
                availableTypes.push('flat');
            }
            if (standardTimes.jumps) {
                availableTypes.push('jumps');
            }

            var selectedType = availableTypes[selected];
            var tableData = (0, _lodash.sortBy)(standardTimes[selectedType], ['distanceYards', 'horseName']);

            // selectedType could be empty only if you get here by direct link
            return selectedType ? _jsx('section', {
                className: 'cp-courseRecords'
            }, void 0, availableTypes.length > 1 ? _jsx(_Switcher2.default, {
                items: availableTypes,
                selected: selected,
                setSelected: this.setSelected
            }) : null, _jsx(_rpReactTable2.default, {
                columns: (0, _columns2.default)(name, id, selectedType),
                data: tableData
            })) : _ref;
        }
    }]);

    return CourseRecords;
}(_react.PureComponent);

var recordPropTypes = _propTypes2.default.shape({
    averageTimeSec: _propTypes2.default.number,
    courseRecordHorseName: _propTypes2.default.string,
    distanceYards: _propTypes2.default.number,
    horseCountryOriginCode: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    noOfFences: _propTypes2.default.number,
    raceDate: _propTypes2.default.string,
    raceInstanceUid: _propTypes2.default.number,
    raceTypeCode: _propTypes2.default.string,
    rpAgesAllowedDesc: _propTypes2.default.string,
    straightRoundJubileeCode: _propTypes2.default.string,
    winnersTime: _propTypes2.default.number
});

exports.default = CourseRecords;

/***/ }),
/* 1092 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactTable = __webpack_require__(23);

var _ProfileLink = __webpack_require__(26);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _distance = __webpack_require__(113);

var _date = __webpack_require__(18);

var _formatTime = __webpack_require__(1264);

var _formatTime2 = _interopRequireDefault(_formatTime);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = function columns(courseName, courseUid, raceType) {
    return [{
        key: 'distanceYards',
        header: 'distance',
        /** for IRE courses use average-times request
         *  it has distanceYard and noOfObstacles instead of distanceYards and noOfFences
         */
        cell: function cell(_ref) {
            var distanceYards = _ref.distanceYards,
                distanceYard = _ref.distanceYard,
                raceTypeCode = _ref.raceTypeCode,
                noOfFences = _ref.noOfFences,
                noOfObstacles = _ref.noOfObstacles;
            return _jsx('span', {}, void 0, (0, _distance.yardsToFurlongs)(distanceYards || distanceYard), raceType === 'jumps' && raceTypeCode ? '(' + raceTypeCode + ')' : '', noOfFences || noOfObstacles ? '(' + (noOfFences || noOfObstacles) + ')' : '');
        }
    }, {
        key: 'horseName',
        header: 'record holder',
        cell: function cell(_ref2) {
            var horseName = _ref2.horseName,
                horseUid = _ref2.horseUid,
                horseCountryOriginCode = _ref2.horseCountryOriginCode,
                rpAgesAllowedDesc = _ref2.rpAgesAllowedDesc;
            return horseUid || horseName ? _jsx('span', {}, void 0, _jsx(_ProfileLink.HorseLink, {
                horseUid: horseUid,
                horseStyleName: horseName
            }), '\xA0(', horseCountryOriginCode, ') \xA0(', rpAgesAllowedDesc, ')') : _rpReactTable.EMPTINESS_SIGN;
        }
    }, {
        key: 'raceDate',
        header: 'date',
        cell: function cell(_ref3) {
            var raceInstanceUid = _ref3.raceInstanceUid,
                raceDate = _ref3.raceDate;
            return _jsx(_ResultLink2.default, {
                courseName: courseName,
                courseUid: +courseUid,
                raceInstanceUid: raceInstanceUid,
                raceDatetime: raceDate
            }, void 0, (0, _date.formatDate)(raceDate, 'DDMMMYY'));
        }
    }, {
        key: 'winnersTime',
        header: 'course record',
        cell: function cell(_ref4) {
            var raceInstanceUid = _ref4.raceInstanceUid,
                raceDate = _ref4.raceDate,
                winnersTime = _ref4.winnersTime;
            return winnersTime ? _jsx(_Abbr2.default, {
                title: (0, _formatTime2.default)(winnersTime)
            }, void 0, _jsx(_ResultLink2.default, {
                courseName: courseName,
                courseUid: +courseUid,
                raceInstanceUid: raceInstanceUid,
                raceDatetime: raceDate,
                className: 'pp-abbr__inner'
            }, void 0, (0, _formatTime2.default)(winnersTime))) : _rpReactTable.EMPTINESS_SIGN;
        }
    }, {
        key: 'averageTimeSec',
        header: 'rp standard',
        cell: function cell(_ref5) {
            var averageTimeSec = _ref5.averageTimeSec;
            return (0, _formatTime2.default)(averageTimeSec);
        }
    }];
};

exports.default = columns;

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Filter = __webpack_require__(142);

var _Filter2 = _interopRequireDefault(_Filter);

var _lodash = __webpack_require__(9);

var _filter = __webpack_require__(144);

var _filter2 = _interopRequireDefault(_filter);

var _filter3 = __webpack_require__(75);

var _HeaderRow = __webpack_require__(1094);

var _HeaderRow2 = _interopRequireDefault(_HeaderRow);

var _columns = __webpack_require__(1095);

var _columns2 = _interopRequireDefault(_columns);

var _name = __webpack_require__(231);

var _object = __webpack_require__(300);

var _categories = __webpack_require__(606);

var _categories2 = _interopRequireDefault(_categories);

var _reducer = __webpack_require__(1096);

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noDataText = 'No favourites records available in the Racing Post database for this year.';

var Favourites = function (_FilteringComponent) {
    _inherits(Favourites, _FilteringComponent);

    function Favourites(props) {
        _classCallCheck(this, Favourites);

        var _this = _possibleConstructorReturn(this, (Favourites.__proto__ || Object.getPrototypeOf(Favourites)).call(this, props));

        var _this$props$data = _this.props.data,
            favourites = _this$props$data.favourites,
            profile = _this$props$data.profile,
            seasonDefaults = _this$props$data.seasonDefaults;
        var courseCountryCode = profile.courseCountryCode,
            courseTypeCode = profile.courseTypeCode;
        var seasonRaceType = seasonDefaults.seasonRaceType;


        _this.dataKey = 'favourites';
        _this.emptyData = { handicap: {}, nonHandicap: {} };

        _this.state = {
            categories: (0, _categories2.default)(seasonRaceType, courseCountryCode, courseTypeCode),
            data: favourites || _this.emptyData,
            loading: false,
            fetchError: false
        };
        return _this;
    }

    _createClass(Favourites, [{
        key: 'renderStatus',
        value: function renderStatus() {
            var categories = this.state.categories;

            var raceType = _filter3.selection.getCaption(categories, 'raceType');

            var _selection$getOption = _filter3.selection.getOption(categories, 'timePeriod'),
                value = _selection$getOption.value,
                label = _selection$getOption.label;

            if (value.match(/last5/)) {
                return _jsx('h2', {
                    className: 'ui-filter__statusText'
                }, void 0, raceType, ', ', (0, _lodash.toLower)(label));
            }

            var years = (0, _lodash.uniq)(value.split('/').slice(0, 2));
            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, raceType, ', ', years.join('-'));
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                categories = _state.categories,
                _state$data = _state.data,
                handicap = _state$data.handicap,
                nonHandicap = _state$data.nonHandicap,
                loading = _state.loading,
                fetchError = _state.fetchError;


            var isEmptyTable = (0, _object.areAllFieldsEmpty)(handicap) || (0, _object.areAllFieldsEmpty)(nonHandicap);
            // merging "handicap" and "nonHandicap" objects into one array
            var data = (0, _lodash.keys)(handicap).map(function (key) {
                return _extends({
                    // key of object is the raceName
                    raceName: (0, _name.formatRaceName)(key)
                }, handicap[key], {
                    // for non-handicap keys added preffix "nh_"
                    // to avoid key duplication
                    nh_percentage: nonHandicap[key].percentage,
                    nh_wins: nonHandicap[key].wins,
                    nh_runs: nonHandicap[key].runs,
                    nh_stake: nonHandicap[key].stake
                });
            });

            // extract total row from array
            var total = isEmptyTable ? null : data.find(function (_ref) {
                var raceName = _ref.raceName;
                return raceName === 'TOTAL';
            });
            var tableData = isEmptyTable ? null : (0, _lodash.without)(data, total);

            return _jsx('section', {
                className: 'cp-favourites'
            }, void 0, _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _reducer2.default,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: tableData,
                footerData: total,
                columns: _columns2.default,
                initialSortIdx: 0,
                sortable: true,
                className: 'cp-favouritesTable',
                headerRow: _HeaderRow2.default,
                loading: loading,
                noDataText: noDataText
            }));
        }
    }]);

    return Favourites;
}(_filter2.default);

// shape of handicap and non-handicap objects


var itemPropsShape = _propTypes2.default.shape({
    percentage: _propTypes2.default.number,
    runs: _propTypes2.default.number.isRequired,
    stake: _propTypes2.default.number.isRequired,
    wins: _propTypes2.default.number.isRequired
});

Favourites.propTypes = {
    data: _propTypes2.default.shape({
        favourites: _propTypes2.default.shape({
            handicap: _propTypes2.default.objectOf(itemPropsShape),
            nonHandicap: _propTypes2.default.objectOf(itemPropsShape)
        }),
        profile: _propTypes2.default.shape({
            courseTypeCode: _propTypes2.default.string.isRequired,
            courseCountryCode: _propTypes2.default.string.isRequired
        }),
        seasonDefaults: _propTypes2.default.shape({
            seasonRaceType: _propTypes2.default.string.isRequired
        })
    }).isRequired,
    params: _propTypes2.default.shape({
        id: _propTypes2.default.string.isRequired
    }).isRequired
};

exports.default = Favourites;

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx("tr", {}, void 0, _jsx("th", {}), _jsx("th", {
    className: "cp-favourites__specialCell hidden-sm-up",
    colSpan: "2"
}, void 0, "non handicap"), _jsx("th", {
    className: "cp-favourites__specialCell hidden-sm-up",
    colSpan: "2"
}, void 0, "handicap"), _jsx("th", {
    className: "cp-favourites__specialCell hidden-xs-down",
    colSpan: "4"
}, void 0, "non handicap"), _jsx("th", {
    className: "cp-favourites__specialCell hidden-xs-down",
    colSpan: "4"
}, void 0, "handicap"));

var HeaderRow = function HeaderRow() {
    return _ref;
};

exports.default = HeaderRow;

/***/ }),
/* 1095 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _name = __webpack_require__(231);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var handicapColumns = function handicapColumns(prefix) {
    return [{
        key: prefix + 'wins',
        header: 'wins'
    }, {
        key: prefix + 'runs',
        header: 'runs'
    }, {
        key: prefix + 'percentage',
        header: '%'
    }, {
        key: prefix + 'stake',
        header: '£1 stake'
    }];
};

var _ref = _jsx(_Abbr2.default, {
    title: 'by favourites'
}, void 0, 'fav');

var columns = [{
    key: 'raceName',
    header: function header() {
        return _ref;
    },
    sortFn: (0, _name.sortByRaceName)('raceName')
}].concat(_toConsumableArray(handicapColumns('nh_')), _toConsumableArray(handicapColumns('')));

exports.default = columns;

/***/ }),
/* 1096 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(606);

var timePeriodReducer = function timePeriodReducer(timePeriod, action) {
    var _timePeriod$createdBy = timePeriod.createdBy,
        raceType = _timePeriod$createdBy.raceType,
        countryCode = _timePeriod$createdBy.countryCode;


    if (action.type === 'raceType' && raceType !== action.value) {
        return (0, _categories.timePeriodFactory)(action.value, countryCode);
    }

    return timePeriod;
};

var categoriesReducer = function categoriesReducer(_ref, action) {
    var raceType = _ref.raceType,
        timePeriod = _ref.timePeriod;
    return {
        raceType: raceType,
        timePeriod: timePeriodReducer(timePeriod, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpGuiGuide = __webpack_require__(126);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NameRow = function NameRow(_ref) {
    var _ref$profile = _ref.profile,
        courseStyleName = _ref$profile.courseStyleName,
        courseClerk = _ref$profile.courseClerk,
        courseTel = _ref$profile.courseTel;
    return _jsx('div', {
        className: 'cp-nameRow'
    }, void 0, _jsx('h1', {
        className: 'cp-nameRow__name'
    }, void 0, courseStyleName), courseClerk && _jsx('div', {}, void 0, 'Clerk of the course\xA0', _jsx('span', {
        className: 'cp-nameRow__data'
    }, void 0, courseClerk)), courseTel && _jsx('div', {}, void 0, 'Racecourse contact\xA0', _rpGuiGuide.mobileDetect.isPhone() ? _jsx('a', {
        href: 'tel: ' + courseTel,
        className: 'ui-link cp-nameRow__data'
    }, void 0, courseTel) : _jsx('span', {
        className: 'cp-nameRow__data'
    }, void 0, courseTel)));
};

exports.default = NameRow;

/***/ }),
/* 1098 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _columns = __webpack_require__(1099);

var _columns2 = _interopRequireDefault(_columns);

var _date = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('h2', {
    className: 'cp-raceDays__title'
}, void 0, 'Upcoming Racedays');

var RaceDays = function (_PureComponent) {
    _inherits(RaceDays, _PureComponent);

    function RaceDays(props) {
        _classCallCheck(this, RaceDays);

        var _this = _possibleConstructorReturn(this, (RaceDays.__proto__ || Object.getPrototypeOf(RaceDays)).call(this, props));

        _this.toggle = function () {
            _this.setState({
                expanded: !_this.state.expanded
            });
        };

        _this.state = {
            expanded: false,
            data: props.data.sort((0, _date.sortByDate)('raceDate', true))
        };
        return _this;
    }

    _createClass(RaceDays, [{
        key: 'render',
        value: function render() {
            var _props$params = this.props.params,
                name = _props$params.name,
                id = _props$params.id;
            var _state = this.state,
                expanded = _state.expanded,
                data = _state.data;

            var slicedData = expanded ? data : data.slice(0, 5);
            var iconName = expanded ? 'up' : 'down';

            return _jsx('div', {
                className: 'cp-raceDays'
            }, void 0, _ref, _jsx(_rpReactTable2.default, {
                data: slicedData,
                columns: (0, _columns2.default)(name, id),
                uiType: 5,
                noDataText: 'No upcoming racedays'
            }), data && data.length > 5 && _jsx('button', {
                className: 'ui-btn',
                onClick: this.toggle
            }, void 0, _jsx(_rpReactSvgIcon2.default, {
                iconName: iconName,
                size: 'Medium'
            }, iconName)));
        }
    }]);

    return RaceDays;
}(_react.PureComponent);

exports.default = RaceDays;

/***/ }),
/* 1099 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _RaceDayLink = __webpack_require__(1249);

var _RaceDayLink2 = _interopRequireDefault(_RaceDayLink);

var _date = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = function columns(name, id) {
    return [{
        key: 'raceDate',
        header: 'date',
        cell: function cell(_ref) {
            var raceDate = _ref.raceDate;
            return _jsx(_RaceDayLink2.default, {
                courseName: name,
                courseUid: +id,
                raceDate: raceDate
            }, void 0, _jsx('span', {
                className: 'hidden-sm-up'
            }, void 0, (0, _date.formatDate)(raceDate, 'DDMMMYY')), _jsx('span', {
                className: 'hidden-xs-down'
            }, void 0, (0, _date.formatDate)(raceDate, 'dddd, D MMMM Y')));
        }
    }, {
        key: 'raceDatetimeFirst',
        header: 'first race',
        cell: function cell(_ref2) {
            var raceDatetimeFirst = _ref2.raceDatetimeFirst;
            return (0, _date.formatDate)(raceDatetimeFirst, 'h:mm');
        }
    }, {
        key: 'raceDatetimeLast',
        header: 'last race',
        cell: function cell(_ref3) {
            var raceDatetimeLast = _ref3.raceDatetimeLast;
            return (0, _date.formatDate)(raceDatetimeLast, 'h:mm');
        }
    }, {
        key: '',
        header: ' ',
        cell: function cell() {
            return null;
        }
    }];
};

exports.default = columns;

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Filter = __webpack_require__(142);

var _Filter2 = _interopRequireDefault(_Filter);

var _columns = __webpack_require__(1101);

var _columns2 = _interopRequireDefault(_columns);

var _filter = __webpack_require__(144);

var _filter2 = _interopRequireDefault(_filter);

var _categories = __webpack_require__(607);

var _categories2 = _interopRequireDefault(_categories);

var _reducer = __webpack_require__(1102);

var _reducer2 = _interopRequireDefault(_reducer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Results = function (_FilteringComponent) {
    _inherits(Results, _FilteringComponent);

    function Results(props) {
        _classCallCheck(this, Results);

        var _this = _possibleConstructorReturn(this, (Results.__proto__ || Object.getPrototypeOf(Results)).call(this, props));

        var _props$data = props.data,
            seasonInfo = _props$data.seasonInfo,
            seasonsAvailable = _props$data.seasonsAvailable,
            courseTypeCode = _props$data.profile.courseTypeCode,
            principleRaceResults = _props$data.principleRaceResults;
        var coursePrincipalSeason = seasonInfo.coursePrincipalSeason,
            raceType = seasonInfo.raceType,
            raceStatusType = seasonInfo.raceStatusType;


        _this.state = {
            data: principleRaceResults,
            categories: (0, _categories2.default)(raceStatusType, courseTypeCode, raceType, coursePrincipalSeason, seasonsAvailable),
            loading: false,
            fetchError: false
        };

        var _this$props$params = _this.props.params,
            name = _this$props$params.name,
            id = _this$props$params.id;

        _this.columns = (0, _columns2.default)(name, id);

        // key for getting info from API request
        _this.dataKey = 'principleRaceResults';
        return _this;
    }

    _createClass(Results, [{
        key: 'renderDefaultStatus',
        value: function renderDefaultStatus() {
            var _props$data$seasonInf = this.props.data.seasonInfo,
                raceStatusType = _props$data$seasonInf.raceStatusType,
                raceType = _props$data$seasonInf.raceType,
                year = _props$data$seasonInf.coursePrincipalSeason;


            var years = raceType === 'jumps' ? year + '-' + (year + 1) : year;
            var raceStatus = raceStatusType === 'big-race' ? 'Big races' : 'All races';

            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, raceStatus, ', ', raceType, ', ', years);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                data = _state.data,
                categories = _state.categories,
                loading = _state.loading,
                fetchError = _state.fetchError;


            return _jsx('section', {
                className: 'cp-results'
            }, void 0, _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _reducer2.default,
                columns: this.columns,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                columns: this.columns,
                data: data,
                loading: loading,
                initialSortIdx: 0,
                noDataText: 'No results found'
            }));
        }
    }]);

    return Results;
}(_filter2.default);

Results.propTypes = {
    data: _propTypes2.default.shape({
        seasonInfo: _propTypes2.default.shape({
            coursePrincipalSeason: _propTypes2.default.number,
            raceStatusType: _propTypes2.default.string,
            raceType: _propTypes2.default.string
        }),
        principleRaceResults: _propTypes2.default.arrayOf(_propTypes2.default.shape({
            horseStyleName: _propTypes2.default.string,
            horseUid: _propTypes2.default.number,
            prizeSterling: _propTypes2.default.number,
            raceDatetime: _propTypes2.default.string,
            raceInstanceTitle: _propTypes2.default.string,
            raceInstanceUid: _propTypes2.default.number,
            trainerStyleName: _propTypes2.default.string,
            trainerUid: _propTypes2.default.number
        }))
    }).isRequired,
    params: _propTypes2.default.shape({
        name: _propTypes2.default.string.isRequired,
        id: _propTypes2.default.string.isRequired
    }).isRequired
};

exports.default = Results;

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(26);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _date = __webpack_require__(18);

var _money = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = function columns(name, id) {
    return [{
        key: 'raceDatetime',
        header: 'date',
        sortFn: (0, _date.sortByDate)('raceDatetime'),
        cell: function cell(_ref) {
            var raceDatetime = _ref.raceDatetime;
            return (0, _date.formatDate)(raceDatetime, 'DDMMMYY');
        }
    }, {
        key: 'raceInstanceUid',
        header: 'race name',
        cell: function cell(row) {
            return _react2.default.createElement(_ResultLink2.default, _extends({}, row, {
                courseName: name,
                courseUid: +id
            }));
        }
    }, {
        key: 'horseUid',
        header: 'winner',
        cell: _ProfileLink.HorseLink
    }, {
        key: 'trainerUid',
        header: 'trainer',
        cell: _ProfileLink.TrainerLink
    }, {
        key: 'prizeSterling',
        header: 'winnings',
        cell: function cell(_ref2) {
            var prizeSterling = _ref2.prizeSterling;
            return (0, _money.formatMoney)(prizeSterling);
        }
    }];
};

exports.default = columns;

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(607);

var timePeriodReducer = function timePeriodReducer(timePeriod, action) {
    var _timePeriod$createdBy = timePeriod.createdBy,
        raceType = _timePeriod$createdBy.raceType,
        principalSeason = _timePeriod$createdBy.principalSeason,
        seasonsAvailable = _timePeriod$createdBy.seasonsAvailable;


    if (action.type === 'raceType' && raceType !== action.value) {
        return (0, _categories.timePeriodFactory)(action.value, principalSeason, seasonsAvailable);
    }

    return timePeriod;
};

var categoriesReducer = function categoriesReducer(_ref, action) {
    var raceCategory = _ref.raceCategory,
        raceType = _ref.raceType,
        timePeriod = _ref.timePeriod;
    return {
        raceCategory: raceCategory,
        raceType: raceType,
        timePeriod: timePeriodReducer(timePeriod, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _axios = __webpack_require__(127);

var _axios2 = _interopRequireDefault(_axios);

var _columns = __webpack_require__(1107);

var _columns2 = _interopRequireDefault(_columns);

var _Select = __webpack_require__(402);

var _Select2 = _interopRequireDefault(_Select);

var _date = __webpack_require__(18);

var _transformData = __webpack_require__(1108);

var _transformData2 = _interopRequireDefault(_transformData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var travelersCheckTable = 'travelersCheck';
var tableKeys = ['travelersCheck', 'firstTimeBlinkers', 'sevenDayWinners'];
var tableHeaders = ['Travellers\' Check', 'First Time Blinkers', 'Seven-Day Winners'];

var _ref2 = _jsx('strong', {}, void 0, 'Meeting');

var _ref3 = _jsx(_rpReactTable.Loading, {});

var Signposts = function (_PureComponent) {
    _inherits(Signposts, _PureComponent);

    function Signposts(props) {
        _classCallCheck(this, Signposts);

        var _this = _possibleConstructorReturn(this, (Signposts.__proto__ || Object.getPrototypeOf(Signposts)).call(this, props));

        _this.onSelect = function (val) {
            if (_this.state.selectValue === +val) {
                return;
            }
            _this.fetchData(+val);
        };

        var dates = (props.data.upcomingRaces || []).sort((0, _date.sortByDate)('raceDate', true)).map(function (item) {
            return item.raceDate;
        });
        _this.state = {
            signposts: props.data.signposts,
            optionDates: dates.map(function (date) {
                return (0, _date.formatDate)(date, 'dddd, DD MMM Y');
            }),
            urlDates: dates.map(function (date) {
                return (0, _date.formatDate)(date, 'Y-MM-DD');
            }),
            selectValue: 0,
            loading: false
        };
        return _this;
    }

    _createClass(Signposts, [{
        key: 'fetchData',
        value: function fetchData(selectValue) {
            var _this2 = this;

            this.setState({ selectValue: selectValue, loading: true });

            var id = this.props.params.id;

            var urlDate = this.state.urlDates[selectValue];
            _axios2.default.get('course/filter/signposts/' + id + '/' + urlDate).then(function (_ref) {
                var data = _ref.data;

                _this2.setState({
                    loading: false,
                    signposts: data.signposts
                });
            }).catch(function (error) {
                return console.warn(error);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                signposts = _state.signposts,
                optionDates = _state.optionDates,
                loading = _state.loading,
                selectValue = _state.selectValue;
            var params = this.props.params;

            var transSignposts = (0, _transformData2.default)(signposts, params);
            var transformTravelersCheck = transSignposts.travelersCheck.map(function (post) {
                var updatedPost = _extends({}, post);
                if (post.miles === 0 && isNaN(parseFloat(post.distOut))) {
                    updatedPost.miles = post.distOut;
                }

                return updatedPost;
            });

            var transformSignpostData = _extends({}, transSignposts, {
                travelersCheck: transformTravelersCheck
            });

            return _jsx('section', {
                className: 'cp-signposts'
            }, void 0, optionDates.length > 1 && _jsx('div', {
                className: 'cp-signposts__dropdown'
            }, void 0, _ref2, _jsx(_Select2.default, {
                value: selectValue,
                options: optionDates,
                onSelect: this.onSelect
            })), loading ? _ref3 : tableKeys.map(function (key, i) {
                return _jsx('div', {
                    className: 'cp-signposts__' + key
                }, key, _jsx('h3', {}, void 0, tableHeaders[i]), _jsx(_rpReactTable2.default, {
                    columns: _columns2.default[key],
                    data: transformSignpostData[key],
                    sortable: key === travelersCheckTable,
                    initialSortIdx: key === travelersCheckTable ? 3 : 1,
                    noDataText: 'No ' + tableHeaders[i] + ' data available\n                                for this meeting in the Racing Post database'
                }));
            }));
        }
    }]);

    return Signposts;
}(_react.PureComponent);

var columnPropsShape = {
    horseStyleName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    raceDatetime: _propTypes2.default.string
};

exports.default = Signposts;

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(18);

var _RaceCardLink = __webpack_require__(297);

var _RaceCardLink2 = _interopRequireDefault(_RaceCardLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TravellersRaceCell = function TravellersRaceCell(props) {
    return _react2.default.createElement(
        _RaceCardLink2.default,
        props,
        (0, _date.formatDate)(props.raceDatetime, 'h:mm')
    );
};

exports.default = TravellersRaceCell;

/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(18);

var _RaceCardLink = __webpack_require__(297);

var _RaceCardLink2 = _interopRequireDefault(_RaceCardLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UpcomingRaceCell = function UpcomingRaceCell(_ref) {
    var upcomingRace = _ref.upcomingRace;
    return _react2.default.createElement(
        _RaceCardLink2.default,
        upcomingRace,
        (0, _date.formatDate)(upcomingRace.raceDatetime, 'h:mm')
    );
};

exports.default = UpcomingRaceCell;

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _date = __webpack_require__(18);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Last cell for Seven-Day Winners table on Signposts Tab
 */
var WonCell = function WonCell(_ref) {
    var courseStyleName = _ref.courseStyleName,
        courseUid = _ref.courseUid,
        raceDatetime = _ref.raceDatetime,
        raceInstanceUid = _ref.raceInstanceUid,
        raceInstanceTitle = _ref.raceInstanceTitle;
    return _jsx('span', {}, void 0, courseStyleName, '\xA0', _jsx(_ResultLink2.default, {
        courseUid: courseUid,
        courseName: courseStyleName,
        raceDatetime: raceDatetime,
        raceInstanceUid: raceInstanceUid,
        raceInstanceTitle: raceInstanceTitle
    }, void 0, (0, _date.formatDate)(raceDatetime, 'h:mm')), '\xA0', (0, _date.formatDate)(raceDatetime, 'DDMMMYY'));
};

exports.default = WonCell;

/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ProfileLink = __webpack_require__(26);

var _WonCell = __webpack_require__(1106);

var _WonCell2 = _interopRequireDefault(_WonCell);

var _date = __webpack_require__(18);

var _UpcomingRaceCell = __webpack_require__(1105);

var _UpcomingRaceCell2 = _interopRequireDefault(_UpcomingRaceCell);

var _TravellersRaceCell = __webpack_require__(1104);

var _TravellersRaceCell2 = _interopRequireDefault(_TravellersRaceCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var horseCol = {
    key: 'horseStyleName',
    header: 'horse',
    cell: _ProfileLink.HorseLink,
    sortFn: 'alphabetic'
};

var timeCol = {
    key: 'raceDatetime',
    header: 'race',
    cell: _TravellersRaceCell2.default,
    sortFn: (0, _date.sortByDate)('raceDatetime', true)
};

var trainerCol = {
    key: 'trainerStyleName',
    header: 'trainer',
    cell: _ProfileLink.TrainerLink,
    sortFn: 'byLastName'
};

var milesCol = { key: 'miles' };

var timeCol2 = {
    key: 'upcomingRace',
    header: 'race',
    cell: _UpcomingRaceCell2.default,
    sortFn: (0, _date.sortByDate)('upcomingRace.raceDatetime', true)
};

var wonCol = {
    key: 'raceInstanceUid',
    header: 'race won',
    cell: _WonCell2.default
};

exports.default = {
    travelersCheck: [horseCol, trainerCol, timeCol, milesCol],
    firstTimeBlinkers: [horseCol, timeCol],
    sevenDayWinners: [horseCol, timeCol2, wonCol]
};

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var transformData = function transformData(data, params) {
    var transformedData = {
        travelersCheck: [],
        firstTimeBlinkers: [],
        sevenDayWinners: []
    };

    if (!data) {
        return transformedData;
    }

    Object.keys(transformedData).forEach(function (key) {
        transformedData[key] = Array.isArray(data[key]) ? data[key] : transformedData[key];
    });

    var sevenDayWinners = transformedData.sevenDayWinners,
        firstTimeBlinkers = transformedData.firstTimeBlinkers,
        travelersCheck = transformedData.travelersCheck;


    return {
        firstTimeBlinkers: firstTimeBlinkers.map(function (firstTimeBlinker) {
            return _extends({}, firstTimeBlinker, {
                courseUid: +params.id,
                courseName: params.name
            });
        }),
        travelersCheck: travelersCheck.map(function (traveller) {
            return _extends({}, traveller, {
                courseName: params.name
            });
        }),
        sevenDayWinners: sevenDayWinners.map(function (winner) {
            return _extends({}, winner, {
                upcomingRace: _extends({}, winner.upcomingRace, {
                    courseUid: +params.id,
                    courseName: params.name
                })
            });
        })
    };
};

exports.default = transformData;

/***/ }),
/* 1109 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _lodash = __webpack_require__(9);

var _Filter = __webpack_require__(142);

var _Filter2 = _interopRequireDefault(_Filter);

var _columns = __webpack_require__(1110);

var _columns2 = _interopRequireDefault(_columns);

var _categories = __webpack_require__(608);

var _reducer = __webpack_require__(1111);

var _reducer2 = _interopRequireDefault(_reducer);

var _filter = __webpack_require__(144);

var _filter2 = _interopRequireDefault(_filter);

var _filter3 = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dataKeys = ['topJockeys', 'topTrainers', 'topHorses', 'topOwners'];

var _ref = _jsx(_rpReactTable.Loading, {});

var Stats = function (_FilteringComponent) {
    _inherits(Stats, _FilteringComponent);

    function Stats(props) {
        _classCallCheck(this, Stats);

        var _this = _possibleConstructorReturn(this, (Stats.__proto__ || Object.getPrototypeOf(Stats)).call(this, props));

        _this.dataKey = 'statistics';
        _this.emptyData = {};
        _this.tab = 'stats';

        var _props$data = props.data,
            _props$data$profile = _props$data.profile,
            courseTypeCode = _props$data$profile.courseTypeCode,
            courseCountryCode = _props$data$profile.courseCountryCode,
            raceType = _props$data.seasonInfo.raceType,
            statistics = _props$data.statistics,
            seasonsAvailable = _props$data.seasonsAvailable;


        var categories = (0, _categories.categoriesFactory)(courseTypeCode, courseCountryCode, raceType, seasonsAvailable);

        _this.state = {
            data: statistics || _this.emptyData,
            categories: categories,
            fetchError: false
        };
        return _this;
    }

    _createClass(Stats, [{
        key: 'renderStatus',
        value: function renderStatus() {
            var categories = this.state.categories;

            var raceType = _filter3.selection.getCaption(categories, 'raceType');

            var _selection$getOption = _filter3.selection.getOption(categories, 'timePeriod'),
                value = _selection$getOption.value,
                label = _selection$getOption.label;

            if (value.match(/last5/)) {
                return _jsx('h2', {
                    className: 'ui-filter__statusText'
                }, void 0, raceType, ', ', (0, _lodash.toLower)(label));
            }

            var years = (0, _lodash.uniq)(value.split('/').slice(0, 2));
            if (years.length > 1) {
                years[1] = years[1].slice(2);
            }
            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, raceType, ', ', years.join('-'));
        }
    }, {
        key: 'renderDefaultStatus',
        value: function renderDefaultStatus() {
            var _props$data$stats$sea = this.props.data.stats.seasonInfo,
                raceType = _props$data$stats$sea.raceType,
                seasonYearBegin = _props$data$stats$sea.seasonYearBegin,
                seasonYearEnd = _props$data$stats$sea.seasonYearEnd;

            var years = seasonYearBegin === seasonYearEnd ? seasonYearBegin : seasonYearBegin + '-' + seasonYearEnd;

            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, (0, _lodash.capitalize)(raceType), ', ', years);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                loading = _state.loading,
                data = _state.data,
                categories = _state.categories,
                fetchError = _state.fetchError;


            return _jsx('section', {
                className: 'cp-stats'
            }, void 0, _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _reducer2.default,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && (!loading ? _jsx('div', {
                className: 'cp-stats__tablesWrapper'
            }, void 0, dataKeys.map(function (dataKey) {
                return _jsx(_rpReactTable2.default, {
                    data: data[dataKey],
                    columns: _columns2.default[dataKey],
                    noDataText: 'No stats found',
                    className: 'cp-stats__table_' + (dataKey === 'topHorses' ? 'horse' : 'human')
                }, dataKey);
            })) : _ref));
        }
    }]);

    return Stats;
}(_filter2.default);

var genericRow = {
    wins: _propTypes2.default.number,
    runs: _propTypes2.default.number,
    stake: _propTypes2.default.number,
    styleName: _propTypes2.default.string,
    winPercent: _propTypes2.default.number
};

Stats.propTypes = {
    data: _propTypes2.default.shape({
        seasonInfo: _propTypes2.default.shape({
            seasonYearBegin: _propTypes2.default.number,
            seasonYearEnd: _propTypes2.default.number,
            raceType: _propTypes2.default.string
        }),
        stats: _propTypes2.default.shape({
            statistics: _propTypes2.default.shape({
                topJockeys: _propTypes2.default.arrayOf(_propTypes2.default.shape(genericRow)),
                topTrainers: _propTypes2.default.arrayOf(_propTypes2.default.shape(genericRow)),
                topHorses: _propTypes2.default.arrayOf(_propTypes2.default.shape(_extends({}, genericRow, {
                    trainerName: _propTypes2.default.string,
                    topRpr: _propTypes2.default.number
                }))),
                topOwners: _propTypes2.default.arrayOf(_propTypes2.default.shape(genericRow))
            })
        }),
        profile: _propTypes2.default.shape({
            courseCountryCode: _propTypes2.default.string
        })
    }),
    params: _propTypes2.default.shape({
        id: _propTypes2.default.string
    })
};

exports.default = Stats;

/***/ }),
/* 1110 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _ProfileLink = __webpack_require__(26);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

var _StakeCell = __webpack_require__(296);

var _StakeCell2 = _interopRequireDefault(_StakeCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; } /* eslint react/prop-types: 0 */


var humanColumnsFactory = function humanColumnsFactory(type) {
    return [{
        key: 'styleName',
        header: 'Top ' + type,
        cell: function cell(row) {
            var StaffLink = _ProfileLink2.default[type];
            var nameProp = _defineProperty({}, type + 'StyleName', row.styleName);
            return _react2.default.createElement(StaffLink, _extends({}, row, nameProp));
        }
    }, {
        key: 'wins',
        header: 'wins-' + (type === 'jockey' ? 'rides' : 'runs'),
        cell: function cell(_ref) {
            var wins = _ref.wins,
                runs = _ref.runs;
            return wins + '-' + runs;
        }
    }, {
        key: 'winPercent',
        header: '%'
    }, {
        key: 'stake',
        header: '£1 stake',
        cell: _StakeCell2.default
    }];
};

var horse = [{
    key: 'styleName',
    header: 'Course Specialist',
    cell: function cell(_ref2) {
        var horseUid = _ref2.horseUid,
            styleName = _ref2.styleName;
        return _jsx(_ProfileLink.HorseLink, {
            horseStyleName: styleName,
            horseUid: horseUid
        });
    }
}, {
    key: 'wins',
    header: 'wins-runs',
    cell: function cell(_ref3) {
        var wins = _ref3.wins,
            runs = _ref3.runs;
        return wins + '-' + runs;
    }
}, {
    key: 'winPercent',
    header: '%'
}, {
    key: 'trainerName',
    header: 'Trainer',
    cell: function cell(_ref4) {
        var trainerUid = _ref4.trainerUid,
            trainerName = _ref4.trainerName;
        return _jsx(_ProfileLink.TrainerLink, {
            trainerStyleName: trainerName,
            trainerUid: trainerUid
        });
    }
}, {
    key: 'topRpr',
    header: 'Best Course RPR'
}, {
    key: 'stake',
    header: '£1 stake',
    cell: _StakeCell2.default
}];

exports.default = {
    topJockeys: humanColumnsFactory('jockey'),
    topTrainers: humanColumnsFactory('trainer'),
    topHorses: horse,
    topOwners: humanColumnsFactory('owner')
};

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _categories = __webpack_require__(608);

var getRaceType = function getRaceType(val) {
    return val.match(/jumps|flat/)[0];
};

var timePeriodReducer = function timePeriodReducer(timePeriod, action) {
    var _timePeriod$createdBy = timePeriod.createdBy,
        raceType = _timePeriod$createdBy.raceType,
        seasonsAvailable = _timePeriod$createdBy.seasonsAvailable,
        country = _timePeriod$createdBy.country;

    if (action.type === 'raceType') {
        var newRaceType = getRaceType(action.value);
        if (raceType !== newRaceType) {
            return (0, _categories.timePeriodsFactory)(country, newRaceType, seasonsAvailable);
        }
    }
    return timePeriod;
};

var categoriesReducer = function categoriesReducer(categories, action) {
    return _extends({}, categories, {
        timePeriod: timePeriodReducer(categories.timePeriod, action)
    });
};

exports.default = categoriesReducer;

/***/ }),
/* 1112 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getTabName = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _NameRow = __webpack_require__(1144);

var _NameRow2 = _interopRequireDefault(_NameRow);

var _Nav = __webpack_require__(405);

var _Nav2 = _interopRequireDefault(_Nav);

var _DeclaredBox = __webpack_require__(1116);

var _DeclaredBox2 = _interopRequireDefault(_DeclaredBox);

var _Details = __webpack_require__(1118);

var _Details2 = _interopRequireDefault(_Details);

var _horse = __webpack_require__(161);

var _MetaData = __webpack_require__(404);

var _MetaData2 = _interopRequireDefault(_MetaData);

var _BestOdds = __webpack_require__(630);

var _BestOdds2 = _interopRequireDefault(_BestOdds);

var _bloodstockLogoString = __webpack_require__(1115);

var _bloodstockLogoString2 = _interopRequireDefault(_bloodstockLogoString);

var _tabNames = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getTabName = exports.getTabName = function getTabName(_ref, _ref2) {
    var tab = _ref.tab,
        subTab = _ref.subTab;
    var sireStatus = _ref2.sireStatus,
        damStatus = _ref2.damStatus,
        weatherbysUid = _ref2.weatherbysUid;

    if (subTab) {
        return subTab;
    }

    if (tab) {
        return tab;
    }

    if (!sireStatus && !damStatus) {
        return 'form';
    }

    if (sireStatus && weatherbysUid) {
        return 'weatherbys-overview';
    }

    return 'progeny';
};

var HorsePage = function (_React$Component) {
    _inherits(HorsePage, _React$Component);

    function HorsePage(props) {
        _classCallCheck(this, HorsePage);

        var _this = _possibleConstructorReturn(this, (HorsePage.__proto__ || Object.getPrototypeOf(HorsePage)).call(this, props));

        _this.onSubnavMenuExpand = function () {
            _this.setState(_extends({}, _this.state, {
                isSubnavMenuExpanded: true
            }));
        };

        _this.isMobile = function () {
            var isMobile = window.innerWidth < 720;
            return isMobile;
        };

        _this.resize = function () {
            var isMobile = _this.isMobile();

            _this.setState(_extends({}, _this.state, {
                isMobile: isMobile
            }));

            localStorage.setItem('isMobile', '' + isMobile);

            var screenResizedEvt = new CustomEvent('screen-resized', {
                detail: isMobile
            });

            window.dispatchEvent(screenResizedEvt);
        };

        _this.showMyRatings = function () {
            _this.setState({ isMyRatingShown: true });
        };

        _this.hideMyRatings = function () {
            _this.setState({ isMyRatingShown: false });
        };

        _this.showMyRatings = _this.showMyRatings;
        _this.hideMyRatings = _this.hideMyRatings;

        _this.state = {
            isMyRatingShown: props.params.subTab === 'my-ratings',
            isMobile: _this.isMobile()
        };
        return _this;
    }

    _createClass(HorsePage, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('resize', this.resize);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.resize);
        }
    }, {
        key: 'checkSireStatus',
        value: function checkSireStatus() {
            var isInserted = document.querySelector('.hp-details__pinkToRedLine');
            if (isInserted) return;

            var sireStatus = this.props.data.profile.sireStatus;


            if (sireStatus) {
                var logoWrap = document.querySelector('.rn-menuBar__logo__wrp');
                var menuBar = document.querySelector('.rn-menuBar');

                logoWrap.innerHTML = _bloodstockLogoString2.default;
                menuBar.style.borderTop = '0';
                menuBar.style.borderLeft = '0';
                menuBar.style.borderRight = '0';
                menuBar.style.borderBottom = '3px solid';
                menuBar.style.borderImageSource = 'linear-gradient(to right, #d674ad, #eb212e)';
                menuBar.style.borderImageSlice = '1';
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _props = this.props,
                data = _props.data,
                children = _props.children,
                params = _props.params,
                userRole = _props.userRole,
                pageName = _props.pageName,
                hasAccess = _props.hasAccess;
            var _data$externalLinks = data.externalLinks,
                helpCenterUrl = _data$externalLinks.helpCenterUrl,
                imagesUrl = _data$externalLinks.imagesUrl,
                profile = data.profile,
                entries = data.entries,
                quotes = data.quotes,
                skybetDiffusionName = data.skybetDiffusionName;


            this.checkSireStatus();

            var weatherbysUid = profile.weatherbysUid,
                sireStatus = profile.sireStatus,
                comments = profile.comments,
                horseName = profile.horseName;
            var _state = this.state,
                isMobile = _state.isMobile,
                isSubnavMenuExpanded = _state.isSubnavMenuExpanded;

            var tabPage = getTabName(params, profile);
            var tabsToExclude = [(!weatherbysUid || !sireStatus) && 'stallionDetails', (0, _horse.hasProgeny)(profile) && (0, _lodash.isEmpty)(entries) && 'entries', (0, _lodash.isEmpty)(quotes) && 'quotes'];

            params.mr = {
                show: this.showMyRatings,
                hide: this.hideMyRatings,
                isShown: this.state.isMyRatingShown
            };

            return _jsx('div', {
                className: weatherbysUid && _tabNames.sireSubTabs.stallionDetails.includes(tabPage) ? 'weatherbys__wrapper' : ''
            }, void 0, _jsx(_MetaData2.default, {
                type: params.type,
                page: tabPage,
                profile: profile
            }), _jsx('section', {}, void 0, _jsx(_NameRow2.default, {
                profile: profile,
                params: params,
                imagesHost: imagesUrl,
                isMobile: isMobile,
                isWeatherbysSire: !!(sireStatus && weatherbysUid)
            }), _react2.default.createElement(_Details2.default, _extends({}, profile, { isMobile: isMobile
            })), _jsx(_DeclaredBox2.default, {
                horseName: horseName,
                entries: entries || [],
                comments: comments || []
            }), _jsx(_BestOdds2.default, {
                skybetDiffusionName: skybetDiffusionName
            })), _jsx(_Nav2.default, {
                params: params,
                userRole: userRole,
                pageName: pageName,
                horseType: (0, _horse.getHorseType)(profile),
                helpUrl: helpCenterUrl,
                tabsToExclude: tabsToExclude,
                isMobile: isMobile,
                isSubnavMenuExpanded: isSubnavMenuExpanded,
                onSubnavMenuExpand: this.onSubnavMenuExpand
            }), (0, _react.cloneElement)(children, { data: data, params: params, isMobile: isMobile, hasAccess: hasAccess }));
        }
    }]);

    return HorsePage;
}(_react2.default.Component);

exports.default = HorsePage;

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TabFetchProvider = __webpack_require__(298);

var _TabFetchProvider2 = _interopRequireDefault(_TabFetchProvider);

var _Form = __webpack_require__(610);

var _Form2 = _interopRequireDefault(_Form);

var _Progeny = __webpack_require__(614);

var _Progeny2 = _interopRequireDefault(_Progeny);

var _horse = __webpack_require__(161);

var _WeatherbysOverview = __webpack_require__(619);

var _WeatherbysOverview2 = _interopRequireDefault(_WeatherbysOverview);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = {
    form: {
        Tab: _Form2.default,
        fetchPath: 'form'
    },
    progeny: {
        Tab: _Progeny2.default,
        fetchPath: 'progeny'
    },
    weatherbysOverview: {
        Tab: _WeatherbysOverview2.default,
        fetchPath: 'weatherbys-overview'
    }
};

var IndexTab = function IndexTab(props) {
    var profile = props.data.profile;


    if (profile.weatherbysUid) {
        var _route = routes.weatherbysOverview;
        return _react2.default.createElement(_TabFetchProvider2.default, _extends({}, props, { route: _route }));
    }

    var route = (0, _horse.hasProgeny)(profile) ? routes.progeny : routes.form;
    return _react2.default.createElement(_TabFetchProvider2.default, _extends({}, props, { route: route }));
};

IndexTab.displayName = 'IndexTab';

exports.default = IndexTab;

/***/ }),
/* 1114 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/no-danger: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CopyrightWeatherby = __webpack_require__(403);

var _CopyrightWeatherby2 = _interopRequireDefault(_CopyrightWeatherby);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('section', {
    className: 'hp-bestProgeny__container--text-center'
}, void 0, 'No progeny information for this sire is available', _jsx(_CopyrightWeatherby2.default, {}));

var _ref2 = _jsx(_CopyrightWeatherby2.default, {});

var BestProgeny = function BestProgeny(props) {
    var data = props.data.data;


    if (!data || !data.bestProgenyHTMLflat || Array.isArray(data.bestProgenyHTMLflat) && !data.bestProgenyHTMLflat.length) {
        return _ref;
    }

    var bestProgenyHTMLflat = data.bestProgenyHTMLflat;


    return _jsx('div', {}, void 0, _jsx('section', {
        className: 'hp-bestProgeny__container',
        dangerouslySetInnerHTML: { __html: bestProgenyHTMLflat }
    }), _ref2);
};

exports.default = BestProgeny;

/***/ }),
/* 1115 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var url = window.location.host;
var bloodstockLogoString = '<a href="https://' + url + '/bloodstock" class="rn-menuBar__logo__link"' + 'title="Racing Post Home" data-test-selector="link-navigationRpLogo">' + '<svg class="rn-menuBar__logo__img" viewBox="92.88178217821783 220.25359999999998 670.4159405940594 146.43887999999998"' + ' version="1.1" xmlns="http://www.w3.org/2000/svg">' + '  <defs>' + '    <style>' + '      .cls-1 {' + '        fill: #eb84c9;' + '      }' + '      .cls-2 {' + '        fill: #e30913;' + '      }' + '    </style>' + '  </defs>' + '  <g>' + '    <g id="Layer_1">' + '      <path d="M753.62,363.36l-22.25-31.3,21.18-26.18h-22.13l-17.49,22.97v-44.86h-18.33v79.37h18.33v-13.8l5.47-6.55,12.61,20.35h22.61ZM663.9,364.78c12.38,0,20.11-5.59,23.56-10.59l-11.9-11.19c-2.26,3.21-5.95,5.59-10.83,5.59-7.62,0-13.45-5.35-13.45-14.04s5.83-13.92,13.45-13.92c4.88,0,8.57,2.14,10.83,5.47l11.9-11.07c-3.45-5.12-11.19-10.59-23.56-10.59-17.97,0-31.42,12.14-31.42,30.11s13.45,30.23,31.42,30.23M596.43,348.6c-7.97,0-12.38-6.31-12.38-14.04s4.4-13.92,12.38-13.92,12.61,6.31,12.61,13.92-4.52,14.04-12.61,14.04M596.43,364.78c19.75,0,31.42-14.04,31.42-30.23s-11.66-30.11-31.42-30.11-31.3,13.92-31.3,30.11,11.78,30.23,31.3,30.23M549.06,364.78c6.78,0,11.3-1.67,13.57-3.81l-3.57-13.8c-.6.71-2.62,1.43-4.64,1.43-3.21,0-5.12-2.5-5.12-5.83v-20.94h11.66v-15.95h-11.66v-15.71h-18.21v15.71h-9.52v15.95h9.52v26.06c0,11.07,6.31,16.9,17.97,16.9M492.9,364.78c16.54,0,26.18-8.09,26.18-19.04,0-23.56-33.44-17.02-33.44-23.68,0-2.38,2.98-4.17,7.26-4.17,6.9,0,13.45,2.97,16.9,6.31l7.02-12.14c-6.19-4.52-14.4-7.62-24.04-7.62-15.95,0-24.63,8.81-24.63,18.92,0,23.09,33.44,15.71,33.44,23.21,0,2.62-2.26,4.4-7.74,4.4-6.78,0-15.95-3.81-20.23-7.62l-7.62,12.61c6.07,5.35,16.66,8.81,26.89,8.81M429.35,348.6c-7.26,0-12.61-5.47-12.61-14.04s5.35-13.92,12.61-13.92c3.93,0,8.69,2.02,11.07,5.12v17.61c-2.38,3.09-7.14,5.24-11.07,5.24M458.63,363.36v-79.37h-18.21v28.68c-4.64-5.71-10.71-8.21-17.02-8.21-14.4,0-25.47,11.31-25.47,30.11s11.3,30.23,25.47,30.23c6.43,0,12.26-2.62,17.02-8.09v6.66h18.21ZM361.88,348.6c-7.97,0-12.38-6.31-12.38-14.04s4.4-13.92,12.38-13.92,12.61,6.31,12.61,13.92-4.52,14.04-12.61,14.04M361.88,364.78c19.75,0,31.42-14.04,31.42-30.23s-11.66-30.11-31.42-30.11-31.3,13.92-31.3,30.11,11.78,30.23,31.3,30.23M294.53,348.6c-7.97,0-12.38-6.31-12.38-14.04s4.4-13.92,12.38-13.92,12.61,6.31,12.61,13.92-4.52,14.04-12.61,14.04M294.53,364.78c19.75,0,31.42-14.04,31.42-30.23s-11.66-30.11-31.42-30.11-31.3,13.92-31.3,30.11,11.78,30.23,31.3,30.23M254.9,283.98h-18.33v79.37h18.33v-79.37ZM198.38,346.1h-20.59v-14.28h20.59c5,0,7.85,3.21,7.85,7.14,0,4.28-2.97,7.14-7.85,7.14M197.66,314.45h-19.87v-13.21h19.87c4.17,0,7.02,2.74,7.02,6.54s-2.86,6.66-7.02,6.66M203.73,363.36c15.59,0,23.32-10,23.32-21.54,0-10-6.66-18.09-15.11-19.4,7.5-1.67,13.57-8.33,13.57-18.21s-7.5-20.23-23.21-20.23h-44.98v79.37h46.41Z" class="cls-1"/>' + '      <path d="M168.52,269.91h21.73c0-26.08-21.11-47.08-47.08-47.08s-47.08,21.11-47.08,47.08,21.11,47.08,47.08,47.08v-21.73c-13.97,0-25.35-11.38-25.35-25.35s11.38-25.35,25.35-25.35,25.35,11.28,25.35,25.35" class="cls-2"/>' + '    </g>' + '  </g>' + '</svg>' + '</a>';

exports.default = bloodstockLogoString;

/***/ }),
/* 1116 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(18);

var _distance = __webpack_require__(113);

var _Definition = __webpack_require__(143);

var _Definition2 = _interopRequireDefault(_Definition);

var _RaceCardLink = __webpack_require__(297);

var _RaceCardLink2 = _interopRequireDefault(_RaceCardLink);

var _ProfileLink = __webpack_require__(26);

var _PriceButton = __webpack_require__(631);

var _PriceButton2 = _interopRequireDefault(_PriceButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref2 = _jsx('strong', {
    className: 'hp-declared__title'
}, void 0, 'DECLARED');

var DeclaredBox = function (_React$PureComponent) {
    _inherits(DeclaredBox, _React$PureComponent);

    function DeclaredBox(props) {
        _classCallCheck(this, DeclaredBox);

        var _this = _possibleConstructorReturn(this, (DeclaredBox.__proto__ || Object.getPrototypeOf(DeclaredBox)).call(this, props));

        _this.componentDidMount = function () {
            var races = _this.props.entries.filter(function (_ref) {
                var raceStatusCode = _ref.raceStatusCode;
                return raceStatusCode === 'O';
            }).map(function (entry) {
                return _extends({}, entry, {
                    comment: (_this.props.comments.find(function (c) {
                        return c.raceInstanceUid === entry.raceInstanceUid;
                    }) || {}).individualComment
                });
            });

            _this.setState({
                overnightRaces: races
            });
        };

        _this.state = {
            overnightRaces: []
        };
        return _this;
    }

    _createClass(DeclaredBox, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            if (!this.state.overnightRaces.length) {
                return null;
            }
            return _jsx('div', {
                className: 'js-diffusionTopicSettingsRace'
            }, void 0, this.state.overnightRaces.map(function (race) {
                return _jsx('div', {
                    className: 'hp-declared'
                }, race.raceInstanceUid, _jsx('dl', {
                    className: 'hp-declared__box'
                }, void 0, _ref2, _jsx(_Definition2.default, {
                    term: (0, _date.formatEntryDate)(race.raceDatetime, 'ddd, DD MMMM YYYY')
                }, void 0, _react2.default.createElement(
                    _RaceCardLink2.default,
                    race,
                    (0, _date.formatEntryTime)(race.raceDatetime),
                    '\xA0',
                    race.courseStyleName
                ), '\xA0', _jsx('span', {
                    className: 'hidden-sm-down'
                }, void 0, (0, _distance.yardsToFurlongs)(race.distanceYard))), race.jockeyStyleName && race.jockeyLast14Days && _jsx(_Definition2.default, {
                    term: 'Jockey'
                }, void 0, _react2.default.createElement(_ProfileLink.JockeyLink, race), _jsx('span', {
                    className: 'hp-declared__jockeyStats'
                }, void 0, '\xA0(Last 14 days:\xA0', race.jockeyLast14Days.wins, '-', race.jockeyLast14Days.runs, ',', race.jockeyLast14Days.percent, '%)')), _jsx(_Definition2.default, {
                    term: 'RPR',
                    description: race.rpPostmark
                }), _jsx(_Definition2.default, {
                    className: 'hp-declared__comments',
                    term: 'Comment',
                    description: race.comment
                })), _react2.default.createElement(_PriceButton2.default, _extends({
                    horseName: _this2.props.horseName
                }, race)));
            }));
        }
    }]);

    return DeclaredBox;
}(_react2.default.PureComponent);

exports.default = DeclaredBox;

/***/ }),
/* 1117 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Breeder = __webpack_require__(394);

var _Breeder2 = _interopRequireDefault(_Breeder);

var _Trainer = __webpack_require__(399);

var _Trainer2 = _interopRequireDefault(_Trainer);

var _Owner = __webpack_require__(397);

var _Owner2 = _interopRequireDefault(_Owner);

var _Age = __webpack_require__(393);

var _Age2 = _interopRequireDefault(_Age);

var _Sire = __webpack_require__(398);

var _Sire2 = _interopRequireDefault(_Sire);

var _Dam = __webpack_require__(395);

var _Dam2 = _interopRequireDefault(_Dam);

var _DamSire = __webpack_require__(396);

var _DamSire2 = _interopRequireDefault(_DamSire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DamDetails = function DamDetails(props) {
    return _jsx('div', {
        className: 'hp-details__data'
    }, void 0, _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_Age2.default, _extends({ key: 'Age' }, props)), _react2.default.createElement(_Sire2.default, _extends({ key: 'Sire' }, props)), _react2.default.createElement(_Dam2.default, _extends({ key: 'Dam' }, props)), _react2.default.createElement(_DamSire2.default, _extends({ key: 'DamSire' }, props))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_Breeder2.default, _extends({ key: 'Breeder' }, props)), _jsx('div', {
        className: 'hp-details__extraData'
    }, void 0, _react2.default.createElement(_Trainer2.default, _extends({ key: 'Trainer' }, props, { hasPedigree: true })), _react2.default.createElement(_Owner2.default, _extends({ key: 'Owner' }, props, { hasPedigree: true })))));
};

exports.default = DamDetails;

/***/ }),
/* 1118 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DamDetails = __webpack_require__(1117);

var _DamDetails2 = _interopRequireDefault(_DamDetails);

var _StallionDetails = __webpack_require__(1120);

var _StallionDetails2 = _interopRequireDefault(_StallionDetails);

var _GenericDetails = __webpack_require__(1119);

var _GenericDetails2 = _interopRequireDefault(_GenericDetails);

var _horse = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var stallionKeys = ['trainerUid', 'ownerUid', 'sireComment'];
var genericKeys = ['sireUid', 'damUid', 'damSireUid'];
var requiredKeys = ['horseDateOfBirth', 'horseSexCode', 'breederName'].concat(genericKeys, stallionKeys);

var isExtraDataPresent = function isExtraDataPresent(data, isSire) {
    return (isSire ? stallionKeys : genericKeys).every(function (key) {
        return data[key];
    });
};

var getTypeSpecificDetails = function getTypeSpecificDetails(props, type) {
    var isMobile = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    if (type === 'sire') {
        return _react2.default.createElement(_StallionDetails2.default, _extends({}, props, { isMobile: isMobile }));
    }

    if (type === 'dam') {
        return _react2.default.createElement(_DamDetails2.default, props);
    }

    return _react2.default.createElement(_GenericDetails2.default, props);
};

var _ref = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'down',
    size: 'Medium'
});

var Details = function (_PureComponent) {
    _inherits(Details, _PureComponent);

    function Details(props) {
        _classCallCheck(this, Details);

        var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this, props));

        _this.toggleDetails = function () {
            _this.setState(function (state) {
                return { expanded: !state.expanded };
            });
        };

        _this.state = {
            expanded: false
        };
        _this.isEmpty = requiredKeys.every(function (key) {
            return !props[key];
        });
        var type = (0, _horse.getHorseType)(props);
        _this.isExtraDataPresent = isExtraDataPresent(props, type === 'sire');
        return _this;
    }

    _createClass(Details, [{
        key: 'render',
        value: function render() {
            var type = (0, _horse.getHorseType)(this.props);
            var isMobile = this.props.isMobile;


            return this.isEmpty ? null : _jsx('div', {
                className: (0, _classnames2.default)('hp-details', this.state.expanded && 'hp-details__expanded')
            }, void 0, getTypeSpecificDetails(this.props, type, isMobile), this.isExtraDataPresent && _jsx('button', {
                className: 'ui-btn hidden-md-up hp-details__expandBtn',
                onClick: this.toggleDetails
            }, void 0, _ref));
        }
    }]);

    return Details;
}(_react.PureComponent);

exports.default = Details;

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Breeder = __webpack_require__(394);

var _Breeder2 = _interopRequireDefault(_Breeder);

var _Trainer = __webpack_require__(399);

var _Trainer2 = _interopRequireDefault(_Trainer);

var _Owner = __webpack_require__(397);

var _Owner2 = _interopRequireDefault(_Owner);

var _Age = __webpack_require__(393);

var _Age2 = _interopRequireDefault(_Age);

var _Sire = __webpack_require__(398);

var _Sire2 = _interopRequireDefault(_Sire);

var _Dam = __webpack_require__(395);

var _Dam2 = _interopRequireDefault(_Dam);

var _DamSire = __webpack_require__(396);

var _DamSire2 = _interopRequireDefault(_DamSire);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GenericDetails = function GenericDetails(props) {
    return _jsx('div', {
        className: 'hp-details__data'
    }, void 0, _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_Age2.default, _extends({ key: 'Age' }, props)), _react2.default.createElement(_Breeder2.default, _extends({ key: 'Breeder_xn' }, props, { className: 'hidden-md-up' })), _react2.default.createElement(_Trainer2.default, _extends({ key: 'Trainer' }, props)), _react2.default.createElement(_Owner2.default, _extends({ key: 'Owner' }, props))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _jsx('div', {
        className: 'hp-details__extraData'
    }, void 0, _react2.default.createElement(_Sire2.default, _extends({ key: 'Sire' }, props)), _react2.default.createElement(_Dam2.default, _extends({ key: 'Dam' }, props)), _react2.default.createElement(_DamSire2.default, _extends({ key: 'DamSire' }, props))), _react2.default.createElement(_Breeder2.default, _extends({ key: 'Breeder' }, props, { className: 'hidden-sm-down' }))));
};

exports.default = GenericDetails;

/***/ }),
/* 1120 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Breeder = __webpack_require__(394);

var _Breeder2 = _interopRequireDefault(_Breeder);

var _Age = __webpack_require__(393);

var _Age2 = _interopRequireDefault(_Age);

var _Sire = __webpack_require__(398);

var _Sire2 = _interopRequireDefault(_Sire);

var _Dam = __webpack_require__(395);

var _Dam2 = _interopRequireDefault(_Dam);

var _Trainer = __webpack_require__(399);

var _Trainer2 = _interopRequireDefault(_Trainer);

var _Owner = __webpack_require__(397);

var _Owner2 = _interopRequireDefault(_Owner);

var _DamSire = __webpack_require__(396);

var _DamSire2 = _interopRequireDefault(_DamSire);

var _Standing = __webpack_require__(609);

var _Standing2 = _interopRequireDefault(_Standing);

var _SireComment = __webpack_require__(1121);

var _SireComment2 = _interopRequireDefault(_SireComment);

var _horse = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('span', {
    className: 'hp-details__label'
}, void 0, 'Age');

var _ref2 = _jsx('span', {
    className: 'hp-details__label'
}, void 0, 'Sire');

var _ref3 = _jsx('span', {
    className: 'hp-details__label'
}, void 0, 'Dam');

var _ref4 = _jsx('span', {
    className: 'hp-details__label'
}, void 0, 'Dam\'s Sire');

var _ref5 = _jsx('span', {
    className: 'hp-details__label'
}, void 0, 'Sire Comment');

var _ref6 = _jsx('span', {
    className: 'hp-details__label'
}, void 0, 'Breeder');

var _ref7 = _jsx('span', {
    className: 'hp-details__label'
}, void 0, 'Trainer');

var _ref8 = _jsx('span', {
    className: 'hp-details__label'
}, void 0, 'Racing Owner');

function weatherbyDetails(props) {
    var compData = _extends({}, props, {
        isWeatherbysMobile: (0, _horse.isWeatherbysMobile)(props)
    });

    return _jsx('div', {
        className: 'hp-details__data'
    }, void 0, _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _ref, _jsx('div', {
        className: 'hp-details__detail-wrapper--weatherbys'
    }, void 0, _react2.default.createElement(_Age2.default, _extends({ key: 'Age' }, compData))), _ref2, _jsx('div', {
        className: 'hp-details__detail-wrapper--weatherbys'
    }, void 0, _react2.default.createElement(_Sire2.default, _extends({ key: 'Sire' }, compData)))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _ref3, _jsx('div', {
        className: 'hp-details__detail-wrapper--weatherbys'
    }, void 0, _react2.default.createElement(_Dam2.default, _extends({ key: 'Dam' }, compData))), _ref4, _jsx('div', {
        className: 'hp-details__detail-wrapper--weatherbys'
    }, void 0, _react2.default.createElement(_DamSire2.default, _extends({ key: 'DamSire' }, compData)))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _ref5, _jsx('div', {
        className: 'hp-details__detail-wrapper--weatherbys-comment'
    }, void 0, _react2.default.createElement(_SireComment2.default, _extends({ key: 'SireComment' }, compData)))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _ref6, _jsx('div', {
        className: 'hp-details__detail-wrapper--weatherbys'
    }, void 0, _react2.default.createElement(_Breeder2.default, _extends({ key: 'Breeder' }, compData))), _ref7, _jsx('div', {
        className: 'hp-details__detail-wrapper--weatherbys'
    }, void 0, _react2.default.createElement(_Trainer2.default, _extends({ key: 'Trainer' }, compData, { hasPedigree: true })))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _ref8, _jsx('div', {
        className: 'hp-details__detail-wrapper--weatherbys'
    }, void 0, _react2.default.createElement(_Owner2.default, _extends({ key: 'Owner' }, compData, { hasPedigree: true })))));
}

function weatherbyDetailsMobile(props) {
    var compData = _extends({}, props, {
        isWeatherbysMobile: (0, _horse.isWeatherbysMobile)(props)
    });

    return _jsx('div', {
        className: 'hp-details__data'
    }, void 0, _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_Age2.default, _extends({ key: 'Age' }, compData)), _react2.default.createElement(_Sire2.default, _extends({ key: 'Sire' }, compData)), _react2.default.createElement(_Dam2.default, _extends({ key: 'Dam' }, compData)), _react2.default.createElement(_DamSire2.default, _extends({ key: 'DamSire' }, compData))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_SireComment2.default, _extends({ key: 'SireComment' }, compData)), _react2.default.createElement(_Breeder2.default, _extends({ key: 'Breeder' }, compData)), _jsx('div', {
        className: 'hp-details__extraData'
    }, void 0, _react2.default.createElement(_Trainer2.default, _extends({ key: 'Trainer' }, compData, { hasPedigree: true })), _react2.default.createElement(_Owner2.default, _extends({ key: 'Owner' }, compData, { hasPedigree: true })))));
}

function stallionDetails(props) {
    return _jsx('div', {
        className: 'hp-details__data'
    }, void 0, _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_Age2.default, _extends({ key: 'Age' }, props)), _react2.default.createElement(_Sire2.default, _extends({ key: 'Sire' }, props)), _react2.default.createElement(_Dam2.default, _extends({ key: 'Dam' }, props)), _react2.default.createElement(_DamSire2.default, _extends({ key: 'DamSire' }, props)), _react2.default.createElement(_Standing2.default, _extends({ key: 'Standing' }, props))), _jsx('div', {
        className: 'hp-details__section'
    }, void 0, _react2.default.createElement(_SireComment2.default, _extends({ key: 'SireComment' }, props)), _react2.default.createElement(_Breeder2.default, _extends({ key: 'Breeder' }, props)), _jsx('div', {
        className: 'hp-details__extraData'
    }, void 0, _react2.default.createElement(_Trainer2.default, _extends({ key: 'Trainer' }, props, { hasPedigree: true })), _react2.default.createElement(_Owner2.default, _extends({ key: 'Owner' }, props, { hasPedigree: true })))));
}

var StallionDetails = function StallionDetails(props) {
    if (!props.weatherbysUid) {
        return stallionDetails(props);
    }

    var isMobile = props.isMobile;


    if (!isMobile) {
        return weatherbyDetails(props);
    }

    return weatherbyDetailsMobile(props);
};

exports.default = StallionDetails;

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Definition = __webpack_require__(143);

var _Definition2 = _interopRequireDefault(_Definition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SireComment = function SireComment(_ref) {
    var sireComment = _ref.sireComment,
        isWeatherbysMobile = _ref.isWeatherbysMobile;

    if (isWeatherbysMobile) {
        return !!sireComment && _jsx(_Definition2.default, {
            isTermLabel: false,
            forceShow: true,
            term: sireComment,
            description: ''
        });
    }

    return !!sireComment && _jsx(_Definition2.default, {
        term: 'Sire comment',
        description: sireComment
    });
};

exports.default = SireComment;

/***/ }),
/* 1122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1123);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FeeHistory = function FeeHistory(_ref) {
    var data = _ref.data;
    return _jsx('section', {
        className: 'hp-feeHistory'
    }, void 0, _jsx(_rpReactTable2.default, {
        data: data.feeHistory || [],
        columns: _columns2.default,
        sortable: true,
        initialSortIdx: 0,
        noDataText: 'No fee history data for this sire in the Racing Post database'
    }));
};

exports.default = FeeHistory;

/***/ }),
/* 1123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(9);

var _money = __webpack_require__(39);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_Abbr2.default, {
    title: 'country'
}, void 0, 'cntry');

var columns = [{
    key: 'nominationYear',
    header: 'year'
}, {
    key: 'studFee',
    header: 'stud fee',
    cell: function cell(_ref) {
        var studFee = _ref.studFee,
            currencyCode = _ref.currencyCode;
        return (0, _lodash.isString)(studFee) ? studFee : currencyCode + ' ' + (0, _money.formatPrice)(studFee);
    },
    sortFn: function sortFn(a, b) {
        if ((0, _lodash.isString)(a.studFee)) {
            return 1;
        }
        if ((0, _lodash.isString)(b.studFee)) {
            return -1;
        }
        return b.studFee - a.studFee;
    }
}, {
    key: 'countryDesc',
    header: function header() {
        return _ref2;
    },
    cell: function cell(_ref3) {
        var countryCode = _ref3.countryCode,
            countryDesc = _ref3.countryDesc;
        return countryDesc && countryCode ? _jsx(_Abbr2.default, {
            title: countryDesc
        }, void 0, countryCode) : '—';
    },
    sortFn: 'alphabetic'
}, {
    key: 'studName',
    header: 'standing',
    sortFn: 'alphabetic'
}];

exports.default = columns;

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(18);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CommonSpecialRow = function CommonSpecialRow(_ref) {
    var raceDatetime = _ref.raceDatetime,
        specialText = _ref.specialText,
        trainerFrom = _ref.trainerFrom,
        trainerTo = _ref.trainerTo;
    return _jsx('tr', {
        className: 'ui-table__row hp-formTable__special'
    }, raceDatetime, _jsx('td', {
        className: 'ui-table__cell hp-formTable__special__date'
    }, void 0, (0, _date.formatDate)(raceDatetime, 'DDMMMYY')), _jsx('td', {
        className: 'ui-table__cell',
        colSpan: 10
    }, void 0, specialText || _jsx('span', {}, void 0, 'Changed Trainer notification: ', _react2.default.createElement(_ProfileLink.TrainerLink, trainerFrom), ' ', 'to ', _react2.default.createElement(_ProfileLink.TrainerLink, trainerTo))));
};

var trainerProp = {
    trainerStyleName: _propTypes2.default.string.isRequired,
    trainerUid: _propTypes2.default.number.isRequired
};

exports.default = CommonSpecialRow;

/***/ }),
/* 1125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _distance = __webpack_require__(113);

var _money = __webpack_require__(39);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ConditionsCell = function ConditionsCell(_ref) {
    var courseComments = _ref.courseComments,
        courseStyleName = _ref.courseStyleName,
        courseRpAbbrev3 = _ref.courseRpAbbrev3,
        distanceYard = _ref.distanceYard,
        goingTypeServicesDesc = _ref.goingTypeServicesDesc,
        courseUid = _ref.courseUid,
        raceDescription = _ref.raceDescription,
        raceClass = _ref.raceClass,
        prizeSterling = _ref.prizeSterling,
        jubileeDesc = _ref.rpStraightRoundJubileeDesc,
        raceOutcomeCode = _ref.raceOutcomeCode,
        rpCloseUpComment = _ref.rpCloseUpComment;

    var filteredJubileeDesc = jubileeDesc && (0, _lodash.lowerCase)(jubileeDesc.replace(/oms\s?/i, ''));
    return _jsx('span', {}, void 0, _jsx(_ProfileLink.CourseLink, {
        courseStyleName: courseStyleName,
        courseUid: courseUid,
        title: courseComments,
        className: 'hp-formTable__course'
    }, void 0, _jsx('span', {
        className: 'hidden-lg-down'
    }, void 0, courseStyleName), _jsx('span', {
        className: 'hidden-xl-up'
    }, void 0, (0, _lodash.capitalize)(courseRpAbbrev3))), filteredJubileeDesc ? _jsx('span', {}, void 0, '\xA0', filteredJubileeDesc) : null, _jsx('span', {
        className: 'hidden-sm-up'
    }, void 0, '\xA0', (0, _distance.yardsToFurlongs)(distanceYard), ' ', goingTypeServicesDesc), raceClass ? ' C' : ' ', raceDescription, _jsx('span', {
        className: 'hidden-xs-down'
    }, void 0, '\xA0', (0, _money.formatPrize)(prizeSterling)), raceOutcomeCode === 'NR' && _jsx('div', {}, void 0, _jsx('strong', {
        className: 'nonRunnerSliderSwitcherData__exNarrow'
    }, void 0, 'Non Runner', !!rpCloseUpComment && ' (' + rpCloseUpComment + ')')));
};

exports.default = ConditionsCell;

/***/ }),
/* 1126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _PopoverComponent = __webpack_require__(598);

var _PopoverComponent2 = _interopRequireDefault(_PopoverComponent);

var _PopoverListItem = __webpack_require__(1051);

var _PopoverListItem2 = _interopRequireDefault(_PopoverListItem);

var _Abbr = __webpack_require__(1038);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint jsx-a11y/no-static-element-interactions: 0 */


var popoverListConfig = ['course', 'class', 'prize'];

var _ref = _jsx(_Abbr2.default, {
    title: 'Course / Class / Type / Prize',
    breakpoint: 'sm'
}, void 0, 'conditions');

var CustomHeaderCell = function (_Popover) {
    _inherits(CustomHeaderCell, _Popover);

    function CustomHeaderCell(props) {
        _classCallCheck(this, CustomHeaderCell);

        var _this = _possibleConstructorReturn(this, (CustomHeaderCell.__proto__ || Object.getPrototypeOf(CustomHeaderCell)).call(this, props));

        _initialiseProps.call(_this);

        var expanded = props.expanded,
            sortBy = props.sortBy;

        _this.state = {
            expanded: expanded,
            sortBy: sortBy
        };

        _this.cancelStopPropag = false;
        return _this;
    }

    _createClass(CustomHeaderCell, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                expanded = _state.expanded,
                sortBy = _state.sortBy;


            return _react2.default.createElement(
                'div',
                {
                    className: 'cm-popoverList__popoverWrapper',
                    onClick: this.handleClick,
                    ref: function ref(el) {
                        _this2.node = el;
                    }
                },
                _ref,
                expanded && _jsx('div', {
                    className: (0, _classnames2.default)('cm-popoverList__popover', 'ui-popover', 'ui-popover_customised')
                }, void 0, popoverListConfig.map(function (listItem) {
                    return _jsx(_PopoverListItem2.default, {
                        isSelected: sortBy === listItem,
                        onSelect: function onSelect() {
                            return _this2.onSelect(listItem);
                        },
                        text: listItem === 'prize' ? 'prize money' : listItem
                    }, listItem);
                }))
            );
        }
    }]);

    return CustomHeaderCell;
}(_PopoverComponent2.default);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.handleClick = function (e) {
        var sortBy = _this3.props.sortBy;

        _this3.setState({
            expanded: !_this3.state.expanded
        });

        if (!_this3.cancelStopPropag) {
            e.stopPropagation();

            var isHeaderCellSorted = _this3.node.closest('.ui-table__cell_header').classList.contains('ui-table__cell_sorted');

            if (sortBy !== '' && !isHeaderCellSorted) {
                _this3.setState({
                    sortBy: ''
                });
            }
        } else {
            _this3.cancelStopPropag = false;
        }
    };

    this.onSelect = function (sortBy) {
        _this3.setState({
            sortBy: sortBy
        });
        _this3.props.onUpdate(sortBy);
        _this3.cancelStopPropag = true;
    };
};

CustomHeaderCell.propTypes = {
    expanded: _propTypes2.default.bool,
    sortBy: _propTypes2.default.string
};

exports.default = CustomHeaderCell;

/***/ }),
/* 1127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'hp-formTable__delimiterLine'
});

var DelimiterRow = function DelimiterRow(_ref) {
    var raceDatetime = _ref.raceDatetime,
        daysBreak = _ref.daysBreak;
    return _jsx('tr', {
        className: 'ui-table__row hp-formTable__delimiter'
    }, raceDatetime, _jsx('td', {
        className: 'ui-table__cell hp-formTable__delimiterCell',
        colSpan: 11
    }, void 0, _ref2, _jsx('span', {
        className: 'hp-formTable__delimiterText'
    }, void 0, daysBreak, ' days break')));
};

exports.default = DelimiterRow;

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _formatWeight = __webpack_require__(299);

var _formatWeight2 = _interopRequireDefault(_formatWeight);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getDistance(outcomeCode, winDist, distToWin) {
    if (!winDist && !distToWin) {
        return null;
    }
    if (+outcomeCode === 1) {
        return _jsx('span', {}, void 0, 'by ', winDist, '\xA0');
    }
    return _jsx('span', {}, void 0, 'btn ', distToWin, '\xA0');
}

var _ref2 = _jsx('span', {
    className: 'nonRunnerSliderSwitcherData__exNarrow'
}, void 0, _rpReactTable.EMPTINESS_SIGN);

var FinishingCell = function FinishingCell(_ref) {
    var raceOutcomeCode = _ref.raceOutcomeCode,
        rpCloseUpComment = _ref.rpCloseUpComment,
        rpBettingMovements = _ref.rpBettingMovements,
        noOfRunners = _ref.noOfRunners,
        _ref$otherHorse = _ref.otherHorse,
        otherHorse = _ref$otherHorse === undefined ? {} : _ref$otherHorse,
        winningDistance = _ref.winningDistance,
        distanceToWinner = _ref.distanceToWinner,
        courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        raceDatetime = _ref.raceDatetime,
        raceInstanceUid = _ref.raceInstanceUid;
    return _jsx('span', {}, void 0, _jsx('span', {
        className: raceOutcomeCode === 'NR' && 'nonRunnerSliderSwitcherHideData'
    }, void 0, _jsx('strong', {}, void 0, raceOutcomeCode), '/', noOfRunners, '\xA0', _jsx(_ResultLink2.default, {
        courseName: courseName,
        courseUid: courseUid,
        raceDatetime: raceDatetime,
        raceInstanceUid: raceInstanceUid,
        raceInstanceTitle: '' + rpCloseUpComment + (rpBettingMovements ? ' (' + rpBettingMovements + ')' : ''),
        className: 'hidden-sm-down'
    }, void 0, getDistance(raceOutcomeCode, winningDistance, distanceToWinner), otherHorse && _jsx('span', {}, void 0, otherHorse.styleName, '\xA0', (0, _formatWeight2.default)(otherHorse.weightCarriedLbs)))), raceOutcomeCode === 'NR' && _jsx('span', {}, void 0, _jsx('strong', {
        className: 'nonRunnerSliderSwitcherData'
    }, void 0, 'Non Runner', !!rpCloseUpComment && ' (' + rpCloseUpComment + ')'), _ref2));
};

exports.default = FinishingCell;

/***/ }),
/* 1129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _index = __webpack_require__(401);

var _index2 = _interopRequireDefault(_index);

var _columns = __webpack_require__(1134);

var _columns2 = _interopRequireDefault(_columns);

var _getSortFn = __webpack_require__(1136);

var _getSortFn2 = _interopRequireDefault(_getSortFn);

var _SpecialRow = __webpack_require__(1132);

var _SpecialRow2 = _interopRequireDefault(_SpecialRow);

var _Slider = __webpack_require__(1131);

var _Slider2 = _interopRequireDefault(_Slider);

var _mergeWithMR = __webpack_require__(1137);

var _mergeWithMR2 = _interopRequireDefault(_mergeWithMR);

var _dataPropTypes = __webpack_require__(400);

var _helper = __webpack_require__(230);

var _ContentBarrier = __webpack_require__(1240);

var _ContentBarrier2 = _interopRequireDefault(_ContentBarrier);

var _analyticsPage = __webpack_require__(290);

var _analyticsPage2 = _interopRequireDefault(_analyticsPage);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var sliderConfig = {
    nonRunnerSwitcher: { stateProp: 'isNRShown', title: 'Non-Runner Info' },
    delimiterLineSwitcher: { stateProp: 'isBreakShown', title: 'Breaks (50+ days)' },
    myRatingSwitcher: { title: 'My Rating' }
};

var _ref = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'spinner',
    size: 'Large',
    className: 'ui-animation_spinnerAnimation'
});

var _ref2 = _jsx(_ContentBarrier2.default, {});

var FormTable = function (_Component) {
    _inherits(FormTable, _Component);

    function FormTable(props) {
        _classCallCheck(this, FormTable);

        var _this = _possibleConstructorReturn(this, (FormTable.__proto__ || Object.getPrototypeOf(FormTable)).call(this, props));

        _this.componentDidMount = function () {
            var _this$props = _this.props,
                data = _this$props.data,
                hasAccess = _this$props.hasAccess;

            _this.shouldShowContentBarrier = !hasAccess && data.form.filter(function (row) {
                return (0, _helper.isRunner)(row) && !row.isSpecial;
            }).length > _this.raceRowsLimit;
            (0, _analyticsPage2.default)(data, _this.shouldShowContentBarrier);
        };

        _this.onSortIndexChange = function (index) {
            _this.setState({ indexDefault: index });
        };

        _this.getFilteredData = function () {
            var _this$props2 = _this.props,
                form = _this$props2.data.form,
                params = _this$props2.params;
            var _this$state = _this.state,
                isNRShown = _this$state.isNRShown,
                isMRShown = _this$state.isMRShown;


            var sortedForm = form.sort(function (a, b) {
                return new Date(b.raceDatetime) - new Date(a.raceDatetime);
            });

            var tableData = [];
            var realRaceCount = 0;
            var allowOnlyNonRealAfterLimit = false;

            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
                for (var _iterator = sortedForm[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                    var row = _step.value;

                    var isSpecialRow = row.isSpecial;
                    var isRunnerRow = (0, _helper.isRunner)(row) && !isSpecialRow;
                    var isNonRunnerRow = row.raceOutcomeCode === 'NR';

                    if (!isNRShown && isNonRunnerRow) {
                        continue;
                    }

                    if (isRunnerRow) {
                        if (realRaceCount < _this.raceRowsLimit) {
                            tableData.push(row);
                            realRaceCount += 1;
                        } else {
                            allowOnlyNonRealAfterLimit = true;
                        }
                    } else {
                        tableData.push(row);
                    }

                    if (allowOnlyNonRealAfterLimit && isRunnerRow) {
                        break;
                    }
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally {
                try {
                    if (!_iteratorNormalCompletion && _iterator.return) {
                        _iterator.return();
                    }
                } finally {
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }

            return isMRShown ? (0, _mergeWithMR2.default)(tableData, params.myRatings) : tableData;
        };

        _this.myRatingToggle = function () {
            var show = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
            var _this$props$params = _this.props.params,
                id = _this$props$params.id,
                name = _this$props$params.name,
                myRatings = _this$props$params.mr;

            var myRatingState = show ? 'show' : 'hide';
            var configUrl = {
                show: 'horse/' + id + '/' + name + '/form/my-ratings',
                hide: 'horse/' + id + '/' + name + '/form'
            };

            _index2.default.replace(configUrl[myRatingState]);
            if (myRatings[myRatingState]) {
                myRatings[myRatingState]();
            }
        };

        _this.updateSortBy = function (sortBy) {
            if (sortBy !== _this.state.sortBy) {
                _this.setState({ sortBy: sortBy });
            }
        };

        var isMyRatingShown = localStorage.getItem('myRatingSwitcher') === 'true';
        var isDelimiterLineShown = localStorage.getItem('delimiterLineSwitcher') === 'true';

        _this.state = {
            isNRShown: localStorage.getItem('nonRunnerSwitcher') === 'true',
            isBreakShown: isDelimiterLineShown,
            sortBy: '',
            indexDefault: 0
        };

        _this.getColumnsConfig = _columns2.default.bind(null, _this.updateSortBy);
        _this.handleSlider = _this.handleSlider.bind(_this);
        _this.handleMyRatingSlider = _this.handleMyRatingSlider.bind(_this);
        _this.raceRowsLimit = 5;
        _this.shouldShowContentBarrier = false;

        if (isMyRatingShown) {
            _this.myRatingToggle(true);
        } else {
            _this.myRatingToggle();
        }
        return _this;
    }

    _createClass(FormTable, [{
        key: 'handleSlider',
        value: function handleSlider(key) {
            var isCurrentlyEnabled = localStorage.getItem(key) === 'true';
            this.setState(_defineProperty({}, sliderConfig[key].stateProp, !isCurrentlyEnabled));
            localStorage.setItem(key, !isCurrentlyEnabled);
        }
    }, {
        key: 'handleMyRatingSlider',
        value: function handleMyRatingSlider() {
            var myRatings = this.props.params.mr;

            var key = 'myRatingSwitcher';
            var show = !myRatings.isShown;

            localStorage.setItem(key, show);
            this.myRatingToggle(show);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props = this.props,
                data = _props.data,
                selectedFilter = _props.selectedFilter,
                hasSpecial = _props.hasSpecial,
                params = _props.params,
                hasAccess = _props.hasAccess;
            var form = data.form,
                loading = data.loading,
                myRatings = data.myRatings;
            var isMRShown = params.mr.isShown;
            var _state = this.state,
                isNRShown = _state.isNRShown,
                isBreakShown = _state.isBreakShown,
                sortBy = _state.sortBy,
                indexDefault = _state.indexDefault;


            var tableData = isNRShown ? form : form.filter(_helper.isRunner);

            if (hasAccess) {
                tableData = isMRShown ? (0, _mergeWithMR2.default)(tableData, myRatings) : tableData;
            } else {
                tableData = this.getFilteredData();
            }

            return _jsx('section', {}, void 0, _jsx('div', {
                className: 'hp-formTable__header'
            }, void 0, _jsx('h2', {
                className: 'hp-formTable__title'
            }, void 0, 'Form ', selectedFilter && '- ' + selectedFilter), _jsx('div', {
                className: 'hp-formTable__sliderContainer'
            }, void 0, Object.keys(sliderConfig).map(function (key) {
                return _jsx(_Slider2.default, {
                    handleSlider: function handleSlider() {
                        return key === 'myRatingSwitcher' ? _this2.handleMyRatingSlider() : _this2.handleSlider(key);
                    },
                    sliderState: key === 'myRatingSwitcher' ? isMRShown : _this2.state[sliderConfig[key].stateProp],
                    title: sliderConfig[key].title,
                    id: key,
                    disabled: key === 'delimiterLineSwitcher' && (selectedFilter || indexDefault !== 0)
                }, key);
            })), loading && _ref), _jsx(_rpReactTable2.default, {
                className: (0, _classnames2.default)('hp-formTable', isMRShown && 'hp-formTable__my-ratings', isNRShown && 'nonRunnerSliderSwitcher', !isBreakShown && 'hp-formTable__delimiterHide'),
                data: tableData,
                columns: this.getColumnsConfig(sortBy),
                noDataText: 'No form for this horse',
                sortable: hasAccess,
                initialSortIdx: indexDefault,
                filter: (0, _getSortFn2.default)(selectedFilter),
                specialRow: hasSpecial ? _SpecialRow2.default : undefined,
                onSortUpdate: this.onSortIndexChange
            }), this.shouldShowContentBarrier && _ref2);
        }
    }]);

    return FormTable;
}(_react.Component);

exports.default = FormTable;

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _helper = __webpack_require__(230);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getValue = function getValue(value, zeroToDash) {
    if (value || !zeroToDash && value === 0) {
        return value;
    }
    return _rpReactTable.EMPTINESS_SIGN;
};

var NonRunnerSwitcherTableCell = function NonRunnerSwitcherTableCell(_ref) {
    var code = _ref.code,
        value = _ref.value,
        zeroToDash = _ref.zeroToDash;
    return _jsx('span', {}, void 0, (0, _helper.isRunnerCode)(code) ? _jsx('span', {}, void 0, getValue(value, zeroToDash)) : _rpReactTable.EMPTINESS_SIGN);
};

exports.default = NonRunnerSwitcherTableCell;

/***/ }),
/* 1131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'slider__trigger'
});

var Slider = function Slider(_ref) {
    var sliderState = _ref.sliderState,
        handleSlider = _ref.handleSlider,
        title = _ref.title,
        id = _ref.id,
        disabled = _ref.disabled;
    return _jsx('div', {
        className: (0, _classnames2.default)('sliderInfo', id + 'Slider', disabled && 'sliderInfo_disabled')
    }, void 0, _jsx('span', {
        className: 'sliderInfo__title'
    }, void 0, title), _jsx('label', {
        className: 'slider',
        htmlFor: id
    }, void 0, _jsx('input', {
        className: 'sliderInput',
        type: 'checkbox',
        checked: sliderState,
        onChange: handleSlider,
        id: id,
        disabled: disabled
    }), _ref2));
};

exports.default = Slider;

/***/ }),
/* 1132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CommonSpecialRow = __webpack_require__(1124);

var _CommonSpecialRow2 = _interopRequireDefault(_CommonSpecialRow);

var _DelimiterRow = __webpack_require__(1127);

var _DelimiterRow2 = _interopRequireDefault(_DelimiterRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var SpecialRow = function SpecialRow(_ref) {
    var isSpecial = _ref.isSpecial,
        daysBreak = _ref.daysBreak,
        props = _objectWithoutProperties(_ref, ['isSpecial', 'daysBreak']);

    return isSpecial && (daysBreak ? _react2.default.createElement(_DelimiterRow2.default, _extends({ daysBreak: daysBreak }, props)) : _react2.default.createElement(_CommonSpecialRow2.default, props));
};

exports.default = SpecialRow;

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formatWeight = __webpack_require__(299);

var _formatWeight2 = _interopRequireDefault(_formatWeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('sup', {}, void 0, '1');

var WeightCell = function WeightCell(_ref) {
    var weightCarriedLbs = _ref.weightCarriedLbs,
        horseHeadGear = _ref.horseHeadGear,
        firstTimeHeadgear = _ref.firstTimeHeadgear;
    return _jsx('span', {}, void 0, (0, _formatWeight2.default)(weightCarriedLbs), horseHeadGear && _jsx('span', {}, void 0, '\xA0', horseHeadGear, firstTimeHeadgear && _ref2));
};

exports.default = WeightCell;

/***/ }),
/* 1134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _date = __webpack_require__(18);

var _distance = __webpack_require__(113);

var _going = __webpack_require__(632);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _ConditionsCell = __webpack_require__(1125);

var _ConditionsCell2 = _interopRequireDefault(_ConditionsCell);

var _FinishingCell = __webpack_require__(1128);

var _FinishingCell2 = _interopRequireDefault(_FinishingCell);

var _CustomHeaderCell = __webpack_require__(1126);

var _CustomHeaderCell2 = _interopRequireDefault(_CustomHeaderCell);

var _columnsCells = __webpack_require__(1135);

var _number = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sortConfig = {
    course: { key: 'courseName', sortFn: 'alphabetic' },
    class: { key: 'raceClass', sortFn: 'numericReverse' },
    prize: { key: 'prizeSterling', sortFn: 'numeric' }
};

var _ref3 = _jsx(_Abbr2.default, {
    title: 'Pos. Finish dist / winner or Runner-up / Wgt',
    breakpoint: 'fromMedium'
}, void 0, 'Pos.');

var columns = function columns(onUpdate, sortKey) {
    var _ref = _jsx(_CustomHeaderCell2.default, {
        onUpdate: onUpdate,
        sortBy: sortKey
    });

    return [{
        key: 'raceDatetime',
        header: 'date',
        cell: _columnsCells.raceDatetimeCell,
        sortFn: (0, _date.sortByDate)('raceDatetime')
    }, {
        key: sortConfig[sortKey] ? sortConfig[sortKey].key : sortKey,
        header: function header() {
            return _ref;
        },
        cell: _ConditionsCell2.default,
        sortFn: sortConfig[sortKey] ? sortConfig[sortKey].sortFn : function () {
            return null;
        }
    }, {
        key: 'distanceFurlong',
        header: 'dist.',
        cell: function cell(_ref2) {
            var distanceYard = _ref2.distanceYard;
            return (0, _distance.yardsToFurlongs)(distanceYard);
        },
        sortFn: 'numericReverse'
    }, {
        key: 'goingTypeServicesDesc',
        header: 'gng.',
        sortFn: _going.goingCodeSortFn
    }, {
        key: 'weightCarriedLbs',
        header: 'wgt / hdgr',
        cell: _columnsCells.weightCarriedLbsCell
    }, {
        key: 'raceOutcomeCode',
        header: function header() {
            return _ref3;
        },
        cell: _FinishingCell2.default,
        sortFn: 'numericReverse'
    }, {
        key: 'oddsValue',
        header: 'sp',
        cell: _columnsCells.oddsValueCell,
        sortFn: 'numericReverse'
    }, {
        key: 'jockeyShortName',
        header: 'jockey',
        cell: _columnsCells.jockeyShortNameCell,
        sortFn: 'byLastName'
    }, {
        key: 'officialRatingRanOff',
        header: 'or',
        cell: _columnsCells.officialRatingRanOffCell,
        sortFn: (0, _number.numericAndDashSort)('officialRatingRanOff')
    }, {
        key: 'rpTopspeed',
        header: 'ts',
        cell: _columnsCells.rpTopspeedCell,
        sortFn: (0, _number.numericAndDashSort)('rpTopspeed')
    }, {
        key: 'rpPostmark',
        header: 'rpr',
        cell: _columnsCells.rpPostmarkCell,
        sortFn: (0, _number.numericAndDashSort)('rpPostmark')
    }, {
        key: 'myRating',
        header: 'mr'
    }];
};

exports.default = columns;

/***/ }),
/* 1135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.weightCarriedLbsCell = exports.rpPostmarkCell = exports.rpTopspeedCell = exports.officialRatingRanOffCell = exports.jockeyShortNameCell = exports.oddsValueCell = exports.raceDatetimeCell = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactTable = __webpack_require__(23);

var _get = __webpack_require__(542);

var _get2 = _interopRequireDefault(_get);

var _helper = __webpack_require__(230);

var _horse = __webpack_require__(161);

var _ProfileLink = __webpack_require__(26);

var _date = __webpack_require__(18);

var _WeightCell = __webpack_require__(1133);

var _WeightCell2 = _interopRequireDefault(_WeightCell);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _ReplayLink = __webpack_require__(627);

var _ReplayLink2 = _interopRequireDefault(_ReplayLink);

var _NonRunnerSwitcherTableCell = __webpack_require__(1130);

var _NonRunnerSwitcherTableCell2 = _interopRequireDefault(_NonRunnerSwitcherTableCell);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var raceDatetimeCell = exports.raceDatetimeCell = function raceDatetimeCell(props) {
    var videoDetail = (0, _get2.default)(props, 'videoDetail[0]');
    var shouldDisplayIcon = (0, _horse.shouldShowReplayButton)(videoDetail);

    return _jsx('div', {
        className: 'hp-formTable__dateWrapper' + (!shouldDisplayIcon ? '__noVideoIcon' : '')
    }, void 0, shouldDisplayIcon && _react2.default.createElement(_ReplayLink2.default, props), _react2.default.createElement(
        _ResultLink2.default,
        props,
        (0, _date.formatDate)(props.raceDatetime, 'DDMMMYY')
    ));
};

var oddsValueCell = exports.oddsValueCell = function oddsValueCell(_ref) {
    var raceOutcomeCode = _ref.raceOutcomeCode,
        oddsDesc = _ref.oddsDesc;
    return _jsx(_NonRunnerSwitcherTableCell2.default, {
        code: raceOutcomeCode,
        value: oddsDesc,
        zeroToDash: true
    });
};

var jockeyShortNameCell = exports.jockeyShortNameCell = function jockeyShortNameCell(rowData) {
    return (0, _helper.isRunner)(rowData) ? _jsx('span', {}, void 0, _react2.default.createElement(_ProfileLink.JockeyLink, rowData), !!rowData.weightAllowanceLbs && _jsx('sup', {
        className: 'hp-formTable__jockeyAllowance'
    }, void 0, rowData.weightAllowanceLbs)) : _rpReactTable.EMPTINESS_SIGN;
};

var officialRatingRanOffCell = exports.officialRatingRanOffCell = function officialRatingRanOffCell(_ref2) {
    var raceOutcomeCode = _ref2.raceOutcomeCode,
        officialRatingRanOff = _ref2.officialRatingRanOff;
    return _jsx(_NonRunnerSwitcherTableCell2.default, {
        code: raceOutcomeCode,
        value: officialRatingRanOff,
        zeroToDash: true
    });
};

var rpTopspeedCell = exports.rpTopspeedCell = function rpTopspeedCell(_ref3) {
    var raceOutcomeCode = _ref3.raceOutcomeCode,
        rpTopspeed = _ref3.rpTopspeed;
    return _jsx(_NonRunnerSwitcherTableCell2.default, {
        code: raceOutcomeCode,
        value: rpTopspeed
    });
};

var rpPostmarkCell = exports.rpPostmarkCell = function rpPostmarkCell(_ref4) {
    var raceOutcomeCode = _ref4.raceOutcomeCode,
        rpPostmark = _ref4.rpPostmark;
    return _jsx(_NonRunnerSwitcherTableCell2.default, {
        code: raceOutcomeCode,
        value: rpPostmark
    });
};

var weightCarriedLbsCell = exports.weightCarriedLbsCell = function weightCarriedLbsCell(rowData) {
    return (0, _helper.isRunner)(rowData) ? _react2.default.createElement(_WeightCell2.default, rowData) : _rpReactTable.EMPTINESS_SIGN;
};

/***/ }),
/* 1136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _filterArrays = __webpack_require__(611);

var _filterArrays2 = _interopRequireDefault(_filterArrays);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var stakesGroupIds = [1, 2, 3, 4, 5, 7, 8, 9, 11, 12, 13, 14, 15, 16]; /*
                                                                           Flat turf - race_type_code = F
                                                                           AW - race_type_code = X
                                                                           NHF - race_type_code = B & W
                                                                           Hurdle - race_type_code = H, Y
                                                                           Chase - race_type_code = C, U, Z
                                                                           PTP - race_type_code = P
                                                                           Rules Races - race_type_code != P
                                                                           A Stakes race will be any race that has
                                                                           race_group_uid = 1,2,3,4,5,7,8,9,11,12,13,14,15,16
                                                                       */


var filterFuncs = {
    'Rules Races': function RulesRaces(_ref) {
        var raceTypeCode = _ref.raceTypeCode;
        return raceTypeCode && raceTypeCode !== 'P';
    },
    Stakes: function Stakes(_ref2) {
        var raceGroupUid = _ref2.raceGroupUid;
        return stakesGroupIds.includes(raceGroupUid);
    }
};

var getSortFn = function getSortFn(name) {
    if (_filterArrays2.default[name]) {
        return function (_ref3) {
            var raceTypeCode = _ref3.raceTypeCode;
            return _filterArrays2.default[name].includes(raceTypeCode);
        };
    }

    if (filterFuncs[name]) {
        return filterFuncs[name];
    }

    return function () {
        return true;
    };
};

exports.default = getSortFn;

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = function (data, myRatings) {
    if (!myRatings) {
        return data;
    }

    return data.map(function (item) {
        return _extends({}, item, {
            myRating: myRatings[item.raceInstanceUid]
        });
    });
};

/***/ }),
/* 1138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _shortid = __webpack_require__(386);

var _shortid2 = _interopRequireDefault(_shortid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var FigureRow = function FigureRow(_ref) {
    var figures = _ref.figures,
        type = _ref.type;
    return (0, _lodash.isEmpty)(figures) ? null : _jsx('div', {
        className: 'hp-raceRecords__figuresRow'
    }, void 0, _jsx('span', {}, void 0, (0, _lodash.capitalize)(type), ' placings: '), '\xA0', [].concat(_toConsumableArray(figures)).reverse().map(function (_ref2) {
        var raceTypeCode = _ref2.raceTypeCode,
            formFigure = _ref2.formFigure;
        return ['X', 'P'].includes(raceTypeCode) ? _jsx('strong', {}, _shortid2.default.generate(), formFigure) : formFigure;
    }));
};

exports.default = FigureRow;

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var xnLabel = {
    'Rules Races': 'Rules',
    'All-weather': 'AW'
};

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'cross',
    size: 'Small',
    className: 'hp-raceRecords__cross tableShowIcon'
});

var FilterBtn = function FilterBtn(_ref) {
    var raceType = _ref.raceType,
        onClick = _ref.onClick,
        isSelected = _ref.isSelected,
        hasAccess = _ref.hasAccess;
    return _jsx('button', {
        className: (0, _classnames2.default)('ui-btn ui-btn_tiertiary', isSelected && 'ui-btn_major hp-raceRecords__colSelectedBtn'),
        onClick: onClick,
        value: raceType,
        disabled: !hasAccess
    }, void 0, _jsx('span', {
        className: 'hp-raceRecords__filterButton'
    }, void 0, _jsx('span', {
        className: 'hp-raceRecords__label'
    }, void 0, xnLabel[raceType] ? _jsx(_Abbr2.default, {
        title: raceType
    }, void 0, xnLabel[raceType]) : raceType), isSelected && _ref2));
};

exports.default = FilterBtn;

/***/ }),
/* 1140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1141);

var _columns2 = _interopRequireDefault(_columns);

var _FigureRow = __webpack_require__(1138);

var _FigureRow2 = _interopRequireDefault(_FigureRow);

var _mergeWithMR = __webpack_require__(1142);

var _mergeWithMR2 = _interopRequireDefault(_mergeWithMR);

var _dataPropTypes = __webpack_require__(400);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('h2', {
    className: 'hp-raceRecords__title'
}, void 0, 'Race Record');

var RaceRecords = function RaceRecords(_ref) {
    var figures = _ref.figures,
        data = _ref.data,
        onFilterClick = _ref.onFilterClick,
        selectedFilter = _ref.selectedFilter,
        isMRShown = _ref.params.mr.isShown,
        hasAccess = _ref.hasAccess;
    return _jsx('section', {
        className: 'hp-raceRecords'
    }, void 0, _jsx('div', {
        className: 'hp-raceRecords__header'
    }, void 0, _ref2, _jsx('div', {}, void 0, Object.keys(figures).map(function (key) {
        return _jsx(_FigureRow2.default, {
            figures: figures[key],
            type: key
        }, key);
    }))), _jsx(_rpReactTable2.default, {
        data: isMRShown ? (0, _mergeWithMR2.default)(data) : data.raceRecords,
        className: (0, _classnames2.default)('hp-raceRecords', isMRShown && 'hp-raceRecords__my-ratings'),
        columns: (0, _columns2.default)(onFilterClick, selectedFilter, hasAccess),
        uiType: 2,
        initialSortIdx: 10,
        noDataText: 'No race record for this horse'
    }));
};

exports.default = RaceRecords;

/***/ }),
/* 1141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _FilterBtn = __webpack_require__(1139);

var _FilterBtn2 = _interopRequireDefault(_FilterBtn);

var _money = __webpack_require__(39);

var _number = __webpack_require__(97);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_Abbr2.default, {
    title: 'wins',
    breakpoint: 'fromMedium'
}, void 0, 'wins runs');

var columns = function columns(onFilterClick, selectedFilter, hasAccess) {
    return [{
        key: 'raceType',
        header: 'lifetime record',
        cell: function cell(_ref) {
            var raceType = _ref.raceType;
            return _jsx(_FilterBtn2.default, {
                raceType: raceType,
                onClick: onFilterClick,
                isSelected: raceType === selectedFilter,
                hasAccess: hasAccess
            });
        }
    }, {
        key: 'starts',
        header: 'runs'
    }, {
        key: 'wins',
        header: function header() {
            return _ref2;
        },
        cell: function cell(_ref3) {
            var wins = _ref3.wins,
                starts = _ref3.starts;
            return _jsx('span', {}, void 0, wins, _jsx('span', {
                className: 'hidden-md-up'
            }, void 0, '/', starts));
        }
    }, {
        key: '2nds'
    }, {
        key: '3rds'
    }, {
        key: 'winPrize',
        header: 'winnings',
        cell: function cell(_ref4) {
            var netWinPrize = _ref4.netWinPrize;
            return (0, _money.formatMoney)(netWinPrize);
        }
    }, {
        key: 'totalPrize',
        header: 'prize',
        cell: function cell(_ref5) {
            var netTotalPrize = _ref5.netTotalPrize;
            return (0, _money.formatPrize)(netTotalPrize);
        }

    }, {
        key: 'totalPrizeFormatted',
        header: 'earnings',
        cell: function cell(_ref6) {
            var netTotalPrize = _ref6.netTotalPrize;
            return (0, _money.formatMoney)(netTotalPrize);
        }
    }, {
        key: 'or+',
        header: 'or',
        cell: (0, _number.zeroToDash)('or+'),
        sortFn: (0, _number.numericAndDashSort)('or+')
    }, {
        key: 'bestTs',
        cell: (0, _number.zeroToDash)('bestTs')
    }, {
        key: 'bestRpr',
        cell: (0, _number.zeroToDash)('bestRpr')
    }, {
        key: 'myRating',
        header: 'best mr'
    }];
};

exports.default = columns;

/***/ }),
/* 1142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _filterArrays = __webpack_require__(611);

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

exports.default = function (_ref) {
    var _ref$form = _ref.form,
        form = _ref$form === undefined ? [] : _ref$form,
        myRatings = _ref.myRatings,
        _ref$raceRecords = _ref.raceRecords,
        raceRecords = _ref$raceRecords === undefined ? [] : _ref$raceRecords;

    if (!myRatings) {
        return raceRecords;
    }

    var hasRating = function hasRating(id) {
        return Boolean(myRatings[id]);
    };
    var findRaceById = function findRaceById(id) {
        return form.find(function (_ref2) {
            var uid = _ref2.raceInstanceUid;
            return Number(id) === uid;
        });
    };

    var preparedData = Object.keys(myRatings).filter(hasRating).map(function (id) {
        var _findRaceById = findRaceById(id),
            raceTypeCode = _findRaceById.raceTypeCode;

        return raceTypeCode ? {
            type: (0, _filterArrays.findTypeByCode)(raceTypeCode),
            rating: myRatings[id]
        } : {};
    }).reduce(function (acc, _ref3) {
        var type = _ref3.type,
            rating = _ref3.rating;
        return _extends({}, acc, _defineProperty({}, type, Math.max(acc[type] || 0, rating)));
    }, {});

    return raceRecords.map(function (row) {
        return _extends({}, row, {
            myRating: preparedData[row.raceType]
        });
    });
};

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _moment = __webpack_require__(73);

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__(9);

var _object = __webpack_require__(300);

var _date = __webpack_require__(18);

var _helper = __webpack_require__(230);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getSpecialRow = function getSpecialRow(specialText, raceDatetime) {
    return {
        isSpecial: true,
        raceDatetime: raceDatetime,
        specialText: specialText
    };
};

var geldRow = getSpecialRow.bind(null, 'Gelded notification');
var windRow = function windRow(_ref) {
    var medicalDate = _ref.medicalDate,
        medicalType = _ref.medicalType;
    return getSpecialRow(medicalType, medicalDate);
};

var trainersRows = function trainersRows(previousTrainers, currentTrainer) {
    return previousTrainers.sort((0, _date.sortByDate)('trainerChangeDate')).map(function (_ref2, i) {
        var trainerChangeDate = _ref2.trainerChangeDate,
            trainer = _objectWithoutProperties(_ref2, ['trainerChangeDate']);

        return {
            isSpecial: true,
            raceDatetime: trainerChangeDate,
            trainerFrom: trainer,
            trainerTo: previousTrainers[i - 1] || currentTrainer
        };
    });
};

var isMoreThen50Days = function isMoreThen50Days(daysCount) {
    return daysCount >= 50;
};

var DATE_FORMAT = 'YYYY-MM-DD';

var breakRows = function breakRows(form) {
    return (0, _lodash.sortBy)(form, 'raceDatetime').filter(_helper.isRunner).map(function (row, i, arr) {
        return i < arr.length ? { prev: row, next: arr[i + 1] } : null;
    }).reduce(function (acc, current) {
        var prev = current.prev,
            next = current.next;

        if (!prev || !next) {
            return acc;
        }

        var day = (0, _moment2.default)(prev.raceDatetime).format(DATE_FORMAT);
        var timePrev = (0, _moment2.default)(day);
        day = (0, _moment2.default)(next.raceDatetime).format(DATE_FORMAT);
        var timeNext = (0, _moment2.default)(day);
        var daysBreak = Math.abs(timePrev.diff(timeNext, 'days'));

        return isMoreThen50Days(daysBreak) ? [].concat(_toConsumableArray(acc), [{
            raceDatetime: (0, _moment2.default)(next.raceDatetime).subtract(1, 'second').format(),
            daysBreak: daysBreak,
            isSpecial: true }]) : acc;
    }, []);
};

var transformData = function transformData(data) {
    if (!data) return {};

    var _data$raceRecords = data.raceRecords,
        records = _data$raceRecords.lifetimeRecords,
        jumps = _data$raceRecords.jumpsFiguresCalculated,
        flat = _data$raceRecords.flatFiguresCalculated,
        _data$profile = data.profile,
        dateGelded = _data$profile.dateGelded,
        previousTrainers = _data$profile.previousTrainers,
        trainerUid = _data$profile.trainerUid,
        trainerStyleName = _data$profile.trainerName,
        medical = _data$profile.medical,
        form = data.form;

    var currentTrainer = { trainerStyleName: trainerStyleName, trainerUid: trainerUid };
    var gelded = dateGelded ? [geldRow(dateGelded)] : [];
    var medicalData = medical ? medical.map(windRow) : [];
    var trainers = previousTrainers ? trainersRows(previousTrainers, currentTrainer) : [];
    var breaks = (0, _helper.duplicateArrayVals)(breakRows([].concat(_toConsumableArray(Object.values(form)))));

    var specialRows = [].concat(_toConsumableArray(medicalData), gelded, _toConsumableArray(trainers), _toConsumableArray(breaks));

    return {
        records: (0, _object.fromObjToArray)(records, 'raceType'),
        figures: { jumps: jumps, flat: flat },
        form: [].concat(_toConsumableArray(Object.values(form)), _toConsumableArray(specialRows)),
        hasSpecial: !!specialRows.length
    };
};

exports.default = transformData;

/***/ }),
/* 1144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _axios = __webpack_require__(127);

var _axios2 = _interopRequireDefault(_axios);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _lodash = __webpack_require__(9);

var _RunnerSelect = __webpack_require__(1145);

var _RunnerSelect2 = _interopRequireDefault(_RunnerSelect);

var _StudFee = __webpack_require__(1146);

var _StudFee2 = _interopRequireDefault(_StudFee);

var _NameContainer = __webpack_require__(612);

var _NameContainer2 = _interopRequireDefault(_NameContainer);

var _horse = __webpack_require__(161);

var horseUtils = _interopRequireWildcard(_horse);

var _Image = __webpack_require__(623);

var _Image2 = _interopRequireDefault(_Image);

var _horseTracker = __webpack_require__(1248);

var _horseTracker2 = _interopRequireDefault(_horseTracker);

var _Standing = __webpack_require__(609);

var _Standing2 = _interopRequireDefault(_Standing);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NameRow = function (_PureComponent) {
    _inherits(NameRow, _PureComponent);

    function NameRow(props) {
        _classCallCheck(this, NameRow);

        var _this = _possibleConstructorReturn(this, (NameRow.__proto__ || Object.getPrototypeOf(NameRow)).call(this, props));

        _this.state = {
            fetched: false,
            runners: []
        };
        return _this;
    }

    _createClass(NameRow, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var hash = this.props.params.hash;


            if (!hash) {
                return;
            }

            var raceId = hash.split('=').pop();
            this.fetchData(raceId);
        }
    }, {
        key: 'fetchData',
        value: function fetchData(raceId) {
            var _this2 = this;

            _axios2.default.get('horse/data/cardrunners/' + raceId + '.json').then(function (_ref) {
                var runners = _ref.data.runners;

                _this2.setState({
                    runners: (0, _lodash.sortBy)(runners, 'startNumber'),
                    fetched: true
                });
            }).catch(function (error) {
                return console.warn(error);
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                runners = _state.runners,
                fetched = _state.fetched;
            var _props = this.props,
                imagesHost = _props.imagesHost,
                profile = _props.profile,
                params = _props.params,
                isMobile = _props.isMobile,
                isWeatherbysSire = _props.isWeatherbysSire;
            var horseName = profile.horseName,
                horseUid = profile.horseUid,
                horseCountryOriginCode = profile.horseCountryOriginCode,
                silkImagePath = profile.silkImagePath,
                studFee = profile.studFee;


            var horseType = horseUtils.getHorseType(profile);
            var hasProgeny = horseUtils.hasProgeny(profile);

            var selectedHorseIndex = runners.findIndex(function (r) {
                return r.horseUid === horseUid;
            });

            var nameRowClass = (0, _classnames2.default)('hp-nameRow', hasProgeny && 'hp-nameRow_pedigree', params.hash && 'hp-nameRow_inSelect');

            var horseTypeClassName = (0, _classnames2.default)(isWeatherbysSire && 'hp-nameRow__progenyIcon--hidden');

            return _jsx('div', {}, void 0, hasProgeny && _jsx('span', {
                className: 'hp-nameRow__progenyIcon'
            }, void 0, _jsx(_rpReactSvgIcon2.default, {
                className: horseTypeClassName,
                iconName: horseType,
                size: (0, _lodash.capitalize)(horseType)
            })), _jsx('div', {
                className: nameRowClass
            }, void 0, _jsx('div', {
                className: 'hp-nameRow__horseDetails'
            }, void 0, silkImagePath && _jsx(_Image2.default, {
                src: imagesHost + '/png_silks/' + silkImagePath + '.png',
                imgHost: imagesHost,
                imgClass: 'hp-nameRow__silk',
                alt: 'Horse Profile - Jockey Colours'
            }), fetched && selectedHorseIndex > -1 ? _jsx(_RunnerSelect2.default, {
                runners: runners,
                selectedHorseIndex: selectedHorseIndex
            }) : _jsx(_NameContainer2.default, {
                horseName: horseName,
                countryCode: horseCountryOriginCode
            }), isMobile && profile.weatherbysUid ? _jsx(_horseTracker2.default, {
                profile: profile
            }) : ''), _jsx('div', {
                className: 'hp-nameRow__rightContainer'
            }, void 0, profile && profile.weatherbysUid ? _react2.default.createElement(_Standing2.default, _extends({ key: 'Standing' }, profile)) : '', _jsx(_StudFee2.default, {
                isWeatherbys: profile.weatherbysUid,
                data: studFee
            }), isMobile && profile.weatherbysUid ? '' : _jsx(_horseTracker2.default, {
                profile: profile
            }))));
        }
    }]);

    return NameRow;
}(_react.PureComponent);

exports.default = NameRow;

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpPopup = __webpack_require__(390);

var _rpGuiGuide = __webpack_require__(126);

var _Select = __webpack_require__(402);

var _Select2 = _interopRequireDefault(_Select);

var _NameContainer = __webpack_require__(612);

var _NameContainer2 = _interopRequireDefault(_NameContainer);

var _url = __webpack_require__(232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RunnerSelect = function (_PureComponent) {
    _inherits(RunnerSelect, _PureComponent);

    function RunnerSelect() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, RunnerSelect);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RunnerSelect.__proto__ || Object.getPrototypeOf(RunnerSelect)).call.apply(_ref, [this].concat(args))), _this), _this.onChange = function (val) {
            var selectedRunner = _this.props.runners[+val];
            var url = (0, _url.buildProfileUrl)(selectedRunner.horseUid, selectedRunner.horseName, 'horse');
            var urlToRedirect = url + '#race-id=' + selectedRunner.raceInstanceUid;

            if (_rpGuiGuide.mobileDetect.mobile()) {
                _rpPopup.journeyHandler.trackJourney(urlToRedirect);
            }
            window.location.href = urlToRedirect;
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(RunnerSelect, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                runners = _props.runners,
                selectedHorseIndex = _props.selectedHorseIndex;
            var _runners$selectedHors = runners[selectedHorseIndex],
                horseName = _runners$selectedHors.horseName,
                countryOriginCode = _runners$selectedHors.countryOriginCode,
                startNumber = _runners$selectedHors.startNumber;


            var options = runners.map(function (r) {
                return r.startNumber + '. ' + r.horseName + ' (' + r.countryOriginCode + ')';
            });

            return _jsx(_Select2.default, {
                value: selectedHorseIndex,
                options: options,
                onSelect: this.onChange,
                wrapperClass: 'pp-select_runners ui-btn_hollow'
            }, void 0, _jsx(_NameContainer2.default, {
                horseName: horseName,
                countryCode: countryOriginCode,
                number: startNumber
            }));
        }
    }]);

    return RunnerSelect;
}(_react.PureComponent);

exports.default = RunnerSelect;

/***/ }),
/* 1146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _money = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StudFee = function StudFee(_ref) {
    var data = _ref.data,
        isWeatherbys = _ref.isWeatherbys;

    if (!data || !data.length) {
        return null;
    }

    var _data$ = data[0],
        nominationFee = _data$.nominationFee,
        studFeeCondition = _data$.studFeeCondition,
        curCode = _data$.curCode,
        nominationYear = _data$.nominationYear;


    var nomination = (0, _lodash.toLower)(studFeeCondition) === 'private' ? 'Private' : (0, _money.formatSalePrice)(nominationFee, curCode);

    if (isWeatherbys) {
        return nomination === '—' ? null : _jsx('span', {
            className: 'hp-nameRow__studFee hp-nameRow__studFee--justifyContentCenter'
        }, void 0, _jsx('span', {
            className: 'hp-nameRow__studFee__value hp-nameRow__studFee__value--weatherbys'
        }, void 0, nomination));
    }

    return nomination === '—' ? null : _jsx('span', {
        className: 'hp-nameRow__studFee'
    }, void 0, _jsx('span', {
        className: 'hp-nameRow__studFee__value'
    }, void 0, nomination), nominationYear && _jsx('span', {
        className: 'hp-nameRow__studFee__label'
    }, void 0, nominationYear, ' stud fee'));
};

exports.default = StudFee;

/***/ }),
/* 1147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _axios = __webpack_require__(127);

var _axios2 = _interopRequireDefault(_axios);

var _lodash = __webpack_require__(9);

var _rpReactTable = __webpack_require__(23);

var _columns = __webpack_require__(1148);

var _columns2 = _interopRequireDefault(_columns);

var _NickRow = __webpack_require__(1150);

var _NickRow2 = _interopRequireDefault(_NickRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var tableClassName = 'ui-table ui-table_type1 ui-table_sortable';
var initialSortIdx = 2;
var defaultSortIdx = initialSortIdx;
var perPage = 50;

var _ref = _jsx('tr', {
    className: 'ui-table__row'
}, void 0, _jsx('td', {
    colSpan: '8'
}, void 0, _jsx(_rpReactTable.NoData, {
    text: 'No nicks for this sire in the Racing Post database'
})));

var Nicks = function (_PureComponent) {
    _inherits(Nicks, _PureComponent);

    function Nicks(props) {
        _classCallCheck(this, Nicks);

        var _this = _possibleConstructorReturn(this, (Nicks.__proto__ || Object.getPrototypeOf(Nicks)).call(this, props));

        _initialiseProps.call(_this);

        var _props$data$nick = props.data.nick,
            data = _props$data$nick === undefined ? [] : _props$data$nick;


        var bindedColumns = (0, _columns2.default)(_this.onIconClick);
        _this.columns = (0, _rpReactTable.addSortFns)(bindedColumns, true);

        var tableData = (0, _rpReactTable.sortData)((0, _rpReactTable.addIds)(data), _this.columns, initialSortIdx, defaultSortIdx);

        _this.state = {
            tableData: tableData,
            sortIdx: initialSortIdx,
            itemsShown: perPage,
            expandedRowIds: [],
            dataStorage: {}
        };
        return _this;
    }

    _createClass(Nicks, [{
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                tableData = _state.tableData,
                sortIdx = _state.sortIdx,
                itemsShown = _state.itemsShown,
                expandedRowIds = _state.expandedRowIds,
                dataStorage = _state.dataStorage;


            return _jsx('section', {
                className: 'hp-nicks'
            }, void 0, _jsx('table', {
                className: tableClassName
            }, void 0, _jsx(_rpReactTable.Header, {
                columns: this.columns,
                sortIdx: sortIdx,
                sortable: !!tableData.length,
                sortTable: this.sortTable,
                onHeaderCellClick: this.sortTable
            }), !tableData.length && _ref, tableData.slice(0, itemsShown).map(function (rowData) {
                var expanded = expandedRowIds.includes(rowData.horseUid);

                return _jsx(_NickRow2.default, {
                    rowData: rowData,
                    columns: _this2.columns,
                    expanded: expanded,
                    data: expanded ? dataStorage[rowData.horseUid] : null
                }, rowData.horseUid);
            })), itemsShown < tableData.length && _jsx(_rpReactTable.ShowMore, {
                onClick: this.showMore
            }));
        }
    }]);

    return Nicks;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
    var _this3 = this;

    this.onIconClick = function (horseUid) {
        if (_this3.state.expandedRowIds.includes(horseUid)) {
            _this3.setState(function (_ref2) {
                var expandedRowIds = _ref2.expandedRowIds;
                return {
                    expandedRowIds: (0, _lodash.without)(expandedRowIds, horseUid)
                };
            });

            return;
        }

        _this3.setState(function (_ref3) {
            var expandedRowIds = _ref3.expandedRowIds;
            return {
                expandedRowIds: [].concat(_toConsumableArray(expandedRowIds), [horseUid])
            };
        });

        if (_this3.state.dataStorage[horseUid]) {
            return;
        }

        _axios2.default.get('horse/descendants/' + _this3.props.params.id + '/' + horseUid).then(function (_ref4) {
            var data = _ref4.data;

            _this3.setState(function (_ref5) {
                var dataStorage = _ref5.dataStorage;
                return {
                    dataStorage: _extends({}, dataStorage, _defineProperty({}, horseUid, data.nickDescendants || []))
                };
            });
        }).catch(console.warn);
    };

    this.showMore = function () {
        _this3.setState(function (state) {
            return {
                itemsShown: state.itemsShown + perPage
            };
        });
    };

    this.sortTable = function (idx) {
        _this3.setState(function (_ref6) {
            var tableData = _ref6.tableData;
            return {
                tableData: (0, _rpReactTable.sortData)(tableData, _this3.columns, idx, defaultSortIdx),
                sortIdx: idx,
                expandedRowIds: []
            };
        });
    };
};

exports.default = Nicks;

/***/ }),
/* 1148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _RatioCell = __webpack_require__(624);

var _RatioCell2 = _interopRequireDefault(_RatioCell);

var _ProfileLink = __webpack_require__(26);

var _money = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    className: 'hp-nicks__arrow tableShowIcon',
    iconName: 'down',
    size: 'Medium'
});

var columns = function columns(_onClick) {
    return [{
        key: 'arrow',
        header: ' ',
        cell: function cell(_ref) {
            var horseUid = _ref.horseUid,
                descendants = _ref.descendants;
            return descendants ? _jsx('button', {
                className: 'hp-nicks__expand',
                onClick: function onClick() {
                    return _onClick(horseUid);
                }
            }, void 0, _ref2) : null;
        }
    }, {
        key: 'styleName',
        header: "dam's sire",
        cell: function cell(_ref3) {
            var styleName = _ref3.styleName,
                horseUid = _ref3.horseUid;
            return _jsx(_ProfileLink.HorseLink, {
                horseStyleName: styleName,
                horseUid: horseUid
            });
        },
        sortFn: 'alphabetic'
    }, {
        key: 'winners',
        header: 'winners / runners',
        cell: function cell(_ref4) {
            var a = _ref4.winners,
                b = _ref4.runners;
            return _jsx(_RatioCell2.default, {
                a: a,
                b: b
            });
        }
    }, {
        key: 'winnersPercent',
        header: '%'
    }, {
        key: 'wins',
        header: 'wins / runs',
        cell: function cell(_ref5) {
            var a = _ref5.wins,
                b = _ref5.runs;
            return _jsx(_RatioCell2.default, {
                a: a,
                b: b
            });
        }
    }, {
        key: 'winsPercent',
        header: '%'
    }, {
        key: 'winPrizeMoney',
        header: 'winnings',
        cell: function cell(_ref6) {
            var winPrizeMoney = _ref6.winPrizeMoney;
            return (0, _money.formatMoney)(winPrizeMoney);
        }
    }, {
        key: 'totalMoney',
        header: 'total earnings',
        cell: function cell(_ref7) {
            var totalMoney = _ref7.totalMoney;
            return (0, _money.formatMoney)(totalMoney);
        }
    }];
};

exports.default = columns;

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref3 = _jsx('span', {}, void 0, 'No descendants found');

var DescendantsList = function DescendantsList(_ref) {
    var data = _ref.data;
    return data.length ? _jsx('ul', {
        className: 'hp-nicks__descendants'
    }, void 0, data.map(function (_ref2) {
        var horseUid = _ref2.horseUid,
            styleName = _ref2.styleName;
        return _jsx('li', {}, horseUid, _jsx(_ProfileLink.HorseLink, {
            horseUid: horseUid,
            horseStyleName: styleName,
            className: 'ui-link_marked'
        }));
    })) : _ref3;
};

exports.default = DescendantsList;

/***/ }),
/* 1150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _DescendantsList = __webpack_require__(1149);

var _DescendantsList2 = _interopRequireDefault(_DescendantsList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_rpReactTable.Loading, {});

var NicksRow = function (_PureComponent) {
    _inherits(NicksRow, _PureComponent);

    function NicksRow() {
        _classCallCheck(this, NicksRow);

        return _possibleConstructorReturn(this, (NicksRow.__proto__ || Object.getPrototypeOf(NicksRow)).apply(this, arguments));
    }

    _createClass(NicksRow, [{
        key: 'shouldComponentUpdate',
        value: function shouldComponentUpdate(nextProps) {
            var _props = this.props,
                data = _props.data,
                expanded = _props.expanded;

            if (data === nextProps.data && expanded === nextProps.expanded) {
                return false;
            }

            return true;
        }
    }, {
        key: 'render',
        value: function render() {
            var _props2 = this.props,
                rowData = _props2.rowData,
                columns = _props2.columns,
                expanded = _props2.expanded,
                data = _props2.data;


            return _jsx('tbody', {
                className: 'hp-nicks__row'
            }, void 0, _jsx(_rpReactTable.Row, {
                rowData: rowData,
                columns: columns
            }), expanded && _jsx('tr', {
                className: 'ui-table__row'
            }, void 0, _jsx('td', {
                colSpan: '8'
            }, void 0, data ? _jsx(_DescendantsList2.default, {
                data: data
            }) : _ref)));
        }
    }]);

    return NicksRow;
}(_react.PureComponent);

exports.default = NicksRow;

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _axios = __webpack_require__(127);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(279);

var _qs2 = _interopRequireDefault(_qs);

var _Note = __webpack_require__(1154);

var _Note2 = _interopRequireDefault(_Note);

var _ErrorNote = __webpack_require__(1153);

var _ErrorNote2 = _interopRequireDefault(_ErrorNote);

var _ActionRow = __webpack_require__(1152);

var _ActionRow2 = _interopRequireDefault(_ActionRow);

var _ErrorModal = __webpack_require__(622);

var _ErrorModal2 = _interopRequireDefault(_ErrorModal);

var _helpers = __webpack_require__(1155);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref3 = _jsx('div', {
    className: 'ui-divider'
});

var Notes = function (_PureComponent) {
    _inherits(Notes, _PureComponent);

    function Notes(props) {
        _classCallCheck(this, Notes);

        var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));

        _this.onSaveSuccess = function (data) {
            var notes = _this.state.notes;


            Object.keys(notes).forEach(function (key) {
                notes[key].isExists = !!data[key];
            });

            _this.setState({
                notes: _extends({}, notes),
                isSaveDisabled: true,
                isDataSaved: true
            });
        };

        _this.onSave = function () {
            var note = _this.state.notes;


            _axios2.default.post(_this.ajaxUrl, _qs2.default.stringify({ note: note })).then(function (_ref) {
                var data = _ref.data;

                var error = Object.keys(data).some(function (item) {
                    return data[item].error;
                });

                if (error) {
                    throw new Error();
                } else {
                    _this.onSaveSuccess(data);
                }
            }).catch(function () {
                return _this.setState({ error: 'postError' });
            });
        };

        _this.onClear = function () {
            var notes = (0, _helpers.initEmptyNotes)(_this.state.notes);
            _helpers.raceTypes.forEach(function (type) {
                notes[type].onChange = _this.onChange.bind(_this, type);
            });

            _this.setState({ notes: notes, isSaveDisabled: false, isDataSaved: false });
        };

        _this.onChange = function (raceType, event) {
            var _event$target = event.target,
                name = _event$target.name,
                value = _event$target.value;

            var notes = _extends({}, _this.state.notes);

            notes[raceType][name] = (0, _helpers.validateInput)(name, value);

            _this.setState({
                notes: notes,
                isSaveDisabled: false,
                isDataSaved: false
            });
        };

        _this.getNotes = function () {
            _axios2.default.get(_this.ajaxUrl).then(function (_ref2) {
                var _ref2$data = _ref2.data,
                    data = _ref2$data.data,
                    error = _ref2$data.error;

                if (error) {
                    throw new Error();
                } else {
                    _this.appendNotes(data);
                }
            }).catch(function () {
                return _this.setState({ error: 'getError' });
            });
        };

        _this.appendNotes = function (data) {
            var notes = _this.state.notes;

            var newNotes = data.reduce(function (acc, cur) {
                return _extends({}, acc, _defineProperty({}, cur.raceTypeCode, {
                    raceType: cur.raceTypeCode,
                    ratingFlag: cur.ratingFlag || '',
                    rating: cur.rating,
                    note: cur.comment || '',
                    isExists: true
                }));
            }, notes);

            _helpers.raceTypes.forEach(function (type) {
                newNotes[type].onChange = _this.onChange.bind(_this, type);
            });

            _this.setState({ notes: _extends({}, newNotes), error: null });
        };

        _this.hideErrorLightbox = function () {
            _this.setState({ error: null });
        };

        _this.state = {
            notes: (0, _helpers.initEmptyNotes)(),
            isSaveDisabled: true,
            isDataSaved: false,
            error: null
        };
        _this.ajaxUrl = (0, _helpers.getAjaxUrl)(_this.props.data.profile.horseUid);
        return _this;
    }

    _createClass(Notes, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.getNotes();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                notes = _state.notes,
                isSaveDisabled = _state.isSaveDisabled,
                isDataSaved = _state.isDataSaved,
                error = _state.error;

            var isGetErrorOccurred = error === 'getError';
            var isPostErrorOccurred = error === 'postError';

            return _jsx('section', {
                className: 'hp-notes__container'
            }, void 0, _jsx(_ActionRow2.default, {
                onSave: this.onSave,
                onClear: this.onClear,
                isDisabled: isSaveDisabled,
                isSaved: isDataSaved,
                isErrorOccurred: error
            }), _ref3, Object.entries(notes).map(function (_ref4) {
                var _ref5 = _slicedToArray(_ref4, 2),
                    type = _ref5[0],
                    value = _ref5[1];

                return isGetErrorOccurred ? _jsx(_ErrorNote2.default, {
                    raceType: type,
                    raceTypeName: _helpers.raceTypeNames[type],
                    onReload: _this2.getNotes
                }, type) : _react2.default.createElement(_Note2.default, _extends({}, value, {
                    raceTypeName: _helpers.raceTypeNames[type],
                    key: type
                }));
            }), _jsx(_ActionRow2.default, {
                onSave: this.onSave,
                onClear: this.onClear,
                isDisabled: isSaveDisabled,
                isSaved: isDataSaved,
                isErrorOccurred: error
            }), isPostErrorOccurred && _jsx(_ErrorModal2.default, {
                text: _helpers.errorMessageText,
                onClose: this.hideErrorLightbox
            }));
        }
    }]);

    return Notes;
}(_react.PureComponent);

exports.default = Notes;

/***/ }),
/* 1152 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {}, void 0, _jsx(_rpReactSvgIcon2.default, {
    iconName: 'tick',
    size: 'sizeNotesTick'
}), _jsx('span', {
    className: 'hp-notes__buttonLabel'
}, void 0, 'Saved'));

var ActionRow = function ActionRow(_ref) {
    var onClear = _ref.onClear,
        onSave = _ref.onSave,
        isDisabled = _ref.isDisabled,
        isSaved = _ref.isSaved,
        isErrorOccurred = _ref.isErrorOccurred;
    return _jsx('div', {
        className: 'hp-notes__actionRow'
    }, void 0, _jsx('div', {
        className: 'hp-notes__actionRowButtons'
    }, void 0, _jsx('button', {
        onClick: onClear,
        disabled: isErrorOccurred,
        className: 'hp-notes__button ui-btn ui-btn_secondary ui-btn_hollow'
    }, void 0, 'Clear'), _jsx('button', {
        onClick: onSave,
        disabled: isDisabled,
        className: (0, _classnames2.default)('hp-notes__button ui-btn ui-btn_primary ui-btn_major', isDisabled && 'ui-btn_disabled')
    }, void 0, isSaved ? _ref2 : 'Save')));
};

exports.default = ActionRow;

/***/ }),
/* 1153 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'ui-input hp-notes__input hp-notes__input_rating'
});

var _ref3 = _jsx('span', {
    className: 'ui-input hp-notes__input hp-notes__input_ratingFlag'
});

var _ref4 = _jsx('div', {
    className: 'ui-divider'
});

var ErrorNote = function ErrorNote(_ref) {
    var raceType = _ref.raceType,
        raceTypeName = _ref.raceTypeName,
        onReload = _ref.onReload;
    return _jsx('div', {}, void 0, _jsx('h3', {
        className: 'hp-notes__title'
    }, void 0, raceTypeName), _jsx('div', {
        className: 'hp-notes__note'
    }, void 0, _jsx('div', {
        className: 'hp-notes__fieldSet'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_note'
    }, void 0, _jsx('span', {
        className: 'hp-notes__label_type'
    }, void 0, raceTypeName), 'Note'), _jsx('div', {
        className: 'hp-notes__input_container'
    }, void 0, _jsx('div', {
        className: 'hp-notes__error'
    }, void 0, 'There\'s a technical problem that means notes and ratings content is currently unavailable. We are working to restore the service as fast as possible and are sorry for any inconvenience caused. Please click ', _jsx('span', {
        onClick: onReload,
        className: 'hp-notes__error__link'
    }, void 0, 'here'), ' to refresh the page or try again later.'))), _jsx('div', {
        className: 'hp-notes__fieldSetWrapper'
    }, void 0, _jsx('div', {
        className: 'hp-notes__fieldSet hp-notes__fieldSet_rating'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_rating'
    }, void 0, 'Rating'), _ref2), _jsx('div', {
        className: 'hp-notes__fieldSet hp-notes__fieldSet_ratingFlag'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_ratingFlag'
    }, void 0, '+/-'), _ref3))), _ref4);
};

exports.default = ErrorNote;

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _reactTextareaAutosize = __webpack_require__(952);

var _reactTextareaAutosize2 = _interopRequireDefault(_reactTextareaAutosize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'hp-notes__icon'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    iconName: 'note',
    size: 'Medium'
}));

var _ref3 = _jsx('div', {
    className: 'ui-divider'
});

var Note = function Note(_ref) {
    var raceType = _ref.raceType,
        raceTypeName = _ref.raceTypeName,
        rating = _ref.rating,
        ratingFlag = _ref.ratingFlag,
        note = _ref.note,
        onChange = _ref.onChange;
    return _jsx('div', {}, void 0, _jsx('h3', {
        className: 'hp-notes__title'
    }, void 0, raceTypeName), _jsx('div', {
        className: 'hp-notes__note'
    }, void 0, _jsx('div', {
        className: 'hp-notes__fieldSet'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_note'
    }, void 0, _jsx('span', {
        className: 'hp-notes__label_type'
    }, void 0, raceTypeName), 'Note'), _jsx('div', {
        className: (0, _classnames2.default)('hp-notes__input_container', note && 'hp-notes__icon_hidden')
    }, void 0, _jsx(_reactTextareaAutosize2.default, {
        onChange: onChange,
        name: 'note',
        value: note,
        id: raceType + '_note',
        rows: 1,
        maxLength: 250,
        className: 'ui-input hp-notes__input'
    }), _ref2)), _jsx('div', {
        className: 'hp-notes__fieldSetWrapper'
    }, void 0, _jsx('div', {
        className: 'hp-notes__fieldSet hp-notes__fieldSet_rating'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_rating'
    }, void 0, 'Rating'), _jsx('input', {
        onChange: onChange,
        type: 'text',
        name: 'rating',
        value: rating,
        id: raceType + '_rating',
        maxLength: 3,
        className: 'ui-input hp-notes__input hp-notes__input_rating'
    })), _jsx('div', {
        className: 'hp-notes__fieldSet hp-notes__fieldSet_ratingFlag'
    }, void 0, _jsx('label', {
        className: 'hp-notes__label',
        htmlFor: raceType + '_ratingFlag'
    }, void 0, '+/-'), _jsx('input', {
        onChange: onChange,
        type: 'text',
        name: 'ratingFlag',
        value: ratingFlag,
        id: raceType + '_ratingFlag',
        maxLength: 1,
        className: 'ui-input hp-notes__input hp-notes__input_ratingFlag'
    })))), _ref3);
};

exports.default = Note;

/***/ }),
/* 1155 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var raceTypeNames = exports.raceTypeNames = {
    F: 'Flat Turf and NHF',
    X: 'All Weather',
    H: 'Hurdle',
    C: 'Chase'
};

var raceTypes = exports.raceTypes = Object.keys(raceTypeNames);

var initEmptyNotes = exports.initEmptyNotes = function initEmptyNotes(existingNotes) {
    return raceTypes.reduce(function (acc, type) {
        return _extends({}, acc, _defineProperty({}, type, {
            raceType: type,
            ratingFlag: '',
            rating: '',
            note: '',
            isExists: existingNotes && existingNotes[type].isExists || false
        }));
    }, {});
};

var errorMessageText = exports.errorMessageText = 'Something\'s gone wrong \n     and your changes could not be saved. \n     Press save to try again.';

var getAjaxUrl = exports.getAjaxUrl = function getAjaxUrl(horseUid) {
    return 'horse/ugc/' + horseUid;
};

var validateInput = exports.validateInput = function validateInput(name, value) {
    var rating = value;
    if (name === 'rating') {
        rating = value.replace(/[^0-9]/g, '');
        rating = +rating > 500 ? 500 : rating;
    }

    return rating;
};

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FamilyTree = __webpack_require__(1158);

var _FamilyTree2 = _interopRequireDefault(_FamilyTree);

var _FamilyTreeSummary = __webpack_require__(1159);

var _FamilyTreeSummary2 = _interopRequireDefault(_FamilyTreeSummary);

var _FlatJumpsTables = __webpack_require__(613);

var _FlatJumpsTables2 = _interopRequireDefault(_FlatJumpsTables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Pedigree = function Pedigree(_ref) {
    var _ref$data = _ref.data,
        pedigree = _ref$data.pedigree,
        relatives = _ref$data.relatives,
        weatherbysPedigreeUrl = _ref$data.weatherbysPedigreeUrl;
    return _jsx('section', {}, void 0, _react2.default.createElement(_FamilyTreeSummary2.default, pedigree), _jsx('p', {}, void 0, pedigree.rpFormText), !weatherbysPedigreeUrl && _jsx(_FamilyTree2.default, {
        pedigree: pedigree
    }), _jsx(_FlatJumpsTables2.default, {
        data: relatives || {},
        disclaimerName: 'Relatives',
        flatTitle: 'Relatives - Flat (GB & IRE)',
        jumpsTitle: 'Relatives - jumps (GB & IRE)',
        flatNoData: 'No relatives that ran on the Flat in our records',
        jumpsNoData: 'No relatives that ran over jumps in our records'
    }));
};

exports.default = Pedigree;

/***/ }),
/* 1157 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(18);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'hp-familyTree__block'
});

var FamilyLeaf = function FamilyLeaf(_ref) {
    var data = _ref.data;

    if (data && data.horseName) {
        var horseUid = data.horseUid,
            horseName = data.horseName,
            countryOriginCode = data.countryOriginCode,
            horseDateOfBirth = data.horseDateOfBirth;

        return _jsx(_ProfileLink.HorseLink, {
            className: 'hp-familyTree__block',
            horseUid: horseUid,
            horseStyleName: horseName
        }, void 0, _jsx('span', {
            className: 'hp-familyTree__block__name'
        }, void 0, _jsx('span', {
            className: 'hp-familyTree__block__horseName'
        }, void 0, horseName, _jsx('span', {
            className: 'hp-familyTree__block__code'
        }, void 0, ' (' + countryOriginCode + ') ')), _jsx('span', {
            className: 'hp-familyTree__block__yob'
        }, void 0, horseDateOfBirth && (0, _date.formatDate)(horseDateOfBirth, 'YYYY'))));
    }
    return _ref2;
};

exports.default = FamilyLeaf;

/***/ }),
/* 1158 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FamilyLeaf = __webpack_require__(1157);

var _FamilyLeaf2 = _interopRequireDefault(_FamilyLeaf);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {
    className: 'hp-familyTree__branches'
}, void 0, _jsx('div', {
    className: 'hp-familyTree__branch'
}));

var _ref3 = _jsx('div', {
    className: 'hp-familyTree__branches'
}, void 0, _jsx('div', {
    className: 'hp-familyTree__branch'
}));

var _ref4 = _jsx('div', {
    className: 'hp-familyTree__branches'
}, void 0, _jsx('div', {
    className: 'hp-familyTree__branch'
}));

var FamilyTree = function FamilyTree(_ref) {
    var pedigree = _ref.pedigree;
    return _jsx('div', {
        className: 'hp-familyTree hp-pedigree__familyTree hidden-sm-down'
    }, void 0, _jsx('div', {
        className: 'hp-familyTree__leaf'
    }, void 0, _jsx(_FamilyLeaf2.default, {
        data: pedigree
    })), _jsx('div', {
        className: 'hp-familyTree__stage hp-familyTree__stage_second'
    }, void 0, _ref2, _jsx('div', {
        className: 'hp-familyTree__leaf'
    }, void 0, _jsx(_FamilyLeaf2.default, {
        data: pedigree.sire
    }), _jsx(_FamilyLeaf2.default, {
        data: pedigree.dam
    }))), _jsx('div', {
        className: 'hp-familyTree__stage hp-familyTree__stage_third'
    }, void 0, _jsx('div', {
        className: 'hp-familyTree__section'
    }, void 0, _ref3, _jsx('div', {
        className: 'hp-familyTree__leaf'
    }, void 0, _jsx(_FamilyLeaf2.default, {
        data: pedigree.sire && pedigree.sire.sire
    }), _jsx(_FamilyLeaf2.default, {
        data: pedigree.sire && pedigree.sire.dam
    }))), _jsx('div', {
        className: 'hp-familyTree__section'
    }, void 0, _ref4, _jsx('div', {
        className: 'hp-familyTree__leaf'
    }, void 0, _jsx(_FamilyLeaf2.default, {
        data: pedigree.dam && pedigree.dam.sire
    }), _jsx(_FamilyLeaf2.default, {
        data: pedigree.dam && pedigree.dam.dam
    })))));
};

var horseTypes = {
    countryOriginCode: _propTypes2.default.string,
    horseDateOfBirth: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number
};
var horseShape = _propTypes2.default.shape(horseTypes);
var sireOrDamShape = _propTypes2.default.shape(_extends({}, horseTypes, {
    sire: horseShape,
    dam: horseShape
}));

exports.default = FamilyTree;

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _HorseDefinition = __webpack_require__(294);

var _HorseDefinition2 = _interopRequireDefault(_HorseDefinition);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FamilyTreeSummary = function FamilyTreeSummary(_ref) {
    var sire = _ref.sire,
        dam = _ref.dam;
    return _jsx('dl', {
        className: 'hidden-md-up'
    }, void 0, sire && _react2.default.createElement(_HorseDefinition2.default, _extends({}, sire, {
        term: 'Sire',
        avgFlatWinDist: sire.avgFlatWinDistOfProgeny
    })), dam && _react2.default.createElement(_HorseDefinition2.default, _extends({}, dam, {
        term: 'Dam',
        avgFlatWinDist: dam.avgFlatWinDistOfProgeny
    })), dam && dam.sire && _react2.default.createElement(_HorseDefinition2.default, _extends({}, dam.sire, {
        term: 'Dam\'s Sire',
        avgFlatWinDist: dam.sire.avgFlatWinDistOfProgeny
    })));
};

var horseTypes = {
    avgFlatWinDistOfProgeny: _propTypes2.default.number,
    countryOriginCode: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number
};
exports.default = FamilyTreeSummary;

/***/ }),
/* 1160 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('br', {});

var HorseSireCell = function HorseSireCell(_ref) {
    var avgFlatWinDistOfProgeny = _ref.avgFlatWinDistOfProgeny,
        countryOriginCode = _ref.countryOriginCode,
        horseName = _ref.horseName,
        horseSexCode = _ref.horseSexCode,
        horseUid = _ref.horseUid,
        horseYob = _ref.horseYob,
        sireStyleName = _ref.sireStyleName,
        sireCountryOriginCode = _ref.sireCountryOriginCode,
        sireUid = _ref.sireUid,
        stakesWinnerOrPlaced = _ref.stakesWinnerOrPlaced;
    return _jsx('div', {}, void 0, _jsx(_ProfileLink.HorseLink, {
        className: stakesWinnerOrPlaced && 'hp-relatives__stakesPlaced',
        horseStyleName: horseName,
        horseUid: horseUid
    }), _jsx('span', {
        className: 'hp-relatives__horseInfo'
    }, void 0, countryOriginCode && ' (' + countryOriginCode + ') ', horseYob, (0, _lodash.toLower)(horseSexCode)), _ref2, _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked',
        horseStyleName: sireStyleName,
        horseUid: sireUid
    }), sireCountryOriginCode && ' (' + sireCountryOriginCode + ')', avgFlatWinDistOfProgeny && ' ' + avgFlatWinDistOfProgeny + 'f');
};

exports.default = HorseSireCell;

/***/ }),
/* 1161 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1163);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RelativesTable = function RelativesTable(_ref) {
    var data = _ref.data,
        title = _ref.title,
        noDataText = _ref.noDataText;
    return _jsx('section', {
        className: 'hp-relatives'
    }, void 0, _jsx('h2', {
        className: 'hp-relatives__title'
    }, void 0, title), _jsx(_rpReactTable2.default, {
        columns: _columns2.default,
        data: data,
        initialSortIdx: 8,
        noDataText: noDataText,
        sortable: true
    }));
};

exports.default = RelativesTable;

/***/ }),
/* 1162 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('strong', {}, void 0, 'bold');

var _ref3 = _jsx('p', {
    className: 'pp-bottomText__progenyInfo'
}, void 0, 'Details of horses trained outside GB and Ireland or born prior to 1986 may be incomplete.');

var RelativesTableDisclaimer = function RelativesTableDisclaimer(_ref) {
    var type = _ref.type;
    return _jsx('div', {
        className: 'pp-bottomText'
    }, void 0, _jsx('p', {
        className: 'pp-bottomText__progenyInfo'
    }, void 0, type, ' in ', _ref2, ' are stakes placed. Trainer listed is trainer with whom horse achieved highest RPR.'), _ref3);
};

exports.default = RelativesTableDisclaimer;

/***/ }),
/* 1163 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(39);

var _distance = __webpack_require__(113);

var _ProfileLink = __webpack_require__(26);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _HorseSireCell = __webpack_require__(1160);

var _HorseSireCell2 = _interopRequireDefault(_HorseSireCell);

var _number = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    breakpoint: 'fromMedium',
    title: 'placed'
}, void 0, 'pld');

var _ref4 = _jsx(_Abbr2.default, {
    breakpoint: 'fromMedium',
    title: 'distance'
}, void 0, 'dist.');

var columns = [{
    key: 'horseName',
    header: 'horse sire',
    cell: function cell(relativeData) {
        return _react2.default.createElement(_HorseSireCell2.default, relativeData);
    },
    sortFn: 'alphabetic'
}, {
    key: 'wins'
}, {
    key: 'runs'
}, {
    key: 'winPercent',
    header: '%'
}, {
    key: 'places',
    header: function header() {
        return _ref;
    }
}, {
    key: 'trainerName',
    header: 'trainer',
    cell: function cell(_ref2) {
        var trainerName = _ref2.trainerName,
            trainerUid = _ref2.trainerUid;
        return _jsx(_ProfileLink.TrainerLink, {
            className: 'ui-link_marked',
            trainerStyleName: trainerName,
            trainerUid: trainerUid
        });
    },
    sortFn: 'byLastName'
}, {
    key: 'totalPrizeMoney',
    header: 'total earnings',
    cell: function cell(_ref3) {
        var totalPrizeMoney = _ref3.totalPrizeMoney;
        return (0, _money.formatMoney)(totalPrizeMoney);
    }
}, {
    key: 'distanceYard',
    header: function header() {
        return _ref4;
    },
    cell: function cell(_ref5) {
        var distanceYard = _ref5.distanceYard;
        return (0, _distance.yardsToFurlongs)(distanceYard) || '—';
    },
    sortFn: 'numericReverse'
}, {
    key: 'bestRpPostmark',
    header: 'best rpr',
    sortFn: (0, _number.numericAndDashSort)('bestRpPostmark')
}];

exports.default = columns;

/***/ }),
/* 1164 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Filter = __webpack_require__(142);

var _Filter2 = _interopRequireDefault(_Filter);

var _filter = __webpack_require__(144);

var _filter2 = _interopRequireDefault(_filter);

var _categories = __webpack_require__(616);

var _categories2 = _interopRequireDefault(_categories);

var _categoriesReducer = __webpack_require__(1165);

var _categoriesReducer2 = _interopRequireDefault(_categoriesReducer);

var _columns = __webpack_require__(1168);

var _columns2 = _interopRequireDefault(_columns);

var _columns3 = __webpack_require__(1167);

var _columns4 = _interopRequireDefault(_columns3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getColumns = function getColumns(tab) {
    return !tab || tab === 'progeny' ? _columns2.default : _columns4.default;
};

var _ref2 = _jsx('div', {
    className: 'pp-bottomText'
}, void 0, 'Details of horses trained outside GB and Ireland or born prior to 1986 may be incomplete. OR Rating is the latest published.');

var _ref3 = _jsx('div', {
    className: 'pp-bottomText'
}, void 0, 'Progeny in magenta coloured text denotes a female horse.');

var ProgenyCommon = function (_FilteringComponent) {
    _inherits(ProgenyCommon, _FilteringComponent);

    function ProgenyCommon(props) {
        _classCallCheck(this, ProgenyCommon);

        var _this = _possibleConstructorReturn(this, (ProgenyCommon.__proto__ || Object.getPrototypeOf(ProgenyCommon)).call(this, props));

        _initialiseProps.call(_this);

        var _props$data = props.data,
            progenyHorses = _props$data.progenyHorses,
            damSireProgenyHorses = _props$data.damSireProgenyHorses,
            seasonInfo = _props$data.seasonInfo;

        var _ref = props.availableSeasonsData.data || {},
            seasonsAvailable = _ref.seasonsAvailable;

        _this.state = {
            data: progenyHorses || damSireProgenyHorses,
            categories: seasonsAvailable && (0, _categories2.default)(seasonsAvailable, seasonInfo),
            loading: false,
            fetchError: false
        };
        return _this;
    }

    _createClass(ProgenyCommon, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.onFilterApply(this.state.categories);
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                data = _state.data,
                categories = _state.categories,
                loading = _state.loading,
                fetchError = _state.fetchError;
            var tab = this.props.tab;

            var columns = getColumns(tab);

            return _jsx('section', {
                className: 'hp-sire-progeny'
            }, void 0, categories && _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _categoriesReducer2.default,
                columns: columns,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: data,
                columns: columns,
                loading: loading,
                initialSortIdx: 8,
                sortable: true,
                resultsPerPage: 50,
                noDataText: 'No progeny for this sire in the Racing Post database'
            }), _ref2, _ref3);
        }
    }]);

    return ProgenyCommon;
}(_filter2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.buildUrl = function (_ref4) {
        var raceType = _ref4.raceType,
            timePeriod = _ref4.timePeriod;
        var _props = _this2.props,
            id = _props.id,
            tab = _props.tab;

        return 'horse/filter/' + (tab || 'progeny') + '/' + id + '/' + timePeriod + '/' + raceType;
    };

    this.onDataReceive = function (_ref5) {
        var progenyHorses = _ref5.progenyHorses,
            damSireProgenyHorses = _ref5.damSireProgenyHorses;

        _this2.setState({
            data: progenyHorses || damSireProgenyHorses || _this2.emptyData,
            loading: false
        });
    };
};

var SireProgenyType = {
    countryOriginCode: _propTypes2.default.string,
    damSireCountryOriginCode: _propTypes2.default.string,
    damSireStyleName: _propTypes2.default.string,
    damSireUid: _propTypes2.default.number,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    places: _propTypes2.default.number,
    rpPostmark: _propTypes2.default.number,
    runs: _propTypes2.default.number,
    totalPrizeMoney: _propTypes2.default.number,
    winPercent: _propTypes2.default.number,
    wins: _propTypes2.default.number
};

var DamsSireProgenyType = _extends({}, SireProgenyType, {
    bestOr: _propTypes2.default.number,
    horseAge: _propTypes2.default.number,
    horseSexCode: _propTypes2.default.string,
    sireCountryOriginCode: _propTypes2.default.string,
    sireStyleName: _propTypes2.default.string,
    sireUid: _propTypes2.default.number
});

ProgenyCommon.propTypes = {
    data: _propTypes2.default.shape({
        progenyHorses: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.shape(SireProgenyType), _propTypes2.default.shape(DamsSireProgenyType)])),
        seasonInfo: _propTypes2.default.shape({
            raceType: _propTypes2.default.string,
            seasonYearBegin: _propTypes2.default.number,
            seasonYearEnd: _propTypes2.default.number
        })
    }).isRequired,
    id: _propTypes2.default.string,
    tab: _propTypes2.default.string,
    availableSeasonsData: _propTypes2.default.shape({
        data: _propTypes2.default.shape({
            FLAT: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                seasonStartYear: _propTypes2.default.string,
                seasonEndYear: _propTypes2.default.string
            })),
            JUMPS: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                seasonStartYear: _propTypes2.default.string,
                seasonEndYear: _propTypes2.default.string
            }))
        })
    }),
    weatherbysUid: _propTypes2.default.string
};

exports.default = ProgenyCommon;

/***/ }),
/* 1165 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(616);

var getRaceType = function getRaceType(val) {
    return val.match(/jumps|flat/)[0];
};

var timePeriodReducer = function timePeriodReducer(timePeriod, action) {
    var _timePeriod$createdBy = timePeriod.createdBy,
        raceType = _timePeriod$createdBy.raceType,
        seasonsAvailable = _timePeriod$createdBy.seasonsAvailable;

    if (action.type === 'raceType') {
        var newRaceType = getRaceType(action.value);
        if (raceType !== newRaceType) {
            return (0, _categories.timePeriodsFactory)(newRaceType, seasonsAvailable);
        }
    }
    return timePeriod;
};

var categoriesReducer = function categoriesReducer(_ref, action) {
    var raceType = _ref.raceType,
        timePeriod = _ref.timePeriod;
    return {
        raceType: raceType,
        timePeriod: timePeriodReducer(timePeriod, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _FlatJumpsTables = __webpack_require__(613);

var _FlatJumpsTables2 = _interopRequireDefault(_FlatJumpsTables);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Progeny = function Progeny(_ref) {
    var data = _ref.data;
    return _jsx(_FlatJumpsTables2.default, {
        data: data,
        disclaimerName: 'Progeny',
        flatTitle: 'Flat',
        jumpsTitle: 'Jumps',
        flatNoData: 'No progeny results on the Flat in our records',
        jumpsNoData: 'No progeny results over jumps in our records'
    });
};

exports.default = Progeny;

/***/ }),
/* 1167 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(39);

var _ProfileLink = __webpack_require__(26);

var _HorseCell = __webpack_require__(615);

var _HorseCell2 = _interopRequireDefault(_HorseCell);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _number = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    title: 'horse'
}, void 0, 'horse / sire');

var _ref3 = _jsx(_Abbr2.default, {
    title: 'wins'
}, void 0, 'wins / runs');

var columns = [{
    key: 'horseName',
    header: function header() {
        return _ref;
    },
    cell: _HorseCell2.default,
    sortFn: 'alphabetic'
}, {
    key: 'sireStyleName',
    header: 'sire',
    cell: function cell(_ref2) {
        var sireStyleName = _ref2.sireStyleName,
            sireUid = _ref2.sireUid,
            sireCountryOriginCode = _ref2.sireCountryOriginCode;
        return _jsx('span', {}, void 0, _jsx(_ProfileLink.HorseLink, {
            className: 'ui-link_marked',
            horseStyleName: sireStyleName,
            horseUid: sireUid
        }), sireCountryOriginCode ? _jsx('span', {}, void 0, ' (' + sireCountryOriginCode + ')') : null);
    },
    sortFn: 'alphabetic'
}, {
    key: 'wins',
    header: function header() {
        return _ref3;
    },
    cell: function cell(_ref4) {
        var wins = _ref4.wins,
            runs = _ref4.runs;
        return _jsx('span', {}, void 0, _jsx('strong', {}, void 0, wins), _jsx('span', {
            className: 'hidden-sm-up'
        }, void 0, '/', runs));
    }
}, {
    key: 'runs'
}, {
    key: 'winPercent',
    header: '%'
}, {
    key: 'places',
    header: 'placed'
}, {
    key: 'totalPrizeMoney',
    header: 'total earnings',
    cell: function cell(_ref5) {
        var totalPrizeMoney = _ref5.totalPrizeMoney;
        return (0, _money.formatMoney)(totalPrizeMoney);
    }
}, {
    key: 'bestOr',
    header: 'best or',
    sortFn: (0, _number.numericAndDashSort)('bestOr')
}, {
    key: 'rpPostmark',
    header: 'best rpr',
    sortFn: (0, _number.numericAndDashSort)('rpPostmark')
}];

exports.default = columns;

/***/ }),
/* 1168 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(39);

var _ProfileLink = __webpack_require__(26);

var _HorseCell = __webpack_require__(615);

var _HorseCell2 = _interopRequireDefault(_HorseCell);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _number = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    title: 'horse'
}, void 0, 'horse / dam\'s sire');

var _ref3 = _jsx(_Abbr2.default, {
    title: 'wins'
}, void 0, 'wins / runs');

var columns = [{
    key: 'horseName',
    header: function header() {
        return _ref;
    },
    cell: function cell(data) {
        return _react2.default.createElement(_HorseCell2.default, _extends({}, data, { isDamSire: true }));
    },
    sortFn: 'alphabetic'
}, {
    key: 'damSireStyleName',
    header: 'dam\'s sire',
    cell: function cell(_ref2) {
        var damSireStyleName = _ref2.damSireStyleName,
            damSireUid = _ref2.damSireUid,
            damSireCountryOriginCode = _ref2.damSireCountryOriginCode;
        return _jsx('span', {}, void 0, _jsx(_ProfileLink.HorseLink, {
            className: 'ui-link_marked',
            horseStyleName: damSireStyleName,
            horseUid: damSireUid
        }), _jsx('span', {}, void 0, ' (' + damSireCountryOriginCode + ')'));
    },
    sortFn: 'alphabetic'
}, {
    key: 'wins',
    header: function header() {
        return _ref3;
    },
    cell: function cell(_ref4) {
        var wins = _ref4.wins,
            runs = _ref4.runs;
        return _jsx('span', {}, void 0, _jsx('strong', {}, void 0, wins), _jsx('span', {
            className: 'hidden-sm-up'
        }, void 0, '/', runs));
    }
}, {
    key: 'runs'
}, {
    key: 'winPercent',
    header: '%'
}, {
    key: 'places',
    header: 'placed'
}, {
    key: 'totalPrizeMoney',
    header: 'total earnings',
    cell: function cell(_ref5) {
        var totalPrizeMoney = _ref5.totalPrizeMoney;
        return (0, _money.formatMoney)(totalPrizeMoney);
    },
    sortFn: (0, _number.numericAndDashSort)('totalPrizeMoney')
}, {
    key: 'bestOr',
    header: 'best or',
    sortFn: (0, _number.numericAndDashSort)('bestOr')
}, {
    key: 'rpPostmark',
    header: 'best rpr',
    sortFn: (0, _number.numericAndDashSort)('rpPostmark')
}];

exports.default = columns;

/***/ }),
/* 1169 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _EntriesList = __webpack_require__(626);

var _EntriesList2 = _interopRequireDefault(_EntriesList);

var _Switcher = __webpack_require__(295);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(200);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var switcherTitles = ['Big Races', 'Flat', 'Jumps'];
var switcherKeys = ['progenyEntriesBigRaces', 'progenyEntriesFlat', 'progenyEntriesJumps'];

var getInitRaceTypeNumber = function getInitRaceTypeNumber(data) {
    for (var idx in switcherKeys) {
        // eslint-disable-line no-restricted-syntax
        if (!(0, _lodash.isEmpty)(data[switcherKeys[idx]].data.progenyEntries)) {
            return +idx;
        }
    }
    return 0;
};

var ProgenyEntries = function (_PureComponent) {
    _inherits(ProgenyEntries, _PureComponent);

    function ProgenyEntries(props) {
        _classCallCheck(this, ProgenyEntries);

        var _this = _possibleConstructorReturn(this, (ProgenyEntries.__proto__ || Object.getPrototypeOf(ProgenyEntries)).call(this, props));

        _this.setSelected = function (raceType) {
            _this.setState({ raceType: raceType }, function () {
                (0, _fixMobileSafariWhiteScreenBug2.default)();
            });
        };

        var sireStatus = props.data.profile.sireStatus;

        _this.state = { raceType: sireStatus && getInitRaceTypeNumber(props.data) };
        return _this;
    }

    _createClass(ProgenyEntries, [{
        key: 'render',
        value: function render() {
            var data = this.props.data;
            var sireStatus = data.profile.sireStatus;

            var entries = (sireStatus ? data[switcherKeys[this.state.raceType]].data.progenyEntries : data.progenyEntries) || [];
            var noDataText = 'No progeny entries' + (sireStatus ? ' for this stallion' : '');

            return _jsx('div', {
                className: 'hp-progenyEntries'
            }, void 0, sireStatus && _jsx('div', {
                className: 'ui-centered-wrapper'
            }, void 0, _jsx(_Switcher2.default, {
                items: switcherTitles,
                selected: this.state.raceType,
                setSelected: this.setSelected
            })), _jsx(_EntriesList2.default, {
                entries: entries,
                noDataText: noDataText,
                isHorseShown: true,
                isDamShown: sireStatus,
                showMore: this.showMore,
                shownItems: this.state.shownItems
            }));
        }
    }]);

    return ProgenyEntries;
}(_react.PureComponent);

var progenyEntriesTypes = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    courseStyleName: _propTypes2.default.string,
    courseUid: _propTypes2.default.number,
    damCountryCode: _propTypes2.default.string,
    damName: _propTypes2.default.string,
    damUid: _propTypes2.default.number,
    horseAge: _propTypes2.default.number,
    horseCountryCode: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    raceDatetime: _propTypes2.default.string,
    raceInstanceTitle: _propTypes2.default.string,
    raceInstanceUid: _propTypes2.default.number,
    raceStatusCode: _propTypes2.default.string,
    raceUid: _propTypes2.default.number
}));
var stallionProgenyEntriesTypes = _propTypes2.default.shape({
    data: _propTypes2.default.shape({ progenyEntries: progenyEntriesTypes })
});

exports.default = ProgenyEntries;

/***/ }),
/* 1170 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _lodash = __webpack_require__(9);

var _Filter = __webpack_require__(142);

var _Filter2 = _interopRequireDefault(_Filter);

var _filter = __webpack_require__(144);

var _filter2 = _interopRequireDefault(_filter);

var _columns = __webpack_require__(1171);

var _columns2 = _interopRequireDefault(_columns);

var _categories = __webpack_require__(617);

var _categories2 = _interopRequireDefault(_categories);

var _reducer = __webpack_require__(1173);

var _reducer2 = _interopRequireDefault(_reducer);

var _selection = __webpack_require__(160);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var noDataText = 'No GB or IRE progeny results for this sire in the Racing Post database';

var emptyData = {
    progenyResults: [],
    seasonInfo: {}
};

var ProgenyResults = function (_FilteringComponent) {
    _inherits(ProgenyResults, _FilteringComponent);

    function ProgenyResults(props) {
        _classCallCheck(this, ProgenyResults);

        var _this = _possibleConstructorReturn(this, (ProgenyResults.__proto__ || Object.getPrototypeOf(ProgenyResults)).call(this, props));

        _initialiseProps.call(_this);

        _this.dataKey = 'progenyResults';
        var data = props.data;

        var _get = (0, _lodash.get)(data, 'progenyResults.data', emptyData),
            progenyResults = _get.progenyResults,
            _get$seasonInfo = _get.seasonInfo,
            countryCode = _get$seasonInfo.countryCode,
            raceType = _get$seasonInfo.raceType,
            surface = _get$seasonInfo.surface,
            seasonYearBegin = _get$seasonInfo.seasonYearBegin,
            seasonYearEnd = _get$seasonInfo.seasonYearEnd;

        var _get2 = (0, _lodash.get)(data, 'availableSeasonsData.data', {}),
            seasonsAvailable = _get2.seasonsAvailable;

        var surfaceUri = surface ? '/' + surface : '';

        _this.state = {
            data: progenyResults || [],
            categories: seasonsAvailable && (0, _categories2.default)(seasonsAvailable, {
                raceType: countryCode + '/' + raceType + surfaceUri,
                timePeriod: seasonYearBegin + '/' + seasonYearEnd
            }),
            loading: false,
            fetchError: false
        };
        return _this;
    }

    _createClass(ProgenyResults, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                data = _state.data,
                categories = _state.categories,
                loading = _state.loading,
                fetchError = _state.fetchError;


            return _jsx('section', {
                className: 'hp-progeny-results'
            }, void 0, categories && _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _reducer2.default,
                columns: _columns2.default,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: data,
                columns: _columns2.default,
                loading: loading,
                initialSortIdx: 0,
                sortable: true,
                resultsPerPage: 50,
                noDataText: noDataText
            }));
        }
    }]);

    return ProgenyResults;
}(_filter2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.buildUrl = function (_ref) {
        var raceType = _ref.raceType,
            timePeriod = _ref.timePeriod,
            month = _ref.month;
        var id = _this2.props.params.id;

        return 'horse/filter/progeny-results/' + id + '/' + timePeriod + '/' + raceType + '/' + month;
    };

    this.renderStatus = function () {
        var categories = _this2.state.categories;

        var typeCaption = (0, _selection.getOption)(categories, 'raceType').label;
        var seasonCaption = (0, _selection.getOption)(categories, 'timePeriod').label;
        var month = (0, _selection.getOption)(categories, 'month');

        return _jsx('h2', {
            className: 'ui-filter__statusText'
        }, void 0, _jsx('strong', {}, void 0, typeCaption, ', ', seasonCaption), month.value && ' (' + month.label + ')');
    };
};

ProgenyResults.propTypes = {
    data: _propTypes2.default.shape({
        progenyResults: _propTypes2.default.shape({
            data: _propTypes2.default.shape({
                progenyResults: _propTypes2.default.arrayOf(_propTypes2.default.shape({
                    countryCode: _propTypes2.default.string,
                    courseName: _propTypes2.default.string,
                    courseRpAbbrev3: _propTypes2.default.string,
                    courseUid: _propTypes2.default.number,
                    distanceFurlong: _propTypes2.default.number,
                    goingTypeCode: _propTypes2.default.string,
                    horseName: _propTypes2.default.string,
                    horseUid: _propTypes2.default.number,
                    noOfRunners: _propTypes2.default.number,
                    officialRatingRanOff: _propTypes2.default.number,
                    prizeMoney: _propTypes2.default.number,
                    raceDatetime: _propTypes2.default.string,
                    raceDescription: _propTypes2.default.string,
                    raceInstanceUid: _propTypes2.default.number,
                    raceOutcomePosition: _propTypes2.default.number,
                    rpPostmark: _propTypes2.default.number,
                    rpTopspeed: _propTypes2.default.number
                }))
            })
        })
    }).isRequired
};

exports.default = ProgenyResults;

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _CourseCell = __webpack_require__(1172);

var _CourseCell2 = _interopRequireDefault(_CourseCell);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _ProfileLink = __webpack_require__(26);

var _date = __webpack_require__(18);

var _number = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_Abbr2.default, {
    title: 'position',
    breakpoint: 'fromMedium'
}, void 0, 'pos.');

var _ref4 = _jsx(_Abbr2.default, {
    title: 'course / conditions / prize'
}, void 0, 'crs.');

var columns = [{
    key: 'raceDatetime',
    header: 'date',
    cell: function cell(props) {
        return _react2.default.createElement(
            _ResultLink2.default,
            props,
            (0, _date.formatDate)(props.raceDatetime, 'DDMMMYY')
        );
    },
    sortFn: (0, _date.sortByDate)('raceDatetime')
}, {
    key: 'horseName',
    header: 'horse',
    cell: function cell(_ref) {
        var horseName = _ref.horseName,
            horseUid = _ref.horseUid,
            countryCode = _ref.countryCode;
        return _jsx('span', {}, void 0, _jsx(_ProfileLink.HorseLink, {
            horseStyleName: horseName,
            horseUid: horseUid
        }), _jsx('span', {
            className: 'hp-progeny-results__country'
        }, void 0, ' (', countryCode, ')'));
    },
    sortFn: 'alphabetic'
}, {
    key: 'raceOutcomePosition',
    header: function header() {
        return _ref2;
    },
    cell: function cell(_ref3) {
        var raceOutcomePosition = _ref3.raceOutcomePosition,
            noOfRunners = _ref3.noOfRunners,
            raceOutcomeCode = _ref3.raceOutcomeCode;
        return _jsx('span', {}, void 0, _jsx('strong', {}, void 0, raceOutcomePosition || raceOutcomeCode), '/', noOfRunners);
    },
    sortFn: (0, _number.placesSort)('raceOutcomePosition')
}, {
    key: 'courseName',
    header: function header() {
        return _ref4;
    },
    cell: _CourseCell2.default
}, {
    key: 'officialRatingRanOff',
    header: 'or',
    cell: (0, _number.zeroToDash)('officialRatingRanOff'),
    sortFn: (0, _number.numericAndDashSort)('officialRatingRanOff')
}, {
    key: 'rpTopspeed',
    header: 'ts',
    sortFn: (0, _number.numericAndDashSort)('rpTopspeed')
}, {
    key: 'rpPostmark',
    header: 'rpr',
    cell: (0, _number.zeroToDash)('rpPostmark'),
    sortFn: (0, _number.numericAndDashSort)('rpPostmark')
}];

exports.default = columns;

/***/ }),
/* 1172 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _ProfileLink = __webpack_require__(26);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _money = __webpack_require__(39);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CourseCell = function CourseCell(_ref) {
    var courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        courseRpAbbrev3 = _ref.courseRpAbbrev3,
        distanceFurlong = _ref.distanceFurlong,
        goingTypeCode = _ref.goingTypeCode,
        raceDescription = _ref.raceDescription,
        prizeMoney = _ref.prizeMoney;
    return _jsx('span', {}, void 0, _jsx(_ProfileLink.CourseLink, {
        courseStyleName: courseName,
        courseUid: courseUid
    }, void 0, _jsx(_Abbr2.default, {
        title: courseName
    }, void 0, (0, _lodash.capitalize)(courseRpAbbrev3))), _jsx('span', {
        className: 'hidden-xs-down'
    }, void 0, ' ' + distanceFurlong + goingTypeCode, '\xA0', 'C' + raceDescription, '\xA0', (0, _money.formatMoney)(prizeMoney)));
};

exports.default = CourseCell;

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(617);

var getRaceType = function getRaceType(val) {
    return val.split('/')[1].match(/jumps|flat/)[0];
};

var timePeriodReducer = function timePeriodReducer(timePeriod, _ref) {
    var type = _ref.type,
        value = _ref.value;
    var _timePeriod$createdBy = timePeriod.createdBy,
        flatOrJumps = _timePeriod$createdBy.flatOrJumps,
        seasonsAvailable = _timePeriod$createdBy.seasonsAvailable;

    if (type === 'raceType' && flatOrJumps !== getRaceType(value)) {
        return (0, _categories.timePeriodsFactory)(value, seasonsAvailable);
    }
    return timePeriod;
};

var monthReducer = function monthReducer(month, _ref2) {
    var type = _ref2.type,
        value = _ref2.value;
    var _month$createdBy = month.createdBy,
        flatOrJumps = _month$createdBy.flatOrJumps,
        timePeriod = _month$createdBy.timePeriod,
        seasonsAvailable = _month$createdBy.seasonsAvailable;

    if (type === 'raceType' && flatOrJumps !== getRaceType(value)) {
        return (0, _categories.monthFactory)(value, timePeriod, seasonsAvailable);
    }
    if (type === 'timePeriod' && timePeriod !== value) {
        return (0, _categories.monthFactory)(flatOrJumps, value, seasonsAvailable);
    }
    return month;
};

var categoriesReducer = function categoriesReducer(_ref3, action) {
    var raceType = _ref3.raceType,
        timePeriod = _ref3.timePeriod,
        month = _ref3.month;
    return {
        raceType: raceType,
        timePeriod: timePeriodReducer(timePeriod, action),
        month: monthReducer(month, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1174 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1175);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ProgenySales = function ProgenySales(_ref) {
    var progenySales = _ref.data.progenySales;
    return _jsx('section', {
        className: 'hp-progeny-sales'
    }, void 0, _jsx(_rpReactTable2.default, {
        columns: _columns2.default,
        data: progenySales,
        initialSortIdx: 0,
        noDataText: 'No progeny sales',
        sortable: true
    }));
};

exports.default = ProgenySales;

/***/ }),
/* 1175 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(9);

var _money = __webpack_require__(39);

var _date = __webpack_require__(18);

var _HorseCell = __webpack_require__(1176);

var _HorseCell2 = _interopRequireDefault(_HorseCell);

var _SireCell = __webpack_require__(1177);

var _SireCell2 = _interopRequireDefault(_SireCell);

var _SalesHorseLink = __webpack_require__(628);

var _SalesHorseLink2 = _interopRequireDefault(_SalesHorseLink);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    title: 'horse',
    breakpoint: 'fromMedium'
}, void 0, 'horse', _jsx('br', {}), 'sire (dam\'s sire)');

var _ref2 = _jsx('abbr', {
    className: 'pp-abbr__from'
}, void 0, 'sire', _jsx('br', {}), 'dam\'s sire');

var columns = [{
    key: 'saleDate',
    header: 'date',
    cell: _SalesHorseLink2.default,
    sortFn: (0, _date.sortByDate)('saleDate')
}, {
    key: 'horseName',
    header: function header() {
        return _ref;
    },
    cell: _HorseCell2.default,
    sortFn: 'alphabetic'
}, {
    key: 'sireName',
    // using <abbr className="pp-abbr__from"> for A-QA comfort
    header: function header() {
        return _ref2;
    },
    cell: _SireCell2.default,
    sortFn: 'alphabetic'
}, {
    key: 'priceGbp',
    header: 'price',
    cell: function cell(_ref3) {
        var price = _ref3.price,
            curCode = _ref3.curCode;
        return (0, _money.formatSalePrice)(price, curCode);
    }
}, {
    key: 'vendor',
    sortFn: 'alphabetic'
}, {
    key: 'buyerDetail',
    header: 'buyer',
    sortFn: 'byLastName'
}, {
    key: 'venueDesc',
    header: 'sale',
    cell: function cell(_ref4) {
        var venueDesc = _ref4.venueDesc;
        return (0, _lodash.capitalize)(venueDesc).substr(0, 3);
    },
    sortFn: 'alphabetic'
}];

exports.default = columns;

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _getFormattedAge = __webpack_require__(1265);

var _getFormattedAge2 = _interopRequireDefault(_getFormattedAge);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'hidden-md-up'
}, void 0, ',');

var HorseCell = function HorseCell(_ref) {
    var horseName = _ref.horseName,
        horseSaleName = _ref.horseSaleName,
        horseCountryOriginCode = _ref.horseCountryOriginCode,
        horseUid = _ref.horseUid,
        horseFirstColourCode = _ref.horseFirstColourCode,
        horseSex = _ref.horseSex,
        horseAge = _ref.horseAge,
        sireName = _ref.sireName,
        sireUid = _ref.sireUid,
        sireOfDamName = _ref.sireOfDamName,
        sireOfDamUid = _ref.sireOfDamUid;
    return _jsx('div', {}, void 0, horseUid ? _jsx(_ProfileLink.HorseLink, {
        className: 'hp-progeny-sales__horseName',
        horseStyleName: horseName || horseSaleName,
        horseUid: horseUid,
        whenEmpty: 'Unnamed'
    }) : _jsx('span', {}, void 0, horseName || (0, _lodash.startCase)((0, _lodash.toLower)(horseSaleName))), _ref2, horseCountryOriginCode && _jsx('span', {
        className: 'hidden-sm-down'
    }, void 0, ' (' + horseCountryOriginCode + ')'), horseFirstColourCode ? ' ' + horseFirstColourCode + ', ' : ' ', horseSex, ', ', (0, _getFormattedAge2.default)(horseAge), _jsx('div', {
        className: 'hidden-md-up'
    }, void 0, _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked',
        horseStyleName: sireName,
        horseUid: sireUid
    }), ' ', _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked hp-progeny-sales__secondary-link',
        horseStyleName: sireOfDamName,
        horseUid: sireOfDamUid
    }, void 0, '(' + sireOfDamName + ')')));
};

exports.default = HorseCell;

/***/ }),
/* 1177 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('br', {
    className: 'hidden-sm-down'
});

var SireCell = function SireCell(_ref) {
    var sireName = _ref.sireName,
        sireCountryOriginCode = _ref.sireCountryOriginCode,
        sireUid = _ref.sireUid,
        sireOfDamName = _ref.sireOfDamName,
        sireOfDamCountryOriginCode = _ref.sireOfDamCountryOriginCode,
        sireOfDamUid = _ref.sireOfDamUid;
    return _jsx('div', {}, void 0, _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked',
        horseStyleName: sireName,
        horseUid: sireUid
    }, void 0, sireName, ' (', sireCountryOriginCode, ')'), _ref2, _jsx(_ProfileLink.HorseLink, {
        className: 'ui-link_marked',
        horseStyleName: sireOfDamName,
        horseUid: sireOfDamUid
    }, void 0, sireOfDamName, ' (', sireOfDamCountryOriginCode, ')'));
};

exports.default = SireCell;

/***/ }),
/* 1178 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _lodash = __webpack_require__(9);

var _columns = __webpack_require__(618);

var _columns2 = _interopRequireDefault(_columns);

var _RaceRow = __webpack_require__(1179);

var _RaceRow2 = _interopRequireDefault(_RaceRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sectionTitles = {
    '1988ToDate': '1988 to Date',
    '2000ToDate': '2000 to Date',
    currentYear: 'Current Year'
};

var noDataText = 'No progeny statistics for this sire in the Racing Post database';
var tableClassName = 'ui-table ui-table_type2 hp-progeny-statistics__table';

var _ref2 = _jsx(_rpReactTable.NoData, {
    text: noDataText
});

var _ref3 = _jsx(_rpReactTable.Header, {
    columns: _columns2.default
});

var ProgenyStatistics = function ProgenyStatistics(_ref) {
    var progenyStatistics = _ref.data.progenyStatistics,
        id = _ref.params.id;
    return _jsx('section', {
        className: 'hp-progeny-statistics'
    }, void 0, (0, _lodash.isEmpty)(progenyStatistics) ? _ref2 : (0, _lodash.keys)(progenyStatistics).map(function (timePeriod) {
        var data = progenyStatistics[timePeriod];

        return (0, _lodash.isEmpty)(data) ? null : _jsx('div', {}, timePeriod, _jsx('h2', {}, void 0, sectionTitles[timePeriod]), _jsx('table', {
            className: tableClassName
        }, void 0, _ref3, data.map(function (rowData) {
            return _jsx(_RaceRow2.default, {
                data: rowData,
                horseId: id,
                timePeriod: timePeriod
            }, rowData.category);
        })));
    }));
};

var statisticsRow = _propTypes2.default.shape({
    category: _propTypes2.default.string,
    winners: _propTypes2.default.number,
    runners: _propTypes2.default.number,
    percentWinnersRunners: _propTypes2.default.number,
    wins: _propTypes2.default.number,
    runs: _propTypes2.default.number,
    percentWinsRuns: _propTypes2.default.number,
    place2ndNumber: _propTypes2.default.number,
    place3rdNumber: _propTypes2.default.number,
    totalPrizeMoney: _propTypes2.default.number
});

exports.default = ProgenyStatistics;

/***/ }),
/* 1179 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _axios = __webpack_require__(127);

var _axios2 = _interopRequireDefault(_axios);

var _columns = __webpack_require__(618);

var _columns2 = _interopRequireDefault(_columns);

var _columns3 = __webpack_require__(1180);

var _columns4 = _interopRequireDefault(_columns3);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable jsx-a11y/no-static-element-interactions */


var _ref2 = _jsx(_rpReactTable.Loading, {});

var RaceRow = function (_PureComponent) {
    _inherits(RaceRow, _PureComponent);

    function RaceRow(props) {
        _classCallCheck(this, RaceRow);

        var _this = _possibleConstructorReturn(this, (RaceRow.__proto__ || Object.getPrototypeOf(RaceRow)).call(this, props));

        _this.fetchDetails = function () {
            var _this$props = _this.props,
                horseId = _this$props.horseId,
                timePeriod = _this$props.timePeriod,
                category = _this$props.data.category;

            var startYear = parseInt(timePeriod, 10) || new Date().getFullYear();
            var raceType = encodeURI(category);

            _axios2.default.get('horse/accordion-statistics/' + horseId + '/' + startYear + '/' + raceType).then(function (_ref) {
                var _ref$data = _ref.data,
                    progenyStatisticsTop = _ref$data.progenyStatisticsTop,
                    progenyBroodmareSiresStatisticsTop = _ref$data.progenyBroodmareSiresStatisticsTop;

                _this.setState({
                    detailsData: progenyStatisticsTop || progenyBroodmareSiresStatisticsTop,
                    needFetch: false
                });
            }).catch(function (error) {
                console.warn(error);
                _this.setState({ needFetch: false });
            });
        };

        _this.toggleDetails = function (event) {
            if (event.target.nodeName === 'A') {
                return;
            }

            _this.setState(function (state) {
                return { expanded: !state.expanded };
            });

            if (_this.state.needFetch) {
                _this.fetchDetails();
            }
        };

        _this.state = {
            detailsData: [],
            expanded: false,
            needFetch: true
        };
        return _this;
    }

    /* to not pollute global Row component we adding handler for tbody
     and preventing click handling on second table row by css pointer-events: none
     and checking target.nodeName */


    _createClass(RaceRow, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                detailsData = _state.detailsData,
                expanded = _state.expanded,
                needFetch = _state.needFetch;


            return _jsx('tbody', {
                className: expanded && 'hp-progeny-statistics__expanded',
                onClick: this.toggleDetails
            }, void 0, _jsx(_rpReactTable.Row, {
                rowData: this.props.data,
                columns: _columns2.default,
                setRowClass: function setRowClass() {
                    return 'hp-progeny-statistics__row';
                }
            }), expanded && _jsx('tr', {
                className: 'ui-table__row'
            }, void 0, _jsx('td', {
                colSpan: '10',
                className: 'hp-progeny-statistics__detailsTable'
            }, void 0, needFetch ? _ref2 : _jsx(_rpReactTable2.default, {
                data: detailsData,
                columns: (0, _columns4.default)(this.props.data.broodmareCategory),
                uiType: 5
            }))));
        }
    }]);

    return RaceRow;
}(_react.PureComponent);

exports.default = RaceRow;

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(39);

var _ProfileLink = __webpack_require__(26);

var _number = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = function columns(isBroodmare) {
    return [{
        key: 'horseUid',
        header: 'horse',
        cell: _ProfileLink.HorseLink
    }, {
        key: 'damSireUid',
        header: isBroodmare ? 'sire' : 'dam\'s sire',
        cell: function cell(_ref) {
            var damSireStyleName = _ref.damSireStyleName,
                damSireUid = _ref.damSireUid,
                sireStyleName = _ref.sireStyleName,
                sireUid = _ref.sireUid;
            return _jsx(_ProfileLink.HorseLink, {
                horseStyleName: damSireStyleName || sireStyleName,
                horseUid: damSireUid || sireUid
            });
        }
    }, {
        key: 'wins'
    }, {
        key: 'runs'
    }, {
        key: 'winsPercent',
        header: '%'
    }, {
        key: 'totalPrizemoney',
        header: 'total earnings',
        cell: function cell(_ref2) {
            var totalPrizemoney = _ref2.totalPrizemoney;
            return (0, _money.formatMoney)(totalPrizemoney);
        }
    }, {
        key: 'rpPostmark',
        header: 'rpr',
        sortFn: (0, _number.numericAndDashSort)('rpPostmark')
    }];
};

exports.default = columns;

/***/ }),
/* 1181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _date = __webpack_require__(18);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Quotes = function Quotes(_ref) {
    var _ref$data = _ref.data,
        quotes = _ref$data.quotes,
        lookupTable = _ref$data.lookupTable;
    return _jsx('section', {
        className: 'hp-quotes'
    }, void 0, quotes && quotes.map(function (_ref2) {
        var raceDate = _ref2.raceDate,
            raceId = _ref2.raceId,
            raceTitle = _ref2.raceTitle,
            courseName = _ref2.courseName,
            courseUid = _ref2.courseUid,
            courseStyleName = _ref2.courseStyleName,
            distanceFurlong = _ref2.distanceFurlong,
            goingTypeCode = _ref2.goingTypeCode,
            rpPostmark = _ref2.rpPostmark,
            notes = _ref2.notes;
        return _jsx('div', {
            className: 'hp-quotes__item'
        }, raceId, _jsx('h2', {
            className: 'hp-quotes__header'
        }, void 0, _jsx(_ResultLink2.default, {
            className: 'hp-quotes__resultsLink',
            courseName: courseName,
            courseUid: +courseUid,
            raceInstanceUid: raceId,
            raceInstanceTitle: raceTitle,
            raceDatetime: raceDate
        }, void 0, (0, _date.formatDate)(raceDate, 'DMMMYY')), '\xA0', courseStyleName, '\xA0 (', distanceFurlong, lookupTable && lookupTable[goingTypeCode].servicesDesc, rpPostmark && ', RPR ' + rpPostmark, ')'), _jsx('p', {
            className: 'hp-quotes__text'
        }, void 0, notes));
    }));
};

exports.default = Quotes;

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _RecentStakesLayout = __webpack_require__(1185);

var _RecentStakesLayout2 = _interopRequireDefault(_RecentStakesLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx('section', {
    className: 'hp-recentStakesPerformers__container--text-center'
}, void 0, 'No recent top performers information for this sire is available');

var _ref2 = _jsx('div', {
    className: 'sireinfo'
}, void 0, 'Recent Top Performers');

var RecentStakesPerformers = function RecentStakesPerformers(props) {
    var data = props.data.data;


    var isRecentStakesData = data && data.recentStakeCategoryData && Object.keys(data.recentStakeCategoryData).length > 0;
    if (!isRecentStakesData) {
        return _ref;
    }

    return _jsx('div', {
        className: 'hp-weatherbys hp-weatherbys__recentStakesPerformers\n            hp-recentStakesPerformers__container'
    }, void 0, _ref2, _jsx(_RecentStakesLayout2.default, {
        data: data.recentStakeCategoryData
    }));
};

exports.default = RecentStakesPerformers;

/***/ }),
/* 1183 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _utilsMap = __webpack_require__(1187);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('br', {});

var ColumnContentRight = function ColumnContentRight(_ref) {
    var horseDetails = _ref.horseDetails;
    var raceDate = horseDetails.raceDate,
        horseName = horseDetails.horseName,
        raceCourse = horseDetails.raceCourse,
        horseAge = horseDetails.horseAge,
        horseColour1 = horseDetails.horseColour1,
        horseSex = horseDetails.horseSex,
        horseDam = horseDetails.horseDam,
        horseDamSire = horseDetails.horseDamSire,
        position = horseDetails.position,
        raceName = horseDetails.raceName,
        raceGrade = horseDetails.raceGrade,
        raceDistance = horseDetails.raceDistance;


    var getColorMap = function getColorMap(color) {
        return _utilsMap.colorMap[color] ? _utilsMap.colorMap[color].toLowerCase() : color.toLowerCase();
    };

    var getRaceDistanceMap = function getRaceDistanceMap(distance) {
        return _utilsMap.raceDistanceMap[distance] ? _utilsMap.raceDistanceMap[distance] : distance;
    };

    var getRaceGrade = function getRaceGrade(grade) {
        return isNaN(grade) ? grade : 'G' + grade;
    };

    var getPositionWithPrefix = function getPositionWithPrefix(number) {
        return (
            // eslint-disable-next-line
            number + ['st', 'nd', 'rd'][((number + 90) % 100 - 10) % 10 - 1] || 'th'
        );
    };

    var horseSexFormatted = horseSex.toLowerCase();
    var getColorFromMap = getColorMap(horseColour1);
    var getRaceDistanceFromMap = getRaceDistanceMap(raceDistance);
    var getConvertedRaceGrade = getRaceGrade(raceGrade);
    var getConvertedPosition = getPositionWithPrefix(position);

    var classContentTopLeft = (0, _classnames2.default)('hp-recentStakesPerformers__container__content__row__right__content__top__left');

    var classContentTopRight = (0, _classnames2.default)('hp-recentStakesPerformers__container__content__row__right__content__top__right');

    var classContentTopBottom = (0, _classnames2.default)('hp-recentStakesPerformers__container__content__row__right__content__bottom');

    return _jsx('div', {
        className: 'hp-recentStakesPerformers__container__content__row__right__content'
    }, void 0, _jsx('div', {
        className: 'hp-recentStakesPerformers__container__content__row__right__content__top'
    }, void 0, _jsx('div', {
        className: classContentTopLeft
    }, void 0, raceDate, ' ', horseName), _jsx('div', {
        className: classContentTopRight
    }, void 0, raceCourse)), _jsx('div', {
        className: classContentTopBottom
    }, void 0, horseAge + 'yo', ' ', getColorFromMap, ' ', horseSexFormatted, ' ', horseDam, ' ', horseDamSire, _ref2, getConvertedPosition, ' ', raceName, ' ', getConvertedRaceGrade, ' ', getRaceDistanceFromMap));
};

exports.default = ColumnContentRight;

/***/ }),
/* 1184 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ColumnLeft = function ColumnLeft(props) {
    var rowYear = props.rowYear;


    return _jsx('div', {
        className: 'hp-recentStakesPerformers__container__content__row__left'
    }, void 0, rowYear);
};

exports.default = ColumnLeft;

/***/ }),
/* 1185 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Row = __webpack_require__(1186);

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RecentStakesLayout = function RecentStakesLayout(_ref) {
    var data = _ref.data;

    var sortHorsesByYear = function sortHorsesByYear() {
        var sortedHorses = {};
        data.forEach(function (horse) {
            var monthYear = horse.monthYear;

            if (!Object.prototype.hasOwnProperty.call(sortedHorses, monthYear)) {
                sortedHorses[monthYear] = [];
            }

            sortedHorses[monthYear].push(horse);
        });
        return sortedHorses;
    };

    var sortedHorseData = sortHorsesByYear();

    return _jsx('div', {
        className: 'hp-recentStakesPerformers__container__content'
    }, void 0, Object.keys(sortedHorseData).map(function (year) {
        return _jsx(_Row2.default, {
            horseList: sortedHorseData[year],
            rowYear: year
        }, year);
    }));
};

exports.default = RecentStakesLayout;

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ColumnLeft = __webpack_require__(1184);

var _ColumnLeft2 = _interopRequireDefault(_ColumnLeft);

var _ColumnContentRight = __webpack_require__(1183);

var _ColumnContentRight2 = _interopRequireDefault(_ColumnContentRight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Row = function Row(props) {
    var horseList = props.horseList,
        rowYear = props.rowYear;


    return _jsx('div', {
        className: 'hp-recentStakesPerformers__container__content__row'
    }, void 0, _jsx(_ColumnLeft2.default, {
        rowYear: rowYear
    }), _jsx('div', {
        className: 'hp-recentStakesPerformers__container__content__row__right'
    }, void 0, horseList.map(function (horse) {
        return _jsx(_ColumnContentRight2.default, {
            horseDetails: horse
        }, rowYear + horse.horseName);
    })));
};

exports.default = Row;

/***/ }),
/* 1187 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint-disable */
var colorMap = exports.colorMap = {
    'Appaloosa': 'Ap',
    'Appaloosa/Cream': 'Ap/Cr',
    'Bay': 'B',
    'Bay/Appaloosa': 'B/Ap',
    'Bay/Black': 'B/Bl',
    'Bay or Brown': 'B/Br',
    'Bay/Chesnut': 'B/Ch',
    'Bay/Dun': 'B/D',
    'Bay/Grey': 'B/Gr',
    'Bay/Roan': 'Bl/Ro',
    'Black': 'BL',
    'Black/Bay': 'Bl/B',
    'Black/Brown': 'Bl/Br',
    'Black/Grey': 'Bl/Gr',
    'Black/Roan': 'Bl/Ro',
    'Bay Overo': 'BO',
    'Brown': 'Br',
    'Brown/Bay': 'Br/B',
    'Brown/Black': 'Br/Bl',
    'Brown/Brown': 'Br/Br',
    'Brown/Chesnut': 'Br/Ch',
    'Brown/Grey': 'Br/Gr',
    'Brown/Roan': 'Br/Ro',
    'Buckskin': 'Bu',
    'Black Overo': 'BV',
    'Black Overo/Black': 'BV/Bl',
    'Chesnut': 'Ch',
    'Chesnut/Bay': 'Ch/B',
    'Chesnut/Black': 'Ch/Bl',
    'Chesnut/Brown': 'Ch/Br',
    'Chesnut/Chesnut': 'Ch/Ch',
    'Chesnut/Dun': 'Ch/D',
    'Chesnut/Grey': 'Ch/Gr',
    'Chesnut/Roan': 'Ch/Ro',
    'Cremello': 'CM',
    'Chesnut Overo': 'CO',
    'Cream': 'Cr',
    'Dun': 'D',
    'Dun/Bay': 'D/B',
    'Dun/Chesnut': 'D/Ch',
    'Dun/Grey': 'D/Gr',
    'Grey': 'Gr',
    'Grey/Bay': 'Gr/B',
    'Grey/Black': 'Gr/Bl',
    'Grey/Brown': 'Gr/Br',
    'Grey/Chesnut': 'Gr/Ch',
    'Grey/Grey': 'Gr/Gr',
    'Grey/Roan': 'Gr/Ro',
    'Grey/White': 'Gr/Wh',
    'Leopard': 'L',
    'Leopard/Bay': 'L/B',
    'Overo': 'Ov',
    'Palomino': 'Pa',
    'Painted': 'PT',
    'Piebald': 'P',
    'Skewbald': 'Sk',
    'Skewbald/Appaloosa': 'Sk/Ap',
    'Skewbald/Roan': 'Sk/Ro',
    'Skewbald/Tobiano': 'Sk/To',
    'Spotted': 'Sp',
    'Roan': 'Ro',
    'Roan/Brown': 'Ro/Br',
    'Roan/Chesnut': 'Ro/Ch',
    'Roan/Grey': 'Ro/Gr',
    'Tobiano': 'To',
    'Unknown': 'U',
    'White': 'Wh'
};

var raceDistanceMap = exports.raceDistanceMap = {
    '5f': '5f',
    '6f': '6f',
    '7f': '7f',
    '8f': '1m',
    '9f': '1m1f',
    '10f': '1m2f',
    '11f': '1m3f',
    '12f': '1m4f',
    '13f': '1m5f',
    '14f': '1m6f',
    '15f': '1m7f',
    '16f': '2m',
    '17f': '2m1f',
    '18f': '2m2f',
    '19f': '2m3f',
    '20f': '2m4f',
    '21f': '2m5f',
    '22f': '2m6f',
    '23f': '2m7f',
    '24f': '3m',
    '25f': '3m1f',
    '26f': '3m2f',
    '27f': '3m3f',
    '28f': '3m4f',
    '29f': '3m5f',
    '30f': '3m6f',
    '31f': '3m7f',
    '32f': '4m',
    '33f': '4m1f',
    '34f': '4m2f',
    '35f': '4m3f',
    '36f': '4m4f'
};

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1189);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Sales = function Sales(_ref) {
    var data = _ref.data;
    return _jsx('section', {
        className: 'hp-sales'
    }, void 0, _jsx(_rpReactTable2.default, {
        data: data.sales,
        columns: _columns2.default,
        noDataText: 'No sales data for this horse'
    }));
};

exports.default = Sales;

/***/ }),
/* 1189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(9);

var _money = __webpack_require__(39);

var _date = __webpack_require__(18);

var _SalesHorseLink = __webpack_require__(628);

var _SalesHorseLink2 = _interopRequireDefault(_SalesHorseLink);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = [{
    key: 'saleDate',
    header: 'date',
    cell: function cell(data) {
        return _react2.default.createElement(
            _SalesHorseLink2.default,
            data,
            _jsx(_Abbr2.default, {
                title: (0, _date.formatDate)(data.saleDate, 'dddd, DD MMMM YYYY'),
                breakpoint: 'exWide'
            }, void 0, (0, _date.formatDate)(data.saleDate, 'DDMMMYY'))
        );
    }
}, {
    key: 'abbrevName',
    header: 'sale name',
    cell: function cell(_ref) {
        var abbrevName = _ref.abbrevName,
            venueDesc = _ref.venueDesc;
        return _jsx('div', {}, void 0, _jsx('span', {
            className: 'hidden-sm-down'
        }, void 0, abbrevName), _jsx('span', {
            className: 'hidden-md-up'
        }, void 0, (0, _lodash.lowerCase)(venueDesc)));
    }
}, {
    key: 'lotNo',
    header: 'lot'
}, {
    key: 'sellerName',
    header: 'vendor'
}, {
    key: 'buyerDetail',
    header: 'purchaser'
}, {
    key: 'price',
    header: 'price',
    cell: function cell(_ref2) {
        var price = _ref2.price,
            curCode = _ref2.curCode;
        return (0, _money.formatSalePrice)(price, curCode);
    }
}];

exports.default = columns;

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

exports.default = SalesEntries;

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpBloodstockSearch = __webpack_require__(985);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function SalesEntries(_ref) {
    var _ref$data$profile = _ref.data.profile,
        horseUid = _ref$data$profile.horseUid,
        horseName = _ref$data$profile.horseName;

    return _jsx(_rpBloodstockSearch.SearchEntries, {
        sireUid: horseUid,
        sireName: horseName
    });
}

/***/ }),
/* 1191 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

exports.default = SalesResults;

var _moment = __webpack_require__(73);

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpBloodstockSearch = __webpack_require__(985);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DATE_FORMAT = 'YYYY-MM-DD';

function SalesResults(_ref) {
    var horseName = _ref.data.profile.horseName;

    var from = (0, _moment2.default)().add(-1, 'years').format(DATE_FORMAT);
    var to = (0, _moment2.default)().format(DATE_FORMAT);
    return _jsx(_rpBloodstockSearch.SearchResults, {
        sireName: horseName,
        from: from,
        to: to
    });
}

/***/ }),
/* 1192 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Filter = __webpack_require__(142);

var _Filter2 = _interopRequireDefault(_Filter);

var _filter = __webpack_require__(144);

var _filter2 = _interopRequireDefault(_filter);

var _categories = __webpack_require__(1193);

var _categories2 = _interopRequireDefault(_categories);

var _columns = __webpack_require__(1194);

var _columns2 = _interopRequireDefault(_columns);

var _getMappedStatistic = __webpack_require__(1195);

var _getMappedStatistic2 = _interopRequireDefault(_getMappedStatistic);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setRowClass = function setRowClass(_ref) {
    var type = _ref.type;
    return type === 'total' ? 'hp-sales-statistic__totalRow' : '';
};

var _ref2 = _jsx('div', {
    className: 'hp-sales-statistic__subtext'
}, void 0, 'All sales prices are shown in English Guineas');

var SalesStatistic = function (_FilteringComponent) {
    _inherits(SalesStatistic, _FilteringComponent);

    function SalesStatistic(props) {
        _classCallCheck(this, SalesStatistic);

        var _this = _possibleConstructorReturn(this, (SalesStatistic.__proto__ || Object.getPrototypeOf(SalesStatistic)).call(this, props));

        _initialiseProps.call(_this);

        var _props$data = props.data,
            overall = _props$data.overall,
            saleStatistics = _props$data.saleStatistics,
            countryFlag = _props$data.seasonInfo.countryFlag;


        _this.state = {
            data: (0, _getMappedStatistic2.default)(overall, saleStatistics),
            categories: (0, _categories2.default)(countryFlag, 'yearlings'),
            loading: false,
            fetchError: false
        };
        return _this;
    }

    _createClass(SalesStatistic, [{
        key: 'render',
        value: function render() {
            var _state = this.state,
                data = _state.data,
                categories = _state.categories,
                loading = _state.loading,
                fetchError = _state.fetchError;

            return _jsx('section', {
                className: 'hp-sales-statistic'
            }, void 0, _jsx(_Filter2.default, {
                categories: categories,
                fetchError: fetchError,
                categoriesReducer: this.categoriesReducer,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: data,
                columns: _columns2.default,
                loading: loading,
                uiType: 6,
                setRowClass: setRowClass,
                noDataText: 'No sales statistics in the Racing Post database for this sire'
            }), _ref2);
        }
    }]);

    return SalesStatistic;
}(_filter2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.buildUrl = function (_ref3) {
        var displayBy = _ref3.displayBy,
            regions = _ref3.regions;
        var id = _this2.props.params.id;

        return 'horse/filter/sales-statistics/' + id + '/' + displayBy + '/' + regions;
    };

    this.onDataReceive = function (_ref4) {
        var overall = _ref4.overall,
            saleStatistics = _ref4.saleStatistics;

        _this2.setState({
            data: (0, _getMappedStatistic2.default)(overall, saleStatistics) || _this2.emptyData,
            loading: false
        });
    };

    this.categoriesReducer = function (categories) {
        return categories;
    };
};

var saleTypes = {
    saleYear: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
    byersCount: _propTypes2.default.number,
    offeredCount: _propTypes2.default.number,
    salesCount: _propTypes2.default.number,
    soldPercent: _propTypes2.default.number,
    priceAverage: _propTypes2.default.number,
    priceMax: _propTypes2.default.number,
    median: _propTypes2.default.number,
    priceMin: _propTypes2.default.number
};

var segmentShape = _propTypes2.default.shape(_extends({}, saleTypes, {
    colts: _propTypes2.default.shape(saleTypes),
    fillies: _propTypes2.default.shape(saleTypes)
}));

SalesStatistic.propTypes = {
    data: _propTypes2.default.shape({
        saleStatistics: _propTypes2.default.arrayOf(segmentShape),
        overall: segmentShape
    }).isRequired
};

exports.default = SalesStatistic;

/***/ }),
/* 1193 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _selection = __webpack_require__(160);

var regionsOptions = [{
    label: 'GB',
    value: 'GB'
}, {
    label: 'Ireland',
    value: 'IRE'
}, {
    label: 'GB and Ireland',
    value: 'GB-IRE'
}, {
    label: 'Europe',
    value: 'Europe'
}, {
    label: 'USA',
    value: 'USA'
}, {
    label: 'All',
    value: 'All'
}];

var displayByOptions = [{
    label: 'Foals',
    value: 'foals'
}, {
    label: 'Yearlings',
    value: 'yearlings'
}, {
    label: '2yo',
    value: '2yo'
}, {
    label: '3yo',
    value: '3yo'
}, {
    label: '4yo',
    value: '4yo'
}, {
    label: 'Older horses',
    value: 'older'
}, {
    label: 'Mares',
    value: 'mares'
}];

var regionsFactory = function regionsFactory(region) {
    return {
        title: 'regions',
        options: (0, _selection.setSelected)(regionsOptions, region)
    };
};

var displayByFactory = function displayByFactory(displayBy) {
    return {
        title: 'display by',
        options: (0, _selection.setSelected)(displayByOptions, displayBy)
    };
};

var categoriesFactory = function categoriesFactory(region, displayBy) {
    return {
        regions: regionsFactory(region),
        displayBy: displayByFactory(displayBy)
    };
};

exports.default = categoriesFactory;

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(39);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_Abbr2.default, {
    title: 'catalogued',
    breakpoint: 'fromMedium'
}, void 0, 'cat\'d');

var _ref3 = _jsx(_Abbr2.default, {
    title: 'offered',
    breakpoint: 'fromMedium'
}, void 0, 'off\'d');

var columns = [{
    key: 'saleYear',
    header: 'horse',
    cell: function cell(_ref) {
        var type = _ref.type,
            saleYear = _ref.saleYear;
        return type === 'total' ? saleYear : saleYear + ' ' + type;
    }
}, {
    key: 'byersCount',
    header: function header() {
        return _ref2;
    }
}, {
    key: 'offeredCount',
    header: function header() {
        return _ref3;
    }
}, {
    key: 'salesCount',
    header: 'sold (%)',
    cell: function cell(_ref4) {
        var salesCount = _ref4.salesCount,
            soldPercent = _ref4.soldPercent;
        return salesCount + ' (' + (soldPercent || '') + '%)';
    }
}, {
    key: 'priceAverage',
    header: 'average',
    cell: function cell(_ref5) {
        var priceAverage = _ref5.priceAverage;
        return (0, _money.formatPrice)(priceAverage);
    }
}, {
    key: 'priceMax',
    header: 'highest',
    cell: function cell(_ref6) {
        var priceMax = _ref6.priceMax;
        return (0, _money.formatPrice)(priceMax);
    }
}, {
    key: 'median',
    cell: function cell(_ref7) {
        var median = _ref7.median;
        return (0, _money.formatPrice)(median);
    }
}, {
    key: 'priceMin',
    header: 'low',
    cell: function cell(_ref8) {
        var priceMin = _ref8.priceMin;
        return (0, _money.formatPrice)(priceMin);
    }
}];

exports.default = columns;

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(9);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var getObjWithType = function getObjWithType(type, obj) {
    return obj ? _extends({ type: type }, obj) : null;
};

function getMappedStatistic(overall, saleStatistics) {
    var statistic = (0, _lodash.compact)([overall].concat(saleStatistics)).reduce(function (result, _ref) {
        var colts = _ref.colts,
            fillies = _ref.fillies,
            total = _objectWithoutProperties(_ref, ['colts', 'fillies']);

        result.push(getObjWithType('total', total), getObjWithType('colts', colts), getObjWithType('fillies', fillies));
        return result;
    }, []);
    return (0, _lodash.compact)(statistic);
}

exports.default = getMappedStatistic;

/***/ }),
/* 1196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/no-danger: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CopyrightWeatherby = __webpack_require__(403);

var _CopyrightWeatherby2 = _interopRequireDefault(_CopyrightWeatherby);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('section', {
    className: 'hp-sireReference__container--text-center'
}, void 0, 'No sire reference information for this sire is available', _jsx(_CopyrightWeatherby2.default, {}));

var _ref3 = _jsx(_CopyrightWeatherby2.default, {});

var SireReference = function SireReference(_ref) {
    var data = _ref.data.data;

    if (!data) {
        return _ref2;
    }

    var sireReferenceHTMLflat = data.sireReferenceHTMLflat;


    return _jsx('div', {}, void 0, _jsx('section', {
        className: 'hp-weatherbys__sireReference hp-sireReference__container',
        dangerouslySetInnerHTML: { __html: sireReferenceHTMLflat }
    }), _ref3);
};

exports.default = SireReference;

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CopyrightWeatherby = __webpack_require__(403);

var _CopyrightWeatherby2 = _interopRequireDefault(_CopyrightWeatherby);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('section', {
    className: 'hp-bestProgeny__container--text-center'
}, void 0, 'No Stallion Book PDF information for this sire is available');

var _ref3 = _jsx(_CopyrightWeatherby2.default, {});

var StallionBookPdf = function StallionBookPdf(_ref) {
    var data = _ref.data.data,
        isMobile = _ref.isMobile;

    if (!data) {
        return _ref2;
    }

    var displayPdf = function displayPdf(pdf) {
        return _jsx('div', {
            className: 'hp-stallionBookPdf__wrapper'
        }, pdf.sequence, _jsx('iframe', {
            scrolling: 'auto',
            src: pdf.url,
            width: '100%',
            height: '600px'
        }), isMobile && _jsx('a', {
            href: pdf.url,
            target: '_blank',
            rel: 'noopener noreferrer',
            onClick: function onClick() {
                window.open(pdf.url, 'popup', 'width=750px,height=600');
                return false;
            },
            className: 'hp-stallionBookPdf__full-screen-btn'
        }, void 0, 'OPEN PDF IN FULL SCREEN'));
    };

    return _jsx('div', {}, void 0, data.map(function (pdf) {
        return displayPdf(pdf);
    }), _ref3);
};

exports.default = StallionBookPdf;

/***/ }),
/* 1198 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _StatsTables = __webpack_require__(1199);

var _StatsTables2 = _interopRequireDefault(_StatsTables);

var _Switcher = __webpack_require__(295);

var _Switcher2 = _interopRequireDefault(_Switcher);

var _fixMobileSafariWhiteScreenBug = __webpack_require__(200);

var _fixMobileSafariWhiteScreenBug2 = _interopRequireDefault(_fixMobileSafariWhiteScreenBug);

var _transformData = __webpack_require__(1201);

var _transformData2 = _interopRequireDefault(_transformData);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var raceTypes = ['flat', 'jumps'];

var Stats = function (_PureComponent) {
    _inherits(Stats, _PureComponent);

    function Stats(props) {
        _classCallCheck(this, Stats);

        var _this = _possibleConstructorReturn(this, (Stats.__proto__ || Object.getPrototypeOf(Stats)).call(this, props));

        _initialiseProps.call(_this);

        var _props$data$stats = props.data.stats,
            statsFlat = _props$data$stats.statsFlat,
            statsJumps = _props$data$stats.statsJumps;


        _this.raceTypeStats = [(0, _lodash.isEmpty)(statsFlat) ? null : (0, _transformData2.default)(statsFlat.statistics, 'flat'), (0, _lodash.isEmpty)(statsJumps) ? null : (0, _transformData2.default)(statsJumps.statistics, 'jumps')];

        var selected = !_this.raceTypeStats[0] && _this.raceTypeStats[1] ? 1 : 0;

        _this.state = { selected: selected };
        return _this;
    }

    _createClass(Stats, [{
        key: 'render',
        value: function render() {
            var selected = this.state.selected;


            return _jsx('section', {
                className: 'hp-stats'
            }, void 0, _jsx('div', {
                className: 'ui-centered-wrapper'
            }, void 0, _jsx(_Switcher2.default, {
                items: raceTypes,
                selected: selected,
                setSelected: this.setSelected
            })), _jsx(_StatsTables2.default, {
                data: this.raceTypeStats[selected],
                raceType: raceTypes[selected]
            }));
        }
    }]);

    return Stats;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.setSelected = function (selected) {
        _this2.setState({ selected: selected }, function () {
            (0, _fixMobileSafariWhiteScreenBug2.default)();
        });
    };
};

exports.default = Stats;

/***/ }),
/* 1199 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1200);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var tables = ['course', 'distance', 'going', 'month', 'jockey', 'class'];

var StatsTables = function StatsTables(_ref) {
    var data = _ref.data,
        raceType = _ref.raceType;
    return data ? _jsx('div', {}, void 0, tables.map(function (tableKey) {
        return _jsx(_rpReactTable2.default, {
            data: data[tableKey],
            columns: [_columns.firstColumns[tableKey]].concat(_toConsumableArray(_columns.sharedColumns)),
            className: 'hp-stats__table',
            sortable: true,
            initialSortIdx: 0
        }, tableKey);
    })) : _jsx(_rpReactTable.NoData, {
        text: 'No stats for this horse ' + (raceType === 'flat' ? 'on the Flat' : 'over Jumps')
    });
};

var sharedPropTypes = {
    startsNumber: _propTypes2.default.number,
    place1stNumber: _propTypes2.default.number,
    place2ndNumber: _propTypes2.default.number,
    place3rdNumber: _propTypes2.default.number,
    winPrize: _propTypes2.default.number,
    totalPrize: _propTypes2.default.number,
    bestRpTopspeed: _propTypes2.default.number,
    bestRpPostmark: _propTypes2.default.number
};

exports.default = StatsTables;

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.firstColumns = exports.sharedColumns = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(39);

var _ProfileLink = __webpack_require__(26);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _number = __webpack_require__(97);

var _date = __webpack_require__(18);

var _going = __webpack_require__(632);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sharedColumns = exports.sharedColumns = [{
    key: 'startsNumber',
    header: 'runs'
}, {
    key: 'place1stNumber',
    header: 'wins'
}, {
    key: 'place2ndNumber',
    header: '2nd'
}, {
    key: 'place3rdNumber',
    header: '3rd'
}, {
    key: 'netWinPrize',
    header: 'win prize money',
    cell: function cell(_ref) {
        var netWinPrize = _ref.netWinPrize;
        return (0, _money.formatMoney)(netWinPrize);
    }
}, {
    key: 'netTotalPrize',
    header: 'total prize money',
    cell: function cell(_ref2) {
        var netTotalPrize = _ref2.netTotalPrize;
        return (0, _money.formatMoney)(netTotalPrize);
    }
}, {
    key: 'bestRpTopspeed',
    header: 'best ts',
    cell: (0, _number.zeroToDash)('bestRpTopspeed')
}, {
    key: 'bestRpPostmark',
    header: 'best rpr',
    cell: (0, _number.zeroToDash)('bestRpPostmark'),
    sortFn: (0, _number.numericAndDashSort)('bestRpPostmark')
}];

var firstColumns = exports.firstColumns = {
    course: {
        key: 'courseStyleName',
        header: 'course',
        cell: function cell(_ref3) {
            var courseStyleName = _ref3.courseStyleName,
                courseUid = _ref3.courseUid,
                courseComment = _ref3.courseComment;
            return _jsx(_ProfileLink.CourseLink, {
                courseStyleName: courseStyleName,
                courseUid: courseUid,
                title: courseComment
            });
        },
        sortFn: 'alphabetic'
    },
    distance: {
        key: 'distance',
        sortFn: function sortFn(a, b) {
            return a.distanceYard - b.distanceYard;
        }
    },
    jockey: {
        key: 'jockeyStyleName',
        header: 'jockey',
        cell: function cell(_ref4) {
            var jockeyStyleName = _ref4.jockeyStyleName,
                jockeyShortName = _ref4.jockeyShortName,
                jockeyUid = _ref4.jockeyUid;
            return _jsx(_ProfileLink.JockeyLink, {
                jockeyStyleName: jockeyStyleName,
                jockeyUid: jockeyUid
            }, void 0, _jsx(_Abbr2.default, {
                title: jockeyStyleName,
                breakpoint: 'fromMedium'
            }, void 0, jockeyShortName));
        },
        sortFn: 'byLastName'
    },
    going: {
        key: 'going',
        sortFn: _going.goingSortFn
    },
    month: {
        key: 'monthName',
        header: 'month',
        sortFn: (0, _date.sortByDate)('dateStr', true)
    },
    class: {
        key: 'class',
        header: 'class',
        cell: function cell(_ref5) {
            var cls = _ref5.class;

            var match = cls.match(/^Cl(\d+)$/);
            return match ? 'Class ' + match[1] : cls;
        },
        sortFn: 'alphabetic'
    }
};

/***/ }),
/* 1201 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint no-param-reassign: 0 */


var _distance = __webpack_require__(113);

var _date = __webpack_require__(18);

var _object = __webpack_require__(300);

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// adding year to month to make it parsible for "new Date()"
var year = (0, _date.getYearFromUtc)();
var addDateStr = function addDateStr(data) {
    return data.map(function (row) {
        return _extends({}, row, { dateStr: row.monthName + ' ' + year });
    });
};

// keys that are calculated as summ of values
var summKeys = ['place1stNumber', 'place2ndNumber', 'place3rdNumber', 'startsNumber', 'netWinPrize', 'netTotalPrize'];

// keys that are calculated as maximum of values
var maxKeys = ['distanceYard', 'bestRpTopspeed', 'bestRpPostmark'];

var createEmptyRow = function createEmptyRow() {
    var row = {};
    [].concat(summKeys, maxKeys).forEach(function (key) {
        row[key] = 0;
    });
    return row;
};

// aggregating data by groups
var aggrData = function aggrData(data, groupKey, raceType) {
    var isDistance = groupKey === 'distanceYard';

    var groupedData = data.reduce(function (acc, item) {
        var group = isDistance ? (0, _distance.distanceMap)(item.distanceYard, raceType) : item[groupKey];

        if (!acc[group]) {
            acc[group] = createEmptyRow();
        }

        summKeys.forEach(function (key) {
            acc[group][key] += item[key];
        });

        maxKeys.forEach(function (key) {
            acc[group][key] = Math.max(item[key], acc[group][key]);
        });

        return acc;
    }, {});

    var newGroupKey = isDistance ? 'distance' : 'going';

    return (0, _object.fromObjToArray)(groupedData, newGroupKey);
};

var transformData = function transformData(_ref, raceType) {
    var month = _ref.month,
        going = _ref.going,
        distance = _ref.distance,
        rest = _objectWithoutProperties(_ref, ['month', 'going', 'distance']);

    return _extends({
        month: addDateStr(month),
        going: aggrData(going, 'goingTypeDesc'),
        distance: aggrData(distance, 'distanceYard', raceType)
    }, rest);
};

exports.default = transformData;

/***/ }),
/* 1202 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseParentsTree = function HorseParentsTree(_ref) {
    var father = _ref.father,
        mother = _ref.mother;
    return _jsx('div', {
        className: 'family-tree__horse-parents'
    }, void 0, _jsx('div', {
        className: 'family-tree__horse-father'
    }, void 0, _jsx('div', {
        className: 'family-tree__horse-info'
    }, void 0, _jsx('div', {
        className: 'family-tree__horse-info-wrapper'
    }, void 0, _jsx('div', {
        className: 'family-tree__horse-name'
    }, void 0, father.horseName), _jsx('div', {
        className: 'family-tree__horse-details'
    }, void 0, father.horseBestRacePerf && 'R: BTW ', father.progenyBestPerf && 'B: ' + father.progenyBestPerfCount + ' ' + father.progenyBestPerf))), father.parents && HorseParentsTree(father.parents)), _jsx('div', {
        className: 'family-tree__horse-mother'
    }, void 0, _jsx('div', {
        className: 'family-tree__horse-info'
    }, void 0, _jsx('div', {
        className: 'family-tree__horse-info-wrapper'
    }, void 0, _jsx('div', {
        className: 'family-tree__horse-name'
    }, void 0, mother.horseName), _jsx('div', {
        className: 'family-tree__horse-details'
    }, void 0, mother.horseBestRacePerf && 'R: BTW ', mother.progenyBestPerf && 'B: ' + mother.progenyBestPerfCount + ' ' + mother.progenyBestPerf))), mother.parents && HorseParentsTree(mother.parents)));
};

exports.default = HorseParentsTree;

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Nav = __webpack_require__(405);

var _Nav2 = _interopRequireDefault(_Nav);

var _Details = __webpack_require__(1204);

var _Details2 = _interopRequireDefault(_Details);

var _MetaData = __webpack_require__(404);

var _MetaData2 = _interopRequireDefault(_MetaData);

var _getDetailsData = __webpack_require__(1206);

var _getDetailsData2 = _interopRequireDefault(_getDetailsData);

var _nameRow = __webpack_require__(1227);

var _nameRow2 = _interopRequireDefault(_nameRow);

var _BestOdds = __webpack_require__(630);

var _BestOdds2 = _interopRequireDefault(_BestOdds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HumanPage = function HumanPage(_ref) {
    var data = _ref.data,
        children = _ref.children,
        params = _ref.params,
        userRole = _ref.userRole,
        pageName = _ref.pageName;

    var NameRow = _nameRow2.default[params.type];
    var detailsData = (0, _getDetailsData2.default)(data.recordsByType, params.type);
    var _data$externalLinks = data.externalLinks,
        imagesUrl = _data$externalLinks.imagesUrl,
        helpCenterUrl = _data$externalLinks.helpCenterUrl,
        profile = data.profile,
        skybetDiffusionName = data.skybetDiffusionName;


    return _jsx('div', {}, void 0, _jsx(_MetaData2.default, {
        type: params.type,
        page: params.tab ? params.tab : 'form',
        name: profile.styleName
    }), _jsx('section', {}, void 0, _jsx(NameRow, {
        profile: profile,
        imagesHost: imagesUrl
    }), _jsx(_Details2.default, {
        data: detailsData,
        type: params.type
    }), _jsx(_BestOdds2.default, {
        skybetDiffusionName: skybetDiffusionName
    })), _jsx(_Nav2.default, {
        params: params,
        helpUrl: helpCenterUrl,
        userRole: userRole,
        pageName: pageName
    }), (0, _react.cloneElement)(children, { data: data, params: params }));
};

exports.default = HumanPage;

/***/ }),
/* 1204 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Select = __webpack_require__(402);

var _Select2 = _interopRequireDefault(_Select);

var _columns = __webpack_require__(1205);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Details = function (_PureComponent) {
    _inherits(Details, _PureComponent);

    function Details(props) {
        _classCallCheck(this, Details);

        var _this = _possibleConstructorReturn(this, (Details.__proto__ || Object.getPrototypeOf(Details)).call(this, props));

        _this.onSelect = function (val) {
            _this.setState({ selectValue: +val });
        };

        _this.state = { selectValue: 0 };
        return _this;
    }

    _createClass(Details, [{
        key: 'render',
        value: function render() {
            var selectValue = this.state.selectValue;
            var _props = this.props,
                data = _props.data,
                type = _props.type;

            if (!data.length) {
                return null;
            }

            var _data$selectValue$tit = data[selectValue].title,
                race = _data$selectValue$tit.race,
                season = _data$selectValue$tit.season;

            var isIreSelected = race.includes('IRE');
            var classPrefix = type === 'jockey' ? 'jockey' : 'notJockey';

            return _jsx('div', {
                className: 'mp-details mp-details_' + classPrefix
            }, void 0, _jsx(_Select2.default, {
                value: selectValue,
                options: data.map(function (item) {
                    return item.title.option;
                }),
                onSelect: this.onSelect,
                wrapperClass: 'pp-select_details'
            }, void 0, race, '\xA0', _jsx('span', {
                className: 'mp-details__season'
            }, void 0, season)), _jsx('div', {
                className: 'mp-details__wrapper'
            }, void 0, _jsx(_rpReactTable2.default, {
                data: data[selectValue].rows,
                footerData: data[selectValue].total,
                columns: (0, _columns2.default)(type, isIreSelected),
                uiType: 5,
                initialSortIdx: 0
            })));
        }
    }]);

    return Details;
}(_react.PureComponent);

var rowPropTypes = _propTypes2.default.shape({
    // common:
    groupName: _propTypes2.default.string.isRequired,
    wins: _propTypes2.default.number,
    runs: _propTypes2.default.number,
    percent: _propTypes2.default.number,
    placed: _propTypes2.default.number,
    stake: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
    totalEarnings: _propTypes2.default.string,
    // jockey:
    '2nd': _propTypes2.default.number,
    '3rd': _propTypes2.default.number,
    '4ths': _propTypes2.default.number,
    winnings: _propTypes2.default.string,
    // trainer & owner
    winsHorses: _propTypes2.default.string,
    horseName: _propTypes2.default.string,
    horseUid: _propTypes2.default.number,
    rpr: _propTypes2.default.number
});

exports.default = Details;

/***/ }),
/* 1205 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _ProfileLink = __webpack_require__(26);

var _StakeCell = __webpack_require__(296);

var _StakeCell2 = _interopRequireDefault(_StakeCell);

var _name = __webpack_require__(231);

var _number = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    title: 'wins'
});

var _ref2 = _jsx(_Abbr2.default, {
    title: 'placed'
});

var columns = function columns(type, isIreSelected) {
    var stakeCell = {
        key: 'stake',
        header: (isIreSelected ? '€' : '£') + '1 Stake',
        cell: _StakeCell2.default
    };

    var commonColumns = [{
        key: 'groupName',
        header: ' ',
        sortFn: (0, _name.sortByRaceName)('groupName')
    }, {
        key: 'wins',
        header: function header() {
            return _ref;
        }
    }, {
        key: 'runs',
        header: function header() {
            return _jsx(_Abbr2.default, {
                title: type === 'jockey' ? 'rides' : 'runs'
            });
        }
    }, {
        key: 'percent',
        header: '%'
    }, {
        key: 'placed',
        header: function header() {
            return _ref2;
        }
    }];

    if (type === 'jockey') {
        return commonColumns.concat([{
            key: '2nd'
        }, {
            key: '3rd'
        }, {
            key: '4ths'
        }, {
            key: 'winnings'
        }, {
            key: 'totalEarnings'
        }, _extends({}, stakeCell)]);
    }

    return commonColumns.concat([{
        key: 'winsHorses',
        header: 'winners / horses'
    }, {
        key: 'totalEarnings'
    }, _extends({}, stakeCell), {
        key: 'horseUid',
        header: 'best in category',
        cell: _ProfileLink.HorseLink
    }, {
        key: 'rpr',
        cell: (0, _number.zeroToDash)('rpr')
    }]);
};

exports.default = columns;

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(9);

var _getRow = __webpack_require__(1207);

var _getRow2 = _interopRequireDefault(_getRow);

var _getTitle = __webpack_require__(1208);

var _getTitle2 = _interopRequireDefault(_getTitle);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var emptyTable = { total: {} };
var seasonsPeriods = [5, 1];

var getDetailsData = function getDetailsData(apiData, profileType) {
    if (!apiData) {
        return [];
    }

    var data = (0, _lodash.keys)(apiData).map(function (key) {
        return seasonsPeriods.map(function (period) {
            var recordsData = apiData[key][period].data;
            var rows = (0, _lodash.values)(recordsData.recordByRaceType);
            var total = rows.find(function (row) {
                return row.groupName === 'total';
            });

            if (!total) {
                return emptyTable;
            }

            var isIre = key.includes('IRE');

            return {
                rows: (0, _lodash.without)(rows, total).map(function (row) {
                    return (0, _getRow2.default)(row, profileType, isIre);
                }),
                total: (0, _getRow2.default)(total, profileType, isIre),
                title: total.racesNumber && (0, _getTitle2.default)(recordsData.seasonInfo)
            };
        });
    });

    var sortedData = [].concat(_toConsumableArray(data)).sort(function (item1, item2) {
        return item2[0].total.runs - item1[0].total.runs;
    });

    return (0, _lodash.flatten)(sortedData).filter(function (item) {
        return item.total.runs;
    });
};

exports.default = getDetailsData;

/***/ }),
/* 1207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _lodash = __webpack_require__(9);

var _money = __webpack_require__(39);

var _name = __webpack_require__(231);

var getRow = function getRow(row, profileType, isIre) {
    var res = {
        groupName: (0, _name.formatRaceName)(row.groupName),
        wins: row.place1stNumber,
        runs: row.racesNumber,
        percent: (0, _lodash.isNumber)(row.winPercent) ? row.winPercent : row.percent,
        placed: row.placed,
        stake: row.stake,
        totalEarnings: isIre ? (0, _money.formatSalePrice)(row.euroTotalPrize, 'EUR') : (0, _money.formatSalePrice)(row.totalPrize, 'GBP')
    };

    if (profileType === 'jockey') {
        return _extends({}, res, {
            '2nd': row.place2ndNumber,
            '3rd': row.place3rdNumber,
            '4ths': row.place4thNumber,
            winnings: isIre ? (0, _money.formatSalePrice)(row.euroWinPrize, 'EUR') : (0, _money.formatSalePrice)(row.winPrize, 'GBP')
        });
    }

    return _extends({}, res, {
        winsHorses: row.winners + '/' + row.horses,
        horseStyleName: row.horseName,
        horseUid: row.horseUid,
        rpr: row.bestRpPostmark
    });
};

exports.default = getRow;

/***/ }),
/* 1208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(9);

var _date = __webpack_require__(18);

var getTitle = function getTitle(_ref) {
    var seasonDateBegin = _ref.seasonDateBegin,
        seasonDateEnd = _ref.seasonDateEnd,
        seasonYearBegin = _ref.seasonYearBegin,
        seasonYearEnd = _ref.seasonYearEnd,
        countryCode = _ref.countryCode,
        raceType = _ref.raceType;

    var seasons = seasonYearEnd - seasonYearBegin < 4 ? 'current season' : 'last 5 seasons';
    var dateBegin = (0, _date.formatDate)(seasonDateBegin, 'MMM Y');
    var dateEnd = (0, _date.formatDate)(seasonDateEnd, 'MMM Y');
    var type = raceType === 'jumps' ? raceType : (0, _lodash.capitalize)(raceType);

    var race = countryCode + ' ' + type;
    var season = seasons + ' ' + dateBegin + ' - ' + dateEnd;
    var option = race + ' ' + season;

    return { race: race, season: season, option: option };
};

exports.default = getTitle;

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Header = __webpack_require__(1214);

var _Header2 = _interopRequireDefault(_Header);

var _columns = __webpack_require__(1210);

var _columns2 = _interopRequireDefault(_columns);

var _getSinceWin = __webpack_require__(1220);

var _getSinceWin2 = _interopRequireDefault(_getSinceWin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('div', {
    className: 'pp-bottomText'
}, void 0, 'DIFF is the difference between the RPR the horse recorded and their expected RPR');

var Form = function Form(_ref) {
    var _ref$data = _ref.data,
        last14Days = _ref$data.last14Days,
        profile = _ref$data.profile,
        entries = _ref$data.entries,
        bookedRides = _ref$data.bookedRides,
        type = _ref.params.type;
    return _jsx('section', {
        className: 'mp-form mp-form_' + type
    }, void 0, _jsx(_Header2.default, {
        winsRuns: profile[type + 'Last14Days'] || undefined,
        sinceWin: (0, _getSinceWin2.default)(profile.sinceAWin, entries || bookedRides),
        upcomingEntries: !!(entries || bookedRides || []).length,
        profileType: type
    }), _jsx(_rpReactTable2.default, {
        data: last14Days || [],
        columns: (0, _columns2.default)(type),
        initialSortIdx: 0,
        noDataText: 'No form for this ' + type,
        sortable: true
    }), _ref2);
};

var profileLast14Days = _propTypes2.default.shape({
    wins: _propTypes2.default.number,
    runs: _propTypes2.default.number,
    percent: _propTypes2.default.number
});

exports.default = Form;

/***/ }),
/* 1210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.posSortFn = undefined;

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _DateCell = __webpack_require__(1213);

var _DateCell2 = _interopRequireDefault(_DateCell);

var _CourseHeader = __webpack_require__(1212);

var _CourseHeader2 = _interopRequireDefault(_CourseHeader);

var _CourseCell = __webpack_require__(1211);

var _CourseCell2 = _interopRequireDefault(_CourseCell);

var _HorseHeader = __webpack_require__(1216);

var _HorseHeader2 = _interopRequireDefault(_HorseHeader);

var _HorseCell = __webpack_require__(1215);

var _HorseCell2 = _interopRequireDefault(_HorseCell);

var _PosCell = __webpack_require__(1217);

var _PosCell2 = _interopRequireDefault(_PosCell);

var _ProfileLink = __webpack_require__(26);

var _ProfileLink2 = _interopRequireDefault(_ProfileLink);

var _date = __webpack_require__(18);

var _number = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var posSortFn = exports.posSortFn = function posSortFn(a, b) {
    var outcomeCodeA = a.raceOutcomeCode;
    var outcomeCodeB = b.raceOutcomeCode;

    if (isNaN(outcomeCodeA) && isNaN(outcomeCodeB)) {
        return (0, _date.sortByDate)('raceDatetime')(a, b);
    }
    if (isNaN(outcomeCodeA)) {
        return 1;
    }
    if (isNaN(outcomeCodeB)) {
        return -1;
    }
    if (outcomeCodeA !== outcomeCodeB) {
        return outcomeCodeA - outcomeCodeB;
    }

    return (0, _date.sortByDate)('raceDatetime')(a, b);
};

var columns = function columns(profileType) {
    var _ref = _jsx(_HorseHeader2.default, {
        isJockey: profileType === 'jockey'
    });

    var staff = profileType === 'trainer' ? 'jockey' : 'trainer';

    return [{
        key: 'raceDatetime',
        header: 'date',
        cell: _DateCell2.default,
        sortFn: (0, _date.sortByDate)('raceDatetime')
    }, {
        key: 'courseRpAbbrev3',
        header: _CourseHeader2.default,
        cell: _CourseCell2.default,
        sortFn: 'alphabetic'
    }, {
        key: 'raceOutcomeCode',
        header: 'pos.',
        cell: _PosCell2.default,
        sortFn: posSortFn
    }, {
        key: 'horseStyleName',
        header: function header() {
            return _ref;
        },
        cell: function cell(props) {
            return _react2.default.createElement(_HorseCell2.default, _extends({}, props, { profileType: profileType }));
        },
        sortFn: 'alphabetic'
    }, {
        key: 'oddsDesc',
        header: 'sp',
        sortFn: function sortFn(_ref2, _ref3) {
            var a = _ref2.oddsValue;
            var b = _ref3.oddsValue;
            return a - b;
        }
    }, {
        key: staff + 'ShortName',
        header: staff,
        cell: function cell(rowData) {
            var StaffLink = _ProfileLink2.default[staff];
            return _jsx('span', {}, void 0, _react2.default.createElement(StaffLink, rowData), !!rowData.weightAllowanceLbs && staff === 'jockey' && _jsx('sup', {
                className: 'mp-form__jockeyAllowance'
            }, void 0, rowData.weightAllowanceLbs));
        },
        sortFn: 'byLastName'
    }, {
        key: 'rpPostmark',
        header: 'rpr',
        cell: (0, _number.zeroToDash)('rpPostmark'),
        sortFn: (0, _number.numericAndDashSort)('rpPostmark')
    }, {
        key: 'rpPostmarkDifference',
        header: 'diff'
    }];
};

exports.default = columns;

/***/ }),
/* 1211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _ProfileLink = __webpack_require__(26);

var _money = __webpack_require__(39);

var _distance = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('wbr', {});

var _ref3 = _jsx('wbr', {});

var _ref4 = _jsx('wbr', {});

var CourseCell = function CourseCell(_ref) {
    var courseStyleName = _ref.courseStyleName,
        courseRpAbbrev3 = _ref.courseRpAbbrev3,
        courseUid = _ref.courseUid,
        raceClass = _ref.raceClass,
        raceDescription = _ref.raceDescription,
        distanceYard = _ref.distanceYard,
        goingTypeServicesDesc = _ref.goingTypeServicesDesc,
        prizeSterling = _ref.prizeSterling;
    return _jsx('span', {}, void 0, _jsx(_ProfileLink.CourseLink, {
        courseStyleName: courseStyleName,
        courseShortName: (0, _lodash.upperFirst)((0, _lodash.toLower)(courseRpAbbrev3)),
        courseUid: courseUid
    }), '\xA0', _ref2, _jsx('span', {
        className: 'hidden-sm-down'
    }, void 0, (0, _distance.yardsToFurlongs)(distanceYard), goingTypeServicesDesc), '\xA0', _ref3, _jsx('span', {
        className: 'hidden-xs-down'
    }, void 0, raceClass && 'C', raceDescription), '\xA0', _ref4, _jsx('span', {
        className: 'hidden-sm-down'
    }, void 0, (0, _money.formatPrize)(prizeSterling)));
};

exports.default = CourseCell;

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref = _jsx(_Abbr2.default, {
    title: 'Course / Conditions / Prize',
    breakpoint: 'fromMedium'
}, void 0, _jsx('span', {
    className: 'hidden-sm-up'
}, void 0, 'Crs.'), _jsx('span', {
    className: 'hidden-xs-down hidden-md-up'
}, void 0, 'Crs / Class / Type'));

var CrsHeader = function CrsHeader() {
    return _ref;
};

exports.default = CrsHeader;

/***/ }),
/* 1213 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = __webpack_require__(542);

var _get2 = _interopRequireDefault(_get);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _ReplayLink = __webpack_require__(627);

var _ReplayLink2 = _interopRequireDefault(_ReplayLink);

var _date = __webpack_require__(18);

var _horse = __webpack_require__(161);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DateCell = function DateCell(props) {
    var videoDetail = (0, _get2.default)(props, 'videoDetail[0]');
    var shouldDisplayIcon = (0, _horse.shouldShowReplayButton)(videoDetail);

    return _jsx('div', {
        className: 'mp-form__dateWrapper' + (!shouldDisplayIcon ? '__noVideoIcon' : '')
    }, void 0, shouldDisplayIcon && _react2.default.createElement(_ReplayLink2.default, props), _jsx(_ResultLink2.default, {
        courseName: props.courseName,
        courseUid: props.courseUid,
        raceDatetime: props.raceDatetime,
        raceInstanceUid: props.raceInstanceUid,
        raceInstanceTitle: props.raceInstanceTitle,
        className: 'mp-form__date'
    }, void 0, (0, _date.formatDate)(props.raceDatetime, 'DDMMM'), _jsx('span', {
        className: 'hidden-sm-down'
    }, void 0, (0, _date.formatDate)(props.raceDatetime, 'YY'))));
};

exports.default = DateCell;

/***/ }),
/* 1214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _WinsRuns = __webpack_require__(1219);

var _WinsRuns2 = _interopRequireDefault(_WinsRuns);

var _SinceWin = __webpack_require__(1218);

var _SinceWin2 = _interopRequireDefault(_SinceWin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('h2', {
    className: 'mp-form__title'
}, void 0, 'Last 14 days');

var Header = function Header(_ref) {
    var profileType = _ref.profileType,
        winsRuns = _ref.winsRuns,
        sinceWin = _ref.sinceWin,
        upcomingEntries = _ref.upcomingEntries;
    return _jsx('div', {
        className: 'mp-form__header'
    }, void 0, _ref2, (winsRuns.runs || upcomingEntries) && _jsx('div', {
        className: 'mp-form__info'
    }, void 0, winsRuns.runs ? _react2.default.createElement(_WinsRuns2.default, _extends({ profileType: profileType }, winsRuns)) : null, _react2.default.createElement(_SinceWin2.default, _extends({ profileType: profileType }, sinceWin.flat, { type: 'flat' })), _react2.default.createElement(_SinceWin2.default, _extends({ profileType: profileType }, sinceWin.jumps, { type: 'jumps' }))));
};

Header.defaultProps = {
    winsRuns: {}
};

exports.default = Header;

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _formatWeight = __webpack_require__(299);

var _formatWeight2 = _interopRequireDefault(_formatWeight);

var _distance = __webpack_require__(113);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseCell = function HorseCell(_ref) {
    var profileType = _ref.profileType,
        courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        raceInstanceUid = _ref.raceInstanceUid,
        raceDatetime = _ref.raceDatetime,
        rpCloseUpComment = _ref.rpCloseUpComment,
        rpBettingMovements = _ref.rpBettingMovements,
        horseStyleName = _ref.horseStyleName,
        raceOutcomeCode = _ref.raceOutcomeCode,
        winningDistance = _ref.winningDistance,
        distanceToWinner = _ref.distanceToWinner,
        weightCarriedLbs = _ref.weightCarriedLbs,
        horseHeadGear = _ref.horseHeadGear;
    return _jsx(_ResultLink2.default, {
        courseName: courseName,
        courseUid: courseUid,
        raceInstanceUid: raceInstanceUid,
        raceDatetime: raceDatetime,
        raceInstanceTitle: '' + rpCloseUpComment + (rpBettingMovements ? ' (' + rpBettingMovements + ')' : ''),
        cssClass: 'mp-form__disabledOnNarrow',
        showAfter: false
    }, void 0, _jsx('span', {
        className: 'hidden-xs-down'
    }, void 0, (0, _distance.formatWinDist)(raceOutcomeCode, winningDistance, distanceToWinner)), horseStyleName, weightCarriedLbs && profileType === 'jockey' && _jsx('span', {
        className: 'hidden-xs-down'
    }, void 0, '\xA0', (0, _formatWeight2.default)(weightCarriedLbs)), _jsx('span', {
        className: 'hidden-sm-down'
    }, void 0, '\xA0', horseHeadGear));
};

exports.default = HorseCell;

/***/ }),
/* 1216 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'hidden-xs-down'
}, void 0, 'Finishing dist / ');

var _ref3 = _jsx('span', {
    className: 'hidden-xs-down'
}, void 0, ' / weight');

var HorseHeader = function HorseHeader(_ref) {
    var isJockey = _ref.isJockey;
    return _jsx(_Abbr2.default, {
        breakpoint: 'fromMedium',
        title: 'Finishing dist / Horse ' + (isJockey ? '/ weight ' : '') + '/ hdgr'
    }, void 0, _ref2, 'Horse', isJockey && _ref3);
};

exports.default = HorseHeader;

/***/ }),
/* 1217 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PosCell = function PosCell(_ref) {
    var raceOutcomeCode = _ref.raceOutcomeCode,
        noOfRunners = _ref.noOfRunners,
        disqualificationDesc = _ref.disqualificationDesc;
    return _jsx('span', {}, void 0, _jsx('strong', {}, void 0, _lodash2.default.toLower(disqualificationDesc) === 'disq' ? 'd' : raceOutcomeCode.trim()), '/', noOfRunners);
};

exports.default = PosCell;

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SinceWin = function SinceWin(_ref) {
    var profileType = _ref.profileType,
        days = _ref.days,
        runs = _ref.runs,
        type = _ref.type;
    return profileType === 'owner' || !(days || runs) ? null : _jsx('span', {
        className: 'mp-form__stats'
    }, void 0, _jsx('span', {
        className: 'mp-form__stats__label'
    }, void 0, 'Since win ', type, ': '), _jsx('strong', {}, void 0, runs, '\xA0'), profileType === 'jockey' ? 'rides' : 'runs', '\xA0', _jsx('strong', {}, void 0, days, '\xA0'), 'days');
};

exports.default = SinceWin;

/***/ }),
/* 1219 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'mp-form__stats__label'
}, void 0, 'Wins: ');

var WinsRuns = function WinsRuns(_ref) {
    var profileType = _ref.profileType,
        wins = _ref.wins,
        runs = _ref.runs,
        percent = _ref.percent;
    return _jsx('div', {}, void 0, _jsx('span', {
        className: 'mp-form__stats'
    }, void 0, _ref2, _jsx('strong', {}, void 0, wins)), _jsx('span', {
        className: 'mp-form__stats'
    }, void 0, _jsx('span', {
        className: 'mp-form__stats__label'
    }, void 0, profileType === 'jockey' ? 'Rides: ' : 'Runs: '), _jsx('strong', {}, void 0, runs)), _jsx('span', {
        className: 'mp-form__stats'
    }, void 0, _jsx('strong', {}, void 0, '(', percent, '%)')));
};

exports.default = WinsRuns;

/***/ }),
/* 1220 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getSinceWin = function getSinceWin(sinsWin, entries) {
    /**
     * Flat:  X, F
     * Jumps: J, B
     */
    var flatCodes = ['X', 'F'];
    var jumpsCodes = ['B', 'J'];

    if (!entries) {
        return sinsWin;
    }

    var isFlatEntries = entries.some(function (entry) {
        return flatCodes.includes(entry.courseTypeCode);
    });
    var isJumpsEntries = entries.some(function (entry) {
        return jumpsCodes.includes(entry.courseTypeCode);
    });

    return {
        flat: isFlatEntries ? sinsWin.flat : null,
        jumps: isJumpsEntries ? sinsWin.jumps : null
    };
};

exports.default = getSinceWin;

/***/ }),
/* 1221 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _Filter = __webpack_require__(142);

var _Filter2 = _interopRequireDefault(_Filter);

var _filter = __webpack_require__(144);

var _filter2 = _interopRequireDefault(_filter);

var _columns = __webpack_require__(1223);

var _columns2 = _interopRequireDefault(_columns);

var _categories = __webpack_require__(620);

var _categories2 = _interopRequireDefault(_categories);

var _categoriesReducer = __webpack_require__(1222);

var _categoriesReducer2 = _interopRequireDefault(_categoriesReducer);

var _storage = __webpack_require__(410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Horses = function (_FilteringComponent) {
    _inherits(Horses, _FilteringComponent);

    function Horses(props) {
        _classCallCheck(this, Horses);

        var _this = _possibleConstructorReturn(this, (Horses.__proto__ || Object.getPrototypeOf(Horses)).call(this, props));

        _initialiseProps.call(_this);

        var _this$props = _this.props,
            _this$props$data = _this$props.data,
            horses = _this$props$data.horses,
            profileSeasonInfo = _this$props$data.seasonInfo,
            type = _this$props.params.type;

        var _ref = horses || {},
            seasonInfo = _ref.seasonInfo,
            horsesData = _ref.horses;
        // seasonInfo data absent in horses request data when jockey hasn't current year races
        // but it's available in profile overview request


        var _ref2 = seasonInfo || profileSeasonInfo || {},
            countryCode = _ref2.countryCode,
            raceType = _ref2.raceType;

        var categories = (0, _categories2.default)(countryCode, raceType);

        _this.state = {
            data: horsesData || [],
            loading: false,
            categories: categories,
            fetchError: false
        };

        var columnsSet = type === 'trainer' ? 'trainer' : 'default';
        _this.columns = _columns2.default[columnsSet];
        _this.dataKey = 'horses';
        return _this;
    }

    _createClass(Horses, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props$params = this.props.params,
                tab = _props$params.tab,
                type = _props$params.type;

            var categories = (0, _storage.getCategories)(tab, type, _categoriesReducer2.default, this.state.categories);
            if (categories) {
                this.onFilterApply(categories);
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                data = _state.data,
                loading = _state.loading,
                categories = _state.categories,
                fetchError = _state.fetchError;


            return _jsx('section', {
                className: 'mp-horses'
            }, void 0, categories && _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _categoriesReducer2.default,
                columns: this.columns,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: data,
                columns: this.columns,
                loading: loading,
                noDataText: 'No horses found',
                resultsPerPage: 50
            }));
        }
    }]);

    return Horses;
}(_filter2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.buildUrl = function (_ref3) {
        var timePeriod = _ref3.timePeriod,
            raceType = _ref3.raceType;
        var _props$params2 = _this2.props.params,
            type = _props$params2.type,
            id = _props$params2.id;

        return 'filter/' + type + '/' + id + '/horses/' + timePeriod.split('/')[0] + '/' + raceType;
    };
};

Horses.defaultProps = {
    data: {
        horses: {
            seasonInfo: {}
        }
    }
};

Horses.propTypes = {
    data: _propTypes2.default.shape({
        horses: _propTypes2.default.object
    }).isRequired,
    params: _propTypes2.default.shape({
        type: _propTypes2.default.string,
        id: _propTypes2.default.string
    }).isRequired
};

exports.default = Horses;

/***/ }),
/* 1222 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _categories = __webpack_require__(620);

var _selection = __webpack_require__(160);

var RACE_TYPE = 'raceType';
var getRaceType = function getRaceType(val) {
    return val.match(/jumps|flat/)[0];
};
var getCountry = function getCountry(val) {
    return val.match(/GB|IRE/)[0];
};

var timePeriodReducer = function timePeriodReducer(categories, _ref) {
    var type = _ref.type,
        value = _ref.value;
    var timePeriod = categories.timePeriod;


    if (!(0, _selection.hasValue)(categories[type], value)) {
        return timePeriod;
    }

    if (type === RACE_TYPE) {
        var newRaceType = getRaceType(value);
        if (timePeriod.createdBy.raceType !== newRaceType) {
            return (0, _categories.timePeriodsFactory)(getCountry(value), newRaceType);
        }
    }
    return timePeriod;
};

var raceTypeReducer = function raceTypeReducer(categories) {
    return categories.raceType;
};

var categoriesReducer = function categoriesReducer(categories, action) {
    return {
        raceType: raceTypeReducer(categories),
        timePeriod: timePeriodReducer(categories, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(39);

var _ProfileLink = __webpack_require__(26);

var _StakeCell = __webpack_require__(296);

var _StakeCell2 = _interopRequireDefault(_StakeCell);

var _number = __webpack_require__(97);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = [{
    key: 'horseUid',
    header: 'horse',
    cell: function cell(_ref) {
        var horse = _ref.horse,
            horseName = _ref.horseName,
            horseUid = _ref.horseUid;
        return _jsx(_ProfileLink.HorseLink, {
            horseStyleName: horse || horseName,
            horseUid: horseUid
        });
    }
}, {
    key: 'trainerStyleName',
    header: 'trainer',
    cell: function cell(_ref2) {
        var trainerName = _ref2.trainerName,
            trainerUid = _ref2.trainerUid;
        return _jsx(_ProfileLink.TrainerLink, {
            trainerStyleName: trainerName,
            trainerUid: trainerUid
        });
    }
}, {
    key: 'place1stNumber',
    header: 'wins'
}, {
    key: 'racesNumber',
    header: 'runs'
}, {
    key: 'rpr'
}, {
    key: 'totalPrize',
    header: 'total earnings',
    cell: function cell(_ref3) {
        var totalPrize = _ref3.totalPrize;
        return (0, _money.formatMoney)(totalPrize);
    },
    sortFn: (0, _number.numericAndDashSort)('totalPrize')
}, {
    key: 'winPrize',
    header: 'winnings',
    cell: function cell(_ref4) {
        var winPrize = _ref4.winPrize;
        return (0, _money.formatMoney)(winPrize);
    }
}, {
    key: 'stake',
    header: '£1 stake',
    cell: _StakeCell2.default
}];

var ownerColumn = {
    key: 'ownerStyleName',
    header: 'owner',
    cell: _ProfileLink.OwnerLink
};

var columnsSet = {
    set default(cols) {
        this.default = cols;
    },
    get default() {
        delete this.default;

        this.default = columns;

        return this.default;
    },
    set trainer(cols) {
        this.trainer = cols;
    },
    get trainer() {
        delete this.trainer;
        var trainerColumnIndex = columns.findIndex(function (c) {
            return c.header === 'trainer';
        });
        columns[trainerColumnIndex] = ownerColumn;
        this.trainer = columns;

        return this.trainer;
    }
};

exports.default = columnsSet;

/***/ }),
/* 1224 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _formatWeight = __webpack_require__(299);

var _formatWeight2 = _interopRequireDefault(_formatWeight);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var flatLicences = { P: 'Flat', A: 'Apprentice', M: 'Amateur', X: 'Retired' };

var jumpLicences = {
    P: { IRE: 'Jumps', GB: 'Jumps' },
    C: { IRE: 'Claiming Professional', GB: 'Conditional' },
    M: { IRE: 'Amateur', GB: 'Amateur' },
    X: { IRE: 'Retired', GB: 'Retired' }
};

var JockeyNameRow = function JockeyNameRow(_ref) {
    var _ref$profile = _ref.profile,
        styleName = _ref$profile.styleName,
        flat = _ref$profile.flatJockeyTypeCode,
        jump = _ref$profile.jumpJockeyTypeCode,
        country = _ref$profile.countryCode,
        weight = _ref$profile.lowestRidingWeight;

    var licenceNames = [flatLicences[flat], jump && jumpLicences[jump][country]];
    var licence = (0, _lodash2.default)(licenceNames).compact().uniq().join(' & ');

    return _jsx('div', {
        className: 'mp-nameRow'
    }, void 0, _jsx('div', {
        className: 'mp-nameRow__block'
    }, void 0, _jsx('h1', {
        className: 'mp-nameRow__name'
    }, void 0, styleName), licence && _jsx('h2', {
        className: 'mp-nameRow__licenceRow'
    }, void 0, 'Licence\xA0', _jsx('span', {
        className: 'mp-nameRow__licence'
    }, void 0, licence)), _jsx('div', {
        className: 'mp-nameRow__weightRow'
    }, void 0, 'Lowest riding weight in last 12 months\xA0', _jsx('div', {
        className: 'mp-nameRow__weight'
    }, void 0, weight ? (0, _formatWeight2.default)(weight) : null))));
};

exports.default = JockeyNameRow;

/***/ }),
/* 1225 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Image = __webpack_require__(623);

var _Image2 = _interopRequireDefault(_Image);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OwnerNameRow = function OwnerNameRow(_ref) {
    var _ref$profile = _ref.profile,
        styleName = _ref$profile.styleName,
        silkImagePath = _ref$profile.silkImagePath,
        imagesHost = _ref.imagesHost;
    return _jsx('div', {
        className: 'mp-nameRow'
    }, void 0, _jsx(_Image2.default, {
        src: imagesHost + '/png_silks/' + silkImagePath + '.png',
        imgHost: imagesHost,
        imgClass: 'mp-nameRow__silk',
        alt: 'owner details'
    }), _jsx('h1', {
        className: 'mp-nameRow__name'
    }, void 0, styleName));
};

exports.default = OwnerNameRow;

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'mp-nameRow__rtfText'
}, void 0, 'Horses running to');

var _ref3 = _jsx('span', {
    className: 'mp-nameRow__rtfText'
}, void 0, 'form in last 14 days');

var TrainerNameRow = function TrainerNameRow(_ref) {
    var _ref$profile = _ref.profile,
        styleName = _ref$profile.styleName,
        trainerLocation = _ref$profile.trainerLocation,
        runningToForm = _ref$profile.runningToForm;
    return _jsx('div', {
        className: 'mp-nameRow mp-nameRow_trainer'
    }, void 0, _jsx('div', {
        className: 'mp-nameRow__nameBlock'
    }, void 0, _jsx('h1', {
        className: 'mp-nameRow__name'
    }, void 0, styleName), _jsx('span', {
        className: 'mp-nameRow__location'
    }, void 0, trainerLocation)), (0, _lodash.isNumber)(runningToForm) && _jsx('div', {
        className: 'mp-nameRow__rtfBlock'
    }, void 0, _jsx('span', {
        className: 'mp-nameRow__rtfPercentage'
    }, void 0, 'RTF ', Math.round(runningToForm), '%'), _ref2, _ref3));
};

exports.default = TrainerNameRow;

/***/ }),
/* 1227 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _JockeyNameRow = __webpack_require__(1224);

var _JockeyNameRow2 = _interopRequireDefault(_JockeyNameRow);

var _OwnerNameRow = __webpack_require__(1225);

var _OwnerNameRow2 = _interopRequireDefault(_OwnerNameRow);

var _TrainerNameRow = __webpack_require__(1226);

var _TrainerNameRow2 = _interopRequireDefault(_TrainerNameRow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    jockey: _JockeyNameRow2.default,
    owner: _OwnerNameRow2.default,
    trainer: _TrainerNameRow2.default
};

/***/ }),
/* 1228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _Accordion = __webpack_require__(1236);

var _Accordion2 = _interopRequireDefault(_Accordion);

var _BigRaceWins = __webpack_require__(1229);

var _BigRaceWins2 = _interopRequireDefault(_BigRaceWins);

var _StatsTable = __webpack_require__(1231);

var _StatsTable2 = _interopRequireDefault(_StatsTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactTable.NoData, {
    text: 'No stats found'
});

var Stats = function Stats(_ref) {
    var _ref$data = _ref.data,
        bigRaceWins = _ref$data.bigRaceWins,
        stats = _ref$data.stats,
        params = _ref.params;
    return _jsx('section', {}, void 0, _jsx(_Accordion2.default, {
        header: 'stats',
        initialExpanded: true
    }, void 0, stats ? _jsx(_StatsTable2.default, {
        data: stats,
        params: params
    }) : _ref2), _jsx(_Accordion2.default, {
        header: 'big race wins'
    }, void 0, _jsx(_BigRaceWins2.default, {
        data: bigRaceWins,
        type: params.type
    })));
};

Stats.defaultProps = {
    data: {
        stats: {
            seasonInfo: {}
        },
        bigRaceWins: []
    }
};

exports.default = Stats;

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _columns = __webpack_require__(1230);

var _columns2 = _interopRequireDefault(_columns);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BigRaceWins = function BigRaceWins(_ref) {
    var data = _ref.data,
        type = _ref.type;
    return _jsx('div', {
        className: 'mp-bigRaceWins'
    }, void 0, _jsx(_rpReactTable2.default, {
        data: data,
        columns: (0, _columns2.default)(type),
        initialSortIdx: 0,
        noDataText: 'No big race wins',
        resultsPerPage: 50
    }));
};

exports.default = BigRaceWins;

/***/ }),
/* 1230 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _money = __webpack_require__(39);

var _date = __webpack_require__(18);

var _ResultLink = __webpack_require__(96);

var _ResultLink2 = _interopRequireDefault(_ResultLink);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var columns = function columns(type) {
    return [{
        key: 'raceDate',
        header: 'date',
        cell: function cell(_ref) {
            var raceDate = _ref.raceDate;
            return (0, _date.formatDate)(raceDate, 'DDMMMYY');
        },
        sortFn: (0, _date.sortByDate)('raceDate')
    }, {
        key: 'raceInstanceTitle',
        header: 'race name',
        cell: function cell(rowData) {
            return _react2.default.createElement(
                _ResultLink2.default,
                rowData,
                rowData.raceInstanceTitle
            );
        }
    }, {
        key: 'horseStyleName',
        header: 'horse',
        cell: _ProfileLink.HorseLink
    }, type === 'trainer' ? {
        key: 'jockeyStyleName',
        header: 'jockey',
        cell: _ProfileLink.JockeyLink
    } : {
        key: 'trainerStyleName',
        header: 'trainer',
        cell: _ProfileLink.TrainerLink
    }, {
        key: 'prizeSterling',
        header: 'winnings',
        cell: function cell(_ref2) {
            var prizeSterling = _ref2.prizeSterling;
            return (0, _money.formatMoney)(prizeSterling);
        }
    }];
}; /* eslint react/prop-types: 0 */
exports.default = columns;

/***/ }),
/* 1231 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactTable = __webpack_require__(23);

var _rpReactTable2 = _interopRequireDefault(_rpReactTable);

var _lodash = __webpack_require__(9);

var _Filter = __webpack_require__(142);

var _Filter2 = _interopRequireDefault(_Filter);

var _categoriesReducer = __webpack_require__(1232);

var _categoriesReducer2 = _interopRequireDefault(_categoriesReducer);

var _categories = __webpack_require__(621);

var _columns = __webpack_require__(1233);

var _filter = __webpack_require__(144);

var _filter2 = _interopRequireDefault(_filter);

var _filter3 = __webpack_require__(75);

var _storage = __webpack_require__(410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Stats = function (_FilteringComponent) {
    _inherits(Stats, _FilteringComponent);

    function Stats(props) {
        _classCallCheck(this, Stats);

        var _this = _possibleConstructorReturn(this, (Stats.__proto__ || Object.getPrototypeOf(Stats)).call(this, props));

        _initialiseProps.call(_this);

        var _props$data = props.data,
            statistics = _props$data.statistics,
            statisticalSummary = _props$data.statisticalSummary,
            seasonInfo = _props$data.seasonInfo,
            seasonsAvailable = _props$data.seasonsAvailable;


        var categories = (0, _categories.categoriesFactory)(seasonInfo.countryCode, seasonInfo.raceType, props.params.type, seasonsAvailable);
        var status = (0, _categories.statusFactory)(categories);

        _this.state = {
            tableData: statistics || statisticalSummary || [],
            loading: false,
            fetchError: false,
            categories: categories,
            status: status
        };
        return _this;
    }

    _createClass(Stats, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _props$params = this.props.params,
                tab = _props$params.tab,
                type = _props$params.type;

            var categories = (0, _storage.getCategories)(tab, type, _categoriesReducer2.default, this.state.categories);
            if (categories) {
                this.onFilterApply(categories);
            }
        }
    }, {
        key: 'renderStatus',
        value: function renderStatus() {
            var _state$status = this.state.status,
                raceType = _state$status.raceType,
                displayBy = _state$status.displayBy,
                timePeriod = _state$status.timePeriod,
                advanced = _state$status.advanced;

            var displayByParts = displayBy.split('(');
            var displayByGeneral = (0, _lodash.toLower)(displayByParts[0].trim());
            var displayByDesc = displayByParts[1];
            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, raceType, ',\xA0', timePeriod, ',\xA0', _jsx('strong', {}, void 0, 'displayed by ', displayByGeneral), '\xA0', displayByDesc ? '(' + displayByDesc : null, advanced ? _jsx('span', {}, void 0, '(', advanced, ')') : null, '\xA0');
        }
    }, {
        key: 'render',
        value: function render() {
            var _state = this.state,
                tableData = _state.tableData,
                loading = _state.loading,
                categories = _state.categories,
                fetchError = _state.fetchError;


            var dynamicColumn = (0, _columns.createDynamicColumn)(categories);

            var isIre = _filter3.selection.getValue(categories, 'raceType').includes('IRE');
            var statsCols = [dynamicColumn].concat(_toConsumableArray((0, _columns.statsColumns)(isIre)));

            var overall = tableData.find(function (row) {
                return row.groupName === 'OVERALL';
            });
            var statsData = (0, _lodash.without)(tableData, overall);

            return _jsx('div', {
                className: 'mp-statsTable'
            }, void 0, _jsx(_Filter2.default, {
                categories: categories,
                categoriesReducer: _categoriesReducer2.default,
                columns: statsCols,
                fetchError: fetchError,
                onFilterApply: this.onFilterApply
            }), !fetchError && _jsx(_rpReactTable2.default, {
                data: statsData || [],
                footerData: overall,
                columns: statsCols,
                sortable: true,
                noDataText: 'No stats found',
                initialSortIdx: 0,
                loading: loading
            }));
        }
    }]);

    return Stats;
}(_filter2.default);

var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.onDataReceive = function (_ref) {
        var _ref$data = _ref.data,
            statistics = _ref$data.statistics,
            statisticalSummary = _ref$data.statisticalSummary;
        var categories = _this2.state.categories;

        var selectedAdvanced = _filter3.selection.getValue(categories, 'advanced');
        var selectedDisplayBy = _filter3.selection.getValue(categories, 'displayBy');

        var tableData = [];
        if (selectedDisplayBy === 'age-of-horse' || selectedDisplayBy === 'race-category') {
            tableData = (0, _lodash.flatten)(Object.values(statistics));
        } else {
            tableData = (statistics ? statistics[(0, _lodash.toUpper)(selectedAdvanced)] : statisticalSummary) || [];
        }

        _this2.setState({
            tableData: tableData,
            loading: false,
            status: (0, _categories.statusFactory)(categories)
        });
    };

    this.buildUrl = function (_ref2) {
        var timePeriod = _ref2.timePeriod,
            raceType = _ref2.raceType,
            displayBy = _ref2.displayBy;
        var _props$params2 = _this2.props.params,
            id = _props$params2.id,
            type = _props$params2.type;

        var commonPart = 'filter/' + type + '/' + id + '/stats';

        var years = timePeriod.split('/').slice(0, 2).join('/');
        if (displayBy === 'year' || displayBy === 'season') {
            return commonPart + '/summary/' + years + '/' + raceType;
        }
        var racingTypeWithDisplayBy = raceType.match(/turf|aw/) ? raceType.replace(/(turf|aw)/g, displayBy + '/$1') : raceType + '/' + displayBy;

        return commonPart + '/statistics/' + years + '/' + racingTypeWithDisplayBy;
    };
};

var statsPros = _propTypes2.default.arrayOf(_propTypes2.default.shape({
    euroTotalPrize: _propTypes2.default.number,
    euroWinPrize: _propTypes2.default.number,
    place1stNumber: _propTypes2.default.number,
    place2ndNumber: _propTypes2.default.number,
    place3rdNumber: _propTypes2.default.number,
    place4thNumber: _propTypes2.default.number,
    raceNumber: _propTypes2.default.number,
    seasonEndDate: _propTypes2.default.string,
    seasonStartDate: _propTypes2.default.string,
    stake: _propTypes2.default.number,
    totalPrize: _propTypes2.default.number,
    winPercent: _propTypes2.default.number,
    winPrize: _propTypes2.default.number
}));

Stats.propTypes = {
    data: _propTypes2.default.shape({
        stats: statsPros,
        statsResponse: statsPros,
        seasonInfo: _propTypes2.default.shape({
            raceType: _propTypes2.default.string.isRequired,
            countryCode: _propTypes2.default.string.isRequired,
            seasonStartDate: _propTypes2.default.string,
            seasonEndDate: _propTypes2.default.string.isRequired
        }).isRequired
    }).isRequired,
    params: _propTypes2.default.shape({
        id: _propTypes2.default.string,
        type: _propTypes2.default.string
    }).isRequired
};

exports.default = Stats;

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _filter = __webpack_require__(75);

var _categories = __webpack_require__(621);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var getRaceType = function getRaceType(val) {
    return val.match(/jumps|flat/)[0];
};
var getCountry = function getCountry(val) {
    return val.match(/GB|IRE/)[0];
};
var hasValue = _filter.selection.hasValue,
    getValue = _filter.selection.getValue;


var RACE_TYPE = 'raceType';
var DISPLAY_BY = 'displayBy';

/**
 * Time periods format should change in the following way:
 * for flat - YYYY,
 * for jumps - YYYY-YY
 */
var timePeriodReducer = function timePeriodReducer(categories, _ref) {
    var type = _ref.type,
        value = _ref.value;
    var timePeriod = categories.timePeriod;
    var getCurrentSeasonEndYear = _filter.timePeriods.getCurrentSeasonEndYear,
        getPeriods = _filter.timePeriods.getPeriods,
        getAll = _filter.timePeriods.getAll,
        getCurrent = _filter.timePeriods.getCurrent,
        getLast5 = _filter.timePeriods.getLast5;


    if (!hasValue(categories[type], value)) {
        return categories.timePeriod;
    }

    if (type === RACE_TYPE) {
        var nextRaceType = getRaceType(value);
        var country = getCountry(value);
        var startYear = 1988;
        var endYear = getCurrentSeasonEndYear(nextRaceType, country);
        var lastFivePeriods = getPeriods(endYear - 1, endYear - 6, nextRaceType);
        var newOptions = [getAll(startYear, endYear), getCurrent(endYear, nextRaceType), getLast5(endYear, nextRaceType)].concat(_toConsumableArray(lastFivePeriods));
        newOptions[0].selected = true;
        return _extends({}, timePeriod, {
            options: newOptions,
            title: 'time period',
            createdBy: {
                raceType: nextRaceType
            }
        });
    }
    return timePeriod;
};
/**
 * Display by options should change alongside with race type,
 * for race type specific Display by options see ./categories.js
 *
 * If selected display by option is present for jumps and flat race types -
 * keep it selected and vice versa.
 */
var displayByReducer = function displayByReducer(categories, _ref2) {
    var type = _ref2.type,
        value = _ref2.value;

    if (!hasValue(categories[type], value)) {
        return categories.displayBy;
    }

    if (type === RACE_TYPE) {
        var raceType = getRaceType(value);
        var country = getCountry(value);
        var displayBy = categories.displayBy;

        return (0, _categories.displayByFactory)(country, raceType, categories.displayBy.createdBy.humanType, displayBy.options.find(function (o) {
            return o.selected;
        }).value);
    }
    return categories.displayBy;
};
/**
 * Race type does not depend on other selected values.
 */
var raceTypeReducer = function raceTypeReducer(categories) {
    return categories.raceType;
};
/**
 * Advanced options should be shown only if value,
 * selected in display by category is present for
 * flat and jumps race types.
 *
 * If race type changes and generic display by value is selected -
 * race type specific advanced options should be added to advanced category
 */
var advancedReducer = function advancedReducer(categories, _ref3) {
    var type = _ref3.type,
        value = _ref3.value;

    if (!hasValue(categories[type], value)) {
        return categories.advanced;
    }

    var humanType = categories.displayBy.createdBy.humanType;
    switch (type) {
        case DISPLAY_BY:
            {
                var selectedType = getValue(categories, RACE_TYPE);
                var raceType = getRaceType(selectedType);
                var country = getCountry(selectedType);

                return (0, _categories.advancedFactory)(country, raceType, value, humanType);
            }

        case RACE_TYPE:
            {
                var _raceType = getRaceType(value);
                var _country = getCountry(value);
                var displayBy = getValue(categories, DISPLAY_BY);

                return (0, _categories.advancedFactory)(_country, _raceType, displayBy, humanType);
            }

        default:
            return categories.advanced;

    }
};
/**
 * Reducers composition
 */
var categoriesReducer = function categoriesReducer(categories, action) {
    return {
        raceType: raceTypeReducer(categories),
        displayBy: displayByReducer(categories, action),
        timePeriod: timePeriodReducer(categories, action),
        advanced: advancedReducer(categories, action)
    };
};

exports.default = categoriesReducer;

/***/ }),
/* 1233 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.createDynamicColumn = exports.statsColumns = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint react/prop-types: 0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(9);

var _StakeCell = __webpack_require__(296);

var _StakeCell2 = _interopRequireDefault(_StakeCell);

var _money = __webpack_require__(39);

var _ProfileLink = __webpack_require__(26);

var _date = __webpack_require__(18);

var _name = __webpack_require__(231);

var _distance = __webpack_require__(113);

var _filter = __webpack_require__(75);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var statsColumns = exports.statsColumns = function statsColumns(isIre) {
    return [{
        key: 'place1stNumber',
        header: 'wins'
    }, {
        key: 'racesNumber',
        header: 'runs'
    }, {
        key: 'winPercent',
        header: '%'
    }, {
        key: 'place2ndNumber',
        header: '2nd'
    }, {
        key: 'place3rdNumber',
        header: '3rd'
    }, {
        key: 'place4thNumber',
        header: '4th'
    }, {
        key: (isIre ? 'euroT' : 't') + 'otalPrize',
        header: 'total earnings',
        cell: function cell(_ref) {
            var totalPrize = _ref.totalPrize,
                euroTotalPrize = _ref.euroTotalPrize;
            return isIre ? (0, _money.formatSalePrice)(euroTotalPrize, 'EUR') : (0, _money.formatSalePrice)(totalPrize, 'GBP');
        }
    }, {
        key: 'stake',
        header: (isIre ? '€' : '£') + '1 stake',
        cell: _StakeCell2.default
    }];
};

var columns = {
    year: {
        header: 'year',
        key: 'seasonEndDate',
        cell: function cell(_ref2) {
            var seasonEndDate = _ref2.seasonEndDate;
            return (0, _date.formatDate)(seasonEndDate, 'YYYY');
        },
        sortFn: (0, _date.sortByDate)('seasonEndDate')
    },
    season: {
        header: 'season',
        key: 'seasonEndDate',
        cell: function cell(_ref3) {
            var seasonEndDate = _ref3.seasonEndDate,
                seasonStartDate = _ref3.seasonStartDate;
            return (0, _date.formatDate)(seasonStartDate, 'YYYY') + '-' + (0, _date.formatDate)(seasonEndDate, 'YY');
        },
        sortFn: (0, _date.sortByDate)('seasonEndDate')
    },
    course: {
        header: 'course',
        key: 'groupName',
        cell: function cell(_ref4) {
            var groupName = _ref4.groupName,
                groupId = _ref4.groupId;
            return _jsx(_ProfileLink.CourseLink, {
                courseStyleName: groupName,
                courseUid: groupId
            });
        },
        sortFn: 'alphabetic'
    },
    distance: {
        header: 'distance',
        key: 'groupName',
        sortFn: 'alphabetic'
    },
    month: {
        header: 'month',
        key: 'groupName',
        sortFn: (0, _date.sortByRecentMonth)('groupName')
    },
    raceType: {
        header: 'race class',
        key: 'groupName',
        sortFn: (0, _name.sortByRaceName)('groupName')
    },
    raceCategory: {
        header: 'race type',
        key: 'groupName',
        sortFn: 'alphabetic'
    },
    ageOfHorse: {
        header: 'age of horse',
        key: 'groupName',
        sortFn: 'alphabetic'
    },
    jockey: {
        header: 'jockey',
        key: 'groupName',
        cell: function cell(_ref5) {
            var groupName = _ref5.groupName,
                groupId = _ref5.groupId;
            return _jsx(_ProfileLink.JockeyLink, {
                jockeyStyleName: groupName,
                jockeyUid: groupId
            });
        },
        sortFn: 'byLastName'
    },
    trainer: {
        header: 'trainer',
        key: 'groupName',
        cell: function cell(_ref6) {
            var groupName = _ref6.groupName,
                groupId = _ref6.groupId;
            return _jsx(_ProfileLink.TrainerLink, {
                trainerStyleName: groupName,
                trainerUid: groupId
            });
        },
        sortFn: 'byLastName'
    }
};

var createDynamicColumn = exports.createDynamicColumn = function createDynamicColumn(categories) {
    var displayBy = (0, _lodash.camelCase)(_filter.selection.getValue(categories, 'displayBy'));
    var column = columns[displayBy];

    if (displayBy !== 'month' && displayBy !== 'distance') {
        return column;
    }

    var raceType = _filter.selection.getValue(categories, 'raceType').match(/flat|jumps/)[0];

    if (displayBy === 'month') {
        var isFlat = raceType === 'flat';

        var selectedTimePeriod = _filter.selection.getValueWithSuffix(categories, 'timePeriod');
        var periodOption = selectedTimePeriod.split('/')[2];
        var isSameYear = periodOption !== 'last5' && periodOption !== 'all';

        return isSameYear && isFlat ? _extends({}, column, {
            cell: function cell(_ref7) {
                var groupName = _ref7.groupName;
                return groupName.split(' ')[0];
            }
        }) : column;
    }

    // distance
    return _extends({}, column, {
        cell: function cell(_ref8) {
            var groupName = _ref8.groupName;
            return (0, _distance.mapYardGroups)(groupName, raceType);
        }
    });
};

/***/ }),
/* 1234 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpAdvertising = __webpack_require__(589);

var _rpAdvertising2 = _interopRequireDefault(_rpAdvertising);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var setTargeting = function setTargeting(targetingStr) {
    var UPDATE_TARGETING = 'updateTargeting';

    if (targetingStr) {
        (0, _rpAdvertising2.default)({
            targeting: [targetingStr],
            targetingEvent: UPDATE_TARGETING
        });
    } else {
        (0, _rpAdvertising2.default)();
    }
};

var initAds = function initAds() {
    var paddyPowerDomain = 'paddypower.com';
    var _document = document,
        referrer = _document.referrer;


    if (referrer.includes(paddyPowerDomain)) {
        setTargeting('paddypower');
    } else {
        setTargeting();
    }
};

exports.default = initAds;

/***/ }),
/* 1235 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpPricesComponent = __webpack_require__(2598);

var _BetslipInteracter = __webpack_require__(1262);

var _BetslipInteracter2 = _interopRequireDefault(_BetslipInteracter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function initPrices() {
    var customizeSettings = _jquery2.default.cookie('customizeSettings');
    var showPrices = false;

    try {
        showPrices = JSON.parse(customizeSettings).showPrices;
    } catch (e) {
        console.warn(e);
    }

    if (showPrices) {
        /* eslint-disable no-new */
        new _rpPricesComponent.BestOdds();
        new _rpPricesComponent.BetHandler();
        /* eslint-enable no-new */

        _rpPricesComponent.priceButton.activate();
        var betslipInteracter = new _BetslipInteracter2.default();
        betslipInteracter.init().then(function (betslipFeedName) {
            return _rpPricesComponent.pricesProvider.init(betslipFeedName);
        });
    }
}

exports.default = initPrices;

/***/ }),
/* 1236 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'minus',
    size: 'Medium',
    className: 'ui-icon accordionMinus ui-accordion__arrow'
});

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'plus',
    size: 'Medium',
    className: 'ui-icon accordionPlus ui-accordion__arrow'
});

var Accordion = function (_PureComponent) {
    _inherits(Accordion, _PureComponent);

    function Accordion(props) {
        _classCallCheck(this, Accordion);

        var _this = _possibleConstructorReturn(this, (Accordion.__proto__ || Object.getPrototypeOf(Accordion)).call(this, props));

        _this.toggleExpandedState = function () {
            _this.setState({ expanded: !_this.state.expanded });
        };

        _this.state = {
            expanded: props.initialExpanded
        };
        return _this;
    }

    _createClass(Accordion, [{
        key: 'render',
        value: function render() {
            var expanded = this.state.expanded;
            var _props = this.props,
                header = _props.header,
                children = _props.children;

            var className = (0, _classnames2.default)('ui-accordion__header', expanded && 'ui-accordion__header_active');

            return _jsx('section', {
                className: 'ui-accordion__row'
            }, void 0, _jsx('button', {
                className: className,
                onClick: this.toggleExpandedState
            }, void 0, _jsx('h2', {
                className: 'ui-accordion__title'
            }, void 0, header), _ref, _ref2), expanded && _jsx('div', {
                className: 'ui-accordion__content'
            }, void 0, children));
        }
    }]);

    return Accordion;
}(_react.PureComponent);

Accordion.defaultProps = {
    initialExpanded: false
};

exports.default = Accordion;

/***/ }),
/* 1237 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('p', {
    className: 'pp-fetchError__text'
}, void 0, 'There\'s a technical issue that means we are currently unable to retrieve this data.');

var _ref3 = _jsx('p', {
    className: 'pp-fetchError__text'
}, void 0, 'We are working to resolve this and expect service to return to normal shortly.');

var _ref4 = _jsx('p', {
    className: 'pp-fetchError__text'
}, void 0, 'Apologies for any inconvenience this has caused.');

var FetchError = function FetchError(_ref) {
    var refresh = _ref.refresh;
    return _jsx('div', {
        className: 'pp-fetchError'
    }, void 0, _ref2, _ref3, _jsx('p', {
        className: 'pp-fetchError__text'
    }, void 0, 'Your page should refresh in 20 seconds. If it does not refresh please click\xA0', _jsx('button', {
        className: 'ui-link',
        onClick: refresh
    }, void 0, 'here'), '.'), _ref4);
};

exports.default = FetchError;

/***/ }),
/* 1238 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _reactDom = __webpack_require__(112);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Popover = function (_PureComponent) {
    _inherits(Popover, _PureComponent);

    function Popover(props) {
        _classCallCheck(this, Popover);

        var _this = _possibleConstructorReturn(this, (Popover.__proto__ || Object.getPrototypeOf(Popover)).call(this, props));

        _this.onOutsideClick = function (event) {
            var domNode = (0, _reactDom.findDOMNode)(_this);
            if (!domNode || !domNode.contains(event.target)) {
                _this.closePopover();
            }
        };

        _this.closePopover = function () {
            _this.setState({ expanded: false });
        };

        _this.openPopover = function () {
            _this.setState({ expanded: true });
        };

        _this.togglePopover = function (e) {
            if (_this.state.expanded) {
                _this.closePopover(e);
            } else {
                _this.openPopover(e);
            }
        };

        _this.state = { expanded: false };
        return _this;
    }

    _createClass(Popover, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            document.addEventListener('click', this.onOutsideClick, true);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            document.removeEventListener('click', this.onOutsideClick, true);
        }
    }]);

    return Popover;
}(_react.PureComponent);

exports.default = Popover;

/***/ }),
/* 1239 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _glide = __webpack_require__(1019);

var _glide2 = _interopRequireDefault(_glide);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref = _jsx('div', {
    className: 'glide__arrows',
    'data-glide-el': 'controls'
}, void 0, _jsx('button', {
    className: 'glide__arrow glide__arrow--left',
    'data-glide-dir': '<'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    iconName: 'left',
    className: 'ui-icon chevronIcon',
    size: 'Large'
})));

var _ref2 = _jsx('div', {
    className: 'glide__arrows',
    'data-glide-el': 'controls'
}, void 0, _jsx('button', {
    className: 'glide__arrow glide__arrow--right',
    'data-glide-dir': '>'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon chevronIcon',
    size: 'Large'
})));

var Slider = function (_PureComponent) {
    _inherits(Slider, _PureComponent);

    function Slider() {
        _classCallCheck(this, Slider);

        return _possibleConstructorReturn(this, (Slider.__proto__ || Object.getPrototypeOf(Slider)).apply(this, arguments));
    }

    _createClass(Slider, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.slider.mount();
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            this.slider.mount();
        }
    }, {
        key: 'showControls',
        value: function showControls() {
            var slides = this.props.slides;


            return slides && Array.isArray(slides) && slides.length > 1;
        }
    }, {
        key: 'renderControls',
        value: function renderControls() {
            var _props = this.props,
                slides = _props.slides,
                hideArrows = _props.hideArrows;


            if (!this.showControls()) {
                return null;
            }

            return _jsx('div', {
                className: 'glide__controllers-wrapper'
            }, void 0, !hideArrows && _ref, _jsx('div', {
                className: 'glide__bullets',
                'data-glide-el': 'controls[nav]'
            }, void 0, slides.map(function (slide, i) {
                return _jsx('button', {
                    className: 'glide__bullet',
                    'data-glide-dir': '=' + i
                }, slide.sequence);
            })), !hideArrows && _ref2);
        }
    }, {
        key: 'render',
        value: function render() {
            var slides = this.props.slides;

            this.slider = new _glide2.default('.glide');

            return _jsx('div', {
                className: 'glide' + (!this.showControls() ? ' glide--no-controls' : '')
            }, void 0, _jsx('div', {
                className: 'glide__track',
                'data-glide-el': 'track'
            }, void 0, _jsx('ul', {
                className: 'glide__slides'
            }, void 0, slides.map(function (slide) {
                return _jsx('li', {
                    className: 'glide__slide',
                    style: {
                        backgroundImage: 'url("' + slide.url + '")'
                    }
                }, slide.sequence);
            }))), this.renderControls());
        }
    }]);

    return Slider;
}(_react.PureComponent);

exports.default = Slider;

/***/ }),
/* 1240 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _rpAuth = __webpack_require__(287);

var _rpAnalytics = __webpack_require__(59);

var _traits = __webpack_require__(11);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var subsectionTrait = _defineProperty({}, _traits.TRAIT_SUBSECTION, 'Horses');
var TIPPING = _rpAuth.subscriptionTypes.TIPPING;


var padlockIcon = _jsx('img', {
    src: '/svgs/padlock_unlocked.svg',
    alt: 'padlock_unlocked',
    className: 'content-barrier__body-content-icon'
});

var contentBarrierBodyContent = function contentBarrierBodyContent(text) {
    return _jsx('div', {
        className: 'content-barrier__body-content-text'
    }, void 0, padlockIcon, text);
};

var _ref3 = _jsx('table', {
    className: 'content-barrier__blurred-row ui-table hp-formTable nonRunnerSliderSwitcher ui-table_type1'
}, void 0, _jsx('tbody', {
    className: 'ui-table__body'
}, void 0, _jsx('tr', {
    className: 'ui-table__row'
}, void 0, _jsx('td', {
    className: 'ui-table__cell'
}, void 0, _jsx('div', {
    className: 'hp-formTable__dateWrapper'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    iconName: 'videoHollow',
    size: 'Medium',
    className: 'content-barrier__blurred-row-video-icon tableShowIcon',
    viewBox: '0 0 24 24'
}), _jsx('span', {
    className: 'ui-link ui-link_table js-popupLink'
}, void 0, '12Feb24'))), _jsx('td', {
    className: 'ui-table__cell'
}, void 0, _jsx('span', {
    className: 'blurred-row__bolded-text'
}, void 0, 'Navan'), ' HcH 6K'), _jsx('td', {
    className: 'ui-table__cell'
}, void 0, '2m1f'), _jsx('td', {
    className: 'ui-table__cell'
}, void 0, 'Gd/Y'), _jsx('td', {
    className: 'ui-table__cell'
}, void 0, '10-3'), _jsx('td', {
    className: 'ui-table__cell'
}, void 0, 'F/25 ', _jsx('span', {
    className: 'content-barrier__blurred-row-bolded-text--position'
}, void 0, 'Wa Wa 11-4')), _jsx('td', {
    className: 'ui-table__cell'
}, void 0, '14/1'), _jsx('td', {
    className: 'ui-table__cell'
}, void 0, 'S W Flanagan'), _jsx('td', {
    className: 'ui-table__cell'
}, void 0, '94'), _jsx('td', {
    className: 'ui-table__cell'
}, void 0, '67'), _jsx('td', {
    className: 'ui-table__cell'
}, void 0, '80'))));

var _ref4 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'premium-lock',
    className: 'content-barrier__padlock--lock',
    size: 'Large'
});

var _ref5 = _jsx('p', {
    className: 'content-barrier__header-body-text--main'
}, void 0, 'RACING POST+');

var _ref6 = _jsx('div', {
    className: 'content-barrier__freeTrial'
}, void 0, _jsx('p', {
    className: 'content-barrier__subtitle'
}, void 0, 'Don\'t worry, you can still enjoy full form for free.'), _jsx('p', {
    className: 'content-barrier__description'
}, void 0, 'Simply sign up for a free Racing Post account'));

var _ref7 = _jsx('p', {
    className: 'content-barrier__description'
}, void 0, 'By subscribing to our ', _jsx('span', {
    className: 'content-barrier__description--bolded'
}, void 0, 'Insights'), ' package, you\'ll gain access to the most detailed database in racing alongside invaluable insights and statistics curated by our team of expert analysts');

var _ref8 = _jsx('div', {
    className: 'content-barrier__body--freeTrial'
}, void 0, padlockIcon, _jsx('div', {
    className: 'content-barrier__body-content'
}, void 0, 'Plus get full access to every jockey, trainer and owner profile page'));

var _ref9 = _jsx('div', {
    className: 'content-barrier__body-header'
}, void 0, 'Package highlights');

var ContentBarrier = function (_React$Component) {
    _inherits(ContentBarrier, _React$Component);

    function ContentBarrier(props) {
        _classCallCheck(this, ContentBarrier);

        var _this = _possibleConstructorReturn(this, (ContentBarrier.__proto__ || Object.getPrototypeOf(ContentBarrier)).call(this, props));

        _this.handleLoginClick = function () {
            (0, _rpAnalytics.trackBarrierInteraction)(_extends(_defineProperty({}, _traits.TRAIT_SELECTION, 'Login'), subsectionTrait));
        };

        _this.handleSubscribeOrUpgradeClick = function (e) {
            var buttonText = e.target.innerHTML.replace(/[\n\t]/g, '').trim();
            (0, _rpAnalytics.trackBarrierInteraction)(_extends(_defineProperty({}, _traits.TRAIT_SELECTION, buttonText), subsectionTrait));
        };

        _this.state = {
            session: null
        };
        return _this;
    }

    _createClass(ContentBarrier, [{
        key: 'componentWillMount',
        value: function () {
            var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                var _ref2, session;

                return regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                        switch (_context.prev = _context.next) {
                            case 0:
                                _context.next = 2;
                                return (0, _rpAuth.getSessionStatus)();

                            case 2:
                                _ref2 = _context.sent;
                                session = _ref2.session;


                                this.setState({ session: session });

                            case 5:
                            case 'end':
                                return _context.stop();
                        }
                    }
                }, _callee, this);
            }));

            function componentWillMount() {
                return _ref.apply(this, arguments);
            }

            return componentWillMount;
        }()
    }, {
        key: 'render',
        value: function render() {
            var userRole = localStorage.getItem('userRole');
            // get the header value as it is, without checks for tab and page, since here there is no condition for showing it depending on the tab - JP-9931
            var isFreeTrial = sessionStorage.getItem('freeTrialHeader') === 'true';

            var buttonText = isFreeTrial ? 'Sign up' : 'Subscribe';
            if (userRole === TIPPING) buttonText = 'Upgrade';
            var signupLink = isFreeTrial ? '/api/auth/login/?signup=true&state=' + btoa(window.location.href) + '&force=true' : '/subscriptions/';

            return _jsx('section', {
                className: 'content-barrier'
            }, void 0, _ref3, _jsx('div', {
                className: 'content-barrier__header'
            }, void 0, _jsx('div', {
                className: 'content-barrier__header-body'
            }, void 0, _ref4, _jsx('div', {
                className: 'content-barrier__header-body-text-wrapper'
            }, void 0, _jsx('p', {
                className: 'content-barrier__header-body-text--small'
            }, void 0, 'Full form is part of ', !isFreeTrial && 'the'), _ref5))), isFreeTrial ? _ref6 : _ref7, isFreeTrial ? _ref8 : _jsx('div', {
                className: 'content-barrier__body'
            }, void 0, _ref9, _jsx('div', {
                className: 'content-barrier__body-content'
            }, void 0, contentBarrierBodyContent('Full access to horse, trainer, jockey and owner profile pages - including form, sales and pedigree information'), contentBarrierBodyContent('Access the Pro Card, with unrivalled race insights including runner-by-runner Spotlight assessments, ratings and statistics'), contentBarrierBodyContent('Regular email newsletters from our analysis experts'))), _jsx('div', {
                className: 'content-barrier__footer'
            }, void 0, _jsx('a', {
                href: signupLink,
                className: 'content-barrier__footer-subscribe-button',
                onClick: this.handleSubscribeOrUpgradeClick
            }, void 0, buttonText), !this.state.session && _jsx('p', {
                className: 'content-barrier__footer-text'
            }, void 0, isFreeTrial ? 'Already have an account?' : 'Already a subscriber?', _jsx('a', {
                href: '/api/auth/login/?state=' + btoa(window.location.href) + '&force=true',
                className: 'content-barrier__footer-login-link',
                onClick: this.handleLoginClick
            }, void 0, ' Log in'))));
        }
    }]);

    return ContentBarrier;
}(_react2.default.Component);

exports.default = ContentBarrier;

/***/ }),
/* 1241 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ProfileLink = __webpack_require__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EntriesHorseLink = function EntriesHorseLink(_ref) {
    var damCountryCode = _ref.damCountryCode,
        damName = _ref.damName,
        damUid = _ref.damUid,
        horseAge = _ref.horseAge,
        horseCountryCode = _ref.horseCountryCode,
        horseName = _ref.horseName,
        horseUid = _ref.horseUid,
        isDamShown = _ref.isDamShown;
    return _jsx('span', {}, void 0, _jsx(_ProfileLink.HorseLink, {
        horseStyleName: horseName,
        horseUid: horseUid
    }), isDamShown && _jsx('span', {
        className: 'hp-progenyEntries__dam'
    }, void 0, ' (' + horseCountryCode + ') ', horseAge, 'yo\xA0\u2014\xA0', _jsx(_ProfileLink.HorseLink, {
        className: 'hp-progenyEntries__regularLink',
        horseStyleName: damName,
        horseUid: damUid
    }), ' (' + damCountryCode + ')'));
};

exports.default = EntriesHorseLink;

/***/ }),
/* 1242 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _PriceButton = __webpack_require__(631);

var _PriceButton2 = _interopRequireDefault(_PriceButton);

var _RaceCardLink = __webpack_require__(297);

var _RaceCardLink2 = _interopRequireDefault(_RaceCardLink);

var _date = __webpack_require__(18);

var _distance = __webpack_require__(113);

var _EntriesHorseLink = __webpack_require__(1241);

var _EntriesHorseLink2 = _interopRequireDefault(_EntriesHorseLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var raceStatus = {
    O: 'Overnight',
    C: 'Early closer',
    3: 'Three day',
    4: 'Four day',
    5: 'Five day',
    6: 'Six day'
};

var EntriesRow = function EntriesRow(_ref) {
    var data = _ref.data,
        isHorseShown = _ref.isHorseShown,
        isDamShown = _ref.isDamShown,
        isPriceShown = _ref.isPriceShown;
    var courseStyleName = data.courseStyleName,
        courseUid = data.courseUid,
        raceDatetime = data.raceDatetime,
        raceInstanceTitle = data.raceInstanceTitle,
        raceInstanceUid = data.raceInstanceUid,
        raceStatusCode = data.raceStatusCode,
        raceUid = data.raceUid,
        runningConditions = data.runningConditions,
        distanceYard = data.distanceYard;

    return _jsx('li', {
        className: 'pp-entries__item'
    }, void 0, _jsx('div', {
        className: 'pp-entries__item__wrapper'
    }, void 0, _jsx('div', {
        className: 'pp-entries__item__header'
    }, void 0, _jsx('span', {}, void 0, (0, _date.formatEntryDateTime)(raceDatetime), ' '), isHorseShown && _react2.default.createElement(_EntriesHorseLink2.default, _extends({}, data, {
        isDamShown: isDamShown
    }))), raceStatusCode && '(' + raceStatus[raceStatusCode] + ') ', courseStyleName && 'at ' + courseStyleName + ' ', _jsx(_RaceCardLink2.default, {
        courseName: courseStyleName,
        courseUid: courseUid,
        raceDatetime: raceDatetime,
        raceInstanceUid: raceInstanceUid || raceUid
    }, void 0, raceInstanceTitle), runningConditions && ' (' + runningConditions + ')', distanceYard && ' (' + (0, _distance.yardsToFurlongs)(distanceYard) + ')'), isPriceShown && _react2.default.createElement(_PriceButton2.default, data));
};

exports.default = EntriesRow;

/***/ }),
/* 1243 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _axios = __webpack_require__(127);

var _axios2 = _interopRequireDefault(_axios);

var _lodash = __webpack_require__(9);

var _filter = __webpack_require__(75);

var _storage = __webpack_require__(410);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var humans = ['jockey', 'trainer', 'owner'];

var FilteringComponent = function (_PureComponent) {
    _inherits(FilteringComponent, _PureComponent);

    function FilteringComponent(props) {
        _classCallCheck(this, FilteringComponent);

        // key for getting data from API request
        var _this = _possibleConstructorReturn(this, (FilteringComponent.__proto__ || Object.getPrototypeOf(FilteringComponent)).call(this, props));

        _this.onDataReceive = function (data) {
            _this.setState({
                data: (0, _lodash.get)(data, 'data.' + _this.dataKey, _this.emptyData),
                loading: false
            });
        };

        _this.onDataError = function (error) {
            console.warn(error);
            _this.setState({ data: _this.emptyData, loading: false, fetchError: true });
        };

        _this.onFilterApply = function (categories) {
            _this.setState({ categories: categories, loading: true, fetchError: false });

            var selectedValues = _filter.selection.getValues(categories);
            var requestUri = _this.buildUrl(selectedValues);

            var params = _this.props.params;


            if (params && params.tab && params.type && humans.includes(params.type)) {
                (0, _storage.setCategories)(params.tab, params.type, categories);
            }

            _axios2.default.get(requestUri).then(function (_ref) {
                var data = _ref.data;
                return _this.onDataReceive(data);
            }).catch(_this.onDataError);
        };

        _this.buildUrl = function (_ref2) {
            var timePeriod = _ref2.timePeriod,
                raceType = _ref2.raceType,
                raceCategory = _ref2.raceCategory;
            var _this$props$params = _this.props.params,
                type = _this$props$params.type,
                id = _this$props$params.id,
                tab = _this$props$params.tab;

            var uriValues = [timePeriod, raceType, raceCategory];
            return type + '/filter/' + (tab || _this.tab) + '/' + id + '/' + (0, _lodash.compact)(uriValues).join('/');
        };

        _this.dataKey = '';

        // default value that would be passed if response
        // will come with empty data[dataKey]
        _this.emptyData = [];
        return _this;
    }

    // handle received from server data


    // handle received from server error


    // when button "Apply" are clicked we need to save new categories


    // default way to building uri string


    _createClass(FilteringComponent, [{
        key: 'renderStatus',


        // default way to build filter status
        value: function renderStatus() {
            var labels = _filter.selection.getCaptions(this.state.categories);
            var statusText = Object.values(labels).join(', ');
            return _jsx('h2', {
                className: 'ui-filter__statusText'
            }, void 0, statusText);
        }
    }]);

    return FilteringComponent;
}(_react.PureComponent);

exports.default = FilteringComponent;

/***/ }),
/* 1244 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var toggleSelected = function toggleSelected(arr, value) {
    if (!arr.some(function (option) {
        return option.value === value;
    })) {
        return arr;
    }

    return arr.map(function (item) {
        if (item.value === value) {
            return _extends({}, item, { selected: true });
        }
        if (item.selected) {
            return _extends({}, item, { selected: false });
        }
        return item;
    });
};

var setSelectReducer = function setSelectReducer(categories, _ref) {
    var type = _ref.type,
        value = _ref.value;
    return _extends({}, categories, _defineProperty({}, type, _extends({}, categories[type], {
        options: toggleSelected(categories[type].options, value)
    })));
};

/**
 * When some option is changed we are using two reducers
 * (one that passed through props and one that change selected option)
 * to handle options transformations
 */
var updateCategories = function updateCategories(categories, reducer, action) {
    return setSelectReducer(reducer(categories, action), action);
};

exports.default = updateCategories;

/***/ }),
/* 1245 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _shortid = __webpack_require__(386);

var _shortid2 = _interopRequireDefault(_shortid);

var _axios = __webpack_require__(127);

var _axios2 = _interopRequireDefault(_axios);

var _rpNavigation = __webpack_require__(389);

var _rpAnalytics = __webpack_require__(59);

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _analyticsPage = __webpack_require__(290);

var _HorseTrackerButton = __webpack_require__(1246);

var _HorseTrackerButton2 = _interopRequireDefault(_HorseTrackerButton);

var _ErrorModal = __webpack_require__(622);

var _ErrorModal2 = _interopRequireDefault(_ErrorModal);

var _helpers = __webpack_require__(1247);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _ref5 = _jsx('span', {}, void 0, ' You\'ve reached your limit of 1,000 horses. To add this horse to your tracker please go to ', _jsx('a', {
    className: 'ui-link',
    target: '_blank',
    rel: 'noopener noreferrer',
    href: '/horse-tracker/'
}, void 0, ' Horse Tracker '), ' and remove some horses.');

var HorseTracker = function (_PureComponent) {
    _inherits(HorseTracker, _PureComponent);

    function HorseTracker(props) {
        _classCallCheck(this, HorseTracker);

        var _this = _possibleConstructorReturn(this, (HorseTracker.__proto__ || Object.getPrototypeOf(HorseTracker)).call(this, props));

        _this.onTrack = function () {
            (0, _rpNavigation.checkForAccess)('Subscriptions', true, true, {
                text: 'Subscribe to Racing Post+ and get access to this content and much more',
                r: window.location.origin + '/horse-tracker',
                service: 'both'
            }).then(function (access) {
                if (access) {
                    _axios2.default.get((0, _helpers.getAjaxUrl)(_this.horseUid, 'check')).then(function (_ref) {
                        var data = _ref.data;
                        var alertMe = data.data.alertMe;


                        if (alertMe) {
                            _this.onSuccess('active');
                        } else {
                            _this.trackHorse();
                        }
                    });
                }
            });
        };

        _this.onUntrack = function () {
            _axios2.default.get((0, _helpers.getAjaxUrl)(_this.horseUid, 'untrack')).then(function (_ref2) {
                var data = _ref2.data;
                var result = data.data.result,
                    error = data.error;


                if (error) {
                    _this.onError('untrack');
                }

                if (result) {
                    _this.onSuccess('track');
                    _this.segmentUntrackHorse();
                }
            }).catch(function () {
                return _this.onError('untrack');
            });
        };

        _this.onSuccess = function (buttonKey) {
            _this.setState({ button: buttonKey });
        };

        _this.onError = function (errorKey) {
            _this.setState({ error: errorKey });
        };

        _this.onTracked = function () {
            _this.onSuccess('active');
        };

        _this.onCancel = function () {
            _this.onSuccess('tracked');
        };

        _this.closeErrorModal = function () {
            _this.onError(null);
        };

        _this.trackHorse = function () {
            _axios2.default.get((0, _helpers.getAjaxUrl)(_this.horseUid, 'track')).then(function (_ref3) {
                var data = _ref3.data;
                var result = data.data.result,
                    error = data.error;


                if (error) {
                    if (error.code === 403) {
                        _this.onError('limit');
                    } else {
                        _this.onError('track');
                    }
                }

                if (result) {
                    _this.onSuccess('tracked');
                    _this.segmentTrackHorse();
                }
            }).catch(function () {
                return _this.onError('tracked');
            });
        };

        _this.segmentTrackHorse = function () {
            segmentio.track('Track Horse', { horse_name: (0, _analyticsPage.getHorseName)() });
        };

        _this.segmentUntrackHorse = function () {
            segmentio.track('Untrack Horse', { horse_name: (0, _analyticsPage.getHorseName)() });
        };

        _this.horseUid = _this.props.profile.horseUid;
        _this.state = {
            button: 'pending',
            error: null,
            isDestroyed: false
        };
        _this.buttons = (0, _helpers.getButtons)(_this.onTrack, _this.onTracked, _this.onCancel);
        _this.controls = (0, _helpers.getControls)(_this.onCancel, _this.onUntrack);
        return _this;
    }

    _createClass(HorseTracker, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            _rpNavigation.authReady.then(function (auth) {
                if (auth.user.isLoggedIn) {
                    _axios2.default.get((0, _helpers.getAjaxUrl)(_this2.horseUid, 'check')).then(function (_ref4) {
                        var data = _ref4.data;
                        var alertMe = data.data.alertMe;


                        if (alertMe) {
                            _this2.onSuccess('tracked');
                        } else {
                            _this2.onSuccess('track');
                        }
                    }).catch(function () {
                        return _this2.onSuccess('track');
                    });
                } else {
                    _this2.onSuccess('track');
                }
            }).catch(function () {
                return _this2.onSuccess('track');
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var buttonState = this.state.button;
            var shouldShowControls = buttonState === 'active';
            var shouldShowButton = buttonState !== 'pending';
            var errorMessage = _helpers.errorMessages[this.state.error];

            return _jsx('div', {
                className: 'hp-horseTracker'
            }, void 0, shouldShowControls ? _jsx('div', {
                className: 'hp-horseTracker__controls'
            }, void 0, this.controls.map(function (button) {
                return _react2.default.createElement(_HorseTrackerButton2.default, _extends({}, button, { key: _shortid2.default.generate() }));
            })) : null, shouldShowButton ? _react2.default.createElement(_HorseTrackerButton2.default, _extends({}, this.buttons[buttonState], { key: _shortid2.default.generate() })) : null, errorMessage ? _jsx(_ErrorModal2.default, {
                text: errorMessage,
                onClose: this.closeErrorModal
            }, void 0, errorMessage === 'limitError' ? _ref5 : null) : null);
        }
    }]);

    return HorseTracker;
}(_react.PureComponent);

exports.default = HorseTracker;

/***/ }),
/* 1246 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }(); /* eslint jsx-a11y/no-static-element-interactions:0 */


var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HorseTrackerButton = function HorseTrackerButton(_ref) {
    var className = _ref.className,
        label = _ref.label,
        iconName = _ref.iconName,
        onClick = _ref.onClick;
    return _jsx('button', {
        className: (0, _classnames2.default)('hp-horseTracker__button ui-btn ui-btn_primary', className),
        onClick: onClick
    }, void 0, _jsx('span', {
        className: 'hp-horseTracker__label'
    }, void 0, label), iconName ? _jsx(_rpReactSvgIcon2.default, {
        iconName: iconName,
        size: iconName === 'tracker' ? 'Medium' : 'Medium'
    }) : null);
};

exports.default = HorseTrackerButton;

/***/ }),
/* 1247 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var getControls = exports.getControls = function getControls(onCancel, onUntrack) {
    return [{
        className: 'hp-horseTracker__cancel ui-btn_hollow',
        label: 'Cancel',
        onClick: onCancel
    }, {
        className: 'hp-horseTracker__untrack ui-btn_hollow',
        label: 'Untrack',
        onClick: onUntrack
    }];
};

var getButtons = exports.getButtons = function getButtons(onTrack, onTracked, onCancel) {
    return {
        track: {
            className: 'hp-horseTracker__track ui-btn_major',
            label: 'Track Horse',
            iconName: 'tracker',
            onClick: onTrack
        },
        tracked: {
            className: 'hp-horseTracker__tracked ui-btn_hollow',
            label: 'Horse Tracked',
            iconName: 'tick',
            onClick: onTracked
        },
        active: {
            className: 'hp-horseTracker__tracked hp-horseTracker__tracked_active ui-btn_hollow',
            label: 'Horse Tracked',
            iconName: 'tick',
            onClick: onCancel
        }
    };
};

var errorMessages = exports.errorMessages = {
    track: 'Something\'s gone wrong and your horse could\n            not be added to Horse Tracker.\n            Please check you are signed in and try again.',
    untrack: 'Something\'s gone wrong and your horse could\n            not be removed from your Horse Tracker.\n            Please check you are signed in and try again.',
    limit: 'limitError'
};

var getAjaxUrl = exports.getAjaxUrl = function getAjaxUrl(horseUid, action) {
    return 'horse/horse-tracker/ugc/' + horseUid + '/' + action;
};

/***/ }),
/* 1248 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _HorseTracker = __webpack_require__(1245);

var _HorseTracker2 = _interopRequireDefault(_HorseTracker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _HorseTracker2.default;

/***/ }),
/* 1249 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _rpGuiGuide = __webpack_require__(126);

var _date = __webpack_require__(18);

var _url = __webpack_require__(232);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'right',
    className: 'ui-icon ui-icon__btn chevronIcon',
    size: 'XSmall'
});

var RaceDayLink = function RaceDayLink(_ref) {
    var courseName = _ref.courseName,
        courseUid = _ref.courseUid,
        raceDate = _ref.raceDate,
        children = _ref.children;

    if (!courseName || !courseUid || !raceDate) {
        return null;
    }

    var date = (0, _date.formatDate)(raceDate, 'Y-MM-DD');
    var name = (0, _url.nameToUrl)(courseName);
    var url = _rpGuiGuide.mobileDetect.isPhone() ? date + '#' + name : courseUid + '/' + name + '/' + date;
    return _jsx('a', {
        className: 'ui-link ui-link_table js-popupLink',
        href: '/racecards/' + url
    }, void 0, children, _ref2);
};

exports.default = RaceDayLink;

/***/ }),
/* 1250 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint prefer-template: 0 */
var getCourseMetaTitle = exports.getCourseMetaTitle = function getCourseMetaTitle(page, name) {
    var titleConfig = {
        stats: 'Racecourse Statistics',
        results: 'Racecourse Results',
        signposts: 'Signposts',
        favourites: 'Favourites Win Rate',
        'course-map': 'Racecourse Map',
        'course-records': 'Course Records',
        'course-info': 'Racecourse Information'
    };

    var title = name + ' Racecourse | ' + titleConfig[page] + ' | Racing Post';

    window.pageTitle = title;

    return title;
};

var getCourseMetaDescription = function getCourseMetaDescription(page, name) {
    var descriptionConfig = {
        stats: 'Who are the top performers at ' + name + ' Racecourse?\n            Find out here with detailed jockey,\n            trainer and owner statistics from the Racing Post.',
        results: 'Historical race results for ' + name + ' Racecourse.\n            Brought to you by the Racing Post.',
        signposts: name + ' signposts & travellers check. Information provided on horses\n            that have travelled the furthest to make the race meet, including first\n            time blinkers and seven day winners. Courtesy of the Racing Post.',
        favourites: name + ' racecourse favourites. Data covering the last 5 seasons,\n            split by horse age as well as handicap. Provided courtesy of the Racing Post.',
        'course-map': 'Get a lay of the land with detailed course maps and aerial views of\n            ' + name + ' Racecourse. View up to date information on all upcoming races.',
        'course-records': 'All the racecourse information you need, brought to you by the Racing Post.\n            Distances covered, record course times and RP standard.',
        'course-info': 'Your one stop shop for a great day out at ' + name + '. From ticket prices\n            and admissions, to travel and parking information. We\'ve got it all covered!'
    };

    return descriptionConfig[page];
};

var getCourseMetaData = function getCourseMetaData(page, name) {
    return {
        title: getCourseMetaTitle(page, name),
        description: getCourseMetaDescription(page, name)
    };
};

exports.default = getCourseMetaData;

/***/ }),
/* 1251 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _lodash = __webpack_require__(9);

var _date = __webpack_require__(18);

/* eslint prefer-template: 0 */
var getHorseMetaTitle = function getHorseMetaTitle(page, name) {
    var titleConfig = {
        'weatherbys-overview': 'Weatherbys Overview',
        'best-progeny': 'Best Progeny',
        'sire-reference': 'Sire Reference',
        'recent-stakes-performers': 'Recent Stakes Performers',
        'stallion-book-pdf': 'Stallion Book PDF',
        progeny: 'Progeny',
        'progeny-dam': 'Progeny',
        'progeny-dams-sire': 'Progeny Dam\'s Sire',
        'progeny-statistics': 'Progeny Statistics',
        'progeny-results': 'Progeny Results',
        'progeny-entries': 'Progeny Entries',
        nicks: 'Nicks',
        'fee-history': 'Fee History',
        'sales-statistics': 'Sales Statistics',
        'sales-results': 'No title',
        'sales-entries': 'No title',
        'progeny-sales': 'Progeny Sales',
        form: 'Race Record & Form',
        'my-ratings': 'Form & My Ratings',
        entries: 'Race Entries',
        stats: 'Race Stats',
        quotes: 'Quotes From Connections',
        pedigree: 'Horse Pedigree',
        sales: 'Sales Details',
        notes: 'Personal Notes'
    };

    var title = name + ' | ' + titleConfig[page] + ' | Racing Post';

    window.pageTitle = title;

    return title;
};

var getHorseMetaDescription = function getHorseMetaDescription(page, _ref) {
    var age = _ref.age,
        horseDateOfBirth = _ref.horseDateOfBirth,
        horseColourCode = _ref.horseColourCode,
        horseSexCode = _ref.horseSexCode,
        sireHorseName = _ref.sireHorseName,
        sireAvgFlatWinDist = _ref.sireAvgFlatWinDist,
        damHorseName = _ref.damHorseName,
        damCountryOriginCode = _ref.damCountryOriginCode,
        damSireHorseName = _ref.damSireHorseName,
        damSireAvgFlatWinDist = _ref.damSireAvgFlatWinDist,
        trainerName = _ref.trainerName,
        ownerName = _ref.ownerName,
        breederName = _ref.breederName,
        horseName = _ref.horseName,
        countryCode = _ref.horseCountryOriginCode,
        sireStatus = _ref.sireStatus;

    var horseDetails = age + ' (' + (0, _date.formatDate)(horseDateOfBirth, 'DDMMMYY') + '\n        ' + (0, _lodash.toLower)(horseColourCode) + ' ' + (0, _lodash.toLower)(horseSexCode) + ');\n        ' + sireHorseName + ' (' + sireAvgFlatWinDist + 'f) - ' + damHorseName + '\n        (' + damCountryOriginCode + ') (' + damSireHorseName + ' (' + (damSireAvgFlatWinDist || '') + 'f));\n        Trainer ' + trainerName + '; Owner ' + ownerName + '; Breeder ' + breederName;

    var descriptionConfig = {
        'weatherbys-overview': 'Weatherbys Overview for ' + horseName + ' available on Racing Post Bloodstock.\n            Profile page includes Stud Fee, Sire, Dam, Dam\'s Sire, Standing, Sire Comment,\n            Breeder, Trainer and Owner.',
        'best-progeny': 'Best Progeny for ' + horseName + ' available on Racing Post Bloodstock.\n            Profile page includes Stud Fee, Sire, Dam, Dam\'s Sire, Standing, Sire Comment,\n            Breeder, Trainer and Owner.',
        'sire-reference': 'Weatherbys Sire Reference for ' + horseName + ' available on Racing Post Bloodstock.\n            Copyright protected. All rights reserved.',
        'stallion-book-pdf': 'Stallion Book PDF for ' + horseName + ' available on Racing Post Bloodstock.\n            Copyright protected. All rights reserved.',
        'recent-stakes-performers': 'Weatherbys Recent Stakes Performers for ' + horseName + ' available on\n            Racing Post Bloodstock. Copyright protected. All rights reserved.',
        progeny: 'View detailed progeny statistics for ' + horseName + ' including wins,\n            runs and total earnings',
        'progeny-dams-sire': 'View detailed dam\'s sire progeny statistics for ' + horseName + ' including wins,\n            runs and total earnings',
        'progeny-statistics': 'Stallion statistics from the Racing Post.\n            View wins, runs, earnings and Racing Post Ratings.',
        'progeny-results': 'Historical Progeny Results for ' + horseName + '.\n            Includes statistics on course run, course conditions and prize earnings.',
        'progeny-entries': sireStatus ? 'Historical Progeny Entries for ' + horseName + '. Filter by season or race.' : 'Full list of progeny entries for ' + horseName + ' listed by race and date.',
        nicks: 'View the family related data of ' + horseName + ' including statistics such as wins,\n            win percentage and total earnings.',
        'fee-history': 'Research yearly Stud fee\'s for ' + horseName + ' on the Racing Post.\n            The most comprehensive Horse Racing statistics available today.',
        'sales-statistics': 'In depth sales statistics for ' + horseName + '.\n            Get the most comprehensive Horse Racing statistics available from the Racing Post.',
        'sales-results': 'No description',
        'sales-entries': 'No description',
        'progeny-sales': 'Progeny sales data brought to you by the Racing Post.\n            Track prices, sales, buyer information and more.',
        form: horseName + ' statistics and form.\n            View results and future entries as well as statistics by course,\n            race type and prize money.',
        'my-ratings': horseName + ' statistics and form.\n            View results and future entries as well as statistics by course,\n            race type and prize money.',
        entries: 'Forthcoming race entries for ' + horseName + '.\n            Includes date entered, race time and latest betting odds.',
        stats: horseName + ' Race Statistics provided by the Racing Post.\n            Broken down by course, distance, going, month, jockey and class.',
        quotes: 'Quotes from the connections of ' + horseName + '. ' + horseDetails,
        pedigree: horseName + ' Pedigree. Stallion and Dam details provided.',
        sales: horseName + ' (' + countryCode + ') Sales Details. ' + horseDetails,
        notes: 'Access the "My Notes" section of individual horse profiles.\n            Providing notes according to race type as well as being able\n            to provide your own horse ratings'
    };

    return descriptionConfig[page];
};

var getHorseMetaData = function getHorseMetaData(page, profile) {
    return {
        title: getHorseMetaTitle(page, profile.horseName),
        description: getHorseMetaDescription(page, profile)
    };
};

exports.default = getHorseMetaData;

/***/ }),
/* 1252 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint prefer-template: 0 */
var getHumanMetaTitle = function getHumanMetaTitle(page, name) {
    var titleConfig = {
        form: 'Record By Race Type',
        entries: 'Historical Race Entries',
        'booked-rides': 'Booked Rides',
        horses: 'Horse Records',
        stats: 'Statistical Summary'
    };

    var title = name + ' | ' + titleConfig[page] + ' | Racing Post';

    window.pageTitle = title;

    return title;
};

var getHumanMetaDescription = function getHumanMetaDescription(type, page, name) {
    var descriptionConfig = {
        jockey: {
            form: 'Jockey ' + name + ' statistics and form.\n                View results and future entries as well as statistics by course,\n                race type and prize money.',
            'booked-rides': 'View upcoming rides for Jockey ' + name + '.\n                With unparalleled statistics including wins,\n                earnings and much, much more.',
            horses: 'Jockey ' + name + ' historical horse records.\n                Data includes runs, wins, RPR, winnings and earnings.\n                Drill down by race type and time by using the filter option.',
            stats: 'Statistical summary of results for Jockey ' + name + '.\n                Filter results by race type, check out win ratios,\n                total prize money won plus much, much more.'
        },
        trainer: {
            form: 'Trainer ' + name + ' statistics and form.\n                View results and future entries as well as statistics by course,\n                race type and prize money.',
            entries: 'Forthcoming entries for trainer ' + name + '.\n                Includes date entered, race time and latest betting odds.',
            horses: name + '\'s historical horse records.\n                Data includes runs, wins, RPR, winnings and earnings.',
            stats: 'Statistical summary of results for trainer ' + name + '.\n                Filter results by race type, check out win ratios,\n                total prize money won plus much, much more.'
        },
        owner: {
            form: 'Owner ' + name + ' statistics and form.\n                View results and future entries as well as statistics by course,\n                race type and prize money.',
            entries: 'Historical race entries for owner ' + name + '.\n                A comprehensive list of entries for the last five seasons.\n                Access win ratios, total prize money won, RPR and much more.',
            horses: name + '\'s historical horse records.\n                Filter by race type and time period.\n                Data includes runs, wins, RPR, winnings and earnings.',
            stats: 'Statistical summary of results for owner ' + name + '.\n                Filter results by race type, check out win ratios,\n                total prize money won plus much, much more.'
        }
    };

    return descriptionConfig[type][page];
};

var getHumanMetaData = function getHumanMetaData(type, page, name) {
    return {
        title: getHumanMetaTitle(page, name),
        description: getHumanMetaDescription(type, page, name)
    };
};

exports.default = getHumanMetaData;

/***/ }),
/* 1253 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'cirleHelp',
    size: 'Medium'
});

var HelpLink = function HelpLink(_ref) {
    var url = _ref.url;
    return _jsx('div', {
        className: 'ui-helpCenter pp-tabs__help hidden-sm-down'
    }, void 0, _jsx('a', {
        href: url,
        target: '_blank',
        rel: 'noopener noreferrer',
        className: 'ui-link_questionMark'
    }, void 0, _ref2));
};

exports.default = HelpLink;

/***/ }),
/* 1254 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _lodash = __webpack_require__(9);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _Popover2 = __webpack_require__(1238);

var _Popover3 = _interopRequireDefault(_Popover2);

var _Abbr = __webpack_require__(47);

var _Abbr2 = _interopRequireDefault(_Abbr);

var _PopoverLink = __webpack_require__(1256);

var _PopoverLink2 = _interopRequireDefault(_PopoverLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// Popover component has state: { expanded } and
// change state.expanded to false on outside click
var _ref = _jsx('span', {
    className: 'ui-tabs__arrow'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    iconName: 'down'
}));

var MoreBtn = function (_Popover) {
    _inherits(MoreBtn, _Popover);

    function MoreBtn() {
        _classCallCheck(this, MoreBtn);

        return _possibleConstructorReturn(this, (MoreBtn.__proto__ || Object.getPrototypeOf(MoreBtn)).apply(this, arguments));
    }

    _createClass(MoreBtn, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                url = _props.url,
                hash = _props.hash,
                tabNames = _props.tabNames,
                currentTab = _props.currentTab,
                is5Tabs = _props.is5Tabs;
            var expanded = this.state.expanded;

            var activeTab = tabNames.find(function (tabName) {
                return tabName === currentTab;
            });
            var isFirstSelected = activeTab === tabNames[0];
            var className = (0, _classnames2.default)('ui-tabs__tab', 'pp-tabs__tab', 'pp-tabs__more', 'hidden-md-up', expanded && 'ui-tabs__tab_more_major', activeTab && 'ui-tabs__tab_selected', isFirstSelected && 'pp-tabs__more_firstSelected', is5Tabs && 'pp-tabs__more_fiveTabs');

            /* eslint jsx-a11y/no-static-element-interactions: 0 */
            return _jsx('div', {
                className: className,
                onClick: this.togglePopover
            }, void 0, _jsx('div', {
                className: 'ui-tabs__tab_more'
            }, void 0, isFirstSelected ? _jsx(_Abbr2.default, {
                title: 'More'
            }, void 0, (0, _lodash.startCase)(activeTab)) : (0, _lodash.startCase)(activeTab) || 'More', _ref), expanded && _jsx('div', {
                className: 'ui-popover ui-popover_customised'
            }, void 0, tabNames.map(function (tabName, i) {
                return _jsx(_PopoverLink2.default, {
                    tabName: tabName,
                    url: url,
                    hash: hash,
                    className: i === 0 ? 'hidden-sm-up' : ''
                }, tabName);
            })));
        }
    }]);

    return MoreBtn;
}(_Popover3.default);

MoreBtn.propTypes = {
    url: _propTypes2.default.string.isRequired,
    hash: _propTypes2.default.string,
    currentTab: _propTypes2.default.string,
    is5Tabs: _propTypes2.default.bool.isRequired,
    tabNames: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

exports.default = MoreBtn;

/***/ }),
/* 1255 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(199);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _showBarrier = __webpack_require__(409);

var _showBarrier2 = _interopRequireDefault(_showBarrier);

var _tabNames = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var NavLink = function NavLink(_ref) {
    var url = _ref.url,
        hash = _ref.hash,
        tabName = _ref.tabName,
        tabUrl = _ref.tabUrl,
        activeClassName = _ref.activeClassName,
        cssClasses = _ref.cssClasses,
        userRole = _ref.userRole,
        pageName = _ref.pageName,
        pathname = _ref.location.pathname;

    var tabNameText = (0, _tabNames.tabsMapping)(tabName);
    var page = _tabNames.restrictedPagesByCustomMetering[pageName];
    var shouldUseCustomMetering = page ? page.includes(tabNameText.toLowerCase().replace(' ', '_')) && tabNameText !== 'form' : false;

    var splittedPaths = pathname.split('/');
    var activeTab = splittedPaths[splittedPaths.length - 1];

    if (activeTab === tabUrl ||
    // for the case where form tab is active, but there is no /form in the URL
    tabName === 'form' && !tabUrl && activeTab !== 'form') {
        return _jsx('span', {
            className: _classnames2.default.apply(undefined, ['ui-tabs__tab', 'pp-tabs__tab'].concat(_toConsumableArray(cssClasses), [activeClassName])),
            'data-tab-name': tabNameText,
            activeClassName: activeClassName
        }, void 0, tabNameText);
    }

    return _jsx(_reactRouter.Link, {
        to: url + '/' + tabUrl + hash,
        className: _classnames2.default.apply(undefined, ['ui-tabs__tab', 'pp-tabs__tab'].concat(_toConsumableArray(cssClasses))),
        'data-tab-name': tabNameText,
        activeClassName: activeClassName,
        onClick: function onClick(event) {
            return (0, _showBarrier2.default)(event, url + '/' + tabUrl + hash, tabNameText, shouldUseCustomMetering, userRole, pageName);
        }
    }, void 0, tabNameText);
};

NavLink.defaultProps = {
    cssClasses: [],
    location: {
        pathname: ''
    }
};

exports.default = (0, _reactRouter.withRouter)(NavLink);

/***/ }),
/* 1256 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _reactRouter = __webpack_require__(199);

var _lodash = __webpack_require__(9);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _showBarrier = __webpack_require__(409);

var _showBarrier2 = _interopRequireDefault(_showBarrier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx('span', {
    className: 'ui-popoverList__icon'
}, void 0, _jsx(_rpReactSvgIcon2.default, {
    className: 'tableShowIcon',
    iconName: 'tick',
    size: 'Medium'
}));

var PopoverLink = function PopoverLink(_ref) {
    var url = _ref.url,
        hash = _ref.hash,
        tabName = _ref.tabName,
        className = _ref.className;
    return _jsx(_reactRouter.Link, {
        to: url + '/' + tabName + hash,
        className: (0, _classnames2.default)('pp-tabs__popoverLink', 'ui-popoverList__item', className),
        activeClassName: 'pp-tabs__popoverLink_selected',
        onClick: function onClick(event) {
            return (0, _showBarrier2.default)(event, url + '/' + tabName + hash);
        }
    }, void 0, _jsx('span', {
        className: 'ui-popoverList__label'
    }, void 0, (0, _lodash.startCase)(tabName)), _ref2);
};

exports.default = PopoverLink;

/***/ }),
/* 1257 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _SubNavLink = __webpack_require__(1258);

var _SubNavLink2 = _interopRequireDefault(_SubNavLink);

var _tabNames = __webpack_require__(128);

var _calculateTabUrl = __webpack_require__(629);

var _calculateTabUrl2 = _interopRequireDefault(_calculateTabUrl);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _ref2 = _jsx(_rpReactSvgIcon2.default, {
    iconName: 'down',
    size: 'Medium'
});

var SubNav = function SubNav(_ref) {
    var currentTab = _ref.currentTab,
        url = _ref.url,
        hasWeatherbys = _ref.hasWeatherbys,
        isMobile = _ref.isMobile,
        onSubnavMenuExpand = _ref.onSubnavMenuExpand,
        isExpanded = _ref.isExpanded;

    var tab = currentTab || (hasWeatherbys ? 'weatherbys-overview' : 'progeny');

    var expandMenu = function expandMenu() {
        onSubnavMenuExpand();
    };

    var isWeatherbysTab = _tabNames.sireSubTabs.stallionDetails.includes(tab);

    return _jsx('div', {
        className: (0, _classnames2.default)('pp-subTabs', isWeatherbysTab && 'pp-subTabs_weatherbys', (!isMobile || isExpanded) && 'pp-subTabs_weatherbys--all-visible')
    }, void 0, Object.values(_tabNames.sireSubTabs).find(function (subTabs) {
        return subTabs.includes(tab);
    }).map(function (subTab, i) {
        return _jsx(_SubNavLink2.default, {
            url: url,
            tabName: subTab,
            tabUrl: (0, _calculateTabUrl2.default)(currentTab, subTab, i)
        }, subTab);
    }), !isExpanded && isWeatherbysTab && _jsx('button', {
        className: 'ui-btn hidden-md-up pp-subTabs__expand-btn',
        onClick: expandMenu
    }, void 0, _ref2));
};

exports.default = SubNav;

/***/ }),
/* 1258 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol.for && Symbol.for("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = __webpack_require__(199);

var _showBarrier = __webpack_require__(409);

var _showBarrier2 = _interopRequireDefault(_showBarrier);

var _tabNames = __webpack_require__(128);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SubNavLink = function SubNavLink(_ref) {
    var url = _ref.url,
        tabName = _ref.tabName,
        tabUrl = _ref.tabUrl;
    return _jsx(_reactRouter.Link, {
        to: url + '/' + tabUrl,
        className: 'ui-link ui-link_primary ui-popoverList__link pp-subTabs__tab',
        activeClassName: 'pp-subTabs__tab_selected',
        onClick: function onClick(event) {
            return (0, _showBarrier2.default)(event, url + '/' + tabUrl);
        }
    }, void 0, tabName === 'progeny-dams-sire' ? 'Damsire' : (0, _tabNames.tabsMapping)(tabName));
};

exports.default = SubNavLink;

/***/ }),
/* 1259 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabNames = __webpack_require__(128);

var calculateActiveClass = function calculateActiveClass(isSire, hasWeatherbys, isSubTabSelected, tab) {
    if (!isSire || !isSubTabSelected) {
        return 'ui-tabs__tab_selected';
    }

    return 'ui-tabs__tab_selected ' + (hasWeatherbys && (!tab || _tabNames.sireSubTabs.stallionDetails.includes(tab)) ? 'weatherbys' : 'dark');
};

exports.default = calculateActiveClass;

/***/ }),
/* 1260 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _tabNames = __webpack_require__(128);

var checkSubTabSelected = function checkSubTabSelected(tab) {
    return tab ? Object.values(_tabNames.sireSubTabs).some(function (arr) {
        return arr.includes(tab);
    }) : true;
};

exports.default = checkSubTabSelected;

/***/ }),
/* 1261 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var isShown = {
    XN: 3,
    N: 4
};

exports.default = isShown;

/***/ }),
/* 1262 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BetslipInteracter = function () {
    function BetslipInteracter() {
        _classCallCheck(this, BetslipInteracter);

        this.onBookmakerChanged = this.onBookmakerChanged.bind(this);
        this.onBetslipInitialized = this.onBetslipInitialized.bind(this);
        this.setBetslipBookmaker = this.setBetslipBookmaker.bind(this);
        this.init = this.init.bind(this);
        this.decimalOdds = false;
    }

    _createClass(BetslipInteracter, [{
        key: 'init',
        value: function init(feedName) {
            var deferred = _jquery2.default.Deferred();
            this.resolvePromise = deferred.resolve;
            var customizeSettingsCookie = _jquery2.default.cookie('customizeSettings');
            if (customizeSettingsCookie) {
                var customizeSettings = JSON.parse(customizeSettingsCookie);
                this.decimalOdds = customizeSettings.decimalOdds;
            }
            this.bindEvents();
            if (feedName) {
                this.feedName = feedName;
                this.setBetslipBookmaker(feedName);
            } else {
                this.requestSelectedBookmaker();
            }
            return deferred.promise();
        }
    }, {
        key: 'onBookmakerChanged',
        value: function onBookmakerChanged(_ref) {
            var bookmaker = _ref.detail.bookmaker;

            (0, _jquery2.default)(document).trigger('bookieChanged.BOOKMAKER', bookmaker);
            this.resolveBookmaker(bookmaker);
        }
    }, {
        key: 'resolveBookmaker',
        value: function resolveBookmaker(bookmaker) {
            if (this.resolvePromise) {
                this.resolvePromise(bookmaker);
                this.resolvePromise = null;
                delete this.resolvePromise;
            }
        }
    }, {
        key: 'onBetslipInitialized',
        value: function onBetslipInitialized() {
            if (this.feedName) {
                this.setBetslipBookmaker(this.feedName);
                this.resolveBookmaker(this.feedName);
            } else {
                this.requestSelectedBookmaker();
            }
        }

        /* eslint-disable class-methods-use-this */

    }, {
        key: 'requestSelectedBookmaker',
        value: function requestSelectedBookmaker() {
            var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.GET');
            document.dispatchEvent(betslipEvent);
        }
    }, {
        key: 'setBetslipBookmaker',
        value: function setBetslipBookmaker(bookmaker) {
            var betslipEvent = new CustomEvent('BETSLIP.BOOKMAKER.SET', {
                detail: { bookmaker: bookmaker }
            });
            document.dispatchEvent(betslipEvent);
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            document.addEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
            document.addEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
            document.addEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            document.removeEventListener('BETSLIP.BOOKMAKER_CHANGED', this.onBookmakerChanged, false);
            document.removeEventListener('BETSLIP.BOOKMAKER', this.onBookmakerChanged, false);
            document.removeEventListener('BETSLIP.INITIALIZED', this.onBetslipInitialized, false);
        }
    }]);

    return BetslipInteracter;
}();

exports.default = BetslipInteracter;

/***/ }),
/* 1263 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var gbFlat = [{
    label: 'GB Flat (turf & AW)',
    value: 'GB/flat'
}, {
    label: 'GB Flat turf',
    value: 'GB/flat/turf'
}, {
    label: 'GB AW',
    value: 'GB/flat/aw'
}];
var gbJumps = [{
    label: 'GB jumps',
    value: 'GB/jumps'
}];
var ireFlat = [{
    label: 'Irish Flat (turf & AW)',
    value: 'IRE/flat'
}, {
    label: 'Irish Flat turf',
    value: 'IRE/flat/turf'
}, {
    label: 'Irish AW',
    value: 'IRE/flat/aw'
}];
var ireJumps = [{
    label: 'Irish jumps',
    value: 'IRE/jumps'
}];

var human = [].concat(gbFlat, gbJumps, ireFlat, ireJumps);

var horse = {
    flat: [].concat(gbFlat, ireFlat),
    jumps: [].concat(gbJumps, ireJumps)
};

var course = {
    flat: {
        value: 'flat',
        label: 'Flat'
    },
    jumps: {
        value: 'jumps',
        label: 'Jumps'
    },
    flatTurf: {
        label: 'Flat turf',
        value: 'flat'
    },
    aw: {
        label: 'AW',
        value: 'flat'
    }
};

var getForCourse = function getForCourse(typeCode, seasonsAvailable) {
    var isStats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

    var shouldShowJumps = isStats && Object.prototype.hasOwnProperty.call(seasonsAvailable, 'JUMPS');
    var flatTurf = course.flatTurf,
        aw = course.aw,
        jumps = course.jumps;

    switch (typeCode) {
        case 'J':
        case 'P':
            return [jumps];
        case 'F':
            return [flatTurf];
        case 'B':
            return [flatTurf, jumps];
        case 'X':
            return shouldShowJumps ? [aw, jumps] : [aw];
        default:
            return [];
    }
};

exports.default = { human: human, horse: horse, course: course, getForCourse: getForCourse };

/***/ }),
/* 1264 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(9);

/**
 * Format time function
 * Takes time in seconds and returns as formatted string
 * Examples:
 * 52    -> 52.00s
 * 60    -> 1m 0.00s
 * 65    -> 1m 5.00s
 * 65.89 -> 1m 5.89s
 * 65.80 -> 1m 6.80s
 *
 * @param seconds float
 * @returns {string}
 */
function formatTime(seconds) {
  var time = (0, _lodash.isNumber)(seconds) ? seconds : 0;
  var integralValue = Math.floor(time / 60);
  var fractionalValue = (time % 60).toFixed(2);
  var integralPart = integralValue ? integralValue + 'm' : '';
  var fractionalPart = fractionalValue + 's';

  return (integralPart + ' ' + fractionalPart).trim();
}

exports.default = formatTime;

/***/ }),
/* 1265 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var ageFormat = { 0: 'f', 1: 'y' };

var getFormattedAge = function getFormattedAge(age) {
  return ageFormat[age] || age + 'yo';
};

exports.default = getFormattedAge;

/***/ }),
/* 1266 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var pageNames = {
    horse: 'horse',
    trainer: 'trainer',
    owner: 'owner',
    jockey: 'jockey',
    course: 'course'
};

var getPageName = exports.getPageName = function getPageName(pageName) {
    switch (pageName) {
        case pageNames.horse:
            return pageNames.horse + '_profile';
        case pageNames.trainer:
            return pageNames.trainer + '_profile';
        case pageNames.owner:
            return pageNames.owner + '_profile';
        case pageNames.jockey:
            return pageNames.jockey + '_profile';
        case pageNames.course:
            return pageNames.course + '_profile';
        default:
            return '';
    }
};

/***/ }),
/* 1267 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var isSessionStorageEnabled = function isSessionStorageEnabled() {
    try {
        sessionStorage.setItem('test-session-storage', 'test-session-storage');
        sessionStorage.removeItem('test-session-storage');
        return true;
    } catch (err) {
        return false;
    }
};

var setSessionStorageItem = exports.setSessionStorageItem = function setSessionStorageItem(key, value) {
    if (isSessionStorageEnabled()) {
        sessionStorage.setItem(key, value);
    }
};

/***/ }),
/* 1268 */,
/* 1269 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1283), __esModule: true };

/***/ }),
/* 1270 */,
/* 1271 */,
/* 1272 */,
/* 1273 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1292), __esModule: true };

/***/ }),
/* 1274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1295), __esModule: true };

/***/ }),
/* 1275 */,
/* 1276 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1298), __esModule: true };

/***/ }),
/* 1277 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(1299), __esModule: true };

/***/ }),
/* 1278 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(1269);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 1279 */,
/* 1280 */,
/* 1281 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;﻿/*!
* Clamp.js 0.5.1
*
* Copyright 2011-2013, Joseph Schmitt http://joe.sh
* Released under the WTFPL license
* http://sam.zoy.org/wtfpl/
*/

!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function(){
    /**
     * Clamps a text node.
     * @param {HTMLElement} element. Element containing the text node to clamp.
     * @param {Object} options. Options to pass to the clamper.
     */
    function clamp(element, options) {
        options = options || {};

        var self = this,
            win = window,
            opt = {
                clamp:              options.clamp || 2,
                useNativeClamp:     typeof(options.useNativeClamp) != 'undefined' ? options.useNativeClamp : true,
                splitOnChars:       options.splitOnChars || ['.', '-', '–', '—', ' '], //Split on sentences (periods), hypens, en-dashes, em-dashes, and words (spaces).
                animate:            options.animate || false,
                truncationChar:     options.truncationChar || '…',
                truncationHTML:     options.truncationHTML
            },

            sty = element.style,
            originalText = element.innerHTML,

            supportsNativeClamp = typeof(element.style.webkitLineClamp) != 'undefined',
            clampValue = opt.clamp,
            isCSSValue = clampValue.indexOf && (clampValue.indexOf('px') > -1 || clampValue.indexOf('em') > -1),
            truncationHTMLContainer;
            
        if (opt.truncationHTML) {
            truncationHTMLContainer = document.createElement('span');
            truncationHTMLContainer.innerHTML = opt.truncationHTML;
        }


// UTILITY FUNCTIONS __________________________________________________________

        /**
         * Return the current style for an element.
         * @param {HTMLElement} elem The element to compute.
         * @param {string} prop The style property.
         * @returns {number}
         */
        function computeStyle(elem, prop) {
            if (!win.getComputedStyle) {
                win.getComputedStyle = function(el, pseudo) {
                    this.el = el;
                    this.getPropertyValue = function(prop) {
                        var re = /(\-([a-z]){1})/g;
                        if (prop == 'float') prop = 'styleFloat';
                        if (re.test(prop)) {
                            prop = prop.replace(re, function () {
                                return arguments[2].toUpperCase();
                            });
                        }
                        return el.currentStyle && el.currentStyle[prop] ? el.currentStyle[prop] : null;
                    }
                    return this;
                }
            }

            return win.getComputedStyle(elem, null).getPropertyValue(prop);
        }

        /**
         * Returns the maximum number of lines of text that should be rendered based
         * on the current height of the element and the line-height of the text.
         */
        function getMaxLines(height) {
            var availHeight = height || element.clientHeight,
                lineHeight = getLineHeight(element);

            return Math.max(Math.floor(availHeight/lineHeight), 0);
        }

        /**
         * Returns the maximum height a given element should have based on the line-
         * height of the text and the given clamp value.
         */
        function getMaxHeight(clmp) {
            var lineHeight = getLineHeight(element);
            return lineHeight * clmp;
        }

        /**
         * Returns the line-height of an element as an integer.
         */
        function getLineHeight(elem) {
            var lh = computeStyle(elem, 'line-height');
            if (lh == 'normal') {
                // Normal line heights vary from browser to browser. The spec recommends
                // a value between 1.0 and 1.2 of the font size. Using 1.1 to split the diff.
                lh = parseInt(computeStyle(elem, 'font-size')) * 1.2;
            }
            return parseInt(lh);
        }


// MEAT AND POTATOES (MMMM, POTATOES...) ______________________________________
        var splitOnChars = opt.splitOnChars.slice(0),
            splitChar = splitOnChars[0],
            chunks,
            lastChunk;
        
        /**
         * Gets an element's last child. That may be another node or a node's contents.
         */
        function getLastChild(elem) {
            //Current element has children, need to go deeper and get last child as a text node
            if (elem.lastChild.children && elem.lastChild.children.length > 0) {
                return getLastChild(Array.prototype.slice.call(elem.children).pop());
            }
            //This is the absolute last child, a text node, but something's wrong with it. Remove it and keep trying
            else if (!elem.lastChild || !elem.lastChild.nodeValue || elem.lastChild.nodeValue == '' || elem.lastChild.nodeValue == opt.truncationChar) {
                elem.lastChild.parentNode.removeChild(elem.lastChild);
                return getLastChild(element);
            }
            //This is the last child we want, return it
            else {
                return elem.lastChild;
            }
        }
        
        /**
         * Removes one character at a time from the text until its width or
         * height is beneath the passed-in max param.
         */
        function truncate(target, maxHeight) {
            if (!maxHeight) {return;}
            
            /**
             * Resets global variables.
             */
            function reset() {
                splitOnChars = opt.splitOnChars.slice(0);
                splitChar = splitOnChars[0];
                chunks = null;
                lastChunk = null;
            }
            
            var nodeValue = target.nodeValue.replace(opt.truncationChar, '');
            
            //Grab the next chunks
            if (!chunks) {
                //If there are more characters to try, grab the next one
                if (splitOnChars.length > 0) {
                    splitChar = splitOnChars.shift();
                }
                //No characters to chunk by. Go character-by-character
                else {
                    splitChar = '';
                }
                
                chunks = nodeValue.split(splitChar);
            }
            
            //If there are chunks left to remove, remove the last one and see if
            // the nodeValue fits.
            if (chunks.length > 1) {
                // console.log('chunks', chunks);
                lastChunk = chunks.pop();
                // console.log('lastChunk', lastChunk);
                applyEllipsis(target, chunks.join(splitChar));
            }
            //No more chunks can be removed using this character
            else {
                chunks = null;
            }
            
            //Insert the custom HTML before the truncation character
            if (truncationHTMLContainer) {
                target.nodeValue = target.nodeValue.replace(opt.truncationChar, '');
                element.innerHTML = target.nodeValue + ' ' + truncationHTMLContainer.innerHTML + opt.truncationChar;
            }

            //Search produced valid chunks
            if (chunks) {
                //It fits
                if (element.clientHeight <= maxHeight) {
                    //There's still more characters to try splitting on, not quite done yet
                    if (splitOnChars.length >= 0 && splitChar != '') {
                        applyEllipsis(target, chunks.join(splitChar) + splitChar + lastChunk);
                        chunks = null;
                    }
                    //Finished!
                    else {
                        return element.innerHTML;
                    }
                }
            }
            //No valid chunks produced
            else {
                //No valid chunks even when splitting by letter, time to move
                //on to the next node
                if (splitChar == '') {
                    applyEllipsis(target, '');
                    target = getLastChild(element);
                    
                    reset();
                }
            }
            
            //If you get here it means still too big, let's keep truncating
            if (opt.animate) {
                setTimeout(function() {
                    truncate(target, maxHeight);
                }, opt.animate === true ? 10 : opt.animate);
            }
            else {
                return truncate(target, maxHeight);
            }
        }
        
        function applyEllipsis(elem, str) {
            elem.nodeValue = str + opt.truncationChar;
        }


// CONSTRUCTOR ________________________________________________________________

        if (clampValue == 'auto') {
            clampValue = getMaxLines();
        }
        else if (isCSSValue) {
            clampValue = getMaxLines(parseInt(clampValue));
        }

        var clampedText;
        if (supportsNativeClamp && opt.useNativeClamp) {
            sty.overflow = 'hidden';
            sty.textOverflow = 'ellipsis';
            sty.webkitBoxOrient = 'vertical';
            sty.display = '-webkit-box';
            sty.webkitLineClamp = clampValue;

            if (isCSSValue) {
                sty.height = opt.clamp + 'px';
            }
        }
        else {
            var height = getMaxHeight(clampValue);
            if (height < element.clientHeight) {
                clampedText = truncate(getLastChild(element), height);
            }
        }
        
        return {
            'original': originalText,
            'clamped': clampedText
        }
    }

    return clamp;
}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));

/***/ }),
/* 1282 */,
/* 1283 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(239);
__webpack_require__(1323);
module.exports = __webpack_require__(38).Array.from;


/***/ }),
/* 1284 */,
/* 1285 */,
/* 1286 */,
/* 1287 */,
/* 1288 */,
/* 1289 */,
/* 1290 */,
/* 1291 */,
/* 1292 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1330);
var $Object = __webpack_require__(38).Object;
module.exports = function getOwnPropertyDescriptor(it, key) {
  return $Object.getOwnPropertyDescriptor(it, key);
};


/***/ }),
/* 1293 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1331);
module.exports = __webpack_require__(38).Object.getPrototypeOf;


/***/ }),
/* 1294 */,
/* 1295 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1333);
module.exports = __webpack_require__(38).Object.setPrototypeOf;


/***/ }),
/* 1296 */,
/* 1297 */,
/* 1298 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(1335);
__webpack_require__(653);
__webpack_require__(1339);
__webpack_require__(1340);
module.exports = __webpack_require__(38).Symbol;


/***/ }),
/* 1299 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(239);
__webpack_require__(307);
module.exports = __webpack_require__(429).f('iterator');


/***/ }),
/* 1300 */,
/* 1301 */,
/* 1302 */,
/* 1303 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(130);
var createDesc = __webpack_require__(237);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 1304 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(204);
var gOPS = __webpack_require__(422);
var pIE = __webpack_require__(236);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 1305 */,
/* 1306 */,
/* 1307 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(234);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 1308 */,
/* 1309 */,
/* 1310 */,
/* 1311 */,
/* 1312 */,
/* 1313 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(146);
var gOPN = __webpack_require__(645).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 1314 */,
/* 1315 */,
/* 1316 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(129);
var anObject = __webpack_require__(114);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(201)(Function.call, __webpack_require__(421).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(201);
var $export = __webpack_require__(76);
var toObject = __webpack_require__(238);
var call = __webpack_require__(641);
var isArrayIter = __webpack_require__(640);
var toLength = __webpack_require__(426);
var createProperty = __webpack_require__(1303);
var getIterFn = __webpack_require__(430);

$export($export.S + $export.F * !__webpack_require__(643)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 1324 */,
/* 1325 */,
/* 1326 */,
/* 1327 */,
/* 1328 */,
/* 1329 */,
/* 1330 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
var toIObject = __webpack_require__(146);
var $getOwnPropertyDescriptor = __webpack_require__(421).f;

__webpack_require__(304)('getOwnPropertyDescriptor', function () {
  return function getOwnPropertyDescriptor(it, key) {
    return $getOwnPropertyDescriptor(toIObject(it), key);
  };
});


/***/ }),
/* 1331 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 Object.getPrototypeOf(O)
var toObject = __webpack_require__(238);
var $getPrototypeOf = __webpack_require__(646);

__webpack_require__(304)('getPrototypeOf', function () {
  return function getPrototypeOf(it) {
    return $getPrototypeOf(toObject(it));
  };
});


/***/ }),
/* 1332 */,
/* 1333 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(76);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(1316).set });


/***/ }),
/* 1334 */,
/* 1335 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(67);
var has = __webpack_require__(163);
var DESCRIPTORS = __webpack_require__(145);
var $export = __webpack_require__(76);
var redefine = __webpack_require__(650);
var META = __webpack_require__(644).KEY;
var $fails = __webpack_require__(202);
var shared = __webpack_require__(424);
var setToStringTag = __webpack_require__(305);
var uid = __webpack_require__(306);
var wks = __webpack_require__(68);
var wksExt = __webpack_require__(429);
var wksDefine = __webpack_require__(428);
var enumKeys = __webpack_require__(1304);
var isArray = __webpack_require__(1307);
var anObject = __webpack_require__(114);
var isObject = __webpack_require__(129);
var toIObject = __webpack_require__(146);
var toPrimitive = __webpack_require__(427);
var createDesc = __webpack_require__(237);
var _create = __webpack_require__(420);
var gOPNExt = __webpack_require__(1313);
var $GOPD = __webpack_require__(421);
var $DP = __webpack_require__(130);
var $keys = __webpack_require__(204);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function';
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(645).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(236).f = $propertyIsEnumerable;
  __webpack_require__(422).f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(235)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(164)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 1336 */,
/* 1337 */,
/* 1338 */,
/* 1339 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(428)('asyncIterator');


/***/ }),
/* 1340 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(428)('observable');


/***/ }),
/* 1341 */,
/* 1342 */,
/* 1343 */,
/* 1344 */,
/* 1345 */,
/* 1346 */,
/* 1347 */,
/* 1348 */,
/* 1349 */,
/* 1350 */,
/* 1351 */,
/* 1352 */,
/* 1353 */,
/* 1354 */,
/* 1355 */,
/* 1356 */,
/* 1357 */,
/* 1358 */,
/* 1359 */,
/* 1360 */,
/* 1361 */,
/* 1362 */,
/* 1363 */,
/* 1364 */,
/* 1365 */,
/* 1366 */,
/* 1367 */,
/* 1368 */,
/* 1369 */,
/* 1370 */,
/* 1371 */,
/* 1372 */,
/* 1373 */,
/* 1374 */,
/* 1375 */,
/* 1376 */,
/* 1377 */,
/* 1378 */,
/* 1379 */,
/* 1380 */,
/* 1381 */,
/* 1382 */,
/* 1383 */,
/* 1384 */,
/* 1385 */,
/* 1386 */,
/* 1387 */,
/* 1388 */,
/* 1389 */,
/* 1390 */,
/* 1391 */,
/* 1392 */,
/* 1393 */,
/* 1394 */,
/* 1395 */,
/* 1396 */,
/* 1397 */,
/* 1398 */,
/* 1399 */,
/* 1400 */,
/* 1401 */,
/* 1402 */,
/* 1403 */,
/* 1404 */,
/* 1405 */,
/* 1406 */,
/* 1407 */,
/* 1408 */,
/* 1409 */,
/* 1410 */,
/* 1411 */,
/* 1412 */,
/* 1413 */,
/* 1414 */,
/* 1415 */,
/* 1416 */,
/* 1417 */,
/* 1418 */,
/* 1419 */,
/* 1420 */,
/* 1421 */,
/* 1422 */,
/* 1423 */,
/* 1424 */,
/* 1425 */,
/* 1426 */,
/* 1427 */,
/* 1428 */,
/* 1429 */,
/* 1430 */,
/* 1431 */,
/* 1432 */,
/* 1433 */,
/* 1434 */,
/* 1435 */,
/* 1436 */,
/* 1437 */,
/* 1438 */,
/* 1439 */,
/* 1440 */,
/* 1441 */,
/* 1442 */,
/* 1443 */,
/* 1444 */,
/* 1445 */,
/* 1446 */,
/* 1447 */,
/* 1448 */,
/* 1449 */,
/* 1450 */,
/* 1451 */,
/* 1452 */,
/* 1453 */,
/* 1454 */,
/* 1455 */,
/* 1456 */,
/* 1457 */,
/* 1458 */,
/* 1459 */,
/* 1460 */,
/* 1461 */,
/* 1462 */,
/* 1463 */,
/* 1464 */,
/* 1465 */,
/* 1466 */,
/* 1467 */,
/* 1468 */,
/* 1469 */,
/* 1470 */,
/* 1471 */,
/* 1472 */,
/* 1473 */,
/* 1474 */,
/* 1475 */,
/* 1476 */,
/* 1477 */,
/* 1478 */,
/* 1479 */,
/* 1480 */,
/* 1481 */,
/* 1482 */,
/* 1483 */,
/* 1484 */,
/* 1485 */,
/* 1486 */,
/* 1487 */,
/* 1488 */,
/* 1489 */,
/* 1490 */,
/* 1491 */,
/* 1492 */,
/* 1493 */,
/* 1494 */,
/* 1495 */,
/* 1496 */,
/* 1497 */,
/* 1498 */,
/* 1499 */,
/* 1500 */,
/* 1501 */,
/* 1502 */,
/* 1503 */,
/* 1504 */,
/* 1505 */,
/* 1506 */,
/* 1507 */,
/* 1508 */,
/* 1509 */,
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */,
/* 1514 */,
/* 1515 */,
/* 1516 */,
/* 1517 */,
/* 1518 */,
/* 1519 */,
/* 1520 */,
/* 1521 */,
/* 1522 */,
/* 1523 */,
/* 1524 */,
/* 1525 */,
/* 1526 */,
/* 1527 */,
/* 1528 */,
/* 1529 */,
/* 1530 */,
/* 1531 */
/***/ (function(module, exports) {

var MILLISECONDS_IN_MINUTE = 60000

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
module.exports = function getTimezoneOffsetInMilliseconds (dirtyDate) {
  var date = new Date(dirtyDate.getTime())
  var baseTimezoneOffset = date.getTimezoneOffset()
  date.setSeconds(0, 0)
  var millisecondsPartOfTimezoneOffset = date.getTime() % MILLISECONDS_IN_MINUTE

  return baseTimezoneOffset * MILLISECONDS_IN_MINUTE + millisecondsPartOfTimezoneOffset
}


/***/ }),
/* 1532 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Range Helpers
 * @summary Is the given date range overlapping with another date range?
 *
 * @description
 * Is the given date range overlapping with another date range?
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Boolean} whether the date ranges are overlapping
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> true
 *
 * @example
 * // For non-overlapping date ranges:
 * areRangesOverlapping(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> false
 */
function areRangesOverlapping (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return initialStartTime < comparedEndTime && comparedStartTime < initialEndTime
}

module.exports = areRangesOverlapping


/***/ }),
/* 1533 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Return an index of the closest date from the array comparing to the given date.
 *
 * @description
 * Return an index of the closest date from the array comparing to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Number} an index of the date closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015?
 * var dateToCompare = new Date(2015, 8, 6)
 * var datesArray = [
 *   new Date(2015, 0, 1),
 *   new Date(2016, 0, 1),
 *   new Date(2017, 0, 1)
 * ]
 * var result = closestIndexTo(dateToCompare, datesArray)
 * //=> 1
 */
function closestIndexTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate, index) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = index
      minDistance = distance
    }
  })

  return result
}

module.exports = closestIndexTo


/***/ }),
/* 1534 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Return a date from the array closest to the given date.
 *
 * @description
 * Return a date from the array closest to the given date.
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date[]|String[]|Number[]} datesArray - the array to search
 * @returns {Date} the date from the array closest to the given date
 * @throws {TypeError} the second argument must be an instance of Array
 *
 * @example
 * // Which date is closer to 6 September 2015: 1 January 2000 or 1 January 2030?
 * var dateToCompare = new Date(2015, 8, 6)
 * var result = closestTo(dateToCompare, [
 *   new Date(2000, 0, 1),
 *   new Date(2030, 0, 1)
 * ])
 * //=> Tue Jan 01 2030 00:00:00
 */
function closestTo (dirtyDateToCompare, dirtyDatesArray) {
  if (!(dirtyDatesArray instanceof Array)) {
    throw new TypeError(toString.call(dirtyDatesArray) + ' is not an instance of Array')
  }

  var dateToCompare = parse(dirtyDateToCompare)
  var timeToCompare = dateToCompare.getTime()

  var result
  var minDistance

  dirtyDatesArray.forEach(function (dirtyDate) {
    var currentDate = parse(dirtyDate)
    var distance = Math.abs(timeToCompare - currentDate.getTime())
    if (result === undefined || distance < minDistance) {
      result = currentDate
      minDistance = distance
    }
  })

  return result
}

module.exports = closestTo


/***/ }),
/* 1535 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOWeek = __webpack_require__(178)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week Helpers
 * @summary Get the number of calendar ISO weeks between the given dates.
 *
 * @description
 * Get the number of calendar ISO weeks between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar ISO weeks
 *
 * @example
 * // How many calendar ISO weeks are between 6 July 2014 and 21 July 2014?
 * var result = differenceInCalendarISOWeeks(
 *   new Date(2014, 6, 21),
 *   new Date(2014, 6, 6)
 * )
 * //=> 3
 */
function differenceInCalendarISOWeeks (dirtyDateLeft, dirtyDateRight) {
  var startOfISOWeekLeft = startOfISOWeek(dirtyDateLeft)
  var startOfISOWeekRight = startOfISOWeek(dirtyDateRight)

  var timestampLeft = startOfISOWeekLeft.getTime() -
    startOfISOWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfISOWeekRight.getTime() -
    startOfISOWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarISOWeeks


/***/ }),
/* 1536 */
/***/ (function(module, exports, __webpack_require__) {

var getQuarter = __webpack_require__(715)
var parse = __webpack_require__(5)

/**
 * @category Quarter Helpers
 * @summary Get the number of calendar quarters between the given dates.
 *
 * @description
 * Get the number of calendar quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar quarters
 *
 * @example
 * // How many calendar quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInCalendarQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 3
 */
function differenceInCalendarQuarters (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear()
  var quarterDiff = getQuarter(dateLeft) - getQuarter(dateRight)

  return yearDiff * 4 + quarterDiff
}

module.exports = differenceInCalendarQuarters


/***/ }),
/* 1537 */
/***/ (function(module, exports, __webpack_require__) {

var startOfWeek = __webpack_require__(326)

var MILLISECONDS_IN_MINUTE = 60000
var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category Week Helpers
 * @summary Get the number of calendar weeks between the given dates.
 *
 * @description
 * Get the number of calendar weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Number} the number of calendar weeks
 *
 * @example
 * // How many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 3
 *
 * @example
 * // If the week starts on Monday,
 * // how many calendar weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInCalendarWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5),
 *   {weekStartsOn: 1}
 * )
 * //=> 2
 */
function differenceInCalendarWeeks (dirtyDateLeft, dirtyDateRight, dirtyOptions) {
  var startOfWeekLeft = startOfWeek(dirtyDateLeft, dirtyOptions)
  var startOfWeekRight = startOfWeek(dirtyDateRight, dirtyOptions)

  var timestampLeft = startOfWeekLeft.getTime() -
    startOfWeekLeft.getTimezoneOffset() * MILLISECONDS_IN_MINUTE
  var timestampRight = startOfWeekRight.getTime() -
    startOfWeekRight.getTimezoneOffset() * MILLISECONDS_IN_MINUTE

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_WEEK)
}

module.exports = differenceInCalendarWeeks


/***/ }),
/* 1538 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(325)

var MILLISECONDS_IN_HOUR = 3600000

/**
 * @category Hour Helpers
 * @summary Get the number of hours between the given dates.
 *
 * @description
 * Get the number of hours between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of hours
 *
 * @example
 * // How many hours are between 2 July 2014 06:50:00 and 2 July 2014 19:00:00?
 * var result = differenceInHours(
 *   new Date(2014, 6, 2, 19, 0),
 *   new Date(2014, 6, 2, 6, 50)
 * )
 * //=> 12
 */
function differenceInHours (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_HOUR
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInHours


/***/ }),
/* 1539 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var differenceInCalendarISOYears = __webpack_require__(706)
var compareAsc = __webpack_require__(248)
var subISOYears = __webpack_require__(734)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of full ISO week-numbering years between the given dates.
 *
 * @description
 * Get the number of full ISO week-numbering years between the given dates.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full ISO week-numbering years
 *
 * @example
 * // How many full ISO week-numbering years are between 1 January 2010 and 1 January 2012?
 * var result = differenceInISOYears(
 *   new Date(2012, 0, 1),
 *   new Date(2010, 0, 1)
 * )
 * //=> 1
 */
function differenceInISOYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarISOYears(dateLeft, dateRight))
  dateLeft = subISOYears(dateLeft, sign * difference)

  // Math.abs(diff in full ISO years - diff in calendar ISO years) === 1
  // if last calendar ISO year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastISOYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastISOYearNotFull)
}

module.exports = differenceInISOYears


/***/ }),
/* 1540 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMilliseconds = __webpack_require__(325)

var MILLISECONDS_IN_MINUTE = 60000

/**
 * @category Minute Helpers
 * @summary Get the number of minutes between the given dates.
 *
 * @description
 * Get the number of minutes between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of minutes
 *
 * @example
 * // How many minutes are between 2 July 2014 12:07:59 and 2 July 2014 12:20:00?
 * var result = differenceInMinutes(
 *   new Date(2014, 6, 2, 12, 20, 0),
 *   new Date(2014, 6, 2, 12, 7, 59)
 * )
 * //=> 12
 */
function differenceInMinutes (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMilliseconds(dirtyDateLeft, dirtyDateRight) / MILLISECONDS_IN_MINUTE
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInMinutes


/***/ }),
/* 1541 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInMonths = __webpack_require__(459)

/**
 * @category Quarter Helpers
 * @summary Get the number of full quarters between the given dates.
 *
 * @description
 * Get the number of full quarters between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full quarters
 *
 * @example
 * // How many full quarters are between 31 December 2013 and 2 July 2014?
 * var result = differenceInQuarters(
 *   new Date(2014, 6, 2),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInQuarters (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInMonths(dirtyDateLeft, dirtyDateRight) / 3
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInQuarters


/***/ }),
/* 1542 */
/***/ (function(module, exports, __webpack_require__) {

var differenceInDays = __webpack_require__(709)

/**
 * @category Week Helpers
 * @summary Get the number of full weeks between the given dates.
 *
 * @description
 * Get the number of full weeks between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full weeks
 *
 * @example
 * // How many full weeks are between 5 July 2014 and 20 July 2014?
 * var result = differenceInWeeks(
 *   new Date(2014, 6, 20),
 *   new Date(2014, 6, 5)
 * )
 * //=> 2
 */
function differenceInWeeks (dirtyDateLeft, dirtyDateRight) {
  var diff = differenceInDays(dirtyDateLeft, dirtyDateRight) / 7
  return diff > 0 ? Math.floor(diff) : Math.ceil(diff)
}

module.exports = differenceInWeeks


/***/ }),
/* 1543 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var differenceInCalendarYears = __webpack_require__(708)
var compareAsc = __webpack_require__(248)

/**
 * @category Year Helpers
 * @summary Get the number of full years between the given dates.
 *
 * @description
 * Get the number of full years between the given dates.
 *
 * @param {Date|String|Number} dateLeft - the later date
 * @param {Date|String|Number} dateRight - the earlier date
 * @returns {Number} the number of full years
 *
 * @example
 * // How many full years are between 31 December 2013 and 11 February 2015?
 * var result = differenceInYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 1
 */
function differenceInYears (dirtyDateLeft, dirtyDateRight) {
  var dateLeft = parse(dirtyDateLeft)
  var dateRight = parse(dirtyDateRight)

  var sign = compareAsc(dateLeft, dateRight)
  var difference = Math.abs(differenceInCalendarYears(dateLeft, dateRight))
  dateLeft.setFullYear(dateLeft.getFullYear() - sign * difference)

  // Math.abs(diff in full years - diff in calendar years) === 1 if last calendar year is not full
  // If so, result must be decreased by 1 in absolute value
  var isLastYearNotFull = compareAsc(dateLeft, dateRight) === -sign
  return sign * (difference - isLastYearNotFull)
}

module.exports = differenceInYears


/***/ }),
/* 1544 */
/***/ (function(module, exports, __webpack_require__) {

var compareDesc = __webpack_require__(458)
var parse = __webpack_require__(5)
var differenceInSeconds = __webpack_require__(460)
var enLocale = __webpack_require__(466)

var MINUTES_IN_DAY = 1440
var MINUTES_IN_MONTH = 43200
var MINUTES_IN_YEAR = 525600

/**
 * @category Common Helpers
 * @summary Return the distance between the given dates in words.
 *
 * @description
 * Return the distance between the given dates in words, using strict units.
 * This is like `distanceInWords`, but does not use helpers like 'almost', 'over',
 * 'less than' and the like.
 *
 * | Distance between dates | Result              |
 * |------------------------|---------------------|
 * | 0 ... 59 secs          | [0..59] seconds     |
 * | 1 ... 59 mins          | [1..59] minutes     |
 * | 1 ... 23 hrs           | [1..23] hours       |
 * | 1 ... 29 days          | [1..29] days        |
 * | 1 ... 11 months        | [1..11] months      |
 * | 1 ... N years          | [1..N]  years       |
 *
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @param {Date|String|Number} date - the other date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.addSuffix=false] - result indicates if the second date is earlier or later than the first
 * @param {'s'|'m'|'h'|'d'|'M'|'Y'} [options.unit] - if specified, will force a unit
 * @param {'floor'|'ceil'|'round'} [options.partialMethod='floor'] - which way to round partial units
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // What is the distance between 2 July 2014 and 1 January 2015?
 * var result = distanceInWordsStrict(
 *   new Date(2014, 6, 2),
 *   new Date(2015, 0, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // What is the distance between 1 January 2015 00:00:15
 * // and 1 January 2015 00:00:00?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   new Date(2015, 0, 1, 0, 0, 0),
 * )
 * //=> '15 seconds'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, with a suffix?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> '1 year ago'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 1 January 2015, in minutes?
 * var result = distanceInWordsStrict(
 *   new Date(2016, 0, 1),
 *   new Date(2015, 0, 1),
 *   {unit: 'm'}
 * )
 * //=> '525600 minutes'
 *
 * @example
 * // What is the distance from 1 January 2016
 * // to 28 January 2015, in months, rounded up?
 * var result = distanceInWordsStrict(
 *   new Date(2015, 0, 28),
 *   new Date(2015, 0, 1),
 *   {unit: 'M', partialMethod: 'ceil'}
 * )
 * //=> '1 month'
 *
 * @example
 * // What is the distance between 1 August 2016 and 1 January 2015 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsStrict(
 *   new Date(2016, 7, 1),
 *   new Date(2015, 0, 1),
 *   {locale: eoLocale}
 * )
 * //=> '1 jaro'
 */
function distanceInWordsStrict (dirtyDateToCompare, dirtyDate, dirtyOptions) {
  var options = dirtyOptions || {}

  var comparison = compareDesc(dirtyDateToCompare, dirtyDate)

  var locale = options.locale
  var localize = enLocale.distanceInWords.localize
  if (locale && locale.distanceInWords && locale.distanceInWords.localize) {
    localize = locale.distanceInWords.localize
  }

  var localizeOptions = {
    addSuffix: Boolean(options.addSuffix),
    comparison: comparison
  }

  var dateLeft, dateRight
  if (comparison > 0) {
    dateLeft = parse(dirtyDateToCompare)
    dateRight = parse(dirtyDate)
  } else {
    dateLeft = parse(dirtyDate)
    dateRight = parse(dirtyDateToCompare)
  }

  var unit
  var mathPartial = Math[options.partialMethod ? String(options.partialMethod) : 'floor']
  var seconds = differenceInSeconds(dateRight, dateLeft)
  var offset = dateRight.getTimezoneOffset() - dateLeft.getTimezoneOffset()
  var minutes = mathPartial(seconds / 60) - offset
  var hours, days, months, years

  if (options.unit) {
    unit = String(options.unit)
  } else {
    if (minutes < 1) {
      unit = 's'
    } else if (minutes < 60) {
      unit = 'm'
    } else if (minutes < MINUTES_IN_DAY) {
      unit = 'h'
    } else if (minutes < MINUTES_IN_MONTH) {
      unit = 'd'
    } else if (minutes < MINUTES_IN_YEAR) {
      unit = 'M'
    } else {
      unit = 'Y'
    }
  }

  // 0 up to 60 seconds
  if (unit === 's') {
    return localize('xSeconds', seconds, localizeOptions)

  // 1 up to 60 mins
  } else if (unit === 'm') {
    return localize('xMinutes', minutes, localizeOptions)

  // 1 up to 24 hours
  } else if (unit === 'h') {
    hours = mathPartial(minutes / 60)
    return localize('xHours', hours, localizeOptions)

  // 1 up to 30 days
  } else if (unit === 'd') {
    days = mathPartial(minutes / MINUTES_IN_DAY)
    return localize('xDays', days, localizeOptions)

  // 1 up to 12 months
  } else if (unit === 'M') {
    months = mathPartial(minutes / MINUTES_IN_MONTH)
    return localize('xMonths', months, localizeOptions)

  // 1 year up to max Date
  } else if (unit === 'Y') {
    years = mathPartial(minutes / MINUTES_IN_YEAR)
    return localize('xYears', years, localizeOptions)
  }

  throw new Error('Unknown unit: ' + unit)
}

module.exports = distanceInWordsStrict


/***/ }),
/* 1545 */
/***/ (function(module, exports, __webpack_require__) {

var distanceInWords = __webpack_require__(710)

/**
 * @category Common Helpers
 * @summary Return the distance between the given date and now in words.
 *
 * @description
 * Return the distance between the given date and now in words.
 *
 * | Distance to now                                                   | Result              |
 * |-------------------------------------------------------------------|---------------------|
 * | 0 ... 30 secs                                                     | less than a minute  |
 * | 30 secs ... 1 min 30 secs                                         | 1 minute            |
 * | 1 min 30 secs ... 44 mins 30 secs                                 | [2..44] minutes     |
 * | 44 mins ... 30 secs ... 89 mins 30 secs                           | about 1 hour        |
 * | 89 mins 30 secs ... 23 hrs 59 mins 30 secs                        | about [2..24] hours |
 * | 23 hrs 59 mins 30 secs ... 41 hrs 59 mins 30 secs                 | 1 day               |
 * | 41 hrs 59 mins 30 secs ... 29 days 23 hrs 59 mins 30 secs         | [2..30] days        |
 * | 29 days 23 hrs 59 mins 30 secs ... 44 days 23 hrs 59 mins 30 secs | about 1 month       |
 * | 44 days 23 hrs 59 mins 30 secs ... 59 days 23 hrs 59 mins 30 secs | about 2 months      |
 * | 59 days 23 hrs 59 mins 30 secs ... 1 yr                           | [2..12] months      |
 * | 1 yr ... 1 yr 3 months                                            | about 1 year        |
 * | 1 yr 3 months ... 1 yr 9 month s                                  | over 1 year         |
 * | 1 yr 9 months ... 2 yrs                                           | almost 2 years      |
 * | N yrs ... N yrs 3 months                                          | about N years       |
 * | N yrs 3 months ... N yrs 9 months                                 | over N years        |
 * | N yrs 9 months ... N+1 yrs                                        | almost N+1 years    |
 *
 * With `options.includeSeconds == true`:
 * | Distance to now     | Result               |
 * |---------------------|----------------------|
 * | 0 secs ... 5 secs   | less than 5 seconds  |
 * | 5 secs ... 10 secs  | less than 10 seconds |
 * | 10 secs ... 20 secs | less than 20 seconds |
 * | 20 secs ... 40 secs | half a minute        |
 * | 40 secs ... 60 secs | less than a minute   |
 * | 60 secs ... 90 secs | 1 minute             |
 *
 * @param {Date|String|Number} date - the given date
 * @param {Object} [options] - the object with options
 * @param {Boolean} [options.includeSeconds=false] - distances less than a minute are more detailed
 * @param {Boolean} [options.addSuffix=false] - result specifies if the second date is earlier or later than the first
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the distance in words
 *
 * @example
 * // If today is 1 January 2015, what is the distance to 2 July 2014?
 * var result = distanceInWordsToNow(
 *   new Date(2014, 6, 2)
 * )
 * //=> '6 months'
 *
 * @example
 * // If now is 1 January 2015 00:00:00,
 * // what is the distance to 1 January 2015 00:00:15, including seconds?
 * var result = distanceInWordsToNow(
 *   new Date(2015, 0, 1, 0, 0, 15),
 *   {includeSeconds: true}
 * )
 * //=> 'less than 20 seconds'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 January 2016, with a suffix?
 * var result = distanceInWordsToNow(
 *   new Date(2016, 0, 1),
 *   {addSuffix: true}
 * )
 * //=> 'in about 1 year'
 *
 * @example
 * // If today is 1 January 2015,
 * // what is the distance to 1 August 2016 in Esperanto?
 * var eoLocale = require('date-fns/locale/eo')
 * var result = distanceInWordsToNow(
 *   new Date(2016, 7, 1),
 *   {locale: eoLocale}
 * )
 * //=> 'pli ol 1 jaro'
 */
function distanceInWordsToNow (dirtyDate, dirtyOptions) {
  return distanceInWords(Date.now(), dirtyDate, dirtyOptions)
}

module.exports = distanceInWordsToNow


/***/ }),
/* 1546 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Day Helpers
 * @summary Return the array of dates within the specified range.
 *
 * @description
 * Return the array of dates within the specified range.
 *
 * @param {Date|String|Number} startDate - the first date
 * @param {Date|String|Number} endDate - the last date
 * @param {Number} [step=1] - the step between each day
 * @returns {Date[]} the array with starts of days from the day of startDate to the day of endDate
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // Each day between 6 October 2014 and 10 October 2014:
 * var result = eachDay(
 *   new Date(2014, 9, 6),
 *   new Date(2014, 9, 10)
 * )
 * //=> [
 * //   Mon Oct 06 2014 00:00:00,
 * //   Tue Oct 07 2014 00:00:00,
 * //   Wed Oct 08 2014 00:00:00,
 * //   Thu Oct 09 2014 00:00:00,
 * //   Fri Oct 10 2014 00:00:00
 * // ]
 */
function eachDay (dirtyStartDate, dirtyEndDate, dirtyStep) {
  var startDate = parse(dirtyStartDate)
  var endDate = parse(dirtyEndDate)
  var step = dirtyStep !== undefined ? dirtyStep : 1

  var endTime = endDate.getTime()

  if (startDate.getTime() > endTime) {
    throw new Error('The first date cannot be after the second date')
  }

  var dates = []

  var currentDate = startDate
  currentDate.setHours(0, 0, 0, 0)

  while (currentDate.getTime() <= endTime) {
    dates.push(parse(currentDate))
    currentDate.setDate(currentDate.getDate() + step)
  }

  return dates
}

module.exports = eachDay


/***/ }),
/* 1547 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Hour Helpers
 * @summary Return the end of an hour for the given date.
 *
 * @description
 * Return the end of an hour for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an hour
 *
 * @example
 * // The end of an hour for 2 September 2014 11:55:00:
 * var result = endOfHour(new Date(2014, 8, 2, 11, 55))
 * //=> Tue Sep 02 2014 11:59:59.999
 */
function endOfHour (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMinutes(59, 59, 999)
  return date
}

module.exports = endOfHour


/***/ }),
/* 1548 */
/***/ (function(module, exports, __webpack_require__) {

var endOfWeek = __webpack_require__(712)

/**
 * @category ISO Week Helpers
 * @summary Return the end of an ISO week for the given date.
 *
 * @description
 * Return the end of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week
 *
 * @example
 * // The end of an ISO week for 2 September 2014 11:55:00:
 * var result = endOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 23:59:59.999
 */
function endOfISOWeek (dirtyDate) {
  return endOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = endOfISOWeek


/***/ }),
/* 1549 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(176)
var startOfISOWeek = __webpack_require__(178)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the end of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the end of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The end of an ISO week-numbering year for 2 July 2005:
 * var result = endOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 23:59:59.999
 */
function endOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuaryOfNextYear = new Date(0)
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4)
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuaryOfNextYear)
  date.setMilliseconds(date.getMilliseconds() - 1)
  return date
}

module.exports = endOfISOYear


/***/ }),
/* 1550 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Minute Helpers
 * @summary Return the end of a minute for the given date.
 *
 * @description
 * Return the end of a minute for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a minute
 *
 * @example
 * // The end of a minute for 1 December 2014 22:15:45.400:
 * var result = endOfMinute(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:59.999
 */
function endOfMinute (dirtyDate) {
  var date = parse(dirtyDate)
  date.setSeconds(59, 999)
  return date
}

module.exports = endOfMinute


/***/ }),
/* 1551 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Quarter Helpers
 * @summary Return the end of a year quarter for the given date.
 *
 * @description
 * Return the end of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a quarter
 *
 * @example
 * // The end of a quarter for 2 September 2014 11:55:00:
 * var result = endOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfQuarter


/***/ }),
/* 1552 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Second Helpers
 * @summary Return the end of a second for the given date.
 *
 * @description
 * Return the end of a second for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a second
 *
 * @example
 * // The end of a second for 1 December 2014 22:15:45.400:
 * var result = endOfSecond(new Date(2014, 11, 1, 22, 15, 45, 400))
 * //=> Mon Dec 01 2014 22:15:45.999
 */
function endOfSecond (dirtyDate) {
  var date = parse(dirtyDate)
  date.setMilliseconds(999)
  return date
}

module.exports = endOfSecond


/***/ }),
/* 1553 */
/***/ (function(module, exports, __webpack_require__) {

var endOfDay = __webpack_require__(461)

/**
 * @category Day Helpers
 * @summary Return the end of today.
 *
 * @description
 * Return the end of today.
 *
 * @returns {Date} the end of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfToday()
 * //=> Mon Oct 6 2014 23:59:59.999
 */
function endOfToday () {
  return endOfDay(new Date())
}

module.exports = endOfToday


/***/ }),
/* 1554 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of tomorrow.
 *
 * @description
 * Return the end of tomorrow.
 *
 * @returns {Date} the end of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfTomorrow()
 * //=> Tue Oct 7 2014 23:59:59.999
 */
function endOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfTomorrow


/***/ }),
/* 1555 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of a year
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * var result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYear


/***/ }),
/* 1556 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the end of yesterday.
 *
 * @description
 * Return the end of yesterday.
 *
 * @returns {Date} the end of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = endOfYesterday()
 * //=> Sun Oct 5 2014 23:59:59.999
 */
function endOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(23, 59, 59, 999)
  return date
}

module.exports = endOfYesterday


/***/ }),
/* 1557 */
/***/ (function(module, exports, __webpack_require__) {

var getDayOfYear = __webpack_require__(713)
var getISOWeek = __webpack_require__(463)
var getISOYear = __webpack_require__(176)
var parse = __webpack_require__(5)
var isValid = __webpack_require__(725)
var enLocale = __webpack_require__(466)

/**
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format.
 *
 * Accepted tokens:
 * | Unit                    | Token | Result examples                  |
 * |-------------------------|-------|----------------------------------|
 * | Month                   | M     | 1, 2, ..., 12                    |
 * |                         | Mo    | 1st, 2nd, ..., 12th              |
 * |                         | MM    | 01, 02, ..., 12                  |
 * |                         | MMM   | Jan, Feb, ..., Dec               |
 * |                         | MMMM  | January, February, ..., December |
 * | Quarter                 | Q     | 1, 2, 3, 4                       |
 * |                         | Qo    | 1st, 2nd, 3rd, 4th               |
 * | Day of month            | D     | 1, 2, ..., 31                    |
 * |                         | Do    | 1st, 2nd, ..., 31st              |
 * |                         | DD    | 01, 02, ..., 31                  |
 * | Day of year             | DDD   | 1, 2, ..., 366                   |
 * |                         | DDDo  | 1st, 2nd, ..., 366th             |
 * |                         | DDDD  | 001, 002, ..., 366               |
 * | Day of week             | d     | 0, 1, ..., 6                     |
 * |                         | do    | 0th, 1st, ..., 6th               |
 * |                         | dd    | Su, Mo, ..., Sa                  |
 * |                         | ddd   | Sun, Mon, ..., Sat               |
 * |                         | dddd  | Sunday, Monday, ..., Saturday    |
 * | Day of ISO week         | E     | 1, 2, ..., 7                     |
 * | ISO week                | W     | 1, 2, ..., 53                    |
 * |                         | Wo    | 1st, 2nd, ..., 53rd              |
 * |                         | WW    | 01, 02, ..., 53                  |
 * | Year                    | YY    | 00, 01, ..., 99                  |
 * |                         | YYYY  | 1900, 1901, ..., 2099            |
 * | ISO week-numbering year | GG    | 00, 01, ..., 99                  |
 * |                         | GGGG  | 1900, 1901, ..., 2099            |
 * | AM/PM                   | A     | AM, PM                           |
 * |                         | a     | am, pm                           |
 * |                         | aa    | a.m., p.m.                       |
 * | Hour                    | H     | 0, 1, ... 23                     |
 * |                         | HH    | 00, 01, ... 23                   |
 * |                         | h     | 1, 2, ..., 12                    |
 * |                         | hh    | 01, 02, ..., 12                  |
 * | Minute                  | m     | 0, 1, ..., 59                    |
 * |                         | mm    | 00, 01, ..., 59                  |
 * | Second                  | s     | 0, 1, ..., 59                    |
 * |                         | ss    | 00, 01, ..., 59                  |
 * | 1/10 of second          | S     | 0, 1, ..., 9                     |
 * | 1/100 of second         | SS    | 00, 01, ..., 99                  |
 * | Millisecond             | SSS   | 000, 001, ..., 999               |
 * | Timezone                | Z     | -01:00, +00:00, ... +12:00       |
 * |                         | ZZ    | -0100, +0000, ..., +1200         |
 * | Seconds timestamp       | X     | 512969520                        |
 * | Milliseconds timestamp  | x     | 512969520900                     |
 *
 * The characters wrapped in square brackets are escaped.
 *
 * The result may vary by locale.
 *
 * @param {Date|String|Number} date - the original date
 * @param {String} [format='YYYY-MM-DDTHH:mm:ss.SSSZ'] - the string of tokens
 * @param {Object} [options] - the object with options
 * @param {Object} [options.locale=enLocale] - the locale object
 * @returns {String} the formatted date string
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * var result = format(
 *   new Date(2014, 1, 11),
 *   'MM/DD/YYYY'
 * )
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * var eoLocale = require('date-fns/locale/eo')
 * var result = format(
 *   new Date(2014, 6, 2),
 *   'Do [de] MMMM YYYY',
 *   {locale: eoLocale}
 * )
 * //=> '2-a de julio 2014'
 */
function format (dirtyDate, dirtyFormatStr, dirtyOptions) {
  var formatStr = dirtyFormatStr ? String(dirtyFormatStr) : 'YYYY-MM-DDTHH:mm:ss.SSSZ'
  var options = dirtyOptions || {}

  var locale = options.locale
  var localeFormatters = enLocale.format.formatters
  var formattingTokensRegExp = enLocale.format.formattingTokensRegExp
  if (locale && locale.format && locale.format.formatters) {
    localeFormatters = locale.format.formatters

    if (locale.format.formattingTokensRegExp) {
      formattingTokensRegExp = locale.format.formattingTokensRegExp
    }
  }

  var date = parse(dirtyDate)

  if (!isValid(date)) {
    return 'Invalid Date'
  }

  var formatFn = buildFormatFn(formatStr, localeFormatters, formattingTokensRegExp)

  return formatFn(date)
}

var formatters = {
  // Month: 1, 2, ..., 12
  'M': function (date) {
    return date.getMonth() + 1
  },

  // Month: 01, 02, ..., 12
  'MM': function (date) {
    return addLeadingZeros(date.getMonth() + 1, 2)
  },

  // Quarter: 1, 2, 3, 4
  'Q': function (date) {
    return Math.ceil((date.getMonth() + 1) / 3)
  },

  // Day of month: 1, 2, ..., 31
  'D': function (date) {
    return date.getDate()
  },

  // Day of month: 01, 02, ..., 31
  'DD': function (date) {
    return addLeadingZeros(date.getDate(), 2)
  },

  // Day of year: 1, 2, ..., 366
  'DDD': function (date) {
    return getDayOfYear(date)
  },

  // Day of year: 001, 002, ..., 366
  'DDDD': function (date) {
    return addLeadingZeros(getDayOfYear(date), 3)
  },

  // Day of week: 0, 1, ..., 6
  'd': function (date) {
    return date.getDay()
  },

  // Day of ISO week: 1, 2, ..., 7
  'E': function (date) {
    return date.getDay() || 7
  },

  // ISO week: 1, 2, ..., 53
  'W': function (date) {
    return getISOWeek(date)
  },

  // ISO week: 01, 02, ..., 53
  'WW': function (date) {
    return addLeadingZeros(getISOWeek(date), 2)
  },

  // Year: 00, 01, ..., 99
  'YY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4).substr(2)
  },

  // Year: 1900, 1901, ..., 2099
  'YYYY': function (date) {
    return addLeadingZeros(date.getFullYear(), 4)
  },

  // ISO week-numbering year: 00, 01, ..., 99
  'GG': function (date) {
    return String(getISOYear(date)).substr(2)
  },

  // ISO week-numbering year: 1900, 1901, ..., 2099
  'GGGG': function (date) {
    return getISOYear(date)
  },

  // Hour: 0, 1, ... 23
  'H': function (date) {
    return date.getHours()
  },

  // Hour: 00, 01, ..., 23
  'HH': function (date) {
    return addLeadingZeros(date.getHours(), 2)
  },

  // Hour: 1, 2, ..., 12
  'h': function (date) {
    var hours = date.getHours()
    if (hours === 0) {
      return 12
    } else if (hours > 12) {
      return hours % 12
    } else {
      return hours
    }
  },

  // Hour: 01, 02, ..., 12
  'hh': function (date) {
    return addLeadingZeros(formatters['h'](date), 2)
  },

  // Minute: 0, 1, ..., 59
  'm': function (date) {
    return date.getMinutes()
  },

  // Minute: 00, 01, ..., 59
  'mm': function (date) {
    return addLeadingZeros(date.getMinutes(), 2)
  },

  // Second: 0, 1, ..., 59
  's': function (date) {
    return date.getSeconds()
  },

  // Second: 00, 01, ..., 59
  'ss': function (date) {
    return addLeadingZeros(date.getSeconds(), 2)
  },

  // 1/10 of second: 0, 1, ..., 9
  'S': function (date) {
    return Math.floor(date.getMilliseconds() / 100)
  },

  // 1/100 of second: 00, 01, ..., 99
  'SS': function (date) {
    return addLeadingZeros(Math.floor(date.getMilliseconds() / 10), 2)
  },

  // Millisecond: 000, 001, ..., 999
  'SSS': function (date) {
    return addLeadingZeros(date.getMilliseconds(), 3)
  },

  // Timezone: -01:00, +00:00, ... +12:00
  'Z': function (date) {
    return formatTimezone(date.getTimezoneOffset(), ':')
  },

  // Timezone: -0100, +0000, ... +1200
  'ZZ': function (date) {
    return formatTimezone(date.getTimezoneOffset())
  },

  // Seconds timestamp: 512969520
  'X': function (date) {
    return Math.floor(date.getTime() / 1000)
  },

  // Milliseconds timestamp: 512969520900
  'x': function (date) {
    return date.getTime()
  }
}

function buildFormatFn (formatStr, localeFormatters, formattingTokensRegExp) {
  var array = formatStr.match(formattingTokensRegExp)
  var length = array.length

  var i
  var formatter
  for (i = 0; i < length; i++) {
    formatter = localeFormatters[array[i]] || formatters[array[i]]
    if (formatter) {
      array[i] = formatter
    } else {
      array[i] = removeFormattingTokens(array[i])
    }
  }

  return function (date) {
    var output = ''
    for (var i = 0; i < length; i++) {
      if (array[i] instanceof Function) {
        output += array[i](date, formatters)
      } else {
        output += array[i]
      }
    }
    return output
  }
}

function removeFormattingTokens (input) {
  if (input.match(/\[[\s\S]/)) {
    return input.replace(/^\[|]$/g, '')
  }
  return input.replace(/\\/g, '')
}

function formatTimezone (offset, delimeter) {
  delimeter = delimeter || ''
  var sign = offset > 0 ? '-' : '+'
  var absOffset = Math.abs(offset)
  var hours = Math.floor(absOffset / 60)
  var minutes = absOffset % 60
  return sign + addLeadingZeros(hours, 2) + delimeter + addLeadingZeros(minutes, 2)
}

function addLeadingZeros (number, targetLength) {
  var output = Math.abs(number).toString()
  while (output.length < targetLength) {
    output = '0' + output
  }
  return output
}

module.exports = format


/***/ }),
/* 1558 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of month
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * var result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate (dirtyDate) {
  var date = parse(dirtyDate)
  var dayOfMonth = date.getDate()
  return dayOfMonth
}

module.exports = getDate


/***/ }),
/* 1559 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the day of week
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * var result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day
}

module.exports = getDay


/***/ }),
/* 1560 */
/***/ (function(module, exports, __webpack_require__) {

var isLeapYear = __webpack_require__(716)

/**
 * @category Year Helpers
 * @summary Get the number of days in a year of the given date.
 *
 * @description
 * Get the number of days in a year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of days in a year
 *
 * @example
 * // How many days are in 2012?
 * var result = getDaysInYear(new Date(2012, 0, 1))
 * //=> 366
 */
function getDaysInYear (dirtyDate) {
  return isLeapYear(dirtyDate) ? 366 : 365
}

module.exports = getDaysInYear


/***/ }),
/* 1561 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the hours
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * var result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours (dirtyDate) {
  var date = parse(dirtyDate)
  var hours = date.getHours()
  return hours
}

module.exports = getHours


/***/ }),
/* 1562 */
/***/ (function(module, exports, __webpack_require__) {

var startOfISOYear = __webpack_require__(249)
var addWeeks = __webpack_require__(457)

var MILLISECONDS_IN_WEEK = 604800000

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * @description
 * Get the number of weeks in an ISO week-numbering year of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the number of ISO weeks in a year
 *
 * @example
 * // How many weeks are in ISO week-numbering year 2015?
 * var result = getISOWeeksInYear(new Date(2015, 1, 11))
 * //=> 53
 */
function getISOWeeksInYear (dirtyDate) {
  var thisYear = startOfISOYear(dirtyDate)
  var nextYear = startOfISOYear(addWeeks(thisYear, 60))
  var diff = nextYear.valueOf() - thisYear.valueOf()
  // Round the number of weeks to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK)
}

module.exports = getISOWeeksInYear


/***/ }),
/* 1563 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Millisecond Helpers
 * @summary Get the milliseconds of the given date.
 *
 * @description
 * Get the milliseconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the milliseconds
 *
 * @example
 * // Get the milliseconds of 29 February 2012 11:45:05.123:
 * var result = getMilliseconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 123
 */
function getMilliseconds (dirtyDate) {
  var date = parse(dirtyDate)
  var milliseconds = date.getMilliseconds()
  return milliseconds
}

module.exports = getMilliseconds


/***/ }),
/* 1564 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the minutes
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * var result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes (dirtyDate) {
  var date = parse(dirtyDate)
  var minutes = date.getMinutes()
  return minutes
}

module.exports = getMinutes


/***/ }),
/* 1565 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the month
 *
 * @example
 * // Which month is 29 February 2012?
 * var result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  return month
}

module.exports = getMonth


/***/ }),
/* 1566 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

var MILLISECONDS_IN_DAY = 24 * 60 * 60 * 1000

/**
 * @category Range Helpers
 * @summary Get the number of days that overlap in two date ranges
 *
 * @description
 * Get the number of days that overlap in two date ranges
 *
 * @param {Date|String|Number} initialRangeStartDate - the start of the initial range
 * @param {Date|String|Number} initialRangeEndDate - the end of the initial range
 * @param {Date|String|Number} comparedRangeStartDate - the start of the range to compare it with
 * @param {Date|String|Number} comparedRangeEndDate - the end of the range to compare it with
 * @returns {Number} the number of days that overlap in two date ranges
 * @throws {Error} startDate of a date range cannot be after its endDate
 *
 * @example
 * // For overlapping date ranges adds 1 for each started overlapping day:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 17), new Date(2014, 0, 21)
 * )
 * //=> 3
 *
 * @example
 * // For non-overlapping date ranges returns 0:
 * getOverlappingDaysInRanges(
 *   new Date(2014, 0, 10), new Date(2014, 0, 20), new Date(2014, 0, 21), new Date(2014, 0, 22)
 * )
 * //=> 0
 */
function getOverlappingDaysInRanges (dirtyInitialRangeStartDate, dirtyInitialRangeEndDate, dirtyComparedRangeStartDate, dirtyComparedRangeEndDate) {
  var initialStartTime = parse(dirtyInitialRangeStartDate).getTime()
  var initialEndTime = parse(dirtyInitialRangeEndDate).getTime()
  var comparedStartTime = parse(dirtyComparedRangeStartDate).getTime()
  var comparedEndTime = parse(dirtyComparedRangeEndDate).getTime()

  if (initialStartTime > initialEndTime || comparedStartTime > comparedEndTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  var isOverlapping = initialStartTime < comparedEndTime && comparedStartTime < initialEndTime

  if (!isOverlapping) {
    return 0
  }

  var overlapStartDate = comparedStartTime < initialStartTime
    ? initialStartTime
    : comparedStartTime

  var overlapEndDate = comparedEndTime > initialEndTime
    ? initialEndTime
    : comparedEndTime

  var differenceInMs = overlapEndDate - overlapStartDate

  return Math.ceil(differenceInMs / MILLISECONDS_IN_DAY)
}

module.exports = getOverlappingDaysInRanges


/***/ }),
/* 1567 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the seconds
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * var result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds (dirtyDate) {
  var date = parse(dirtyDate)
  var seconds = date.getSeconds()
  return seconds
}

module.exports = getSeconds


/***/ }),
/* 1568 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the timestamp
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * var result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime (dirtyDate) {
  var date = parse(dirtyDate)
  var timestamp = date.getTime()
  return timestamp
}

module.exports = getTime


/***/ }),
/* 1569 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|String|Number} date - the given date
 * @returns {Number} the year
 *
 * @example
 * // Which year is 2 July 2014?
 * var result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  return year
}

module.exports = getYear


/***/ }),
/* 1570 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = {
  addDays: __webpack_require__(246),
  addHours: __webpack_require__(700),
  addISOYears: __webpack_require__(701),
  addMilliseconds: __webpack_require__(247),
  addMinutes: __webpack_require__(702),
  addMonths: __webpack_require__(323),
  addQuarters: __webpack_require__(703),
  addSeconds: __webpack_require__(704),
  addWeeks: __webpack_require__(457),
  addYears: __webpack_require__(705),
  areRangesOverlapping: __webpack_require__(1532),
  closestIndexTo: __webpack_require__(1533),
  closestTo: __webpack_require__(1534),
  compareAsc: __webpack_require__(248),
  compareDesc: __webpack_require__(458),
  differenceInCalendarDays: __webpack_require__(324),
  differenceInCalendarISOWeeks: __webpack_require__(1535),
  differenceInCalendarISOYears: __webpack_require__(706),
  differenceInCalendarMonths: __webpack_require__(707),
  differenceInCalendarQuarters: __webpack_require__(1536),
  differenceInCalendarWeeks: __webpack_require__(1537),
  differenceInCalendarYears: __webpack_require__(708),
  differenceInDays: __webpack_require__(709),
  differenceInHours: __webpack_require__(1538),
  differenceInISOYears: __webpack_require__(1539),
  differenceInMilliseconds: __webpack_require__(325),
  differenceInMinutes: __webpack_require__(1540),
  differenceInMonths: __webpack_require__(459),
  differenceInQuarters: __webpack_require__(1541),
  differenceInSeconds: __webpack_require__(460),
  differenceInWeeks: __webpack_require__(1542),
  differenceInYears: __webpack_require__(1543),
  distanceInWords: __webpack_require__(710),
  distanceInWordsStrict: __webpack_require__(1544),
  distanceInWordsToNow: __webpack_require__(1545),
  eachDay: __webpack_require__(1546),
  endOfDay: __webpack_require__(461),
  endOfHour: __webpack_require__(1547),
  endOfISOWeek: __webpack_require__(1548),
  endOfISOYear: __webpack_require__(1549),
  endOfMinute: __webpack_require__(1550),
  endOfMonth: __webpack_require__(711),
  endOfQuarter: __webpack_require__(1551),
  endOfSecond: __webpack_require__(1552),
  endOfToday: __webpack_require__(1553),
  endOfTomorrow: __webpack_require__(1554),
  endOfWeek: __webpack_require__(712),
  endOfYear: __webpack_require__(1555),
  endOfYesterday: __webpack_require__(1556),
  format: __webpack_require__(1557),
  getDate: __webpack_require__(1558),
  getDay: __webpack_require__(1559),
  getDayOfYear: __webpack_require__(713),
  getDaysInMonth: __webpack_require__(462),
  getDaysInYear: __webpack_require__(1560),
  getHours: __webpack_require__(1561),
  getISODay: __webpack_require__(714),
  getISOWeek: __webpack_require__(463),
  getISOWeeksInYear: __webpack_require__(1562),
  getISOYear: __webpack_require__(176),
  getMilliseconds: __webpack_require__(1563),
  getMinutes: __webpack_require__(1564),
  getMonth: __webpack_require__(1565),
  getOverlappingDaysInRanges: __webpack_require__(1566),
  getQuarter: __webpack_require__(715),
  getSeconds: __webpack_require__(1567),
  getTime: __webpack_require__(1568),
  getYear: __webpack_require__(1569),
  isAfter: __webpack_require__(1571),
  isBefore: __webpack_require__(1572),
  isDate: __webpack_require__(464),
  isEqual: __webpack_require__(1573),
  isFirstDayOfMonth: __webpack_require__(1574),
  isFriday: __webpack_require__(1575),
  isFuture: __webpack_require__(1576),
  isLastDayOfMonth: __webpack_require__(1577),
  isLeapYear: __webpack_require__(716),
  isMonday: __webpack_require__(1578),
  isPast: __webpack_require__(1579),
  isSameDay: __webpack_require__(1580),
  isSameHour: __webpack_require__(717),
  isSameISOWeek: __webpack_require__(718),
  isSameISOYear: __webpack_require__(719),
  isSameMinute: __webpack_require__(720),
  isSameMonth: __webpack_require__(721),
  isSameQuarter: __webpack_require__(722),
  isSameSecond: __webpack_require__(723),
  isSameWeek: __webpack_require__(465),
  isSameYear: __webpack_require__(724),
  isSaturday: __webpack_require__(1581),
  isSunday: __webpack_require__(1582),
  isThisHour: __webpack_require__(1583),
  isThisISOWeek: __webpack_require__(1584),
  isThisISOYear: __webpack_require__(1585),
  isThisMinute: __webpack_require__(1586),
  isThisMonth: __webpack_require__(1587),
  isThisQuarter: __webpack_require__(1588),
  isThisSecond: __webpack_require__(1589),
  isThisWeek: __webpack_require__(1590),
  isThisYear: __webpack_require__(1591),
  isThursday: __webpack_require__(1592),
  isToday: __webpack_require__(1593),
  isTomorrow: __webpack_require__(1594),
  isTuesday: __webpack_require__(1595),
  isValid: __webpack_require__(725),
  isWednesday: __webpack_require__(1596),
  isWeekend: __webpack_require__(1597),
  isWithinRange: __webpack_require__(1598),
  isYesterday: __webpack_require__(1599),
  lastDayOfISOWeek: __webpack_require__(1600),
  lastDayOfISOYear: __webpack_require__(1601),
  lastDayOfMonth: __webpack_require__(1602),
  lastDayOfQuarter: __webpack_require__(1603),
  lastDayOfWeek: __webpack_require__(726),
  lastDayOfYear: __webpack_require__(1604),
  max: __webpack_require__(1608),
  min: __webpack_require__(1609),
  parse: __webpack_require__(5),
  setDate: __webpack_require__(1610),
  setDay: __webpack_require__(1611),
  setDayOfYear: __webpack_require__(1612),
  setHours: __webpack_require__(1613),
  setISODay: __webpack_require__(1614),
  setISOWeek: __webpack_require__(1615),
  setISOYear: __webpack_require__(727),
  setMilliseconds: __webpack_require__(1616),
  setMinutes: __webpack_require__(1617),
  setMonth: __webpack_require__(728),
  setQuarter: __webpack_require__(1618),
  setSeconds: __webpack_require__(1619),
  setYear: __webpack_require__(1620),
  startOfDay: __webpack_require__(177),
  startOfHour: __webpack_require__(729),
  startOfISOWeek: __webpack_require__(178),
  startOfISOYear: __webpack_require__(249),
  startOfMinute: __webpack_require__(730),
  startOfMonth: __webpack_require__(1621),
  startOfQuarter: __webpack_require__(731),
  startOfSecond: __webpack_require__(732),
  startOfToday: __webpack_require__(1622),
  startOfTomorrow: __webpack_require__(1623),
  startOfWeek: __webpack_require__(326),
  startOfYear: __webpack_require__(733),
  startOfYesterday: __webpack_require__(1624),
  subDays: __webpack_require__(1625),
  subHours: __webpack_require__(1626),
  subISOYears: __webpack_require__(734),
  subMilliseconds: __webpack_require__(1627),
  subMinutes: __webpack_require__(1628),
  subMonths: __webpack_require__(1629),
  subQuarters: __webpack_require__(1630),
  subSeconds: __webpack_require__(1631),
  subWeeks: __webpack_require__(1632),
  subYears: __webpack_require__(1633)
}


/***/ }),
/* 1571 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|String|Number} date - the date that should be after the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * var result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() > dateToCompare.getTime()
}

module.exports = isAfter


/***/ }),
/* 1572 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|String|Number} date - the date that should be before the other one to return true
 * @param {Date|String|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * var result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore (dirtyDate, dirtyDateToCompare) {
  var date = parse(dirtyDate)
  var dateToCompare = parse(dirtyDateToCompare)
  return date.getTime() < dateToCompare.getTime()
}

module.exports = isBefore


/***/ }),
/* 1573 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|String|Number} dateLeft - the first date to compare
 * @param {Date|String|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * var result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0)
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual (dirtyLeftDate, dirtyRightDate) {
  var dateLeft = parse(dirtyLeftDate)
  var dateRight = parse(dirtyRightDate)
  return dateLeft.getTime() === dateRight.getTime()
}

module.exports = isEqual


/***/ }),
/* 1574 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Month Helpers
 * @summary Is the given date the first day of a month?
 *
 * @description
 * Is the given date the first day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the first day of a month
 *
 * @example
 * // Is 1 September 2014 the first day of a month?
 * var result = isFirstDayOfMonth(new Date(2014, 8, 1))
 * //=> true
 */
function isFirstDayOfMonth (dirtyDate) {
  return parse(dirtyDate).getDate() === 1
}

module.exports = isFirstDayOfMonth


/***/ }),
/* 1575 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Weekday Helpers
 * @summary Is the given date Friday?
 *
 * @description
 * Is the given date Friday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Friday
 *
 * @example
 * // Is 26 September 2014 Friday?
 * var result = isFriday(new Date(2014, 8, 26))
 * //=> true
 */
function isFriday (dirtyDate) {
  return parse(dirtyDate).getDay() === 5
}

module.exports = isFriday


/***/ }),
/* 1576 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Is the given date in the future?
 *
 * @description
 * Is the given date in the future?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the future
 *
 * @example
 * // If today is 6 October 2014, is 31 December 2014 in the future?
 * var result = isFuture(new Date(2014, 11, 31))
 * //=> true
 */
function isFuture (dirtyDate) {
  return parse(dirtyDate).getTime() > new Date().getTime()
}

module.exports = isFuture


/***/ }),
/* 1577 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var endOfDay = __webpack_require__(461)
var endOfMonth = __webpack_require__(711)

/**
 * @category Month Helpers
 * @summary Is the given date the last day of a month?
 *
 * @description
 * Is the given date the last day of a month?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is the last day of a month
 *
 * @example
 * // Is 28 February 2014 the last day of a month?
 * var result = isLastDayOfMonth(new Date(2014, 1, 28))
 * //=> true
 */
function isLastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  return endOfDay(date).getTime() === endOfMonth(date).getTime()
}

module.exports = isLastDayOfMonth


/***/ }),
/* 1578 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Weekday Helpers
 * @summary Is the given date Monday?
 *
 * @description
 * Is the given date Monday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Monday
 *
 * @example
 * // Is 22 September 2014 Monday?
 * var result = isMonday(new Date(2014, 8, 22))
 * //=> true
 */
function isMonday (dirtyDate) {
  return parse(dirtyDate).getDay() === 1
}

module.exports = isMonday


/***/ }),
/* 1579 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Is the given date in the past?
 *
 * @description
 * Is the given date in the past?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in the past
 *
 * @example
 * // If today is 6 October 2014, is 2 July 2014 in the past?
 * var result = isPast(new Date(2014, 6, 2))
 * //=> true
 */
function isPast (dirtyDate) {
  return parse(dirtyDate).getTime() < new Date().getTime()
}

module.exports = isPast


/***/ }),
/* 1580 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(177)

/**
 * @category Day Helpers
 * @summary Are the given dates in the same day?
 *
 * @description
 * Are the given dates in the same day?
 *
 * @param {Date|String|Number} dateLeft - the first date to check
 * @param {Date|String|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * var result = isSameDay(
 *   new Date(2014, 8, 4, 6, 0),
 *   new Date(2014, 8, 4, 18, 0)
 * )
 * //=> true
 */
function isSameDay (dirtyDateLeft, dirtyDateRight) {
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft)
  var dateRightStartOfDay = startOfDay(dirtyDateRight)

  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime()
}

module.exports = isSameDay


/***/ }),
/* 1581 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Weekday Helpers
 * @summary Is the given date Saturday?
 *
 * @description
 * Is the given date Saturday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Saturday
 *
 * @example
 * // Is 27 September 2014 Saturday?
 * var result = isSaturday(new Date(2014, 8, 27))
 * //=> true
 */
function isSaturday (dirtyDate) {
  return parse(dirtyDate).getDay() === 6
}

module.exports = isSaturday


/***/ }),
/* 1582 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Weekday Helpers
 * @summary Is the given date Sunday?
 *
 * @description
 * Is the given date Sunday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Sunday
 *
 * @example
 * // Is 21 September 2014 Sunday?
 * var result = isSunday(new Date(2014, 8, 21))
 * //=> true
 */
function isSunday (dirtyDate) {
  return parse(dirtyDate).getDay() === 0
}

module.exports = isSunday


/***/ }),
/* 1583 */
/***/ (function(module, exports, __webpack_require__) {

var isSameHour = __webpack_require__(717)

/**
 * @category Hour Helpers
 * @summary Is the given date in the same hour as the current date?
 *
 * @description
 * Is the given date in the same hour as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this hour
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:00:00 in this hour?
 * var result = isThisHour(new Date(2014, 8, 25, 18))
 * //=> true
 */
function isThisHour (dirtyDate) {
  return isSameHour(new Date(), dirtyDate)
}

module.exports = isThisHour


/***/ }),
/* 1584 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOWeek = __webpack_require__(718)

/**
 * @category ISO Week Helpers
 * @summary Is the given date in the same ISO week as the current date?
 *
 * @description
 * Is the given date in the same ISO week as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week
 *
 * @example
 * // If today is 25 September 2014, is 22 September 2014 in this ISO week?
 * var result = isThisISOWeek(new Date(2014, 8, 22))
 * //=> true
 */
function isThisISOWeek (dirtyDate) {
  return isSameISOWeek(new Date(), dirtyDate)
}

module.exports = isThisISOWeek


/***/ }),
/* 1585 */
/***/ (function(module, exports, __webpack_require__) {

var isSameISOYear = __webpack_require__(719)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Is the given date in the same ISO week-numbering year as the current date?
 *
 * @description
 * Is the given date in the same ISO week-numbering year as the current date?
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this ISO week-numbering year
 *
 * @example
 * // If today is 25 September 2014,
 * // is 30 December 2013 in this ISO week-numbering year?
 * var result = isThisISOYear(new Date(2013, 11, 30))
 * //=> true
 */
function isThisISOYear (dirtyDate) {
  return isSameISOYear(new Date(), dirtyDate)
}

module.exports = isThisISOYear


/***/ }),
/* 1586 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMinute = __webpack_require__(720)

/**
 * @category Minute Helpers
 * @summary Is the given date in the same minute as the current date?
 *
 * @description
 * Is the given date in the same minute as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this minute
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:00 in this minute?
 * var result = isThisMinute(new Date(2014, 8, 25, 18, 30))
 * //=> true
 */
function isThisMinute (dirtyDate) {
  return isSameMinute(new Date(), dirtyDate)
}

module.exports = isThisMinute


/***/ }),
/* 1587 */
/***/ (function(module, exports, __webpack_require__) {

var isSameMonth = __webpack_require__(721)

/**
 * @category Month Helpers
 * @summary Is the given date in the same month as the current date?
 *
 * @description
 * Is the given date in the same month as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this month
 *
 * @example
 * // If today is 25 September 2014, is 15 September 2014 in this month?
 * var result = isThisMonth(new Date(2014, 8, 15))
 * //=> true
 */
function isThisMonth (dirtyDate) {
  return isSameMonth(new Date(), dirtyDate)
}

module.exports = isThisMonth


/***/ }),
/* 1588 */
/***/ (function(module, exports, __webpack_require__) {

var isSameQuarter = __webpack_require__(722)

/**
 * @category Quarter Helpers
 * @summary Is the given date in the same quarter as the current date?
 *
 * @description
 * Is the given date in the same quarter as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this quarter
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this quarter?
 * var result = isThisQuarter(new Date(2014, 6, 2))
 * //=> true
 */
function isThisQuarter (dirtyDate) {
  return isSameQuarter(new Date(), dirtyDate)
}

module.exports = isThisQuarter


/***/ }),
/* 1589 */
/***/ (function(module, exports, __webpack_require__) {

var isSameSecond = __webpack_require__(723)

/**
 * @category Second Helpers
 * @summary Is the given date in the same second as the current date?
 *
 * @description
 * Is the given date in the same second as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this second
 *
 * @example
 * // If now is 25 September 2014 18:30:15.500,
 * // is 25 September 2014 18:30:15.000 in this second?
 * var result = isThisSecond(new Date(2014, 8, 25, 18, 30, 15))
 * //=> true
 */
function isThisSecond (dirtyDate) {
  return isSameSecond(new Date(), dirtyDate)
}

module.exports = isThisSecond


/***/ }),
/* 1590 */
/***/ (function(module, exports, __webpack_require__) {

var isSameWeek = __webpack_require__(465)

/**
 * @category Week Helpers
 * @summary Is the given date in the same week as the current date?
 *
 * @description
 * Is the given date in the same week as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Boolean} the date is in this week
 *
 * @example
 * // If today is 25 September 2014, is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21))
 * //=> true
 *
 * @example
 * // If today is 25 September 2014 and week starts with Monday
 * // is 21 September 2014 in this week?
 * var result = isThisWeek(new Date(2014, 8, 21), {weekStartsOn: 1})
 * //=> false
 */
function isThisWeek (dirtyDate, dirtyOptions) {
  return isSameWeek(new Date(), dirtyDate, dirtyOptions)
}

module.exports = isThisWeek


/***/ }),
/* 1591 */
/***/ (function(module, exports, __webpack_require__) {

var isSameYear = __webpack_require__(724)

/**
 * @category Year Helpers
 * @summary Is the given date in the same year as the current date?
 *
 * @description
 * Is the given date in the same year as the current date?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is in this year
 *
 * @example
 * // If today is 25 September 2014, is 2 July 2014 in this year?
 * var result = isThisYear(new Date(2014, 6, 2))
 * //=> true
 */
function isThisYear (dirtyDate) {
  return isSameYear(new Date(), dirtyDate)
}

module.exports = isThisYear


/***/ }),
/* 1592 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Weekday Helpers
 * @summary Is the given date Thursday?
 *
 * @description
 * Is the given date Thursday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Thursday
 *
 * @example
 * // Is 25 September 2014 Thursday?
 * var result = isThursday(new Date(2014, 8, 25))
 * //=> true
 */
function isThursday (dirtyDate) {
  return parse(dirtyDate).getDay() === 4
}

module.exports = isThursday


/***/ }),
/* 1593 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(177)

/**
 * @category Day Helpers
 * @summary Is the given date today?
 *
 * @description
 * Is the given date today?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is today
 *
 * @example
 * // If today is 6 October 2014, is 6 October 14:00:00 today?
 * var result = isToday(new Date(2014, 9, 6, 14, 0))
 * //=> true
 */
function isToday (dirtyDate) {
  return startOfDay(dirtyDate).getTime() === startOfDay(new Date()).getTime()
}

module.exports = isToday


/***/ }),
/* 1594 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(177)

/**
 * @category Day Helpers
 * @summary Is the given date tomorrow?
 *
 * @description
 * Is the given date tomorrow?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is tomorrow
 *
 * @example
 * // If today is 6 October 2014, is 7 October 14:00:00 tomorrow?
 * var result = isTomorrow(new Date(2014, 9, 7, 14, 0))
 * //=> true
 */
function isTomorrow (dirtyDate) {
  var tomorrow = new Date()
  tomorrow.setDate(tomorrow.getDate() + 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(tomorrow).getTime()
}

module.exports = isTomorrow


/***/ }),
/* 1595 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Weekday Helpers
 * @summary Is the given date Tuesday?
 *
 * @description
 * Is the given date Tuesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Tuesday
 *
 * @example
 * // Is 23 September 2014 Tuesday?
 * var result = isTuesday(new Date(2014, 8, 23))
 * //=> true
 */
function isTuesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 2
}

module.exports = isTuesday


/***/ }),
/* 1596 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Weekday Helpers
 * @summary Is the given date Wednesday?
 *
 * @description
 * Is the given date Wednesday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is Wednesday
 *
 * @example
 * // Is 24 September 2014 Wednesday?
 * var result = isWednesday(new Date(2014, 8, 24))
 * //=> true
 */
function isWednesday (dirtyDate) {
  return parse(dirtyDate).getDay() === 3
}

module.exports = isWednesday


/***/ }),
/* 1597 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Weekday Helpers
 * @summary Does the given date fall on a weekend?
 *
 * @description
 * Does the given date fall on a weekend?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date falls on a weekend
 *
 * @example
 * // Does 5 October 2014 fall on a weekend?
 * var result = isWeekend(new Date(2014, 9, 5))
 * //=> true
 */
function isWeekend (dirtyDate) {
  var date = parse(dirtyDate)
  var day = date.getDay()
  return day === 0 || day === 6
}

module.exports = isWeekend


/***/ }),
/* 1598 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Range Helpers
 * @summary Is the given date within the range?
 *
 * @description
 * Is the given date within the range?
 *
 * @param {Date|String|Number} date - the date to check
 * @param {Date|String|Number} startDate - the start of range
 * @param {Date|String|Number} endDate - the end of range
 * @returns {Boolean} the date is within the range
 * @throws {Error} startDate cannot be after endDate
 *
 * @example
 * // For the date within the range:
 * isWithinRange(
 *   new Date(2014, 0, 3), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> true
 *
 * @example
 * // For the date outside of the range:
 * isWithinRange(
 *   new Date(2014, 0, 10), new Date(2014, 0, 1), new Date(2014, 0, 7)
 * )
 * //=> false
 */
function isWithinRange (dirtyDate, dirtyStartDate, dirtyEndDate) {
  var time = parse(dirtyDate).getTime()
  var startTime = parse(dirtyStartDate).getTime()
  var endTime = parse(dirtyEndDate).getTime()

  if (startTime > endTime) {
    throw new Error('The start of the range cannot be after the end of the range')
  }

  return time >= startTime && time <= endTime
}

module.exports = isWithinRange


/***/ }),
/* 1599 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(177)

/**
 * @category Day Helpers
 * @summary Is the given date yesterday?
 *
 * @description
 * Is the given date yesterday?
 *
 * @param {Date|String|Number} date - the date to check
 * @returns {Boolean} the date is yesterday
 *
 * @example
 * // If today is 6 October 2014, is 5 October 14:00:00 yesterday?
 * var result = isYesterday(new Date(2014, 9, 5, 14, 0))
 * //=> true
 */
function isYesterday (dirtyDate) {
  var yesterday = new Date()
  yesterday.setDate(yesterday.getDate() - 1)
  return startOfDay(dirtyDate).getTime() === startOfDay(yesterday).getTime()
}

module.exports = isYesterday


/***/ }),
/* 1600 */
/***/ (function(module, exports, __webpack_require__) {

var lastDayOfWeek = __webpack_require__(726)

/**
 * @category ISO Week Helpers
 * @summary Return the last day of an ISO week for the given date.
 *
 * @description
 * Return the last day of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of an ISO week
 *
 * @example
 * // The last day of an ISO week for 2 September 2014 11:55:00:
 * var result = lastDayOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Sep 07 2014 00:00:00
 */
function lastDayOfISOWeek (dirtyDate) {
  return lastDayOfWeek(dirtyDate, {weekStartsOn: 1})
}

module.exports = lastDayOfISOWeek


/***/ }),
/* 1601 */
/***/ (function(module, exports, __webpack_require__) {

var getISOYear = __webpack_require__(176)
var startOfISOWeek = __webpack_require__(178)

/**
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the last day of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the last day of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the end of an ISO week-numbering year
 *
 * @example
 * // The last day of an ISO week-numbering year for 2 July 2005:
 * var result = lastDayOfISOYear(new Date(2005, 6, 2))
 * //=> Sun Jan 01 2006 00:00:00
 */
function lastDayOfISOYear (dirtyDate) {
  var year = getISOYear(dirtyDate)
  var fourthOfJanuary = new Date(0)
  fourthOfJanuary.setFullYear(year + 1, 0, 4)
  fourthOfJanuary.setHours(0, 0, 0, 0)
  var date = startOfISOWeek(fourthOfJanuary)
  date.setDate(date.getDate() - 1)
  return date
}

module.exports = lastDayOfISOYear


/***/ }),
/* 1602 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Month Helpers
 * @summary Return the last day of a month for the given date.
 *
 * @description
 * Return the last day of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a month
 *
 * @example
 * // The last day of a month for 2 September 2014 11:55:00:
 * var result = lastDayOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  var month = date.getMonth()
  date.setFullYear(date.getFullYear(), month + 1, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfMonth


/***/ }),
/* 1603 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Quarter Helpers
 * @summary Return the last day of a year quarter for the given date.
 *
 * @description
 * Return the last day of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a quarter
 *
 * @example
 * // The last day of a quarter for 2 September 2014 11:55:00:
 * var result = lastDayOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 00:00:00
 */
function lastDayOfQuarter (dirtyDate) {
  var date = parse(dirtyDate)
  var currentMonth = date.getMonth()
  var month = currentMonth - currentMonth % 3 + 3
  date.setMonth(month, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfQuarter


/***/ }),
/* 1604 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Year Helpers
 * @summary Return the last day of a year for the given date.
 *
 * @description
 * Return the last day of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the last day of a year
 *
 * @example
 * // The last day of a year for 2 September 2014 11:55:00:
 * var result = lastDayOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 00:00:00
 */
function lastDayOfYear (dirtyDate) {
  var date = parse(dirtyDate)
  var year = date.getFullYear()
  date.setFullYear(year + 1, 0, 0)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = lastDayOfYear


/***/ }),
/* 1605 */
/***/ (function(module, exports) {

var commonFormatterKeys = [
  'M', 'MM', 'Q', 'D', 'DD', 'DDD', 'DDDD', 'd',
  'E', 'W', 'WW', 'YY', 'YYYY', 'GG', 'GGGG',
  'H', 'HH', 'h', 'hh', 'm', 'mm',
  's', 'ss', 'S', 'SS', 'SSS',
  'Z', 'ZZ', 'X', 'x'
]

function buildFormattingTokensRegExp (formatters) {
  var formatterKeys = []
  for (var key in formatters) {
    if (formatters.hasOwnProperty(key)) {
      formatterKeys.push(key)
    }
  }

  var formattingTokens = commonFormatterKeys
    .concat(formatterKeys)
    .sort()
    .reverse()
  var formattingTokensRegExp = new RegExp(
    '(\\[[^\\[]*\\])|(\\\\)?' + '(' + formattingTokens.join('|') + '|.)', 'g'
  )

  return formattingTokensRegExp
}

module.exports = buildFormattingTokensRegExp


/***/ }),
/* 1606 */
/***/ (function(module, exports) {

function buildDistanceInWordsLocale () {
  var distanceInWordsLocale = {
    lessThanXSeconds: {
      one: 'less than a second',
      other: 'less than {{count}} seconds'
    },

    xSeconds: {
      one: '1 second',
      other: '{{count}} seconds'
    },

    halfAMinute: 'half a minute',

    lessThanXMinutes: {
      one: 'less than a minute',
      other: 'less than {{count}} minutes'
    },

    xMinutes: {
      one: '1 minute',
      other: '{{count}} minutes'
    },

    aboutXHours: {
      one: 'about 1 hour',
      other: 'about {{count}} hours'
    },

    xHours: {
      one: '1 hour',
      other: '{{count}} hours'
    },

    xDays: {
      one: '1 day',
      other: '{{count}} days'
    },

    aboutXMonths: {
      one: 'about 1 month',
      other: 'about {{count}} months'
    },

    xMonths: {
      one: '1 month',
      other: '{{count}} months'
    },

    aboutXYears: {
      one: 'about 1 year',
      other: 'about {{count}} years'
    },

    xYears: {
      one: '1 year',
      other: '{{count}} years'
    },

    overXYears: {
      one: 'over 1 year',
      other: 'over {{count}} years'
    },

    almostXYears: {
      one: 'almost 1 year',
      other: 'almost {{count}} years'
    }
  }

  function localize (token, count, options) {
    options = options || {}

    var result
    if (typeof distanceInWordsLocale[token] === 'string') {
      result = distanceInWordsLocale[token]
    } else if (count === 1) {
      result = distanceInWordsLocale[token].one
    } else {
      result = distanceInWordsLocale[token].other.replace('{{count}}', count)
    }

    if (options.addSuffix) {
      if (options.comparison > 0) {
        return 'in ' + result
      } else {
        return result + ' ago'
      }
    }

    return result
  }

  return {
    localize: localize
  }
}

module.exports = buildDistanceInWordsLocale


/***/ }),
/* 1607 */
/***/ (function(module, exports, __webpack_require__) {

var buildFormattingTokensRegExp = __webpack_require__(1605)

function buildFormatLocale () {
  // Note: in English, the names of days of the week and months are capitalized.
  // If you are making a new locale based on this one, check if the same is true for the language you're working on.
  // Generally, formatted dates should look like they are in the middle of a sentence,
  // e.g. in Spanish language the weekdays and months should be in the lowercase.
  var months3char = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
  var monthsFull = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
  var weekdays2char = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
  var weekdays3char = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
  var weekdaysFull = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
  var meridiemUppercase = ['AM', 'PM']
  var meridiemLowercase = ['am', 'pm']
  var meridiemFull = ['a.m.', 'p.m.']

  var formatters = {
    // Month: Jan, Feb, ..., Dec
    'MMM': function (date) {
      return months3char[date.getMonth()]
    },

    // Month: January, February, ..., December
    'MMMM': function (date) {
      return monthsFull[date.getMonth()]
    },

    // Day of week: Su, Mo, ..., Sa
    'dd': function (date) {
      return weekdays2char[date.getDay()]
    },

    // Day of week: Sun, Mon, ..., Sat
    'ddd': function (date) {
      return weekdays3char[date.getDay()]
    },

    // Day of week: Sunday, Monday, ..., Saturday
    'dddd': function (date) {
      return weekdaysFull[date.getDay()]
    },

    // AM, PM
    'A': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemUppercase[1] : meridiemUppercase[0]
    },

    // am, pm
    'a': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemLowercase[1] : meridiemLowercase[0]
    },

    // a.m., p.m.
    'aa': function (date) {
      return (date.getHours() / 12) >= 1 ? meridiemFull[1] : meridiemFull[0]
    }
  }

  // Generate ordinal version of formatters: M -> Mo, D -> Do, etc.
  var ordinalFormatters = ['M', 'D', 'DDD', 'd', 'Q', 'W']
  ordinalFormatters.forEach(function (formatterToken) {
    formatters[formatterToken + 'o'] = function (date, formatters) {
      return ordinal(formatters[formatterToken](date))
    }
  })

  return {
    formatters: formatters,
    formattingTokensRegExp: buildFormattingTokensRegExp(formatters)
  }
}

function ordinal (number) {
  var rem100 = number % 100
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st'
      case 2:
        return number + 'nd'
      case 3:
        return number + 'rd'
    }
  }
  return number + 'th'
}

module.exports = buildFormatLocale


/***/ }),
/* 1608 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the latest of the dates
 *
 * @example
 * // Which of these dates is the latest?
 * var result = max(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Sun Jul 02 1995 00:00:00
 */
function max () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var latestTimestamp = Math.max.apply(null, dates)
  return new Date(latestTimestamp)
}

module.exports = max


/***/ }),
/* 1609 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Common Helpers
 * @summary Return the earliest of the given dates.
 *
 * @description
 * Return the earliest of the given dates.
 *
 * @param {...(Date|String|Number)} dates - the dates to compare
 * @returns {Date} the earliest of the dates
 *
 * @example
 * // Which of these dates is the earliest?
 * var result = min(
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * )
 * //=> Wed Feb 11 1987 00:00:00
 */
function min () {
  var dirtyDates = Array.prototype.slice.call(arguments)
  var dates = dirtyDates.map(function (dirtyDate) {
    return parse(dirtyDate)
  })
  var earliestTimestamp = Math.min.apply(null, dates)
  return new Date(earliestTimestamp)
}

module.exports = min


/***/ }),
/* 1610 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Day Helpers
 * @summary Set the day of the month to the given date.
 *
 * @description
 * Set the day of the month to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfMonth - the day of the month of the new date
 * @returns {Date} the new date with the day of the month setted
 *
 * @example
 * // Set the 30th day of the month to 1 September 2014:
 * var result = setDate(new Date(2014, 8, 1), 30)
 * //=> Tue Sep 30 2014 00:00:00
 */
function setDate (dirtyDate, dirtyDayOfMonth) {
  var date = parse(dirtyDate)
  var dayOfMonth = Number(dirtyDayOfMonth)
  date.setDate(dayOfMonth)
  return date
}

module.exports = setDate


/***/ }),
/* 1611 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var addDays = __webpack_require__(246)

/**
 * @category Weekday Helpers
 * @summary Set the day of the week to the given date.
 *
 * @description
 * Set the day of the week to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the week of the new date
 * @param {Object} [options] - the object with options
 * @param {Number} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the new date with the day of the week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0)
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If week starts with Monday, set Sunday to 1 September 2014:
 * var result = setDay(new Date(2014, 8, 1), 0, {weekStartsOn: 1})
 * //=> Sun Sep 07 2014 00:00:00
 */
function setDay (dirtyDate, dirtyDay, dirtyOptions) {
  var weekStartsOn = dirtyOptions ? (Number(dirtyOptions.weekStartsOn) || 0) : 0
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = date.getDay()

  var remainder = day % 7
  var dayIndex = (remainder + 7) % 7

  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay
  return addDays(date, diff)
}

module.exports = setDay


/***/ }),
/* 1612 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Day Helpers
 * @summary Set the day of the year to the given date.
 *
 * @description
 * Set the day of the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} dayOfYear - the day of the year of the new date
 * @returns {Date} the new date with the day of the year setted
 *
 * @example
 * // Set the 2nd day of the year to 2 July 2014:
 * var result = setDayOfYear(new Date(2014, 6, 2), 2)
 * //=> Thu Jan 02 2014 00:00:00
 */
function setDayOfYear (dirtyDate, dirtyDayOfYear) {
  var date = parse(dirtyDate)
  var dayOfYear = Number(dirtyDayOfYear)
  date.setMonth(0)
  date.setDate(dayOfYear)
  return date
}

module.exports = setDayOfYear


/***/ }),
/* 1613 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours setted
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * var result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours (dirtyDate, dirtyHours) {
  var date = parse(dirtyDate)
  var hours = Number(dirtyHours)
  date.setHours(hours)
  return date
}

module.exports = setHours


/***/ }),
/* 1614 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var addDays = __webpack_require__(246)
var getISODay = __webpack_require__(714)

/**
 * @category Weekday Helpers
 * @summary Set the day of the ISO week to the given date.
 *
 * @description
 * Set the day of the ISO week to the given date.
 * ISO week starts with Monday.
 * 7 is the index of Sunday, 1 is the index of Monday etc.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} day - the day of the ISO week of the new date
 * @returns {Date} the new date with the day of the ISO week setted
 *
 * @example
 * // Set Sunday to 1 September 2014:
 * var result = setISODay(new Date(2014, 8, 1), 7)
 * //=> Sun Sep 07 2014 00:00:00
 */
function setISODay (dirtyDate, dirtyDay) {
  var date = parse(dirtyDate)
  var day = Number(dirtyDay)
  var currentDay = getISODay(date)
  var diff = day - currentDay
  return addDays(date, diff)
}

module.exports = setISODay


/***/ }),
/* 1615 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var getISOWeek = __webpack_require__(463)

/**
 * @category ISO Week Helpers
 * @summary Set the ISO week to the given date.
 *
 * @description
 * Set the ISO week to the given date, saving the weekday number.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} isoWeek - the ISO week of the new date
 * @returns {Date} the new date with the ISO week setted
 *
 * @example
 * // Set the 53rd ISO week to 7 August 2004:
 * var result = setISOWeek(new Date(2004, 7, 7), 53)
 * //=> Sat Jan 01 2005 00:00:00
 */
function setISOWeek (dirtyDate, dirtyISOWeek) {
  var date = parse(dirtyDate)
  var isoWeek = Number(dirtyISOWeek)
  var diff = getISOWeek(date) - isoWeek
  date.setDate(date.getDate() - diff * 7)
  return date
}

module.exports = setISOWeek


/***/ }),
/* 1616 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Millisecond Helpers
 * @summary Set the milliseconds to the given date.
 *
 * @description
 * Set the milliseconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} milliseconds - the milliseconds of the new date
 * @returns {Date} the new date with the milliseconds setted
 *
 * @example
 * // Set 300 milliseconds to 1 September 2014 11:30:40.500:
 * var result = setMilliseconds(new Date(2014, 8, 1, 11, 30, 40, 500), 300)
 * //=> Mon Sep 01 2014 11:30:40.300
 */
function setMilliseconds (dirtyDate, dirtyMilliseconds) {
  var date = parse(dirtyDate)
  var milliseconds = Number(dirtyMilliseconds)
  date.setMilliseconds(milliseconds)
  return date
}

module.exports = setMilliseconds


/***/ }),
/* 1617 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes setted
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * var result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes (dirtyDate, dirtyMinutes) {
  var date = parse(dirtyDate)
  var minutes = Number(dirtyMinutes)
  date.setMinutes(minutes)
  return date
}

module.exports = setMinutes


/***/ }),
/* 1618 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)
var setMonth = __webpack_require__(728)

/**
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter setted
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * var result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter (dirtyDate, dirtyQuarter) {
  var date = parse(dirtyDate)
  var quarter = Number(dirtyQuarter)
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1
  var diff = quarter - oldQuarter
  return setMonth(date, date.getMonth() + diff * 3)
}

module.exports = setQuarter


/***/ }),
/* 1619 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds setted
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * var result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds (dirtyDate, dirtySeconds) {
  var date = parse(dirtyDate)
  var seconds = Number(dirtySeconds)
  date.setSeconds(seconds)
  return date
}

module.exports = setSeconds


/***/ }),
/* 1620 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year setted
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * var result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear (dirtyDate, dirtyYear) {
  var date = parse(dirtyDate)
  var year = Number(dirtyYear)
  date.setFullYear(year)
  return date
}

module.exports = setYear


/***/ }),
/* 1621 */
/***/ (function(module, exports, __webpack_require__) {

var parse = __webpack_require__(5)

/**
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|String|Number} date - the original date
 * @returns {Date} the start of a month
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * var result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth (dirtyDate) {
  var date = parse(dirtyDate)
  date.setDate(1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfMonth


/***/ }),
/* 1622 */
/***/ (function(module, exports, __webpack_require__) {

var startOfDay = __webpack_require__(177)

/**
 * @category Day Helpers
 * @summary Return the start of today.
 *
 * @description
 * Return the start of today.
 *
 * @returns {Date} the start of today
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfToday()
 * //=> Mon Oct 6 2014 00:00:00
 */
function startOfToday () {
  return startOfDay(new Date())
}

module.exports = startOfToday


/***/ }),
/* 1623 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of tomorrow.
 *
 * @description
 * Return the start of tomorrow.
 *
 * @returns {Date} the start of tomorrow
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfTomorrow()
 * //=> Tue Oct 7 2014 00:00:00
 */
function startOfTomorrow () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day + 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfTomorrow


/***/ }),
/* 1624 */
/***/ (function(module, exports) {

/**
 * @category Day Helpers
 * @summary Return the start of yesterday.
 *
 * @description
 * Return the start of yesterday.
 *
 * @returns {Date} the start of yesterday
 *
 * @example
 * // If today is 6 October 2014:
 * var result = startOfYesterday()
 * //=> Sun Oct 5 2014 00:00:00
 */
function startOfYesterday () {
  var now = new Date()
  var year = now.getFullYear()
  var month = now.getMonth()
  var day = now.getDate()

  var date = new Date(0)
  date.setFullYear(year, month, day - 1)
  date.setHours(0, 0, 0, 0)
  return date
}

module.exports = startOfYesterday


/***/ }),
/* 1625 */
/***/ (function(module, exports, __webpack_require__) {

var addDays = __webpack_require__(246)

/**
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted
 * @returns {Date} the new date with the days subtracted
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * var result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addDays(dirtyDate, -amount)
}

module.exports = subDays


/***/ }),
/* 1626 */
/***/ (function(module, exports, __webpack_require__) {

var addHours = __webpack_require__(700)

/**
 * @category Hour Helpers
 * @summary Subtract the specified number of hours from the given date.
 *
 * @description
 * Subtract the specified number of hours from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be subtracted
 * @returns {Date} the new date with the hours subtracted
 *
 * @example
 * // Subtract 2 hours from 11 July 2014 01:00:00:
 * var result = subHours(new Date(2014, 6, 11, 1, 0), 2)
 * //=> Thu Jul 10 2014 23:00:00
 */
function subHours (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addHours(dirtyDate, -amount)
}

module.exports = subHours


/***/ }),
/* 1627 */
/***/ (function(module, exports, __webpack_require__) {

var addMilliseconds = __webpack_require__(247)

/**
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted
 * @returns {Date} the new date with the milliseconds subtracted
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * var result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMilliseconds(dirtyDate, -amount)
}

module.exports = subMilliseconds


/***/ }),
/* 1628 */
/***/ (function(module, exports, __webpack_require__) {

var addMinutes = __webpack_require__(702)

/**
 * @category Minute Helpers
 * @summary Subtract the specified number of minutes from the given date.
 *
 * @description
 * Subtract the specified number of minutes from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be subtracted
 * @returns {Date} the new date with the mintues subtracted
 *
 * @example
 * // Subtract 30 minutes from 10 July 2014 12:00:00:
 * var result = subMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 11:30:00
 */
function subMinutes (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMinutes(dirtyDate, -amount)
}

module.exports = subMinutes


/***/ }),
/* 1629 */
/***/ (function(module, exports, __webpack_require__) {

var addMonths = __webpack_require__(323)

/**
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted
 * @returns {Date} the new date with the months subtracted
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * var result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addMonths(dirtyDate, -amount)
}

module.exports = subMonths


/***/ }),
/* 1630 */
/***/ (function(module, exports, __webpack_require__) {

var addQuarters = __webpack_require__(703)

/**
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted
 * @returns {Date} the new date with the quarters subtracted
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * var result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addQuarters(dirtyDate, -amount)
}

module.exports = subQuarters


/***/ }),
/* 1631 */
/***/ (function(module, exports, __webpack_require__) {

var addSeconds = __webpack_require__(704)

/**
 * @category Second Helpers
 * @summary Subtract the specified number of seconds from the given date.
 *
 * @description
 * Subtract the specified number of seconds from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of seconds to be subtracted
 * @returns {Date} the new date with the seconds subtracted
 *
 * @example
 * // Subtract 30 seconds from 10 July 2014 12:45:00:
 * var result = subSeconds(new Date(2014, 6, 10, 12, 45, 0), 30)
 * //=> Thu Jul 10 2014 12:44:30
 */
function subSeconds (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addSeconds(dirtyDate, -amount)
}

module.exports = subSeconds


/***/ }),
/* 1632 */
/***/ (function(module, exports, __webpack_require__) {

var addWeeks = __webpack_require__(457)

/**
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted
 * @returns {Date} the new date with the weeks subtracted
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * var result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addWeeks(dirtyDate, -amount)
}

module.exports = subWeeks


/***/ }),
/* 1633 */
/***/ (function(module, exports, __webpack_require__) {

var addYears = __webpack_require__(705)

/**
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|String|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted
 * @returns {Date} the new date with the years subtracted
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * var result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears (dirtyDate, dirtyAmount) {
  var amount = Number(dirtyAmount)
  return addYears(dirtyDate, -amount)
}

module.exports = subYears


/***/ }),
/* 1634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _lodash = __webpack_require__(9);

var _lodash2 = _interopRequireDefault(_lodash);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = __webpack_require__(73);

var _moment2 = _interopRequireDefault(_moment);

var _rpMqBreakpoints = __webpack_require__(66);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * RP1 Date Picker jQuery plugin
 *
 * @author Roman Kelemen <roman.kelemen@racingpost.com>
 */
(function ($, moment, _, breakpoints) {
    'use strict';

    /**
     * Default configuration options
     * @type {Object}
     */

    var defaults = {
        date: null,
        minDate: null,
        maxDate: null,
        monthPickerAutoClose: false,
        monthAutoPick: false,
        initFromMonthPicker: false,
        weekStart: 1,
        autoOpen: false,
        autoClose: false,
        track: false,
        template: '',
        zIndex: 1000,
        container: null,
        placement: 'body',
        triggers: {
            today: 'ui-datePicker__calendar__btnToday',
            date: 'ui-datePicker__item_day',
            month: 'ui-datePicker__item_month',
            year: 'ui-datePicker__item_year',
            nextMonth: 'ui-datePicker__stepSelect__right',
            prevMonth: 'ui-datePicker__stepSelect__left',
            nextYears: 'ui-datePicker__stepper__right',
            prevYears: 'ui-datePicker__stepper__left',
            pickMonth: 'ui-datePicker__stepSelect__central',
            pickDate: 'ui-datePicker__backBlock',
            selectMonth: 'ui-datePicker__backSection__btnSelect',
            close: 'ui-datePicker__closeBlock'
        },
        css: {
            picker: 'ui-datePicker',
            pickerInline: 'ui-datePicker_inline',
            pointer: 'ui-datePicker__pointer',
            pointerInvert: 'ui-datePicker__pointer_top',
            datePicker: 'ui-datePicker__frontSection',
            monthPicker: 'ui-datePicker__backSection',
            dateDisabled: 'ui-datePicker__item_disabled',
            dateSelected: 'ui-datePicker__item_active',
            datePast: 'ui-datePicker__item_inactive',
            dateFuture: 'ui-datePicker__item_inactive',
            stepDisabled: 'ui-btn_secondary--disabled',
            monthSelected: 'ui-datePicker__item_active',
            monthDisabled: 'ui-datePicker__item_disabled',
            yearSelected: 'ui-datePicker__item_active',
            yearDisabled: 'ui-datePicker__item_disabled'
        },
        position: {
            my: 'center top+8',
            at: 'center bottom',
            collision: 'flipfit'
        },
        pointerPosition: {
            my: 'center-12 top',
            at: 'center bottom'
        }
    };

    /**
     * Default template
     *
     * @type {string}
     */
    var template = '\
        <div class="ui-datePicker__pointer"></div>\
        <div class="ui-datePicker__closeBlock ui-btn ui-btn_tiertiary">\
            <svg class="ui-datePicker__close ui-icon ui-icon_sizeMedium">\
                <use xlink:href="img/icons.svg#icon-cross"/>\
            </svg>\
        </div>\
        <div class="ui-datePicker__frontSection">\
            <div class="ui-datePicker__header ui-datePicker__header_calendar">\
                <span class="ui-datePicker__caption">Select Date</span>\
            </div>\
            <div class="ui-datePicker__calendar">\
                <div class="ui-datePicker__stepSelect ui-btnGroup">\
                    <a href="#" class="ui-datePicker__stepSelect__left ui-btn ui-btn_tiertiary" data-test-selector="button-calendarMonthLeft">\
                        <svg class="ui-icon ui-icon_sizeMedium">\
                            <use xlink:href="img/icons.svg#icon-left"/>\
                        </svg>\
                    </a>\
                    <a href="#" class="ui-datePicker__stepSelect__central ui-btn ui-btn_tiertiary" data-test-selector="link-calendarGoToMonthYear" >\
                        <span><%=viewDate.format("MMMM YYYY") %></span>\
                        <svg class="ui-icon ui-icon_sizeMedium ui-datePicker__centralIcon">\
                            <use xlink:href="img/icons.svg#icon-down"/>\
                        </svg>\
                    </a>\
                    <a href="#" class="ui-datePicker__stepSelect__right ui-btn ui-btn_tiertiary" data-test-selector="button-calendarMonthRight">\
                        <svg class="ui-icon ui-icon_sizeMedium">\
                            <use xlink:href="img/icons.svg#icon-right"/>\
                        </svg>\
                    </a>\
                </div>\
                <div class="ui-datePicker__calendar__footer">\
                    <div class="ui-datePicker__calendar__btnToday ui-btn ui-btn_primary" data-test-selector="link-calendarToday">Today</div>\
                </div>\
                <table class="ui-datePicker__calendar__block">\
                    <thead>\
                        <tr>\
                            <% for(var i = 0; i < week.length; i++) { %>\
                            <td class="ui-datePicker__calendar__cell"><%=week[i] %></td>\
                            <% } %>\
                        </tr>\
                    </thead>\
                    <tbody class="ui-datePicker__calendar__body">\
                        <% for(var i = 0; i < dates.length; i++) { %>\
                        <tr class="ui-datePicker__row">\
                            <% for(var j = 0; j < 7; j++) { %>\
                            <td class="ui-datePicker__cell">\
                                <a href="#" class="ui-datePicker__item ui-datePicker__item_day <%=dates[i][j].classes.join(" ") %>" data-date="<%=dates[i][j].data %>" data-test-selector="link-calendarDate"><%=dates[i][j].label %></a>\
                            </td>\
                            <% } %>\
                        </tr>\
                        <% } %>\
                    </tbody>\
                </table>\
            </div>\
        </div>\
        <div class="ui-datePicker__backSection">\
            <div class="ui-datePicker__header">\
                <div class="ui-datePicker__backBlock ui-btn ui-btn_tiertiary">\
                    <svg class="ui-datePicker__back ui-icon ui-icon_sizeMedium">\
                        <use xlink:href="img/icons.svg#icon-left"/>\
                    </svg>\
                </div>\
                <span class="ui-datePicker__caption">Choose Month</span>\
            </div>\
            <div class="ui-datePicker__months">\
                <table class="ui-datePicker__months__block">\
                    <% for(var i = 0; i < 2; i++) { %>\
                    <tr class="ui-datePicker__row">\
                        <% for(var j = 0; j < 6; j++) { %>\
                        <td class="ui-datePicker__cell ui-datePicker__months__cell">\
                            <a href="#" class="ui-datePicker__item ui-datePicker__item_month <%= months[i][j].classes.join(" ") %>" data-month="<%= months[i][j].data %>" data-test-selector="link-calendarMonthSelect"><%= months[i][j].label %></a>\
                        </td>\
                        <% } %>\
                    </tr>\
                    <% } %>\
                </table>\
            </div>\
            <div class="ui-datePicker__header ui-datePicker__header_years">\
                <span class="ui-datePicker__caption">Choose Year</span>\
            </div>\
            <div class="ui-datePicker__years">\
                <table class="ui-datePicker__years__block">\
                    <% for(var i = 0; i < 2; i++) { %>\
                    <tr class="ui-datePicker__row">\
                    <% for(var j = 0; j < 3; j++) { %>\
                    <td class="ui-datePicker__cell ui-datePicker__years__cell">\
                    <a href="#" class="ui-datePicker__item ui-datePicker__item_year <%= years[i][j].classes.join(" ") %>" data-year="<%= years[i][j].data %>" data-test-selector="link-calendarYearSelect"><%= years[i][j].label %></a>\
                    </td>\
                    <% } %>\
                    </tr>\
                    <% } %>\
                </table>\
                <div class="ui-datePicker__years__footer">\
                    <div class="ui-datePicker__stepper ui-btnGroup">\
                        <a href="#" class="ui-datePicker__stepper__left ui-btn ui-btn_secondary" data-test-selector="button-calendarYearMonthLeft">\
                            <svg class="ui-icon ui-icon_sizeMedium">\
                                <use xlink:href="img/icons.svg#icon-left"/>\
                            </svg>\
                        </a>\
                        <a href="#" class="ui-datePicker__stepper__right ui-btn ui-btn_secondary" data-test-selector="button-calendarYearMonthRight">\
                            <svg class="ui-icon ui-icon_sizeMedium">\
                                <use xlink:href="img/icons.svg#icon-right"/>\
                            </svg>\
                        </a>\
                    </div>\
                    <div class="ui-datePicker__backSection__btnSelect ui-btn ui-btn_primary" data-test-selector="link-calendarYearMonthSelect">Select</div>\
                </div>\
            </div>\
        </div>';

    /**
     * Plugin name
     *
     * @type {string}
     */
    var pluginName = 'datePicker';

    /**
     * Plugin constructor
     *
     * @param {HTMLElement|jQuery} element Bound element
     * @param {Object} options Instance configuration
     *
     * @constructor
     */
    function DatePicker(element, options) {
        this.element = $(element);
        this.options = $.extend(true, {}, defaults, options);
        this.options.css = $.extend({}, defaults.css, $.fn[pluginName].css, options ? options.css : {});
        this.options.triggers = $.extend({}, defaults.triggers, $.fn[pluginName].triggers, options ? options.triggers : {});

        this._container = null;
        if (this.options.container) {
            this._container = $(this.options.container);
        }

        this._minDate = null;
        if (this.options.minDate) {
            this._minDate = moment(this.options.minDate).startOf('day');
        }

        this._maxDate = null;
        if (this.options.maxDate) {
            var maxDate = moment(this.options.maxDate);
            if (!this._minDate || maxDate.subtract(1, 'day').isAfter(this._minDate)) {
                this._maxDate = moment(this.options.maxDate).endOf('day');
            }
        }

        this._date = null;
        if (this.options.date && this.isValid(this.options.date)) {
            this._date = moment(this.options.date);
        }

        if (this._date) {
            this.currentDate(this._date, true);
        } else {
            this.currentDate(moment(), true);
        }

        this._monthPicker = this.options.initFromMonthPicker === true;
        this._monthPickerDate = this.currentDate();
        this._yearsPage = undefined;

        this.saveState();

        this.picker = $('<div class="' + this.options.css.picker + '"></div>');
        this.picker.hide().css('z-index', this.options.zIndex);

        if (this._container) {
            this.picker.addClass(this.options.css.pickerInline);
            this.picker.appendTo(this._container);
        } else {
            this.picker.appendTo(this.options.placement);
        }

        this.breakpoints = breakpoints;
        this.breakpoint = this.breakpoints.current();

        this.init();
    }

    /**
     * Save datepicker state
     */
    DatePicker.prototype.saveState = function () {
        this._initial = {
            date: this.date(),
            current: this.currentDate(),
            minDate: this.minDate(),
            maxDate: this.maxDate()
        };
    };

    /**
     * Reset to initial state
     */
    DatePicker.prototype.restoreState = function () {
        this._minDate = this._initial.minDate;
        this._maxDate = this._initial.maxDate;
        this._currentDate = this._initial.current;
        this._date = this._initial.date;

        this.element.trigger('restoreState.rp.datePicker');
        this.render(true);
    };

    /**
     * Initialise basic functionality
     */
    DatePicker.prototype.init = function () {
        this.bindEvents();
        this.render();
        if (this.options.autoOpen) {
            this.show();
        }
    };

    /**
     * Destroy plugin instance. Unbind events, remove DOM
     */
    DatePicker.prototype.destroy = function () {
        this.picker.remove();
        this.element.off('.rp.datePicker');
        $('body').off('.rp.datePicker');
        $.data(this.element, pluginName, null);
    };

    /**
     * Get or set minimum date
     *
     * @param {Moment|String=} minDate Optionally, set minimum date.
     * @returns {Moment|null|void} If argument ommited, returns current minimum date
     */
    DatePicker.prototype.minDate = function (minDate) {
        if (minDate === undefined) {
            return this._minDate ? moment(this._minDate) : null;
        }

        minDate = moment(minDate);
        if (!minDate.isAfter(moment(this._maxDate), 'day')) {
            this._minDate = minDate.startOf('day');
            if (!this.isValid(this._date)) {
                this.reset();
            }
            this.render(true);
        }
    };

    /**
     * Get or set maximum date
     *
     * @param {Moment|String=} maxDate Optionally, set maximum date.
     * @returns {Moment|null|void} If argument ommited, returns current maximum date
     */
    DatePicker.prototype.maxDate = function (maxDate) {
        if (maxDate === undefined) {
            return this._maxDate ? moment(this._maxDate) : null;
        }

        maxDate = moment(maxDate);
        if (!maxDate.isBefore(moment(this._minDate), 'day')) {
            this._maxDate = maxDate.endOf('day');
            if (!this.isValid(this._date)) {
                this.reset();
            }
            this.render(true);
        }
    };

    /**
     * Checks, if given date is valid
     *
     * @param {Moment|String} date Date to check
     * @returns {boolean} TRUE if date is valid, FALSE otherwise
     */
    DatePicker.prototype.isValid = function (date) {
        var check = moment(date);

        if (this._minDate && this._maxDate) {
            return this._minDate <= check && this._maxDate >= check;
        } else if (this._maxDate) {
            return this._maxDate >= check;
        } else if (this._minDate) {
            return this._minDate <= check;
        }

        return true;
    };

    /**
     * Bind handlers to handle required events
     */
    DatePicker.prototype.bindEvents = function () {
        this.picker.on('click', '.' + this.options.triggers.today, { context: this }, this.today);
        this.picker.on('click', '.' + this.options.triggers.date + ':not(.disabled)', { context: this }, this.date);
        this.picker.on('click', '.' + this.options.triggers.month, { context: this }, this.month);
        this.picker.on('click', '.' + this.options.triggers.year, { context: this }, this.year);
        this.picker.on('click', '.' + this.options.triggers.nextMonth + ':not(.disabled)', { context: this }, this.nextMonth);
        this.picker.on('click', '.' + this.options.triggers.prevMonth + ':not(.disabled)', { context: this }, this.prevMonth);
        this.picker.on('click', '.' + this.options.triggers.nextYears, { context: this }, this.nextYears);
        this.picker.on('click', '.' + this.options.triggers.prevYears, { context: this }, this.prevYears);
        this.picker.on('click', '.' + this.options.triggers.pickMonth, { context: this }, this.pickMonth);
        this.picker.on('click', '.' + this.options.triggers.pickDate, { context: this }, this.pickDate);
        this.picker.on('click', '.' + this.options.triggers.selectMonth, { context: this }, this.selectMonth);
        this.picker.on('click', '.' + this.options.triggers.close, { context: this }, this.hide);

        this.element.on('click.rp.datePicker', { context: this }, this.toggle);

        $(window).on('resize.rp.datePicker', this._onWindowResize());
        $(window).on('scroll.rp.datePicker', _lodash2.default.throttle(this.position.bind(this), 50));
        $(window).on('rpBreakpointsSwitch', this._onBreakpoint());
        $('body').on('click', { context: this }, function (event) {
            var skip = event.originalEvent && event.originalEvent.keepShown === event.data.context || $(event.target).is(event.data.context.element) || $.contains(event.data.context.picker[0], event.target) || $.contains(event.data.context.element[0], event.target);
            if (skip) {
                return;
            }

            event.data.context.hide();
        });
    };

    /**
     * Open picker if it is hidden, or hide it, if it is opened
     * If called as event handler, event object passed as first argument.
     *
     * @param {Event=} event Optionally, Event object
     */
    DatePicker.prototype.toggle = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.data.context.toggle();
            return;
        }

        if (this.picker.is(':visible')) {
            this.hide();
        } else {
            this.show();
        }
    };

    /**
     * Open picker
     */
    DatePicker.prototype.show = function () {
        var event = $.Event('show.rp.datePicker');
        this.element.trigger(event);
        if (!event.isDefaultPrevented()) {
            if (this._container && !this._container.is(this.picker.parent())) {
                this._container.append(this.picker);
            }

            this.picker.show();
            this.position();
            this.element.trigger('shown.rp.datePicker');
        }
    };

    /**
     * Hide picker
     * If called as event handler, event object passed as first argument.
     *
     * @param {Event=} event Optionally, event object
     */
    DatePicker.prototype.hide = function (event) {
        if (event && event.preventDefault) {
            if ($(event.data.context.picker).is(':visible') && !event.data.context._container) {
                event.preventDefault();
                event.data.context.hide();
            }

            return;
        }

        event = $.Event('hide.rp.datePicker');
        this.element.trigger(event);
        if (!event.isDefaultPrevented() && this.picker.is(':visible')) {
            this.picker.hide();
            this.element.trigger('hidden.rp.datePicker');
        }
    };

    /**
     * Set selected and view date to today
     * If called as event handler, event object passed as first argument.
     *
     * @param event Optionally, event object
     */
    DatePicker.prototype.today = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.today();
            return;
        }

        var today = moment();

        this.currentDate(today);
        this.date(today, this.options.autoClose);
    };

    /**
     * Get or set selected date
     *
     * @param {Moment|String|null|Event=} date Optionally. If called as event, this is event object.
     * If called directly, this param should contain date to select
     * @param {Boolean=} close Optionally. Close auto picker after success change
     *
     * @return {Moment|void} If called without parameters, method will return currently selected date
     */
    DatePicker.prototype.date = function (date, close) {
        if (date === undefined) {
            return this._date ? moment(this._date) : null;
        }

        if (date.data && date.data.context) {
            date.preventDefault();
            date.originalEvent.keepShown = date.data.context;
            date.data.context.date($(this).data('date'), date.data.context.options.autoClose);
            return;
        }

        if (this.isValid(date)) {
            var oldDate = this.date(),
                newDate = moment(date),
                event = $.Event('change.rp.datePicker');

            this.element.trigger(event, [newDate, oldDate]);

            if (!event.isDefaultPrevented()) {
                this._date = moment(date);
                this._currentDate = moment(this._date);

                if (close) {
                    this.hide();
                }

                this.render();
            }
        }
    };

    /**
     * Deselect selected date
     */
    DatePicker.prototype.reset = function () {
        var oldDate = this.date();
        this._date = null;
        this.element.trigger('reset.rp.datePicker', [oldDate]);

        this.render();
    };

    /**
     * Set current (view) date
     *
     * @param {Moment|String=} date Date to view
     * @param {Boolean=} noRender Optionally, picker after changing view date. Default is false, that means that
     * picker will be re-rendered automatically
     */
    DatePicker.prototype.currentDate = function (date, noRender) {
        if (!date) {
            return moment(this._currentDate);
        } else {
            date = moment(date);

            if (this._minDate) {
                date = moment.max(date, this._minDate);
            }

            if (this._maxDate) {
                date = moment.min(date, this._maxDate);
            }

            this._yearsPage = undefined;
            this._currentDate = date;
            if (!noRender) {
                this.render();
            }
        }
    };

    /**
     * Get or set view month
     *
     * @param {Moment|String|Event=} month Optionally. If called as event, this is event object.
     * If called directly, this param should contain zero-based index of month to view
     *
     * @return {Number|void} If called without parameters, method will return current view month as zero-based number
     */
    DatePicker.prototype.month = function (month) {
        if (month === undefined) {
            return this._currentDate.month();
        }

        if (month.data && month.data.context) {
            month.preventDefault();
            month.data.context.month($(this).data('month'));
            month.originalEvent.keepShown = month.data.context;
            return;
        }

        var currentDate = moment(this._currentDate).month(month);
        this.currentDate(currentDate, true);
        if (this.options.monthPickerAutoClose) {
            this.pickDate();
        }

        this.render();
    };

    /**
     * Get or set view year
     *
     * @param {Moment|String|Event=} year Optionally. If called as event, this is event object.
     * If called directly, this param should contain view year
     *
     * @return {Number|void} If called without parameters, method will return current view year
     */
    DatePicker.prototype.year = function (year) {
        if (year === undefined) {
            return this._currentDate.year();
        }

        if (year.data && year.data.context) {
            year.preventDefault();
            year.data.context.year($(this).data('year'));
            year.originalEvent.keepShown = year.data.context;
            return;
        }

        var currentDate = moment(this._currentDate).year(year);
        this.currentDate(currentDate, true);
        if (this.options.monthPickerAutoClose) {
            this.pickDate();
        }

        this.render();
    };

    /**
     * Go to next years page
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.nextYears = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.nextYears();
            return;
        }

        if (this._maxDate && this._yearsPage >= this._getYearPage(this._maxDate.year())) {
            this._yearsPage = this._getYearPage(this._maxDate.year());
        } else {
            this._yearsPage++;
        }

        this.render();
    };

    /**
     * Go to previous years page
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.prevYears = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.prevYears();
            return;
        }

        if (this._minDate && this._yearsPage <= this._getYearPage(this._minDate.year())) {
            this._yearsPage = this._getYearPage(this._minDate.year());
        } else {
            this._yearsPage--;
        }

        this.render();
    };

    /**
     * Go to next month view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.nextMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.nextMonth();
            return;
        }

        this.currentDate(this.currentDate().add(1, 'month'));
    };

    /**
     * Go to previous month view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.prevMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.prevMonth();
            return;
        }

        this.currentDate(this.currentDate().subtract(1, 'month'));
    };

    /**
     * Open month picker view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.pickMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.pickMonth();
            return;
        }

        this._yearsPage = undefined;
        this._monthPicker = true;
        this._monthPickerDate = this.currentDate();
        this.render();
    };

    /**
     * Open date picker view
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.pickDate = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.pickDate();
            return;
        }

        this._monthPicker = false;
        if (!this.options.monthPickerAutoClose && !this.options.monthAutoPick) {
            this.currentDate(this._monthPickerDate);
        }

        this.render();
    };

    /**
     * Select month and close month picker
     *
     * @param {Event=} event If called as event handler, event object passed as first argument
     */
    DatePicker.prototype.selectMonth = function (event) {
        if (event && event.preventDefault) {
            event.preventDefault();
            event.originalEvent.keepShown = event.data.context;
            event.data.context.selectMonth();
            return;
        }

        this._monthPicker = false;
        this.render();
    };

    /**
     * Render date picker
     * @param {Boolean=} force Optionally, force render
     */
    DatePicker.prototype.render = function (force) {
        var self = this;
        var tpl = this.options.template ? this.options.template : $.fn[pluginName].template ? $.fn[pluginName].template : template;

        var compiled = _.template(tpl),
            renderHtml = function renderHtml() {
            self.picker.html(compiled({
                dates: self.buildDates(),
                months: self.buildMonths(),
                years: self.buildYears(),
                week: self.buildWeek(),
                viewDate: self.currentDate()
            }));

            self.picker.data('currentDate', self.currentDate());
            self.picker.data('yearsPage', self._yearsPage);

            self.position();
        },
            updateMonthView = function updateMonthView() {
            var datePicker, monthPicker;

            datePicker = self.picker.find('.' + self.options.css.datePicker);
            monthPicker = self.picker.find('.' + self.options.css.monthPicker);
            if (self._monthPicker) {
                monthPicker.show();
                datePicker.hide();
            } else {
                monthPicker.hide();
                datePicker.show();
            }
        },
            updateMonthStep = function updateMonthStep() {
            if (!self.isValid(self.currentDate().add(1, 'month').startOf('month'))) {
                self.picker.find('.' + self.options.triggers.nextMonth).addClass(self.options.css.stepDisabled);
            }

            if (!self.isValid(self.currentDate().subtract(1, 'month').endOf('month'))) {
                self.picker.find('.' + self.options.triggers.prevMonth).addClass(self.options.css.stepDisabled);
            }
        },
            updateYearStep = function updateYearStep() {
            var prevYears = self.picker.find('.' + self.options.triggers.prevYears),
                nextYears = self.picker.find('.' + self.options.triggers.nextYears);

            prevYears.removeClass(self.options.css.stepDisabled);
            nextYears.removeClass(self.options.css.stepDisabled);

            if (self._minDate && self._yearsPage <= self._getYearPage(self._minDate.year())) {
                self._yearsPage = self._getYearPage(self._minDate.year());
                prevYears.addClass(self.options.css.stepDisabled);
            }

            if (self._maxDate && self._yearsPage >= self._getYearPage(self._maxDate.year())) {
                self._yearsPage = self._getYearPage(self._maxDate.year());
                nextYears.addClass(self.options.css.stepDisabled);
            }
        };

        renderHtml();
        updateMonthView();
        updateMonthStep();
        updateYearStep();
    };

    /**
     * Build months matrix
     * @returns {Array} Matrix of months
     */
    DatePicker.prototype.buildMonths = function () {
        var months = moment.monthsShort(),
            selectedMonth = this.currentDate().format('MMM'),
            rows = [],
            row,
            month;

        for (var i = 0; i < 2; i++) {
            row = [];
            for (var j = 0; j < 6; j++) {
                var key = 6 * i + j;
                month = {
                    data: key,
                    label: months[key],
                    classes: []
                };
                var check = this.currentDate().month(key);

                if (this._minDate && this._minDate.isAfter(check, 'month')) {
                    month.classes.push(this.options.css.monthDisabled);
                } else if (this._maxDate && this._maxDate.isBefore(check, 'month')) {
                    month.classes.push(this.options.css.monthDisabled);
                } else if (months[key] == selectedMonth) {
                    month.classes.push(this.options.css.monthSelected);
                }

                row.push(month);
            }
            rows.push(row);
        }

        return rows;
    };

    /**
     * Build years matrix
     * @returns {Array} Matrix of years
     */
    DatePicker.prototype.buildYears = function () {
        var current = this.currentDate(),
            view = moment(),
            rows = [],
            offset,
            row;

        if (this._yearsPage === undefined) {
            this._yearsPage = this._getYearPage();
        }

        offset = this._yearsPage * 6 - 3;
        view.add(offset, 'year');
        for (var i = 0; i < 2; i++) {
            row = [];
            for (var j = 0; j < 3; j++) {
                var year = {
                    data: view.year(),
                    label: view.format('YYYY'),
                    classes: []
                };

                if (this._minDate && this._minDate.year() > view.year()) {
                    year.classes.push(this.options.css.yearDisabled);
                } else if (this._maxDate && this._maxDate.year() < view.year()) {
                    year.classes.push(this.options.css.yearDisabled);
                } else if (view.year() == current.year()) {
                    year.classes.push(this.options.css.yearSelected);
                }

                row.push(year);
                view.add(1, 'year');
            }

            rows.push(row);
        }

        return rows;
    };

    /**
     * Calculate years page
     *
     * @returns {Number} page of current viewed year
     */
    DatePicker.prototype._getYearPage = function (year) {
        year = year ? year : this.currentDate().year();

        var diff = year - moment().year() - 2;
        return Math.ceil(diff / 6);
    };

    /**
     * Build days matrix
     * @returns {Array} Matrix of years
     */
    DatePicker.prototype.buildDates = function () {
        var css = this.options.css,
            current = this.currentDate(),
            origin = this.currentDate(),
            selected = this.date(),
            days = current.daysInMonth(),
            offset = current.startOf('month').day() - this.options.weekStart,
            rows,
            dates,
            date;

        offset = offset < 0 ? 6 : offset;

        current.subtract(offset, 'days');
        rows = [];
        for (var i = 0, lines = Math.ceil((days + offset) / 7); i < lines; i++) {
            dates = [];
            for (var j = 0; j < 7; j++) {
                date = {
                    data: current.format('YYYY-MM-DD'),
                    label: current.format('D'),
                    moment: moment(current),
                    classes: []
                };

                if (!this.isValid(current)) {
                    date.classes.push(css.dateDisabled);
                } else if (current.isSame(selected, 'day')) {
                    date.classes.push(css.dateSelected);
                }

                if (i === 0 && j < offset) {
                    date.classes.push(css.datePast);
                } else if (current.month() != origin.month()) {
                    date.classes.push(css.dateFuture);
                }

                dates.push(date);
                current.add(1, 'days');
            }
            rows.push(dates);
        }

        return rows;
    };

    /**
     * Build week days array
     * @returns {Array} Array of week days abbreviations
     */
    DatePicker.prototype.buildWeek = function () {
        var weekDays = moment.weekdaysMin();
        if (this.options.weekStart) {
            weekDays = weekDays.concat(weekDays.splice(0, this.options.weekStart));
        }

        return weekDays;
    };

    /**
     * Place datePicker in configured position
     */
    DatePicker.prototype.position = function () {
        var position = this.options.position,
            track = this.options.track,
            scrollTop = window.pageYOffset || document.documentElement.scrollTop,
            pointerPosition = this.options.pointerPosition,
            pointer = this.picker.find('.' + this.options.css.pointer);

        if (!position.of) {
            position.of = this.element;
        }

        if (!pointerPosition.of) {
            pointerPosition.of = position.of;
        }

        var NARROW = _rpMqBreakpoints.breakpointCodes.NARROW,
            EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW;

        var wideScreen = [NARROW, EXTRA_NARROW].indexOf(this.breakpoint.code) === -1;

        if (wideScreen && !this._container) {
            this.picker.position(position);
            pointer.position(pointerPosition);
            pointer.css('top', 0);
            if (this.picker.offset().top < this.element.offset().top) {
                pointer.addClass(this.options.css.pointerInvert);
            } else {
                pointer.removeClass(this.options.css.pointerInvert);
            }
        } else {
            if (track) {
                this.picker.css('top', scrollTop).css('left', '');
            } else {
                this.picker.css('top', '').css('left', '');
            }
        }
    };

    /**
     * Change container of datepicker
     */
    DatePicker.prototype.container = function (selector) {
        if (!selector) {
            this._container = null;
            this.picker.removeClass(this.options.css.pickerInline);
            this.picker.appendTo(this.options.placement);
        } else {
            this._container = $(selector);
            this.picker.addClass(this.options.css.pickerInline);
            this.picker.appendTo(this._container);
        }

        this.position();
    };

    /**
     * Window resize event handler
     * Should perform repositioning of picker
     *
     * @returns {Function} Event handler
     * @private
     */
    DatePicker.prototype._onWindowResize = function () {
        var self = this,
            tm = null;

        return function () {
            clearTimeout(tm);

            tm = setTimeout(function () {
                self.position();
            }, 100);
        };
    };

    /**
     * Breakpoint change event
     * Should perform repositioning of picker
     *
     * @returns {Function} Event handler
     * @private
     */
    DatePicker.prototype._onBreakpoint = function () {
        var self = this;

        return function (event) {
            self.breakpoint = event.detail.breakpoint;
        };
    };

    /**
     * Register plugin function
     *
     * @param params
     * @returns {$.fn}
     */
    $.fn[pluginName] = function (params) {
        var args = Array.prototype.slice.call(arguments, 1);
        var getterResult;

        this.each(function () {
            var object = $.data(this, pluginName);
            if (!object) {
                $.data(this, pluginName, new DatePicker(this, params));
            } else if (params && params != '_' && object[params]) {
                getterResult = object[params].apply(object, args);
            } else {
                object.show();
            }
        });

        return getterResult !== undefined ? getterResult : this;
    };

    /**
     * Global CSS styles
     * @type {Object}
     */
    $.fn[pluginName].css = {};

    /**
     * Global triggers
     * @type {Object}
     */
    $.fn[pluginName].triggers = {};

    /**
     * Global template
     * @type {Object}
     */
    $.fn[pluginName].template = '';
})(_jquery2.default, _moment2.default, _lodash2.default, _rpMqBreakpoints2.default);

/***/ }),
/* 1635 */,
/* 1636 */
/***/ (function(module, exports, __webpack_require__) {

var pSlice = Array.prototype.slice;
var objectKeys = __webpack_require__(1638);
var isArguments = __webpack_require__(1637);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 1637 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 1638 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */,
/* 1669 */,
/* 1670 */,
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */,
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */,
/* 1792 */,
/* 1793 */,
/* 1794 */,
/* 1795 */,
/* 1796 */,
/* 1797 */,
/* 1798 */,
/* 1799 */,
/* 1800 */,
/* 1801 */,
/* 1802 */,
/* 1803 */,
/* 1804 */,
/* 1805 */,
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */,
/* 1811 */,
/* 1812 */,
/* 1813 */,
/* 1814 */,
/* 1815 */,
/* 1816 */,
/* 1817 */,
/* 1818 */,
/* 1819 */,
/* 1820 */,
/* 1821 */,
/* 1822 */,
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */,
/* 1847 */,
/* 1848 */,
/* 1849 */,
/* 1850 */,
/* 1851 */,
/* 1852 */,
/* 1853 */,
/* 1854 */,
/* 1855 */,
/* 1856 */,
/* 1857 */,
/* 1858 */,
/* 1859 */,
/* 1860 */,
/* 1861 */,
/* 1862 */,
/* 1863 */,
/* 1864 */,
/* 1865 */,
/* 1866 */,
/* 1867 */,
/* 1868 */,
/* 1869 */,
/* 1870 */,
/* 1871 */,
/* 1872 */,
/* 1873 */,
/* 1874 */,
/* 1875 */,
/* 1876 */,
/* 1877 */,
/* 1878 */,
/* 1879 */,
/* 1880 */,
/* 1881 */,
/* 1882 */,
/* 1883 */,
/* 1884 */,
/* 1885 */,
/* 1886 */,
/* 1887 */,
/* 1888 */,
/* 1889 */,
/* 1890 */,
/* 1891 */,
/* 1892 */,
/* 1893 */,
/* 1894 */,
/* 1895 */,
/* 1896 */,
/* 1897 */,
/* 1898 */,
/* 1899 */,
/* 1900 */,
/* 1901 */,
/* 1902 */,
/* 1903 */,
/* 1904 */,
/* 1905 */,
/* 1906 */,
/* 1907 */,
/* 1908 */,
/* 1909 */,
/* 1910 */,
/* 1911 */,
/* 1912 */,
/* 1913 */,
/* 1914 */,
/* 1915 */,
/* 1916 */,
/* 1917 */,
/* 1918 */,
/* 1919 */,
/* 1920 */,
/* 1921 */,
/* 1922 */,
/* 1923 */,
/* 1924 */,
/* 1925 */,
/* 1926 */,
/* 1927 */,
/* 1928 */,
/* 1929 */,
/* 1930 */,
/* 1931 */,
/* 1932 */,
/* 1933 */,
/* 1934 */,
/* 1935 */,
/* 1936 */,
/* 1937 */,
/* 1938 */,
/* 1939 */,
/* 1940 */,
/* 1941 */,
/* 1942 */,
/* 1943 */,
/* 1944 */,
/* 1945 */,
/* 1946 */,
/* 1947 */,
/* 1948 */,
/* 1949 */,
/* 1950 */,
/* 1951 */,
/* 1952 */,
/* 1953 */,
/* 1954 */,
/* 1955 */,
/* 1956 */,
/* 1957 */,
/* 1958 */,
/* 1959 */,
/* 1960 */,
/* 1961 */,
/* 1962 */,
/* 1963 */,
/* 1964 */,
/* 1965 */,
/* 1966 */,
/* 1967 */,
/* 1968 */,
/* 1969 */,
/* 1970 */,
/* 1971 */,
/* 1972 */,
/* 1973 */,
/* 1974 */,
/* 1975 */,
/* 1976 */,
/* 1977 */,
/* 1978 */,
/* 1979 */,
/* 1980 */,
/* 1981 */,
/* 1982 */,
/* 1983 */,
/* 1984 */,
/* 1985 */,
/* 1986 */,
/* 1987 */,
/* 1988 */,
/* 1989 */,
/* 1990 */,
/* 1991 */,
/* 1992 */,
/* 1993 */,
/* 1994 */,
/* 1995 */,
/* 1996 */,
/* 1997 */,
/* 1998 */,
/* 1999 */,
/* 2000 */,
/* 2001 */,
/* 2002 */,
/* 2003 */,
/* 2004 */,
/* 2005 */,
/* 2006 */,
/* 2007 */,
/* 2008 */,
/* 2009 */,
/* 2010 */,
/* 2011 */,
/* 2012 */,
/* 2013 */,
/* 2014 */,
/* 2015 */,
/* 2016 */,
/* 2017 */,
/* 2018 */,
/* 2019 */,
/* 2020 */,
/* 2021 */,
/* 2022 */,
/* 2023 */,
/* 2024 */,
/* 2025 */,
/* 2026 */,
/* 2027 */,
/* 2028 */,
/* 2029 */,
/* 2030 */,
/* 2031 */,
/* 2032 */,
/* 2033 */,
/* 2034 */,
/* 2035 */,
/* 2036 */,
/* 2037 */,
/* 2038 */,
/* 2039 */,
/* 2040 */,
/* 2041 */,
/* 2042 */,
/* 2043 */,
/* 2044 */,
/* 2045 */,
/* 2046 */,
/* 2047 */,
/* 2048 */,
/* 2049 */,
/* 2050 */,
/* 2051 */,
/* 2052 */,
/* 2053 */,
/* 2054 */,
/* 2055 */,
/* 2056 */,
/* 2057 */,
/* 2058 */,
/* 2059 */,
/* 2060 */,
/* 2061 */,
/* 2062 */,
/* 2063 */,
/* 2064 */,
/* 2065 */,
/* 2066 */,
/* 2067 */,
/* 2068 */,
/* 2069 */,
/* 2070 */,
/* 2071 */,
/* 2072 */,
/* 2073 */,
/* 2074 */,
/* 2075 */,
/* 2076 */,
/* 2077 */,
/* 2078 */,
/* 2079 */,
/* 2080 */,
/* 2081 */,
/* 2082 */,
/* 2083 */,
/* 2084 */,
/* 2085 */,
/* 2086 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = void 0;

var _default = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

exports.default = _default;
module.exports = exports["default"];

/***/ }),
/* 2087 */,
/* 2088 */,
/* 2089 */,
/* 2090 */,
/* 2091 */,
/* 2092 */,
/* 2093 */,
/* 2094 */,
/* 2095 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {
	'use strict';

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (true) {
		!(__WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return ExecutionEnvironment;
		}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof module !== 'undefined' && module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());


/***/ }),
/* 2096 */,
/* 2097 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2098 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2099 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 2100 */,
/* 2101 */,
/* 2102 */,
/* 2103 */,
/* 2104 */,
/* 2105 */,
/* 2106 */,
/* 2107 */,
/* 2108 */,
/* 2109 */,
/* 2110 */,
/* 2111 */,
/* 2112 */,
/* 2113 */,
/* 2114 */,
/* 2115 */,
/* 2116 */,
/* 2117 */,
/* 2118 */,
/* 2119 */,
/* 2120 */,
/* 2121 */,
/* 2122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _invariant = __webpack_require__(52);

var _invariant2 = _interopRequireDefault(_invariant);

var _DOMUtils = __webpack_require__(271);

var _ExecutionEnvironment = __webpack_require__(354);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var startListener = function startListener(getPromptMessage) {
  var handleBeforeUnload = function handleBeforeUnload(event) {
    var message = getPromptMessage();

    if (typeof message === 'string') {
      (event || window.event).returnValue = message;
      return message;
    }

    return undefined;
  };

  (0, _DOMUtils.addEventListener)(window, 'beforeunload', handleBeforeUnload);

  return function () {
    return (0, _DOMUtils.removeEventListener)(window, 'beforeunload', handleBeforeUnload);
  };
};

/**
 * Returns a new createHistory function that can be used to create
 * history objects that know how to use the beforeunload event in web
 * browsers to cancel navigation.
 */
var useBeforeUnload = function useBeforeUnload(createHistory) {
  !_ExecutionEnvironment.canUseDOM ?  false ? (0, _invariant2.default)(false, 'useBeforeUnload only works in DOM environments') : (0, _invariant2.default)(false) : void 0;

  return function (options) {
    var history = createHistory(options);

    var listeners = [];
    var stopListener = void 0;

    var getPromptMessage = function getPromptMessage() {
      var message = void 0;
      for (var i = 0, len = listeners.length; message == null && i < len; ++i) {
        message = listeners[i].call();
      }return message;
    };

    var listenBeforeUnload = function listenBeforeUnload(listener) {
      if (listeners.push(listener) === 1) stopListener = startListener(getPromptMessage);

      return function () {
        listeners = listeners.filter(function (item) {
          return item !== listener;
        });

        if (listeners.length === 0 && stopListener) {
          stopListener();
          stopListener = null;
        }
      };
    };

    return _extends({}, history, {
      listenBeforeUnload: listenBeforeUnload
    });
  };
};

exports.default = useBeforeUnload;

/***/ }),
/* 2123 */,
/* 2124 */,
/* 2125 */,
/* 2126 */,
/* 2127 */,
/* 2128 */,
/* 2129 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(2637);
module.exports = self.fetch.bind(self);


/***/ }),
/* 2130 */,
/* 2131 */,
/* 2132 */,
/* 2133 */,
/* 2134 */,
/* 2135 */,
/* 2136 */,
/* 2137 */,
/* 2138 */,
/* 2139 */,
/* 2140 */,
/* 2141 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * The base implementation of `_.delay` and `_.defer` which accepts `args`
 * to provide to `func`.
 *
 * @private
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {Array} args The arguments to provide to `func`.
 * @returns {number|Object} Returns the timer id or timeout object.
 */
function baseDelay(func, wait, args) {
  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return setTimeout(function() { func.apply(undefined, args); }, wait);
}

module.exports = baseDelay;


/***/ }),
/* 2142 */,
/* 2143 */,
/* 2144 */,
/* 2145 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 2146 */,
/* 2147 */,
/* 2148 */,
/* 2149 */,
/* 2150 */,
/* 2151 */,
/* 2152 */,
/* 2153 */,
/* 2154 */,
/* 2155 */,
/* 2156 */,
/* 2157 */,
/* 2158 */,
/* 2159 */,
/* 2160 */,
/* 2161 */,
/* 2162 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 2163 */,
/* 2164 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(217);

/**
 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
 * of key-value pairs for `object` corresponding to the property names of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the key-value pairs.
 */
function baseToPairs(object, props) {
  return arrayMap(props, function(key) {
    return [key, object[key]];
  });
}

module.exports = baseToPairs;


/***/ }),
/* 2165 */,
/* 2166 */,
/* 2167 */,
/* 2168 */,
/* 2169 */,
/* 2170 */,
/* 2171 */,
/* 2172 */,
/* 2173 */,
/* 2174 */,
/* 2175 */,
/* 2176 */,
/* 2177 */,
/* 2178 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(273),
    isIterateeCall = __webpack_require__(2205);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 2179 */,
/* 2180 */,
/* 2181 */,
/* 2182 */,
/* 2183 */,
/* 2184 */
/***/ (function(module, exports, __webpack_require__) {

var LodashWrapper = __webpack_require__(523),
    flatRest = __webpack_require__(874),
    getData = __webpack_require__(534),
    getFuncName = __webpack_require__(877),
    isArray = __webpack_require__(53),
    isLaziable = __webpack_require__(881);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used to compose bitmasks for function metadata. */
var WRAP_CURRY_FLAG = 8,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256;

/**
 * Creates a `_.flow` or `_.flowRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new flow function.
 */
function createFlow(fromRight) {
  return flatRest(function(funcs) {
    var length = funcs.length,
        index = length,
        prereq = LodashWrapper.prototype.thru;

    if (fromRight) {
      funcs.reverse();
    }
    while (index--) {
      var func = funcs[index];
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
        var wrapper = new LodashWrapper([], true);
      }
    }
    index = wrapper ? index : length;
    while (++index < length) {
      func = funcs[index];

      var funcName = getFuncName(func),
          data = funcName == 'wrapper' ? getData(func) : undefined;

      if (data && isLaziable(data[0]) &&
            data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
            !data[4].length && data[9] == 1
          ) {
        wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
      } else {
        wrapper = (func.length == 1 && isLaziable(func))
          ? wrapper[funcName]()
          : wrapper.thru(func);
      }
    }
    return function() {
      var args = arguments,
          value = args[0];

      if (wrapper && args.length == 1 && isArray(value)) {
        return wrapper.plant(value).value();
      }
      var index = 0,
          result = length ? funcs[index].apply(this, args) : value;

      while (++index < length) {
        result = funcs[index].call(this, result);
      }
      return result;
    };
  });
}

module.exports = createFlow;


/***/ }),
/* 2185 */,
/* 2186 */
/***/ (function(module, exports, __webpack_require__) {

var baseToPairs = __webpack_require__(2164),
    getTag = __webpack_require__(218),
    mapToArray = __webpack_require__(883),
    setToPairs = __webpack_require__(2228);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Creates a `_.toPairs` or `_.toPairsIn` function.
 *
 * @private
 * @param {Function} keysFunc The function to get the keys of a given object.
 * @returns {Function} Returns the new pairs function.
 */
function createToPairs(keysFunc) {
  return function(object) {
    var tag = getTag(object);
    if (tag == mapTag) {
      return mapToArray(object);
    }
    if (tag == setTag) {
      return setToPairs(object);
    }
    return baseToPairs(object, keysFunc(object));
  };
}

module.exports = createToPairs;


/***/ }),
/* 2187 */,
/* 2188 */,
/* 2189 */,
/* 2190 */,
/* 2191 */,
/* 2192 */,
/* 2193 */,
/* 2194 */,
/* 2195 */,
/* 2196 */,
/* 2197 */,
/* 2198 */,
/* 2199 */,
/* 2200 */,
/* 2201 */,
/* 2202 */,
/* 2203 */,
/* 2204 */,
/* 2205 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(368),
    isArrayLike = __webpack_require__(195),
    isIndex = __webpack_require__(364),
    isObject = __webpack_require__(108);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 2206 */,
/* 2207 */,
/* 2208 */,
/* 2209 */,
/* 2210 */,
/* 2211 */,
/* 2212 */,
/* 2213 */,
/* 2214 */,
/* 2215 */,
/* 2216 */,
/* 2217 */,
/* 2218 */,
/* 2219 */,
/* 2220 */,
/* 2221 */,
/* 2222 */,
/* 2223 */,
/* 2224 */,
/* 2225 */,
/* 2226 */,
/* 2227 */,
/* 2228 */
/***/ (function(module, exports) {

/**
 * Converts `set` to its value-value pairs.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the value-value pairs.
 */
function setToPairs(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = [value, value];
  });
  return result;
}

module.exports = setToPairs;


/***/ }),
/* 2229 */,
/* 2230 */,
/* 2231 */,
/* 2232 */,
/* 2233 */,
/* 2234 */,
/* 2235 */,
/* 2236 */,
/* 2237 */,
/* 2238 */,
/* 2239 */,
/* 2240 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(530),
    copyObject = __webpack_require__(275),
    createAssigner = __webpack_require__(2178),
    isArrayLike = __webpack_require__(195),
    isPrototype = __webpack_require__(365),
    keys = __webpack_require__(196);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns own enumerable string keyed properties of source objects to the
 * destination object. Source objects are applied from left to right.
 * Subsequent sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object` and is loosely based on
 * [`Object.assign`](https://mdn.io/Object/assign).
 *
 * @static
 * @memberOf _
 * @since 0.10.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @see _.assignIn
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * function Bar() {
 *   this.c = 3;
 * }
 *
 * Foo.prototype.b = 2;
 * Bar.prototype.d = 4;
 *
 * _.assign({ 'a': 0 }, new Foo, new Bar);
 * // => { 'a': 1, 'c': 3 }
 */
var assign = createAssigner(function(object, source) {
  if (isPrototype(source) || isArrayLike(source)) {
    copyObject(source, keys(source), object);
    return;
  }
  for (var key in source) {
    if (hasOwnProperty.call(source, key)) {
      assignValue(object, key, source[key]);
    }
  }
});

module.exports = assign;


/***/ }),
/* 2241 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(273),
    createWrap = __webpack_require__(362),
    getHolder = __webpack_require__(535),
    replaceHolders = __webpack_require__(367);

/** Used to compose bitmasks for function metadata. */
var WRAP_BIND_FLAG = 1,
    WRAP_PARTIAL_FLAG = 32;

/**
 * Creates a function that invokes `func` with the `this` binding of `thisArg`
 * and `partials` prepended to the arguments it receives.
 *
 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
 * may be used as a placeholder for partially applied arguments.
 *
 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
 * property of bound functions.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to bind.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {...*} [partials] The arguments to be partially applied.
 * @returns {Function} Returns the new bound function.
 * @example
 *
 * function greet(greeting, punctuation) {
 *   return greeting + ' ' + this.user + punctuation;
 * }
 *
 * var object = { 'user': 'fred' };
 *
 * var bound = _.bind(greet, object, 'hi');
 * bound('!');
 * // => 'hi fred!'
 *
 * // Bound with placeholders.
 * var bound = _.bind(greet, object, _, '!');
 * bound('hi');
 * // => 'hi fred!'
 */
var bind = baseRest(function(func, thisArg, partials) {
  var bitmask = WRAP_BIND_FLAG;
  if (partials.length) {
    var holders = replaceHolders(partials, getHolder(bind));
    bitmask |= WRAP_PARTIAL_FLAG;
  }
  return createWrap(func, bitmask, thisArg, partials, holders);
});

// Assign default placeholders.
bind.placeholder = {};

module.exports = bind;


/***/ }),
/* 2242 */,
/* 2243 */,
/* 2244 */,
/* 2245 */
/***/ (function(module, exports, __webpack_require__) {

var baseDelay = __webpack_require__(2141),
    baseRest = __webpack_require__(273),
    toNumber = __webpack_require__(547);

/**
 * Invokes `func` after `wait` milliseconds. Any additional arguments are
 * provided to `func` when it's invoked.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to delay.
 * @param {number} wait The number of milliseconds to delay invocation.
 * @param {...*} [args] The arguments to invoke `func` with.
 * @returns {number} Returns the timer id.
 * @example
 *
 * _.delay(function(text) {
 *   console.log(text);
 * }, 1000, 'later');
 * // => Logs 'later' after one second.
 */
var delay = baseRest(function(func, wait, args) {
  return baseDelay(func, toNumber(wait) || 0, args);
});

module.exports = delay;


/***/ }),
/* 2246 */,
/* 2247 */,
/* 2248 */,
/* 2249 */,
/* 2250 */,
/* 2251 */,
/* 2252 */,
/* 2253 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(2145),
    hasPath = __webpack_require__(880);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 2254 */,
/* 2255 */,
/* 2256 */,
/* 2257 */,
/* 2258 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(862),
    getMatchData = __webpack_require__(878);

/**
 * Performs a partial deep comparison between `object` and `source` to
 * determine if `object` contains equivalent property values.
 *
 * **Note:** This method is equivalent to `_.matches` when `source` is
 * partially applied.
 *
 * Partial comparisons will match empty array and empty object `source`
 * values against any array or object value, respectively. See `_.isEqual`
 * for a list of supported value comparisons.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 *
 * _.isMatch(object, { 'b': 2 });
 * // => true
 *
 * _.isMatch(object, { 'b': 1 });
 * // => false
 */
function isMatch(object, source) {
  return object === source || baseIsMatch(object, source, getMatchData(source));
}

module.exports = isMatch;


/***/ }),
/* 2259 */,
/* 2260 */,
/* 2261 */,
/* 2262 */,
/* 2263 */,
/* 2264 */,
/* 2265 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(531),
    baseForOwn = __webpack_require__(857),
    baseIteratee = __webpack_require__(272);

/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */
function mapKeys(object, iteratee) {
  var result = {};
  iteratee = baseIteratee(iteratee, 3);

  baseForOwn(object, function(value, key, object) {
    baseAssignValue(result, iteratee(value, key, object), value);
  });
  return result;
}

module.exports = mapKeys;


/***/ }),
/* 2266 */,
/* 2267 */,
/* 2268 */,
/* 2269 */,
/* 2270 */,
/* 2271 */,
/* 2272 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(853),
    baseEach = __webpack_require__(359),
    baseIteratee = __webpack_require__(272),
    baseReduce = __webpack_require__(2162),
    isArray = __webpack_require__(53);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 2273 */,
/* 2274 */
/***/ (function(module, exports, __webpack_require__) {

var debounce = __webpack_require__(894),
    isObject = __webpack_require__(108);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

module.exports = throttle;


/***/ }),
/* 2275 */,
/* 2276 */,
/* 2277 */
/***/ (function(module, exports, __webpack_require__) {

var createToPairs = __webpack_require__(2186),
    keys = __webpack_require__(196);

/**
 * Creates an array of own enumerable string keyed-value pairs for `object`
 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
 * entries are returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @alias entries
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the key-value pairs.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.toPairs(new Foo);
 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
 */
var toPairs = createToPairs(keys);

module.exports = toPairs;


/***/ }),
/* 2278 */,
/* 2279 */,
/* 2280 */,
/* 2281 */,
/* 2282 */,
/* 2283 */,
/* 2284 */,
/* 2285 */,
/* 2286 */,
/* 2287 */,
/* 2288 */
/***/ (function(module, exports) {

/**
 * Secure random string generator with custom alphabet.
 *
 * Alphabet must contain 256 symbols or less. Otherwise, the generator
 * will not be secure.
 *
 * @param {generator} random The random bytes generator.
 * @param {string} alphabet Symbols to be used in new random string.
 * @param {size} size The number of symbols in new random string.
 *
 * @return {string} Random string.
 *
 * @example
 * const format = require('nanoid/format')
 *
 * function random (size) {
 *   const result = []
 *   for (let i = 0; i < size; i++) {
 *     result.push(randomByte())
 *   }
 *   return result
 * }
 *
 * format(random, "abcdef", 5) //=> "fbaef"
 *
 * @name format
 * @function
 */
module.exports = function (random, alphabet, size) {
  var mask = (2 << Math.log(alphabet.length - 1) / Math.LN2) - 1
  var step = Math.ceil(1.6 * mask * size / alphabet.length)

  var id = ''
  while (true) {
    var bytes = random(step)
    for (var i = 0; i < step; i++) {
      var byte = bytes[i] & mask
      if (alphabet[byte]) {
        id += alphabet[byte]
        if (id.length === size) return id
      }
    }
  }
}

/**
 * @callback generator
 * @param {number} bytes The number of bytes to generate.
 * @return {number[]} Random bytes.
 */


/***/ }),
/* 2289 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*! @preserve
 * numeral.js
 * version : 2.0.6
 * author : Adam Draper
 * license : MIT
 * http://adamwdraper.github.com/Numeral-js/
 */

(function (global, factory) {
    if (true) {
        !(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
    } else if (typeof module === 'object' && module.exports) {
        module.exports = factory();
    } else {
        global.numeral = factory();
    }
}(this, function () {
    /************************************
        Variables
    ************************************/

    var numeral,
        _,
        VERSION = '2.0.6',
        formats = {},
        locales = {},
        defaults = {
            currentLocale: 'en',
            zeroFormat: null,
            nullFormat: null,
            defaultFormat: '0,0',
            scalePercentBy100: true
        },
        options = {
            currentLocale: defaults.currentLocale,
            zeroFormat: defaults.zeroFormat,
            nullFormat: defaults.nullFormat,
            defaultFormat: defaults.defaultFormat,
            scalePercentBy100: defaults.scalePercentBy100
        };


    /************************************
        Constructors
    ************************************/

    // Numeral prototype object
    function Numeral(input, number) {
        this._input = input;

        this._value = number;
    }

    numeral = function(input) {
        var value,
            kind,
            unformatFunction,
            regexp;

        if (numeral.isNumeral(input)) {
            value = input.value();
        } else if (input === 0 || typeof input === 'undefined') {
            value = 0;
        } else if (input === null || _.isNaN(input)) {
            value = null;
        } else if (typeof input === 'string') {
            if (options.zeroFormat && input === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && input === options.nullFormat || !input.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                for (kind in formats) {
                    regexp = typeof formats[kind].regexps.unformat === 'function' ? formats[kind].regexps.unformat() : formats[kind].regexps.unformat;

                    if (regexp && input.match(regexp)) {
                        unformatFunction = formats[kind].unformat;

                        break;
                    }
                }

                unformatFunction = unformatFunction || numeral._.stringToNumber;

                value = unformatFunction(input);
            }
        } else {
            value = Number(input)|| null;
        }

        return new Numeral(input, value);
    };

    // version number
    numeral.version = VERSION;

    // compare numeral object
    numeral.isNumeral = function(obj) {
        return obj instanceof Numeral;
    };

    // helper functions
    numeral._ = _ = {
        // formats numbers separators, decimals places, signs, abbreviations
        numberToFormat: function(value, format, roundingFunction) {
            var locale = locales[numeral.options.currentLocale],
                negP = false,
                optDec = false,
                leadingCount = 0,
                abbr = '',
                trillion = 1000000000000,
                billion = 1000000000,
                million = 1000000,
                thousand = 1000,
                decimal = '',
                neg = false,
                abbrForce, // force abbreviation
                abs,
                min,
                max,
                power,
                int,
                precision,
                signed,
                thousands,
                output;

            // make sure we never format a null value
            value = value || 0;

            abs = Math.abs(value);

            // see if we should use parentheses for negative number or if we should prefix with a sign
            // if both are present we default to parentheses
            if (numeral._.includes(format, '(')) {
                negP = true;
                format = format.replace(/[\(|\)]/g, '');
            } else if (numeral._.includes(format, '+') || numeral._.includes(format, '-')) {
                signed = numeral._.includes(format, '+') ? format.indexOf('+') : value < 0 ? format.indexOf('-') : -1;
                format = format.replace(/[\+|\-]/g, '');
            }

            // see if abbreviation is wanted
            if (numeral._.includes(format, 'a')) {
                abbrForce = format.match(/a(k|m|b|t)?/);

                abbrForce = abbrForce ? abbrForce[1] : false;

                // check for space before abbreviation
                if (numeral._.includes(format, ' a')) {
                    abbr = ' ';
                }

                format = format.replace(new RegExp(abbr + 'a[kmbt]?'), '');

                if (abs >= trillion && !abbrForce || abbrForce === 't') {
                    // trillion
                    abbr += locale.abbreviations.trillion;
                    value = value / trillion;
                } else if (abs < trillion && abs >= billion && !abbrForce || abbrForce === 'b') {
                    // billion
                    abbr += locale.abbreviations.billion;
                    value = value / billion;
                } else if (abs < billion && abs >= million && !abbrForce || abbrForce === 'm') {
                    // million
                    abbr += locale.abbreviations.million;
                    value = value / million;
                } else if (abs < million && abs >= thousand && !abbrForce || abbrForce === 'k') {
                    // thousand
                    abbr += locale.abbreviations.thousand;
                    value = value / thousand;
                }
            }

            // check for optional decimals
            if (numeral._.includes(format, '[.]')) {
                optDec = true;
                format = format.replace('[.]', '.');
            }

            // break number and format
            int = value.toString().split('.')[0];
            precision = format.split('.')[1];
            thousands = format.indexOf(',');
            leadingCount = (format.split('.')[0].split(',')[0].match(/0/g) || []).length;

            if (precision) {
                if (numeral._.includes(precision, '[')) {
                    precision = precision.replace(']', '');
                    precision = precision.split('[');
                    decimal = numeral._.toFixed(value, (precision[0].length + precision[1].length), roundingFunction, precision[1].length);
                } else {
                    decimal = numeral._.toFixed(value, precision.length, roundingFunction);
                }

                int = decimal.split('.')[0];

                if (numeral._.includes(decimal, '.')) {
                    decimal = locale.delimiters.decimal + decimal.split('.')[1];
                } else {
                    decimal = '';
                }

                if (optDec && Number(decimal.slice(1)) === 0) {
                    decimal = '';
                }
            } else {
                int = numeral._.toFixed(value, 0, roundingFunction);
            }

            // check abbreviation again after rounding
            if (abbr && !abbrForce && Number(int) >= 1000 && abbr !== locale.abbreviations.trillion) {
                int = String(Number(int) / 1000);

                switch (abbr) {
                    case locale.abbreviations.thousand:
                        abbr = locale.abbreviations.million;
                        break;
                    case locale.abbreviations.million:
                        abbr = locale.abbreviations.billion;
                        break;
                    case locale.abbreviations.billion:
                        abbr = locale.abbreviations.trillion;
                        break;
                }
            }


            // format number
            if (numeral._.includes(int, '-')) {
                int = int.slice(1);
                neg = true;
            }

            if (int.length < leadingCount) {
                for (var i = leadingCount - int.length; i > 0; i--) {
                    int = '0' + int;
                }
            }

            if (thousands > -1) {
                int = int.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1' + locale.delimiters.thousands);
            }

            if (format.indexOf('.') === 0) {
                int = '';
            }

            output = int + decimal + (abbr ? abbr : '');

            if (negP) {
                output = (negP && neg ? '(' : '') + output + (negP && neg ? ')' : '');
            } else {
                if (signed >= 0) {
                    output = signed === 0 ? (neg ? '-' : '+') + output : output + (neg ? '-' : '+');
                } else if (neg) {
                    output = '-' + output;
                }
            }

            return output;
        },
        // unformats numbers separators, decimals places, signs, abbreviations
        stringToNumber: function(string) {
            var locale = locales[options.currentLocale],
                stringOriginal = string,
                abbreviations = {
                    thousand: 3,
                    million: 6,
                    billion: 9,
                    trillion: 12
                },
                abbreviation,
                value,
                i,
                regexp;

            if (options.zeroFormat && string === options.zeroFormat) {
                value = 0;
            } else if (options.nullFormat && string === options.nullFormat || !string.replace(/[^0-9]+/g, '').length) {
                value = null;
            } else {
                value = 1;

                if (locale.delimiters.decimal !== '.') {
                    string = string.replace(/\./g, '').replace(locale.delimiters.decimal, '.');
                }

                for (abbreviation in abbreviations) {
                    regexp = new RegExp('[^a-zA-Z]' + locale.abbreviations[abbreviation] + '(?:\\)|(\\' + locale.currency.symbol + ')?(?:\\))?)?$');

                    if (stringOriginal.match(regexp)) {
                        value *= Math.pow(10, abbreviations[abbreviation]);
                        break;
                    }
                }

                // check for negative number
                value *= (string.split('-').length + Math.min(string.split('(').length - 1, string.split(')').length - 1)) % 2 ? 1 : -1;

                // remove non numbers
                string = string.replace(/[^0-9\.]+/g, '');

                value *= Number(string);
            }

            return value;
        },
        isNaN: function(value) {
            return typeof value === 'number' && isNaN(value);
        },
        includes: function(string, search) {
            return string.indexOf(search) !== -1;
        },
        insert: function(string, subString, start) {
            return string.slice(0, start) + subString + string.slice(start);
        },
        reduce: function(array, callback /*, initialValue*/) {
            if (this === null) {
                throw new TypeError('Array.prototype.reduce called on null or undefined');
            }

            if (typeof callback !== 'function') {
                throw new TypeError(callback + ' is not a function');
            }

            var t = Object(array),
                len = t.length >>> 0,
                k = 0,
                value;

            if (arguments.length === 3) {
                value = arguments[2];
            } else {
                while (k < len && !(k in t)) {
                    k++;
                }

                if (k >= len) {
                    throw new TypeError('Reduce of empty array with no initial value');
                }

                value = t[k++];
            }
            for (; k < len; k++) {
                if (k in t) {
                    value = callback(value, t[k], k, t);
                }
            }
            return value;
        },
        /**
         * Computes the multiplier necessary to make x >= 1,
         * effectively eliminating miscalculations caused by
         * finite precision.
         */
        multiplier: function (x) {
            var parts = x.toString().split('.');

            return parts.length < 2 ? 1 : Math.pow(10, parts[1].length);
        },
        /**
         * Given a variable number of arguments, returns the maximum
         * multiplier that must be used to normalize an operation involving
         * all of them.
         */
        correctionFactor: function () {
            var args = Array.prototype.slice.call(arguments);

            return args.reduce(function(accum, next) {
                var mn = _.multiplier(next);
                return accum > mn ? accum : mn;
            }, 1);
        },
        /**
         * Implementation of toFixed() that treats floats more like decimals
         *
         * Fixes binary rounding issues (eg. (0.615).toFixed(2) === '0.61') that present
         * problems for accounting- and finance-related software.
         */
        toFixed: function(value, maxDecimals, roundingFunction, optionals) {
            var splitValue = value.toString().split('.'),
                minDecimals = maxDecimals - (optionals || 0),
                boundedPrecision,
                optionalsRegExp,
                power,
                output;

            // Use the smallest precision value possible to avoid errors from floating point representation
            if (splitValue.length === 2) {
              boundedPrecision = Math.min(Math.max(splitValue[1].length, minDecimals), maxDecimals);
            } else {
              boundedPrecision = minDecimals;
            }

            power = Math.pow(10, boundedPrecision);

            // Multiply up by precision, round accurately, then divide and use native toFixed():
            output = (roundingFunction(value + 'e+' + boundedPrecision) / power).toFixed(boundedPrecision);

            if (optionals > maxDecimals - boundedPrecision) {
                optionalsRegExp = new RegExp('\\.?0{1,' + (optionals - (maxDecimals - boundedPrecision)) + '}$');
                output = output.replace(optionalsRegExp, '');
            }

            return output;
        }
    };

    // avaliable options
    numeral.options = options;

    // avaliable formats
    numeral.formats = formats;

    // avaliable formats
    numeral.locales = locales;

    // This function sets the current locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    numeral.locale = function(key) {
        if (key) {
            options.currentLocale = key.toLowerCase();
        }

        return options.currentLocale;
    };

    // This function provides access to the loaded locale data.  If
    // no arguments are passed in, it will simply return the current
    // global locale object.
    numeral.localeData = function(key) {
        if (!key) {
            return locales[options.currentLocale];
        }

        key = key.toLowerCase();

        if (!locales[key]) {
            throw new Error('Unknown locale : ' + key);
        }

        return locales[key];
    };

    numeral.reset = function() {
        for (var property in defaults) {
            options[property] = defaults[property];
        }
    };

    numeral.zeroFormat = function(format) {
        options.zeroFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.nullFormat = function (format) {
        options.nullFormat = typeof(format) === 'string' ? format : null;
    };

    numeral.defaultFormat = function(format) {
        options.defaultFormat = typeof(format) === 'string' ? format : '0.0';
    };

    numeral.register = function(type, name, format) {
        name = name.toLowerCase();

        if (this[type + 's'][name]) {
            throw new TypeError(name + ' ' + type + ' already registered.');
        }

        this[type + 's'][name] = format;

        return format;
    };


    numeral.validate = function(val, culture) {
        var _decimalSep,
            _thousandSep,
            _currSymbol,
            _valArray,
            _abbrObj,
            _thousandRegEx,
            localeData,
            temp;

        //coerce val to string
        if (typeof val !== 'string') {
            val += '';

            if (console.warn) {
                console.warn('Numeral.js: Value is not string. It has been co-erced to: ', val);
            }
        }

        //trim whitespaces from either sides
        val = val.trim();

        //if val is just digits return true
        if (!!val.match(/^\d+$/)) {
            return true;
        }

        //if val is empty return false
        if (val === '') {
            return false;
        }

        //get the decimal and thousands separator from numeral.localeData
        try {
            //check if the culture is understood by numeral. if not, default it to current locale
            localeData = numeral.localeData(culture);
        } catch (e) {
            localeData = numeral.localeData(numeral.locale());
        }

        //setup the delimiters and currency symbol based on culture/locale
        _currSymbol = localeData.currency.symbol;
        _abbrObj = localeData.abbreviations;
        _decimalSep = localeData.delimiters.decimal;
        if (localeData.delimiters.thousands === '.') {
            _thousandSep = '\\.';
        } else {
            _thousandSep = localeData.delimiters.thousands;
        }

        // validating currency symbol
        temp = val.match(/^[^\d]+/);
        if (temp !== null) {
            val = val.substr(1);
            if (temp[0] !== _currSymbol) {
                return false;
            }
        }

        //validating abbreviation symbol
        temp = val.match(/[^\d]+$/);
        if (temp !== null) {
            val = val.slice(0, -1);
            if (temp[0] !== _abbrObj.thousand && temp[0] !== _abbrObj.million && temp[0] !== _abbrObj.billion && temp[0] !== _abbrObj.trillion) {
                return false;
            }
        }

        _thousandRegEx = new RegExp(_thousandSep + '{2}');

        if (!val.match(/[^\d.,]/g)) {
            _valArray = val.split(_decimalSep);
            if (_valArray.length > 2) {
                return false;
            } else {
                if (_valArray.length < 2) {
                    return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx));
                } else {
                    if (_valArray[0].length === 1) {
                        return ( !! _valArray[0].match(/^\d+$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    } else {
                        return ( !! _valArray[0].match(/^\d+.*\d$/) && !_valArray[0].match(_thousandRegEx) && !! _valArray[1].match(/^\d+$/));
                    }
                }
            }
        }

        return false;
    };


    /************************************
        Numeral Prototype
    ************************************/

    numeral.fn = Numeral.prototype = {
        clone: function() {
            return numeral(this);
        },
        format: function(inputString, roundingFunction) {
            var value = this._value,
                format = inputString || options.defaultFormat,
                kind,
                output,
                formatFunction;

            // make sure we have a roundingFunction
            roundingFunction = roundingFunction || Math.round;

            // format based on value
            if (value === 0 && options.zeroFormat !== null) {
                output = options.zeroFormat;
            } else if (value === null && options.nullFormat !== null) {
                output = options.nullFormat;
            } else {
                for (kind in formats) {
                    if (format.match(formats[kind].regexps.format)) {
                        formatFunction = formats[kind].format;

                        break;
                    }
                }

                formatFunction = formatFunction || numeral._.numberToFormat;

                output = formatFunction(value, format, roundingFunction);
            }

            return output;
        },
        value: function() {
            return this._value;
        },
        input: function() {
            return this._input;
        },
        set: function(value) {
            this._value = Number(value);

            return this;
        },
        add: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum + Math.round(corrFactor * curr);
            }

            this._value = _.reduce([this._value, value], cback, 0) / corrFactor;

            return this;
        },
        subtract: function(value) {
            var corrFactor = _.correctionFactor.call(null, this._value, value);

            function cback(accum, curr, currI, O) {
                return accum - Math.round(corrFactor * curr);
            }

            this._value = _.reduce([value], cback, Math.round(this._value * corrFactor)) / corrFactor;

            return this;
        },
        multiply: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) * Math.round(curr * corrFactor) / Math.round(corrFactor * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback, 1);

            return this;
        },
        divide: function(value) {
            function cback(accum, curr, currI, O) {
                var corrFactor = _.correctionFactor(accum, curr);
                return Math.round(accum * corrFactor) / Math.round(curr * corrFactor);
            }

            this._value = _.reduce([this._value, value], cback);

            return this;
        },
        difference: function(value) {
            return Math.abs(numeral(this._value).subtract(value).value());
        }
    };

    /************************************
        Default Locale && Format
    ************************************/

    numeral.register('locale', 'en', {
        delimiters: {
            thousands: ',',
            decimal: '.'
        },
        abbreviations: {
            thousand: 'k',
            million: 'm',
            billion: 'b',
            trillion: 't'
        },
        ordinal: function(number) {
            var b = number % 10;
            return (~~(number % 100 / 10) === 1) ? 'th' :
                (b === 1) ? 'st' :
                (b === 2) ? 'nd' :
                (b === 3) ? 'rd' : 'th';
        },
        currency: {
            symbol: '$'
        }
    });

    

(function() {
        numeral.register('format', 'bps', {
            regexps: {
                format: /(BPS)/,
                unformat: /(BPS)/
            },
            format: function(value, format, roundingFunction) {
                var space = numeral._.includes(format, ' BPS') ? ' ' : '',
                    output;

                value = value * 10000;

                // check for space before BPS
                format = format.replace(/\s?BPS/, '');

                output = numeral._.numberToFormat(value, format, roundingFunction);

                if (numeral._.includes(output, ')')) {
                    output = output.split('');

                    output.splice(-1, 0, space + 'BPS');

                    output = output.join('');
                } else {
                    output = output + space + 'BPS';
                }

                return output;
            },
            unformat: function(string) {
                return +(numeral._.stringToNumber(string) * 0.0001).toFixed(15);
            }
        });
})();


(function() {
        var decimal = {
            base: 1000,
            suffixes: ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
        },
        binary = {
            base: 1024,
            suffixes: ['B', 'KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB']
        };

    var allSuffixes =  decimal.suffixes.concat(binary.suffixes.filter(function (item) {
            return decimal.suffixes.indexOf(item) < 0;
        }));
        var unformatRegex = allSuffixes.join('|');
        // Allow support for BPS (http://www.investopedia.com/terms/b/basispoint.asp)
        unformatRegex = '(' + unformatRegex.replace('B', 'B(?!PS)') + ')';

    numeral.register('format', 'bytes', {
        regexps: {
            format: /([0\s]i?b)/,
            unformat: new RegExp(unformatRegex)
        },
        format: function(value, format, roundingFunction) {
            var output,
                bytes = numeral._.includes(format, 'ib') ? binary : decimal,
                suffix = numeral._.includes(format, ' b') || numeral._.includes(format, ' ib') ? ' ' : '',
                power,
                min,
                max;

            // check for space before
            format = format.replace(/\s?i?b/, '');

            for (power = 0; power <= bytes.suffixes.length; power++) {
                min = Math.pow(bytes.base, power);
                max = Math.pow(bytes.base, power + 1);

                if (value === null || value === 0 || value >= min && value < max) {
                    suffix += bytes.suffixes[power];

                    if (min > 0) {
                        value = value / min;
                    }

                    break;
                }
            }

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + suffix;
        },
        unformat: function(string) {
            var value = numeral._.stringToNumber(string),
                power,
                bytesMultiplier;

            if (value) {
                for (power = decimal.suffixes.length - 1; power >= 0; power--) {
                    if (numeral._.includes(string, decimal.suffixes[power])) {
                        bytesMultiplier = Math.pow(decimal.base, power);

                        break;
                    }

                    if (numeral._.includes(string, binary.suffixes[power])) {
                        bytesMultiplier = Math.pow(binary.base, power);

                        break;
                    }
                }

                value *= (bytesMultiplier || 1);
            }

            return value;
        }
    });
})();


(function() {
        numeral.register('format', 'currency', {
        regexps: {
            format: /(\$)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                symbols = {
                    before: format.match(/^([\+|\-|\(|\s|\$]*)/)[0],
                    after: format.match(/([\+|\-|\)|\s|\$]*)$/)[0]
                },
                output,
                symbol,
                i;

            // strip format of spaces and $
            format = format.replace(/\s?\$\s?/, '');

            // format the number
            output = numeral._.numberToFormat(value, format, roundingFunction);

            // update the before and after based on value
            if (value >= 0) {
                symbols.before = symbols.before.replace(/[\-\(]/, '');
                symbols.after = symbols.after.replace(/[\-\)]/, '');
            } else if (value < 0 && (!numeral._.includes(symbols.before, '-') && !numeral._.includes(symbols.before, '('))) {
                symbols.before = '-' + symbols.before;
            }

            // loop through each before symbol
            for (i = 0; i < symbols.before.length; i++) {
                symbol = symbols.before[i];

                switch (symbol) {
                    case '$':
                        output = numeral._.insert(output, locale.currency.symbol, i);
                        break;
                    case ' ':
                        output = numeral._.insert(output, ' ', i + locale.currency.symbol.length - 1);
                        break;
                }
            }

            // loop through each after symbol
            for (i = symbols.after.length - 1; i >= 0; i--) {
                symbol = symbols.after[i];

                switch (symbol) {
                    case '$':
                        output = i === symbols.after.length - 1 ? output + locale.currency.symbol : numeral._.insert(output, locale.currency.symbol, -(symbols.after.length - (1 + i)));
                        break;
                    case ' ':
                        output = i === symbols.after.length - 1 ? output + ' ' : numeral._.insert(output, ' ', -(symbols.after.length - (1 + i) + locale.currency.symbol.length - 1));
                        break;
                }
            }


            return output;
        }
    });
})();


(function() {
        numeral.register('format', 'exponential', {
        regexps: {
            format: /(e\+|e-)/,
            unformat: /(e\+|e-)/
        },
        format: function(value, format, roundingFunction) {
            var output,
                exponential = typeof value === 'number' && !numeral._.isNaN(value) ? value.toExponential() : '0e+0',
                parts = exponential.split('e');

            format = format.replace(/e[\+|\-]{1}0/, '');

            output = numeral._.numberToFormat(Number(parts[0]), format, roundingFunction);

            return output + 'e' + parts[1];
        },
        unformat: function(string) {
            var parts = numeral._.includes(string, 'e+') ? string.split('e+') : string.split('e-'),
                value = Number(parts[0]),
                power = Number(parts[1]);

            power = numeral._.includes(string, 'e-') ? power *= -1 : power;

            function cback(accum, curr, currI, O) {
                var corrFactor = numeral._.correctionFactor(accum, curr),
                    num = (accum * corrFactor) * (curr * corrFactor) / (corrFactor * corrFactor);
                return num;
            }

            return numeral._.reduce([value, Math.pow(10, power)], cback, 1);
        }
    });
})();


(function() {
        numeral.register('format', 'ordinal', {
        regexps: {
            format: /(o)/
        },
        format: function(value, format, roundingFunction) {
            var locale = numeral.locales[numeral.options.currentLocale],
                output,
                ordinal = numeral._.includes(format, ' o') ? ' ' : '';

            // check for space before
            format = format.replace(/\s?o/, '');

            ordinal += locale.ordinal(value);

            output = numeral._.numberToFormat(value, format, roundingFunction);

            return output + ordinal;
        }
    });
})();


(function() {
        numeral.register('format', 'percentage', {
        regexps: {
            format: /(%)/,
            unformat: /(%)/
        },
        format: function(value, format, roundingFunction) {
            var space = numeral._.includes(format, ' %') ? ' ' : '',
                output;

            if (numeral.options.scalePercentBy100) {
                value = value * 100;
            }

            // check for space before %
            format = format.replace(/\s?\%/, '');

            output = numeral._.numberToFormat(value, format, roundingFunction);

            if (numeral._.includes(output, ')')) {
                output = output.split('');

                output.splice(-1, 0, space + '%');

                output = output.join('');
            } else {
                output = output + space + '%';
            }

            return output;
        },
        unformat: function(string) {
            var number = numeral._.stringToNumber(string);
            if (numeral.options.scalePercentBy100) {
                return number * 0.01;
            }
            return number;
        }
    });
})();


(function() {
        numeral.register('format', 'time', {
        regexps: {
            format: /(:)/,
            unformat: /(:)/
        },
        format: function(value, format, roundingFunction) {
            var hours = Math.floor(value / 60 / 60),
                minutes = Math.floor((value - (hours * 60 * 60)) / 60),
                seconds = Math.round(value - (hours * 60 * 60) - (minutes * 60));

            return hours + ':' + (minutes < 10 ? '0' + minutes : minutes) + ':' + (seconds < 10 ? '0' + seconds : seconds);
        },
        unformat: function(string) {
            var timeArray = string.split(':'),
                seconds = 0;

            // turn hours and minutes into seconds and add them all up
            if (timeArray.length === 3) {
                // hours
                seconds = seconds + (Number(timeArray[0]) * 60 * 60);
                // minutes
                seconds = seconds + (Number(timeArray[1]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[2]);
            } else if (timeArray.length === 2) {
                // minutes
                seconds = seconds + (Number(timeArray[0]) * 60);
                // seconds
                seconds = seconds + Number(timeArray[1]);
            }
            return Number(seconds);
        }
    });
})();

return numeral;
}));


/***/ }),
/* 2290 */,
/* 2291 */,
/* 2292 */,
/* 2293 */,
/* 2294 */,
/* 2295 */,
/* 2296 */,
/* 2297 */,
/* 2298 */,
/* 2299 */,
/* 2300 */,
/* 2301 */,
/* 2302 */,
/* 2303 */,
/* 2304 */,
/* 2305 */,
/* 2306 */,
/* 2307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getDisplayName;
function getDisplayName(Component) {
  return Component.displayName || Component.name || (typeof Component === 'string' && Component.length > 0 ? Component : 'Unknown');
}

/***/ }),
/* 2308 */,
/* 2309 */,
/* 2310 */,
/* 2311 */,
/* 2312 */,
/* 2313 */,
/* 2314 */,
/* 2315 */,
/* 2316 */,
/* 2317 */,
/* 2318 */,
/* 2319 */,
/* 2320 */,
/* 2321 */,
/* 2322 */,
/* 2323 */,
/* 2324 */,
/* 2325 */,
/* 2326 */,
/* 2327 */,
/* 2328 */,
/* 2329 */,
/* 2330 */,
/* 2331 */,
/* 2332 */,
/* 2333 */,
/* 2334 */,
/* 2335 */,
/* 2336 */,
/* 2337 */,
/* 2338 */,
/* 2339 */,
/* 2340 */,
/* 2341 */,
/* 2342 */,
/* 2343 */,
/* 2344 */,
/* 2345 */,
/* 2346 */,
/* 2347 */,
/* 2348 */,
/* 2349 */,
/* 2350 */,
/* 2351 */,
/* 2352 */,
/* 2353 */,
/* 2354 */,
/* 2355 */,
/* 2356 */,
/* 2357 */,
/* 2358 */,
/* 2359 */,
/* 2360 */,
/* 2361 */,
/* 2362 */,
/* 2363 */,
/* 2364 */,
/* 2365 */,
/* 2366 */,
/* 2367 */,
/* 2368 */,
/* 2369 */,
/* 2370 */,
/* 2371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
  center: _propTypes2.default.any,
  draggable: _propTypes2.default.bool,
  editable: _propTypes2.default.bool,
  options: _propTypes2.default.object,
  radius: _propTypes2.default.number,
  visible: _propTypes2.default.bool
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onCenterChanged: "center_changed",

  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRadiusChanged: "radius_changed",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getBounds: function getBounds(circle) {
    return circle.getBounds();
  },
  getCenter: function getCenter(circle) {
    return circle.getCenter();
  },
  getDraggable: function getDraggable(circle) {
    return circle.getDraggable();
  },
  getEditable: function getEditable(circle) {
    return circle.getEditable();
  },
  getMap: function getMap(circle) {
    return circle.getMap();
  },
  getRadius: function getRadius(circle) {
    return circle.getRadius();
  },
  getVisible: function getVisible(circle) {
    return circle.getVisible();
  }
};

var controlledPropUpdaterMap = {
  center: function center(circle, _center) {
    circle.setCenter(_center);
  },
  draggable: function draggable(circle, _draggable) {
    circle.setDraggable(_draggable);
  },
  editable: function editable(circle, _editable) {
    circle.setEditable(_editable);
  },
  options: function options(circle, _options) {
    circle.setOptions(_options);
  },
  radius: function radius(circle, _radius) {
    circle.setRadius(_radius);
  },
  visible: function visible(circle, _visible) {
    circle.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.CIRCLE];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Circle",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Circle
    var circle = new google.maps.Circle((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.CIRCLE, circle);
  },
  componentWillUnmount: function componentWillUnmount() {
    var circle = getInstanceFromComponent(this);
    if (circle) {
      circle.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
  directions: _propTypes2.default.any,
  options: _propTypes2.default.object,
  panel: _propTypes2.default.object,
  routeIndex: _propTypes2.default.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onDirectionsChanged: "directions_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDirections: function getDirections(directionsRenderer) {
    return directionsRenderer.getDirections();
  },
  getPanel: function getPanel(directionsRenderer) {
    return directionsRenderer.getPanel();
  },
  getRouteIndex: function getRouteIndex(directionsRenderer) {
    return directionsRenderer.getRouteIndex();
  }
};

var controlledPropUpdaterMap = {
  directions: function directions(directionsRenderer, _directions) {
    directionsRenderer.setDirections(_directions);
  },
  options: function options(directionsRenderer, _options) {
    directionsRenderer.setOptions(_options);
  },
  panel: function panel(directionsRenderer, _panel) {
    directionsRenderer.setPanel(_panel);
  },
  routeIndex: function routeIndex(directionsRenderer, _routeIndex) {
    directionsRenderer.setRouteIndex(_routeIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.DIRECTIONS_RENDERER];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "DirectionsRenderer",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#DirectionsRenderer
    var directionsRenderer = new google.maps.DirectionsRenderer((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.DIRECTIONS_RENDERER, directionsRenderer);
  },
  componentWillUnmount: function componentWillUnmount() {
    var directionsRenderer = getInstanceFromComponent(this);
    if (directionsRenderer) {
      directionsRenderer.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
    // NOTICE!!!!!!
    //
    // Only expose those with getters & setters in the table as controlled props.
    //
    // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
    //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
    //
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
    options: _propTypes2.default.object
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
    onClick: "click"
};

var publicMethodMap = {
    // Public APIs
    //
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#FusionTablesLayer
    //
    // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
    //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
    // END - Public APIs
};

var controlledPropUpdaterMap = {
    options: function options(fusionTablesLayer, _options) {
        fusionTablesLayer.setOptions(_options);
    }
};

function getInstanceFromComponent(component) {
    return component.state[_constants.FUSION_TABLES_LAYER];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
    displayName: "FusionTablesLayer",

    propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

    contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

    getInitialState: function getInitialState() {
        var fusionTablesLayer = new google.maps.FusionTablesLayer((0, _extends3.default)({
            map: this.context[_constants.MAP]
        }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));

        return (0, _defineProperty3.default)({}, _constants.FUSION_TABLES_LAYER, fusionTablesLayer);
    },
    componentWillUnmount: function componentWillUnmount() {
        var fusionTablesLayer = getInstanceFromComponent(this);
        if (fusionTablesLayer) {
            fusionTablesLayer.setMap(null);
        }
    },
    render: function render() {
        return false;
    }
});

/***/ }),
/* 2374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _toConsumableArray2 = __webpack_require__(1278);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _invariant = __webpack_require__(52);

var _invariant2 = _interopRequireDefault(_invariant);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  center: _propTypes2.default.object,

  heading: _propTypes2.default.number,

  mapTypeId: _propTypes2.default.any,

  options: _propTypes2.default.object,

  streetView: _propTypes2.default.any,

  tilt: _propTypes2.default.number,

  zoom: _propTypes2.default.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onBoundsChanged: "bounds_changed",

  onCenterChanged: "center_changed",

  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onHeadingChanged: "heading_changed",

  onIdle: "idle",

  onMapTypeIdChanged: "maptypeid_changed",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onProjectionChanged: "projection_changed",

  onResize: "resize",

  onRightClick: "rightclick",

  onTilesLoaded: "tilesloaded",

  onTiltChanged: "tilt_changed",

  onZoomChanged: "zoom_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getBounds: function getBounds(map) {
    return map.getBounds();
  },
  getCenter: function getCenter(map) {
    return map.getCenter();
  },
  getDiv: function getDiv(map) {
    return map.getDiv();
  },
  getHeading: function getHeading(map) {
    return map.getHeading();
  },
  getMapTypeId: function getMapTypeId(map) {
    return map.getMapTypeId();
  },
  getProjection: function getProjection(map) {
    return map.getProjection();
  },
  getStreetView: function getStreetView(map) {
    return map.getStreetView();
  },
  getTilt: function getTilt(map) {
    return map.getTilt();
  },
  getZoom: function getZoom(map) {
    return map.getZoom();
  },

  // END - Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  //
  // Public APIs - Use this carefully
  // See discussion in https://github.com/tomchentw/react-google-maps/issues/62
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return !it.match(/^get/) && !it.match(/^set/) && !it.match(/Map$/); })
  fitBounds: function fitBounds(map, args) {
    return map.fitBounds.apply(map, (0, _toConsumableArray3.default)(args));
  },
  panBy: function panBy(map, args) {
    return map.panBy.apply(map, (0, _toConsumableArray3.default)(args));
  },
  panTo: function panTo(map, args) {
    return map.panTo.apply(map, (0, _toConsumableArray3.default)(args));
  },
  panToBounds: function panToBounds(map, args) {
    return map.panToBounds.apply(map, (0, _toConsumableArray3.default)(args));
  }
};

var controlledPropUpdaterMap = {
  center: function center(map, _center) {
    map.setCenter(_center);
  },
  heading: function heading(map, _heading) {
    map.setHeading(_heading);
  },
  mapTypeId: function mapTypeId(map, _mapTypeId) {
    map.setMapTypeId(_mapTypeId);
  },
  options: function options(map, _options) {
    map.setOptions(_options);
  },
  streetView: function streetView(map, _streetView) {
    map.setStreetView(_streetView);
  },
  tilt: function tilt(map, _tilt) {
    map.setTilt(_tilt);
  },
  zoom: function zoom(map, _zoom) {
    map.setZoom(_zoom);
  }
};

function getInstanceFromComponent(component) {
  return component.context[_constants.MAP];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "GoogleMap",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    var map = getInstanceFromComponent(this);

    (0, _invariant2.default)(!!map, "Did you wrap <GoogleMap> component with withGoogleMap() HOC?");

    map.setOptions((0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props));
    return null;
  },
  render: function render() {
    var children = this.props.children;


    return _react2.default.createElement(
      "div",
      null,
      children
    );
  }
});

/***/ }),
/* 2375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _contextTypes; /* global google */


var _invariant = __webpack_require__(52);

var _invariant2 = _interopRequireDefault(_invariant);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = __webpack_require__(1);

var _reactDom = __webpack_require__(112);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
  children: _propTypes2.default.element,
  options: _propTypes2.default.object,
  position: _propTypes2.default.any,
  zIndex: _propTypes2.default.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onCloseClick: "closeclick",

  onContentChanged: "content_changed",

  onDomReady: "domready",

  onPositionChanged: "position_changed",

  onZIndexChanged: "zindex_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getPosition: function getPosition(infoWindow) {
    return infoWindow.getPosition();
  },
  getZIndex: function getZIndex(infoWindow) {
    return infoWindow.getZIndex();
  }
};

var controlledPropUpdaterMap = {
  children: function children(infoWindow, _children, component) {
    (0, _reactDom.unstable_renderSubtreeIntoContainer)(component, _react.Children.only(_children), infoWindow.getContent());
  },
  options: function options(infoWindow, _options) {
    infoWindow.setOptions(_options);
  },
  position: function position(infoWindow, _position) {
    infoWindow.setPosition(_position);
  },
  zIndex: function zIndex(infoWindow, _zIndex) {
    infoWindow.setZIndex(_zIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.INFO_WINDOW];
}

function openInfoWindow(context, infoWindow) {
  var map = context[_constants.MAP];
  var anchor = context[_constants.ANCHOR];
  if (anchor) {
    infoWindow.open(map, anchor);
  } else if (infoWindow.getPosition()) {
    infoWindow.open(map);
  } else {
    (0, _invariant2.default)(false, "You must provide either an anchor (typically a <Marker>) or a position for <InfoWindow>.");
  }
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "InfoWindow",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (_contextTypes = {}, (0, _defineProperty3.default)(_contextTypes, _constants.MAP, _propTypes2.default.object), (0, _defineProperty3.default)(_contextTypes, _constants.ANCHOR, _propTypes2.default.object), _contextTypes),

  getInitialState: function getInitialState() {
    var map = this.context[_constants.MAP];
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#InfoWindow
    var infoWindow = new google.maps.InfoWindow((0, _extends3.default)({
      map: map
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props), {
      // Override props of ReactElement type
      content: undefined,
      children: undefined
    }));

    openInfoWindow(this.context, infoWindow);
    return (0, _defineProperty3.default)({}, _constants.INFO_WINDOW, infoWindow);
  },
  componentDidMount: function componentDidMount() {
    var infoWindow = getInstanceFromComponent(this);
    var content = document.createElement("div");

    controlledPropUpdaterMap.children({
      getContent: function getContent() {
        return content;
      }
    }, this.props.children, this);
    infoWindow.setContent(content);
  },
  componentWillReceiveProps: function componentWillReceiveProps(nextProps, nextContext) {
    var anchorChanged = this.context[_constants.ANCHOR] !== nextContext[_constants.ANCHOR];
    if (anchorChanged) {
      var infoWindow = getInstanceFromComponent(this);
      openInfoWindow(nextContext, infoWindow);
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    var infoWindow = getInstanceFromComponent(this);
    if (infoWindow) {
      (0, _reactDom.unmountComponentAtNode)(infoWindow.getContent());
      infoWindow.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2376 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
  defaultViewport: _propTypes2.default.any,
  options: _propTypes2.default.any,
  metadata: _propTypes2.default.any,
  status: _propTypes2.default.any,
  url: _propTypes2.default.string,
  zIndex: _propTypes2.default.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onClick: "click",

  onDefaultViewportChanged: "defaultviewport_changed",

  onStatusChanged: "status_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDefaultViewport: function getDefaultViewport(kmlLayer) {
    return kmlLayer.getDefaultViewport();
  },
  getMetadata: function getMetadata(kmlLayer) {
    return kmlLayer.getMetadata();
  },
  getOptions: function getOptions(kmlLayer) {
    return kmlLayer.getOptions();
  },
  getStatus: function getStatus(kmlLayer) {
    return kmlLayer.getStatus();
  },
  getUrl: function getUrl(kmlLayer) {
    return kmlLayer.getUrl();
  },
  getZIndex: function getZIndex(kmlLayer) {
    return kmlLayer.getZIndex();
  }
};

var controlledPropUpdaterMap = {
  defaultViewport: function defaultViewport(kmlLayer, _defaultViewport) {
    kmlLayer.setDefaultViewport(_defaultViewport);
  },
  metadata: function metadata(kmlLayer, _metadata) {
    kmlLayer.setMetadata(_metadata);
  },
  options: function options(kmlLayer, _options) {
    kmlLayer.setOptions(_options);
  },
  status: function status(kmlLayer, _status) {
    kmlLayer.setStatus(_status);
  },
  url: function url(kmlLayer, _url) {
    kmlLayer.setUrl(_url);
  },
  zIndex: function zIndex(kmlLayer, _zIndex) {
    kmlLayer.setZIndex(_zIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.KML_LAYER];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "KmlLayer",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#KmlLayer
    var kmlLayer = new google.maps.KmlLayer((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.KML_LAYER, kmlLayer);
  },
  componentWillUnmount: function componentWillUnmount() {
    var kmlLayer = getInstanceFromComponent(this);
    if (kmlLayer) {
      kmlLayer.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2377 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _contextTypes; /* global google */


var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
  animation: _propTypes2.default.any,

  attribution: _propTypes2.default.any,

  clickable: _propTypes2.default.bool,

  cursor: _propTypes2.default.string,

  draggable: _propTypes2.default.bool,

  icon: _propTypes2.default.any,

  label: _propTypes2.default.any,

  noRedraw: _propTypes2.default.bool,

  opacity: _propTypes2.default.number,

  options: _propTypes2.default.object,

  place: _propTypes2.default.any,

  position: _propTypes2.default.any,

  shape: _propTypes2.default.any,

  title: _propTypes2.default.string,

  visible: _propTypes2.default.bool,

  zIndex: _propTypes2.default.number
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onAnimationChanged: "animation_changed",

  onClick: "click",

  onClickableChanged: "clickable_changed",

  onCursorChanged: "cursor_changed",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDraggableChanged: "draggable_changed",

  onDragStart: "dragstart",

  onFlatChanged: "flat_changed",

  onIconChanged: "icon_changed",

  onMouseDown: "mousedown",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onPositionChanged: "position_changed",

  onRightClick: "rightclick",

  onShapeChanged: "shape_changed",

  onTitleChanged: "title_changed",

  onVisibleChanged: "visible_changed",

  onZindexChanged: "zindex_changed"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getAnimation: function getAnimation(marker) {
    return marker.getAnimation();
  },
  getAttribution: function getAttribution(marker) {
    return marker.getAttribution();
  },
  getClickable: function getClickable(marker) {
    return marker.getClickable();
  },
  getCursor: function getCursor(marker) {
    return marker.getCursor();
  },
  getDraggable: function getDraggable(marker) {
    return marker.getDraggable();
  },
  getIcon: function getIcon(marker) {
    return marker.getIcon();
  },
  getLabel: function getLabel(marker) {
    return marker.getLabel();
  },
  getOpacity: function getOpacity(marker) {
    return marker.getOpacity();
  },
  getPlace: function getPlace(marker) {
    return marker.getPlace();
  },
  getPosition: function getPosition(marker) {
    return marker.getPosition();
  },
  getShape: function getShape(marker) {
    return marker.getShape();
  },
  getTitle: function getTitle(marker) {
    return marker.getTitle();
  },
  getVisible: function getVisible(marker) {
    return marker.getVisible();
  },
  getZIndex: function getZIndex(marker) {
    return marker.getZIndex();
  }
};

var controlledPropUpdaterMap = {
  animation: function animation(marker, _animation) {
    marker.setAnimation(_animation);
  },
  attribution: function attribution(marker, _attribution) {
    marker.setAttribution(_attribution);
  },
  clickable: function clickable(marker, _clickable) {
    marker.setClickable(_clickable);
  },
  cursor: function cursor(marker, _cursor) {
    marker.setCursor(_cursor);
  },
  draggable: function draggable(marker, _draggable) {
    marker.setDraggable(_draggable);
  },
  icon: function icon(marker, _icon) {
    marker.setIcon(_icon);
  },
  label: function label(marker, _label) {
    marker.setLabel(_label);
  },
  opacity: function opacity(marker, _opacity) {
    marker.setOpacity(_opacity);
  },
  options: function options(marker, _options) {
    marker.setOptions(_options);
  },
  place: function place(marker, _place) {
    marker.setPlace(_place);
  },
  position: function position(marker, _position) {
    marker.setPosition(_position);
  },
  shape: function shape(marker, _shape) {
    marker.setShape(_shape);
  },
  title: function title(marker, _title) {
    marker.setTitle(_title);
  },
  visible: function visible(marker, _visible) {
    marker.setVisible(_visible);
  },
  zIndex: function zIndex(marker, _zIndex) {
    marker.setZIndex(_zIndex);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.MARKER];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Marker",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (_contextTypes = {}, (0, _defineProperty3.default)(_contextTypes, _constants.MAP, _propTypes2.default.object), (0, _defineProperty3.default)(_contextTypes, _constants.MARKER_CLUSTERER, _propTypes2.default.object), _contextTypes),

  childContextTypes: (0, _defineProperty3.default)({}, _constants.ANCHOR, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Marker
    var marker = new google.maps.Marker((0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props));
    var markerClusterer = this.context[_constants.MARKER_CLUSTERER];
    if (markerClusterer) {
      markerClusterer.addMarker(marker, !!this.props.noRedraw);
    } else {
      marker.setMap(this.context[_constants.MAP]);
    }
    return (0, _defineProperty3.default)({}, _constants.MARKER, marker);
  },
  getChildContext: function getChildContext() {
    return (0, _defineProperty3.default)({}, _constants.ANCHOR, this.context[_constants.ANCHOR] || getInstanceFromComponent(this));
  },
  componentWillUnmount: function componentWillUnmount() {
    var marker = getInstanceFromComponent(this);
    if (marker) {
      var markerClusterer = this.context[_constants.MARKER_CLUSTERER];
      if (markerClusterer) {
        markerClusterer.removeMarker(marker, !!this.props.noRedraw);
      }
      marker.setMap(null);
    }
  },
  render: function render() {
    var children = this.props.children;


    return _react2.default.createElement(
      "div",
      null,
      children
    );
  }
});

/***/ }),
/* 2378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _delay2 = __webpack_require__(2245);

var _delay3 = _interopRequireDefault(_delay2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

var _OverlayViewHelper = __webpack_require__(2385);

var helpers = _interopRequireWildcard(_OverlayViewHelper);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
  mapPaneName: _propTypes2.default.string,
  position: _propTypes2.default.object,
  bounds: _propTypes2.default.object
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getPanes: function getPanes(overlayView) {
    return overlayView.getPanes();
  },
  getProjection: function getProjection(overlayView) {
    return overlayView.getProjection();
  }
};

var controlledPropUpdaterMap = {};

function getInstanceFromComponent(component) {
  return component.state[_constants.OVERLAY_VIEW];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "OverlayView",

  statics: {
    FLOAT_PANE: "floatPane",
    MAP_PANE: "mapPane",
    MARKER_LAYER: "markerLayer",
    OVERLAY_LAYER: "overlayLayer",
    OVERLAY_MOUSE_TARGET: "overlayMouseTarget"
  },

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes, {
    children: _propTypes2.default.node.isRequired,
    getPixelPositionOffset: _propTypes2.default.func
  }),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
    var overlayView = new google.maps.OverlayView();
    // You must implement three methods: onAdd(), draw(), and onRemove().
    overlayView.onAdd = this.onAdd;
    overlayView.draw = this.draw;
    overlayView.onRemove = this.onRemove;
    // You must call setMap() with a valid Map object to trigger the call to
    // the onAdd() method and setMap(null) in order to trigger the onRemove() method.
    overlayView.setMap(this.context[_constants.MAP]);
    return (0, _defineProperty3.default)({}, _constants.OVERLAY_VIEW, overlayView);
  },
  onAdd: function onAdd() {
    this._containerElement = helpers.createContainerElement();
  },
  draw: function draw() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#OverlayView
    var overlayView = getInstanceFromComponent(this);
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
    var mapPanes = overlayView.getPanes();
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapCanvasProjection
    var mapCanvasProjection = overlayView.getProjection();
    //
    var props = (0, _extends3.default)({}, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props), {
      children: this.props.children,
      getPixelPositionOffset: this.props.getPixelPositionOffset
    });
    helpers.mountContainerElementToPane(mapPanes, this._containerElement, props);
    helpers.renderChildToContainerElement(mapCanvasProjection, this._containerElement, props);
  },
  onRemove: function onRemove() {
    helpers.unmountAndDestroyContainerElement(this._containerElement);
    this._containerElement = null;
  },
  componentDidUpdate: function componentDidUpdate() {
    (0, _delay3.default)(this.draw);
  },
  componentWillUnmount: function componentWillUnmount() {
    var overlayView = getInstanceFromComponent(this);
    if (overlayView) {
      overlayView.setMap(null);
      // You must implement three methods: onAdd(), draw(), and onRemove().
      overlayView.onAdd = null;
      overlayView.draw = null;
      overlayView.onRemove = null;
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
  draggable: _propTypes2.default.bool,
  editable: _propTypes2.default.bool,
  options: _propTypes2.default.object,
  path: _propTypes2.default.any,
  paths: _propTypes2.default.any,
  visible: _propTypes2.default.bool
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDraggable: function getDraggable(polygon) {
    return polygon.getDraggable();
  },
  getEditable: function getEditable(polygon) {
    return polygon.getEditable();
  },
  getPath: function getPath(polygon) {
    return polygon.getPath();
  },
  getPaths: function getPaths(polygon) {
    return polygon.getPaths();
  },
  getVisible: function getVisible(polygon) {
    return polygon.getVisible();
  }
};

var controlledPropUpdaterMap = {
  draggable: function draggable(polygon, _draggable) {
    polygon.setDraggable(_draggable);
  },
  editable: function editable(polygon, _editable) {
    polygon.setEditable(_editable);
  },
  options: function options(polygon, _options) {
    polygon.setOptions(_options);
  },
  path: function path(polygon, _path) {
    polygon.setPath(_path);
  },
  paths: function paths(polygon, _paths) {
    polygon.setPaths(_paths);
  },
  visible: function visible(polygon, _visible) {
    polygon.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.POLYGON];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Polygon",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polygon
    var polygon = new google.maps.Polygon((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.POLYGON, polygon);
  },
  componentWillUnmount: function componentWillUnmount() {
    var polygon = getInstanceFromComponent(this);
    if (polygon) {
      polygon.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
  draggable: _propTypes2.default.bool,
  editable: _propTypes2.default.bool,
  options: _propTypes2.default.object,
  path: _propTypes2.default.any,
  visible: _propTypes2.default.bool
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getDraggable: function getDraggable(polyline) {
    return polyline.getDraggable();
  },
  getEditable: function getEditable(polyline) {
    return polyline.getEditable();
  },
  getPath: function getPath(polyline) {
    return polyline.getPath();
  },
  getVisible: function getVisible(polyline) {
    return polyline.getVisible();
  }
};

var controlledPropUpdaterMap = {
  draggable: function draggable(polyline, _draggable) {
    polyline.setDraggable(_draggable);
  },
  editable: function editable(polyline, _editable) {
    polyline.setEditable(_editable);
  },
  options: function options(polyline, _options) {
    polyline.setOptions(_options);
  },
  path: function path(polyline, _path) {
    polyline.setPath(_path);
  },
  visible: function visible(polyline, _visible) {
    polyline.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.POLYLINE];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Polyline",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Polyline
    var polyline = new google.maps.Polyline((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.POLYLINE, polyline);
  },
  componentWillUnmount: function componentWillUnmount() {
    var polyline = getInstanceFromComponent(this);
    if (polyline) {
      polyline.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
  bounds: _propTypes2.default.any,
  draggable: _propTypes2.default.bool,
  editable: _propTypes2.default.bool,
  options: _propTypes2.default.object,
  visible: _propTypes2.default.bool
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onBoundsChanged: "bounds_changed",

  onClick: "click",

  onDblClick: "dblclick",

  onDrag: "drag",

  onDragEnd: "dragend",

  onDragStart: "dragstart",

  onMouseDown: "mousedown",

  onMouseMove: "mousemove",

  onMouseOut: "mouseout",

  onMouseOver: "mouseover",

  onMouseUp: "mouseup",

  onRightClick: "rightclick"
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getBounds: function getBounds(rectangle) {
    return rectangle.getBounds();
  },
  getDraggable: function getDraggable(rectangle) {
    return rectangle.getDraggable();
  },
  getEditable: function getEditable(rectangle) {
    return rectangle.getEditable();
  },
  getVisible: function getVisible(rectangle) {
    return rectangle.getVisible();
  }
};

var controlledPropUpdaterMap = {
  bounds: function bounds(rectangle, _bounds) {
    rectangle.setBounds(_bounds);
  },
  draggable: function draggable(rectangle, _draggable) {
    rectangle.setDraggable(_draggable);
  },
  editable: function editable(rectangle, _editable) {
    rectangle.setEditable(_editable);
  },
  options: function options(rectangle, _options) {
    rectangle.setOptions(_options);
  },
  visible: function visible(rectangle, _visible) {
    rectangle.setVisible(_visible);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.RECTANGLE];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "Rectangle",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Rectangle
    var rectangle = new google.maps.Rectangle((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.RECTANGLE, rectangle);
  },
  componentWillUnmount: function componentWillUnmount() {
    var rectangle = getInstanceFromComponent(this);
    if (rectangle) {
      rectangle.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2382 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
  links: _propTypes2.default.array,
  motionTracking: _propTypes2.default.bool,
  options: _propTypes2.default.object,
  pano: _propTypes2.default.string,
  panoProvider: _propTypes2.default.func,
  position: _propTypes2.default.object,
  pov: _propTypes2.default.object,
  visible: _propTypes2.default.bool,
  zoom: _propTypes2.default.number
}; /* global google */


var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  onCloseClick: "closeclick",

  onPanoChanged: "pano_changed",

  onPositionChanged: "position_changed",

  onLinksChanged: "links_changed",

  onPovChanged: "pov_changed",

  onResize: "resize",

  onStatusChanged: "status_changed",

  onVisibleChanged: "visible_changed",

  onZoomChanged: "zoom_changed"

};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  getLinks: function getLinks(streetViewPanorama) {
    return streetViewPanorama.getLinks();
  },
  getLocation: function getLocation(streetViewPanorama) {
    return streetViewPanorama.getLocation();
  },
  getMotionTracking: function getMotionTracking(streetViewPanorama) {
    return streetViewPanorama.getMotionTracking();
  },
  getPano: function getPano(streetViewPanorama) {
    return streetViewPanorama.getPano();
  },
  getPhotographerPov: function getPhotographerPov(streetViewPanorama) {
    return streetViewPanorama.getPhotographerPov();
  },
  getPosition: function getPosition(streetViewPanorama) {
    return streetViewPanorama.getPosition();
  },
  getPov: function getPov(streetViewPanorama) {
    return streetViewPanorama.getPov();
  },
  getStatus: function getStatus(streetViewPanorama) {
    return streetViewPanorama.getStatus();
  },
  getVisible: function getVisible(streetViewPanorama) {
    return streetViewPanorama.getVisible();
  },
  getZoom: function getZoom(streetViewPanorama) {
    return streetViewPanorama.getZoom();
  }
};

var controlledPropUpdaterMap = {
  links: function links(streetViewPanorama, _links) {
    streetViewPanorama.setLinks(_links);
  },
  motionTracking: function motionTracking(streetViewPanorama, _motionTracking) {
    streetViewPanorama.setMotionTracking(_motionTracking);
  },
  options: function options(streetViewPanorama, _options) {
    streetViewPanorama.setOptions(_options);
  },
  pano: function pano(streetViewPanorama, _pano) {
    streetViewPanorama.setPano(_pano);
  },
  panoProvider: function panoProvider(streetViewPanorama, _panoProvider) {
    streetViewPanorama.registerPanoProvider(_panoProvider);
  },
  position: function position(streetViewPanorama, _position) {
    streetViewPanorama.setPosition(_position);
  },
  pov: function pov(streetViewPanorama, _pov) {
    streetViewPanorama.setPov(_pov);
  },
  visible: function visible(streetViewPanorama, _visible) {
    streetViewPanorama.setVisible(_visible);
  },
  zoom: function zoom(streetViewPanorama, _zoom) {
    streetViewPanorama.setZoom(_zoom);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.STREET_VIEW_PANORAMA];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "StreetViewPanorama",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  childContextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialOptions: function getInitialOptions() {
    return (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props);
  },
  getChildContext: function getChildContext() {
    return (0, _defineProperty3.default)({}, _constants.MAP, this.state[_constants.STREET_VIEW_PANORAMA]);
  },
  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#StreetViewPanorama
    var streetViewPanorama = void 0;
    if (!this.props.containerElement && this.context[_constants.MAP]) {
      streetViewPanorama = this.context[_constants.MAP].getStreetView();
      streetViewPanorama.setOptions(this.getInitialOptions());
    }
    if (!this.props.containerElement && !this.context[_constants.MAP]) {
      throw new Error("You need to use the StreetViewPanorama in the context of `<GoogleMap>` or pass an `containerElement` for it to be rendered in.");
    }
    return (0, _defineProperty3.default)({}, _constants.STREET_VIEW_PANORAMA, streetViewPanorama);
  },
  handleComponentMount: function handleComponentMount(el) {
    this.el = el;
    if (this.el) {
      var streetViewPanorama = new google.maps.StreetViewPanorama(this.el, (0, _extends3.default)({
        map: this.context[_constants.MAP]
      }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
      if (this.context[_constants.MAP]) {
        this.context[_constants.MAP].setStreetView(streetViewPanorama);
      }
      this.setState((0, _defineProperty3.default)({}, _constants.STREET_VIEW_PANORAMA, streetViewPanorama));
    }
  },
  componentWillUnmount: function componentWillUnmount() {
    var streetViewPanorama = getInstanceFromComponent(this);
    if (streetViewPanorama) {
      streetViewPanorama.setVisible(false);
    }
  },
  render: function render() {
    if (this.props.containerElement) {
      return _react2.default.cloneElement(this.props.containerElement, { ref: this.handleComponentMount }, this.props.children);
    }
    return _react2.default.createElement(
      "div",
      null,
      this.props.children
    );
  }
});

/***/ }),
/* 2383 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _flowRight2 = __webpack_require__(71);

var _flowRight3 = _interopRequireDefault(_flowRight2);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _createReactClass = __webpack_require__(41);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _constants = __webpack_require__(74);

var _enhanceElement = __webpack_require__(86);

var _enhanceElement2 = _interopRequireDefault(_enhanceElement);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
var controlledPropTypes = {
  // NOTICE!!!!!!
  //
  // Only expose those with getters & setters in the table as controlled props.
  //
  // [].map.call($0.querySelectorAll("tr>td>code", function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^set/) && !it.match(/^setMap/); })
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
  options: _propTypes2.default.object
};

var defaultUncontrolledPropTypes = (0, _enhanceElement.addDefaultPrefixToPropTypes)(controlledPropTypes);

var eventMap = {
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
};

var publicMethodMap = {
  // Public APIs
  //
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
  //
  // [].map.call($0.querySelectorAll("tr>td>code"), function(it){ return it.textContent; })
  //    .filter(function(it){ return it.match(/^get/) && !it.match(/Map$/); })
  // END - Public APIs
};

var controlledPropUpdaterMap = {
  options: function options(trafficLayer, _options) {
    trafficLayer.setOptions(_options);
  }
};

function getInstanceFromComponent(component) {
  return component.state[_constants.TRAFFIC_LAYER];
}

exports.default = (0, _flowRight3.default)(_createReactClass2.default, (0, _enhanceElement2.default)(getInstanceFromComponent, publicMethodMap, eventMap, controlledPropUpdaterMap))({
  displayName: "TrafficLayer",

  propTypes: (0, _extends3.default)({}, controlledPropTypes, defaultUncontrolledPropTypes),

  contextTypes: (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object),

  getInitialState: function getInitialState() {
    // https://developers.google.com/maps/documentation/javascript/3.exp/reference#TrafficLayer
    var trafficLayer = new google.maps.TrafficLayer((0, _extends3.default)({
      map: this.context[_constants.MAP]
    }, (0, _enhanceElement.collectUncontrolledAndControlledProps)(defaultUncontrolledPropTypes, controlledPropTypes, this.props)));
    return (0, _defineProperty3.default)({}, _constants.TRAFFIC_LAYER, trafficLayer);
  },
  componentWillUnmount: function componentWillUnmount() {
    var trafficLayer = getInstanceFromComponent(this);
    if (trafficLayer) {
      trafficLayer.setMap(null);
    }
  },
  render: function render() {
    return false;
  }
});

/***/ }),
/* 2384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _withGoogleMap = __webpack_require__(2386);

Object.defineProperty(exports, "withGoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_withGoogleMap).default;
  }
});

var _GoogleMap = __webpack_require__(2374);

Object.defineProperty(exports, "GoogleMap", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_GoogleMap).default;
  }
});

var _Marker = __webpack_require__(2377);

Object.defineProperty(exports, "Marker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Marker).default;
  }
});

var _Rectangle = __webpack_require__(2381);

Object.defineProperty(exports, "Rectangle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Rectangle).default;
  }
});

var _Polyline = __webpack_require__(2380);

Object.defineProperty(exports, "Polyline", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polyline).default;
  }
});

var _Polygon = __webpack_require__(2379);

Object.defineProperty(exports, "Polygon", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Polygon).default;
  }
});

var _Circle = __webpack_require__(2371);

Object.defineProperty(exports, "Circle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Circle).default;
  }
});

var _KmlLayer = __webpack_require__(2376);

Object.defineProperty(exports, "KmlLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_KmlLayer).default;
  }
});

var _FusionTablesLayer = __webpack_require__(2373);

Object.defineProperty(exports, "FusionTablesLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FusionTablesLayer).default;
  }
});

var _TrafficLayer = __webpack_require__(2383);

Object.defineProperty(exports, "TrafficLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrafficLayer).default;
  }
});

var _DirectionsRenderer = __webpack_require__(2372);

Object.defineProperty(exports, "DirectionsRenderer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DirectionsRenderer).default;
  }
});

var _InfoWindow = __webpack_require__(2375);

Object.defineProperty(exports, "InfoWindow", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_InfoWindow).default;
  }
});

var _OverlayView = __webpack_require__(2378);

Object.defineProperty(exports, "OverlayView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_OverlayView).default;
  }
});

var _StreetViewPanorama = __webpack_require__(2382);

Object.defineProperty(exports, "StreetViewPanorama", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_StreetViewPanorama).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 2385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(8);

var _extends3 = _interopRequireDefault(_extends2);

var _assign2 = __webpack_require__(2240);

var _assign3 = _interopRequireDefault(_assign2);

var _isFunction2 = __webpack_require__(370);

var _isFunction3 = _interopRequireDefault(_isFunction2);

exports.createContainerElement = createContainerElement;
exports.mountContainerElementToPane = mountContainerElementToPane;
exports.renderChildToContainerElement = renderChildToContainerElement;
exports.unmountAndDestroyContainerElement = unmountAndDestroyContainerElement;

var _invariant = __webpack_require__(52);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(1);

var _reactDom = __webpack_require__(112);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createContainerElement() {
  var containerElement = document.createElement("div");
  containerElement.style.position = "absolute";
  return containerElement;
} /* global google */
function mountContainerElementToPane(mapPanes, containerElement, props) {
  var mapPaneName = props.mapPaneName;

  (0, _invariant2.default)(!!mapPaneName, "OverlayView requires either props.mapPaneName or props.defaultMapPaneName but got %s", mapPaneName);
  // https://developers.google.com/maps/documentation/javascript/3.exp/reference#MapPanes
  mapPanes[mapPaneName].appendChild(containerElement);
}

function getOffsetOverride(containerElement, props) {
  var getPixelPositionOffset = props.getPixelPositionOffset;
  //
  // Allows the component to control the visual position of the OverlayView
  // relative to the LatLng pixel position.
  //

  if ((0, _isFunction3.default)(getPixelPositionOffset)) {
    return getPixelPositionOffset(containerElement.offsetWidth, containerElement.offsetHeight);
  } else {
    return {};
  }
}

function createLatLng(inst, Type) {
  return new Type(inst.lat, inst.lng);
}

function createLatLngBounds(inst, Type) {
  return new Type(new google.maps.LatLng(inst.ne.lat, inst.ne.lng), new google.maps.LatLng(inst.sw.lat, inst.sw.lng));
}

function ensureOfType(inst, type, factory) {
  if (inst instanceof type) {
    return inst;
  } else {
    return factory(inst, type);
  }
}

function getLayoutStylesByBounds(mapCanvasProjection, offset, bounds) {
  var ne = mapCanvasProjection.fromLatLngToDivPixel(bounds.getNorthEast());
  var sw = mapCanvasProjection.fromLatLngToDivPixel(bounds.getSouthWest());
  if (ne && sw) {
    return {
      left: sw.x + offset.x + "px",
      top: ne.y + offset.y + "px",
      width: ne.x - sw.x - offset.x + "px",
      height: sw.y - ne.y - offset.y + "px"
    };
  }
  return {
    left: "-9999px",
    top: "-9999px"
  };
}

function getLayoutStylesByPosition(mapCanvasProjection, offset, position) {
  var point = mapCanvasProjection.fromLatLngToDivPixel(position);
  if (point) {
    var x = point.x,
        y = point.y;

    return {
      left: x + offset.x + "px",
      top: y + offset.y + "px"
    };
  }
  return {
    left: "-9999px",
    top: "-9999px"
  };
}

function getLayoutStyles(mapCanvasProjection, offset, props) {
  if (props.bounds) {
    var bounds = ensureOfType(props.bounds, google.maps.LatLngBounds, createLatLngBounds);
    return getLayoutStylesByBounds(mapCanvasProjection, offset, bounds);
  } else {
    var position = ensureOfType(props.position, google.maps.LatLng, createLatLng);
    return getLayoutStylesByPosition(mapCanvasProjection, offset, position);
  }
}

function renderChildToContainerElement(mapCanvasProjection, containerElement, props) {
  var child = _react.Children.only(props.children);
  (0, _reactDom.render)(child, containerElement, function () {
    var offset = (0, _extends3.default)({
      x: 0,
      y: 0
    }, getOffsetOverride(containerElement, props));
    var layoutStyles = getLayoutStyles(mapCanvasProjection, offset, props);
    (0, _assign3.default)(containerElement.style, layoutStyles);
  });
}

function unmountAndDestroyContainerElement(containerElement) {
  containerElement.parentNode.removeChild(containerElement);
  (0, _reactDom.unmountComponentAtNode)(containerElement);
}

/***/ }),
/* 2386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(233);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = __webpack_require__(60);

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = __webpack_require__(40);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(43);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(62);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(61);

var _inherits3 = _interopRequireDefault(_inherits2);

exports.default = withGoogleMap;

var _warning = __webpack_require__(141);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(52);

var _invariant2 = _interopRequireDefault(_invariant);

var _reactDisplayName = __webpack_require__(2307);

var _reactDisplayName2 = _interopRequireDefault(_reactDisplayName);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _constants = __webpack_require__(74);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* global google */
function withGoogleMap(WrappedComponent) {
  var _class, _temp2;

  return _temp2 = _class = function (_Component) {
    (0, _inherits3.default)(Container, _Component);

    function Container() {
      var _ref;

      var _temp, _this, _ret;

      (0, _classCallCheck3.default)(this, Container);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Container.__proto__ || (0, _getPrototypeOf2.default)(Container)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
        map: null
      }, _this.handleComponentMount = _this.handleComponentMount.bind(_this), _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(Container, [{
      key: "getChildContext",
      value: function getChildContext() {
        return (0, _defineProperty3.default)({}, _constants.MAP, this.state.map);
      }
    }, {
      key: "componentWillMount",
      value: function componentWillMount() {
        var _props = this.props,
            containerElement = _props.containerElement,
            mapElement = _props.mapElement;

        (0, _invariant2.default)(!!containerElement && !!mapElement, "Required props containerElement or mapElement is missing. You need to provide both of them.\n The `google.maps.Map` instance will be initialized on mapElement and it's wrapped by containerElement.\nYou need to provide both of them since Google Map requires the DOM to have height when initialized.");
      }
    }, {
      key: "handleComponentMount",
      value: function handleComponentMount(node) {
        if (this.state.map || node === null) {
          return;
        }
        (0, _warning2.default)("undefined" !== typeof google, "Make sure you've put a <script> tag in your <head> element to load Google Maps JavaScript API v3.\n If you're looking for built-in support to load it for you, use the \"async/ScriptjsLoader\" instead.\n See https://github.com/tomchentw/react-google-maps/pull/168");
        // https://developers.google.com/maps/documentation/javascript/3.exp/reference#Map
        var map = new google.maps.Map(node);
        this.setState({ map: map });
      }
    }, {
      key: "render",
      value: function render() {
        var _props2 = this.props,
            containerElement = _props2.containerElement,
            mapElement = _props2.mapElement,
            restProps = (0, _objectWithoutProperties3.default)(_props2, ["containerElement", "mapElement"]);
        var map = this.state.map;


        if (map) {
          return _react2.default.cloneElement(containerElement, {}, _react2.default.cloneElement(mapElement, {
            ref: this.handleComponentMount
          }), _react2.default.createElement(
            "div",
            null,
            _react2.default.createElement(WrappedComponent, restProps)
          ));
        } else {
          return _react2.default.cloneElement(containerElement, {}, _react2.default.cloneElement(mapElement, {
            ref: this.handleComponentMount
          }), _react2.default.createElement("div", null));
        }
      }
    }]);
    return Container;
  }(_react.Component), _class.displayName = "withGoogleMap(" + (0, _reactDisplayName2.default)(WrappedComponent) + ")", _class.propTypes = {
    containerElement: _propTypes2.default.node.isRequired,
    mapElement: _propTypes2.default.node.isRequired
  }, _class.childContextTypes = (0, _defineProperty3.default)({}, _constants.MAP, _propTypes2.default.object), _temp2;
}

/***/ }),
/* 2387 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(2407);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _deepEqual = __webpack_require__(1636);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _HelmetUtils = __webpack_require__(2388);

var _HelmetConstants = __webpack_require__(943);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _deepEqual2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
            * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
            * @param {Object} bodyAttributes: {"className": "root"}
            * @param {String} defaultTitle: "Default Title"
            * @param {Boolean} defer: true
            * @param {Boolean} encodeSpecialCharacters: true
            * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
            * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
            * @param {Array} meta: [{"name": "description", "content": "Test description"}]
            * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
            * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
            * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
            * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
            * @param {String} title: "Title"
            * @param {Object} titleAttributes: {"itemprop": "name"}
            * @param {String} titleTemplate: "MySite.com - %s"
            */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 2388 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(34);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(943);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 2389 */,
/* 2390 */,
/* 2391 */,
/* 2392 */,
/* 2393 */,
/* 2394 */,
/* 2395 */,
/* 2396 */,
/* 2397 */,
/* 2398 */,
/* 2399 */,
/* 2400 */,
/* 2401 */,
/* 2402 */,
/* 2403 */,
/* 2404 */,
/* 2405 */,
/* 2406 */,
/* 2407 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(1);
var React__default = _interopDefault(React);
var ExecutionEnvironment = _interopDefault(__webpack_require__(2095));
var shallowEqual = _interopDefault(__webpack_require__(2621));

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }
  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }
  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state = void 0;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect = function (_Component) {
      _inherits(SideEffect, _Component);

      function SideEffect() {
        _classCallCheck(this, SideEffect);

        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
      }

      // Try to use displayName of wrapped component
      SideEffect.peek = function peek() {
        return state;
      };

      // Expose canUseDOM so tests can monkeypatch it


      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      SideEffect.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      SideEffect.prototype.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      SideEffect.prototype.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      SideEffect.prototype.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      SideEffect.prototype.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    SideEffect.displayName = 'SideEffect(' + getDisplayName(WrappedComponent) + ')';
    SideEffect.canUseDOM = ExecutionEnvironment.canUseDOM;


    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 2408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(953);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });





/***/ }),
/* 2409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AutoSizer__ = __webpack_require__(954);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__AutoSizer__["a"]; });





/***/ }),
/* 2410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = idCellSizeCache;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defaultCellSizeCache__ = __webpack_require__(568);


/**
 * Alternate CellMeasurer `cellSizeCache` implementation.
 * Similar to `defaultCellSizeCache` except that sizes are tied to data id rather than index.
 * Requires an index-to-id map function (passed in externally) to operate.
 */
function idCellSizeCache(_ref) {
  var indexToIdMap = _ref.indexToIdMap;
  var _ref$uniformColumnWid = _ref.uniformColumnWidth;
  var uniformColumnWidth = _ref$uniformColumnWid === undefined ? false : _ref$uniformColumnWid;
  var _ref$uniformRowHeight = _ref.uniformRowHeight;
  var uniformRowHeight = _ref$uniformRowHeight === undefined ? false : _ref$uniformRowHeight;

  var cellSizeCache = new __WEBPACK_IMPORTED_MODULE_0__defaultCellSizeCache__["a" /* default */]({
    uniformColumnWidth: uniformColumnWidth,
    uniformRowHeight: uniformRowHeight
  });

  return {
    clearAllColumnWidths: function clearAllColumnWidths() {
      cellSizeCache.clearAllColumnWidths();
    },
    clearAllRowHeights: function clearAllRowHeights() {
      cellSizeCache.clearAllRowHeights();
    },
    clearColumnWidth: function clearColumnWidth(index) {
      cellSizeCache.clearColumnWidth(indexToIdMap(index));
    },
    clearRowHeight: function clearRowHeight(index) {
      cellSizeCache.clearRowHeight(indexToIdMap(index));
    },
    getColumnWidth: function getColumnWidth(index) {
      return cellSizeCache.getColumnWidth(indexToIdMap(index));
    },
    getRowHeight: function getRowHeight(index) {
      return cellSizeCache.getRowHeight(indexToIdMap(index));
    },
    setColumnWidth: function setColumnWidth(index, width) {
      cellSizeCache.setColumnWidth(indexToIdMap(index), width);
    },
    setRowHeight: function setRowHeight(index, height) {
      cellSizeCache.setRowHeight(indexToIdMap(index), height);
    }
  };
}

/***/ }),
/* 2411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__ = __webpack_require__(955);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__CellMeasurer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellSizeCache__ = __webpack_require__(568);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__defaultCellSizeCache__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__idCellSizeCache__ = __webpack_require__(2410);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__idCellSizeCache__["a"]; });









/***/ }),
/* 2412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_classnames___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_classnames__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__ = __webpack_require__(834);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare__);












// @TODO It would be nice to refactor Grid to use this code as well.

/**
 * Specifies the number of miliseconds during which to disable pointer events while a scroll is in progress.
 * This improves performance and makes scrolling smoother.
 */
var IS_SCROLLING_TIMEOUT = 150;

/**
 * Controls whether the Grid updates the DOM element's scrollLeft/scrollTop based on the current state or just observes it.
 * This prevents Grid from interrupting mouse-wheel animations (see issue #2).
 */
var SCROLL_POSITION_CHANGE_REASONS = {
  OBSERVED: 'observed',
  REQUESTED: 'requested'
};

/**
 * Monitors changes in properties (eg. cellCount) and state (eg. scroll offsets) to determine when rendering needs to occur.
 * This component does not render any visible content itself; it defers to the specified :cellLayoutManager.
 */

var CollectionView = function (_Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CollectionView, _Component);

  function CollectionView(props, context) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CollectionView);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CollectionView.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CollectionView)).call(this, props, context));

    _this.state = {
      calculateSizeAndPositionDataOnNextUpdate: false,
      isScrolling: false,
      scrollLeft: 0,
      scrollTop: 0
    };

    // Invokes callbacks only when their values have changed.
    _this._onSectionRenderedMemoizer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__["a" /* default */])();
    _this._onScrollMemoizer = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_8__utils_createCallbackMemoizer__["a" /* default */])(false);

    // Bind functions to instance so they don't lose context when passed around.
    _this._invokeOnSectionRenderedHelper = _this._invokeOnSectionRenderedHelper.bind(_this);
    _this._onScroll = _this._onScroll.bind(_this);
    _this._updateScrollPositionForScrollToCell = _this._updateScrollPositionForScrollToCell.bind(_this);
    return _this;
  }

  /**
   * Forced recompute of cell sizes and positions.
   * This function should be called if cell sizes have changed but nothing else has.
   * Since cell positions are calculated by callbacks, the collection view has no way of detecting when the underlying data has changed.
   */


  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CollectionView, [{
    key: 'recomputeCellSizesAndPositions',
    value: function recomputeCellSizesAndPositions() {
      this.setState({
        calculateSizeAndPositionDataOnNextUpdate: true
      });
    }

    /* ---------------------------- Component lifecycle methods ---------------------------- */

  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props;
      var cellLayoutManager = _props.cellLayoutManager;
      var scrollLeft = _props.scrollLeft;
      var scrollToCell = _props.scrollToCell;
      var scrollTop = _props.scrollTop;

      // If this component was first rendered server-side, scrollbar size will be undefined.
      // In that event we need to remeasure.

      if (!this._scrollbarSizeMeasured) {
        this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()();
        this._scrollbarSizeMeasured = true;
        this.setState({});
      }

      if (scrollToCell >= 0) {
        this._updateScrollPositionForScrollToCell();
      } else if (scrollLeft >= 0 || scrollTop >= 0) {
        this._setScrollPosition({ scrollLeft: scrollLeft, scrollTop: scrollTop });
      }

      // Update onSectionRendered callback.
      this._invokeOnSectionRenderedHelper();

      var _cellLayoutManager$ge = cellLayoutManager.getTotalSize();

      var totalHeight = _cellLayoutManager$ge.height;
      var totalWidth = _cellLayoutManager$ge.width;

      // Initialize onScroll callback.

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft || 0,
        scrollTop: scrollTop || 0,
        totalHeight: totalHeight,
        totalWidth: totalWidth
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate(prevProps, prevState) {
      var _props2 = this.props;
      var height = _props2.height;
      var scrollToAlignment = _props2.scrollToAlignment;
      var scrollToCell = _props2.scrollToCell;
      var width = _props2.width;
      var _state = this.state;
      var scrollLeft = _state.scrollLeft;
      var scrollPositionChangeReason = _state.scrollPositionChangeReason;
      var scrollTop = _state.scrollTop;

      // Make sure requested changes to :scrollLeft or :scrollTop get applied.
      // Assigning to scrollLeft/scrollTop tells the browser to interrupt any running scroll animations,
      // And to discard any pending async changes to the scroll position that may have happened in the meantime (e.g. on a separate scrolling thread).
      // So we only set these when we require an adjustment of the scroll position.
      // See issue #2 for more information.

      if (scrollPositionChangeReason === SCROLL_POSITION_CHANGE_REASONS.REQUESTED) {
        if (scrollLeft >= 0 && scrollLeft !== prevState.scrollLeft && scrollLeft !== this._scrollingContainer.scrollLeft) {
          this._scrollingContainer.scrollLeft = scrollLeft;
        }
        if (scrollTop >= 0 && scrollTop !== prevState.scrollTop && scrollTop !== this._scrollingContainer.scrollTop) {
          this._scrollingContainer.scrollTop = scrollTop;
        }
      }

      // Update scroll offsets if the current :scrollToCell values requires it
      if (height !== prevProps.height || scrollToAlignment !== prevProps.scrollToAlignment || scrollToCell !== prevProps.scrollToCell || width !== prevProps.width) {
        this._updateScrollPositionForScrollToCell();
      }

      // Update onRowsRendered callback if start/stop indices have changed
      this._invokeOnSectionRenderedHelper();
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var cellLayoutManager = this.props.cellLayoutManager;


      cellLayoutManager.calculateSizeAndPositionData();

      // If this component is being rendered server-side, getScrollbarSize() will return undefined.
      // We handle this case in componentDidMount()
      this._scrollbarSize = __WEBPACK_IMPORTED_MODULE_9_dom_helpers_util_scrollbarSize___default()();
      if (this._scrollbarSize === undefined) {
        this._scrollbarSizeMeasured = false;
        this._scrollbarSize = 0;
      } else {
        this._scrollbarSizeMeasured = true;
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }
    }

    /**
     * @private
     * This method updates scrollLeft/scrollTop in state for the following conditions:
     * 1) Empty content (0 rows or columns)
     * 2) New scroll props overriding the current state
     * 3) Cells-count or cells-size has changed, making previous scroll offsets invalid
     */

  }, {
    key: 'componentWillUpdate',
    value: function componentWillUpdate(nextProps, nextState) {
      if (nextProps.cellCount === 0 && (nextState.scrollLeft !== 0 || nextState.scrollTop !== 0)) {
        this._setScrollPosition({
          scrollLeft: 0,
          scrollTop: 0
        });
      } else if (nextProps.scrollLeft !== this.props.scrollLeft || nextProps.scrollTop !== this.props.scrollTop) {
        this._setScrollPosition({
          scrollLeft: nextProps.scrollLeft,
          scrollTop: nextProps.scrollTop
        });
      }

      if (nextProps.cellCount !== this.props.cellCount || nextProps.cellLayoutManager !== this.props.cellLayoutManager || nextState.calculateSizeAndPositionDataOnNextUpdate) {
        nextProps.cellLayoutManager.calculateSizeAndPositionData();
      }

      if (nextState.calculateSizeAndPositionDataOnNextUpdate) {
        this.setState({
          calculateSizeAndPositionDataOnNextUpdate: false
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props3 = this.props;
      var autoHeight = _props3.autoHeight;
      var cellCount = _props3.cellCount;
      var cellLayoutManager = _props3.cellLayoutManager;
      var className = _props3.className;
      var height = _props3.height;
      var horizontalOverscanSize = _props3.horizontalOverscanSize;
      var id = _props3.id;
      var noContentRenderer = _props3.noContentRenderer;
      var style = _props3.style;
      var verticalOverscanSize = _props3.verticalOverscanSize;
      var width = _props3.width;
      var _state2 = this.state;
      var isScrolling = _state2.isScrolling;
      var scrollLeft = _state2.scrollLeft;
      var scrollTop = _state2.scrollTop;

      var _cellLayoutManager$ge2 = cellLayoutManager.getTotalSize();

      var totalHeight = _cellLayoutManager$ge2.height;
      var totalWidth = _cellLayoutManager$ge2.width;

      // Safely expand the rendered area by the specified overscan amount

      var left = Math.max(0, scrollLeft - horizontalOverscanSize);
      var top = Math.max(0, scrollTop - verticalOverscanSize);
      var right = Math.min(totalWidth, scrollLeft + width + horizontalOverscanSize);
      var bottom = Math.min(totalHeight, scrollTop + height + verticalOverscanSize);

      var childrenToDisplay = height > 0 && width > 0 ? cellLayoutManager.cellRenderers({
        height: bottom - top,
        isScrolling: isScrolling,
        width: right - left,
        x: left,
        y: top
      }) : [];

      var collectionStyle = {
        boxSizing: 'border-box',
        direction: 'ltr',
        height: autoHeight ? 'auto' : height,
        position: 'relative',
        WebkitOverflowScrolling: 'touch',
        width: width,
        willChange: 'transform'
      };

      // Force browser to hide scrollbars when we know they aren't necessary.
      // Otherwise once scrollbars appear they may not disappear again.
      // For more info see issue #116
      var verticalScrollBarSize = totalHeight > height ? this._scrollbarSize : 0;
      var horizontalScrollBarSize = totalWidth > width ? this._scrollbarSize : 0;

      // Also explicitly init styles to 'auto' if scrollbars are required.
      // This works around an obscure edge case where external CSS styles have not yet been loaded,
      // But an initial scroll index of offset is set as an external prop.
      // Without this style, Grid would render the correct range of cells but would NOT update its internal offset.
      // This was originally reported via clauderic/react-infinite-calendar/issues/23
      collectionStyle.overflowX = totalWidth + verticalScrollBarSize <= width ? 'hidden' : 'auto';
      collectionStyle.overflowY = totalHeight + horizontalScrollBarSize <= height ? 'hidden' : 'auto';

      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
        'div',
        {
          ref: function ref(_ref) {
            _this2._scrollingContainer = _ref;
          },
          'aria-label': this.props['aria-label'],
          className: __WEBPACK_IMPORTED_MODULE_7_classnames___default()('ReactVirtualized__Collection', className),
          id: id,
          onScroll: this._onScroll,
          role: 'grid',
          style: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, collectionStyle, style),
          tabIndex: 0
        },
        cellCount > 0 && __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          'div',
          {
            className: 'ReactVirtualized__Collection__innerScrollContainer',
            style: {
              height: totalHeight,
              maxHeight: totalHeight,
              maxWidth: totalWidth,
              overflow: 'hidden',
              pointerEvents: isScrolling ? 'none' : '',
              width: totalWidth
            }
          },
          childrenToDisplay
        ),
        cellCount === 0 && noContentRenderer()
      );
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return __WEBPACK_IMPORTED_MODULE_10_react_addons_shallow_compare___default()(this, nextProps, nextState);
    }

    /* ---------------------------- Helper methods ---------------------------- */

    /**
     * Sets an :isScrolling flag for a small window of time.
     * This flag is used to disable pointer events on the scrollable portion of the Collection.
     * This prevents jerky/stuttery mouse-wheel scrolling.
     */

  }, {
    key: '_enablePointerEventsAfterDelay',
    value: function _enablePointerEventsAfterDelay() {
      var _this3 = this;

      if (this._disablePointerEventsTimeoutId) {
        clearTimeout(this._disablePointerEventsTimeoutId);
      }

      this._disablePointerEventsTimeoutId = setTimeout(function () {
        var isScrollingChange = _this3.props.isScrollingChange;


        isScrollingChange(false);

        _this3._disablePointerEventsTimeoutId = null;
        _this3.setState({
          isScrolling: false
        });
      }, IS_SCROLLING_TIMEOUT);
    }
  }, {
    key: '_invokeOnSectionRenderedHelper',
    value: function _invokeOnSectionRenderedHelper() {
      var _props4 = this.props;
      var cellLayoutManager = _props4.cellLayoutManager;
      var onSectionRendered = _props4.onSectionRendered;


      this._onSectionRenderedMemoizer({
        callback: onSectionRendered,
        indices: {
          indices: cellLayoutManager.getLastRenderedIndices()
        }
      });
    }
  }, {
    key: '_invokeOnScrollMemoizer',
    value: function _invokeOnScrollMemoizer(_ref2) {
      var _this4 = this;

      var scrollLeft = _ref2.scrollLeft;
      var scrollTop = _ref2.scrollTop;
      var totalHeight = _ref2.totalHeight;
      var totalWidth = _ref2.totalWidth;

      this._onScrollMemoizer({
        callback: function callback(_ref3) {
          var scrollLeft = _ref3.scrollLeft;
          var scrollTop = _ref3.scrollTop;
          var _props5 = _this4.props;
          var height = _props5.height;
          var onScroll = _props5.onScroll;
          var width = _props5.width;


          onScroll({
            clientHeight: height,
            clientWidth: width,
            scrollHeight: totalHeight,
            scrollLeft: scrollLeft,
            scrollTop: scrollTop,
            scrollWidth: totalWidth
          });
        },
        indices: {
          scrollLeft: scrollLeft,
          scrollTop: scrollTop
        }
      });
    }
  }, {
    key: '_setScrollPosition',
    value: function _setScrollPosition(_ref4) {
      var scrollLeft = _ref4.scrollLeft;
      var scrollTop = _ref4.scrollTop;

      var newState = {
        scrollPositionChangeReason: SCROLL_POSITION_CHANGE_REASONS.REQUESTED
      };

      if (scrollLeft >= 0) {
        newState.scrollLeft = scrollLeft;
      }

      if (scrollTop >= 0) {
        newState.scrollTop = scrollTop;
      }

      if (scrollLeft >= 0 && scrollLeft !== this.state.scrollLeft || scrollTop >= 0 && scrollTop !== this.state.scrollTop) {
        this.setState(newState);
      }
    }
  }, {
    key: '_updateScrollPositionForScrollToCell',
    value: function _updateScrollPositionForScrollToCell() {
      var _props6 = this.props;
      var cellLayoutManager = _props6.cellLayoutManager;
      var height = _props6.height;
      var scrollToAlignment = _props6.scrollToAlignment;
      var scrollToCell = _props6.scrollToCell;
      var width = _props6.width;
      var _state3 = this.state;
      var scrollLeft = _state3.scrollLeft;
      var scrollTop = _state3.scrollTop;


      if (scrollToCell >= 0) {
        var scrollPosition = cellLayoutManager.getScrollPositionForCell({
          align: scrollToAlignment,
          cellIndex: scrollToCell,
          height: height,
          scrollLeft: scrollLeft,
          scrollTop: scrollTop,
          width: width
        });

        if (scrollPosition.scrollLeft !== scrollLeft || scrollPosition.scrollTop !== scrollTop) {
          this._setScrollPosition(scrollPosition);
        }
      }
    }
  }, {
    key: '_onScroll',
    value: function _onScroll(event) {
      // In certain edge-cases React dispatches an onScroll event with an invalid target.scrollLeft / target.scrollTop.
      // This invalid event can be detected by comparing event.target to this component's scrollable DOM element.
      // See issue #404 for more information.
      if (event.target !== this._scrollingContainer) {
        return;
      }

      // Prevent pointer events from interrupting a smooth scroll
      this._enablePointerEventsAfterDelay();

      // When this component is shrunk drastically, React dispatches a series of back-to-back scroll events,
      // Gradually converging on a scrollTop that is within the bounds of the new, smaller height.
      // This causes a series of rapid renders that is slow for long lists.
      // We can avoid that by doing some simple bounds checking to ensure that scrollTop never exceeds the total height.
      var _props7 = this.props;
      var cellLayoutManager = _props7.cellLayoutManager;
      var height = _props7.height;
      var isScrollingChange = _props7.isScrollingChange;
      var width = _props7.width;

      var scrollbarSize = this._scrollbarSize;

      var _cellLayoutManager$ge3 = cellLayoutManager.getTotalSize();

      var totalHeight = _cellLayoutManager$ge3.height;
      var totalWidth = _cellLayoutManager$ge3.width;

      var scrollLeft = Math.max(0, Math.min(totalWidth - width + scrollbarSize, event.target.scrollLeft));
      var scrollTop = Math.max(0, Math.min(totalHeight - height + scrollbarSize, event.target.scrollTop));

      // Certain devices (like Apple touchpad) rapid-fire duplicate events.
      // Don't force a re-render if this is the case.
      // The mouse may move faster then the animation frame does.
      // Use requestAnimationFrame to avoid over-updating.
      if (this.state.scrollLeft !== scrollLeft || this.state.scrollTop !== scrollTop) {
        // Browsers with cancelable scroll events (eg. Firefox) interrupt scrolling animations if scrollTop/scrollLeft is set.
        // Other browsers (eg. Safari) don't scroll as well without the help under certain conditions (DOM or style changes during scrolling).
        // All things considered, this seems to be the best current work around that I'm aware of.
        // For more information see https://github.com/bvaughn/react-virtualized/pull/124
        var scrollPositionChangeReason = event.cancelable ? SCROLL_POSITION_CHANGE_REASONS.OBSERVED : SCROLL_POSITION_CHANGE_REASONS.REQUESTED;

        // Synchronously set :isScrolling the first time (since _setNextState will reschedule its animation frame each time it's called)
        if (!this.state.isScrolling) {
          isScrollingChange(true);
        }

        this.setState({
          isScrolling: true,
          scrollLeft: scrollLeft,
          scrollPositionChangeReason: scrollPositionChangeReason,
          scrollTop: scrollTop
        });
      }

      this._invokeOnScrollMemoizer({
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        totalWidth: totalWidth,
        totalHeight: totalHeight
      });
    }
  }]);

  return CollectionView;
}(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

CollectionView.defaultProps = {
  'aria-label': 'grid',
  horizontalOverscanSize: 0,
  noContentRenderer: function noContentRenderer() {
    return null;
  },
  onScroll: function onScroll() {
    return null;
  },
  onSectionRendered: function onSectionRendered() {
    return null;
  },
  scrollToAlignment: 'auto',
  style: {},
  verticalOverscanSize: 0
};
/* harmony default export */ __webpack_exports__["a"] = (CollectionView);
 false ? CollectionView.propTypes = {
  'aria-label': PropTypes.string,

  /**
   * Removes fixed height from the scrollingContainer so that the total height
   * of rows can stretch the window. Intended for use with WindowScroller
   */
  autoHeight: PropTypes.bool,

  /**
   * Number of cells in collection.
   */
  cellCount: PropTypes.number.isRequired,

  /**
   * Calculates cell sizes and positions and manages rendering the appropriate cells given a specified window.
   */
  cellLayoutManager: PropTypes.object.isRequired,

  /**
   * Optional custom CSS class name to attach to root Collection element.
   */
  className: PropTypes.string,

  /**
   * Height of Collection; this property determines the number of visible (vs virtualized) rows.
   */
  height: PropTypes.number.isRequired,

  /**
   * Optional custom id to attach to root Collection element.
   */
  id: PropTypes.string,

  /**
   * Enables the `Collection` to horiontally "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  horizontalOverscanSize: PropTypes.number.isRequired,

  isScrollingChange: PropTypes.func,

  /**
   * Optional renderer to be used in place of rows when either :rowCount or :cellCount is 0.
   */
  noContentRenderer: PropTypes.func.isRequired,

  /**
   * Callback invoked whenever the scroll offset changes within the inner scrollable region.
   * This callback can be used to sync scrolling between lists, tables, or grids.
   * ({ clientHeight, clientWidth, scrollHeight, scrollLeft, scrollTop, scrollWidth }): void
   */
  onScroll: PropTypes.func.isRequired,

  /**
   * Callback invoked with information about the section of the Collection that was just rendered.
   * This callback is passed a named :indices parameter which is an Array of the most recently rendered section indices.
   */
  onSectionRendered: PropTypes.func.isRequired,

  /**
   * Horizontal offset.
   */
  scrollLeft: PropTypes.number,

  /**
   * Controls scroll-to-cell behavior of the Grid.
   * The default ("auto") scrolls the least amount possible to ensure that the specified cell is fully visible.
   * Use "start" to align cells to the top/left of the Grid and "end" to align bottom/right.
   */
  scrollToAlignment: PropTypes.oneOf(['auto', 'end', 'start', 'center']).isRequired,

  /**
   * Cell index to ensure visible (by forcefully scrolling if necessary).
   */
  scrollToCell: PropTypes.number,

  /**
   * Vertical offset.
   */
  scrollTop: PropTypes.number,

  /**
   * Optional custom inline style to attach to root Collection element.
   */
  style: PropTypes.object,

  /**
   * Enables the `Collection` to vertically "overscan" its content similar to how `Grid` does.
   * This can reduce flicker around the edges when a user scrolls quickly.
   */
  verticalOverscanSize: PropTypes.number.isRequired,

  /**
   * Width of Collection; this property determines the number of visible (vs virtualized) columns.
   */
  width: PropTypes.number.isRequired
} : void 0;

/***/ }),
/* 2413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * A section of the Window.
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * Sections have a fixed size and contain 0 to many cells (tracked by their indices).
 */
var Section = function () {
  function Section(_ref) {
    var height = _ref.height;
    var width = _ref.width;
    var x = _ref.x;
    var y = _ref.y;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Section);

    this.height = height;
    this.width = width;
    this.x = x;
    this.y = y;

    this._indexMap = {};
    this._indices = [];
  }

  /** Add a cell to this section. */


  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(Section, [{
    key: 'addCellIndex',
    value: function addCellIndex(_ref2) {
      var index = _ref2.index;

      if (!this._indexMap[index]) {
        this._indexMap[index] = true;
        this._indices.push(index);
      }
    }

    /** Get all cell indices that have been added to this section. */

  }, {
    key: 'getCellIndices',
    value: function getCellIndices() {
      return this._indices;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      return this.x + ',' + this.y + ' ' + this.width + 'x' + this.height;
    }
  }]);

  return Section;
}(); /** @rlow */


/* harmony default export */ __webpack_exports__["a"] = (Section);

/***/ }),
/* 2414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Section__ = __webpack_require__(2413);



/**
 * Window Sections are used to group nearby cells.
 * This enables us to more quickly determine which cells to display in a given region of the Window.
 * 
 */



var SECTION_SIZE = 100;

/**
 * Contains 0 to many Sections.
 * Grows (and adds Sections) dynamically as cells are registered.
 * Automatically adds cells to the appropriate Section(s).
 */
var SectionManager = function () {
  function SectionManager() {
    var sectionSize = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : SECTION_SIZE;

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, SectionManager);

    this._sectionSize = sectionSize;

    this._cellMetadata = [];
    this._sections = {};
  }

  /**
   * Gets all cell indices contained in the specified region.
   * A region may encompass 1 or more Sections.
   */


  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(SectionManager, [{
    key: 'getCellIndices',
    value: function getCellIndices(_ref) {
      var height = _ref.height;
      var width = _ref.width;
      var x = _ref.x;
      var y = _ref.y;

      var indices = {};

      this.getSections({ height: height, width: width, x: x, y: y }).forEach(function (section) {
        return section.getCellIndices().forEach(function (index) {
          indices[index] = index;
        });
      });

      // Object keys are strings; this function returns numbers
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(indices).map(function (index) {
        return indices[index];
      });
    }

    /** Get size and position information for the cell specified. */

  }, {
    key: 'getCellMetadata',
    value: function getCellMetadata(_ref2) {
      var index = _ref2.index;

      return this._cellMetadata[index];
    }

    /** Get all Sections overlapping the specified region. */

  }, {
    key: 'getSections',
    value: function getSections(_ref3) {
      var height = _ref3.height;
      var width = _ref3.width;
      var x = _ref3.x;
      var y = _ref3.y;

      var sectionXStart = Math.floor(x / this._sectionSize);
      var sectionXStop = Math.floor((x + width - 1) / this._sectionSize);
      var sectionYStart = Math.floor(y / this._sectionSize);
      var sectionYStop = Math.floor((y + height - 1) / this._sectionSize);

      var sections = [];

      for (var sectionX = sectionXStart; sectionX <= sectionXStop; sectionX++) {
        for (var sectionY = sectionYStart; sectionY <= sectionYStop; sectionY++) {
          var key = sectionX + '.' + sectionY;

          if (!this._sections[key]) {
            this._sections[key] = new __WEBPACK_IMPORTED_MODULE_3__Section__["a" /* default */]({
              height: this._sectionSize,
              width: this._sectionSize,
              x: sectionX * this._sectionSize,
              y: sectionY * this._sectionSize
            });
          }

          sections.push(this._sections[key]);
        }
      }

      return sections;
    }

    /** Total number of Sections based on the currently registered cells. */

  }, {
    key: 'getTotalSectionCount',
    value: function getTotalSectionCount() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).length;
    }

    /** Intended for debugger/test purposes only */

  }, {
    key: 'toString',
    value: function toString() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this._sections).map(function (index) {
        return _this._sections[index].toString();
      });
    }

    /** Adds a cell to the appropriate Sections and registers it metadata for later retrievable. */

  }, {
    key: 'registerCell',
    value: function registerCell(_ref4) {
      var cellMetadatum = _ref4.cellMetadatum;
      var index = _ref4.index;

      this._cellMetadata[index] = cellMetadatum;

      this.getSections(cellMetadatum).forEach(function (section) {
        return section.addCellIndex({ index: index });
      });
    }
  }]);

  return SectionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (SectionManager);

/***/ }),
/* 2415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Collection__ = __webpack_require__(956);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Collection__["a"]; });





/***/ }),
/* 2416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionData;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SectionManager__ = __webpack_require__(2414);


function calculateSizeAndPositionData(_ref) {
  var cellCount = _ref.cellCount;
  var cellSizeAndPositionGetter = _ref.cellSizeAndPositionGetter;
  var sectionSize = _ref.sectionSize;

  var cellMetadata = [];
  var sectionManager = new __WEBPACK_IMPORTED_MODULE_0__SectionManager__["a" /* default */](sectionSize);
  var height = 0;
  var width = 0;

  for (var index = 0; index < cellCount; index++) {
    var cellMetadatum = cellSizeAndPositionGetter({ index: index });

    if (cellMetadatum.height == null || isNaN(cellMetadatum.height) || cellMetadatum.width == null || isNaN(cellMetadatum.width) || cellMetadatum.x == null || isNaN(cellMetadatum.x) || cellMetadatum.y == null || isNaN(cellMetadatum.y)) {
      throw Error('Invalid metadata returned for cell ' + index + ':\n        x:' + cellMetadatum.x + ', y:' + cellMetadatum.y + ', width:' + cellMetadatum.width + ', height:' + cellMetadatum.height);
    }

    height = Math.max(height, cellMetadatum.y + cellMetadatum.height);
    width = Math.max(width, cellMetadatum.x + cellMetadatum.width);

    cellMetadata[index] = cellMetadatum;
    sectionManager.registerCell({
      cellMetadatum: cellMetadatum,
      index: index
    });
  }

  return {
    cellMetadata: cellMetadata,
    height: height,
    sectionManager: sectionManager,
    width: width
  };
}

/***/ }),
/* 2417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__ = __webpack_require__(957);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ColumnSizer__["a"]; });





/***/ }),
/* 2418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



/**
 * Just-in-time calculates and caches size and position information for a collection of cells.
 */
var CellSizeAndPositionManager = function () {
  function CellSizeAndPositionManager(_ref) {
    var cellCount = _ref.cellCount;
    var cellSizeGetter = _ref.cellSizeGetter;
    var estimatedCellSize = _ref.estimatedCellSize;

    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CellSizeAndPositionManager);

    this._cellSizeGetter = cellSizeGetter;
    this._cellCount = cellCount;
    this._estimatedCellSize = estimatedCellSize;

    // Cache of size and position data for cells, mapped by cell index.
    // Note that invalid values may exist in this map so only rely on cells up to this._lastMeasuredIndex
    this._cellSizeAndPositionData = {};

    // Measurements for cells up to this index can be trusted; cells afterward should be estimated.
    this._lastMeasuredIndex = -1;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CellSizeAndPositionManager, [{
    key: 'configure',
    value: function configure(_ref2) {
      var cellCount = _ref2.cellCount;
      var estimatedCellSize = _ref2.estimatedCellSize;

      this._cellCount = cellCount;
      this._estimatedCellSize = estimatedCellSize;
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellCount;
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._estimatedCellSize;
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._lastMeasuredIndex;
    }

    /**
     * This method returns the size and position for the cell at the specified index.
     * It just-in-time calculates (or used cached values) for cells leading up to the index.
     */

  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      if (index < 0 || index >= this._cellCount) {
        throw Error('Requested index ' + index + ' is outside of range 0..' + this._cellCount);
      }

      if (index > this._lastMeasuredIndex) {
        var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
        var _offset = lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size;

        for (var i = this._lastMeasuredIndex + 1; i <= index; i++) {
          var _size = this._cellSizeGetter({ index: i });

          if (_size == null || isNaN(_size)) {
            throw Error('Invalid size returned for cell ' + i + ' of value ' + _size);
          }

          this._cellSizeAndPositionData[i] = {
            offset: _offset,
            size: _size
          };

          _offset += _size;
        }

        this._lastMeasuredIndex = index;
      }

      return this._cellSizeAndPositionData[index];
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._lastMeasuredIndex >= 0 ? this._cellSizeAndPositionData[this._lastMeasuredIndex] : {
        offset: 0,
        size: 0
      };
    }

    /**
     * Total size of all cells being measured.
     * This value will be completedly estimated initially.
     * As cells as measured the estimate will be updated.
     */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();

      return lastMeasuredCellSizeAndPosition.offset + lastMeasuredCellSizeAndPosition.size + (this._cellCount - this._lastMeasuredIndex - 1) * this._estimatedCellSize;
    }

    /**
     * Determines a new offset that ensures a certain cell is visible, given the current offset.
     * If the cell is already visible then the current offset will be returned.
     * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
     *
     * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
     * @param containerSize Size (width or height) of the container viewport
     * @param currentOffset Container's current (x or y) offset
     * @param totalSize Total size (width or height) of all cells
     * @return Offset to use to ensure the specified cell is visible
     */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align;
      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
      var containerSize = _ref3.containerSize;
      var currentOffset = _ref3.currentOffset;
      var targetIndex = _ref3.targetIndex;

      if (containerSize <= 0) {
        return 0;
      }

      var datum = this.getSizeAndPositionOfCell(targetIndex);
      var maxOffset = datum.offset;
      var minOffset = maxOffset - containerSize + datum.size;

      var idealOffset = void 0;

      switch (align) {
        case 'start':
          idealOffset = maxOffset;
          break;
        case 'end':
          idealOffset = minOffset;
          break;
        case 'center':
          idealOffset = maxOffset - (containerSize - datum.size) / 2;
          break;
        default:
          idealOffset = Math.max(minOffset, Math.min(maxOffset, currentOffset));
          break;
      }

      var totalSize = this.getTotalSize();

      return Math.max(0, Math.min(totalSize - containerSize, idealOffset));
    }
  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize;
      var offset = _ref4.offset;

      var totalSize = this.getTotalSize();

      if (totalSize === 0) {
        return {};
      }

      var maxOffset = offset + containerSize;
      var start = this._findNearestCell(offset);

      var datum = this.getSizeAndPositionOfCell(start);
      offset = datum.offset + datum.size;

      var stop = start;

      while (offset < maxOffset && stop < this._cellCount - 1) {
        stop++;

        offset += this.getSizeAndPositionOfCell(stop).size;
      }

      return {
        start: start,
        stop: stop
      };
    }

    /**
     * Clear all cached values for cells after the specified index.
     * This method should be called for any cell that has changed its size.
     * It will not immediately perform any calculations; they'll be performed the next time getSizeAndPositionOfCell() is called.
     */

  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._lastMeasuredIndex = Math.min(this._lastMeasuredIndex, index - 1);
    }
  }, {
    key: '_binarySearch',
    value: function _binarySearch(_ref5) {
      var high = _ref5.high;
      var low = _ref5.low;
      var offset = _ref5.offset;

      var middle = void 0;
      var currentOffset = void 0;

      while (low <= high) {
        middle = low + Math.floor((high - low) / 2);
        currentOffset = this.getSizeAndPositionOfCell(middle).offset;

        if (currentOffset === offset) {
          return middle;
        } else if (currentOffset < offset) {
          low = middle + 1;
        } else if (currentOffset > offset) {
          high = middle - 1;
        }
      }

      if (low > 0) {
        return low - 1;
      }
    }
  }, {
    key: '_exponentialSearch',
    value: function _exponentialSearch(_ref6) {
      var index = _ref6.index;
      var offset = _ref6.offset;

      var interval = 1;

      while (index < this._cellCount && this.getSizeAndPositionOfCell(index).offset < offset) {
        index += interval;
        interval *= 2;
      }

      return this._binarySearch({
        high: Math.min(index, this._cellCount - 1),
        low: Math.floor(index / 2),
        offset: offset
      });
    }

    /**
     * Searches for the cell (index) nearest the specified offset.
     *
     * If no exact match is found the next lowest cell index will be returned.
     * This allows partially visible cells (with offsets just before/above the fold) to be visible.
     */

  }, {
    key: '_findNearestCell',
    value: function _findNearestCell(offset) {
      if (isNaN(offset)) {
        throw Error('Invalid offset ' + offset + ' specified');
      }

      // Our search algorithms find the nearest match at or below the specified offset.
      // So make sure the offset is at least 0 or no match will be found.
      offset = Math.max(0, offset);

      var lastMeasuredCellSizeAndPosition = this.getSizeAndPositionOfLastMeasuredCell();
      var lastMeasuredIndex = Math.max(0, this._lastMeasuredIndex);

      if (lastMeasuredCellSizeAndPosition.offset >= offset) {
        // If we've already measured cells within this range just use a binary search as it's faster.
        return this._binarySearch({
          high: lastMeasuredIndex,
          low: 0,
          offset: offset
        });
      } else {
        // If we haven't yet measured this high, fallback to an exponential search with an inner binary search.
        // The exponential search avoids pre-computing sizes for the full set of cells as a binary search would.
        // The overall complexity for this approach is O(log n).
        return this._exponentialSearch({
          index: lastMeasuredIndex,
          offset: offset
        });
      }
    }
  }]);

  return CellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (CellSizeAndPositionManager);

/***/ }),
/* 2419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export DEFAULT_MAX_SCROLL_SIZE */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(233);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__ = __webpack_require__(2418);





/**
 * Browsers have scroll offset limitations (eg Chrome stops scrolling at ~33.5M pixels where as Edge tops out at ~1.5M pixels).
 * After a certain position, the browser won't allow the user to scroll further (even via JavaScript scroll offset adjustments).
 * This util picks a lower ceiling for max size and artificially adjusts positions within to make it transparent for users.
 */
var DEFAULT_MAX_SCROLL_SIZE = 1500000;

/**
 * Extends CellSizeAndPositionManager and adds scaling behavior for lists that are too large to fit within a browser's native limits.
 */

var ScalingCellSizeAndPositionManager = function () {
  function ScalingCellSizeAndPositionManager(_ref) {
    var _ref$maxScrollSize = _ref.maxScrollSize;
    var maxScrollSize = _ref$maxScrollSize === undefined ? DEFAULT_MAX_SCROLL_SIZE : _ref$maxScrollSize;

    var params = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_objectWithoutProperties___default()(_ref, ['maxScrollSize']);

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, ScalingCellSizeAndPositionManager);

    // Favor composition over inheritance to simplify IE10 support
    this._cellSizeAndPositionManager = new __WEBPACK_IMPORTED_MODULE_3__CellSizeAndPositionManager__["a" /* default */](params);
    this._maxScrollSize = maxScrollSize;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ScalingCellSizeAndPositionManager, [{
    key: 'configure',
    value: function configure(params) {
      this._cellSizeAndPositionManager.configure(params);
    }
  }, {
    key: 'getCellCount',
    value: function getCellCount() {
      return this._cellSizeAndPositionManager.getCellCount();
    }
  }, {
    key: 'getEstimatedCellSize',
    value: function getEstimatedCellSize() {
      return this._cellSizeAndPositionManager.getEstimatedCellSize();
    }
  }, {
    key: 'getLastMeasuredIndex',
    value: function getLastMeasuredIndex() {
      return this._cellSizeAndPositionManager.getLastMeasuredIndex();
    }

    /**
     * Number of pixels a cell at the given position (offset) should be shifted in order to fit within the scaled container.
     * The offset passed to this function is scalled (safe) as well.
     */

  }, {
    key: 'getOffsetAdjustment',
    value: function getOffsetAdjustment(_ref2) {
      var containerSize = _ref2.containerSize;
      var offset = _ref2.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();
      var offsetPercentage = this._getOffsetPercentage({
        containerSize: containerSize,
        offset: offset,
        totalSize: safeTotalSize
      });

      return Math.round(offsetPercentage * (safeTotalSize - totalSize));
    }
  }, {
    key: 'getSizeAndPositionOfCell',
    value: function getSizeAndPositionOfCell(index) {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfCell(index);
    }
  }, {
    key: 'getSizeAndPositionOfLastMeasuredCell',
    value: function getSizeAndPositionOfLastMeasuredCell() {
      return this._cellSizeAndPositionManager.getSizeAndPositionOfLastMeasuredCell();
    }

    /** See CellSizeAndPositionManager#getTotalSize */

  }, {
    key: 'getTotalSize',
    value: function getTotalSize() {
      return Math.min(this._maxScrollSize, this._cellSizeAndPositionManager.getTotalSize());
    }

    /** See CellSizeAndPositionManager#getUpdatedOffsetForIndex */

  }, {
    key: 'getUpdatedOffsetForIndex',
    value: function getUpdatedOffsetForIndex(_ref3) {
      var _ref3$align = _ref3.align;
      var align = _ref3$align === undefined ? 'auto' : _ref3$align;
      var containerSize = _ref3.containerSize;
      var currentOffset = _ref3.currentOffset;
      var targetIndex = _ref3.targetIndex;
      var totalSize = _ref3.totalSize;

      currentOffset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: currentOffset
      });

      var offset = this._cellSizeAndPositionManager.getUpdatedOffsetForIndex({
        align: align,
        containerSize: containerSize,
        currentOffset: currentOffset,
        targetIndex: targetIndex,
        totalSize: totalSize
      });

      return this._offsetToSafeOffset({
        containerSize: containerSize,
        offset: offset
      });
    }

    /** See CellSizeAndPositionManager#getVisibleCellRange */

  }, {
    key: 'getVisibleCellRange',
    value: function getVisibleCellRange(_ref4) {
      var containerSize = _ref4.containerSize;
      var offset = _ref4.offset;

      offset = this._safeOffsetToOffset({
        containerSize: containerSize,
        offset: offset
      });

      return this._cellSizeAndPositionManager.getVisibleCellRange({
        containerSize: containerSize,
        offset: offset
      });
    }
  }, {
    key: 'resetCell',
    value: function resetCell(index) {
      this._cellSizeAndPositionManager.resetCell(index);
    }
  }, {
    key: '_getOffsetPercentage',
    value: function _getOffsetPercentage(_ref5) {
      var containerSize = _ref5.containerSize;
      var offset = _ref5.offset;
      var totalSize = _ref5.totalSize;

      return totalSize <= containerSize ? 0 : offset / (totalSize - containerSize);
    }
  }, {
    key: '_offsetToSafeOffset',
    value: function _offsetToSafeOffset(_ref6) {
      var containerSize = _ref6.containerSize;
      var offset = _ref6.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: totalSize
        });

        return Math.round(offsetPercentage * (safeTotalSize - containerSize));
      }
    }
  }, {
    key: '_safeOffsetToOffset',
    value: function _safeOffsetToOffset(_ref7) {
      var containerSize = _ref7.containerSize;
      var offset = _ref7.offset;

      var totalSize = this._cellSizeAndPositionManager.getTotalSize();
      var safeTotalSize = this.getTotalSize();

      if (totalSize === safeTotalSize) {
        return offset;
      } else {
        var offsetPercentage = this._getOffsetPercentage({
          containerSize: containerSize,
          offset: offset,
          totalSize: safeTotalSize
        });

        return Math.round(offsetPercentage * (totalSize - containerSize));
      }
    }
  }]);

  return ScalingCellSizeAndPositionManager;
}();

/* harmony default export */ __webpack_exports__["a"] = (ScalingCellSizeAndPositionManager);

/***/ }),
/* 2420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = calculateSizeAndPositionDataAndUpdateScrollOffset;
/**
 * Helper method that determines when to recalculate row or column metadata.
 *
 * @param cellCount Number of rows or columns in the current axis
 * @param cellsSize Width or height of cells for the current axis
 * @param computeMetadataCallback Method to invoke if cell metadata should be recalculated
 * @param computeMetadataCallbackProps Parameters to pass to :computeMetadataCallback
 * @param nextCellsCount Newly updated number of rows or columns in the current axis
 * @param nextCellsSize Newly updated width or height of cells for the current axis
 * @param nextScrollToIndex Newly updated scroll-to-index
 * @param scrollToIndex Scroll-to-index
 * @param updateScrollOffsetForScrollToIndex Callback to invoke if the scroll position should be recalculated
 */
function calculateSizeAndPositionDataAndUpdateScrollOffset(_ref) {
  var cellCount = _ref.cellCount;
  var cellSize = _ref.cellSize;
  var computeMetadataCallback = _ref.computeMetadataCallback;
  var computeMetadataCallbackProps = _ref.computeMetadataCallbackProps;
  var nextCellsCount = _ref.nextCellsCount;
  var nextCellSize = _ref.nextCellSize;
  var nextScrollToIndex = _ref.nextScrollToIndex;
  var scrollToIndex = _ref.scrollToIndex;
  var updateScrollOffsetForScrollToIndex = _ref.updateScrollOffsetForScrollToIndex;

  // Don't compare cell sizes if they are functions because inline functions would cause infinite loops.
  // In that event users should use the manual recompute methods to inform of changes.
  if (cellCount !== nextCellsCount || (typeof cellSize === 'number' || typeof nextCellSize === 'number') && cellSize !== nextCellSize) {
    computeMetadataCallback(computeMetadataCallbackProps);

    // Updated cell metadata may have hidden the previous scrolled-to item.
    // In this case we should also update the scrollTop to ensure it stays visible.
    if (scrollToIndex >= 0 && scrollToIndex === nextScrollToIndex) {
      updateScrollOffsetForScrollToIndex();
    }
  }
}

/***/ }),
/* 2421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SCROLL_DIRECTION_BACKWARD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SCROLL_DIRECTION_FORWARD; });
/* harmony export (immutable) */ __webpack_exports__["b"] = getOverscanIndices;
var SCROLL_DIRECTION_BACKWARD = -1;
var SCROLL_DIRECTION_FORWARD = 1;

/**
 * Calculates the number of cells to overscan before and after a specified range.
 * This function ensures that overscanning doesn't exceed the available cells.
 *
 * @param cellCount Number of rows or columns in the current axis
 * @param scrollDirection One of SCROLL_DIRECTION_BACKWARD
 * @param overscanCellsCount Maximum number of cells to over-render in either direction
 * @param startIndex Begin of range of visible cells
 * @param stopIndex End of range of visible cells
 */
function getOverscanIndices(_ref) {
  var cellCount = _ref.cellCount;
  var overscanCellsCount = _ref.overscanCellsCount;
  var scrollDirection = _ref.scrollDirection;
  var startIndex = _ref.startIndex;
  var stopIndex = _ref.stopIndex;

  var overscanStartIndex = void 0;
  var overscanStopIndex = void 0;

  switch (scrollDirection) {
    case SCROLL_DIRECTION_FORWARD:
      overscanStartIndex = startIndex;
      overscanStopIndex = stopIndex + overscanCellsCount;
      break;
    case SCROLL_DIRECTION_BACKWARD:
      overscanStartIndex = startIndex - overscanCellsCount;
      overscanStopIndex = stopIndex;
      break;
  }

  return {
    overscanStartIndex: Math.max(0, overscanStartIndex),
    overscanStopIndex: Math.min(cellCount - 1, overscanStopIndex)
  };
}

/***/ }),
/* 2422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = updateScrollIndexHelper;
/**
 * Helper function that determines when to update scroll offsets to ensure that a scroll-to-index remains visible.
 * This function also ensures that the scroll ofset isn't past the last column/row of cells.
 *
 * @param cellsSize Width or height of cells for the current axis
 * @param cellSizeAndPositionManager Manages size and position metadata of cells
 * @param previousCellsCount Previous number of rows or columns
 * @param previousCellsSize Previous width or height of cells
 * @param previousScrollToIndex Previous scroll-to-index
 * @param previousSize Previous width or height of the virtualized container
 * @param scrollOffset Current scrollLeft or scrollTop
 * @param scrollToIndex Scroll-to-index
 * @param size Width or height of the virtualized container
 * @param updateScrollIndexCallback Callback to invoke with an scroll-to-index value
 */
function updateScrollIndexHelper(_ref) {
  var cellSize = _ref.cellSize;
  var cellSizeAndPositionManager = _ref.cellSizeAndPositionManager;
  var previousCellsCount = _ref.previousCellsCount;
  var previousCellSize = _ref.previousCellSize;
  var previousScrollToAlignment = _ref.previousScrollToAlignment;
  var previousScrollToIndex = _ref.previousScrollToIndex;
  var previousSize = _ref.previousSize;
  var scrollOffset = _ref.scrollOffset;
  var scrollToAlignment = _ref.scrollToAlignment;
  var scrollToIndex = _ref.scrollToIndex;
  var size = _ref.size;
  var updateScrollIndexCallback = _ref.updateScrollIndexCallback;

  var cellCount = cellSizeAndPositionManager.getCellCount();
  var hasScrollToIndex = scrollToIndex >= 0 && scrollToIndex < cellCount;
  var sizeHasChanged = size !== previousSize || !previousCellSize || typeof cellSize === 'number' && cellSize !== previousCellSize;

  // If we have a new scroll target OR if height/row-height has changed,
  // We should ensure that the scroll target is visible.
  if (hasScrollToIndex && (sizeHasChanged || scrollToAlignment !== previousScrollToAlignment || scrollToIndex !== previousScrollToIndex)) {
    updateScrollIndexCallback(scrollToIndex);

    // If we don't have a selected item but list size or number of children have decreased,
    // Make sure we aren't scrolled too far past the current content.
  } else if (!hasScrollToIndex && cellCount > 0 && (size < previousSize || cellCount < previousCellsCount)) {
    // We need to ensure that the current scroll offset is still within the collection's range.
    // To do this, we don't need to measure everything; CellMeasurer would perform poorly.
    // Just check to make sure we're still okay.
    // Only adjust the scroll position if we've scrolled below the last set of rows.
    if (scrollOffset > cellSizeAndPositionManager.getTotalSize() - size) {
      updateScrollIndexCallback(cellCount - 1);
    }
  }
}

/***/ }),
/* 2423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__ = __webpack_require__(960);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__InfiniteLoader__["a"]; });





/***/ }),
/* 2424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__List__ = __webpack_require__(961);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__List__["a"]; });





/***/ }),
/* 2425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MultiGrid__ = __webpack_require__(962);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__MultiGrid__["a"]; });





/***/ }),
/* 2426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollSync__ = __webpack_require__(963);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ScrollSync__["a"]; });





/***/ }),
/* 2427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Table__ = __webpack_require__(966);
/* unused harmony reexport default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__ = __webpack_require__(967);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__defaultCellDataGetter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__ = __webpack_require__(968);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__defaultCellRenderer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRenderer__ = __webpack_require__(969);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__defaultHeaderRenderer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__defaultRowRenderer__ = __webpack_require__(970);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__defaultRowRenderer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Table__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Column__ = __webpack_require__(964);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__Column__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__SortDirection__ = __webpack_require__(569);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__SortDirection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__SortIndicator__ = __webpack_require__(965);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_7__SortIndicator__["a"]; });



















/***/ }),
/* 2428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WindowScroller__ = __webpack_require__(971);
/* unused harmony reexport default */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__WindowScroller__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_onScroll__ = __webpack_require__(972);
/* unused harmony reexport IS_SCROLLING_TIMEOUT */







/***/ }),
/* 2429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getHeight;
/* harmony export (immutable) */ __webpack_exports__["b"] = getPositionFromTop;
/* harmony export (immutable) */ __webpack_exports__["c"] = getScrollTop;
/**
 * Gets the height of the element, accounting for API differences between
 * `window` and other DOM elements.
 */
function getHeight(element) {
  return element === window ? window.innerHeight : element.getBoundingClientRect().height;
}

/**
 * Gets the vertical position of an element within its scroll container.
 * Elements that have been “scrolled past” return negative values.
 * Handles edge-case where a user is navigating back (history) from an already-scrolled page.
 * In this case the body’s top position will be a negative number and this element’s top will be increased (by that amount).
 */
function getPositionFromTop(element, container) {
  var offset = container === window ? 0 : getScrollTop(container);
  var containerElement = container === window ? document.documentElement : container;
  return element.getBoundingClientRect().top + offset - containerElement.getBoundingClientRect().top;
}

/**
 * Gets the vertical scroll amount of the element, accounting for IE compatibility
 * and API differences between `window` and other DOM elements.
 */
function getScrollTop(element) {
  if (element === window) {
    return 'scrollY' in window ? window.scrollY : document.documentElement.scrollTop;
  } else {
    return element.scrollTop;
  }
}

/***/ }),
/* 2430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__ = __webpack_require__(2408);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ArrowKeyStepper", function() { return __WEBPACK_IMPORTED_MODULE_0__ArrowKeyStepper__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__AutoSizer__ = __webpack_require__(2409);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "AutoSizer", function() { return __WEBPACK_IMPORTED_MODULE_1__AutoSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__ = __webpack_require__(2411);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "CellMeasurer", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultCellMeasurerCellSizeCache", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "uniformSizeCellMeasurerCellSizeCache", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "idCellMeasurerCellSizeCache", function() { return __WEBPACK_IMPORTED_MODULE_2__CellMeasurer__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Collection__ = __webpack_require__(2415);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Collection", function() { return __WEBPACK_IMPORTED_MODULE_3__Collection__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__ = __webpack_require__(2417);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ColumnSizer", function() { return __WEBPACK_IMPORTED_MODULE_4__ColumnSizer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Table__ = __webpack_require__(2427);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableCellDataGetter", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableCellRenderer", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["b"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableHeaderRenderer", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["c"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultTableRowRenderer", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["d"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Table", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["e"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Column", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["f"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortDirection", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["g"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "SortIndicator", function() { return __WEBPACK_IMPORTED_MODULE_5__Table__["h"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Grid__ = __webpack_require__(378);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "defaultCellRangeRenderer", function() { return __WEBPACK_IMPORTED_MODULE_6__Grid__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Grid", function() { return __WEBPACK_IMPORTED_MODULE_6__Grid__["b"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__InfiniteLoader__ = __webpack_require__(2423);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "InfiniteLoader", function() { return __WEBPACK_IMPORTED_MODULE_7__InfiniteLoader__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__List__ = __webpack_require__(2424);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() { return __WEBPACK_IMPORTED_MODULE_8__List__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__MultiGrid__ = __webpack_require__(2425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "MultiGrid", function() { return __WEBPACK_IMPORTED_MODULE_9__MultiGrid__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ScrollSync__ = __webpack_require__(2426);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ScrollSync", function() { return __WEBPACK_IMPORTED_MODULE_10__ScrollSync__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__WindowScroller__ = __webpack_require__(2428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "WindowScroller", function() { return __WEBPACK_IMPORTED_MODULE_11__WindowScroller__["a"]; });













/***/ }),
/* 2431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getUpdatedOffsetForIndex;
/**
 * Determines a new offset that ensures a certain cell is visible, given the current offset.
 * If the cell is already visible then the current offset will be returned.
 * If the current offset is too great or small, it will be adjusted just enough to ensure the specified index is visible.
 *
 * @param align Desired alignment within container; one of "auto" (default), "start", or "end"
 * @param cellOffset Offset (x or y) position for cell
 * @param cellSize Size (width or height) of cell
 * @param containerSize Total size (width or height) of the container
 * @param currentOffset Container's current (x or y) offset
 * @return Offset to use to ensure the specified cell is visible
 */
function getUpdatedOffsetForIndex(_ref) {
  var _ref$align = _ref.align;
  var align = _ref$align === undefined ? 'auto' : _ref$align;
  var cellOffset = _ref.cellOffset;
  var cellSize = _ref.cellSize;
  var containerSize = _ref.containerSize;
  var currentOffset = _ref.currentOffset;

  var maxOffset = cellOffset;
  var minOffset = maxOffset - containerSize + cellSize;

  switch (align) {
    case 'start':
      return maxOffset;
    case 'end':
      return minOffset;
    case 'center':
      return maxOffset - (containerSize - cellSize) / 2;
    default:
      return Math.max(minOffset, Math.min(maxOffset, currentOffset));
  }
}

/***/ }),
/* 2432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = createDetectElementResize;
/**
 * Detect Element Resize.
 * https://github.com/sdecima/javascript-detect-element-resize
 * Sebastian Decima
 *
 * Forked from version 0.5.3; includes the following modifications:
 * 1) Guard against unsafe 'window' and 'document' references (to support SSR).
 * 2) Defer initialization code via a top-level function wrapper (to support SSR).
 * 3) Avoid unnecessary reflows by not measuring size for scroll events bubbling from children.
 **/

function createDetectElementResize() {
  // Check `document` and `window` in case of server-side rendering
  var _window;
  if (typeof window !== 'undefined') {
    _window = window;
  } else if (typeof self !== 'undefined') {
    _window = self;
  } else {
    _window = this;
  }

  var attachEvent = typeof document !== 'undefined' && document.attachEvent;

  if (!attachEvent) {
    var requestFrame = function () {
      var raf = _window.requestAnimationFrame || _window.mozRequestAnimationFrame || _window.webkitRequestAnimationFrame || function (fn) {
        return _window.setTimeout(fn, 20);
      };
      return function (fn) {
        return raf(fn);
      };
    }();

    var cancelFrame = function () {
      var cancel = _window.cancelAnimationFrame || _window.mozCancelAnimationFrame || _window.webkitCancelAnimationFrame || _window.clearTimeout;
      return function (id) {
        return cancel(id);
      };
    }();

    var resetTriggers = function resetTriggers(element) {
      var triggers = element.__resizeTriggers__,
          expand = triggers.firstElementChild,
          contract = triggers.lastElementChild,
          expandChild = expand.firstElementChild;
      contract.scrollLeft = contract.scrollWidth;
      contract.scrollTop = contract.scrollHeight;
      expandChild.style.width = expand.offsetWidth + 1 + 'px';
      expandChild.style.height = expand.offsetHeight + 1 + 'px';
      expand.scrollLeft = expand.scrollWidth;
      expand.scrollTop = expand.scrollHeight;
    };

    var checkTriggers = function checkTriggers(element) {
      return element.offsetWidth != element.__resizeLast__.width || element.offsetHeight != element.__resizeLast__.height;
    };

    var scrollListener = function scrollListener(e) {
      // Don't measure (which forces) reflow for scrolls that happen inside of children!
      if (e.target.className.indexOf('contract-trigger') < 0 && e.target.className.indexOf('expand-trigger') < 0) {
        return;
      }

      var element = this;
      resetTriggers(this);
      if (this.__resizeRAF__) cancelFrame(this.__resizeRAF__);
      this.__resizeRAF__ = requestFrame(function () {
        if (checkTriggers(element)) {
          element.__resizeLast__.width = element.offsetWidth;
          element.__resizeLast__.height = element.offsetHeight;
          element.__resizeListeners__.forEach(function (fn) {
            fn.call(element, e);
          });
        }
      });
    };

    /* Detect CSS Animations support to detect element display/re-attach */
    var animation = false,
        animationstring = 'animation',
        keyframeprefix = '',
        animationstartevent = 'animationstart',
        domPrefixes = 'Webkit Moz O ms'.split(' '),
        startEvents = 'webkitAnimationStart animationstart oAnimationStart MSAnimationStart'.split(' '),
        pfx = '';
    {
      var elm = document.createElement('fakeelement');
      if (elm.style.animationName !== undefined) {
        animation = true;
      }

      if (animation === false) {
        for (var i = 0; i < domPrefixes.length; i++) {
          if (elm.style[domPrefixes[i] + 'AnimationName'] !== undefined) {
            pfx = domPrefixes[i];
            animationstring = pfx + 'Animation';
            keyframeprefix = '-' + pfx.toLowerCase() + '-';
            animationstartevent = startEvents[i];
            animation = true;
            break;
          }
        }
      }
    }

    var animationName = 'resizeanim';
    var animationKeyframes = '@' + keyframeprefix + 'keyframes ' + animationName + ' { from { opacity: 0; } to { opacity: 0; } } ';
    var animationStyle = keyframeprefix + 'animation: 1ms ' + animationName + '; ';
  }

  var createStyles = function createStyles() {
    if (!document.getElementById('detectElementResize')) {
      //opacity:0 works around a chrome bug https://code.google.com/p/chromium/issues/detail?id=286360
      var css = (animationKeyframes ? animationKeyframes : '') + '.resize-triggers { ' + (animationStyle ? animationStyle : '') + 'visibility: hidden; opacity: 0; } ' + '.resize-triggers, .resize-triggers > div, .contract-trigger:before { content: \" \"; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; z-index: -1; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',
          head = document.head || document.getElementsByTagName('head')[0],
          style = document.createElement('style');

      style.id = 'detectElementResize';
      style.type = 'text/css';
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }

      head.appendChild(style);
    }
  };

  var addResizeListener = function addResizeListener(element, fn) {
    if (attachEvent) element.attachEvent('onresize', fn);else {
      if (!element.__resizeTriggers__) {
        var elementStyle = _window.getComputedStyle(element);
        if (elementStyle && elementStyle.position == 'static') {
          element.style.position = 'relative';
        }
        createStyles();
        element.__resizeLast__ = {};
        element.__resizeListeners__ = [];
        (element.__resizeTriggers__ = document.createElement('div')).className = 'resize-triggers';
        element.__resizeTriggers__.innerHTML = '<div class="expand-trigger"><div></div></div>' + '<div class="contract-trigger"></div>';
        element.appendChild(element.__resizeTriggers__);
        resetTriggers(element);
        element.addEventListener('scroll', scrollListener, true);

        /* Listen for a css animation to detect element display/re-attach */
        if (animationstartevent) {
          element.__resizeTriggers__.__animationListener__ = function animationListener(e) {
            if (e.animationName == animationName) resetTriggers(element);
          };
          element.__resizeTriggers__.addEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
        }
      }
      element.__resizeListeners__.push(fn);
    }
  };

  var removeResizeListener = function removeResizeListener(element, fn) {
    if (attachEvent) element.detachEvent('onresize', fn);else {
      element.__resizeListeners__.splice(element.__resizeListeners__.indexOf(fn), 1);
      if (!element.__resizeListeners__.length) {
        element.removeEventListener('scroll', scrollListener, true);
        if (element.__resizeTriggers__.__animationListener__) {
          element.__resizeTriggers__.removeEventListener(animationstartevent, element.__resizeTriggers__.__animationListener__);
          element.__resizeTriggers__.__animationListener__ = null;
        }
        try {
          element.__resizeTriggers__ = !element.removeChild(element.__resizeTriggers__);
        } catch (e) {
          // Preact compat; see developit/preact-compat/issues/228
        }
      }
    }
  };

  return {
    addResizeListener: addResizeListener,
    removeResizeListener: removeResizeListener
  };
}

/***/ }),
/* 2433 */,
/* 2434 */,
/* 2435 */,
/* 2436 */,
/* 2437 */,
/* 2438 */,
/* 2439 */,
/* 2440 */,
/* 2441 */,
/* 2442 */,
/* 2443 */,
/* 2444 */,
/* 2445 */,
/* 2446 */,
/* 2447 */,
/* 2448 */,
/* 2449 */,
/* 2450 */,
/* 2451 */,
/* 2452 */,
/* 2453 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var requestIdleCallback =
  function (cb) {
  if (global.requestIdleCallback) return global.requestIdleCallback(cb)
    var start = Date.now();
    return setTimeout(function () {
      cb({
        didTimeout: false,
        timeRemaining: function () {
          return Math.max(0, 50 - (Date.now() - start));
        }
      });
    }, 1);
  }

var cancelIdleCallback =
  function (id) {
  if (global.cancelIdleCallback) return global.cancelIdleCallback(id)
    return clearTimeout(id);
  }

exports.requestIdleCallback = requestIdleCallback
exports.cancelIdleCallback = cancelIdleCallback

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 2454 */,
/* 2455 */,
/* 2456 */,
/* 2457 */,
/* 2458 */,
/* 2459 */,
/* 2460 */,
/* 2461 */,
/* 2462 */,
/* 2463 */,
/* 2464 */,
/* 2465 */,
/* 2466 */,
/* 2467 */,
/* 2468 */,
/* 2469 */,
/* 2470 */,
/* 2471 */,
/* 2472 */,
/* 2473 */,
/* 2474 */,
/* 2475 */,
/* 2476 */,
/* 2477 */,
/* 2478 */,
/* 2479 */,
/* 2480 */,
/* 2481 */,
/* 2482 */,
/* 2483 */,
/* 2484 */,
/* 2485 */,
/* 2486 */,
/* 2487 */,
/* 2488 */,
/* 2489 */,
/* 2490 */,
/* 2491 */,
/* 2492 */,
/* 2493 */,
/* 2494 */,
/* 2495 */,
/* 2496 */,
/* 2497 */,
/* 2498 */,
/* 2499 */,
/* 2500 */,
/* 2501 */,
/* 2502 */,
/* 2503 */,
/* 2504 */,
/* 2505 */,
/* 2506 */,
/* 2507 */,
/* 2508 */,
/* 2509 */,
/* 2510 */,
/* 2511 */,
/* 2512 */,
/* 2513 */,
/* 2514 */,
/* 2515 */,
/* 2516 */,
/* 2517 */,
/* 2518 */,
/* 2519 */,
/* 2520 */,
/* 2521 */,
/* 2522 */,
/* 2523 */,
/* 2524 */,
/* 2525 */,
/* 2526 */,
/* 2527 */,
/* 2528 */,
/* 2529 */,
/* 2530 */,
/* 2531 */,
/* 2532 */,
/* 2533 */,
/* 2534 */,
/* 2535 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(59));
	else if(typeof define === 'function' && define.amd)
		define(["rp-analytics"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("rp-analytics")) : factory(root["rp-analytics"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(this, function(__WEBPACK_EXTERNAL_MODULE_2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 23);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var BREAKPOINTS = exports.BREAKPOINTS = {
    TABLET: 719.9,
    DESKTOP: 989.9
};

var isMobile = exports.isMobile = /iPhone|Android|BlackBerry|Opera Mini|IEMobile/i.test(navigator.userAgent);
var isTabletBeakpoint = exports.isTabletBeakpoint = window.screen.width > 719;
var isDesktopBeakpoint = exports.isDesktopBeakpoint = window.screen.width > 989.9;

var isRacecardsOrResults = exports.isRacecardsOrResults = window.location.pathname.includes('/racecards/') || window.location.pathname.includes('/results/') || window.location.pathname.includes('/fast-results/');

var tierBookmakers = exports.tierBookmakers = {
    tierOne: 'Tier 1',
    tierTwo: 'Tier 2'
};

var BOOKMAKER_STATUS = exports.BOOKMAKER_STATUS = {
    OPEN: 'open',
    CLOSE: 'close'
};

var BOOKMAKER_ANALYTICS = exports.BOOKMAKER_ANALYTICS = {
    MORE_OFFERS_TITLE: 'More Offers',
    TODAYS_OFFERS_TITLE: "Today's Offers",
    TODAYS_OFFERS_TITLE_QUICK_LINK: "Today's Offers - Quick Link"
};

var COUNTRY_CODES = exports.COUNTRY_CODES = {
    IRE: 'IRE',
    IE: 'IE'
};

var CURRENCY_SYMBOLS = exports.CURRENCY_SYMBOLS = {
    GBP: '£',
    EUR: '€'
};

var BOOKMAKER_OFFER_TYPE = exports.BOOKMAKER_OFFER_TYPE = {
    TIER_ONE: 'Tier 1',
    EXCLUSIVE: 'Exclusive'
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.orderByPosition = undefined;

var _shuffleArray = __webpack_require__(27);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// eslint-disable-next-line import/prefer-default-export
var orderByPosition = exports.orderByPosition = function orderByPosition(offers) {
    var withPosition = [];
    var nonPositioned = [];
    offers.forEach(function (offer) {
        if (offer.position && offer.position !== 0) {
            withPosition.push(offer);
        } else nonPositioned.push(offer);
    });

    return [].concat(_toConsumableArray(withPosition.sort(function (a, b) {
        return a.position - b.position;
    })), _toConsumableArray((0, _shuffleArray.shuffleArray)(nonPositioned, new Date().getTime())));
};

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE_2__;

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function isObject(obj) {
  return obj !== null && (typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function extend(target, src) {
  if (target === void 0) {
    target = {};
  }
  if (src === void 0) {
    src = {};
  }
  Object.keys(src).forEach(function (key) {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      extend(target[key], src[key]);
    }
  });
}
var ssrDocument = {
  body: {},
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},

  activeElement: {
    blur: function blur() {},

    nodeName: ''
  },
  querySelector: function querySelector() {
    return null;
  },
  querySelectorAll: function querySelectorAll() {
    return [];
  },
  getElementById: function getElementById() {
    return null;
  },
  createEvent: function createEvent() {
    return {
      initEvent: function initEvent() {}
    };
  },
  createElement: function createElement() {
    return {
      children: [],
      childNodes: [],
      style: {},
      setAttribute: function setAttribute() {},
      getElementsByTagName: function getElementsByTagName() {
        return [];
      }
    };
  },
  createElementNS: function createElementNS() {
    return {};
  },
  importNode: function importNode() {
    return null;
  },

  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  }
};
function getDocument() {
  var doc = typeof document !== 'undefined' ? document : {};
  extend(doc, ssrDocument);
  return doc;
}
var ssrWindow = {
  document: ssrDocument,
  navigator: {
    userAgent: ''
  },
  location: {
    hash: '',
    host: '',
    hostname: '',
    href: '',
    origin: '',
    pathname: '',
    protocol: '',
    search: ''
  },
  history: {
    replaceState: function replaceState() {},
    pushState: function pushState() {},
    go: function go() {},
    back: function back() {}
  },
  CustomEvent: function CustomEvent() {
    return this;
  },
  addEventListener: function addEventListener() {},
  removeEventListener: function removeEventListener() {},
  getComputedStyle: function getComputedStyle() {
    return {
      getPropertyValue: function getPropertyValue() {
        return '';
      }
    };
  },
  Image: function Image() {},
  Date: function Date() {},

  screen: {},
  setTimeout: function setTimeout() {},
  clearTimeout: function clearTimeout() {},
  matchMedia: function matchMedia() {
    return {};
  },
  requestAnimationFrame: function requestAnimationFrame(callback) {
    if (typeof setTimeout === 'undefined') {
      callback();
      return null;
    }
    return setTimeout(callback, 0);
  },
  cancelAnimationFrame: function cancelAnimationFrame(id) {
    if (typeof setTimeout === 'undefined') {
      return;
    }
    clearTimeout(id);
  }
};
function getWindow() {
  var win = typeof window !== 'undefined' ? window : {};
  extend(win, ssrWindow);
  return win;
}

exports.a = getWindow;
exports.g = getDocument;

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.replaceCurrencySigns = undefined;

var _constants = __webpack_require__(0);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// eslint-disable-next-line import/prefer-default-export
var replaceCurrencySigns = exports.replaceCurrencySigns = function replaceCurrencySigns() {
    var oddsComparisonPrices = document.getElementsByClassName('RC-oddsRaceContent__dataOffer');
    var betPopupsHeadline = document.getElementsByClassName('RC-oddsRaceContent__offerPopoverHeadline');
    var betPopupsOffer = document.getElementsByClassName('RC-oddsRaceContent__offerPopoverOffer');
    var chooseBookieOffers = document.getElementsByClassName('RC-chooseBookieMobile__buttonFreeBet');

    Array.from([].concat(_toConsumableArray(oddsComparisonPrices), _toConsumableArray(betPopupsHeadline), _toConsumableArray(betPopupsOffer), _toConsumableArray(chooseBookieOffers))).forEach(function (element) {
        // eslint-disable-next-line
        element.innerHTML = element.innerHTML.replaceAll(_constants.CURRENCY_SYMBOLS.GBP, _constants.CURRENCY_SYMBOLS.EUR);
    });
};

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
// eslint-disable-next-line import/prefer-default-export
var BUTTON_TEXT = exports.BUTTON_TEXT = 'CLAIM OFFER';

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getBookmakersToShow = exports.shouldShowBookmaker = undefined;

var _constants = __webpack_require__(0);

var _localStorageHandlers = __webpack_require__(25);

/**
 * Filters out bookmakers that the user has either:
 * - Marked as having an account with during the bookmaker quiz
 * - Recently logged into
 *
 * Quiz location: 'https://www.racingpost.com/free-bets/bookmakers-quiz/'
 *
 * @param {Array} offers - List of bookmaker offers to filter.
 *
 * Excluded bookmakers are determined based on stored user data:s
 * - `__user_traits` (stores bookmakers selected in the quiz)
 * - `__recent_bookmakers` (stores recently logged-in bookmakers)
 *
 * @returns {Array} - A filtered list of bookmakers that are still eligible to be shown.
 * NOTE: It's valid only for TIER ONE bookmaker offers.
 */

/* eslint-disable no-multi-spaces, arrow-parens, import/prefer-default-export */
var getTransformedBookmakerName = function getTransformedBookmakerName(bookmaker, type, isContainInQuiz) {
    if (isContainInQuiz) {
        var bookmakerNameQuiz = type === _constants.BOOKMAKER_OFFER_TYPE.TIER_ONE ? bookmaker.displayName.toLowerCase().replace(' ', '_') : bookmaker.name.toLowerCase().replace(' ', '_');

        return bookmakerNameQuiz.includes('skybet') ? 'sky_bet_quiz' : bookmakerNameQuiz + '_quiz';
    }

    return type === _constants.BOOKMAKER_OFFER_TYPE.TIER_ONE ? bookmaker.displayName.toLowerCase().replace(' ', '') : bookmaker.name.toLowerCase().replace(' ', '');
};

var shouldShowBookmaker = exports.shouldShowBookmaker = function shouldShowBookmaker(bookmaker, type) {
    var userTraits = (0, _localStorageHandlers.tryParseJson)((0, _localStorageHandlers.getLocalStorageItem)('__user_traits') || '{}');
    var recentBookmakers = (0, _localStorageHandlers.tryParseJson)((0, _localStorageHandlers.getLocalStorageItem)('recentBookmakers') || '{}');
    var isTierOne = bookmaker.isTierOne || Number(bookmaker.bookmaker_tier) === 1;

    if (!isTierOne) {
        return true;
    }

    return !userTraits[getTransformedBookmakerName(bookmaker, type, true)] && !recentBookmakers[getTransformedBookmakerName(bookmaker, type, false)];
};

var getBookmakersToShow = exports.getBookmakersToShow = function getBookmakersToShow(bookmakerOffers, type) {
    return bookmakerOffers.filter(function (bookmaker) {
        return shouldShowBookmaker(bookmaker, type);
    });
};

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _bookmakersExclusiveOffersPanel = __webpack_require__(16);

var _bookmakersExclusiveOffersPanel2 = _interopRequireDefault(_bookmakersExclusiveOffersPanel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

/**
 * Tranfsorm bookmakers and filter
 * by display_offer to be visible in the carousel
 *
 * @param { Object } bookmakers
 * @returns { desktopBookmakers, mobileBookmakers }
 *
 */
var transformBookmakersExclusive = function transformBookmakersExclusive(bookmakers) {
    var desktopBookmakers = [];
    var mobileBookmakers = [];

    // eslint-disable-next-line no-restricted-syntax
    for (var bookmakerKey in bookmakers) {
        if (bookmakers[bookmakerKey].desktop && bookmakers[bookmakerKey].desktop.display_offer === 'true' && bookmakers[bookmakerKey].desktop.name !== null) {
            desktopBookmakers.push(bookmakers[bookmakerKey].desktop);
        }

        if (bookmakers[bookmakerKey].mobile && bookmakers[bookmakerKey].mobile.display_offer === 'true' && bookmakers[bookmakerKey].mobile.name !== null) {
            mobileBookmakers.push(bookmakers[bookmakerKey].mobile);
        }
    }

    return { desktopBookmakers: desktopBookmakers, mobileBookmakers: mobileBookmakers };
};

var fetchBookmakerExclusiveOffers = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return fetch(window.location.origin + '/api/stubs/bookmaker-exclusive-offers/').then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            return response.json();
                        }).then(function (data) {
                            var _transformBookmakersE = transformBookmakersExclusive(data.exclusiveOffers),
                                desktopBookmakers = _transformBookmakersE.desktopBookmakers,
                                mobileBookmakers = _transformBookmakersE.mobileBookmakers;

                            (0, _bookmakersExclusiveOffersPanel2.default)(desktopBookmakers, mobileBookmakers);
                        }).catch(function (error) {
                            console.error('There was an error fetching the data for bookmaker offer t2/3', error);
                        });

                    case 2:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function fetchBookmakerExclusiveOffers() {
        return _ref.apply(this, arguments);
    };
}();

exports.default = fetchBookmakerExclusiveOffers;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(0);

var _orderByPosition = __webpack_require__(1);

var _replaceCurrencySigns = __webpack_require__(4);

var _renderPromotedTierTwoBookmakers = __webpack_require__(20);

var _renderPromotedTierTwoBookmakers2 = _interopRequireDefault(_renderPromotedTierTwoBookmakers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var fetchBookmakersMixedTier = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return fetch(window.location.origin + '/api/stubs/bookmaker-offers-mixed-tier/').then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            return response.json();
                        }).then(function (data) {
                            if (data.shortCode === _constants.COUNTRY_CODES.IRE || data.shortCode === _constants.COUNTRY_CODES.IE) {
                                (0, _replaceCurrencySigns.replaceCurrencySigns)();
                            }

                            var bookmakerOffersTierTwoDesktop = data.bookmakerOffersTierTwoDesktop,
                                bookmakerOffersTierTwoMobile = data.bookmakerOffersTierTwoMobile;

                            // NOTE: Order by position regarding requirements of [JP-10686]

                            (0, _renderPromotedTierTwoBookmakers2.default)((0, _orderByPosition.orderByPosition)(bookmakerOffersTierTwoDesktop), (0, _orderByPosition.orderByPosition)(bookmakerOffersTierTwoMobile));
                        }).catch(function (error) {
                            console.error('There was an error fetching the data for bookmaker offer t2/3', error);
                        });

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function fetchBookmakersMixedTier() {
        return _ref.apply(this, arguments);
    };
}();

exports.default = fetchBookmakersMixedTier;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _renderTierOneBookmakers = __webpack_require__(22);

var _renderTierOneBookmakers2 = _interopRequireDefault(_renderTierOneBookmakers);

var _orderByPosition = __webpack_require__(1);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var fetchBookmakersTierOne = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return fetch(window.location.origin + '/api/stubs/bookmaker-offers-tier-one/').then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            return response.json();
                        }).then(function (data) {
                            (0, _renderTierOneBookmakers2.default)((0, _orderByPosition.orderByPosition)(data.bookmakerOffersDesktop), (0, _orderByPosition.orderByPosition)(data.bookmakerOffersMobile), data.freeBetsDesktopOffers, data.freeBetsMobileOffers);
                        }).catch(function (error) {
                            console.error('There was an error fetching the data for tier 1 bookmaker offer', error);
                        });

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function fetchBookmakersTierOne() {
        return _ref.apply(this, arguments);
    };
}();

exports.default = fetchBookmakersTierOne;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(0);

var _orderByPosition = __webpack_require__(1);

var _bookmakersTierTwoPanel = __webpack_require__(18);

var _bookmakersTierTwoPanel2 = _interopRequireDefault(_bookmakersTierTwoPanel);

var _replaceCurrencySigns = __webpack_require__(4);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var transformBookmakersTierTwo = function transformBookmakersTierTwo(bookmakers) {
    var bookmakerOffersTierTwoDesktop = bookmakers.bookmakerOffersTierTwoDesktop,
        bookmakerOffersTierTwoMobile = bookmakers.bookmakerOffersTierTwoMobile;

    // Those offers are used for T2/T3 bookmaker offers panel

    var moreOffersBookmakers = _constants.isMobile ? bookmakerOffersTierTwoMobile : bookmakerOffersTierTwoDesktop;
    var filteredMoreOffers = moreOffersBookmakers.filter(function (bookmaker) {
        return bookmaker.name && bookmaker.includeInTier2Panel;
    });
    var filteredMoreOffersBookmakers = (0, _orderByPosition.orderByPosition)(filteredMoreOffers);

    return { filteredMoreOffersBookmakers: filteredMoreOffersBookmakers };
};

var fetchBookmakersTierTwo = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return fetch(window.location.origin + '/api/stubs/bookmaker-offers-tier-two/').then(function (response) {
                            if (!response.ok) {
                                throw new Error('Network response was not ok');
                            }

                            return response.json();
                        }).then(function (data) {
                            var _transformBookmakersT = transformBookmakersTierTwo(data),
                                filteredMoreOffersBookmakers = _transformBookmakersT.filteredMoreOffersBookmakers;

                            if (_constants.isRacecardsOrResults) {
                                (0, _bookmakersTierTwoPanel2.default)(filteredMoreOffersBookmakers);
                            }

                            if (data.shortCode === _constants.COUNTRY_CODES.IRE || data.shortCode === _constants.COUNTRY_CODES.IE) {
                                (0, _replaceCurrencySigns.replaceCurrencySigns)();
                            }
                        }).catch(function (error) {
                            console.error('There was an error fetching the data for bookmaker offer t2/3', error);
                        });

                    case 2:
                        return _context.abrupt('return', _context.sent);

                    case 3:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function fetchBookmakersTierTwo() {
        return _ref.apply(this, arguments);
    };
}();

exports.default = fetchBookmakersTierTwo;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// eslint-disable-next-line import/prefer-default-export
var BOOKMAKERS_DISPLAY_NAME = {
    matchbook: 'Matchbook',
    netbet: 'Netbet',
    sbk: 'SBK',
    copybet: 'CopyBet',
    kwiff: 'Kwiff',
    boylesports: 'Boyle Sports',
    unibet: 'Unibet',
    parimatch: 'Parimatch',
    spreadex: 'SpreadEx',
    planetsports: 'Planet Sports',
    easybet: 'EasyBet',
    bet365: 'bet365',
    skybet: 'SkyBet',
    coral: 'Coral',
    ladbrokes: 'Ladbrokes',
    paddypower: 'Paddy Power',
    betfair: 'Betfair',
    williamhill: 'William Hill',
    tote: 'Tote',
    betmgm: 'BetMGM',
    betway: 'Betway',
    livescore: 'Livescore',
    virginbet: 'Virgin Bet',
    midnite: 'Midnite',
    bzeebet: 'Bzeebet',
    betfred: 'Betfred',
    betgoodwin: 'BetGoodwin',
    starsports: 'Star Sports',
    '10bet': '10Bet',
    jeffbet: 'JeffBet'
};

/* eslint-disable import/prefer-default-export */
var getBookmakersName = exports.getBookmakersName = function getBookmakersName(name) {
    return BOOKMAKERS_DISPLAY_NAME[name.toLowerCase().replace(' ', '')];
};

/***/ }),
/* 12 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.d = exports.S = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _ssrWindowEsm = __webpack_require__(3);

var _utils = __webpack_require__(14);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var support = void 0;
function calcSupport() {
  var window = (0, _ssrWindowEsm.a)();
  var document = (0, _ssrWindowEsm.g)();
  return {
    smoothScroll: document.documentElement && document.documentElement.style && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch)
  };
}
function getSupport() {
  if (!support) {
    support = calcSupport();
  }
  return support;
}

var deviceCached = void 0;
function calcDevice(_temp) {
  var _ref3 = _temp === void 0 ? {} : _temp,
      userAgent = _ref3.userAgent;

  var support = getSupport();
  var window = (0, _ssrWindowEsm.a)();
  var platform = window.navigator.platform;
  var ua = userAgent || window.navigator.userAgent;
  var device = {
    ios: false,
    android: false
  };
  var screenWidth = window.screen.width;
  var screenHeight = window.screen.height;
  var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
  var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  var windows = platform === 'Win32';
  var macos = platform === 'MacIntel';

  // iPadOs 13 fix
  var iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];
  if (!ipad && macos && support.touch && iPadScreens.indexOf(screenWidth + 'x' + screenHeight) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  }

  // Android
  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }
  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  }

  // Export object
  return device;
}
function getDevice(overrides) {
  if (overrides === void 0) {
    overrides = {};
  }
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }
  return deviceCached;
}

var browser = void 0;
function calcBrowser() {
  var window = (0, _ssrWindowEsm.a)();
  var device = getDevice();
  var needPerspectiveFix = false;
  function isSafari() {
    var ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }
  if (isSafari()) {
    var ua = String(window.navigator.userAgent);
    if (ua.includes('Version/')) {
      var _ua$split$1$split$0$s = ua.split('Version/')[1].split(' ')[0].split('.').map(function (num) {
        return Number(num);
      }),
          _ua$split$1$split$0$s2 = _slicedToArray(_ua$split$1$split$0$s, 2),
          major = _ua$split$1$split$0$s2[0],
          minor = _ua$split$1$split$0$s2[1];

      needPerspectiveFix = major < 16 || major === 16 && minor < 2;
    }
  }
  var isWebView = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent);
  var isSafariBrowser = isSafari();
  var need3dFix = isSafariBrowser || isWebView && device.ios;
  return {
    isSafari: needPerspectiveFix || isSafariBrowser,
    needPerspectiveFix: needPerspectiveFix,
    need3dFix: need3dFix,
    isWebView: isWebView
  };
}
function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }
  return browser;
}

function Resize(_ref) {
  var swiper = _ref.swiper,
      on = _ref.on,
      emit = _ref.emit;

  var window = (0, _ssrWindowEsm.a)();
  var observer = null;
  var animationFrame = null;
  var resizeHandler = function resizeHandler() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };
  var createObserver = function createObserver() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(function (entries) {
      animationFrame = window.requestAnimationFrame(function () {
        var width = swiper.width,
            height = swiper.height;

        var newWidth = width;
        var newHeight = height;
        entries.forEach(function (_ref2) {
          var contentBoxSize = _ref2.contentBoxSize,
              contentRect = _ref2.contentRect,
              target = _ref2.target;

          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });
        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };
  var removeObserver = function removeObserver() {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }
    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };
  var orientationChangeHandler = function orientationChangeHandler() {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };
  on('init', function () {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }
    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', function () {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

function Observer(_ref) {
  var swiper = _ref.swiper,
      extendParams = _ref.extendParams,
      on = _ref.on,
      emit = _ref.emit;

  var observers = [];
  var window = (0, _ssrWindowEsm.a)();
  var attach = function attach(target, options) {
    if (options === void 0) {
      options = {};
    }
    var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    var observer = new ObserverFunc(function (mutations) {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (swiper.__preventObserver__) return;
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }
      var observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };
  var init = function init() {
    if (!swiper.params.observer) return;
    if (swiper.params.observeParents) {
      var containerParents = (0, _utils.a)(swiper.hostEl);
      for (var i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    }
    // Observe container
    attach(swiper.hostEl, {
      childList: swiper.params.observeSlideChildren
    });

    // Observe wrapper
    attach(swiper.wrapperEl, {
      attributes: false
    });
  };
  var destroy = function destroy() {
    observers.forEach(function (observer) {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };
  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */

var eventsEmitter = {
  on: function on(events, handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(function (event) {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },
  once: function once(events, handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    function onceHandler() {
      self.off(events, onceHandler);
      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      handler.apply(self, args);
    }
    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },
  onAny: function onAny(handler, priority) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    var method = priority ? 'unshift' : 'push';
    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }
    return self;
  },
  offAny: function offAny(handler) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    var index = self.eventsAnyListeners.indexOf(handler);
    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }
    return self;
  },
  off: function off(events, handler) {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(function (event) {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler, index) {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },
  emit: function emit() {
    var self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    var events = void 0;
    var data = void 0;
    var context = void 0;
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }
    data.unshift(context);
    var eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(function (event) {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(function (eventHandler) {
          eventHandler.apply(context, [event].concat(_toConsumableArray(data)));
        });
      }
      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(function (eventHandler) {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }
};

function updateSize() {
  var swiper = this;
  var width = void 0;
  var height = void 0;
  var el = swiper.el;
  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = el.clientWidth;
  }
  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = el.clientHeight;
  }
  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  }

  // Subtract paddings
  width = width - parseInt((0, _utils.o)(el, 'padding-left') || 0, 10) - parseInt((0, _utils.o)(el, 'padding-right') || 0, 10);
  height = height - parseInt((0, _utils.o)(el, 'padding-top') || 0, 10) - parseInt((0, _utils.o)(el, 'padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width: width,
    height: height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  var swiper = this;
  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(swiper.getDirectionLabel(label)) || 0);
  }
  var params = swiper.params;
  var wrapperEl = swiper.wrapperEl,
      slidesEl = swiper.slidesEl,
      swiperSize = swiper.size,
      rtl = swiper.rtlTranslate,
      wrongRTL = swiper.wrongRTL;

  var isVirtual = swiper.virtual && params.virtual.enabled;
  var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  var slides = (0, _utils.e)(slidesEl, '.' + swiper.params.slideClass + ', swiper-slide');
  var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  var snapGrid = [];
  var slidesGrid = [];
  var slidesSizesGrid = [];
  var offsetBefore = params.slidesOffsetBefore;
  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }
  var offsetAfter = params.slidesOffsetAfter;
  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }
  var previousSnapGridLength = swiper.snapGrid.length;
  var previousSlidesGridLength = swiper.slidesGrid.length;
  var spaceBetween = params.spaceBetween;
  var slidePosition = -offsetBefore;
  var prevSlideSize = 0;
  var index = 0;
  if (typeof swiperSize === 'undefined') {
    return;
  }
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  swiper.virtualSize = -spaceBetween;

  // reset margins
  slides.forEach(function (slideEl) {
    if (rtl) {
      slideEl.style.marginLeft = '';
    } else {
      slideEl.style.marginRight = '';
    }
    slideEl.style.marginBottom = '';
    slideEl.style.marginTop = '';
  });

  // reset cssMode offsets
  if (params.centeredSlides && params.cssMode) {
    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-before', '');
    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-after', '');
  }
  var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
  if (gridEnabled) {
    swiper.grid.initSlides(slides);
  } else if (swiper.grid) {
    swiper.grid.unsetSlides();
  }

  // Calc slides
  var slideSize = void 0;
  var shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(function (key) {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;
  for (var i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    var _slide = void 0;
    if (slides[i]) _slide = slides[i];
    if (gridEnabled) {
      swiper.grid.updateSlide(i, _slide, slides);
    }
    if (slides[i] && (0, _utils.o)(_slide, 'display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[swiper.getDirectionLabel('width')] = '';
      }
      var slideStyles = getComputedStyle(_slide);
      var currentTransform = _slide.style.transform;
      var currentWebKitTransform = _slide.style.webkitTransform;
      if (currentTransform) {
        _slide.style.transform = 'none';
      }
      if (currentWebKitTransform) {
        _slide.style.webkitTransform = 'none';
      }
      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? (0, _utils.f)(_slide, 'width', true) : (0, _utils.f)(_slide, 'height', true);
      } else {
        // eslint-disable-next-line
        var width = getDirectionPropertyValue(slideStyles, 'width');
        var paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        var paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        var marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        var marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        var boxSizing = slideStyles.getPropertyValue('box-sizing');
        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          var _slide2 = _slide,
              clientWidth = _slide2.clientWidth,
              offsetWidth = _slide2.offsetWidth;

          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }
      if (currentTransform) {
        _slide.style.transform = currentTransform;
      }
      if (currentWebKitTransform) {
        _slide.style.webkitTransform = currentWebKitTransform;
      }
      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);
      if (slides[i]) {
        slides[i].style[swiper.getDirectionLabel('width')] = slideSize + 'px';
      }
    }
    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }
    slidesSizesGrid.push(slideSize);
    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }
    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }
  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    wrapperEl.style.width = swiper.virtualSize + spaceBetween + 'px';
  }
  if (params.setWrapperSize) {
    wrapperEl.style[swiper.getDirectionLabel('width')] = swiper.virtualSize + spaceBetween + 'px';
  }
  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid);
  }

  // Remove last grid elements depending on width
  if (!params.centeredSlides) {
    var newSlidesGrid = [];
    for (var _i = 0; _i < snapGrid.length; _i += 1) {
      var slidesGridItem = snapGrid[_i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
      if (snapGrid[_i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }
    snapGrid = newSlidesGrid;
    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }
  if (isVirtual && params.loop) {
    var size = slidesSizesGrid[0] + spaceBetween;
    if (params.slidesPerGroup > 1) {
      var groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
      var groupSize = size * params.slidesPerGroup;
      for (var _i2 = 0; _i2 < groups; _i2 += 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
      }
    }
    for (var _i3 = 0; _i3 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; _i3 += 1) {
      if (params.slidesPerGroup === 1) {
        snapGrid.push(snapGrid[snapGrid.length - 1] + size);
      }
      slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
      swiper.virtualSize += size;
    }
  }
  if (snapGrid.length === 0) snapGrid = [0];
  if (spaceBetween !== 0) {
    var key = swiper.isHorizontal() && rtl ? 'marginLeft' : swiper.getDirectionLabel('marginRight');
    slides.filter(function (_, slideIndex) {
      if (!params.cssMode || params.loop) return true;
      if (slideIndex === slides.length - 1) {
        return false;
      }
      return true;
    }).forEach(function (slideEl) {
      slideEl.style[key] = spaceBetween + 'px';
    });
  }
  if (params.centeredSlides && params.centeredSlidesBounds) {
    var allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    allSlidesSize -= spaceBetween;
    var maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(function (snap) {
      if (snap <= 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }
  if (params.centerInsufficientSlides) {
    var _allSlidesSize = 0;
    slidesSizesGrid.forEach(function (slideSizeValue) {
      _allSlidesSize += slideSizeValue + (spaceBetween || 0);
    });
    _allSlidesSize -= spaceBetween;
    if (_allSlidesSize < swiperSize) {
      var allSlidesOffset = (swiperSize - _allSlidesSize) / 2;
      snapGrid.forEach(function (snap, snapIndex) {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach(function (snap, snapIndex) {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }
  Object.assign(swiper, {
    slides: slides,
    snapGrid: snapGrid,
    slidesGrid: slidesGrid,
    slidesSizesGrid: slidesSizesGrid
  });
  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-before', -snapGrid[0] + 'px');
    (0, _utils.s)(wrapperEl, '--swiper-centered-offset-after', swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2 + 'px');
    var addToSnapGrid = -swiper.snapGrid[0];
    var addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(function (v) {
      return v + addToSnapGrid;
    });
    swiper.slidesGrid = swiper.slidesGrid.map(function (v) {
      return v + addToSlidesGrid;
    });
  }
  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }
  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }
  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  swiper.emit('slidesUpdated');
  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    var backFaceHiddenClass = params.containerModifierClass + 'backface-hidden';
    var hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.el.classList.remove(backFaceHiddenClass);
    }
  }
}

function updateAutoHeight(speed) {
  var swiper = this;
  var activeSlides = [];
  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  var newHeight = 0;
  var i = void 0;
  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }
  var getSlideByIndex = function getSlideByIndex(index) {
    if (isVirtual) {
      return swiper.slides[swiper.getSlideIndexByData(index)];
    }
    return swiper.slides[index];
  };
  // Find slides currently in view
  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || []).forEach(function (slide) {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        var index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  }

  // Find new height from highest slide in view
  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      var height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  }

  // Update Height
  if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = newHeight + 'px';
}

function updateSlidesOffset() {
  var swiper = this;
  var slides = swiper.slides;
  // eslint-disable-next-line
  var minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
  for (var i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
  }
}

function updateSlidesProgress(translate) {
  if (translate === void 0) {
    translate = this && this.translate || 0;
  }
  var swiper = this;
  var params = swiper.params;
  var slides = swiper.slides,
      rtl = swiper.rtlTranslate,
      snapGrid = swiper.snapGrid;

  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  var offsetCenter = -translate;
  if (rtl) offsetCenter = translate;

  // Visible Slides
  slides.forEach(function (slideEl) {
    slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass);
  });
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];
  var spaceBetween = params.spaceBetween;
  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiper.size;
  } else if (typeof spaceBetween === 'string') {
    spaceBetween = parseFloat(spaceBetween);
  }
  for (var i = 0; i < slides.length; i += 1) {
    var _slide3 = slides[i];
    var slideOffset = _slide3.swiperSlideOffset;
    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }
    var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (_slide3.swiperSlideSize + spaceBetween);
    var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (_slide3.swiperSlideSize + spaceBetween);
    var slideBefore = -(offsetCenter - slideOffset);
    var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    var isFullyVisible = slideBefore >= 0 && slideBefore <= swiper.size - swiper.slidesSizesGrid[i];
    var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
    if (isVisible) {
      swiper.visibleSlides.push(_slide3);
      swiper.visibleSlidesIndexes.push(i);
      slides[i].classList.add(params.slideVisibleClass);
    }
    if (isFullyVisible) {
      slides[i].classList.add(params.slideFullyVisibleClass);
    }
    _slide3.progress = rtl ? -slideProgress : slideProgress;
    _slide3.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }
}

function updateProgress(translate) {
  var swiper = this;
  if (typeof translate === 'undefined') {
    var multiplier = swiper.rtlTranslate ? -1 : 1;
    // eslint-disable-next-line
    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }
  var params = swiper.params;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  var progress = swiper.progress,
      isBeginning = swiper.isBeginning,
      isEnd = swiper.isEnd,
      progressLoop = swiper.progressLoop;

  var wasBeginning = isBeginning;
  var wasEnd = isEnd;
  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    var isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
    var isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
    isBeginning = isBeginningRounded || progress <= 0;
    isEnd = isEndRounded || progress >= 1;
    if (isBeginningRounded) progress = 0;
    if (isEndRounded) progress = 1;
  }
  if (params.loop) {
    var firstSlideIndex = swiper.getSlideIndexByData(0);
    var lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
    var firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
    var lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
    var translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
    var translateAbs = Math.abs(translate);
    if (translateAbs >= firstSlideTranslate) {
      progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
    } else {
      progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
    }
    if (progressLoop > 1) progressLoop -= 1;
  }
  Object.assign(swiper, {
    progress: progress,
    progressLoop: progressLoop,
    isBeginning: isBeginning,
    isEnd: isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }
  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }
  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }
  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  var swiper = this;
  var slides = swiper.slides,
      params = swiper.params,
      slidesEl = swiper.slidesEl,
      activeIndex = swiper.activeIndex;

  var isVirtual = swiper.virtual && params.virtual.enabled;
  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  var getFilteredSlide = function getFilteredSlide(selector) {
    return (0, _utils.e)(slidesEl, '.' + params.slideClass + selector + ', swiper-slide' + selector)[0];
  };
  slides.forEach(function (slideEl) {
    slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
  });
  var activeSlide = void 0;
  var prevSlide = void 0;
  var nextSlide = void 0;
  if (isVirtual) {
    if (params.loop) {
      var slideIndex = activeIndex - swiper.virtual.slidesBefore;
      if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
      if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
      activeSlide = getFilteredSlide('[data-swiper-slide-index="' + slideIndex + '"]');
    } else {
      activeSlide = getFilteredSlide('[data-swiper-slide-index="' + activeIndex + '"]');
    }
  } else {
    if (gridEnabled) {
      activeSlide = slides.filter(function (slideEl) {
        return slideEl.column === activeIndex;
      })[0];
      nextSlide = slides.filter(function (slideEl) {
        return slideEl.column === activeIndex + 1;
      })[0];
      prevSlide = slides.filter(function (slideEl) {
        return slideEl.column === activeIndex - 1;
      })[0];
    } else {
      activeSlide = slides[activeIndex];
    }
  }
  if (activeSlide) {
    // Active classes
    activeSlide.classList.add(params.slideActiveClass);
    if (gridEnabled) {
      if (nextSlide) {
        nextSlide.classList.add(params.slideNextClass);
      }
      if (prevSlide) {
        prevSlide.classList.add(params.slidePrevClass);
      }
    } else {
      // Next Slide
      nextSlide = (0, _utils.p)(activeSlide, '.' + params.slideClass + ', swiper-slide')[0];
      if (params.loop && !nextSlide) {
        nextSlide = slides[0];
      }
      if (nextSlide) {
        nextSlide.classList.add(params.slideNextClass);
      }

      // Prev Slide
      prevSlide = (0, _utils.q)(activeSlide, '.' + params.slideClass + ', swiper-slide')[0];
      if (params.loop && !prevSlide === 0) {
        prevSlide = slides[slides.length - 1];
      }
      if (prevSlide) {
        prevSlide.classList.add(params.slidePrevClass);
      }
    }
  }
  swiper.emitSlidesClasses();
}

var processLazyPreloader = function processLazyPreloader(swiper, imageEl) {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  var slideSelector = function slideSelector() {
    return swiper.isElement ? 'swiper-slide' : '.' + swiper.params.slideClass;
  };
  var slideEl = imageEl.closest(slideSelector());
  if (slideEl) {
    var lazyEl = slideEl.querySelector('.' + swiper.params.lazyPreloaderClass);
    if (!lazyEl && swiper.isElement) {
      if (slideEl.shadowRoot) {
        lazyEl = slideEl.shadowRoot.querySelector('.' + swiper.params.lazyPreloaderClass);
      } else {
        // init later
        requestAnimationFrame(function () {
          if (slideEl.shadowRoot) {
            lazyEl = slideEl.shadowRoot.querySelector('.' + swiper.params.lazyPreloaderClass);
            if (lazyEl) lazyEl.remove();
          }
        });
      }
    }
    if (lazyEl) lazyEl.remove();
  }
};
var unlazy = function unlazy(swiper, index) {
  if (!swiper.slides[index]) return;
  var imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
  if (imageEl) imageEl.removeAttribute('loading');
};
var preload = function preload(swiper) {
  if (!swiper || swiper.destroyed || !swiper.params) return;
  var amount = swiper.params.lazyPreloadPrevNext;
  var len = swiper.slides.length;
  if (!len || !amount || amount < 0) return;
  amount = Math.min(amount, len);
  var slidesPerView = swiper.params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
  var activeIndex = swiper.activeIndex;
  if (swiper.params.grid && swiper.params.grid.rows > 1) {
    var activeColumn = activeIndex;
    var preloadColumns = [activeColumn - amount];
    preloadColumns.push.apply(preloadColumns, _toConsumableArray(Array.from({
      length: amount
    }).map(function (_, i) {
      return activeColumn + slidesPerView + i;
    })));
    swiper.slides.forEach(function (slideEl, i) {
      if (preloadColumns.includes(slideEl.column)) unlazy(swiper, i);
    });
    return;
  }
  var slideIndexLastInView = activeIndex + slidesPerView - 1;
  if (swiper.params.rewind || swiper.params.loop) {
    for (var i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1) {
      var realIndex = (i % len + len) % len;
      if (realIndex < activeIndex || realIndex > slideIndexLastInView) unlazy(swiper, realIndex);
    }
  } else {
    for (var _i4 = Math.max(activeIndex - amount, 0); _i4 <= Math.min(slideIndexLastInView + amount, len - 1); _i4 += 1) {
      if (_i4 !== activeIndex && (_i4 > slideIndexLastInView || _i4 < activeIndex)) {
        unlazy(swiper, _i4);
      }
    }
  }
};

function getActiveIndexByTranslate(swiper) {
  var slidesGrid = swiper.slidesGrid,
      params = swiper.params;

  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var activeIndex = void 0;
  for (var i = 0; i < slidesGrid.length; i += 1) {
    if (typeof slidesGrid[i + 1] !== 'undefined') {
      if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
        activeIndex = i;
      } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
        activeIndex = i + 1;
      }
    } else if (translate >= slidesGrid[i]) {
      activeIndex = i;
    }
  }
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
  }
  return activeIndex;
}
function updateActiveIndex(newActiveIndex) {
  var swiper = this;
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  var snapGrid = swiper.snapGrid,
      params = swiper.params,
      previousIndex = swiper.activeIndex,
      previousRealIndex = swiper.realIndex,
      previousSnapIndex = swiper.snapIndex;

  var activeIndex = newActiveIndex;
  var snapIndex = void 0;
  var getVirtualRealIndex = function getVirtualRealIndex(aIndex) {
    var realIndex = aIndex - swiper.virtual.slidesBefore;
    if (realIndex < 0) {
      realIndex = swiper.virtual.slides.length + realIndex;
    }
    if (realIndex >= swiper.virtual.slides.length) {
      realIndex -= swiper.virtual.slides.length;
    }
    return realIndex;
  };
  if (typeof activeIndex === 'undefined') {
    activeIndex = getActiveIndexByTranslate(swiper);
  }
  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  if (activeIndex === previousIndex && !swiper.params.loop) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }
    return;
  }
  if (activeIndex === previousIndex && swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
    swiper.realIndex = getVirtualRealIndex(activeIndex);
    return;
  }
  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;

  // Get real index
  var realIndex = void 0;
  if (swiper.virtual && params.virtual.enabled && params.loop) {
    realIndex = getVirtualRealIndex(activeIndex);
  } else if (gridEnabled) {
    var firstSlideInColumn = swiper.slides.filter(function (slideEl) {
      return slideEl.column === activeIndex;
    })[0];
    var activeSlideIndex = parseInt(firstSlideInColumn.getAttribute('data-swiper-slide-index'), 10);
    if (Number.isNaN(activeSlideIndex)) {
      activeSlideIndex = Math.max(swiper.slides.indexOf(firstSlideInColumn), 0);
    }
    realIndex = Math.floor(activeSlideIndex / params.grid.rows);
  } else if (swiper.slides[activeIndex]) {
    var slideIndex = swiper.slides[activeIndex].getAttribute('data-swiper-slide-index');
    if (slideIndex) {
      realIndex = parseInt(slideIndex, 10);
    } else {
      realIndex = activeIndex;
    }
  } else {
    realIndex = activeIndex;
  }
  Object.assign(swiper, {
    previousSnapIndex: previousSnapIndex,
    snapIndex: snapIndex,
    previousRealIndex: previousRealIndex,
    realIndex: realIndex,
    previousIndex: previousIndex,
    activeIndex: activeIndex
  });
  if (swiper.initialized) {
    preload(swiper);
  }
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');
  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    if (previousRealIndex !== realIndex) {
      swiper.emit('realIndexChange');
    }
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(el, path) {
  var swiper = this;
  var params = swiper.params;
  var slide = el.closest('.' + params.slideClass + ', swiper-slide');
  if (!slide && swiper.isElement && path && path.length > 1 && path.includes(el)) {
    [].concat(_toConsumableArray(path.slice(path.indexOf(el) + 1, path.length))).forEach(function (pathEl) {
      if (!slide && pathEl.matches && pathEl.matches('.' + params.slideClass + ', swiper-slide')) {
        slide = pathEl;
      }
    });
  }
  var slideFound = false;
  var slideIndex = void 0;
  if (slide) {
    for (var i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }
  if (slide && slideFound) {
    swiper.clickedSlide = slide;
    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt(slide.getAttribute('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }
  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize: updateSize,
  updateSlides: updateSlides,
  updateAutoHeight: updateAutoHeight,
  updateSlidesOffset: updateSlidesOffset,
  updateSlidesProgress: updateSlidesProgress,
  updateProgress: updateProgress,
  updateSlidesClasses: updateSlidesClasses,
  updateActiveIndex: updateActiveIndex,
  updateClickedSlide: updateClickedSlide
};

function getSwiperTranslate(axis) {
  if (axis === void 0) {
    axis = this.isHorizontal() ? 'x' : 'y';
  }
  var swiper = this;
  var params = swiper.params,
      rtl = swiper.rtlTranslate,
      translate = swiper.translate,
      wrapperEl = swiper.wrapperEl;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }
  if (params.cssMode) {
    return translate;
  }
  var currentTranslate = (0, _utils.i)(wrapperEl, axis);
  currentTranslate += swiper.cssOverflowAdjustment();
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  var swiper = this;
  var rtl = swiper.rtlTranslate,
      params = swiper.params,
      wrapperEl = swiper.wrapperEl,
      progress = swiper.progress;

  var x = 0;
  var y = 0;
  var z = 0;
  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }
  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }
  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y;
  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    if (swiper.isHorizontal()) {
      x -= swiper.cssOverflowAdjustment();
    } else {
      y -= swiper.cssOverflowAdjustment();
    }
    wrapperEl.style.transform = 'translate3d(' + x + 'px, ' + y + 'px, ' + z + 'px)';
  }

  // Check if we need to update progress
  var newProgress = void 0;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }
  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate, speed, runCallbacks, translateBounds, internal) {
  if (translate === void 0) {
    translate = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (translateBounds === void 0) {
    translateBounds = true;
  }
  var swiper = this;
  var params = swiper.params,
      wrapperEl = swiper.wrapperEl;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }
  var minTranslate = swiper.minTranslate();
  var maxTranslate = swiper.maxTranslate();
  var newTranslate = void 0;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate;

  // Update progress
  swiper.updateProgress(newTranslate);
  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      var _wrapperEl$scrollTo;

      if (!swiper.support.smoothScroll) {
        (0, _utils.r)({
          swiper: swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo((_wrapperEl$scrollTo = {}, _defineProperty(_wrapperEl$scrollTo, isH ? 'left' : 'top', -newTranslate), _defineProperty(_wrapperEl$scrollTo, 'behavior', 'smooth'), _wrapperEl$scrollTo));
    }
    return true;
  }
  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);
    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }
    if (!swiper.animating) {
      swiper.animating = true;
      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.wrapperEl.removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;
          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }
      swiper.wrapperEl.addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
    }
  }
  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate: setTranslate,
  minTranslate: minTranslate,
  maxTranslate: maxTranslate,
  translateTo: translateTo
};

function setTransition(duration, byController) {
  var swiper = this;
  if (!swiper.params.cssMode) {
    swiper.wrapperEl.style.transitionDuration = duration + 'ms';
    swiper.wrapperEl.style.transitionDelay = duration === 0 ? '0ms' : '';
  }
  swiper.emit('setTransition', duration, byController);
}

function transitionEmit(_ref) {
  var swiper = _ref.swiper,
      runCallbacks = _ref.runCallbacks,
      direction = _ref.direction,
      step = _ref.step;
  var activeIndex = swiper.activeIndex,
      previousIndex = swiper.previousIndex;

  var dir = direction;
  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }
  swiper.emit('transition' + step);
  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit('slideResetTransition' + step);
      return;
    }
    swiper.emit('slideChangeTransition' + step);
    if (dir === 'next') {
      swiper.emit('slideNextTransition' + step);
    } else {
      swiper.emit('slidePrevTransition' + step);
    }
  }
}

function transitionStart(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  var swiper = this;
  var params = swiper.params;

  if (params.cssMode) return;
  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }
  transitionEmit({
    swiper: swiper,
    runCallbacks: runCallbacks,
    direction: direction,
    step: 'Start'
  });
}

function transitionEnd(runCallbacks, direction) {
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  var swiper = this;
  var params = swiper.params;

  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper: swiper,
    runCallbacks: runCallbacks,
    direction: direction,
    step: 'End'
  });
}

var transition = {
  setTransition: setTransition,
  transitionStart: transitionStart,
  transitionEnd: transitionEnd
};

function slideTo(index, speed, runCallbacks, internal, initial) {
  if (index === void 0) {
    index = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === 'string') {
    index = parseInt(index, 10);
  }
  var swiper = this;
  var slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      previousIndex = swiper.previousIndex,
      activeIndex = swiper.activeIndex,
      rtl = swiper.rtlTranslate,
      wrapperEl = swiper.wrapperEl,
      enabled = swiper.enabled;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial || swiper.destroyed) {
    return false;
  }
  var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  var translate = -snapGrid[snapIndex];
  // Normalize slideIndex
  if (params.normalizeSlideIndex) {
    for (var i = 0; i < slidesGrid.length; i += 1) {
      var normalizedTranslate = -Math.floor(translate * 100);
      var normalizedGrid = Math.floor(slidesGrid[i] * 100);
      var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  }
  // Directions locks
  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) {
      return false;
    }
    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) {
        return false;
      }
    }
  }
  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  }

  // Update progress
  swiper.updateProgress(translate);
  var direction = void 0;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset';

  // Update Index
  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex);
    // Update Height
    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }
    swiper.updateSlidesClasses();
    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }
    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }
    return false;
  }
  if (params.cssMode) {
    var isH = swiper.isHorizontal();
    var t = rtl ? translate : -translate;
    if (speed === 0) {
      var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }
      if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
        swiper._cssModeVirtualInitialSet = true;
        requestAnimationFrame(function () {
          wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
        });
      } else {
        wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
      }
      if (isVirtual) {
        requestAnimationFrame(function () {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._immediateVirtual = false;
        });
      }
    } else {
      var _wrapperEl$scrollTo2;

      if (!swiper.support.smoothScroll) {
        (0, _utils.r)({
          swiper: swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }
      wrapperEl.scrollTo((_wrapperEl$scrollTo2 = {}, _defineProperty(_wrapperEl$scrollTo2, isH ? 'left' : 'top', t), _defineProperty(_wrapperEl$scrollTo2, 'behavior', 'smooth'), _wrapperEl$scrollTo2));
    }
    return true;
  }
  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);
  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;
    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.wrapperEl.removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }
    swiper.wrapperEl.addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
  }
  return true;
}

function slideToLoop(index, speed, runCallbacks, internal) {
  if (index === void 0) {
    index = 0;
  }
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (typeof index === 'string') {
    var indexAsNumber = parseInt(index, 10);
    index = indexAsNumber;
  }
  var swiper = this;
  if (swiper.destroyed) return;
  var gridEnabled = swiper.grid && swiper.params.grid && swiper.params.grid.rows > 1;
  var newIndex = index;
  if (swiper.params.loop) {
    if (swiper.virtual && swiper.params.virtual.enabled) {
      // eslint-disable-next-line
      newIndex = newIndex + swiper.virtual.slidesBefore;
    } else {
      var targetSlideIndex = void 0;
      if (gridEnabled) {
        var slideIndex = newIndex * swiper.params.grid.rows;
        targetSlideIndex = swiper.slides.filter(function (slideEl) {
          return slideEl.getAttribute('data-swiper-slide-index') * 1 === slideIndex;
        })[0].column;
      } else {
        targetSlideIndex = swiper.getSlideIndexByData(newIndex);
      }
      var cols = gridEnabled ? Math.ceil(swiper.slides.length / swiper.params.grid.rows) : swiper.slides.length;
      var centeredSlides = swiper.params.centeredSlides;

      var slidesPerView = swiper.params.slidesPerView;
      if (slidesPerView === 'auto') {
        slidesPerView = swiper.slidesPerViewDynamic();
      } else {
        slidesPerView = Math.ceil(parseFloat(swiper.params.slidesPerView, 10));
        if (centeredSlides && slidesPerView % 2 === 0) {
          slidesPerView = slidesPerView + 1;
        }
      }
      var needLoopFix = cols - targetSlideIndex < slidesPerView;
      if (centeredSlides) {
        needLoopFix = needLoopFix || targetSlideIndex < Math.ceil(slidesPerView / 2);
      }
      if (needLoopFix) {
        var direction = centeredSlides ? targetSlideIndex < swiper.activeIndex ? 'prev' : 'next' : targetSlideIndex - swiper.activeIndex - 1 < swiper.params.slidesPerView ? 'next' : 'prev';
        swiper.loopFix({
          direction: direction,
          slideTo: true,
          activeSlideIndex: direction === 'next' ? targetSlideIndex + 1 : targetSlideIndex - cols + 1,
          slideRealIndex: direction === 'next' ? swiper.realIndex : undefined
        });
      }
      if (gridEnabled) {
        var _slideIndex = newIndex * swiper.params.grid.rows;
        newIndex = swiper.slides.filter(function (slideEl) {
          return slideEl.getAttribute('data-swiper-slide-index') * 1 === _slideIndex;
        })[0].column;
      } else {
        newIndex = swiper.getSlideIndexByData(newIndex);
      }
    }
  }
  requestAnimationFrame(function () {
    swiper.slideTo(newIndex, speed, runCallbacks, internal);
  });
  return swiper;
}

/* eslint no-unused-vars: "off" */
function slideNext(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  var swiper = this;
  var enabled = swiper.enabled,
      params = swiper.params,
      animating = swiper.animating;

  if (!enabled || swiper.destroyed) return swiper;
  var perGroup = params.slidesPerGroup;
  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }
  var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'next'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
    if (swiper.activeIndex === swiper.slides.length - 1 && params.cssMode) {
      requestAnimationFrame(function () {
        swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
      });
      return true;
    }
  }
  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }
  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  var swiper = this;
  var params = swiper.params,
      snapGrid = swiper.snapGrid,
      slidesGrid = swiper.slidesGrid,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled,
      animating = swiper.animating;

  if (!enabled || swiper.destroyed) return swiper;
  var isVirtual = swiper.virtual && params.virtual.enabled;
  if (params.loop) {
    if (animating && !isVirtual && params.loopPreventsSliding) return false;
    swiper.loopFix({
      direction: 'prev'
    });
    // eslint-disable-next-line
    swiper._clientLeft = swiper.wrapperEl.clientLeft;
  }
  var translate = rtlTranslate ? swiper.translate : -swiper.translate;
  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }
  var normalizedTranslate = normalize(translate);
  var normalizedSnapGrid = snapGrid.map(function (val) {
    return normalize(val);
  });
  var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
  if (typeof prevSnap === 'undefined' && params.cssMode) {
    var prevSnapIndex = void 0;
    snapGrid.forEach(function (snap, snapIndex) {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });
    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }
  var prevIndex = 0;
  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }
  if (params.rewind && swiper.isBeginning) {
    var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  } else if (params.loop && swiper.activeIndex === 0 && params.cssMode) {
    requestAnimationFrame(function () {
      swiper.slideTo(prevIndex, speed, runCallbacks, internal);
    });
    return true;
  }
  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed, runCallbacks, internal) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  var swiper = this;
  if (swiper.destroyed) return;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed, runCallbacks, internal, threshold) {
  if (speed === void 0) {
    speed = this.params.speed;
  }
  if (runCallbacks === void 0) {
    runCallbacks = true;
  }
  if (threshold === void 0) {
    threshold = 0.5;
  }
  var swiper = this;
  if (swiper.destroyed) return;
  var index = swiper.activeIndex;
  var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    var currentSnap = swiper.snapGrid[snapIndex];
    var nextSnap = swiper.snapGrid[snapIndex + 1];
    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    var prevSnap = swiper.snapGrid[snapIndex - 1];
    var _currentSnap = swiper.snapGrid[snapIndex];
    if (translate - prevSnap <= (_currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }
  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  var swiper = this;
  if (swiper.destroyed) return;
  var params = swiper.params,
      slidesEl = swiper.slidesEl;

  var slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  var slideToIndex = swiper.clickedIndex;
  var realIndex = void 0;
  var slideSelector = swiper.isElement ? 'swiper-slide' : '.' + params.slideClass;
  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt(swiper.clickedSlide.getAttribute('data-swiper-slide-index'), 10);
    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = swiper.getSlideIndex((0, _utils.e)(slidesEl, slideSelector + '[data-swiper-slide-index="' + realIndex + '"]')[0]);
        (0, _utils.n)(function () {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = swiper.getSlideIndex((0, _utils.e)(slidesEl, slideSelector + '[data-swiper-slide-index="' + realIndex + '"]')[0]);
      (0, _utils.n)(function () {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo: slideTo,
  slideToLoop: slideToLoop,
  slideNext: slideNext,
  slidePrev: slidePrev,
  slideReset: slideReset,
  slideToClosest: slideToClosest,
  slideToClickedSlide: slideToClickedSlide
};

function loopCreate(slideRealIndex) {
  var swiper = this;
  var params = swiper.params,
      slidesEl = swiper.slidesEl;

  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  var initSlides = function initSlides() {
    var slides = (0, _utils.e)(slidesEl, '.' + params.slideClass + ', swiper-slide');
    slides.forEach(function (el, index) {
      el.setAttribute('data-swiper-slide-index', index);
    });
  };
  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  var slidesPerGroup = params.slidesPerGroup * (gridEnabled ? params.grid.rows : 1);
  var shouldFillGroup = swiper.slides.length % slidesPerGroup !== 0;
  var shouldFillGrid = gridEnabled && swiper.slides.length % params.grid.rows !== 0;
  var addBlankSlides = function addBlankSlides(amountOfSlides) {
    for (var i = 0; i < amountOfSlides; i += 1) {
      var slideEl = swiper.isElement ? (0, _utils.c)('swiper-slide', [params.slideBlankClass]) : (0, _utils.c)('div', [params.slideClass, params.slideBlankClass]);
      swiper.slidesEl.append(slideEl);
    }
  };
  if (shouldFillGroup) {
    if (params.loopAddBlankSlides) {
      var slidesToAdd = slidesPerGroup - swiper.slides.length % slidesPerGroup;
      addBlankSlides(slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      (0, _utils.t)('Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else if (shouldFillGrid) {
    if (params.loopAddBlankSlides) {
      var _slidesToAdd = params.grid.rows - swiper.slides.length % params.grid.rows;
      addBlankSlides(_slidesToAdd);
      swiper.recalcSlides();
      swiper.updateSlides();
    } else {
      (0, _utils.t)('Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)');
    }
    initSlides();
  } else {
    initSlides();
  }
  swiper.loopFix({
    slideRealIndex: slideRealIndex,
    direction: params.centeredSlides ? undefined : 'next'
  });
}

function loopFix(_temp) {
  var _ref4 = _temp === void 0 ? {} : _temp,
      slideRealIndex = _ref4.slideRealIndex,
      _ref4$slideTo = _ref4.slideTo,
      slideTo = _ref4$slideTo === undefined ? true : _ref4$slideTo,
      direction = _ref4.direction,
      setTranslate = _ref4.setTranslate,
      activeSlideIndex = _ref4.activeSlideIndex,
      byController = _ref4.byController,
      byMousewheel = _ref4.byMousewheel;

  var swiper = this;
  if (!swiper.params.loop) return;
  swiper.emit('beforeLoopFix');
  var slides = swiper.slides,
      allowSlidePrev = swiper.allowSlidePrev,
      allowSlideNext = swiper.allowSlideNext,
      slidesEl = swiper.slidesEl,
      params = swiper.params;
  var centeredSlides = params.centeredSlides;

  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  if (swiper.virtual && params.virtual.enabled) {
    if (slideTo) {
      if (!params.centeredSlides && swiper.snapIndex === 0) {
        swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
      } else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) {
        swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
      } else if (swiper.snapIndex === swiper.snapGrid.length - 1) {
        swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
      }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
    return;
  }
  var slidesPerView = params.slidesPerView;
  if (slidesPerView === 'auto') {
    slidesPerView = swiper.slidesPerViewDynamic();
  } else {
    slidesPerView = Math.ceil(parseFloat(params.slidesPerView, 10));
    if (centeredSlides && slidesPerView % 2 === 0) {
      slidesPerView = slidesPerView + 1;
    }
  }
  var slidesPerGroup = params.slidesPerGroupAuto ? slidesPerView : params.slidesPerGroup;
  var loopedSlides = slidesPerGroup;
  if (loopedSlides % slidesPerGroup !== 0) {
    loopedSlides += slidesPerGroup - loopedSlides % slidesPerGroup;
  }
  loopedSlides += params.loopAdditionalSlides;
  swiper.loopedSlides = loopedSlides;
  var gridEnabled = swiper.grid && params.grid && params.grid.rows > 1;
  if (slides.length < slidesPerView + loopedSlides) {
    (0, _utils.t)('Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled and not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters');
  } else if (gridEnabled && params.grid.fill === 'row') {
    (0, _utils.t)('Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`');
  }
  var prependSlidesIndexes = [];
  var appendSlidesIndexes = [];
  var activeIndex = swiper.activeIndex;
  if (typeof activeSlideIndex === 'undefined') {
    activeSlideIndex = swiper.getSlideIndex(slides.filter(function (el) {
      return el.classList.contains(params.slideActiveClass);
    })[0]);
  } else {
    activeIndex = activeSlideIndex;
  }
  var isNext = direction === 'next' || !direction;
  var isPrev = direction === 'prev' || !direction;
  var slidesPrepended = 0;
  var slidesAppended = 0;
  var cols = gridEnabled ? Math.ceil(slides.length / params.grid.rows) : slides.length;
  var activeColIndex = gridEnabled ? slides[activeSlideIndex].column : activeSlideIndex;
  var activeColIndexWithShift = activeColIndex + (centeredSlides && typeof setTranslate === 'undefined' ? -slidesPerView / 2 + 0.5 : 0);
  // prepend last slides before start
  if (activeColIndexWithShift < loopedSlides) {
    slidesPrepended = Math.max(loopedSlides - activeColIndexWithShift, slidesPerGroup);
    for (var i = 0; i < loopedSlides - activeColIndexWithShift; i += 1) {
      var index = i - Math.floor(i / cols) * cols;
      if (gridEnabled) {
        var colIndexToPrepend = cols - index - 1;
        for (var _i5 = slides.length - 1; _i5 >= 0; _i5 -= 1) {
          if (slides[_i5].column === colIndexToPrepend) prependSlidesIndexes.push(_i5);
        }
        // slides.forEach((slide, slideIndex) => {
        //   if (slide.column === colIndexToPrepend) prependSlidesIndexes.push(slideIndex);
        // });
      } else {
        prependSlidesIndexes.push(cols - index - 1);
      }
    }
  } else if (activeColIndexWithShift + slidesPerView > cols - loopedSlides) {
    slidesAppended = Math.max(activeColIndexWithShift - (cols - loopedSlides * 2), slidesPerGroup);

    var _loop = function _loop(_i6) {
      var index = _i6 - Math.floor(_i6 / cols) * cols;
      if (gridEnabled) {
        slides.forEach(function (slide, slideIndex) {
          if (slide.column === index) appendSlidesIndexes.push(slideIndex);
        });
      } else {
        appendSlidesIndexes.push(index);
      }
    };

    for (var _i6 = 0; _i6 < slidesAppended; _i6 += 1) {
      _loop(_i6);
    }
  }
  swiper.__preventObserver__ = true;
  requestAnimationFrame(function () {
    swiper.__preventObserver__ = false;
  });
  if (isPrev) {
    prependSlidesIndexes.forEach(function (index) {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.prepend(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  if (isNext) {
    appendSlidesIndexes.forEach(function (index) {
      slides[index].swiperLoopMoveDOM = true;
      slidesEl.append(slides[index]);
      slides[index].swiperLoopMoveDOM = false;
    });
  }
  swiper.recalcSlides();
  if (params.slidesPerView === 'auto') {
    swiper.updateSlides();
  } else if (gridEnabled && (prependSlidesIndexes.length > 0 && isPrev || appendSlidesIndexes.length > 0 && isNext)) {
    swiper.slides.forEach(function (slide, slideIndex) {
      swiper.grid.updateSlide(slideIndex, slide, swiper.slides);
    });
  }
  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }
  if (slideTo) {
    if (prependSlidesIndexes.length > 0 && isPrev) {
      if (typeof slideRealIndex === 'undefined') {
        var currentSlideTranslate = swiper.slidesGrid[activeIndex];
        var newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
        var diff = newSlideTranslate - currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - diff);
        } else {
          swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - diff;
          }
        }
      } else {
        if (setTranslate) {
          var shift = gridEnabled ? prependSlidesIndexes.length / params.grid.rows : prependSlidesIndexes.length;
          swiper.slideTo(swiper.activeIndex + shift, 0, false, true);
          swiper.touchEventsData.currentTranslate = swiper.translate;
        }
      }
    } else if (appendSlidesIndexes.length > 0 && isNext) {
      if (typeof slideRealIndex === 'undefined') {
        var _currentSlideTranslate = swiper.slidesGrid[activeIndex];
        var _newSlideTranslate = swiper.slidesGrid[activeIndex - slidesAppended];
        var _diff = _newSlideTranslate - _currentSlideTranslate;
        if (byMousewheel) {
          swiper.setTranslate(swiper.translate - _diff);
        } else {
          swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
          if (setTranslate) {
            swiper.touchEventsData.startTranslate = swiper.touchEventsData.startTranslate - _diff;
            swiper.touchEventsData.currentTranslate = swiper.touchEventsData.currentTranslate - _diff;
          }
        }
      } else {
        var _shift = gridEnabled ? appendSlidesIndexes.length / params.grid.rows : appendSlidesIndexes.length;
        swiper.slideTo(swiper.activeIndex - _shift, 0, false, true);
      }
    }
  }
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.controller && swiper.controller.control && !byController) {
    var loopParams = {
      slideRealIndex: slideRealIndex,
      direction: direction,
      setTranslate: setTranslate,
      activeSlideIndex: activeSlideIndex,
      byController: true
    };
    if (Array.isArray(swiper.controller.control)) {
      swiper.controller.control.forEach(function (c) {
        if (!c.destroyed && c.params.loop) c.loopFix(_extends({}, loopParams, {
          slideTo: c.params.slidesPerView === params.slidesPerView ? slideTo : false
        }));
      });
    } else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) {
      swiper.controller.control.loopFix(_extends({}, loopParams, {
        slideTo: swiper.controller.control.params.slidesPerView === params.slidesPerView ? slideTo : false
      }));
    }
  }
  swiper.emit('loopFix');
}

function loopDestroy() {
  var swiper = this;
  var params = swiper.params,
      slidesEl = swiper.slidesEl;

  if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
  swiper.recalcSlides();
  var newSlidesOrder = [];
  swiper.slides.forEach(function (slideEl) {
    var index = typeof slideEl.swiperSlideIndex === 'undefined' ? slideEl.getAttribute('data-swiper-slide-index') * 1 : slideEl.swiperSlideIndex;
    newSlidesOrder[index] = slideEl;
  });
  swiper.slides.forEach(function (slideEl) {
    slideEl.removeAttribute('data-swiper-slide-index');
  });
  newSlidesOrder.forEach(function (slideEl) {
    slidesEl.append(slideEl);
  });
  swiper.recalcSlides();
  swiper.slideTo(swiper.realIndex, 0);
}

var loop = {
  loopCreate: loopCreate,
  loopFix: loopFix,
  loopDestroy: loopDestroy
};

function setGrabCursor(moving) {
  var swiper = this;
  if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  var el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
  if (swiper.isElement) {
    requestAnimationFrame(function () {
      swiper.__preventObserver__ = false;
    });
  }
}

function unsetGrabCursor() {
  var swiper = this;
  if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }
  if (swiper.isElement) {
    swiper.__preventObserver__ = true;
  }
  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
  if (swiper.isElement) {
    requestAnimationFrame(function () {
      swiper.__preventObserver__ = false;
    });
  }
}

var grabCursor = {
  setGrabCursor: setGrabCursor,
  unsetGrabCursor: unsetGrabCursor
};

// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function closestElement(selector, base) {
  if (base === void 0) {
    base = this;
  }
  function __closestFrom(el) {
    if (!el || el === (0, _ssrWindowEsm.g)() || el === (0, _ssrWindowEsm.a)()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    var found = el.closest(selector);
    if (!found && !el.getRootNode) {
      return null;
    }
    return found || __closestFrom(el.getRootNode().host);
  }
  return __closestFrom(base);
}
function preventEdgeSwipe(swiper, event, startX) {
  var window = (0, _ssrWindowEsm.a)();
  var params = swiper.params;

  var edgeSwipeDetection = params.edgeSwipeDetection;
  var edgeSwipeThreshold = params.edgeSwipeThreshold;
  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
      return true;
    }
    return false;
  }
  return true;
}
function onTouchStart(event) {
  var swiper = this;
  var document = (0, _ssrWindowEsm.g)();
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var data = swiper.touchEventsData;
  if (e.type === 'pointerdown') {
    if (data.pointerId !== null && data.pointerId !== e.pointerId) {
      return;
    }
    data.pointerId = e.pointerId;
  } else if (e.type === 'touchstart' && e.targetTouches.length === 1) {
    data.touchId = e.targetTouches[0].identifier;
  }
  if (e.type === 'touchstart') {
    // don't proceed touch event
    preventEdgeSwipe(swiper, e, e.targetTouches[0].pageX);
    return;
  }
  var params = swiper.params,
      touches = swiper.touches,
      enabled = swiper.enabled;

  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }
  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }
  var targetEl = e.target;
  if (params.touchEventsTarget === 'wrapper') {
    if (!swiper.wrapperEl.contains(targetEl)) return;
  }
  if ('which' in e && e.which === 3) return;
  if ('button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return;

  // change target el for shadow root component
  var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== '';
  // eslint-disable-next-line
  var eventPath = e.composedPath ? e.composedPath() : e.path;
  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    targetEl = eventPath[0];
  }
  var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : '.' + params.noSwipingClass;
  var isTargetShadow = !!(e.target && e.target.shadowRoot);

  // use closestElement for shadow root element to get the actual closest for nested shadow root element
  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
    swiper.allowClick = true;
    return;
  }
  if (params.swipeHandler) {
    if (!targetEl.closest(params.swipeHandler)) return;
  }
  touches.currentX = e.pageX;
  touches.currentY = e.pageY;
  var startX = touches.currentX;
  var startY = touches.currentY;

  // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  if (!preventEdgeSwipe(swiper, e, startX)) {
    return;
  }
  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = (0, _utils.d)();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;
  var preventDefault = true;
  if (targetEl.matches(data.focusableElements)) {
    preventDefault = false;
    if (targetEl.nodeName === 'SELECT') {
      data.isTouched = false;
    }
  }
  if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl) {
    document.activeElement.blur();
  }
  var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
  if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) {
    e.preventDefault();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }
  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  var document = (0, _ssrWindowEsm.g)();
  var swiper = this;
  var data = swiper.touchEventsData;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      enabled = swiper.enabled;

  if (!enabled) return;
  if (!params.simulateTouch && event.pointerType === 'mouse') return;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  if (e.type === 'pointermove') {
    if (data.touchId !== null) return; // return from pointer if we use touch
    var id = e.pointerId;
    if (id !== data.pointerId) return;
  }
  var targetTouch = void 0;
  if (e.type === 'touchmove') {
    targetTouch = [].concat(_toConsumableArray(e.changedTouches)).filter(function (t) {
      return t.identifier === data.touchId;
    })[0];
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  } else {
    targetTouch = e;
  }
  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }
    return;
  }
  var pageX = targetTouch.pageX;
  var pageY = targetTouch.pageY;
  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }
  if (!swiper.allowTouchMove) {
    if (!e.target.matches(data.focusableElements)) {
      swiper.allowClick = false;
    }
    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = (0, _utils.d)();
    }
    return;
  }
  if (params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }
  if (document.activeElement) {
    if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }
  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }
  touches.previousX = touches.currentX;
  touches.previousY = touches.currentY;
  touches.currentX = pageX;
  touches.currentY = pageY;
  var diffX = touches.currentX - touches.startX;
  var diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
  if (typeof data.isScrolling === 'undefined') {
    var touchAngle = void 0;
    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }
  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }
  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }
  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }
  if (!data.startMoving) {
    return;
  }
  swiper.allowClick = false;
  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }
  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }
  var diff = swiper.isHorizontal() ? diffX : diffY;
  var touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
  if (params.oneWayMovement) {
    diff = Math.abs(diff) * (rtl ? 1 : -1);
    touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
  }
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) {
    diff = -diff;
    touchesDiff = -touchesDiff;
  }
  var prevTouchesDirection = swiper.touchesDirection;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  swiper.touchesDirection = touchesDiff > 0 ? 'prev' : 'next';
  var isLoop = swiper.params.loop && !params.cssMode;
  var allowLoopFix = swiper.touchesDirection === 'next' && swiper.allowSlideNext || swiper.touchesDirection === 'prev' && swiper.allowSlidePrev;
  if (!data.isMoved) {
    if (isLoop && allowLoopFix) {
      swiper.loopFix({
        direction: swiper.swipeDirection
      });
    }
    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);
    if (swiper.animating) {
      var evt = new window.CustomEvent('transitionend', {
        bubbles: true,
        cancelable: true
      });
      swiper.wrapperEl.dispatchEvent(evt);
    }
    data.allowMomentumBounce = false;
    // Grab Cursor
    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }
    swiper.emit('sliderFirstMove', e);
  }
  var loopFixed = void 0;
  new Date().getTime();
  if (data.isMoved && data.allowThresholdMove && prevTouchesDirection !== swiper.touchesDirection && isLoop && allowLoopFix && Math.abs(diff) >= 1) {
    Object.assign(touches, {
      startX: pageX,
      startY: pageY,
      currentX: pageX,
      currentY: pageY,
      startTranslate: data.currentTranslate
    });
    data.loopSwapReset = true;
    data.startTranslate = data.currentTranslate;
    return;
  }
  swiper.emit('sliderMove', e);
  data.isMoved = true;
  data.currentTranslate = diff + data.startTranslate;
  var disableParentSwiper = true;
  var resistanceRatio = params.resistanceRatio;
  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }
  if (diff > 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.slidesSizesGrid[swiper.activeIndex + 1] : swiper.minTranslate())) {
      swiper.loopFix({
        direction: 'prev',
        setTranslate: true,
        activeSlideIndex: 0
      });
    }
    if (data.currentTranslate > swiper.minTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
      }
    }
  } else if (diff < 0) {
    if (isLoop && allowLoopFix && !loopFixed && data.allowThresholdMove && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.slidesSizesGrid[swiper.slidesSizesGrid.length - 1] : swiper.maxTranslate())) {
      swiper.loopFix({
        direction: 'next',
        setTranslate: true,
        activeSlideIndex: swiper.slides.length - (params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
      });
    }
    if (data.currentTranslate < swiper.maxTranslate()) {
      disableParentSwiper = false;
      if (params.resistance) {
        data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
      }
    }
  }
  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  }

  // Directions locks
  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }
  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  }

  // Threshold
  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }
  if (!params.followFinger || params.cssMode) return;

  // Update active index in free mode
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }
  if (params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  }
  // Update progress
  swiper.updateProgress(data.currentTranslate);
  // Update translate
  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  var swiper = this;
  var data = swiper.touchEventsData;
  var e = event;
  if (e.originalEvent) e = e.originalEvent;
  var targetTouch = void 0;
  var isTouchEvent = e.type === 'touchend' || e.type === 'touchcancel';
  if (!isTouchEvent) {
    if (data.touchId !== null) return; // return from pointer if we use touch
    if (e.pointerId !== data.pointerId) return;
    targetTouch = e;
  } else {
    targetTouch = [].concat(_toConsumableArray(e.changedTouches)).filter(function (t) {
      return t.identifier === data.touchId;
    })[0];
    if (!targetTouch || targetTouch.identifier !== data.touchId) return;
  }
  if (['pointercancel', 'pointerout', 'pointerleave', 'contextmenu'].includes(e.type)) {
    var proceed = ['pointercancel', 'contextmenu'].includes(e.type) && (swiper.browser.isSafari || swiper.browser.isWebView);
    if (!proceed) {
      return;
    }
  }
  data.pointerId = null;
  data.touchId = null;
  var params = swiper.params,
      touches = swiper.touches,
      rtl = swiper.rtlTranslate,
      slidesGrid = swiper.slidesGrid,
      enabled = swiper.enabled;

  if (!enabled) return;
  if (!params.simulateTouch && e.pointerType === 'mouse') return;
  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }
  data.allowTouchCallbacks = false;
  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  // Return Grab Cursor
  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  }

  // Time diff
  var touchEndTime = (0, _utils.d)();
  var timeDiff = touchEndTime - data.touchStartTime;

  // Tap, doubleTap, Click
  if (swiper.allowClick) {
    var pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target, pathTree);
    swiper.emit('tap click', e);
    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }
  data.lastClickTime = (0, _utils.d)();
  (0, _utils.n)(function () {
    if (!swiper.destroyed) swiper.allowClick = true;
  });
  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 && !data.loopSwapReset || data.currentTranslate === data.startTranslate && !data.loopSwapReset) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }
  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  var currentPos = void 0;
  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }
  if (params.cssMode) {
    return;
  }
  if (params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos: currentPos
    });
    return;
  }

  // Find current slide
  var swipeToLast = currentPos >= -swiper.maxTranslate() && !swiper.params.loop;
  var stopIndex = 0;
  var groupSize = swiper.slidesSizesGrid[0];
  for (var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    var _increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (typeof slidesGrid[i + _increment] !== 'undefined') {
      if (swipeToLast || currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + _increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + _increment] - slidesGrid[i];
      }
    } else if (swipeToLast || currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }
  var rewindFirstIndex = null;
  var rewindLastIndex = null;
  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  }
  // Find current slide size
  var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  var increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }
    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }
    var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }
      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  var swiper = this;
  var params = swiper.params,
      el = swiper.el;

  if (el && el.offsetWidth === 0) return;

  // Breakpoints
  if (params.breakpoints) {
    swiper.setBreakpoint();
  }

  // Save locks
  var allowSlideNext = swiper.allowSlideNext,
      allowSlidePrev = swiper.allowSlidePrev,
      snapGrid = swiper.snapGrid;

  var isVirtual = swiper.virtual && swiper.params.virtual.enabled;

  // Disable locks on resize
  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();
  var isVirtualLoop = isVirtual && params.loop;
  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    if (swiper.params.loop && !isVirtual) {
      swiper.slideToLoop(swiper.realIndex, 0, false, true);
    } else {
      swiper.slideTo(swiper.activeIndex, 0, false, true);
    }
  }
  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    clearTimeout(swiper.autoplay.resizeTimeout);
    swiper.autoplay.resizeTimeout = setTimeout(function () {
      if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        swiper.autoplay.resume();
      }
    }, 500);
  }
  // Return locks after resize
  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  var swiper = this;
  if (!swiper.enabled) return;
  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();
    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  var swiper = this;
  var wrapperEl = swiper.wrapperEl,
      rtlTranslate = swiper.rtlTranslate,
      enabled = swiper.enabled;

  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;
  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  }
  // eslint-disable-next-line
  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  var newProgress = void 0;
  var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }
  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }
  swiper.emit('setTranslate', swiper.translate, false);
}

function onLoad(e) {
  var swiper = this;
  processLazyPreloader(swiper, e.target);
  if (swiper.params.cssMode || swiper.params.slidesPerView !== 'auto' && !swiper.params.autoHeight) {
    return;
  }
  swiper.update();
}

function onDocumentTouchStart() {
  var swiper = this;
  if (swiper.documentTouchHandlerProceeded) return;
  swiper.documentTouchHandlerProceeded = true;
  if (swiper.params.touchReleaseOnEdges) {
    swiper.el.style.touchAction = 'auto';
  }
}

var events = function events(swiper, method) {
  var document = (0, _ssrWindowEsm.g)();
  var params = swiper.params,
      el = swiper.el,
      wrapperEl = swiper.wrapperEl,
      device = swiper.device;

  var capture = !!params.nested;
  var domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  var swiperMethod = method;

  // Touch Events
  document[domMethod]('touchstart', swiper.onDocumentTouchStart, {
    passive: false,
    capture: capture
  });
  el[domMethod]('touchstart', swiper.onTouchStart, {
    passive: false
  });
  el[domMethod]('pointerdown', swiper.onTouchStart, {
    passive: false
  });
  document[domMethod]('touchmove', swiper.onTouchMove, {
    passive: false,
    capture: capture
  });
  document[domMethod]('pointermove', swiper.onTouchMove, {
    passive: false,
    capture: capture
  });
  document[domMethod]('touchend', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerup', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointercancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('touchcancel', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerout', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('pointerleave', swiper.onTouchEnd, {
    passive: true
  });
  document[domMethod]('contextmenu', swiper.onTouchEnd, {
    passive: true
  });

  // Prevent Links Clicks
  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }
  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  }

  // Resize handler
  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }

  // Images loader
  el[domMethod]('load', swiper.onLoad, {
    capture: true
  });
};
function attachEvents() {
  var swiper = this;
  var params = swiper.params;

  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);
  swiper.onDocumentTouchStart = onDocumentTouchStart.bind(swiper);
  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }
  swiper.onClick = onClick.bind(swiper);
  swiper.onLoad = onLoad.bind(swiper);
  events(swiper, 'on');
}
function detachEvents() {
  var swiper = this;
  events(swiper, 'off');
}
var events$1 = {
  attachEvents: attachEvents,
  detachEvents: detachEvents
};

var isGridEnabled = function isGridEnabled(swiper, params) {
  return swiper.grid && params.grid && params.grid.rows > 1;
};
function setBreakpoint() {
  var swiper = this;
  var realIndex = swiper.realIndex,
      initialized = swiper.initialized,
      params = swiper.params,
      el = swiper.el;

  var breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;

  // Get breakpoint for window width and update parameters
  var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  var breakpointParams = breakpointOnlyParams || swiper.originalParams;
  var wasMultiRow = isGridEnabled(swiper, params);
  var isMultiRow = isGridEnabled(swiper, breakpointParams);
  var wasEnabled = params.enabled;
  if (wasMultiRow && !isMultiRow) {
    el.classList.remove(params.containerModifierClass + 'grid', params.containerModifierClass + 'grid-column');
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    el.classList.add(params.containerModifierClass + 'grid');
    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      el.classList.add(params.containerModifierClass + 'grid-column');
    }
    swiper.emitContainerClasses();
  }

  // Toggle navigation, pagination, scrollbar
  ['navigation', 'pagination', 'scrollbar'].forEach(function (prop) {
    if (typeof breakpointParams[prop] === 'undefined') return;
    var wasModuleEnabled = params[prop] && params[prop].enabled;
    var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }
    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
  var wasLoop = params.loop;
  if (directionChanged && initialized) {
    swiper.changeDirection();
  }
  (0, _utils.u)(swiper.params, breakpointParams);
  var isEnabled = swiper.params.enabled;
  var hasLoop = swiper.params.loop;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });
  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }
  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);
  if (initialized) {
    if (needsReLoop) {
      swiper.loopDestroy();
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (!wasLoop && hasLoop) {
      swiper.loopCreate(realIndex);
      swiper.updateSlides();
    } else if (wasLoop && !hasLoop) {
      swiper.loopDestroy();
    }
  }
  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base, containerEl) {
  if (base === void 0) {
    base = 'window';
  }
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  var breakpoint = false;
  var window = (0, _ssrWindowEsm.a)();
  var currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  var points = Object.keys(breakpoints).map(function (point) {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      var minRatio = parseFloat(point.substr(1));
      var value = currentHeight * minRatio;
      return {
        value: value,
        point: point
      };
    }
    return {
      value: point,
      point: point
    };
  });
  points.sort(function (a, b) {
    return parseInt(a.value, 10) - parseInt(b.value, 10);
  });
  for (var i = 0; i < points.length; i += 1) {
    var _points$i = points[i],
        point = _points$i.point,
        value = _points$i.value;

    if (base === 'window') {
      if (window.matchMedia('(min-width: ' + value + 'px)').matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }
  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint: setBreakpoint,
  getBreakpoint: getBreakpoint
};

function prepareClasses(entries, prefix) {
  var resultClasses = [];
  entries.forEach(function (item) {
    if ((typeof item === 'undefined' ? 'undefined' : _typeof(item)) === 'object') {
      Object.keys(item).forEach(function (classNames) {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}
function addClasses() {
  var _el$classList;

  var swiper = this;
  var classNames = swiper.classNames,
      params = swiper.params,
      rtl = swiper.rtl,
      el = swiper.el,
      device = swiper.device;
  // prettier-ignore

  var suffixes = prepareClasses(['initialized', params.direction, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push.apply(classNames, _toConsumableArray(suffixes));
  (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(classNames));
  swiper.emitContainerClasses();
}

function removeClasses() {
  var _el$classList2;

  var swiper = this;
  var el = swiper.el,
      classNames = swiper.classNames;

  (_el$classList2 = el.classList).remove.apply(_el$classList2, _toConsumableArray(classNames));
  swiper.emitContainerClasses();
}

var classes = {
  addClasses: addClasses,
  removeClasses: removeClasses
};

function checkOverflow() {
  var swiper = this;
  var wasLocked = swiper.isLocked,
      params = swiper.params;
  var slidesOffsetBefore = params.slidesOffsetBefore;

  if (slidesOffsetBefore) {
    var lastSlideIndex = swiper.slides.length - 1;
    var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }
  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }
  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }
  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }
  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}
var checkOverflow$1 = {
  checkOverflow: checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  oneWayMovement: false,
  swiperElementNodeName: 'SWIPER-CONTAINER',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  eventsPrefix: 'swiper',
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'

  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 5,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // loop
  loop: false,
  loopAddBlankSlides: true,
  loopAdditionalSlides: 0,
  loopPreventsSliding: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-blank',
  slideActiveClass: 'swiper-slide-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideFullyVisibleClass: 'swiper-slide-fully-visible',
  slideNextClass: 'swiper-slide-next',
  slidePrevClass: 'swiper-slide-prev',
  wrapperClass: 'swiper-wrapper',
  lazyPreloaderClass: 'swiper-lazy-preloader',
  lazyPreloadPrevNext: 0,
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj) {
    if (obj === void 0) {
      obj = {};
    }
    var moduleParamName = Object.keys(obj)[0];
    var moduleParams = obj[moduleParamName];
    if ((typeof moduleParams === 'undefined' ? 'undefined' : _typeof(moduleParams)) !== 'object' || moduleParams === null) {
      (0, _utils.u)(allModulesParams, obj);
      return;
    }
    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }
    if (moduleParamName === 'navigation' && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].prevEl && !params[moduleParamName].nextEl) {
      params[moduleParamName].auto = true;
    }
    if (['pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] && params[moduleParamName].enabled && !params[moduleParamName].el) {
      params[moduleParamName].auto = true;
    }
    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      (0, _utils.u)(allModulesParams, obj);
      return;
    }
    if (_typeof(params[moduleParamName]) === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }
    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    (0, _utils.u)(allModulesParams, obj);
  };
}

/* eslint no-param-reassign: "off" */
var prototypes = {
  eventsEmitter: eventsEmitter,
  update: update,
  translate: translate,
  transition: transition,
  slide: slide,
  loop: loop,
  grabCursor: grabCursor,
  events: events$1,
  breakpoints: breakpoints,
  checkOverflow: checkOverflow$1,
  classes: classes
};
var extendedDefaults = {};

var Swiper = function () {
  function Swiper() {
    _classCallCheck(this, Swiper);

    var el = void 0;
    var params = void 0;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      el = args[0];
      params = args[1];
    }
    if (!params) params = {};
    params = (0, _utils.u)({}, params);
    if (el && !params.el) params.el = el;
    var document = (0, _ssrWindowEsm.g)();
    if (params.el && typeof params.el === 'string' && document.querySelectorAll(params.el).length > 1) {
      var swipers = [];
      document.querySelectorAll(params.el).forEach(function (containerEl) {
        var newParams = (0, _utils.u)({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper(newParams));
      });
      // eslint-disable-next-line no-constructor-return
      return swipers;
    }

    // Swiper Instance
    var swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [].concat(_toConsumableArray(swiper.__modules__));
    if (params.modules && Array.isArray(params.modules)) {
      var _swiper$modules;

      (_swiper$modules = swiper.modules).push.apply(_swiper$modules, _toConsumableArray(params.modules));
    }
    var allModulesParams = {};
    swiper.modules.forEach(function (mod) {
      mod({
        params: params,
        swiper: swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    });

    // Extend defaults with modules params
    var swiperParams = (0, _utils.u)({}, defaults, allModulesParams);

    // Extend defaults with passed params
    swiper.params = (0, _utils.u)({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = (0, _utils.u)({}, swiper.params);
    swiper.passedParams = (0, _utils.u)({}, params);

    // add event listeners
    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(function (eventName) {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }
    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    }

    // Extend Swiper
    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el: el,
      // Classes
      classNames: [],
      // Slides
      slides: [],
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],
      // isDirection
      isHorizontal: function isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },
      isVertical: function isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      cssOverflowAdjustment: function cssOverflowAdjustment() {
        // Returns 0 unless `translate` is > 2**23
        // Should be subtracted from css values to prevent overflow
        return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
      },

      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: 0,
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        startMoving: undefined,
        pointerId: null,
        touchId: null
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper');

    // Init
    if (swiper.params.init) {
      swiper.init();
    }

    // Return app instance
    // eslint-disable-next-line no-constructor-return
    return swiper;
  }

  _createClass(Swiper, [{
    key: 'getDirectionLabel',
    value: function getDirectionLabel(property) {
      if (this.isHorizontal()) {
        return property;
      }
      // prettier-ignore
      return {
        'width': 'height',
        'margin-top': 'margin-left',
        'margin-bottom ': 'margin-right',
        'margin-left': 'margin-top',
        'margin-right': 'margin-bottom',
        'padding-left': 'padding-top',
        'padding-right': 'padding-bottom',
        'marginRight': 'marginBottom'
      }[property];
    }
  }, {
    key: 'getSlideIndex',
    value: function getSlideIndex(slideEl) {
      var slidesEl = this.slidesEl,
          params = this.params;

      var slides = (0, _utils.e)(slidesEl, '.' + params.slideClass + ', swiper-slide');
      var firstSlideIndex = (0, _utils.g)(slides[0]);
      return (0, _utils.g)(slideEl) - firstSlideIndex;
    }
  }, {
    key: 'getSlideIndexByData',
    value: function getSlideIndexByData(index) {
      return this.getSlideIndex(this.slides.filter(function (slideEl) {
        return slideEl.getAttribute('data-swiper-slide-index') * 1 === index;
      })[0]);
    }
  }, {
    key: 'recalcSlides',
    value: function recalcSlides() {
      var swiper = this;
      var slidesEl = swiper.slidesEl,
          params = swiper.params;

      swiper.slides = (0, _utils.e)(slidesEl, '.' + params.slideClass + ', swiper-slide');
    }
  }, {
    key: 'enable',
    value: function enable() {
      var swiper = this;
      if (swiper.enabled) return;
      swiper.enabled = true;
      if (swiper.params.grabCursor) {
        swiper.setGrabCursor();
      }
      swiper.emit('enable');
    }
  }, {
    key: 'disable',
    value: function disable() {
      var swiper = this;
      if (!swiper.enabled) return;
      swiper.enabled = false;
      if (swiper.params.grabCursor) {
        swiper.unsetGrabCursor();
      }
      swiper.emit('disable');
    }
  }, {
    key: 'setProgress',
    value: function setProgress(progress, speed) {
      var swiper = this;
      progress = Math.min(Math.max(progress, 0), 1);
      var min = swiper.minTranslate();
      var max = swiper.maxTranslate();
      var current = (max - min) * progress + min;
      swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }, {
    key: 'emitContainerClasses',
    value: function emitContainerClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var cls = swiper.el.className.split(' ').filter(function (className) {
        return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
      });
      swiper.emit('_containerClasses', cls.join(' '));
    }
  }, {
    key: 'getSlideClasses',
    value: function getSlideClasses(slideEl) {
      var swiper = this;
      if (swiper.destroyed) return '';
      return slideEl.className.split(' ').filter(function (className) {
        return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
      }).join(' ');
    }
  }, {
    key: 'emitSlidesClasses',
    value: function emitSlidesClasses() {
      var swiper = this;
      if (!swiper.params._emitClasses || !swiper.el) return;
      var updates = [];
      swiper.slides.forEach(function (slideEl) {
        var classNames = swiper.getSlideClasses(slideEl);
        updates.push({
          slideEl: slideEl,
          classNames: classNames
        });
        swiper.emit('_slideClass', slideEl, classNames);
      });
      swiper.emit('_slideClasses', updates);
    }
  }, {
    key: 'slidesPerViewDynamic',
    value: function slidesPerViewDynamic(view, exact) {
      if (view === void 0) {
        view = 'current';
      }
      if (exact === void 0) {
        exact = false;
      }
      var swiper = this;
      var params = swiper.params,
          slides = swiper.slides,
          slidesGrid = swiper.slidesGrid,
          slidesSizesGrid = swiper.slidesSizesGrid,
          swiperSize = swiper.size,
          activeIndex = swiper.activeIndex;

      var spv = 1;
      if (typeof params.slidesPerView === 'number') return params.slidesPerView;
      if (params.centeredSlides) {
        var slideSize = slides[activeIndex] ? Math.ceil(slides[activeIndex].swiperSlideSize) : 0;
        var breakLoop = void 0;
        for (var i = activeIndex + 1; i < slides.length; i += 1) {
          if (slides[i] && !breakLoop) {
            slideSize += Math.ceil(slides[i].swiperSlideSize);
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
        for (var _i7 = activeIndex - 1; _i7 >= 0; _i7 -= 1) {
          if (slides[_i7] && !breakLoop) {
            slideSize += slides[_i7].swiperSlideSize;
            spv += 1;
            if (slideSize > swiperSize) breakLoop = true;
          }
        }
      } else {
        // eslint-disable-next-line
        if (view === 'current') {
          for (var _i8 = activeIndex + 1; _i8 < slides.length; _i8 += 1) {
            var slideInView = exact ? slidesGrid[_i8] + slidesSizesGrid[_i8] - slidesGrid[activeIndex] < swiperSize : slidesGrid[_i8] - slidesGrid[activeIndex] < swiperSize;
            if (slideInView) {
              spv += 1;
            }
          }
        } else {
          // previous
          for (var _i9 = activeIndex - 1; _i9 >= 0; _i9 -= 1) {
            var _slideInView = slidesGrid[activeIndex] - slidesGrid[_i9] < swiperSize;
            if (_slideInView) {
              spv += 1;
            }
          }
        }
      }
      return spv;
    }
  }, {
    key: 'update',
    value: function update() {
      var swiper = this;
      if (!swiper || swiper.destroyed) return;
      var snapGrid = swiper.snapGrid,
          params = swiper.params;
      // Breakpoints

      if (params.breakpoints) {
        swiper.setBreakpoint();
      }
      [].concat(_toConsumableArray(swiper.el.querySelectorAll('[loading="lazy"]'))).forEach(function (imageEl) {
        if (imageEl.complete) {
          processLazyPreloader(swiper, imageEl);
        }
      });
      swiper.updateSize();
      swiper.updateSlides();
      swiper.updateProgress();
      swiper.updateSlidesClasses();
      function setTranslate() {
        var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
        var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
        swiper.setTranslate(newTranslate);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
      }
      var translated = void 0;
      if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
        setTranslate();
        if (params.autoHeight) {
          swiper.updateAutoHeight();
        }
      } else {
        if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
          var slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
          translated = swiper.slideTo(slides.length - 1, 0, false, true);
        } else {
          translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
        }
        if (!translated) {
          setTranslate();
        }
      }
      if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
        swiper.checkOverflow();
      }
      swiper.emit('update');
    }
  }, {
    key: 'changeDirection',
    value: function changeDirection(newDirection, needUpdate) {
      if (needUpdate === void 0) {
        needUpdate = true;
      }
      var swiper = this;
      var currentDirection = swiper.params.direction;
      if (!newDirection) {
        // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
      }
      if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
        return swiper;
      }
      swiper.el.classList.remove('' + swiper.params.containerModifierClass + currentDirection);
      swiper.el.classList.add('' + swiper.params.containerModifierClass + newDirection);
      swiper.emitContainerClasses();
      swiper.params.direction = newDirection;
      swiper.slides.forEach(function (slideEl) {
        if (newDirection === 'vertical') {
          slideEl.style.width = '';
        } else {
          slideEl.style.height = '';
        }
      });
      swiper.emit('changeDirection');
      if (needUpdate) swiper.update();
      return swiper;
    }
  }, {
    key: 'changeLanguageDirection',
    value: function changeLanguageDirection(direction) {
      var swiper = this;
      if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
      swiper.rtl = direction === 'rtl';
      swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
      if (swiper.rtl) {
        swiper.el.classList.add(swiper.params.containerModifierClass + 'rtl');
        swiper.el.dir = 'rtl';
      } else {
        swiper.el.classList.remove(swiper.params.containerModifierClass + 'rtl');
        swiper.el.dir = 'ltr';
      }
      swiper.update();
    }
  }, {
    key: 'mount',
    value: function mount(element) {
      var swiper = this;
      if (swiper.mounted) return true;

      // Find el
      var el = element || swiper.params.el;
      if (typeof el === 'string') {
        el = document.querySelector(el);
      }
      if (!el) {
        return false;
      }
      el.swiper = swiper;
      if (el.parentNode && el.parentNode.host && el.parentNode.host.nodeName === swiper.params.swiperElementNodeName.toUpperCase()) {
        swiper.isElement = true;
      }
      var getWrapperSelector = function getWrapperSelector() {
        return '.' + (swiper.params.wrapperClass || '').trim().split(' ').join('.');
      };
      var getWrapper = function getWrapper() {
        if (el && el.shadowRoot && el.shadowRoot.querySelector) {
          var res = el.shadowRoot.querySelector(getWrapperSelector());
          // Children needs to return slot items
          return res;
        }
        return (0, _utils.e)(el, getWrapperSelector())[0];
      };
      // Find Wrapper
      var wrapperEl = getWrapper();
      if (!wrapperEl && swiper.params.createElements) {
        wrapperEl = (0, _utils.c)('div', swiper.params.wrapperClass);
        el.append(wrapperEl);
        (0, _utils.e)(el, '.' + swiper.params.slideClass).forEach(function (slideEl) {
          wrapperEl.append(slideEl);
        });
      }
      Object.assign(swiper, {
        el: el,
        wrapperEl: wrapperEl,
        slidesEl: swiper.isElement && !el.parentNode.host.slideSlots ? el.parentNode.host : wrapperEl,
        hostEl: swiper.isElement ? el.parentNode.host : el,
        mounted: true,
        // RTL
        rtl: el.dir.toLowerCase() === 'rtl' || (0, _utils.o)(el, 'direction') === 'rtl',
        rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || (0, _utils.o)(el, 'direction') === 'rtl'),
        wrongRTL: (0, _utils.o)(wrapperEl, 'display') === '-webkit-box'
      });
      return true;
    }
  }, {
    key: 'init',
    value: function init(el) {
      var swiper = this;
      if (swiper.initialized) return swiper;
      var mounted = swiper.mount(el);
      if (mounted === false) return swiper;
      swiper.emit('beforeInit');

      // Set breakpoint
      if (swiper.params.breakpoints) {
        swiper.setBreakpoint();
      }

      // Add Classes
      swiper.addClasses();

      // Update size
      swiper.updateSize();

      // Update slides
      swiper.updateSlides();
      if (swiper.params.watchOverflow) {
        swiper.checkOverflow();
      }

      // Set Grab Cursor
      if (swiper.params.grabCursor && swiper.enabled) {
        swiper.setGrabCursor();
      }

      // Slide To Initial Slide
      if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) {
        swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
      } else {
        swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
      }

      // Create loop
      if (swiper.params.loop) {
        swiper.loopCreate();
      }

      // Attach events
      swiper.attachEvents();
      var lazyElements = [].concat(_toConsumableArray(swiper.el.querySelectorAll('[loading="lazy"]')));
      if (swiper.isElement) {
        lazyElements.push.apply(lazyElements, _toConsumableArray(swiper.hostEl.querySelectorAll('[loading="lazy"]')));
      }
      lazyElements.forEach(function (imageEl) {
        if (imageEl.complete) {
          processLazyPreloader(swiper, imageEl);
        } else {
          imageEl.addEventListener('load', function (e) {
            processLazyPreloader(swiper, e.target);
          });
        }
      });
      preload(swiper);

      // Init Flag
      swiper.initialized = true;
      preload(swiper);

      // Emit
      swiper.emit('init');
      swiper.emit('afterInit');
      return swiper;
    }
  }, {
    key: 'destroy',
    value: function destroy(deleteInstance, cleanStyles) {
      if (deleteInstance === void 0) {
        deleteInstance = true;
      }
      if (cleanStyles === void 0) {
        cleanStyles = true;
      }
      var swiper = this;
      var params = swiper.params,
          el = swiper.el,
          wrapperEl = swiper.wrapperEl,
          slides = swiper.slides;

      if (typeof swiper.params === 'undefined' || swiper.destroyed) {
        return null;
      }
      swiper.emit('beforeDestroy');

      // Init Flag
      swiper.initialized = false;

      // Detach events
      swiper.detachEvents();

      // Destroy loop
      if (params.loop) {
        swiper.loopDestroy();
      }

      // Cleanup styles
      if (cleanStyles) {
        swiper.removeClasses();
        el.removeAttribute('style');
        wrapperEl.removeAttribute('style');
        if (slides && slides.length) {
          slides.forEach(function (slideEl) {
            slideEl.classList.remove(params.slideVisibleClass, params.slideFullyVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
            slideEl.removeAttribute('style');
            slideEl.removeAttribute('data-swiper-slide-index');
          });
        }
      }
      swiper.emit('destroy');

      // Detach emitter events
      Object.keys(swiper.eventsListeners).forEach(function (eventName) {
        swiper.off(eventName);
      });
      if (deleteInstance !== false) {
        swiper.el.swiper = null;
        (0, _utils.v)(swiper);
      }
      swiper.destroyed = true;
      return null;
    }
  }], [{
    key: 'extendDefaults',
    value: function extendDefaults(newDefaults) {
      (0, _utils.u)(extendedDefaults, newDefaults);
    }
  }, {
    key: 'installModule',
    value: function installModule(mod) {
      if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
      var modules = Swiper.prototype.__modules__;
      if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
        modules.push(mod);
      }
    }
  }, {
    key: 'use',
    value: function use(module) {
      if (Array.isArray(module)) {
        module.forEach(function (m) {
          return Swiper.installModule(m);
        });
        return Swiper;
      }
      Swiper.installModule(module);
      return Swiper;
    }
  }, {
    key: 'extendedDefaults',
    get: function get() {
      return extendedDefaults;
    }
  }, {
    key: 'defaults',
    get: function get() {
      return defaults;
    }
  }]);

  return Swiper;
}();

Object.keys(prototypes).forEach(function (prototypeGroup) {
  Object.keys(prototypes[prototypeGroup]).forEach(function (protoMethod) {
    Swiper.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper.use([Resize, Observer]);

exports.S = Swiper;
exports.d = defaults;

/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.v = exports.u = exports.t = exports.s = exports.r = exports.q = exports.p = exports.o = exports.n = exports.m = exports.l = exports.k = exports.j = exports.i = exports.h = exports.g = exports.f = exports.e = exports.d = exports.c = exports.b = exports.a = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _ssrWindowEsm = __webpack_require__(3);

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function classesToTokens(classes) {
  if (classes === void 0) {
    classes = '';
  }
  return classes.trim().split(' ').filter(function (c) {
    return !!c.trim();
  });
}

function deleteProps(obj) {
  var object = obj;
  Object.keys(object).forEach(function (key) {
    try {
      object[key] = null;
    } catch (e) {
      // no getter for object
    }
    try {
      delete object[key];
    } catch (e) {
      // something got wrong
    }
  });
}
function nextTick(callback, delay) {
  if (delay === void 0) {
    delay = 0;
  }
  return setTimeout(callback, delay);
}
function now() {
  return Date.now();
}
function getComputedStyle(el) {
  var window = (0, _ssrWindowEsm.a)();
  var style = void 0;
  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }
  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }
  if (!style) {
    style = el.style;
  }
  return style;
}
function getTranslate(el, axis) {
  if (axis === void 0) {
    axis = 'x';
  }
  var window = (0, _ssrWindowEsm.a)();
  var matrix = void 0;
  var curTransform = void 0;
  var transformMatrix = void 0;
  var curStyle = getComputedStyle(el);
  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;
    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(function (a) {
        return a.replace(',', '.');
      }).join(', ');
    }
    // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case
    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }
  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
      // Normal Browsers
      else curTransform = parseFloat(matrix[4]);
  }
  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42;
    // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
      // Normal Browsers
      else curTransform = parseFloat(matrix[5]);
  }
  return curTransform || 0;
}
function isObject(o) {
  return (typeof o === 'undefined' ? 'undefined' : _typeof(o)) === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }
  return node && (node.nodeType === 1 || node.nodeType === 11);
}
function extend() {
  var to = Object(arguments.length <= 0 ? undefined : arguments[0]);
  var noExtend = ['__proto__', 'constructor', 'prototype'];
  for (var i = 1; i < arguments.length; i += 1) {
    var nextSource = i < 0 || arguments.length <= i ? undefined : arguments[i];
    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      var keysArray = Object.keys(Object(nextSource)).filter(function (key) {
        return noExtend.indexOf(key) < 0;
      });
      for (var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        var nextKey = keysArray[nextIndex];
        var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
        if (desc !== undefined && desc.enumerable) {
          if (isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject(to[nextKey]) && isObject(nextSource[nextKey])) {
            to[nextKey] = {};
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }
  return to;
}
function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}
function animateCSSModeScroll(_ref) {
  var swiper = _ref.swiper,
      targetPosition = _ref.targetPosition,
      side = _ref.side;

  var window = (0, _ssrWindowEsm.a)();
  var startPosition = -swiper.translate;
  var startTime = null;
  var time = void 0;
  var duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  var dir = targetPosition > startPosition ? 'next' : 'prev';
  var isOutOfBound = function isOutOfBound(current, target) {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };
  var animate = function animate() {
    time = new Date().getTime();
    if (startTime === null) {
      startTime = time;
    }
    var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }
    swiper.wrapperEl.scrollTo(_defineProperty({}, side, currentPosition));
    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(function () {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo(_defineProperty({}, side, currentPosition));
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }
    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };
  animate();
}
function getSlideTransformEl(slideEl) {
  return slideEl.querySelector('.swiper-slide-transform') || slideEl.shadowRoot && slideEl.shadowRoot.querySelector('.swiper-slide-transform') || slideEl;
}
function elementChildren(element, selector) {
  if (selector === void 0) {
    selector = '';
  }
  return [].concat(_toConsumableArray(element.children)).filter(function (el) {
    return el.matches(selector);
  });
}
function showWarning(text) {
  try {
    console.warn(text);
    return;
  } catch (err) {
    // err
  }
}
function createElement(tag, classes) {
  var _el$classList;

  if (classes === void 0) {
    classes = [];
  }
  var el = document.createElement(tag);
  (_el$classList = el.classList).add.apply(_el$classList, _toConsumableArray(Array.isArray(classes) ? classes : classesToTokens(classes)));
  return el;
}
function elementOffset(el) {
  var window = (0, _ssrWindowEsm.a)();
  var document = (0, _ssrWindowEsm.g)();
  var box = el.getBoundingClientRect();
  var body = document.body;
  var clientTop = el.clientTop || body.clientTop || 0;
  var clientLeft = el.clientLeft || body.clientLeft || 0;
  var scrollTop = el === window ? window.scrollY : el.scrollTop;
  var scrollLeft = el === window ? window.scrollX : el.scrollLeft;
  return {
    top: box.top + scrollTop - clientTop,
    left: box.left + scrollLeft - clientLeft
  };
}
function elementPrevAll(el, selector) {
  var prevEls = [];
  while (el.previousElementSibling) {
    var prev = el.previousElementSibling; // eslint-disable-line
    if (selector) {
      if (prev.matches(selector)) prevEls.push(prev);
    } else prevEls.push(prev);
    el = prev;
  }
  return prevEls;
}
function elementNextAll(el, selector) {
  var nextEls = [];
  while (el.nextElementSibling) {
    var next = el.nextElementSibling; // eslint-disable-line
    if (selector) {
      if (next.matches(selector)) nextEls.push(next);
    } else nextEls.push(next);
    el = next;
  }
  return nextEls;
}
function elementStyle(el, prop) {
  var window = (0, _ssrWindowEsm.a)();
  return window.getComputedStyle(el, null).getPropertyValue(prop);
}
function elementIndex(el) {
  var child = el;
  var i = void 0;
  if (child) {
    i = 0;
    // eslint-disable-next-line
    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }
    return i;
  }
  return undefined;
}
function elementParents(el, selector) {
  var parents = []; // eslint-disable-line
  var parent = el.parentElement; // eslint-disable-line
  while (parent) {
    if (selector) {
      if (parent.matches(selector)) parents.push(parent);
    } else {
      parents.push(parent);
    }
    parent = parent.parentElement;
  }
  return parents;
}
function elementTransitionEnd(el, callback) {
  function fireCallBack(e) {
    if (e.target !== el) return;
    callback.call(el, e);
    el.removeEventListener('transitionend', fireCallBack);
  }
  if (callback) {
    el.addEventListener('transitionend', fireCallBack);
  }
}
function elementOuterSize(el, size, includeMargins) {
  var window = (0, _ssrWindowEsm.a)();
  if (includeMargins) {
    return el[size === 'width' ? 'offsetWidth' : 'offsetHeight'] + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-right' : 'margin-top')) + parseFloat(window.getComputedStyle(el, null).getPropertyValue(size === 'width' ? 'margin-left' : 'margin-bottom'));
  }
  return el.offsetWidth;
}
function makeElementsArray(el) {
  return (Array.isArray(el) ? el : [el]).filter(function (e) {
    return !!e;
  });
}

exports.a = elementParents;
exports.b = elementOffset;
exports.c = createElement;
exports.d = now;
exports.e = elementChildren;
exports.f = elementOuterSize;
exports.g = elementIndex;
exports.h = classesToTokens;
exports.i = getTranslate;
exports.j = elementTransitionEnd;
exports.k = isObject;
exports.l = getSlideTransformEl;
exports.m = makeElementsArray;
exports.n = nextTick;
exports.o = elementStyle;
exports.p = elementNextAll;
exports.q = elementPrevAll;
exports.r = animateCSSModeScroll;
exports.s = setCSSProperty;
exports.t = showWarning;
exports.u = extend;
exports.v = deleteProps;

/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _swiperCore = __webpack_require__(13);

Object.defineProperty(exports, 'Swiper', {
  enumerable: true,
  get: function get() {
    return _swiperCore.S;
  }
});
Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _swiperCore.S;
  }
});

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _rpAnalytics = __webpack_require__(2);

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

var _swiper = __webpack_require__(15);

var _swiper2 = _interopRequireDefault(_swiper);

var _chunkArray = __webpack_require__(24);

var _orderByPosition = __webpack_require__(1);

var _outsideClickHandler = __webpack_require__(26);

var _constants = __webpack_require__(0);

var _constants2 = __webpack_require__(17);

var _filterBookmakers = __webpack_require__(6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var OPEN = _constants.BOOKMAKER_STATUS.OPEN;
var EXCLUSIVE = _constants.BOOKMAKER_OFFER_TYPE.EXCLUSIVE;


var initBookmakersExclusiveOffersPanel = function initBookmakersExclusiveOffersPanel(desktopBookmakers, mobileBookmakers) {
    var bookmakers = _constants.isMobile ? mobileBookmakers : desktopBookmakers;
    var filteredBookmakers = (0, _filterBookmakers.getBookmakersToShow)(bookmakers, EXCLUSIVE);
    /**
     * bookmakerPosition is the index of displayed bookmaker card
     * position is the position from API response and may be different from bookmakerPosition
     * TODO: refactor and choose which prop is needed
     */
    var orderedBookmakers = (0, _orderByPosition.orderByPosition)(filteredBookmakers).map(function (bookmaker, index) {
        return _extends({}, bookmaker, {
            bookmakerPosition: index + 1
        });
    });

    // Carousel wrapper will not be present if carousel_visibility is set to false - JP-9212
    var containers = document.querySelectorAll(_constants2.selectors.mainContainer);

    if (!bookmakers.length && containers.length) {
        containers.forEach(function (container) {
            container.classList.add(_constants2.classes.mainContainerHide);
        });

        return;
    }

    var swiperWrapper = document.createElement('div');
    var chunkedBookmakers = (0, _chunkArray.chunkArray)(orderedBookmakers, 4);

    chunkedBookmakers.forEach(function (chunk) {
        chunk.forEach(function (bookmaker) {
            var bookmakerOffer = bookmaker.altOffer ? bookmaker.altOffer : bookmaker.offer;

            var swiperSlide = document.createElement('div');
            swiperSlide.classList.add(_constants2.classes.slide);
            swiperSlide.classList.add(_constants2.classes.offersContainer);

            var bookmakerElement = document.createElement('div');

            if (bookmaker.takeover_image) {
                bookmakerElement.style.backgroundImage = 'url(' + bookmaker.takeover_image + ')';
                bookmakerElement.style.backgroundSize = 'cover';
            } else if (bookmaker.background_image) {
                bookmakerElement.style.backgroundImage = 'url(' + bookmaker.background_image + ')';
                bookmakerElement.style.backgroundSize = 'cover';
            } else {
                bookmakerElement.style.backgroundColor = bookmaker.colourBranding || '#fff';
            }

            bookmakerElement.classList.add(_constants2.classes.bookmaker);

            if (bookmaker.takeover_image) {
                bookmakerElement.innerHTML = '\n                    <a href=\'' + bookmaker.sign_up_link_1 + '\' target="_blank" \n                    class="bookmakersExclusive__takeoverImageLink bookmakersExclusive__claim-btn"\n                    data-name=\'' + bookmaker.name + '\'\n                    bookmaker-position=\'' + bookmaker.bookmakerPosition + '\'\n                    slide-item-position=\'' + bookmaker.position + '\'\n                    bookmaker-offer=\'null\'\n                    bookmaker-tier=\'Tier ' + Number(bookmaker.bookmaker_tier) + '\'\n                    rel="noreferrer nofollow sponsored"\n                    ></a>';
            } else {
                bookmakerElement.innerHTML = '\n                    <img class="bookmakersExclusive__logo" src="' + bookmaker.bookmaker_logo + '"/>\n                    ' + (bookmaker.offer && '<p class="bookmakersExclusive__offer"\n                            style="color: ' + (bookmaker.textColour || '#000') + '"\n                        >' + bookmaker.offer + '</p>') + '               \n                ' + (bookmaker.tsAndCsRequired === 'true' ? '<button\n                                class="bookmakersExclusive__claim-btn"\n                                data-name=\'' + bookmaker.name + '\'\n                                bookmaker-position=\'' + bookmaker.bookmakerPosition + '\'\n                                slide-item-position=\'' + bookmaker.position + '\'\n                                bookmaker-offer=\'' + bookmakerOffer + '\'\n                                bookmaker-tier=\'Tier ' + Number(bookmaker.bookmaker_tier) + '\'\n                                style="\n                                    background-color: ' + (bookmaker.linkColour || '#F01E28') + ';\n                                    color: ' + (bookmaker.linkTextColour || '#fff') + '\n                                    "\n                            >\n                                ' + (window.innerWidth > 989 ? bookmaker.linkText || 'CLAIM THIS OFFER' : 'CLAIM') + '\n                            </button>' : '<a href=\'' + bookmaker.sign_up_link_1 + '\'\n                                data-name=\'' + bookmaker.name + '\'\n                                bookmaker-position=' + bookmaker.bookmakerPosition + '\n                                bookmaker-offer=\'' + bookmakerOffer + '\'\n                                bookmaker-tier=\'Tier ' + Number(bookmaker.bookmaker_tier) + '\'\n                                target="_blank"\n                                rel="noreferrer nofollow sponsored"\n                                style="\n                                    background-color: ' + (bookmaker.linkColour || '#F01E28') + ';\n                                    color: ' + (bookmaker.linkTextColour || '#fff') + '\n                                    "\n                                class="bookmakersExclusive__claim-btn">\n                                ' + (window.innerWidth > 989 ? bookmaker.linkText || 'CLAIM THIS OFFER' : 'CLAIM') + '\n                            </a>') + '\n                 <p class="bookmakersExclusive__terms">' + bookmaker.tsAndCs + '</p>\n                ';
            }
            bookmakerElement.setAttribute(_constants2.attributes.slidePerPosition, bookmaker.bookmakerPosition);
            bookmakerElement.setAttribute(_constants2.attributes.requiredTerms, bookmaker.tsAndCsRequired);
            swiperSlide.appendChild(bookmakerElement);
            swiperWrapper.appendChild(swiperSlide);
        });
    });

    var swiperContainer = document.createElement('div');
    swiperContainer.innerHTML = '\n        <div class="bookmakersExclusive__heading">\n            <div class="bookmakersExclusive__headingText">Today\u2019s Top Offers</div>\n            <div class="bookmakersExclusive__subHeading">\n                <p class="bookmakersExclusive__subHeadingText">Exclusive new offers</p>\n                <div class="bookmakersExclusive__subHeadingWrapper">\n                    <p class="bookmakersExclusive__subHeadingTextDragMore">Drag to view more</p>\n                    <a href="/free-bets/" target="_blank" class="bookmakersExclusive__subHeadingTextAllOffers">\n                        All offers\n                        <svg class="ui-icon ui-icon_sizeSmall">\n                            <use xlink:href="#icon-right"/>\n                        </svg>\n                    </a>\n                </div>\n            </div>\n        </div>\n        <div class="swiper bookmakersExclusive__swiperContainer">\n            <div class="swiper-wrapper">\n                ' + swiperWrapper.innerHTML + '\n            </div>\n        </div>\n    ';

    document.querySelectorAll(_constants2.selectors.skeleton).forEach(function (skeleton) {
        skeleton.remove();
    });
    var carouselContainers = document.querySelectorAll(_constants2.selectors.carouselContainer);

    var slides = [];

    // Carousel containers will not be present if carousel_visibility is set to false - JP-9212
    if (carouselContainers.length > 0) {
        document.querySelectorAll(_constants2.selectors.carouselContainer).forEach(function (container) {
            // eslint-disable-next-line no-param-reassign
            container.innerHTML = swiperContainer.innerHTML;
        });

        var bookmakersExclusiveContainer = document.querySelector(_constants2.selectors.container);
        slides = bookmakersExclusiveContainer.querySelectorAll('.' + _constants2.classes.offersContainer);

        // eslint-disable-next-line no-unused-vars
        var swiper = new _swiper2.default(bookmakersExclusiveContainer, {
            spaceBetween: 8,
            allowTouchMove: true,
            slidesPerView: 'auto'
        });
    }
    /**
     *
     * @param {Object} data
     */
    var createPopUp = function createPopUp(data) {
        var container = document.querySelector(_constants2.selectors.popUpContainer);
        var popUpWrapper = document.createElement('div');
        popUpWrapper.classList.add(_constants2.classes.popUpWrapper);
        popUpWrapper.setAttribute('' + _constants2.attributes.slidePerPosition, data.position);
        popUpWrapper.dataset.visible = false;
        popUpWrapper.innerHTML = '\n            <div class="bookmakersExclusive__popUp" style="background: ' + (data.colourBranding || '#fff') + '">\n                <img class="bookmakersExclusive__popUpLogo" src="' + data.bookmaker_logo + '"/>\n                ' + (data.offer.length && '<p\n                        class="bookmakersExclusive__popUpTitle"\n                        style="color: ' + (data.textColour || '#000') + '"\n                    >' + data.offer + '</p>') + '\n                <a href=\'' + (data.sign_up_link_1 === '' ? '/' : data.sign_up_link_1) + '\'\n                    style="\n                        background-color: ' + (data.linkColour || '#F01E28') + ';\n                        color: ' + (data.linkTextColour || '#000') + '\n                        "\n                    target="_blank" class="bookmakersExclusive__PopUpClaimBtn"\n                    rel="noreferrer nofollow sponsored">\n                    ' + (window.innerWidth > 989 ? data.linkText || 'CLAIM THIS OFFER' : 'CLAIM') + '\n                </a>\n                ' + (data.tsAndCs.length && '<p\n                        class="bookmakersExclusive__popUpTsAndCs"\n                        ' + (!data.colourBranding && 'style="color: #000"') + '\n                    >' + data.tsAndCs + '</p>') + '\n            </div>\n        ';

        container.appendChild(popUpWrapper);
    };

    var bookmakerName = void 0;
    var bookmakerPosition = void 0;
    var bookmakerOffer = void 0;
    var bookmakerTier = void 0;
    var headerTitle = 'Offer’s Carousel';

    var claimButtons = Array.from(document.querySelectorAll(_constants2.selectors.claimButton));
    if (claimButtons.length) {
        claimButtons.forEach(function (button) {
            return button.addEventListener('click', function () {
                bookmakerName = button.getAttribute(_constants2.attributes.dataName);

                bookmakerPosition = Number(button.getAttribute(_constants2.attributes.bookmakerPosition));

                bookmakerOffer = button.getAttribute(_constants2.attributes.bookmakerOffer);
                bookmakerTier = button.getAttribute(_constants2.attributes.bookmakerTier);

                if (button.tagName === 'BUTTON') {
                    var _SegmentIO$trackOffer;

                    SegmentIO.trackOfferAccordion((_SegmentIO$trackOffer = {}, _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_TIER, bookmakerTier), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_STATUS, OPEN), _SegmentIO$trackOffer));
                } else {
                    var _SegmentIO$trackBookm;

                    SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm = {}, _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer === 'null' ? null : bookmakerOffer), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_TIER, bookmakerTier), _SegmentIO$trackBookm));
                }
            });
        });
    }

    var bookmakersCards = document.querySelectorAll(_constants2.selectors.offers);

    bookmakersCards.forEach(function (bookmaker) {
        var offersCard = bookmaker.querySelector(_constants2.selectors.offersCard);
        var dataTermsAndConditions = offersCard.getAttribute(_constants2.attributes.requiredTerms);
        var currentOfferData = orderedBookmakers[Number(offersCard.getAttribute(_constants2.attributes.slidePerPosition)) - 1];

        if (dataTermsAndConditions.toLowerCase() === 'true') {
            createPopUp(currentOfferData);
        }
    });

    var button = document.querySelector(_constants2.selectors.allOffersButton);

    // All offers button will not be present if carousel_visibility is set to false - JP-9212
    if (button) {
        button.addEventListener('click', function () {
            SegmentIO.trackAllOffers(_defineProperty({}, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle));
        });
    }

    var popUpWrappers = document.querySelectorAll(_constants2.selectors.popUpWrapper);

    // Slides will not be present if carousel_visibility is set to false - JP-9212
    if (slides.length > 0) {
        slides.forEach(function (slide) {
            slide.addEventListener('click', function (e) {
                if (e.target.classList.contains(_constants2.classes.termsText)) {
                    var termsExpand = slide.querySelector(_constants2.selectors.expandWrapper);

                    e.target.dataset.termsHidden = !JSON.parse(e.target.dataset.termsHidden);
                    termsExpand.dataset.expanded = !JSON.parse(termsExpand.dataset.expanded);
                } else if (e.target.classList.contains(_constants2.classes.termsHide)) {
                    var termsBtn = slide.querySelector('.' + _constants2.classes.termsText);
                    var _termsExpand = slide.querySelector(_constants2.selectors.expandWrapper);

                    termsBtn.dataset.termsHidden = !JSON.parse(termsBtn.dataset.termsHidden);
                    _termsExpand.dataset.expanded = !JSON.parse(_termsExpand.dataset.expanded);
                } else if (e.target.tagName === 'BUTTON') {
                    var popUp = Array.from(popUpWrappers).find(function (element) {
                        return element.getAttribute(_constants2.attributes.slidePerPosition) === e.target.getAttribute(_constants2.attributes.slidePerPosition);
                    });
                    popUp.dataset.visible = 'true';
                    document.documentElement.classList.add('no-scroll');
                    (0, _outsideClickHandler.handleClickOutside)(_constants2.selectors.popUp, function () {
                        popUp.dataset.visible = false;
                        document.documentElement.classList.remove('no-scroll');
                    });
                }
            });
        });
    }

    popUpWrappers.forEach(function (wrapper) {
        var claimButton = wrapper.querySelector(_constants2.selectors.popUpClaimButton);

        claimButton.addEventListener('click', function () {
            var _SegmentIO$trackBookm2;

            var popUp = document.querySelector('.bookmakersExclusive__popUpWrapper[data-visible="true"]');
            popUp.dataset.visible = false;
            document.documentElement.classList.remove('no-scroll');

            SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm2 = {}, _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_OFFERS_BANNER, headerTitle), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_TIER, bookmakerTier), _SegmentIO$trackBookm2));
        });
    });
};

exports.default = initBookmakersExclusiveOffersPanel;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var selectors = exports.selectors = Object.freeze({
    carouselContainer: '.carousel-container',
    container: '.bookmakersExclusive__swiperContainer',
    expandWrapper: '.bookmakersExclusive__terms-expand-wrapper',
    skeleton: '.bookmakersExclusive__skeleton',
    claimButton: '.bookmakersExclusive__claim-btn',
    takeoverImageLink: '.bookmakersExclusive__takeoverImageLink',
    allOffersButton: '.bookmakersExclusive__subHeadingTextAllOffers',
    offers: '.bookmakersExclusive__offersContainer',
    offersCard: '.bookmakersExclusive__bookmaker',
    popUpContainer: '.bookmakersExclusive__popUpContainer',
    popUpWrapper: '.bookmakersExclusive__popUpWrapper',
    popUpClaimButton: '.bookmakersExclusive__PopUpClaimBtn',
    headerTitle: '.bookmakersExclusive__headingText',
    popUp: '.bookmakersExclusive__popUp',
    mainContainer: '.js-carouselWrapper'
});

var classes = exports.classes = Object.freeze({
    termsText: 'bookmakersExclusive__terms-text',
    termsHide: 'bookmakersExclusive__terms-hide',
    offersContainer: 'bookmakersExclusive__offersContainer',
    bookmaker: 'bookmakersExclusive__bookmaker',
    slide: 'swiper-slide',
    popUpWrapper: 'bookmakersExclusive__popUpWrapper',
    mainContainerHide: 'js-carouselWrapper--hide'
});

var attributes = exports.attributes = Object.freeze({
    dataName: 'data-name',
    bookmakerPosition: 'bookmaker-position',
    bookmakerOffer: 'bookmaker-offer',
    requiredTerms: 'required-terms-and-conditions',
    slidePerPosition: 'slide-item-position',
    bookmakerTier: 'bookmaker-tier'
});

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _orderByPosition = __webpack_require__(1);

var initTierTwoBookmakersPanel = function initTierTwoBookmakersPanel(bookmakers) {
    var filteredBookmakers = bookmakers.filter(function (bookmaker) {
        return bookmaker.name && bookmaker.includeInTier2Panel;
    });
    var orderedBookmakers = (0, _orderByPosition.orderByPosition)(filteredBookmakers).slice(0, 12);

    var bookmakersContainer = document.createElement('div');
    bookmakersContainer.classList.add('bookmakersTierTwo__offersContainer');

    orderedBookmakers.forEach(function (bookmaker, index) {
        var bookmakerOffer = bookmaker.altOffer || bookmaker.offer;

        var bookmakerElement = document.createElement('a');
        bookmakerElement.setAttribute('bookmaker-position', index + 1);
        bookmakerElement.setAttribute('bookmaker-name', bookmaker.name);
        bookmakerElement.setAttribute('href', bookmaker.signUpLink1);
        bookmakerElement.setAttribute('bookmaker-offer', bookmakerOffer);
        bookmakerElement.setAttribute('target', '_blank');
        bookmakerElement.setAttribute('rel', 'noreferrer nofollow sponsored');
        bookmakerElement.classList.add('bookmakersTierTwo__bookmaker');

        bookmakerElement.innerHTML = '\n            <div class="bookmakersTierTwo__top__row">\n                <img class="bookmakersTierTwo__logo" src="' + bookmaker.bookmakerLogo + '"/>\n                <p class="bookmakersTierTwo__offer"\n                    style="color: ' + (bookmaker.textColour || '#fff') + '"\n                >\n                    ' + (bookmaker.offer ? bookmaker.offer : '') + '\n                </p>\n            </div>\n            ' + (bookmaker.tsAndCs ? '\n            <p class="bookmakersTierTwo__terms"\n               style="color: ' + (bookmaker.textColour || '#fff') + '">\n                ' + bookmaker.tsAndCs + '\n            </p>\n            ' : '') + '\n        ';
        bookmakerElement.style.backgroundColor = bookmaker.colourBranding;

        bookmakersContainer.appendChild(bookmakerElement);
    });

    var container = document.createElement('div');
    container.innerHTML = '\n        <div class="bookmakersTierTwo__heading">\n            <div class="bookmakersTierTwo__headingContainer">\n                <div class="bookmakersTierTwo__subHeading__row">\n                    <div class="bookmakersTierTwo__headingText">MORE OFFERS</div>\n                    <a href="/free-bets/" target="_blank" class="bookmakersTierTwo__subHeadingTextAllOffers">\n                        All offers\n                        <svg class="ui-icon ui-icon_sizeSmall">\n                            <use xlink:href="#icon-right"/>\n                        </svg>\n                    </a>\n                </div>\n            </div>\n        </div>\n    ';

    container.appendChild(bookmakersContainer);
    var footer = document.createElement('p');
    footer.classList.add('bookmakersTierTwo__BookmakerOffersContentTcApplyTierTwo');
    footer.textContent = 'T&Cs apply. 18+ GambleAware.org';
    container.appendChild(footer);

    document.querySelectorAll('#bookmakersTierTwoSkeleton').forEach(function (s) {
        return s.remove();
    });

    document.querySelectorAll('#bookmakersTierTwoSwiper').forEach(function (div) {
        var clone = container.cloneNode(true);
        div.appendChild(clone);

        if (!orderedBookmakers.length) {
            div.parentNode.classList.add('bookmakersTierTwo--hidden');
        }
    });
};

exports.default = initTierTwoBookmakersPanel;

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/* eslint import/prefer-default-export: "off" */
var selectors = exports.selectors = Object.freeze({
    bookmakersListWeb: '.rh-bookmakers__list--web'
});

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(0);

var _constants2 = __webpack_require__(5);

var _constants3 = __webpack_require__(19);

var renderPromotedTierTwoBookmakers = function renderPromotedTierTwoBookmakers(desktopOffers, mobileOffers) {
    var defaultLinkText = 'Claim this offer';
    var displayNone = 'display:none;';

    desktopOffers.forEach(function (_ref) {
        var altOffer = _ref.altOffer,
            discBookmakerLogo = _ref.discBookmakerLogo,
            bookmakerLogo = _ref.bookmakerLogo,
            bookmakerLogoLargeUrl = _ref.bookmakerLogoLargeUrl,
            colourBranding = _ref.colourBranding,
            linkText = _ref.linkText,
            name = _ref.name,
            offer = _ref.offer,
            signUpLink1 = _ref.signUpLink1,
            tsAndCs = _ref.tsAndCs;

        var lowercaseName = name.toLowerCase().replace(' ', '');
        var bookmakerOffer = altOffer || offer;
        // bookmakerLogoSquare is in the response for tier2

        // desktop promoted T2/T3 offers
        var desktopOffer = document.createElement('li');
        desktopOffer.classList.add('rh-bookmaker');
        desktopOffer.classList.add('rh-bookmaker--' + lowercaseName);
        desktopOffer.setAttribute('data-name', name);
        desktopOffer.setAttribute('data-index', lowercaseName);
        desktopOffer.setAttribute('data-test-selector', 'link-bm-' + lowercaseName);
        desktopOffer.setAttribute('bookmaker-color', colourBranding);
        desktopOffer.setAttribute('promoted-bookmaker', 'true');
        desktopOffer.setAttribute('bookmaker-offer', bookmakerOffer);

        // For local testing -> square logo fetch from Janus
        // ->  <img src="http://dev-beta.racingpost.com:8080/svgs/bookmaker-logos/${lowercaseName}-square.svg" class="rh-bookmaker__logo rh-logo--${key} rh-bookmaker__logo__square" alt="${displayName} logo" />
        // -> <img src="http://dev-beta.racingpost.com:8080/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />

        var innerHTMLDesktop = '\n                <div\n                    class="rh-bookmaker__header rh-bookmaker__header--' + lowercaseName + '"\n                    style="background-color: ' + colourBranding + ';"\n                >\n                <img\n                        src=' + bookmakerLogo + '\n                        width={70}\n                        height={32}\n                        alt=' + name + '\n                        class="rh-bookmaker__logo rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + ' rh-bookmaker__logo--open"\n                    />\n                    <a\n                           href=' + signUpLink1 + '\n                           target="_blank"\n                           class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker__btn_claim rh-bookmaker__btn_claim_header"\n                           style="' + (!_constants.isDesktopBeakpoint ? displayNone : '') + '"\n                           data-name=' + name + '\n                           data-index=' + lowercaseName + '\n                           data-test-selector="link-bm-' + lowercaseName + '"\n                           bookmaker-offer="' + bookmakerOffer + '"\n                           rel="noreferrer nofollow sponsored"\n                        >\n                        ' + _constants2.BUTTON_TEXT + '\n                    </a>\n                </div>\n\n                <div class="rh-bookmaker-offer">\n                    <p class="rh-bookmaker-offer__headline">' + bookmakerOffer + '</p>\n                    <div class="rh-bookmaker-offer__copy">' + tsAndCs + '</div>\n                </div>\n            </div>\n    ';

        var bookmakerContainersDesktop = document.querySelectorAll(_constants3.selectors.bookmakersListWeb);
        Array.from(bookmakerContainersDesktop).forEach(function (container) {
            desktopOffer.innerHTML = innerHTMLDesktop;
            container.appendChild(desktopOffer.cloneNode(true));
        });

        // tablet promoted T2/T3 offers
        var tabletOffer = document.createElement('li');
        tabletOffer.classList.add('rh-bookmaker');
        tabletOffer.classList.add('rh-bookmaker--' + lowercaseName);
        tabletOffer.setAttribute('data-name', name);
        tabletOffer.setAttribute('data-index', lowercaseName);
        tabletOffer.setAttribute('data-type', 'discOffer');
        tabletOffer.setAttribute('data-test-selector', 'link-bm-' + lowercaseName);
        tabletOffer.setAttribute('bookmaker-color', colourBranding);
        tabletOffer.setAttribute('promoted-bookmaker', 'true');
        tabletOffer.setAttribute('bookmaker-offer', bookmakerOffer);

        var innerHTMLTablet = '\n        <div class="rh-bookmaker__header">\n            <img\n                src=' + discBookmakerLogo + '\n                alt=' + name + '\n                class="rh-bookmaker__logo rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n                <div class="rh-bookmaker__view-offer">\n                    <span></span>\n                </div>\n            </div>\n            <div class="rh-bookmaker-offer rh-bookmaker-offer--' + lowercaseName + '">\n            <img\n                src=' + (bookmakerLogoLargeUrl || '') + '\n                width=100\n                height=55\n                alt=' + name + '\n                class="rh-bookmaker__logo__text rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n            <div class="rh-bookmaker-offer__headline">' + offer + '</div>\n            <a\n                href=' + signUpLink1 + '\n                target="_blank"\n                class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker-offer__claim-btn-analytics"\n                data-name=' + name + '\n                data-index=' + lowercaseName + '\n                data-test-selector="link-bm-' + lowercaseName + '"\n                bookmaker-offer="' + bookmakerOffer + '"\n                rel="noreferrer nofollow sponsored"\n            >\n                ' + (linkText || defaultLinkText) + '\n            </a>\n            <div class="rh-bookmaker-offer__copy">\n                ' + tsAndCs + '\n            </div>\n        </div>\n    ';

        var bookmakerContainersTablet = document.querySelectorAll('.rh-bookmakers__list--tablet');
        Array.from(bookmakerContainersTablet).forEach(function (container) {
            tabletOffer.innerHTML = innerHTMLTablet;
            container.appendChild(tabletOffer.cloneNode(true));
        });
    });

    mobileOffers.forEach(function (_ref2) {
        var altOffer = _ref2.altOffer,
            offer = _ref2.offer,
            discBookmakerLogo = _ref2.discBookmakerLogo,
            tsAndCs = _ref2.tsAndCs,
            discLinkURL = _ref2.discLinkURL,
            bookmakerLogoLargeUrl = _ref2.bookmakerLogoLargeUrl,
            colourBranding = _ref2.colourBranding,
            linkText = _ref2.linkText,
            name = _ref2.name;

        var lowercaseName = name.toLowerCase().replace(' ', '');
        var bookmakerOffer = altOffer || offer;

        // mobile promoted T2/T3 offers
        var mobileOffer = document.createElement('li');
        mobileOffer.classList.add('rh-bookmaker');
        mobileOffer.classList.add('rh-bookmaker--' + lowercaseName);
        mobileOffer.setAttribute('data-name', name);
        mobileOffer.setAttribute('data-index', lowercaseName);
        mobileOffer.setAttribute('data-type', 'discOffer');
        mobileOffer.setAttribute('data-test-selector', 'link-bm-' + lowercaseName);
        mobileOffer.setAttribute('bookmaker-color', colourBranding);
        mobileOffer.setAttribute('promoted-bookmaker', 'true');
        mobileOffer.setAttribute('bookmaker-offer', bookmakerOffer);

        var innerHTMLMobile = '\n        <div class="rh-bookmaker__header">\n            <img\n                src=' + discBookmakerLogo + '\n                alt=' + name + '\n                class="rh-bookmaker__logo rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n                <div class="rh-bookmaker__view-offer">\n                    <span></span>\n                </div>\n            </div>\n            <div class="rh-bookmaker-offer rh-bookmaker-offer--' + lowercaseName + '">\n            <img\n                src=' + (bookmakerLogoLargeUrl || '') + '\n                alt=' + name + '\n                class="rh-bookmaker__logo__text rh-bookmaker__logo--' + name.toLowerCase() + ' rh-logo--' + name.toLowerCase() + '"\n            />\n            <div class="rh-bookmaker-offer__headline">' + offer + '</div>\n            <a\n                href=' + discLinkURL + '\n                target="_blank"\n                class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker-offer__claim-btn-analytics"\n                data-name=' + name + '\n                data-index=' + lowercaseName + '\n                data-test-selector="link-bm-' + lowercaseName + '"\n                bookmaker-offer="' + bookmakerOffer + '"\n                rel="noreferrer nofollow sponsored"\n            >\n                ' + (linkText || defaultLinkText) + '\n            </a>\n            <div class="rh-bookmaker-offer__copy">\n                ' + tsAndCs + '\n            </div>\n        </div>\n    ';

        var bookmakerContainersMobile = document.querySelectorAll('.rh-bookmakers__list--mobile');
        Array.from(bookmakerContainersMobile).forEach(function (container) {
            mobileOffer.innerHTML = innerHTMLMobile;
            container.appendChild(mobileOffer.cloneNode(true));
        });
    });
}; /* eslint-disable camelcase */
exports.default = renderPromotedTierTwoBookmakers;

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var selectors = exports.selectors = Object.freeze({
    bookmakersListWeb: '.rh-bookmakers__list--web'
});

var classes = exports.classes = Object.freeze({
    bookmakerOpen: 'rh-bookmaker--open'
});

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _constants = __webpack_require__(0);

var _filterBookmakers = __webpack_require__(6);

var _constants2 = __webpack_require__(5);

var _constants3 = __webpack_require__(21);

/* eslint-disable camelcase, arrow-parens, no-multi-spaces */
var TIER_ONE = _constants.BOOKMAKER_OFFER_TYPE.TIER_ONE;

// tier 1

var keys = {
    williamhill: 'williamHill',
    raceBets: 'raceBets'
};

var isValidTopOffer = function isValidTopOffer(publishTime, archiveTime) {
    var publishTimeObj = new Date(publishTime);
    var archiveTimeObj = new Date(archiveTime);
    if (isNaN(archiveTimeObj) || isNaN(publishTimeObj)) {
        return false;
    }
    var currentTime = new Date();
    if (currentTime < publishTimeObj || currentTime > archiveTimeObj) {
        return false;
    }
    return true;
};

var discOfferRender = function discOfferRender(offers, device) {
    offers.forEach(function (_ref) {
        var altOffer = _ref.altOffer,
            linkText = _ref.linkText,
            name = _ref.name,
            displayName = _ref.displayName,
            offer = _ref.offer,
            discLinkURL = _ref.discLinkURL,
            discOfferHeadline = _ref.discOfferHeadline,
            signUpLink3 = _ref.signUpLink3,
            tsAndCs = _ref.tsAndCs,
            topOfferPublishTime = _ref.topOfferPublishTime,
            topOfferArchiveTime = _ref.topOfferArchiveTime;

        var lowercaseName = name.toLowerCase();
        var key = keys[lowercaseName] || lowercaseName;
        var bookmakerOffer = altOffer || offer;

        var discOffer = document.createElement('li');
        discOffer.classList.add('rh-bookmaker');
        discOffer.classList.add('rh-bookmaker--' + key);
        discOffer.setAttribute('data-name', displayName);
        discOffer.setAttribute('data-type', 'discOffer');
        discOffer.setAttribute('data-index', key);
        discOffer.setAttribute('data-test-selector', 'link-bm-' + key);
        discOffer.setAttribute('data-valid-topoffer', isValidTopOffer(topOfferPublishTime, topOfferArchiveTime));
        discOffer.setAttribute('bookmaker-offer', bookmakerOffer);

        var discOfferInnerHTML = '\n            <div class="rh-bookmaker__header">\n                <svg class="rh-bookmaker__logo rh-logo--' + key + '">\n                    <use xlink:href="#logo-disc-' + key + '"/>\n                </svg>\n                <div class="rh-bookmaker__view-offer">\n                    <span></span>\n                </div>\n            </div>\n            <div class="rh-bookmaker-offer rh-bookmaker-offer--' + key + '">\n                <svg class="rh-bookmaker__logo__text rh-logo--' + key + '">\n                    <use xlink:href="#logo-text-' + key + '"/>\n                </svg>\n                <div class="rh-bookmaker-offer__headline">' + (_constants.isMobile ? discOfferHeadline : bookmakerOffer) + '</div>\n                <a href="' + (_constants.isMobile ? discLinkURL : signUpLink3) + '"\n                    target="_blank"\n                    class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker-offer__claim-btn-analytics"\n                    data-name="' + name + '"\n                    data-index="' + key + '"\n                    data-test-selector="link-bm-' + key + '"\n                    rel="noreferrer nofollow sponsored"\n                >\n                    ' + linkText + '\n                </a>\n                <div class="rh-bookmaker-offer__copy">' + tsAndCs + '</div>\n            </div>\n        ';

        var discContainers = document.querySelectorAll('.rh-bookmakers__list--' + device);
        Array.from(discContainers).forEach(function (container) {
            discOffer.innerHTML = discOfferInnerHTML;
            container.appendChild(discOffer.cloneNode(true));
        });
    });
};

var renderTierOneBookmakers = function renderTierOneBookmakers(desktopOffers, mobileOffers, freeBetsOffers) {
    var displayNone = 'display:none;';

    // NOTE: [JP-9948] Filter tierOne after bookmaker quiz or recent logged bookmaker account
    var filteredDesktopOffers = (0, _filterBookmakers.getBookmakersToShow)(desktopOffers, TIER_ONE);
    var filteredMobileOffers = (0, _filterBookmakers.getBookmakersToShow)(mobileOffers, TIER_ONE);

    filteredDesktopOffers.forEach(function (_ref2) {
        var altOffer = _ref2.altOffer,
            name = _ref2.name,
            displayName = _ref2.displayName,
            offer = _ref2.offer,
            signUpLink3 = _ref2.signUpLink3,
            tsAndCs = _ref2.tsAndCs,
            topOfferPublishTime = _ref2.topOfferPublishTime,
            topOfferArchiveTime = _ref2.topOfferArchiveTime;

        var lowercaseName = name.toLowerCase();
        var key = keys[lowercaseName] || lowercaseName;
        var isSkybet = lowercaseName === 'skybet';
        var bookmakerOffer = altOffer || offer;
        var desktopOffer = document.createElement('li');
        desktopOffer.classList.add('rh-bookmaker');
        desktopOffer.classList.add('rh-bookmaker--' + key);
        desktopOffer.setAttribute('data-name', displayName);
        desktopOffer.setAttribute('data-index', key);
        desktopOffer.setAttribute('data-test-selector', 'link-bm-' + key);
        desktopOffer.setAttribute('data-valid-topoffer', isValidTopOffer(topOfferPublishTime, topOfferArchiveTime));
        desktopOffer.setAttribute('bookmaker-offer', bookmakerOffer);

        // For local testing -> square logo fetch from Janus
        // ->  <img src="http://dev-beta.racingpost.com:8080/svgs/bookmaker-logos/${lowercaseName}-square.svg" class="rh-bookmaker__logo rh-logo--${key} rh-bookmaker__logo__square" alt="${displayName} logo" />
        // -> <img src="http://dev-beta.racingpost.com:8080/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />
        var innerHTMLDesktop = '\n            <div class="rh-bookmaker__header rh-bookmaker__header--' + key + '">\n                <svg class="rh-bookmaker__logo rh-logo--' + key + ' rh-bookmaker__logo--open" style="' + (isSkybet ? displayNone : '') + '">\n                    <use xlink:href="#logo-' + key + '"/>\n                </svg>\n                \n                <div class="rh-bookmaker__logo rh-bookmaker__logo--skybet rh-logo--skybet rh-bookmaker__logo--open" style="' + (!isSkybet ? displayNone : '') + '">\n                </div>\n\n                <div class="top-offer-label">TOP OFFER</div>\n                <a href="' + signUpLink3 + '"\n                    target="_blank"\n                    class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker__btn_claim rh-bookmaker-offer__claim-btn-analytics"\n                    data-name="' + name + '"\n                    data-index="' + lowercaseName + '" \n                    data-test-selector="link-bm-' + lowercaseName + '"\n                    rel="noreferrer nofollow sponsored"\n                >\n                    ' + _constants2.BUTTON_TEXT + '\n                </a>\n            </div>\n            <div class="rh-bookmaker-offer">\n                <div class="rh-bookmaker-offer__headline">' + bookmakerOffer + '</div>\n                <a href="' + signUpLink3 + '"\n                    target="_blank"\n                    class="rh-bookmaker-offer__claim-btn ui-btn ui-btn_primary rh-bookmaker__btn_claim rh-bookmaker-offer__claim-btn-analytics rh-bookmaker-offer__claim-btn--top-offer"\n                    data-name="' + name + '"\n                    data-index="' + lowercaseName + '" \n                    data-test-selector="link-bm-' + lowercaseName + '"\n                    rel="noreferrer nofollow sponsored"\n                >\n                    ' + _constants2.BUTTON_TEXT + '\n                </a>\n                <div class="rh-bookmaker-offer__copy">' + tsAndCs + '</div>\n            </div>';

        var bookmakerContainersDesktop = document.querySelectorAll(_constants3.selectors.bookmakersListWeb);
        Array.from(bookmakerContainersDesktop).forEach(function (container) {
            desktopOffer.innerHTML = innerHTMLDesktop;
            container.appendChild(desktopOffer.cloneNode(true));
            container.classList.add(_constants3.classes.bookmakerOpen);
        });
    });

    discOfferRender(filteredDesktopOffers, 'tablet');
    discOfferRender(filteredMobileOffers, 'mobile');

    // Free bets

    var freeBets = document.createElement('a');
    freeBets.classList.add('freeBets__Anchor');
    freeBets.setAttribute('href', '/free-bets/');
    freeBets.setAttribute('target', '_blank');

    // note: icon for expanded offers on everything except bet365

    var freeBetsHTML = '\n        <div class="freeBets__ItemContainer">\n            <div class="freeBets__LogoContainer">\n                <span class="freeBets__Logo">' + freeBetsOffers.name + '</span>\n            </div>\n            <span class="freeBets__Title">' + freeBetsOffers.offer + '</span>\n\n            <img src="/svgs/open_in_new_window_white.svg" class="freeBets__LinkContainer" />\n        </div>';

    var freeBetsContainer = document.querySelectorAll('.rh-freeBets__Container');
    Array.from(freeBetsContainer).forEach(function (container) {
        freeBets.innerHTML = freeBetsHTML;
        container.appendChild(freeBets.cloneNode(true));
    });
};

exports.default = renderTierOneBookmakers;

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _rpAnalytics = __webpack_require__(2);

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

__webpack_require__(12);

var _fetchBookmakersTierTwo = __webpack_require__(10);

var _fetchBookmakersTierTwo2 = _interopRequireDefault(_fetchBookmakersTierTwo);

var _fetchBookmakerExclusiveOffers = __webpack_require__(7);

var _fetchBookmakerExclusiveOffers2 = _interopRequireDefault(_fetchBookmakerExclusiveOffers);

var _constants = __webpack_require__(0);

var _getBookmakersName = __webpack_require__(11);

var _fetchBookmakersTierOne = __webpack_require__(9);

var _fetchBookmakersTierOne2 = _interopRequireDefault(_fetchBookmakersTierOne);

var _fetchBookmakersMixedTier = __webpack_require__(8);

var _fetchBookmakersMixedTier2 = _interopRequireDefault(_fetchBookmakersMixedTier);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; } /* eslint-disable camelcase */
/* eslint-disable no-param-reassign */


var OPEN = _constants.BOOKMAKER_STATUS.OPEN,
    CLOSE = _constants.BOOKMAKER_STATUS.CLOSE;
var MORE_OFFERS_TITLE = _constants.BOOKMAKER_ANALYTICS.MORE_OFFERS_TITLE,
    TODAYS_OFFERS_TITLE = _constants.BOOKMAKER_ANALYTICS.TODAYS_OFFERS_TITLE,
    TODAYS_OFFERS_TITLE_QUICK_LINK = _constants.BOOKMAKER_ANALYTICS.TODAYS_OFFERS_TITLE_QUICK_LINK;


var initBookmakerRegPanel = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var tierOne, tierTwo, openedBookmakerClass, openedOverlayClass, openedOverlayHeaderClass, overlayActiveClass, selectedBreakpointUi, overlay, overlayHeader, bookmakerListMobile, webOffers, tabletOffers, mobileOffers, offerLists, closeOpenDiscOfferUi;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        closeOpenDiscOfferUi = function closeOpenDiscOfferUi() {
                            var openedBookmakerOffer = document.querySelector('.rh-bookmaker--open');

                            overlay.classList.remove(openedOverlayClass);
                            overlayHeader.classList.remove(openedOverlayHeaderClass);
                            openedBookmakerOffer.classList.remove(openedBookmakerClass);
                            bookmakerListMobile.classList.remove(overlayActiveClass);
                        };

                        tierOne = _constants.tierBookmakers.tierOne, tierTwo = _constants.tierBookmakers.tierTwo;

                        if (!_constants.isRacecardsOrResults) {
                            _context.next = 5;
                            break;
                        }

                        _context.next = 5;
                        return (0, _fetchBookmakerExclusiveOffers2.default)();

                    case 5:
                        _context.next = 7;
                        return (0, _fetchBookmakersTierOne2.default)();

                    case 7:
                        _context.next = 9;
                        return (0, _fetchBookmakersTierTwo2.default)();

                    case 9:
                        _context.next = 11;
                        return (0, _fetchBookmakersMixedTier2.default)();

                    case 11:
                        openedBookmakerClass = 'rh-bookmaker--open';
                        openedOverlayClass = 'rh-bookmakers__overlay--open';
                        openedOverlayHeaderClass = 'overlayWrap--open';
                        overlayActiveClass = 'activeDiscOffersOverlay';
                        selectedBreakpointUi = _constants.isTabletBeakpoint ? '.rh-bookmakers__list--tablet' : '.rh-bookmakers__list--mobile';

                        // GET element after injecting

                        overlay = document.querySelector('.rh-bookmakers__overlay');
                        overlayHeader = document.querySelector('main .overlayWrap');
                        bookmakerListMobile = document.querySelector('.rh-bookmakers ' + selectedBreakpointUi);
                        webOffers = document.querySelectorAll('.rh-bookmakers__list--web');
                        tabletOffers = document.getElementsByClassName('rh-bookmakers__list rh-bookmakers__list--tablet');
                        mobileOffers = document.getElementsByClassName('rh-bookmakers__list rh-bookmakers__list--mobile');
                        offerLists = document.querySelectorAll('.rh-bookmakers__list');


                        offerLists.forEach(function (unorderedList) {
                            var listItems = Array.from(unorderedList.querySelectorAll('li'));

                            var validTopOfferItems = listItems.filter(function (item) {
                                return item.getAttribute('data-valid-topoffer') === 'true';
                            });

                            var invalidTopOfferItems = listItems.filter(function (item) {
                                return item.getAttribute('data-valid-topoffer') === 'false';
                            });

                            var promotedTierTwoItems = listItems.filter(function (item) {
                                return item.getAttribute('promoted-bookmaker') === 'true';
                            });

                            // eslint-disable-next-line no-param-reassign
                            unorderedList.innerHTML = '';

                            [].concat(_toConsumableArray(validTopOfferItems), _toConsumableArray(invalidTopOfferItems), _toConsumableArray(promotedTierTwoItems)).forEach(function (item) {
                                return unorderedList.appendChild(item);
                            });
                        });

                        webOffers.forEach(function (desktopList) {
                            desktopList.children[0].classList.add(openedBookmakerClass);

                            var bookmakerClaimBtns = desktopList.querySelectorAll('.rh-bookmaker-offer__claim-btn');

                            if (bookmakerClaimBtns.length > 0) {
                                bookmakerClaimBtns.forEach(function (claimBtn, index) {
                                    if (index === 0) claimBtn.classList.add('rh-bookmaker-offer__claim-btn--hidden');
                                    if (index === 1) claimBtn.classList.add('rh-bookmaker-offer__claim-btn--visible');
                                });
                            }

                            // Add the position attribute to each offer
                            desktopList.childNodes.forEach(function (bookmaker, index) {
                                bookmaker.setAttribute('bookmaker-position', index + 1);
                            });
                        });

                        // Add the position attribute to each offer
                        Array.from(tabletOffers).forEach(function (tabletList) {
                            return tabletList.childNodes.forEach(function (bookmaker, index) {
                                bookmaker.setAttribute('bookmaker-position', index + 1);
                            });
                        });
                        Array.from(mobileOffers).forEach(function (mobileList) {
                            return mobileList.childNodes.forEach(function (bookmaker, index) {
                                bookmaker.setAttribute('bookmaker-position', index + 1);
                            });
                        });

                        if (_constants.isMobile) {
                            Array.from(document.querySelectorAll('.rh-bookmakers__list--web')).forEach(function (webBookmakersNode) {
                                return webBookmakersNode.remove();
                            });
                        }

                        Array.from(document.querySelectorAll('main .rh-bookmakers ' + selectedBreakpointUi)).forEach(function (listNode) {
                            return listNode.addEventListener('click', function (e) {
                                if (e.target !== e.currentTarget) return;

                                closeOpenDiscOfferUi();
                            });
                        });

                        Array.from(document.querySelectorAll('main .overlayWrap')).forEach(function (listNode) {
                            return listNode.addEventListener('click', function () {
                                closeOpenDiscOfferUi();
                            });
                        });

                        Array.from(document.querySelectorAll('.rh-bookmakers .rh-bookmaker__header')).filter(function (headerNode) {
                            return !headerNode.closest('.rh-bookmakers__list--web');
                        }).forEach(function (headerNode) {
                            return headerNode.addEventListener('click', function () {
                                var _SegmentIO$trackOffer;

                                var openedBookmakerNodes = document.getElementsByClassName(openedBookmakerClass);
                                var bookmakerNode = headerNode.parentNode;
                                var isWebPanel = headerNode.parentNode.parentNode.classList.contains('rh-bookmakers__list--web');
                                var isBookmakerNodeOpened = bookmakerNode.classList.contains(openedBookmakerClass);
                                var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));
                                var isTierTwo = bookmakerNode.getAttribute('promoted-bookmaker') === 'true';
                                // Bet365 comes with uppercase B, but it is required to be lowercase
                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(bookmakerNode.getAttribute('data-name'));
                                var isOverlayOpened = overlay.classList.contains(openedOverlayClass);

                                if (!isOverlayOpened && !isWebPanel) {
                                    overlay.classList.add(openedOverlayClass);
                                    bookmakerListMobile.classList.add(overlayActiveClass);
                                    overlayHeader.classList.add(openedOverlayHeaderClass);
                                }

                                if (openedBookmakerNodes.length > 0) {
                                    Array.from(openedBookmakerNodes).forEach(function (node) {
                                        if (node === bookmakerNode) {
                                            overlay.classList.remove(openedOverlayClass);
                                            if (overlayHeader) {
                                                overlayHeader.classList.remove(openedOverlayHeaderClass);
                                            }
                                            bookmakerNode.classList.remove(openedBookmakerClass);
                                            bookmakerListMobile.classList.remove(overlayActiveClass);

                                            var isPromotedBookmaker = node.getAttribute('promoted-bookmaker');

                                            if (isPromotedBookmaker) {
                                                node.childNodes[1].style.backgroundColor = '';
                                            } else {
                                                node.classList.remove(openedBookmakerClass);

                                                if (isPromotedBookmaker) {
                                                    node.childNodes[1].style.backgroundColor = '';
                                                }
                                            }
                                            bookmakerNode.classList.remove(openedBookmakerClass);
                                            bookmakerListMobile.classList.remove(overlayActiveClass);
                                        } else {
                                            node.classList.remove(openedBookmakerClass);
                                            node.childNodes[1].style.backgroundColor = '';
                                        }
                                    });
                                }

                                if (!isBookmakerNodeOpened) {
                                    bookmakerNode.classList.add(openedBookmakerClass);
                                    var isDiscOffer = bookmakerNode.getAttribute('data-type') === 'discOffer';

                                    if (!isDiscOffer) {
                                        var isPromotedBookmaker = bookmakerNode.getAttribute('promoted-bookmaker');
                                        var bookmakerColor = bookmakerNode.getAttribute('bookmaker-color');

                                        if (isPromotedBookmaker) {
                                            bookmakerNode.childNodes[1].style.backgroundColor = bookmakerColor;
                                        }
                                    } else if (isDiscOffer) {
                                        var _isPromotedBookmaker = bookmakerNode.getAttribute('promoted-bookmaker');
                                        var _bookmakerColor = bookmakerNode.getAttribute('bookmaker-color');

                                        if (_isPromotedBookmaker) {
                                            bookmakerNode.childNodes[3].style.backgroundColor = _bookmakerColor;
                                        }
                                    }
                                }
                                var bookmakerOffer = bookmakerNode.getAttribute('bookmaker-offer');

                                SegmentIO.trackOfferAccordion((_SegmentIO$trackOffer = {}, _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_STATUS, !isBookmakerNodeOpened ? OPEN : CLOSE), _defineProperty(_SegmentIO$trackOffer, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackOffer), isTierTwo);
                            });
                        });

                        Array.from(document.querySelectorAll('.rh-bookmaker-offer__claim-btn-analytics')).forEach(function (el) {
                            return el.addEventListener('click', function () {
                                var _SegmentIO$trackBookm;

                                var bookmakerNode = el.parentNode.parentNode;
                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(bookmakerNode.getAttribute('data-name'));
                                var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));
                                var isTierTwo = bookmakerNode.getAttribute('promoted-bookmaker') === 'true';
                                var bookmakerOffer = bookmakerNode.getAttribute('bookmaker-offer');

                                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm = {}, _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_TIER, isTierTwo ? tierTwo : tierOne), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackBookm), isTierTwo);
                            });
                        });

                        Array.from(document.querySelectorAll('.rh-bookmaker__btn_claim_header')).forEach(function (el) {
                            return el.addEventListener('click', function (e) {
                                var _SegmentIO$trackBookm2;

                                e.stopPropagation();
                                var bookmakerNode = el.parentNode.parentNode;
                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(bookmakerNode.getAttribute('data-name'));
                                var bookmakerPosition = Number(bookmakerNode.getAttribute('bookmaker-position'));
                                var isTierTwo = bookmakerNode.getAttribute('promoted-bookmaker') === 'true';
                                var bookmakerOffer = bookmakerNode.getAttribute('bookmaker-offer');

                                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm2 = {}, _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE_QUICK_LINK), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_TIER, isTierTwo ? tierTwo : tierOne), _defineProperty(_SegmentIO$trackBookm2, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackBookm2), isTierTwo);
                            });
                        });

                        Array.from(document.querySelectorAll('.rh-bookmakers__sub-heading-allOffers')).forEach(function (el) {
                            return el.addEventListener('click', function () {
                                SegmentIO.trackAllOffers(_defineProperty({}, SegmentIO.TRAIT_OFFERS_BANNER, TODAYS_OFFERS_TITLE));
                            });
                        });

                        Array.from(document.querySelectorAll('.freeBets__Anchor')).forEach(function (el) {
                            return el.addEventListener('click', function () {
                                SegmentIO.trackFreeBetsTap({});
                            });
                        });

                        Array.from(document.querySelectorAll('.bookmakersTierTwo__subHeadingTextAllOffers')).forEach(function (anchor) {
                            if (!anchor) return;

                            anchor.addEventListener('click', function () {
                                SegmentIO.trackAllOffers(_defineProperty({}, SegmentIO.TRAIT_OFFERS_BANNER, MORE_OFFERS_TITLE));
                            });
                        });

                        Array.from(document.querySelectorAll('.bookmakersTierTwo__bookmaker')).forEach(function (el) {
                            return el.addEventListener('click', function () {
                                var _SegmentIO$trackBookm3;

                                var bookmakerName = (0, _getBookmakersName.getBookmakersName)(el.getAttribute('bookmaker-name'));
                                var bookmakerPosition = Number(el.getAttribute('bookmaker-position'));
                                var bookmakerOffer = el.getAttribute('bookmaker-offer');

                                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm3 = {}, _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_OFFERS_BANNER, MORE_OFFERS_TITLE), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_POSITION, bookmakerPosition), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_BOOKMAKER_TIER, tierTwo), _defineProperty(_SegmentIO$trackBookm3, SegmentIO.TRAIT_BOOKMAKER_OFFER, bookmakerOffer), _SegmentIO$trackBookm3), true);
                            });
                        });

                    case 37:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, undefined);
    }));

    return function initBookmakerRegPanel() {
        return _ref.apply(this, arguments);
    };
}();

exports.default = initBookmakerRegPanel;

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
// eslint-disable-next-line import/prefer-default-export
var chunkArray = exports.chunkArray = function chunkArray(array, chunkSize) {
    var result = [];
    for (var i = 0; i < array.length; i += chunkSize) {
        result.push(array.slice(i, i + chunkSize));
    }
    return result;
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var tryParseJson = exports.tryParseJson = function tryParseJson(json) {
    try {
        return JSON.parse(json);
    } catch (err) {
        console.log('Error parsing JSON', err);

        return null;
    }
};

var getLocalStorageItem = exports.getLocalStorageItem = function getLocalStorageItem(key) {
    return localStorage.getItem(key);
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
/**
 * Reussable global click handler for executing custom code
 * whenever the user clicks outside of the designated target.
 *
 * useCapture is set in order to ensure the document click event
 * is always executed first. Likewise, the event propagation
 * is stopped so as to not retrigger events reattaching
 * another outside click handler.
 *
 * @param {String} target
 * @param {function} callback
 */
// eslint-disable-next-line import/prefer-default-export
var handleClickOutside = exports.handleClickOutside = function handleClickOutside(target, callback) {
    var clickHandler = function clickHandler(e) {
        if (!e.target.closest(target)) {
            callback();
            document.removeEventListener('click', clickHandler, true);
        }
    };

    document.addEventListener('click', clickHandler, true);
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

// eslint-disable-next-line import/prefer-default-export
var shuffleArray = exports.shuffleArray = function shuffleArray(items, seed) {
    var arr = [].concat(_toConsumableArray(items));
    var currentIndex = arr.length;
    var temporaryValue = void 0;
    var randomIndex = void 0;

    // The numbers 9301, 49297, and 233280 are part of a linear congruential generator (LCG),
    // A simple formula used to generate a sequence of pseudo-random numbers.
    var random = function random(max) {
        var newSeed = (seed * 9301 + 49297) % 233280;
        return Math.floor(newSeed / 233280 * max);
    };

    while (currentIndex !== 0) {
        randomIndex = random(currentIndex);
        currentIndex -= 1;
        temporaryValue = arr[currentIndex];
        arr[currentIndex] = arr[randomIndex];
        arr[randomIndex] = temporaryValue;
    }

    return arr;
};

/***/ })
/******/ ]);
});
//# sourceMappingURL=rpbettingspecialoffer.js.map

/***/ }),
/* 2536 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.isMobileView = isMobileView;
exports.default = AppPromo;

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpMqBreakpoints = __webpack_require__(66);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function isMobileView(currentBreakpoint) {
    if ([_rpMqBreakpoints.breakpointCodes.NARROW, _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW].includes(currentBreakpoint)) {
        return true;
    }
    return false;
}

function AppPromo() {
    this.$element = (0, _jquery2.default)('.rn-footerAppPromo');
    this.buttonSelector = '.rn-footerAppPromo__button';
    this.hiddenClass = 'rn-footerAppPromo--hidden';
}

AppPromo.prototype.show = function () {
    this.$element.removeClass(this.hiddenClass);
};

AppPromo.prototype.hide = function () {
    this.$element.addClass(this.hiddenClass);
};

AppPromo.prototype.setButtonAndImage = function (deviceType) {
    (0, _jquery2.default)(this.buttonSelector).hide();
    (0, _jquery2.default)(this.buttonSelector + '--' + deviceType).show();

    this.show();
};

AppPromo.prototype.init = function () {
    var self = this;
    var userAgent = window.navigator.userAgent.toLowerCase();

    (0, _jquery2.default)(window).on('rpBreakpointsSwitch', function (event) {
        if (isMobileView(event.detail.breakpoint.code)) {
            if (/android/i.test(userAgent)) {
                self.setButtonAndImage('android');
                return;
            }

            if (/iPhone/i.test(userAgent)) {
                self.setButtonAndImage('iphone');
                return;
            }

            self.hide();
            return;
        }

        self.show();
    });

    if (isMobileView(_rpMqBreakpoints2.default.current().code)) {
        if (/android/i.test(userAgent)) {
            self.setButtonAndImage('android');
            return;
        }

        if (/iPhone/i.test(userAgent)) {
            self.setButtonAndImage('iphone');
            return;
        }
    } else {
        self.show();
    }
};

/***/ }),
/* 2537 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _stringify = __webpack_require__(301);

var _stringify2 = _interopRequireDefault(_stringify);

var _promise = __webpack_require__(162);

var _promise2 = _interopRequireDefault(_promise);

var _slicedToArray2 = __webpack_require__(413);

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _classCallCheck2 = __webpack_require__(40);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(43);

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _constants = __webpack_require__(2538);

var _rpAnalytics = __webpack_require__(59);

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BookmakersTierOne = function () {
	function BookmakersTierOne(selector) {
		(0, _classCallCheck3.default)(this, BookmakersTierOne);

		this.$selector = (0, _jquery2.default)(selector);
		this.$isMobile = $(window).width() < 768;
		this.localStorageChange = false;
		this.getLastClickedOnBetsCTAName = "lastClickedOnBetsCTA" + (this.$isMobile ? "Mobile" : "Desktop");
		this.lastClickedOnBetsCTA = JSON.parse(localStorage.getItem(this.getLastClickedOnBetsCTAName));
		this.$freeBetsNotifications = this.$selector.find(_constants.selectors.freeBetsNotifications);
		this.$freeBetsNotificationsNumber = this.$freeBetsNotifications.find(_constants.selectors.freeBetsNotificationsNumber);

		this.init();
	}

	(0, _createClass3.default)(BookmakersTierOne, [{
		key: "init",
		value: function init() {
			this.fetchDataFromAPI();
		}

		/**
   * Check if the date is in the valid format
   *
   * @param {String} datetimeString
   * @returns boolean
   */

	}, {
		key: "isValidDateFormat",
		value: function isValidDateFormat(datetimeString) {
			// Regular expression to check the format YYYY-MM-DDTHH:mm±HH:mm
			var regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}([+-]\d{2}:\d{2})?$/;

			var isValidDateTime = regex.test(datetimeString);

			if (!isValidDateTime) {
				return false;
			}

			var date = new Date(datetimeString).getTime();

			return !isNaN(date);
		}

		/**
   * Convert date in UTC format
   *
   * @param {String} datetimeString
   * @param {Boolean} isCurerentDateTime
   * @returns string
   */

	}, {
		key: "formatDateToUKTime",
		value: function formatDateToUKTime(datetimeString) {
			var isCurerentDateTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

			var date = isCurerentDateTime ? new Date() : new Date(datetimeString);

			var options = {
				year: "numeric",
				month: "2-digit",
				day: "2-digit",
				hour: "2-digit",
				minute: "2-digit",
				hour12: false,
				timeZone: "UTC"
			};

			var formattedDate = new Intl.DateTimeFormat("en-GB", options).format(date);

			var _formattedDate$split = formattedDate.split(/[/,\s:]+/),
			    _formattedDate$split2 = (0, _slicedToArray3.default)(_formattedDate$split, 5),
			    day = _formattedDate$split2[0],
			    month = _formattedDate$split2[1],
			    year = _formattedDate$split2[2],
			    hour = _formattedDate$split2[3],
			    minute = _formattedDate$split2[4];

			return year + "-" + month + "-" + day + "T" + hour + ":" + minute + "+00:00";
		}

		/**
   * Handle visibility of the badge based on the last clicked date
   *
   */

	}, {
		key: "handleBadgeVisibility",
		value: function handleBadgeVisibility() {
			var isClicked = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

			this.lastClickedOnBetsCTA = JSON.parse(localStorage.getItem(this.getLastClickedOnBetsCTAName));

			if (!this.getNumberOfOffers) {
				this.$freeBetsNotifications.attr(_constants.attributes.dataVisible, "false");

				return;
			}

			if (!this.lastClickedOnBetsCTA || this.isUpdatedAfterLastClick() && !isClicked) {
				this.$freeBetsNotificationsNumber.text(this.getNumberOfOffers);
				this.$freeBetsNotifications.attr(_constants.attributes.dataVisible, "true");
			} else {
				this.$freeBetsNotifications.attr(_constants.attributes.dataVisible, "false");
			}
		}

		/**
   * Call the bookmakers tier one API and render the component with the data
   * For local testing -> await fetch(`http://dev-beta.racingpost.com:8080/api/stubs/bookmaker-offers-tier-one/`)
   *
   */

	}, {
		key: "fetchDataFromAPI",
		value: function fetchDataFromAPI() {
			var that = this;

			new _promise2.default(function (resolve, reject) {
				_jquery2.default.ajax({
					url: window.location.origin + "/api/stubs/bookmaker-offers-tier-one/"
				}).done(function (data) {
					that.freeBetsDesktopOffers = data.freeBetsDesktopOffers;
					that.freeBetsMobileOffers = data.freeBetsMobileOffers;

					that.freeBetsMobileOffers = {
						linkUrl: that.freeBetsMobileOffers.linkUrl,
						numberOfOffers: that.freeBetsMobileOffers.numberOfOffers,
						datetimeUpdated: that.isValidDateFormat(that.freeBetsMobileOffers.datetimeUpdated) ? that.formatDateToUKTime(that.freeBetsMobileOffers.datetimeUpdated) : null
					};
					that.freeBetsDesktopOffers = {
						linkUrl: that.freeBetsDesktopOffers.linkUrl,
						numberOfOffers: that.freeBetsDesktopOffers.numberOfOffers,
						datetimeUpdated: that.isValidDateFormat(that.freeBetsDesktopOffers.datetimeUpdated) ? that.formatDateToUKTime(that.freeBetsDesktopOffers.datetimeUpdated) : null
					};

					that.datetimeUpdated = that.$isMobile ? that.freeBetsMobileOffers.datetimeUpdated : that.freeBetsDesktopOffers.datetimeUpdated;

					that.getNumberOfOffers = that.$isMobile ? that.freeBetsMobileOffers.numberOfOffers : that.freeBetsDesktopOffers.numberOfOffers;

					that.handleBadgeVisibility();
					that.handleClick();

					resolve();
				}).fail(function () {
					reject("Can't resolve all necessary information from secure server!");
				});
			});
		}

		/**
   * Update the notification count objects in case when we click on the free bets link
   * to hide the notification badge
   *
   */

	}, {
		key: "updateNotificationCount",
		value: function updateNotificationCount() {
			var modifiedOffers = this.$isMobile ? {
				numberOfOffers: !this.lastClickedOnBetsCTA ? this.freeBetsMobileOffers.numberOfOffers : null,
				datetimeUpdated: this.formatDateToUKTime(new Date(), true)
			} : {
				numberOfOffers: !this.lastClickedOnBetsCTA ? this.freeBetsDesktopOffers.numberOfOffers : null,
				datetimeUpdated: this.formatDateToUKTime(new Date(), true)
			};

			localStorage.setItem(this.getLastClickedOnBetsCTAName, (0, _stringify2.default)(modifiedOffers));
		}

		/**
   * Compare the dates between the last clicked date and the date when the data was updated
   *
   */

	}, {
		key: "isUpdatedAfterLastClick",
		value: function isUpdatedAfterLastClick() {
			if (!this.lastClickedOnBetsCTA) return false;

			var lastClickedDate = new Date(this.lastClickedOnBetsCTA.datetimeUpdated).getTime();

			var updatedDate = new Date(this.datetimeUpdated).getTime();

			return updatedDate > lastClickedDate;
		}

		/**
   * Handle the click event on the free bets link, update the notification count
   * and trigger the trackFreeBetsTap event
   *
   */

	}, {
		key: "handleClick",
		value: function handleClick() {
			var that = this;

			this.$selector.on("click", function () {
				if (!that.lastClickedOnBetsCTA || that.isUpdatedAfterLastClick()) {
					that.localStorageChange = !that.localStorageChange;

					that.$freeBetsNotificationsNumber.text(!that.localStorageChange ? that.getNumberOfOffers : null);
				}

				var modifiedOffers = {
					datetimeUpdated: that.formatDateToUKTime(new Date(), true),
					numberOfOffers: null
				};

				localStorage.setItem(that.getLastClickedOnBetsCTAName, (0, _stringify2.default)(modifiedOffers));

				that.handleBadgeVisibility(true);
				that.updateNotificationCount();

				SegmentIO.trackFreeBetsTap((0, _defineProperty3.default)({}, SegmentIO.TRAIT_NUMBER_OF_OFFERS, that.getNumberOfOffers ? that.getNumberOfOffers : null), true);
			});
		}
	}]);
	return BookmakersTierOne;
}();

exports.default = BookmakersTierOne;

/***/ }),
/* 2538 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.freeBetsDesktopOffers = exports.freeBetsMobileOffers = exports.attributes = exports.selectors = undefined;

var _freeze = __webpack_require__(634);

var _freeze2 = _interopRequireDefault(_freeze);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var selectors = exports.selectors = (0, _freeze2.default)({
	freeBetsNotifications: ".free-bets-link__notifications",
	freeBetsNotificationsNumber: ".free-bets-link__notifications-number"
});

var attributes = exports.attributes = (0, _freeze2.default)({
	dataVisible: "data-visible"
});

/**
 * This commented lines are for the mock data in case when we want
 * to mock it and we should comment the fetchDataFromAPI method
 */
var freeBetsMobileOffers = exports.freeBetsMobileOffers = (0, _freeze2.default)({
	linkUrl: "https://www.racingpost.com/free-bets/",
	numberOfOffers: 5,
	datetimeUpdated: "2024-08-23T18:30+00:00aaaa" // invalid dagetimUpdated for testing purposes
});

var freeBetsDesktopOffers = exports.freeBetsDesktopOffers = (0, _freeze2.default)({
	linkUrl: "https://www.racingpost.com/free-bets/",
	numberOfOffers: 3,
	datetimeUpdated: "2024-01-17T17:30+00:00"
});

/***/ }),
/* 2539 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = Footer;

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpMqBreakpoints = __webpack_require__(66);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpAnalytics = __webpack_require__(59);

var segmentio = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Footer() {
    this.$element = (0, _jquery2.default)('.rn-footerMenu__sectionTitle');
    this.$sections = (0, _jquery2.default)('.rn-footerMenu__section');

    this.listExpandedClass = 'rn-footerMenu__section_expanded';

    this.init();
}

Footer.prototype.show = function (el) {
    (0, _jquery2.default)(el).parent().addClass(this.listExpandedClass);
};

Footer.prototype.hide = function () {
    this.$sections.removeClass(this.listExpandedClass);
};

Footer.prototype.toggle = function (el) {
    if ((0, _jquery2.default)(el).parent().hasClass(this.listExpandedClass)) {
        this.hide();
    } else {
        this.hide();
        this.show(el);
    }
};

Footer.prototype.init = function () {
    var self = this;
    (0, _jquery2.default)(window).on('rpBreakpointsSwitch', function (event) {
        if (![_rpMqBreakpoints.breakpointCodes.NARROW, _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW, _rpMqBreakpoints.breakpointCodes.MEDIUM].includes(event.detail.breakpoint.code)) {
            self.hide();
        }
    });
    this.$element.on('click', function () {
        if ([_rpMqBreakpoints.breakpointCodes.NARROW, _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW, _rpMqBreakpoints.breakpointCodes.MEDIUM].includes(_rpMqBreakpoints2.default.current().code)) {
            var target = this;
            self.toggle(target);
        }
    });

    /**
     * Bind footer click tracking event
     */
    (0, _jquery2.default)('.rn-footerMenu').on('click', function (event) {
        var $footerLinkItem = (0, _jquery2.default)(event.target);
        if ($footerLinkItem.hasClass('rn-footerMenu__listLink')) {
            var selection = $footerLinkItem.text().trim();
            segmentio.trackFooterClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, selection));
        }
    });
};

/***/ }),
/* 2540 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.tierOne = exports.authRender = exports.checkForAccess = exports.authReady = exports.footer = exports.appPromo = exports.secondary = exports.primary = undefined;

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _promise = __webpack_require__(162);

var _promise2 = _interopRequireDefault(_promise);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpAuth = __webpack_require__(287);

__webpack_require__(849);

var _rpAnalytics = __webpack_require__(59);

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _authPrefsLoader = __webpack_require__(2541);

var _authPrefsLoader2 = _interopRequireDefault(_authPrefsLoader);

var _primaryMenu = __webpack_require__(2543);

var _primaryMenu2 = _interopRequireDefault(_primaryMenu);

var _secondaryMenu = __webpack_require__(2547);

var _secondaryMenu2 = _interopRequireDefault(_secondaryMenu);

var _appPromo = __webpack_require__(2536);

var _appPromo2 = _interopRequireDefault(_appPromo);

var _footer = __webpack_require__(2539);

var _footer2 = _interopRequireDefault(_footer);

var _freeBets = __webpack_require__(2551);

var _freeBets2 = _interopRequireDefault(_freeBets);

var _BookmakersTierOne = __webpack_require__(2537);

var _BookmakersTierOne2 = _interopRequireDefault(_BookmakersTierOne);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var primary = new _primaryMenu2.default('#primaryNav');
var secondary = new _secondaryMenu2.default('#secondaryNav');
var appPromo = new _appPromo2.default();
var footer = new _footer2.default();
var tierOne = new _BookmakersTierOne2.default('.free-bets-link');

(0, _freeBets2.default)('.rn-menuBar__navItem__freeBets');

var $authPrefsUrl = (0, _jquery2.default)('[data-auth-prefs-url]');
var authReady = (0, _authPrefsLoader2.default)($authPrefsUrl.data('auth-prefs-url')).then(function (auth) {
    (0, _rpAuth.render)();
    (0, _rpAuth.createBarriers)();
    (0, _rpAuth.checkForAccess)('Subscriptions');

    return auth;
});

function constructGlobalAuthApi() {
    global.authApi = global.authApi || {};

    var authReadyExternal = new _promise2.default(function (resolve, reject) {
        authReady.finally(resolve);
    });

    global.authApi.authReady = authReadyExternal; // exposes only the success/error of the authentification, no other data
}

constructGlobalAuthApi();

/**
 * Bind menu bar tracking event
 */
(0, _jquery2.default)('.rn-menuBar').on('click', function (event) {
    var $menuItem = (0, _jquery2.default)(event.target).closest('.rn-menuBar__navItem');
    if ($menuItem[0] && !(0, _jquery2.default)(event.target).closest('.bs-switchBookmakers')[0]) {
        var selection = (0, _jquery2.default)((0, _jquery2.default)($menuItem[0]).find('span')[0]).text().trim().split('/')[0];

        segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, selection));
    }
});

exports.primary = primary;
exports.secondary = secondary;
exports.appPromo = appPromo;
exports.footer = footer;
exports.authReady = authReady;
exports.checkForAccess = _rpAuth.checkForAccess;
exports.authRender = _rpAuth.render;
exports.tierOne = tierOne;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),
/* 2541 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(162);

var _promise2 = _interopRequireDefault(_promise);

exports.default = function (url) {
    if (!authPrefsPromise) {
        authPrefsPromise = new _promise2.default(function (resolve, reject) {
            if (!url) {
                reject('Navigation auth preferences url is not configured');
            } else {
                _jquery2.default.ajax({
                    url: url,
                    xhrFields: {
                        withCredentials: true
                    },
                    crossDomain: true,
                    cache: false
                }).done(function (data) {
                    resolve(data);
                }).fail(function () {
                    reject("Can't resolve all necessary information from secure server! URL: " + url);
                });
            }
        });
    }

    return authPrefsPromise;
};

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var authPrefsPromise = null; /**
                              * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
                              */

/***/ }),
/* 2542 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _stringify = __webpack_require__(301);

var _stringify2 = _interopRequireDefault(_stringify);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = __webpack_require__(192);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Manage a state of a certain menu item
 * @param {CommonMenuItem} item
 * @constructor
 */
/**
 * @module navigation/menuStateManager
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function MenuStateManager(item) {
    this.item = item;
    this.itemKey = item.getTitle().toLowerCase();

    this.updateUrl();

    this.prevState = this.getItemState();
}

MenuStateManager.prototype.COOKIE_NAME = 'navigationState';
MenuStateManager.prototype.COOKIE_PATH = '/';
MenuStateManager.prototype.COOKIE_DURATION = 365;

/**
 * @public
 * @returns {Object|{}}
 */
MenuStateManager.prototype.getItemState = function () {
    var itemState = this.readData();

    return itemState && itemState[this.itemKey];
};

/**
 * @public
 * @param {Object} options
 * @returns {MenuStateManager}
 */
MenuStateManager.prototype.setItemState = function (options) {
    var state = this.readData() || {};
    state[this.itemKey] = state[this.itemKey] || {};

    _jquery2.default.extend(true, state[this.itemKey], options);

    this.writeData(state);

    this.updateUrl();

    return this;
};

/**
 * Check existing of state for menu item
 * @returns {boolean}
 */
MenuStateManager.prototype.hasItemState = function () {
    return !!this.readData();
};

/**
 * @public
 * @returns {MenuStateManager}
 */
MenuStateManager.prototype.clearItemState = function () {
    var itemState = this.readData();
    delete itemState[this.itemKey];

    this.writeData(itemState);

    this.updateUrl();

    return this;
};

/**
 * Read data from cookie
 * @protected
 * @returns {Object}
 */
MenuStateManager.prototype.readData = function () {
    var data = null;

    if (!_jsCookie2.default.get(this.COOKIE_NAME)) {
        return data;
    }

    try {
        data = JSON.parse(window.atob(_jsCookie2.default.get(this.COOKIE_NAME)));
    } catch (e) {
        throw new Error(e.name + ': ' + e.message + '\n' + e.stack);
    }

    return data;
};

/**
 * Write data to cookie
 * @protected
 * @param {Object} data
 */
MenuStateManager.prototype.writeData = function (data) {
    var self = this;

    try {
        this.prevState = this.getItemState();

        _jsCookie2.default.set(self.COOKIE_NAME, window.btoa((0, _stringify2.default)(data)), {
            path: self.COOKIE_PATH,
            domain: '.' + document.domain.split('.').slice(-2).join('.'),
            expires: self.COOKIE_DURATION
        });
    } catch (e) {
        throw new Error(e.name + ': ' + e.message + '\n' + e.stack);
    }
};

/**
 * Update url according to actual state
 * @protected
 */
MenuStateManager.prototype.updateUrl = function () {
    if (!this.hasItemState()) {
        return;
    }

    var $link = this.item.$obj.children(),
        url = $link.attr('href'),
        updatedUrlSuffix = this.buildUrlSuffix(this.getItemState());

    if (this.prevState) {
        url = url.replace(this.buildUrlSuffix(this.prevState), updatedUrlSuffix);
    } else {
        url += !/(#.*)|(\/)$/.test(url) ? '/' : '';
        url += updatedUrlSuffix;
    }

    $link.attr('href', url);
};

/**
 * Build url suffix using state object
 * @protected
 * @param {Object} state
 * @returns {string}
 */
MenuStateManager.prototype.buildUrlSuffix = function (state) {
    state = state || {};

    var urlSuffix = '';

    if (state.path) {
        urlSuffix += state.path;
    }

    if (state.params) {
        var params = [];
        for (var param in state.params) {
            if (state.params.hasOwnProperty(param)) {
                params.push(encodeURIComponent(param) + '=' + encodeURIComponent(state.params[param]));
            }
        }
        params = params.join('&');

        urlSuffix += '?' + params;
    }

    if (state.hash) {
        urlSuffix += '#' + state.hash;
    }

    return urlSuffix;
};

exports.default = MenuStateManager;

/***/ }),
/* 2543 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(302);

var _keys2 = _interopRequireDefault(_keys);

var _defineProperty2 = __webpack_require__(7);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _create = __webpack_require__(54);

var _create2 = _interopRequireDefault(_create);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _commonMenu = __webpack_require__(986);

var _commonMenu2 = _interopRequireDefault(_commonMenu);

var _primaryMenuItemBuilder = __webpack_require__(2546);

var _primaryMenuItemBuilder2 = _interopRequireDefault(_primaryMenuItemBuilder);

var _primaryMenuItemActiveNarrow = __webpack_require__(2545);

var _primaryMenuItemActiveNarrow2 = _interopRequireDefault(_primaryMenuItemActiveNarrow);

var _rpMqBreakpoints = __webpack_require__(66);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpAnalytics = __webpack_require__(59);

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _rpUtils = __webpack_require__(288);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Primary Menu
 * @augments CommonMenu
 * @constructor
 */
function PrimaryMenu() {
    _commonMenu2.default.prototype.constructor.apply(this, arguments);

    this.activeItemNarrow = new _primaryMenuItemActiveNarrow2.default('#primaryCurrent');

    this.itemBuilder = new _primaryMenuItemBuilder2.default();
    this.itemSelector = '.rn-primaryNav__item';

    this.moreItemSelector = '#primaryMoreItem';
    this.moreItemLinkSelector = '#primaryMoreLink';

    this.hamburgerMenuButtonTabletSelector = '#userMenuBtnTablet';

    this.$moreItem = (0, _jquery2.default)(this.moreItemSelector);
    this.$moreItemLink = (0, _jquery2.default)(this.moreItemLinkSelector);

    this.$secondaryPointer = (0, _jquery2.default)('.rn-secondaryNav__pointer');
    this.$hamburgerMenuButton = (0, _jquery2.default)('#userMenuBtn');
    this.$hamburgerMenu = (0, _jquery2.default)('#hamburgerMenu');
    this.$hamburgerMenuNextRaceItem = (0, _jquery2.default)('#hamburgerMenu-nextRaceItem');
    this.$hamburgerMenuNextRaceLink = (0, _jquery2.default)('.js-nextRaceLink');
    this.$hamburgerMenuNextRaceSpanUnavailable = (0, _jquery2.default)('.js-nextRaceSpanUnavailable');
    this.$hamburgerMenuNextRaceTimeLeft = (0, _jquery2.default)('.js-nextRaceTimeLeft');
    this.$hamburgerMenuNextRaceTimeAndCourse = (0, _jquery2.default)('.js-nextRaceTimeAndCourse');
    this.$freeBetsAnchors = (0, _jquery2.default)('.freeBets__Anchor');

    this.$popover = (0, _jquery2.default)('.rn-primaryNav__popover');
    this.$popoverList = (0, _jquery2.default)('.rn-primaryNav__popover__list');
    this.$parent = (0, _jquery2.default)('body');
    this.$overlay = (0, _jquery2.default)('<div class="ui-overlay" />');
    this.$overlayFrom = (0, _jquery2.default)('<body>');

    this.itemClassPreRender = 'rn-primaryNav__item_preRender';
    this.primaryActiveClass = 'rn-primaryNav_active';
    this.hamburgerMenuActiveClass = 'rn-hamburgerMenu--active';
    this.hamburgerMenuLinkHiddenClass = 'rn-hamburgerMenu__link--hidden';

    this.primaryNavMoreLinkActiveClass = 'rn-primaryNav__more__link--active';
    this.btnMajorClass = 'ui-btn_primary';
    this.linkUiClass = 'ui-link';
    this.morePopoverClass = 'rn-primaryNav__popover_active';
    this.isAnchorInNavigation = 'freeBets__Anchor--in-navigation';

    this.firstClickPrimary = false;
    this.openedPrimary = false;
    this.firstClickMore = false;
    this.openedMore = false;

    this.init();
} /* eslint-disable prefer-arrow-callback */
/**
 * @module navigation/primaryMenu
 * @requires module: navigation/commonMenu
 * @requires module: navigation/primaryMenuItemBuilder
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

PrimaryMenu.prototype = (0, _create2.default)(_commonMenu2.default.prototype);

/**
 * @inheritdoc
 */
PrimaryMenu.prototype.setActiveItem = function (menuItem) {
    /**
     * Deactivate previously active item
     */
    var activeItem = this.getActiveItem();
    if (activeItem) {
        activeItem.isActive = false;
        activeItem.render();
    }

    /**
     * Skip "More" item, just change a position of pointer
     */
    if (menuItem.$obj.is(this.moreItemSelector)) {
        this.getNavigationContainer().trigger('changePointerPosition.secondaryNav', this._getItemPointerPosition(this.$moreItem));
        return this;
    }

    /**
     * Mark item to active after next render
     */
    _commonMenu2.default.prototype.setActiveItem.call(this, menuItem);

    /**
     * Apply changes to DOM
     */
    menuItem.render();

    this._changeSecondaryPointerPosition();

    return this;
};

/**
 * Bind events
 * @private
 */
PrimaryMenu.prototype._bindEvents = function () {
    var self = this;

    (0, _jquery2.default)(document).ready(this._onDocumentReadyHandler());

    (0, _jquery2.default)(window).on('load', this._onWindowLoadHandler()).on('orientationchange', this._onWindowResizeHandler()).resize(this._onWindowResizeHandler()).on('rpBreakpointsSwitch', this._onSwitchBreakpointsHandler()).on('scroll', this._onWindowScrollHandler());

    (0, _jquery2.default)('.rn-primaryNav').on('click', function (event) {
        var $target = (0, _jquery2.default)(event.target);
        if ($target.hasClass('rn-primaryNav__label')) {
            // eslint-disable-next-line max-len
            segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, $target.text().trim())).then(function () {
                console.log($target.text().trim());
            });
        }
    });

    this.$hamburgerMenuButton.on('click touchstart', function (event) {
        event.preventDefault();
        if (!self.openedPrimary) {
            self.firstClickPrimary = true;
            self._openHamburgerMenu();
        }
    });

    /**
     * Bind topMenu click tracking event on link
     */
    (0, _jquery2.default)('.rn-topMenu__item').on('click', function (event) {
        var currentTargetTextSection = (0, _jquery2.default)(event.currentTarget).attr('data-text');

        segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, currentTargetTextSection));
    });

    /**
     * Bind topMenu click tracking event on link
     */
    (0, _jquery2.default)('.rn-primaryNavMobile__link').on('click', function (event) {
        var currentTargetTextSection = (0, _jquery2.default)(event.currentTarget).attr('data-text');

        segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, currentTargetTextSection));
    });

    /**
     * Bind hamburger click tracking.
     */
    (0, _jquery2.default)('.rn-hamburgerMenu').on('click', function (event) {
        var $target = (0, _jquery2.default)(event.target);
        // eslint-disable-next-line max-len
        if ($target.hasClass('rn-hamburgerMenu__link') && $target.parent().attr('id') !== 'hamburgerMenu-moreItem') {
            // eslint-disable-next-line max-len
            segmentio.trackNavigationClick((0, _defineProperty3.default)({}, segmentio.TRAIT_SELECTION, $target.text().trim())).then(function () {
                console.log($target.text().trim());
            });
        }
    });

    this.$obj.on('click touchstart', this.hamburgerMenuButtonTabletSelector, function (event) {
        event.preventDefault();
        if (!self.openedPrimary) {
            self.firstClickPrimary = true;
            self._openHamburgerMenu();
        }
    });

    this.$obj.on('click touchstart', this.moreItemLinkSelector, function (event) {
        event.preventDefault();
        if (!self.openedMore) {
            self.firstClickMore = true;
            self._openMorePopover();
        }
    });

    this._startMenuSizeTracking();
    this.freeBets();
};

PrimaryMenu.prototype._startMenuSizeTracking = function () {
    var _this = this;

    var handler = this._onWindowResizeHandler();
    var width = this.$obj.width();
    this.interval = setInterval(function () {
        var newWidth = _this.$obj.width();
        if (newWidth !== width) {
            handler();
            width = newWidth;
        }
    }, 50);
};

PrimaryMenu.prototype._stopMenuSizeTracking = function () {
    clearInterval(this.interval);
    this.interval = null;
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onDocumentReadyHandler = function () {
    var self = this;

    self._hamburgerMenuNextRace();

    return function () {
        self.render();

        self.updatePrimaryNavItems();
        self.updateHamburgerMenuItems();
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onWindowLoadHandler = function () {
    var self = this;

    return function () {
        self.render();
        self._restoreOverflow();
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onWindowResizeHandler = function () {
    var self = this;

    return function (event) {
        self._changeSecondaryPointerPosition.call(self, event);
        self.render();
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onSwitchBreakpointsHandler = function () {
    var self = this;

    return function (event) {
        var breakpointCode = event.detail.breakpoint.code;

        if (self.openedPrimary) {
            self._positionOverlay();
        }

        if (!['xn', 'n'].includes(breakpointCode)) {
            if (self.openedPrimary) {
                self._closeHamburgerMenu();
            }

            self._renderMoreMenu();
        }

        if (self.openedMore && ['xn', 'n'].includes(breakpointCode)) {
            self._closeMorePopover();
        }
    };
};

/**
 * @returns {Function}
 * @private
 */
PrimaryMenu.prototype._onWindowScrollHandler = function () {
    var self = this;
    return function () {
        if (self.openedPrimary) {
            self._positionOverlay();
        }
    };
};

/**
 * @inheritdoc
 */
PrimaryMenu.prototype.render = function () {
    this.getRenderedItems().removeClass(this.itemClassPreRender);

    _commonMenu2.default.prototype.render.apply(this, arguments);

    if (!['xn', 'n'].includes(_rpMqBreakpoints2.default.current().code)) {
        this._renderMoreMenu();
    }
};

/**
 * Get current visible items number
 * Show items, which fits actual container width
 * Move items, which doesn't fit actual container width, into the 'More' popover
 * Bind click handler to 'More' link
 * @private
 */
PrimaryMenu.prototype._renderMoreMenu = function () {
    var _this2 = this;

    var containerWidth = this.$obj.outerWidth();
    var itemsWidth = 0;
    var moreItems = [];

    this.items.forEach(function (item) {
        var width = item.getItemWidth();
        if (width === 0 || item.$obj.is(_this2.moreItemSelector)) {
            return false;
        }

        itemsWidth += width;
        if (itemsWidth >= containerWidth - _this2.$moreItem.outerWidth()) {
            moreItems.push(item.$obj);
        }
    });

    if (itemsWidth >= containerWidth) {
        this.$popoverList.append(moreItems);
    }

    if (this.$popoverList.find('li').length === 0) {
        this.$moreItem.detach();
    }

    this._changeSecondaryPointerPosition();
};

/**
 * Remove overflow hidden for primary menu container
 * @private
 */
PrimaryMenu.prototype._restoreOverflow = function () {
    this.$obj.addClass('rn-primaryNav_ready');
};

/**
 * Close Primary Navigation Hamburger Menu
 * @private
 */
PrimaryMenu.prototype._closeHamburgerMenu = function () {
    this.$obj.removeClass(this.primaryActiveClass);
    this.$hamburgerMenu.removeClass(this.hamburgerMenuActiveClass);
    (0, _jquery2.default)('html').css({
        'overflow-y': 'auto'
    });

    this.$overlay.remove();
    this.openedPrimary = false;

    (0, _jquery2.default)(document).off('click touchstart', '.ui-overlay');
};

/**
 * Opens Primary Navigation popover on exNarrow and narrow breakpoints
 * @private
 */
PrimaryMenu.prototype._openHamburgerMenu = function () {
    if (this.openedPrimary) {
        return;
    }
    this.$hamburgerMenu.addClass(this.hamburgerMenuActiveClass);

    (0, _jquery2.default)('html').css({
        'overflow-y': 'hidden'
    });

    this.$obj.addClass(this.primaryActiveClass);

    this.$parent.append(this.$overlay);
    this.openedPrimary = true;
    this._positionOverlay();

    var self = this;
    (0, _jquery2.default)(document).on('click touchstart', '.ui-overlay', function () {
        if (self.firstClickPrimary) {
            self.firstClickPrimary = false;
        } else {
            self._closeHamburgerMenu();
        }
    });
};

/**
 * Change the data/state of next-race in hamburger menu
 * @private
 */
PrimaryMenu.prototype._hamburgerMenuNextRace = function () {
    var link = window.location.protocol + '//' + window.location.host + '/racecards/next-race-data';
    var self = this;

    _jquery2.default.ajax({
        type: 'GET',
        url: link,
        dataType: 'json',
        success: function success(res) {
            var time_left_lable = res.time_left_lable,
                course_style_name = res.course_style_name,
                race_time = res.race_time,
                next_race_url = res.next_race_url;

            // next race URL is based on tab preference which is stored in localStorage

            var cardTabPrefCookie = localStorage.getItem('cdt_tab_pref');
            var cardTabToOpen = cardTabPrefCookie || 'free';
            var nextRaceUrl = cardTabToOpen === 'free' ? next_race_url + '/' : next_race_url + '/' + cardTabToOpen + '/';

            self.$hamburgerMenuNextRaceTimeLeft.text(time_left_lable);
            self.$hamburgerMenuNextRaceTimeAndCourse.text(race_time + ' ' + course_style_name);
            self.$hamburgerMenuNextRaceLink.attr('href', nextRaceUrl);
            self.$hamburgerMenuNextRaceSpanUnavailable.addClass(self.hamburgerMenuLinkHiddenClass);
            self.$hamburgerMenuNextRaceLink.removeClass(self.hamburgerMenuLinkHiddenClass);
        }
    });
};

/**
 * @private
 */
PrimaryMenu.prototype._positionOverlay = function () {
    this.$overlay.position({
        my: 'left top',
        at: 'left bottom',
        of: this.$overlayFrom.eq(0)
    });
};

/**
 * @private
 * @param {jQuery} $item
 * @returns {int}
 */
PrimaryMenu.prototype._getItemPointerPosition = function ($item) {
    return $item.offset().left + $item.outerWidth() / 2;
};

/**
 * @private
 */
PrimaryMenu.prototype._changeSecondaryPointerPosition = function () {
    if (!this.$secondaryPointer.is(':visible') || !this.getActiveItem()) {
        return;
    }

    var $currentItem = this.getActiveItem().$obj.children();

    if ($currentItem.closest(this.moreItemSelector).length !== 0) {
        $currentItem = this.$moreItem;
    }

    this.getNavigationContainer().trigger('changePointerPosition.secondaryNav', this._getItemPointerPosition($currentItem));
};

/**
 * Show 'More Sites' popover
 * Change appropriate classes for 'More' button
 * Bind click handler to elements outside the popover
 * @private
 */
PrimaryMenu.prototype._openMorePopover = function () {
    if (this.openedMore) {
        return;
    }

    this._restoreOverflow();

    this.$popover.addClass(this.morePopoverClass);
    this.$moreItemLink.addClass(this.primaryNavMoreLinkActiveClass).removeClass(this.linkUiClass);
    this.openedMore = true;

    (0, _jquery2.default)(document).on('click.rp.navigation.more touchstart.rp.navigation.more', this._onClickNavigationMoreHandler());
};

PrimaryMenu.prototype._onClickNavigationMoreHandler = function () {
    var self = this;

    return function (event) {
        if (self.firstClickMore) {
            self.firstClickMore = false;
        } else if (!self.$popover[0].contains(event.target)) {
            self._closeMorePopover();
        }
    };
};

PrimaryMenu.prototype.freeBets = function () {
    var _this3 = this;

    this.$freeBetsAnchors.each(function (_idx, el) {
        var $el = (0, _jquery2.default)(el);

        $el.on('click', function () {
            if ($el.hasClass(_this3.isAnchorInNavigation)) {
                segmentio.trackFreeBetsTap({});
            }
        });
    });
};

/**
 * Hide 'More Sites' popover
 * Change appropriate classes for 'More' button
 * Unbind click handler from elements outside the popover
 * @private
 */
PrimaryMenu.prototype._closeMorePopover = function () {
    this.$popover.removeClass(this.morePopoverClass);
    this.$moreItemLink.removeClass(this.primaryNavMoreLinkActiveClass).addClass(this.linkUiClass);
    this.openedMore = false;

    (0, _jquery2.default)(document).unbind('.rp.navigation.more');
};

function validateId(value) {
    return value === null || value === 'null' || value === 'undefined' ? null : value;
}

function isValidUserData(userData) {
    if (!userData || !userData.userTraits || !(0, _keys2.default)(userData).length || !(0, _keys2.default)(userData.userTraits).length) {
        return false;
    }

    return true;
}

function getRoleLabelText(userRole) {
    var role = (userRole || '').toLowerCase();
    var roleLabelMap = {
        free: 'Free account',
        insights: 'Insights',
        essential: 'Insights',
        tipping: 'Tipping',
        ultimate: 'Ultimate'
    };
    return roleLabelMap[role] || '';
}

function updateSubscribeButton(subscribeButton, userRole, menuType) {
    if (!subscribeButton) return;

    var role = (userRole || '').toLowerCase();
    var userId = (0, _rpUtils.getUserId)();
    var parentLink = subscribeButton.closest('a');

    if (!validateId(userId) && menuType === 'hamburger' || role === 'ultimate') {
        subscribeButton.style.display = 'none';

        return;
    }

    subscribeButton.style.display = 'inline-block';

    var upgradeRoles = ['insights', 'essential', 'tipping'];
    if (upgradeRoles.includes(role)) {
        subscribeButton.textContent = 'Upgrade';
        if (parentLink) parentLink.href = '/subscriptions/my-account/#tab=subscriptions';
    } else {
        subscribeButton.textContent = 'Subscribe';
        if (parentLink) parentLink.href = '/subscriptions/';
    }
}

function updateRoleLabel(plusIconSelector, labelClassName, userRole) {
    var plusIcons = document.querySelectorAll(plusIconSelector);
    var labelText = getRoleLabelText(userRole);

    plusIcons.forEach(function (img) {
        var nextEl = img.nextElementSibling;
        if (nextEl && nextEl.classList.contains(labelClassName)) {
            nextEl.remove();
        }

        if (!userRole) {
            img.style.display = 'none';
            return;
        }

        var roleLabel = document.createElement('span');
        roleLabel.className = labelClassName;
        roleLabel.textContent = labelText;
        img.insertAdjacentElement('afterend', roleLabel);

        if (userRole.toLowerCase() === 'free') {
            img.style.display = 'none';
            if (img.nextElementSibling) {
                img.nextElementSibling.classList.add('noLeftPadding');
            }
        } else {
            img.style.display = 'inline-block';
        }
    });
}

PrimaryMenu.prototype.updatePrimaryNavItems = function () {
    var padlockIcons = document.querySelectorAll('[data-padlock]');
    var subscribeButton = document.querySelector('.menu-subscribe-button');
    var plusIcons = document.querySelectorAll('.racing-post-plus-icon');

    (0, _rpUtils.getUserMetaData)().then(function (userData) {
        if (!isValidUserData(userData)) {
            plusIcons.forEach(function (img) {
                return img.style.display = 'none';
            });
            padlockIcons.forEach(function (img) {
                return img.style.display = 'none';
            });
            if (subscribeButton) subscribeButton.classList.add('noLeftMargin');
            return;
        }

        var userRole = userData ? userData.userTraits.auth_role : null;
        var role = (userRole || '').toLowerCase();

        if (!role) {
            plusIcons.forEach(function (img) {
                return img.style.display = 'none';
            });
            padlockIcons.forEach(function (img) {
                return img.style.display = 'none';
            });
            document.querySelectorAll('.user-role-label').forEach(function (label) {
                label.style.display = 'none';
                label.style.textDecoration = 'none';
            });
            if (subscribeButton) subscribeButton.classList.add('noLeftMargin');
            return;
        }

        updateSubscribeButton(subscribeButton, role, 'primary');
        updateRoleLabel('.racing-post-plus-icon', 'user-role-label', role);

        var plusIcon = document.querySelector('.racing-post-plus-icon');

        if (plusIcon) {
            var label = plusIcon.nextElementSibling;

            if (role === 'free') {
                plusIcon.style.display = 'none';
                if (label) label.classList.add('noLeftPadding');
            } else {
                if (role === 'ultimate' && label) label.classList.add('noRightPadding');
                plusIcon.style.display = 'inline-block';
                updateRoleLabel('.racing-post-plus-icon', 'user-role-label', userRole);
            }
        }

        padlockIcons.forEach(function (img) {
            if (!role) {
                img.style.display = 'none';
                return;
            }

            img.style.display = 'inline-block';
            var isHorseTracker = img.classList.contains('horse-tracker-padlock');
            if (isHorseTracker) {
                img.src = ['essential', 'insights', 'ultimate'].includes(role) ? '/svgs/padlock_unlocked.svg' : '/svgs/padlock_locked.svg';
            } else {
                img.src = role === 'ultimate' ? '/svgs/padlock_unlocked.svg' : '/svgs/padlock_locked.svg';
            }
        });
    }).catch(function (error) {
        console.error('Error fetching user metadata in updatePrimaryNavItems:', error);

        plusIcons.forEach(function (img) {
            return img.style.display = 'none';
        });
        padlockIcons.forEach(function (img) {
            return img.style.display = 'none';
        });
        document.querySelectorAll('.user-role-label').forEach(function (label) {
            label.style.display = 'none';
            label.style.textDecoration = 'none';
        });
        if (subscribeButton) subscribeButton.classList.add('noLeftMargin');
    });
};

PrimaryMenu.prototype.updateHamburgerMenuItems = function () {
    var userId = (0, _rpUtils.getUserId)();

    var freeBetsItem = document.querySelector('#free-bets-item');
    var subscribeItem = document.querySelector('#subscribe-item');

    if (freeBetsItem && subscribeItem) {
        if (validateId(userId)) {
            freeBetsItem.style.display = 'none';
            subscribeItem.style.display = 'flex';
        } else {
            freeBetsItem.style.display = 'block';
            subscribeItem.style.display = 'none';
        }
    }

    (0, _rpUtils.getUserMetaData)().then(function (userData) {
        var userRole = userData ? userData.userTraits.auth_role : null;
        var role = (userRole || '').toLowerCase();

        if (!role && subscribeItem) {
            subscribeItem.style.display = 'none';
        } else if (subscribeItem) {
            subscribeItem.style.display = 'flex';
        }

        // eslint-disable-next-line max-len
        var subscribeButtonHamburger = document.querySelector('.menu-subscribe-button-hamburger');
        updateSubscribeButton(subscribeButtonHamburger, userRole, 'hamburger');

        // eslint-disable-next-line max-len
        updateRoleLabel('.racing-post-plus-icon-hamburger', 'user-role-label-hamburger', userRole);

        var plusIconHamburger = document.querySelector('.racing-post-plus-icon-hamburger');
        if (role === 'free' && plusIconHamburger) {
            plusIconHamburger.style.display = 'none';
        } else if (plusIconHamburger) {
            plusIconHamburger.style.display = 'inline-block';
        }

        if (subscribeItem && role === 'ultimate') {
            var navLink = subscribeItem.querySelector('a');
            if (navLink) {
                navLink.removeAttribute('href');
                navLink.style.cursor = 'default';
                navLink.style.pointerEvents = 'none';
            }
        }

        var padlockIcons = document.querySelectorAll('[data-padlock]');
        padlockIcons.forEach(function (img) {
            if (!role) {
                img.style.display = 'none';
            } else {
                img.style.display = 'inline-block';
                var isHorseTracker = img.classList.contains('horse-tracker-padlock');
                img.src = (isHorseTracker ? ['essential', 'insights', 'ultimate'].includes(role) : role === 'ultimate') ? '/svgs/padlock_unlocked.svg' : '/svgs/padlock_locked.svg';
                img.alt = role === 'ultimate' ? 'Unlocked icon' : 'Locked icon';
            }
        });
    }).catch(function (error) {
        console.error(error);

        if (subscribeItem) subscribeItem.style.display = 'none';
        document.querySelectorAll('[data-padlock]').forEach(function (img) {
            img.style.display = 'none';
        });
    });
};

exports.default = PrimaryMenu;

/***/ }),
/* 2544 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * @module navigation/primaryMenuItem
 * @requires module: navigation/commonMenuItem
 * @requires module: navigation/menuStateManager
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */



/**
 * @type {CommonMenuItem}
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = __webpack_require__(54);

var _create2 = _interopRequireDefault(_create);

var _commonMenuItem = __webpack_require__(578);

var _commonMenuItem2 = _interopRequireDefault(_commonMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Primary Menu Item
 * @augments CommonMenuItem
 * @constructor
 */
function PrimaryMenuItem() {
  _commonMenuItem2.default.prototype.constructor.apply(this, arguments);
}
PrimaryMenuItem.prototype = (0, _create2.default)(_commonMenuItem2.default.prototype);

/**
 * Get width of inner item element
 * @protected
 * @returns {number}
 */
PrimaryMenuItem.prototype.getItemWidth = function () {
  return this.$obj.get(0).offsetWidth;
};

exports.default = PrimaryMenuItem;

/***/ }),
/* 2545 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = __webpack_require__(54);

var _create2 = _interopRequireDefault(_create);

var _commonMenuItemActiveNarrow = __webpack_require__(579);

var _commonMenuItemActiveNarrow2 = _interopRequireDefault(_commonMenuItemActiveNarrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Active menu item for N and XN breakpoints
 * @constructor
 */
function PrimaryMenuItemActiveNarrow() {
  _commonMenuItemActiveNarrow2.default.prototype.constructor.apply(this, arguments);
} /**
   * @module navigation/primaryMenuItemActiveNarrow
   * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
   */

PrimaryMenuItemActiveNarrow.prototype = (0, _create2.default)(_commonMenuItemActiveNarrow2.default.prototype);

exports.default = PrimaryMenuItemActiveNarrow;

/***/ }),
/* 2546 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = __webpack_require__(54);

var _create2 = _interopRequireDefault(_create);

var _commonMenuItemBuilder = __webpack_require__(987);

var _commonMenuItemBuilder2 = _interopRequireDefault(_commonMenuItemBuilder);

var _primaryMenuItem = __webpack_require__(2544);

var _primaryMenuItem2 = _interopRequireDefault(_primaryMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Primary Menu Item builder
 * @augments CommonMenuItemBuilder
 * @constructor
 */
/**
 * @module navigation/primaryMenuItemBuilder
 * @requires module: navigation/commonMenuItemBuilder
 * @requires module: navigation/primaryMenuItem
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function PrimaryMenuItemBuilder() {
  _commonMenuItemBuilder2.default.prototype.constructor.apply(this, arguments);

  this.ItemConstructor = _primaryMenuItem2.default;
  this.activeClass = 'ui-link_selected';

  this.outerClass = 'rn-primaryNav__item';
  this.innerClass = 'rn-primaryNav__link ui-link';
}
PrimaryMenuItemBuilder.prototype = (0, _create2.default)(_commonMenuItemBuilder2.default.prototype);

exports.default = PrimaryMenuItemBuilder;

/***/ }),
/* 2547 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getIterator2 = __webpack_require__(411);

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _create = __webpack_require__(54);

var _create2 = _interopRequireDefault(_create);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _commonMenu = __webpack_require__(986);

var _commonMenu2 = _interopRequireDefault(_commonMenu);

var _secondaryMenuItemBuilder = __webpack_require__(2550);

var _secondaryMenuItemBuilder2 = _interopRequireDefault(_secondaryMenuItemBuilder);

var _secondaryMenuItemActiveNarrow = __webpack_require__(2549);

var _secondaryMenuItemActiveNarrow2 = _interopRequireDefault(_secondaryMenuItemActiveNarrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Secondary Menu
 * @augments CommonMenu
 * @constructor
 */
/**
 * @module navigation/secondaryMenu
 * @requires module: navigation/commonMenu
 * @requires module: navigation/secondaryMenuItemBuilder
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function SecondaryMenu() {
    _commonMenu2.default.prototype.constructor.apply(this, arguments);

    this.activeItemNarrow = new _secondaryMenuItemActiveNarrow2.default('#secondaryCurrent');

    this.itemBuilder = new _secondaryMenuItemBuilder2.default();
    this.itemSelector = '.rn-secondaryNav__list__item';

    this.$outerObj = (0, _jquery2.default)('.rn-secondaryNav');
    this.$navPointer = (0, _jquery2.default)('.rn-secondaryNav__pointer');
    this.$select = (0, _jquery2.default)('.rn-secondaryNav__select');
    this.$close = (0, _jquery2.default)('.rn-secondaryNav__close');
    this.$parent = (0, _jquery2.default)('body');
    this.$overlay = (0, _jquery2.default)('<div class="ui-overlay" />');
    this.$overlayFrom = (0, _jquery2.default)('.rn-menuBar');

    this.secondaryPointerPreRender = 'rn-secondaryNav__pointer_preRender';
    this.secondaryActiveClass = 'rn-secondaryNav_active';
    this.openedSecondary = false;
    this.firstClickSecondary = false;

    this.init();
}
SecondaryMenu.prototype = (0, _create2.default)(_commonMenu2.default.prototype);

SecondaryMenu.prototype._bindEvents = function () {
    this._showHiddenActiveElement();
};

/**
 * @returns {Function}
 * @private
 */
SecondaryMenu.prototype._showHiddenActiveElement = function () {
    $(document).on('ready', function () {
        if (!(0, _jquery2.default)('.rn-secondaryNav')[0]) {
            return false;
        }

        var activeItem = (0, _jquery2.default)('.rn-secondaryNav__list__link.ui-link.ui-link_marked')[0];

        if (!activeItem) {
            var targetNode = (0, _jquery2.default)('.rn-secondaryNav')[0];
            var config = { attributes: false, childList: true, subtree: true };

            // Callback function to execute when mutations are observed
            var callback = function callback(mutationList, observer) {
                var _iteratorNormalCompletion = true;
                var _didIteratorError = false;
                var _iteratorError = undefined;

                try {
                    for (var _iterator = (0, _getIterator3.default)(mutationList), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                        var mutation = _step.value;

                        if (mutation.type === 'childList') {
                            var renderedActiveItem = (0, _jquery2.default)('.rn-secondaryNav__list__link.ui-link.ui-link_marked')[0];
                            // There is a bug. Tomorrow is not marked as active
                            if (renderedActiveItem) {
                                renderedActiveItem.scrollIntoView({
                                    behavior: 'smooth',
                                    block: 'center',
                                    inline: 'nearest'
                                });
                                observer.disconnect();
                            }
                        }
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally {
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return) {
                            _iterator.return();
                        }
                    } finally {
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };

            var observer = new MutationObserver(callback);

            observer.observe(targetNode, config);
        } else {
            activeItem.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        }
    });
};

/**
 * @inheritdoc
 */
SecondaryMenu.prototype.render = function () {
    _commonMenu2.default.prototype.render.apply(this, arguments);
};

exports.default = SecondaryMenu;

/***/ }),
/* 2548 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = __webpack_require__(54);

var _create2 = _interopRequireDefault(_create);

var _commonMenuItem = __webpack_require__(578);

var _commonMenuItem2 = _interopRequireDefault(_commonMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Secondary Menu Item
 * @constructor
 */
function SecondaryMenuItem() {
  _commonMenuItem2.default.prototype.constructor.apply(this, arguments);
} /**
   * @module navigation/secondaryMenuItem
   * @requires module: navigation/commonMenuItem
   * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
   */

SecondaryMenuItem.prototype = (0, _create2.default)(_commonMenuItem2.default.prototype);

exports.default = SecondaryMenuItem;

/***/ }),
/* 2549 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = __webpack_require__(54);

var _create2 = _interopRequireDefault(_create);

var _commonMenuItemActiveNarrow = __webpack_require__(579);

var _commonMenuItemActiveNarrow2 = _interopRequireDefault(_commonMenuItemActiveNarrow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Active menu item for N and XN breakpoints
 * @constructor
 */
function SecondaryMenuItemActiveNarrow() {
  _commonMenuItemActiveNarrow2.default.prototype.constructor.apply(this, arguments);
} /**
   * @module navigation/secondaryMenuItemActiveNarrow
   * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
   */

SecondaryMenuItemActiveNarrow.prototype = (0, _create2.default)(_commonMenuItemActiveNarrow2.default.prototype);

/**
 * Set item's title
 * @param {String} title
 */
SecondaryMenuItemActiveNarrow.prototype.setTitle = function (title) {
  this.$obj.find('span:first-child').text(title);
};

exports.default = SecondaryMenuItemActiveNarrow;

/***/ }),
/* 2550 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _create = __webpack_require__(54);

var _create2 = _interopRequireDefault(_create);

var _commonMenuItemBuilder = __webpack_require__(987);

var _commonMenuItemBuilder2 = _interopRequireDefault(_commonMenuItemBuilder);

var _secondaryMenuItem = __webpack_require__(2548);

var _secondaryMenuItem2 = _interopRequireDefault(_secondaryMenuItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Secondary Menu Item builder
 * @augments CommonMenuItemBuilder
 * @constructor
 */
/**
 * @module navigation/secondaryMenuItemBuilder
 * @requires module: navigation/commonMenuItemBuilder
 * @requires module: navigation/secondaryMenuItem
 * @author: Serhii Atiahin [serhii.atiahin@racingpost.com]
 */

function SecondaryMenuItemBuilder() {
  _commonMenuItemBuilder2.default.prototype.constructor.apply(this, arguments);

  this.ItemConstructor = _secondaryMenuItem2.default;
  this.activeClass = 'ui-link_marked';

  this.outerClass = 'rn-secondaryNav__list__item';
  this.innerClass = 'rn-secondaryNav__list__link ui-link';
}
SecondaryMenuItemBuilder.prototype = (0, _create2.default)(_commonMenuItemBuilder2.default.prototype);

exports.default = SecondaryMenuItemBuilder;

/***/ }),
/* 2551 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpMqBreakpoints = __webpack_require__(66);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initFreeBets = function initFreeBets(selector) {
    var link = (0, _jquery2.default)(selector);

    link.on('click', function () {
        if (!['xn', 'n'].includes(_rpMqBreakpoints2.default.current().code)) {
            link.attr('target', '_blank');
        } else {
            link.attr('target', '');
        }
    });
};

exports.default = initFreeBets;

/***/ }),
/* 2552 */,
/* 2553 */,
/* 2554 */,
/* 2555 */,
/* 2556 */,
/* 2557 */,
/* 2558 */,
/* 2559 */,
/* 2560 */,
/* 2561 */,
/* 2562 */,
/* 2563 */,
/* 2564 */,
/* 2565 */,
/* 2566 */,
/* 2567 */,
/* 2568 */,
/* 2569 */,
/* 2570 */,
/* 2571 */,
/* 2572 */,
/* 2573 */,
/* 2574 */,
/* 2575 */,
/* 2576 */,
/* 2577 */,
/* 2578 */,
/* 2579 */,
/* 2580 */,
/* 2581 */,
/* 2582 */,
/* 2583 */,
/* 2584 */,
/* 2585 */,
/* 2586 */,
/* 2587 */,
/* 2588 */,
/* 2589 */,
/* 2590 */,
/* 2591 */,
/* 2592 */,
/* 2593 */,
/* 2594 */,
/* 2595 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _rpUtils = __webpack_require__(288);

var _rpMqBreakpoints = __webpack_require__(66);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpDiffusionConnector = __webpack_require__(291);

var _rpDiffusionConnector2 = _interopRequireDefault(_rpDiffusionConnector);

var _DiffusionServiceUtils = __webpack_require__(229);

var _PricesStateStore = __webpack_require__(228);

var _DIFFUSION = __webpack_require__(384);

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _EVENTS = __webpack_require__(997);

var _EVENTS2 = _interopRequireDefault(_EVENTS);

var _PopOver2 = __webpack_require__(999);

var _PopOver3 = _interopRequireDefault(_PopOver2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /* eslint-disable max-len */

// eslint-disable-next-line import/no-extraneous-dependencies, import/no-unresolved


var narrowBreakpoints = [_rpMqBreakpoints.breakpointCodes.EXTRA_NARROW, _rpMqBreakpoints.breakpointCodes.NARROW];

var BestOddsPopOver = function (_PopOver) {
    _inherits(BestOddsPopOver, _PopOver);

    function BestOddsPopOver() {
        _classCallCheck(this, BestOddsPopOver);

        return _possibleConstructorReturn(this, (BestOddsPopOver.__proto__ || Object.getPrototypeOf(BestOddsPopOver)).apply(this, arguments));
    }

    _createClass(BestOddsPopOver, [{
        key: 'open',
        value: function open(e) {
            var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
            if (currentBookmaker !== '#BESTODDS') {
                return;
            }
            _get(BestOddsPopOver.prototype.__proto__ || Object.getPrototypeOf(BestOddsPopOver.prototype), 'open', this).call(this, e);
            (0, _jquery2.default)(window).on(_EVENTS2.default.RESIZE, this.config.onResizeHandler);
            (0, _jquery2.default)(window).on(_EVENTS2.default.SWITCH_BREAKPOINTS, this.config.onBreakpointChange);
        }
    }, {
        key: 'close',
        value: function close(e) {
            (0, _jquery2.default)(window).off(_EVENTS2.default.RESIZE, this.config.onResizeHandler);
            (0, _jquery2.default)(window).off(_EVENTS2.default.SWITCH_BREAKPOINTS, this.config.onBreakpointChange);
            _get(BestOddsPopOver.prototype.__proto__ || Object.getPrototypeOf(BestOddsPopOver.prototype), 'close', this).call(this, e);
        }
    }]);

    return BestOddsPopOver;
}(_PopOver3.default);

var defaultConfig = {
    bestOddsContainerSelector: '.js-bestOddsPriceContainer',
    diffusionConfigs: '.js-diffusionHorsesList',
    priceBtnOddsSelector: '.js-PC-bestOdds__priceBtn',
    activeBestOddsSelector: {
        popOver: '.js-PC-bestOdds',
        horseList: '.js-diffusionBestOdds',
        arrow: '.js-PC-bestOdds__arrow'
    },
    bestOddsArrowHiddenClass: 'PC-bestOdds__arrow_hidden',
    bestOddsArrowRight: 'PC-bestOdds__arrow_right',
    bestOddsArrowLeft: 'PC-bestOdds__arrow_left',
    noPointerClass: 'RC-runnerPrice_noPointer',
    bestOddsArrowHeight: 27,
    sideMarginInPx: 16,
    bestOddsArrowPositionInPx: {
        min: 7,
        max: 488
    },
    popOverConfig: {
        activeClass: 'PC-bestOdds_active',
        popOverSelector: '.js-PC-bestOdds',
        openAreaSelector: '.js-runnerPriceBestOdds',
        shadowAreaSelectors: '.PC-bestOddsOverlay',
        diffusionConfig: '.js-diffusionBestOdds',
        runnerName: '.js-bestOddsHorseName'
    }
};

var BestOdds = function () {
    function BestOdds(config) {
        _classCallCheck(this, BestOdds);

        this.config = _jquery2.default.extend(true, defaultConfig, config);

        if ((0, _rpDiffusionConnector.shouldEstablishSession)()) {
            this.init();
            // here we will store the bookmakers offers (tier1 and tier2) fetched from janus
            this.bookmakersOffers = [];
        }
    }

    _createClass(BestOdds, [{
        key: 'init',
        value: function init() {
            this.diffusionSession = new _rpDiffusionConnector2.default({
                onDataFunction: this.onDataReceive.bind(this)
            });

            this.showDecimalPrices = false;
            this.initOverlay();
            this.bindEvents();
            this.$bestOdds = (0, _jquery2.default)(this.config.popOverConfig.popOverSelector);
            this.$bestOddsParent = this.$bestOdds.parent();
            this.initPopover();
            this.fetchBookmakers();
        }
    }, {
        key: 'setBookmakersOpenAccountLinks',
        value: function setBookmakersOpenAccountLinks() {
            /**
             * With this function we set the open account links for the bookmakers
             * just need to have same html structure for the bestOdds like in the horse-tracker
             * bestOdds.volt file
             *
             * Then with this function we get the open account links rendered in the volt file
             * and manipulate them
             */
            if (this.bookmakersOffers.length === 0) {
                return;
            }

            var isMobile = window.innerWidth <= 720;

            var tier1Offers = isMobile ? this.bookmakersOffers.bookmakerOffersMobile : this.bookmakersOffers.bookmakerOffersDesktop;
            var tier2Offers = isMobile ? this.bookmakersOffers.bookmakerOffersTierTwoMobile : this.bookmakersOffers.bookmakerOffersTierTwoDesktop;

            var setOpenAccountLinks = function setOpenAccountLinks(elements, offers) {
                elements.each(function (index, el) {
                    var $el = $(el);
                    var bookieName = $el.data('bookie-name').toLowerCase();
                    if (!bookieName) return;

                    var offer = offers.find(function (o) {
                        return o.name.toLowerCase() === bookieName;
                    });
                    if (offer) {
                        // [JP-10331] for tote we use signUpLink8 rather than signUpLink3
                        if (bookieName === 'tote') {
                            if (offer.signUpLink8) {
                                $el.attr('href', offer.signUpLink8);
                            } else {
                                $el.hide();
                            }
                        } else if (offer.signUpLink3) {
                            $el.attr('href', offer.signUpLink3);
                        } else {
                            $el.hide();
                        }
                    }
                });
            };

            /**
             * for now we need manipulation for the open account links
             * for tier 2 only with the ticket JP-10331
             * but in the future we can use the same logic for tier 1
             *
             * const tier1OpenAccountLinks = $('.js-tier1-open-account-link');
             * setOpenAccountLinks(tier1OpenAccountLinks, [...tier1Offers, ...tier2Offers]);
             */

            var tier2OpenAccountLinks = $('.js-tier2-open-account-link');
            setOpenAccountLinks(tier2OpenAccountLinks, [].concat(_toConsumableArray(tier1Offers), _toConsumableArray(tier2Offers)));
        }
    }, {
        key: 'fetchBookmakers',
        value: function fetchBookmakers() {
            var _this2 = this;

            (0, _rpUtils.fetchBookmakersMixed)().then(function (bookmakersOffers) {
                _this2.bookmakersOffers = bookmakersOffers;
            });
        }
    }, {
        key: 'toggleOpenAccountLinksForTierTwo',
        value: function toggleOpenAccountLinksForTierTwo() {
            /**
             * on mobile we hide the open account links for tier 2
             */
            if (window.innerWidth <= 720) {
                (0, _jquery2.default)('.js-tier2-open-account-link').hide();
            } else {
                (0, _jquery2.default)('.js-tier2-open-account-link').show();
            }
        }
    }, {
        key: 'initOverlay',
        value: function initOverlay() {
            this.overlay = (0, _jquery2.default)('<div class="PC-bestOddsOverlay"></div>');
            (0, _jquery2.default)('body').append(this.overlay);
        }
    }, {
        key: 'initPopover',
        value: function initPopover() {
            var popoverOptions = this.getPopoverOptions();
            this.popOver = new BestOddsPopOver(popoverOptions);
        }
    }, {
        key: 'getPopoverOptions',
        value: function getPopoverOptions() {
            return {
                activeClass: this.config.popOverConfig.activeClass,
                popOverSelector: this.config.popOverConfig.popOverSelector,
                openAreaSelectors: [this.config.popOverConfig.openAreaSelector],
                closeAreaSelectors: [this.config.priceBtnOddsSelector, this.config.popOverConfig.shadowAreaSelectors],
                onOpen: this.onPopOverOpen.bind(this),
                onClose: this.onPopOverClose.bind(this),
                onResizeHandler: this.onResizeHandler.bind(this),
                onBreakpointChange: this.onBreakpointChange.bind(this)
            };
        }
    }, {
        key: 'onPopOverOpen',
        value: function onPopOverOpen(e) {
            this.overlay.show();
            this.prepareDiffusionData(e);
            this.pricesSubscribe();
            this.setOriginPrice(e.target);
            this.handleBestOddsPosition();
            this.toggleOpenAccountLinksForTierTwo();
            this.setBookmakersOpenAccountLinks();

            // eslint-disable-next-line array-callback-return
            (0, _jquery2.default)('.PC-bestOdds__bookieRow__name_account.ui-link').each(function (_, element) {
                var currentHref = element.getAttribute('href');

                if (!currentHref.includes('/redirect/')) {
                    var bookmakerRedirectUrl = '/redirect/?url=' + encodeURIComponent(currentHref) + '&name=' + element.getAttribute('bookmaker-name');
                    element.setAttribute('href', bookmakerRedirectUrl);
                }
            });
        }
    }, {
        key: 'onPopOverClose',
        value: function onPopOverClose() {
            // todo: add check - JP-10398
            // if (this.diffusionSession) {
            //     this.diffusionSession.unsubscribeAll();
            // }

            this.diffusionSession.unsubscribeAll();
            this.toggleOpenAccountLinksForTierTwo();
            this.clearPopUp();
            this.overlay.hide();
            this.$bestOdds.detach();
            this.$bestOddsParent.append(this.$bestOdds);
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            (0, _jquery2.default)(document).on(_EVENTS2.default.USER_SETTINGS_CHANGED, this.onUserSettingsChanged.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.DYNAMIC_PRICES_UPDATED, this.onDynamicsRunnersUpdate.bind(this));
            (0, _jquery2.default)(document).on(_EVENTS2.default.HORSES_LIST_CHANGED, this.onDynamicsRunnersUpdate.bind(this));
        }
    }, {
        key: 'onUserSettingsChanged',
        value: function onUserSettingsChanged(event, userSettings) {
            this.showDecimalPrices = userSettings.decimalOdds;
        }
    }, {
        key: 'onDynamicsRunnersUpdate',
        value: function onDynamicsRunnersUpdate() {
            this.popOver.destroy();
            this.initPopover();
        }
    }, {
        key: 'onDataReceive',
        value: function onDataReceive(webClientMessage) {
            var topic = webClientMessage.getTopic();

            if (topic.includes('#INFO')) {
                this.handleRaceInfo(webClientMessage);
            } else {
                this.handleHorsePrice(webClientMessage);
            }
        }
    }, {
        key: 'prepareDiffusionData',
        value: function prepareDiffusionData(event) {
            var $diffusionHorseListElem = (0, _jquery2.default)(event.target).closest(this.config.diffusionConfigs);
            var diffusionHorseName = $diffusionHorseListElem.attr(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME);
            var raceDate = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceDate($diffusionHorseListElem);
            var raceTime = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceTime($diffusionHorseListElem);
            var courseName = _DiffusionServiceUtils.diffusionServiceUtils.getTopicCourseName($diffusionHorseListElem);

            (0, _jquery2.default)(this.config.popOverConfig.runnerName).text(diffusionHorseName);
            var $diffusionBestOdds = (0, _jquery2.default)(this.config.popOverConfig.diffusionConfig);
            this.$bestOdds.detach();

            $diffusionBestOdds.attr(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME, diffusionHorseName).attr(_DIFFUSION2.default.DATA.INPUT.COURSE_NAME, courseName).attr(_DIFFUSION2.default.DATA.INPUT.RACE_TIME, raceTime).attr(_DIFFUSION2.default.DATA.INPUT.RACE_DATE, raceDate);

            var $priceContainer = (0, _jquery2.default)(event.target).closest(this.config.bestOddsContainerSelector);
            $priceContainer.append(this.$bestOdds);
        }
    }, {
        key: 'handleRaceInfo',
        value: function handleRaceInfo(WebClientMessage) {
            var raceInfo = _DiffusionServiceUtils.diffusionServiceUtils.parseInfoTopicData(WebClientMessage);

            this.renderEwInfo(raceInfo);
            _PricesStateStore.pricesStateStore.updateRaceInfo(raceInfo);
            if (raceInfo.suspendState === 'H') {
                this.updatePricesForRaceInfo(raceInfo.bookmaker);
            }
        }
    }, {
        key: 'handleHorsePrice',
        value: function handleHorsePrice(WebClientMessage) {
            var renderConfig = _DiffusionServiceUtils.diffusionServiceUtils.parsePriceTopicData(WebClientMessage);

            this.renderPrice(renderConfig);
        }
    }, {
        key: 'renderPrice',
        value: function renderPrice(renderConfig) {
            /** TODO: filter was used due to PhantomJS/Jasmine-jquery doesn't (JIRA: PC-4557)
             * support CSS selector search with data attributes
             */

            // const bookieContainerSelector = `[data-diffusion-bookmaker="${renderConfig}"]`;
            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver);
            var pricesContainer = popOver.find(this.config.popOverConfig.diffusionConfig);
            var bookieContainer = Array.prototype.filter.call(pricesContainer, function (el) {
                return el.dataset.diffusionBookmaker === renderConfig.bookmaker;
            });
            var priceButton = (0, _jquery2.default)(bookieContainer).find(this.config.priceBtnOddsSelector)[0];

            this.clearBestOddsPosition();

            if (priceButton) {
                var renderPriceValue = _DiffusionServiceUtils.diffusionServiceUtils.getDisplayedPriceValue(renderConfig);
                priceButton.innerHTML = renderPriceValue;
                if (renderPriceValue === '-') {
                    priceButton.classList.add(this.config.noPointerClass);
                } else {
                    priceButton.classList.remove(this.config.noPointerClass);
                }
                var raceInfo = _PricesStateStore.pricesStateStore.getRaceInfo(renderConfig);
                var dataDiffusionStatus = raceInfo && raceInfo.suspendState === 'H' ? 'H' : renderConfig.status;

                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, renderConfig.outcomersId);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, renderConfig.fractionalPrice);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, renderConfig.decimalPrice);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.STATUS, dataDiffusionStatus);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID, renderConfig.eventId);
                priceButton.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID, renderConfig.meetingId);

                bookieContainer[0].classList.add('PC-bestOdds__bookieRow_active');
                this.sortPrices(bookieContainer);
            }
            this.handleBestOddsPosition();
        }
    }, {
        key: 'sortPrices',
        value: function sortPrices(bookieRow) {
            var isMobile = window.innerWidth < 720;

            var bookieContainer = (0, _jquery2.default)(bookieRow).closest('.PC-bestOdds__bookiesList').find('.PC-bestOdds__bookieRow_active');

            if (bookieContainer.length === 0) {
                return;
            }

            var priceBtnOddsSelector = this.config.priceBtnOddsSelector;

            bookieContainer.toArray().map(function (item) {
                return {
                    bookie: item.getAttribute('data-diffusion-bookieName').toLowerCase(),
                    price: (0, _jquery2.default)(item).find(priceBtnOddsSelector).attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL),
                    element: item
                };
            }).sort(function (prev, next) {
                if (isMobile) {
                    if (prev.bookie === 'betfred') return 1;
                    if (next.bookie === 'betfred') return -1;
                }

                if (isNaN(prev.price) && isNaN(next.price) || prev.price === next.price) {
                    if (prev.bookie > next.bookie) return 1;
                    if (prev.bookie < next.bookie) return -1;
                    return 0;
                } else if (isNaN(prev.price)) {
                    return 1;
                } else if (isNaN(next.price)) {
                    return 0;
                }
                return next.price - prev.price;
            }).forEach(function (elem, index) {
                var bookieElement = elem.element;
                bookieElement.style.order = index;
            });
        }
    }, {
        key: 'pricesSubscribe',
        value: function pricesSubscribe() {
            var horsesList = (0, _jquery2.default)(this.config.activeBestOddsSelector.horseList).toArray();
            var topics = horsesList.map(function (horseElement) {
                var bookmaker = _DiffusionServiceUtils.diffusionServiceUtils.getTopicBookmaker(horseElement);
                var diffusionData = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(horseElement);

                return _extends(diffusionData, { bookmaker: bookmaker });
            }).map(function (diffusionData) {
                var priceTopic = _DiffusionServiceUtils.diffusionServiceUtils.createPriceTopic(diffusionData);
                var infoTopic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic(diffusionData);

                return [priceTopic, infoTopic];
            }).reduce(function (acum, value) {
                return acum.concat(value);
            }, []).filter(function (topic) {
                return topic;
            });

            if (this.diffusionSession) {
                this.diffusionSession.subscribe({ topics: topics });
            }
        }
    }, {
        key: 'renderEwInfo',
        value: function renderEwInfo(renderConfig) {
            /** TODO: filter was used due to PhantomJS/Jasmine-jquery doesn't (JIRA: PC-4557)
             * support CSS selector search with data attributes
             */

            // const bookieContainerSelector = `[data-diffusion-bookmaker="${renderConfig.bookmaker}"]`;

            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver);
            var pricesContainer = popOver.find(this.config.popOverConfig.diffusionConfig);
            var bookieContainer = (0, _jquery2.default)(Array.prototype.filter.call(pricesContainer, function (el) {
                return el.dataset.diffusionBookmaker === renderConfig.bookmaker;
            }));
            var ewElement = bookieContainer.find('.js-diffusionBestOdds_eachWay')[0];
            var bogElement = bookieContainer.find('.js-diffusionBestOdds_bog')[0];

            if (ewElement) {
                ewElement.innerHTML = renderConfig.isWinOnly ? '<b>win only</b>' : [renderConfig.winOdds, renderConfig.placeWinner].join(' ');
            }

            if (bogElement) {
                if (renderConfig.isBog === 'Y') {
                    bogElement.classList.add('PC-bestOdds__bookieRow__oddsIcon_active');
                } else {
                    bogElement.classList.remove('PC-bestOdds__bookieRow__oddsIcon_active');
                }
            }
        }
    }, {
        key: 'clearPopUp',
        value: function clearPopUp() {
            var _this3 = this;

            var diffusionRows = (0, _jquery2.default)(this.config.activeBestOddsSelector.horseList);

            Array.prototype.forEach.call(diffusionRows, function (element) {
                var priceBtn = (0, _jquery2.default)(element).find(_this3.config.priceBtnOddsSelector)[0];

                element.classList.remove('PC-bestOdds__bookieRow_active');

                _this3.renderEwInfo({
                    winOdds: '',
                    placeWinner: '',
                    isBog: 'N',
                    bookmaker: element.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER)
                });
                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, '');
                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, '');
                priceBtn.setAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, '');
                priceBtn.innerHTML = '';
            });
        }
    }, {
        key: 'handleBestOddsPosition',
        value: function handleBestOddsPosition() {
            var popOver = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver)[0];
            var popOverArrow = (0, _jquery2.default)(this.config.activeBestOddsSelector.arrow)[0];
            var windowHeight = window.innerHeight;
            var windowWidth = window.innerWidth;
            var bestOddsRect = popOver.getBoundingClientRect();
            var bestOddsArrowPositionMax = bestOddsRect.height - this.config.bestOddsArrowHeight;
            var $priceContainer = (0, _jquery2.default)(this.originPrice).closest(this.config.bestOddsContainerSelector);
            var priceContainerRect = $priceContainer.length ? $priceContainer[0].getBoundingClientRect() : null;
            var originPriceRect = this.originPrice.getBoundingClientRect();
            var targetContainerRect = priceContainerRect && priceContainerRect.width && priceContainerRect.height > originPriceRect.height ? priceContainerRect : originPriceRect;
            var isWideBreakpoint = narrowBreakpoints.indexOf(_rpMqBreakpoints2.default.current().code) === -1;

            var calculatedTop = -(bestOddsRect.height - targetContainerRect.height) / 2;
            var spaceToTop = targetContainerRect.top + calculatedTop;
            var spaceToBottom = windowHeight - (targetContainerRect.top + calculatedTop + bestOddsRect.height);
            var calculatedLeft = void 0;

            // Vertical Alignment

            if (spaceToTop < this.config.sideMarginInPx && spaceToBottom > this.config.sideMarginInPx) {
                calculatedTop = this.config.sideMarginInPx - targetContainerRect.top;
            } else if (spaceToBottom < this.config.sideMarginInPx && spaceToTop > this.config.sideMarginInPx) {
                calculatedTop = windowHeight - targetContainerRect.top - bestOddsRect.height - this.config.sideMarginInPx;
            }
            var arrowTop = -(calculatedTop - (targetContainerRect.height - this.config.bestOddsArrowHeight) / 2);

            // Arrow alignment
            if (arrowTop < this.config.bestOddsArrowPositionInPx.min || arrowTop > bestOddsArrowPositionMax) {
                popOverArrow.classList.add(this.config.bestOddsArrowHiddenClass);
            } else {
                popOverArrow.setAttribute('style', 'top:' + arrowTop + 'px');
            }
            // Horizontal alignment

            if (isWideBreakpoint) {
                calculatedLeft = targetContainerRect.width + 16;
            } else {
                calculatedLeft = (windowWidth - bestOddsRect.width) / 2 - targetContainerRect.left;
            }

            if (windowWidth < targetContainerRect.left + calculatedLeft + bestOddsRect.width + this.config.sideMarginInPx && isWideBreakpoint) {
                calculatedLeft = -(bestOddsRect.width + 16);
                popOverArrow.classList.add(this.config.bestOddsArrowRight);
            } else {
                popOverArrow.classList.add(this.config.bestOddsArrowLeft);
            }

            if (calculatedLeft) {
                popOver.setAttribute('style', 'top:' + calculatedTop + 'px; left:' + calculatedLeft + 'px');
            } else {
                popOver.setAttribute('style', 'top:' + calculatedTop + 'px');
            }
        }
    }, {
        key: 'clearBestOddsPosition',
        value: function clearBestOddsPosition() {
            var arrow = (0, _jquery2.default)(this.config.activeBestOddsSelector.arrow)[0];
            arrow.setAttribute('style', '');
            arrow.classList.remove(this.config.bestOddsArrowHiddenClass);
            arrow.classList.remove(this.config.bestOddsArrowRight);
            arrow.classList.remove(this.config.bestOddsArrowLeft);

            (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver)[0].setAttribute('style', '');
        }
    }, {
        key: 'onResizeHandler',
        value: function onResizeHandler() {
            this.clearBestOddsPosition();
            this.handleBestOddsPosition();
        }
    }, {
        key: 'onBreakpointChange',
        value: function onBreakpointChange() {
            this.popOver.close();
            this.toggleOpenAccountLinksForTierTwo();
        }
    }, {
        key: 'updatePricesForRaceInfo',
        value: function updatePricesForRaceInfo(bookmaker) {
            var _this4 = this;

            var bookieElements = (0, _jquery2.default)(this.config.activeBestOddsSelector.popOver).find(this.config.popOverConfig.diffusionConfig).toArray();

            bookieElements.filter(function (el) {
                return el.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER) === bookmaker;
            }).map(function (el) {
                return (0, _jquery2.default)(el).find(_this4.config.priceBtnOddsSelector)[0];
            }).forEach(function (el) {
                var priceInfo = _this4.getRenderConfigFromElement(el);
                var getRaceInfo = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(el);
                var renderConfig = _extends(priceInfo, getRaceInfo, { bookmaker: bookmaker });
                // TODO: clear is some esear way (JIRA: PC-4557)
                _this4.renderPrice(renderConfig);
            });
        }
        // TODO: move to private function or to utils (JIRA: PC-4559)
        /* eslint-disable class-methods-use-this */

    }, {
        key: 'getRenderConfigFromElement',
        value: function getRenderConfigFromElement(element) {
            return {
                outcomersId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID),
                fractionalPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL),
                decimalPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL),
                historyPrice: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.HISTORY),
                eventId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID),
                meetingId: element.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID)
            };
        }
        /* eslint-enable class-methods-use-this */

    }, {
        key: 'setOriginPrice',
        value: function setOriginPrice(newPrice) {
            this.originPriceElement = newPrice;
        }
    }, {
        key: 'originPrice',
        get: function get() {
            return this.originPriceElement;
        }
    }]);

    return BestOdds;
}();

exports.default = BestOdds;

/***/ }),
/* 2596 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _bookmakersMap;

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _jsCookie = __webpack_require__(192);

var _jsCookie2 = _interopRequireDefault(_jsCookie);

var _rpAnalytics = __webpack_require__(59);

var segmentio = _interopRequireWildcard(_rpAnalytics);

var _rpDiffusionConnector = __webpack_require__(291);

var _DiffusionServiceUtils = __webpack_require__(229);

var _ToteBookmakersNameMap = __webpack_require__(2604);

var _PricesStateStore = __webpack_require__(228);

var _DIFFUSION = __webpack_require__(384);

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _PreloadedStateHelper = __webpack_require__(584);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var nonIntegratedBookieList = {
    BOLEYSPORTS: {
        url: 'https://www.boylesports.com/Betslip/AddToBetslip?selId=[$outcomeId]&idfiacampaign=32667',
        width: 1000,
        height: 600,
        name: 'BOLEYSPORTS'
    },
    VC: {
        url: 'http://www.betvictor.com/sports/en/coupon/remotes?outcomeids=[[$outcomeId]00]&btagid=90081080',
        width: 986,
        height: 600,
        name: 'VC'
    },
    TOTE: {
        url: 'https://tote.co.uk/racecards/[$meeting-name]/today/[$time]/win?selections=[$selections]&utm_source=racingpost&utm_medium=partner-editoral&utm_campaign=oddsgrid&utm_content=odds-grid',
        width: 1050,
        height: 500,
        name: 'TOTE'
    },
    BETFRED: {
        url: 'https://www.betfred.com/affiliates?affiliate_id=101891&btag=113519&targeturl=https://www.betfred.com/external-betslip?selection=[$outcomeId]',
        width: 1050,
        height: 500,
        name: 'BETFRED'
    }
};

var bookmakersMap = (_bookmakersMap = {
    BET365: 'bet365',
    LADB: 'Ladbrokes',
    WH_OXI: 'William Hill',
    CORAL: 'Coral',
    PPWR: 'Paddy Power',
    BETFAIR: 'Betfair',
    VC: 'BetVictor'
}, _defineProperty(_bookmakersMap, _PreloadedStateHelper.skybetDiffusionName, 'Sky bet'), _defineProperty(_bookmakersMap, 'BOLEYSPORTS', 'Boylesport'), _defineProperty(_bookmakersMap, 'TOTE', 'Tote'), _defineProperty(_bookmakersMap, '#BESTODDS', 'Best Odds'), _bookmakersMap);

var LOCATION_DATA_ATTRIBUTE = 'data-price-location';
var RACE_ID_DATA_ATTRIBUTE = 'data-diffusion-race-id';
var DATA_RACE_DATE_TIME = 'data-card-race-date-time';
var DATA_DIFFUSION_RACE_TIME = 'data-diffusion-racetime';

function isPriceButtonClicked($priceElement) {
    var invalidPricePattern = /^[\s,\-,NR]{1,}$/;
    return $priceElement.length && !$priceElement.text().match(invalidPricePattern);
}

function getBookmakerName($priceElement) {
    var bookieRow = $priceElement.closest('[' + _DIFFUSION2.default.DATA.INPUT.BOOKMAKER + ']')[0];
    if (bookieRow) {
        var bookmaker = bookieRow.getAttribute(_DIFFUSION2.default.DATA.INPUT.BOOKMAKER);
        if (bookmaker) {
            return bookmaker;
        }
    }
    return _PricesStateStore.pricesStateStore.getCurrentBookmaker();
}

function isBookmakerIntegrated(bookmakerName) {
    return !!nonIntegratedBookieList[bookmakerName];
}

function setLocationfromURL() {
    var location = window.location.href;
    if (location.indexOf('horse-tracker') > -1) return 'Horse Tracker';

    if (location.indexOf('profile') > -1) {
        if (location.indexOf('horse') > -1) return 'Horse Profile';
        if (location.indexOf('jockey') > -1) return 'Jockey Profile';
        if (location.indexOf('owner') > -1) return 'Owner Profile';
        if (location.indexOf('trainer') > -1) return 'Trainer Profile';
    }

    if (location.indexOf('tipping') > -1) return 'Tipping Article';
    if (location.indexOf('news') > -1) return 'News Article';

    return 'Undefined location';
}

function trackBetButtonClickAnalytics(bookieName, location, selectionData) {
    var _config;

    var bookmaker = Object.prototype.hasOwnProperty.call(bookmakersMap, bookieName) ? bookmakersMap[bookieName] : bookieName;
    var trackLocation = void 0;

    if (location) {
        trackLocation = location;
    } else {
        trackLocation = setLocationfromURL();
    }

    var config = (_config = {}, _defineProperty(_config, segmentio.TRAIT_LOCATION, trackLocation), _defineProperty(_config, segmentio.TRAIT_BOOKMAKER, bookmaker), _defineProperty(_config, segmentio.TRAIT_PRICE, selectionData.priceType), _defineProperty(_config, segmentio.TRAIT_HORSE_NAME, selectionData.horseName), _config);

    segmentio.identify(undefined, config).then(function () {
        return segmentio.trackBetButtonClick(config);
    });
}

/* eslint-disable class-methods-use-this */

var BetHandler = function () {
    function BetHandler() {
        _classCallCheck(this, BetHandler);

        this.bindEvents();
    }

    _createClass(BetHandler, [{
        key: 'bindEvents',
        value: function bindEvents() {
            var $body = (0, _jquery2.default)('body');

            $body[0].addEventListener('click', this.makeSelectionHandler.bind(this), true, { once: true });
            $body.on('RC.makeSelection', this.makeSelection.bind(this));
        }
    }, {
        key: 'makeSelectionHandler',
        value: function makeSelectionHandler(event) {
            var $priceElement = (0, _jquery2.default)(event.target).closest('.js-betHandler');

            if (!(0, _rpDiffusionConnector.shouldEstablishSession)()) {
                return;
            }
            if (!isPriceButtonClicked($priceElement)) {
                return;
            }
            event.preventDefault();

            var horseElement = $priceElement.closest('.js-diffusionHorsesList')[0] || $priceElement.closest('.js-diffusionBestOdds')[0];
            var raceId = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(RACE_ID_DATA_ATTRIBUTE, horseElement);

            if (!raceId) {
                // eslint-disable-next-line no-console
                console.error('Making selection required parameter missing');
                return;
            }

            var id = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID);
            var fractionalPrice = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL);
            var decimalPrice = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL);
            var isSp = fractionalPrice === 'SP';
            var price = isSp ? null : fractionalPrice;
            var eventId = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID);
            var meetingId = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID);
            var marketId = $priceElement.attr(_DIFFUSION2.default.DATA.OUTPUT.MARKET_ID);
            var bookmaker = getBookmakerName($priceElement);

            var courseName = _DiffusionServiceUtils.diffusionServiceUtils.getTopicCourseName(horseElement);
            var horseName = horseElement.getAttribute(_DIFFUSION2.default.DATA.INPUT.HORSE_NAME);
            var raceTime = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceTime(horseElement);
            // eslint-disable-next-line max-len
            // data-card-race-date-time is not available for racecards index, so we're using diffusion racetime data-diffusion-racetime
            var dataRaceDateTime = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(DATA_RACE_DATE_TIME, horseElement) || _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(DATA_DIFFUSION_RACE_TIME, horseElement);
            var raceDate = _DiffusionServiceUtils.diffusionServiceUtils.getTopicRaceDate(horseElement);
            var location = _DiffusionServiceUtils.diffusionServiceUtils.getElementDataAttribute(LOCATION_DATA_ATTRIBUTE, horseElement);
            var userMD5 = _jsCookie2.default.get('RP_MD5_COOKIE');
            var topic = _DiffusionServiceUtils.diffusionServiceUtils.createInfoTopic({
                courseName: courseName,
                raceTime: raceTime,
                raceDate: raceDate,
                bookmaker: bookmaker
            });

            var startNumberElements = (0, _jquery2.default)('.RC-runnerNumber__no[data-horseName="' + horseName + '"]');
            // eslint-disable-next-line max-len
            var startNumber = startNumberElements.length ? Number(startNumberElements[0].innerHTML) : null;

            var getCourseName = courseName.toUpperCase();
            var getToteCourseName = getCourseName in _ToteBookmakersNameMap.toteCourseNameMapping ? _ToteBookmakersNameMap.toteCourseNameMapping[getCourseName] : courseName;
            var ToteTimeObj = new Date(dataRaceDateTime);
            var setToteRaceTime = void 0;
            // dateRaceTime comes as a HH:MM format from diffusion on racecards index, so no need to convert it
            if (!isNaN(ToteTimeObj)) {
                var formatMinutes = ToteTimeObj.getMinutes() < 10 ? '0' + ToteTimeObj.getMinutes() : ToteTimeObj.getMinutes();
                setToteRaceTime = ToteTimeObj.getHours() + ':' + formatMinutes;
            } else setToteRaceTime = raceTime;

            var selectionData = {
                selectionInfo: {
                    id: id,
                    price: price,
                    fractionalPrice: fractionalPrice,
                    decimalPrice: decimalPrice,
                    isSp: isSp,
                    eventId: eventId,
                    meetingId: meetingId,
                    marketId: marketId,
                    data: {
                        horseName: horseName,
                        courseName: courseName.toLowerCase(),
                        raceDate: raceDate,
                        time: raceTime,
                        eachWayTopic: topic,
                        infoTopic: topic,
                        raceId: raceId
                    },
                    toteUrlParams: {
                        horseName: horseName.replace(/[\W_]/g, '-').toLowerCase(),
                        courseName: getToteCourseName.replace(/[\W_]/g, '-').toLowerCase(),
                        time: setToteRaceTime,
                        startNumber: startNumber
                    }
                },
                bookieName: bookmaker,
                userMD5: userMD5,
                priceElement: $priceElement
            };
            this.makeSelection(event, selectionData);

            if ((0, _jquery2.default)(event.target).hasClass('added-to-betslip')) {
                var priceType = isSp ? 'SP' : 'Odds';

                trackBetButtonClickAnalytics(bookmaker, location, {
                    priceType: priceType,
                    horseName: horseName
                });
            }
        }
    }, {
        key: 'onNotIntegratedBookmakerSelected',
        value: function onNotIntegratedBookmakerSelected(data) {
            var bookieName = data.bookieName,
                _data$selectionInfo = data.selectionInfo,
                outcomersId = _data$selectionInfo.id,
                price = _data$selectionInfo.price,
                isSp = _data$selectionInfo.isSp,
                priceElement = data.priceElement;

            var notIntegratedBookmaker = nonIntegratedBookieList[bookieName];
            var dividend = '';
            var divider = '';
            if (!isSp) {
                var splitedPrice = price.split('/');
                dividend = splitedPrice[0];
                divider = splitedPrice[1];
            }

            var toteHorseName = data.selectionInfo.toteUrlParams.horseName;
            var toteCorseName = data.selectionInfo.toteUrlParams.courseName;
            var toteRaceTime = data.selectionInfo.toteUrlParams.time;
            var isOddsComparisonTable = window.location.href.split('/').indexOf('odds-comparison') > 0;
            var selections = data.selectionInfo.toteUrlParams.startNumber;
            // tote replacing are [$meeting-name]/[$time]/[$runner-name]/win'

            var url = notIntegratedBookmaker.url.replace('[$runner-name]', toteHorseName).replace('[$time]', toteRaceTime).replace('[$meeting-name]', toteCorseName).replace('[$selections]', selections).replace('[$outcomeId]', outcomersId).replace('[$dividend]', dividend).replace('[$divider]', divider).replace('[$price]', data.selectionInfo.price || '').replace('[$userMD5]', !data.userMD5 ? 'no_MD5_cookie' : data.userMD5).replace('[$eventId]', data.selectionInfo.eventId).replace('[$meetingId]', data.selectionInfo.meetingId).replace('[$utm_content]', isOddsComparisonTable ? 'oddscomparison' : 'racecardsodds');

            priceElement.attr('href', url).attr('data-popup-width', notIntegratedBookmaker.width).attr('data-popup-height', notIntegratedBookmaker.height).attr('data-popup-blank', true).addClass('js-popupLink');
        }
    }, {
        key: 'onIntegratedBookmakerSelected',
        value: function onIntegratedBookmakerSelected(data) {
            var bookieName = data.bookieName,
                _data$selectionInfo2 = data.selectionInfo,
                meetingId = _data$selectionInfo2.meetingId,
                _data$selectionInfo2$ = _data$selectionInfo2.data,
                courseName = _data$selectionInfo2$.courseName,
                raceDate = _data$selectionInfo2$.raceDate,
                time = _data$selectionInfo2$.time;

            var _pricesStateStore$get = _PricesStateStore.pricesStateStore.getRaceInfo({
                bookmaker: bookieName,
                courseName: courseName.toUpperCase(),
                raceDate: raceDate,
                raceTime: time
            }),
                suspendState = _pricesStateStore$get.suspendState,
                winOdds = _pricesStateStore$get.winOdds,
                placeWinner = _pricesStateStore$get.placeWinner,
                isBog = _pricesStateStore$get.isBog;

            _extends(data.selectionInfo, {
                suspendState: suspendState,
                eachWayFraction: winOdds,
                eachWayPlaces: placeWinner,
                isBog: isBog
            });
            var raceId = data.selectionInfo.data.raceId;
            var outcomersId = data.selectionInfo.id;

            if (window.betslipApi && window.betslipApi.isHorseSelected(raceId, outcomersId, meetingId)) {
                var removeSelectionEvent = new CustomEvent('BETSLIP.REMOVE_SELECTION', { detail: data });
                document.dispatchEvent(removeSelectionEvent);
                // for back compatibility (temporary)
                _jquery2.default.event.trigger('BETSLIP.REMOVE_SELECTION', _extends({}, data));
            } else {
                var makeSelectionEvent = new CustomEvent('BETSLIP.MAKE_SELECTION', { detail: data });
                document.dispatchEvent(makeSelectionEvent);
                // for back compatibility (temporary)
                _jquery2.default.event.trigger('BETSLIP.MAKE_SELECTION', _extends({}, data));
            }
        }
    }, {
        key: 'makeSelection',
        value: function makeSelection(event, data) {
            var bookieName = data.bookieName;

            if (isBookmakerIntegrated(bookieName)) {
                this.onNotIntegratedBookmakerSelected(data);
            } else if (data.bookieName !== '#BESTODDS') {
                this.onIntegratedBookmakerSelected(data);
            }
        }
    }]);

    return BetHandler;
}();
/* eslint-enable class-methods-use-this */

exports.default = BetHandler;

/***/ }),
/* 2597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _LocalStorageHelper = __webpack_require__(2602);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var selectors = Object.freeze({
	bookmakerRow: ".RC-oddsRaceContent__data_offer",
	bookie: ".PC-bestOdds__bookieRow_betslip",
	choseBookie: ".js-RC-chooseBookieMobile__bookmaker"
});

var attributes = Object.freeze({
	bookmakerName: "bookmaker-name",
	bookieName: "data-diffusion-bookiename",
	dataHidden: "data-hidden",
	dataBookmakerName: "data-bookmaker-name"
});

var bookmakersTierOne = ["williamhill", "ladbrokes", "bet365", "coral", "paddypower", "betfair", "skybet", "tote"];

/**
 * Filters out bookmakers that the user has either:
 * - Marked as having an account with during the bookmaker quiz
 * - Recently logged into
 *
 * @param {HTMLElement} $offers
 * @returns Object
 */
var getBookmakersToExclude = function getBookmakersToExclude($offers, dataAttribute) {
	var userTraits = (0, _LocalStorageHelper.tryParseJson)((0, _LocalStorageHelper.getLocalStorageItem)("__user_traits") || "{}");
	var recentBookmaker = (0, _LocalStorageHelper.tryParseJson)((0, _LocalStorageHelper.getLocalStorageItem)("recentBookmakers") || "{}");

	var excludedBookmakers = [].concat(_toConsumableArray(Object.keys(userTraits).filter(function (key) {
		return Boolean(userTraits[key]);
	})), _toConsumableArray(Object.keys(recentBookmaker))).reduce(function (acc, cur) {
		return cur.includes("_quiz") ? acc.add(cur.replace(/(_quiz)/g, "").replaceAll("_", "").toLowerCase()) : acc.add(cur);
	}, new Set());

	return $offers.filter(function (_idx, offer) {
		var bookmakerName = (0, _jquery2.default)(offer).attr(dataAttribute).toLowerCase().replaceAll(" ", "");

		return bookmakersTierOne.includes(bookmakerName) && excludedBookmakers.has(bookmakerName);
	});
};

/**
 * Map and validate by offer which should be excluded and hidden
 *
 * @param {Object} offers
 */
var handleExcludedOffers = function handleExcludedOffers(offers) {
	return offers.each(function (_idx, offer) {
		return (0, _jquery2.default)(offer).attr(attributes.dataHidden, "true");
	});
};

var BookmakersHandler = function () {
	function BookmakersHandler() {
		_classCallCheck(this, BookmakersHandler);

		this.$body = (0, _jquery2.default)("body");

		this.$bookmakerOffers = this.$body.find(selectors.bookmakerRow);
		this.$bookies = this.$body.find(selectors.bookie);
		this.$choseBookies = this.$body.find(selectors.choseBookie);

		this.init();
	}

	_createClass(BookmakersHandler, [{
		key: "init",
		value: function init() {
			this.oddsComparisonHandler();
			this.bookiesHandler();
			this.chooseBookiesHandler();
		}

		/**
   * Hide "New Account Bet Offer" on hover if user is logged in into the bookmaker
   * or has marked the bookmaker as having an account with during the bookmaker quiz
   *
   */

	}, {
		key: "oddsComparisonHandler",
		value: function oddsComparisonHandler() {
			var $offersToExlude = getBookmakersToExclude(this.$bookmakerOffers, attributes.bookmakerName);

			handleExcludedOffers($offersToExlude);
		}

		/**
   * Hide "Open account" in the odds if user is logged in into the bookmaker
   * or has marked the bookmaker as having an account with during the bookmaker quiz
   *
   */

	}, {
		key: "bookiesHandler",
		value: function bookiesHandler() {
			var $bookiesToExlude = getBookmakersToExclude(this.$bookies, attributes.bookieName);

			handleExcludedOffers($bookiesToExlude);
		}

		/**
   * Hide "Choose your Bookmaker" bookmakers if user is logged in into the bookmaker
   * or has marked the bookmaker as having an account with during the bookmaker quiz
   *
   */

	}, {
		key: "chooseBookiesHandler",
		value: function chooseBookiesHandler() {
			var $choseBookiesToExclude = getBookmakersToExclude(this.$choseBookies, attributes.dataBookmakerName);

			handleExcludedOffers($choseBookiesToExclude);
		}
	}]);

	return BookmakersHandler;
}();

exports.default = BookmakersHandler;

/***/ }),
/* 2598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BookmakersHandler = exports.pricesStateStore = exports.horsesListStore = exports.diffusionServiceUtils = exports.pricesProvider = exports.priceButton = exports.PRICE_HANDLER_EVENTS = exports.BestOdds = exports.PopOver = exports.BetHandler = undefined;

__webpack_require__(2097);

var _PopOver = __webpack_require__(999);

var _PopOver2 = _interopRequireDefault(_PopOver);

var _BestOdds = __webpack_require__(2595);

var _BestOdds2 = _interopRequireDefault(_BestOdds);

var _DiffusionServiceUtils = __webpack_require__(229);

var _BetHandler = __webpack_require__(2596);

var _BetHandler2 = _interopRequireDefault(_BetHandler);

var _PricesStateStore = __webpack_require__(228);

var _HorsesListStore = __webpack_require__(998);

var _priceButtonPresenter = __webpack_require__(2599);

var _PricesProvider = __webpack_require__(996);

var _BookmakersHandler = __webpack_require__(2597);

var _BookmakersHandler2 = _interopRequireDefault(_BookmakersHandler);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.BetHandler = _BetHandler2.default;
exports.PopOver = _PopOver2.default;
exports.BestOdds = _BestOdds2.default;
exports.PRICE_HANDLER_EVENTS = _PricesProvider.PRICE_HANDLER_EVENTS;
exports.priceButton = _priceButtonPresenter.priceButton;
exports.pricesProvider = _PricesProvider.pricesProvider;
exports.diffusionServiceUtils = _DiffusionServiceUtils.diffusionServiceUtils;
exports.horsesListStore = _HorsesListStore.horsesListStore;
exports.pricesStateStore = _PricesStateStore.pricesStateStore;
exports.BookmakersHandler = _BookmakersHandler2.default;

/***/ }),
/* 2599 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.priceButton = exports.PRICE_BUTTON = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _BOOKMAKERS, _BOOKMAKERS2;

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

var _DiffusionServiceUtils = __webpack_require__(229);

var _DIFFUSION = __webpack_require__(384);

var _DIFFUSION2 = _interopRequireDefault(_DIFFUSION);

var _PricesStateStore = __webpack_require__(228);

var _PricesProvider = __webpack_require__(996);

var _PreloadedStateHelper = __webpack_require__(584);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var BOOKMAKERS = (_BOOKMAKERS = {
    WH_OXI: 'WH_OXI',
    '#BESTODDS': 'ui-priceBtn_bestOdds',
    LADB: 'LADB',
    BET365: 'BET365',
    CORAL: 'CORAL',
    PPWR: 'PPWR',
    BETFAIR: 'BETFAIR',
    VC: 'VC'
}, _defineProperty(_BOOKMAKERS, _PreloadedStateHelper.skybetDiffusionName, _PreloadedStateHelper.skybetDiffusionName), _defineProperty(_BOOKMAKERS, 'BOLEYSPORTS', 'BOLEYSPORTS'), _defineProperty(_BOOKMAKERS, 'TOTE', 'TOTE'), _defineProperty(_BOOKMAKERS, 'BETFRED', 'BETFRED'), _BOOKMAKERS);

var PRICE_BUTTON = exports.PRICE_BUTTON = {
    CLASSES: {
        SUBSCRIBED: 'js-PC-subscribed',
        NOT_SUBSCRIBED: '.js-diffusionHorsesList:not(.js-PC-subscribed)',
        NOT_CLICKABLE: 'noPointerClass',
        HIDDEN: 'ui-priceBtn_noPrice'
    },
    SELECTORS: {
        RACE_SETTINGS: '.js-diffusionTopicSettingsRace', // General container
        HORSE_ELEMENT: '.js-diffusionHorsesList', // Div with particular price
        PRICE_VALUE: '.js-diffusionPriceValue' // <a> with data from diffusion
    },
    POPUP: {
        HEIGHT: 'data-popup-height',
        WIDTH: 'data-popup-width',
        BLANK: 'data-popup-blank',
        LINK_CLASS: 'js-popupLink'
    },
    BOOKMAKERS: (_BOOKMAKERS2 = {}, _defineProperty(_BOOKMAKERS2, BOOKMAKERS.WH_OXI, 'ui-priceBtn_williamHill'), _defineProperty(_BOOKMAKERS2, '#BESTODDS', 'ui-priceBtn_bestOdds'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.LADB, 'ui-priceBtn_ladbrokes'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.BET365, 'ui-priceBtn_bet365'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.CORAL, 'ui-priceBtn_coral'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.PPWR, 'ui-priceBtn_paddypower'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.BETFAIR, 'ui-priceBtn_betfair'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.VC, 'ui-priceBtn_betVictor'), _defineProperty(_BOOKMAKERS2, _PreloadedStateHelper.skybetDiffusionName, 'ui-priceBtn_skybet'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.BOLEYSPORTS, 'ui-priceBtn_boylesports'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.TOTE, 'ui-priceBtn_tote'), _defineProperty(_BOOKMAKERS2, BOOKMAKERS.BETFRED, 'ui-priceBtn_betfred'), _BOOKMAKERS2)
};

/* eslint-disable no-use-before-define */
var priceButton = exports.priceButton = {
    activate: activate,
    deactivate: deactivate
};

function activate() {
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICE_RECEIVED, onPriceReceived);
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, onPriceSettingsChanged);
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, onRaceInfoReceived);
    _PricesProvider.pricesProvider.subscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED, onPricesWillBeUpdated);
    addBetslipEventListeners();
}

function deactivate() {
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICE_RECEIVED, onPriceReceived);
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_SETTINGS_CHANGED, onPriceSettingsChanged);
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.RACE_INFO_RECEIVED, onRaceInfoReceived);
    _PricesProvider.pricesProvider.unsubscribe(_PricesProvider.PRICE_HANDLER_EVENTS.PRICES_WILL_BE_UPDATED, onPricesWillBeUpdated);
}

function onPriceReceived(renderConfig) {
    var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();
    if (currentBookmaker === renderConfig.bookmaker) {
        renderPrice(renderConfig);
    }
}

function onPriceSettingsChanged(_ref) {
    var showDecimal = _ref.showDecimal;

    togglePricesViewType({ showDecimal: showDecimal });
}

function onPricesWillBeUpdated() {
    clearPrices();
}

function addBetslipEventListeners() {
    document.addEventListener('BETSLIP.SELECTION_MADE', function () {
        setAddedToBetslipClass();
    });

    document.addEventListener('BETSLIP.SELECTION_REMOVED', function () {
        setAddedToBetslipClass();
    });
}

function onRaceInfoReceived(_ref2) {
    var bookmaker = _ref2.bookmaker,
        courseName = _ref2.courseName,
        raceDate = _ref2.raceDate,
        raceTime = _ref2.raceTime,
        suspendState = _ref2.suspendState;

    if (suspendState === 'H') {
        markPricesOfFinishedRaces({ bookmaker: bookmaker, courseName: courseName, raceDate: raceDate, raceTime: raceTime });
    }
}

function markPricesOfFinishedRaces(_ref3) {
    var bookmaker = _ref3.bookmaker,
        courseName = _ref3.courseName,
        raceDate = _ref3.raceDate,
        raceTime = _ref3.raceTime;

    var priceElements = (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray();
    var currentBookmaker = _PricesStateStore.pricesStateStore.getCurrentBookmaker();

    if (bookmaker !== currentBookmaker) {
        return;
    }
    priceElements.filter(function (priceElement) {
        var elementData = _DiffusionServiceUtils.diffusionServiceUtils.getElementDiffusionData(priceElement);

        return elementData.courseName === courseName && elementData.raceDate === raceDate && elementData.raceTime === raceTime;
    }).forEach(function (priceElement) {
        var element = priceElement;

        element.innerHTML = '-';
        element.classList.add(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
    });
}

function togglePricesViewType(_ref4) {
    var showDecimal = _ref4.showDecimal;

    var priceElements = (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray();

    priceElements.forEach(togglePriceViewType);

    function togglePriceViewType(priceElement) {
        var element = priceElement;
        var currentValue = priceElement.innerHTML;
        var isNoPrice = ['', '-', 'SP'].includes(currentValue);

        if (!isNoPrice) {
            element.innerHTML = showDecimal ? Math.floor(parseFloat(priceElement.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL)) * 100) / 100 : priceElement.getAttribute(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL);

            if (_DIFFUSION2.default.DATA.INPUT.BOOKMAKER === 'TOTE') {
                element.innerHTML = parseFloat(element.innerHTML).toFixed(2);
            }
        }
    }
}

function renderPrice(renderConfig) {
    var priceElements = _DiffusionServiceUtils.diffusionServiceUtils.getPriceContainer(renderConfig);

    priceElements.forEach(function (buttonContainer) {
        var priceElement = (0, _jquery2.default)(buttonContainer).find(PRICE_BUTTON.SELECTORS.PRICE_VALUE)[0];
        var $priceElement = (0, _jquery2.default)(priceElement);
        var renderPriceValue = _DiffusionServiceUtils.diffusionServiceUtils.getDisplayedPriceValue(renderConfig);

        if (priceElement) {
            applyButtonStyling($priceElement, renderPriceValue, renderConfig.bookmaker);

            setDiffusionDataAttributes($priceElement, _extends(renderConfig, { nextPrice: renderPriceValue }));
            $priceElement.text(renderPriceValue);
        }
    });

    setAddedToBetslipClass();
}

function clearPrices() {
    (0, _jquery2.default)(PRICE_BUTTON.SELECTORS.PRICE_VALUE).toArray().forEach(function (priceElement) {
        var element = priceElement;

        element.innerHTML = '';
        setDiffusionDataAttributes(element, {});
        clearBookmakerStyling(element);
    });
}

function setAddedToBetslipClass() {
    var nextSelections = !!window.betslipApi && window.betslipApi.getSelectedBets();
    (0, _jquery2.default)('.added-to-betslip').removeClass('added-to-betslip');
    if (nextSelections.length) {
        nextSelections.forEach(function (selection) {
            var $priceElements = (0, _jquery2.default)('[data-diffusion-outcomers-id="' + selection.outcomersId + '"][data-diffusion-meeting-id="' + selection.meetingId + '"]');
            if ($priceElements.length) {
                $priceElements.addClass('added-to-betslip');
            }
        });
    }
}

function setDiffusionDataAttributes(element, priceConfig) {
    (0, _jquery2.default)(element).attr(_DIFFUSION2.default.DATA.OUTPUT.OUTCOMERS_ID, priceConfig.outcomersId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.FRACTIONAL, priceConfig.fractionalPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.DECIMAL, priceConfig.decimalPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.HISTORY, priceConfig.historyPrice || '').attr(_DIFFUSION2.default.DATA.OUTPUT.STATUS, priceConfig.status || '').attr(_DIFFUSION2.default.DATA.OUTPUT.EVENT_ID, priceConfig.eventId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.MARKET_ID, priceConfig.marketId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.MEETING_ID, priceConfig.meetingId || '').attr(_DIFFUSION2.default.DATA.OUTPUT.NEXT_PRICE, priceConfig.nextPrice || '').attr(PRICE_BUTTON.POPUP.WIDTH, '').attr(PRICE_BUTTON.POPUP.HEIGHT, '').attr('href', '#');
}

function clearBookmakerStyling(element) {
    var $element = (0, _jquery2.default)(element);

    $element.addClass(PRICE_BUTTON.CLASSES.HIDDEN);
    Object.keys(PRICE_BUTTON.BOOKMAKERS).forEach(function (feed) {
        $element.removeClass(PRICE_BUTTON.BOOKMAKERS[feed]);
    });
}

function applyButtonStyling($priceElement, renderPriceValue, bookmaker) {
    $priceElement.removeClass(PRICE_BUTTON.POPUP.LINK_CLASS);
    if (renderPriceValue) {
        if (renderPriceValue === '-') {
            $priceElement.addClass(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
        } else {
            $priceElement.removeClass(PRICE_BUTTON.CLASSES.NOT_CLICKABLE);
        }
        $priceElement.removeClass(PRICE_BUTTON.CLASSES.HIDDEN).addClass(PRICE_BUTTON.BOOKMAKERS[bookmaker]);
    } else {
        $priceElement.addClass(PRICE_BUTTON.CLASSES.HIDDEN);
    }
}

/***/ }),
/* 2600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _PreloadedStateHelper = __webpack_require__(584);

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DiffusionFeedHelper = function () {
    function DiffusionFeedHelper() {
        _classCallCheck(this, DiffusionFeedHelper);

        this.bookmakerFeedConfig = [{ bookmaker: 'PPWR', feed: 'PADDYPOWER' }, { bookmaker: 'BETFAIR', feed: 'BETFAIR' }, { bookmaker: 'WH_OXI', feed: 'WH_OXI' }, { bookmaker: 'LADB', feed: 'LADB' }, { bookmaker: 'BET365', feed: 'BET365' }, { bookmaker: 'CORAL', feed: 'CORAL' }, { bookmaker: 'BOLEYSPORTS', feed: 'BOLEYSPORTS' }, { bookmaker: 'RB', feed: 'RB' }, { bookmaker: _PreloadedStateHelper.skybetDiffusionName, feed: _PreloadedStateHelper.skybetDiffusionName }, { bookmaker: 'VC', feed: 'VC' }, { bookmaker: 'TOTE', feed: 'TOTE' }, { bookmaker: 'BETFRED', feed: 'BETFRED' }];
    }

    _createClass(DiffusionFeedHelper, [{
        key: 'getFeedByBookmaker',
        value: function getFeedByBookmaker(bookmaker) {
            var found = this.bookmakerFeedConfig.find(function (item) {
                return item.bookmaker === bookmaker;
            });
            return found ? found.feed : bookmaker;
        }
    }, {
        key: 'getBookmakerByFeed',
        value: function getBookmakerByFeed(feed) {
            var found = this.bookmakerFeedConfig.find(function (item) {
                return item.feed === feed;
            });
            return found ? found.bookmaker : feed;
        }
    }]);

    return DiffusionFeedHelper;
}();

exports.default = new DiffusionFeedHelper();

/***/ }),
/* 2601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.prepareTopics = exports.combineArrays = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _requestIdleCallback = __webpack_require__(2453);

var _requestIdleCallback2 = _interopRequireDefault(_requestIdleCallback);

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// [a, b] + [c, d, e] = [ a, c, b, d, e ]
var combineArrays = exports.combineArrays = function combineArrays(first, second) {
    var result = [];
    while (first.length > 0 || second.length > 0) {
        if (first.length > 0) {
            result.push(first.shift());
        }
        if (second.length > 0) {
            result.push(second.shift());
        }
    }

    return result;
};

// in order to subscribe for prices in both columns in parallel.
var prepareTopics = exports.prepareTopics = function prepareTopics(topics) {
    var preparedTopics = [];
    if ((0, _jquery2.default)(document).width() < 768) {
        preparedTopics = Array.from(topics);
    } else {
        var center = topics.findIndex(function (topic) {
            return topic.indexOf && topic.indexOf('WIN/M') > -1;
        });
        preparedTopics = combineArrays(topics.slice(0, center), topics.slice(center));
    }

    return preparedTopics;
};

var Subscriber = function () {
    function Subscriber(session) {
        var chunkSize = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;

        _classCallCheck(this, Subscriber);

        this.taskList = [];
        this.isActive = false;
        this.session = session;
        this.currentTaskId = 0;
        this.chunkSize = chunkSize;
        this.runTask = this.runTask.bind(this);
    }

    _createClass(Subscriber, [{
        key: 'run',
        value: function run() {
            this.isActive = true;
        }
    }, {
        key: 'stop',
        value: function stop() {
            this.isActive = false;
        }
    }, {
        key: 'addTask',
        value: function addTask(taskHandler, taskData) {
            this.taskList.push({
                handler: taskHandler,
                data: taskData
            });

            if (!this.currentTaskId) {
                this.currentTaskId = _requestIdleCallback2.default.requestIdleCallback(this.runTask, { timeout: 1000 });
            }
        }
    }, {
        key: 'runTask',
        value: function runTask(deadline) {
            while ((deadline.timeRemaining() > 0 || deadline.didTimeout) && this.taskList.length && this.isActive) {
                var task = this.taskList.shift();
                task.handler(task.data);
            }

            if (this.taskList.length) {
                this.currentTaskId = _requestIdleCallback2.default.requestIdleCallback(this.runTask, { timeout: 1000 });
            } else {
                this.currentTaskId = 0;
            }
        }
    }, {
        key: 'schedule',
        value: function schedule(topics) {
            var _this = this;

            var chunks = [];
            var preparedTopics = prepareTopics(topics);

            for (var i = 0; i < topics.length; i += this.chunkSize) {
                chunks.push(preparedTopics.slice(i, i + this.chunkSize));
            }

            chunks.forEach(function (chunk) {
                _this.addTask(_this.session.subscribe, { topics: chunk });
            });
        }
    }, {
        key: 'subscribe',
        value: function subscribe(topics) {
            if (!this.session || !topics.map) {
                return;
            }

            if (topics.length <= this.chunkSize) {
                this.session.subscribe({ topics: topics });
            } else {
                this.schedule(topics);
            }
        }
    }, {
        key: 'unsubscribeAll',
        value: function unsubscribeAll() {
            this.stop();
            this.taskList = [];
            _requestIdleCallback2.default.cancelIdleCallback(this.currentTaskId);
            this.currentTaskId = 0;
            this.session.unsubscribeAll();
            this.run();
        }
    }]);

    return Subscriber;
}();

exports.default = Subscriber;

/***/ }),
/* 2602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});
var tryParseJson = exports.tryParseJson = function tryParseJson(json) {
	try {
		return JSON.parse(json);
	} catch (err) {
		console.error("Error parsing JSON", err);

		return null;
	}
};

var getLocalStorageItem = exports.getLocalStorageItem = function getLocalStorageItem(key) {
	return localStorage.getItem(key);
};

/***/ }),
/* 2603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PubSub = function () {
    function PubSub() {
        _classCallCheck(this, PubSub);

        this.handlers = [];
    }

    _createClass(PubSub, [{
        key: "subscribe",
        value: function subscribe(event, handler) {
            this.handlers.push({ event: event, handler: handler });
        }
    }, {
        key: "unsubscribe",
        value: function unsubscribe(event, handler) {
            this.handlers = this.handlers.filter(function (savedHandler) {
                return !(savedHandler.event === event && savedHandler.handler === handler);
            });
        }
    }, {
        key: "publish",
        value: function publish(event, args) {
            this.handlers.filter(function (topic) {
                return topic.event === event;
            }).forEach(function (topic) {
                return topic.handler(args);
            });
        }
    }]);

    return PubSub;
}();

exports.default = PubSub;

/***/ }),
/* 2604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var toteCourseNameMapping = exports.toteCourseNameMapping = {
    "ASCOT": "ASCOT",
    "AYR": "AYR",
    "BANGOR-ON-DEE": "BANGOR",
    "CARLISLE": "CARLISLE",
    "CATTERICK": "CATTERICK",
    "CHELMSFORD": "CHELMSFORD CITY",
    "CHELMSFORD (A.W)": "CHELMSFORD CITY",
    "CHELTENHAM": "CHELTENHAM",
    "CHEPSTOW": "CHEPSTOW",
    "CLONMEL": "CLONMEL",
    "CORK": "CORK",
    "DONCASTER": "DONCASTER",
    "DOWN ROYAL": "DOWN ROYAL",
    "DOWNPATRICK": "DOWNPATRICK",
    "DUNDALK (A.W)": "DUNDALK",
    "EXETER": "EXETER",
    "FAIRYHOUSE": "FAIRYHOUSE",
    "FAKENHAM": "FAKENHAM",
    "FFOS LAS": "FFOS LAS",
    "FONTWELL": "FONTWELL",
    "GOWRAN PARK": "GOWRAN",
    "HAYDOCK": "HAYDOCK PARK",
    "HEREFORD": "HEREFORD",
    "HEXHAM": "HEXHAM",
    "HUNTINGDON": "HUNTINGDON",
    "KELSO": "KELSO",
    "KEMPTON": "KEMPTON PARK",
    "KEMPTON (A.W)": "KEMPTON PARK",
    "LEICESTER": "LEICESTER",
    "LEOPARDSTOWN": "LEOPARDSTOWN",
    "LIMERICK": "LIMERICK",
    "LINGFIELD": "LINGFIELD PARK",
    "LINGFIELD (A.W)": "LINGFIELD PARK",
    "LUDLOW": "LUDLOW",
    "MARKET RASEN": "MARKET RASEN",
    "MUSSELBURGH": "MUSSELBURGH",
    "NAAS": "NAAS",
    "NAVAN": "NAVAN",
    "NEWBURY": "NEWBURY",
    "NEWCASTLE": "NEWCASTLE",
    "NEWCASTLE (A.W)": "NEWCASTLE",
    "PLUMPTON": "PLUMPTON",
    "PUNCHESTOWN": "PUNCHESTOWN",
    "RIPON": "RIPON",
    "SEDGEFIELD": "SEDGEFIELD",
    "SOUTHWELL": "SOUTHWELL",
    "SOUTHWELL (A.W)": "SOUTHWELL",
    "STRATFORD": "STRATFORD",
    "TAUNTON": "TAUNTON",
    "THURLES": "THURLES",
    "TRAMORE": "TRAMORE",
    "UTTOXETER": "UTTOXETER",
    "WARWICK": "WARWICK",
    "WETHERBY": "WETHERBY",
    "WEXFORD": "WEXFORD",
    "WINCANTON": "WINCANTON",
    "WOLVERHAMPTON (A.W)": "WOLVERHAMPTON"
};

/***/ }),
/* 2605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.disabledScrollClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(9);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _rpMqBreakpoints = __webpack_require__(66);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _SelectPopover = __webpack_require__(2611);

var _SelectPopover2 = _interopRequireDefault(_SelectPopover);

var _SelectButton = __webpack_require__(2608);

var _SelectButton2 = _interopRequireDefault(_SelectButton);

var _SelectOption = __webpack_require__(2610);

var _SelectOption2 = _interopRequireDefault(_SelectOption);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var disabledScrollClass = exports.disabledScrollClass = 'ui-disabledScroll';

var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
    NARROW = _rpMqBreakpoints.breakpointCodes.NARROW;

/**
 * The Select component. The only exported component.
 */

var Select = function (_PureComponent) {
    _inherits(Select, _PureComponent);

    _createClass(Select, null, [{
        key: 'toggleElementClass',
        value: function toggleElementClass(element, className, enabled) {
            // IE 11 doesn't support second parameter in classList.toggle
            if (enabled) {
                element.classList.add(className);
            } else {
                element.classList.remove(className);
            }
        }
    }, {
        key: 'toggleDisabledScrollClass',
        value: function toggleDisabledScrollClass(enabled) {
            Select.toggleElementClass(document.querySelector('html'), disabledScrollClass, enabled);
            Select.toggleElementClass(document.body, disabledScrollClass, enabled);
        }
    }, {
        key: 'getOptionProp',
        value: function getOptionProp(option, getter) {
            if ((0, _lodash.isString)(getter) || (0, _lodash.isArray)(getter)) {
                return (0, _lodash.get)(option, getter);
            }

            if ((0, _lodash.isFunction)(getter)) {
                return getter(option);
            }

            return null;
        }
    }]);

    function Select(props) {
        _classCallCheck(this, Select);

        var _this = _possibleConstructorReturn(this, (Select.__proto__ || Object.getPrototypeOf(Select)).call(this, props));

        _this.renderNoOptions = function () {
            var _this$props = _this.props,
                noOptionsRenderer = _this$props.noOptionsRenderer,
                noOptionsMessage = _this$props.noOptionsMessage;


            if (noOptionsRenderer) return noOptionsRenderer();

            return _react2.default.createElement(
                'div',
                { className: 'ui-errorMessage' },
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__icon' },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { size: 'XL', iconName: 'results' })
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'ui-errorMessage__text' },
                    noOptionsMessage
                )
            );
        };

        _this.state = {
            popoverOpen: false,
            query: ''
        };
        _this.startPagePositionTop = null;

        _this.handlePageClick = _this.handlePageClick.bind(_this);
        _this.handleBreakpointChange = _this.handleBreakpointChange.bind(_this);

        _this.closePopover = _this.closePopover.bind(_this);
        _this.togglePopover = _this.togglePopover.bind(_this);

        _this.clearSelection = _this.clearSelection.bind(_this);

        _this.handleButtonClick = _this.handleButtonClick.bind(_this);
        _this.handleOptionClick = _this.handleOptionClick.bind(_this);

        _this.handleQueryChange = _this.handleQueryChange.bind(_this);

        _this.getOptionLabel = _this.getOptionLabel.bind(_this);
        _this.getOptionValue = _this.getOptionValue.bind(_this);
        _this.isOptionSelected = _this.isOptionSelected.bind(_this);
        _this.renderButtonLabel = _this.renderButtonLabel.bind(_this);
        _this.renderButtonOption = _this.renderButtonOption.bind(_this);
        _this.renderOption = _this.renderOption.bind(_this);
        return _this;
    }

    _createClass(Select, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            window.addEventListener('click', this.handlePageClick, false);
            window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('click', this.handlePageClick, false);
            window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointChange);

            if (this.isPopoverOpen()) {
                this.closePopover();
            }
        }
    }, {
        key: 'getRenderingOptions',
        value: function getRenderingOptions() {
            var _this2 = this;

            var _props = this.props,
                options = _props.options,
                optionsSorter = _props.optionsSorter;
            var _state$query = this.state.query,
                query = _state$query === undefined ? '' : _state$query;

            return (optionsSorter === null ? _lodash.identity : _lodash.sortBy)(!query ? options : options.filter(function (option) {
                return _this2.props.optionsQueryComparator(_this2.getOptionLabel(option), query);
            }), optionsSorter || function (option) {
                return _this2.getOptionLabel(option).toLowerCase();
            });
        }
    }, {
        key: 'getOptionValue',
        value: function getOptionValue(option) {
            return Select.getOptionProp(option, this.props.valueGetter);
        }
    }, {
        key: 'getOptionLabel',
        value: function getOptionLabel(option) {
            return Select.getOptionProp(option, this.props.labelGetter);
        }
    }, {
        key: 'isOptionSelected',
        value: function isOptionSelected(option) {
            var currentValue = this.getOptionValue(option);
            if ((0, _lodash.isArray)(this.props.value)) {
                return this.props.value.indexOf(currentValue) >= 0;
            }
            return currentValue === this.props.value;
        }
    }, {
        key: 'isPopoverOpen',
        value: function isPopoverOpen() {
            return this.state.popoverOpen;
        }
    }, {
        key: 'togglePopover',
        value: function togglePopover() {
            var popoverOpen = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !this.isPopoverOpen();

            this.setState({
                popoverOpen: popoverOpen
            });

            this.togglePageScroll(popoverOpen, _rpMqBreakpoints2.default.current().code);
        }
    }, {
        key: 'closePopover',
        value: function closePopover() {
            this.togglePopover(false);
        }
    }, {
        key: 'clearSelection',
        value: function clearSelection(e, value) {
            e.stopPropagation();

            if (this.props.disabled) {
                return;
            }

            var result = this.props.multiSelect ? this.props.value.filter(function (item) {
                return item !== value;
            }) : null;

            this.props.onChange(result);
        }
    }, {
        key: 'togglePageScroll',
        value: function togglePageScroll(popoverOpen, breakpointCode) {
            if (popoverOpen && [EXTRA_NARROW, NARROW].indexOf(breakpointCode) > -1) {
                this.disablePageScroll();
            } else {
                this.enablePageScroll();
            }
        }
    }, {
        key: 'enablePageScroll',
        value: function enablePageScroll() {
            Select.toggleDisabledScrollClass(false);

            if (this.startPagePositionTop !== null) {
                var windowPageYOffset = this.rootRef.getBoundingClientRect().top - this.startPagePositionTop + window.pageYOffset;
                this.startPagePositionTop = null;
                window.setTimeout(function () {
                    window.scrollTo(window.pageXOffset, windowPageYOffset);
                }, 0);
            }
        }
    }, {
        key: 'disablePageScroll',
        value: function disablePageScroll() {
            this.startPagePositionTop = this.rootRef.getBoundingClientRect().top;

            Select.toggleDisabledScrollClass(true);
        }
    }, {
        key: 'handleBreakpointChange',
        value: function handleBreakpointChange(e) {
            if (this.isPopoverOpen()) {
                this.togglePageScroll(true, e.detail.breakpoint.code);
            }
        }
    }, {
        key: 'handleSingleOptionClick',
        value: function handleSingleOptionClick(value, option) {
            this.props.onChange(value, option);
            this.closePopover();
        }
    }, {
        key: 'handleMultiOptionClick',
        value: function handleMultiOptionClick(value, option) {
            this.props.onChange(value, option);
        }
    }, {
        key: 'handleOptionClick',
        value: function handleOptionClick(value, option) {
            var _props2 = this.props,
                onChange = _props2.onChange,
                multiSelect = _props2.multiSelect;

            onChange(value, option);
            if (!multiSelect) {
                this.closePopover();
            }
        }
    }, {
        key: 'handleQueryChange',
        value: function handleQueryChange(query) {
            this.setState({ query: query });
        }
    }, {
        key: 'handlePageClick',
        value: function handlePageClick(e) {
            if (this.isPopoverOpen() && !this.rootRef.contains(e.target)) {
                this.closePopover();
            }
        }
    }, {
        key: 'handleButtonClick',
        value: function handleButtonClick() {
            this.togglePopover();
        }
    }, {
        key: 'renderButtonOption',
        value: function renderButtonOption(value) {
            var _this3 = this;

            var option = this.props.options.find(function (item) {
                return _this3.getOptionValue(item) === value;
            });
            return _react2.default.createElement(
                'span',
                { className: 'sb-select__button__label_flag', key: value },
                _react2.default.createElement(
                    'span',
                    { className: 'sb-select__button__label' },
                    this.getOptionLabel(option)
                ),
                _react2.default.createElement(
                    'span',
                    {
                        className: 'sb-select__button__label_flagClose',
                        onClick: function onClick(e) {
                            return _this3.clearSelection(e, value);
                        }
                    },
                    _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'cross', size: 'Small' })
                )
            );
        }
    }, {
        key: 'renderButtonLabel',
        value: function renderButtonLabel() {
            var _props3 = this.props,
                multiSelect = _props3.multiSelect,
                value = _props3.value,
                placeholder = _props3.placeholder;


            if ((0, _lodash.isNil)(value) || multiSelect && !value.length) {
                return placeholder;
            }

            return multiSelect ? value.map(this.renderButtonOption) : this.renderButtonOption(value);
        }
    }, {
        key: 'renderOption',
        value: function renderOption(option) {
            var _this4 = this;

            return _react2.default.createElement(_SelectOption2.default, {
                key: this.getOptionValue(option),
                option: option,
                labelGetter: this.getOptionLabel,
                valueGetter: this.getOptionValue,
                isSelected: this.isOptionSelected,
                immediateUpdate: this.props.multiSelect,
                onClick: function onClick(value, valueOption) {
                    _this4.handleOptionClick(value, valueOption);
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this5 = this;

            var _props4 = this.props,
                title = _props4.title,
                disabled = _props4.disabled,
                alphabet = _props4.alphabet,
                showSearch = _props4.showSearch,
                onPopoverDidOpen = _props4.onPopoverDidOpen,
                multiSelect = _props4.multiSelect,
                options = _props4.options,
                rowHeight = _props4.rowHeight,
                dropdownListHeight = _props4.dropdownListHeight;
            var query = this.state.query;

            return _react2.default.createElement(
                'div',
                {
                    className: 'sb-select ' + (multiSelect ? 'sb-select_multi' : ''),
                    ref: function ref(_ref) {
                        return _this5.rootRef = _ref;
                    }
                },
                _react2.default.createElement(_SelectButton2.default, {
                    label: this.renderButtonLabel(),
                    major: this.isPopoverOpen(),
                    disabled: disabled,
                    onClick: this.handleButtonClick
                }),
                this.isPopoverOpen() ? _react2.default.createElement(_SelectPopover2.default, {
                    title: title,
                    alphabet: alphabet,
                    showSearch: showSearch && options.length > 0,
                    query: query,
                    rowHeight: rowHeight,
                    options: this.getRenderingOptions(),
                    optionLabelGetter: this.getOptionLabel,
                    optionRenderer: function optionRenderer(opt) {
                        return _this5.renderOption(opt);
                    },
                    noOptionsRenderer: this.renderNoOptions,
                    onQueryChange: this.handleQueryChange,
                    onClose: this.closePopover,
                    onDidMount: onPopoverDidOpen,
                    dropdownListHeight: dropdownListHeight
                }) : null
            );
        }
    }]);

    return Select;
}(_react.PureComponent);

Select.propTypes = {
    /**
     * Title to be displayed in popover on mobile devices
     */
    title: _react.PropTypes.string.isRequired,
    /**
     * Placeholder to be displayed while no value selected
     */
    placeholder: _react.PropTypes.string,
    /**
     * Disables the component
     */
    disabled: _react.PropTypes.bool,
    /**
     * Select should be used as a controlled component.
     * This property sets it's value.
     */
    value: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.number, _react.PropTypes.array]),
    /**
     * This property allows multiple options to be selected..
     */
    multiSelect: _react.PropTypes.bool,
    /**
     * Options to be rendered in open popover.
     * It should have structure [{ label: 'Option Label', value: 'optionValue' }] by default.
     * Options with custom structure are acceptable too (see 'labelGetter' and 'valueGetter' for details).
     */
    options: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
    /**
     * Shows alphabet in popover.
     * It could be boolean if you want to control the visibility of the default (English) alphabet.
     * You can also provide a string with custom chars to be rendered instead of default alphabet.
     */
    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.string]),
    /**
     * Controls the visibility of search input in popover.
     */
    showSearch: _react.PropTypes.bool,
    /**
     * Controls height of row element, defaults to 64px
     */
    rowHeight: _react.PropTypes.number,
    /**
     * Controls height of options list into dropdown (for medium and larger screens),
     */
    dropdownListHeight: _react.PropTypes.number,
    /**
     * You can set custom option label getter if you have custom option object structure.
     * By default, it is 'label'.
     * It uses _.get for string and array label getter.
     * You also can pass a function which accepts option object as a parameter and returns string label.
     * For example, ({ name }) => name
     */
    labelGetter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array, _react.PropTypes.func]),
    /**
     * You can set custom option value getter if you have custom option object structure.
     * By default it is 'value'.
     * It uses _.get for string and array value getter.
     * You also can pass a function which accepts option object as a parameter and returns value.
     * For example, ({ id }) => id
     */
    valueGetter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.array, _react.PropTypes.func]),
    /**
     * By default options are sorted by labels in alphabet order.
     * You can override default sorting with this property.
     * It uses _.sortBy API.
     * Pass null if you want to disable sorting.
     */
    optionsSorter: _react.PropTypes.oneOfType([_react.PropTypes.string, _react.PropTypes.func]),
    /**
     * Comapring option and filter query
     */
    optionsQueryComparator: _react.PropTypes.func,
    /**
     * Message to render if no options available (due to search query or any other reason).
     * It is ignored if noOptionsRenderer is set.
     */
    noOptionsMessage: _react.PropTypes.string,
    /**
     * Function that renders the placeholder if no options available (due to search query or any other reason)
     */
    noOptionsRenderer: _react.PropTypes.func,
    /**
     * Select should be used as a controlled component.
     * You should handle change event with this property to change component value.
     */
    onChange: _react.PropTypes.func.isRequired,
    /**
     * You can handle popover open with this property.
     * If your handler returns Promise, component will render the Spinne while promise unresolved.
     * It could be used to load options asynchronously.
     */
    onPopoverDidOpen: _react.PropTypes.func
};

Select.defaultProps = {
    value: null,
    placeholder: 'Select',
    labelGetter: 'label',
    valueGetter: 'value',
    noOptionsMessage: 'No results',
    noOptionsRenderer: null,
    optionsQueryComparator: function optionsQueryComparator(optionLabel, query) {
        return optionLabel.toLowerCase().indexOf(query.toLowerCase()) > -1;
    }
};

exports.default = Select;

/***/ }),
/* 2606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__(9);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The alphabet.
 */
var SelectAlphabet = function SelectAlphabet(_ref) {
    var alphabet = _ref.alphabet,
        _onClick = _ref.onClick;
    return _react2.default.createElement(
        'ul',
        { className: 'sb-selectAlphabet' },
        ((0, _lodash.isString)(alphabet) ? alphabet.split('') : alphabet).map(function (character, index) {
            return _react2.default.createElement(
                'li',
                {
                    key: index,
                    onClick: function onClick() {
                        return _onClick(character);
                    },
                    className: 'sb-selectAlphabet__character'
                },
                character
            );
        })
    );
};

SelectAlphabet.propTypes = {
    /**
     * You can provide string with all alphabet characters or an array of characters to be displayed.
     * It is English alphabet by default.
     */
    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.array, _react.PropTypes.string]),
    /**
     * The 'click' event handler.
     * It will receive a character as an argument.
     */
    onClick: _react.PropTypes.func.isRequired
};

SelectAlphabet.defaultProps = {
    alphabet: 'abcdefghijklmnopqrstuvwxyz'
};

exports.default = SelectAlphabet;

/***/ }),
/* 2607 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _throttle = __webpack_require__(2274);

var _throttle2 = _interopRequireDefault(_throttle);

var _isMatch = __webpack_require__(2258);

var _isMatch2 = _interopRequireDefault(_isMatch);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectAutoSizer = function (_PureComponent) {
    _inherits(SelectAutoSizer, _PureComponent);

    function SelectAutoSizer() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, SelectAutoSizer);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectAutoSizer.__proto__ || Object.getPrototypeOf(SelectAutoSizer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
            measured: false,
            height: null,
            width: null
        }, _this.checkSize = function () {
            // TODO: width and height should be calculated without padding
            var _this$parentRef = _this.parentRef,
                clientWidth = _this$parentRef.clientWidth,
                clientHeight = _this$parentRef.clientHeight;

            var _this$props$sizeProce = _this.props.sizeProcessor({
                height: clientHeight,
                width: clientWidth
            }),
                height = _this$props$sizeProce.height,
                width = _this$props$sizeProce.width;

            var state = {
                height: height,
                width: width,
                measured: true
            };
            if ((0, _isMatch2.default)(_this.state, state)) {
                return;
            }
            _this.setState(state, _this.props.onDidResize);
        }, _this.checkSizeThrottled = (0, _throttle2.default)(_this.checkSize, 100, { leading: false, trailing: true }), _this.handleResize = _this.checkSizeThrottled, _this.handleOrientationChange = function () {
            // Mobile devices (iOS 10.3.1) don't return valid parent element size
            // right after the screen orientation change. It also fires the resize event
            // with the same issue.
            // So we need to check size after some time past after event.
            // The only robust way to get new screen size I've found is to
            // check the size several times (during at least 500ms).
            // We could do this just once after 500ms past but it makes the UX worse.
            // I've also tried to check repeatedly until the first size change happened
            // but there were situations on iOS when it returns new height
            // with old width.
            var count = 0;
            var checkSizeRepeated = function checkSizeRepeated() {
                _this.checkSizeThrottled();
                count += 1;
                if (count < 5) {
                    setTimeout(checkSizeRepeated, 100);
                }
            };
            checkSizeRepeated();
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(SelectAutoSizer, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.parentRef = this.rootRef.parentNode;
            this.checkSize();

            window.addEventListener('resize', this.handleResize);
            window.addEventListener('orientationchange', this.handleOrientationChange);
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps() {
            this.checkSize();
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('resize', this.handleResize);
            window.removeEventListener('orientationchange', this.handleOrientationChange);
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _state = this.state,
                measured = _state.measured,
                height = _state.height,
                width = _state.width;

            return _react2.default.createElement(
                'div',
                { ref: function ref(_ref2) {
                        return _this2.rootRef = _ref2;
                    } },
                measured ? this.props.contentRenderer({ height: height, width: width })
                // Hack for IE11 to get correct clientWidth
                : _react2.default.createElement(
                    'div',
                    null,
                    '\xA0'
                )
            );
        }
    }]);

    return SelectAutoSizer;
}(_react.PureComponent);

SelectAutoSizer.propTypes = {
    sizeProcessor: _react.PropTypes.func,
    contentRenderer: _react.PropTypes.func.isRequired,
    onDidResize: _react.PropTypes.func
};
SelectAutoSizer.defaultProps = {
    sizeProcessor: function sizeProcessor(obj) {
        return obj;
    },
    onDidResize: function onDidResize() {
        return null;
    }
};
exports.default = SelectAutoSizer;

/***/ }),
/* 2608 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The button with selected value that toggles the popover.
 * It doesn't pass element to the ref callback if written as a stateless function.
 */
var SelectButton = function (_PureComponent) {
    _inherits(SelectButton, _PureComponent);

    function SelectButton() {
        _classCallCheck(this, SelectButton);

        return _possibleConstructorReturn(this, (SelectButton.__proto__ || Object.getPrototypeOf(SelectButton)).apply(this, arguments));
    }

    _createClass(SelectButton, [{
        key: 'render',
        // eslint-disable-line
        value: function render() {
            var _props = this.props,
                label = _props.label,
                major = _props.major,
                disabled = _props.disabled,
                onClick = _props.onClick;

            return _react2.default.createElement(
                'div',
                {
                    className: (0, _classnames2.default)('ui-btn', 'sb-select__button', {
                        'ui-btn_primary': major,
                        'ui-btn_primary--disabled': major && disabled,
                        'ui-btn--disabled': !major && disabled
                    }),
                    onClick: disabled ? null : onClick
                },
                _react2.default.createElement(
                    'span',
                    { className: 'sb-select__button__label' },
                    label
                ),
                _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'down', size: 'Medium' })
            );
        }
    }]);

    return SelectButton;
}(_react.PureComponent);

SelectButton.propTypes = {
    /**
     * This is the label to be displayed.
     * It could be a string or a node to render.
     */
    label: _react.PropTypes.node.isRequired,
    /**
     * Applies major button styling.
     */
    major: _react.PropTypes.bool.isRequired,
    /**
     * Disables the button.
     */
    disabled: _react.PropTypes.bool,
    /**
     * The 'click' event handler.
     */
    onClick: _react.PropTypes.func.isRequired
};

exports.default = SelectButton;

/***/ }),
/* 2609 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * The search input.
 */
var SelectInput = function SelectInput(_ref) {
  var title = _ref.title,
      value = _ref.value,
      onChange = _ref.onChange,
      onKeyDown = _ref.onKeyDown;
  return _react2.default.createElement(
    "div",
    { className: "sb-select__inputContainer" },
    _react2.default.createElement(
      "span",
      { className: "sb-select__inputLabel" },
      title
    ),
    _react2.default.createElement("input", {
      className: "sb-select__input",
      type: "text",
      maxLength: "30",
      placeholder: "Search...",
      value: value,
      onChange: onChange,
      onKeyDown: onKeyDown
    })
  );
};

SelectInput.propTypes = {
  /**
   * Title to be displayed on mobile devices
   */
  title: _react.PropTypes.string.isRequired,
  /**
   * This is the controlled component, so it requires it's value.
   */
  value: _react.PropTypes.string.isRequired,
  /**
   * This is the controlled component, so it requires 'change' event handler.
   */
  onChange: _react.PropTypes.func.isRequired,
  /**
   * The 'keydown' event handler. It is used to handle 'Esc' and 'Enter' buttons.
   */
  onKeyDown: _react.PropTypes.func.isRequired
};

exports.default = SelectInput;

/***/ }),
/* 2610 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _clamper = __webpack_require__(1281);

var _clamper2 = _interopRequireDefault(_clamper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The option from the list.
 */
var SelectOption = function (_PureComponent) {
    _inherits(SelectOption, _PureComponent);

    function SelectOption(props) {
        _classCallCheck(this, SelectOption);

        var _this = _possibleConstructorReturn(this, (SelectOption.__proto__ || Object.getPrototypeOf(SelectOption)).call(this, props));

        _this.handleClick = _this.handleClick.bind(_this);
        return _this;
    }

    _createClass(SelectOption, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            (0, _clamper2.default)(this.labelRef, { clamp: 2 });
        }
    }, {
        key: 'handleClick',
        value: function handleClick() {
            var _props = this.props,
                option = _props.option,
                valueGetter = _props.valueGetter,
                onClick = _props.onClick,
                immediateUpdate = _props.immediateUpdate;

            onClick(valueGetter(option), option);

            if (immediateUpdate) {
                this.forceUpdate();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _props2 = this.props,
                option = _props2.option,
                labelGetter = _props2.labelGetter,
                isSelected = _props2.isSelected;

            return _react2.default.createElement(
                'div',
                {
                    onClick: this.handleClick,
                    className: (0, _classnames2.default)('sb-selectList__option', 'ui-popoverList__link', { 'sb-selectList__option_selected': isSelected(option) })
                },
                _react2.default.createElement(
                    'span',
                    {
                        className: 'sb-selectList__label',
                        ref: function ref(_ref) {
                            return _this2.labelRef = _ref;
                        }
                    },
                    labelGetter(option)
                ),
                _react2.default.createElement(_rpReactSvgIcon2.default, {
                    iconName: 'tick',
                    size: 'Medium'
                })
            );
        }
    }]);

    return SelectOption;
}(_react.PureComponent);

SelectOption.propTypes = {
    /**
     * The option to render.
     * It has no mandatory structure.
     * You can pass any object with custom label and value getters.
     */
    option: _react.PropTypes.object.isRequired, // eslint-disable-line
    /**
     * The option label getter.
     * It is used to display the option.
     */
    labelGetter: _react.PropTypes.func.isRequired,
    /**
     * The option value getter.
     * It is used to pass the value to the onClick handler.
     */
    valueGetter: _react.PropTypes.func.isRequired,
    /**
     * Function to check is option selected.
     * It is used to highlight the selected option.
     */
    isSelected: _react.PropTypes.func.isRequired,
    /**
     * The 'click' event handler.
     * It gets option value and the option itself as arguments.
     */
    onClick: _react.PropTypes.func.isRequired,
    /**
     * Property for immediate option re render on selection
     */
    immediateUpdate: _react.PropTypes.bool
};

exports.default = SelectOption;

/***/ }),
/* 2611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.POSITION_BOTTOM = exports.POSITION_TOP = exports.KEY_CODE_ESC = exports.KEY_CODE_ENTER = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _lodash = __webpack_require__(9);

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _reactVirtualized = __webpack_require__(2430);

var _rpMqBreakpoints = __webpack_require__(66);

var _rpMqBreakpoints2 = _interopRequireDefault(_rpMqBreakpoints);

var _rpReactSvgIcon = __webpack_require__(14);

var _rpReactSvgIcon2 = _interopRequireDefault(_rpReactSvgIcon);

var _SelectInput = __webpack_require__(2609);

var _SelectInput2 = _interopRequireDefault(_SelectInput);

var _SelectAlphabet = __webpack_require__(2606);

var _SelectAlphabet2 = _interopRequireDefault(_SelectAlphabet);

var _SelectAutoSizer = __webpack_require__(2607);

var _SelectAutoSizer2 = _interopRequireDefault(_SelectAutoSizer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEY_CODE_ENTER = exports.KEY_CODE_ENTER = 13;
var KEY_CODE_ESC = exports.KEY_CODE_ESC = 27;

var POSITION_TOP = exports.POSITION_TOP = 'top';
var POSITION_BOTTOM = exports.POSITION_BOTTOM = 'bottom';

/**
 * The popover with options, search input and alphabet.
 */

var SelectPopover = function (_PureComponent) {
    _inherits(SelectPopover, _PureComponent);

    _createClass(SelectPopover, null, [{
        key: 'renderSpinner',
        value: function renderSpinner() {
            return _react2.default.createElement(
                'div',
                { className: 'sb-selectSpinner' },
                _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'spinner', size: '2XL' })
            );
        }
    }]);

    function SelectPopover(props) {
        _classCallCheck(this, SelectPopover);

        var _this = _possibleConstructorReturn(this, (SelectPopover.__proto__ || Object.getPrototypeOf(SelectPopover)).call(this, props));

        _this.handleBreakpointsSwitch = function (e) {
            return _this.setState({
                breakpointCode: e.detail.breakpoint.code
            });
        };

        _this.checkPosition = (0, _lodash.once)(function () {
            // Popover shouldn't jump from top to bottom while querying
            // So we call this function only once
            var _this$rootRef$parentN = _this.rootRef.parentNode.getBoundingClientRect(),
                parentTop = _this$rootRef$parentN.top,
                parentBottom = _this$rootRef$parentN.bottom;

            var _this$rootRef$getBoun = _this.rootRef.getBoundingClientRect(),
                height = _this$rootRef$getBoun.height;

            var windowHeight = window.innerHeight;

            // We show popover at bottom if there is enough space for it below the select button
            // or there is not enough space above the select button.
            // Otherwise it is shown at top.
            var position = windowHeight - parentBottom >= height || parentTop < height ? POSITION_BOTTOM : POSITION_TOP;

            if (position !== _this.state.position) {
                _this.setState({ position: position });
            }
        });

        _this.processListSize = function (_ref) {
            var width = _ref.width,
                height = _ref.height;
            var _this$props = _this.props,
                options = _this$props.options,
                rowHeight = _this$props.rowHeight,
                dropdownListHeight = _this$props.dropdownListHeight;
            var breakpointCode = _this.state.breakpointCode;
            var EXTRA_NARROW = _rpMqBreakpoints.breakpointCodes.EXTRA_NARROW,
                NARROW = _rpMqBreakpoints.breakpointCodes.NARROW;

            return {
                width: width,
                height: [EXTRA_NARROW, NARROW].includes(breakpointCode) ? height : Math.min(dropdownListHeight, options.length * rowHeight)
            };
        };

        _this.state = {
            didMountHandling: false,
            breakpointCode: _rpMqBreakpoints2.default.current().code,
            position: POSITION_BOTTOM
        };

        _this.renderOption = _this.renderOption.bind(_this);
        _this.handleInputChange = _this.handleInputChange.bind(_this);
        _this.handleInputKeyDown = _this.handleInputKeyDown.bind(_this);
        _this.handleAlphabetClick = _this.handleAlphabetClick.bind(_this);
        return _this;
    }

    _createClass(SelectPopover, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            var _this2 = this;

            var onDidMount = this.props.onDidMount;

            if (onDidMount) {
                var handlerResult = onDidMount();
                if ((0, _lodash.isObject)(handlerResult) && (0, _lodash.isFunction)(handlerResult.then) && (0, _lodash.isFunction)(handlerResult.catch)) {
                    this.toggleDidMountHandling(true);
                    // TODO: handle errors
                    handlerResult.then(function () {
                        return _this2.toggleDidMountHandling(false);
                    }).catch(function () {
                        return _this2.toggleDidMountHandling(false);
                    });
                }
            }

            window.addEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            window.removeEventListener('rpBreakpointsSwitch', this.handleBreakpointsSwitch);
        }
    }, {
        key: 'handleInputChange',
        value: function handleInputChange(e) {
            this.props.onQueryChange(e.target.value);

            /*
            * This does re-rendering of List
            * if options were changed but quantity is the same.
            *
            * For example your query is "x"
            * and you have two options "x1" and "x2".
            * After that you change query to "y"
            * and get "y1" and "y2".
            * In this case List shows previous results
            * and we should trigger update manually
            */
            if (this.listRef) {
                this.listRef.forceUpdateGrid();
            }
        }
    }, {
        key: 'handleInputKeyDown',
        value: function handleInputKeyDown(e) {
            if (e.keyCode === KEY_CODE_ENTER || e.keyCode === KEY_CODE_ESC) {
                this.props.onClose(e);
            }
        }
    }, {
        key: 'handleAlphabetClick',
        value: function handleAlphabetClick(char) {
            var _props = this.props,
                options = _props.options,
                optionLabelGetter = _props.optionLabelGetter;

            this.listRef.scrollToRow(options.findIndex(function (option) {
                return optionLabelGetter(option)[0].toLowerCase() >= char.toLowerCase();
            }));
        }
    }, {
        key: 'toggleDidMountHandling',
        value: function toggleDidMountHandling(didMountHandling) {
            this.setState({ didMountHandling: didMountHandling });
        }
    }, {
        key: 'renderAlphabet',
        value: function renderAlphabet() {
            var alphabet = this.props.alphabet;

            if (!alphabet) {
                return null;
            }

            return _react2.default.createElement(_SelectAlphabet2.default, {
                alphabet: (0, _lodash.isString)(alphabet) ? alphabet : undefined,
                onClick: this.handleAlphabetClick
            });
        }
    }, {
        key: 'renderQueryInput',
        value: function renderQueryInput() {
            var _props2 = this.props,
                query = _props2.query,
                title = _props2.title,
                showSearch = _props2.showSearch;

            if (!showSearch) {
                return null;
            }
            return _react2.default.createElement(_SelectInput2.default, {
                title: title,
                value: query,
                onChange: this.handleInputChange,
                onKeyDown: this.handleInputKeyDown
            });
        }
    }, {
        key: 'renderOption',
        value: function renderOption(_ref2) {
            var index = _ref2.index,
                key = _ref2.key,
                style = _ref2.style;

            return _react2.default.createElement(
                'div',
                {
                    key: key,
                    style: style
                },
                this.props.optionRenderer(this.props.options[index])
            );
        }
    }, {
        key: 'renderList',
        value: function renderList() {
            var _this3 = this;

            var _props3 = this.props,
                options = _props3.options,
                rowHeight = _props3.rowHeight,
                noOptionsRenderer = _props3.noOptionsRenderer;


            if (options.length === 0) {
                return noOptionsRenderer();
            }
            return _react2.default.createElement(
                'div',
                { className: 'sb-selectListWrap' },
                _react2.default.createElement(
                    'div',
                    { className: 'sb-selectList' },
                    _react2.default.createElement(_SelectAutoSizer2.default, {
                        sizeProcessor: this.processListSize,
                        contentRenderer: function contentRenderer(_ref3) {
                            var width = _ref3.width,
                                height = _ref3.height;
                            return _react2.default.createElement(_reactVirtualized.List, {
                                ref: function ref(_ref5) {
                                    return _this3.listRef = _ref5;
                                },
                                height: height,
                                overscanRowCount: 15,
                                rowHeight: rowHeight,
                                rowCount: options.length,
                                rowRenderer: function rowRenderer(_ref4) {
                                    var index = _ref4.index,
                                        key = _ref4.key,
                                        style = _ref4.style;
                                    return _this3.renderOption({ index: index, key: key, style: style });
                                },
                                scrollToAlignment: 'start',
                                width: width
                            });
                        },
                        onDidResize: this.checkPosition
                    })
                ),
                this.renderAlphabet()
            );
        }
    }, {
        key: 'render',
        value: function render() {
            var _this4 = this;

            var _props4 = this.props,
                title = _props4.title,
                onClose = _props4.onClose;

            return _react2.default.createElement(
                'div',
                {
                    ref: function ref(_ref6) {
                        return _this4.rootRef = _ref6;
                    },
                    className: 'ui-popover ui-popover_headless ui-popover_' + this.state.position
                },
                _react2.default.createElement('div', { className: 'ui-popoverPointer' }),
                _react2.default.createElement(
                    'div',
                    { className: 'ui-popoverHeader' },
                    _react2.default.createElement(
                        'span',
                        { className: 'ui-popoverHeader__title' },
                        title
                    ),
                    _react2.default.createElement(
                        'span',
                        {
                            className: 'ui-btn ui-btn_secondary ui-popoverHeader__btn',
                            onClick: onClose
                        },
                        _react2.default.createElement(_rpReactSvgIcon2.default, { iconName: 'cross', size: 'Medium' })
                    )
                ),
                this.renderQueryInput(),
                this.state.didMountHandling ? SelectPopover.renderSpinner() : this.renderList()
            );
        }
    }]);

    return SelectPopover;
}(_react.PureComponent);

SelectPopover.propTypes = {
    /**
     * Title to be displayed on mobile devices
     */
    title: _react.PropTypes.string.isRequired,
    /**
     * Shows alphabet.
     * It could be boolean if you want to control the visibility of the default (English) alphabet.
     * You can also provide a string with custom chars to be rendered instead of default alphabet.
     */
    alphabet: _react.PropTypes.oneOfType([_react.PropTypes.bool, _react.PropTypes.string]),
    /**
     * Controls the visibility of search input.
     */
    showSearch: _react.PropTypes.bool,
    /**
     * Controls height of row element, defaults to 64px
     */
    rowHeight: _react.PropTypes.number,
    /**
     * Controls height of options list into dropdown (for medium and larger screens),
     */
    dropdownListHeight: _react.PropTypes.number,
    /**
     * The search query value.
     * This is the controlled component so it requires the search query value.
     */
    query: _react.PropTypes.string.isRequired,
    /**
     * Array of options to be rendered.
     */
    options: _react.PropTypes.arrayOf(_react.PropTypes.object).isRequired,
    /**
     * Funtion that gets the option as an argument and returns it's label.
     * It is used to scroll to option by alphabet.
     */
    optionLabelGetter: _react.PropTypes.func.isRequired,
    /**
     * Function that gets the option as an argument and returns the React node for this option.
     */
    optionRenderer: _react.PropTypes.func.isRequired,
    /**
     * Function that renders the placeholder if no options available (due to search query or any other reason)
     */
    noOptionsRenderer: _react.PropTypes.func.isRequired,
    /**
     * This is the controlled component so it requires the search query change handler.
     */
    onQueryChange: _react.PropTypes.func.isRequired,
    /**
     * Close button 'click' handler.
     */
    onClose: _react.PropTypes.func.isRequired,
    /**
     * It could be considered as the 'open' event handler.
     * If it returns a Promise application shows the spinner until promise resolved or rejected.
     */
    onDidMount: _react.PropTypes.func
};

SelectPopover.defaultProps = {
    rowHeight: 64,
    dropdownListHeight: 354,
    query: '',
    options: []
};

exports.default = SelectPopover;

/***/ }),
/* 2612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Select = __webpack_require__(2605);

var _Select2 = _interopRequireDefault(_Select);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * @link https://racingpost.atlassian.net/browse/PB2-610
 */
exports.default = _Select2.default;

/***/ }),
/* 2613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _Header = __webpack_require__(586);

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__(585);

var _Body2 = _interopRequireDefault(_Body);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RpSimpleTable = function (_PureComponent) {
  _inherits(RpSimpleTable, _PureComponent);

  function RpSimpleTable() {
    _classCallCheck(this, RpSimpleTable);

    return _possibleConstructorReturn(this, (RpSimpleTable.__proto__ || Object.getPrototypeOf(RpSimpleTable)).apply(this, arguments));
  }

  _createClass(RpSimpleTable, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          columns = _props.columns,
          loading = _props.loading,
          noDataText = _props.noDataText,
          className = _props.className,
          uiType = _props.uiType,
          sortIdx = _props.sortIdx,
          onHeaderCellClick = _props.onHeaderCellClick;


      var sortable = data.length > 0;

      var tableClassName = (0, _classnames2.default)('ui-table', className, 'ui-table_type' + uiType, sortable && 'ui-table_sortable');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { className: tableClassName },
          _react2.default.createElement(_Header2.default, {
            columns: columns,
            sortable: data.length > 0,
            sortIdx: sortIdx,
            onHeaderCellClick: onHeaderCellClick
          }),
          _react2.default.createElement(_Body2.default, {
            data: data,
            columns: columns,
            loading: loading,
            noDataText: noDataText
          })
        )
      );
    }
  }]);

  return RpSimpleTable;
}(_react.PureComponent);

RpSimpleTable.defaultProps = {
  data: [],
  uiType: 1,
  noDataText: 'No data for this table'
};

RpSimpleTable.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    cell: _propTypes2.default.func,
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    className: _propTypes2.default.string
  })).isRequired,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  sortIdx: _propTypes2.default.number,
  className: _propTypes2.default.string,
  uiType: _propTypes2.default.number,
  noDataText: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  onHeaderCellClick: _propTypes2.default.func.isRequired
};

exports.default = RpSimpleTable;

/***/ }),
/* 2614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = __webpack_require__(15);

var _classnames2 = _interopRequireDefault(_classnames);

var _Header = __webpack_require__(586);

var _Header2 = _interopRequireDefault(_Header);

var _Body = __webpack_require__(585);

var _Body2 = _interopRequireDefault(_Body);

var _Footer = __webpack_require__(2615);

var _Footer2 = _interopRequireDefault(_Footer);

var _ShowMore = __webpack_require__(1002);

var _ShowMore2 = _interopRequireDefault(_ShowMore);

var _addSortFns = __webpack_require__(1005);

var _addSortFns2 = _interopRequireDefault(_addSortFns);

var _sortData = __webpack_require__(1007);

var _sortData2 = _interopRequireDefault(_sortData);

var _addIds = __webpack_require__(1003);

var _addIds2 = _interopRequireDefault(_addIds);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var dataChange = function dataChange(data, columns, sortIdx, defaultSortIdx) {
  var changedData = (0, _addIds2.default)(data || []);
  return Number.isFinite(sortIdx) ? (0, _sortData2.default)(changedData, columns, sortIdx, defaultSortIdx) : changedData;
};

var RpTable = function (_PureComponent) {
  _inherits(RpTable, _PureComponent);

  function RpTable(props) {
    _classCallCheck(this, RpTable);

    var _this = _possibleConstructorReturn(this, (RpTable.__proto__ || Object.getPrototypeOf(RpTable)).call(this, props));

    _initialiseProps.call(_this);

    var defaultSortIdx = props.defaultSortIdx || props.initialSortIdx || 0;
    var sortIdx = props.initialSortIdx;
    var columns = (0, _addSortFns2.default)(props.columns, props.sortable, props.initialSortIdx);
    var data = dataChange(props.data, columns, sortIdx, defaultSortIdx);
    var itemsShown = props.resultsPerPage || data.length;

    _this.state = {
      columns: columns, defaultSortIdx: defaultSortIdx, data: data, sortIdx: sortIdx, itemsShown: itemsShown
    };
    return _this;
  }

  _createClass(RpTable, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (this.props === nextProps) return;

      var newState = {};
      var _state = this.state,
          sortIdx = _state.sortIdx,
          defaultSortIdx = _state.defaultSortIdx,
          columns = _state.columns;

      var nextSortIdx = nextProps.initialSortIdx;

      if (this.props.columns !== nextProps.columns) {
        newState.columns = (0, _addSortFns2.default)(nextProps.columns, nextProps.sortable, sortIdx, defaultSortIdx);
      }

      if (this.props.data !== nextProps.data || this.props.columns !== nextProps.columns) {
        newState.data = dataChange(nextProps.data, newState.columns || columns, nextSortIdx, defaultSortIdx);
        newState.itemsShown = nextProps.resultsPerPage || newState.data.length;
      }

      this.setState(newState);
    }
  }, {
    key: 'render',
    value: function render() {
      var _state2 = this.state,
          columns = _state2.columns,
          data = _state2.data,
          sortIdx = _state2.sortIdx,
          itemsShown = _state2.itemsShown,
          defaultSortIdx = _state2.defaultSortIdx;
      var _props = this.props,
          loading = _props.loading,
          noDataText = _props.noDataText,
          footerData = _props.footerData,
          setRowClass = _props.setRowClass,
          className = _props.className,
          uiType = _props.uiType,
          filter = _props.filter,
          headerRow = _props.headerRow,
          specialRow = _props.specialRow;


      var sortable = this.props.sortable && data.length > 1;

      var filteredData = filter ? data.filter(filter) : data;
      var specialFiltered = specialRow && sortIdx !== defaultSortIdx ? filteredData.filter(function (_ref) {
        var isSpecial = _ref.isSpecial;
        return !isSpecial;
      }) : filteredData;
      var shownData = itemsShown < specialFiltered.length ? specialFiltered.slice(0, itemsShown) : specialFiltered;

      var tableClassName = (0, _classnames2.default)('ui-table', className, 'ui-table_type' + uiType, sortable && 'ui-table_sortable');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'table',
          { className: tableClassName },
          _react2.default.createElement(_Header2.default, {
            columns: columns,
            sortable: sortable,
            sortIdx: sortIdx,
            onHeaderCellClick: this.sortTable,
            headerRow: headerRow
          }),
          _react2.default.createElement(_Body2.default, {
            data: shownData,
            columns: columns,
            loading: loading,
            noDataText: noDataText,
            setRowClass: setRowClass,
            specialRow: specialRow
          }),
          !loading && footerData && _react2.default.createElement(_Footer2.default, {
            footerData: footerData,
            columns: columns
          })
        ),
        !loading && itemsShown < data.length && _react2.default.createElement(_ShowMore2.default, { onClick: this.showMore })
      );
    }
  }]);

  return RpTable;
}(_react.PureComponent);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.showMore = function () {
    _this2.setState({
      itemsShown: _this2.state.itemsShown + _this2.props.resultsPerPage
    });
  };

  this.sortTable = function (index) {
    var _state3 = _this2.state,
        data = _state3.data,
        columns = _state3.columns,
        defaultSortIdx = _state3.defaultSortIdx;
    var onSortUpdate = _this2.props.onSortUpdate;


    _this2.setState({
      data: (0, _sortData2.default)(data, columns, index, defaultSortIdx),
      sortIdx: index
    });

    if (onSortUpdate) {
      onSortUpdate(index);
    }
  };
};

RpTable.defaultProps = {
  data: [],
  uiType: 1,
  noDataText: 'No data for this table'
};

RpTable.propTypes = {
  columns: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    key: _propTypes2.default.string.isRequired,
    cell: _propTypes2.default.func,
    header: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func]),
    className: _propTypes2.default.string,
    sortFn: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.oneOf(['numeric', 'numericReverse', 'alphabetic', 'byLastName'])])
  })).isRequired,
  data: _propTypes2.default.arrayOf(_propTypes2.default.shape({})),
  sortable: _propTypes2.default.bool,
  initialSortIdx: _propTypes2.default.number,
  defaultSortIdx: _propTypes2.default.number,
  footerData: _propTypes2.default.shape({}),
  className: _propTypes2.default.string,
  uiType: _propTypes2.default.number,
  noDataText: _propTypes2.default.string,
  loading: _propTypes2.default.bool,
  resultsPerPage: _propTypes2.default.number,
  filter: _propTypes2.default.func,
  setRowClass: _propTypes2.default.func,
  specialRow: _propTypes2.default.func,
  headerRow: _propTypes2.default.func,
  onSortUpdate: _propTypes2.default.func
};

exports.default = RpTable;

/***/ }),
/* 2615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(1);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(0);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Row = __webpack_require__(587);

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var setFooterClass = function setFooterClass() {
  return 'ui-table__cell_footer';
};

var Footer = function (_PureComponent) {
  _inherits(Footer, _PureComponent);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          footerData = _props.footerData,
          columns = _props.columns;


      return _react2.default.createElement(
        'tfoot',
        { className: 'ui-table__footer' },
        _react2.default.createElement(_Row2.default, {
          rowData: footerData,
          columns: columns,
          setRowClass: setFooterClass
        })
      );
    }
  }]);

  return Footer;
}(_react.PureComponent);

Footer.propTypes = {
  footerData: _propTypes2.default.shape({}).isRequired,
  columns: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

exports.default = Footer;

/***/ }),
/* 2616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var alphabetic = function alphabetic(key) {
  return function (itemA, itemB) {
    var a = itemA[key];
    var b = itemB[key];

    if (a === b) return 0;

    if (!a) return 1;
    if (!b) return -1;

    return a > b ? 1 : -1;
  };
};

exports.default = alphabetic;

/***/ }),
/* 2617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }(); /*
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          * Sort by last name then by first name
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                          */


var _lodash = __webpack_require__(9);

var separator = ' ';

var splitFullName = function splitFullName(fullName) {
  var nameArray = fullName.split(separator);
  return [nameArray.pop(), nameArray.join(separator)];
};

var byLastName = function byLastName(key) {
  return function (itemA, itemB) {
    var a = itemA[key];
    var b = itemB[key];

    if (a === b) return 0;

    if (!(0, _lodash.isString)(a)) return 1;
    if (!(0, _lodash.isString)(b)) return -1;

    var _splitFullName = splitFullName(a),
        _splitFullName2 = _slicedToArray(_splitFullName, 2),
        surnameA = _splitFullName2[0],
        nameA = _splitFullName2[1];

    var _splitFullName3 = splitFullName(b),
        _splitFullName4 = _slicedToArray(_splitFullName3, 2),
        surnameB = _splitFullName4[0],
        nameB = _splitFullName4[1];

    if (surnameA === surnameB) {
      return nameA > nameB ? 1 : -1;
    }

    return surnameA > surnameB ? 1 : -1;
  };
};

exports.default = byLastName;

/***/ }),
/* 2618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var isFinite = Number.isFinite;
var numeric = exports.numeric = function numeric(key) {
  return function (itemA, itemB) {
    var a = isNaN(parseFloat(itemA[key])) ? 'isCountryCode' : parseFloat(itemA[key]);
    var b = isNaN(parseFloat(itemB[key])) ? 'isCountryCode' : parseFloat(itemB[key]);

    if (a === 'isCountryCode' && b === 'isCountryCode') return 0;

    if (a === 'isCountryCode') return -1;
    if (b === 'isCountryCode') return 1;

    return b - a;
  };
};

var numericReverse = exports.numericReverse = function numericReverse(key) {
  return function (itemA, itemB) {
    var a = parseFloat(itemA[key]);
    var b = parseFloat(itemB[key]);

    if (!isFinite(a)) return 1;
    if (!isFinite(b)) return -1;

    return a - b;
  };
};

/***/ }),
/* 2619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.RESULTS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = exports.CARDS_PREFERRED_TAB = undefined;
exports.getPrefValue = getPrefValue;

var _jquery = __webpack_require__(13);

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CARDS_PREFERRED_TAB = exports.CARDS_PREFERRED_TAB = 'cdt_tab_pref';
var CARDS_LIST_VIEW_TYPE = exports.CARDS_LIST_VIEW_TYPE = 'cdt_list_pref';
var RESULTS_LIST_VIEW_TYPE = exports.RESULTS_LIST_VIEW_TYPE = 'rsp_list_pref';

function getValuesIfExist(value, possibleValues) {
    return value in possibleValues;
}

function getPrefValue(prefType, prefDefaultValue) {
    return localStorage.getItem(prefType) || prefDefaultValue;
}

function buildUrl(className, prefType, prefDefaultValue, possibleValues) {
    var prefValue = void 0;

    (0, _jquery2.default)(document).on('touchstart mousedown', '.' + className, function (e) {
        var $target = (0, _jquery2.default)(e.currentTarget);

        function updateHref(value) {
            $target.attr('href', function (index, href) {
                return '' + href.replace(/\/$/, '') + possibleValues[value];
            });
            $target.removeClass(className);
        }

        if (prefValue) {
            updateHref(prefValue);
        } else {
            prefValue = getPrefValue(prefType, prefDefaultValue);
            updateHref(prefValue);
        }
    });
}

function setPref(selector, storageKeyName, possibleValues) {
    var value = (0, _jquery2.default)(selector).attr('data-pref-type');
    if (!getValuesIfExist(value, possibleValues)) {
        return;
    }

    if (value) {
        try {
            localStorage.setItem(storageKeyName, value);
        } catch (e) {
            /* eslint-disable no-console */
            console.warn('You are in a private mode, so, we couldn\'t save your preference.');
        }
    }
}

function navigate() {
    var cardTabsPossibleValues = {
        free: '/',
        pro: '/pro',
        'at-a-glance': '/at-a-glance',
        'odds-comparison': '/odds-comparison',
        'raceday-live': '/raceday-live'
    };
    var cardListTypePossibleValues = {
        byCourse: '/',
        byTime: '/time-order'
    };

    var resultsListTypePossibleValues = {
        byCourse: '/',
        byTime: '/time-order'
    };

    // Racecards tab preferences
    // TODO: change to more related name
    setPref('.js-navigate-type', CARDS_PREFERRED_TAB, cardTabsPossibleValues);
    buildUrl('js-navigate-url', CARDS_PREFERRED_TAB, 'free', cardTabsPossibleValues);

    // Racecards list types preferences
    setPref('.js-rc-list-type', CARDS_LIST_VIEW_TYPE, cardListTypePossibleValues);
    buildUrl('js-rc-list-url', CARDS_LIST_VIEW_TYPE, 'byCourse', cardListTypePossibleValues);

    // Results list types preferences
    setPref('.js-rsp-list-type', RESULTS_LIST_VIEW_TYPE, resultsListTypePossibleValues);
    buildUrl('js-rsp-list-url', RESULTS_LIST_VIEW_TYPE, 'byCourse', resultsListTypePossibleValues);
}

exports.default = navigate;

/***/ }),
/* 2620 */,
/* 2621 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 2622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var generate = __webpack_require__(2623);
var alphabet = __webpack_require__(387);

// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
// This number should be updated every year or so to keep the generated id short.
// To regenerate `new Date() - 0` and bump the version. Always bump the version!
var REDUCE_TIME = 1459707606518;

// don't change unless we change the algos or REDUCE_TIME
// must be an integer and less than 16
var version = 6;

// Counter is used when shortid is called multiple times in one second.
var counter;

// Remember the last time shortid was called in case counter is needed.
var previousSeconds;

/**
 * Generate unique id
 * Returns string id
 */
function build(clusterWorkerId) {
    var str = '';

    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);

    if (seconds === previousSeconds) {
        counter++;
    } else {
        counter = 0;
        previousSeconds = seconds;
    }

    str = str + generate(version);
    str = str + generate(clusterWorkerId);
    if (counter > 0) {
        str = str + generate(counter);
    }
    str = str + generate(seconds);
    return str;
}

module.exports = build;


/***/ }),
/* 2623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(387);
var random = __webpack_require__(2626);
var format = __webpack_require__(2288);

function generate(number) {
    var loopCounter = 0;
    var done;

    var str = '';

    while (!done) {
        str = str + format(random, alphabet.get(), 1);
        done = number < (Math.pow(16, loopCounter + 1 ) );
        loopCounter++;
    }
    return str;
}

module.exports = generate;


/***/ }),
/* 2624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var alphabet = __webpack_require__(387);
var build = __webpack_require__(2622);
var isValid = __webpack_require__(2625);

// if you are using cluster or multiple servers use this to make each instance
// has a unique value for worker
// Note: I don't know if this is automatically set when using third
// party cluster solutions such as pm2.
var clusterWorkerId = __webpack_require__(2628) || 0;

/**
 * Set the seed.
 * Highly recommended if you don't want people to try to figure out your id schema.
 * exposed as shortid.seed(int)
 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
 */
function seed(seedValue) {
    alphabet.seed(seedValue);
    return module.exports;
}

/**
 * Set the cluster worker or machine id
 * exposed as shortid.worker(int)
 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
 * returns shortid module so it can be chained.
 */
function worker(workerId) {
    clusterWorkerId = workerId;
    return module.exports;
}

/**
 *
 * sets new characters to use in the alphabet
 * returns the shuffled alphabet
 */
function characters(newCharacters) {
    if (newCharacters !== undefined) {
        alphabet.characters(newCharacters);
    }

    return alphabet.shuffled();
}

/**
 * Generate unique id
 * Returns string id
 */
function generate() {
  return build(clusterWorkerId);
}

// Export all other functions as properties of the generate function
module.exports = generate;
module.exports.generate = generate;
module.exports.seed = seed;
module.exports.worker = worker;
module.exports.characters = characters;
module.exports.isValid = isValid;


/***/ }),
/* 2625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var alphabet = __webpack_require__(387);

function isShortId(id) {
    if (!id || typeof id !== 'string' || id.length < 6 ) {
        return false;
    }

    var nonAlphabetic = new RegExp('[^' +
      alphabet.get().replace(/[|\\{}()[\]^$+*?.-]/g, '\\$&') +
    ']');
    return !nonAlphabetic.test(id);
}

module.exports = isShortId;


/***/ }),
/* 2626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto

var randomByte;

if (!crypto || !crypto.getRandomValues) {
    randomByte = function(size) {
        var bytes = [];
        for (var i = 0; i < size; i++) {
            bytes.push(Math.floor(Math.random() * 256));
        }
        return bytes;
    };
} else {
    randomByte = function(size) {
        return crypto.getRandomValues(new Uint8Array(size));
    };
}

module.exports = randomByte;


/***/ }),
/* 2627 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Found this seed-based random generator somewhere
// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)

var seed = 1;

/**
 * return a random number based on a seed
 * @param seed
 * @returns {number}
 */
function getNextValue() {
    seed = (seed * 9301 + 49297) % 233280;
    return seed/(233280.0);
}

function setSeed(_seed_) {
    seed = _seed_;
}

module.exports = {
    nextValue: getNextValue,
    seed: setSeed
};


/***/ }),
/* 2628 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = 0;


/***/ }),
/* 2629 */,
/* 2630 */,
/* 2631 */,
/* 2632 */
/***/ (function(module, exports) {

/***
   Copyright 2013 Teun Duynstee

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

     http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/
module.exports = (function() {

    function identity(v){return v;}

    function ignoreCase(v){return typeof(v)==="string" ? v.toLowerCase() : v;}

    function makeCompareFunction(f, opt){
        opt = typeof(opt)==="number" ? {direction:opt} : opt||{};
        if(typeof(f)!="function"){
            var prop = f;
            // make unary function
            f = function(v1){return !!v1[prop] ? v1[prop] : "";}
        }
        if(f.length === 1) {
            // f is a unary function mapping a single item to its sort score
            var uf = f;
            var preprocess = opt.ignoreCase?ignoreCase:identity;
            var cmp = opt.cmp || function(v1,v2) {return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;}
            f = function(v1,v2) {return cmp(preprocess(uf(v1)), preprocess(uf(v2)));}
        }
        if(opt.direction === -1) return function(v1,v2){return -f(v1,v2)};
        return f;
    }

    /* adds a secondary compare function to the target function (`this` context)
       which is applied in case the first one returns 0 (equal)
       returns a new compare function, which has a `thenBy` method as well */
    function tb(func, opt) {
        /* should get value false for the first call. This can be done by calling the 
        exported function, or the firstBy property on it (for es6 module compatibility)
        */
        var x = (typeof(this) == "function" && !this.firstBy) ? this : false;
        var y = makeCompareFunction(func, opt);
        var f = x ? function(a, b) {
                        return x(a,b) || y(a,b);
                    }
                  : y;
        f.thenBy = tb;
        return f;
    }
    tb.firstBy = tb;
    return tb;
})();


/***/ }),
/* 2633 */,
/* 2634 */,
/* 2635 */,
/* 2636 */,
/* 2637 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
var support = {
  searchParams: 'URLSearchParams' in self,
  iterable: 'Symbol' in self && 'iterator' in Symbol,
  blob:
    'FileReader' in self &&
    'Blob' in self &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in self,
  arrayBuffer: 'ArrayBuffer' in self
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
    var parts = line.split(':')
    var key = parts.shift().trim()
    if (key) {
      var value = parts.join(':').trim()
      headers.append(key, value)
    }
  })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : 'OK'
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = self.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      resolve(new Response(body, options))
    }

    xhr.onerror = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.ontimeout = function() {
      reject(new TypeError('Network request failed'))
    }

    xhr.onabort = function() {
      reject(new DOMException('Aborted', 'AbortError'))
    }

    xhr.open(request.method, request.url, true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr && support.blob) {
      xhr.responseType = 'blob'
    }

    request.headers.forEach(function(value, name) {
      xhr.setRequestHeader(name, value)
    })

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!self.fetch) {
  self.fetch = fetch
  self.Headers = Headers
  self.Request = Request
  self.Response = Response
}


/***/ })
],[401]);


// WEBPACK FOOTER //
// app.min.js